var _toArray = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");
var _assertThisInitialized = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _construct = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
var _toConsumableArray = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _wrapNativeSuper = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var _get = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _slicedToArray = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _possibleConstructorReturn = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Volumes/ssd/cache/guofu/workspace/web/vue/md.haoxueai.cn/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n260 = 0, F = function F() {}; return { s: F, n: function n() { return _n260 >= r.length ? { done: !0 } : { done: !1, value: r[_n260++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  "use strict";

  var __webpack_modules__ = {
      351: function _(t, e, r) {
        var _n2,
          o = this && this.__extends || (_n2 = function n(t, e) {
            return _n2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n2(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AssistiveMmlHandler = e.AssistiveMmlMathDocumentMixin = e.AssistiveMmlMathItemMixin = e.LimitedMmlVisitor = void 0;
        var T = r(4474),
          l = r(9259),
          c = r(7233),
          u = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.getAttributes = function (e) {
              return t.prototype.getAttributes.call(this, e).replace(/ ?id=".*?"/, "");
            }, e;
          }(l.SerializedMmlVisitor);
        function p(t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.assistiveMml = function (t, e) {
              if (void 0 === e && (e = !1), !(this.state() >= T.STATE.ASSISTIVEMML)) {
                if (!this.isEscaped && (t.options.enableAssistiveMml || e)) {
                  var r = t.adaptor,
                    n = t.toMML(this.root).replace(/\n */g, "").replace(/<!--.*?-->/g, ""),
                    o = r.firstChild(r.body(r.parse(n, "text/html"))),
                    i = r.node("mjx-assistive-mml", {
                      unselectable: "on",
                      display: this.display ? "block" : "inline"
                    }, [o]);
                  r.setAttribute(r.firstChild(this.typesetRoot), "aria-hidden", "true"), r.setStyle(this.typesetRoot, "position", "relative"), r.append(this.typesetRoot, i);
                }
                this.state(T.STATE.ASSISTIVEMML);
              }
            }, e;
          }(t);
        }
        function h(t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, Q([], a(e), !1)) || this,
                o = n.constructor,
                i = o.ProcessBits;
              return i.has("assistive-mml") || i.allocate("assistive-mml"), n.visitor = new u(n.mmlFactory), n.options.MathItem = p(n.options.MathItem), "addStyles" in n && n.addStyles(o.assistiveStyles), n;
            }
            return o(e, t), e.prototype.toMML = function (t) {
              return this.visitor.visitTree(t);
            }, e.prototype.assistiveMml = function () {
              var t, e;
              if (!this.processed.isSet("assistive-mml")) {
                try {
                  for (var r = s(this.math), n = r.next(); !n.done; n = r.next()) {
                    n.value.assistiveMml(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("assistive-mml");
              }
              return this;
            }, e.prototype.state = function (e, r) {
              return void 0 === r && (r = !1), t.prototype.state.call(this, e, r), e < T.STATE.ASSISTIVEMML && this.processed.clear("assistive-mml"), this;
            }, e;
          }(t), e.OPTIONS = i(i({}, t.OPTIONS), {
            enableAssistiveMml: !0,
            renderActions: (0, c.expandable)(i(i({}, t.OPTIONS.renderActions), {
              assistiveMml: [T.STATE.ASSISTIVEMML]
            }))
          }), e.assistiveStyles = {
            "mjx-assistive-mml": {
              position: "absolute !important",
              top: "0px",
              left: "0px",
              clip: "rect(1px, 1px, 1px, 1px)",
              padding: "1px 0px 0px 0px !important",
              border: "0px !important",
              display: "block !important",
              width: "auto !important",
              overflow: "hidden !important",
              "-webkit-touch-callout": "none",
              "-webkit-user-select": "none",
              "-khtml-user-select": "none",
              "-moz-user-select": "none",
              "-ms-user-select": "none",
              "user-select": "none"
            },
            'mjx-assistive-mml[display="block"]': {
              width: "100% !important"
            }
          }, e;
        }
        e.LimitedMmlVisitor = u, (0, T.newState)("ASSISTIVEMML", 153), e.AssistiveMmlMathItemMixin = p, e.AssistiveMmlMathDocumentMixin = h, e.AssistiveMmlHandler = function (t) {
          return t.documentClass = h(t.documentClass), t;
        };
      },
      5282: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = new Map();
        e.default = r;
      },
      5445: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__awaiter || function (t, e, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function a(t) {
                try {
                  s(n.next(t));
                } catch (t) {
                  i(t);
                }
              }
              function Q(t) {
                try {
                  s(n.throw(t));
                } catch (t) {
                  i(t);
                }
              }
              function s(t) {
                var e;
                t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                  t(e);
                })).then(a, Q);
              }
              s((n = n.apply(t, e || [])).next());
            });
          },
          Q = this && this.__generator || function (t, e) {
            var r,
              n,
              o,
              i,
              a = {
                label: 0,
                sent: function sent() {
                  if (1 & o[0]) throw o[1];
                  return o[1];
                },
                trys: [],
                ops: []
              };
            return i = {
              next: Q(0),
              throw: Q(1),
              return: Q(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;
            function Q(i) {
              return function (Q) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");
                  for (; a;) try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;
                      case 4:
                        return a.label++, {
                          value: i[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = i[1], i = [0];
                        continue;
                      case 7:
                        i = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          a.label = i[1];
                          break;
                        }
                        if (6 === i[0] && a.label < o[1]) {
                          a.label = o[1], o = i;
                          break;
                        }
                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(i);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    i = e.call(t, a);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, Q]);
              };
            }
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sreReady = e.Sre = void 0;
        var T,
          l = i(r(2998)),
          c = i(r(3362)),
          u = i(r(9552)),
          p = i(r(4440)),
          h = s(r(5897)),
          d = r(8504),
          f = i(r(3090)),
          m = r(1377),
          L = s(r(5282));
        !function (t) {
          t.locales = m.Variables.LOCALES, t.sreReady = l.engineReady, t.setupEngine = l.setupEngine, t.engineSetup = l.engineSetup, t.toEnriched = l.toEnriched, t.toSpeech = l.toSpeech, t.clearspeakPreferences = d.ClearspeakPreferences, t.getHighlighter = f.highlighter, t.getSpeechGenerator = u.generator, t.getWalker = c.walker, t.clearspeakStyle = function () {
            return p.DOMAIN_TO_STYLES.clearspeak;
          }, t.preloadLocales = function (t) {
            return a(this, void 0, void 0, function () {
              var e;
              return Q(this, function (r) {
                return [2, (e = L.default.get(t)) ? new Promise(function (t, r) {
                  return t(JSON.stringify(e));
                }) : l.localeLoader()(t)];
              });
            });
          };
        }(T = e.Sre || (e.Sre = {})), e.sreReady = T.sreReady, h.default.getInstance().delay = !0, e.default = T;
      },
      444: function _(t, e, r) {
        var _n3,
          o = this && this.__extends || (_n3 = function n(t, e) {
            return _n3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n3(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLAdaptor = void 0;
        var a = function (t) {
          function e(e) {
            var r = t.call(this, e.document) || this;
            return r.window = e, r.parser = new e.DOMParser(), r;
          }
          return o(e, t), e.prototype.parse = function (t, e) {
            return void 0 === e && (e = "text/html"), this.parser.parseFromString(t, e);
          }, e.prototype.create = function (t, e) {
            return e ? this.document.createElementNS(e, t) : this.document.createElement(t);
          }, e.prototype.text = function (t) {
            return this.document.createTextNode(t);
          }, e.prototype.head = function (t) {
            return t.head || t;
          }, e.prototype.body = function (t) {
            return t.body || t;
          }, e.prototype.root = function (t) {
            return t.documentElement || t;
          }, e.prototype.doctype = function (t) {
            return t.doctype ? "<!DOCTYPE ".concat(t.doctype.name, ">") : "";
          }, e.prototype.tags = function (t, e, r) {
            void 0 === r && (r = null);
            var n = r ? t.getElementsByTagNameNS(r, e) : t.getElementsByTagName(e);
            return Array.from(n);
          }, e.prototype.getElements = function (t, e) {
            var r,
              n,
              o = [];
            try {
              for (var a = i(t), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                "string" == typeof s ? o = o.concat(Array.from(this.document.querySelectorAll(s))) : Array.isArray(s) || s instanceof this.window.NodeList || s instanceof this.window.HTMLCollection ? o = o.concat(Array.from(s)) : o.push(s);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return o;
          }, e.prototype.contains = function (t, e) {
            return t.contains(e);
          }, e.prototype.parent = function (t) {
            return t.parentNode;
          }, e.prototype.append = function (t, e) {
            return t.appendChild(e);
          }, e.prototype.insert = function (t, e) {
            return this.parent(e).insertBefore(t, e);
          }, e.prototype.remove = function (t) {
            return this.parent(t).removeChild(t);
          }, e.prototype.replace = function (t, e) {
            return this.parent(e).replaceChild(t, e);
          }, e.prototype.clone = function (t) {
            return t.cloneNode(!0);
          }, e.prototype.split = function (t, e) {
            return t.splitText(e);
          }, e.prototype.next = function (t) {
            return t.nextSibling;
          }, e.prototype.previous = function (t) {
            return t.previousSibling;
          }, e.prototype.firstChild = function (t) {
            return t.firstChild;
          }, e.prototype.lastChild = function (t) {
            return t.lastChild;
          }, e.prototype.childNodes = function (t) {
            return Array.from(t.childNodes);
          }, e.prototype.childNode = function (t, e) {
            return t.childNodes[e];
          }, e.prototype.kind = function (t) {
            var e = t.nodeType;
            return 1 === e || 3 === e || 8 === e ? t.nodeName.toLowerCase() : "";
          }, e.prototype.value = function (t) {
            return t.nodeValue || "";
          }, e.prototype.textContent = function (t) {
            return t.textContent;
          }, e.prototype.innerHTML = function (t) {
            return t.innerHTML;
          }, e.prototype.outerHTML = function (t) {
            return t.outerHTML;
          }, e.prototype.serializeXML = function (t) {
            return new this.window.XMLSerializer().serializeToString(t);
          }, e.prototype.setAttribute = function (t, e, r, n) {
            return void 0 === n && (n = null), n ? (e = n.replace(/.*\//, "") + ":" + e.replace(/^.*:/, ""), t.setAttributeNS(n, e, r)) : t.setAttribute(e, r);
          }, e.prototype.getAttribute = function (t, e) {
            return t.getAttribute(e);
          }, e.prototype.removeAttribute = function (t, e) {
            return t.removeAttribute(e);
          }, e.prototype.hasAttribute = function (t, e) {
            return t.hasAttribute(e);
          }, e.prototype.allAttributes = function (t) {
            return Array.from(t.attributes).map(function (t) {
              return {
                name: t.name,
                value: t.value
              };
            });
          }, e.prototype.addClass = function (t, e) {
            t.classList ? t.classList.add(e) : t.className = (t.className + " " + e).trim();
          }, e.prototype.removeClass = function (t, e) {
            t.classList ? t.classList.remove(e) : t.className = t.className.split(/ /).filter(function (t) {
              return t !== e;
            }).join(" ");
          }, e.prototype.hasClass = function (t, e) {
            return t.classList ? t.classList.contains(e) : t.className.split(/ /).indexOf(e) >= 0;
          }, e.prototype.setStyle = function (t, e, r) {
            t.style[e] = r;
          }, e.prototype.getStyle = function (t, e) {
            return t.style[e];
          }, e.prototype.allStyles = function (t) {
            return t.style.cssText;
          }, e.prototype.insertRules = function (t, e) {
            var r, n;
            try {
              for (var o = i(e.reverse()), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value;
                try {
                  t.sheet.insertRule(Q, 0);
                } catch (t) {
                  console.warn("MathJax: can't insert css rule '".concat(Q, "': ").concat(t.message));
                }
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e.prototype.fontSize = function (t) {
            var e = this.window.getComputedStyle(t);
            return parseFloat(e.fontSize);
          }, e.prototype.fontFamily = function (t) {
            return this.window.getComputedStyle(t).fontFamily || "";
          }, e.prototype.nodeSize = function (t, e, r) {
            if (void 0 === e && (e = 1), void 0 === r && (r = !1), r && t.getBBox) {
              var n = t.getBBox();
              return [n.width / e, n.height / e];
            }
            return [t.offsetWidth / e, t.offsetHeight / e];
          }, e.prototype.nodeBBox = function (t) {
            var e = t.getBoundingClientRect();
            return {
              left: e.left,
              right: e.right,
              top: e.top,
              bottom: e.bottom
            };
          }, e;
        }(r(5009).AbstractDOMAdaptor);
        e.HTMLAdaptor = a;
      },
      6191: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.browserAdaptor = void 0;
        var n = r(444);
        e.browserAdaptor = function () {
          return new n.HTMLAdaptor(window);
        };
      },
      9515: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathJax = e.combineWithMathJax = e.combineDefaults = e.combineConfig = e.isObject = void 0;
        var o = r(3282);
        function i(t) {
          return "object" == typeof t && null !== t;
        }
        function a(t, e) {
          var r, o;
          try {
            for (var Q = n(Object.keys(e)), s = Q.next(); !s.done; s = Q.next()) {
              var T = s.value;
              "__esModule" !== T && (!i(t[T]) || !i(e[T]) || e[T] instanceof Promise ? null !== e[T] && void 0 !== e[T] && (t[T] = e[T]) : a(t[T], e[T]));
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (o = Q.return) && o.call(Q);
            } finally {
              if (r) throw r.error;
            }
          }
          return t;
        }
        e.isObject = i, e.combineConfig = a, e.combineDefaults = function t(e, r, o) {
          var a, Q;
          e[r] || (e[r] = {}), e = e[r];
          try {
            for (var s = n(Object.keys(o)), T = s.next(); !T.done; T = s.next()) {
              var l = T.value;
              i(e[l]) && i(o[l]) ? t(e, l, o[l]) : null == e[l] && null != o[l] && (e[l] = o[l]);
            }
          } catch (t) {
            a = {
              error: t
            };
          } finally {
            try {
              T && !T.done && (Q = s.return) && Q.call(s);
            } finally {
              if (a) throw a.error;
            }
          }
          return e;
        }, e.combineWithMathJax = function (t) {
          return a(e.MathJax, t);
        }, void 0 === r.g.MathJax && (r.g.MathJax = {}), r.g.MathJax.version || (r.g.MathJax = {
          version: o.VERSION,
          _: {},
          config: r.g.MathJax
        }), e.MathJax = r.g.MathJax;
      },
      235: function _(t, e, r) {
        var n,
          o,
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CONFIG = e.MathJax = e.Loader = e.PathFilters = e.PackageError = e.Package = void 0;
        var a = r(9515),
          Q = r(265),
          s = r(265);
        Object.defineProperty(e, "Package", {
          enumerable: !0,
          get: function get() {
            return s.Package;
          }
        }), Object.defineProperty(e, "PackageError", {
          enumerable: !0,
          get: function get() {
            return s.PackageError;
          }
        });
        var T,
          l = r(7525);
        if (e.PathFilters = {
          source: function source(t) {
            return e.CONFIG.source.hasOwnProperty(t.name) && (t.name = e.CONFIG.source[t.name]), !0;
          },
          normalize: function normalize(t) {
            var e = t.name;
            return e.match(/^(?:[a-z]+:\/)?\/|[a-z]:\\|\[/i) || (t.name = "[mathjax]/" + e.replace(/^\.\//, "")), t.addExtension && !e.match(/\.[^\/]+$/) && (t.name += ".js"), !0;
          },
          prefix: function prefix(t) {
            for (var r; (r = t.name.match(/^\[([^\]]*)\]/)) && e.CONFIG.paths.hasOwnProperty(r[1]);) t.name = e.CONFIG.paths[r[1]] + t.name.substr(r[0].length);
            return !0;
          }
        }, function (t) {
          var r = a.MathJax.version;
          t.versions = new Map(), t.ready = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            0 === r.length && (r = Array.from(Q.Package.packages.keys()));
            var o = [];
            try {
              for (var a = i(r), s = a.next(); !s.done; s = a.next()) {
                var T = s.value,
                  l = Q.Package.packages.get(T) || new Q.Package(T, !0);
                o.push(l.promise);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return Promise.all(o);
          }, t.load = function () {
            for (var r, n, o = [], a = 0; a < arguments.length; a++) o[a] = arguments[a];
            if (0 === o.length) return Promise.resolve();
            var s = [],
              T = function T(r) {
                var n = Q.Package.packages.get(r);
                n || (n = new Q.Package(r)).provides(e.CONFIG.provides[r]), n.checkNoLoad(), s.push(n.promise.then(function () {
                  e.CONFIG.versionWarnings && n.isLoaded && !t.versions.has(Q.Package.resolvePath(r)) && console.warn("No version information available for component ".concat(r));
                }));
              };
            try {
              for (var l = i(o), c = l.next(); !c.done; c = l.next()) {
                var u = c.value;
                T(u);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (n = l.return) && n.call(l);
              } finally {
                if (r) throw r.error;
              }
            }
            return Q.Package.loadAll(), Promise.all(s);
          }, t.preLoad = function () {
            for (var t, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            try {
              for (var a = i(n), s = a.next(); !s.done; s = a.next()) {
                var T = s.value,
                  l = Q.Package.packages.get(T);
                l || (l = new Q.Package(T, !0)).provides(e.CONFIG.provides[T]), l.loaded();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (r = a.return) && r.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.defaultReady = function () {
            void 0 !== e.MathJax.startup && e.MathJax.config.startup.ready();
          }, t.getRoot = function () {
            var t = "//../../es5";
            if ("undefined" != typeof document) {
              var e = document.currentScript || document.getElementById("MathJax-script");
              e && (t = e.src.replace(/\/[^\/]*$/, ""));
            }
            return t;
          }, t.checkVersion = function (n, o, i) {
            return t.versions.set(Q.Package.resolvePath(n), r), !(!e.CONFIG.versionWarnings || o === r) && (console.warn("Component ".concat(n, " uses ").concat(o, " of MathJax; version in use is ").concat(r)), !0);
          }, t.pathFilters = new l.FunctionList(), t.pathFilters.add(e.PathFilters.source, 0), t.pathFilters.add(e.PathFilters.normalize, 10), t.pathFilters.add(e.PathFilters.prefix, 20);
        }(T = e.Loader || (e.Loader = {})), e.MathJax = a.MathJax, void 0 === e.MathJax.loader) {
          (0, a.combineDefaults)(e.MathJax.config, "loader", {
            paths: {
              mathjax: T.getRoot()
            },
            source: {},
            dependencies: {},
            provides: {},
            load: [],
            ready: T.defaultReady.bind(T),
            failed: function failed(t) {
              return console.log("MathJax(".concat(t.package || "?", "): ").concat(t.message));
            },
            require: null,
            pathFilters: [],
            versionWarnings: !0
          }), (0, a.combineWithMathJax)({
            loader: T
          });
          try {
            for (var c = i(e.MathJax.config.loader.pathFilters), u = c.next(); !u.done; u = c.next()) {
              var p = u.value;
              Array.isArray(p) ? T.pathFilters.add(p[0], p[1]) : T.pathFilters.add(p);
            }
          } catch (t) {
            n = {
              error: t
            };
          } finally {
            try {
              u && !u.done && (o = c.return) && o.call(c);
            } finally {
              if (n) throw n.error;
            }
          }
        }
        e.CONFIG = e.MathJax.config.loader;
      },
      265: function _(t, e, r) {
        var _n4,
          o = this && this.__extends || (_n4 = function n(t, e) {
            return _n4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n4(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n4(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Package = e.PackageError = void 0;
        var s = r(235),
          T = function (t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return n.package = r, n;
            }
            return o(e, t), e;
          }(Error);
        e.PackageError = T;
        var l = function () {
          function t(e, r) {
            void 0 === r && (r = !1), this.isLoaded = !1, this.isLoading = !1, this.hasFailed = !1, this.dependents = [], this.dependencies = [], this.dependencyCount = 0, this.provided = [], this.name = e, this.noLoad = r, t.packages.set(e, this), this.promise = this.makePromise(this.makeDependencies());
          }
          return Object.defineProperty(t.prototype, "canLoad", {
            get: function get() {
              return 0 === this.dependencyCount && !this.noLoad && !this.isLoading && !this.hasFailed;
            },
            enumerable: !1,
            configurable: !0
          }), t.resolvePath = function (t, e) {
            void 0 === e && (e = !0);
            var r = {
              name: t,
              original: t,
              addExtension: e
            };
            return s.Loader.pathFilters.execute(r), r.name;
          }, t.loadAll = function () {
            var t, e;
            try {
              for (var r = i(this.packages.values()), n = r.next(); !n.done; n = r.next()) {
                var o = n.value;
                o.canLoad && o.load();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (e = r.return) && e.call(r);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.makeDependencies = function () {
            var e,
              r,
              n = [],
              o = t.packages,
              T = this.noLoad,
              l = this.name,
              c = [];
            s.CONFIG.dependencies.hasOwnProperty(l) ? c.push.apply(c, Q([], a(s.CONFIG.dependencies[l]), !1)) : "core" !== l && c.push("core");
            try {
              for (var u = i(c), p = u.next(); !p.done; p = u.next()) {
                var h = p.value,
                  d = o.get(h) || new t(h, T);
                this.dependencies.indexOf(d) < 0 && (d.addDependent(this, T), this.dependencies.push(d), d.isLoaded || (this.dependencyCount++, n.push(d.promise)));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (r = u.return) && r.call(u);
              } finally {
                if (e) throw e.error;
              }
            }
            return n;
          }, t.prototype.makePromise = function (t) {
            var e = this,
              r = new Promise(function (t, r) {
                e.resolve = t, e.reject = r;
              }),
              n = s.CONFIG[this.name] || {};
            return n.ready && (r = r.then(function (t) {
              return n.ready(e.name);
            })), t.length && (t.push(r), r = Promise.all(t).then(function (t) {
              return t.join(", ");
            })), n.failed && r.catch(function (t) {
              return n.failed(new T(t, e.name));
            }), r;
          }, t.prototype.load = function () {
            if (!this.isLoaded && !this.isLoading && !this.noLoad) {
              this.isLoading = !0;
              var e = t.resolvePath(this.name);
              s.CONFIG.require ? this.loadCustom(e) : this.loadScript(e);
            }
          }, t.prototype.loadCustom = function (t) {
            var e = this;
            try {
              var r = s.CONFIG.require(t);
              r instanceof Promise ? r.then(function () {
                return e.checkLoad();
              }).catch(function (r) {
                return e.failed("Can't load \"" + t + '"\n' + r.message.trim());
              }) : this.checkLoad();
            } catch (t) {
              this.failed(t.message);
            }
          }, t.prototype.loadScript = function (t) {
            var e = this,
              r = document.createElement("script");
            r.src = t, r.charset = "UTF-8", r.onload = function (t) {
              return e.checkLoad();
            }, r.onerror = function (r) {
              return e.failed("Can't load \"" + t + '"');
            }, document.head.appendChild(r);
          }, t.prototype.loaded = function () {
            var t, e, r, n;
            this.isLoaded = !0, this.isLoading = !1;
            try {
              for (var o = i(this.dependents), a = o.next(); !a.done; a = o.next()) {
                a.value.requirementSatisfied();
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            try {
              for (var Q = i(this.provided), s = Q.next(); !s.done; s = Q.next()) {
                s.value.loaded();
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = Q.return) && n.call(Q);
              } finally {
                if (r) throw r.error;
              }
            }
            this.resolve(this.name);
          }, t.prototype.failed = function (t) {
            this.hasFailed = !0, this.isLoading = !1, this.reject(new T(t, this.name));
          }, t.prototype.checkLoad = function () {
            var t = this;
            ((s.CONFIG[this.name] || {}).checkReady || function () {
              return Promise.resolve();
            })().then(function () {
              return t.loaded();
            }).catch(function (e) {
              return t.failed(e);
            });
          }, t.prototype.requirementSatisfied = function () {
            this.dependencyCount && (this.dependencyCount--, this.canLoad && this.load());
          }, t.prototype.provides = function (e) {
            var r, n;
            void 0 === e && (e = []);
            try {
              for (var o = i(e), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value,
                  T = t.packages.get(Q);
                T || (s.CONFIG.dependencies[Q] || (s.CONFIG.dependencies[Q] = []), s.CONFIG.dependencies[Q].push(Q), (T = new t(Q, !0)).isLoading = !0), this.provided.push(T);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.prototype.addDependent = function (t, e) {
            this.dependents.push(t), e || this.checkNoLoad();
          }, t.prototype.checkNoLoad = function () {
            var t, e;
            if (this.noLoad) {
              this.noLoad = !1;
              try {
                for (var r = i(this.dependencies), n = r.next(); !n.done; n = r.next()) {
                  n.value.checkNoLoad();
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }
          }, t.packages = new Map(), t;
        }();
        e.Package = l;
      },
      2388: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CONFIG = e.MathJax = e.Startup = void 0;
        var Q,
          s = r(9515),
          T = r(8666),
          l = r(7233);
        !function (t) {
          var Q,
            s,
            l = new T.PrioritizedList();
          function u(e) {
            return Q.visitTree(e, t.document);
          }
          function p() {
            Q = new e.MathJax._.core.MmlTree.SerializedMmlVisitor.SerializedMmlVisitor(), s = e.MathJax._.mathjax.mathjax, t.input = y(), t.output = g(), t.adaptor = v(), t.handler && s.handlers.unregister(t.handler), t.handler = b(), t.handler && (s.handlers.register(t.handler), t.document = H());
          }
          function h() {
            var e, r;
            t.input && t.output && d();
            var n = t.output ? t.output.name.toLowerCase() : "";
            try {
              for (var i = o(t.input), a = i.next(); !a.done; a = i.next()) {
                var Q = a.value,
                  s = Q.name.toLowerCase();
                m(s, Q), L(s, Q), t.output && f(s, n, Q);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
          }
          function d() {
            e.MathJax.typeset = function (e) {
              void 0 === e && (e = null), t.document.options.elements = e, t.document.reset(), t.document.render();
            }, e.MathJax.typesetPromise = function (e) {
              return void 0 === e && (e = null), t.document.options.elements = e, t.document.reset(), s.handleRetriesFor(function () {
                t.document.render();
              });
            }, e.MathJax.typesetClear = function (e) {
              void 0 === e && (e = null), e ? t.document.clearMathItemsWithin(e) : t.document.clear();
            };
          }
          function f(r, n, o) {
            var i = r + "2" + n;
            e.MathJax[i] = function (e, r) {
              return void 0 === r && (r = {}), r.format = o.name, t.document.convert(e, r);
            }, e.MathJax[i + "Promise"] = function (e, r) {
              return void 0 === r && (r = {}), r.format = o.name, s.handleRetriesFor(function () {
                return t.document.convert(e, r);
              });
            }, e.MathJax[n + "Stylesheet"] = function () {
              return t.output.styleSheet(t.document);
            }, "getMetricsFor" in t.output && (e.MathJax.getMetricsFor = function (e, r) {
              return t.output.getMetricsFor(e, r);
            });
          }
          function m(r, n) {
            var o = e.MathJax._.core.MathItem.STATE;
            e.MathJax[r + "2mml"] = function (e, r) {
              return void 0 === r && (r = {}), r.end = o.CONVERT, r.format = n.name, u(t.document.convert(e, r));
            }, e.MathJax[r + "2mmlPromise"] = function (e, r) {
              return void 0 === r && (r = {}), r.end = o.CONVERT, r.format = n.name, s.handleRetriesFor(function () {
                return u(t.document.convert(e, r));
              });
            };
          }
          function L(t, r) {
            e.MathJax[t + "Reset"] = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
              return r.reset.apply(r, a([], i(t), !1));
            };
          }
          function y() {
            var r,
              n,
              i = [];
            try {
              for (var a = o(e.CONFIG.input), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value,
                  T = t.constructors[s];
                if (!T) throw Error('Input Jax "' + s + '" is not defined (has it been loaded?)');
                i.push(new T(e.MathJax.config[s]));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return i;
          }
          function g() {
            var r = e.CONFIG.output;
            if (!r) return null;
            var n = t.constructors[r];
            if (!n) throw Error('Output Jax "' + r + '" is not defined (has it been loaded?)');
            return new n(e.MathJax.config[r]);
          }
          function v() {
            var r = e.CONFIG.adaptor;
            if (!r || "none" === r) return null;
            var n = t.constructors[r];
            if (!n) throw Error('DOMAdaptor "' + r + '" is not defined (has it been loaded?)');
            return n(e.MathJax.config[r]);
          }
          function b() {
            var r,
              n,
              i = e.CONFIG.handler;
            if (!i || "none" === i || !t.adaptor) return null;
            var a = t.constructors[i];
            if (!a) throw Error('Handler "' + i + '" is not defined (has it been loaded?)');
            var Q = new a(t.adaptor, 5);
            try {
              for (var s = o(l), T = s.next(); !T.done; T = s.next()) {
                Q = T.value.item(Q);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (n = s.return) && n.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
            return Q;
          }
          function H(r) {
            return void 0 === r && (r = null), s.document(r || e.CONFIG.document, n(n({}, e.MathJax.config.options), {
              InputJax: t.input,
              OutputJax: t.output
            }));
          }
          t.constructors = {}, t.input = [], t.output = null, t.handler = null, t.adaptor = null, t.elements = null, t.document = null, t.promise = new Promise(function (e, r) {
            t.promiseResolve = e, t.promiseReject = r;
          }), t.pagePromise = new Promise(function (t, e) {
            var n = r.g.document;
            if (n && n.readyState && "complete" !== n.readyState && "interactive" !== n.readyState) {
              var o = function o() {
                return t();
              };
              n.defaultView.addEventListener("load", o, !0), n.defaultView.addEventListener("DOMContentLoaded", o, !0);
            } else t();
          }), t.toMML = u, t.registerConstructor = function (e, r) {
            t.constructors[e] = r;
          }, t.useHandler = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.handler && !r || (e.CONFIG.handler = t);
          }, t.useAdaptor = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.adaptor && !r || (e.CONFIG.adaptor = t);
          }, t.useInput = function (t, r) {
            void 0 === r && (r = !1), c && !r || e.CONFIG.input.push(t);
          }, t.useOutput = function (t, r) {
            void 0 === r && (r = !1), e.CONFIG.output && !r || (e.CONFIG.output = t);
          }, t.extendHandler = function (t, e) {
            void 0 === e && (e = 10), l.add(t, e);
          }, t.defaultReady = function () {
            p(), h(), t.pagePromise.then(function () {
              return e.CONFIG.pageReady();
            }).then(function () {
              return t.promiseResolve();
            }).catch(function (e) {
              return t.promiseReject(e);
            });
          }, t.defaultPageReady = function () {
            return e.CONFIG.typeset && e.MathJax.typesetPromise ? e.MathJax.typesetPromise(e.CONFIG.elements) : Promise.resolve();
          }, t.getComponents = p, t.makeMethods = h, t.makeTypesetMethods = d, t.makeOutputMethods = f, t.makeMmlMethods = m, t.makeResetMethod = L, t.getInputJax = y, t.getOutputJax = g, t.getAdaptor = v, t.getHandler = b, t.getDocument = H;
        }(Q = e.Startup || (e.Startup = {})), e.MathJax = s.MathJax, void 0 === e.MathJax._.startup && ((0, s.combineDefaults)(e.MathJax.config, "startup", {
          input: [],
          output: "",
          handler: null,
          adaptor: null,
          document: "undefined" == typeof document ? "" : document,
          elements: null,
          typeset: !0,
          ready: Q.defaultReady.bind(Q),
          pageReady: Q.defaultPageReady.bind(Q)
        }), (0, s.combineWithMathJax)({
          startup: Q,
          options: {}
        }), e.MathJax.config.startup.invalidOption && (l.OPTIONS.invalidOption = e.MathJax.config.startup.invalidOption), e.MathJax.config.startup.optionError && (l.OPTIONS.optionError = e.MathJax.config.startup.optionError)), e.CONFIG = e.MathJax.config.startup;
        var c = 0 !== e.CONFIG.input.length;
      },
      3282: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VERSION = void 0, e.VERSION = "3.2.2";
      },
      5009: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractDOMAdaptor = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = null), this.document = t;
          }
          return t.prototype.node = function (t, e, n, o) {
            var i, a;
            void 0 === e && (e = {}), void 0 === n && (n = []);
            var Q = this.create(t, o);
            this.setAttributes(Q, e);
            try {
              for (var s = r(n), T = s.next(); !T.done; T = s.next()) {
                var l = T.value;
                this.append(Q, l);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (a = s.return) && a.call(s);
              } finally {
                if (i) throw i.error;
              }
            }
            return Q;
          }, t.prototype.setAttributes = function (t, e) {
            var n, o, i, a, Q, s;
            if (e.style && "string" != typeof e.style) try {
              for (var T = r(Object.keys(e.style)), l = T.next(); !l.done; l = T.next()) {
                var c = l.value;
                this.setStyle(t, c.replace(/-([a-z])/g, function (t, e) {
                  return e.toUpperCase();
                }), e.style[c]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (o = T.return) && o.call(T);
              } finally {
                if (n) throw n.error;
              }
            }
            if (e.properties) try {
              for (var u = r(Object.keys(e.properties)), p = u.next(); !p.done; p = u.next()) {
                t[c = p.value] = e.properties[c];
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                p && !p.done && (a = u.return) && a.call(u);
              } finally {
                if (i) throw i.error;
              }
            }
            try {
              for (var h = r(Object.keys(e)), d = h.next(); !d.done; d = h.next()) {
                "style" === (c = d.value) && "string" != typeof e.style || "properties" === c || this.setAttribute(t, c, e[c]);
              }
            } catch (t) {
              Q = {
                error: t
              };
            } finally {
              try {
                d && !d.done && (s = h.return) && s.call(h);
              } finally {
                if (Q) throw Q.error;
              }
            }
          }, t.prototype.replace = function (t, e) {
            return this.insert(t, e), this.remove(e), e;
          }, t.prototype.childNode = function (t, e) {
            return this.childNodes(t)[e];
          }, t.prototype.allClasses = function (t) {
            var e = this.getAttribute(t, "class");
            return e ? e.replace(/  +/g, " ").replace(/^ /, "").replace(/ $/, "").split(/ /) : [];
          }, t;
        }();
        e.AbstractDOMAdaptor = n;
      },
      3494: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractFindMath = void 0;
        var n = r(7233),
          o = function () {
            function t(t) {
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t);
            }
            return t.OPTIONS = {}, t;
          }();
        e.AbstractFindMath = o;
      },
      3670: function _(t, e, r) {
        var _n5,
          o = this && this.__extends || (_n5 = function n(t, e) {
            return _n5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n5(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n5(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractHandler = void 0;
        var i = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(r(5722).AbstractMathDocument),
          a = function () {
            function t(t, e) {
              void 0 === e && (e = 5), this.documentClass = i, this.adaptor = t, this.priority = e;
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.handlesDocument = function (t) {
              return !1;
            }, t.prototype.create = function (t, e) {
              return new this.documentClass(t, this.adaptor, e);
            }, t.NAME = "generic", t;
          }();
        e.AbstractHandler = a;
      },
      805: function _(t, e, r) {
        var _n6,
          o = this && this.__extends || (_n6 = function n(t, e) {
            return _n6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n6(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n6(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HandlerList = void 0;
        var a = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.register = function (t) {
            return this.add(t, t.priority);
          }, e.prototype.unregister = function (t) {
            this.remove(t);
          }, e.prototype.handlesDocument = function (t) {
            var e, r;
            try {
              for (var n = i(this), o = n.next(); !o.done; o = n.next()) {
                var a = o.value.item;
                if (a.handlesDocument(t)) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
            throw new Error("Can't find handler for document");
          }, e.prototype.document = function (t, e) {
            return void 0 === e && (e = null), this.handlesDocument(t).create(t, e);
          }, e;
        }(r(8666).PrioritizedList);
        e.HandlerList = a;
      },
      9206: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractInputJax = void 0;
        var n = r(7233),
          o = r(7525),
          i = function () {
            function t(t) {
              void 0 === t && (t = {}), this.adaptor = null, this.mmlFactory = null;
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t), this.preFilters = new o.FunctionList(), this.postFilters = new o.FunctionList();
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.setAdaptor = function (t) {
              this.adaptor = t;
            }, t.prototype.setMmlFactory = function (t) {
              this.mmlFactory = t;
            }, t.prototype.initialize = function () {}, t.prototype.reset = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            }, Object.defineProperty(t.prototype, "processStrings", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.findMath = function (t, e) {
              return [];
            }, t.prototype.executeFilters = function (t, e, r, n) {
              var o = {
                math: e,
                document: r,
                data: n
              };
              return t.execute(o), o.data;
            }, t.NAME = "generic", t.OPTIONS = {}, t;
          }();
        e.AbstractInputJax = i;
      },
      5722: function _(t, e, r) {
        var _n7,
          o = this && this.__extends || (_n7 = function n(t, e) {
            return _n7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n7(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n7(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMathDocument = e.resetAllOptions = e.resetOptions = e.RenderList = void 0;
        var s = r(7233),
          T = r(9206),
          l = r(2975),
          c = r(9e3),
          u = r(4474),
          p = r(3909),
          h = r(6751),
          d = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.create = function (t) {
              var e,
                r,
                n = new this();
              try {
                for (var o = i(Object.keys(t)), Q = o.next(); !Q.done; Q = o.next()) {
                  var s = Q.value,
                    T = a(this.action(s, t[s]), 2),
                    l = T[0],
                    c = T[1];
                  c && n.add(l, c);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return n;
            }, e.action = function (t, e) {
              var r,
                n,
                o,
                i,
                Q,
                s,
                T = !0,
                l = e[0];
              if (1 === e.length || "boolean" == typeof e[1]) 2 === e.length && (T = e[1]), Q = (r = a(this.methodActions(t), 2))[0], s = r[1];else if ("string" == typeof e[1]) {
                if ("string" == typeof e[2]) {
                  4 === e.length && (T = e[3]);
                  var c = a(e.slice(1), 2),
                    u = c[0],
                    p = c[1];
                  Q = (n = a(this.methodActions(u, p), 2))[0], s = n[1];
                } else 3 === e.length && (T = e[2]), Q = (o = a(this.methodActions(e[1]), 2))[0], s = o[1];
              } else 4 === e.length && (T = e[3]), Q = (i = a(e.slice(1), 2))[0], s = i[1];
              return [{
                id: t,
                renderDoc: Q,
                renderMath: s,
                convert: T
              }, l];
            }, e.methodActions = function (t, e) {
              return void 0 === e && (e = t), [function (e) {
                return t && e[t](), !1;
              }, function (t, r) {
                return e && t[e](r), !1;
              }];
            }, e.prototype.renderDoc = function (t, e) {
              var r, n;
              void 0 === e && (e = u.STATE.UNPROCESSED);
              try {
                for (var o = i(this.items), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  if (Q.priority >= e && Q.item.renderDoc(t)) return;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, e.prototype.renderMath = function (t, e, r) {
              var n, o;
              void 0 === r && (r = u.STATE.UNPROCESSED);
              try {
                for (var a = i(this.items), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  if (s.priority >= r && s.item.renderMath(t, e)) return;
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (o = a.return) && o.call(a);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.renderConvert = function (t, e, r) {
              var n, o;
              void 0 === r && (r = u.STATE.LAST);
              try {
                for (var a = i(this.items), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  if (s.priority > r) return;
                  if (s.item.convert && s.item.renderMath(t, e)) return;
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (o = a.return) && o.call(a);
                } finally {
                  if (n) throw n.error;
                }
              }
            }, e.prototype.findID = function (t) {
              var e, r;
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if (a.item.id === t) return a.item;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e;
          }(r(8666).PrioritizedList);
        e.RenderList = d, e.resetOptions = {
          all: !1,
          processed: !1,
          inputJax: null,
          outputJax: null
        }, e.resetAllOptions = {
          all: !0,
          processed: !0,
          inputJax: [],
          outputJax: []
        };
        var f = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.compile = function (t) {
              return null;
            }, e;
          }(T.AbstractInputJax),
          m = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.typeset = function (t, e) {
              return void 0 === e && (e = null), null;
            }, e.prototype.escaped = function (t, e) {
              return null;
            }, e;
          }(l.AbstractOutputJax),
          L = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(c.AbstractMathList),
          y = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e;
          }(u.AbstractMathItem),
          g = function () {
            function t(e, r, n) {
              var o = this,
                i = this.constructor;
              this.document = e, this.options = (0, s.userOptions)((0, s.defaultOptions)({}, i.OPTIONS), n), this.math = new (this.options.MathList || L)(), this.renderActions = d.create(this.options.renderActions), this.processed = new t.ProcessBits(), this.outputJax = this.options.OutputJax || new m();
              var a = this.options.InputJax || [new f()];
              Array.isArray(a) || (a = [a]), this.inputJax = a, this.adaptor = r, this.outputJax.setAdaptor(r), this.inputJax.map(function (t) {
                return t.setAdaptor(r);
              }), this.mmlFactory = this.options.MmlFactory || new p.MmlFactory(), this.inputJax.map(function (t) {
                return t.setMmlFactory(o.mmlFactory);
              }), this.outputJax.initialize(), this.inputJax.map(function (t) {
                return t.initialize();
              });
            }
            return Object.defineProperty(t.prototype, "kind", {
              get: function get() {
                return this.constructor.KIND;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.addRenderAction = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var n = a(d.action(t, e), 2),
                o = n[0],
                i = n[1];
              this.renderActions.add(o, i);
            }, t.prototype.removeRenderAction = function (t) {
              var e = this.renderActions.findID(t);
              e && this.renderActions.remove(e);
            }, t.prototype.render = function () {
              return this.renderActions.renderDoc(this), this;
            }, t.prototype.rerender = function (t) {
              return void 0 === t && (t = u.STATE.RERENDER), this.state(t - 1), this.render(), this;
            }, t.prototype.convert = function (t, e) {
              void 0 === e && (e = {});
              var r = (0, s.userOptions)({
                  format: this.inputJax[0].name,
                  display: !0,
                  end: u.STATE.LAST,
                  em: 16,
                  ex: 8,
                  containerWidth: null,
                  lineWidth: 1e6,
                  scale: 1,
                  family: ""
                }, e),
                n = r.format,
                o = r.display,
                i = r.end,
                a = r.ex,
                Q = r.em,
                T = r.containerWidth,
                l = r.lineWidth,
                c = r.scale,
                p = r.family;
              null === T && (T = 80 * a);
              var h = this.inputJax.reduce(function (t, e) {
                  return e.name === n ? e : t;
                }, null),
                d = new this.options.MathItem(t, h, o);
              return d.start.node = this.adaptor.body(this.document), d.setMetrics(Q, a, T, l, c), this.outputJax.options.mtextInheritFont && (d.outputData.mtextFamily = p), this.outputJax.options.merrorInheritFont && (d.outputData.merrorFamily = p), d.convert(this, i), d.typesetRoot || d.root;
            }, t.prototype.findMath = function (t) {
              return void 0 === t && (t = null), this.processed.set("findMath"), this;
            }, t.prototype.compile = function () {
              var t, e, r, n;
              if (!this.processed.isSet("compile")) {
                var o = [];
                try {
                  for (var a = i(this.math), Q = a.next(); !Q.done; Q = a.next()) {
                    var s = Q.value;
                    this.compileMath(s), void 0 !== s.inputData.recompile && o.push(s);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    Q && !Q.done && (e = a.return) && e.call(a);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                try {
                  for (var T = i(o), l = T.next(); !l.done; l = T.next()) {
                    var c = (s = l.value).inputData.recompile;
                    s.state(c.state), s.inputData.recompile = c, this.compileMath(s);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    l && !l.done && (n = T.return) && n.call(T);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                this.processed.set("compile");
              }
              return this;
            }, t.prototype.compileMath = function (t) {
              try {
                t.compile(this);
              } catch (e) {
                if (e.retry || e.restart) throw e;
                this.options.compileError(this, t, e), t.inputData.error = e;
              }
            }, t.prototype.compileError = function (t, e) {
              t.root = this.mmlFactory.create("math", null, [this.mmlFactory.create("merror", {
                "data-mjx-error": e.message,
                title: e.message
              }, [this.mmlFactory.create("mtext", null, [this.mmlFactory.create("text").setText("Math input error")])])]), t.display && t.root.attributes.set("display", "block"), t.inputData.error = e.message;
            }, t.prototype.typeset = function () {
              var t, e;
              if (!this.processed.isSet("typeset")) {
                try {
                  for (var r = i(this.math), n = r.next(); !n.done; n = r.next()) {
                    var o = n.value;
                    try {
                      o.typeset(this);
                    } catch (t) {
                      if (t.retry || t.restart) throw t;
                      this.options.typesetError(this, o, t), o.outputData.error = t;
                    }
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("typeset");
              }
              return this;
            }, t.prototype.typesetError = function (t, e) {
              t.typesetRoot = this.adaptor.node("mjx-container", {
                class: "MathJax mjx-output-error",
                jax: this.outputJax.name
              }, [this.adaptor.node("span", {
                "data-mjx-error": e.message,
                title: e.message,
                style: {
                  color: "red",
                  "background-color": "yellow",
                  "line-height": "normal"
                }
              }, [this.adaptor.text("Math output error")])]), t.display && this.adaptor.setAttributes(t.typesetRoot, {
                style: {
                  display: "block",
                  margin: "1em 0",
                  "text-align": "center"
                }
              }), t.outputData.error = e.message;
            }, t.prototype.getMetrics = function () {
              return this.processed.isSet("getMetrics") || (this.outputJax.getMetrics(this), this.processed.set("getMetrics")), this;
            }, t.prototype.updateDocument = function () {
              var t, e;
              if (!this.processed.isSet("updateDocument")) {
                try {
                  for (var r = i(this.math.reversed()), n = r.next(); !n.done; n = r.next()) {
                    n.value.updateDocument(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("updateDocument");
              }
              return this;
            }, t.prototype.removeFromDocument = function (t) {
              return void 0 === t && (t = !1), this;
            }, t.prototype.state = function (t, e) {
              var r, n;
              void 0 === e && (e = !1);
              try {
                for (var o = i(this.math), a = o.next(); !a.done; a = o.next()) {
                  a.value.state(t, e);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return t < u.STATE.INSERTED && this.processed.clear("updateDocument"), t < u.STATE.TYPESET && (this.processed.clear("typeset"), this.processed.clear("getMetrics")), t < u.STATE.COMPILED && this.processed.clear("compile"), this;
            }, t.prototype.reset = function (t) {
              var r;
              return void 0 === t && (t = {
                processed: !0
              }), (t = (0, s.userOptions)(Object.assign({}, e.resetOptions), t)).all && Object.assign(t, e.resetAllOptions), t.processed && this.processed.reset(), t.inputJax && this.inputJax.forEach(function (e) {
                return e.reset.apply(e, Q([], a(t.inputJax), !1));
              }), t.outputJax && (r = this.outputJax).reset.apply(r, Q([], a(t.outputJax), !1)), this;
            }, t.prototype.clear = function () {
              return this.reset(), this.math.clear(), this;
            }, t.prototype.concat = function (t) {
              return this.math.merge(t), this;
            }, t.prototype.clearMathItemsWithin = function (t) {
              var e,
                r = this.getMathItemsWithin(t);
              return (e = this.math).remove.apply(e, Q([], a(r), !1)), r;
            }, t.prototype.getMathItemsWithin = function (t) {
              var e, r, n, o;
              Array.isArray(t) || (t = [t]);
              var a = this.adaptor,
                Q = [],
                s = a.getElements(t, this.document);
              try {
                t: for (var T = i(this.math), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value;
                  try {
                    for (var u = (n = void 0, i(s)), p = u.next(); !p.done; p = u.next()) {
                      var h = p.value;
                      if (c.start.node && a.contains(h, c.start.node)) {
                        Q.push(c);
                        continue t;
                      }
                    }
                  } catch (t) {
                    n = {
                      error: t
                    };
                  } finally {
                    try {
                      p && !p.done && (o = u.return) && o.call(u);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (r = T.return) && r.call(T);
                } finally {
                  if (e) throw e.error;
                }
              }
              return Q;
            }, t.KIND = "MathDocument", t.OPTIONS = {
              OutputJax: null,
              InputJax: null,
              MmlFactory: null,
              MathList: L,
              MathItem: y,
              compileError: function compileError(t, e, r) {
                t.compileError(e, r);
              },
              typesetError: function typesetError(t, e, r) {
                t.typesetError(e, r);
              },
              renderActions: (0, s.expandable)({
                find: [u.STATE.FINDMATH, "findMath", "", !1],
                compile: [u.STATE.COMPILED],
                metrics: [u.STATE.METRICS, "getMetrics", "", !1],
                typeset: [u.STATE.TYPESET],
                update: [u.STATE.INSERTED, "updateDocument", !1]
              })
            }, t.ProcessBits = (0, h.BitFieldClass)("findMath", "compile", "getMetrics", "typeset", "updateDocument"), t;
          }();
        e.AbstractMathDocument = g;
      },
      4474: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.newState = e.STATE = e.AbstractMathItem = e.protoItem = void 0, e.protoItem = function (t, e, r, n, o, i, a) {
          return void 0 === a && (a = null), {
            open: t,
            math: e,
            close: r,
            n: n,
            start: {
              n: o
            },
            end: {
              n: i
            },
            display: a
          };
        };
        var r = function () {
          function t(t, r, n, o, i) {
            void 0 === n && (n = !0), void 0 === o && (o = {
              i: 0,
              n: 0,
              delim: ""
            }), void 0 === i && (i = {
              i: 0,
              n: 0,
              delim: ""
            }), this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {}, this._state = e.STATE.UNPROCESSED, this.math = t, this.inputJax = r, this.display = n, this.start = o, this.end = i, this.root = null, this.typesetRoot = null, this.metrics = {}, this.inputData = {}, this.outputData = {};
          }
          return Object.defineProperty(t.prototype, "isEscaped", {
            get: function get() {
              return null === this.display;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.render = function (t) {
            t.renderActions.renderMath(this, t);
          }, t.prototype.rerender = function (t, r) {
            void 0 === r && (r = e.STATE.RERENDER), this.state() >= r && this.state(r - 1), t.renderActions.renderMath(this, t, r);
          }, t.prototype.convert = function (t, r) {
            void 0 === r && (r = e.STATE.LAST), t.renderActions.renderConvert(this, t, r);
          }, t.prototype.compile = function (t) {
            this.state() < e.STATE.COMPILED && (this.root = this.inputJax.compile(this, t), this.state(e.STATE.COMPILED));
          }, t.prototype.typeset = function (t) {
            this.state() < e.STATE.TYPESET && (this.typesetRoot = t.outputJax[this.isEscaped ? "escaped" : "typeset"](this, t), this.state(e.STATE.TYPESET));
          }, t.prototype.updateDocument = function (t) {}, t.prototype.removeFromDocument = function (t) {
            void 0 === t && (t = !1);
          }, t.prototype.setMetrics = function (t, e, r, n, o) {
            this.metrics = {
              em: t,
              ex: e,
              containerWidth: r,
              lineWidth: n,
              scale: o
            };
          }, t.prototype.state = function (t, r) {
            return void 0 === t && (t = null), void 0 === r && (r = !1), null != t && (t < e.STATE.INSERTED && this._state >= e.STATE.INSERTED && this.removeFromDocument(r), t < e.STATE.TYPESET && this._state >= e.STATE.TYPESET && (this.outputData = {}), t < e.STATE.COMPILED && this._state >= e.STATE.COMPILED && (this.inputData = {}), this._state = t), this._state;
          }, t.prototype.reset = function (t) {
            void 0 === t && (t = !1), this.state(e.STATE.UNPROCESSED, t);
          }, t;
        }();
        e.AbstractMathItem = r, e.STATE = {
          UNPROCESSED: 0,
          FINDMATH: 10,
          COMPILED: 20,
          CONVERT: 100,
          METRICS: 110,
          RERENDER: 125,
          TYPESET: 150,
          INSERTED: 200,
          LAST: 1e4
        }, e.newState = function (t, r) {
          if (t in e.STATE) throw Error("State " + t + " already exists");
          e.STATE[t] = r;
        };
      },
      9e3: function _(t, e, r) {
        var _n8,
          o = this && this.__extends || (_n8 = function n(t, e) {
            return _n8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n8(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n8(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMathList = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.isBefore = function (t, e) {
            return t.start.i < e.start.i || t.start.i === e.start.i && t.start.n < e.start.n;
          }, e;
        }(r(103).LinkedList);
        e.AbstractMathList = i;
      },
      91: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Attributes = e.INHERIT = void 0, e.INHERIT = "_inherit_";
        var n = function () {
          function t(t, e) {
            this.global = e, this.defaults = Object.create(e), this.inherited = Object.create(this.defaults), this.attributes = Object.create(this.inherited), Object.assign(this.defaults, t);
          }
          return t.prototype.set = function (t, e) {
            this.attributes[t] = e;
          }, t.prototype.setList = function (t) {
            Object.assign(this.attributes, t);
          }, t.prototype.get = function (t) {
            var r = this.attributes[t];
            return r === e.INHERIT && (r = this.global[t]), r;
          }, t.prototype.getExplicit = function (t) {
            if (this.attributes.hasOwnProperty(t)) return this.attributes[t];
          }, t.prototype.getList = function () {
            for (var t, e, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            var i = {};
            try {
              for (var a = r(n), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                i[s] = this.get(s);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                Q && !Q.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return i;
          }, t.prototype.setInherited = function (t, e) {
            this.inherited[t] = e;
          }, t.prototype.getInherited = function (t) {
            return this.inherited[t];
          }, t.prototype.getDefault = function (t) {
            return this.defaults[t];
          }, t.prototype.isSet = function (t) {
            return this.attributes.hasOwnProperty(t) || this.inherited.hasOwnProperty(t);
          }, t.prototype.hasDefault = function (t) {
            return t in this.defaults;
          }, t.prototype.getExplicitNames = function () {
            return Object.keys(this.attributes);
          }, t.prototype.getInheritedNames = function () {
            return Object.keys(this.inherited);
          }, t.prototype.getDefaultNames = function () {
            return Object.keys(this.defaults);
          }, t.prototype.getGlobalNames = function () {
            return Object.keys(this.global);
          }, t.prototype.getAllAttributes = function () {
            return this.attributes;
          }, t.prototype.getAllInherited = function () {
            return this.inherited;
          }, t.prototype.getAllDefaults = function () {
            return this.defaults;
          }, t.prototype.getAllGlobals = function () {
            return this.global;
          }, t;
        }();
        e.Attributes = n;
      },
      6336: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MML = void 0;
        var o = r(9007),
          i = r(3233),
          a = r(450),
          Q = r(3050),
          s = r(2756),
          T = r(4770),
          l = r(6030),
          c = r(7265),
          u = r(9878),
          p = r(6850),
          h = r(7131),
          d = r(6145),
          f = r(1314),
          m = r(1581),
          L = r(7238),
          y = r(5741),
          g = r(5410),
          v = r(6661),
          b = r(9145),
          H = r(4461),
          _ = r(5184),
          M = r(6405),
          x = r(1349),
          O = r(5022),
          S = r(4359),
          V = r(142),
          E = r(7590),
          A = r(3985),
          C = r(9102),
          w = r(3948),
          N = r(1334);
        e.MML = ((n = {})[i.MmlMath.prototype.kind] = i.MmlMath, n[a.MmlMi.prototype.kind] = a.MmlMi, n[Q.MmlMn.prototype.kind] = Q.MmlMn, n[s.MmlMo.prototype.kind] = s.MmlMo, n[T.MmlMtext.prototype.kind] = T.MmlMtext, n[l.MmlMspace.prototype.kind] = l.MmlMspace, n[c.MmlMs.prototype.kind] = c.MmlMs, n[u.MmlMrow.prototype.kind] = u.MmlMrow, n[u.MmlInferredMrow.prototype.kind] = u.MmlInferredMrow, n[p.MmlMfrac.prototype.kind] = p.MmlMfrac, n[h.MmlMsqrt.prototype.kind] = h.MmlMsqrt, n[d.MmlMroot.prototype.kind] = d.MmlMroot, n[f.MmlMstyle.prototype.kind] = f.MmlMstyle, n[m.MmlMerror.prototype.kind] = m.MmlMerror, n[L.MmlMpadded.prototype.kind] = L.MmlMpadded, n[y.MmlMphantom.prototype.kind] = y.MmlMphantom, n[g.MmlMfenced.prototype.kind] = g.MmlMfenced, n[v.MmlMenclose.prototype.kind] = v.MmlMenclose, n[b.MmlMaction.prototype.kind] = b.MmlMaction, n[H.MmlMsub.prototype.kind] = H.MmlMsub, n[H.MmlMsup.prototype.kind] = H.MmlMsup, n[H.MmlMsubsup.prototype.kind] = H.MmlMsubsup, n[_.MmlMunder.prototype.kind] = _.MmlMunder, n[_.MmlMover.prototype.kind] = _.MmlMover, n[_.MmlMunderover.prototype.kind] = _.MmlMunderover, n[M.MmlMmultiscripts.prototype.kind] = M.MmlMmultiscripts, n[M.MmlMprescripts.prototype.kind] = M.MmlMprescripts, n[M.MmlNone.prototype.kind] = M.MmlNone, n[x.MmlMtable.prototype.kind] = x.MmlMtable, n[O.MmlMlabeledtr.prototype.kind] = O.MmlMlabeledtr, n[O.MmlMtr.prototype.kind] = O.MmlMtr, n[S.MmlMtd.prototype.kind] = S.MmlMtd, n[V.MmlMaligngroup.prototype.kind] = V.MmlMaligngroup, n[E.MmlMalignmark.prototype.kind] = E.MmlMalignmark, n[A.MmlMglyph.prototype.kind] = A.MmlMglyph, n[C.MmlSemantics.prototype.kind] = C.MmlSemantics, n[C.MmlAnnotation.prototype.kind] = C.MmlAnnotation, n[C.MmlAnnotationXML.prototype.kind] = C.MmlAnnotationXML, n[w.TeXAtom.prototype.kind] = w.TeXAtom, n[N.MathChoice.prototype.kind] = N.MathChoice, n[o.TextNode.prototype.kind] = o.TextNode, n[o.XMLNode.prototype.kind] = o.XMLNode, n);
      },
      1759: function _(t, e, r) {
        var _n9,
          o = this && this.__extends || (_n9 = function n(t, e) {
            return _n9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n9(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n9(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathMLVisitor = void 0;
        var a = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.document = null, e;
          }
          return o(e, t), e.prototype.visitTree = function (t, e) {
            this.document = e;
            var r = e.createElement("top");
            return this.visitNode(t, r), this.document = null, r.firstChild;
          }, e.prototype.visitTextNode = function (t, e) {
            e.appendChild(this.document.createTextNode(t.getText()));
          }, e.prototype.visitXMLNode = function (t, e) {
            e.appendChild(t.getXML().cloneNode(!0));
          }, e.prototype.visitInferredMrowNode = function (t, e) {
            var r, n;
            try {
              for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value;
                this.visitNode(Q, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e.prototype.visitDefault = function (t, e) {
            var r,
              n,
              o = this.document.createElement(t.kind);
            this.addAttributes(t, o);
            try {
              for (var a = i(t.childNodes), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                this.visitNode(s, o);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            e.appendChild(o);
          }, e.prototype.addAttributes = function (t, e) {
            var r,
              n,
              o = t.attributes,
              a = o.getExplicitNames();
            try {
              for (var Q = i(a), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                e.setAttribute(T, o.getExplicit(T).toString());
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = Q.return) && n.call(Q);
              } finally {
                if (r) throw r.error;
              }
            }
          }, e;
        }(r(6325).MmlVisitor);
        e.MathMLVisitor = a;
      },
      3909: function _(t, e, r) {
        var _n10,
          o = this && this.__extends || (_n10 = function n(t, e) {
            return _n10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n10(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n10(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlFactory = void 0;
        var i = r(7860),
          a = r(6336),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "MML", {
              get: function get() {
                return this.node;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaultNodes = a.MML, e;
          }(i.AbstractNodeFactory);
        e.MmlFactory = Q;
      },
      9007: function _(t, e, r) {
        var _n11,
          o = this && this.__extends || (_n11 = function n(t, e) {
            return _n11 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n11(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n11(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          Q = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.XMLNode = e.TextNode = e.AbstractMmlEmptyNode = e.AbstractMmlBaseNode = e.AbstractMmlLayoutNode = e.AbstractMmlTokenNode = e.AbstractMmlNode = e.indentAttributes = e.TEXCLASSNAMES = e.TEXCLASS = void 0;
        var s = r(91),
          T = r(4596);
        e.TEXCLASS = {
          ORD: 0,
          OP: 1,
          BIN: 2,
          REL: 3,
          OPEN: 4,
          CLOSE: 5,
          PUNCT: 6,
          INNER: 7,
          VCENTER: 8,
          NONE: -1
        }, e.TEXCLASSNAMES = ["ORD", "OP", "BIN", "REL", "OPEN", "CLOSE", "PUNCT", "INNER", "VCENTER"];
        var l = ["", "thinmathspace", "mediummathspace", "thickmathspace"],
          c = [[0, -1, 2, 3, 0, 0, 0, 1], [-1, -1, 0, 3, 0, 0, 0, 1], [2, 2, 0, 0, 2, 0, 0, 2], [3, 3, 0, 0, 3, 0, 0, 3], [0, 0, 0, 0, 0, 0, 0, 0], [0, -1, 2, 3, 0, 0, 0, 1], [1, 1, 0, 1, 1, 1, 1, 1], [1, -1, 2, 3, 1, 0, 1, 1]];
        e.indentAttributes = ["indentalign", "indentalignfirst", "indentshift", "indentshiftfirst"];
        var u = function (t) {
          function r(e, r, n) {
            void 0 === r && (r = {}), void 0 === n && (n = []);
            var o = t.call(this, e) || this;
            return o.prevClass = null, o.prevLevel = null, o.texclass = null, o.arity < 0 && (o.childNodes = [e.create("inferredMrow")], o.childNodes[0].parent = o), o.setChildren(n), o.attributes = new s.Attributes(e.getNodeClass(o.kind).defaults, e.getNodeClass("math").defaults), o.attributes.setList(r), o;
          }
          return o(r, t), r.prototype.copy = function (t) {
            var e, r, n, o;
            void 0 === t && (t = !1);
            var Q = this.factory.create(this.kind);
            if (Q.properties = i({}, this.properties), this.attributes) {
              var s = this.attributes.getAllAttributes();
              try {
                for (var T = a(Object.keys(s)), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value;
                  ("id" !== c || t) && Q.attributes.set(c, s[c]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (r = T.return) && r.call(T);
                } finally {
                  if (e) throw e.error;
                }
              }
            }
            if (this.childNodes && this.childNodes.length) {
              var u = this.childNodes;
              1 === u.length && u[0].isInferred && (u = u[0].childNodes);
              try {
                for (var p = a(u), h = p.next(); !h.done; h = p.next()) {
                  var d = h.value;
                  d ? Q.appendChild(d.copy()) : Q.childNodes.push(null);
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  h && !h.done && (o = p.return) && o.call(p);
                } finally {
                  if (n) throw n.error;
                }
              }
            }
            return Q;
          }, Object.defineProperty(r.prototype, "texClass", {
            get: function get() {
              return this.texclass;
            },
            set: function set(t) {
              this.texclass = t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isToken", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isSpacelike", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "linebreakContainer", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "hasNewLine", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "arity", {
            get: function get() {
              return 1 / 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isInferred", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "Parent", {
            get: function get() {
              for (var t = this.parent; t && t.notParent;) t = t.Parent;
              return t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "notParent", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.setChildren = function (e) {
            return this.arity < 0 ? this.childNodes[0].setChildren(e) : t.prototype.setChildren.call(this, e);
          }, r.prototype.appendChild = function (e) {
            var r,
              n,
              o = this;
            if (this.arity < 0) return this.childNodes[0].appendChild(e), e;
            if (e.isInferred) {
              if (this.arity === 1 / 0) return e.childNodes.forEach(function (e) {
                return t.prototype.appendChild.call(o, e);
              }), e;
              var i = e;
              (e = this.factory.create("mrow")).setChildren(i.childNodes), e.attributes = i.attributes;
              try {
                for (var Q = a(i.getPropertyNames()), s = Q.next(); !s.done; s = Q.next()) {
                  var T = s.value;
                  e.setProperty(T, i.getProperty(T));
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (n = Q.return) && n.call(Q);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            return t.prototype.appendChild.call(this, e);
          }, r.prototype.replaceChild = function (e, r) {
            return this.arity < 0 ? (this.childNodes[0].replaceChild(e, r), e) : t.prototype.replaceChild.call(this, e, r);
          }, r.prototype.core = function () {
            return this;
          }, r.prototype.coreMO = function () {
            return this;
          }, r.prototype.coreIndex = function () {
            return 0;
          }, r.prototype.childPosition = function () {
            for (var t, e, r = this, n = r.parent; n && n.notParent;) r = n, n = n.parent;
            if (n) {
              var o = 0;
              try {
                for (var i = a(n.childNodes), Q = i.next(); !Q.done; Q = i.next()) {
                  if (Q.value === r) return o;
                  o++;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  Q && !Q.done && (e = i.return) && e.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
            }
            return null;
          }, r.prototype.setTeXclass = function (t) {
            return this.getPrevClass(t), null != this.texClass ? this : t;
          }, r.prototype.updateTeXclass = function (t) {
            t && (this.prevClass = t.prevClass, this.prevLevel = t.prevLevel, t.prevClass = t.prevLevel = null, this.texClass = t.texClass);
          }, r.prototype.getPrevClass = function (t) {
            t && (this.prevClass = t.texClass, this.prevLevel = t.attributes.get("scriptlevel"));
          }, r.prototype.texSpacing = function () {
            var t = null != this.prevClass ? this.prevClass : e.TEXCLASS.NONE,
              r = this.texClass || e.TEXCLASS.ORD;
            if (t === e.TEXCLASS.NONE || r === e.TEXCLASS.NONE) return "";
            t === e.TEXCLASS.VCENTER && (t = e.TEXCLASS.ORD), r === e.TEXCLASS.VCENTER && (r = e.TEXCLASS.ORD);
            var n = c[t][r];
            return (this.prevLevel > 0 || this.attributes.get("scriptlevel") > 0) && n >= 0 ? "" : l[Math.abs(n)];
          }, r.prototype.hasSpacingAttributes = function () {
            return this.isEmbellished && this.coreMO().hasSpacingAttributes();
          }, r.prototype.setInheritedAttributes = function (t, e, n, o) {
            var i, s;
            void 0 === t && (t = {}), void 0 === e && (e = !1), void 0 === n && (n = 0), void 0 === o && (o = !1);
            var T = this.attributes.getAllDefaults();
            try {
              for (var l = a(Object.keys(t)), c = l.next(); !c.done; c = l.next()) {
                var u = c.value;
                if (T.hasOwnProperty(u) || r.alwaysInherit.hasOwnProperty(u)) {
                  var p = Q(t[u], 2),
                    h = p[0],
                    d = p[1];
                  ((r.noInherit[h] || {})[this.kind] || {})[u] || this.attributes.setInherited(u, d);
                }
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (s = l.return) && s.call(l);
              } finally {
                if (i) throw i.error;
              }
            }
            void 0 === this.attributes.getExplicit("displaystyle") && this.attributes.setInherited("displaystyle", e), void 0 === this.attributes.getExplicit("scriptlevel") && this.attributes.setInherited("scriptlevel", n), o && this.setProperty("texprimestyle", o);
            var f = this.arity;
            if (f >= 0 && f !== 1 / 0 && (1 === f && 0 === this.childNodes.length || 1 !== f && this.childNodes.length !== f)) if (f < this.childNodes.length) this.childNodes = this.childNodes.slice(0, f);else for (; this.childNodes.length < f;) this.appendChild(this.factory.create("mrow"));
            this.setChildInheritedAttributes(t, e, n, o);
          }, r.prototype.setChildInheritedAttributes = function (t, e, r, n) {
            var o, i;
            try {
              for (var Q = a(this.childNodes), s = Q.next(); !s.done; s = Q.next()) {
                s.value.setInheritedAttributes(t, e, r, n);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (i = Q.return) && i.call(Q);
              } finally {
                if (o) throw o.error;
              }
            }
          }, r.prototype.addInheritedAttributes = function (t, e) {
            var r,
              n,
              o = i({}, t);
            try {
              for (var Q = a(Object.keys(e)), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                "displaystyle" !== T && "scriptlevel" !== T && "style" !== T && (o[T] = [this.kind, e[T]]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = Q.return) && n.call(Q);
              } finally {
                if (r) throw r.error;
              }
            }
            return o;
          }, r.prototype.inheritAttributesFrom = function (t) {
            var e = t.attributes,
              r = e.get("displaystyle"),
              n = e.get("scriptlevel"),
              o = e.isSet("mathsize") ? {
                mathsize: ["math", e.get("mathsize")]
              } : {},
              i = t.getProperty("texprimestyle") || !1;
            this.setInheritedAttributes(o, r, n, i);
          }, r.prototype.verifyTree = function (t) {
            if (void 0 === t && (t = null), null !== t) {
              this.verifyAttributes(t);
              var e = this.arity;
              t.checkArity && e >= 0 && e !== 1 / 0 && (1 === e && 0 === this.childNodes.length || 1 !== e && this.childNodes.length !== e) && this.mError('Wrong number of children for "' + this.kind + '" node', t, !0), this.verifyChildren(t);
            }
          }, r.prototype.verifyAttributes = function (t) {
            var e, r;
            if (t.checkAttributes) {
              var n = this.attributes,
                o = [];
              try {
                for (var i = a(n.getExplicitNames()), Q = i.next(); !Q.done; Q = i.next()) {
                  var s = Q.value;
                  "data-" === s.substr(0, 5) || void 0 !== n.getDefault(s) || s.match(/^(?:class|style|id|(?:xlink:)?href)$/) || o.push(s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              o.length && this.mError("Unknown attributes for " + this.kind + " node: " + o.join(", "), t);
            }
          }, r.prototype.verifyChildren = function (t) {
            var e, r;
            try {
              for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                o.value.verifyTree(t);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, r.prototype.mError = function (t, e, r) {
            if (void 0 === r && (r = !1), this.parent && this.parent.isKind("merror")) return null;
            var n = this.factory.create("merror");
            if (n.attributes.set("data-mjx-message", t), e.fullErrors || r) {
              var o = this.factory.create("mtext"),
                i = this.factory.create("text");
              i.setText(e.fullErrors ? t : this.kind), o.appendChild(i), n.appendChild(o), this.parent.replaceChild(n, this);
            } else this.parent.replaceChild(n, this), n.appendChild(this);
            return n;
          }, r.defaults = {
            mathbackground: s.INHERIT,
            mathcolor: s.INHERIT,
            mathsize: s.INHERIT,
            dir: s.INHERIT
          }, r.noInherit = {
            mstyle: {
              mpadded: {
                width: !0,
                height: !0,
                depth: !0,
                lspace: !0,
                voffset: !0
              },
              mtable: {
                width: !0,
                height: !0,
                depth: !0,
                align: !0
              }
            },
            maligngroup: {
              mrow: {
                groupalign: !0
              },
              mtable: {
                groupalign: !0
              }
            }
          }, r.alwaysInherit = {
            scriptminsize: !0,
            scriptsizemultiplier: !0
          }, r.verifyDefaults = {
            checkArity: !0,
            checkAttributes: !1,
            fullErrors: !1,
            fixMmultiscripts: !0,
            fixMtables: !0
          }, r;
        }(T.AbstractNode);
        e.AbstractMmlNode = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isToken", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getText = function () {
            var t,
              e,
              r = "";
            try {
              for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                i instanceof m && (r += i.getText());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
            var o, i;
            try {
              for (var Q = a(this.childNodes), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                T instanceof u && T.setInheritedAttributes(t, e, r, n);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (i = Q.return) && i.call(Q);
              } finally {
                if (o) throw o.error;
              }
            }
          }, e.prototype.walkTree = function (t, e) {
            var r, n;
            t(this, e);
            try {
              for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                var Q = i.value;
                Q instanceof u && Q.walkTree(t, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            return e;
          }, e.defaults = i(i({}, u.defaults), {
            mathvariant: "normal",
            mathsize: s.INHERIT
          }), e;
        }(u);
        e.AbstractMmlTokenNode = p;
        var h = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isSpacelike", {
            get: function get() {
              return this.childNodes[0].isSpacelike;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isEmbellished", {
            get: function get() {
              return this.childNodes[0].isEmbellished;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return -1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.core = function () {
            return this.childNodes[0];
          }, e.prototype.coreMO = function () {
            return this.childNodes[0].coreMO();
          }, e.prototype.setTeXclass = function (t) {
            return t = this.childNodes[0].setTeXclass(t), this.updateTeXclass(this.childNodes[0]), t;
          }, e.defaults = u.defaults, e;
        }(u);
        e.AbstractMmlLayoutNode = h;
        var d = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return this.childNodes[0].isEmbellished;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.core = function () {
            return this.childNodes[0];
          }, r.prototype.coreMO = function () {
            return this.childNodes[0].coreMO();
          }, r.prototype.setTeXclass = function (t) {
            var r, n;
            this.getPrevClass(t), this.texClass = e.TEXCLASS.ORD;
            var o = this.childNodes[0];
            o ? this.isEmbellished || o.isKind("mi") ? (t = o.setTeXclass(t), this.updateTeXclass(this.core())) : (o.setTeXclass(null), t = this) : t = this;
            try {
              for (var i = a(this.childNodes.slice(1)), Q = i.next(); !Q.done; Q = i.next()) {
                var s = Q.value;
                s && s.setTeXclass(null);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = i.return) && n.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
            return t;
          }, r.defaults = u.defaults, r;
        }(u);
        e.AbstractMmlBaseNode = d;
        var f = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), Object.defineProperty(r.prototype, "isToken", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isEmbellished", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isSpacelike", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "linebreakContainer", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "hasNewLine", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "isInferred", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "notParent", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "Parent", {
            get: function get() {
              return this.parent;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "texClass", {
            get: function get() {
              return e.TEXCLASS.NONE;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "prevClass", {
            get: function get() {
              return e.TEXCLASS.NONE;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(r.prototype, "prevLevel", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.hasSpacingAttributes = function () {
            return !1;
          }, Object.defineProperty(r.prototype, "attributes", {
            get: function get() {
              return null;
            },
            enumerable: !1,
            configurable: !0
          }), r.prototype.core = function () {
            return this;
          }, r.prototype.coreMO = function () {
            return this;
          }, r.prototype.coreIndex = function () {
            return 0;
          }, r.prototype.childPosition = function () {
            return 0;
          }, r.prototype.setTeXclass = function (t) {
            return t;
          }, r.prototype.texSpacing = function () {
            return "";
          }, r.prototype.setInheritedAttributes = function (t, e, r, n) {}, r.prototype.inheritAttributesFrom = function (t) {}, r.prototype.verifyTree = function (t) {}, r.prototype.mError = function (t, e, r) {
            return void 0 === r && (r = !1), null;
          }, r;
        }(T.AbstractEmptyNode);
        e.AbstractMmlEmptyNode = f;
        var m = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.text = "", e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "text";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getText = function () {
            return this.text;
          }, e.prototype.setText = function (t) {
            return this.text = t, this;
          }, e.prototype.copy = function () {
            return this.factory.create(this.kind).setText(this.getText());
          }, e.prototype.toString = function () {
            return this.text;
          }, e;
        }(f);
        e.TextNode = m;
        var L = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.xml = null, e.adaptor = null, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "XML";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getXML = function () {
            return this.xml;
          }, e.prototype.setXML = function (t, e) {
            return void 0 === e && (e = null), this.xml = t, this.adaptor = e, this;
          }, e.prototype.getSerializedXML = function () {
            return this.adaptor.serializeXML(this.xml);
          }, e.prototype.copy = function () {
            return this.factory.create(this.kind).setXML(this.adaptor.clone(this.xml));
          }, e.prototype.toString = function () {
            return "XML data";
          }, e;
        }(f);
        e.XMLNode = L;
      },
      3948: function _(t, e, r) {
        var _n12,
          o = this && this.__extends || (_n12 = function n(t, e) {
            return _n12 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n12(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n12(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeXAtom = void 0;
        var a = r(9007),
          Q = r(2756),
          s = function (t) {
            function e(e, r, n) {
              var o = t.call(this, e, r, n) || this;
              return o.texclass = a.TEXCLASS.ORD, o.setProperty("texClass", o.texClass), o;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "TeXAtom";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.childNodes[0].setTeXclass(null), this.adjustTeXclass(t);
            }, e.prototype.adjustTeXclass = function (t) {
              return t;
            }, e.defaults = i({}, a.AbstractMmlBaseNode.defaults), e;
          }(a.AbstractMmlBaseNode);
        e.TeXAtom = s, s.prototype.adjustTeXclass = Q.MmlMo.prototype.adjustTeXclass;
      },
      9145: function _(t, e, r) {
        var _n13,
          o = this && this.__extends || (_n13 = function n(t, e) {
            return _n13 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n13(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n13(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMaction = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "maction";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "selected", {
              get: function get() {
                var t = this.attributes.get("selection"),
                  e = Math.max(1, Math.min(this.childNodes.length, t)) - 1;
                return this.childNodes[e] || this.factory.create("mrow");
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                return this.selected.isEmbellished;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return this.selected.isSpacelike;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.core = function () {
              return this.selected.core();
            }, e.prototype.coreMO = function () {
              return this.selected.coreMO();
            }, e.prototype.verifyAttributes = function (e) {
              (t.prototype.verifyAttributes.call(this, e), "toggle" !== this.attributes.get("actiontype") && void 0 !== this.attributes.getExplicit("selection")) && delete this.attributes.getAllAttributes().selection;
            }, e.prototype.setTeXclass = function (t) {
              "tooltip" === this.attributes.get("actiontype") && this.childNodes[1] && this.childNodes[1].setTeXclass(null);
              var e = this.selected;
              return t = e.setTeXclass(t), this.updateTeXclass(e), t;
            }, e.prototype.nextToggleSelection = function () {
              var t = Math.max(1, this.attributes.get("selection") + 1);
              t > this.childNodes.length && (t = 1), this.attributes.set("selection", t);
            }, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              actiontype: "toggle",
              selection: 1
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMaction = Q;
      },
      142: function _(t, e, r) {
        var _n14,
          o = this && this.__extends || (_n14 = function n(t, e) {
            return _n14 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n14(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n14(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMaligngroup = void 0;
        var a = r(9007),
          Q = r(91),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "maligngroup";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              e = this.addInheritedAttributes(e, this.attributes.getAllAttributes()), t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              groupalign: Q.INHERIT
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMaligngroup = s;
      },
      7590: function _(t, e, r) {
        var _n15,
          o = this && this.__extends || (_n15 = function n(t, e) {
            return _n15 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n15(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n15(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMalignmark = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "malignmark";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              edge: "left"
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMalignmark = Q;
      },
      3233: function _(t, e, r) {
        var _n16,
          o = this && this.__extends || (_n16 = function n(t, e) {
            return _n16 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n16(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n16(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMath = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "math";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              "display" === this.attributes.get("mode") && this.attributes.setInherited("display", "block"), e = this.addInheritedAttributes(e, this.attributes.getAllAttributes()), r = !!this.attributes.get("displaystyle") || !this.attributes.get("displaystyle") && "block" === this.attributes.get("display"), this.attributes.setInherited("displaystyle", r), n = this.attributes.get("scriptlevel") || this.constructor.defaults.scriptlevel, t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              mathvariant: "normal",
              mathsize: "normal",
              mathcolor: "",
              mathbackground: "transparent",
              dir: "ltr",
              scriptlevel: 0,
              displaystyle: !1,
              display: "inline",
              maxwidth: "",
              overflow: "linebreak",
              altimg: "",
              "altimg-width": "",
              "altimg-height": "",
              "altimg-valign": "",
              alttext: "",
              cdgroup: "",
              scriptsizemultiplier: 1 / Math.sqrt(2),
              scriptminsize: "8px",
              infixlinebreakstyle: "before",
              lineleading: "1ex",
              linebreakmultchar: "\u2062",
              indentshift: "auto",
              indentalign: "auto",
              indenttarget: "",
              indentalignfirst: "indentalign",
              indentshiftfirst: "indentshift",
              indentalignlast: "indentalign",
              indentshiftlast: "indentshift"
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMath = Q;
      },
      1334: function _(t, e, r) {
        var _n17,
          o = this && this.__extends || (_n17 = function n(t, e) {
            return _n17 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n17(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n17(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathChoice = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "MathChoice";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 4;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (t, e, r, n) {
              var o = e ? 0 : Math.max(0, Math.min(r, 2)) + 1,
                i = this.childNodes[o] || this.factory.create("mrow");
              this.parent.replaceChild(i, this), i.setInheritedAttributes(t, e, r, n);
            }, e.defaults = i({}, a.AbstractMmlBaseNode.defaults), e;
          }(a.AbstractMmlBaseNode);
        e.MathChoice = Q;
      },
      6661: function _(t, e, r) {
        var _n18,
          o = this && this.__extends || (_n18 = function n(t, e) {
            return _n18 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n18(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n18(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMenclose = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "menclose";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContininer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return t = this.childNodes[0].setTeXclass(t), this.updateTeXclass(this.childNodes[0]), t;
            }, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
              notation: "longdiv"
            }), e;
          }(a.AbstractMmlNode);
        e.MmlMenclose = Q;
      },
      1581: function _(t, e, r) {
        var _n19,
          o = this && this.__extends || (_n19 = function n(t, e) {
            return _n19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n19(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n19(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMerror = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "merror";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMerror = Q;
      },
      5410: function _(t, e, r) {
        var _n20,
          o = this && this.__extends || (_n20 = function n(t, e) {
            return _n20 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n20(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n20(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMfenced = void 0;
        var Q = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = Q.TEXCLASS.INNER, e.separators = [], e.open = null, e.close = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mfenced";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              this.getPrevClass(t), this.open && (t = this.open.setTeXclass(t)), this.childNodes[0] && (t = this.childNodes[0].setTeXclass(t));
              for (var e = 1, r = this.childNodes.length; e < r; e++) this.separators[e - 1] && (t = this.separators[e - 1].setTeXclass(t)), this.childNodes[e] && (t = this.childNodes[e].setTeXclass(t));
              return this.close && (t = this.close.setTeXclass(t)), this.updateTeXclass(this.open), t;
            }, e.prototype.setChildInheritedAttributes = function (e, r, n, o) {
              var i, Q;
              this.addFakeNodes();
              try {
                for (var s = a([this.open, this.close].concat(this.separators)), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value;
                  l && l.setInheritedAttributes(e, r, n, o);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (Q = s.return) && Q.call(s);
                } finally {
                  if (i) throw i.error;
                }
              }
              t.prototype.setChildInheritedAttributes.call(this, e, r, n, o);
            }, e.prototype.addFakeNodes = function () {
              var t,
                e,
                r = this.attributes.getList("open", "close", "separators"),
                n = r.open,
                o = r.close,
                i = r.separators;
              if (n = n.replace(/[ \t\n\r]/g, ""), o = o.replace(/[ \t\n\r]/g, ""), i = i.replace(/[ \t\n\r]/g, ""), n && (this.open = this.fakeNode(n, {
                fence: !0,
                form: "prefix"
              }, Q.TEXCLASS.OPEN)), i) {
                for (; i.length < this.childNodes.length - 1;) i += i.charAt(i.length - 1);
                var s = 0;
                try {
                  for (var T = a(this.childNodes.slice(1)), l = T.next(); !l.done; l = T.next()) {
                    l.value && this.separators.push(this.fakeNode(i.charAt(s++)));
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    l && !l.done && (e = T.return) && e.call(T);
                  } finally {
                    if (t) throw t.error;
                  }
                }
              }
              o && (this.close = this.fakeNode(o, {
                fence: !0,
                form: "postfix"
              }, Q.TEXCLASS.CLOSE));
            }, e.prototype.fakeNode = function (t, e, r) {
              void 0 === e && (e = {}), void 0 === r && (r = null);
              var n = this.factory.create("text").setText(t),
                o = this.factory.create("mo", e, [n]);
              return o.texClass = r, o.parent = this, o;
            }, e.defaults = i(i({}, Q.AbstractMmlNode.defaults), {
              open: "(",
              close: ")",
              separators: ","
            }), e;
          }(Q.AbstractMmlNode);
        e.MmlMfenced = s;
      },
      6850: function _(t, e, r) {
        var _n21,
          o = this && this.__extends || (_n21 = function n(t, e) {
            return _n21 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n21(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n21(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMfrac = void 0;
        var Q = r(9007),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mfrac";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              (!e || r > 0) && r++, this.childNodes[0].setInheritedAttributes(t, !1, r, n), this.childNodes[1].setInheritedAttributes(t, !1, r, !0);
            }, e.defaults = i(i({}, Q.AbstractMmlBaseNode.defaults), {
              linethickness: "medium",
              numalign: "center",
              denomalign: "center",
              bevelled: !1
            }), e;
          }(Q.AbstractMmlBaseNode);
        e.MmlMfrac = s;
      },
      3985: function _(t, e, r) {
        var _n22,
          o = this && this.__extends || (_n22 = function n(t, e) {
            return _n22 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n22(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n22(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMglyph = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mglyph";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.verifyAttributes = function (e) {
              var r = this.attributes.getList("src", "fontfamily", "index"),
                n = r.src,
                o = r.fontfamily,
                i = r.index;
              "" !== n || "" !== o && "" !== i ? t.prototype.verifyAttributes.call(this, e) : this.mError("mglyph must have either src or fontfamily and index attributes", e, !0);
            }, e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              alt: "",
              src: "",
              index: "",
              width: "auto",
              height: "auto",
              valign: "0em"
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMglyph = Q;
      },
      450: function _(t, e, r) {
        var _n23,
          o = this && this.__extends || (_n23 = function n(t, e) {
            return _n23 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n23(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n23(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMi = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mi";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (r, n, o, i) {
              void 0 === r && (r = {}), void 0 === n && (n = !1), void 0 === o && (o = 0), void 0 === i && (i = !1), t.prototype.setInheritedAttributes.call(this, r, n, o, i), this.getText().match(e.singleCharacter) && !r.mathvariant && this.attributes.setInherited("mathvariant", "italic");
            }, e.prototype.setTeXclass = function (t) {
              this.getPrevClass(t);
              var r = this.getText();
              return r.length > 1 && r.match(e.operatorName) && "normal" === this.attributes.get("mathvariant") && void 0 === this.getProperty("autoOP") && void 0 === this.getProperty("texClass") && (this.texClass = a.TEXCLASS.OP, this.setProperty("autoOP", !0)), this;
            }, e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e.operatorName = /^[a-z][a-z0-9]*$/i, e.singleCharacter = /^[\uD800-\uDBFF]?.[\u0300-\u036F\u1AB0-\u1ABE\u1DC0-\u1DFF\u20D0-\u20EF]*$/, e;
          }(a.AbstractMmlTokenNode);
        e.MmlMi = Q;
      },
      6405: function _(t, e, r) {
        var _n24,
          o = this && this.__extends || (_n24 = function n(t, e) {
            return _n24 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n24(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n24(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlNone = e.MmlMprescripts = e.MmlMmultiscripts = void 0;
        var a = r(9007),
          Q = r(4461),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mmultiscripts";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, n);
              for (var o = !1, i = 1, a = 0; i < this.childNodes.length; i++) {
                var Q = this.childNodes[i];
                if (Q.isKind("mprescripts")) {
                  if (!o && (o = !0, i % 2 == 0)) {
                    var s = this.factory.create("mrow");
                    this.childNodes.splice(i, 0, s), s.parent = this, i++;
                  }
                } else {
                  var T = n || a % 2 == 0;
                  Q.setInheritedAttributes(t, !1, r + 1, T), a++;
                }
              }
              this.childNodes.length % 2 == (o ? 1 : 0) && (this.appendChild(this.factory.create("mrow")), this.childNodes[this.childNodes.length - 1].setInheritedAttributes(t, !1, r + 1, n));
            }, e.prototype.verifyChildren = function (e) {
              for (var r = !1, n = e.fixMmultiscripts, o = 0; o < this.childNodes.length; o++) {
                var i = this.childNodes[o];
                i.isKind("mprescripts") && (r ? i.mError(i.kind + " can only appear once in " + this.kind, e, !0) : (r = !0, o % 2 != 0 || n || this.mError("There must be an equal number of prescripts of each type", e)));
              }
              this.childNodes.length % 2 != (r ? 1 : 0) || n || this.mError("There must be an equal number of scripts of each type", e), t.prototype.verifyChildren.call(this, e);
            }, e.defaults = i({}, Q.MmlMsubsup.defaults), e;
          }(Q.MmlMsubsup);
        e.MmlMmultiscripts = s;
        var T = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mprescripts";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.verifyTree = function (e) {
            t.prototype.verifyTree.call(this, e), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e, !0);
          }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
        }(a.AbstractMmlNode);
        e.MmlMprescripts = T;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "none";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.verifyTree = function (e) {
            t.prototype.verifyTree.call(this, e), this.parent && !this.parent.isKind("mmultiscripts") && this.mError(this.kind + " must be a child of mmultiscripts", e, !0);
          }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
        }(a.AbstractMmlNode);
        e.MmlNone = l;
      },
      3050: function _(t, e, r) {
        var _n25,
          o = this && this.__extends || (_n25 = function n(t, e) {
            return _n25 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n25(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n25(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMn = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mn";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMn = Q;
      },
      2756: function _(t, e, r) {
        var _n26,
          o = this && this.__extends || (_n26 = function n(t, e) {
            return _n26 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n26(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n26(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMo = void 0;
        var s = r(9007),
          T = r(4082),
          l = r(505),
          c = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e._texClass = null, e.lspace = 5 / 18, e.rspace = 5 / 18, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "texClass", {
              get: function get() {
                if (null === this._texClass) {
                  var t = this.getText(),
                    e = a(this.handleExplicitForm(this.getForms()), 3),
                    r = e[0],
                    n = e[1],
                    o = e[2],
                    i = this.constructor.OPTABLE,
                    Q = i[r][t] || i[n][t] || i[o][t];
                  return Q ? Q[2] : s.TEXCLASS.REL;
                }
                return this._texClass;
              },
              set: function set(t) {
                this._texClass = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mo";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasNewLine", {
              get: function get() {
                return "newline" === this.attributes.get("linebreak");
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.coreParent = function () {
              for (var t = this, e = this, r = this.factory.getNodeClass("math"); e && e.isEmbellished && e.coreMO() === this && !(e instanceof r);) t = e, e = e.parent;
              return t;
            }, e.prototype.coreText = function (t) {
              if (!t) return "";
              if (t.isEmbellished) return t.coreMO().getText();
              for (; ((t.isKind("mrow") || t.isKind("TeXAtom") && t.texClass !== s.TEXCLASS.VCENTER || t.isKind("mstyle") || t.isKind("mphantom")) && 1 === t.childNodes.length || t.isKind("munderover")) && t.childNodes[0];) t = t.childNodes[0];
              return t.isToken ? t.getText() : "";
            }, e.prototype.hasSpacingAttributes = function () {
              return this.attributes.isSet("lspace") || this.attributes.isSet("rspace");
            }, Object.defineProperty(e.prototype, "isAccent", {
              get: function get() {
                var t = !1,
                  e = this.coreParent().parent;
                if (e) {
                  var r = e.isKind("mover") ? e.childNodes[e.over].coreMO() ? "accent" : "" : e.isKind("munder") ? e.childNodes[e.under].coreMO() ? "accentunder" : "" : e.isKind("munderover") ? this === e.childNodes[e.over].coreMO() ? "accent" : this === e.childNodes[e.under].coreMO() ? "accentunder" : "" : "";
                  if (r) t = void 0 !== e.attributes.getExplicit(r) ? t : this.attributes.get("accent");
                }
                return t;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              var e = this.attributes.getList("form", "fence"),
                r = e.form,
                n = e.fence;
              return void 0 === this.getProperty("texClass") && (this.attributes.isSet("lspace") || this.attributes.isSet("rspace")) ? null : (n && this.texClass === s.TEXCLASS.REL && ("prefix" === r && (this.texClass = s.TEXCLASS.OPEN), "postfix" === r && (this.texClass = s.TEXCLASS.CLOSE)), this.adjustTeXclass(t));
            }, e.prototype.adjustTeXclass = function (t) {
              var e = this.texClass,
                r = this.prevClass;
              if (e === s.TEXCLASS.NONE) return t;
              if (t ? (!t.getProperty("autoOP") || e !== s.TEXCLASS.BIN && e !== s.TEXCLASS.REL || (r = t.texClass = s.TEXCLASS.ORD), r = this.prevClass = t.texClass || s.TEXCLASS.ORD, this.prevLevel = this.attributes.getInherited("scriptlevel")) : r = this.prevClass = s.TEXCLASS.NONE, e !== s.TEXCLASS.BIN || r !== s.TEXCLASS.NONE && r !== s.TEXCLASS.BIN && r !== s.TEXCLASS.OP && r !== s.TEXCLASS.REL && r !== s.TEXCLASS.OPEN && r !== s.TEXCLASS.PUNCT) {
                if (r !== s.TEXCLASS.BIN || e !== s.TEXCLASS.REL && e !== s.TEXCLASS.CLOSE && e !== s.TEXCLASS.PUNCT) {
                  if (e === s.TEXCLASS.BIN) {
                    for (var n = this, o = this.parent; o && o.parent && o.isEmbellished && (1 === o.childNodes.length || !o.isKind("mrow") && o.core() === n);) n = o, o = o.parent;
                    o.childNodes[o.childNodes.length - 1] === n && (this.texClass = s.TEXCLASS.ORD);
                  }
                } else t.texClass = this.prevClass = s.TEXCLASS.ORD;
              } else this.texClass = s.TEXCLASS.ORD;
              return this;
            }, e.prototype.setInheritedAttributes = function (e, r, n, o) {
              void 0 === e && (e = {}), void 0 === r && (r = !1), void 0 === n && (n = 0), void 0 === o && (o = !1), t.prototype.setInheritedAttributes.call(this, e, r, n, o);
              var i = this.getText();
              this.checkOperatorTable(i), this.checkPseudoScripts(i), this.checkPrimes(i), this.checkMathAccent(i);
            }, e.prototype.checkOperatorTable = function (t) {
              var e,
                r,
                n = a(this.handleExplicitForm(this.getForms()), 3),
                o = n[0],
                i = n[1],
                s = n[2];
              this.attributes.setInherited("form", o);
              var l = this.constructor.OPTABLE,
                c = l[o][t] || l[i][t] || l[s][t];
              if (c) {
                void 0 === this.getProperty("texClass") && (this.texClass = c[2]);
                try {
                  for (var u = Q(Object.keys(c[3] || {})), p = u.next(); !p.done; p = u.next()) {
                    var h = p.value;
                    this.attributes.setInherited(h, c[3][h]);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    p && !p.done && (r = u.return) && r.call(u);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                this.lspace = (c[0] + 1) / 18, this.rspace = (c[1] + 1) / 18;
              } else {
                var d = (0, T.getRange)(t);
                if (d) {
                  void 0 === this.getProperty("texClass") && (this.texClass = d[2]);
                  var f = this.constructor.MMLSPACING[d[2]];
                  this.lspace = (f[0] + 1) / 18, this.rspace = (f[1] + 1) / 18;
                }
              }
            }, e.prototype.getForms = function () {
              for (var t = this, e = this.parent, r = this.Parent; r && r.isEmbellished;) t = e, e = r.parent, r = r.Parent;
              if (e && e.isKind("mrow") && 1 !== e.nonSpaceLength()) {
                if (e.firstNonSpace() === t) return ["prefix", "infix", "postfix"];
                if (e.lastNonSpace() === t) return ["postfix", "infix", "prefix"];
              }
              return ["infix", "prefix", "postfix"];
            }, e.prototype.handleExplicitForm = function (t) {
              if (this.attributes.isSet("form")) {
                var e = this.attributes.get("form");
                t = [e].concat(t.filter(function (t) {
                  return t !== e;
                }));
              }
              return t;
            }, e.prototype.checkPseudoScripts = function (t) {
              var e = this.constructor.pseudoScripts;
              if (t.match(e)) {
                var r = this.coreParent().Parent,
                  n = !r || !(r.isKind("msubsup") && !r.isKind("msub"));
                this.setProperty("pseudoscript", n), n && (this.attributes.setInherited("lspace", 0), this.attributes.setInherited("rspace", 0));
              }
            }, e.prototype.checkPrimes = function (t) {
              var e = this.constructor.primes;
              if (t.match(e)) {
                var r = this.constructor.remapPrimes,
                  n = (0, l.unicodeString)((0, l.unicodeChars)(t).map(function (t) {
                    return r[t];
                  }));
                this.setProperty("primes", n);
              }
            }, e.prototype.checkMathAccent = function (t) {
              var e = this.Parent;
              if (void 0 === this.getProperty("mathaccent") && e && e.isKind("munderover")) {
                var r = e.childNodes[0];
                if (!r.isEmbellished || r.coreMO() !== this) {
                  var n = this.constructor.mathaccents;
                  t.match(n) && this.setProperty("mathaccent", !0);
                }
              }
            }, e.defaults = i(i({}, s.AbstractMmlTokenNode.defaults), {
              form: "infix",
              fence: !1,
              separator: !1,
              lspace: "thickmathspace",
              rspace: "thickmathspace",
              stretchy: !1,
              symmetric: !1,
              maxsize: "infinity",
              minsize: "0em",
              largeop: !1,
              movablelimits: !1,
              accent: !1,
              linebreak: "auto",
              lineleading: "1ex",
              linebreakstyle: "before",
              indentalign: "auto",
              indentshift: "0",
              indenttarget: "",
              indentalignfirst: "indentalign",
              indentshiftfirst: "indentshift",
              indentalignlast: "indentalign",
              indentshiftlast: "indentshift"
            }), e.MMLSPACING = T.MMLSPACING, e.OPTABLE = T.OPTABLE, e.pseudoScripts = new RegExp(["^[\"'*`", "\xaa", "\xb0", "\xb2-\xb4", "\xb9", "\xba", "\u2018-\u201F", "\u2032-\u2037\u2057", "\u2070\u2071", "\u2074-\u207F", "\u2080-\u208E", "]+$"].join("")), e.primes = new RegExp(["^[\"'`", "\u2018-\u201F", "]+$"].join("")), e.remapPrimes = {
              34: 8243,
              39: 8242,
              96: 8245,
              8216: 8245,
              8217: 8242,
              8218: 8242,
              8219: 8245,
              8220: 8246,
              8221: 8243,
              8222: 8243,
              8223: 8246
            }, e.mathaccents = new RegExp(["^[", "\xB4\u0301\u02CA", "`\u0300\u02CB", "\xA8\u0308", "~\u0303\u02DC", "\xAF\u0304\u02C9", "\u02D8\u0306", "\u02C7\u030C", "^\u0302\u02C6", "\u2192\u20D7", "\u02D9\u0307", "\u02DA\u030A", "\u20DB", "\u20DC", "]$"].join("")), e;
          }(s.AbstractMmlTokenNode);
        e.MmlMo = c;
      },
      7238: function _(t, e, r) {
        var _n27,
          o = this && this.__extends || (_n27 = function n(t, e) {
            return _n27 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n27(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n27(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMpadded = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mpadded";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              width: "",
              height: "",
              depth: "",
              lspace: 0,
              voffset: 0
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMpadded = Q;
      },
      5741: function _(t, e, r) {
        var _n28,
          o = this && this.__extends || (_n28 = function n(t, e) {
            return _n28 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n28(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n28(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMphantom = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mphantom";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlLayoutNode.defaults), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMphantom = Q;
      },
      6145: function _(t, e, r) {
        var _n29,
          o = this && this.__extends || (_n29 = function n(t, e) {
            return _n29 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n29(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n29(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMroot = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mroot";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this.childNodes[1].setTeXclass(null), this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, !0), this.childNodes[1].setInheritedAttributes(t, !1, r + 2, n);
            }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMroot = Q;
      },
      9878: function _(t, e, r) {
        var _n30,
          o = this && this.__extends || (_n30 = function n(t, e) {
            return _n30 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n30(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n30(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlInferredMrow = e.MmlMrow = void 0;
        var Q = r(9007),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e._core = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mrow";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                var t, e;
                try {
                  for (var r = a(this.childNodes), n = r.next(); !n.done; n = r.next()) {
                    if (!n.value.isSpacelike) return !1;
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isEmbellished", {
              get: function get() {
                var t,
                  e,
                  r = !1,
                  n = 0;
                try {
                  for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                    var Q = i.value;
                    if (Q) if (Q.isEmbellished) {
                      if (r) return !1;
                      r = !0, this._core = n;
                    } else if (!Q.isSpacelike) return !1;
                    n++;
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    i && !i.done && (e = o.return) && e.call(o);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                return r;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.core = function () {
              return this.isEmbellished && null != this._core ? this.childNodes[this._core] : this;
            }, e.prototype.coreMO = function () {
              return this.isEmbellished && null != this._core ? this.childNodes[this._core].coreMO() : this;
            }, e.prototype.nonSpaceLength = function () {
              var t,
                e,
                r = 0;
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  i && !i.isSpacelike && r++;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, e.prototype.firstNonSpace = function () {
              var t, e;
              try {
                for (var r = a(this.childNodes), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value;
                  if (o && !o.isSpacelike) return o;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
              return null;
            }, e.prototype.lastNonSpace = function () {
              for (var t = this.childNodes.length; --t >= 0;) {
                var e = this.childNodes[t];
                if (e && !e.isSpacelike) return e;
              }
              return null;
            }, e.prototype.setTeXclass = function (t) {
              var e, r, n, o;
              if (null != this.getProperty("open") || null != this.getProperty("close")) {
                this.getPrevClass(t), t = null;
                try {
                  for (var i = a(this.childNodes), s = i.next(); !s.done; s = i.next()) {
                    t = s.value.setTeXclass(t);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    s && !s.done && (r = i.return) && r.call(i);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                null == this.texClass && (this.texClass = Q.TEXCLASS.INNER);
              } else {
                try {
                  for (var T = a(this.childNodes), l = T.next(); !l.done; l = T.next()) {
                    t = l.value.setTeXclass(t);
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    l && !l.done && (o = T.return) && o.call(T);
                  } finally {
                    if (n) throw n.error;
                  }
                }
                this.childNodes[0] && this.updateTeXclass(this.childNodes[0]);
              }
              return t;
            }, e.defaults = i({}, Q.AbstractMmlNode.defaults), e;
          }(Q.AbstractMmlNode);
        e.MmlMrow = s;
        var T = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "inferredMrow";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isInferred", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "notParent", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.toString = function () {
            return "[" + this.childNodes.join(",") + "]";
          }, e.defaults = s.defaults, e;
        }(s);
        e.MmlInferredMrow = T;
      },
      7265: function _(t, e, r) {
        var _n31,
          o = this && this.__extends || (_n31 = function n(t, e) {
            return _n31 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n31(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n31(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMs = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "ms";
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              lquote: '"',
              rquote: '"'
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMs = Q;
      },
      6030: function _(t, e, r) {
        var _n32,
          o = this && this.__extends || (_n32 = function n(t, e) {
            return _n32 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n32(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n32(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMspace = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.NONE, e;
            }
            return o(e, t), e.prototype.setTeXclass = function (t) {
              return t;
            }, Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mspace";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "hasNewline", {
              get: function get() {
                var t = this.attributes;
                return null == t.getExplicit("width") && null == t.getExplicit("height") && null == t.getExplicit("depth") && "newline" === t.get("linebreak");
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlTokenNode.defaults), {
              width: "0em",
              height: "0ex",
              depth: "0ex",
              linebreak: "auto"
            }), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMspace = Q;
      },
      7131: function _(t, e, r) {
        var _n33,
          o = this && this.__extends || (_n33 = function n(t, e) {
            return _n33 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n33(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n33(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMsqrt = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "msqrt";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this;
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              this.childNodes[0].setInheritedAttributes(t, e, r, !0);
            }, e.defaults = i({}, a.AbstractMmlNode.defaults), e;
          }(a.AbstractMmlNode);
        e.MmlMsqrt = Q;
      },
      1314: function _(t, e, r) {
        var _n34,
          o = this && this.__extends || (_n34 = function n(t, e) {
            return _n34 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n34(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n34(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMstyle = void 0;
        var a = r(9007),
          Q = r(91),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mstyle";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return this.childNodes[0] && 1 === this.childNodes[0].childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.attributes.getExplicit("scriptlevel");
              null != o && ((o = o.toString()).match(/^\s*[-+]/) ? r += parseInt(o) : r = parseInt(o), n = !1);
              var i = this.attributes.getExplicit("displaystyle");
              null != i && (e = !0 === i, n = !1);
              var a = this.attributes.getExplicit("data-cramped");
              null != a && (n = a), t = this.addInheritedAttributes(t, this.attributes.getAllAttributes()), this.childNodes[0].setInheritedAttributes(t, e, r, n);
            }, e.defaults = i(i({}, a.AbstractMmlLayoutNode.defaults), {
              scriptlevel: Q.INHERIT,
              displaystyle: Q.INHERIT,
              scriptsizemultiplier: 1 / Math.sqrt(2),
              scriptminsize: "8px",
              mathbackground: Q.INHERIT,
              mathcolor: Q.INHERIT,
              dir: Q.INHERIT,
              infixlinebreakstyle: "before"
            }), e;
          }(a.AbstractMmlLayoutNode);
        e.MmlMstyle = s;
      },
      4461: function _(t, e, r) {
        var _n35,
          o = this && this.__extends || (_n35 = function n(t, e) {
            return _n35 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n35(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n35(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMsup = e.MmlMsub = e.MmlMsubsup = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "msubsup";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 3;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "sub", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "sup", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.childNodes;
              o[0].setInheritedAttributes(t, e, r, n), o[1].setInheritedAttributes(t, !1, r + 1, n || 1 === this.sub), o[2] && o[2].setInheritedAttributes(t, !1, r + 1, n || 2 === this.sub);
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              subscriptshift: "",
              superscriptshift: ""
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlMsubsup = Q;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "msub";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, Q.defaults), e;
        }(Q);
        e.MmlMsub = s;
        var T = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "msup";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sup", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "sub", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, Q.defaults), e;
        }(Q);
        e.MmlMsup = T;
      },
      1349: function _(t, e, r) {
        var _n36,
          o = this && this.__extends || (_n36 = function n(t, e) {
            return _n36 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n36(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n36(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtable = void 0;
        var Q = r(9007),
          s = r(505),
          T = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.properties = {
                useHeight: !0
              }, e.texclass = Q.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtable";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setInheritedAttributes = function (e, r, n, o) {
              var i, s;
              try {
                for (var T = a(Q.indentAttributes), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value;
                  e[c] && this.attributes.setInherited(c, e[c][1]), void 0 !== this.attributes.getExplicit(c) && delete this.attributes.getAllAttributes()[c];
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (s = T.return) && s.call(T);
                } finally {
                  if (i) throw i.error;
                }
              }
              t.prototype.setInheritedAttributes.call(this, e, r, n, o);
            }, e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o, i, Q, T;
              try {
                for (var l = a(this.childNodes), c = l.next(); !c.done; c = l.next()) {
                  (f = c.value).isKind("mtr") || this.replaceChild(this.factory.create("mtr"), f).appendChild(f);
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (i = l.return) && i.call(l);
                } finally {
                  if (o) throw o.error;
                }
              }
              r = this.getProperty("scriptlevel") || r, e = !(!this.attributes.getExplicit("displaystyle") && !this.attributes.getDefault("displaystyle")), t = this.addInheritedAttributes(t, {
                columnalign: this.attributes.get("columnalign"),
                rowalign: "center"
              });
              var u = this.attributes.getExplicit("data-cramped"),
                p = (0, s.split)(this.attributes.get("rowalign"));
              try {
                for (var h = a(this.childNodes), d = h.next(); !d.done; d = h.next()) {
                  var f = d.value;
                  t.rowalign[1] = p.shift() || t.rowalign[1], f.setInheritedAttributes(t, e, r, !!u);
                }
              } catch (t) {
                Q = {
                  error: t
                };
              } finally {
                try {
                  d && !d.done && (T = h.return) && T.call(h);
                } finally {
                  if (Q) throw Q.error;
                }
              }
            }, e.prototype.verifyChildren = function (e) {
              for (var r = null, n = this.factory, o = 0; o < this.childNodes.length; o++) {
                var i = this.childNodes[o];
                if (i.isKind("mtr")) r = null;else {
                  var a = i.isKind("mtd");
                  if (r ? (this.removeChild(i), o--) : r = this.replaceChild(n.create("mtr"), i), r.appendChild(a ? i : n.create("mtd", {}, [i])), !e.fixMtables) {
                    i.parent.removeChild(i), i.parent = this, a && r.appendChild(n.create("mtd"));
                    var Q = i.mError("Children of " + this.kind + " must be mtr or mlabeledtr", e, a);
                    r.childNodes[r.childNodes.length - 1].appendChild(Q);
                  }
                }
              }
              t.prototype.verifyChildren.call(this, e);
            }, e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.defaults = i(i({}, Q.AbstractMmlNode.defaults), {
              align: "axis",
              rowalign: "baseline",
              columnalign: "center",
              groupalign: "{left}",
              alignmentscope: !0,
              columnwidth: "auto",
              width: "auto",
              rowspacing: "1ex",
              columnspacing: ".8em",
              rowlines: "none",
              columnlines: "none",
              frame: "none",
              framespacing: "0.4em 0.5ex",
              equalrows: !1,
              equalcolumns: !1,
              displaystyle: !1,
              side: "right",
              minlabelspacing: "0.8em"
            }), e;
          }(Q.AbstractMmlNode);
        e.MmlMtable = T;
      },
      4359: function _(t, e, r) {
        var _n37,
          o = this && this.__extends || (_n37 = function n(t, e) {
            return _n37 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n37(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n37(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtd = void 0;
        var a = r(9007),
          Q = r(91),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtd";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return -1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.verifyChildren = function (e) {
              !this.parent || this.parent.isKind("mtr") ? t.prototype.verifyChildren.call(this, e) : this.mError(this.kind + " can only be a child of an mtr or mlabeledtr", e, !0);
            }, e.prototype.setTeXclass = function (t) {
              return this.getPrevClass(t), this.childNodes[0].setTeXclass(null), this;
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              rowspan: 1,
              columnspan: 1,
              rowalign: Q.INHERIT,
              columnalign: Q.INHERIT,
              groupalign: Q.INHERIT
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlMtd = s;
      },
      4770: function _(t, e, r) {
        var _n38,
          o = this && this.__extends || (_n38 = function n(t, e) {
            return _n38 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n38(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n38(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMtext = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.texclass = a.TEXCLASS.ORD, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtext";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isSpacelike", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i({}, a.AbstractMmlTokenNode.defaults), e;
          }(a.AbstractMmlTokenNode);
        e.MmlMtext = Q;
      },
      5022: function _(t, e, r) {
        var _n39,
          o = this && this.__extends || (_n39 = function n(t, e) {
            return _n39 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n39(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n39(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMlabeledtr = e.MmlMtr = void 0;
        var Q = r(9007),
          s = r(91),
          T = r(505),
          l = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "mtr";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o, i, Q, s;
              try {
                for (var l = a(this.childNodes), c = l.next(); !c.done; c = l.next()) {
                  (d = c.value).isKind("mtd") || this.replaceChild(this.factory.create("mtd"), d).appendChild(d);
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (i = l.return) && i.call(l);
                } finally {
                  if (o) throw o.error;
                }
              }
              var u = (0, T.split)(this.attributes.get("columnalign"));
              1 === this.arity && u.unshift(this.parent.attributes.get("side")), t = this.addInheritedAttributes(t, {
                rowalign: this.attributes.get("rowalign"),
                columnalign: "center"
              });
              try {
                for (var p = a(this.childNodes), h = p.next(); !h.done; h = p.next()) {
                  var d = h.value;
                  t.columnalign[1] = u.shift() || t.columnalign[1], d.setInheritedAttributes(t, e, r, n);
                }
              } catch (t) {
                Q = {
                  error: t
                };
              } finally {
                try {
                  h && !h.done && (s = p.return) && s.call(p);
                } finally {
                  if (Q) throw Q.error;
                }
              }
            }, e.prototype.verifyChildren = function (e) {
              var r, n;
              if (!this.parent || this.parent.isKind("mtable")) {
                try {
                  for (var o = a(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                    var Q = i.value;
                    if (!Q.isKind("mtd")) this.replaceChild(this.factory.create("mtd"), Q).appendChild(Q), e.fixMtables || Q.mError("Children of " + this.kind + " must be mtd", e);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    i && !i.done && (n = o.return) && n.call(o);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                t.prototype.verifyChildren.call(this, e);
              } else this.mError(this.kind + " can only be a child of an mtable", e, !0);
            }, e.prototype.setTeXclass = function (t) {
              var e, r;
              this.getPrevClass(t);
              try {
                for (var n = a(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.setTeXclass(null);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this;
            }, e.defaults = i(i({}, Q.AbstractMmlNode.defaults), {
              rowalign: s.INHERIT,
              columnalign: s.INHERIT,
              groupalign: s.INHERIT
            }), e;
          }(Q.AbstractMmlNode);
        e.MmlMtr = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mlabeledtr";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(l);
        e.MmlMlabeledtr = c;
      },
      5184: function _(t, e, r) {
        var _n40,
          o = this && this.__extends || (_n40 = function n(t, e) {
            return _n40 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n40(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n40(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlMover = e.MmlMunder = e.MmlMunderover = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "munderover";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 3;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "under", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "over", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "linebreakContainer", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.setChildInheritedAttributes = function (t, e, r, n) {
              var o = this.childNodes;
              o[0].setInheritedAttributes(t, e, r, n || !!o[this.over]);
              var i = !(e || !o[0].coreMO().attributes.get("movablelimits")),
                a = this.constructor.ACCENTS;
              o[1].setInheritedAttributes(t, !1, this.getScriptlevel(a[1], i, r), n || 1 === this.under), this.setInheritedAccent(1, a[1], e, r, n, i), o[2] && (o[2].setInheritedAttributes(t, !1, this.getScriptlevel(a[2], i, r), n || 2 === this.under), this.setInheritedAccent(2, a[2], e, r, n, i));
            }, e.prototype.getScriptlevel = function (t, e, r) {
              return !e && this.attributes.get(t) || r++, r;
            }, e.prototype.setInheritedAccent = function (t, e, r, n, o, i) {
              var a = this.childNodes[t];
              if (null == this.attributes.getExplicit(e) && a.isEmbellished) {
                var Q = a.coreMO().attributes.get("accent");
                this.attributes.setInherited(e, Q), Q !== this.attributes.getDefault(e) && a.setInheritedAttributes({}, r, this.getScriptlevel(e, i, n), o);
              }
            }, e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              accent: !1,
              accentunder: !1,
              align: "center"
            }), e.ACCENTS = ["", "accentunder", "accent"], e;
          }(a.AbstractMmlBaseNode);
        e.MmlMunderover = Q;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "munder";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, Q.defaults), e;
        }(Q);
        e.MmlMunder = s;
        var T = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mover";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "arity", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "over", {
            get: function get() {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "under", {
            get: function get() {
              return 2;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, Q.defaults), e.ACCENTS = ["", "accent", "accentunder"], e;
        }(Q);
        e.MmlMover = T;
      },
      9102: function _(t, e, r) {
        var _n41,
          o = this && this.__extends || (_n41 = function n(t, e) {
            return _n41 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n41(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n41(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlAnnotation = e.MmlAnnotationXML = e.MmlSemantics = void 0;
        var a = r(9007),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "semantics";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "arity", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "notParent", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.defaults = i(i({}, a.AbstractMmlBaseNode.defaults), {
              definitionUrl: null,
              encoding: null
            }), e;
          }(a.AbstractMmlBaseNode);
        e.MmlSemantics = Q;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "annotation-xml";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.setChildInheritedAttributes = function () {}, e.defaults = i(i({}, a.AbstractMmlNode.defaults), {
            definitionUrl: null,
            encoding: null,
            cd: "mathmlkeys",
            name: "",
            src: null
          }), e;
        }(a.AbstractMmlNode);
        e.MmlAnnotationXML = s;
        var T = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.properties = {
              isChars: !0
            }, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "annotation";
            },
            enumerable: !1,
            configurable: !0
          }), e.defaults = i({}, s.defaults), e;
        }(s);
        e.MmlAnnotation = T;
      },
      6325: function _(t, e, r) {
        var _n42,
          o = this && this.__extends || (_n42 = function n(t, e) {
            return _n42 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n42(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n42(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlVisitor = void 0;
        var i = r(3909),
          a = function (t) {
            function e(e) {
              return void 0 === e && (e = null), e || (e = new i.MmlFactory()), t.call(this, e) || this;
            }
            return o(e, t), e.prototype.visitTextNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            }, e.prototype.visitXMLNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            }, e;
          }(r(8823).AbstractVisitor);
        e.MmlVisitor = a;
      },
      4082: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OPTABLE = e.MMLSPACING = e.getRange = e.RANGES = e.MO = e.OPDEF = void 0;
        var o = r(9007);
        function i(t, e, r, n) {
          return void 0 === r && (r = o.TEXCLASS.BIN), void 0 === n && (n = null), [t, e, r, n];
        }
        e.OPDEF = i, e.MO = {
          ORD: i(0, 0, o.TEXCLASS.ORD),
          ORD11: i(1, 1, o.TEXCLASS.ORD),
          ORD21: i(2, 1, o.TEXCLASS.ORD),
          ORD02: i(0, 2, o.TEXCLASS.ORD),
          ORD55: i(5, 5, o.TEXCLASS.ORD),
          NONE: i(0, 0, o.TEXCLASS.NONE),
          OP: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            movablelimits: !0,
            symmetric: !0
          }),
          OPFIXED: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            movablelimits: !0
          }),
          INTEGRAL: i(0, 1, o.TEXCLASS.OP, {
            largeop: !0,
            symmetric: !0
          }),
          INTEGRAL2: i(1, 2, o.TEXCLASS.OP, {
            largeop: !0,
            symmetric: !0
          }),
          BIN3: i(3, 3, o.TEXCLASS.BIN),
          BIN4: i(4, 4, o.TEXCLASS.BIN),
          BIN01: i(0, 1, o.TEXCLASS.BIN),
          BIN5: i(5, 5, o.TEXCLASS.BIN),
          TALLBIN: i(4, 4, o.TEXCLASS.BIN, {
            stretchy: !0
          }),
          BINOP: i(4, 4, o.TEXCLASS.BIN, {
            largeop: !0,
            movablelimits: !0
          }),
          REL: i(5, 5, o.TEXCLASS.REL),
          REL1: i(1, 1, o.TEXCLASS.REL, {
            stretchy: !0
          }),
          REL4: i(4, 4, o.TEXCLASS.REL),
          RELSTRETCH: i(5, 5, o.TEXCLASS.REL, {
            stretchy: !0
          }),
          RELACCENT: i(5, 5, o.TEXCLASS.REL, {
            accent: !0
          }),
          WIDEREL: i(5, 5, o.TEXCLASS.REL, {
            accent: !0,
            stretchy: !0
          }),
          OPEN: i(0, 0, o.TEXCLASS.OPEN, {
            fence: !0,
            stretchy: !0,
            symmetric: !0
          }),
          CLOSE: i(0, 0, o.TEXCLASS.CLOSE, {
            fence: !0,
            stretchy: !0,
            symmetric: !0
          }),
          INNER: i(0, 0, o.TEXCLASS.INNER),
          PUNCT: i(0, 3, o.TEXCLASS.PUNCT),
          ACCENT: i(0, 0, o.TEXCLASS.ORD, {
            accent: !0
          }),
          WIDEACCENT: i(0, 0, o.TEXCLASS.ORD, {
            accent: !0,
            stretchy: !0
          })
        }, e.RANGES = [[32, 127, o.TEXCLASS.REL, "mo"], [160, 191, o.TEXCLASS.ORD, "mo"], [192, 591, o.TEXCLASS.ORD, "mi"], [688, 879, o.TEXCLASS.ORD, "mo"], [880, 6688, o.TEXCLASS.ORD, "mi"], [6832, 6911, o.TEXCLASS.ORD, "mo"], [6912, 7615, o.TEXCLASS.ORD, "mi"], [7616, 7679, o.TEXCLASS.ORD, "mo"], [7680, 8191, o.TEXCLASS.ORD, "mi"], [8192, 8303, o.TEXCLASS.ORD, "mo"], [8304, 8351, o.TEXCLASS.ORD, "mo"], [8448, 8527, o.TEXCLASS.ORD, "mi"], [8528, 8591, o.TEXCLASS.ORD, "mn"], [8592, 8703, o.TEXCLASS.REL, "mo"], [8704, 8959, o.TEXCLASS.BIN, "mo"], [8960, 9215, o.TEXCLASS.ORD, "mo"], [9312, 9471, o.TEXCLASS.ORD, "mn"], [9472, 10223, o.TEXCLASS.ORD, "mo"], [10224, 10239, o.TEXCLASS.REL, "mo"], [10240, 10495, o.TEXCLASS.ORD, "mtext"], [10496, 10623, o.TEXCLASS.REL, "mo"], [10624, 10751, o.TEXCLASS.ORD, "mo"], [10752, 11007, o.TEXCLASS.BIN, "mo"], [11008, 11055, o.TEXCLASS.ORD, "mo"], [11056, 11087, o.TEXCLASS.REL, "mo"], [11088, 11263, o.TEXCLASS.ORD, "mo"], [11264, 11744, o.TEXCLASS.ORD, "mi"], [11776, 11903, o.TEXCLASS.ORD, "mo"], [11904, 12255, o.TEXCLASS.ORD, "mi", "normal"], [12272, 12351, o.TEXCLASS.ORD, "mo"], [12352, 42143, o.TEXCLASS.ORD, "mi", "normal"], [42192, 43055, o.TEXCLASS.ORD, "mi"], [43056, 43071, o.TEXCLASS.ORD, "mn"], [43072, 55295, o.TEXCLASS.ORD, "mi"], [63744, 64255, o.TEXCLASS.ORD, "mi", "normal"], [64256, 65023, o.TEXCLASS.ORD, "mi"], [65024, 65135, o.TEXCLASS.ORD, "mo"], [65136, 65791, o.TEXCLASS.ORD, "mi"], [65792, 65935, o.TEXCLASS.ORD, "mn"], [65936, 74751, o.TEXCLASS.ORD, "mi", "normal"], [74752, 74879, o.TEXCLASS.ORD, "mn"], [74880, 113823, o.TEXCLASS.ORD, "mi", "normal"], [113824, 119391, o.TEXCLASS.ORD, "mo"], [119648, 119679, o.TEXCLASS.ORD, "mn"], [119808, 120781, o.TEXCLASS.ORD, "mi"], [120782, 120831, o.TEXCLASS.ORD, "mn"], [122624, 129023, o.TEXCLASS.ORD, "mo"], [129024, 129279, o.TEXCLASS.REL, "mo"], [129280, 129535, o.TEXCLASS.ORD, "mo"], [131072, 195103, o.TEXCLASS.ORD, "mi", "normnal"]], e.getRange = function (t) {
          var r,
            o,
            i = t.codePointAt(0);
          try {
            for (var a = n(e.RANGES), Q = a.next(); !Q.done; Q = a.next()) {
              var s = Q.value;
              if (i <= s[1]) {
                if (i >= s[0]) return s;
                break;
              }
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              Q && !Q.done && (o = a.return) && o.call(a);
            } finally {
              if (r) throw r.error;
            }
          }
          return null;
        }, e.MMLSPACING = [[0, 0], [1, 2], [3, 3], [4, 4], [0, 0], [0, 0], [0, 3]], e.OPTABLE = {
          prefix: {
            "(": e.MO.OPEN,
            "+": e.MO.BIN01,
            "-": e.MO.BIN01,
            "[": e.MO.OPEN,
            "{": e.MO.OPEN,
            "|": e.MO.OPEN,
            "||": [0, 0, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xac": e.MO.ORD21,
            "\xb1": e.MO.BIN01,
            "\u2016": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2018": [0, 0, o.TEXCLASS.OPEN, {
              fence: !0
            }],
            "\u201C": [0, 0, o.TEXCLASS.OPEN, {
              fence: !0
            }],
            "\u2145": e.MO.ORD21,
            "\u2146": i(2, 0, o.TEXCLASS.ORD),
            "\u2200": e.MO.ORD21,
            "\u2202": e.MO.ORD21,
            "\u2203": e.MO.ORD21,
            "\u2204": e.MO.ORD21,
            "\u2207": e.MO.ORD21,
            "\u220F": e.MO.OP,
            "\u2210": e.MO.OP,
            "\u2211": e.MO.OP,
            "\u2212": e.MO.BIN01,
            "\u2213": e.MO.BIN01,
            "\u221A": [1, 1, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u221B": e.MO.ORD11,
            "\u221C": e.MO.ORD11,
            "\u2220": e.MO.ORD,
            "\u2221": e.MO.ORD,
            "\u2222": e.MO.ORD,
            "\u222B": e.MO.INTEGRAL,
            "\u222C": e.MO.INTEGRAL,
            "\u222D": e.MO.INTEGRAL,
            "\u222E": e.MO.INTEGRAL,
            "\u222F": e.MO.INTEGRAL,
            "\u2230": e.MO.INTEGRAL,
            "\u2231": e.MO.INTEGRAL,
            "\u2232": e.MO.INTEGRAL,
            "\u2233": e.MO.INTEGRAL,
            "\u22C0": e.MO.OP,
            "\u22C1": e.MO.OP,
            "\u22C2": e.MO.OP,
            "\u22C3": e.MO.OP,
            "\u2308": e.MO.OPEN,
            "\u230A": e.MO.OPEN,
            "\u2329": e.MO.OPEN,
            "\u2772": e.MO.OPEN,
            "\u27E6": e.MO.OPEN,
            "\u27E8": e.MO.OPEN,
            "\u27EA": e.MO.OPEN,
            "\u27EC": e.MO.OPEN,
            "\u27EE": e.MO.OPEN,
            "\u2980": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2983": e.MO.OPEN,
            "\u2985": e.MO.OPEN,
            "\u2987": e.MO.OPEN,
            "\u2989": e.MO.OPEN,
            "\u298B": e.MO.OPEN,
            "\u298D": e.MO.OPEN,
            "\u298F": e.MO.OPEN,
            "\u2991": e.MO.OPEN,
            "\u2993": e.MO.OPEN,
            "\u2995": e.MO.OPEN,
            "\u2997": e.MO.OPEN,
            "\u29FC": e.MO.OPEN,
            "\u2A00": e.MO.OP,
            "\u2A01": e.MO.OP,
            "\u2A02": e.MO.OP,
            "\u2A03": e.MO.OP,
            "\u2A04": e.MO.OP,
            "\u2A05": e.MO.OP,
            "\u2A06": e.MO.OP,
            "\u2A07": e.MO.OP,
            "\u2A08": e.MO.OP,
            "\u2A09": e.MO.OP,
            "\u2A0A": e.MO.OP,
            "\u2A0B": e.MO.INTEGRAL2,
            "\u2A0C": e.MO.INTEGRAL,
            "\u2A0D": e.MO.INTEGRAL2,
            "\u2A0E": e.MO.INTEGRAL2,
            "\u2A0F": e.MO.INTEGRAL2,
            "\u2A10": e.MO.OP,
            "\u2A11": e.MO.OP,
            "\u2A12": e.MO.OP,
            "\u2A13": e.MO.OP,
            "\u2A14": e.MO.OP,
            "\u2A15": e.MO.INTEGRAL2,
            "\u2A16": e.MO.INTEGRAL2,
            "\u2A17": e.MO.INTEGRAL2,
            "\u2A18": e.MO.INTEGRAL2,
            "\u2A19": e.MO.INTEGRAL2,
            "\u2A1A": e.MO.INTEGRAL2,
            "\u2A1B": e.MO.INTEGRAL2,
            "\u2A1C": e.MO.INTEGRAL2,
            "\u2AFC": e.MO.OP,
            "\u2AFF": e.MO.OP
          },
          postfix: {
            "!!": i(1, 0),
            "!": [1, 0, o.TEXCLASS.CLOSE, null],
            '"': e.MO.ACCENT,
            "&": e.MO.ORD,
            ")": e.MO.CLOSE,
            "++": i(0, 0),
            "--": i(0, 0),
            "..": i(0, 0),
            "...": e.MO.ORD,
            "'": e.MO.ACCENT,
            "]": e.MO.CLOSE,
            "^": e.MO.WIDEACCENT,
            _: e.MO.WIDEACCENT,
            "`": e.MO.ACCENT,
            "|": e.MO.CLOSE,
            "}": e.MO.CLOSE,
            "~": e.MO.WIDEACCENT,
            "||": [0, 0, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xa8": e.MO.ACCENT,
            "\xaa": e.MO.ACCENT,
            "\xaf": e.MO.WIDEACCENT,
            "\xb0": e.MO.ORD,
            "\xb2": e.MO.ACCENT,
            "\xb3": e.MO.ACCENT,
            "\xb4": e.MO.ACCENT,
            "\xb8": e.MO.ACCENT,
            "\xb9": e.MO.ACCENT,
            "\xba": e.MO.ACCENT,
            "\u02C6": e.MO.WIDEACCENT,
            "\u02C7": e.MO.WIDEACCENT,
            "\u02C9": e.MO.WIDEACCENT,
            "\u02CA": e.MO.ACCENT,
            "\u02CB": e.MO.ACCENT,
            "\u02CD": e.MO.WIDEACCENT,
            "\u02D8": e.MO.ACCENT,
            "\u02D9": e.MO.ACCENT,
            "\u02DA": e.MO.ACCENT,
            "\u02DC": e.MO.WIDEACCENT,
            "\u02DD": e.MO.ACCENT,
            "\u02F7": e.MO.WIDEACCENT,
            "\u0302": e.MO.WIDEACCENT,
            "\u0311": e.MO.ACCENT,
            "\u03F6": e.MO.REL,
            "\u2016": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2019": [0, 0, o.TEXCLASS.CLOSE, {
              fence: !0
            }],
            "\u201A": e.MO.ACCENT,
            "\u201B": e.MO.ACCENT,
            "\u201D": [0, 0, o.TEXCLASS.CLOSE, {
              fence: !0
            }],
            "\u201E": e.MO.ACCENT,
            "\u201F": e.MO.ACCENT,
            "\u2032": e.MO.ORD,
            "\u2033": e.MO.ACCENT,
            "\u2034": e.MO.ACCENT,
            "\u2035": e.MO.ACCENT,
            "\u2036": e.MO.ACCENT,
            "\u2037": e.MO.ACCENT,
            "\u203E": e.MO.WIDEACCENT,
            "\u2057": e.MO.ACCENT,
            "\u20DB": e.MO.ACCENT,
            "\u20DC": e.MO.ACCENT,
            "\u2309": e.MO.CLOSE,
            "\u230B": e.MO.CLOSE,
            "\u232A": e.MO.CLOSE,
            "\u23B4": e.MO.WIDEACCENT,
            "\u23B5": e.MO.WIDEACCENT,
            "\u23DC": e.MO.WIDEACCENT,
            "\u23DD": e.MO.WIDEACCENT,
            "\u23DE": e.MO.WIDEACCENT,
            "\u23DF": e.MO.WIDEACCENT,
            "\u23E0": e.MO.WIDEACCENT,
            "\u23E1": e.MO.WIDEACCENT,
            "\u25A0": e.MO.BIN3,
            "\u25A1": e.MO.BIN3,
            "\u25AA": e.MO.BIN3,
            "\u25AB": e.MO.BIN3,
            "\u25AD": e.MO.BIN3,
            "\u25AE": e.MO.BIN3,
            "\u25AF": e.MO.BIN3,
            "\u25B0": e.MO.BIN3,
            "\u25B1": e.MO.BIN3,
            "\u25B2": e.MO.BIN4,
            "\u25B4": e.MO.BIN4,
            "\u25B6": e.MO.BIN4,
            "\u25B7": e.MO.BIN4,
            "\u25B8": e.MO.BIN4,
            "\u25BC": e.MO.BIN4,
            "\u25BE": e.MO.BIN4,
            "\u25C0": e.MO.BIN4,
            "\u25C1": e.MO.BIN4,
            "\u25C2": e.MO.BIN4,
            "\u25C4": e.MO.BIN4,
            "\u25C5": e.MO.BIN4,
            "\u25C6": e.MO.BIN4,
            "\u25C7": e.MO.BIN4,
            "\u25C8": e.MO.BIN4,
            "\u25C9": e.MO.BIN4,
            "\u25CC": e.MO.BIN4,
            "\u25CD": e.MO.BIN4,
            "\u25CE": e.MO.BIN4,
            "\u25CF": e.MO.BIN4,
            "\u25D6": e.MO.BIN4,
            "\u25D7": e.MO.BIN4,
            "\u25E6": e.MO.BIN4,
            "\u266D": e.MO.ORD02,
            "\u266E": e.MO.ORD02,
            "\u266F": e.MO.ORD02,
            "\u2773": e.MO.CLOSE,
            "\u27E7": e.MO.CLOSE,
            "\u27E9": e.MO.CLOSE,
            "\u27EB": e.MO.CLOSE,
            "\u27ED": e.MO.CLOSE,
            "\u27EF": e.MO.CLOSE,
            "\u2980": [0, 0, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0
            }],
            "\u2984": e.MO.CLOSE,
            "\u2986": e.MO.CLOSE,
            "\u2988": e.MO.CLOSE,
            "\u298A": e.MO.CLOSE,
            "\u298C": e.MO.CLOSE,
            "\u298E": e.MO.CLOSE,
            "\u2990": e.MO.CLOSE,
            "\u2992": e.MO.CLOSE,
            "\u2994": e.MO.CLOSE,
            "\u2996": e.MO.CLOSE,
            "\u2998": e.MO.CLOSE,
            "\u29FD": e.MO.CLOSE
          },
          infix: {
            "!=": e.MO.BIN4,
            "#": e.MO.ORD,
            $: e.MO.ORD,
            "%": [3, 3, o.TEXCLASS.ORD, null],
            "&&": e.MO.BIN4,
            "": e.MO.ORD,
            "*": e.MO.BIN3,
            "**": i(1, 1),
            "*=": e.MO.BIN4,
            "+": e.MO.BIN4,
            "+=": e.MO.BIN4,
            ",": [0, 3, o.TEXCLASS.PUNCT, {
              linebreakstyle: "after",
              separator: !0
            }],
            "-": e.MO.BIN4,
            "-=": e.MO.BIN4,
            "->": e.MO.BIN5,
            ".": [0, 3, o.TEXCLASS.PUNCT, {
              separator: !0
            }],
            "/": e.MO.ORD11,
            "//": i(1, 1),
            "/=": e.MO.BIN4,
            ":": [1, 2, o.TEXCLASS.REL, null],
            ":=": e.MO.BIN4,
            ";": [0, 3, o.TEXCLASS.PUNCT, {
              linebreakstyle: "after",
              separator: !0
            }],
            "<": e.MO.REL,
            "<=": e.MO.BIN5,
            "<>": i(1, 1),
            "=": e.MO.REL,
            "==": e.MO.BIN4,
            ">": e.MO.REL,
            ">=": e.MO.BIN5,
            "?": [1, 1, o.TEXCLASS.CLOSE, null],
            "@": e.MO.ORD11,
            "\\": e.MO.ORD,
            "^": e.MO.ORD11,
            _: e.MO.ORD11,
            "|": [2, 2, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "||": [2, 2, o.TEXCLASS.BIN, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "|||": [2, 2, o.TEXCLASS.ORD, {
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }],
            "\xb1": e.MO.BIN4,
            "\xb7": e.MO.BIN4,
            "\xd7": e.MO.BIN4,
            "\xf7": e.MO.BIN4,
            "\u02B9": e.MO.ORD,
            "\u0300": e.MO.ACCENT,
            "\u0301": e.MO.ACCENT,
            "\u0303": e.MO.WIDEACCENT,
            "\u0304": e.MO.ACCENT,
            "\u0306": e.MO.ACCENT,
            "\u0307": e.MO.ACCENT,
            "\u0308": e.MO.ACCENT,
            "\u030C": e.MO.ACCENT,
            "\u0332": e.MO.WIDEACCENT,
            "\u0338": e.MO.REL4,
            "\u2015": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u2017": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u2020": e.MO.BIN3,
            "\u2021": e.MO.BIN3,
            "\u2022": e.MO.BIN4,
            "\u2026": e.MO.INNER,
            "\u2043": e.MO.BIN4,
            "\u2044": e.MO.TALLBIN,
            "\u2061": e.MO.NONE,
            "\u2062": e.MO.NONE,
            "\u2063": [0, 0, o.TEXCLASS.NONE, {
              linebreakstyle: "after",
              separator: !0
            }],
            "\u2064": e.MO.NONE,
            "\u20D7": e.MO.ACCENT,
            "\u2111": e.MO.ORD,
            "\u2113": e.MO.ORD,
            "\u2118": e.MO.ORD,
            "\u211C": e.MO.ORD,
            "\u2190": e.MO.WIDEREL,
            "\u2191": e.MO.RELSTRETCH,
            "\u2192": e.MO.WIDEREL,
            "\u2193": e.MO.RELSTRETCH,
            "\u2194": e.MO.WIDEREL,
            "\u2195": e.MO.RELSTRETCH,
            "\u2196": e.MO.RELSTRETCH,
            "\u2197": e.MO.RELSTRETCH,
            "\u2198": e.MO.RELSTRETCH,
            "\u2199": e.MO.RELSTRETCH,
            "\u219A": e.MO.RELACCENT,
            "\u219B": e.MO.RELACCENT,
            "\u219C": e.MO.WIDEREL,
            "\u219D": e.MO.WIDEREL,
            "\u219E": e.MO.WIDEREL,
            "\u219F": e.MO.WIDEREL,
            "\u21A0": e.MO.WIDEREL,
            "\u21A1": e.MO.RELSTRETCH,
            "\u21A2": e.MO.WIDEREL,
            "\u21A3": e.MO.WIDEREL,
            "\u21A4": e.MO.WIDEREL,
            "\u21A5": e.MO.RELSTRETCH,
            "\u21A6": e.MO.WIDEREL,
            "\u21A7": e.MO.RELSTRETCH,
            "\u21A8": e.MO.RELSTRETCH,
            "\u21A9": e.MO.WIDEREL,
            "\u21AA": e.MO.WIDEREL,
            "\u21AB": e.MO.WIDEREL,
            "\u21AC": e.MO.WIDEREL,
            "\u21AD": e.MO.WIDEREL,
            "\u21AE": e.MO.RELACCENT,
            "\u21AF": e.MO.RELSTRETCH,
            "\u21B0": e.MO.RELSTRETCH,
            "\u21B1": e.MO.RELSTRETCH,
            "\u21B2": e.MO.RELSTRETCH,
            "\u21B3": e.MO.RELSTRETCH,
            "\u21B4": e.MO.RELSTRETCH,
            "\u21B5": e.MO.RELSTRETCH,
            "\u21B6": e.MO.RELACCENT,
            "\u21B7": e.MO.RELACCENT,
            "\u21B8": e.MO.REL,
            "\u21B9": e.MO.WIDEREL,
            "\u21BA": e.MO.REL,
            "\u21BB": e.MO.REL,
            "\u21BC": e.MO.WIDEREL,
            "\u21BD": e.MO.WIDEREL,
            "\u21BE": e.MO.RELSTRETCH,
            "\u21BF": e.MO.RELSTRETCH,
            "\u21C0": e.MO.WIDEREL,
            "\u21C1": e.MO.WIDEREL,
            "\u21C2": e.MO.RELSTRETCH,
            "\u21C3": e.MO.RELSTRETCH,
            "\u21C4": e.MO.WIDEREL,
            "\u21C5": e.MO.RELSTRETCH,
            "\u21C6": e.MO.WIDEREL,
            "\u21C7": e.MO.WIDEREL,
            "\u21C8": e.MO.RELSTRETCH,
            "\u21C9": e.MO.WIDEREL,
            "\u21CA": e.MO.RELSTRETCH,
            "\u21CB": e.MO.WIDEREL,
            "\u21CC": e.MO.WIDEREL,
            "\u21CD": e.MO.RELACCENT,
            "\u21CE": e.MO.RELACCENT,
            "\u21CF": e.MO.RELACCENT,
            "\u21D0": e.MO.WIDEREL,
            "\u21D1": e.MO.RELSTRETCH,
            "\u21D2": e.MO.WIDEREL,
            "\u21D3": e.MO.RELSTRETCH,
            "\u21D4": e.MO.WIDEREL,
            "\u21D5": e.MO.RELSTRETCH,
            "\u21D6": e.MO.RELSTRETCH,
            "\u21D7": e.MO.RELSTRETCH,
            "\u21D8": e.MO.RELSTRETCH,
            "\u21D9": e.MO.RELSTRETCH,
            "\u21DA": e.MO.WIDEREL,
            "\u21DB": e.MO.WIDEREL,
            "\u21DC": e.MO.WIDEREL,
            "\u21DD": e.MO.WIDEREL,
            "\u21DE": e.MO.REL,
            "\u21DF": e.MO.REL,
            "\u21E0": e.MO.WIDEREL,
            "\u21E1": e.MO.RELSTRETCH,
            "\u21E2": e.MO.WIDEREL,
            "\u21E3": e.MO.RELSTRETCH,
            "\u21E4": e.MO.WIDEREL,
            "\u21E5": e.MO.WIDEREL,
            "\u21E6": e.MO.WIDEREL,
            "\u21E7": e.MO.RELSTRETCH,
            "\u21E8": e.MO.WIDEREL,
            "\u21E9": e.MO.RELSTRETCH,
            "\u21EA": e.MO.RELSTRETCH,
            "\u21EB": e.MO.RELSTRETCH,
            "\u21EC": e.MO.RELSTRETCH,
            "\u21ED": e.MO.RELSTRETCH,
            "\u21EE": e.MO.RELSTRETCH,
            "\u21EF": e.MO.RELSTRETCH,
            "\u21F0": e.MO.WIDEREL,
            "\u21F1": e.MO.REL,
            "\u21F2": e.MO.REL,
            "\u21F3": e.MO.RELSTRETCH,
            "\u21F4": e.MO.RELACCENT,
            "\u21F5": e.MO.RELSTRETCH,
            "\u21F6": e.MO.WIDEREL,
            "\u21F7": e.MO.RELACCENT,
            "\u21F8": e.MO.RELACCENT,
            "\u21F9": e.MO.RELACCENT,
            "\u21FA": e.MO.RELACCENT,
            "\u21FB": e.MO.RELACCENT,
            "\u21FC": e.MO.RELACCENT,
            "\u21FD": e.MO.WIDEREL,
            "\u21FE": e.MO.WIDEREL,
            "\u21FF": e.MO.WIDEREL,
            "\u2201": i(1, 2, o.TEXCLASS.ORD),
            "\u2205": e.MO.ORD,
            "\u2206": e.MO.BIN3,
            "\u2208": e.MO.REL,
            "\u2209": e.MO.REL,
            "\u220A": e.MO.REL,
            "\u220B": e.MO.REL,
            "\u220C": e.MO.REL,
            "\u220D": e.MO.REL,
            "\u220E": e.MO.BIN3,
            "\u2212": e.MO.BIN4,
            "\u2213": e.MO.BIN4,
            "\u2214": e.MO.BIN4,
            "\u2215": e.MO.TALLBIN,
            "\u2216": e.MO.BIN4,
            "\u2217": e.MO.BIN4,
            "\u2218": e.MO.BIN4,
            "\u2219": e.MO.BIN4,
            "\u221D": e.MO.REL,
            "\u221E": e.MO.ORD,
            "\u221F": e.MO.REL,
            "\u2223": e.MO.REL,
            "\u2224": e.MO.REL,
            "\u2225": e.MO.REL,
            "\u2226": e.MO.REL,
            "\u2227": e.MO.BIN4,
            "\u2228": e.MO.BIN4,
            "\u2229": e.MO.BIN4,
            "\u222A": e.MO.BIN4,
            "\u2234": e.MO.REL,
            "\u2235": e.MO.REL,
            "\u2236": e.MO.REL,
            "\u2237": e.MO.REL,
            "\u2238": e.MO.BIN4,
            "\u2239": e.MO.REL,
            "\u223A": e.MO.BIN4,
            "\u223B": e.MO.REL,
            "\u223C": e.MO.REL,
            "\u223D": e.MO.REL,
            "\u223D\u0331": e.MO.BIN3,
            "\u223E": e.MO.REL,
            "\u223F": e.MO.BIN3,
            "\u2240": e.MO.BIN4,
            "\u2241": e.MO.REL,
            "\u2242": e.MO.REL,
            "\u2242\u0338": e.MO.REL,
            "\u2243": e.MO.REL,
            "\u2244": e.MO.REL,
            "\u2245": e.MO.REL,
            "\u2246": e.MO.REL,
            "\u2247": e.MO.REL,
            "\u2248": e.MO.REL,
            "\u2249": e.MO.REL,
            "\u224A": e.MO.REL,
            "\u224B": e.MO.REL,
            "\u224C": e.MO.REL,
            "\u224D": e.MO.REL,
            "\u224E": e.MO.REL,
            "\u224E\u0338": e.MO.REL,
            "\u224F": e.MO.REL,
            "\u224F\u0338": e.MO.REL,
            "\u2250": e.MO.REL,
            "\u2251": e.MO.REL,
            "\u2252": e.MO.REL,
            "\u2253": e.MO.REL,
            "\u2254": e.MO.REL,
            "\u2255": e.MO.REL,
            "\u2256": e.MO.REL,
            "\u2257": e.MO.REL,
            "\u2258": e.MO.REL,
            "\u2259": e.MO.REL,
            "\u225A": e.MO.REL,
            "\u225B": e.MO.REL,
            "\u225C": e.MO.REL,
            "\u225D": e.MO.REL,
            "\u225E": e.MO.REL,
            "\u225F": e.MO.REL,
            "\u2260": e.MO.REL,
            "\u2261": e.MO.REL,
            "\u2262": e.MO.REL,
            "\u2263": e.MO.REL,
            "\u2264": e.MO.REL,
            "\u2265": e.MO.REL,
            "\u2266": e.MO.REL,
            "\u2266\u0338": e.MO.REL,
            "\u2267": e.MO.REL,
            "\u2268": e.MO.REL,
            "\u2269": e.MO.REL,
            "\u226A": e.MO.REL,
            "\u226A\u0338": e.MO.REL,
            "\u226B": e.MO.REL,
            "\u226B\u0338": e.MO.REL,
            "\u226C": e.MO.REL,
            "\u226D": e.MO.REL,
            "\u226E": e.MO.REL,
            "\u226F": e.MO.REL,
            "\u2270": e.MO.REL,
            "\u2271": e.MO.REL,
            "\u2272": e.MO.REL,
            "\u2273": e.MO.REL,
            "\u2274": e.MO.REL,
            "\u2275": e.MO.REL,
            "\u2276": e.MO.REL,
            "\u2277": e.MO.REL,
            "\u2278": e.MO.REL,
            "\u2279": e.MO.REL,
            "\u227A": e.MO.REL,
            "\u227B": e.MO.REL,
            "\u227C": e.MO.REL,
            "\u227D": e.MO.REL,
            "\u227E": e.MO.REL,
            "\u227F": e.MO.REL,
            "\u227F\u0338": e.MO.REL,
            "\u2280": e.MO.REL,
            "\u2281": e.MO.REL,
            "\u2282": e.MO.REL,
            "\u2282\u20D2": e.MO.REL,
            "\u2283": e.MO.REL,
            "\u2283\u20D2": e.MO.REL,
            "\u2284": e.MO.REL,
            "\u2285": e.MO.REL,
            "\u2286": e.MO.REL,
            "\u2287": e.MO.REL,
            "\u2288": e.MO.REL,
            "\u2289": e.MO.REL,
            "\u228A": e.MO.REL,
            "\u228B": e.MO.REL,
            "\u228C": e.MO.BIN4,
            "\u228D": e.MO.BIN4,
            "\u228E": e.MO.BIN4,
            "\u228F": e.MO.REL,
            "\u228F\u0338": e.MO.REL,
            "\u2290": e.MO.REL,
            "\u2290\u0338": e.MO.REL,
            "\u2291": e.MO.REL,
            "\u2292": e.MO.REL,
            "\u2293": e.MO.BIN4,
            "\u2294": e.MO.BIN4,
            "\u2295": e.MO.BIN4,
            "\u2296": e.MO.BIN4,
            "\u2297": e.MO.BIN4,
            "\u2298": e.MO.BIN4,
            "\u2299": e.MO.BIN4,
            "\u229A": e.MO.BIN4,
            "\u229B": e.MO.BIN4,
            "\u229C": e.MO.BIN4,
            "\u229D": e.MO.BIN4,
            "\u229E": e.MO.BIN4,
            "\u229F": e.MO.BIN4,
            "\u22A0": e.MO.BIN4,
            "\u22A1": e.MO.BIN4,
            "\u22A2": e.MO.REL,
            "\u22A3": e.MO.REL,
            "\u22A4": e.MO.ORD55,
            "\u22A5": e.MO.REL,
            "\u22A6": e.MO.REL,
            "\u22A7": e.MO.REL,
            "\u22A8": e.MO.REL,
            "\u22A9": e.MO.REL,
            "\u22AA": e.MO.REL,
            "\u22AB": e.MO.REL,
            "\u22AC": e.MO.REL,
            "\u22AD": e.MO.REL,
            "\u22AE": e.MO.REL,
            "\u22AF": e.MO.REL,
            "\u22B0": e.MO.REL,
            "\u22B1": e.MO.REL,
            "\u22B2": e.MO.REL,
            "\u22B3": e.MO.REL,
            "\u22B4": e.MO.REL,
            "\u22B5": e.MO.REL,
            "\u22B6": e.MO.REL,
            "\u22B7": e.MO.REL,
            "\u22B8": e.MO.REL,
            "\u22B9": e.MO.REL,
            "\u22BA": e.MO.BIN4,
            "\u22BB": e.MO.BIN4,
            "\u22BC": e.MO.BIN4,
            "\u22BD": e.MO.BIN4,
            "\u22BE": e.MO.BIN3,
            "\u22BF": e.MO.BIN3,
            "\u22C4": e.MO.BIN4,
            "\u22C5": e.MO.BIN4,
            "\u22C6": e.MO.BIN4,
            "\u22C7": e.MO.BIN4,
            "\u22C8": e.MO.REL,
            "\u22C9": e.MO.BIN4,
            "\u22CA": e.MO.BIN4,
            "\u22CB": e.MO.BIN4,
            "\u22CC": e.MO.BIN4,
            "\u22CD": e.MO.REL,
            "\u22CE": e.MO.BIN4,
            "\u22CF": e.MO.BIN4,
            "\u22D0": e.MO.REL,
            "\u22D1": e.MO.REL,
            "\u22D2": e.MO.BIN4,
            "\u22D3": e.MO.BIN4,
            "\u22D4": e.MO.REL,
            "\u22D5": e.MO.REL,
            "\u22D6": e.MO.REL,
            "\u22D7": e.MO.REL,
            "\u22D8": e.MO.REL,
            "\u22D9": e.MO.REL,
            "\u22DA": e.MO.REL,
            "\u22DB": e.MO.REL,
            "\u22DC": e.MO.REL,
            "\u22DD": e.MO.REL,
            "\u22DE": e.MO.REL,
            "\u22DF": e.MO.REL,
            "\u22E0": e.MO.REL,
            "\u22E1": e.MO.REL,
            "\u22E2": e.MO.REL,
            "\u22E3": e.MO.REL,
            "\u22E4": e.MO.REL,
            "\u22E5": e.MO.REL,
            "\u22E6": e.MO.REL,
            "\u22E7": e.MO.REL,
            "\u22E8": e.MO.REL,
            "\u22E9": e.MO.REL,
            "\u22EA": e.MO.REL,
            "\u22EB": e.MO.REL,
            "\u22EC": e.MO.REL,
            "\u22ED": e.MO.REL,
            "\u22EE": e.MO.ORD55,
            "\u22EF": e.MO.INNER,
            "\u22F0": e.MO.REL,
            "\u22F1": [5, 5, o.TEXCLASS.INNER, null],
            "\u22F2": e.MO.REL,
            "\u22F3": e.MO.REL,
            "\u22F4": e.MO.REL,
            "\u22F5": e.MO.REL,
            "\u22F6": e.MO.REL,
            "\u22F7": e.MO.REL,
            "\u22F8": e.MO.REL,
            "\u22F9": e.MO.REL,
            "\u22FA": e.MO.REL,
            "\u22FB": e.MO.REL,
            "\u22FC": e.MO.REL,
            "\u22FD": e.MO.REL,
            "\u22FE": e.MO.REL,
            "\u22FF": e.MO.REL,
            "\u2305": e.MO.BIN3,
            "\u2306": e.MO.BIN3,
            "\u2322": e.MO.REL4,
            "\u2323": e.MO.REL4,
            "\u2329": e.MO.OPEN,
            "\u232A": e.MO.CLOSE,
            "\u23AA": e.MO.ORD,
            "\u23AF": [0, 0, o.TEXCLASS.ORD, {
              stretchy: !0
            }],
            "\u23B0": e.MO.OPEN,
            "\u23B1": e.MO.CLOSE,
            "\u2500": e.MO.ORD,
            "\u25B3": e.MO.BIN4,
            "\u25B5": e.MO.BIN4,
            "\u25B9": e.MO.BIN4,
            "\u25BD": e.MO.BIN4,
            "\u25BF": e.MO.BIN4,
            "\u25C3": e.MO.BIN4,
            "\u25EF": e.MO.BIN3,
            "\u2660": e.MO.ORD,
            "\u2661": e.MO.ORD,
            "\u2662": e.MO.ORD,
            "\u2663": e.MO.ORD,
            "\u2758": e.MO.REL,
            "\u27F0": e.MO.RELSTRETCH,
            "\u27F1": e.MO.RELSTRETCH,
            "\u27F5": e.MO.WIDEREL,
            "\u27F6": e.MO.WIDEREL,
            "\u27F7": e.MO.WIDEREL,
            "\u27F8": e.MO.WIDEREL,
            "\u27F9": e.MO.WIDEREL,
            "\u27FA": e.MO.WIDEREL,
            "\u27FB": e.MO.WIDEREL,
            "\u27FC": e.MO.WIDEREL,
            "\u27FD": e.MO.WIDEREL,
            "\u27FE": e.MO.WIDEREL,
            "\u27FF": e.MO.WIDEREL,
            "\u2900": e.MO.RELACCENT,
            "\u2901": e.MO.RELACCENT,
            "\u2902": e.MO.RELACCENT,
            "\u2903": e.MO.RELACCENT,
            "\u2904": e.MO.RELACCENT,
            "\u2905": e.MO.RELACCENT,
            "\u2906": e.MO.RELACCENT,
            "\u2907": e.MO.RELACCENT,
            "\u2908": e.MO.REL,
            "\u2909": e.MO.REL,
            "\u290A": e.MO.RELSTRETCH,
            "\u290B": e.MO.RELSTRETCH,
            "\u290C": e.MO.WIDEREL,
            "\u290D": e.MO.WIDEREL,
            "\u290E": e.MO.WIDEREL,
            "\u290F": e.MO.WIDEREL,
            "\u2910": e.MO.WIDEREL,
            "\u2911": e.MO.RELACCENT,
            "\u2912": e.MO.RELSTRETCH,
            "\u2913": e.MO.RELSTRETCH,
            "\u2914": e.MO.RELACCENT,
            "\u2915": e.MO.RELACCENT,
            "\u2916": e.MO.RELACCENT,
            "\u2917": e.MO.RELACCENT,
            "\u2918": e.MO.RELACCENT,
            "\u2919": e.MO.RELACCENT,
            "\u291A": e.MO.RELACCENT,
            "\u291B": e.MO.RELACCENT,
            "\u291C": e.MO.RELACCENT,
            "\u291D": e.MO.RELACCENT,
            "\u291E": e.MO.RELACCENT,
            "\u291F": e.MO.RELACCENT,
            "\u2920": e.MO.RELACCENT,
            "\u2921": e.MO.RELSTRETCH,
            "\u2922": e.MO.RELSTRETCH,
            "\u2923": e.MO.REL,
            "\u2924": e.MO.REL,
            "\u2925": e.MO.REL,
            "\u2926": e.MO.REL,
            "\u2927": e.MO.REL,
            "\u2928": e.MO.REL,
            "\u2929": e.MO.REL,
            "\u292A": e.MO.REL,
            "\u292B": e.MO.REL,
            "\u292C": e.MO.REL,
            "\u292D": e.MO.REL,
            "\u292E": e.MO.REL,
            "\u292F": e.MO.REL,
            "\u2930": e.MO.REL,
            "\u2931": e.MO.REL,
            "\u2932": e.MO.REL,
            "\u2933": e.MO.RELACCENT,
            "\u2934": e.MO.REL,
            "\u2935": e.MO.REL,
            "\u2936": e.MO.REL,
            "\u2937": e.MO.REL,
            "\u2938": e.MO.REL,
            "\u2939": e.MO.REL,
            "\u293A": e.MO.RELACCENT,
            "\u293B": e.MO.RELACCENT,
            "\u293C": e.MO.RELACCENT,
            "\u293D": e.MO.RELACCENT,
            "\u293E": e.MO.REL,
            "\u293F": e.MO.REL,
            "\u2940": e.MO.REL,
            "\u2941": e.MO.REL,
            "\u2942": e.MO.RELACCENT,
            "\u2943": e.MO.RELACCENT,
            "\u2944": e.MO.RELACCENT,
            "\u2945": e.MO.RELACCENT,
            "\u2946": e.MO.RELACCENT,
            "\u2947": e.MO.RELACCENT,
            "\u2948": e.MO.RELACCENT,
            "\u2949": e.MO.REL,
            "\u294A": e.MO.RELACCENT,
            "\u294B": e.MO.RELACCENT,
            "\u294C": e.MO.REL,
            "\u294D": e.MO.REL,
            "\u294E": e.MO.WIDEREL,
            "\u294F": e.MO.RELSTRETCH,
            "\u2950": e.MO.WIDEREL,
            "\u2951": e.MO.RELSTRETCH,
            "\u2952": e.MO.WIDEREL,
            "\u2953": e.MO.WIDEREL,
            "\u2954": e.MO.RELSTRETCH,
            "\u2955": e.MO.RELSTRETCH,
            "\u2956": e.MO.RELSTRETCH,
            "\u2957": e.MO.RELSTRETCH,
            "\u2958": e.MO.RELSTRETCH,
            "\u2959": e.MO.RELSTRETCH,
            "\u295A": e.MO.WIDEREL,
            "\u295B": e.MO.WIDEREL,
            "\u295C": e.MO.RELSTRETCH,
            "\u295D": e.MO.RELSTRETCH,
            "\u295E": e.MO.WIDEREL,
            "\u295F": e.MO.WIDEREL,
            "\u2960": e.MO.RELSTRETCH,
            "\u2961": e.MO.RELSTRETCH,
            "\u2962": e.MO.RELACCENT,
            "\u2963": e.MO.REL,
            "\u2964": e.MO.RELACCENT,
            "\u2965": e.MO.REL,
            "\u2966": e.MO.RELACCENT,
            "\u2967": e.MO.RELACCENT,
            "\u2968": e.MO.RELACCENT,
            "\u2969": e.MO.RELACCENT,
            "\u296A": e.MO.RELACCENT,
            "\u296B": e.MO.RELACCENT,
            "\u296C": e.MO.RELACCENT,
            "\u296D": e.MO.RELACCENT,
            "\u296E": e.MO.RELSTRETCH,
            "\u296F": e.MO.RELSTRETCH,
            "\u2970": e.MO.RELACCENT,
            "\u2971": e.MO.RELACCENT,
            "\u2972": e.MO.RELACCENT,
            "\u2973": e.MO.RELACCENT,
            "\u2974": e.MO.RELACCENT,
            "\u2975": e.MO.RELACCENT,
            "\u2976": e.MO.RELACCENT,
            "\u2977": e.MO.RELACCENT,
            "\u2978": e.MO.RELACCENT,
            "\u2979": e.MO.RELACCENT,
            "\u297A": e.MO.RELACCENT,
            "\u297B": e.MO.RELACCENT,
            "\u297C": e.MO.RELACCENT,
            "\u297D": e.MO.RELACCENT,
            "\u297E": e.MO.REL,
            "\u297F": e.MO.REL,
            "\u2981": e.MO.BIN3,
            "\u2982": e.MO.BIN3,
            "\u2999": e.MO.BIN3,
            "\u299A": e.MO.BIN3,
            "\u299B": e.MO.BIN3,
            "\u299C": e.MO.BIN3,
            "\u299D": e.MO.BIN3,
            "\u299E": e.MO.BIN3,
            "\u299F": e.MO.BIN3,
            "\u29A0": e.MO.BIN3,
            "\u29A1": e.MO.BIN3,
            "\u29A2": e.MO.BIN3,
            "\u29A3": e.MO.BIN3,
            "\u29A4": e.MO.BIN3,
            "\u29A5": e.MO.BIN3,
            "\u29A6": e.MO.BIN3,
            "\u29A7": e.MO.BIN3,
            "\u29A8": e.MO.BIN3,
            "\u29A9": e.MO.BIN3,
            "\u29AA": e.MO.BIN3,
            "\u29AB": e.MO.BIN3,
            "\u29AC": e.MO.BIN3,
            "\u29AD": e.MO.BIN3,
            "\u29AE": e.MO.BIN3,
            "\u29AF": e.MO.BIN3,
            "\u29B0": e.MO.BIN3,
            "\u29B1": e.MO.BIN3,
            "\u29B2": e.MO.BIN3,
            "\u29B3": e.MO.BIN3,
            "\u29B4": e.MO.BIN3,
            "\u29B5": e.MO.BIN3,
            "\u29B6": e.MO.BIN4,
            "\u29B7": e.MO.BIN4,
            "\u29B8": e.MO.BIN4,
            "\u29B9": e.MO.BIN4,
            "\u29BA": e.MO.BIN4,
            "\u29BB": e.MO.BIN4,
            "\u29BC": e.MO.BIN4,
            "\u29BD": e.MO.BIN4,
            "\u29BE": e.MO.BIN4,
            "\u29BF": e.MO.BIN4,
            "\u29C0": e.MO.REL,
            "\u29C1": e.MO.REL,
            "\u29C2": e.MO.BIN3,
            "\u29C3": e.MO.BIN3,
            "\u29C4": e.MO.BIN4,
            "\u29C5": e.MO.BIN4,
            "\u29C6": e.MO.BIN4,
            "\u29C7": e.MO.BIN4,
            "\u29C8": e.MO.BIN4,
            "\u29C9": e.MO.BIN3,
            "\u29CA": e.MO.BIN3,
            "\u29CB": e.MO.BIN3,
            "\u29CC": e.MO.BIN3,
            "\u29CD": e.MO.BIN3,
            "\u29CE": e.MO.REL,
            "\u29CF": e.MO.REL,
            "\u29CF\u0338": e.MO.REL,
            "\u29D0": e.MO.REL,
            "\u29D0\u0338": e.MO.REL,
            "\u29D1": e.MO.REL,
            "\u29D2": e.MO.REL,
            "\u29D3": e.MO.REL,
            "\u29D4": e.MO.REL,
            "\u29D5": e.MO.REL,
            "\u29D6": e.MO.BIN4,
            "\u29D7": e.MO.BIN4,
            "\u29D8": e.MO.BIN3,
            "\u29D9": e.MO.BIN3,
            "\u29DB": e.MO.BIN3,
            "\u29DC": e.MO.BIN3,
            "\u29DD": e.MO.BIN3,
            "\u29DE": e.MO.REL,
            "\u29DF": e.MO.BIN3,
            "\u29E0": e.MO.BIN3,
            "\u29E1": e.MO.REL,
            "\u29E2": e.MO.BIN4,
            "\u29E3": e.MO.REL,
            "\u29E4": e.MO.REL,
            "\u29E5": e.MO.REL,
            "\u29E6": e.MO.REL,
            "\u29E7": e.MO.BIN3,
            "\u29E8": e.MO.BIN3,
            "\u29E9": e.MO.BIN3,
            "\u29EA": e.MO.BIN3,
            "\u29EB": e.MO.BIN3,
            "\u29EC": e.MO.BIN3,
            "\u29ED": e.MO.BIN3,
            "\u29EE": e.MO.BIN3,
            "\u29EF": e.MO.BIN3,
            "\u29F0": e.MO.BIN3,
            "\u29F1": e.MO.BIN3,
            "\u29F2": e.MO.BIN3,
            "\u29F3": e.MO.BIN3,
            "\u29F4": e.MO.REL,
            "\u29F5": e.MO.BIN4,
            "\u29F6": e.MO.BIN4,
            "\u29F7": e.MO.BIN4,
            "\u29F8": e.MO.BIN3,
            "\u29F9": e.MO.BIN3,
            "\u29FA": e.MO.BIN3,
            "\u29FB": e.MO.BIN3,
            "\u29FE": e.MO.BIN4,
            "\u29FF": e.MO.BIN4,
            "\u2A1D": e.MO.BIN3,
            "\u2A1E": e.MO.BIN3,
            "\u2A1F": e.MO.BIN3,
            "\u2A20": e.MO.BIN3,
            "\u2A21": e.MO.BIN3,
            "\u2A22": e.MO.BIN4,
            "\u2A23": e.MO.BIN4,
            "\u2A24": e.MO.BIN4,
            "\u2A25": e.MO.BIN4,
            "\u2A26": e.MO.BIN4,
            "\u2A27": e.MO.BIN4,
            "\u2A28": e.MO.BIN4,
            "\u2A29": e.MO.BIN4,
            "\u2A2A": e.MO.BIN4,
            "\u2A2B": e.MO.BIN4,
            "\u2A2C": e.MO.BIN4,
            "\u2A2D": e.MO.BIN4,
            "\u2A2E": e.MO.BIN4,
            "\u2A2F": e.MO.BIN4,
            "\u2A30": e.MO.BIN4,
            "\u2A31": e.MO.BIN4,
            "\u2A32": e.MO.BIN4,
            "\u2A33": e.MO.BIN4,
            "\u2A34": e.MO.BIN4,
            "\u2A35": e.MO.BIN4,
            "\u2A36": e.MO.BIN4,
            "\u2A37": e.MO.BIN4,
            "\u2A38": e.MO.BIN4,
            "\u2A39": e.MO.BIN4,
            "\u2A3A": e.MO.BIN4,
            "\u2A3B": e.MO.BIN4,
            "\u2A3C": e.MO.BIN4,
            "\u2A3D": e.MO.BIN4,
            "\u2A3E": e.MO.BIN4,
            "\u2A3F": e.MO.BIN4,
            "\u2A40": e.MO.BIN4,
            "\u2A41": e.MO.BIN4,
            "\u2A42": e.MO.BIN4,
            "\u2A43": e.MO.BIN4,
            "\u2A44": e.MO.BIN4,
            "\u2A45": e.MO.BIN4,
            "\u2A46": e.MO.BIN4,
            "\u2A47": e.MO.BIN4,
            "\u2A48": e.MO.BIN4,
            "\u2A49": e.MO.BIN4,
            "\u2A4A": e.MO.BIN4,
            "\u2A4B": e.MO.BIN4,
            "\u2A4C": e.MO.BIN4,
            "\u2A4D": e.MO.BIN4,
            "\u2A4E": e.MO.BIN4,
            "\u2A4F": e.MO.BIN4,
            "\u2A50": e.MO.BIN4,
            "\u2A51": e.MO.BIN4,
            "\u2A52": e.MO.BIN4,
            "\u2A53": e.MO.BIN4,
            "\u2A54": e.MO.BIN4,
            "\u2A55": e.MO.BIN4,
            "\u2A56": e.MO.BIN4,
            "\u2A57": e.MO.BIN4,
            "\u2A58": e.MO.BIN4,
            "\u2A59": e.MO.REL,
            "\u2A5A": e.MO.BIN4,
            "\u2A5B": e.MO.BIN4,
            "\u2A5C": e.MO.BIN4,
            "\u2A5D": e.MO.BIN4,
            "\u2A5E": e.MO.BIN4,
            "\u2A5F": e.MO.BIN4,
            "\u2A60": e.MO.BIN4,
            "\u2A61": e.MO.BIN4,
            "\u2A62": e.MO.BIN4,
            "\u2A63": e.MO.BIN4,
            "\u2A64": e.MO.BIN4,
            "\u2A65": e.MO.BIN4,
            "\u2A66": e.MO.REL,
            "\u2A67": e.MO.REL,
            "\u2A68": e.MO.REL,
            "\u2A69": e.MO.REL,
            "\u2A6A": e.MO.REL,
            "\u2A6B": e.MO.REL,
            "\u2A6C": e.MO.REL,
            "\u2A6D": e.MO.REL,
            "\u2A6E": e.MO.REL,
            "\u2A6F": e.MO.REL,
            "\u2A70": e.MO.REL,
            "\u2A71": e.MO.BIN4,
            "\u2A72": e.MO.BIN4,
            "\u2A73": e.MO.REL,
            "\u2A74": e.MO.REL,
            "\u2A75": e.MO.REL,
            "\u2A76": e.MO.REL,
            "\u2A77": e.MO.REL,
            "\u2A78": e.MO.REL,
            "\u2A79": e.MO.REL,
            "\u2A7A": e.MO.REL,
            "\u2A7B": e.MO.REL,
            "\u2A7C": e.MO.REL,
            "\u2A7D": e.MO.REL,
            "\u2A7D\u0338": e.MO.REL,
            "\u2A7E": e.MO.REL,
            "\u2A7E\u0338": e.MO.REL,
            "\u2A7F": e.MO.REL,
            "\u2A80": e.MO.REL,
            "\u2A81": e.MO.REL,
            "\u2A82": e.MO.REL,
            "\u2A83": e.MO.REL,
            "\u2A84": e.MO.REL,
            "\u2A85": e.MO.REL,
            "\u2A86": e.MO.REL,
            "\u2A87": e.MO.REL,
            "\u2A88": e.MO.REL,
            "\u2A89": e.MO.REL,
            "\u2A8A": e.MO.REL,
            "\u2A8B": e.MO.REL,
            "\u2A8C": e.MO.REL,
            "\u2A8D": e.MO.REL,
            "\u2A8E": e.MO.REL,
            "\u2A8F": e.MO.REL,
            "\u2A90": e.MO.REL,
            "\u2A91": e.MO.REL,
            "\u2A92": e.MO.REL,
            "\u2A93": e.MO.REL,
            "\u2A94": e.MO.REL,
            "\u2A95": e.MO.REL,
            "\u2A96": e.MO.REL,
            "\u2A97": e.MO.REL,
            "\u2A98": e.MO.REL,
            "\u2A99": e.MO.REL,
            "\u2A9A": e.MO.REL,
            "\u2A9B": e.MO.REL,
            "\u2A9C": e.MO.REL,
            "\u2A9D": e.MO.REL,
            "\u2A9E": e.MO.REL,
            "\u2A9F": e.MO.REL,
            "\u2AA0": e.MO.REL,
            "\u2AA1": e.MO.REL,
            "\u2AA1\u0338": e.MO.REL,
            "\u2AA2": e.MO.REL,
            "\u2AA2\u0338": e.MO.REL,
            "\u2AA3": e.MO.REL,
            "\u2AA4": e.MO.REL,
            "\u2AA5": e.MO.REL,
            "\u2AA6": e.MO.REL,
            "\u2AA7": e.MO.REL,
            "\u2AA8": e.MO.REL,
            "\u2AA9": e.MO.REL,
            "\u2AAA": e.MO.REL,
            "\u2AAB": e.MO.REL,
            "\u2AAC": e.MO.REL,
            "\u2AAD": e.MO.REL,
            "\u2AAE": e.MO.REL,
            "\u2AAF": e.MO.REL,
            "\u2AAF\u0338": e.MO.REL,
            "\u2AB0": e.MO.REL,
            "\u2AB0\u0338": e.MO.REL,
            "\u2AB1": e.MO.REL,
            "\u2AB2": e.MO.REL,
            "\u2AB3": e.MO.REL,
            "\u2AB4": e.MO.REL,
            "\u2AB5": e.MO.REL,
            "\u2AB6": e.MO.REL,
            "\u2AB7": e.MO.REL,
            "\u2AB8": e.MO.REL,
            "\u2AB9": e.MO.REL,
            "\u2ABA": e.MO.REL,
            "\u2ABB": e.MO.REL,
            "\u2ABC": e.MO.REL,
            "\u2ABD": e.MO.REL,
            "\u2ABE": e.MO.REL,
            "\u2ABF": e.MO.REL,
            "\u2AC0": e.MO.REL,
            "\u2AC1": e.MO.REL,
            "\u2AC2": e.MO.REL,
            "\u2AC3": e.MO.REL,
            "\u2AC4": e.MO.REL,
            "\u2AC5": e.MO.REL,
            "\u2AC6": e.MO.REL,
            "\u2AC7": e.MO.REL,
            "\u2AC8": e.MO.REL,
            "\u2AC9": e.MO.REL,
            "\u2ACA": e.MO.REL,
            "\u2ACB": e.MO.REL,
            "\u2ACC": e.MO.REL,
            "\u2ACD": e.MO.REL,
            "\u2ACE": e.MO.REL,
            "\u2ACF": e.MO.REL,
            "\u2AD0": e.MO.REL,
            "\u2AD1": e.MO.REL,
            "\u2AD2": e.MO.REL,
            "\u2AD3": e.MO.REL,
            "\u2AD4": e.MO.REL,
            "\u2AD5": e.MO.REL,
            "\u2AD6": e.MO.REL,
            "\u2AD7": e.MO.REL,
            "\u2AD8": e.MO.REL,
            "\u2AD9": e.MO.REL,
            "\u2ADA": e.MO.REL,
            "\u2ADB": e.MO.REL,
            "\u2ADD": e.MO.REL,
            "\u2ADD\u0338": e.MO.REL,
            "\u2ADE": e.MO.REL,
            "\u2ADF": e.MO.REL,
            "\u2AE0": e.MO.REL,
            "\u2AE1": e.MO.REL,
            "\u2AE2": e.MO.REL,
            "\u2AE3": e.MO.REL,
            "\u2AE4": e.MO.REL,
            "\u2AE5": e.MO.REL,
            "\u2AE6": e.MO.REL,
            "\u2AE7": e.MO.REL,
            "\u2AE8": e.MO.REL,
            "\u2AE9": e.MO.REL,
            "\u2AEA": e.MO.REL,
            "\u2AEB": e.MO.REL,
            "\u2AEC": e.MO.REL,
            "\u2AED": e.MO.REL,
            "\u2AEE": e.MO.REL,
            "\u2AEF": e.MO.REL,
            "\u2AF0": e.MO.REL,
            "\u2AF1": e.MO.REL,
            "\u2AF2": e.MO.REL,
            "\u2AF3": e.MO.REL,
            "\u2AF4": e.MO.BIN4,
            "\u2AF5": e.MO.BIN4,
            "\u2AF6": e.MO.BIN4,
            "\u2AF7": e.MO.REL,
            "\u2AF8": e.MO.REL,
            "\u2AF9": e.MO.REL,
            "\u2AFA": e.MO.REL,
            "\u2AFB": e.MO.BIN4,
            "\u2AFD": e.MO.BIN4,
            "\u2AFE": e.MO.BIN3,
            "\u2B45": e.MO.RELSTRETCH,
            "\u2B46": e.MO.RELSTRETCH,
            "\u3008": e.MO.OPEN,
            "\u3009": e.MO.CLOSE,
            "\uFE37": e.MO.WIDEACCENT,
            "\uFE38": e.MO.WIDEACCENT
          }
        }, e.OPTABLE.infix["^"] = e.MO.WIDEREL, e.OPTABLE.infix._ = e.MO.WIDEREL, e.OPTABLE.infix["\u2ADC"] = e.MO.REL;
      },
      9259: function _(t, e, r) {
        var _n43,
          o = this && this.__extends || (_n43 = function n(t, e) {
            return _n43 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n43(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n43(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SerializedMmlVisitor = e.toEntity = e.DATAMJX = void 0;
        var Q = r(6325),
          s = r(9007),
          T = r(450);
        e.DATAMJX = "data-mjx-";
        e.toEntity = function (t) {
          return "&#x" + t.codePointAt(0).toString(16).toUpperCase() + ";";
        };
        var l = function (t) {
          function r() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(r, t), r.prototype.visitTree = function (t) {
            return this.visitNode(t, "");
          }, r.prototype.visitTextNode = function (t, e) {
            return this.quoteHTML(t.getText());
          }, r.prototype.visitXMLNode = function (t, e) {
            return e + t.getSerializedXML();
          }, r.prototype.visitInferredMrowNode = function (t, e) {
            var r,
              n,
              o = [];
            try {
              for (var a = i(t.childNodes), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                o.push(this.visitNode(s, e));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            return o.join("\n");
          }, r.prototype.visitTeXAtomNode = function (t, e) {
            var r = this.childNodeMml(t, e + "  ", "\n");
            return e + "<mrow" + this.getAttributes(t) + ">" + (r.match(/\S/) ? "\n" + r + e : "") + "</mrow>";
          }, r.prototype.visitAnnotationNode = function (t, e) {
            return e + "<annotation" + this.getAttributes(t) + ">" + this.childNodeMml(t, "", "") + "</annotation>";
          }, r.prototype.visitDefault = function (t, e) {
            var r = t.kind,
              n = a(t.isToken || 0 === t.childNodes.length ? ["", ""] : ["\n", e], 2),
              o = n[0],
              i = n[1],
              Q = this.childNodeMml(t, e + "  ", o);
            return e + "<" + r + this.getAttributes(t) + ">" + (Q.match(/\S/) ? o + Q + i : "") + "</" + r + ">";
          }, r.prototype.childNodeMml = function (t, e, r) {
            var n,
              o,
              a = "";
            try {
              for (var Q = i(t.childNodes), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                a += this.visitNode(T, e) + r;
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (o = Q.return) && o.call(Q);
              } finally {
                if (n) throw n.error;
              }
            }
            return a;
          }, r.prototype.getAttributes = function (t) {
            var e,
              r,
              n = [],
              o = this.constructor.defaultAttributes[t.kind] || {},
              a = Object.assign({}, o, this.getDataAttributes(t), t.attributes.getAllAttributes()),
              Q = this.constructor.variants;
            a.hasOwnProperty("mathvariant") && Q.hasOwnProperty(a.mathvariant) && (a.mathvariant = Q[a.mathvariant]);
            try {
              for (var s = i(Object.keys(a)), T = s.next(); !T.done; T = s.next()) {
                var l = T.value,
                  c = String(a[l]);
                void 0 !== c && n.push(l + '="' + this.quoteHTML(c) + '"');
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (r = s.return) && r.call(s);
              } finally {
                if (e) throw e.error;
              }
            }
            return n.length ? " " + n.join(" ") : "";
          }, r.prototype.getDataAttributes = function (t) {
            var e = {},
              r = t.attributes.getExplicit("mathvariant"),
              n = this.constructor.variants;
            r && n.hasOwnProperty(r) && this.setDataAttribute(e, "variant", r), t.getProperty("variantForm") && this.setDataAttribute(e, "alternate", "1"), t.getProperty("pseudoscript") && this.setDataAttribute(e, "pseudoscript", "true"), !1 === t.getProperty("autoOP") && this.setDataAttribute(e, "auto-op", "false");
            var o = t.getProperty("scriptalign");
            o && this.setDataAttribute(e, "script-align", o);
            var i = t.getProperty("texClass");
            if (void 0 !== i) {
              var a = !0;
              if (i === s.TEXCLASS.OP && t.isKind("mi")) {
                var Q = t.getText();
                a = !(Q.length > 1 && Q.match(T.MmlMi.operatorName));
              }
              a && this.setDataAttribute(e, "texclass", i < 0 ? "NONE" : s.TEXCLASSNAMES[i]);
            }
            return t.getProperty("scriptlevel") && !1 === t.getProperty("useHeight") && this.setDataAttribute(e, "smallmatrix", "true"), e;
          }, r.prototype.setDataAttribute = function (t, r, n) {
            t[e.DATAMJX + r] = n;
          }, r.prototype.quoteHTML = function (t) {
            return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/[\uD800-\uDBFF]./g, e.toEntity).replace(/[\u0080-\uD7FF\uE000-\uFFFF]/g, e.toEntity);
          }, r.variants = {
            "-tex-calligraphic": "script",
            "-tex-bold-calligraphic": "bold-script",
            "-tex-oldstyle": "normal",
            "-tex-bold-oldstyle": "bold",
            "-tex-mathit": "italic"
          }, r.defaultAttributes = {
            math: {
              xmlns: "http://www.w3.org/1998/Math/MathML"
            }
          }, r;
        }(Q.MmlVisitor);
        e.SerializedMmlVisitor = l;
      },
      2975: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractOutputJax = void 0;
        var n = r(7233),
          o = r(7525),
          i = function () {
            function t(t) {
              void 0 === t && (t = {}), this.adaptor = null;
              var e = this.constructor;
              this.options = (0, n.userOptions)((0, n.defaultOptions)({}, e.OPTIONS), t), this.postFilters = new o.FunctionList();
            }
            return Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this.constructor.NAME;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.setAdaptor = function (t) {
              this.adaptor = t;
            }, t.prototype.initialize = function () {}, t.prototype.reset = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            }, t.prototype.getMetrics = function (t) {}, t.prototype.styleSheet = function (t) {
              return null;
            }, t.prototype.pageElements = function (t) {
              return null;
            }, t.prototype.executeFilters = function (t, e, r, n) {
              var o = {
                math: e,
                document: r,
                data: n
              };
              return t.execute(o), o.data;
            }, t.NAME = "generic", t.OPTIONS = {}, t;
          }();
        e.AbstractOutputJax = i;
      },
      4574: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractFactory = void 0;
        var i = function () {
          function t(t) {
            var e, n;
            void 0 === t && (t = null), this.defaultKind = "unknown", this.nodeMap = new Map(), this.node = {}, null === t && (t = this.constructor.defaultNodes);
            try {
              for (var o = r(Object.keys(t)), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.setNodeClass(a, t[a]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }
          return t.prototype.create = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            return (this.node[t] || this.node[this.defaultKind]).apply(void 0, o([], n(e), !1));
          }, t.prototype.setNodeClass = function (t, e) {
            this.nodeMap.set(t, e);
            var r = this,
              i = this.nodeMap.get(t);
            this.node[t] = function () {
              for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
              return new (i.bind.apply(i, o([void 0, r], n(t), !1)))();
            };
          }, t.prototype.getNodeClass = function (t) {
            return this.nodeMap.get(t);
          }, t.prototype.deleteNodeClass = function (t) {
            this.nodeMap.delete(t), delete this.node[t];
          }, t.prototype.nodeIsKind = function (t, e) {
            return t instanceof this.getNodeClass(e);
          }, t.prototype.getKinds = function () {
            return Array.from(this.nodeMap.keys());
          }, t.defaultNodes = {}, t;
        }();
        e.AbstractFactory = i;
      },
      4596: function _(t, e) {
        var _r2,
          n = this && this.__extends || (_r2 = function r(t, e) {
            return _r2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r2(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r2(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__assign || function () {
            return o = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, o.apply(this, arguments);
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEmptyNode = e.AbstractNode = void 0;
        var a = function () {
          function t(t, e, r) {
            var n, o;
            void 0 === e && (e = {}), void 0 === r && (r = []), this.factory = t, this.parent = null, this.properties = {}, this.childNodes = [];
            try {
              for (var a = i(Object.keys(e)), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                this.setProperty(s, e[s]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
            r.length && this.setChildren(r);
          }
          return Object.defineProperty(t.prototype, "kind", {
            get: function get() {
              return "unknown";
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.setProperty = function (t, e) {
            this.properties[t] = e;
          }, t.prototype.getProperty = function (t) {
            return this.properties[t];
          }, t.prototype.getPropertyNames = function () {
            return Object.keys(this.properties);
          }, t.prototype.getAllProperties = function () {
            return this.properties;
          }, t.prototype.removeProperty = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value;
                delete this.properties[Q];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.isKind = function (t) {
            return this.factory.nodeIsKind(this, t);
          }, t.prototype.setChildren = function (t) {
            var e, r;
            this.childNodes = [];
            try {
              for (var n = i(t), o = n.next(); !o.done; o = n.next()) {
                var a = o.value;
                this.appendChild(a);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.appendChild = function (t) {
            return this.childNodes.push(t), t.parent = this, t;
          }, t.prototype.replaceChild = function (t, e) {
            var r = this.childIndex(e);
            return null !== r && (this.childNodes[r] = t, t.parent = this, e.parent = null), t;
          }, t.prototype.removeChild = function (t) {
            var e = this.childIndex(t);
            return null !== e && (this.childNodes.splice(e, 1), t.parent = null), t;
          }, t.prototype.childIndex = function (t) {
            var e = this.childNodes.indexOf(t);
            return -1 === e ? null : e;
          }, t.prototype.copy = function () {
            var t,
              e,
              r = this.factory.create(this.kind);
            r.properties = o({}, this.properties);
            try {
              for (var n = i(this.childNodes || []), a = n.next(); !a.done; a = n.next()) {
                var Q = a.value;
                Q && r.appendChild(Q.copy());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, t.prototype.findNodes = function (t) {
            var e = [];
            return this.walkTree(function (r) {
              r.isKind(t) && e.push(r);
            }), e;
          }, t.prototype.walkTree = function (t, e) {
            var r, n;
            t(this, e);
            try {
              for (var o = i(this.childNodes), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value;
                Q && Q.walkTree(t, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            return e;
          }, t.prototype.toString = function () {
            return this.kind + "(" + this.childNodes.join(",") + ")";
          }, t;
        }();
        e.AbstractNode = a;
        var Q = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return n(e, t), e.prototype.setChildren = function (t) {}, e.prototype.appendChild = function (t) {
            return t;
          }, e.prototype.replaceChild = function (t, e) {
            return e;
          }, e.prototype.childIndex = function (t) {
            return null;
          }, e.prototype.walkTree = function (t, e) {
            return t(this, e), e;
          }, e.prototype.toString = function () {
            return this.kind;
          }, e;
        }(a);
        e.AbstractEmptyNode = Q;
      },
      7860: function _(t, e, r) {
        var _n44,
          o = this && this.__extends || (_n44 = function n(t, e) {
            return _n44 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n44(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n44(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractNodeFactory = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.create = function (t, e, r) {
            return void 0 === e && (e = {}), void 0 === r && (r = []), this.node[t](e, r);
          }, e;
        }(r(4574).AbstractFactory);
        e.AbstractNodeFactory = i;
      },
      8823: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractVisitor = void 0;
        var a = r(4596),
          Q = function () {
            function t(e) {
              var r, o;
              this.nodeHandlers = new Map();
              try {
                for (var i = n(e.getKinds()), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value,
                    s = this[t.methodName(Q)];
                  s && this.nodeHandlers.set(Q, s);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (o = i.return) && o.call(i);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            return t.methodName = function (t) {
              return "visit" + (t.charAt(0).toUpperCase() + t.substr(1)).replace(/[^a-z0-9_]/gi, "_") + "Node";
            }, t.prototype.visitTree = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              return this.visitNode.apply(this, i([t], o(e), !1));
            }, t.prototype.visitNode = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var n = this.nodeHandlers.get(t.kind) || this.visitDefault;
              return n.call.apply(n, i([this, t], o(e), !1));
            }, t.prototype.visitDefault = function (t) {
              for (var e, r, Q = [], s = 1; s < arguments.length; s++) Q[s - 1] = arguments[s];
              if (t instanceof a.AbstractNode) try {
                for (var T = n(t.childNodes), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value;
                  this.visitNode.apply(this, i([c], o(Q), !1));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (r = T.return) && r.call(T);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.setNodeHandler = function (t, e) {
              this.nodeHandlers.set(t, e);
            }, t.prototype.removeNodeHandler = function (t) {
              this.nodeHandlers.delete(t);
            }, t;
          }();
        e.AbstractVisitor = Q;
      },
      8912: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWrapper = void 0;
        var r = function () {
          function t(t, e) {
            this.factory = t, this.node = e;
          }
          return Object.defineProperty(t.prototype, "kind", {
            get: function get() {
              return this.node.kind;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.wrap = function (t) {
            return this.factory.wrap(t);
          }, t;
        }();
        e.AbstractWrapper = r;
      },
      3811: function _(t, e, r) {
        var _n45,
          o = this && this.__extends || (_n45 = function n(t, e) {
            return _n45 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n45(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n45(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWrapperFactory = void 0;
        var Q = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.wrap = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            return this.create.apply(this, a([t.kind, t], i(e), !1));
          }, e;
        }(r(4574).AbstractFactory);
        e.AbstractWrapperFactory = Q;
      },
      6272: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RegisterHTMLHandler = void 0;
        var n = r(5713),
          o = r(3726);
        e.RegisterHTMLHandler = function (t) {
          var e = new o.HTMLHandler(t);
          return n.mathjax.handlers.register(e), e;
        };
      },
      3683: function _(t, e, r) {
        var _n46,
          o = this && this.__extends || (_n46 = function n(t, e) {
            return _n46 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n46(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n46(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLDocument = void 0;
        var s = r(5722),
          T = r(7233),
          l = r(3363),
          c = r(3335),
          u = r(5138),
          p = r(4474),
          h = function (t) {
            function e(e, r, n) {
              var o = this,
                i = a((0, T.separateOptions)(n, u.HTMLDomStrings.OPTIONS), 2),
                Q = i[0],
                s = i[1];
              return (o = t.call(this, e, r, Q) || this).domStrings = o.options.DomStrings || new u.HTMLDomStrings(s), o.domStrings.adaptor = r, o.styles = [], o;
            }
            return o(e, t), e.prototype.findPosition = function (t, e, r, n) {
              var o,
                i,
                s = this.adaptor;
              try {
                for (var T = Q(n[t]), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value,
                    u = a(c, 2),
                    p = u[0],
                    h = u[1];
                  if (e <= h && "#text" === s.kind(p)) return {
                    node: p,
                    n: Math.max(e, 0),
                    delim: r
                  };
                  e -= h;
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  l && !l.done && (i = T.return) && i.call(T);
                } finally {
                  if (o) throw o.error;
                }
              }
              return {
                node: null,
                n: 0,
                delim: r
              };
            }, e.prototype.mathItem = function (t, e, r) {
              var n = t.math,
                o = this.findPosition(t.n, t.start.n, t.open, r),
                i = this.findPosition(t.n, t.end.n, t.close, r);
              return new this.options.MathItem(n, e, t.display, o, i);
            }, e.prototype.findMath = function (t) {
              var e, r, n, o, i, s, l, c, u;
              if (!this.processed.isSet("findMath")) {
                this.adaptor.document = this.document, t = (0, T.userOptions)({
                  elements: this.options.elements || [this.adaptor.body(this.document)]
                }, t);
                try {
                  for (var p = Q(this.adaptor.getElements(t.elements, this.document)), h = p.next(); !h.done; h = p.next()) {
                    var d = h.value,
                      f = a([null, null], 2),
                      m = f[0],
                      L = f[1];
                    try {
                      for (var y = (n = void 0, Q(this.inputJax)), g = y.next(); !g.done; g = y.next()) {
                        var v = g.value,
                          b = new this.options.MathList();
                        if (v.processStrings) {
                          null === m && (m = (i = a(this.domStrings.find(d), 2))[0], L = i[1]);
                          try {
                            for (var H = (s = void 0, Q(v.findMath(m))), _ = H.next(); !_.done; _ = H.next()) {
                              var M = _.value;
                              b.push(this.mathItem(M, v, L));
                            }
                          } catch (t) {
                            s = {
                              error: t
                            };
                          } finally {
                            try {
                              _ && !_.done && (l = H.return) && l.call(H);
                            } finally {
                              if (s) throw s.error;
                            }
                          }
                        } else try {
                          for (var x = (c = void 0, Q(v.findMath(d))), O = x.next(); !O.done; O = x.next()) {
                            M = O.value;
                            var S = new this.options.MathItem(M.math, v, M.display, M.start, M.end);
                            b.push(S);
                          }
                        } catch (t) {
                          c = {
                            error: t
                          };
                        } finally {
                          try {
                            O && !O.done && (u = x.return) && u.call(x);
                          } finally {
                            if (c) throw c.error;
                          }
                        }
                        this.math.merge(b);
                      }
                    } catch (t) {
                      n = {
                        error: t
                      };
                    } finally {
                      try {
                        g && !g.done && (o = y.return) && o.call(y);
                      } finally {
                        if (n) throw n.error;
                      }
                    }
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    h && !h.done && (r = p.return) && r.call(p);
                  } finally {
                    if (e) throw e.error;
                  }
                }
                this.processed.set("findMath");
              }
              return this;
            }, e.prototype.updateDocument = function () {
              return this.processed.isSet("updateDocument") || (this.addPageElements(), this.addStyleSheet(), t.prototype.updateDocument.call(this), this.processed.set("updateDocument")), this;
            }, e.prototype.addPageElements = function () {
              var t = this.adaptor.body(this.document),
                e = this.documentPageElements();
              e && this.adaptor.append(t, e);
            }, e.prototype.addStyleSheet = function () {
              var t = this.documentStyleSheet(),
                e = this.adaptor;
              if (t && !e.parent(t)) {
                var r = e.head(this.document),
                  n = this.findSheet(r, e.getAttribute(t, "id"));
                n ? e.replace(t, n) : e.append(r, t);
              }
            }, e.prototype.findSheet = function (t, e) {
              var r, n;
              if (e) try {
                for (var o = Q(this.adaptor.tags(t, "style")), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  if (this.adaptor.getAttribute(a, "id") === e) return a;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return null;
            }, e.prototype.removeFromDocument = function (t) {
              var e, r;
              if (void 0 === t && (t = !1), this.processed.isSet("updateDocument")) try {
                for (var n = Q(this.math), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  i.state() >= p.STATE.INSERTED && i.state(p.STATE.TYPESET, t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.processed.clear("updateDocument"), this;
            }, e.prototype.documentStyleSheet = function () {
              return this.outputJax.styleSheet(this);
            }, e.prototype.documentPageElements = function () {
              return this.outputJax.pageElements(this);
            }, e.prototype.addStyles = function (t) {
              this.styles.push(t);
            }, e.prototype.getStyles = function () {
              return this.styles;
            }, e.KIND = "HTML", e.OPTIONS = i(i({}, s.AbstractMathDocument.OPTIONS), {
              renderActions: (0, T.expandable)(i(i({}, s.AbstractMathDocument.OPTIONS.renderActions), {
                styles: [p.STATE.INSERTED + 1, "", "updateStyleSheet", !1]
              })),
              MathList: c.HTMLMathList,
              MathItem: l.HTMLMathItem,
              DomStrings: null
            }), e;
          }(s.AbstractMathDocument);
        e.HTMLDocument = h;
      },
      5138: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
            o,
            i = r.call(t),
            a = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLDomStrings = void 0;
        var o = r(7233),
          i = function () {
            function t(t) {
              void 0 === t && (t = null);
              var e = this.constructor;
              this.options = (0, o.userOptions)((0, o.defaultOptions)({}, e.OPTIONS), t), this.init(), this.getPatterns();
            }
            return t.prototype.init = function () {
              this.strings = [], this.string = "", this.snodes = [], this.nodes = [], this.stack = [];
            }, t.prototype.getPatterns = function () {
              var t = (0, o.makeArray)(this.options.skipHtmlTags),
                e = (0, o.makeArray)(this.options.ignoreHtmlClass),
                r = (0, o.makeArray)(this.options.processHtmlClass);
              this.skipHtmlTags = new RegExp("^(?:" + t.join("|") + ")$", "i"), this.ignoreHtmlClass = new RegExp("(?:^| )(?:" + e.join("|") + ")(?: |$)"), this.processHtmlClass = new RegExp("(?:^| )(?:" + r + ")(?: |$)");
            }, t.prototype.pushString = function () {
              this.string.match(/\S/) && (this.strings.push(this.string), this.nodes.push(this.snodes)), this.string = "", this.snodes = [];
            }, t.prototype.extendString = function (t, e) {
              this.snodes.push([t, e.length]), this.string += e;
            }, t.prototype.handleText = function (t, e) {
              return e || this.extendString(t, this.adaptor.value(t)), this.adaptor.next(t);
            }, t.prototype.handleTag = function (t, e) {
              if (!e) {
                var r = this.options.includeHtmlTags[this.adaptor.kind(t)];
                this.extendString(t, r);
              }
              return this.adaptor.next(t);
            }, t.prototype.handleContainer = function (t, e) {
              this.pushString();
              var r = this.adaptor.getAttribute(t, "class") || "",
                n = this.adaptor.kind(t) || "",
                o = this.processHtmlClass.exec(r),
                i = t;
              return !this.adaptor.firstChild(t) || this.adaptor.getAttribute(t, "data-MJX") || !o && this.skipHtmlTags.exec(n) ? i = this.adaptor.next(t) : (this.adaptor.next(t) && this.stack.push([this.adaptor.next(t), e]), i = this.adaptor.firstChild(t), e = (e || this.ignoreHtmlClass.exec(r)) && !o), [i, e];
            }, t.prototype.handleOther = function (t, e) {
              return this.pushString(), this.adaptor.next(t);
            }, t.prototype.find = function (t) {
              var e, r;
              this.init();
              for (var o = this.adaptor.next(t), i = !1, a = this.options.includeHtmlTags; t && t !== o;) {
                var Q = this.adaptor.kind(t);
                "#text" === Q ? t = this.handleText(t, i) : a.hasOwnProperty(Q) ? t = this.handleTag(t, i) : Q ? (t = (e = n(this.handleContainer(t, i), 2))[0], i = e[1]) : t = this.handleOther(t, i), !t && this.stack.length && (this.pushString(), t = (r = n(this.stack.pop(), 2))[0], i = r[1]);
              }
              this.pushString();
              var s = [this.strings, this.nodes];
              return this.init(), s;
            }, t.OPTIONS = {
              skipHtmlTags: ["script", "noscript", "style", "textarea", "pre", "code", "annotation", "annotation-xml"],
              includeHtmlTags: {
                br: "\n",
                wbr: "",
                "#comment": ""
              },
              ignoreHtmlClass: "mathjax_ignore",
              processHtmlClass: "mathjax_process"
            }, t;
          }();
        e.HTMLDomStrings = i;
      },
      3726: function _(t, e, r) {
        var _n47,
          o = this && this.__extends || (_n47 = function n(t, e) {
            return _n47 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n47(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n47(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLHandler = void 0;
        var i = r(3670),
          a = r(3683),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.documentClass = a.HTMLDocument, e;
            }
            return o(e, t), e.prototype.handlesDocument = function (t) {
              var e = this.adaptor;
              if ("string" == typeof t) try {
                t = e.parse(t, "text/html");
              } catch (t) {}
              return t instanceof e.window.Document || t instanceof e.window.HTMLElement || t instanceof e.window.DocumentFragment;
            }, e.prototype.create = function (e, r) {
              var n = this.adaptor;
              if ("string" == typeof e) e = n.parse(e, "text/html");else if (e instanceof n.window.HTMLElement || e instanceof n.window.DocumentFragment) {
                var o = e;
                e = n.parse("", "text/html"), n.append(n.body(e), o);
              }
              return t.prototype.create.call(this, e, r);
            }, e;
          }(i.AbstractHandler);
        e.HTMLHandler = Q;
      },
      3363: function _(t, e, r) {
        var _n48,
          o = this && this.__extends || (_n48 = function n(t, e) {
            return _n48 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n48(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n48(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLMathItem = void 0;
        var i = r(4474),
          a = function (t) {
            function e(e, r, n, o, i) {
              return void 0 === n && (n = !0), void 0 === o && (o = {
                node: null,
                n: 0,
                delim: ""
              }), void 0 === i && (i = {
                node: null,
                n: 0,
                delim: ""
              }), t.call(this, e, r, n, o, i) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "adaptor", {
              get: function get() {
                return this.inputJax.adaptor;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.updateDocument = function (t) {
              if (this.state() < i.STATE.INSERTED) {
                if (this.inputJax.processStrings) {
                  var e = this.start.node;
                  if (e === this.end.node) this.end.n && this.end.n < this.adaptor.value(this.end.node).length && this.adaptor.split(this.end.node, this.end.n), this.start.n && (e = this.adaptor.split(this.start.node, this.start.n)), this.adaptor.replace(this.typesetRoot, e);else {
                    for (this.start.n && (e = this.adaptor.split(e, this.start.n)); e !== this.end.node;) {
                      var r = this.adaptor.next(e);
                      this.adaptor.remove(e), e = r;
                    }
                    this.adaptor.insert(this.typesetRoot, e), this.end.n < this.adaptor.value(e).length && this.adaptor.split(e, this.end.n), this.adaptor.remove(e);
                  }
                } else this.adaptor.replace(this.typesetRoot, this.start.node);
                this.start.node = this.end.node = this.typesetRoot, this.start.n = this.end.n = 0, this.state(i.STATE.INSERTED);
              }
            }, e.prototype.updateStyleSheet = function (t) {
              t.addStyleSheet();
            }, e.prototype.removeFromDocument = function (t) {
              if (void 0 === t && (t = !1), this.state() >= i.STATE.TYPESET) {
                var e = this.adaptor,
                  r = this.start.node,
                  n = e.text("");
                if (t) {
                  var o = this.start.delim + this.math + this.end.delim;
                  if (this.inputJax.processStrings) n = e.text(o);else {
                    var a = e.parse(o, "text/html");
                    n = e.firstChild(e.body(a));
                  }
                }
                e.parent(r) && e.replace(n, r), this.start.node = this.end.node = n, this.start.n = this.end.n = 0;
              }
            }, e;
          }(i.AbstractMathItem);
        e.HTMLMathItem = a;
      },
      3335: function _(t, e, r) {
        var _n49,
          o = this && this.__extends || (_n49 = function n(t, e) {
            return _n49 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n49(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n49(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HTMLMathList = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e;
        }(r(9e3).AbstractMathList);
        e.HTMLMathList = i;
      },
      8462: function _(t, e, r) {
        var _n50,
          o = this && this.__extends || (_n50 = function n(t, e) {
            return _n50 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n50(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n50(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeX = void 0;
        var s = r(9206),
          T = r(7233),
          l = r(7073),
          c = Q(r(4676)),
          u = Q(r(1256)),
          p = Q(r(8417)),
          h = Q(r(3971)),
          d = Q(r(8562)),
          f = r(6521),
          m = r(9899);
        r(2942);
        var L = function (t) {
          function e(r) {
            void 0 === r && (r = {});
            var n = this,
              o = a((0, T.separateOptions)(r, e.OPTIONS, l.FindTeX.OPTIONS), 3),
              i = o[0],
              Q = o[1],
              s = o[2];
            (n = t.call(this, Q) || this).findTeX = n.options.FindTeX || new l.FindTeX(s);
            var u = n.options.packages,
              p = n.configuration = e.configure(u),
              h = n._parseOptions = new d.default(p, [n.options, f.TagsFactory.OPTIONS]);
            return (0, T.userOptions)(h.options, i), p.config(n), e.tags(h, p), n.postFilters.add(c.default.cleanSubSup, -6), n.postFilters.add(c.default.setInherited, -5), n.postFilters.add(c.default.moveLimits, -4), n.postFilters.add(c.default.cleanStretchy, -3), n.postFilters.add(c.default.cleanAttributes, -2), n.postFilters.add(c.default.combineRelations, -1), n;
          }
          return o(e, t), e.configure = function (t) {
            var e = new m.ParserConfiguration(t, ["tex"]);
            return e.init(), e;
          }, e.tags = function (t, e) {
            f.TagsFactory.addTags(e.tags), f.TagsFactory.setDefault(t.options.tags), t.tags = f.TagsFactory.getDefault(), t.tags.configuration = t;
          }, e.prototype.setMmlFactory = function (e) {
            t.prototype.setMmlFactory.call(this, e), this._parseOptions.nodeFactory.setMmlFactory(e);
          }, Object.defineProperty(e.prototype, "parseOptions", {
            get: function get() {
              return this._parseOptions;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.reset = function (t) {
            void 0 === t && (t = 0), this.parseOptions.tags.reset(t);
          }, e.prototype.compile = function (t, e) {
            this.parseOptions.clear(), this.executeFilters(this.preFilters, t, e, this.parseOptions);
            var r,
              n,
              o = t.display;
            this.latex = t.math, this.parseOptions.tags.startEquation(t);
            try {
              var i = new p.default(this.latex, {
                display: o,
                isInner: !1
              }, this.parseOptions);
              r = i.mml(), n = i.stack.global;
            } catch (t) {
              if (!(t instanceof h.default)) throw t;
              this.parseOptions.error = !0, r = this.options.formatError(this, t);
            }
            return r = this.parseOptions.nodeFactory.create("node", "math", [r]), (null == n ? void 0 : n.indentalign) && u.default.setAttribute(r, "indentalign", n.indentalign), o && u.default.setAttribute(r, "display", "block"), this.parseOptions.tags.finishEquation(t), this.parseOptions.root = r, this.executeFilters(this.postFilters, t, e, this.parseOptions), this.mathNode = this.parseOptions.root, this.mathNode;
          }, e.prototype.findMath = function (t) {
            return this.findTeX.findMath(t);
          }, e.prototype.formatError = function (t) {
            var e = t.message.replace(/\n.*/, "");
            return this.parseOptions.nodeFactory.create("error", e, t.id, this.latex);
          }, e.NAME = "TeX", e.OPTIONS = i(i({}, s.AbstractInputJax.OPTIONS), {
            FindTeX: null,
            packages: ["base"],
            digits: /^(?:[0-9]+(?:\{,\}[0-9]{3})*(?:\.[0-9]*)?|\.[0-9]+)/,
            maxBuffer: 5120,
            formatError: function formatError(t, e) {
              return t.formatError(e);
            }
          }), e;
        }(s.AbstractInputJax);
        e.TeX = L;
      },
      210: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AllPackages = void 0, r(2942), r(8174), r(8021), r(583), r(1186), r(8603), r(6538), r(9499), r(8963), r(3752), r(8227), r(5860), r(6628), r(6648), r(8458), r(5464), r(1428), r(6121), r(3078), r(8901), r(7535), r(6944), r(1496), r(4234), r(4898), r(3168), r(9365), r(1527), r(2307), r(2675), r(1442), r(6841), r(1247), "undefined" != typeof MathJax && MathJax.loader && MathJax.loader.preLoad("[tex]/action", "[tex]/ams", "[tex]/amscd", "[tex]/bbox", "[tex]/boldsymbol", "[tex]/braket", "[tex]/bussproofs", "[tex]/cancel", "[tex]/cases", "[tex]/centernot", "[tex]/color", "[tex]/colorv2", "[tex]/colortbl", "[tex]/empheq", "[tex]/enclose", "[tex]/extpfeil", "[tex]/gensymb", "[tex]/html", "[tex]/mathtools", "[tex]/mhchem", "[tex]/newcommand", "[tex]/noerrors", "[tex]/noundefined", "[tex]/physics", "[tex]/upgreek", "[tex]/unicode", "[tex]/verb", "[tex]/configmacros", "[tex]/tagformat", "[tex]/textcomp", "[tex]/textmacros", "[tex]/setoptions"), e.AllPackages = ["base", "action", "ams", "amscd", "bbox", "boldsymbol", "braket", "bussproofs", "cancel", "cases", "centernot", "color", "colortbl", "empheq", "enclose", "extpfeil", "gensymb", "html", "mathtools", "mhchem", "newcommand", "noerrors", "noundefined", "upgreek", "unicode", "verb", "configmacros", "tagformat", "textcomp", "textmacros"];
      },
      9899: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ParserConfiguration = e.ConfigurationHandler = e.Configuration = void 0;
        var i,
          a = r(7233),
          Q = r(2947),
          s = r(7525),
          T = r(8666),
          l = r(6521),
          c = function () {
            function t(t, e, r, n, o, i, a, Q, s, T, l, c, u) {
              void 0 === e && (e = {}), void 0 === r && (r = {}), void 0 === n && (n = {}), void 0 === o && (o = {}), void 0 === i && (i = {}), void 0 === a && (a = {}), void 0 === Q && (Q = []), void 0 === s && (s = []), void 0 === T && (T = null), void 0 === l && (l = null), this.name = t, this.handler = e, this.fallback = r, this.items = n, this.tags = o, this.options = i, this.nodes = a, this.preprocessors = Q, this.postprocessors = s, this.initMethod = T, this.configMethod = l, this.priority = c, this.parser = u, this.handler = Object.assign({
                character: [],
                delimiter: [],
                macro: [],
                environment: []
              }, e);
            }
            return t.makeProcessor = function (t, e) {
              return Array.isArray(t) ? t : [t, e];
            }, t._create = function (e, r) {
              var n = this;
              void 0 === r && (r = {});
              var o = r.priority || T.PrioritizedList.DEFAULTPRIORITY,
                i = r.init ? this.makeProcessor(r.init, o) : null,
                a = r.config ? this.makeProcessor(r.config, o) : null,
                Q = (r.preprocessors || []).map(function (t) {
                  return n.makeProcessor(t, o);
                }),
                s = (r.postprocessors || []).map(function (t) {
                  return n.makeProcessor(t, o);
                }),
                l = r.parser || "tex";
              return new t(e, r.handler || {}, r.fallback || {}, r.items || {}, r.tags || {}, r.options || {}, r.nodes || {}, Q, s, i, a, o, l);
            }, t.create = function (e, r) {
              void 0 === r && (r = {});
              var n = t._create(e, r);
              return i.set(e, n), n;
            }, t.local = function (e) {
              return void 0 === e && (e = {}), t._create("", e);
            }, Object.defineProperty(t.prototype, "init", {
              get: function get() {
                return this.initMethod ? this.initMethod[0] : null;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "config", {
              get: function get() {
                return this.configMethod ? this.configMethod[0] : null;
              },
              enumerable: !1,
              configurable: !0
            }), t;
          }();
        e.Configuration = c, function (t) {
          var e = new Map();
          t.set = function (t, r) {
            e.set(t, r);
          }, t.get = function (t) {
            return e.get(t);
          }, t.keys = function () {
            return e.keys();
          };
        }(i = e.ConfigurationHandler || (e.ConfigurationHandler = {}));
        var u = function () {
          function t(t, e) {
            var r, o, i, a;
            void 0 === e && (e = ["tex"]), this.initMethod = new s.FunctionList(), this.configMethod = new s.FunctionList(), this.configurations = new T.PrioritizedList(), this.parsers = [], this.handlers = new Q.SubHandlers(), this.items = {}, this.tags = {}, this.options = {}, this.nodes = {}, this.parsers = e;
            try {
              for (var l = n(t.slice().reverse()), c = l.next(); !c.done; c = l.next()) {
                var u = c.value;
                this.addPackage(u);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (o = l.return) && o.call(l);
              } finally {
                if (r) throw r.error;
              }
            }
            try {
              for (var p = n(this.configurations), h = p.next(); !h.done; h = p.next()) {
                var d = h.value,
                  f = d.item,
                  m = d.priority;
                this.append(f, m);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (a = p.return) && a.call(p);
              } finally {
                if (i) throw i.error;
              }
            }
          }
          return t.prototype.init = function () {
            this.initMethod.execute(this);
          }, t.prototype.config = function (t) {
            var e, r;
            this.configMethod.execute(this, t);
            try {
              for (var o = n(this.configurations), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.addFilters(t, a.item);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.addPackage = function (t) {
            var e = "string" == typeof t ? t : t[0],
              r = this.getPackage(e);
            r && this.configurations.add(r, "string" == typeof t ? r.priority : t[1]);
          }, t.prototype.add = function (t, e, r) {
            var o, i;
            void 0 === r && (r = {});
            var Q = this.getPackage(t);
            this.append(Q), this.configurations.add(Q, Q.priority), this.init();
            var s = e.parseOptions;
            s.nodeFactory.setCreators(Q.nodes);
            try {
              for (var T = n(Object.keys(Q.items)), c = T.next(); !c.done; c = T.next()) {
                var u = c.value;
                s.itemFactory.setNodeClass(u, Q.items[u]);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (i = T.return) && i.call(T);
              } finally {
                if (o) throw o.error;
              }
            }
            l.TagsFactory.addTags(Q.tags), (0, a.defaultOptions)(s.options, Q.options), (0, a.userOptions)(s.options, r), this.addFilters(e, Q), Q.config && Q.config(this, e);
          }, t.prototype.getPackage = function (t) {
            var e = i.get(t);
            if (e && this.parsers.indexOf(e.parser) < 0) throw Error("Package ".concat(t, " doesn't target the proper parser"));
            return e;
          }, t.prototype.append = function (t, e) {
            e = e || t.priority, t.initMethod && this.initMethod.add(t.initMethod[0], t.initMethod[1]), t.configMethod && this.configMethod.add(t.configMethod[0], t.configMethod[1]), this.handlers.add(t.handler, t.fallback, e), Object.assign(this.items, t.items), Object.assign(this.tags, t.tags), (0, a.defaultOptions)(this.options, t.options), Object.assign(this.nodes, t.nodes);
          }, t.prototype.addFilters = function (t, e) {
            var r, i, a, Q;
            try {
              for (var s = n(e.preprocessors), T = s.next(); !T.done; T = s.next()) {
                var l = o(T.value, 2),
                  c = l[0],
                  u = l[1];
                t.preFilters.add(c, u);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (i = s.return) && i.call(s);
              } finally {
                if (r) throw r.error;
              }
            }
            try {
              for (var p = n(e.postprocessors), h = p.next(); !h.done; h = p.next()) {
                var d = o(h.value, 2),
                  f = d[0];
                u = d[1];
                t.postFilters.add(f, u);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                h && !h.done && (Q = p.return) && Q.call(p);
              } finally {
                if (a) throw a.error;
              }
            }
          }, t;
        }();
        e.ParserConfiguration = u;
      },
      4676: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i,
          a = r(9007),
          Q = o(r(1256));
        !function (t) {
          t.cleanStretchy = function (t) {
            var e,
              r,
              o = t.data;
            try {
              for (var i = n(o.getList("fixStretchy")), a = i.next(); !a.done; a = i.next()) {
                var s = a.value;
                if (Q.default.getProperty(s, "fixStretchy")) {
                  var T = Q.default.getForm(s);
                  T && T[3] && T[3].stretchy && Q.default.setAttribute(s, "stretchy", !1);
                  var l = s.parent;
                  if (!(Q.default.getTexClass(s) || T && T[2])) {
                    var c = o.nodeFactory.create("node", "TeXAtom", [s]);
                    l.replaceChild(c, s), c.inheritAttributesFrom(s);
                  }
                  Q.default.removeProperties(s, "fixStretchy");
                }
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.cleanAttributes = function (t) {
            t.data.root.walkTree(function (t, e) {
              var r,
                o,
                i = t.attributes;
              if (i) {
                var a = new Set((i.get("mjx-keep-attrs") || "").split(/ /));
                delete i.getAllAttributes()["mjx-keep-attrs"];
                try {
                  for (var Q = n(i.getExplicitNames()), s = Q.next(); !s.done; s = Q.next()) {
                    var T = s.value;
                    a.has(T) || i.attributes[T] !== t.attributes.getInherited(T) || delete i.attributes[T];
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    s && !s.done && (o = Q.return) && o.call(Q);
                  } finally {
                    if (r) throw r.error;
                  }
                }
              }
            }, {});
          }, t.combineRelations = function (t) {
            var o,
              i,
              s,
              T,
              l = [];
            try {
              for (var c = n(t.data.getList("mo")), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                if (!p.getProperty("relationsCombined") && p.parent && (!p.parent || Q.default.isType(p.parent, "mrow")) && Q.default.getTexClass(p) === a.TEXCLASS.REL) {
                  for (var h = p.parent, d = void 0, f = h.childNodes, m = f.indexOf(p) + 1, L = Q.default.getProperty(p, "variantForm"); m < f.length && (d = f[m]) && Q.default.isType(d, "mo") && Q.default.getTexClass(d) === a.TEXCLASS.REL;) {
                    if (L !== Q.default.getProperty(d, "variantForm") || !r(p, d)) {
                      null == p.attributes.getExplicit("rspace") && Q.default.setAttribute(p, "rspace", "0pt"), null == d.attributes.getExplicit("lspace") && Q.default.setAttribute(d, "lspace", "0pt");
                      break;
                    }
                    Q.default.appendChildren(p, Q.default.getChildren(d)), e(["stretchy", "rspace"], p, d);
                    try {
                      for (var y = (s = void 0, n(d.getPropertyNames())), g = y.next(); !g.done; g = y.next()) {
                        var v = g.value;
                        p.setProperty(v, d.getProperty(v));
                      }
                    } catch (t) {
                      s = {
                        error: t
                      };
                    } finally {
                      try {
                        g && !g.done && (T = y.return) && T.call(y);
                      } finally {
                        if (s) throw s.error;
                      }
                    }
                    f.splice(m, 1), l.push(d), d.parent = null, d.setProperty("relationsCombined", !0);
                  }
                  p.attributes.setInherited("form", p.getForms()[0]);
                }
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (i = c.return) && i.call(c);
              } finally {
                if (o) throw o.error;
              }
            }
            t.data.removeFromList("mo", l);
          };
          var e = function e(t, _e2, r) {
              var n = _e2.attributes,
                o = r.attributes;
              t.forEach(function (t) {
                var e = o.getExplicit(t);
                null != e && n.set(t, e);
              });
            },
            r = function r(t, e) {
              var r,
                o,
                i = function i(t, e) {
                  return t.getExplicitNames().filter(function (r) {
                    return r !== e && ("stretchy" !== r || t.getExplicit("stretchy"));
                  });
                },
                a = t.attributes,
                Q = e.attributes,
                s = i(a, "lspace"),
                T = i(Q, "rspace");
              if (s.length !== T.length) return !1;
              try {
                for (var l = n(s), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  if (a.getExplicit(u) !== Q.getExplicit(u)) return !1;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (o = l.return) && o.call(l);
                } finally {
                  if (r) throw r.error;
                }
              }
              return !0;
            },
            o = function o(t, e, r) {
              var o,
                i,
                a = [];
              try {
                for (var s = n(t.getList("m" + e + r)), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value,
                    c = l.childNodes;
                  if (!c[l[e]] || !c[l[r]]) {
                    var u = l.parent,
                      p = c[l[e]] ? t.nodeFactory.create("node", "m" + e, [c[l.base], c[l[e]]]) : t.nodeFactory.create("node", "m" + r, [c[l.base], c[l[r]]]);
                    Q.default.copyAttributes(l, p), u ? u.replaceChild(p, l) : t.root = p, a.push(l);
                  }
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (i = s.return) && i.call(s);
                } finally {
                  if (o) throw o.error;
                }
              }
              t.removeFromList("m" + e + r, a);
            };
          t.cleanSubSup = function (t) {
            var e = t.data;
            e.error || (o(e, "sub", "sup"), o(e, "under", "over"));
          };
          var i = function i(t, e, r) {
            var o,
              i,
              a = [];
            try {
              for (var s = n(t.getList(e)), T = s.next(); !T.done; T = s.next()) {
                var l = T.value;
                if (!l.attributes.get("displaystyle")) {
                  var c = l.childNodes[l.base],
                    u = c.coreMO();
                  if (c.getProperty("movablelimits") && !u.attributes.getExplicit("movablelimits")) {
                    var p = t.nodeFactory.create("node", r, l.childNodes);
                    Q.default.copyAttributes(l, p), l.parent ? l.parent.replaceChild(p, l) : t.root = p, a.push(l);
                  }
                }
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (i = s.return) && i.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
            t.removeFromList(e, a);
          };
          t.moveLimits = function (t) {
            var e = t.data;
            i(e, "munderover", "msubsup"), i(e, "munder", "msub"), i(e, "mover", "msup");
          }, t.setInherited = function (t) {
            t.data.root.setInheritedAttributes({}, t.math.display, 0, !1);
          };
        }(i || (i = {})), e.default = i;
      },
      7073: function _(t, e, r) {
        var _n51,
          o = this && this.__extends || (_n51 = function n(t, e) {
            return _n51 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n51(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n51(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FindTeX = void 0;
        var a = r(3494),
          Q = r(505),
          s = r(4474),
          T = function (t) {
            function e(e) {
              var r = t.call(this, e) || this;
              return r.getPatterns(), r;
            }
            return o(e, t), e.prototype.getPatterns = function () {
              var t = this,
                e = this.options,
                r = [],
                n = [],
                o = [];
              this.end = {}, this.env = this.sub = 0;
              var i = 1;
              e.inlineMath.forEach(function (e) {
                return t.addPattern(r, e, !1);
              }), e.displayMath.forEach(function (e) {
                return t.addPattern(r, e, !0);
              }), r.length && n.push(r.sort(Q.sortLength).join("|")), e.processEnvironments && (n.push("\\\\begin\\s*\\{([^}]*)\\}"), this.env = i, i++), e.processEscapes && o.push("\\\\([\\\\$])"), e.processRefs && o.push("(\\\\(?:eq)?ref\\s*\\{[^}]*\\})"), o.length && (n.push("(" + o.join("|") + ")"), this.sub = i), this.start = new RegExp(n.join("|"), "g"), this.hasPatterns = n.length > 0;
            }, e.prototype.addPattern = function (t, e, r) {
              var n = i(e, 2),
                o = n[0],
                a = n[1];
              t.push((0, Q.quotePattern)(o)), this.end[o] = [a, r, this.endPattern(a)];
            }, e.prototype.endPattern = function (t, e) {
              return new RegExp((e || (0, Q.quotePattern)(t)) + "|\\\\(?:[a-zA-Z]|.)|[{}]", "g");
            }, e.prototype.findEnd = function (t, e, r, n) {
              for (var o, a = i(n, 3), Q = a[0], T = a[1], l = a[2], c = l.lastIndex = r.index + r[0].length, u = 0; o = l.exec(t);) {
                if ((o[1] || o[0]) === Q && 0 === u) return (0, s.protoItem)(r[0], t.substr(c, o.index - c), o[0], e, r.index, o.index + o[0].length, T);
                "{" === o[0] ? u++ : "}" === o[0] && u && u--;
              }
              return null;
            }, e.prototype.findMathInString = function (t, e, r) {
              var n, o;
              for (this.start.lastIndex = 0; n = this.start.exec(r);) {
                if (void 0 !== n[this.env] && this.env) {
                  var i = "\\\\end\\s*(\\{" + (0, Q.quotePattern)(n[this.env]) + "\\})";
                  (o = this.findEnd(r, e, n, ["{" + n[this.env] + "}", !0, this.endPattern(null, i)])) && (o.math = o.open + o.math + o.close, o.open = o.close = "");
                } else if (void 0 !== n[this.sub] && this.sub) {
                  var a = n[this.sub];
                  i = n.index + n[this.sub].length;
                  o = 2 === a.length ? (0, s.protoItem)("", a.substr(1), "", e, n.index, i) : (0, s.protoItem)("", a, "", e, n.index, i, !1);
                } else o = this.findEnd(r, e, n, this.end[n[0]]);
                o && (t.push(o), this.start.lastIndex = o.end.n);
              }
            }, e.prototype.findMath = function (t) {
              var e = [];
              if (this.hasPatterns) for (var r = 0, n = t.length; r < n; r++) this.findMathInString(e, r, t[r]);
              return e;
            }, e.OPTIONS = {
              inlineMath: [["\\(", "\\)"]],
              displayMath: [["$$", "$$"], ["\\[", "\\]"]],
              processEscapes: !0,
              processEnvironments: !0,
              processRefs: !0
            }, e;
          }(a.AbstractFindMath);
        e.FindTeX = T;
      },
      2947: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SubHandlers = e.SubHandler = e.MapHandler = void 0;
        var i,
          a = r(8666),
          Q = r(7525);
        !function (t) {
          var e = new Map();
          t.register = function (t) {
            e.set(t.name, t);
          }, t.getMap = function (t) {
            return e.get(t);
          };
        }(i = e.MapHandler || (e.MapHandler = {}));
        var s = function () {
          function t() {
            this._configuration = new a.PrioritizedList(), this._fallback = new Q.FunctionList();
          }
          return t.prototype.add = function (t, e, r) {
            var o, Q;
            void 0 === r && (r = a.PrioritizedList.DEFAULTPRIORITY);
            try {
              for (var s = n(t.slice().reverse()), T = s.next(); !T.done; T = s.next()) {
                var l = T.value,
                  c = i.getMap(l);
                if (!c) return void this.warn("Configuration " + l + " not found! Omitted.");
                this._configuration.add(c, r);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (Q = s.return) && Q.call(s);
              } finally {
                if (o) throw o.error;
              }
            }
            e && this._fallback.add(e, r);
          }, t.prototype.parse = function (t) {
            var e, r;
            try {
              for (var i = n(this._configuration), a = i.next(); !a.done; a = i.next()) {
                var Q = a.value.item.parse(t);
                if (Q) return Q;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            var s = o(t, 2),
              T = s[0],
              l = s[1];
            Array.from(this._fallback)[0].item(T, l);
          }, t.prototype.lookup = function (t) {
            var e = this.applicable(t);
            return e ? e.lookup(t) : null;
          }, t.prototype.contains = function (t) {
            return !!this.applicable(t);
          }, t.prototype.toString = function () {
            var t,
              e,
              r = [];
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                r.push(a.name);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                i && !i.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return r.join(", ");
          }, t.prototype.applicable = function (t) {
            var e, r;
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                if (a.contains(t)) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.retrieve = function (t) {
            var e, r;
            try {
              for (var o = n(this._configuration), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.item;
                if (a.name === t) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.warn = function (t) {
            console.log("TexParser Warning: " + t);
          }, t;
        }();
        e.SubHandler = s;
        var T = function () {
          function t() {
            this.map = new Map();
          }
          return t.prototype.add = function (t, e, r) {
            var o, i;
            void 0 === r && (r = a.PrioritizedList.DEFAULTPRIORITY);
            try {
              for (var Q = n(Object.keys(t)), T = Q.next(); !T.done; T = Q.next()) {
                var l = T.value,
                  c = this.get(l);
                c || (c = new s(), this.set(l, c)), c.add(t[l], e[l], r);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (i = Q.return) && i.call(Q);
              } finally {
                if (o) throw o.error;
              }
            }
          }, t.prototype.set = function (t, e) {
            this.map.set(t, e);
          }, t.prototype.get = function (t) {
            return this.map.get(t);
          }, t.prototype.retrieve = function (t) {
            var e, r;
            try {
              for (var o = n(this.map.values()), i = o.next(); !i.done; i = o.next()) {
                var a = i.value.retrieve(t);
                if (a) return a;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          }, t.prototype.keys = function () {
            return this.map.keys();
          }, t;
        }();
        e.SubHandlers = T;
      },
      8929: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NodeFactory = void 0;
        var a = i(r(1256)),
          Q = function () {
            function t() {
              this.mmlFactory = null, this.factory = {
                node: t.createNode,
                token: t.createToken,
                text: t.createText,
                error: t.createError
              };
            }
            return t.createNode = function (t, e, r, n, o) {
              void 0 === r && (r = []), void 0 === n && (n = {});
              var i = t.mmlFactory.create(e);
              return i.setChildren(r), o && i.appendChild(o), a.default.setProperties(i, n), i;
            }, t.createToken = function (t, e, r, n) {
              void 0 === r && (r = {}), void 0 === n && (n = "");
              var o = t.create("text", n);
              return t.create("node", e, [], r, o);
            }, t.createText = function (t, e) {
              return null == e ? null : t.mmlFactory.create("text").setText(e);
            }, t.createError = function (t, e) {
              var r = t.create("text", e),
                n = t.create("node", "mtext", [], {}, r);
              return t.create("node", "merror", [n], {
                "data-mjx-error": e
              });
            }, t.prototype.setMmlFactory = function (t) {
              this.mmlFactory = t;
            }, t.prototype.set = function (t, e) {
              this.factory[t] = e;
            }, t.prototype.setCreators = function (t) {
              for (var e in t) this.set(e, t[e]);
            }, t.prototype.create = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var i = this.factory[t] || this.factory.node,
                a = i.apply(void 0, o([this, e[0]], n(e.slice(1)), !1));
              return "node" === t && this.configuration.addNode(e[0], a), a;
            }, t.prototype.get = function (t) {
              return this.factory[t];
            }, t;
          }();
        e.NodeFactory = Q;
      },
      1256: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          Q = r(9007),
          s = r(2756);
        !function (t) {
          var e = new Map([["autoOP", !0], ["fnOP", !0], ["movesupsub", !0], ["subsupOK", !0], ["texprimestyle", !0], ["useHeight", !0], ["variantForm", !0], ["withDelims", !0], ["mathaccent", !0], ["open", !0], ["close", !0]]);
          function r(t, r) {
            var o, i;
            try {
              for (var a = n(Object.keys(r)), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value,
                  T = r[s];
                "texClass" === s ? (t.texClass = T, t.setProperty(s, T)) : "movablelimits" === s ? (t.setProperty("movablelimits", T), (t.isKind("mo") || t.isKind("mstyle")) && t.attributes.set("movablelimits", T)) : "inferred" === s || (e.has(s) ? t.setProperty(s, T) : t.attributes.set(s, T));
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (i = a.return) && i.call(a);
              } finally {
                if (o) throw o.error;
              }
            }
          }
          function a(t, e, r) {
            t.childNodes[e] = r, r && (r.parent = t);
          }
          function T(t, e) {
            return t.isKind(e);
          }
          t.createEntity = function (t) {
            return String.fromCodePoint(parseInt(t, 16));
          }, t.getChildren = function (t) {
            return t.childNodes;
          }, t.getText = function (t) {
            return t.getText();
          }, t.appendChildren = function (t, e) {
            var r, o;
            try {
              for (var i = n(e), a = i.next(); !a.done; a = i.next()) {
                var Q = a.value;
                t.appendChild(Q);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (o = i.return) && o.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.setAttribute = function (t, e, r) {
            t.attributes.set(e, r);
          }, t.setProperty = function (t, e, r) {
            t.setProperty(e, r);
          }, t.setProperties = r, t.getProperty = function (t, e) {
            return t.getProperty(e);
          }, t.getAttribute = function (t, e) {
            return t.attributes.get(e);
          }, t.removeProperties = function (t) {
            for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
            t.removeProperty.apply(t, i([], o(e), !1));
          }, t.getChildAt = function (t, e) {
            return t.childNodes[e];
          }, t.setChild = a, t.copyChildren = function (t, e) {
            for (var r = t.childNodes, n = 0; n < r.length; n++) a(e, n, r[n]);
          }, t.copyAttributes = function (t, e) {
            e.attributes = t.attributes, r(e, t.getAllProperties());
          }, t.isType = T, t.isEmbellished = function (t) {
            return t.isEmbellished;
          }, t.getTexClass = function (t) {
            return t.texClass;
          }, t.getCoreMO = function (t) {
            return t.coreMO();
          }, t.isNode = function (t) {
            return t instanceof Q.AbstractMmlNode || t instanceof Q.AbstractMmlEmptyNode;
          }, t.isInferred = function (t) {
            return t.isInferred;
          }, t.getForm = function (t) {
            var e, r;
            if (!T(t, "mo")) return null;
            var o = t,
              i = o.getForms();
            try {
              for (var a = n(i), Q = a.next(); !Q.done; Q = a.next()) {
                var l = Q.value,
                  c = s.MmlMo.OPTABLE[l][o.getText()];
                if (c) return c;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (r = a.return) && r.call(a);
              } finally {
                if (e) throw e.error;
              }
            }
            return null;
          };
        }(a || (a = {})), e.default = a;
      },
      5450: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          Q = i(r(1256)),
          s = r(8317),
          T = i(r(1130));
        !function (t) {
          t.variable = function (t, e) {
            var r = T.default.getFontDef(t),
              n = t.stack.env;
            n.multiLetterIdentifiers && "" !== n.font && (e = t.string.substr(t.i - 1).match(n.multiLetterIdentifiers)[0], t.i += e.length - 1, r.mathvariant === s.TexConstant.Variant.NORMAL && n.noAutoOP && e.length > 1 && (r.autoOP = !1));
            var o = t.create("token", "mi", r, e);
            t.Push(o);
          }, t.digit = function (t, e) {
            var r,
              n = t.configuration.options.digits,
              o = t.string.slice(t.i - 1).match(n),
              i = T.default.getFontDef(t);
            o ? (r = t.create("token", "mn", i, o[0].replace(/[{}]/g, "")), t.i += o[0].length - 1) : r = t.create("token", "mo", i, e), t.Push(r);
          }, t.controlSequence = function (t, e) {
            var r = t.GetCS();
            t.parse("macro", [t, r]);
          }, t.mathchar0mi = function (t, e) {
            var r = e.attributes || {
                mathvariant: s.TexConstant.Variant.ITALIC
              },
              n = t.create("token", "mi", r, e.char);
            t.Push(n);
          }, t.mathchar0mo = function (t, e) {
            var r = e.attributes || {};
            r.stretchy = !1;
            var n = t.create("token", "mo", r, e.char);
            Q.default.setProperty(n, "fixStretchy", !0), t.configuration.addNode("fixStretchy", n), t.Push(n);
          }, t.mathchar7 = function (t, e) {
            var r = e.attributes || {
              mathvariant: s.TexConstant.Variant.NORMAL
            };
            t.stack.env.font && (r.mathvariant = t.stack.env.font);
            var n = t.create("token", "mi", r, e.char);
            t.Push(n);
          }, t.delimiter = function (t, e) {
            var r = e.attributes || {};
            r = Object.assign({
              fence: !1,
              stretchy: !1
            }, r);
            var n = t.create("token", "mo", r, e.char);
            t.Push(n);
          }, t.environment = function (t, e, r, i) {
            var a = i[0],
              Q = t.itemFactory.create("begin").setProperties({
                name: e,
                end: a
              });
            Q = r.apply(void 0, o([t, Q], n(i.slice(1)), !1)), t.Push(Q);
          };
        }(a || (a = {})), e.default = a;
      },
      8562: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = a(r(5453)),
          s = r(8929),
          T = a(r(1256)),
          l = r(7233),
          c = function () {
            function t(t, e) {
              void 0 === e && (e = []), this.options = {}, this.packageData = new Map(), this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.handlers = t.handlers, this.nodeFactory = new s.NodeFactory(), this.nodeFactory.configuration = this, this.nodeFactory.setCreators(t.nodes), this.itemFactory = new Q.default(t.items), this.itemFactory.configuration = this, l.defaultOptions.apply(void 0, o([this.options], n(e), !1)), (0, l.defaultOptions)(this.options, t.options);
            }
            return t.prototype.pushParser = function (t) {
              this.parsers.unshift(t);
            }, t.prototype.popParser = function () {
              this.parsers.shift();
            }, Object.defineProperty(t.prototype, "parser", {
              get: function get() {
                return this.parsers[0];
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.clear = function () {
              this.parsers = [], this.root = null, this.nodeLists = {}, this.error = !1, this.tags.resetTag();
            }, t.prototype.addNode = function (t, e) {
              var r = this.nodeLists[t];
              if (r || (r = this.nodeLists[t] = []), r.push(e), e.kind !== t) {
                var n = T.default.getProperty(e, "in-lists") || "",
                  o = (n ? n.split(/,/) : []).concat(t).join(",");
                T.default.setProperty(e, "in-lists", o);
              }
            }, t.prototype.getList = function (t) {
              var e,
                r,
                n = this.nodeLists[t] || [],
                o = [];
              try {
                for (var a = i(n), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  this.inTree(s) && o.push(s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.nodeLists[t] = o, o;
            }, t.prototype.removeFromList = function (t, e) {
              var r,
                n,
                o = this.nodeLists[t] || [];
              try {
                for (var a = i(e), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value,
                    T = o.indexOf(s);
                  T >= 0 && o.splice(T, 1);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (n = a.return) && n.call(a);
                } finally {
                  if (r) throw r.error;
                }
              }
            }, t.prototype.inTree = function (t) {
              for (; t && t !== this.root;) t = t.parent;
              return !!t;
            }, t;
          }();
        e.default = c;
      },
      1130: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a,
          Q = r(9007),
          s = i(r(1256)),
          T = i(r(8417)),
          l = i(r(3971)),
          c = r(5368);
        !function (t) {
          var e = 7.2,
            r = {
              em: function em(t) {
                return t;
              },
              ex: function ex(t) {
                return .43 * t;
              },
              pt: function pt(t) {
                return t / 10;
              },
              pc: function pc(t) {
                return 1.2 * t;
              },
              px: function px(t) {
                return t * e / 72;
              },
              in: function _in(t) {
                return t * e;
              },
              cm: function cm(t) {
                return t * e / 2.54;
              },
              mm: function mm(t) {
                return t * e / 25.4;
              },
              mu: function mu(t) {
                return t / 18;
              }
            },
            i = "([-+]?([.,]\\d+|\\d+([.,]\\d*)?))",
            a = "(pt|em|ex|mu|px|mm|cm|in|pc)",
            u = RegExp("^\\s*" + i + "\\s*" + a + "\\s*$"),
            p = RegExp("^\\s*" + i + "\\s*" + a + " ?");
          function h(t, e) {
            void 0 === e && (e = !1);
            var o = t.match(e ? p : u);
            return o ? function (t) {
              var e = n(t, 3),
                o = e[0],
                i = e[1],
                a = e[2];
              if ("mu" !== i) return [o, i, a];
              return [d(r[i](parseFloat(o || "1"))).slice(0, -2), "em", a];
            }([o[1].replace(/,/, "."), o[4], o[0].length]) : [null, null, 0];
          }
          function d(t) {
            return Math.abs(t) < 6e-4 ? "0em" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
          }
          function f(t, e, r) {
            "{" !== e && "}" !== e || (e = "\\" + e);
            var n = "{\\bigg" + r + " " + e + "}",
              o = "{\\big" + r + " " + e + "}";
            return new T.default("\\mathchoice" + n + o + o + o, {}, t).mml();
          }
          function m(t, e, r) {
            e = e.replace(/^\s+/, c.entities.nbsp).replace(/\s+$/, c.entities.nbsp);
            var n = t.create("text", e);
            return t.create("node", "mtext", [], r, n);
          }
          function L(t, e, r) {
            if (r.match(/^[a-z]/i) && e.match(/(^|[^\\])(\\\\)*\\[a-z]+$/i) && (e += " "), e.length + r.length > t.configuration.options.maxBuffer) throw new l.default("MaxBufferSize", "MathJax internal buffer size exceeded; is there a recursive macro call?");
            return e + r;
          }
          function y(t, e) {
            for (; e > 0;) t = t.trim().slice(1, -1), e--;
            return t.trim();
          }
          function g(t, e) {
            for (var r = t.length, n = 0, o = "", i = 0, a = 0, Q = !0, s = !1; i < r;) {
              var T = t[i++];
              switch (T) {
                case " ":
                  break;
                case "{":
                  Q ? a++ : (s = !1, a > n && (a = n)), n++;
                  break;
                case "}":
                  n && n--, (Q || s) && (a--, s = !0), Q = !1;
                  break;
                default:
                  if (!n && -1 !== e.indexOf(T)) return [s ? "true" : y(o, a), T, t.slice(i)];
                  Q = !1, s = !1;
              }
              o += T;
            }
            if (n) throw new l.default("ExtraOpenMissingClose", "Extra open brace or missing close brace");
            return [s ? "true" : y(o, a), "", t.slice(i)];
          }
          t.matchDimen = h, t.dimen2em = function (t) {
            var e = n(h(t), 2),
              o = e[0],
              i = e[1],
              a = parseFloat(o || "1"),
              Q = r[i];
            return Q ? Q(a) : 0;
          }, t.Em = d, t.cols = function () {
            for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            return t.map(function (t) {
              return d(t);
            }).join(" ");
          }, t.fenced = function (t, e, r, n, o, i) {
            void 0 === o && (o = ""), void 0 === i && (i = "");
            var a,
              l = t.nodeFactory,
              c = l.create("node", "mrow", [], {
                open: e,
                close: n,
                texClass: Q.TEXCLASS.INNER
              });
            if (o) a = new T.default("\\" + o + "l" + e, t.parser.stack.env, t).mml();else {
              var u = l.create("text", e);
              a = l.create("node", "mo", [], {
                fence: !0,
                stretchy: !0,
                symmetric: !0,
                texClass: Q.TEXCLASS.OPEN
              }, u);
            }
            if (s.default.appendChildren(c, [a, r]), o) a = new T.default("\\" + o + "r" + n, t.parser.stack.env, t).mml();else {
              var p = l.create("text", n);
              a = l.create("node", "mo", [], {
                fence: !0,
                stretchy: !0,
                symmetric: !0,
                texClass: Q.TEXCLASS.CLOSE
              }, p);
            }
            return i && a.attributes.set("mathcolor", i), s.default.appendChildren(c, [a]), c;
          }, t.fixedFence = function (t, e, r, n) {
            var o = t.nodeFactory.create("node", "mrow", [], {
              open: e,
              close: n,
              texClass: Q.TEXCLASS.ORD
            });
            return e && s.default.appendChildren(o, [f(t, e, "l")]), s.default.isType(r, "mrow") ? s.default.appendChildren(o, s.default.getChildren(r)) : s.default.appendChildren(o, [r]), n && s.default.appendChildren(o, [f(t, n, "r")]), o;
          }, t.mathPalette = f, t.fixInitialMO = function (t, e) {
            for (var r = 0, n = e.length; r < n; r++) {
              var o = e[r];
              if (o && !s.default.isType(o, "mspace") && (!s.default.isType(o, "TeXAtom") || s.default.getChildren(o)[0] && s.default.getChildren(s.default.getChildren(o)[0]).length)) {
                if (s.default.isEmbellished(o) || s.default.isType(o, "TeXAtom") && s.default.getTexClass(o) === Q.TEXCLASS.REL) {
                  var i = t.nodeFactory.create("node", "mi");
                  e.unshift(i);
                }
                break;
              }
            }
          }, t.internalMath = function (t, e, r, n) {
            if (t.configuration.options.internalMath) return t.configuration.options.internalMath(t, e, r, n);
            var o,
              i,
              a = n || t.stack.env.font,
              Q = a ? {
                mathvariant: a
              } : {},
              s = [],
              c = 0,
              u = 0,
              p = "",
              h = 0;
            if (e.match(/\\?[${}\\]|\\\(|\\(eq)?ref\s*\{/)) {
              for (; c < e.length;) if ("$" === (o = e.charAt(c++))) "$" === p && 0 === h ? (i = t.create("node", "TeXAtom", [new T.default(e.slice(u, c - 1), {}, t.configuration).mml()]), s.push(i), p = "", u = c) : "" === p && (u < c - 1 && s.push(m(t, e.slice(u, c - 1), Q)), p = "$", u = c);else if ("{" === o && "" !== p) h++;else if ("}" === o) {
                if ("}" === p && 0 === h) {
                  var d = new T.default(e.slice(u, c), {}, t.configuration).mml();
                  i = t.create("node", "TeXAtom", [d], Q), s.push(i), p = "", u = c;
                } else "" !== p && h && h--;
              } else if ("\\" === o) if ("" === p && e.substr(c).match(/^(eq)?ref\s*\{/)) {
                var f = RegExp["$&"].length;
                u < c - 1 && s.push(m(t, e.slice(u, c - 1), Q)), p = "}", u = c - 1, c += f;
              } else "(" === (o = e.charAt(c++)) && "" === p ? (u < c - 2 && s.push(m(t, e.slice(u, c - 2), Q)), p = ")", u = c) : ")" === o && ")" === p && 0 === h ? (i = t.create("node", "TeXAtom", [new T.default(e.slice(u, c - 2), {}, t.configuration).mml()]), s.push(i), p = "", u = c) : o.match(/[${}\\]/) && "" === p && (c--, e = e.substr(0, c - 1) + e.substr(c));
              if ("" !== p) throw new l.default("MathNotTerminated", "Math not terminated in text box");
            }
            return u < e.length && s.push(m(t, e.slice(u), Q)), null != r ? s = [t.create("node", "mstyle", s, {
              displaystyle: !1,
              scriptlevel: r
            })] : s.length > 1 && (s = [t.create("node", "mrow", s)]), s;
          }, t.internalText = m, t.underOver = function (e, r, n, o, i) {
            if (t.checkMovableLimits(r), s.default.isType(r, "munderover") && s.default.isEmbellished(r)) {
              s.default.setProperties(s.default.getCoreMO(r), {
                lspace: 0,
                rspace: 0
              });
              var a = e.create("node", "mo", [], {
                rspace: 0
              });
              r = e.create("node", "mrow", [a, r]);
            }
            var T = e.create("node", "munderover", [r]);
            s.default.setChild(T, "over" === o ? T.over : T.under, n);
            var l = T;
            return i && (l = e.create("node", "TeXAtom", [T], {
              texClass: Q.TEXCLASS.OP,
              movesupsub: !0
            })), s.default.setProperty(l, "subsupOK", !0), l;
          }, t.checkMovableLimits = function (t) {
            var e = s.default.isType(t, "mo") ? s.default.getForm(t) : null;
            (s.default.getProperty(t, "movablelimits") || e && e[3] && e[3].movablelimits) && s.default.setProperties(t, {
              movablelimits: !1
            });
          }, t.trimSpaces = function (t) {
            if ("string" != typeof t) return t;
            var e = t.trim();
            return e.match(/\\$/) && t.match(/ $/) && (e += " "), e;
          }, t.setArrayAlign = function (e, r) {
            return "t" === (r = t.trimSpaces(r || "")) ? e.arraydef.align = "baseline 1" : "b" === r ? e.arraydef.align = "baseline -1" : "c" === r ? e.arraydef.align = "axis" : r && (e.arraydef.align = r), e;
          }, t.substituteArgs = function (t, e, r) {
            for (var n = "", o = "", i = 0; i < r.length;) {
              var a = r.charAt(i++);
              if ("\\" === a) n += a + r.charAt(i++);else if ("#" === a) {
                if ("#" === (a = r.charAt(i++))) n += a;else {
                  if (!a.match(/[1-9]/) || parseInt(a, 10) > e.length) throw new l.default("IllegalMacroParam", "Illegal macro parameter reference");
                  o = L(t, L(t, o, n), e[parseInt(a, 10) - 1]), n = "";
                }
              } else n += a;
            }
            return L(t, o, n);
          }, t.addArgs = L, t.checkMaxMacros = function (t, e) {
            if (void 0 === e && (e = !0), !(++t.macroCount <= t.configuration.options.maxMacros)) throw e ? new l.default("MaxMacroSub1", "MathJax maximum macro substitution count exceeded; is here a recursive macro call?") : new l.default("MaxMacroSub2", "MathJax maximum substitution count exceeded; is there a recursive latex environment?");
          }, t.checkEqnEnv = function (t) {
            if (t.stack.global.eqnenv) throw new l.default("ErroneousNestingEq", "Erroneous nesting of equation structures");
            t.stack.global.eqnenv = !0;
          }, t.copyNode = function (t, e) {
            var r = t.copy(),
              n = e.configuration;
            return r.walkTree(function (t) {
              var e, r;
              n.addNode(t.kind, t);
              var i = (t.getProperty("in-lists") || "").split(/,/);
              try {
                for (var a = o(i), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  s && n.addNode(s, t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }), r;
          }, t.MmlFilterAttribute = function (t, e, r) {
            return r;
          }, t.getFontDef = function (t) {
            var e = t.stack.env.font;
            return e ? {
              mathvariant: e
            } : {};
          }, t.keyvalOptions = function (t, e, r) {
            var i, a;
            void 0 === e && (e = null), void 0 === r && (r = !1);
            var Q = function (t) {
              var e,
                r,
                o,
                i,
                a,
                Q = {},
                s = t;
              for (; s;) i = (e = n(g(s, ["=", ","]), 3))[0], o = e[1], s = e[2], "=" === o ? (a = (r = n(g(s, [","]), 3))[0], o = r[1], s = r[2], a = "false" === a || "true" === a ? JSON.parse(a) : a, Q[i] = a) : i && (Q[i] = !0);
              return Q;
            }(t);
            if (e) try {
              for (var s = o(Object.keys(Q)), T = s.next(); !T.done; T = s.next()) {
                var c = T.value;
                if (!e.hasOwnProperty(c)) {
                  if (r) throw new l.default("InvalidOption", "Invalid option: %1", c);
                  delete Q[c];
                }
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                T && !T.done && (a = s.return) && a.call(s);
              } finally {
                if (i) throw i.error;
              }
            }
            return Q;
          };
        }(a || (a = {})), e.default = a;
      },
      9497: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = a(r(1256)),
          s = function () {
            function t(t, e, r) {
              this._factory = t, this._env = e, this.global = {}, this.stack = [], this.global = {
                isInner: r
              }, this.stack = [this._factory.create("start", this.global)], e && (this.stack[0].env = e), this.env = this.stack[0].env;
            }
            return Object.defineProperty(t.prototype, "env", {
              get: function get() {
                return this._env;
              },
              set: function set(t) {
                this._env = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Push = function () {
              for (var t, e, r = [], a = 0; a < arguments.length; a++) r[a] = arguments[a];
              try {
                for (var s = n(r), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value;
                  if (l) {
                    var c = Q.default.isNode(l) ? this._factory.create("mml", l) : l;
                    c.global = this.global;
                    var u = o(this.stack.length ? this.Top().checkItem(c) : [null, !0], 2),
                      p = u[0],
                      h = u[1];
                    h && (p ? (this.Pop(), this.Push.apply(this, i([], o(p), !1))) : (this.stack.push(c), c.env ? (c.copyEnv && Object.assign(c.env, this.env), this.env = c.env) : c.env = this.env));
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  T && !T.done && (e = s.return) && e.call(s);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, t.prototype.Pop = function () {
              var t = this.stack.pop();
              return t.isOpen || delete t.env, this.env = this.stack.length ? this.Top().env : {}, t;
            }, t.prototype.Top = function (t) {
              return void 0 === t && (t = 1), this.stack.length < t ? null : this.stack[this.stack.length - t];
            }, t.prototype.Prev = function (t) {
              var e = this.Top();
              return t ? e.First : e.Pop();
            }, t.prototype.toString = function () {
              return "stack[\n  " + this.stack.join("\n  ") + "\n]";
            }, t;
          }();
        e.default = s;
      },
      8292: function _(t, e, r) {
        var _n52,
          o = this && this.__extends || (_n52 = function n(t, e) {
            return _n52 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n52(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n52(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BaseItem = e.MmlStack = void 0;
        var T = s(r(3971)),
          l = function () {
            function t(t) {
              this._nodes = t;
            }
            return Object.defineProperty(t.prototype, "nodes", {
              get: function get() {
                return this._nodes;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Push = function () {
              for (var t, e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              (t = this._nodes).push.apply(t, a([], i(e), !1));
            }, t.prototype.Pop = function () {
              return this._nodes.pop();
            }, Object.defineProperty(t.prototype, "First", {
              get: function get() {
                return this._nodes[this.Size() - 1];
              },
              set: function set(t) {
                this._nodes[this.Size() - 1] = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "Last", {
              get: function get() {
                return this._nodes[0];
              },
              set: function set(t) {
                this._nodes[0] = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.Peek = function (t) {
              return null == t && (t = 1), this._nodes.slice(this.Size() - t);
            }, t.prototype.Size = function () {
              return this._nodes.length;
            }, t.prototype.Clear = function () {
              this._nodes = [];
            }, t.prototype.toMml = function (t, e) {
              return void 0 === t && (t = !0), 1 !== this._nodes.length || e ? this.create("node", t ? "inferredMrow" : "mrow", this._nodes, {}) : this.First;
            }, t.prototype.create = function (t) {
              for (var e, r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              return (e = this.factory.configuration.nodeFactory).create.apply(e, a([t], i(r), !1));
            }, t;
          }();
        e.MmlStack = l;
        var c = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, r) || this;
            return o.factory = e, o.global = {}, o._properties = {}, o.isOpen && (o._env = {}), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "base";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "env", {
            get: function get() {
              return this._env;
            },
            set: function set(t) {
              this._env = t;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "copyEnv", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.getProperty = function (t) {
            return this._properties[t];
          }, e.prototype.setProperty = function (t, e) {
            return this._properties[t] = e, this;
          }, Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isFinal", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.isKind = function (t) {
            return t === this.kind;
          }, e.prototype.checkItem = function (t) {
            if (t.isKind("over") && this.isOpen && (t.setProperty("num", this.toMml(!1)), this.Clear()), t.isKind("cell") && this.isOpen) {
              if (t.getProperty("linebreak")) return e.fail;
              throw new T.default("Misplaced", "Misplaced %1", t.getName());
            }
            if (t.isClose && this.getErrors(t.kind)) {
              var r = i(this.getErrors(t.kind), 2),
                n = r[0],
                o = r[1];
              throw new T.default(n, o, t.getName());
            }
            return t.isFinal ? (this.Push(t.First), e.fail) : e.success;
          }, e.prototype.clearEnv = function () {
            var t, e;
            try {
              for (var r = Q(Object.keys(this.env)), n = r.next(); !n.done; n = r.next()) {
                var o = n.value;
                delete this.env[o];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                n && !n.done && (e = r.return) && e.call(r);
              } finally {
                if (t) throw t.error;
              }
            }
          }, e.prototype.setProperties = function (t) {
            return Object.assign(this._properties, t), this;
          }, e.prototype.getName = function () {
            return this.getProperty("name");
          }, e.prototype.toString = function () {
            return this.kind + "[" + this.nodes.join("; ") + "]";
          }, e.prototype.getErrors = function (t) {
            return (this.constructor.errors || {})[t] || e.errors[t];
          }, e.fail = [null, !1], e.success = [null, !0], e.errors = {
            end: ["MissingBeginExtraEnd", "Missing \\begin{%1} or extra \\end{%1}"],
            close: ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"],
            right: ["MissingLeftExtraRight", "Missing \\left or extra \\right"],
            middle: ["ExtraMiddle", "Extra \\middle"]
          }, e;
        }(l);
        e.BaseItem = c;
      },
      5453: function _(t, e, r) {
        var _n53,
          o,
          i = this && this.__extends || (_n53 = function n(t, e) {
            return _n53 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n53(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n53(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var a = r(8292),
          Q = r(4574),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e;
          }(a.BaseItem),
          T = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.defaultKind = "dummy", e.configuration = null, e;
            }
            return i(e, t), e.DefaultStackItems = ((o = {})[s.prototype.kind] = s, o), e;
          }(Q.AbstractFactory);
        e.default = T;
      },
      8803: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Macro = e.Symbol = void 0;
        var r = function () {
          function t(t, e, r) {
            this._symbol = t, this._char = e, this._attributes = r;
          }
          return Object.defineProperty(t.prototype, "symbol", {
            get: function get() {
              return this._symbol;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "char", {
            get: function get() {
              return this._char;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function get() {
              return this._attributes;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.Symbol = r;
        var n = function () {
          function t(t, e, r) {
            void 0 === r && (r = []), this._symbol = t, this._func = e, this._args = r;
          }
          return Object.defineProperty(t.prototype, "symbol", {
            get: function get() {
              return this._symbol;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "func", {
            get: function get() {
              return this._func;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "args", {
            get: function get() {
              return this._args;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.Macro = n;
      },
      9140: function _(t, e, r) {
        var _n54,
          o = this && this.__extends || (_n54 = function n(t, e) {
            return _n54 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n54(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n54(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EnvironmentMap = e.CommandMap = e.MacroMap = e.DelimiterMap = e.CharacterMap = e.AbstractParseMap = e.RegExpMap = e.AbstractSymbolMap = e.parseResult = void 0;
        var s = r(8803),
          T = r(2947);
        function l(t) {
          return void 0 === t || t;
        }
        e.parseResult = l;
        var c = function () {
          function t(t, e) {
            this._name = t, this._parser = e, T.MapHandler.register(this);
          }
          return Object.defineProperty(t.prototype, "name", {
            get: function get() {
              return this._name;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.parserFor = function (t) {
            return this.contains(t) ? this.parser : null;
          }, t.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.parserFor(n),
              a = this.lookup(n);
            return o && a ? l(o(r, a)) : null;
          }, Object.defineProperty(t.prototype, "parser", {
            get: function get() {
              return this._parser;
            },
            set: function set(t) {
              this._parser = t;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }();
        e.AbstractSymbolMap = c;
        var u = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e, r) || this;
            return o._regExp = n, o;
          }
          return o(e, t), e.prototype.contains = function (t) {
            return this._regExp.test(t);
          }, e.prototype.lookup = function (t) {
            return this.contains(t) ? t : null;
          }, e;
        }(c);
        e.RegExpMap = u;
        var p = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.map = new Map(), e;
          }
          return o(e, t), e.prototype.lookup = function (t) {
            return this.map.get(t);
          }, e.prototype.contains = function (t) {
            return this.map.has(t);
          }, e.prototype.add = function (t, e) {
            this.map.set(t, e);
          }, e.prototype.remove = function (t) {
            this.map.delete(t);
          }, e;
        }(c);
        e.AbstractParseMap = p;
        var h = function (t) {
          function e(e, r, n) {
            var o,
              Q,
              T = t.call(this, e, r) || this;
            try {
              for (var l = a(Object.keys(n)), c = l.next(); !c.done; c = l.next()) {
                var u = c.value,
                  p = n[u],
                  h = i("string" == typeof p ? [p, null] : p, 2),
                  d = h[0],
                  f = h[1],
                  m = new s.Symbol(u, d, f);
                T.add(u, m);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (Q = l.return) && Q.call(l);
              } finally {
                if (o) throw o.error;
              }
            }
            return T;
          }
          return o(e, t), e;
        }(p);
        e.CharacterMap = h;
        var d = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.parse = function (e) {
            var r = i(e, 2),
              n = r[0],
              o = r[1];
            return t.prototype.parse.call(this, [n, "\\" + o]);
          }, e;
        }(h);
        e.DelimiterMap = d;
        var f = function (t) {
          function e(e, r, n) {
            var o,
              Q,
              T = t.call(this, e, null) || this;
            try {
              for (var l = a(Object.keys(r)), c = l.next(); !c.done; c = l.next()) {
                var u = c.value,
                  p = r[u],
                  h = i("string" == typeof p ? [p] : p),
                  d = h[0],
                  f = h.slice(1),
                  m = new s.Macro(u, n[d], f);
                T.add(u, m);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                c && !c.done && (Q = l.return) && Q.call(l);
              } finally {
                if (o) throw o.error;
              }
            }
            return T;
          }
          return o(e, t), e.prototype.parserFor = function (t) {
            var e = this.lookup(t);
            return e ? e.func : null;
          }, e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            return o && a ? l(a.apply(void 0, Q([r, o.symbol], i(o.args), !1))) : null;
          }, e;
        }(p);
        e.MacroMap = f;
        var m = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            if (!o || !a) return null;
            var s = r.currentCS;
            r.currentCS = "\\" + n;
            var T = a.apply(void 0, Q([r, "\\" + o.symbol], i(o.args), !1));
            return r.currentCS = s, l(T);
          }, e;
        }(f);
        e.CommandMap = m;
        var L = function (t) {
          function e(e, r, n, o) {
            var i = t.call(this, e, n, o) || this;
            return i.parser = r, i;
          }
          return o(e, t), e.prototype.parse = function (t) {
            var e = i(t, 2),
              r = e[0],
              n = e[1],
              o = this.lookup(n),
              a = this.parserFor(n);
            return o && a ? l(this.parser(r, o.symbol, a, o.args)) : null;
          }, e;
        }(f);
        e.EnvironmentMap = L;
      },
      6521: function _(t, e, r) {
        var _n55,
          o = this && this.__extends || (_n55 = function n(t, e) {
            return _n55 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n55(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n55(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TagsFactory = e.AllTags = e.NoTags = e.AbstractTags = e.TagInfo = e.Label = void 0;
        var Q = a(r(8417)),
          s = function s(t, e) {
            void 0 === t && (t = "???"), void 0 === e && (e = ""), this.tag = t, this.id = e;
          };
        e.Label = s;
        var T = function T(t, e, r, n, o, i, a, Q) {
          void 0 === t && (t = ""), void 0 === e && (e = !1), void 0 === r && (r = !1), void 0 === n && (n = null), void 0 === o && (o = ""), void 0 === i && (i = ""), void 0 === a && (a = !1), void 0 === Q && (Q = ""), this.env = t, this.taggable = e, this.defaultTags = r, this.tag = n, this.tagId = o, this.tagFormat = i, this.noTag = a, this.labelId = Q;
        };
        e.TagInfo = T;
        var l = function () {
          function t() {
            this.counter = 0, this.allCounter = 0, this.configuration = null, this.ids = {}, this.allIds = {}, this.labels = {}, this.allLabels = {}, this.redo = !1, this.refUpdate = !1, this.currentTag = new T(), this.history = [], this.stack = [], this.enTag = function (t, e) {
              var r = this.configuration.nodeFactory,
                n = r.create("node", "mtd", [t]),
                o = r.create("node", "mlabeledtr", [e, n]);
              return r.create("node", "mtable", [o], {
                side: this.configuration.options.tagSide,
                minlabelspacing: this.configuration.options.tagIndent,
                displaystyle: !0
              });
            };
          }
          return t.prototype.start = function (t, e, r) {
            this.currentTag && this.stack.push(this.currentTag), this.currentTag = new T(t, e, r);
          }, Object.defineProperty(t.prototype, "env", {
            get: function get() {
              return this.currentTag.env;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.end = function () {
            this.history.push(this.currentTag), this.currentTag = this.stack.pop();
          }, t.prototype.tag = function (t, e) {
            this.currentTag.tag = t, this.currentTag.tagFormat = e ? t : this.formatTag(t), this.currentTag.noTag = !1;
          }, t.prototype.notag = function () {
            this.tag("", !0), this.currentTag.noTag = !0;
          }, Object.defineProperty(t.prototype, "noTag", {
            get: function get() {
              return this.currentTag.noTag;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "label", {
            get: function get() {
              return this.currentTag.labelId;
            },
            set: function set(t) {
              this.currentTag.labelId = t;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.formatUrl = function (t, e) {
            return e + "#" + encodeURIComponent(t);
          }, t.prototype.formatTag = function (t) {
            return "(" + t + ")";
          }, t.prototype.formatId = function (t) {
            return "mjx-eqn:" + t.replace(/\s/g, "_");
          }, t.prototype.formatNumber = function (t) {
            return t.toString();
          }, t.prototype.autoTag = function () {
            null == this.currentTag.tag && (this.counter++, this.tag(this.formatNumber(this.counter), !1));
          }, t.prototype.clearTag = function () {
            this.label = "", this.tag(null, !0), this.currentTag.tagId = "";
          }, t.prototype.getTag = function (t) {
            if (void 0 === t && (t = !1), t) return this.autoTag(), this.makeTag();
            var e = this.currentTag;
            return e.taggable && !e.noTag && (e.defaultTags && this.autoTag(), e.tag) ? this.makeTag() : null;
          }, t.prototype.resetTag = function () {
            this.history = [], this.redo = !1, this.refUpdate = !1, this.clearTag();
          }, t.prototype.reset = function (t) {
            void 0 === t && (t = 0), this.resetTag(), this.counter = this.allCounter = t, this.allLabels = {}, this.allIds = {};
          }, t.prototype.startEquation = function (t) {
            this.history = [], this.stack = [], this.clearTag(), this.currentTag = new T("", void 0, void 0), this.labels = {}, this.ids = {}, this.counter = this.allCounter, this.redo = !1;
            var e = t.inputData.recompile;
            e && (this.refUpdate = !0, this.counter = e.counter);
          }, t.prototype.finishEquation = function (t) {
            this.redo && (t.inputData.recompile = {
              state: t.state(),
              counter: this.allCounter
            }), this.refUpdate || (this.allCounter = this.counter), Object.assign(this.allIds, this.ids), Object.assign(this.allLabels, this.labels);
          }, t.prototype.finalize = function (t, e) {
            if (!e.display || this.currentTag.env || null == this.currentTag.tag) return t;
            var r = this.makeTag();
            return this.enTag(t, r);
          }, t.prototype.makeId = function () {
            this.currentTag.tagId = this.formatId(this.configuration.options.useLabelIds && this.label || this.currentTag.tag);
          }, t.prototype.makeTag = function () {
            this.makeId(), this.label && (this.labels[this.label] = new s(this.currentTag.tag, this.currentTag.tagId));
            var t = new Q.default("\\text{" + this.currentTag.tagFormat + "}", {}, this.configuration).mml();
            return this.configuration.nodeFactory.create("node", "mtd", [t], {
              id: this.currentTag.tagId
            });
          }, t;
        }();
        e.AbstractTags = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.autoTag = function () {}, e.prototype.getTag = function () {
            return this.currentTag.tag ? t.prototype.getTag.call(this) : null;
          }, e;
        }(l);
        e.NoTags = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.finalize = function (t, e) {
            if (!e.display || this.history.find(function (t) {
              return t.taggable;
            })) return t;
            var r = this.getTag(!0);
            return this.enTag(t, r);
          }, e;
        }(l);
        e.AllTags = u, function (t) {
          var e = new Map([["none", c], ["all", u]]),
            r = "none";
          t.OPTIONS = {
            tags: r,
            tagSide: "right",
            tagIndent: "0.8em",
            useLabelIds: !0,
            ignoreDuplicateLabels: !1
          }, t.add = function (t, r) {
            e.set(t, r);
          }, t.addTags = function (e) {
            var r, n;
            try {
              for (var o = i(Object.keys(e)), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value;
                t.add(Q, e[Q]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.create = function (t) {
            var n = e.get(t) || e.get(r);
            if (!n) throw Error("Unknown tags class");
            return new n();
          }, t.setDefault = function (t) {
            r = t;
          }, t.getDefault = function () {
            return t.create(r);
          };
        }(e.TagsFactory || (e.TagsFactory = {}));
      },
      8317: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TexConstant = void 0, function (t) {
          t.Variant = {
            NORMAL: "normal",
            BOLD: "bold",
            ITALIC: "italic",
            BOLDITALIC: "bold-italic",
            DOUBLESTRUCK: "double-struck",
            FRAKTUR: "fraktur",
            BOLDFRAKTUR: "bold-fraktur",
            SCRIPT: "script",
            BOLDSCRIPT: "bold-script",
            SANSSERIF: "sans-serif",
            BOLDSANSSERIF: "bold-sans-serif",
            SANSSERIFITALIC: "sans-serif-italic",
            SANSSERIFBOLDITALIC: "sans-serif-bold-italic",
            MONOSPACE: "monospace",
            INITIAL: "inital",
            TAILED: "tailed",
            LOOPED: "looped",
            STRETCHED: "stretched",
            CALLIGRAPHIC: "-tex-calligraphic",
            BOLDCALLIGRAPHIC: "-tex-bold-calligraphic",
            OLDSTYLE: "-tex-oldstyle",
            BOLDOLDSTYLE: "-tex-bold-oldstyle",
            MATHITALIC: "-tex-mathit"
          }, t.Form = {
            PREFIX: "prefix",
            INFIX: "infix",
            POSTFIX: "postfix"
          }, t.LineBreak = {
            AUTO: "auto",
            NEWLINE: "newline",
            NOBREAK: "nobreak",
            GOODBREAK: "goodbreak",
            BADBREAK: "badbreak"
          }, t.LineBreakStyle = {
            BEFORE: "before",
            AFTER: "after",
            DUPLICATE: "duplicate",
            INFIXLINBREAKSTYLE: "infixlinebreakstyle"
          }, t.IndentAlign = {
            LEFT: "left",
            CENTER: "center",
            RIGHT: "right",
            AUTO: "auto",
            ID: "id",
            INDENTALIGN: "indentalign"
          }, t.IndentShift = {
            INDENTSHIFT: "indentshift"
          }, t.LineThickness = {
            THIN: "thin",
            MEDIUM: "medium",
            THICK: "thick"
          }, t.Notation = {
            LONGDIV: "longdiv",
            ACTUARIAL: "actuarial",
            PHASORANGLE: "phasorangle",
            RADICAL: "radical",
            BOX: "box",
            ROUNDEDBOX: "roundedbox",
            CIRCLE: "circle",
            LEFT: "left",
            RIGHT: "right",
            TOP: "top",
            BOTTOM: "bottom",
            UPDIAGONALSTRIKE: "updiagonalstrike",
            DOWNDIAGONALSTRIKE: "downdiagonalstrike",
            VERTICALSTRIKE: "verticalstrike",
            HORIZONTALSTRIKE: "horizontalstrike",
            NORTHEASTARROW: "northeastarrow",
            MADRUWB: "madruwb",
            UPDIAGONALARROW: "updiagonalarrow"
          }, t.Align = {
            TOP: "top",
            BOTTOM: "bottom",
            CENTER: "center",
            BASELINE: "baseline",
            AXIS: "axis",
            LEFT: "left",
            RIGHT: "right"
          }, t.Lines = {
            NONE: "none",
            SOLID: "solid",
            DASHED: "dashed"
          }, t.Side = {
            LEFT: "left",
            RIGHT: "right",
            LEFTOVERLAP: "leftoverlap",
            RIGHTOVERLAP: "rightoverlap"
          }, t.Width = {
            AUTO: "auto",
            FIT: "fit"
          }, t.Actiontype = {
            TOGGLE: "toggle",
            STATUSLINE: "statusline",
            TOOLTIP: "tooltip",
            INPUT: "input"
          }, t.Overflow = {
            LINBREAK: "linebreak",
            SCROLL: "scroll",
            ELIDE: "elide",
            TRUNCATE: "truncate",
            SCALE: "scale"
          }, t.Unit = {
            EM: "em",
            EX: "ex",
            PX: "px",
            IN: "in",
            CM: "cm",
            MM: "mm",
            PT: "pt",
            PC: "pc"
          };
        }(e.TexConstant || (e.TexConstant = {}));
      },
      3971: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var r = function () {
          function t(e, r) {
            for (var n = [], o = 2; o < arguments.length; o++) n[o - 2] = arguments[o];
            this.id = e, this.message = t.processString(r, n);
          }
          return t.processString = function (e, r) {
            for (var n = e.split(t.pattern), o = 1, i = n.length; o < i; o += 2) {
              var a = n[o].charAt(0);
              if (a >= "0" && a <= "9") n[o] = r[parseInt(n[o], 10) - 1], "number" == typeof n[o] && (n[o] = n[o].toString());else if ("{" === a) {
                if ((a = n[o].substr(1)) >= "0" && a <= "9") n[o] = r[parseInt(n[o].substr(1, n[o].length - 2), 10) - 1], "number" == typeof n[o] && (n[o] = n[o].toString());else n[o].match(/^\{([a-z]+):%(\d+)\|(.*)\}$/) && (n[o] = "%" + n[o]);
              }
              null == n[o] && (n[o] = "???");
            }
            return n.join("");
          }, t.pattern = /%(\d+|\{\d+\}|\{[a-z]+:\%\d+(?:\|(?:%\{\d+\}|%.|[^\}])*)+\}|.)/g, t;
        }();
        e.default = r;
      },
      8417: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = a(r(1130)),
          s = a(r(9497)),
          T = a(r(3971)),
          l = r(9007),
          c = function () {
            function t(t, e, r) {
              var o, i;
              this._string = t, this.configuration = r, this.macroCount = 0, this.i = 0, this.currentCS = "";
              var a,
                Q = e.hasOwnProperty("isInner"),
                T = e.isInner;
              if (delete e.isInner, e) {
                a = {};
                try {
                  for (var l = n(Object.keys(e)), c = l.next(); !c.done; c = l.next()) {
                    var u = c.value;
                    a[u] = e[u];
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    c && !c.done && (i = l.return) && i.call(l);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
              this.configuration.pushParser(this), this.stack = new s.default(this.itemFactory, a, !Q || T), this.Parse(), this.Push(this.itemFactory.create("stop"));
            }
            return Object.defineProperty(t.prototype, "options", {
              get: function get() {
                return this.configuration.options;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "itemFactory", {
              get: function get() {
                return this.configuration.itemFactory;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "tags", {
              get: function get() {
                return this.configuration.tags;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "string", {
              get: function get() {
                return this._string;
              },
              set: function set(t) {
                this._string = t;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.parse = function (t, e) {
              return this.configuration.handlers.get(t).parse(e);
            }, t.prototype.lookup = function (t, e) {
              return this.configuration.handlers.get(t).lookup(e);
            }, t.prototype.contains = function (t, e) {
              return this.configuration.handlers.get(t).contains(e);
            }, t.prototype.toString = function () {
              var t,
                e,
                r = "";
              try {
                for (var o = n(Array.from(this.configuration.handlers.keys())), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  r += a + ": " + this.configuration.handlers.get(a) + "\n";
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, t.prototype.Parse = function () {
              for (var t; this.i < this.string.length;) t = this.getCodePoint(), this.i += t.length, this.parse("character", [this, t]);
            }, t.prototype.Push = function (t) {
              t instanceof l.AbstractMmlNode && t.isInferred ? this.PushAll(t.childNodes) : this.stack.Push(t);
            }, t.prototype.PushAll = function (t) {
              var e, r;
              try {
                for (var o = n(t), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  this.stack.Push(a);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.mml = function () {
              if (!this.stack.Top().isKind("mml")) return null;
              var t = this.stack.Top().First;
              return this.configuration.popParser(), t;
            }, t.prototype.convertDelimiter = function (t) {
              var e = this.lookup("delimiter", t);
              return e ? e.char : null;
            }, t.prototype.getCodePoint = function () {
              var t = this.string.codePointAt(this.i);
              return void 0 === t ? "" : String.fromCodePoint(t);
            }, t.prototype.nextIsSpace = function () {
              return !!this.string.charAt(this.i).match(/\s/);
            }, t.prototype.GetNext = function () {
              for (; this.nextIsSpace();) this.i++;
              return this.getCodePoint();
            }, t.prototype.GetCS = function () {
              var t = this.string.slice(this.i).match(/^(([a-z]+) ?|[\uD800-\uDBFF].|.)/i);
              return t ? (this.i += t[0].length, t[2] || t[1]) : (this.i++, " ");
            }, t.prototype.GetArgument = function (t, e) {
              switch (this.GetNext()) {
                case "":
                  if (!e) throw new T.default("MissingArgFor", "Missing argument for %1", this.currentCS);
                  return null;
                case "}":
                  if (!e) throw new T.default("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
                  return null;
                case "\\":
                  return this.i++, "\\" + this.GetCS();
                case "{":
                  for (var r = ++this.i, n = 1; this.i < this.string.length;) switch (this.string.charAt(this.i++)) {
                    case "\\":
                      this.i++;
                      break;
                    case "{":
                      n++;
                      break;
                    case "}":
                      if (0 == --n) return this.string.slice(r, this.i - 1);
                  }
                  throw new T.default("MissingCloseBrace", "Missing close brace");
              }
              var o = this.getCodePoint();
              return this.i += o.length, o;
            }, t.prototype.GetBrackets = function (t, e) {
              if ("[" !== this.GetNext()) return e;
              for (var r = ++this.i, n = 0; this.i < this.string.length;) switch (this.string.charAt(this.i++)) {
                case "{":
                  n++;
                  break;
                case "\\":
                  this.i++;
                  break;
                case "}":
                  if (n-- <= 0) throw new T.default("ExtraCloseLooking", "Extra close brace while looking for %1", "']'");
                  break;
                case "]":
                  if (0 === n) return this.string.slice(r, this.i - 1);
              }
              throw new T.default("MissingCloseBracket", "Could not find closing ']' for argument to %1", this.currentCS);
            }, t.prototype.GetDelimiter = function (t, e) {
              var r = this.GetNext();
              if (this.i += r.length, this.i <= this.string.length && ("\\" === r ? r += this.GetCS() : "{" === r && e && (this.i--, r = this.GetArgument(t).trim()), this.contains("delimiter", r))) return this.convertDelimiter(r);
              throw new T.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
            }, t.prototype.GetDimen = function (t) {
              if ("{" === this.GetNext()) {
                var e = this.GetArgument(t),
                  r = o(Q.default.matchDimen(e), 2),
                  n = r[0],
                  i = r[1];
                if (n) return n + i;
              } else {
                e = this.string.slice(this.i);
                var a = o(Q.default.matchDimen(e, !0), 3),
                  s = (n = a[0], i = a[1], a[2]);
                if (n) return this.i += s, n + i;
              }
              throw new T.default("MissingDimOrUnits", "Missing dimension or its units for %1", this.currentCS);
            }, t.prototype.GetUpTo = function (t, e) {
              for (; this.nextIsSpace();) this.i++;
              for (var r = this.i, n = 0; this.i < this.string.length;) {
                var o = this.i,
                  i = this.GetNext();
                switch (this.i += i.length, i) {
                  case "\\":
                    i += this.GetCS();
                    break;
                  case "{":
                    n++;
                    break;
                  case "}":
                    if (0 === n) throw new T.default("ExtraCloseLooking", "Extra close brace while looking for %1", e);
                    n--;
                }
                if (0 === n && i === e) return this.string.slice(r, o);
              }
              throw new T.default("TokenNotFoundForCommand", "Could not find %1 for %2", e, this.currentCS);
            }, t.prototype.ParseArg = function (e) {
              return new t(this.GetArgument(e), this.stack.env, this.configuration).mml();
            }, t.prototype.ParseUpTo = function (e, r) {
              return new t(this.GetUpTo(e, r), this.stack.env, this.configuration).mml();
            }, t.prototype.GetDelimiterArg = function (t) {
              var e = Q.default.trimSpaces(this.GetArgument(t));
              if ("" === e) return null;
              if (this.contains("delimiter", e)) return e;
              throw new T.default("MissingOrUnrecognizedDelim", "Missing or unrecognized delimiter for %1", this.currentCS);
            }, t.prototype.GetStar = function () {
              var t = "*" === this.GetNext();
              return t && this.i++, t;
            }, t.prototype.create = function (t) {
              for (var e, r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              return (e = this.configuration.nodeFactory).create.apply(e, i([t], o(r), !1));
            }, t;
          }();
        e.default = c;
      },
      8174: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ActionConfiguration = e.ActionMethods = void 0;
        var o = r(9899),
          i = n(r(8417)),
          a = r(9140),
          Q = n(r(7693));
        e.ActionMethods = {}, e.ActionMethods.Macro = Q.default.Macro, e.ActionMethods.Toggle = function (t, e) {
          for (var r, n = []; "\\endtoggle" !== (r = t.GetArgument(e));) n.push(new i.default(r, t.stack.env, t.configuration).mml());
          t.Push(t.create("node", "maction", n, {
            actiontype: "toggle"
          }));
        }, e.ActionMethods.Mathtip = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          t.Push(t.create("node", "maction", [r, n], {
            actiontype: "tooltip"
          }));
        }, new a.CommandMap("action-macros", {
          toggle: "Toggle",
          mathtip: "Mathtip",
          texttip: ["Macro", "\\mathtip{#1}{\\text{#2}}", 2]
        }, e.ActionMethods), e.ActionConfiguration = o.Configuration.create("action", {
          handler: {
            macro: ["action-macros"]
          }
        });
      },
      8021: function _(t, e, r) {
        var _n56,
          o,
          i = this && this.__extends || (_n56 = function n(t, e) {
            return _n56 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n56(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n56(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AmsConfiguration = e.AmsTags = void 0;
        var a = r(9899),
          Q = r(2790),
          s = r(6521),
          T = r(4387);
        r(7379);
        var l = r(9140),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), e;
          }(s.AbstractTags);
        e.AmsTags = c;
        e.AmsConfiguration = a.Configuration.create("ams", {
          handler: {
            character: ["AMSmath-operatorLetter"],
            delimiter: ["AMSsymbols-delimiter", "AMSmath-delimiter"],
            macro: ["AMSsymbols-mathchar0mi", "AMSsymbols-mathchar0mo", "AMSsymbols-delimiter", "AMSsymbols-macros", "AMSmath-mathchar0mo", "AMSmath-macros", "AMSmath-delimiter"],
            environment: ["AMSmath-environment"]
          },
          items: (o = {}, o[Q.MultlineItem.prototype.kind] = Q.MultlineItem, o[Q.FlalignItem.prototype.kind] = Q.FlalignItem, o),
          tags: {
            ams: c
          },
          init: function init(t) {
            new l.CommandMap(T.NEW_OPS, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [T.NEW_OPS]
              },
              priority: -1
            }));
          },
          config: function config(t, e) {
            e.parseOptions.options.multlineWidth && (e.parseOptions.options.ams.multlineWidth = e.parseOptions.options.multlineWidth), delete e.parseOptions.options.multlineWidth;
          },
          options: {
            multlineWidth: "",
            ams: {
              multlineWidth: "100%",
              multlineIndent: "1em"
            }
          }
        });
      },
      2790: function _(t, e, r) {
        var _n57,
          o = this && this.__extends || (_n57 = function n(t, e) {
            return _n57 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n57(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n57(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FlalignItem = e.MultlineItem = void 0;
        var Q = r(1181),
          s = a(r(1130)),
          T = a(r(1256)),
          l = a(r(3971)),
          c = r(8317),
          u = function (t) {
            function e(e) {
              for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              var o = t.call(this, e) || this;
              return o.factory.configuration.tags.start("multline", !0, r[0]), o;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "multline";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.EndEntry = function () {
              this.table.length && s.default.fixInitialMO(this.factory.configuration, this.nodes);
              var t = this.getProperty("shove"),
                e = this.create("node", "mtd", this.nodes, t ? {
                  columnalign: t
                } : {});
              this.setProperty("shove", null), this.row.push(e), this.Clear();
            }, e.prototype.EndRow = function () {
              if (1 !== this.row.length) throw new l.default("MultlineRowsOneCol", "The rows within the %1 environment must have exactly one column", "multline");
              var t = this.create("node", "mtr", this.row);
              this.table.push(t), this.row = [];
            }, e.prototype.EndTable = function () {
              if (t.prototype.EndTable.call(this), this.table.length) {
                var e = this.table.length - 1,
                  r = -1;
                T.default.getAttribute(T.default.getChildren(this.table[0])[0], "columnalign") || T.default.setAttribute(T.default.getChildren(this.table[0])[0], "columnalign", c.TexConstant.Align.LEFT), T.default.getAttribute(T.default.getChildren(this.table[e])[0], "columnalign") || T.default.setAttribute(T.default.getChildren(this.table[e])[0], "columnalign", c.TexConstant.Align.RIGHT);
                var n = this.factory.configuration.tags.getTag();
                if (n) {
                  r = this.arraydef.side === c.TexConstant.Align.LEFT ? 0 : this.table.length - 1;
                  var o = this.table[r],
                    i = this.create("node", "mlabeledtr", [n].concat(T.default.getChildren(o)));
                  T.default.copyAttributes(o, i), this.table[r] = i;
                }
              }
              this.factory.configuration.tags.end();
            }, e;
          }(Q.ArrayItem);
        e.MultlineItem = u;
        var p = function (t) {
          function e(e, r, n, o, i) {
            var a = t.call(this, e) || this;
            return a.name = r, a.numbered = n, a.padded = o, a.center = i, a.factory.configuration.tags.start(r, n, n), a;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "flalign";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.EndEntry = function () {
            t.prototype.EndEntry.call(this);
            var e = this.getProperty("xalignat");
            if (e && this.row.length > e) throw new l.default("XalignOverflow", "Extra %1 in row of %2", "&", this.name);
          }, e.prototype.EndRow = function () {
            for (var e, r = this.row, n = this.getProperty("xalignat"); r.length < n;) r.push(this.create("node", "mtd"));
            for (this.row = [], this.padded && this.row.push(this.create("node", "mtd")); e = r.shift();) this.row.push(e), (e = r.shift()) && this.row.push(e), (r.length || this.padded) && this.row.push(this.create("node", "mtd"));
            this.row.length > this.maxrow && (this.maxrow = this.row.length), t.prototype.EndRow.call(this);
            var o = this.table[this.table.length - 1];
            if (this.getProperty("zeroWidthLabel") && o.isKind("mlabeledtr")) {
              var a = T.default.getChildren(o)[0],
                Q = this.factory.configuration.options.tagSide,
                s = i({
                  width: 0
                }, "right" === Q ? {
                  lspace: "-1width"
                } : {}),
                l = this.create("node", "mpadded", T.default.getChildren(a), s);
              a.setChildren([l]);
            }
          }, e.prototype.EndTable = function () {
            (t.prototype.EndTable.call(this), this.center) && this.maxrow <= 2 && (delete this.arraydef.width, delete this.global.indentalign);
          }, e;
        }(Q.EqnArrayItem);
        e.FlalignItem = p;
      },
      7379: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = r(4387),
          s = i(r(9140)),
          T = r(8317),
          l = a(r(5450)),
          c = a(r(1130)),
          u = r(9007),
          p = r(6010);
        new s.CharacterMap("AMSmath-mathchar0mo", l.default.mathchar0mo, {
          iiiint: ["\u2A0C", {
            texClass: u.TEXCLASS.OP
          }]
        }), new s.RegExpMap("AMSmath-operatorLetter", Q.AmsMethods.operatorLetter, /[-*]/i), new s.CommandMap("AMSmath-macros", {
          mathring: ["Accent", "02DA"],
          nobreakspace: "Tilde",
          negmedspace: ["Spacer", p.MATHSPACE.negativemediummathspace],
          negthickspace: ["Spacer", p.MATHSPACE.negativethickmathspace],
          idotsint: ["MultiIntegral", "\\int\\cdots\\int"],
          dddot: ["Accent", "20DB"],
          ddddot: ["Accent", "20DC"],
          sideset: "SideSet",
          boxed: ["Macro", "\\fbox{$\\displaystyle{#1}$}", 1],
          tag: "HandleTag",
          notag: "HandleNoTag",
          eqref: ["HandleRef", !0],
          substack: ["Macro", "\\begin{subarray}{c}#1\\end{subarray}", 1],
          injlim: ["NamedOp", "inj&thinsp;lim"],
          projlim: ["NamedOp", "proj&thinsp;lim"],
          varliminf: ["Macro", "\\mathop{\\underline{\\mmlToken{mi}{lim}}}"],
          varlimsup: ["Macro", "\\mathop{\\overline{\\mmlToken{mi}{lim}}}"],
          varinjlim: ["Macro", "\\mathop{\\underrightarrow{\\mmlToken{mi}{lim}}}"],
          varprojlim: ["Macro", "\\mathop{\\underleftarrow{\\mmlToken{mi}{lim}}}"],
          DeclareMathOperator: "HandleDeclareOp",
          operatorname: "HandleOperatorName",
          genfrac: "Genfrac",
          frac: ["Genfrac", "", "", "", ""],
          tfrac: ["Genfrac", "", "", "", "1"],
          dfrac: ["Genfrac", "", "", "", "0"],
          binom: ["Genfrac", "(", ")", "0", ""],
          tbinom: ["Genfrac", "(", ")", "0", "1"],
          dbinom: ["Genfrac", "(", ")", "0", "0"],
          cfrac: "CFrac",
          shoveleft: ["HandleShove", T.TexConstant.Align.LEFT],
          shoveright: ["HandleShove", T.TexConstant.Align.RIGHT],
          xrightarrow: ["xArrow", 8594, 5, 10],
          xleftarrow: ["xArrow", 8592, 10, 5]
        }, Q.AmsMethods), new s.EnvironmentMap("AMSmath-environment", l.default.environment, {
          "equation*": ["Equation", null, !1],
          "eqnarray*": ["EqnArray", null, !1, !0, "rcl", c.default.cols(0, p.MATHSPACE.thickmathspace), ".5em"],
          align: ["EqnArray", null, !0, !0, "rl", c.default.cols(0, 2)],
          "align*": ["EqnArray", null, !1, !0, "rl", c.default.cols(0, 2)],
          multline: ["Multline", null, !0],
          "multline*": ["Multline", null, !1],
          split: ["EqnArray", null, !1, !1, "rl", c.default.cols(0)],
          gather: ["EqnArray", null, !0, !0, "c"],
          "gather*": ["EqnArray", null, !1, !0, "c"],
          alignat: ["AlignAt", null, !0, !0],
          "alignat*": ["AlignAt", null, !1, !0],
          alignedat: ["AlignAt", null, !1, !1],
          aligned: ["AmsEqnArray", null, null, null, "rl", c.default.cols(0, 2), ".5em", "D"],
          gathered: ["AmsEqnArray", null, null, null, "c", null, ".5em", "D"],
          xalignat: ["XalignAt", null, !0, !0],
          "xalignat*": ["XalignAt", null, !1, !0],
          xxalignat: ["XalignAt", null, !1, !1],
          flalign: ["FlalignArray", null, !0, !1, !0, "rlc", "auto auto fit"],
          "flalign*": ["FlalignArray", null, !1, !1, !0, "rlc", "auto auto fit"],
          subarray: ["Array", null, null, null, null, c.default.cols(0), "0.1em", "S", 1],
          smallmatrix: ["Array", null, null, null, "c", c.default.cols(1 / 3), ".2em", "S", 1],
          matrix: ["Array", null, null, null, "c"],
          pmatrix: ["Array", null, "(", ")", "c"],
          bmatrix: ["Array", null, "[", "]", "c"],
          Bmatrix: ["Array", null, "\\{", "\\}", "c"],
          vmatrix: ["Array", null, "\\vert", "\\vert", "c"],
          Vmatrix: ["Array", null, "\\Vert", "\\Vert", "c"],
          cases: ["Array", null, "\\{", ".", "ll", null, ".2em", "T"]
        }, Q.AmsMethods), new s.DelimiterMap("AMSmath-delimiter", l.default.delimiter, {
          "\\lvert": ["|", {
            texClass: u.TEXCLASS.OPEN
          }],
          "\\rvert": ["|", {
            texClass: u.TEXCLASS.CLOSE
          }],
          "\\lVert": ["\u2016", {
            texClass: u.TEXCLASS.OPEN
          }],
          "\\rVert": ["\u2016", {
            texClass: u.TEXCLASS.CLOSE
          }]
        }), new s.CharacterMap("AMSsymbols-mathchar0mi", l.default.mathchar0mi, {
          digamma: "\u03DD",
          varkappa: "\u03F0",
          varGamma: ["\u0393", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varDelta: ["\u0394", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varTheta: ["\u0398", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varLambda: ["\u039B", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varXi: ["\u039E", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varPi: ["\u03A0", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varSigma: ["\u03A3", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varUpsilon: ["\u03A5", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varPhi: ["\u03A6", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varPsi: ["\u03A8", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          varOmega: ["\u03A9", {
            mathvariant: T.TexConstant.Variant.ITALIC
          }],
          beth: "\u2136",
          gimel: "\u2137",
          daleth: "\u2138",
          backprime: ["\u2035", {
            variantForm: !0
          }],
          hslash: "\u210F",
          varnothing: ["\u2205", {
            variantForm: !0
          }],
          blacktriangle: "\u25B4",
          triangledown: ["\u25BD", {
            variantForm: !0
          }],
          blacktriangledown: "\u25BE",
          square: "\u25FB",
          Box: "\u25FB",
          blacksquare: "\u25FC",
          lozenge: "\u25CA",
          Diamond: "\u25CA",
          blacklozenge: "\u29EB",
          circledS: ["\u24C8", {
            mathvariant: T.TexConstant.Variant.NORMAL
          }],
          bigstar: "\u2605",
          sphericalangle: "\u2222",
          measuredangle: "\u2221",
          nexists: "\u2204",
          complement: "\u2201",
          mho: "\u2127",
          eth: ["\xf0", {
            mathvariant: T.TexConstant.Variant.NORMAL
          }],
          Finv: "\u2132",
          diagup: "\u2571",
          Game: "\u2141",
          diagdown: "\u2572",
          Bbbk: ["k", {
            mathvariant: T.TexConstant.Variant.DOUBLESTRUCK
          }],
          yen: "\xa5",
          circledR: "\xae",
          checkmark: "\u2713",
          maltese: "\u2720"
        }), new s.CharacterMap("AMSsymbols-mathchar0mo", l.default.mathchar0mo, {
          dotplus: "\u2214",
          ltimes: "\u22C9",
          smallsetminus: ["\u2216", {
            variantForm: !0
          }],
          rtimes: "\u22CA",
          Cap: "\u22D2",
          doublecap: "\u22D2",
          leftthreetimes: "\u22CB",
          Cup: "\u22D3",
          doublecup: "\u22D3",
          rightthreetimes: "\u22CC",
          barwedge: "\u22BC",
          curlywedge: "\u22CF",
          veebar: "\u22BB",
          curlyvee: "\u22CE",
          doublebarwedge: "\u2A5E",
          boxminus: "\u229F",
          circleddash: "\u229D",
          boxtimes: "\u22A0",
          circledast: "\u229B",
          boxdot: "\u22A1",
          circledcirc: "\u229A",
          boxplus: "\u229E",
          centerdot: ["\u22C5", {
            variantForm: !0
          }],
          divideontimes: "\u22C7",
          intercal: "\u22BA",
          leqq: "\u2266",
          geqq: "\u2267",
          leqslant: "\u2A7D",
          geqslant: "\u2A7E",
          eqslantless: "\u2A95",
          eqslantgtr: "\u2A96",
          lesssim: "\u2272",
          gtrsim: "\u2273",
          lessapprox: "\u2A85",
          gtrapprox: "\u2A86",
          approxeq: "\u224A",
          lessdot: "\u22D6",
          gtrdot: "\u22D7",
          lll: "\u22D8",
          llless: "\u22D8",
          ggg: "\u22D9",
          gggtr: "\u22D9",
          lessgtr: "\u2276",
          gtrless: "\u2277",
          lesseqgtr: "\u22DA",
          gtreqless: "\u22DB",
          lesseqqgtr: "\u2A8B",
          gtreqqless: "\u2A8C",
          doteqdot: "\u2251",
          Doteq: "\u2251",
          eqcirc: "\u2256",
          risingdotseq: "\u2253",
          circeq: "\u2257",
          fallingdotseq: "\u2252",
          triangleq: "\u225C",
          backsim: "\u223D",
          thicksim: ["\u223C", {
            variantForm: !0
          }],
          backsimeq: "\u22CD",
          thickapprox: ["\u2248", {
            variantForm: !0
          }],
          subseteqq: "\u2AC5",
          supseteqq: "\u2AC6",
          Subset: "\u22D0",
          Supset: "\u22D1",
          sqsubset: "\u228F",
          sqsupset: "\u2290",
          preccurlyeq: "\u227C",
          succcurlyeq: "\u227D",
          curlyeqprec: "\u22DE",
          curlyeqsucc: "\u22DF",
          precsim: "\u227E",
          succsim: "\u227F",
          precapprox: "\u2AB7",
          succapprox: "\u2AB8",
          vartriangleleft: "\u22B2",
          lhd: "\u22B2",
          vartriangleright: "\u22B3",
          rhd: "\u22B3",
          trianglelefteq: "\u22B4",
          unlhd: "\u22B4",
          trianglerighteq: "\u22B5",
          unrhd: "\u22B5",
          vDash: ["\u22A8", {
            variantForm: !0
          }],
          Vdash: "\u22A9",
          Vvdash: "\u22AA",
          smallsmile: ["\u2323", {
            variantForm: !0
          }],
          shortmid: ["\u2223", {
            variantForm: !0
          }],
          smallfrown: ["\u2322", {
            variantForm: !0
          }],
          shortparallel: ["\u2225", {
            variantForm: !0
          }],
          bumpeq: "\u224F",
          between: "\u226C",
          Bumpeq: "\u224E",
          pitchfork: "\u22D4",
          varpropto: ["\u221D", {
            variantForm: !0
          }],
          backepsilon: "\u220D",
          blacktriangleleft: "\u25C2",
          blacktriangleright: "\u25B8",
          therefore: "\u2234",
          because: "\u2235",
          eqsim: "\u2242",
          vartriangle: ["\u25B3", {
            variantForm: !0
          }],
          Join: "\u22C8",
          nless: "\u226E",
          ngtr: "\u226F",
          nleq: "\u2270",
          ngeq: "\u2271",
          nleqslant: ["\u2A87", {
            variantForm: !0
          }],
          ngeqslant: ["\u2A88", {
            variantForm: !0
          }],
          nleqq: ["\u2270", {
            variantForm: !0
          }],
          ngeqq: ["\u2271", {
            variantForm: !0
          }],
          lneq: "\u2A87",
          gneq: "\u2A88",
          lneqq: "\u2268",
          gneqq: "\u2269",
          lvertneqq: ["\u2268", {
            variantForm: !0
          }],
          gvertneqq: ["\u2269", {
            variantForm: !0
          }],
          lnsim: "\u22E6",
          gnsim: "\u22E7",
          lnapprox: "\u2A89",
          gnapprox: "\u2A8A",
          nprec: "\u2280",
          nsucc: "\u2281",
          npreceq: ["\u22E0", {
            variantForm: !0
          }],
          nsucceq: ["\u22E1", {
            variantForm: !0
          }],
          precneqq: "\u2AB5",
          succneqq: "\u2AB6",
          precnsim: "\u22E8",
          succnsim: "\u22E9",
          precnapprox: "\u2AB9",
          succnapprox: "\u2ABA",
          nsim: "\u2241",
          ncong: "\u2247",
          nshortmid: ["\u2224", {
            variantForm: !0
          }],
          nshortparallel: ["\u2226", {
            variantForm: !0
          }],
          nmid: "\u2224",
          nparallel: "\u2226",
          nvdash: "\u22AC",
          nvDash: "\u22AD",
          nVdash: "\u22AE",
          nVDash: "\u22AF",
          ntriangleleft: "\u22EA",
          ntriangleright: "\u22EB",
          ntrianglelefteq: "\u22EC",
          ntrianglerighteq: "\u22ED",
          nsubseteq: "\u2288",
          nsupseteq: "\u2289",
          nsubseteqq: ["\u2288", {
            variantForm: !0
          }],
          nsupseteqq: ["\u2289", {
            variantForm: !0
          }],
          subsetneq: "\u228A",
          supsetneq: "\u228B",
          varsubsetneq: ["\u228A", {
            variantForm: !0
          }],
          varsupsetneq: ["\u228B", {
            variantForm: !0
          }],
          subsetneqq: "\u2ACB",
          supsetneqq: "\u2ACC",
          varsubsetneqq: ["\u2ACB", {
            variantForm: !0
          }],
          varsupsetneqq: ["\u2ACC", {
            variantForm: !0
          }],
          leftleftarrows: "\u21C7",
          rightrightarrows: "\u21C9",
          leftrightarrows: "\u21C6",
          rightleftarrows: "\u21C4",
          Lleftarrow: "\u21DA",
          Rrightarrow: "\u21DB",
          twoheadleftarrow: "\u219E",
          twoheadrightarrow: "\u21A0",
          leftarrowtail: "\u21A2",
          rightarrowtail: "\u21A3",
          looparrowleft: "\u21AB",
          looparrowright: "\u21AC",
          leftrightharpoons: "\u21CB",
          rightleftharpoons: ["\u21CC", {
            variantForm: !0
          }],
          curvearrowleft: "\u21B6",
          curvearrowright: "\u21B7",
          circlearrowleft: "\u21BA",
          circlearrowright: "\u21BB",
          Lsh: "\u21B0",
          Rsh: "\u21B1",
          upuparrows: "\u21C8",
          downdownarrows: "\u21CA",
          upharpoonleft: "\u21BF",
          upharpoonright: "\u21BE",
          downharpoonleft: "\u21C3",
          restriction: "\u21BE",
          multimap: "\u22B8",
          downharpoonright: "\u21C2",
          leftrightsquigarrow: "\u21AD",
          rightsquigarrow: "\u21DD",
          leadsto: "\u21DD",
          dashrightarrow: "\u21E2",
          dashleftarrow: "\u21E0",
          nleftarrow: "\u219A",
          nrightarrow: "\u219B",
          nLeftarrow: "\u21CD",
          nRightarrow: "\u21CF",
          nleftrightarrow: "\u21AE",
          nLeftrightarrow: "\u21CE"
        }), new s.DelimiterMap("AMSsymbols-delimiter", l.default.delimiter, {
          "\\ulcorner": "\u231C",
          "\\urcorner": "\u231D",
          "\\llcorner": "\u231E",
          "\\lrcorner": "\u231F"
        }), new s.CommandMap("AMSsymbols-macros", {
          implies: ["Macro", "\\;\\Longrightarrow\\;"],
          impliedby: ["Macro", "\\;\\Longleftarrow\\;"]
        }, Q.AmsMethods);
      },
      4387: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NEW_OPS = e.AmsMethods = void 0;
        var a = i(r(1130)),
          Q = i(r(5450)),
          s = i(r(1256)),
          T = r(8317),
          l = i(r(8417)),
          c = i(r(3971)),
          u = r(8803),
          p = i(r(7693)),
          h = r(9007);
        function d(t) {
          if (!t || t.isInferred && 0 === t.childNodes.length) return [null, null];
          if (t.isKind("msubsup") && f(t)) return [t, null];
          var e = s.default.getChildAt(t, 0);
          return t.isInferred && e && f(e) ? (t.childNodes.splice(0, 1), [e, t]) : [null, t];
        }
        function f(t) {
          var e = t.childNodes[0];
          return e && e.isKind("mi") && "" === e.getText();
        }
        e.AmsMethods = {}, e.AmsMethods.AmsEqnArray = function (t, e, r, n, o, i, Q) {
          var s = t.GetBrackets("\\begin{" + e.getName() + "}"),
            T = p.default.EqnArray(t, e, r, n, o, i, Q);
          return a.default.setArrayAlign(T, s);
        }, e.AmsMethods.AlignAt = function (t, r, n, o) {
          var i,
            Q,
            s = r.getName(),
            T = "",
            l = [];
          if (o || (Q = t.GetBrackets("\\begin{" + s + "}")), (i = t.GetArgument("\\begin{" + s + "}")).match(/[^0-9]/)) throw new c.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + s + "}");
          for (var u = parseInt(i, 10); u > 0;) T += "rl", l.push("0em 0em"), u--;
          var p = l.join(" ");
          if (o) return e.AmsMethods.EqnArray(t, r, n, o, T, p);
          var h = e.AmsMethods.EqnArray(t, r, n, o, T, p);
          return a.default.setArrayAlign(h, Q);
        }, e.AmsMethods.Multline = function (t, e, r) {
          t.Push(e), a.default.checkEqnEnv(t);
          var n = t.itemFactory.create("multline", r, t.stack);
          return n.arraydef = {
            displaystyle: !0,
            rowspacing: ".5em",
            columnspacing: "100%",
            width: t.options.ams.multlineWidth,
            side: t.options.tagSide,
            minlabelspacing: t.options.tagIndent,
            framespacing: t.options.ams.multlineIndent + " 0",
            frame: "",
            "data-width-includes-label": !0
          }, n;
        }, e.AmsMethods.XalignAt = function (t, r, n, o) {
          var i = t.GetArgument("\\begin{" + r.getName() + "}");
          if (i.match(/[^0-9]/)) throw new c.default("PositiveIntegerArg", "Argument to %1 must me a positive integer", "\\begin{" + r.getName() + "}");
          var a = o ? "crl" : "rlc",
            Q = o ? "fit auto auto" : "auto auto fit",
            s = e.AmsMethods.FlalignArray(t, r, n, o, !1, a, Q, !0);
          return s.setProperty("xalignat", 2 * parseInt(i)), s;
        }, e.AmsMethods.FlalignArray = function (t, e, r, n, o, i, Q, s) {
          void 0 === s && (s = !1), t.Push(e), a.default.checkEqnEnv(t), i = i.split("").join(" ").replace(/r/g, "right").replace(/l/g, "left").replace(/c/g, "center");
          var T = t.itemFactory.create("flalign", e.getName(), r, n, o, t.stack);
          return T.arraydef = {
            width: "100%",
            displaystyle: !0,
            columnalign: i,
            columnspacing: "0em",
            columnwidth: Q,
            rowspacing: "3pt",
            side: t.options.tagSide,
            minlabelspacing: s ? "0" : t.options.tagIndent,
            "data-width-includes-label": !0
          }, T.setProperty("zeroWidthLabel", s), T;
        }, e.NEW_OPS = "ams-declare-ops", e.AmsMethods.HandleDeclareOp = function (t, r) {
          var n = t.GetStar() ? "*" : "",
            o = a.default.trimSpaces(t.GetArgument(r));
          "\\" === o.charAt(0) && (o = o.substr(1));
          var i = t.GetArgument(r);
          t.configuration.handlers.retrieve(e.NEW_OPS).add(o, new u.Macro(o, e.AmsMethods.Macro, ["\\operatorname".concat(n, "{").concat(i, "}")]));
        }, e.AmsMethods.HandleOperatorName = function (t, e) {
          var r = t.GetStar(),
            o = a.default.trimSpaces(t.GetArgument(e)),
            i = new l.default(o, n(n({}, t.stack.env), {
              font: T.TexConstant.Variant.NORMAL,
              multiLetterIdentifiers: /^[-*a-z]+/i,
              operatorLetters: !0
            }), t.configuration).mml();
          if (i.isKind("mi") || (i = t.create("node", "TeXAtom", [i])), s.default.setProperties(i, {
            movesupsub: r,
            movablelimits: !0,
            texClass: h.TEXCLASS.OP
          }), !r) {
            var Q = t.GetNext(),
              c = t.i;
            "\\" === Q && ++t.i && "limits" !== t.GetCS() && (t.i = c);
          }
          t.Push(i);
        }, e.AmsMethods.SideSet = function (t, e) {
          var r = o(d(t.ParseArg(e)), 2),
            n = r[0],
            i = r[1],
            Q = o(d(t.ParseArg(e)), 2),
            T = Q[0],
            l = Q[1],
            c = t.ParseArg(e),
            u = c;
          n && (i ? n.replaceChild(t.create("node", "mphantom", [t.create("node", "mpadded", [a.default.copyNode(c, t)], {
            width: 0
          })]), s.default.getChildAt(n, 0)) : (u = t.create("node", "mmultiscripts", [c]), T && s.default.appendChildren(u, [s.default.getChildAt(T, 1) || t.create("node", "none"), s.default.getChildAt(T, 2) || t.create("node", "none")]), s.default.setProperty(u, "scriptalign", "left"), s.default.appendChildren(u, [t.create("node", "mprescripts"), s.default.getChildAt(n, 1) || t.create("node", "none"), s.default.getChildAt(n, 2) || t.create("node", "none")]))), T && u === c && (T.replaceChild(c, s.default.getChildAt(T, 0)), u = T);
          var p = t.create("node", "TeXAtom", [], {
            texClass: h.TEXCLASS.OP,
            movesupsub: !0,
            movablelimits: !0
          });
          i && (n && p.appendChild(n), p.appendChild(i)), p.appendChild(u), l && p.appendChild(l), t.Push(p);
        }, e.AmsMethods.operatorLetter = function (t, e) {
          return !!t.stack.env.operatorLetters && Q.default.variable(t, e);
        }, e.AmsMethods.MultiIntegral = function (t, e, r) {
          var n = t.GetNext();
          if ("\\" === n) {
            var o = t.i;
            n = t.GetArgument(e), t.i = o, "\\limits" === n && (r = "\\idotsint" === e ? "\\!\\!\\mathop{\\,\\," + r + "}" : "\\!\\!\\!\\mathop{\\,\\,\\," + r + "}");
          }
          t.string = r + " " + t.string.slice(t.i), t.i = 0;
        }, e.AmsMethods.xArrow = function (t, e, r, n, o) {
          var i = {
              width: "+" + a.default.Em((n + o) / 18),
              lspace: a.default.Em(n / 18)
            },
            Q = t.GetBrackets(e),
            T = t.ParseArg(e),
            c = t.create("node", "mspace", [], {
              depth: ".25em"
            }),
            u = t.create("token", "mo", {
              stretchy: !0,
              texClass: h.TEXCLASS.REL
            }, String.fromCodePoint(r));
          u = t.create("node", "mstyle", [u], {
            scriptlevel: 0
          });
          var p = t.create("node", "munderover", [u]),
            d = t.create("node", "mpadded", [T, c], i);
          if (s.default.setAttribute(d, "voffset", "-.2em"), s.default.setAttribute(d, "height", "-.2em"), s.default.setChild(p, p.over, d), Q) {
            var f = new l.default(Q, t.stack.env, t.configuration).mml(),
              m = t.create("node", "mspace", [], {
                height: ".75em"
              });
            d = t.create("node", "mpadded", [f, m], i), s.default.setAttribute(d, "voffset", ".15em"), s.default.setAttribute(d, "depth", "-.15em"), s.default.setChild(p, p.under, d);
          }
          s.default.setProperty(p, "subsupOK", !0), t.Push(p);
        }, e.AmsMethods.HandleShove = function (t, e, r) {
          var n = t.stack.Top();
          if ("multline" !== n.kind) throw new c.default("CommandOnlyAllowedInEnv", "%1 only allowed in %2 environment", t.currentCS, "multline");
          if (n.Size()) throw new c.default("CommandAtTheBeginingOfLine", "%1 must come at the beginning of the line", t.currentCS);
          n.setProperty("shove", r);
        }, e.AmsMethods.CFrac = function (t, e) {
          var r = a.default.trimSpaces(t.GetBrackets(e, "")),
            n = t.GetArgument(e),
            o = t.GetArgument(e),
            i = {
              l: T.TexConstant.Align.LEFT,
              r: T.TexConstant.Align.RIGHT,
              "": ""
            },
            Q = new l.default("\\strut\\textstyle{" + n + "}", t.stack.env, t.configuration).mml(),
            u = new l.default("\\strut\\textstyle{" + o + "}", t.stack.env, t.configuration).mml(),
            p = t.create("node", "mfrac", [Q, u]);
          if (null == (r = i[r])) throw new c.default("IllegalAlign", "Illegal alignment specified in %1", t.currentCS);
          r && s.default.setProperties(p, {
            numalign: r,
            denomalign: r
          }), t.Push(p);
        }, e.AmsMethods.Genfrac = function (t, e, r, n, o, i) {
          null == r && (r = t.GetDelimiterArg(e)), null == n && (n = t.GetDelimiterArg(e)), null == o && (o = t.GetArgument(e)), null == i && (i = a.default.trimSpaces(t.GetArgument(e)));
          var Q = t.ParseArg(e),
            T = t.ParseArg(e),
            l = t.create("node", "mfrac", [Q, T]);
          if ("" !== o && s.default.setAttribute(l, "linethickness", o), (r || n) && (s.default.setProperty(l, "withDelims", !0), l = a.default.fixedFence(t.configuration, r, l, n)), "" !== i) {
            var u = parseInt(i, 10),
              p = ["D", "T", "S", "SS"][u];
            if (null == p) throw new c.default("BadMathStyleFor", "Bad math style for %1", t.currentCS);
            l = t.create("node", "mstyle", [l]), "D" === p ? s.default.setProperties(l, {
              displaystyle: !0,
              scriptlevel: 0
            }) : s.default.setProperties(l, {
              displaystyle: !1,
              scriptlevel: u - 1
            });
          }
          t.Push(l);
        }, e.AmsMethods.HandleTag = function (t, e) {
          if (!t.tags.currentTag.taggable && t.tags.env) throw new c.default("CommandNotAllowedInEnv", "%1 not allowed in %2 environment", t.currentCS, t.tags.env);
          if (t.tags.currentTag.tag) throw new c.default("MultipleCommand", "Multiple %1", t.currentCS);
          var r = t.GetStar(),
            n = a.default.trimSpaces(t.GetArgument(e));
          t.tags.tag(n, r);
        }, e.AmsMethods.HandleNoTag = p.default.HandleNoTag, e.AmsMethods.HandleRef = p.default.HandleRef, e.AmsMethods.Macro = p.default.Macro, e.AmsMethods.Accent = p.default.Accent, e.AmsMethods.Tilde = p.default.Tilde, e.AmsMethods.Array = p.default.Array, e.AmsMethods.Spacer = p.default.Spacer, e.AmsMethods.NamedOp = p.default.NamedOp, e.AmsMethods.EqnArray = p.default.EqnArray, e.AmsMethods.Equation = p.default.Equation;
      },
      583: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AmsCdConfiguration = void 0;
        var n = r(9899);
        r(8289), e.AmsCdConfiguration = n.Configuration.create("amscd", {
          handler: {
            character: ["amscd_special"],
            macro: ["amscd_macros"],
            environment: ["amscd_environment"]
          },
          options: {
            amscd: {
              colspace: "5pt",
              rowspace: "5pt",
              harrowsize: "2.75em",
              varrowsize: "1.75em",
              hideHorizontalLabels: !1
            }
          }
        });
      },
      8289: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = i(r(9140)),
          s = a(r(5450)),
          T = a(r(7819));
        new Q.EnvironmentMap("amscd_environment", s.default.environment, {
          CD: "CD"
        }, T.default), new Q.CommandMap("amscd_macros", {
          minCDarrowwidth: "minCDarrowwidth",
          minCDarrowheight: "minCDarrowheight"
        }, T.default), new Q.MacroMap("amscd_special", {
          "@": "arrow"
        }, T.default);
      },
      7819: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(8417)),
          i = r(2942),
          a = r(9007),
          Q = n(r(1256)),
          s = {
            CD: function CD(t, e) {
              t.Push(e);
              var r = t.itemFactory.create("array"),
                n = t.configuration.options.amscd;
              return r.setProperties({
                minw: t.stack.env.CD_minw || n.harrowsize,
                minh: t.stack.env.CD_minh || n.varrowsize
              }), r.arraydef = {
                columnalign: "center",
                columnspacing: n.colspace,
                rowspacing: n.rowspace,
                displaystyle: !0
              }, r;
            },
            arrow: function arrow(t, e) {
              var r = t.string.charAt(t.i);
              if (!r.match(/[><VA.|=]/)) return (0, i.Other)(t, e);
              t.i++;
              var n = t.stack.Top();
              n.isKind("array") && !n.Size() || (s.cell(t, e), n = t.stack.Top());
              for (var T, l = n, c = l.table.length % 2 == 1, u = (l.row.length + (c ? 0 : 1)) % 2; u;) s.cell(t, e), u--;
              var p = {
                  minsize: l.getProperty("minw"),
                  stretchy: !0
                },
                h = {
                  minsize: l.getProperty("minh"),
                  stretchy: !0,
                  symmetric: !0,
                  lspace: 0,
                  rspace: 0
                };
              if ("." === r) ;else if ("|" === r) T = t.create("token", "mo", h, "\u2225");else if ("=" === r) T = t.create("token", "mo", p, "=");else {
                var d = {
                    ">": "\u2192",
                    "<": "\u2190",
                    V: "\u2193",
                    A: "\u2191"
                  }[r],
                  f = t.GetUpTo(e + r, r),
                  m = t.GetUpTo(e + r, r);
                if (">" === r || "<" === r) {
                  if (T = t.create("token", "mo", p, d), f || (f = "\\kern " + l.getProperty("minw")), f || m) {
                    var L = {
                      width: "+.67em",
                      lspace: ".33em"
                    };
                    if (T = t.create("node", "munderover", [T]), f) {
                      var y = new o.default(f, t.stack.env, t.configuration).mml(),
                        g = t.create("node", "mpadded", [y], L);
                      Q.default.setAttribute(g, "voffset", ".1em"), Q.default.setChild(T, T.over, g);
                    }
                    if (m) {
                      var v = new o.default(m, t.stack.env, t.configuration).mml();
                      Q.default.setChild(T, T.under, t.create("node", "mpadded", [v], L));
                    }
                    t.configuration.options.amscd.hideHorizontalLabels && (T = t.create("node", "mpadded", T, {
                      depth: 0,
                      height: ".67em"
                    }));
                  }
                } else {
                  var b = t.create("token", "mo", h, d);
                  T = b, (f || m) && (T = t.create("node", "mrow"), f && Q.default.appendChildren(T, [new o.default("\\scriptstyle\\llap{" + f + "}", t.stack.env, t.configuration).mml()]), b.texClass = a.TEXCLASS.ORD, Q.default.appendChildren(T, [b]), m && Q.default.appendChildren(T, [new o.default("\\scriptstyle\\rlap{" + m + "}", t.stack.env, t.configuration).mml()]));
                }
              }
              T && t.Push(T), s.cell(t, e);
            },
            cell: function cell(t, e) {
              var r = t.stack.Top();
              (r.table || []).length % 2 == 0 && 0 === (r.row || []).length && t.Push(t.create("node", "mpadded", [], {
                height: "8.5pt",
                depth: "2pt"
              })), t.Push(t.itemFactory.create("cell").setProperties({
                isEntry: !0,
                name: e
              }));
            },
            minCDarrowwidth: function minCDarrowwidth(t, e) {
              t.stack.env.CD_minw = t.GetDimen(e);
            },
            minCDarrowheight: function minCDarrowheight(t, e) {
              t.stack.env.CD_minh = t.GetDimen(e);
            }
          };
        e.default = s;
      },
      1275: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoloadConfiguration = void 0;
        var i = r(9899),
          a = r(9140),
          Q = r(8803),
          s = r(7741),
          T = r(265),
          l = r(7233);
        function c(t, e, r, i) {
          var a, Q, l, c;
          if (T.Package.packages.has(t.options.require.prefix + r)) {
            var h = t.options.autoload[r],
              d = n(2 === h.length && Array.isArray(h[0]) ? h : [h, []], 2),
              f = d[0],
              m = d[1];
            try {
              for (var L = o(f), y = L.next(); !y.done; y = L.next()) {
                var g = y.value;
                u.remove(g);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                y && !y.done && (Q = L.return) && Q.call(L);
              } finally {
                if (a) throw a.error;
              }
            }
            try {
              for (var v = o(m), b = v.next(); !b.done; b = v.next()) {
                var H = b.value;
                p.remove(H);
              }
            } catch (t) {
              l = {
                error: t
              };
            } finally {
              try {
                b && !b.done && (c = v.return) && c.call(v);
              } finally {
                if (l) throw l.error;
              }
            }
            t.string = (i ? e + " " : "\\begin{" + e.slice(1) + "}") + t.string.slice(t.i), t.i = 0;
          }
          (0, s.RequireLoad)(t, r);
        }
        var u = new a.CommandMap("autoload-macros", {}, {}),
          p = new a.CommandMap("autoload-environments", {}, {});
        e.AutoloadConfiguration = i.Configuration.create("autoload", {
          handler: {
            macro: ["autoload-macros"],
            environment: ["autoload-environments"]
          },
          options: {
            autoload: (0, l.expandable)({
              action: ["toggle", "mathtip", "texttip"],
              amscd: [[], ["CD"]],
              bbox: ["bbox"],
              boldsymbol: ["boldsymbol"],
              braket: ["bra", "ket", "braket", "set", "Bra", "Ket", "Braket", "Set", "ketbra", "Ketbra"],
              bussproofs: [[], ["prooftree"]],
              cancel: ["cancel", "bcancel", "xcancel", "cancelto"],
              color: ["color", "definecolor", "textcolor", "colorbox", "fcolorbox"],
              enclose: ["enclose"],
              extpfeil: ["xtwoheadrightarrow", "xtwoheadleftarrow", "xmapsto", "xlongequal", "xtofrom", "Newextarrow"],
              html: ["href", "class", "style", "cssId"],
              mhchem: ["ce", "pu"],
              newcommand: ["newcommand", "renewcommand", "newenvironment", "renewenvironment", "def", "let"],
              unicode: ["unicode"],
              verb: ["verb"]
            })
          },
          config: function config(t, e) {
            var r,
              i,
              a,
              T,
              l,
              h,
              d = e.parseOptions,
              f = d.handlers.get("macro"),
              m = d.handlers.get("environment"),
              L = d.options.autoload;
            d.packageData.set("autoload", {
              Autoload: c
            });
            try {
              for (var y = o(Object.keys(L)), g = y.next(); !g.done; g = y.next()) {
                var v = g.value,
                  b = L[v],
                  H = n(2 === b.length && Array.isArray(b[0]) ? b : [b, []], 2),
                  _ = H[0],
                  M = H[1];
                try {
                  for (var x = (a = void 0, o(_)), O = x.next(); !O.done; O = x.next()) {
                    var S = O.value;
                    f.lookup(S) && "color" !== S || u.add(S, new Q.Macro(S, c, [v, !0]));
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    O && !O.done && (T = x.return) && T.call(x);
                  } finally {
                    if (a) throw a.error;
                  }
                }
                try {
                  for (var V = (l = void 0, o(M)), E = V.next(); !E.done; E = V.next()) {
                    var A = E.value;
                    m.lookup(A) || p.add(A, new Q.Macro(A, c, [v, !1]));
                  }
                } catch (t) {
                  l = {
                    error: t
                  };
                } finally {
                  try {
                    E && !E.done && (h = V.return) && h.call(V);
                  } finally {
                    if (l) throw l.error;
                  }
                }
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                g && !g.done && (i = y.return) && i.call(y);
              } finally {
                if (r) throw r.error;
              }
            }
            d.packageData.get("require") || s.RequireConfiguration.config(t, e);
          },
          init: function init(t) {
            t.options.require || (0, l.defaultOptions)(t.options, s.RequireConfiguration.options);
          },
          priority: 10
        });
      },
      2942: function _(t, e, r) {
        var _n58,
          o,
          i = this && this.__extends || (_n58 = function n(t, e) {
            return _n58 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n58(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n58(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          Q = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          s = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && a(e, t, r);
            return Q(e, t), e;
          },
          T = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          l = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BaseConfiguration = e.BaseTags = e.Other = void 0;
        var c = r(9899),
          u = r(2947),
          p = l(r(3971)),
          h = l(r(1256)),
          d = r(9140),
          f = s(r(1181)),
          m = r(6521);
        r(1267);
        var L = r(4082);
        function y(t, e) {
          var r = t.stack.env.font ? {
              mathvariant: t.stack.env.font
            } : {},
            n = u.MapHandler.getMap("remap").lookup(e),
            o = (0, L.getRange)(e),
            i = o ? o[3] : "mo",
            a = t.create("token", i, r, n ? n.char : e);
          o[4] && a.attributes.set("mathvariant", o[4]), "mo" === i && (h.default.setProperty(a, "fixStretchy", !0), t.configuration.addNode("fixStretchy", a)), t.Push(a);
        }
        new d.CharacterMap("remap", null, {
          "-": "\u2212",
          "*": "\u2217",
          "`": "\u2018"
        }), e.Other = y;
        var g = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return i(e, t), e;
        }(m.AbstractTags);
        e.BaseTags = g, e.BaseConfiguration = c.Configuration.create("base", {
          handler: {
            character: ["command", "special", "letter", "digit"],
            delimiter: ["delimiter"],
            macro: ["delimiter", "macros", "mathchar0mi", "mathchar0mo", "mathchar7"],
            environment: ["environment"]
          },
          fallback: {
            character: y,
            macro: function macro(t, e) {
              throw new p.default("UndefinedControlSequence", "Undefined control sequence %1", "\\" + e);
            },
            environment: function environment(t, e) {
              throw new p.default("UnknownEnv", "Unknown environment '%1'", e);
            }
          },
          items: (o = {}, o[f.StartItem.prototype.kind] = f.StartItem, o[f.StopItem.prototype.kind] = f.StopItem, o[f.OpenItem.prototype.kind] = f.OpenItem, o[f.CloseItem.prototype.kind] = f.CloseItem, o[f.PrimeItem.prototype.kind] = f.PrimeItem, o[f.SubsupItem.prototype.kind] = f.SubsupItem, o[f.OverItem.prototype.kind] = f.OverItem, o[f.LeftItem.prototype.kind] = f.LeftItem, o[f.Middle.prototype.kind] = f.Middle, o[f.RightItem.prototype.kind] = f.RightItem, o[f.BeginItem.prototype.kind] = f.BeginItem, o[f.EndItem.prototype.kind] = f.EndItem, o[f.StyleItem.prototype.kind] = f.StyleItem, o[f.PositionItem.prototype.kind] = f.PositionItem, o[f.CellItem.prototype.kind] = f.CellItem, o[f.MmlItem.prototype.kind] = f.MmlItem, o[f.FnItem.prototype.kind] = f.FnItem, o[f.NotItem.prototype.kind] = f.NotItem, o[f.NonscriptItem.prototype.kind] = f.NonscriptItem, o[f.DotsItem.prototype.kind] = f.DotsItem, o[f.ArrayItem.prototype.kind] = f.ArrayItem, o[f.EqnArrayItem.prototype.kind] = f.EqnArrayItem, o[f.EquationItem.prototype.kind] = f.EquationItem, o),
          options: {
            maxMacros: 1e3,
            baseURL: "undefined" == typeof document || 0 === document.getElementsByTagName("base").length ? "" : String(document.location).replace(/#.*$/, "")
          },
          tags: {
            base: g
          },
          postprocessors: [[function (t) {
            var e,
              r,
              n = t.data;
            try {
              for (var o = T(n.getList("nonscript")), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                if (a.attributes.get("scriptlevel") > 0) {
                  var Q = a.parent;
                  if (Q.childNodes.splice(Q.childIndex(a), 1), n.removeFromList(a.kind, [a]), a.isKind("mrow")) {
                    var s = a.childNodes[0];
                    n.removeFromList("mstyle", [s]), n.removeFromList("mspace", s.childNodes[0].childNodes);
                  }
                } else a.isKind("mrow") && (a.parent.replaceChild(a.childNodes[0], a), n.removeFromList("mrow", [a]));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, -4]]
        });
      },
      1181: function _(t, e, r) {
        var _n59,
          o = this && this.__extends || (_n59 = function n(t, e) {
            return _n59 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n59(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n59(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EquationItem = e.EqnArrayItem = e.ArrayItem = e.DotsItem = e.NonscriptItem = e.NotItem = e.FnItem = e.MmlItem = e.CellItem = e.PositionItem = e.StyleItem = e.EndItem = e.BeginItem = e.RightItem = e.Middle = e.LeftItem = e.OverItem = e.SubsupItem = e.PrimeItem = e.CloseItem = e.OpenItem = e.StopItem = e.StartItem = void 0;
        var s = r(2947),
          T = r(5368),
          l = r(9007),
          c = Q(r(3971)),
          u = Q(r(1130)),
          p = Q(r(1256)),
          h = r(8292),
          d = function (t) {
            function e(e, r) {
              var n = t.call(this, e) || this;
              return n.global = r, n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "start";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              if (e.isKind("stop")) {
                var r = this.toMml();
                return this.global.isInner || (r = this.factory.configuration.tags.finalize(r, this.env)), [[this.factory.create("mml", r)], !0];
              }
              return t.prototype.checkItem.call(this, e);
            }, e;
          }(h.BaseItem);
        e.StartItem = d;
        var f = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "stop";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.StopItem = f;
        var m = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "open";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("close")) {
              var r = this.toMml(),
                n = this.create("node", "TeXAtom", [r]);
              return [[this.factory.create("mml", n)], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.errors = Object.assign(Object.create(h.BaseItem.errors), {
            stop: ["ExtraOpenMissingClose", "Extra open brace or missing close brace"]
          }), e;
        }(h.BaseItem);
        e.OpenItem = m;
        var L = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "close";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.CloseItem = L;
        var y = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "prime";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            var e = i(this.Peek(2), 2),
              r = e[0],
              n = e[1];
            return !p.default.isType(r, "msubsup") || p.default.isType(r, "msup") ? [[this.create("node", "msup", [r, n]), t], !0] : (p.default.setChild(r, r.sup, n), [[r, t], !0]);
          }, e;
        }(h.BaseItem);
        e.PrimeItem = y;
        var g = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "subsup";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("open") || e.isKind("left")) return h.BaseItem.success;
            var r = this.First,
              n = this.getProperty("position");
            if (e.isKind("mml")) {
              if (this.getProperty("primes")) if (2 !== n) p.default.setChild(r, 2, this.getProperty("primes"));else {
                p.default.setProperty(this.getProperty("primes"), "variantForm", !0);
                var o = this.create("node", "mrow", [this.getProperty("primes"), e.First]);
                e.First = o;
              }
              return p.default.setChild(r, n, e.First), null != this.getProperty("movesupsub") && p.default.setProperty(r, "movesupsub", this.getProperty("movesupsub")), [[this.factory.create("mml", r)], !0];
            }
            if (t.prototype.checkItem.call(this, e)[1]) {
              var Q = this.getErrors(["", "sub", "sup"][n]);
              throw new (c.default.bind.apply(c.default, a([void 0, Q[0], Q[1]], i(Q.splice(2)), !1)))();
            }
            return null;
          }, e.errors = Object.assign(Object.create(h.BaseItem.errors), {
            stop: ["MissingScript", "Missing superscript or subscript argument"],
            sup: ["MissingOpenForSup", "Missing open brace for superscript"],
            sub: ["MissingOpenForSub", "Missing open brace for subscript"]
          }), e;
        }(h.BaseItem);
        e.SubsupItem = g;
        var v = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.setProperty("name", "\\over"), r;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "over";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("over")) throw new c.default("AmbiguousUseOf", "Ambiguous use of %1", e.getName());
            if (e.isClose) {
              var r = this.create("node", "mfrac", [this.getProperty("num"), this.toMml(!1)]);
              return null != this.getProperty("thickness") && p.default.setAttribute(r, "linethickness", this.getProperty("thickness")), (this.getProperty("open") || this.getProperty("close")) && (p.default.setProperty(r, "withDelims", !0), r = u.default.fixedFence(this.factory.configuration, this.getProperty("open"), r, this.getProperty("close"))), [[this.factory.create("mml", r), e], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.prototype.toString = function () {
            return "over[" + this.getProperty("num") + " / " + this.nodes.join("; ") + "]";
          }, e;
        }(h.BaseItem);
        e.OverItem = v;
        var b = function (t) {
          function e(e, r) {
            var n = t.call(this, e) || this;
            return n.setProperty("delim", r), n;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "left";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("right")) return [[this.factory.create("mml", u.default.fenced(this.factory.configuration, this.getProperty("delim"), this.toMml(), e.getProperty("delim"), "", e.getProperty("color")))], !0];
            if (e.isKind("middle")) {
              var r = {
                stretchy: !0
              };
              return e.getProperty("color") && (r.mathcolor = e.getProperty("color")), this.Push(this.create("node", "TeXAtom", [], {
                texClass: l.TEXCLASS.CLOSE
              }), this.create("token", "mo", r, e.getProperty("delim")), this.create("node", "TeXAtom", [], {
                texClass: l.TEXCLASS.OPEN
              })), this.env = {}, [[this], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.errors = Object.assign(Object.create(h.BaseItem.errors), {
            stop: ["ExtraLeftMissingRight", "Extra \\left or missing \\right"]
          }), e;
        }(h.BaseItem);
        e.LeftItem = b;
        var H = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e) || this;
            return o.setProperty("delim", r), n && o.setProperty("color", n), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "middle";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.Middle = H;
        var _ = function (t) {
          function e(e, r, n) {
            var o = t.call(this, e) || this;
            return o.setProperty("delim", r), n && o.setProperty("color", n), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "right";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.RightItem = _;
        var M = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "begin";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("end")) {
              if (e.getName() !== this.getName()) throw new c.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e.getName());
              return this.getProperty("end") ? h.BaseItem.fail : [[this.factory.create("mml", this.toMml())], !0];
            }
            if (e.isKind("stop")) throw new c.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(h.BaseItem);
        e.BeginItem = M;
        var x = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "end";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.EndItem = x;
        var O = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "style";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (!e.isClose) return t.prototype.checkItem.call(this, e);
            var r = this.create("node", "mstyle", this.nodes, this.getProperty("styles"));
            return [[this.factory.create("mml", r), e], !0];
          }, e;
        }(h.BaseItem);
        e.StyleItem = O;
        var S = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "position";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isClose) throw new c.default("MissingBoxFor", "Missing box for %1", this.getName());
            if (e.isFinal) {
              var r = e.toMml();
              switch (this.getProperty("move")) {
                case "vertical":
                  return r = this.create("node", "mpadded", [r], {
                    height: this.getProperty("dh"),
                    depth: this.getProperty("dd"),
                    voffset: this.getProperty("dh")
                  }), [[this.factory.create("mml", r)], !0];
                case "horizontal":
                  return [[this.factory.create("mml", this.getProperty("left")), e, this.factory.create("mml", this.getProperty("right"))], !0];
              }
            }
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(h.BaseItem);
        e.PositionItem = S;
        var V = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "cell";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isClose", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.CellItem = V;
        var E = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "isFinal", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "mml";
            },
            enumerable: !1,
            configurable: !0
          }), e;
        }(h.BaseItem);
        e.MmlItem = E;
        var A = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "fn";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            var r = this.First;
            if (r) {
              if (e.isOpen) return h.BaseItem.success;
              if (!e.isKind("fn")) {
                var n = e.First;
                if (!e.isKind("mml") || !n) return [[r, e], !0];
                if (p.default.isType(n, "mstyle") && n.childNodes.length && p.default.isType(n.childNodes[0].childNodes[0], "mspace") || p.default.isType(n, "mspace")) return [[r, e], !0];
                p.default.isEmbellished(n) && (n = p.default.getCoreMO(n));
                var o = p.default.getForm(n);
                if (null != o && [0, 0, 1, 1, 0, 1, 1, 0, 0, 0][o[2]]) return [[r, e], !0];
              }
              var i = this.create("token", "mo", {
                texClass: l.TEXCLASS.NONE
              }, T.entities.ApplyFunction);
              return [[r, i, e], !0];
            }
            return t.prototype.checkItem.apply(this, arguments);
          }, e;
        }(h.BaseItem);
        e.FnItem = A;
        var C = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.remap = s.MapHandler.getMap("not_remap"), e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "not";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            var e, r, n;
            if (t.isKind("open") || t.isKind("left")) return h.BaseItem.success;
            if (t.isKind("mml") && (p.default.isType(t.First, "mo") || p.default.isType(t.First, "mi") || p.default.isType(t.First, "mtext")) && (e = t.First, 1 === (r = p.default.getText(e)).length && !p.default.getProperty(e, "movesupsub") && 1 === p.default.getChildren(e).length)) return this.remap.contains(r) ? (n = this.create("text", this.remap.lookup(r).char), p.default.setChild(e, 0, n)) : (n = this.create("text", "\u0338"), p.default.appendChildren(e, [n])), [[t], !0];
            n = this.create("text", "\u29F8");
            var o = this.create("node", "mtext", [], {}, n),
              i = this.create("node", "mpadded", [o], {
                width: 0
              });
            return [[e = this.create("node", "TeXAtom", [i], {
              texClass: l.TEXCLASS.REL
            }), t], !0];
          }, e;
        }(h.BaseItem);
        e.NotItem = C;
        var w = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "nonscript";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            if (t.isKind("mml") && 1 === t.Size()) {
              var e = t.First;
              if (e.isKind("mstyle") && e.notParent && (e = p.default.getChildren(p.default.getChildren(e)[0])[0]), e.isKind("mspace")) {
                if (e !== t.First) {
                  var r = this.create("node", "mrow", [t.Pop()]);
                  t.Push(r);
                }
                this.factory.configuration.addNode("nonscript", t.First);
              }
            }
            return [[t], !0];
          }, e;
        }(h.BaseItem);
        e.NonscriptItem = w;
        var N = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "dots";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (t) {
            if (t.isKind("open") || t.isKind("left")) return h.BaseItem.success;
            var e = this.getProperty("ldots"),
              r = t.First;
            if (t.isKind("mml") && p.default.isEmbellished(r)) {
              var n = p.default.getTexClass(p.default.getCoreMO(r));
              n !== l.TEXCLASS.BIN && n !== l.TEXCLASS.REL || (e = this.getProperty("cdots"));
            }
            return [[e, t], !0];
          }, e;
        }(h.BaseItem);
        e.DotsItem = N;
        var P = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.table = [], e.row = [], e.frame = [], e.hfill = [], e.arraydef = {}, e.dashed = !1, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "array";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "copyEnv", {
            get: function get() {
              return !1;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isClose && !e.isKind("over")) {
              if (e.getProperty("isEntry")) return this.EndEntry(), this.clearEnv(), h.BaseItem.fail;
              if (e.getProperty("isCR")) return this.EndEntry(), this.EndRow(), this.clearEnv(), h.BaseItem.fail;
              this.EndTable(), this.clearEnv();
              var r = this.factory.create("mml", this.createMml());
              if (this.getProperty("requireClose")) {
                if (e.isKind("close")) return [[r], !0];
                throw new c.default("MissingCloseBrace", "Missing close brace");
              }
              return [[r, e], !0];
            }
            return t.prototype.checkItem.call(this, e);
          }, e.prototype.createMml = function () {
            var t = this.arraydef.scriptlevel;
            delete this.arraydef.scriptlevel;
            var e = this.create("node", "mtable", this.table, this.arraydef);
            return t && e.setProperty("scriptlevel", t), 4 === this.frame.length ? p.default.setAttribute(e, "frame", this.dashed ? "dashed" : "solid") : this.frame.length && (this.arraydef.rowlines && (this.arraydef.rowlines = this.arraydef.rowlines.replace(/none( none)+$/, "none")), p.default.setAttribute(e, "frame", ""), e = this.create("node", "menclose", [e], {
              notation: this.frame.join(" ")
            }), "none" === (this.arraydef.columnlines || "none") && "none" === (this.arraydef.rowlines || "none") || p.default.setAttribute(e, "data-padding", 0)), (this.getProperty("open") || this.getProperty("close")) && (e = u.default.fenced(this.factory.configuration, this.getProperty("open"), e, this.getProperty("close"))), e;
          }, e.prototype.EndEntry = function () {
            var t = this.create("node", "mtd", this.nodes);
            this.hfill.length && (0 === this.hfill[0] && p.default.setAttribute(t, "columnalign", "right"), this.hfill[this.hfill.length - 1] === this.Size() && p.default.setAttribute(t, "columnalign", p.default.getAttribute(t, "columnalign") ? "center" : "left")), this.row.push(t), this.Clear(), this.hfill = [];
          }, e.prototype.EndRow = function () {
            var t;
            this.getProperty("isNumbered") && 3 === this.row.length ? (this.row.unshift(this.row.pop()), t = this.create("node", "mlabeledtr", this.row)) : t = this.create("node", "mtr", this.row), this.table.push(t), this.row = [];
          }, e.prototype.EndTable = function () {
            (this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.checkLines();
          }, e.prototype.checkLines = function () {
            if (this.arraydef.rowlines) {
              var t = this.arraydef.rowlines.split(/ /);
              t.length === this.table.length ? (this.frame.push("bottom"), t.pop(), this.arraydef.rowlines = t.join(" ")) : t.length < this.table.length - 1 && (this.arraydef.rowlines += " none");
            }
            if (this.getProperty("rowspacing")) {
              for (var e = this.arraydef.rowspacing.split(/ /); e.length < this.table.length;) e.push(this.getProperty("rowspacing") + "em");
              this.arraydef.rowspacing = e.join(" ");
            }
          }, e.prototype.addRowSpacing = function (t) {
            if (this.arraydef.rowspacing) {
              var e = this.arraydef.rowspacing.split(/ /);
              if (!this.getProperty("rowspacing")) {
                var r = u.default.dimen2em(e[0]);
                this.setProperty("rowspacing", r);
              }
              for (var n = this.getProperty("rowspacing"); e.length < this.table.length;) e.push(u.default.Em(n));
              e[this.table.length - 1] = u.default.Em(Math.max(0, n + u.default.dimen2em(t))), this.arraydef.rowspacing = e.join(" ");
            }
          }, e;
        }(h.BaseItem);
        e.ArrayItem = P;
        var k = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, e) || this;
            return o.maxrow = 0, o.factory.configuration.tags.start(r[0], r[2], r[1]), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "eqnarray";
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.EndEntry = function () {
            this.row.length && u.default.fixInitialMO(this.factory.configuration, this.nodes);
            var t = this.create("node", "mtd", this.nodes);
            this.row.push(t), this.Clear();
          }, e.prototype.EndRow = function () {
            this.row.length > this.maxrow && (this.maxrow = this.row.length);
            var t = "mtr",
              e = this.factory.configuration.tags.getTag();
            e && (this.row = [e].concat(this.row), t = "mlabeledtr"), this.factory.configuration.tags.clearTag();
            var r = this.create("node", t, this.row);
            this.table.push(r), this.row = [];
          }, e.prototype.EndTable = function () {
            t.prototype.EndTable.call(this), this.factory.configuration.tags.end(), this.extendArray("columnalign", this.maxrow), this.extendArray("columnwidth", this.maxrow), this.extendArray("columnspacing", this.maxrow - 1);
          }, e.prototype.extendArray = function (t, e) {
            if (this.arraydef[t]) {
              var r = this.arraydef[t].split(/ /),
                n = a([], i(r), !1);
              if (n.length > 1) {
                for (; n.length < e;) n.push.apply(n, a([], i(r), !1));
                this.arraydef[t] = n.slice(0, e).join(" ");
              }
            }
          }, e;
        }(P);
        e.EqnArrayItem = k;
        var I = function (t) {
          function e(e) {
            for (var r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
            var o = t.call(this, e) || this;
            return o.factory.configuration.tags.start("equation", !0, r[0]), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "kind", {
            get: function get() {
              return "equation";
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "isOpen", {
            get: function get() {
              return !0;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.checkItem = function (e) {
            if (e.isKind("end")) {
              var r = this.toMml(),
                n = this.factory.configuration.tags.getTag();
              return this.factory.configuration.tags.end(), [[n ? this.factory.configuration.tags.enTag(r, n) : r, e], !0];
            }
            if (e.isKind("stop")) throw new c.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
            return t.prototype.checkItem.call(this, e);
          }, e;
        }(h.BaseItem);
        e.EquationItem = I;
      },
      1267: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = i(r(9140)),
          s = r(8317),
          T = a(r(7693)),
          l = a(r(5450)),
          c = a(r(1130)),
          u = r(9007),
          p = r(6010);
        new Q.RegExpMap("letter", l.default.variable, /[a-z]/i), new Q.RegExpMap("digit", l.default.digit, /[0-9.,]/), new Q.RegExpMap("command", l.default.controlSequence, /^\\/), new Q.MacroMap("special", {
          "{": "Open",
          "}": "Close",
          "~": "Tilde",
          "^": "Superscript",
          _: "Subscript",
          " ": "Space",
          "\t": "Space",
          "\r": "Space",
          "\n": "Space",
          "'": "Prime",
          "%": "Comment",
          "&": "Entry",
          "#": "Hash",
          "\xa0": "Space",
          "\u2019": "Prime"
        }, T.default), new Q.CharacterMap("mathchar0mi", l.default.mathchar0mi, {
          alpha: "\u03B1",
          beta: "\u03B2",
          gamma: "\u03B3",
          delta: "\u03B4",
          epsilon: "\u03F5",
          zeta: "\u03B6",
          eta: "\u03B7",
          theta: "\u03B8",
          iota: "\u03B9",
          kappa: "\u03BA",
          lambda: "\u03BB",
          mu: "\u03BC",
          nu: "\u03BD",
          xi: "\u03BE",
          omicron: "\u03BF",
          pi: "\u03C0",
          rho: "\u03C1",
          sigma: "\u03C3",
          tau: "\u03C4",
          upsilon: "\u03C5",
          phi: "\u03D5",
          chi: "\u03C7",
          psi: "\u03C8",
          omega: "\u03C9",
          varepsilon: "\u03B5",
          vartheta: "\u03D1",
          varpi: "\u03D6",
          varrho: "\u03F1",
          varsigma: "\u03C2",
          varphi: "\u03C6",
          S: ["\xa7", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          aleph: ["\u2135", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          hbar: ["\u210F", {
            variantForm: !0
          }],
          imath: "\u0131",
          jmath: "\u0237",
          ell: "\u2113",
          wp: ["\u2118", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          Re: ["\u211C", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          Im: ["\u2111", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          partial: ["\u2202", {
            mathvariant: s.TexConstant.Variant.ITALIC
          }],
          infty: ["\u221E", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          prime: ["\u2032", {
            variantForm: !0
          }],
          emptyset: ["\u2205", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          nabla: ["\u2207", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          top: ["\u22A4", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          bot: ["\u22A5", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          angle: ["\u2220", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          triangle: ["\u25B3", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          backslash: ["\u2216", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          forall: ["\u2200", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          exists: ["\u2203", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          neg: ["\xac", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          lnot: ["\xac", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          flat: ["\u266D", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          natural: ["\u266E", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          sharp: ["\u266F", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          clubsuit: ["\u2663", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          diamondsuit: ["\u2662", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          heartsuit: ["\u2661", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }],
          spadesuit: ["\u2660", {
            mathvariant: s.TexConstant.Variant.NORMAL
          }]
        }), new Q.CharacterMap("mathchar0mo", l.default.mathchar0mo, {
          surd: "\u221A",
          coprod: ["\u2210", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigvee: ["\u22C1", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigwedge: ["\u22C0", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          biguplus: ["\u2A04", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigcap: ["\u22C2", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigcup: ["\u22C3", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          int: ["\u222B", {
            texClass: u.TEXCLASS.OP
          }],
          intop: ["\u222B", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0,
            movablelimits: !0
          }],
          iint: ["\u222C", {
            texClass: u.TEXCLASS.OP
          }],
          iiint: ["\u222D", {
            texClass: u.TEXCLASS.OP
          }],
          prod: ["\u220F", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          sum: ["\u2211", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigotimes: ["\u2A02", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigoplus: ["\u2A01", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          bigodot: ["\u2A00", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          oint: ["\u222E", {
            texClass: u.TEXCLASS.OP
          }],
          bigsqcup: ["\u2A06", {
            texClass: u.TEXCLASS.OP,
            movesupsub: !0
          }],
          smallint: ["\u222B", {
            largeop: !1
          }],
          triangleleft: "\u25C3",
          triangleright: "\u25B9",
          bigtriangleup: "\u25B3",
          bigtriangledown: "\u25BD",
          wedge: "\u2227",
          land: "\u2227",
          vee: "\u2228",
          lor: "\u2228",
          cap: "\u2229",
          cup: "\u222A",
          ddagger: "\u2021",
          dagger: "\u2020",
          sqcap: "\u2293",
          sqcup: "\u2294",
          uplus: "\u228E",
          amalg: "\u2A3F",
          diamond: "\u22C4",
          bullet: "\u2219",
          wr: "\u2240",
          div: "\xf7",
          divsymbol: "\xf7",
          odot: ["\u2299", {
            largeop: !1
          }],
          oslash: ["\u2298", {
            largeop: !1
          }],
          otimes: ["\u2297", {
            largeop: !1
          }],
          ominus: ["\u2296", {
            largeop: !1
          }],
          oplus: ["\u2295", {
            largeop: !1
          }],
          mp: "\u2213",
          pm: "\xb1",
          circ: "\u2218",
          bigcirc: "\u25EF",
          setminus: "\u2216",
          cdot: "\u22C5",
          ast: "\u2217",
          times: "\xd7",
          star: "\u22C6",
          propto: "\u221D",
          sqsubseteq: "\u2291",
          sqsupseteq: "\u2292",
          parallel: "\u2225",
          mid: "\u2223",
          dashv: "\u22A3",
          vdash: "\u22A2",
          leq: "\u2264",
          le: "\u2264",
          geq: "\u2265",
          ge: "\u2265",
          lt: "<",
          gt: ">",
          succ: "\u227B",
          prec: "\u227A",
          approx: "\u2248",
          succeq: "\u2AB0",
          preceq: "\u2AAF",
          supset: "\u2283",
          subset: "\u2282",
          supseteq: "\u2287",
          subseteq: "\u2286",
          in: "\u2208",
          ni: "\u220B",
          notin: "\u2209",
          owns: "\u220B",
          gg: "\u226B",
          ll: "\u226A",
          sim: "\u223C",
          simeq: "\u2243",
          perp: "\u22A5",
          equiv: "\u2261",
          asymp: "\u224D",
          smile: "\u2323",
          frown: "\u2322",
          ne: "\u2260",
          neq: "\u2260",
          cong: "\u2245",
          doteq: "\u2250",
          bowtie: "\u22C8",
          models: "\u22A8",
          notChar: "\u29F8",
          Leftrightarrow: "\u21D4",
          Leftarrow: "\u21D0",
          Rightarrow: "\u21D2",
          leftrightarrow: "\u2194",
          leftarrow: "\u2190",
          gets: "\u2190",
          rightarrow: "\u2192",
          to: ["\u2192", {
            accent: !1
          }],
          mapsto: "\u21A6",
          leftharpoonup: "\u21BC",
          leftharpoondown: "\u21BD",
          rightharpoonup: "\u21C0",
          rightharpoondown: "\u21C1",
          nearrow: "\u2197",
          searrow: "\u2198",
          nwarrow: "\u2196",
          swarrow: "\u2199",
          rightleftharpoons: "\u21CC",
          hookrightarrow: "\u21AA",
          hookleftarrow: "\u21A9",
          longleftarrow: "\u27F5",
          Longleftarrow: "\u27F8",
          longrightarrow: "\u27F6",
          Longrightarrow: "\u27F9",
          Longleftrightarrow: "\u27FA",
          longleftrightarrow: "\u27F7",
          longmapsto: "\u27FC",
          ldots: "\u2026",
          cdots: "\u22EF",
          vdots: "\u22EE",
          ddots: "\u22F1",
          dotsc: "\u2026",
          dotsb: "\u22EF",
          dotsm: "\u22EF",
          dotsi: "\u22EF",
          dotso: "\u2026",
          ldotp: [".", {
            texClass: u.TEXCLASS.PUNCT
          }],
          cdotp: ["\u22C5", {
            texClass: u.TEXCLASS.PUNCT
          }],
          colon: [":", {
            texClass: u.TEXCLASS.PUNCT
          }]
        }), new Q.CharacterMap("mathchar7", l.default.mathchar7, {
          Gamma: "\u0393",
          Delta: "\u0394",
          Theta: "\u0398",
          Lambda: "\u039B",
          Xi: "\u039E",
          Pi: "\u03A0",
          Sigma: "\u03A3",
          Upsilon: "\u03A5",
          Phi: "\u03A6",
          Psi: "\u03A8",
          Omega: "\u03A9",
          _: "_",
          "#": "#",
          $: "$",
          "%": "%",
          "&": "&",
          And: "&"
        }), new Q.DelimiterMap("delimiter", l.default.delimiter, {
          "(": "(",
          ")": ")",
          "[": "[",
          "]": "]",
          "<": "\u27E8",
          ">": "\u27E9",
          "\\lt": "\u27E8",
          "\\gt": "\u27E9",
          "/": "/",
          "|": ["|", {
            texClass: u.TEXCLASS.ORD
          }],
          ".": "",
          "\\\\": "\\",
          "\\lmoustache": "\u23B0",
          "\\rmoustache": "\u23B1",
          "\\lgroup": "\u27EE",
          "\\rgroup": "\u27EF",
          "\\arrowvert": "\u23D0",
          "\\Arrowvert": "\u2016",
          "\\bracevert": "\u23AA",
          "\\Vert": ["\u2016", {
            texClass: u.TEXCLASS.ORD
          }],
          "\\|": ["\u2016", {
            texClass: u.TEXCLASS.ORD
          }],
          "\\vert": ["|", {
            texClass: u.TEXCLASS.ORD
          }],
          "\\uparrow": "\u2191",
          "\\downarrow": "\u2193",
          "\\updownarrow": "\u2195",
          "\\Uparrow": "\u21D1",
          "\\Downarrow": "\u21D3",
          "\\Updownarrow": "\u21D5",
          "\\backslash": "\\",
          "\\rangle": "\u27E9",
          "\\langle": "\u27E8",
          "\\rbrace": "}",
          "\\lbrace": "{",
          "\\}": "}",
          "\\{": "{",
          "\\rceil": "\u2309",
          "\\lceil": "\u2308",
          "\\rfloor": "\u230B",
          "\\lfloor": "\u230A",
          "\\lbrack": "[",
          "\\rbrack": "]"
        }), new Q.CommandMap("macros", {
          displaystyle: ["SetStyle", "D", !0, 0],
          textstyle: ["SetStyle", "T", !1, 0],
          scriptstyle: ["SetStyle", "S", !1, 1],
          scriptscriptstyle: ["SetStyle", "SS", !1, 2],
          rm: ["SetFont", s.TexConstant.Variant.NORMAL],
          mit: ["SetFont", s.TexConstant.Variant.ITALIC],
          oldstyle: ["SetFont", s.TexConstant.Variant.OLDSTYLE],
          cal: ["SetFont", s.TexConstant.Variant.CALLIGRAPHIC],
          it: ["SetFont", s.TexConstant.Variant.MATHITALIC],
          bf: ["SetFont", s.TexConstant.Variant.BOLD],
          bbFont: ["SetFont", s.TexConstant.Variant.DOUBLESTRUCK],
          scr: ["SetFont", s.TexConstant.Variant.SCRIPT],
          frak: ["SetFont", s.TexConstant.Variant.FRAKTUR],
          sf: ["SetFont", s.TexConstant.Variant.SANSSERIF],
          tt: ["SetFont", s.TexConstant.Variant.MONOSPACE],
          mathrm: ["MathFont", s.TexConstant.Variant.NORMAL],
          mathup: ["MathFont", s.TexConstant.Variant.NORMAL],
          mathnormal: ["MathFont", ""],
          mathbf: ["MathFont", s.TexConstant.Variant.BOLD],
          mathbfup: ["MathFont", s.TexConstant.Variant.BOLD],
          mathit: ["MathFont", s.TexConstant.Variant.MATHITALIC],
          mathbfit: ["MathFont", s.TexConstant.Variant.BOLDITALIC],
          mathbb: ["MathFont", s.TexConstant.Variant.DOUBLESTRUCK],
          Bbb: ["MathFont", s.TexConstant.Variant.DOUBLESTRUCK],
          mathfrak: ["MathFont", s.TexConstant.Variant.FRAKTUR],
          mathbffrak: ["MathFont", s.TexConstant.Variant.BOLDFRAKTUR],
          mathscr: ["MathFont", s.TexConstant.Variant.SCRIPT],
          mathbfscr: ["MathFont", s.TexConstant.Variant.BOLDSCRIPT],
          mathsf: ["MathFont", s.TexConstant.Variant.SANSSERIF],
          mathsfup: ["MathFont", s.TexConstant.Variant.SANSSERIF],
          mathbfsf: ["MathFont", s.TexConstant.Variant.BOLDSANSSERIF],
          mathbfsfup: ["MathFont", s.TexConstant.Variant.BOLDSANSSERIF],
          mathsfit: ["MathFont", s.TexConstant.Variant.SANSSERIFITALIC],
          mathbfsfit: ["MathFont", s.TexConstant.Variant.SANSSERIFBOLDITALIC],
          mathtt: ["MathFont", s.TexConstant.Variant.MONOSPACE],
          mathcal: ["MathFont", s.TexConstant.Variant.CALLIGRAPHIC],
          mathbfcal: ["MathFont", s.TexConstant.Variant.BOLDCALLIGRAPHIC],
          symrm: ["MathFont", s.TexConstant.Variant.NORMAL],
          symup: ["MathFont", s.TexConstant.Variant.NORMAL],
          symnormal: ["MathFont", ""],
          symbf: ["MathFont", s.TexConstant.Variant.BOLD],
          symbfup: ["MathFont", s.TexConstant.Variant.BOLD],
          symit: ["MathFont", s.TexConstant.Variant.ITALIC],
          symbfit: ["MathFont", s.TexConstant.Variant.BOLDITALIC],
          symbb: ["MathFont", s.TexConstant.Variant.DOUBLESTRUCK],
          symfrak: ["MathFont", s.TexConstant.Variant.FRAKTUR],
          symbffrak: ["MathFont", s.TexConstant.Variant.BOLDFRAKTUR],
          symscr: ["MathFont", s.TexConstant.Variant.SCRIPT],
          symbfscr: ["MathFont", s.TexConstant.Variant.BOLDSCRIPT],
          symsf: ["MathFont", s.TexConstant.Variant.SANSSERIF],
          symsfup: ["MathFont", s.TexConstant.Variant.SANSSERIF],
          symbfsf: ["MathFont", s.TexConstant.Variant.BOLDSANSSERIF],
          symbfsfup: ["MathFont", s.TexConstant.Variant.BOLDSANSSERIF],
          symsfit: ["MathFont", s.TexConstant.Variant.SANSSERIFITALIC],
          symbfsfit: ["MathFont", s.TexConstant.Variant.SANSSERIFBOLDITALIC],
          symtt: ["MathFont", s.TexConstant.Variant.MONOSPACE],
          symcal: ["MathFont", s.TexConstant.Variant.CALLIGRAPHIC],
          symbfcal: ["MathFont", s.TexConstant.Variant.BOLDCALLIGRAPHIC],
          textrm: ["HBox", null, s.TexConstant.Variant.NORMAL],
          textup: ["HBox", null, s.TexConstant.Variant.NORMAL],
          textnormal: ["HBox"],
          textit: ["HBox", null, s.TexConstant.Variant.ITALIC],
          textbf: ["HBox", null, s.TexConstant.Variant.BOLD],
          textsf: ["HBox", null, s.TexConstant.Variant.SANSSERIF],
          texttt: ["HBox", null, s.TexConstant.Variant.MONOSPACE],
          tiny: ["SetSize", .5],
          Tiny: ["SetSize", .6],
          scriptsize: ["SetSize", .7],
          small: ["SetSize", .85],
          normalsize: ["SetSize", 1],
          large: ["SetSize", 1.2],
          Large: ["SetSize", 1.44],
          LARGE: ["SetSize", 1.73],
          huge: ["SetSize", 2.07],
          Huge: ["SetSize", 2.49],
          arcsin: "NamedFn",
          arccos: "NamedFn",
          arctan: "NamedFn",
          arg: "NamedFn",
          cos: "NamedFn",
          cosh: "NamedFn",
          cot: "NamedFn",
          coth: "NamedFn",
          csc: "NamedFn",
          deg: "NamedFn",
          det: "NamedOp",
          dim: "NamedFn",
          exp: "NamedFn",
          gcd: "NamedOp",
          hom: "NamedFn",
          inf: "NamedOp",
          ker: "NamedFn",
          lg: "NamedFn",
          lim: "NamedOp",
          liminf: ["NamedOp", "lim&thinsp;inf"],
          limsup: ["NamedOp", "lim&thinsp;sup"],
          ln: "NamedFn",
          log: "NamedFn",
          max: "NamedOp",
          min: "NamedOp",
          Pr: "NamedOp",
          sec: "NamedFn",
          sin: "NamedFn",
          sinh: "NamedFn",
          sup: "NamedOp",
          tan: "NamedFn",
          tanh: "NamedFn",
          limits: ["Limits", 1],
          nolimits: ["Limits", 0],
          overline: ["UnderOver", "2015"],
          underline: ["UnderOver", "2015"],
          overbrace: ["UnderOver", "23DE", 1],
          underbrace: ["UnderOver", "23DF", 1],
          overparen: ["UnderOver", "23DC"],
          underparen: ["UnderOver", "23DD"],
          overrightarrow: ["UnderOver", "2192"],
          underrightarrow: ["UnderOver", "2192"],
          overleftarrow: ["UnderOver", "2190"],
          underleftarrow: ["UnderOver", "2190"],
          overleftrightarrow: ["UnderOver", "2194"],
          underleftrightarrow: ["UnderOver", "2194"],
          overset: "Overset",
          underset: "Underset",
          overunderset: "Overunderset",
          stackrel: ["Macro", "\\mathrel{\\mathop{#2}\\limits^{#1}}", 2],
          stackbin: ["Macro", "\\mathbin{\\mathop{#2}\\limits^{#1}}", 2],
          over: "Over",
          overwithdelims: "Over",
          atop: "Over",
          atopwithdelims: "Over",
          above: "Over",
          abovewithdelims: "Over",
          brace: ["Over", "{", "}"],
          brack: ["Over", "[", "]"],
          choose: ["Over", "(", ")"],
          frac: "Frac",
          sqrt: "Sqrt",
          root: "Root",
          uproot: ["MoveRoot", "upRoot"],
          leftroot: ["MoveRoot", "leftRoot"],
          left: "LeftRight",
          right: "LeftRight",
          middle: "LeftRight",
          llap: "Lap",
          rlap: "Lap",
          raise: "RaiseLower",
          lower: "RaiseLower",
          moveleft: "MoveLeftRight",
          moveright: "MoveLeftRight",
          ",": ["Spacer", p.MATHSPACE.thinmathspace],
          ":": ["Spacer", p.MATHSPACE.mediummathspace],
          ">": ["Spacer", p.MATHSPACE.mediummathspace],
          ";": ["Spacer", p.MATHSPACE.thickmathspace],
          "!": ["Spacer", p.MATHSPACE.negativethinmathspace],
          enspace: ["Spacer", .5],
          quad: ["Spacer", 1],
          qquad: ["Spacer", 2],
          thinspace: ["Spacer", p.MATHSPACE.thinmathspace],
          negthinspace: ["Spacer", p.MATHSPACE.negativethinmathspace],
          hskip: "Hskip",
          hspace: "Hskip",
          kern: "Hskip",
          mskip: "Hskip",
          mspace: "Hskip",
          mkern: "Hskip",
          rule: "rule",
          Rule: ["Rule"],
          Space: ["Rule", "blank"],
          nonscript: "Nonscript",
          big: ["MakeBig", u.TEXCLASS.ORD, .85],
          Big: ["MakeBig", u.TEXCLASS.ORD, 1.15],
          bigg: ["MakeBig", u.TEXCLASS.ORD, 1.45],
          Bigg: ["MakeBig", u.TEXCLASS.ORD, 1.75],
          bigl: ["MakeBig", u.TEXCLASS.OPEN, .85],
          Bigl: ["MakeBig", u.TEXCLASS.OPEN, 1.15],
          biggl: ["MakeBig", u.TEXCLASS.OPEN, 1.45],
          Biggl: ["MakeBig", u.TEXCLASS.OPEN, 1.75],
          bigr: ["MakeBig", u.TEXCLASS.CLOSE, .85],
          Bigr: ["MakeBig", u.TEXCLASS.CLOSE, 1.15],
          biggr: ["MakeBig", u.TEXCLASS.CLOSE, 1.45],
          Biggr: ["MakeBig", u.TEXCLASS.CLOSE, 1.75],
          bigm: ["MakeBig", u.TEXCLASS.REL, .85],
          Bigm: ["MakeBig", u.TEXCLASS.REL, 1.15],
          biggm: ["MakeBig", u.TEXCLASS.REL, 1.45],
          Biggm: ["MakeBig", u.TEXCLASS.REL, 1.75],
          mathord: ["TeXAtom", u.TEXCLASS.ORD],
          mathop: ["TeXAtom", u.TEXCLASS.OP],
          mathopen: ["TeXAtom", u.TEXCLASS.OPEN],
          mathclose: ["TeXAtom", u.TEXCLASS.CLOSE],
          mathbin: ["TeXAtom", u.TEXCLASS.BIN],
          mathrel: ["TeXAtom", u.TEXCLASS.REL],
          mathpunct: ["TeXAtom", u.TEXCLASS.PUNCT],
          mathinner: ["TeXAtom", u.TEXCLASS.INNER],
          vcenter: ["TeXAtom", u.TEXCLASS.VCENTER],
          buildrel: "BuildRel",
          hbox: ["HBox", 0],
          text: "HBox",
          mbox: ["HBox", 0],
          fbox: "FBox",
          boxed: ["Macro", "\\fbox{$\\displaystyle{#1}$}", 1],
          framebox: "FrameBox",
          strut: "Strut",
          mathstrut: ["Macro", "\\vphantom{(}"],
          phantom: "Phantom",
          vphantom: ["Phantom", 1, 0],
          hphantom: ["Phantom", 0, 1],
          smash: "Smash",
          acute: ["Accent", "00B4"],
          grave: ["Accent", "0060"],
          ddot: ["Accent", "00A8"],
          tilde: ["Accent", "007E"],
          bar: ["Accent", "00AF"],
          breve: ["Accent", "02D8"],
          check: ["Accent", "02C7"],
          hat: ["Accent", "005E"],
          vec: ["Accent", "2192"],
          dot: ["Accent", "02D9"],
          widetilde: ["Accent", "007E", 1],
          widehat: ["Accent", "005E", 1],
          matrix: "Matrix",
          array: "Matrix",
          pmatrix: ["Matrix", "(", ")"],
          cases: ["Matrix", "{", "", "left left", null, ".1em", null, !0],
          eqalign: ["Matrix", null, null, "right left", (0, p.em)(p.MATHSPACE.thickmathspace), ".5em", "D"],
          displaylines: ["Matrix", null, null, "center", null, ".5em", "D"],
          cr: "Cr",
          "\\": "CrLaTeX",
          newline: ["CrLaTeX", !0],
          hline: ["HLine", "solid"],
          hdashline: ["HLine", "dashed"],
          eqalignno: ["Matrix", null, null, "right left", (0, p.em)(p.MATHSPACE.thickmathspace), ".5em", "D", null, "right"],
          leqalignno: ["Matrix", null, null, "right left", (0, p.em)(p.MATHSPACE.thickmathspace), ".5em", "D", null, "left"],
          hfill: "HFill",
          hfil: "HFill",
          hfilll: "HFill",
          bmod: ["Macro", '\\mmlToken{mo}[lspace="thickmathspace" rspace="thickmathspace"]{mod}'],
          pmod: ["Macro", "\\pod{\\mmlToken{mi}{mod}\\kern 6mu #1}", 1],
          mod: ["Macro", "\\mathchoice{\\kern18mu}{\\kern12mu}{\\kern12mu}{\\kern12mu}\\mmlToken{mi}{mod}\\,\\,#1", 1],
          pod: ["Macro", "\\mathchoice{\\kern18mu}{\\kern8mu}{\\kern8mu}{\\kern8mu}(#1)", 1],
          iff: ["Macro", "\\;\\Longleftrightarrow\\;"],
          skew: ["Macro", "{{#2{#3\\mkern#1mu}\\mkern-#1mu}{}}", 3],
          pmb: ["Macro", "\\rlap{#1}\\kern1px{#1}", 1],
          TeX: ["Macro", "T\\kern-.14em\\lower.5ex{E}\\kern-.115em X"],
          LaTeX: ["Macro", "L\\kern-.325em\\raise.21em{\\scriptstyle{A}}\\kern-.17em\\TeX"],
          " ": ["Macro", "\\text{ }"],
          not: "Not",
          dots: "Dots",
          space: "Tilde",
          "\xa0": "Tilde",
          begin: "BeginEnd",
          end: "BeginEnd",
          label: "HandleLabel",
          ref: "HandleRef",
          nonumber: "HandleNoTag",
          mathchoice: "MathChoice",
          mmlToken: "MmlToken"
        }, T.default), new Q.EnvironmentMap("environment", l.default.environment, {
          array: ["AlignedArray"],
          equation: ["Equation", null, !0],
          eqnarray: ["EqnArray", null, !0, !0, "rcl", c.default.cols(0, p.MATHSPACE.thickmathspace), ".5em"]
        }, T.default), new Q.CharacterMap("not_remap", null, {
          "\u2190": "\u219A",
          "\u2192": "\u219B",
          "\u2194": "\u21AE",
          "\u21D0": "\u21CD",
          "\u21D2": "\u21CF",
          "\u21D4": "\u21CE",
          "\u2208": "\u2209",
          "\u220B": "\u220C",
          "\u2223": "\u2224",
          "\u2225": "\u2226",
          "\u223C": "\u2241",
          "~": "\u2241",
          "\u2243": "\u2244",
          "\u2245": "\u2247",
          "\u2248": "\u2249",
          "\u224D": "\u226D",
          "=": "\u2260",
          "\u2261": "\u2262",
          "<": "\u226E",
          ">": "\u226F",
          "\u2264": "\u2270",
          "\u2265": "\u2271",
          "\u2272": "\u2274",
          "\u2273": "\u2275",
          "\u2276": "\u2278",
          "\u2277": "\u2279",
          "\u227A": "\u2280",
          "\u227B": "\u2281",
          "\u2282": "\u2284",
          "\u2283": "\u2285",
          "\u2286": "\u2288",
          "\u2287": "\u2289",
          "\u22A2": "\u22AC",
          "\u22A8": "\u22AD",
          "\u22A9": "\u22AE",
          "\u22AB": "\u22AF",
          "\u227C": "\u22E0",
          "\u227D": "\u22E1",
          "\u2291": "\u22E2",
          "\u2292": "\u22E3",
          "\u22B2": "\u22EA",
          "\u22B3": "\u22EB",
          "\u22B4": "\u22EC",
          "\u22B5": "\u22ED",
          "\u2203": "\u2204"
        });
      },
      7693: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          a = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && o(e, t, r);
            return i(e, t), e;
          },
          Q = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var T = a(r(1181)),
          l = s(r(1256)),
          c = s(r(3971)),
          u = s(r(8417)),
          p = r(8317),
          h = s(r(1130)),
          d = r(9007),
          f = r(6521),
          m = r(6010),
          L = r(5368),
          y = r(7233),
          g = {},
          v = {
            fontfamily: 1,
            fontsize: 1,
            fontweight: 1,
            fontstyle: 1,
            color: 1,
            background: 1,
            id: 1,
            class: 1,
            href: 1,
            style: 1
          };
        function b(t, e) {
          var r = t.stack.env,
            n = r.inRoot;
          r.inRoot = !0;
          var o = new u.default(e, r, t.configuration),
            i = o.mml(),
            a = o.stack.global;
          if (a.leftRoot || a.upRoot) {
            var Q = {};
            a.leftRoot && (Q.width = a.leftRoot), a.upRoot && (Q.voffset = a.upRoot, Q.height = a.upRoot), i = t.create("node", "mpadded", [i], Q);
          }
          return r.inRoot = n, i;
        }
        g.Open = function (t, e) {
          t.Push(t.itemFactory.create("open"));
        }, g.Close = function (t, e) {
          t.Push(t.itemFactory.create("close"));
        }, g.Tilde = function (t, e) {
          t.Push(t.create("token", "mtext", {}, L.entities.nbsp));
        }, g.Space = function (t, e) {}, g.Superscript = function (t, e) {
          var r, n, o;
          t.GetNext().match(/\d/) && (t.string = t.string.substr(0, t.i + 1) + " " + t.string.substr(t.i + 1));
          var i = t.stack.Top();
          i.isKind("prime") ? (o = (r = Q(i.Peek(2), 2))[0], n = r[1], t.stack.Pop()) : (o = t.stack.Prev()) || (o = t.create("token", "mi", {}, ""));
          var a = l.default.getProperty(o, "movesupsub"),
            s = l.default.isType(o, "msubsup") ? o.sup : o.over;
          if (l.default.isType(o, "msubsup") && !l.default.isType(o, "msup") && l.default.getChildAt(o, o.sup) || l.default.isType(o, "munderover") && !l.default.isType(o, "mover") && l.default.getChildAt(o, o.over) && !l.default.getProperty(o, "subsupOK")) throw new c.default("DoubleExponent", "Double exponent: use braces to clarify");
          l.default.isType(o, "msubsup") && !l.default.isType(o, "msup") || (a ? ((!l.default.isType(o, "munderover") || l.default.isType(o, "mover") || l.default.getChildAt(o, o.over)) && (o = t.create("node", "munderover", [o], {
            movesupsub: !0
          })), s = o.over) : s = (o = t.create("node", "msubsup", [o])).sup), t.Push(t.itemFactory.create("subsup", o).setProperties({
            position: s,
            primes: n,
            movesupsub: a
          }));
        }, g.Subscript = function (t, e) {
          var r, n, o;
          t.GetNext().match(/\d/) && (t.string = t.string.substr(0, t.i + 1) + " " + t.string.substr(t.i + 1));
          var i = t.stack.Top();
          i.isKind("prime") ? (o = (r = Q(i.Peek(2), 2))[0], n = r[1], t.stack.Pop()) : (o = t.stack.Prev()) || (o = t.create("token", "mi", {}, ""));
          var a = l.default.getProperty(o, "movesupsub"),
            s = l.default.isType(o, "msubsup") ? o.sub : o.under;
          if (l.default.isType(o, "msubsup") && !l.default.isType(o, "msup") && l.default.getChildAt(o, o.sub) || l.default.isType(o, "munderover") && !l.default.isType(o, "mover") && l.default.getChildAt(o, o.under) && !l.default.getProperty(o, "subsupOK")) throw new c.default("DoubleSubscripts", "Double subscripts: use braces to clarify");
          l.default.isType(o, "msubsup") && !l.default.isType(o, "msup") || (a ? ((!l.default.isType(o, "munderover") || l.default.isType(o, "mover") || l.default.getChildAt(o, o.under)) && (o = t.create("node", "munderover", [o], {
            movesupsub: !0
          })), s = o.under) : s = (o = t.create("node", "msubsup", [o])).sub), t.Push(t.itemFactory.create("subsup", o).setProperties({
            position: s,
            primes: n,
            movesupsub: a
          }));
        }, g.Prime = function (t, e) {
          var r = t.stack.Prev();
          if (r || (r = t.create("node", "mi")), l.default.isType(r, "msubsup") && !l.default.isType(r, "msup") && l.default.getChildAt(r, r.sup)) throw new c.default("DoubleExponentPrime", "Prime causes double exponent: use braces to clarify");
          var n = "";
          t.i--;
          do {
            n += L.entities.prime, t.i++, e = t.GetNext();
          } while ("'" === e || e === L.entities.rsquo);
          n = ["", "\u2032", "\u2033", "\u2034", "\u2057"][n.length] || n;
          var o = t.create("token", "mo", {
            variantForm: !0
          }, n);
          t.Push(t.itemFactory.create("prime", r, o));
        }, g.Comment = function (t, e) {
          for (; t.i < t.string.length && "\n" !== t.string.charAt(t.i);) t.i++;
        }, g.Hash = function (t, e) {
          throw new c.default("CantUseHash1", "You can't use 'macro parameter character #' in math mode");
        }, g.MathFont = function (t, e, r) {
          var o = t.GetArgument(e),
            i = new u.default(o, n(n({}, t.stack.env), {
              font: r,
              multiLetterIdentifiers: /^[a-zA-Z]+/,
              noAutoOP: !0
            }), t.configuration).mml();
          t.Push(t.create("node", "TeXAtom", [i]));
        }, g.SetFont = function (t, e, r) {
          t.stack.env.font = r;
        }, g.SetStyle = function (t, e, r, n, o) {
          t.stack.env.style = r, t.stack.env.level = o, t.Push(t.itemFactory.create("style").setProperty("styles", {
            displaystyle: n,
            scriptlevel: o
          }));
        }, g.SetSize = function (t, e, r) {
          t.stack.env.size = r, t.Push(t.itemFactory.create("style").setProperty("styles", {
            mathsize: (0, m.em)(r)
          }));
        }, g.Spacer = function (t, e, r) {
          var n = t.create("node", "mspace", [], {
              width: (0, m.em)(r)
            }),
            o = t.create("node", "mstyle", [n], {
              scriptlevel: 0
            });
          t.Push(o);
        }, g.LeftRight = function (t, e) {
          var r = e.substr(1);
          t.Push(t.itemFactory.create(r, t.GetDelimiter(e), t.stack.env.color));
        }, g.NamedFn = function (t, e, r) {
          r || (r = e.substr(1));
          var n = t.create("token", "mi", {
            texClass: d.TEXCLASS.OP
          }, r);
          t.Push(t.itemFactory.create("fn", n));
        }, g.NamedOp = function (t, e, r) {
          r || (r = e.substr(1)), r = r.replace(/&thinsp;/, "\u2006");
          var n = t.create("token", "mo", {
            movablelimits: !0,
            movesupsub: !0,
            form: p.TexConstant.Form.PREFIX,
            texClass: d.TEXCLASS.OP
          }, r);
          t.Push(n);
        }, g.Limits = function (t, e, r) {
          var n = t.stack.Prev(!0);
          if (!n || l.default.getTexClass(l.default.getCoreMO(n)) !== d.TEXCLASS.OP && null == l.default.getProperty(n, "movesupsub")) throw new c.default("MisplacedLimits", "%1 is allowed only on operators", t.currentCS);
          var o,
            i = t.stack.Top();
          l.default.isType(n, "munderover") && !r ? (o = t.create("node", "msubsup"), l.default.copyChildren(n, o), n = i.Last = o) : l.default.isType(n, "msubsup") && r && (o = t.create("node", "munderover"), l.default.copyChildren(n, o), n = i.Last = o), l.default.setProperty(n, "movesupsub", !!r), l.default.setProperties(l.default.getCoreMO(n), {
            movablelimits: !1
          }), (l.default.getAttribute(n, "movablelimits") || l.default.getProperty(n, "movablelimits")) && l.default.setProperties(n, {
            movablelimits: !1
          });
        }, g.Over = function (t, e, r, n) {
          var o = t.itemFactory.create("over").setProperty("name", t.currentCS);
          r || n ? (o.setProperty("open", r), o.setProperty("close", n)) : e.match(/withdelims$/) && (o.setProperty("open", t.GetDelimiter(e)), o.setProperty("close", t.GetDelimiter(e))), e.match(/^\\above/) ? o.setProperty("thickness", t.GetDimen(e)) : (e.match(/^\\atop/) || r || n) && o.setProperty("thickness", 0), t.Push(o);
        }, g.Frac = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.create("node", "mfrac", [r, n]);
          t.Push(o);
        }, g.Sqrt = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetArgument(e);
          "\\frac" === n && (n += "{" + t.GetArgument(n) + "}{" + t.GetArgument(n) + "}");
          var o = new u.default(n, t.stack.env, t.configuration).mml();
          o = r ? t.create("node", "mroot", [o, b(t, r)]) : t.create("node", "msqrt", [o]), t.Push(o);
        }, g.Root = function (t, e) {
          var r = t.GetUpTo(e, "\\of"),
            n = t.ParseArg(e),
            o = t.create("node", "mroot", [n, b(t, r)]);
          t.Push(o);
        }, g.MoveRoot = function (t, e, r) {
          if (!t.stack.env.inRoot) throw new c.default("MisplacedMoveRoot", "%1 can appear only within a root", t.currentCS);
          if (t.stack.global[r]) throw new c.default("MultipleMoveRoot", "Multiple use of %1", t.currentCS);
          var n = t.GetArgument(e);
          if (!n.match(/-?[0-9]+/)) throw new c.default("IntegerArg", "The argument to %1 must be an integer", t.currentCS);
          "-" !== (n = parseInt(n, 10) / 15 + "em").substr(0, 1) && (n = "+" + n), t.stack.global[r] = n;
        }, g.Accent = function (t, e, r, o) {
          var i = t.ParseArg(e),
            a = n(n({}, h.default.getFontDef(t)), {
              accent: !0,
              mathaccent: !0
            }),
            Q = l.default.createEntity(r),
            s = t.create("token", "mo", a, Q);
          l.default.setAttribute(s, "stretchy", !!o);
          var T = l.default.isEmbellished(i) ? l.default.getCoreMO(i) : i;
          (l.default.isType(T, "mo") || l.default.getProperty(T, "movablelimits")) && l.default.setProperties(T, {
            movablelimits: !1
          });
          var c = t.create("node", "munderover");
          l.default.setChild(c, 0, i), l.default.setChild(c, 1, null), l.default.setChild(c, 2, s);
          var u = t.create("node", "TeXAtom", [c]);
          t.Push(u);
        }, g.UnderOver = function (t, e, r, n) {
          var o = l.default.createEntity(r),
            i = t.create("token", "mo", {
              stretchy: !0,
              accent: !0
            }, o),
            a = "o" === e.charAt(1) ? "over" : "under",
            Q = t.ParseArg(e);
          t.Push(h.default.underOver(t, Q, i, a, n));
        }, g.Overset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          h.default.checkMovableLimits(n), r.isKind("mo") && l.default.setAttribute(r, "accent", !1);
          var o = t.create("node", "mover", [n, r]);
          t.Push(o);
        }, g.Underset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e);
          h.default.checkMovableLimits(n), r.isKind("mo") && l.default.setAttribute(r, "accent", !1);
          var o = t.create("node", "munder", [n, r], {
            accentunder: !1
          });
          t.Push(o);
        }, g.Overunderset = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.ParseArg(e);
          h.default.checkMovableLimits(o), r.isKind("mo") && l.default.setAttribute(r, "accent", !1), n.isKind("mo") && l.default.setAttribute(n, "accent", !1);
          var i = t.create("node", "munderover", [o, n, r], {
            accent: !1,
            accentunder: !1
          });
          t.Push(i);
        }, g.TeXAtom = function (t, e, r) {
          var n,
            o,
            i,
            a = {
              texClass: r
            };
          if (r === d.TEXCLASS.OP) {
            a.movesupsub = a.movablelimits = !0;
            var Q = t.GetArgument(e),
              s = Q.match(/^\s*\\rm\s+([a-zA-Z0-9 ]+)$/);
            s ? (a.mathvariant = p.TexConstant.Variant.NORMAL, o = t.create("token", "mi", a, s[1])) : (i = new u.default(Q, t.stack.env, t.configuration).mml(), o = t.create("node", "TeXAtom", [i], a)), n = t.itemFactory.create("fn", o);
          } else i = t.ParseArg(e), n = t.create("node", "TeXAtom", [i], a);
          t.Push(n);
        }, g.MmlToken = function (t, e) {
          var r,
            n = t.GetArgument(e),
            o = t.GetBrackets(e, "").replace(/^\s+/, ""),
            i = t.GetArgument(e),
            a = {},
            Q = [];
          try {
            r = t.create("node", n);
          } catch (t) {
            r = null;
          }
          if (!r || !r.isToken) throw new c.default("NotMathMLToken", "%1 is not a token element", n);
          for (; "" !== o;) {
            var s = o.match(/^([a-z]+)\s*=\s*('[^']*'|"[^"]*"|[^ ,]*)\s*,?\s*/i);
            if (!s) throw new c.default("InvalidMathMLAttr", "Invalid MathML attribute: %1", o);
            if (!r.attributes.hasDefault(s[1]) && !v[s[1]]) throw new c.default("UnknownAttrForElement", "%1 is not a recognized attribute for %2", s[1], n);
            var T = h.default.MmlFilterAttribute(t, s[1], s[2].replace(/^(['"])(.*)\1$/, "$2"));
            T && ("true" === T.toLowerCase() ? T = !0 : "false" === T.toLowerCase() && (T = !1), a[s[1]] = T, Q.push(s[1])), o = o.substr(s[0].length);
          }
          Q.length && (a["mjx-keep-attrs"] = Q.join(" "));
          var u = t.create("text", i);
          r.appendChild(u), l.default.setProperties(r, a), t.Push(r);
        }, g.Strut = function (t, e) {
          var r = t.create("node", "mrow"),
            n = t.create("node", "mpadded", [r], {
              height: "8.6pt",
              depth: "3pt",
              width: 0
            });
          t.Push(n);
        }, g.Phantom = function (t, e, r, n) {
          var o = t.create("node", "mphantom", [t.ParseArg(e)]);
          (r || n) && (o = t.create("node", "mpadded", [o]), n && (l.default.setAttribute(o, "height", 0), l.default.setAttribute(o, "depth", 0)), r && l.default.setAttribute(o, "width", 0));
          var i = t.create("node", "TeXAtom", [o]);
          t.Push(i);
        }, g.Smash = function (t, e) {
          var r = h.default.trimSpaces(t.GetBrackets(e, "")),
            n = t.create("node", "mpadded", [t.ParseArg(e)]);
          switch (r) {
            case "b":
              l.default.setAttribute(n, "depth", 0);
              break;
            case "t":
              l.default.setAttribute(n, "height", 0);
              break;
            default:
              l.default.setAttribute(n, "height", 0), l.default.setAttribute(n, "depth", 0);
          }
          var o = t.create("node", "TeXAtom", [n]);
          t.Push(o);
        }, g.Lap = function (t, e) {
          var r = t.create("node", "mpadded", [t.ParseArg(e)], {
            width: 0
          });
          "\\llap" === e && l.default.setAttribute(r, "lspace", "-1width");
          var n = t.create("node", "TeXAtom", [r]);
          t.Push(n);
        }, g.RaiseLower = function (t, e) {
          var r = t.GetDimen(e),
            n = t.itemFactory.create("position").setProperties({
              name: t.currentCS,
              move: "vertical"
            });
          "-" === r.charAt(0) && (r = r.slice(1), e = "raise" === e.substr(1) ? "\\lower" : "\\raise"), "\\lower" === e ? (n.setProperty("dh", "-" + r), n.setProperty("dd", "+" + r)) : (n.setProperty("dh", "+" + r), n.setProperty("dd", "-" + r)), t.Push(n);
        }, g.MoveLeftRight = function (t, e) {
          var r = t.GetDimen(e),
            n = "-" === r.charAt(0) ? r.slice(1) : "-" + r;
          if ("\\moveleft" === e) {
            var o = r;
            r = n, n = o;
          }
          t.Push(t.itemFactory.create("position").setProperties({
            name: t.currentCS,
            move: "horizontal",
            left: t.create("node", "mspace", [], {
              width: r
            }),
            right: t.create("node", "mspace", [], {
              width: n
            })
          }));
        }, g.Hskip = function (t, e) {
          var r = t.create("node", "mspace", [], {
            width: t.GetDimen(e)
          });
          t.Push(r);
        }, g.Nonscript = function (t, e) {
          t.Push(t.itemFactory.create("nonscript"));
        }, g.Rule = function (t, e, r) {
          var n = {
            width: t.GetDimen(e),
            height: t.GetDimen(e),
            depth: t.GetDimen(e)
          };
          "blank" !== r && (n.mathbackground = t.stack.env.color || "black");
          var o = t.create("node", "mspace", [], n);
          t.Push(o);
        }, g.rule = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetDimen(e),
            o = t.GetDimen(e),
            i = t.create("node", "mspace", [], {
              width: n,
              height: o,
              mathbackground: t.stack.env.color || "black"
            });
          r && (i = t.create("node", "mpadded", [i], {
            voffset: r
          }), r.match(/^\-/) ? (l.default.setAttribute(i, "height", r), l.default.setAttribute(i, "depth", "+" + r.substr(1))) : l.default.setAttribute(i, "height", "+" + r)), t.Push(i);
        }, g.MakeBig = function (t, e, r, n) {
          var o = String(n *= 1.411764705882353).replace(/(\.\d\d\d).+/, "$1") + "em",
            i = t.GetDelimiter(e, !0),
            a = t.create("token", "mo", {
              minsize: o,
              maxsize: o,
              fence: !0,
              stretchy: !0,
              symmetric: !0
            }, i),
            Q = t.create("node", "TeXAtom", [a], {
              texClass: r
            });
          t.Push(Q);
        }, g.BuildRel = function (t, e) {
          var r = t.ParseUpTo(e, "\\over"),
            n = t.ParseArg(e),
            o = t.create("node", "munderover");
          l.default.setChild(o, 0, n), l.default.setChild(o, 1, null), l.default.setChild(o, 2, r);
          var i = t.create("node", "TeXAtom", [o], {
            texClass: d.TEXCLASS.REL
          });
          t.Push(i);
        }, g.HBox = function (t, e, r, n) {
          t.PushAll(h.default.internalMath(t, t.GetArgument(e), r, n));
        }, g.FBox = function (t, e) {
          var r = h.default.internalMath(t, t.GetArgument(e)),
            n = t.create("node", "menclose", r, {
              notation: "box"
            });
          t.Push(n);
        }, g.FrameBox = function (t, e) {
          var r = t.GetBrackets(e),
            n = t.GetBrackets(e) || "c",
            o = h.default.internalMath(t, t.GetArgument(e));
          r && (o = [t.create("node", "mpadded", o, {
            width: r,
            "data-align": (0, y.lookup)(n, {
              l: "left",
              r: "right"
            }, "center")
          })]);
          var i = t.create("node", "TeXAtom", [t.create("node", "menclose", o, {
            notation: "box"
          })], {
            texClass: d.TEXCLASS.ORD
          });
          t.Push(i);
        }, g.Not = function (t, e) {
          t.Push(t.itemFactory.create("not"));
        }, g.Dots = function (t, e) {
          var r = l.default.createEntity("2026"),
            n = l.default.createEntity("22EF"),
            o = t.create("token", "mo", {
              stretchy: !1
            }, r),
            i = t.create("token", "mo", {
              stretchy: !1
            }, n);
          t.Push(t.itemFactory.create("dots").setProperties({
            ldots: o,
            cdots: i
          }));
        }, g.Matrix = function (t, e, r, n, o, i, a, Q, s, T) {
          var l = t.GetNext();
          if ("" === l) throw new c.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          "{" === l ? t.i++ : (t.string = l + "}" + t.string.slice(t.i + 1), t.i = 0);
          var u = t.itemFactory.create("array").setProperty("requireClose", !0);
          u.arraydef = {
            rowspacing: a || "4pt",
            columnspacing: i || "1em"
          }, s && u.setProperty("isCases", !0), T && (u.setProperty("isNumbered", !0), u.arraydef.side = T), (r || n) && (u.setProperty("open", r), u.setProperty("close", n)), "D" === Q && (u.arraydef.displaystyle = !0), null != o && (u.arraydef.columnalign = o), t.Push(u);
        }, g.Entry = function (t, e) {
          t.Push(t.itemFactory.create("cell").setProperties({
            isEntry: !0,
            name: e
          }));
          var r = t.stack.Top(),
            n = r.getProperty("casesEnv");
          if (r.getProperty("isCases") || n) {
            for (var o = t.string, i = 0, a = -1, Q = t.i, s = o.length, T = n ? new RegExp("^\\\\end\\s*\\{".concat(n.replace(/\*/, "\\*"), "\\}")) : null; Q < s;) {
              var l = o.charAt(Q);
              if ("{" === l) i++, Q++;else if ("}" === l) 0 === i ? s = 0 : (0 === --i && a < 0 && (a = Q - t.i), Q++);else {
                if ("&" === l && 0 === i) throw new c.default("ExtraAlignTab", "Extra alignment tab in \\cases text");
                if ("\\" === l) {
                  var u = o.substr(Q);
                  u.match(/^((\\cr)[^a-zA-Z]|\\\\)/) || T && u.match(T) ? s = 0 : Q += 2;
                } else Q++;
              }
            }
            var p = o.substr(t.i, Q - t.i);
            if (!p.match(/^\s*\\text[^a-zA-Z]/) || a !== p.replace(/\s+$/, "").length - 1) {
              var d = h.default.internalMath(t, h.default.trimSpaces(p), 0);
              t.PushAll(d), t.i = Q;
            }
          }
        }, g.Cr = function (t, e) {
          t.Push(t.itemFactory.create("cell").setProperties({
            isCR: !0,
            name: e
          }));
        }, g.CrLaTeX = function (t, e, r) {
          var n;
          if (void 0 === r && (r = !1), !r && ("*" === t.string.charAt(t.i) && t.i++, "[" === t.string.charAt(t.i))) {
            var o = t.GetBrackets(e, ""),
              i = Q(h.default.matchDimen(o), 2),
              a = i[0],
              s = i[1];
            if (o && !a) throw new c.default("BracketMustBeDimension", "Bracket argument to %1 must be a dimension", t.currentCS);
            n = a + s;
          }
          t.Push(t.itemFactory.create("cell").setProperties({
            isCR: !0,
            name: e,
            linebreak: !0
          }));
          var l,
            u = t.stack.Top();
          u instanceof T.ArrayItem ? n && u.addRowSpacing(n) : (n && (l = t.create("node", "mspace", [], {
            depth: n
          }), t.Push(l)), l = t.create("node", "mspace", [], {
            linebreak: p.TexConstant.LineBreak.NEWLINE
          }), t.Push(l));
        }, g.HLine = function (t, e, r) {
          null == r && (r = "solid");
          var n = t.stack.Top();
          if (!(n instanceof T.ArrayItem) || n.Size()) throw new c.default("Misplaced", "Misplaced %1", t.currentCS);
          if (n.table.length) {
            for (var o = n.arraydef.rowlines ? n.arraydef.rowlines.split(/ /) : []; o.length < n.table.length;) o.push("none");
            o[n.table.length - 1] = r, n.arraydef.rowlines = o.join(" ");
          } else n.frame.push("top");
        }, g.HFill = function (t, e) {
          var r = t.stack.Top();
          if (!(r instanceof T.ArrayItem)) throw new c.default("UnsupportedHFill", "Unsupported use of %1", t.currentCS);
          r.hfill.push(r.Size());
        }, g.BeginEnd = function (t, e) {
          var r = t.GetArgument(e);
          if (r.match(/\\/i)) throw new c.default("InvalidEnv", "Invalid environment name '%1'", r);
          var n = t.configuration.handlers.get("environment").lookup(r);
          if (n && "\\end" === e) {
            if (!n.args[0]) {
              var o = t.itemFactory.create("end").setProperty("name", r);
              return void t.Push(o);
            }
            t.stack.env.closing = r;
          }
          h.default.checkMaxMacros(t, !1), t.parse("environment", [t, r]);
        }, g.Array = function (t, e, r, n, o, i, a, Q, s) {
          o || (o = t.GetArgument("\\begin{" + e.getName() + "}"));
          var T = ("c" + o).replace(/[^clr|:]/g, "").replace(/[^|:]([|:])+/g, "$1");
          o = (o = o.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
          var l = t.itemFactory.create("array");
          return l.arraydef = {
            columnalign: o,
            columnspacing: i || "1em",
            rowspacing: a || "4pt"
          }, T.match(/[|:]/) && (T.charAt(0).match(/[|:]/) && (l.frame.push("left"), l.dashed = ":" === T.charAt(0)), T.charAt(T.length - 1).match(/[|:]/) && l.frame.push("right"), T = T.substr(1, T.length - 2), l.arraydef.columnlines = T.split("").join(" ").replace(/[^|: ]/g, "none").replace(/\|/g, "solid").replace(/:/g, "dashed")), r && l.setProperty("open", t.convertDelimiter(r)), n && l.setProperty("close", t.convertDelimiter(n)), "'" === (Q || "").charAt(1) && (l.arraydef["data-cramped"] = !0, Q = Q.charAt(0)), "D" === Q ? l.arraydef.displaystyle = !0 : Q && (l.arraydef.displaystyle = !1), "S" === Q && (l.arraydef.scriptlevel = 1), s && (l.arraydef.useHeight = !1), t.Push(e), l;
        }, g.AlignedArray = function (t, e) {
          var r = t.GetBrackets("\\begin{" + e.getName() + "}"),
            n = g.Array(t, e);
          return h.default.setArrayAlign(n, r);
        }, g.Equation = function (t, e, r) {
          return t.Push(e), h.default.checkEqnEnv(t), t.itemFactory.create("equation", r).setProperty("name", e.getName());
        }, g.EqnArray = function (t, e, r, n, o, i) {
          t.Push(e), n && h.default.checkEqnEnv(t), o = (o = o.replace(/[^clr]/g, "").split("").join(" ")).replace(/l/g, "left").replace(/r/g, "right").replace(/c/g, "center");
          var a = t.itemFactory.create("eqnarray", e.getName(), r, n, t.stack.global);
          return a.arraydef = {
            displaystyle: !0,
            columnalign: o,
            columnspacing: i || "1em",
            rowspacing: "3pt",
            side: t.options.tagSide,
            minlabelspacing: t.options.tagIndent
          }, a;
        }, g.HandleNoTag = function (t, e) {
          t.tags.notag();
        }, g.HandleLabel = function (t, e) {
          var r = t.GetArgument(e);
          if ("" !== r && !t.tags.refUpdate) {
            if (t.tags.label) throw new c.default("MultipleCommand", "Multiple %1", t.currentCS);
            if (t.tags.label = r, (t.tags.allLabels[r] || t.tags.labels[r]) && !t.options.ignoreDuplicateLabels) throw new c.default("MultipleLabel", "Label '%1' multiply defined", r);
            t.tags.labels[r] = new f.Label();
          }
        }, g.HandleRef = function (t, e, r) {
          var n = t.GetArgument(e),
            o = t.tags.allLabels[n] || t.tags.labels[n];
          o || (t.tags.refUpdate || (t.tags.redo = !0), o = new f.Label());
          var i = o.tag;
          r && (i = t.tags.formatTag(i));
          var a = t.create("node", "mrow", h.default.internalMath(t, i), {
            href: t.tags.formatUrl(o.id, t.options.baseURL),
            class: "MathJax_ref"
          });
          t.Push(a);
        }, g.Macro = function (t, e, r, n, o) {
          if (n) {
            var i = [];
            if (null != o) {
              var a = t.GetBrackets(e);
              i.push(null == a ? o : a);
            }
            for (var Q = i.length; Q < n; Q++) i.push(t.GetArgument(e));
            r = h.default.substituteArgs(t, i, r);
          }
          t.string = h.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, h.default.checkMaxMacros(t);
        }, g.MathChoice = function (t, e) {
          var r = t.ParseArg(e),
            n = t.ParseArg(e),
            o = t.ParseArg(e),
            i = t.ParseArg(e);
          t.Push(t.create("node", "MathChoice", [r, n, o, i]));
        }, e.default = g;
      },
      1186: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BboxConfiguration = e.BboxMethods = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(3971));
        e.BboxMethods = {}, e.BboxMethods.BBox = function (t, e) {
          for (var r, n, o, i = t.GetBrackets(e, ""), T = t.ParseArg(e), l = i.split(/,/), c = 0, u = l.length; c < u; c++) {
            var p = l[c].trim(),
              h = p.match(/^(\.\d+|\d+(\.\d*)?)(pt|em|ex|mu|px|in|cm|mm)$/);
            if (h) {
              if (r) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Padding", e);
              var d = s(h[1] + h[3]);
              d && (r = {
                height: "+" + d,
                depth: "+" + d,
                lspace: d,
                width: "+" + 2 * parseInt(h[1], 10) + h[3]
              });
            } else if (p.match(/^([a-z0-9]+|\#[0-9a-f]{6}|\#[0-9a-f]{3})$/i)) {
              if (n) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Background", e);
              n = p;
            } else if (p.match(/^[-a-z]+:/i)) {
              if (o) throw new a.default("MultipleBBoxProperty", "%1 specified twice in %2", "Style", e);
              o = Q(p);
            } else if ("" !== p) throw new a.default("InvalidBBoxProperty", '"%1" doesn\'t look like a color, a padding dimension, or a style', p);
          }
          r && (T = t.create("node", "mpadded", [T], r)), (n || o) && (r = {}, n && Object.assign(r, {
            mathbackground: n
          }), o && Object.assign(r, {
            style: o
          }), T = t.create("node", "mstyle", [T], r)), t.Push(T);
        };
        var Q = function Q(t) {
            return t;
          },
          s = function s(t) {
            return t;
          };
        new i.CommandMap("bbox", {
          bbox: "BBox"
        }, e.BboxMethods), e.BboxConfiguration = o.Configuration.create("bbox", {
          handler: {
            macro: ["bbox"]
          }
        });
      },
      8603: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BoldsymbolConfiguration = e.rewriteBoldTokens = e.createBoldToken = e.BoldsymbolMethods = void 0;
        var i = r(9899),
          a = o(r(1256)),
          Q = r(8317),
          s = r(9140),
          T = r(8929),
          l = {};
        function c(t, e, r, n) {
          var o = T.NodeFactory.createToken(t, e, r, n);
          return "mtext" !== e && t.configuration.parser.stack.env.boldsymbol && (a.default.setProperty(o, "fixBold", !0), t.configuration.addNode("fixBold", o)), o;
        }
        function u(t) {
          var e, r;
          try {
            for (var o = n(t.data.getList("fixBold")), i = o.next(); !i.done; i = o.next()) {
              var s = i.value;
              if (a.default.getProperty(s, "fixBold")) {
                var T = a.default.getAttribute(s, "mathvariant");
                null == T ? a.default.setAttribute(s, "mathvariant", Q.TexConstant.Variant.BOLD) : a.default.setAttribute(s, "mathvariant", l[T] || T), a.default.removeProperties(s, "fixBold");
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (r = o.return) && r.call(o);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        l[Q.TexConstant.Variant.NORMAL] = Q.TexConstant.Variant.BOLD, l[Q.TexConstant.Variant.ITALIC] = Q.TexConstant.Variant.BOLDITALIC, l[Q.TexConstant.Variant.FRAKTUR] = Q.TexConstant.Variant.BOLDFRAKTUR, l[Q.TexConstant.Variant.SCRIPT] = Q.TexConstant.Variant.BOLDSCRIPT, l[Q.TexConstant.Variant.SANSSERIF] = Q.TexConstant.Variant.BOLDSANSSERIF, l["-tex-calligraphic"] = "-tex-bold-calligraphic", l["-tex-oldstyle"] = "-tex-bold-oldstyle", l["-tex-mathit"] = Q.TexConstant.Variant.BOLDITALIC, e.BoldsymbolMethods = {}, e.BoldsymbolMethods.Boldsymbol = function (t, e) {
          var r = t.stack.env.boldsymbol;
          t.stack.env.boldsymbol = !0;
          var n = t.ParseArg(e);
          t.stack.env.boldsymbol = r, t.Push(n);
        }, new s.CommandMap("boldsymbol", {
          boldsymbol: "Boldsymbol"
        }, e.BoldsymbolMethods), e.createBoldToken = c, e.rewriteBoldTokens = u, e.BoldsymbolConfiguration = i.Configuration.create("boldsymbol", {
          handler: {
            macro: ["boldsymbol"]
          },
          nodes: {
            token: c
          },
          postprocessors: [u]
        });
      },
      6538: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BraketConfiguration = void 0;
        var o = r(9899),
          i = r(7191);
        r(2608), e.BraketConfiguration = o.Configuration.create("braket", {
          handler: {
            character: ["Braket-characters"],
            macro: ["Braket-macros"]
          },
          items: (n = {}, n[i.BraketItem.prototype.kind] = i.BraketItem, n)
        });
      },
      7191: function _(t, e, r) {
        var _n60,
          o = this && this.__extends || (_n60 = function n(t, e) {
            return _n60 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n60(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n60(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BraketItem = void 0;
        var a = r(8292),
          Q = r(9007),
          s = i(r(1130)),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "braket";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("close") ? [[this.factory.create("mml", this.toMml())], !0] : e.isKind("mml") ? (this.Push(e.toMml()), this.getProperty("single") ? [[this.toMml()], !0] : a.BaseItem.fail) : t.prototype.checkItem.call(this, e);
            }, e.prototype.toMml = function () {
              var e = t.prototype.toMml.call(this),
                r = this.getProperty("open"),
                n = this.getProperty("close");
              if (this.getProperty("stretchy")) return s.default.fenced(this.factory.configuration, r, e, n);
              var o = {
                  fence: !0,
                  stretchy: !1,
                  symmetric: !0,
                  texClass: Q.TEXCLASS.OPEN
                },
                i = this.create("token", "mo", o, r);
              o.texClass = Q.TEXCLASS.CLOSE;
              var a = this.create("token", "mo", o, n);
              return this.create("node", "mrow", [i, e, a], {
                open: r,
                close: n,
                texClass: Q.TEXCLASS.INNER
              });
            }, e;
          }(a.BaseItem);
        e.BraketItem = T;
      },
      2608: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = n(r(8667));
        new o.CommandMap("Braket-macros", {
          bra: ["Macro", "{\\langle {#1} \\vert}", 1],
          ket: ["Macro", "{\\vert {#1} \\rangle}", 1],
          braket: ["Braket", "\u27E8", "\u27E9", !1, 1 / 0],
          set: ["Braket", "{", "}", !1, 1],
          Bra: ["Macro", "{\\left\\langle {#1} \\right\\vert}", 1],
          Ket: ["Macro", "{\\left\\vert {#1} \\right\\rangle}", 1],
          Braket: ["Braket", "\u27E8", "\u27E9", !0, 1 / 0],
          Set: ["Braket", "{", "}", !0, 1],
          ketbra: ["Macro", "{\\vert {#1} \\rangle\\langle {#2} \\vert}", 2],
          Ketbra: ["Macro", "{\\left\\vert {#1} \\right\\rangle\\left\\langle {#2} \\right\\vert}", 2],
          "|": "Bar"
        }, i.default), new o.MacroMap("Braket-characters", {
          "|": "Bar"
        }, i.default);
      },
      8667: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(7693)),
          i = r(9007),
          a = n(r(3971)),
          Q = {};
        Q.Macro = o.default.Macro, Q.Braket = function (t, e, r, n, o, i) {
          var Q = t.GetNext();
          if ("" === Q) throw new a.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          var s = !0;
          "{" === Q && (t.i++, s = !1), t.Push(t.itemFactory.create("braket").setProperties({
            barmax: i,
            barcount: 0,
            open: r,
            close: n,
            stretchy: o,
            single: s
          }));
        }, Q.Bar = function (t, e) {
          var r = "|" === e ? "|" : "\u2225",
            n = t.stack.Top();
          if ("braket" !== n.kind || n.getProperty("barcount") >= n.getProperty("barmax")) {
            var o = t.create("token", "mo", {
              texClass: i.TEXCLASS.ORD,
              stretchy: !1
            }, r);
            t.Push(o);
          } else {
            if ("|" === r && "|" === t.GetNext() && (t.i++, r = "\u2225"), n.getProperty("stretchy")) {
              var a = t.create("node", "TeXAtom", [], {
                texClass: i.TEXCLASS.CLOSE
              });
              t.Push(a), n.setProperty("barcount", n.getProperty("barcount") + 1), a = t.create("token", "mo", {
                stretchy: !0,
                braketbar: !0
              }, r), t.Push(a), a = t.create("node", "TeXAtom", [], {
                texClass: i.TEXCLASS.OPEN
              }), t.Push(a);
            } else {
              var Q = t.create("token", "mo", {
                stretchy: !1,
                braketbar: !0
              }, r);
              t.Push(Q);
            }
          }
        }, e.default = Q;
      },
      9499: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BussproofsConfiguration = void 0;
        var o = r(9899),
          i = r(3980),
          a = r(1933);
        r(8620), e.BussproofsConfiguration = o.Configuration.create("bussproofs", {
          handler: {
            macro: ["Bussproofs-macros"],
            environment: ["Bussproofs-environments"]
          },
          items: (n = {}, n[i.ProofTreeItem.prototype.kind] = i.ProofTreeItem, n),
          preprocessors: [[a.saveDocument, 1]],
          postprocessors: [[a.clearDocument, 3], [a.makeBsprAttributes, 2], [a.balanceRules, 1]]
        });
      },
      3980: function _(t, e, r) {
        var _n61,
          o = this && this.__extends || (_n61 = function n(t, e) {
            return _n61 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n61(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n61(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          Q = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ProofTreeItem = void 0;
        var T = s(r(3971)),
          l = r(8292),
          c = s(r(9497)),
          u = Q(r(1933)),
          p = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.leftLabel = null, e.rigthLabel = null, e.innerStack = new c.default(e.factory, {}, !0), e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "proofTree";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (t) {
              if (t.isKind("end") && "prooftree" === t.getName()) {
                var e = this.toMml();
                return u.setProperty(e, "proof", !0), [[this.factory.create("mml", e), t], !0];
              }
              if (t.isKind("stop")) throw new T.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
              return this.innerStack.Push(t), l.BaseItem.fail;
            }, e.prototype.toMml = function () {
              var e = t.prototype.toMml.call(this),
                r = this.innerStack.Top();
              if (r.isKind("start") && !r.Size()) return e;
              this.innerStack.Push(this.factory.create("stop"));
              var n = this.innerStack.Top().toMml();
              return this.create("node", "mrow", [n, e], {});
            }, e;
          }(l.BaseItem);
        e.ProofTreeItem = p;
      },
      8620: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(4934)),
          i = n(r(5450)),
          a = r(9140);
        new a.CommandMap("Bussproofs-macros", {
          AxiomC: "Axiom",
          UnaryInfC: ["Inference", 1],
          BinaryInfC: ["Inference", 2],
          TrinaryInfC: ["Inference", 3],
          QuaternaryInfC: ["Inference", 4],
          QuinaryInfC: ["Inference", 5],
          RightLabel: ["Label", "right"],
          LeftLabel: ["Label", "left"],
          AXC: "Axiom",
          UIC: ["Inference", 1],
          BIC: ["Inference", 2],
          TIC: ["Inference", 3],
          RL: ["Label", "right"],
          LL: ["Label", "left"],
          noLine: ["SetLine", "none", !1],
          singleLine: ["SetLine", "solid", !1],
          solidLine: ["SetLine", "solid", !1],
          dashedLine: ["SetLine", "dashed", !1],
          alwaysNoLine: ["SetLine", "none", !0],
          alwaysSingleLine: ["SetLine", "solid", !0],
          alwaysSolidLine: ["SetLine", "solid", !0],
          alwaysDashedLine: ["SetLine", "dashed", !0],
          rootAtTop: ["RootAtTop", !0],
          alwaysRootAtTop: ["RootAtTop", !0],
          rootAtBottom: ["RootAtTop", !1],
          alwaysRootAtBottom: ["RootAtTop", !1],
          fCenter: "FCenter",
          Axiom: "AxiomF",
          UnaryInf: ["InferenceF", 1],
          BinaryInf: ["InferenceF", 2],
          TrinaryInf: ["InferenceF", 3],
          QuaternaryInf: ["InferenceF", 4],
          QuinaryInf: ["InferenceF", 5]
        }, o.default), new a.EnvironmentMap("Bussproofs-environments", i.default.environment, {
          prooftree: ["Prooftree", null, !1]
        }, o.default);
      },
      4934: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var T = s(r(3971)),
          l = s(r(8417)),
          c = s(r(1130)),
          u = i(r(1933)),
          p = {
            Prooftree: function Prooftree(t, e) {
              return t.Push(e), t.itemFactory.create("proofTree").setProperties({
                name: e.getName(),
                line: "solid",
                currentLine: "solid",
                rootAtTop: !1
              });
            },
            Axiom: function Axiom(t, e) {
              var r = t.stack.Top();
              if ("proofTree" !== r.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
              var n = h(t, t.GetArgument(e));
              u.setProperty(n, "axiom", !0), r.Push(n);
            }
          },
          h = function h(t, e) {
            var r = c.default.internalMath(t, c.default.trimSpaces(e), 0);
            if (!r[0].childNodes[0].childNodes.length) return t.create("node", "mrow", []);
            var n = t.create("node", "mspace", [], {
                width: ".5ex"
              }),
              o = t.create("node", "mspace", [], {
                width: ".5ex"
              });
            return t.create("node", "mrow", Q(Q([n], a(r), !1), [o], !1));
          };
        function d(t, e, r, n, o, i, a) {
          var Q,
            s,
            T,
            l,
            c = t.create("node", "mtr", [t.create("node", "mtd", [e], {})], {}),
            p = t.create("node", "mtr", [t.create("node", "mtd", r, {})], {}),
            h = t.create("node", "mtable", a ? [p, c] : [c, p], {
              align: "top 2",
              rowlines: i,
              framespacing: "0 0"
            });
          if (u.setProperty(h, "inferenceRule", a ? "up" : "down"), n && (Q = t.create("node", "mpadded", [n], {
            height: "+.5em",
            width: "+.5em",
            voffset: "-.15em"
          }), u.setProperty(Q, "prooflabel", "left")), o && (s = t.create("node", "mpadded", [o], {
            height: "+.5em",
            width: "+.5em",
            voffset: "-.15em"
          }), u.setProperty(s, "prooflabel", "right")), n && o) T = [Q, h, s], l = "both";else if (n) T = [Q, h], l = "left";else {
            if (!o) return h;
            T = [h, s], l = "right";
          }
          return h = t.create("node", "mrow", T), u.setProperty(h, "labelledRule", l), h;
        }
        function f(t, e) {
          if ("$" !== t.GetNext()) throw new T.default("IllegalUseOfCommand", "Use of %1 does not match it's definition.", e);
          t.i++;
          var r = t.GetUpTo(e, "$");
          if (-1 === r.indexOf("\\fCenter")) throw new T.default("IllegalUseOfCommand", "Missing \\fCenter in %1.", e);
          var n = a(r.split("\\fCenter"), 2),
            o = n[0],
            i = n[1],
            Q = new l.default(o, t.stack.env, t.configuration).mml(),
            s = new l.default(i, t.stack.env, t.configuration).mml(),
            c = new l.default("\\fCenter", t.stack.env, t.configuration).mml(),
            p = t.create("node", "mtd", [Q], {}),
            h = t.create("node", "mtd", [c], {}),
            d = t.create("node", "mtd", [s], {}),
            f = t.create("node", "mtr", [p, h, d], {}),
            m = t.create("node", "mtable", [f], {
              columnspacing: ".5ex",
              columnalign: "center 2"
            });
          return u.setProperty(m, "sequent", !0), t.configuration.addNode("sequent", f), m;
        }
        p.Inference = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          if (n.Size() < r) throw new T.default("BadProofTree", "Proof tree badly specified.");
          var o = n.getProperty("rootAtTop"),
            i = 1 !== r || n.Peek()[0].childNodes.length ? r : 0,
            a = [];
          do {
            a.length && a.unshift(t.create("node", "mtd", [], {})), a.unshift(t.create("node", "mtd", [n.Pop()], {
              rowalign: o ? "top" : "bottom"
            })), r--;
          } while (r > 0);
          var Q = t.create("node", "mtr", a, {}),
            s = t.create("node", "mtable", [Q], {
              framespacing: "0 0"
            }),
            l = h(t, t.GetArgument(e)),
            c = n.getProperty("currentLine");
          c !== n.getProperty("line") && n.setProperty("currentLine", n.getProperty("line"));
          var p = d(t, s, [l], n.getProperty("left"), n.getProperty("right"), c, o);
          n.setProperty("left", null), n.setProperty("right", null), u.setProperty(p, "inference", i), t.configuration.addNode("inference", p), n.Push(p);
        }, p.Label = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          var o = c.default.internalMath(t, t.GetArgument(e), 0),
            i = o.length > 1 ? t.create("node", "mrow", o, {}) : o[0];
          n.setProperty(r, i);
        }, p.SetLine = function (t, e, r, n) {
          var o = t.stack.Top();
          if ("proofTree" !== o.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          o.setProperty("currentLine", r), n && o.setProperty("line", r);
        }, p.RootAtTop = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          n.setProperty("rootAtTop", r);
        }, p.AxiomF = function (t, e) {
          var r = t.stack.Top();
          if ("proofTree" !== r.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          var n = f(t, e);
          u.setProperty(n, "axiom", !0), r.Push(n);
        }, p.FCenter = function (t, e) {}, p.InferenceF = function (t, e, r) {
          var n = t.stack.Top();
          if ("proofTree" !== n.kind) throw new T.default("IllegalProofCommand", "Proof commands only allowed in prooftree environment.");
          if (n.Size() < r) throw new T.default("BadProofTree", "Proof tree badly specified.");
          var o = n.getProperty("rootAtTop"),
            i = 1 !== r || n.Peek()[0].childNodes.length ? r : 0,
            a = [];
          do {
            a.length && a.unshift(t.create("node", "mtd", [], {})), a.unshift(t.create("node", "mtd", [n.Pop()], {
              rowalign: o ? "top" : "bottom"
            })), r--;
          } while (r > 0);
          var Q = t.create("node", "mtr", a, {}),
            s = t.create("node", "mtable", [Q], {
              framespacing: "0 0"
            }),
            l = f(t, e),
            c = n.getProperty("currentLine");
          c !== n.getProperty("line") && n.setProperty("currentLine", n.getProperty("line"));
          var p = d(t, s, [l], n.getProperty("left"), n.getProperty("right"), c, o);
          n.setProperty("left", null), n.setProperty("right", null), u.setProperty(p, "inference", i), t.configuration.addNode("inference", p), n.Push(p);
        }, e.default = p;
      },
      1933: function _(t, e, r) {
        var n,
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.clearDocument = e.saveDocument = e.makeBsprAttributes = e.removeProperty = e.getProperty = e.setProperty = e.balanceRules = void 0;
        var Q = a(r(1256)),
          s = a(r(1130)),
          T = null,
          l = null,
          c = function c(t) {
            return l.root = t, T.outputJax.getBBox(l, T).w;
          },
          u = function u(t) {
            for (var e = 0; t && !Q.default.isType(t, "mtable");) {
              if (Q.default.isType(t, "text")) return null;
              Q.default.isType(t, "mrow") ? (t = t.childNodes[0], e = 0) : (t = t.parent.childNodes[e], e++);
            }
            return t;
          },
          p = function p(t, e) {
            return t.childNodes["up" === e ? 1 : 0].childNodes[0].childNodes[0].childNodes[0].childNodes[0];
          },
          h = function h(t, e) {
            return t.childNodes[e].childNodes[0].childNodes[0];
          },
          d = function d(t) {
            return h(t, 0);
          },
          f = function f(t) {
            return h(t, t.childNodes.length - 1);
          },
          m = function m(t, e) {
            return t.childNodes["up" === e ? 0 : 1].childNodes[0].childNodes[0].childNodes[0];
          },
          L = function L(t) {
            for (; t && !Q.default.isType(t, "mtd");) t = t.parent;
            return t;
          },
          y = function y(t) {
            return t.parent.childNodes[t.parent.childNodes.indexOf(t) + 1];
          },
          g = function g(t) {
            for (; t && null == (0, e.getProperty)(t, "inference");) t = t.parent;
            return t;
          },
          v = function v(t, e, r) {
            void 0 === r && (r = !1);
            var n = 0;
            if (t === e) return n;
            if (t !== e.parent) {
              var o = t.childNodes,
                i = r ? o.length - 1 : 0;
              Q.default.isType(o[i], "mspace") && (n += c(o[i])), t = e.parent;
            }
            if (t === e) return n;
            var a = t.childNodes,
              s = r ? a.length - 1 : 0;
            return a[s] !== e && (n += c(a[s])), n;
          },
          b = function b(t, r) {
            void 0 === r && (r = !1);
            var n = u(t),
              o = m(n, (0, e.getProperty)(n, "inferenceRule"));
            return v(t, n, r) + (c(n) - c(o)) / 2;
          },
          H = function H(t, r, n, o) {
            if (void 0 === o && (o = !1), (0, e.getProperty)(r, "inferenceRule") || (0, e.getProperty)(r, "labelledRule")) {
              var i = t.nodeFactory.create("node", "mrow");
              r.parent.replaceChild(i, r), i.setChildren([r]), _(r, i), r = i;
            }
            var a = o ? r.childNodes.length - 1 : 0,
              T = r.childNodes[a];
            Q.default.isType(T, "mspace") ? Q.default.setAttribute(T, "width", s.default.Em(s.default.dimen2em(Q.default.getAttribute(T, "width")) + n)) : (T = t.nodeFactory.create("node", "mspace", [], {
              width: s.default.Em(n)
            }), o ? r.appendChild(T) : (T.parent = r, r.childNodes.unshift(T)));
          },
          _ = function _(t, r) {
            ["inference", "proof", "maxAdjust", "labelledRule"].forEach(function (n) {
              var o = (0, e.getProperty)(t, n);
              null != o && ((0, e.setProperty)(r, n, o), (0, e.removeProperty)(t, n));
            });
          },
          M = function M(t, r, n, o, i) {
            var a = t.nodeFactory.create("node", "mspace", [], {
              width: s.default.Em(i)
            });
            if ("left" === o) {
              var Q = r.childNodes[n].childNodes[0];
              a.parent = Q, Q.childNodes.unshift(a);
            } else r.childNodes[n].appendChild(a);
            (0, e.setProperty)(r.parent, "sequentAdjust_" + o, i);
          },
          x = function x(t, r) {
            for (var n = r.pop(); r.length;) {
              var i = r.pop(),
                a = o(O(n, i), 2),
                Q = a[0],
                s = a[1];
              (0, e.getProperty)(n.parent, "axiom") && (M(t, Q < 0 ? n : i, 0, "left", Math.abs(Q)), M(t, s < 0 ? n : i, 2, "right", Math.abs(s))), n = i;
            }
          },
          O = function O(t, e) {
            var r = c(t.childNodes[2]),
              n = c(e.childNodes[2]);
            return [c(t.childNodes[0]) - c(e.childNodes[0]), r - n];
          };
        e.balanceRules = function (t) {
          var r, n;
          l = new t.document.options.MathItem("", null, t.math.display);
          var o = t.data;
          !function (t) {
            var r = t.nodeLists.sequent;
            if (r) for (var n = r.length - 1, o = void 0; o = r[n]; n--) if ((0, e.getProperty)(o, "sequentProcessed")) (0, e.removeProperty)(o, "sequentProcessed");else {
              var i = [],
                a = g(o);
              if (1 === (0, e.getProperty)(a, "inference")) {
                for (i.push(o); 1 === (0, e.getProperty)(a, "inference");) {
                  a = u(a);
                  var Q = d(p(a, (0, e.getProperty)(a, "inferenceRule"))),
                    s = (0, e.getProperty)(Q, "inferenceRule") ? m(Q, (0, e.getProperty)(Q, "inferenceRule")) : Q;
                  (0, e.getProperty)(s, "sequent") && (o = s.childNodes[0], i.push(o), (0, e.setProperty)(o, "sequentProcessed", !0)), a = Q;
                }
                x(t, i);
              }
            }
          }(o);
          var a = o.nodeLists.inference || [];
          try {
            for (var Q = i(a), s = Q.next(); !s.done; s = Q.next()) {
              var T = s.value,
                c = (0, e.getProperty)(T, "proof"),
                h = u(T),
                _ = p(h, (0, e.getProperty)(h, "inferenceRule")),
                M = d(_);
              if ((0, e.getProperty)(M, "inference")) {
                var O = b(M);
                if (O) {
                  H(o, M, -O);
                  var S = v(T, h, !1);
                  H(o, T, O - S);
                }
              }
              var V = f(_);
              if (null != (0, e.getProperty)(V, "inference")) {
                var E = b(V, !0);
                H(o, V, -E, !0);
                var A = v(T, h, !0),
                  C = (0, e.getProperty)(T, "maxAdjust");
                null != C && (E = Math.max(E, C));
                var w = void 0;
                if (!c && (w = L(T))) {
                  var N = y(w);
                  if (N) {
                    var P = o.nodeFactory.create("node", "mspace", [], {
                      width: E - A + "em"
                    });
                    N.appendChild(P), T.removeProperty("maxAdjust");
                  } else {
                    var k = g(w);
                    k && (E = (0, e.getProperty)(k, "maxAdjust") ? Math.max((0, e.getProperty)(k, "maxAdjust"), E) : E, (0, e.setProperty)(k, "maxAdjust", E));
                  }
                } else H(o, (0, e.getProperty)(T, "proof") ? T : T.parent, E - A, !0);
              }
            }
          } catch (t) {
            r = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (n = Q.return) && n.call(Q);
            } finally {
              if (r) throw r.error;
            }
          }
        };
        var S = "bspr_",
          V = ((n = {}).bspr_maxAdjust = !0, n);
        e.setProperty = function (t, e, r) {
          Q.default.setProperty(t, S + e, r);
        };
        e.getProperty = function (t, e) {
          return Q.default.getProperty(t, S + e);
        };
        e.removeProperty = function (t, e) {
          t.removeProperty(S + e);
        };
        e.makeBsprAttributes = function (t) {
          t.data.root.walkTree(function (t, e) {
            var r = [];
            t.getPropertyNames().forEach(function (e) {
              !V[e] && e.match(RegExp("^bspr_")) && r.push(e + ":" + t.getProperty(e));
            }), r.length && Q.default.setAttribute(t, "semantics", r.join(";"));
          });
        };
        e.saveDocument = function (t) {
          if (!("getBBox" in (T = t.document).outputJax)) throw Error("The bussproofs extension requires an output jax with a getBBox() method");
        };
        e.clearDocument = function (t) {
          T = null;
        };
      },
      8963: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CancelConfiguration = e.CancelMethods = void 0;
        var o = r(9899),
          i = r(8317),
          a = r(9140),
          Q = n(r(1130)),
          s = r(1428);
        e.CancelMethods = {}, e.CancelMethods.Cancel = function (t, e, r) {
          var n = t.GetBrackets(e, ""),
            o = t.ParseArg(e),
            i = Q.default.keyvalOptions(n, s.ENCLOSE_OPTIONS);
          i.notation = r, t.Push(t.create("node", "menclose", [o], i));
        }, e.CancelMethods.CancelTo = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.ParseArg(e),
            o = t.ParseArg(e),
            a = Q.default.keyvalOptions(r, s.ENCLOSE_OPTIONS);
          a.notation = [i.TexConstant.Notation.UPDIAGONALSTRIKE, i.TexConstant.Notation.UPDIAGONALARROW, i.TexConstant.Notation.NORTHEASTARROW].join(" "), n = t.create("node", "mpadded", [n], {
            depth: "-.1em",
            height: "+.1em",
            voffset: ".1em"
          }), t.Push(t.create("node", "msup", [t.create("node", "menclose", [o], a), n]));
        }, new a.CommandMap("cancel", {
          cancel: ["Cancel", i.TexConstant.Notation.UPDIAGONALSTRIKE],
          bcancel: ["Cancel", i.TexConstant.Notation.DOWNDIAGONALSTRIKE],
          xcancel: ["Cancel", i.TexConstant.Notation.UPDIAGONALSTRIKE + " " + i.TexConstant.Notation.DOWNDIAGONALSTRIKE],
          cancelto: "CancelTo"
        }, e.CancelMethods), e.CancelConfiguration = o.Configuration.create("cancel", {
          handler: {
            macro: ["cancel"]
          }
        });
      },
      3752: function _(t, e, r) {
        var _n62,
          o,
          i = this && this.__extends || (_n62 = function n(t, e) {
            return _n62 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n62(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n62(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CasesConfiguration = e.CasesMethods = e.CasesTags = e.CasesBeginItem = void 0;
        var Q = r(9899),
          s = r(9140),
          T = a(r(1130)),
          l = a(r(7693)),
          c = a(r(3971)),
          u = r(1181),
          p = r(8021),
          h = r(6471),
          d = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "cases-begin";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("end") && e.getName() === this.getName() && this.getProperty("end") ? (this.setProperty("end", !1), [[], !0]) : t.prototype.checkItem.call(this, e);
            }, e;
          }(u.BeginItem);
        e.CasesBeginItem = d;
        var f = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.subcounter = 0, e;
          }
          return i(e, t), e.prototype.start = function (e, r, n) {
            this.subcounter = 0, t.prototype.start.call(this, e, r, n);
          }, e.prototype.autoTag = function () {
            null == this.currentTag.tag && ("subnumcases" === this.currentTag.env ? (0 === this.subcounter && this.counter++, this.subcounter++, this.tag(this.formatNumber(this.counter, this.subcounter), !1)) : (0 !== this.subcounter && "numcases-left" === this.currentTag.env || this.counter++, this.tag(this.formatNumber(this.counter), !1)));
          }, e.prototype.formatNumber = function (t, e) {
            return void 0 === e && (e = null), t.toString() + (null === e ? "" : String.fromCharCode(96 + e));
          }, e;
        }(p.AmsTags);
        e.CasesTags = f, e.CasesMethods = {
          NumCases: function NumCases(t, e) {
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing, t.Push(t.itemFactory.create("end").setProperty("name", e.getName()));
              var r = t.stack.Top(),
                n = r.Last,
                o = T.default.copyNode(n, t),
                i = r.getProperty("left");
              return h.EmpheqUtil.left(n, o, i + "\\empheqlbrace\\,", t, "numcases-left"), t.Push(t.itemFactory.create("end").setProperty("name", e.getName())), null;
            }
            i = t.GetArgument("\\begin{" + e.getName() + "}");
            e.setProperty("left", i);
            var a = l.default.EqnArray(t, e, !0, !0, "ll");
            return a.arraydef.displaystyle = !1, a.arraydef.rowspacing = ".2em", a.setProperty("numCases", !0), t.Push(e), a;
          },
          Entry: function Entry(t, e) {
            if (!t.stack.Top().getProperty("numCases")) return l.default.Entry(t, e);
            t.Push(t.itemFactory.create("cell").setProperties({
              isEntry: !0,
              name: e
            }));
            for (var r = t.string, n = 0, o = t.i, i = r.length; o < i;) {
              var a = r.charAt(o);
              if ("{" === a) n++, o++;else if ("}" === a) {
                if (0 === n) break;
                n--, o++;
              } else {
                if ("&" === a && 0 === n) throw new c.default("ExtraCasesAlignTab", "Extra alignment tab in text for numcase environment");
                if ("\\" === a && 0 === n) {
                  var Q = (r.slice(o + 1).match(/^[a-z]+|./i) || [])[0];
                  if ("\\" === Q || "cr" === Q || "end" === Q || "label" === Q) break;
                  o += Q.length;
                } else o++;
              }
            }
            var s = r.substr(t.i, o - t.i).replace(/^\s*/, "");
            t.PushAll(T.default.internalMath(t, s, 0)), t.i = o;
          }
        }, new s.EnvironmentMap("cases-env", h.EmpheqUtil.environment, {
          numcases: ["NumCases", "cases"],
          subnumcases: ["NumCases", "cases"]
        }, e.CasesMethods), new s.MacroMap("cases-macros", {
          "&": "Entry"
        }, e.CasesMethods), e.CasesConfiguration = Q.Configuration.create("cases", {
          handler: {
            environment: ["cases-env"],
            character: ["cases-macros"]
          },
          items: (o = {}, o[d.prototype.kind] = d, o),
          tags: {
            cases: f
          }
        });
      },
      8227: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CenternotConfiguration = e.filterCenterOver = void 0;
        var i = r(9899),
          a = o(r(8417)),
          Q = o(r(1256)),
          s = r(9140),
          T = o(r(7693));
        function l(t) {
          var e,
            r,
            o = t.data;
          try {
            for (var i = n(o.getList("centerOver")), a = i.next(); !a.done; a = i.next()) {
              var s = a.value,
                T = Q.default.getTexClass(s.childNodes[0].childNodes[0]);
              null !== T && Q.default.setProperties(s.parent.parent.parent.parent.parent.parent, {
                texClass: T
              });
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (r = i.return) && r.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        new s.CommandMap("centernot", {
          centerOver: "CenterOver",
          centernot: ["Macro", "\\centerOver{#1}{{\u29F8}}", 1]
        }, {
          CenterOver: function CenterOver(t, e) {
            var r = "{" + t.GetArgument(e) + "}",
              n = t.ParseArg(e),
              o = new a.default(r, t.stack.env, t.configuration).mml(),
              i = t.create("node", "TeXAtom", [new a.default(r, t.stack.env, t.configuration).mml(), t.create("node", "mpadded", [t.create("node", "mpadded", [n], {
                width: 0,
                lspace: "-.5width"
              }), t.create("node", "mphantom", [o])], {
                width: 0,
                lspace: "-.5width"
              })]);
            t.configuration.addNode("centerOver", o), t.Push(i);
          },
          Macro: T.default.Macro
        }), e.filterCenterOver = l, e.CenternotConfiguration = i.Configuration.create("centernot", {
          handler: {
            macro: ["centernot"]
          },
          postprocessors: [l]
        });
      },
      5860: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorConfiguration = void 0;
        var n = r(9140),
          o = r(9899),
          i = r(2784),
          a = r(4207);
        new n.CommandMap("color", {
          color: "Color",
          textcolor: "TextColor",
          definecolor: "DefineColor",
          colorbox: "ColorBox",
          fcolorbox: "FColorBox"
        }, i.ColorMethods);
        e.ColorConfiguration = o.Configuration.create("color", {
          handler: {
            macro: ["color"]
          },
          options: {
            color: {
              padding: "5px",
              borderWidth: "2px"
            }
          },
          config: function config(t, e) {
            e.parseOptions.packageData.set("color", {
              model: new a.ColorModel()
            });
          }
        });
      },
      7960: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.COLORS = void 0, e.COLORS = new Map([["Apricot", "#FBB982"], ["Aquamarine", "#00B5BE"], ["Bittersweet", "#C04F17"], ["Black", "#221E1F"], ["Blue", "#2D2F92"], ["BlueGreen", "#00B3B8"], ["BlueViolet", "#473992"], ["BrickRed", "#B6321C"], ["Brown", "#792500"], ["BurntOrange", "#F7921D"], ["CadetBlue", "#74729A"], ["CarnationPink", "#F282B4"], ["Cerulean", "#00A2E3"], ["CornflowerBlue", "#41B0E4"], ["Cyan", "#00AEEF"], ["Dandelion", "#FDBC42"], ["DarkOrchid", "#A4538A"], ["Emerald", "#00A99D"], ["ForestGreen", "#009B55"], ["Fuchsia", "#8C368C"], ["Goldenrod", "#FFDF42"], ["Gray", "#949698"], ["Green", "#00A64F"], ["GreenYellow", "#DFE674"], ["JungleGreen", "#00A99A"], ["Lavender", "#F49EC4"], ["LimeGreen", "#8DC73E"], ["Magenta", "#EC008C"], ["Mahogany", "#A9341F"], ["Maroon", "#AF3235"], ["Melon", "#F89E7B"], ["MidnightBlue", "#006795"], ["Mulberry", "#A93C93"], ["NavyBlue", "#006EB8"], ["OliveGreen", "#3C8031"], ["Orange", "#F58137"], ["OrangeRed", "#ED135A"], ["Orchid", "#AF72B0"], ["Peach", "#F7965A"], ["Periwinkle", "#7977B8"], ["PineGreen", "#008B72"], ["Plum", "#92268F"], ["ProcessBlue", "#00B0F0"], ["Purple", "#99479B"], ["RawSienna", "#974006"], ["Red", "#ED1B23"], ["RedOrange", "#F26035"], ["RedViolet", "#A1246B"], ["Rhodamine", "#EF559F"], ["RoyalBlue", "#0071BC"], ["RoyalPurple", "#613F99"], ["RubineRed", "#ED017D"], ["Salmon", "#F69289"], ["SeaGreen", "#3FBC9D"], ["Sepia", "#671800"], ["SkyBlue", "#46C5DD"], ["SpringGreen", "#C6DC67"], ["Tan", "#DA9D76"], ["TealBlue", "#00AEB3"], ["Thistle", "#D883B7"], ["Turquoise", "#00B4CE"], ["Violet", "#58429B"], ["VioletRed", "#EF58A0"], ["White", "#FFFFFF"], ["WildStrawberry", "#EE2967"], ["Yellow", "#FFF200"], ["YellowGreen", "#98CC70"], ["YellowOrange", "#FAA21A"]]);
      },
      2784: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorMethods = void 0;
        var o = n(r(1256)),
          i = n(r(1130));
        function a(t) {
          var e = "+".concat(t),
            r = t.replace(/^.*?([a-z]*)$/, "$1"),
            n = 2 * parseFloat(e);
          return {
            width: "+".concat(n).concat(r),
            height: e,
            depth: e,
            lspace: t
          };
        }
        e.ColorMethods = {}, e.ColorMethods.Color = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.GetArgument(e),
            o = t.configuration.packageData.get("color").model.getColor(r, n),
            i = t.itemFactory.create("style").setProperties({
              styles: {
                mathcolor: o
              }
            });
          t.stack.env.color = o, t.Push(i);
        }, e.ColorMethods.TextColor = function (t, e) {
          var r = t.GetBrackets(e, ""),
            n = t.GetArgument(e),
            o = t.configuration.packageData.get("color").model.getColor(r, n),
            i = t.stack.env.color;
          t.stack.env.color = o;
          var a = t.ParseArg(e);
          i ? t.stack.env.color = i : delete t.stack.env.color;
          var Q = t.create("node", "mstyle", [a], {
            mathcolor: o
          });
          t.Push(Q);
        }, e.ColorMethods.DefineColor = function (t, e) {
          var r = t.GetArgument(e),
            n = t.GetArgument(e),
            o = t.GetArgument(e);
          t.configuration.packageData.get("color").model.defineColor(n, r, o);
        }, e.ColorMethods.ColorBox = function (t, e) {
          var r = t.GetArgument(e),
            n = i.default.internalMath(t, t.GetArgument(e)),
            Q = t.configuration.packageData.get("color").model,
            s = t.create("node", "mpadded", n, {
              mathbackground: Q.getColor("named", r)
            });
          o.default.setProperties(s, a(t.options.color.padding)), t.Push(s);
        }, e.ColorMethods.FColorBox = function (t, e) {
          var r = t.GetArgument(e),
            n = t.GetArgument(e),
            Q = i.default.internalMath(t, t.GetArgument(e)),
            s = t.options.color,
            T = t.configuration.packageData.get("color").model,
            l = t.create("node", "mpadded", Q, {
              mathbackground: T.getColor("named", n),
              style: "border: ".concat(s.borderWidth, " solid ").concat(T.getColor("named", r))
            });
          o.default.setProperties(l, a(s.padding)), t.Push(l);
        };
      },
      4207: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorModel = void 0;
        var i = o(r(3971)),
          a = r(7960),
          Q = new Map(),
          s = function () {
            function t() {
              this.userColors = new Map();
            }
            return t.prototype.normalizeColor = function (t, e) {
              if (!t || "named" === t) return e;
              if (Q.has(t)) return Q.get(t)(e);
              throw new i.default("UndefinedColorModel", "Color model '%1' not defined", t);
            }, t.prototype.getColor = function (t, e) {
              return t && "named" !== t ? this.normalizeColor(t, e) : this.getColorByName(e);
            }, t.prototype.getColorByName = function (t) {
              return this.userColors.has(t) ? this.userColors.get(t) : a.COLORS.has(t) ? a.COLORS.get(t) : t;
            }, t.prototype.defineColor = function (t, e, r) {
              var n = this.normalizeColor(t, r);
              this.userColors.set(e, n);
            }, t;
          }();
        e.ColorModel = s, Q.set("rgb", function (t) {
          var e,
            r,
            o = t.trim().split(/\s*,\s*/),
            a = "#";
          if (3 !== o.length) throw new i.default("ModelArg1", "Color values for the %1 model require 3 numbers", "rgb");
          try {
            for (var Q = n(o), s = Q.next(); !s.done; s = Q.next()) {
              var T = s.value;
              if (!T.match(/^(\d+(\.\d*)?|\.\d+)$/)) throw new i.default("InvalidDecimalNumber", "Invalid decimal number");
              var l = parseFloat(T);
              if (l < 0 || l > 1) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "rgb", "0", "1");
              var c = Math.floor(255 * l).toString(16);
              c.length < 2 && (c = "0" + c), a += c;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (r = Q.return) && r.call(Q);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }), Q.set("RGB", function (t) {
          var e,
            r,
            o = t.trim().split(/\s*,\s*/),
            a = "#";
          if (3 !== o.length) throw new i.default("ModelArg1", "Color values for the %1 model require 3 numbers", "RGB");
          try {
            for (var Q = n(o), s = Q.next(); !s.done; s = Q.next()) {
              var T = s.value;
              if (!T.match(/^\d+$/)) throw new i.default("InvalidNumber", "Invalid number");
              var l = parseInt(T);
              if (l > 255) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "RGB", "0", "255");
              var c = l.toString(16);
              c.length < 2 && (c = "0" + c), a += c;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (r = Q.return) && r.call(Q);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }), Q.set("gray", function (t) {
          if (!t.match(/^\s*(\d+(\.\d*)?|\.\d+)\s*$/)) throw new i.default("InvalidDecimalNumber", "Invalid decimal number");
          var e = parseFloat(t);
          if (e < 0 || e > 1) throw new i.default("ModelArg2", "Color values for the %1 model must be between %2 and %3", "gray", "0", "1");
          var r = Math.floor(255 * e).toString(16);
          return r.length < 2 && (r = "0" + r), "#".concat(r).concat(r).concat(r);
        });
      },
      6648: function _(t, e, r) {
        var _n63,
          o = this && this.__extends || (_n63 = function n(t, e) {
            return _n63 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n63(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n63(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColortblConfiguration = e.ColorArrayItem = void 0;
        var a = r(1181),
          Q = r(9899),
          s = r(9140),
          T = i(r(3971)),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.color = {
                cell: "",
                row: "",
                col: []
              }, e.hasColor = !1, e;
            }
            return o(e, t), e.prototype.EndEntry = function () {
              t.prototype.EndEntry.call(this);
              var e = this.row[this.row.length - 1],
                r = this.color.cell || this.color.row || this.color.col[this.row.length - 1];
              r && (e.attributes.set("mathbackground", r), this.color.cell = "", this.hasColor = !0);
            }, e.prototype.EndRow = function () {
              t.prototype.EndRow.call(this), this.color.row = "";
            }, e.prototype.createMml = function () {
              var e = t.prototype.createMml.call(this),
                r = e.isKind("mrow") ? e.childNodes[1] : e;
              return r.isKind("menclose") && (r = r.childNodes[0].childNodes[0]), this.hasColor && "none" === r.attributes.get("frame") && r.attributes.set("frame", ""), e;
            }, e;
          }(a.ArrayItem);
        e.ColorArrayItem = l, new s.CommandMap("colortbl", {
          cellcolor: ["TableColor", "cell"],
          rowcolor: ["TableColor", "row"],
          columncolor: ["TableColor", "col"]
        }, {
          TableColor: function TableColor(t, e, r) {
            var n = t.configuration.packageData.get("color").model,
              o = t.GetBrackets(e, ""),
              i = n.getColor(o, t.GetArgument(e)),
              a = t.stack.Top();
            if (!(a instanceof l)) throw new T.default("UnsupportedTableColor", "Unsupported use of %1", t.currentCS);
            if ("col" === r) {
              if (a.table.length) throw new T.default("ColumnColorNotTop", "%1 must be in the top row", e);
              a.color.col[a.row.length] = i, t.GetBrackets(e, "") && t.GetBrackets(e, "");
            } else if (a.color[r] = i, "row" === r && (a.Size() || a.row.length)) throw new T.default("RowColorNotFirst", "%1 must be at the beginning of a row", e);
          }
        });
        e.ColortblConfiguration = Q.Configuration.create("colortbl", {
          handler: {
            macro: ["colortbl"]
          },
          items: {
            array: l
          },
          priority: 10,
          config: [function (t, e) {
            e.parseOptions.packageData.has("color") || Q.ConfigurationHandler.get("color").config(t, e);
          }, 10]
        });
      },
      6628: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorConfiguration = e.ColorV2Methods = void 0;
        var n = r(9140),
          o = r(9899);
        e.ColorV2Methods = {
          Color: function Color(t, e) {
            var r = t.GetArgument(e),
              n = t.stack.env.color;
            t.stack.env.color = r;
            var o = t.ParseArg(e);
            n ? t.stack.env.color = n : delete t.stack.env.color;
            var i = t.create("node", "mstyle", [o], {
              mathcolor: r
            });
            t.Push(i);
          }
        }, new n.CommandMap("colorv2", {
          color: "Color"
        }, e.ColorV2Methods), e.ColorConfiguration = o.Configuration.create("colorv2", {
          handler: {
            macro: ["colorv2"]
          }
        });
      },
      8458: function _(t, e, r) {
        var n,
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ConfigMacrosConfiguration = void 0;
        var a = r(9899),
          Q = r(7233),
          s = r(9140),
          T = i(r(5450)),
          l = r(8803),
          c = i(r(1110)),
          u = r(6793),
          p = "configmacros-map",
          h = "configmacros-env-map";
        e.ConfigMacrosConfiguration = a.Configuration.create("configmacros", {
          init: function init(t) {
            new s.CommandMap(p, {}, {}), new s.EnvironmentMap(h, T.default.environment, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [p],
                environment: [h]
              },
              priority: 3
            }));
          },
          config: function config(t, e) {
            !function (t) {
              var e,
                r,
                n = t.parseOptions.handlers.retrieve(p),
                i = t.parseOptions.options.macros;
              try {
                for (var a = o(Object.keys(i)), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value,
                    T = "string" == typeof i[s] ? [i[s]] : i[s],
                    u = Array.isArray(T[2]) ? new l.Macro(s, c.default.MacroWithTemplate, T.slice(0, 2).concat(T[2])) : new l.Macro(s, c.default.Macro, T);
                  n.add(s, u);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }(e), function (t) {
              var e,
                r,
                n = t.parseOptions.handlers.retrieve(h),
                i = t.parseOptions.options.environments;
              try {
                for (var a = o(Object.keys(i)), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  n.add(s, new l.Macro(s, c.default.BeginEnv, [!0].concat(i[s])));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
            }(e);
          },
          items: (n = {}, n[u.BeginEnvItem.prototype.kind] = u.BeginEnvItem, n),
          options: {
            macros: (0, Q.expandable)({}),
            environments: (0, Q.expandable)({})
          }
        });
      },
      5464: function _(t, e, r) {
        var _n64,
          o,
          i = this && this.__extends || (_n64 = function n(t, e) {
            return _n64 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n64(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n64(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmpheqConfiguration = e.EmpheqMethods = e.EmpheqBeginItem = void 0;
        var s = r(9899),
          T = r(9140),
          l = Q(r(1130)),
          c = Q(r(3971)),
          u = r(1181),
          p = r(6471),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return i(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "empheq-begin";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              return e.isKind("end") && e.getName() === this.getName() && this.setProperty("end", !1), t.prototype.checkItem.call(this, e);
            }, e;
          }(u.BeginItem);
        e.EmpheqBeginItem = h, e.EmpheqMethods = {
          Empheq: function Empheq(t, e) {
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing, t.Push(t.itemFactory.create("end").setProperty("name", t.stack.global.empheq)), t.stack.global.empheq = "";
              var r = t.stack.Top();
              p.EmpheqUtil.adjustTable(r, t), t.Push(t.itemFactory.create("end").setProperty("name", "empheq"));
            } else {
              l.default.checkEqnEnv(t), delete t.stack.global.eqnenv;
              var n = t.GetBrackets("\\begin{" + e.getName() + "}") || "",
                o = a((t.GetArgument("\\begin{" + e.getName() + "}") || "").split(/=/), 2),
                i = o[0],
                Q = o[1];
              if (!p.EmpheqUtil.checkEnv(i)) throw new c.default("UnknownEnv", 'Unknown environment "%1"', i);
              n && e.setProperties(p.EmpheqUtil.splitOptions(n, {
                left: 1,
                right: 1
              })), t.stack.global.empheq = i, t.string = "\\begin{" + i + "}" + (Q ? "{" + Q + "}" : "") + t.string.slice(t.i), t.i = 0, t.Push(e);
            }
          },
          EmpheqMO: function EmpheqMO(t, e, r) {
            t.Push(t.create("token", "mo", {}, r));
          },
          EmpheqDelim: function EmpheqDelim(t, e) {
            var r = t.GetDelimiter(e);
            t.Push(t.create("token", "mo", {
              stretchy: !0,
              symmetric: !0
            }, r));
          }
        }, new T.EnvironmentMap("empheq-env", p.EmpheqUtil.environment, {
          empheq: ["Empheq", "empheq"]
        }, e.EmpheqMethods), new T.CommandMap("empheq-macros", {
          empheqlbrace: ["EmpheqMO", "{"],
          empheqrbrace: ["EmpheqMO", "}"],
          empheqlbrack: ["EmpheqMO", "["],
          empheqrbrack: ["EmpheqMO", "]"],
          empheqlangle: ["EmpheqMO", "\u27E8"],
          empheqrangle: ["EmpheqMO", "\u27E9"],
          empheqlparen: ["EmpheqMO", "("],
          empheqrparen: ["EmpheqMO", ")"],
          empheqlvert: ["EmpheqMO", "|"],
          empheqrvert: ["EmpheqMO", "|"],
          empheqlVert: ["EmpheqMO", "\u2016"],
          empheqrVert: ["EmpheqMO", "\u2016"],
          empheqlfloor: ["EmpheqMO", "\u230A"],
          empheqrfloor: ["EmpheqMO", "\u230B"],
          empheqlceil: ["EmpheqMO", "\u2308"],
          empheqrceil: ["EmpheqMO", "\u2309"],
          empheqbiglbrace: ["EmpheqMO", "{"],
          empheqbigrbrace: ["EmpheqMO", "}"],
          empheqbiglbrack: ["EmpheqMO", "["],
          empheqbigrbrack: ["EmpheqMO", "]"],
          empheqbiglangle: ["EmpheqMO", "\u27E8"],
          empheqbigrangle: ["EmpheqMO", "\u27E9"],
          empheqbiglparen: ["EmpheqMO", "("],
          empheqbigrparen: ["EmpheqMO", ")"],
          empheqbiglvert: ["EmpheqMO", "|"],
          empheqbigrvert: ["EmpheqMO", "|"],
          empheqbiglVert: ["EmpheqMO", "\u2016"],
          empheqbigrVert: ["EmpheqMO", "\u2016"],
          empheqbiglfloor: ["EmpheqMO", "\u230A"],
          empheqbigrfloor: ["EmpheqMO", "\u230B"],
          empheqbiglceil: ["EmpheqMO", "\u2308"],
          empheqbigrceil: ["EmpheqMO", "\u2309"],
          empheql: "EmpheqDelim",
          empheqr: "EmpheqDelim",
          empheqbigl: "EmpheqDelim",
          empheqbigr: "EmpheqDelim"
        }, e.EmpheqMethods), e.EmpheqConfiguration = s.Configuration.create("empheq", {
          handler: {
            macro: ["empheq-macros"],
            environment: ["empheq-env"]
          },
          items: (o = {}, o[h.prototype.kind] = h, o)
        });
      },
      6471: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EmpheqUtil = void 0;
        var Q = a(r(1130)),
          s = a(r(8417));
        e.EmpheqUtil = {
          environment: function environment(t, e, r, i) {
            var a = i[0],
              Q = t.itemFactory.create(a + "-begin").setProperties({
                name: e,
                end: a
              });
            t.Push(r.apply(void 0, o([t, Q], n(i.slice(1)), !1)));
          },
          splitOptions: function splitOptions(t, e) {
            return void 0 === e && (e = null), Q.default.keyvalOptions(t, e, !0);
          },
          columnCount: function columnCount(t) {
            var e,
              r,
              n = 0;
            try {
              for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                var Q = a.value,
                  s = Q.childNodes.length - (Q.isKind("mlabeledtr") ? 1 : 0);
                s > n && (n = s);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = o.return) && r.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
            return n;
          },
          cellBlock: function cellBlock(t, e, r, n) {
            var o,
              a,
              Q = r.create("node", "mpadded", [], {
                height: 0,
                depth: 0,
                voffset: "-1height"
              }),
              T = new s.default(t, r.stack.env, r.configuration),
              l = T.mml();
            n && T.configuration.tags.label && (T.configuration.tags.currentTag.env = n, T.configuration.tags.getTag(!0));
            try {
              for (var c = i(l.isInferred ? l.childNodes : [l]), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                Q.appendChild(p);
              }
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (a = c.return) && a.call(c);
              } finally {
                if (o) throw o.error;
              }
            }
            return Q.appendChild(r.create("node", "mphantom", [r.create("node", "mpadded", [e], {
              width: 0
            })])), Q;
          },
          topRowTable: function topRowTable(t, e) {
            var r = Q.default.copyNode(t, e);
            return r.setChildren(r.childNodes.slice(0, 1)), r.attributes.set("align", "baseline 1"), t.factory.create("mphantom", {}, [e.create("node", "mpadded", [r], {
              width: 0
            })]);
          },
          rowspanCell: function rowspanCell(t, e, r, n, o) {
            t.appendChild(n.create("node", "mpadded", [this.cellBlock(e, Q.default.copyNode(r, n), n, o), this.topRowTable(r, n)], {
              height: 0,
              depth: 0,
              voffset: "height"
            }));
          },
          left: function left(t, e, r, n, o) {
            var a, Q, s;
            void 0 === o && (o = ""), t.attributes.set("columnalign", "right " + (t.attributes.get("columnalign") || "")), t.attributes.set("columnspacing", "0em " + (t.attributes.get("columnspacing") || ""));
            try {
              for (var T = i(t.childNodes.slice(0).reverse()), l = T.next(); !l.done; l = T.next()) {
                var c = l.value;
                s = n.create("node", "mtd"), c.childNodes.unshift(s), s.parent = c, c.isKind("mlabeledtr") && (c.childNodes[0] = c.childNodes[1], c.childNodes[1] = s);
              }
            } catch (t) {
              a = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (Q = T.return) && Q.call(T);
              } finally {
                if (a) throw a.error;
              }
            }
            this.rowspanCell(s, r, e, n, o);
          },
          right: function right(t, r, n, o, i) {
            void 0 === i && (i = ""), 0 === t.childNodes.length && t.appendChild(o.create("node", "mtr"));
            for (var a = e.EmpheqUtil.columnCount(t), Q = t.childNodes[0]; Q.childNodes.length < a;) Q.appendChild(o.create("node", "mtd"));
            var s = Q.appendChild(o.create("node", "mtd"));
            e.EmpheqUtil.rowspanCell(s, n, r, o, i), t.attributes.set("columnalign", (t.attributes.get("columnalign") || "").split(/ /).slice(0, a).join(" ") + " left"), t.attributes.set("columnspacing", (t.attributes.get("columnspacing") || "").split(/ /).slice(0, a - 1).join(" ") + " 0em");
          },
          adjustTable: function adjustTable(t, e) {
            var r = t.getProperty("left"),
              n = t.getProperty("right");
            if (r || n) {
              var o = t.Last,
                i = Q.default.copyNode(o, e);
              r && this.left(o, i, r, e), n && this.right(o, i, n, e);
            }
          },
          allowEnv: {
            equation: !0,
            align: !0,
            gather: !0,
            flalign: !0,
            alignat: !0,
            multline: !0
          },
          checkEnv: function checkEnv(t) {
            return this.allowEnv.hasOwnProperty(t.replace(/\*$/, "")) || !1;
          }
        };
      },
      1428: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EncloseConfiguration = e.EncloseMethods = e.ENCLOSE_OPTIONS = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(1130));
        e.ENCLOSE_OPTIONS = {
          "data-arrowhead": 1,
          color: 1,
          mathcolor: 1,
          background: 1,
          mathbackground: 1,
          "data-padding": 1,
          "data-thickness": 1
        }, e.EncloseMethods = {}, e.EncloseMethods.Enclose = function (t, r) {
          var n = t.GetArgument(r).replace(/,/g, " "),
            o = t.GetBrackets(r, ""),
            i = t.ParseArg(r),
            Q = a.default.keyvalOptions(o, e.ENCLOSE_OPTIONS);
          Q.notation = n, t.Push(t.create("node", "menclose", [i], Q));
        }, new i.CommandMap("enclose", {
          enclose: "Enclose"
        }, e.EncloseMethods), e.EncloseConfiguration = o.Configuration.create("enclose", {
          handler: {
            macro: ["enclose"]
          }
        });
      },
      6121: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ExtpfeilConfiguration = e.ExtpfeilMethods = void 0;
        var o = r(9899),
          i = r(9140),
          a = r(4387),
          Q = n(r(5579)),
          s = r(1496),
          T = n(r(3971));
        e.ExtpfeilMethods = {}, e.ExtpfeilMethods.xArrow = a.AmsMethods.xArrow, e.ExtpfeilMethods.NewExtArrow = function (t, r) {
          var n = t.GetArgument(r),
            o = t.GetArgument(r),
            i = t.GetArgument(r);
          if (!n.match(/^\\([a-z]+|.)$/i)) throw new T.default("NewextarrowArg1", "First argument to %1 must be a control sequence name", r);
          if (!o.match(/^(\d+),(\d+)$/)) throw new T.default("NewextarrowArg2", "Second argument to %1 must be two integers separated by a comma", r);
          if (!i.match(/^(\d+|0x[0-9A-F]+)$/i)) throw new T.default("NewextarrowArg3", "Third argument to %1 must be a unicode character number", r);
          n = n.substr(1);
          var a = o.split(",");
          Q.default.addMacro(t, n, e.ExtpfeilMethods.xArrow, [parseInt(i), parseInt(a[0]), parseInt(a[1])]);
        }, new i.CommandMap("extpfeil", {
          xtwoheadrightarrow: ["xArrow", 8608, 12, 16],
          xtwoheadleftarrow: ["xArrow", 8606, 17, 13],
          xmapsto: ["xArrow", 8614, 6, 7],
          xlongequal: ["xArrow", 61, 7, 7],
          xtofrom: ["xArrow", 8644, 12, 12],
          Newextarrow: "NewExtArrow"
        }, e.ExtpfeilMethods);
        e.ExtpfeilConfiguration = o.Configuration.create("extpfeil", {
          handler: {
            macro: ["extpfeil"]
          },
          init: function init(t) {
            s.NewcommandConfiguration.init(t);
          }
        });
      },
      3078: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.GensymbConfiguration = void 0;
        var n = r(9899),
          o = r(8317);
        new (r(9140).CharacterMap)("gensymb-symbols", function (t, e) {
          var r = e.attributes || {};
          r.mathvariant = o.TexConstant.Variant.NORMAL, r.class = "MathML-Unit";
          var n = t.create("token", "mi", r, e.char);
          t.Push(n);
        }, {
          ohm: "\u2126",
          degree: "\xb0",
          celsius: "\u2103",
          perthousand: "\u2030",
          micro: "\xb5"
        }), e.GensymbConfiguration = n.Configuration.create("gensymb", {
          handler: {
            macro: ["gensymb-symbols"]
          }
        });
      },
      8901: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlConfiguration = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(332));
        new i.CommandMap("html_macros", {
          href: "Href",
          class: "Class",
          style: "Style",
          cssId: "Id"
        }, a.default), e.HtmlConfiguration = o.Configuration.create("html", {
          handler: {
            macro: ["html_macros"]
          }
        });
      },
      332: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(1256)),
          i = {
            Href: function Href(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e);
              o.default.setAttribute(n, "href", r), t.Push(n);
            },
            Class: function Class(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e),
                i = o.default.getAttribute(n, "class");
              i && (r = i + " " + r), o.default.setAttribute(n, "class", r), t.Push(n);
            },
            Style: function Style(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e),
                i = o.default.getAttribute(n, "style");
              i && (";" !== r.charAt(r.length - 1) && (r += ";"), r = i + " " + r), o.default.setAttribute(n, "style", r), t.Push(n);
            },
            Id: function Id(t, e) {
              var r = t.GetArgument(e),
                n = a(t, e);
              o.default.setAttribute(n, "id", r), t.Push(n);
            }
          },
          a = function a(t, e) {
            var r = t.ParseArg(e);
            if (!o.default.isInferred(r)) return r;
            var n = o.default.getChildren(r);
            if (1 === n.length) return n[0];
            var i = t.create("node", "mrow");
            return o.default.copyChildren(r, i), o.default.copyAttributes(r, i), i;
          };
        e.default = i;
      },
      7535: function _(t, e, r) {
        var n,
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsConfiguration = e.fixPrescripts = e.PAIREDDELIMS = void 0;
        var a = r(9899),
          Q = r(9140),
          s = i(r(1256)),
          T = r(7233);
        r(2448);
        var l = r(836),
          c = r(1503),
          u = r(6224);
        function p(t) {
          var e,
            r,
            n,
            i,
            a,
            Q,
            T = t.data;
          try {
            for (var l = o(T.getList("mmultiscripts")), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              if (u.getProperty("fixPrescript")) {
                var p = s.default.getChildren(u),
                  h = 0;
                try {
                  for (var d = (n = void 0, o([1, 2])), f = d.next(); !f.done; f = d.next()) {
                    p[y = f.value] || (s.default.setChild(u, y, T.nodeFactory.create("node", "none")), h++);
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    f && !f.done && (i = d.return) && i.call(d);
                  } finally {
                    if (n) throw n.error;
                  }
                }
                try {
                  for (var m = (a = void 0, o([4, 5])), L = m.next(); !L.done; L = m.next()) {
                    var y = L.value;
                    s.default.isType(p[y], "mrow") && 0 === s.default.getChildren(p[y]).length && s.default.setChild(u, y, T.nodeFactory.create("node", "none"));
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    L && !L.done && (Q = m.return) && Q.call(m);
                  } finally {
                    if (a) throw a.error;
                  }
                }
                2 === h && p.splice(1, 2);
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (r = l.return) && r.call(l);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        e.PAIREDDELIMS = "mathtools-paired-delims", e.fixPrescripts = p, e.MathtoolsConfiguration = a.Configuration.create("mathtools", {
          handler: {
            macro: ["mathtools-macros", "mathtools-delimiters"],
            environment: ["mathtools-environments"],
            delimiter: ["mathtools-delimiters"],
            character: ["mathtools-characters"]
          },
          items: (n = {}, n[u.MultlinedItem.prototype.kind] = u.MultlinedItem, n),
          init: function init(t) {
            new Q.CommandMap(e.PAIREDDELIMS, {}, {}), t.append(a.Configuration.local({
              handler: {
                macro: [e.PAIREDDELIMS]
              },
              priority: -5
            }));
          },
          config: function config(t, e) {
            var r,
              n,
              i = e.parseOptions,
              a = i.options.mathtools.pairedDelimiters;
            try {
              for (var Q = o(Object.keys(a)), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                l.MathtoolsUtil.addPairedDelims(i, T, a[T]);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = Q.return) && n.call(Q);
              } finally {
                if (r) throw r.error;
              }
            }
            (0, c.MathtoolsTagFormat)(t, e);
          },
          postprocessors: [[p, -6]],
          options: {
            mathtools: {
              multlinegap: "1em",
              "multlined-pos": "c",
              "firstline-afterskip": "",
              "lastline-preskip": "",
              "smallmatrix-align": "c",
              shortvdotsadjustabove: ".2em",
              shortvdotsadjustbelow: ".2em",
              centercolon: !1,
              "centercolon-offset": ".04em",
              "thincolon-dx": "-.04em",
              "thincolon-dw": "-.08em",
              "use-unicode": !1,
              "prescript-sub-format": "",
              "prescript-sup-format": "",
              "prescript-arg-format": "",
              "allow-mathtoolsset": !0,
              pairedDelimiters: (0, T.expandable)({}),
              tagforms: (0, T.expandable)({})
            }
          }
        });
      },
      6224: function _(t, e, r) {
        var _n65,
          o = this && this.__extends || (_n65 = function n(t, e) {
            return _n65 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n65(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n65(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MultlinedItem = void 0;
        var a = r(2790),
          Q = i(r(1256)),
          s = r(8317),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "multlined";
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.EndTable = function () {
              if ((this.Size() || this.row.length) && (this.EndEntry(), this.EndRow()), this.table.length > 1) {
                var e = this.factory.configuration.options.mathtools,
                  r = e.multlinegap,
                  n = e["firstline-afterskip"] || r,
                  o = e["lastline-preskip"] || r,
                  i = Q.default.getChildren(this.table[0])[0];
                Q.default.getAttribute(i, "columnalign") !== s.TexConstant.Align.RIGHT && i.appendChild(this.create("node", "mspace", [], {
                  width: n
                }));
                var a = Q.default.getChildren(this.table[this.table.length - 1])[0];
                if (Q.default.getAttribute(a, "columnalign") !== s.TexConstant.Align.LEFT) {
                  var T = Q.default.getChildren(a)[0];
                  T.childNodes.unshift(null);
                  var l = this.create("node", "mspace", [], {
                    width: o
                  });
                  Q.default.setChild(T, 0, l);
                }
              }
              t.prototype.EndTable.call(this);
            }, e;
          }(a.MultlineItem);
        e.MultlinedItem = T;
      },
      2448: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(5450)),
          i = r(9140),
          a = r(8317),
          Q = r(643);
        new i.CommandMap("mathtools-macros", {
          shoveleft: ["HandleShove", a.TexConstant.Align.LEFT],
          shoveright: ["HandleShove", a.TexConstant.Align.RIGHT],
          xleftrightarrow: ["xArrow", 8596, 10, 10],
          xLeftarrow: ["xArrow", 8656, 12, 7],
          xRightarrow: ["xArrow", 8658, 7, 12],
          xLeftrightarrow: ["xArrow", 8660, 12, 12],
          xhookleftarrow: ["xArrow", 8617, 10, 5],
          xhookrightarrow: ["xArrow", 8618, 5, 10],
          xmapsto: ["xArrow", 8614, 10, 10],
          xrightharpoondown: ["xArrow", 8641, 5, 10],
          xleftharpoondown: ["xArrow", 8637, 10, 5],
          xrightleftharpoons: ["xArrow", 8652, 10, 10],
          xrightharpoonup: ["xArrow", 8640, 5, 10],
          xleftharpoonup: ["xArrow", 8636, 10, 5],
          xleftrightharpoons: ["xArrow", 8651, 10, 10],
          mathllap: ["MathLap", "l", !1],
          mathrlap: ["MathLap", "r", !1],
          mathclap: ["MathLap", "c", !1],
          clap: ["MtLap", "c"],
          textllap: ["MtLap", "l"],
          textrlap: ["MtLap", "r"],
          textclap: ["MtLap", "c"],
          cramped: "Cramped",
          crampedllap: ["MathLap", "l", !0],
          crampedrlap: ["MathLap", "r", !0],
          crampedclap: ["MathLap", "c", !0],
          crampedsubstack: ["Macro", "\\begin{crampedsubarray}{c}#1\\end{crampedsubarray}", 1],
          mathmbox: "MathMBox",
          mathmakebox: "MathMakeBox",
          overbracket: "UnderOverBracket",
          underbracket: "UnderOverBracket",
          refeq: "HandleRef",
          MoveEqLeft: ["Macro", "\\hspace{#1em}&\\hspace{-#1em}", 1, "2"],
          Aboxed: "Aboxed",
          ArrowBetweenLines: "ArrowBetweenLines",
          vdotswithin: "VDotsWithin",
          shortvdotswithin: "ShortVDotsWithin",
          MTFlushSpaceAbove: "FlushSpaceAbove",
          MTFlushSpaceBelow: "FlushSpaceBelow",
          DeclarePairedDelimiter: "DeclarePairedDelimiter",
          DeclarePairedDelimiterX: "DeclarePairedDelimiterX",
          DeclarePairedDelimiterXPP: "DeclarePairedDelimiterXPP",
          DeclarePairedDelimiters: "DeclarePairedDelimiter",
          DeclarePairedDelimitersX: "DeclarePairedDelimiterX",
          DeclarePairedDelimitersXPP: "DeclarePairedDelimiterXPP",
          centercolon: ["CenterColon", !0, !0],
          ordinarycolon: ["CenterColon", !1],
          MTThinColon: ["CenterColon", !0, !0, !0],
          coloneqq: ["Relation", ":=", "\u2254"],
          Coloneqq: ["Relation", "::=", "\u2A74"],
          coloneq: ["Relation", ":-"],
          Coloneq: ["Relation", "::-"],
          eqqcolon: ["Relation", "=:", "\u2255"],
          Eqqcolon: ["Relation", "=::"],
          eqcolon: ["Relation", "-:", "\u2239"],
          Eqcolon: ["Relation", "-::"],
          colonapprox: ["Relation", ":\\approx"],
          Colonapprox: ["Relation", "::\\approx"],
          colonsim: ["Relation", ":\\sim"],
          Colonsim: ["Relation", "::\\sim"],
          dblcolon: ["Relation", "::", "\u2237"],
          nuparrow: ["NArrow", "\u2191", ".06em"],
          ndownarrow: ["NArrow", "\u2193", ".25em"],
          bigtimes: ["Macro", "\\mathop{\\Large\\kern-.1em\\boldsymbol{\\times}\\kern-.1em}"],
          splitfrac: ["SplitFrac", !1],
          splitdfrac: ["SplitFrac", !0],
          xmathstrut: "XMathStrut",
          prescript: "Prescript",
          newtagform: ["NewTagForm", !1],
          renewtagform: ["NewTagForm", !0],
          usetagform: "UseTagForm",
          adjustlimits: ["MacroWithTemplate", "\\mathop{{#1}\\vphantom{{#3}}}_{{#2}\\vphantom{{#4}}}\\mathop{{#3}\\vphantom{{#1}}}_{{#4}\\vphantom{{#2}}}", 4,, "_",, "_"],
          mathtoolsset: "SetOptions"
        }, Q.MathtoolsMethods), new i.EnvironmentMap("mathtools-environments", o.default.environment, {
          dcases: ["Array", null, "\\{", "", "ll", null, ".2em", "D"],
          rcases: ["Array", null, "", "\\}", "ll", null, ".2em"],
          drcases: ["Array", null, "", "\\}", "ll", null, ".2em", "D"],
          "dcases*": ["Cases", null, "{", "", "D"],
          "rcases*": ["Cases", null, "", "}"],
          "drcases*": ["Cases", null, "", "}", "D"],
          "cases*": ["Cases", null, "{", ""],
          "matrix*": ["MtMatrix", null, null, null],
          "pmatrix*": ["MtMatrix", null, "(", ")"],
          "bmatrix*": ["MtMatrix", null, "[", "]"],
          "Bmatrix*": ["MtMatrix", null, "\\{", "\\}"],
          "vmatrix*": ["MtMatrix", null, "\\vert", "\\vert"],
          "Vmatrix*": ["MtMatrix", null, "\\Vert", "\\Vert"],
          "smallmatrix*": ["MtSmallMatrix", null, null, null],
          psmallmatrix: ["MtSmallMatrix", null, "(", ")", "c"],
          "psmallmatrix*": ["MtSmallMatrix", null, "(", ")"],
          bsmallmatrix: ["MtSmallMatrix", null, "[", "]", "c"],
          "bsmallmatrix*": ["MtSmallMatrix", null, "[", "]"],
          Bsmallmatrix: ["MtSmallMatrix", null, "\\{", "\\}", "c"],
          "Bsmallmatrix*": ["MtSmallMatrix", null, "\\{", "\\}"],
          vsmallmatrix: ["MtSmallMatrix", null, "\\vert", "\\vert", "c"],
          "vsmallmatrix*": ["MtSmallMatrix", null, "\\vert", "\\vert"],
          Vsmallmatrix: ["MtSmallMatrix", null, "\\Vert", "\\Vert", "c"],
          "Vsmallmatrix*": ["MtSmallMatrix", null, "\\Vert", "\\Vert"],
          crampedsubarray: ["Array", null, null, null, null, "0em", "0.1em", "S'", 1],
          multlined: "MtMultlined",
          spreadlines: ["SpreadLines", !0],
          lgathered: ["AmsEqnArray", null, null, null, "l", null, ".5em", "D"],
          rgathered: ["AmsEqnArray", null, null, null, "r", null, ".5em", "D"]
        }, Q.MathtoolsMethods), new i.DelimiterMap("mathtools-delimiters", o.default.delimiter, {
          "\\lparen": "(",
          "\\rparen": ")"
        }), new i.CommandMap("mathtools-characters", {
          ":": ["CenterColon", !0]
        }, Q.MathtoolsMethods);
      },
      643: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsMethods = void 0;
        var Q = a(r(1130)),
          s = r(4387),
          T = a(r(7693)),
          l = a(r(8417)),
          c = a(r(3971)),
          u = a(r(1256)),
          p = r(9007),
          h = r(6010),
          d = r(7233),
          f = a(r(5579)),
          m = a(r(1110)),
          L = r(836);
        e.MathtoolsMethods = {
          MtMatrix: function MtMatrix(t, r, n, o) {
            var i = t.GetBrackets("\\begin{".concat(r.getName(), "}"), "c");
            return e.MathtoolsMethods.Array(t, r, n, o, i);
          },
          MtSmallMatrix: function MtSmallMatrix(t, r, n, o, i) {
            return i || (i = t.GetBrackets("\\begin{".concat(r.getName(), "}"), t.options.mathtools["smallmatrix-align"])), e.MathtoolsMethods.Array(t, r, n, o, i, Q.default.Em(1 / 3), ".2em", "S", 1);
          },
          MtMultlined: function MtMultlined(t, e) {
            var r,
              n = "\\begin{".concat(e.getName(), "}"),
              i = t.GetBrackets(n, t.options.mathtools["multlined-pos"] || "c"),
              a = i ? t.GetBrackets(n, "") : "";
            i && !i.match(/^[cbt]$/) && (a = (r = o([i, a], 2))[0], i = r[1]), t.Push(e);
            var s = t.itemFactory.create("multlined", t, e);
            return s.arraydef = {
              displaystyle: !0,
              rowspacing: ".5em",
              width: a || "auto",
              columnwidth: "100%"
            }, Q.default.setArrayAlign(s, i || "c");
          },
          HandleShove: function HandleShove(t, e, r) {
            var n = t.stack.Top();
            if ("multline" !== n.kind && "multlined" !== n.kind) throw new c.default("CommandInMultlined", "%1 can only appear within the multline or multlined environments", e);
            if (n.Size()) throw new c.default("CommandAtTheBeginingOfLine", "%1 must come at the beginning of the line", e);
            n.setProperty("shove", r);
            var o = t.GetBrackets(e),
              i = t.ParseArg(e);
            if (o) {
              var a = t.create("node", "mrow", []),
                Q = t.create("node", "mspace", [], {
                  width: o
                });
              "left" === r ? (a.appendChild(Q), a.appendChild(i)) : (a.appendChild(i), a.appendChild(Q)), i = a;
            }
            t.Push(i);
          },
          SpreadLines: function SpreadLines(t, e) {
            var r, n;
            if (t.stack.env.closing === e.getName()) {
              delete t.stack.env.closing;
              var o = t.stack.Pop(),
                a = o.toMml(),
                Q = o.getProperty("spread");
              if (a.isInferred) try {
                for (var s = i(u.default.getChildren(a)), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value;
                  L.MathtoolsUtil.spreadLines(l, Q);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (n = s.return) && n.call(s);
                } finally {
                  if (r) throw r.error;
                }
              } else L.MathtoolsUtil.spreadLines(a, Q);
              t.Push(a);
            } else {
              Q = t.GetDimen("\\begin{".concat(e.getName(), "}"));
              e.setProperty("spread", Q), t.Push(e);
            }
          },
          Cases: function Cases(t, e, r, n, o) {
            var i = t.itemFactory.create("array").setProperty("casesEnv", e.getName());
            return i.arraydef = {
              rowspacing: ".2em",
              columnspacing: "1em",
              columnalign: "left"
            }, "D" === o && (i.arraydef.displaystyle = !0), i.setProperties({
              open: r,
              close: n
            }), t.Push(e), i;
          },
          MathLap: function MathLap(t, e, r, o) {
            var i = t.GetBrackets(e, "").trim(),
              a = t.create("node", "mstyle", [t.create("node", "mpadded", [t.ParseArg(e)], n({
                width: 0
              }, "r" === r ? {} : {
                lspace: "l" === r ? "-1width" : "-.5width"
              }))], {
                "data-cramped": o
              });
            L.MathtoolsUtil.setDisplayLevel(a, i), t.Push(t.create("node", "TeXAtom", [a]));
          },
          Cramped: function Cramped(t, e) {
            var r = t.GetBrackets(e, "").trim(),
              n = t.ParseArg(e),
              o = t.create("node", "mstyle", [n], {
                "data-cramped": !0
              });
            L.MathtoolsUtil.setDisplayLevel(o, r), t.Push(o);
          },
          MtLap: function MtLap(t, e, r) {
            var n = Q.default.internalMath(t, t.GetArgument(e), 0),
              o = t.create("node", "mpadded", n, {
                width: 0
              });
            "r" !== r && u.default.setAttribute(o, "lspace", "l" === r ? "-1width" : "-.5width"), t.Push(o);
          },
          MathMakeBox: function MathMakeBox(t, e) {
            var r = t.GetBrackets(e),
              n = t.GetBrackets(e, "c"),
              o = t.create("node", "mpadded", [t.ParseArg(e)]);
            r && u.default.setAttribute(o, "width", r);
            var i = (0, d.lookup)(n, {
              c: "center",
              r: "right"
            }, "");
            i && u.default.setAttribute(o, "data-align", i), t.Push(o);
          },
          MathMBox: function MathMBox(t, e) {
            t.Push(t.create("node", "mrow", [t.ParseArg(e)]));
          },
          UnderOverBracket: function UnderOverBracket(t, e) {
            var r = (0, h.length2em)(t.GetBrackets(e, ".1em"), .1),
              n = t.GetBrackets(e, ".2em"),
              i = t.GetArgument(e),
              a = o("o" === e.charAt(1) ? ["over", "accent", "bottom"] : ["under", "accentunder", "top"], 3),
              s = a[0],
              T = a[1],
              c = a[2],
              p = (0, h.em)(r),
              d = new l.default(i, t.stack.env, t.configuration).mml(),
              f = new l.default(i, t.stack.env, t.configuration).mml(),
              m = t.create("node", "mpadded", [t.create("node", "mphantom", [f])], {
                style: "border: ".concat(p, " solid; border-").concat(c, ": none"),
                height: n,
                depth: 0
              }),
              L = Q.default.underOver(t, d, m, s, !0),
              y = u.default.getChildAt(u.default.getChildAt(L, 0), 0);
            u.default.setAttribute(y, T, !0), t.Push(L);
          },
          Aboxed: function Aboxed(t, e) {
            var r = L.MathtoolsUtil.checkAlignment(t, e);
            r.row.length % 2 == 1 && r.row.push(t.create("node", "mtd", []));
            var n = t.GetArgument(e),
              o = t.string.substr(t.i);
            t.string = n + "&&\\endAboxed", t.i = 0;
            var i = t.GetUpTo(e, "&"),
              a = t.GetUpTo(e, "&");
            t.GetUpTo(e, "\\endAboxed");
            var s = Q.default.substituteArgs(t, [i, a], "\\rlap{\\boxed{#1{}#2}}\\kern.267em\\phantom{#1}&\\phantom{{}#2}\\kern.267em");
            t.string = s + o, t.i = 0;
          },
          ArrowBetweenLines: function ArrowBetweenLines(t, e) {
            var r = L.MathtoolsUtil.checkAlignment(t, e);
            if (r.Size() || r.row.length) throw new c.default("BetweenLines", "%1 must be on a row by itself", e);
            var n = t.GetStar(),
              o = t.GetBrackets(e, "\\Updownarrow");
            n && (r.EndEntry(), r.EndEntry());
            var i = n ? "\\quad" + o : o + "\\quad",
              a = new l.default(i, t.stack.env, t.configuration).mml();
            t.Push(a), r.EndEntry(), r.EndRow();
          },
          VDotsWithin: function VDotsWithin(t, e) {
            var r = t.stack.Top(),
              o = r.getProperty("flushspaceabove") === r.table.length,
              i = "\\mmlToken{mi}{}" + t.GetArgument(e) + "\\mmlToken{mi}{}",
              a = new l.default(i, t.stack.env, t.configuration).mml(),
              Q = t.create("node", "mpadded", [t.create("node", "mpadded", [t.create("node", "mo", [t.create("text", "\u22EE")])], n({
                width: 0,
                lspace: "-.5width"
              }, o ? {
                height: "-.6em",
                voffset: "-.18em"
              } : {})), t.create("node", "mphantom", [a])], {
                lspace: ".5width"
              });
            t.Push(Q);
          },
          ShortVDotsWithin: function ShortVDotsWithin(t, r) {
            var n = t.stack.Top(),
              o = t.GetStar();
            e.MathtoolsMethods.FlushSpaceAbove(t, "\\MTFlushSpaceAbove"), !o && n.EndEntry(), e.MathtoolsMethods.VDotsWithin(t, "\\vdotswithin"), o && n.EndEntry(), e.MathtoolsMethods.FlushSpaceBelow(t, "\\MTFlushSpaceBelow");
          },
          FlushSpaceAbove: function FlushSpaceAbove(t, e) {
            var r = L.MathtoolsUtil.checkAlignment(t, e);
            r.setProperty("flushspaceabove", r.table.length), r.addRowSpacing("-" + t.options.mathtools.shortvdotsadjustabove);
          },
          FlushSpaceBelow: function FlushSpaceBelow(t, e) {
            var r = L.MathtoolsUtil.checkAlignment(t, e);
            r.Size() && r.EndEntry(), r.EndRow(), r.addRowSpacing("-" + t.options.mathtools.shortvdotsadjustbelow);
          },
          PairedDelimiters: function PairedDelimiters(t, e, r, n, i, a, s, T) {
            void 0 === i && (i = "#1"), void 0 === a && (a = 1), void 0 === s && (s = ""), void 0 === T && (T = "");
            var l = t.GetStar(),
              c = l ? "" : t.GetBrackets(e),
              u = o(l ? ["\\left", "\\right"] : c ? [c + "l", c + "r"] : ["", ""], 2),
              p = u[0],
              h = u[1],
              d = l ? "\\middle" : c || "";
            if (a) {
              for (var f = [], m = f.length; m < a; m++) f.push(t.GetArgument(e));
              s = Q.default.substituteArgs(t, f, s), i = Q.default.substituteArgs(t, f, i), T = Q.default.substituteArgs(t, f, T);
            }
            i = i.replace(/\\delimsize/g, d), t.string = [s, p, r, i, h, n, T, t.string.substr(t.i)].reduce(function (e, r) {
              return Q.default.addArgs(t, e, r);
            }, ""), t.i = 0, Q.default.checkMaxMacros(t);
          },
          DeclarePairedDelimiter: function DeclarePairedDelimiter(t, e) {
            var r = f.default.GetCsNameArgument(t, e),
              n = t.GetArgument(e),
              o = t.GetArgument(e);
            L.MathtoolsUtil.addPairedDelims(t.configuration, r, [n, o]);
          },
          DeclarePairedDelimiterX: function DeclarePairedDelimiterX(t, e) {
            var r = f.default.GetCsNameArgument(t, e),
              n = f.default.GetArgCount(t, e),
              o = t.GetArgument(e),
              i = t.GetArgument(e),
              a = t.GetArgument(e);
            L.MathtoolsUtil.addPairedDelims(t.configuration, r, [o, i, a, n]);
          },
          DeclarePairedDelimiterXPP: function DeclarePairedDelimiterXPP(t, e) {
            var r = f.default.GetCsNameArgument(t, e),
              n = f.default.GetArgCount(t, e),
              o = t.GetArgument(e),
              i = t.GetArgument(e),
              a = t.GetArgument(e),
              Q = t.GetArgument(e),
              s = t.GetArgument(e);
            L.MathtoolsUtil.addPairedDelims(t.configuration, r, [i, a, s, n, o, Q]);
          },
          CenterColon: function CenterColon(t, e, r, o, i) {
            void 0 === o && (o = !1), void 0 === i && (i = !1);
            var a = t.options.mathtools,
              Q = t.create("token", "mo", {}, ":");
            if (r && (a.centercolon || o)) {
              var s = a["centercolon-offset"];
              Q = t.create("node", "mpadded", [Q], n({
                voffset: s,
                height: "+".concat(s),
                depth: "-".concat(s)
              }, i ? {
                width: a["thincolon-dw"],
                lspace: a["thincolon-dx"]
              } : {}));
            }
            t.Push(Q);
          },
          Relation: function Relation(t, e, r, n) {
            t.options.mathtools["use-unicode"] && n ? t.Push(t.create("token", "mo", {
              texClass: p.TEXCLASS.REL
            }, n)) : (r = "\\mathrel{" + r.replace(/:/g, "\\MTThinColon").replace(/-/g, "\\mathrel{-}") + "}", t.string = Q.default.addArgs(t, r, t.string.substr(t.i)), t.i = 0);
          },
          NArrow: function NArrow(t, e, r, n) {
            t.Push(t.create("node", "TeXAtom", [t.create("token", "mtext", {}, r), t.create("node", "mpadded", [t.create("node", "mpadded", [t.create("node", "menclose", [t.create("node", "mspace", [], {
              height: ".2em",
              depth: 0,
              width: ".4em"
            })], {
              notation: "updiagonalstrike",
              "data-thickness": ".05em",
              "data-padding": 0
            })], {
              width: 0,
              lspace: "-.5width",
              voffset: n
            }), t.create("node", "mphantom", [t.create("token", "mtext", {}, r)])], {
              width: 0,
              lspace: "-.5width"
            })], {
              texClass: p.TEXCLASS.REL
            }));
          },
          SplitFrac: function SplitFrac(t, e, r) {
            var n = t.ParseArg(e),
              o = t.ParseArg(e);
            t.Push(t.create("node", "mstyle", [t.create("node", "mfrac", [t.create("node", "mstyle", [n, t.create("token", "mi"), t.create("token", "mspace", {
              width: "1em"
            })], {
              scriptlevel: 0
            }), t.create("node", "mstyle", [t.create("token", "mspace", {
              width: "1em"
            }), t.create("token", "mi"), o], {
              scriptlevel: 0
            })], {
              linethickness: 0,
              numalign: "left",
              denomalign: "right"
            })], {
              displaystyle: r,
              scriptlevel: 0
            }));
          },
          XMathStrut: function XMathStrut(t, e) {
            var r = t.GetBrackets(e),
              n = t.GetArgument(e);
            n = L.MathtoolsUtil.plusOrMinus(e, n), r = L.MathtoolsUtil.plusOrMinus(e, r || n), t.Push(t.create("node", "TeXAtom", [t.create("node", "mpadded", [t.create("node", "mphantom", [t.create("token", "mo", {
              stretchy: !1
            }, "(")])], {
              width: 0,
              height: n + "height",
              depth: r + "depth"
            })], {
              texClass: p.TEXCLASS.ORD
            }));
          },
          Prescript: function Prescript(t, e) {
            var r = L.MathtoolsUtil.getScript(t, e, "sup"),
              n = L.MathtoolsUtil.getScript(t, e, "sub"),
              o = L.MathtoolsUtil.getScript(t, e, "arg");
            if (u.default.isType(r, "none") && u.default.isType(n, "none")) t.Push(o);else {
              var i = t.create("node", "mmultiscripts", [o]);
              u.default.getChildren(i).push(null, null), u.default.appendChildren(i, [t.create("node", "mprescripts"), n, r]), i.setProperty("fixPrescript", !0), t.Push(i);
            }
          },
          NewTagForm: function NewTagForm(t, e, r) {
            void 0 === r && (r = !1);
            var n = t.tags;
            if (!("mtFormats" in n)) throw new c.default("TagsNotMT", "%1 can only be used with ams or mathtools tags", e);
            var o = t.GetArgument(e).trim();
            if (!o) throw new c.default("InvalidTagFormID", "Tag form name can't be empty");
            var i = t.GetBrackets(e, ""),
              a = t.GetArgument(e),
              Q = t.GetArgument(e);
            if (!r && n.mtFormats.has(o)) throw new c.default("DuplicateTagForm", "Duplicate tag form: %1", o);
            n.mtFormats.set(o, [a, Q, i]);
          },
          UseTagForm: function UseTagForm(t, e) {
            var r = t.tags;
            if (!("mtFormats" in r)) throw new c.default("TagsNotMT", "%1 can only be used with ams or mathtools tags", e);
            var n = t.GetArgument(e).trim();
            if (n) {
              if (!r.mtFormats.has(n)) throw new c.default("UndefinedTagForm", "Undefined tag form: %1", n);
              r.mtCurrent = r.mtFormats.get(n);
            } else r.mtCurrent = null;
          },
          SetOptions: function SetOptions(t, e) {
            var r,
              n,
              o = t.options.mathtools;
            if (!o["allow-mathtoolsset"]) throw new c.default("ForbiddenMathtoolsSet", "%1 is disabled", e);
            var a = {};
            Object.keys(o).forEach(function (t) {
              "pariedDelimiters" !== t && "tagforms" !== t && "allow-mathtoolsset" !== t && (a[t] = 1);
            });
            var s = t.GetArgument(e),
              T = Q.default.keyvalOptions(s, a, !0);
            try {
              for (var l = i(Object.keys(T)), u = l.next(); !u.done; u = l.next()) {
                var p = u.value;
                o[p] = T[p];
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (n = l.return) && n.call(l);
              } finally {
                if (r) throw r.error;
              }
            }
          },
          Array: T.default.Array,
          Macro: T.default.Macro,
          xArrow: s.AmsMethods.xArrow,
          HandleRef: s.AmsMethods.HandleRef,
          AmsEqnArray: s.AmsMethods.AmsEqnArray,
          MacroWithTemplate: m.default.MacroWithTemplate
        };
      },
      1503: function _(t, e, r) {
        var _n66,
          o = this && this.__extends || (_n66 = function n(t, e) {
            return _n66 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n66(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n66(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsTagFormat = void 0;
        var s = Q(r(3971)),
          T = r(6521),
          l = 0;
        e.MathtoolsTagFormat = function (t, e) {
          var r = e.parseOptions.options.tags;
          "base" !== r && t.tags.hasOwnProperty(r) && T.TagsFactory.add(r, t.tags[r]);
          var n = function (t) {
              function r() {
                var r,
                  n,
                  o = t.call(this) || this;
                o.mtFormats = new Map(), o.mtCurrent = null;
                var a = e.parseOptions.options.mathtools.tagforms;
                try {
                  for (var Q = i(Object.keys(a)), T = Q.next(); !T.done; T = Q.next()) {
                    var l = T.value;
                    if (!Array.isArray(a[l]) || 3 !== a[l].length) throw new s.default("InvalidTagFormDef", 'The tag form definition for "%1" should be an array fo three strings', l);
                    o.mtFormats.set(l, a[l]);
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    T && !T.done && (n = Q.return) && n.call(Q);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                return o;
              }
              return o(r, t), r.prototype.formatTag = function (e) {
                if (this.mtCurrent) {
                  var r = a(this.mtCurrent, 3),
                    n = r[0],
                    o = r[1],
                    i = r[2];
                  return i ? "".concat(n).concat(i, "{").concat(e, "}").concat(o) : "".concat(n).concat(e).concat(o);
                }
                return t.prototype.formatTag.call(this, e);
              }, r;
            }(T.TagsFactory.create(e.parseOptions.options.tags).constructor),
            Q = "MathtoolsTags-" + ++l;
          T.TagsFactory.add(Q, n), e.parseOptions.options.tags = Q;
        };
      },
      836: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathtoolsUtil = void 0;
        var i = r(1181),
          a = o(r(1130)),
          Q = o(r(8417)),
          s = o(r(3971)),
          T = r(8803),
          l = r(7233),
          c = r(643),
          u = r(7535);
        e.MathtoolsUtil = {
          setDisplayLevel: function setDisplayLevel(t, e) {
            if (e) {
              var r = n((0, l.lookup)(e, {
                  "\\displaystyle": [!0, 0],
                  "\\textstyle": [!1, 0],
                  "\\scriptstyle": [!1, 1],
                  "\\scriptscriptstyle": [!1, 2]
                }, [null, null]), 2),
                o = r[0],
                i = r[1];
              null !== o && (t.attributes.set("displaystyle", o), t.attributes.set("scriptlevel", i));
            }
          },
          checkAlignment: function checkAlignment(t, e) {
            var r = t.stack.Top();
            if (r.kind !== i.EqnArrayItem.prototype.kind) throw new s.default("NotInAlignment", "%1 can only be used in aligment environments", e);
            return r;
          },
          addPairedDelims: function addPairedDelims(t, e, r) {
            t.handlers.retrieve(u.PAIREDDELIMS).add(e, new T.Macro(e, c.MathtoolsMethods.PairedDelimiters, r));
          },
          spreadLines: function spreadLines(t, e) {
            if (t.isKind("mtable")) {
              var r = t.attributes.get("rowspacing");
              if (r) {
                var n = a.default.dimen2em(e);
                r = r.split(/ /).map(function (t) {
                  return a.default.Em(Math.max(0, a.default.dimen2em(t) + n));
                }).join(" ");
              } else r = e;
              t.attributes.set("rowspacing", r);
            }
          },
          plusOrMinus: function plusOrMinus(t, e) {
            if (!(e = e.trim()).match(/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)$/)) throw new s.default("NotANumber", "Argument to %1 is not a number", t);
            return e.match(/^[-+]/) ? e : "+" + e;
          },
          getScript: function getScript(t, e, r) {
            var n = a.default.trimSpaces(t.GetArgument(e));
            if ("" === n) return t.create("node", "none");
            var o = t.options.mathtools["prescript-".concat(r, "-format")];
            return o && (n = "".concat(o, "{").concat(n, "}")), new Q.default(n, t.stack.env, t.configuration).mml();
          }
        };
      },
      6944: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MhchemConfiguration = void 0;
        var o = r(9899),
          i = r(9140),
          a = n(r(3971)),
          Q = n(r(7693)),
          s = r(4387),
          T = r(7718),
          l = {};
        l.Macro = Q.default.Macro, l.xArrow = s.AmsMethods.xArrow, l.Machine = function (t, e, r) {
          var n,
            o = t.GetArgument(e);
          try {
            n = T.mhchemParser.toTex(o, r);
          } catch (t) {
            throw new a.default(t[0], t[1]);
          }
          t.string = n + t.string.substr(t.i), t.i = 0;
        }, new i.CommandMap("mhchem", {
          ce: ["Machine", "ce"],
          pu: ["Machine", "pu"],
          longrightleftharpoons: ["Macro", "\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}"],
          longRightleftharpoons: ["Macro", "\\stackrel{\\textstyle{-}\\!\\!{\\rightharpoonup}}{\\smash{\\leftharpoondown}}"],
          longLeftrightharpoons: ["Macro", "\\stackrel{\\textstyle\\vphantom{{-}}{\\rightharpoonup}}{\\smash{{\\leftharpoondown}\\!\\!{-}}}"],
          longleftrightarrows: ["Macro", "\\stackrel{\\longrightarrow}{\\smash{\\longleftarrow}\\Rule{0px}{.25em}{0px}}"],
          tripledash: ["Macro", "\\vphantom{-}\\raise2mu{\\kern2mu\\tiny\\text{-}\\kern1mu\\text{-}\\kern1mu\\text{-}\\kern2mu}"],
          xleftrightarrow: ["xArrow", 8596, 6, 6],
          xrightleftharpoons: ["xArrow", 8652, 5, 7],
          xRightleftharpoons: ["xArrow", 8652, 5, 7],
          xLeftrightharpoons: ["xArrow", 8652, 5, 7]
        }, l), e.MhchemConfiguration = o.Configuration.create("mhchem", {
          handler: {
            macro: ["mhchem"]
          }
        });
      },
      1496: function _(t, e, r) {
        var n,
          o = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          a = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && o(e, t, r);
            return i(e, t), e;
          },
          Q = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NewcommandConfiguration = void 0;
        var s = r(9899),
          T = r(6793),
          l = Q(r(5579));
        r(5117);
        var c = Q(r(5450)),
          u = a(r(9140));
        e.NewcommandConfiguration = s.Configuration.create("newcommand", {
          handler: {
            macro: ["Newcommand-macros"]
          },
          items: (n = {}, n[T.BeginEnvItem.prototype.kind] = T.BeginEnvItem, n),
          options: {
            maxMacros: 1e3
          },
          init: function init(t) {
            new u.DelimiterMap(l.default.NEW_DELIMITER, c.default.delimiter, {}), new u.CommandMap(l.default.NEW_COMMAND, {}, {}), new u.EnvironmentMap(l.default.NEW_ENVIRONMENT, c.default.environment, {}, {}), t.append(s.Configuration.local({
              handler: {
                character: [],
                delimiter: [l.default.NEW_DELIMITER],
                macro: [l.default.NEW_DELIMITER, l.default.NEW_COMMAND],
                environment: [l.default.NEW_ENVIRONMENT]
              },
              priority: -1
            }));
          }
        });
      },
      6793: function _(t, e, r) {
        var _n67,
          o = this && this.__extends || (_n67 = function n(t, e) {
            return _n67 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n67(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n67(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BeginEnvItem = void 0;
        var a = i(r(3971)),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "beginEnv";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.checkItem = function (e) {
              if (e.isKind("end")) {
                if (e.getName() !== this.getName()) throw new a.default("EnvBadEnd", "\\begin{%1} ended with \\end{%2}", this.getName(), e.getName());
                return [[this.factory.create("mml", this.toMml())], !0];
              }
              if (e.isKind("stop")) throw new a.default("EnvMissingEnd", "Missing \\end{%1}", this.getName());
              return t.prototype.checkItem.call(this, e);
            }, e;
          }(r(8292).BaseItem);
        e.BeginEnvItem = Q;
      },
      5117: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = n(r(1110));
        new (r(9140).CommandMap)("Newcommand-macros", {
          newcommand: "NewCommand",
          renewcommand: "NewCommand",
          newenvironment: "NewEnvironment",
          renewenvironment: "NewEnvironment",
          def: "MacroDef",
          let: "Let"
        }, o.default);
      },
      1110: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var Q = a(r(3971)),
          s = i(r(9140)),
          T = a(r(7693)),
          l = a(r(1130)),
          c = a(r(5579)),
          u = {
            NewCommand: function NewCommand(t, e) {
              var r = c.default.GetCsNameArgument(t, e),
                n = c.default.GetArgCount(t, e),
                o = t.GetBrackets(e),
                i = t.GetArgument(e);
              c.default.addMacro(t, r, u.Macro, [i, n, o]);
            },
            NewEnvironment: function NewEnvironment(t, e) {
              var r = l.default.trimSpaces(t.GetArgument(e)),
                n = c.default.GetArgCount(t, e),
                o = t.GetBrackets(e),
                i = t.GetArgument(e),
                a = t.GetArgument(e);
              c.default.addEnvironment(t, r, u.BeginEnv, [!0, i, a, n, o]);
            },
            MacroDef: function MacroDef(t, e) {
              var r = c.default.GetCSname(t, e),
                n = c.default.GetTemplate(t, e, "\\" + r),
                o = t.GetArgument(e);
              n instanceof Array ? c.default.addMacro(t, r, u.MacroWithTemplate, [o].concat(n)) : c.default.addMacro(t, r, u.Macro, [o, n]);
            },
            Let: function Let(t, e) {
              var r = c.default.GetCSname(t, e),
                n = t.GetNext();
              "=" === n && (t.i++, n = t.GetNext());
              var o = t.configuration.handlers;
              if ("\\" !== n) {
                t.i++;
                var i = o.get("delimiter").lookup(n);
                i ? c.default.addDelimiter(t, "\\" + r, i.char, i.attributes) : c.default.addMacro(t, r, u.Macro, [n]);
              } else {
                e = c.default.GetCSname(t, e);
                var a = o.get("delimiter").lookup("\\" + e);
                if (a) return void c.default.addDelimiter(t, "\\" + r, a.char, a.attributes);
                var Q = o.get("macro").applicable(e);
                if (!Q) return;
                if (Q instanceof s.MacroMap) {
                  var T = Q.lookup(e);
                  return void c.default.addMacro(t, r, T.func, T.args, T.symbol);
                }
                a = Q.lookup(e);
                var l = c.default.disassembleSymbol(r, a);
                c.default.addMacro(t, r, function (t, e) {
                  for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
                  var o = c.default.assembleSymbol(r);
                  return Q.parser(t, o);
                }, l);
              }
            },
            MacroWithTemplate: function MacroWithTemplate(t, e, r, n) {
              for (var o = [], i = 4; i < arguments.length; i++) o[i - 4] = arguments[i];
              var a = parseInt(n, 10);
              if (a) {
                var s = [];
                if (t.GetNext(), o[0] && !c.default.MatchParam(t, o[0])) throw new Q.default("MismatchUseDef", "Use of %1 doesn't match its definition", e);
                for (var T = 0; T < a; T++) s.push(c.default.GetParameter(t, e, o[T + 1]));
                r = l.default.substituteArgs(t, s, r);
              }
              t.string = l.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, l.default.checkMaxMacros(t);
            },
            BeginEnv: function BeginEnv(t, e, r, n, o, i) {
              if (e.getProperty("end") && t.stack.env.closing === e.getName()) {
                delete t.stack.env.closing;
                var a = t.string.slice(t.i);
                return t.string = n, t.i = 0, t.Parse(), t.string = a, t.i = 0, t.itemFactory.create("end").setProperty("name", e.getName());
              }
              if (o) {
                var Q = [];
                if (null != i) {
                  var s = t.GetBrackets("\\begin{" + e.getName() + "}");
                  Q.push(null == s ? i : s);
                }
                for (var T = Q.length; T < o; T++) Q.push(t.GetArgument("\\begin{" + e.getName() + "}"));
                r = l.default.substituteArgs(t, Q, r), n = l.default.substituteArgs(t, [], n);
              }
              return t.string = l.default.addArgs(t, r, t.string.slice(t.i)), t.i = 0, t.itemFactory.create("beginEnv").setProperty("name", e.getName());
            }
          };
        u.Macro = T.default.Macro, e.default = u;
      },
      5579: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o,
          i = n(r(1130)),
          a = n(r(3971)),
          Q = r(8803);
        !function (t) {
          function e(t, e) {
            return t.string.substr(t.i, e.length) !== e || e.match(/\\[a-z]+$/i) && t.string.charAt(t.i + e.length).match(/[a-z]/i) ? 0 : (t.i += e.length, 1);
          }
          t.disassembleSymbol = function (t, e) {
            var r = [t, e.char];
            if (e.attributes) for (var n in e.attributes) r.push(n), r.push(e.attributes[n]);
            return r;
          }, t.assembleSymbol = function (t) {
            for (var e = t[0], r = t[1], n = {}, o = 2; o < t.length; o += 2) n[t[o]] = t[o + 1];
            return new Q.Symbol(e, r, n);
          }, t.GetCSname = function (t, e) {
            if ("\\" !== t.GetNext()) throw new a.default("MissingCS", "%1 must be followed by a control sequence", e);
            return i.default.trimSpaces(t.GetArgument(e)).substr(1);
          }, t.GetCsNameArgument = function (t, e) {
            var r = i.default.trimSpaces(t.GetArgument(e));
            if ("\\" === r.charAt(0) && (r = r.substr(1)), !r.match(/^(.|[a-z]+)$/i)) throw new a.default("IllegalControlSequenceName", "Illegal control sequence name for %1", e);
            return r;
          }, t.GetArgCount = function (t, e) {
            var r = t.GetBrackets(e);
            if (r && !(r = i.default.trimSpaces(r)).match(/^[0-9]+$/)) throw new a.default("IllegalParamNumber", "Illegal number of parameters specified in %1", e);
            return r;
          }, t.GetTemplate = function (t, e, r) {
            for (var n = t.GetNext(), o = [], i = 0, Q = t.i; t.i < t.string.length;) {
              if ("#" === (n = t.GetNext())) {
                if (Q !== t.i && (o[i] = t.string.substr(Q, t.i - Q)), !(n = t.string.charAt(++t.i)).match(/^[1-9]$/)) throw new a.default("CantUseHash2", "Illegal use of # in template for %1", r);
                if (parseInt(n) !== ++i) throw new a.default("SequentialParam", "Parameters for %1 must be numbered sequentially", r);
                Q = t.i + 1;
              } else if ("{" === n) return Q !== t.i && (o[i] = t.string.substr(Q, t.i - Q)), o.length > 0 ? [i.toString()].concat(o) : i;
              t.i++;
            }
            throw new a.default("MissingReplacementString", "Missing replacement string for definition of %1", e);
          }, t.GetParameter = function (t, r, n) {
            if (null == n) return t.GetArgument(r);
            for (var o = t.i, i = 0, Q = 0; t.i < t.string.length;) {
              var s = t.string.charAt(t.i);
              if ("{" === s) t.i === o && (Q = 1), t.GetArgument(r), i = t.i - o;else {
                if (e(t, n)) return Q && (o++, i -= 2), t.string.substr(o, i);
                if ("\\" === s) {
                  t.i++, i++, Q = 0;
                  var T = t.string.substr(t.i).match(/[a-z]+|./i);
                  T && (t.i += T[0].length, i = t.i - o);
                } else t.i++, i++, Q = 0;
              }
            }
            throw new a.default("RunawayArgument", "Runaway argument for %1?", r);
          }, t.MatchParam = e, t.addDelimiter = function (e, r, n, o) {
            e.configuration.handlers.retrieve(t.NEW_DELIMITER).add(r, new Q.Symbol(r, n, o));
          }, t.addMacro = function (e, r, n, o, i) {
            void 0 === i && (i = ""), e.configuration.handlers.retrieve(t.NEW_COMMAND).add(r, new Q.Macro(i || r, n, o));
          }, t.addEnvironment = function (e, r, n, o) {
            e.configuration.handlers.retrieve(t.NEW_ENVIRONMENT).add(r, new Q.Macro(r, n, o));
          }, t.NEW_DELIMITER = "new-Delimiter", t.NEW_COMMAND = "new-Command", t.NEW_ENVIRONMENT = "new-Environment";
        }(o || (o = {})), e.default = o;
      },
      4234: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NoErrorsConfiguration = void 0;
        var n = r(9899);
        e.NoErrorsConfiguration = n.Configuration.create("noerrors", {
          nodes: {
            error: function error(t, e, r, n) {
              var o = t.create("token", "mtext", {}, n.replace(/\n/g, " "));
              return t.create("node", "merror", [o], {
                "data-mjx-error": e,
                title: e
              });
            }
          }
        });
      },
      4898: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NoUndefinedConfiguration = void 0;
        var o = r(9899);
        e.NoUndefinedConfiguration = o.Configuration.create("noundefined", {
          fallback: {
            macro: function macro(t, e) {
              var r,
                o,
                i = t.create("text", "\\" + e),
                a = t.options.noundefined || {},
                Q = {};
              try {
                for (var s = n(["color", "background", "size"]), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value;
                  a[l] && (Q["math" + l] = a[l]);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (o = s.return) && o.call(s);
                } finally {
                  if (r) throw r.error;
                }
              }
              t.Push(t.create("node", "mtext", [], Q, i));
            }
          },
          options: {
            noundefined: {
              color: "red",
              background: "",
              size: ""
            }
          },
          priority: 3
        });
      },
      3168: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PhysicsConfiguration = void 0;
        var o = r(9899),
          i = r(2612);
        r(3847), e.PhysicsConfiguration = o.Configuration.create("physics", {
          handler: {
            macro: ["Physics-automatic-bracing-macros", "Physics-vector-macros", "Physics-vector-mo", "Physics-vector-mi", "Physics-derivative-macros", "Physics-expressions-macros", "Physics-quick-quad-macros", "Physics-bra-ket-macros", "Physics-matrix-macros"],
            character: ["Physics-characters"],
            environment: ["Physics-aux-envs"]
          },
          items: (n = {}, n[i.AutoOpen.prototype.kind] = i.AutoOpen, n),
          options: {
            physics: {
              italicdiff: !1,
              arrowdel: !1
            }
          }
        });
      },
      2612: function _(t, e, r) {
        var _n68,
          o = this && this.__extends || (_n68 = function n(t, e) {
            return _n68 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n68(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n68(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AutoOpen = void 0;
        var a = r(8292),
          Q = i(r(1130)),
          s = i(r(1256)),
          T = i(r(8417)),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.openCount = 0, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "kind", {
              get: function get() {
                return "auto open";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "isOpen", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.toMml = function () {
              var e = this.factory.configuration.parser,
                r = this.getProperty("right");
              if (this.getProperty("smash")) {
                var n = t.prototype.toMml.call(this),
                  o = e.create("node", "mpadded", [n], {
                    height: 0,
                    depth: 0
                  });
                this.Clear(), this.Push(e.create("node", "TeXAtom", [o]));
              }
              r && this.Push(new T.default(r, e.stack.env, e.configuration).mml());
              var i = Q.default.fenced(this.factory.configuration, this.getProperty("open"), t.prototype.toMml.call(this), this.getProperty("close"), this.getProperty("big"));
              return s.default.removeProperties(i, "open", "close", "texClass"), i;
            }, e.prototype.checkItem = function (e) {
              if (e.isKind("mml") && 1 === e.Size()) {
                var r = e.toMml();
                r.isKind("mo") && r.getText() === this.getProperty("open") && this.openCount++;
              }
              var n = e.getProperty("autoclose");
              return n && n === this.getProperty("close") && !this.openCount-- ? this.getProperty("ignore") ? (this.Clear(), [[], !0]) : [[this.toMml()], !0] : t.prototype.checkItem.call(this, e);
            }, e.errors = Object.assign(Object.create(a.BaseItem.errors), {
              stop: ["ExtraOrMissingDelims", "Extra open or missing close delimiter"]
            }), e;
          }(a.BaseItem);
        e.AutoOpen = l;
      },
      3847: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = n(r(7157)),
          a = r(8317),
          Q = n(r(5450)),
          s = r(9007);
        new o.CommandMap("Physics-automatic-bracing-macros", {
          quantity: "Quantity",
          qty: "Quantity",
          pqty: ["Quantity", "(", ")", !0],
          bqty: ["Quantity", "[", "]", !0],
          vqty: ["Quantity", "|", "|", !0],
          Bqty: ["Quantity", "\\{", "\\}", !0],
          absolutevalue: ["Quantity", "|", "|", !0],
          abs: ["Quantity", "|", "|", !0],
          norm: ["Quantity", "\\|", "\\|", !0],
          evaluated: "Eval",
          eval: "Eval",
          order: ["Quantity", "(", ")", !0, "O", a.TexConstant.Variant.CALLIGRAPHIC],
          commutator: "Commutator",
          comm: "Commutator",
          anticommutator: ["Commutator", "\\{", "\\}"],
          acomm: ["Commutator", "\\{", "\\}"],
          poissonbracket: ["Commutator", "\\{", "\\}"],
          pb: ["Commutator", "\\{", "\\}"]
        }, i.default), new o.CharacterMap("Physics-vector-mo", Q.default.mathchar0mo, {
          dotproduct: ["\u22C5", {
            mathvariant: a.TexConstant.Variant.BOLD
          }],
          vdot: ["\u22C5", {
            mathvariant: a.TexConstant.Variant.BOLD
          }],
          crossproduct: "\xd7",
          cross: "\xd7",
          cp: "\xd7",
          gradientnabla: ["\u2207", {
            mathvariant: a.TexConstant.Variant.BOLD
          }]
        }), new o.CharacterMap("Physics-vector-mi", Q.default.mathchar0mi, {
          real: ["\u211C", {
            mathvariant: a.TexConstant.Variant.NORMAL
          }],
          imaginary: ["\u2111", {
            mathvariant: a.TexConstant.Variant.NORMAL
          }]
        }), new o.CommandMap("Physics-vector-macros", {
          vnabla: "Vnabla",
          vectorbold: "VectorBold",
          vb: "VectorBold",
          vectorarrow: ["StarMacro", 1, "\\vec{\\vb", "{#1}}"],
          va: ["StarMacro", 1, "\\vec{\\vb", "{#1}}"],
          vectorunit: ["StarMacro", 1, "\\hat{\\vb", "{#1}}"],
          vu: ["StarMacro", 1, "\\hat{\\vb", "{#1}}"],
          gradient: ["OperatorApplication", "\\vnabla", "(", "["],
          grad: ["OperatorApplication", "\\vnabla", "(", "["],
          divergence: ["VectorOperator", "\\vnabla\\vdot", "(", "["],
          div: ["VectorOperator", "\\vnabla\\vdot", "(", "["],
          curl: ["VectorOperator", "\\vnabla\\crossproduct", "(", "["],
          laplacian: ["OperatorApplication", "\\nabla^2", "(", "["]
        }, i.default), new o.CommandMap("Physics-expressions-macros", {
          sin: "Expression",
          sinh: "Expression",
          arcsin: "Expression",
          asin: "Expression",
          cos: "Expression",
          cosh: "Expression",
          arccos: "Expression",
          acos: "Expression",
          tan: "Expression",
          tanh: "Expression",
          arctan: "Expression",
          atan: "Expression",
          csc: "Expression",
          csch: "Expression",
          arccsc: "Expression",
          acsc: "Expression",
          sec: "Expression",
          sech: "Expression",
          arcsec: "Expression",
          asec: "Expression",
          cot: "Expression",
          coth: "Expression",
          arccot: "Expression",
          acot: "Expression",
          exp: ["Expression", !1],
          log: "Expression",
          ln: "Expression",
          det: ["Expression", !1],
          Pr: ["Expression", !1],
          tr: ["Expression", !1],
          trace: ["Expression", !1, "tr"],
          Tr: ["Expression", !1],
          Trace: ["Expression", !1, "Tr"],
          rank: "NamedFn",
          erf: ["Expression", !1],
          Residue: ["Macro", "\\mathrm{Res}"],
          Res: ["OperatorApplication", "\\Residue", "(", "[", "{"],
          principalvalue: ["OperatorApplication", "{\\cal P}"],
          pv: ["OperatorApplication", "{\\cal P}"],
          PV: ["OperatorApplication", "{\\rm P.V.}"],
          Re: ["OperatorApplication", "\\mathrm{Re}", "{"],
          Im: ["OperatorApplication", "\\mathrm{Im}", "{"],
          sine: ["NamedFn", "sin"],
          hypsine: ["NamedFn", "sinh"],
          arcsine: ["NamedFn", "arcsin"],
          asine: ["NamedFn", "asin"],
          cosine: ["NamedFn", "cos"],
          hypcosine: ["NamedFn", "cosh"],
          arccosine: ["NamedFn", "arccos"],
          acosine: ["NamedFn", "acos"],
          tangent: ["NamedFn", "tan"],
          hyptangent: ["NamedFn", "tanh"],
          arctangent: ["NamedFn", "arctan"],
          atangent: ["NamedFn", "atan"],
          cosecant: ["NamedFn", "csc"],
          hypcosecant: ["NamedFn", "csch"],
          arccosecant: ["NamedFn", "arccsc"],
          acosecant: ["NamedFn", "acsc"],
          secant: ["NamedFn", "sec"],
          hypsecant: ["NamedFn", "sech"],
          arcsecant: ["NamedFn", "arcsec"],
          asecant: ["NamedFn", "asec"],
          cotangent: ["NamedFn", "cot"],
          hypcotangent: ["NamedFn", "coth"],
          arccotangent: ["NamedFn", "arccot"],
          acotangent: ["NamedFn", "acot"],
          exponential: ["NamedFn", "exp"],
          logarithm: ["NamedFn", "log"],
          naturallogarithm: ["NamedFn", "ln"],
          determinant: ["NamedFn", "det"],
          Probability: ["NamedFn", "Pr"]
        }, i.default), new o.CommandMap("Physics-quick-quad-macros", {
          qqtext: "Qqtext",
          qq: "Qqtext",
          qcomma: ["Macro", "\\qqtext*{,}"],
          qc: ["Macro", "\\qqtext*{,}"],
          qcc: ["Qqtext", "c.c."],
          qif: ["Qqtext", "if"],
          qthen: ["Qqtext", "then"],
          qelse: ["Qqtext", "else"],
          qotherwise: ["Qqtext", "otherwise"],
          qunless: ["Qqtext", "unless"],
          qgiven: ["Qqtext", "given"],
          qusing: ["Qqtext", "using"],
          qassume: ["Qqtext", "assume"],
          qsince: ["Qqtext", "since"],
          qlet: ["Qqtext", "let"],
          qfor: ["Qqtext", "for"],
          qall: ["Qqtext", "all"],
          qeven: ["Qqtext", "even"],
          qodd: ["Qqtext", "odd"],
          qinteger: ["Qqtext", "integer"],
          qand: ["Qqtext", "and"],
          qor: ["Qqtext", "or"],
          qas: ["Qqtext", "as"],
          qin: ["Qqtext", "in"]
        }, i.default), new o.CommandMap("Physics-derivative-macros", {
          diffd: "DiffD",
          flatfrac: ["Macro", "\\left.#1\\middle/#2\\right.", 2],
          differential: ["Differential", "\\diffd"],
          dd: ["Differential", "\\diffd"],
          variation: ["Differential", "\\delta"],
          var: ["Differential", "\\delta"],
          derivative: ["Derivative", 2, "\\diffd"],
          dv: ["Derivative", 2, "\\diffd"],
          partialderivative: ["Derivative", 3, "\\partial"],
          pderivative: ["Derivative", 3, "\\partial"],
          pdv: ["Derivative", 3, "\\partial"],
          functionalderivative: ["Derivative", 2, "\\delta"],
          fderivative: ["Derivative", 2, "\\delta"],
          fdv: ["Derivative", 2, "\\delta"]
        }, i.default), new o.CommandMap("Physics-bra-ket-macros", {
          bra: "Bra",
          ket: "Ket",
          innerproduct: "BraKet",
          ip: "BraKet",
          braket: "BraKet",
          outerproduct: "KetBra",
          dyad: "KetBra",
          ketbra: "KetBra",
          op: "KetBra",
          expectationvalue: "Expectation",
          expval: "Expectation",
          ev: "Expectation",
          matrixelement: "MatrixElement",
          matrixel: "MatrixElement",
          mel: "MatrixElement"
        }, i.default), new o.CommandMap("Physics-matrix-macros", {
          matrixquantity: "MatrixQuantity",
          mqty: "MatrixQuantity",
          pmqty: ["Macro", "\\mqty(#1)", 1],
          Pmqty: ["Macro", "\\mqty*(#1)", 1],
          bmqty: ["Macro", "\\mqty[#1]", 1],
          vmqty: ["Macro", "\\mqty|#1|", 1],
          smallmatrixquantity: ["MatrixQuantity", !0],
          smqty: ["MatrixQuantity", !0],
          spmqty: ["Macro", "\\smqty(#1)", 1],
          sPmqty: ["Macro", "\\smqty*(#1)", 1],
          sbmqty: ["Macro", "\\smqty[#1]", 1],
          svmqty: ["Macro", "\\smqty|#1|", 1],
          matrixdeterminant: ["Macro", "\\vmqty{#1}", 1],
          mdet: ["Macro", "\\vmqty{#1}", 1],
          smdet: ["Macro", "\\svmqty{#1}", 1],
          identitymatrix: "IdentityMatrix",
          imat: "IdentityMatrix",
          xmatrix: "XMatrix",
          xmat: "XMatrix",
          zeromatrix: ["Macro", "\\xmat{0}{#1}{#2}", 2],
          zmat: ["Macro", "\\xmat{0}{#1}{#2}", 2],
          paulimatrix: "PauliMatrix",
          pmat: "PauliMatrix",
          diagonalmatrix: "DiagonalMatrix",
          dmat: "DiagonalMatrix",
          antidiagonalmatrix: ["DiagonalMatrix", !0],
          admat: ["DiagonalMatrix", !0]
        }, i.default), new o.EnvironmentMap("Physics-aux-envs", Q.default.environment, {
          smallmatrix: ["Array", null, null, null, "c", "0.333em", ".2em", "S", 1]
        }, i.default), new o.MacroMap("Physics-characters", {
          "|": ["AutoClose", s.TEXCLASS.ORD],
          ")": "AutoClose",
          "]": "AutoClose"
        }, i.default);
      },
      7157: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i = o(r(7693)),
          a = o(r(8417)),
          Q = o(r(3971)),
          s = r(9007),
          T = o(r(1130)),
          l = o(r(1256)),
          c = r(8929),
          u = {},
          p = {
            "(": ")",
            "[": "]",
            "{": "}",
            "|": "|"
          },
          h = /^(b|B)i(g{1,2})$/;
        u.Quantity = function (t, e, r, n, o, i, c) {
          void 0 === r && (r = "("), void 0 === n && (n = ")"), void 0 === o && (o = !1), void 0 === i && (i = ""), void 0 === c && (c = "");
          var u = !!o && t.GetStar(),
            d = t.GetNext(),
            f = t.i,
            m = null;
          if ("\\" === d) {
            if (t.i++, !(m = t.GetCS()).match(h)) {
              var L = t.create("node", "mrow");
              return t.Push(T.default.fenced(t.configuration, r, L, n)), void (t.i = f);
            }
            d = t.GetNext();
          }
          var y = p[d];
          if (o && "{" !== d) throw new Q.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          if (!y) {
            L = t.create("node", "mrow");
            return t.Push(T.default.fenced(t.configuration, r, L, n)), void (t.i = f);
          }
          if (i) {
            var g = t.create("token", "mi", {
              texClass: s.TEXCLASS.OP
            }, i);
            c && l.default.setAttribute(g, "mathvariant", c), t.Push(t.itemFactory.create("fn", g));
          }
          if ("{" === d) {
            var v = t.GetArgument(e);
            return d = o ? r : "\\{", y = o ? n : "\\}", v = u ? d + " " + v + " " + y : m ? "\\" + m + "l" + d + " " + v + " \\" + m + "r" + y : "\\left" + d + " " + v + " \\right" + y, void t.Push(new a.default(v, t.stack.env, t.configuration).mml());
          }
          o && (d = r, y = n), t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: d,
            close: y,
            big: m
          }));
        }, u.Eval = function (t, e) {
          var r = t.GetStar(),
            n = t.GetNext();
          if ("{" !== n) {
            if ("(" === n || "[" === n) return t.i++, void t.Push(t.itemFactory.create("auto open").setProperties({
              open: n,
              close: "|",
              smash: r,
              right: "\\vphantom{\\int}"
            }));
            throw new Q.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          }
          var o = t.GetArgument(e),
            i = "\\left. " + (r ? "\\smash{" + o + "}" : o) + " \\vphantom{\\int}\\right|";
          t.string = t.string.slice(0, t.i) + i + t.string.slice(t.i);
        }, u.Commutator = function (t, e, r, n) {
          void 0 === r && (r = "["), void 0 === n && (n = "]");
          var o = t.GetStar(),
            i = t.GetNext(),
            s = null;
          if ("\\" === i) {
            if (t.i++, !(s = t.GetCS()).match(h)) throw new Q.default("MissingArgFor", "Missing argument for %1", t.currentCS);
            i = t.GetNext();
          }
          if ("{" !== i) throw new Q.default("MissingArgFor", "Missing argument for %1", t.currentCS);
          var T = t.GetArgument(e) + "," + t.GetArgument(e);
          T = o ? r + " " + T + " " + n : s ? "\\" + s + "l" + r + " " + T + " \\" + s + "r" + n : "\\left" + r + " " + T + " \\right" + n, t.Push(new a.default(T, t.stack.env, t.configuration).mml());
        };
        var d = [65, 90],
          f = [97, 122],
          m = [913, 937],
          L = [945, 969],
          y = [48, 57];
        function g(t, e) {
          return t >= e[0] && t <= e[1];
        }
        function v(t, e, r, n) {
          var o = t.configuration.parser,
            i = c.NodeFactory.createToken(t, e, r, n),
            a = n.codePointAt(0);
          return 1 === n.length && !o.stack.env.font && o.stack.env.vectorFont && (g(a, d) || g(a, f) || g(a, m) || g(a, y) || g(a, L) && o.stack.env.vectorStar || l.default.getAttribute(i, "accent")) && l.default.setAttribute(i, "mathvariant", o.stack.env.vectorFont), i;
        }
        u.VectorBold = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = t.configuration.nodeFactory.get("token"),
            i = t.stack.env.font;
          delete t.stack.env.font, t.configuration.nodeFactory.set("token", v), t.stack.env.vectorFont = r ? "bold-italic" : "bold", t.stack.env.vectorStar = r;
          var Q = new a.default(n, t.stack.env, t.configuration).mml();
          i && (t.stack.env.font = i), delete t.stack.env.vectorFont, delete t.stack.env.vectorStar, t.configuration.nodeFactory.set("token", o), t.Push(Q);
        }, u.StarMacro = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          var i = t.GetStar(),
            a = [];
          if (r) for (var Q = a.length; Q < r; Q++) a.push(t.GetArgument(e));
          var s = n.join(i ? "*" : "");
          s = T.default.substituteArgs(t, a, s), t.string = T.default.addArgs(t, s, t.string.slice(t.i)), t.i = 0, T.default.checkMaxMacros(t);
        };
        var b = function b(t, e, r, n, o) {
          var i = new a.default(n, t.stack.env, t.configuration).mml();
          t.Push(t.itemFactory.create(e, i));
          var Q = t.GetNext(),
            s = p[Q];
          if (s) {
            var T = -1 !== o.indexOf(Q);
            if ("{" === Q) {
              var l = (T ? "\\left\\{" : "") + " " + t.GetArgument(r) + " " + (T ? "\\right\\}" : "");
              return t.string = l + t.string.slice(t.i), void (t.i = 0);
            }
            T && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
              open: Q,
              close: s
            })));
          }
        };
        function H(t, e, r) {
          var o = n(t, 3),
            i = o[0],
            a = o[1],
            Q = o[2];
          return e && r ? "\\left\\langle{".concat(i, "}\\middle\\vert{").concat(a, "}\\middle\\vert{").concat(Q, "}\\right\\rangle") : e ? "\\langle{".concat(i, "}\\vert{").concat(a, "}\\vert{").concat(Q, "}\\rangle") : "\\left\\langle{".concat(i, "}\\right\\vert{").concat(a, "}\\left\\vert{").concat(Q, "}\\right\\rangle");
        }
        u.OperatorApplication = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          b(t, "fn", e, r, n);
        }, u.VectorOperator = function (t, e, r) {
          for (var n = [], o = 3; o < arguments.length; o++) n[o - 3] = arguments[o];
          b(t, "mml", e, r, n);
        }, u.Expression = function (t, e, r, n) {
          void 0 === r && (r = !0), void 0 === n && (n = ""), n = n || e.slice(1);
          var o = r ? t.GetBrackets(e) : null,
            i = t.create("token", "mi", {
              texClass: s.TEXCLASS.OP
            }, n);
          if (o) {
            var Q = new a.default(o, t.stack.env, t.configuration).mml();
            i = t.create("node", "msup", [i, Q]);
          }
          t.Push(t.itemFactory.create("fn", i)), "(" === t.GetNext() && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: "(",
            close: ")"
          })));
        }, u.Qqtext = function (t, e, r) {
          var n = (t.GetStar() ? "" : "\\quad") + "\\text{" + (r || t.GetArgument(e)) + "}\\quad ";
          t.string = t.string.slice(0, t.i) + n + t.string.slice(t.i);
        }, u.Differential = function (t, e, r) {
          var n = t.GetBrackets(e),
            o = null != n ? "^{" + n + "}" : " ",
            i = "(" === t.GetNext(),
            Q = "{" === t.GetNext(),
            T = r + o;
          if (i || Q) {
            if (Q) {
              T += t.GetArgument(e);
              l = new a.default(T, t.stack.env, t.configuration).mml();
              t.Push(t.create("node", "TeXAtom", [l], {
                texClass: s.TEXCLASS.OP
              }));
            } else t.Push(new a.default(T, t.stack.env, t.configuration).mml()), t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
              open: "(",
              close: ")"
            }));
          } else {
            T += t.GetArgument(e, !0) || "";
            var l = new a.default(T, t.stack.env, t.configuration).mml();
            t.Push(l);
          }
        }, u.Derivative = function (t, e, r, n) {
          var o = t.GetStar(),
            i = t.GetBrackets(e),
            Q = 1,
            s = [];
          for (s.push(t.GetArgument(e)); "{" === t.GetNext() && Q < r;) s.push(t.GetArgument(e)), Q++;
          var T = !1,
            l = " ",
            c = " ";
          r > 2 && s.length > 2 ? (l = "^{" + (s.length - 1) + "}", T = !0) : null != i && (r > 2 && s.length > 1 && (T = !0), c = l = "^{" + i + "}");
          for (var u = o ? "\\flatfrac" : "\\frac", p = s.length > 1 ? s[0] : "", h = s.length > 1 ? s[1] : s[0], d = "", f = 2, m = void 0; m = s[f]; f++) d += n + " " + m;
          var L = u + "{" + n + l + p + "}{" + n + " " + h + c + " " + d + "}";
          t.Push(new a.default(L, t.stack.env, t.configuration).mml()), "(" === t.GetNext() && (t.i++, t.Push(t.itemFactory.create("auto open").setProperties({
            open: "(",
            close: ")",
            ignore: T
          })));
        }, u.Bra = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = "",
            i = !1,
            Q = !1;
          if ("\\" === t.GetNext()) {
            var s = t.i;
            t.i++;
            var T = t.GetCS(),
              l = t.lookup("macro", T);
            l && "ket" === l.symbol ? (i = !0, s = t.i, Q = t.GetStar(), "{" === t.GetNext() ? o = t.GetArgument(T, !0) : (t.i = s, Q = !1)) : t.i = s;
          }
          var c = "";
          c = i ? r || Q ? "\\langle{".concat(n, "}\\vert{").concat(o, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(o, "}\\right\\rangle") : r || Q ? "\\langle{".concat(n, "}\\vert") : "\\left\\langle{".concat(n, "}\\right\\vert{").concat(o, "}"), t.Push(new a.default(c, t.stack.env, t.configuration).mml());
        }, u.Ket = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = r ? "\\vert{".concat(n, "}\\rangle") : "\\left\\vert{".concat(n, "}\\right\\rangle");
          t.Push(new a.default(o, t.stack.env, t.configuration).mml());
        }, u.BraKet = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = null;
          "{" === t.GetNext() && (o = t.GetArgument(e, !0));
          var i = "";
          i = null == o ? r ? "\\langle{".concat(n, "}\\vert{").concat(n, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(n, "}\\right\\rangle") : r ? "\\langle{".concat(n, "}\\vert{").concat(o, "}\\rangle") : "\\left\\langle{".concat(n, "}\\middle\\vert{").concat(o, "}\\right\\rangle"), t.Push(new a.default(i, t.stack.env, t.configuration).mml());
        }, u.KetBra = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = null;
          "{" === t.GetNext() && (o = t.GetArgument(e, !0));
          var i = "";
          i = null == o ? r ? "\\vert{".concat(n, "}\\rangle\\!\\langle{").concat(n, "}\\vert") : "\\left\\vert{".concat(n, "}\\middle\\rangle\\!\\middle\\langle{").concat(n, "}\\right\\vert") : r ? "\\vert{".concat(n, "}\\rangle\\!\\langle{").concat(o, "}\\vert") : "\\left\\vert{".concat(n, "}\\middle\\rangle\\!\\middle\\langle{").concat(o, "}\\right\\vert"), t.Push(new a.default(i, t.stack.env, t.configuration).mml());
        }, u.Expectation = function (t, e) {
          var r = t.GetStar(),
            n = r && t.GetStar(),
            o = t.GetArgument(e),
            i = null;
          "{" === t.GetNext() && (i = t.GetArgument(e, !0));
          var Q = o && i ? H([i, o, i], r, n) : r ? "\\langle {".concat(o, "} \\rangle") : "\\left\\langle {".concat(o, "} \\right\\rangle");
          t.Push(new a.default(Q, t.stack.env, t.configuration).mml());
        }, u.MatrixElement = function (t, e) {
          var r = t.GetStar(),
            n = r && t.GetStar(),
            o = H([t.GetArgument(e), t.GetArgument(e), t.GetArgument(e)], r, n);
          t.Push(new a.default(o, t.stack.env, t.configuration).mml());
        }, u.MatrixQuantity = function (t, e, r) {
          var n = t.GetStar(),
            o = r ? "smallmatrix" : "array",
            i = "",
            Q = "",
            s = "";
          switch (t.GetNext()) {
            case "{":
              i = t.GetArgument(e);
              break;
            case "(":
              t.i++, Q = n ? "\\lgroup" : "(", s = n ? "\\rgroup" : ")", i = t.GetUpTo(e, ")");
              break;
            case "[":
              t.i++, Q = "[", s = "]", i = t.GetUpTo(e, "]");
              break;
            case "|":
              t.i++, Q = "|", s = "|", i = t.GetUpTo(e, "|");
              break;
            default:
              Q = "(", s = ")";
          }
          var T = (Q ? "\\left" : "") + Q + "\\begin{" + o + "}{} " + i + "\\end{" + o + "}" + (Q ? "\\right" : "") + s;
          t.Push(new a.default(T, t.stack.env, t.configuration).mml());
        }, u.IdentityMatrix = function (t, e) {
          var r = t.GetArgument(e),
            n = parseInt(r, 10);
          if (isNaN(n)) throw new Q.default("InvalidNumber", "Invalid number");
          if (n <= 1) return t.string = "1" + t.string.slice(t.i), void (t.i = 0);
          for (var o = Array(n).fill("0"), i = [], a = 0; a < n; a++) {
            var s = o.slice();
            s[a] = "1", i.push(s.join(" & "));
          }
          t.string = i.join("\\\\ ") + t.string.slice(t.i), t.i = 0;
        }, u.XMatrix = function (t, e) {
          var r = t.GetStar(),
            n = t.GetArgument(e),
            o = t.GetArgument(e),
            i = t.GetArgument(e),
            a = parseInt(o, 10),
            s = parseInt(i, 10);
          if (isNaN(a) || isNaN(s) || s.toString() !== i || a.toString() !== o) throw new Q.default("InvalidNumber", "Invalid number");
          if (a = a < 1 ? 1 : a, s = s < 1 ? 1 : s, !r) {
            var T = Array(s).fill(n).join(" & "),
              l = Array(a).fill(T).join("\\\\ ");
            return t.string = l + t.string.slice(t.i), void (t.i = 0);
          }
          var c = "";
          if (1 === a && 1 === s) c = n;else if (1 === a) {
            T = [];
            for (var u = 1; u <= s; u++) T.push("".concat(n, "_{").concat(u, "}"));
            c = T.join(" & ");
          } else if (1 === s) {
            for (T = [], u = 1; u <= a; u++) T.push("".concat(n, "_{").concat(u, "}"));
            c = T.join("\\\\ ");
          } else {
            var p = [];
            for (u = 1; u <= a; u++) {
              T = [];
              for (var h = 1; h <= s; h++) T.push("".concat(n, "_{{").concat(u, "}{").concat(h, "}}"));
              p.push(T.join(" & "));
            }
            c = p.join("\\\\ ");
          }
          t.string = c + t.string.slice(t.i), t.i = 0;
        }, u.PauliMatrix = function (t, e) {
          var r = t.GetArgument(e),
            n = r.slice(1);
          switch (r[0]) {
            case "0":
              n += " 1 & 0\\\\ 0 & 1";
              break;
            case "1":
            case "x":
              n += " 0 & 1\\\\ 1 & 0";
              break;
            case "2":
            case "y":
              n += " 0 & -i\\\\ i & 0";
              break;
            case "3":
            case "z":
              n += " 1 & 0\\\\ 0 & -1";
          }
          t.string = n + t.string.slice(t.i), t.i = 0;
        }, u.DiagonalMatrix = function (t, e, r) {
          if ("{" === t.GetNext()) {
            var n = t.i;
            t.GetArgument(e);
            var o = t.i;
            t.i = n + 1;
            for (var i = [], a = "", Q = t.i; Q < o;) {
              try {
                a = t.GetUpTo(e, ",");
              } catch (e) {
                t.i = o, i.push(t.string.slice(Q, o - 1));
                break;
              }
              if (t.i >= o) {
                i.push(t.string.slice(Q, o));
                break;
              }
              Q = t.i, i.push(a);
            }
            t.string = function (t, e) {
              for (var r = t.length, n = [], o = 0; o < r; o++) n.push(Array(e ? r - o : o + 1).join("&") + "\\mqty{" + t[o] + "}");
              return n.join("\\\\ ");
            }(i, r) + t.string.slice(o), t.i = 0;
          }
        }, u.AutoClose = function (t, e, r) {
          var n = t.create("token", "mo", {
              stretchy: !1
            }, e),
            o = t.itemFactory.create("mml", n).setProperties({
              autoclose: e
            });
          t.Push(o);
        }, u.Vnabla = function (t, e) {
          var r = t.options.physics.arrowdel ? "\\vec{\\gradientnabla}" : "{\\gradientnabla}";
          return t.Push(new a.default(r, t.stack.env, t.configuration).mml());
        }, u.DiffD = function (t, e) {
          var r = t.options.physics.italicdiff ? "d" : "{\\rm d}";
          return t.Push(new a.default(r, t.stack.env, t.configuration).mml());
        }, u.Macro = i.default.Macro, u.NamedFn = i.default.NamedFn, u.Array = i.default.Array, e.default = u;
      },
      7741: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RequireConfiguration = e.options = e.RequireMethods = e.RequireLoad = void 0;
        var Q = r(9899),
          s = r(9140),
          T = a(r(3971)),
          l = r(9515),
          c = r(265),
          u = r(235),
          p = r(5713),
          h = r(7233),
          d = l.MathJax.config;
        function f(t, e) {
          var r,
            o = t.parseOptions.options.require,
            i = t.parseOptions.packageData.get("require").required,
            a = e.substr(o.prefix.length);
          if (i.indexOf(a) < 0) {
            i.push(a), function (t, e) {
              var r, o;
              void 0 === e && (e = []);
              var i = t.parseOptions.options.require.prefix;
              try {
                for (var a = n(e), Q = a.next(); !Q.done; Q = a.next()) {
                  var s = Q.value;
                  s.substr(0, i.length) === i && f(t, s);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  Q && !Q.done && (o = a.return) && o.call(a);
                } finally {
                  if (r) throw r.error;
                }
              }
            }(t, u.CONFIG.dependencies[e]);
            var s = Q.ConfigurationHandler.get(a);
            if (s) {
              var T = d[e] || {};
              s.options && 1 === Object.keys(s.options).length && s.options[a] && ((r = {})[a] = T, T = r), t.configuration.add(a, t, T);
              var l = t.parseOptions.packageData.get("require").configured;
              s.preprocessors.length && !l.has(a) && (l.set(a, !0), p.mathjax.retryAfter(Promise.resolve()));
            }
          }
        }
        function m(t, e) {
          var r = t.options.require,
            n = r.allow,
            o = ("[" === e.substr(0, 1) ? "" : r.prefix) + e;
          if (!(n.hasOwnProperty(o) ? n[o] : n.hasOwnProperty(e) ? n[e] : r.defaultAllow)) throw new T.default("BadRequire", 'Extension "%1" is not allowed to be loaded', o);
          c.Package.packages.has(o) ? f(t.configuration.packageData.get("require").jax, o) : p.mathjax.retryAfter(u.Loader.load(o));
        }
        e.RequireLoad = m, e.RequireMethods = {
          Require: function Require(t, e) {
            var r = t.GetArgument(e);
            if (r.match(/[^_a-zA-Z0-9]/) || "" === r) throw new T.default("BadPackageName", "Argument for %1 is not a valid package name", e);
            m(t, r);
          }
        }, e.options = {
          require: {
            allow: (0, h.expandable)({
              base: !1,
              "all-packages": !1,
              autoload: !1,
              configmacros: !1,
              tagformat: !1,
              setoptions: !1
            }),
            defaultAllow: !0,
            prefix: "tex"
          }
        }, new s.CommandMap("require", {
          require: "Require"
        }, e.RequireMethods), e.RequireConfiguration = Q.Configuration.create("require", {
          handler: {
            macro: ["require"]
          },
          config: function config(t, e) {
            e.parseOptions.packageData.set("require", {
              jax: e,
              required: i([], o(e.options.packages), !1),
              configured: new Map()
            });
            var r = e.parseOptions.options.require,
              n = r.prefix;
            if (n.match(/[^_a-zA-Z0-9]/)) throw Error("Illegal characters used in \\require prefix");
            u.CONFIG.paths[n] || (u.CONFIG.paths[n] = "[mathjax]/input/tex/extensions"), r.prefix = "[" + n + "]/";
          },
          options: e.options
        });
      },
      9365: function _(t, e, r) {
        var n = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SetOptionsConfiguration = e.SetOptionsUtil = void 0;
        var i = r(9899),
          a = r(9140),
          Q = o(r(3971)),
          s = o(r(1130)),
          T = r(8803),
          l = o(r(7693)),
          c = r(7233);
        e.SetOptionsUtil = {
          filterPackage: function filterPackage(t, e) {
            if ("tex" !== e && !i.ConfigurationHandler.get(e)) throw new Q.default("NotAPackage", "Not a defined package: %1", e);
            var r = t.options.setoptions,
              n = r.allowOptions[e];
            if (void 0 === n && !r.allowPackageDefault || !1 === n) throw new Q.default("PackageNotSettable", 'Options can\'t be set for package "%1"', e);
            return !0;
          },
          filterOption: function filterOption(t, e, r) {
            var n,
              o = t.options.setoptions,
              i = o.allowOptions[e] || {},
              a = i.hasOwnProperty(r) && !(0, c.isObject)(i[r]) ? i[r] : null;
            if (!1 === a || null === a && !o.allowOptionsDefault) throw new Q.default("OptionNotSettable", 'Option "%1" is not allowed to be set', r);
            if (!(null === (n = "tex" === e ? t.options : t.options[e]) || void 0 === n ? void 0 : n.hasOwnProperty(r))) throw "tex" === e ? new Q.default("InvalidTexOption", 'Invalid TeX option "%1"', r) : new Q.default("InvalidOptionKey", 'Invalid option "%1" for package "%2"', r, e);
            return !0;
          },
          filterValue: function filterValue(t, e, r, n) {
            return n;
          }
        };
        var u = new a.CommandMap("setoptions", {
          setOptions: "SetOptions"
        }, {
          SetOptions: function SetOptions(t, e) {
            var r,
              o,
              i = t.GetBrackets(e) || "tex",
              a = s.default.keyvalOptions(t.GetArgument(e)),
              Q = t.options.setoptions;
            if (Q.filterPackage(t, i)) try {
              for (var T = n(Object.keys(a)), l = T.next(); !l.done; l = T.next()) {
                var c = l.value;
                Q.filterOption(t, i, c) && (("tex" === i ? t.options : t.options[i])[c] = Q.filterValue(t, i, c, a[c]));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                l && !l.done && (o = T.return) && o.call(T);
              } finally {
                if (r) throw r.error;
              }
            }
          }
        });
        e.SetOptionsConfiguration = i.Configuration.create("setoptions", {
          handler: {
            macro: ["setoptions"]
          },
          config: function config(t, e) {
            var r = e.parseOptions.handlers.get("macro").lookup("require");
            r && (u.add("Require", new T.Macro("Require", r._func)), u.add("require", new T.Macro("require", l.default.Macro, ["\\Require{#2}\\setOptions[#2]{#1}", 2, ""])));
          },
          priority: 3,
          options: {
            setoptions: {
              filterPackage: e.SetOptionsUtil.filterPackage,
              filterOption: e.SetOptionsUtil.filterOption,
              filterValue: e.SetOptionsUtil.filterValue,
              allowPackageDefault: !0,
              allowOptionsDefault: !0,
              allowOptions: (0, c.expandable)({
                tex: {
                  FindTeX: !1,
                  formatError: !1,
                  package: !1,
                  baseURL: !1,
                  tags: !1,
                  maxBuffer: !1,
                  maxMaxros: !1,
                  macros: !1,
                  environments: !1
                },
                setoptions: !1,
                autoload: !1,
                require: !1,
                configmacros: !1,
                tagformat: !1
              })
            }
          }
        });
      },
      1527: function _(t, e, r) {
        var _n69,
          o = this && this.__extends || (_n69 = function n(t, e) {
            return _n69 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n69(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n69(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TagFormatConfiguration = e.tagformatConfig = void 0;
        var i = r(9899),
          a = r(6521),
          Q = 0;
        function s(t, e) {
          var r = e.parseOptions.options.tags;
          "base" !== r && t.tags.hasOwnProperty(r) && a.TagsFactory.add(r, t.tags[r]);
          var n = function (t) {
              function r() {
                return null !== t && t.apply(this, arguments) || this;
              }
              return o(r, t), r.prototype.formatNumber = function (t) {
                return e.parseOptions.options.tagformat.number(t);
              }, r.prototype.formatTag = function (t) {
                return e.parseOptions.options.tagformat.tag(t);
              }, r.prototype.formatId = function (t) {
                return e.parseOptions.options.tagformat.id(t);
              }, r.prototype.formatUrl = function (t, r) {
                return e.parseOptions.options.tagformat.url(t, r);
              }, r;
            }(a.TagsFactory.create(e.parseOptions.options.tags).constructor),
            i = "configTags-" + ++Q;
          a.TagsFactory.add(i, n), e.parseOptions.options.tags = i;
        }
        e.tagformatConfig = s, e.TagFormatConfiguration = i.Configuration.create("tagformat", {
          config: [s, 10],
          options: {
            tagformat: {
              number: function number(t) {
                return t.toString();
              },
              tag: function tag(t) {
                return "(" + t + ")";
              },
              id: function id(t) {
                return "mjx-eqn:" + t.replace(/\s/g, "_");
              },
              url: function url(t, e) {
                return e + "#" + encodeURIComponent(t);
              }
            }
          }
        });
      },
      2307: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextcompConfiguration = void 0;
        var n = r(9899);
        r(9906), e.TextcompConfiguration = n.Configuration.create("textcomp", {
          handler: {
            macro: ["textcomp-macros"]
          }
        });
      },
      9906: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var o = r(9140),
          i = r(8317),
          a = r(58),
          Q = n(r(1130)),
          s = r(8728);
        new o.CommandMap("textcomp-macros", {
          textasciicircum: ["Insert", "^"],
          textasciitilde: ["Insert", "~"],
          textasteriskcentered: ["Insert", "*"],
          textbackslash: ["Insert", "\\"],
          textbar: ["Insert", "|"],
          textbraceleft: ["Insert", "{"],
          textbraceright: ["Insert", "}"],
          textbullet: ["Insert", "\u2022"],
          textdagger: ["Insert", "\u2020"],
          textdaggerdbl: ["Insert", "\u2021"],
          textellipsis: ["Insert", "\u2026"],
          textemdash: ["Insert", "\u2014"],
          textendash: ["Insert", "\u2013"],
          textexclamdown: ["Insert", "\xa1"],
          textgreater: ["Insert", ">"],
          textless: ["Insert", "<"],
          textordfeminine: ["Insert", "\xaa"],
          textordmasculine: ["Insert", "\xba"],
          textparagraph: ["Insert", "\xb6"],
          textperiodcentered: ["Insert", "\xb7"],
          textquestiondown: ["Insert", "\xbf"],
          textquotedblleft: ["Insert", "\u201C"],
          textquotedblright: ["Insert", "\u201D"],
          textquoteleft: ["Insert", "\u2018"],
          textquoteright: ["Insert", "\u2019"],
          textsection: ["Insert", "\xa7"],
          textunderscore: ["Insert", "_"],
          textvisiblespace: ["Insert", "\u2423"],
          textacutedbl: ["Insert", "\u02DD"],
          textasciiacute: ["Insert", "\xb4"],
          textasciibreve: ["Insert", "\u02D8"],
          textasciicaron: ["Insert", "\u02C7"],
          textasciidieresis: ["Insert", "\xa8"],
          textasciimacron: ["Insert", "\xaf"],
          textgravedbl: ["Insert", "\u02F5"],
          texttildelow: ["Insert", "\u02F7"],
          textbaht: ["Insert", "\u0E3F"],
          textcent: ["Insert", "\xa2"],
          textcolonmonetary: ["Insert", "\u20A1"],
          textcurrency: ["Insert", "\xa4"],
          textdollar: ["Insert", "$"],
          textdong: ["Insert", "\u20AB"],
          texteuro: ["Insert", "\u20AC"],
          textflorin: ["Insert", "\u0192"],
          textguarani: ["Insert", "\u20B2"],
          textlira: ["Insert", "\u20A4"],
          textnaira: ["Insert", "\u20A6"],
          textpeso: ["Insert", "\u20B1"],
          textsterling: ["Insert", "\xa3"],
          textwon: ["Insert", "\u20A9"],
          textyen: ["Insert", "\xa5"],
          textcircledP: ["Insert", "\u2117"],
          textcompwordmark: ["Insert", "\u200C"],
          textcopyleft: ["Insert", "\uD83C\uDD2F"],
          textcopyright: ["Insert", "\xa9"],
          textregistered: ["Insert", "\xae"],
          textservicemark: ["Insert", "\u2120"],
          texttrademark: ["Insert", "\u2122"],
          textbardbl: ["Insert", "\u2016"],
          textbigcircle: ["Insert", "\u25EF"],
          textblank: ["Insert", "\u2422"],
          textbrokenbar: ["Insert", "\xa6"],
          textdiscount: ["Insert", "\u2052"],
          textestimated: ["Insert", "\u212E"],
          textinterrobang: ["Insert", "\u203D"],
          textinterrobangdown: ["Insert", "\u2E18"],
          textmusicalnote: ["Insert", "\u266A"],
          textnumero: ["Insert", "\u2116"],
          textopenbullet: ["Insert", "\u25E6"],
          textpertenthousand: ["Insert", "\u2031"],
          textperthousand: ["Insert", "\u2030"],
          textrecipe: ["Insert", "\u211E"],
          textreferencemark: ["Insert", "\u203B"],
          textlangle: ["Insert", "\u2329"],
          textrangle: ["Insert", "\u232A"],
          textlbrackdbl: ["Insert", "\u27E6"],
          textrbrackdbl: ["Insert", "\u27E7"],
          textlquill: ["Insert", "\u2045"],
          textrquill: ["Insert", "\u2046"],
          textcelsius: ["Insert", "\u2103"],
          textdegree: ["Insert", "\xb0"],
          textdiv: ["Insert", "\xf7"],
          textdownarrow: ["Insert", "\u2193"],
          textfractionsolidus: ["Insert", "\u2044"],
          textleftarrow: ["Insert", "\u2190"],
          textlnot: ["Insert", "\xac"],
          textmho: ["Insert", "\u2127"],
          textminus: ["Insert", "\u2212"],
          textmu: ["Insert", "\xb5"],
          textohm: ["Insert", "\u2126"],
          textonehalf: ["Insert", "\xbd"],
          textonequarter: ["Insert", "\xbc"],
          textonesuperior: ["Insert", "\xb9"],
          textpm: ["Insert", "\xb1"],
          textrightarrow: ["Insert", "\u2192"],
          textsurd: ["Insert", "\u221A"],
          textthreequarters: ["Insert", "\xbe"],
          textthreesuperior: ["Insert", "\xb3"],
          texttimes: ["Insert", "\xd7"],
          texttwosuperior: ["Insert", "\xb2"],
          textuparrow: ["Insert", "\u2191"],
          textborn: ["Insert", "*"],
          textdied: ["Insert", "\u2020"],
          textdivorced: ["Insert", "\u26AE"],
          textmarried: ["Insert", "\u26AD"],
          textcentoldstyle: ["Insert", "\xa2", i.TexConstant.Variant.OLDSTYLE],
          textdollaroldstyle: ["Insert", "$", i.TexConstant.Variant.OLDSTYLE],
          textzerooldstyle: ["Insert", "0", i.TexConstant.Variant.OLDSTYLE],
          textoneoldstyle: ["Insert", "1", i.TexConstant.Variant.OLDSTYLE],
          texttwooldstyle: ["Insert", "2", i.TexConstant.Variant.OLDSTYLE],
          textthreeoldstyle: ["Insert", "3", i.TexConstant.Variant.OLDSTYLE],
          textfouroldstyle: ["Insert", "4", i.TexConstant.Variant.OLDSTYLE],
          textfiveoldstyle: ["Insert", "5", i.TexConstant.Variant.OLDSTYLE],
          textsixoldstyle: ["Insert", "6", i.TexConstant.Variant.OLDSTYLE],
          textsevenoldstyle: ["Insert", "7", i.TexConstant.Variant.OLDSTYLE],
          texteightoldstyle: ["Insert", "8", i.TexConstant.Variant.OLDSTYLE],
          textnineoldstyle: ["Insert", "9", i.TexConstant.Variant.OLDSTYLE]
        }, {
          Insert: function Insert(t, e, r, n) {
            if (t instanceof s.TextParser) {
              if (!n) return void a.TextMacrosMethods.Insert(t, e, r);
              t.saveText();
            }
            t.Push(Q.default.internalText(t, r, n ? {
              mathvariant: n
            } : {}));
          }
        });
      },
      2675: function _(t, e, r) {
        var n,
          o = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextMacrosConfiguration = e.TextBaseConfiguration = void 0;
        var i = r(9899),
          a = o(r(8562)),
          Q = r(6521),
          s = r(1181),
          T = r(8728),
          l = r(58);
        function c(t, e, r, n) {
          var o = t.configuration.packageData.get("textmacros");
          return t instanceof T.TextParser || (o.texParser = t), [new T.TextParser(e, n ? {
            mathvariant: n
          } : {}, o.parseOptions, r).mml()];
        }
        r(8376), e.TextBaseConfiguration = i.Configuration.create("text-base", {
          parser: "text",
          handler: {
            character: ["command", "text-special"],
            macro: ["text-macros"]
          },
          fallback: {
            character: function character(t, e) {
              t.text += e;
            },
            macro: function macro(t, e) {
              var r = t.texParser,
                n = r.lookup("macro", e);
              n && n._func !== l.TextMacrosMethods.Macro && t.Error("MathMacro", "%1 is only supported in math mode", "\\" + e), r.parse("macro", [t, e]);
            }
          },
          items: (n = {}, n[s.StartItem.prototype.kind] = s.StartItem, n[s.StopItem.prototype.kind] = s.StopItem, n[s.MmlItem.prototype.kind] = s.MmlItem, n[s.StyleItem.prototype.kind] = s.StyleItem, n)
        }), e.TextMacrosConfiguration = i.Configuration.create("textmacros", {
          config: function config(t, e) {
            var r = new i.ParserConfiguration(e.parseOptions.options.textmacros.packages, ["tex", "text"]);
            r.init();
            var n = new a.default(r, []);
            n.options = e.parseOptions.options, r.config(e), Q.TagsFactory.addTags(r.tags), n.tags = Q.TagsFactory.getDefault(), n.tags.configuration = n, n.packageData = e.parseOptions.packageData, n.packageData.set("textmacros", {
              parseOptions: n,
              jax: e,
              texParser: null
            }), n.options.internalMath = c;
          },
          preprocessors: [function (t) {
            var e = t.data.packageData.get("textmacros");
            e.parseOptions.nodeFactory.setMmlFactory(e.jax.mmlFactory);
          }],
          options: {
            textmacros: {
              packages: ["text-base"]
            }
          }
        });
      },
      8376: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(9140),
          o = r(8317),
          i = r(58),
          a = r(6010);
        new n.MacroMap("text-special", {
          $: "Math",
          "%": "Comment",
          "^": "MathModeOnly",
          _: "MathModeOnly",
          "&": "Misplaced",
          "#": "Misplaced",
          "~": "Tilde",
          " ": "Space",
          "\t": "Space",
          "\r": "Space",
          "\n": "Space",
          "\xa0": "Tilde",
          "{": "OpenBrace",
          "}": "CloseBrace",
          "`": "OpenQuote",
          "'": "CloseQuote"
        }, i.TextMacrosMethods), new n.CommandMap("text-macros", {
          "(": "Math",
          $: "SelfQuote",
          _: "SelfQuote",
          "%": "SelfQuote",
          "{": "SelfQuote",
          "}": "SelfQuote",
          " ": "SelfQuote",
          "&": "SelfQuote",
          "#": "SelfQuote",
          "\\": "SelfQuote",
          "'": ["Accent", "\xb4"],
          "\u2019": ["Accent", "\xb4"],
          "`": ["Accent", "`"],
          "\u2018": ["Accent", "`"],
          "^": ["Accent", "^"],
          '"': ["Accent", "\xa8"],
          "~": ["Accent", "~"],
          "=": ["Accent", "\xaf"],
          ".": ["Accent", "\u02D9"],
          u: ["Accent", "\u02D8"],
          v: ["Accent", "\u02C7"],
          emph: "Emph",
          rm: ["SetFont", o.TexConstant.Variant.NORMAL],
          mit: ["SetFont", o.TexConstant.Variant.ITALIC],
          oldstyle: ["SetFont", o.TexConstant.Variant.OLDSTYLE],
          cal: ["SetFont", o.TexConstant.Variant.CALLIGRAPHIC],
          it: ["SetFont", "-tex-mathit"],
          bf: ["SetFont", o.TexConstant.Variant.BOLD],
          bbFont: ["SetFont", o.TexConstant.Variant.DOUBLESTRUCK],
          scr: ["SetFont", o.TexConstant.Variant.SCRIPT],
          frak: ["SetFont", o.TexConstant.Variant.FRAKTUR],
          sf: ["SetFont", o.TexConstant.Variant.SANSSERIF],
          tt: ["SetFont", o.TexConstant.Variant.MONOSPACE],
          tiny: ["SetSize", .5],
          Tiny: ["SetSize", .6],
          scriptsize: ["SetSize", .7],
          small: ["SetSize", .85],
          normalsize: ["SetSize", 1],
          large: ["SetSize", 1.2],
          Large: ["SetSize", 1.44],
          LARGE: ["SetSize", 1.73],
          huge: ["SetSize", 2.07],
          Huge: ["SetSize", 2.49],
          Bbb: ["Macro", "{\\bbFont #1}", 1],
          textnormal: ["Macro", "{\\rm #1}", 1],
          textup: ["Macro", "{\\rm #1}", 1],
          textrm: ["Macro", "{\\rm #1}", 1],
          textit: ["Macro", "{\\it #1}", 1],
          textbf: ["Macro", "{\\bf #1}", 1],
          textsf: ["Macro", "{\\sf #1}", 1],
          texttt: ["Macro", "{\\tt #1}", 1],
          dagger: ["Insert", "\u2020"],
          ddagger: ["Insert", "\u2021"],
          S: ["Insert", "\xa7"],
          ",": ["Spacer", a.MATHSPACE.thinmathspace],
          ":": ["Spacer", a.MATHSPACE.mediummathspace],
          ">": ["Spacer", a.MATHSPACE.mediummathspace],
          ";": ["Spacer", a.MATHSPACE.thickmathspace],
          "!": ["Spacer", a.MATHSPACE.negativethinmathspace],
          enspace: ["Spacer", .5],
          quad: ["Spacer", 1],
          qquad: ["Spacer", 2],
          thinspace: ["Spacer", a.MATHSPACE.thinmathspace],
          negthinspace: ["Spacer", a.MATHSPACE.negativethinmathspace],
          hskip: "Hskip",
          hspace: "Hskip",
          kern: "Hskip",
          mskip: "Hskip",
          mspace: "Hskip",
          mkern: "Hskip",
          rule: "rule",
          Rule: ["Rule"],
          Space: ["Rule", "blank"],
          color: "CheckAutoload",
          textcolor: "CheckAutoload",
          colorbox: "CheckAutoload",
          fcolorbox: "CheckAutoload",
          href: "CheckAutoload",
          style: "CheckAutoload",
          class: "CheckAutoload",
          cssId: "CheckAutoload",
          unicode: "CheckAutoload",
          ref: ["HandleRef", !1],
          eqref: ["HandleRef", !0]
        }, i.TextMacrosMethods);
      },
      58: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextMacrosMethods = void 0;
        var o = n(r(8417)),
          i = r(4542),
          a = n(r(7693));
        e.TextMacrosMethods = {
          Comment: function Comment(t, e) {
            for (; t.i < t.string.length && "\n" !== t.string.charAt(t.i);) t.i++;
            t.i++;
          },
          Math: function Math(t, e) {
            t.saveText();
            for (var r, n, i = t.i, a = 0; n = t.GetNext();) switch (r = t.i++, n) {
              case "\\":
                ")" === t.GetCS() && (n = "\\(");
              case "$":
                if (0 === a && e === n) {
                  var Q = t.texParser.configuration,
                    s = new o.default(t.string.substr(i, r - i), t.stack.env, Q).mml();
                  return void t.PushMath(s);
                }
                break;
              case "{":
                a++;
                break;
              case "}":
                0 === a && t.Error("ExtraCloseMissingOpen", "Extra close brace or missing open brace"), a--;
            }
            t.Error("MathNotTerminated", "Math-mode is not properly terminated");
          },
          MathModeOnly: function MathModeOnly(t, e) {
            t.Error("MathModeOnly", "'%1' allowed only in math mode", e);
          },
          Misplaced: function Misplaced(t, e) {
            t.Error("Misplaced", "'%1' can not be used here", e);
          },
          OpenBrace: function OpenBrace(t, e) {
            var r = t.stack.env;
            t.envStack.push(r), t.stack.env = Object.assign({}, r);
          },
          CloseBrace: function CloseBrace(t, e) {
            t.envStack.length ? (t.saveText(), t.stack.env = t.envStack.pop()) : t.Error("ExtraCloseMissingOpen", "Extra close brace or missing open brace");
          },
          OpenQuote: function OpenQuote(t, e) {
            t.string.charAt(t.i) === e ? (t.text += "\u201C", t.i++) : t.text += "\u2018";
          },
          CloseQuote: function CloseQuote(t, e) {
            t.string.charAt(t.i) === e ? (t.text += "\u201D", t.i++) : t.text += "\u2019";
          },
          Tilde: function Tilde(t, e) {
            t.text += "\xa0";
          },
          Space: function Space(t, e) {
            for (t.text += " "; t.GetNext().match(/\s/);) t.i++;
          },
          SelfQuote: function SelfQuote(t, e) {
            t.text += e.substr(1);
          },
          Insert: function Insert(t, e, r) {
            t.text += r;
          },
          Accent: function Accent(t, e, r) {
            var n = t.ParseArg(e),
              o = t.create("token", "mo", {}, r);
            t.addAttributes(o), t.Push(t.create("node", "mover", [n, o]));
          },
          Emph: function Emph(t, e) {
            var r = "-tex-mathit" === t.stack.env.mathvariant ? "normal" : "-tex-mathit";
            t.Push(t.ParseTextArg(e, {
              mathvariant: r
            }));
          },
          SetFont: function SetFont(t, e, r) {
            t.saveText(), t.stack.env.mathvariant = r;
          },
          SetSize: function SetSize(t, e, r) {
            t.saveText(), t.stack.env.mathsize = r;
          },
          CheckAutoload: function CheckAutoload(t, e) {
            var r = t.configuration.packageData.get("autoload"),
              n = t.texParser;
            e = e.slice(1);
            var o = n.lookup("macro", e);
            if (!o || r && o._func === r.Autoload) {
              if (n.parse("macro", [n, e]), !o) return;
              (0, i.retryAfter)(Promise.resolve());
            }
            n.parse("macro", [t, e]);
          },
          Macro: a.default.Macro,
          Spacer: a.default.Spacer,
          Hskip: a.default.Hskip,
          rule: a.default.rule,
          Rule: a.default.Rule,
          HandleRef: a.default.HandleRef
        };
      },
      8728: function _(t, e, r) {
        var _n70,
          o = this && this.__extends || (_n70 = function n(t, e) {
            return _n70 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n70(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n70(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TextParser = void 0;
        var T = s(r(8417)),
          l = s(r(3971)),
          c = s(r(1130)),
          u = r(9007),
          p = s(r(1256)),
          h = r(1181),
          d = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, r, n) || this;
              return i.level = o, i;
            }
            return o(e, t), Object.defineProperty(e.prototype, "texParser", {
              get: function get() {
                return this.configuration.packageData.get("textmacros").texParser;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tags", {
              get: function get() {
                return this.texParser.tags;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.mml = function () {
              return null != this.level ? this.create("node", "mstyle", this.nodes, {
                displaystyle: !1,
                scriptlevel: this.level
              }) : 1 === this.nodes.length ? this.nodes[0] : this.create("node", "mrow", this.nodes);
            }, e.prototype.Parse = function () {
              this.text = "", this.nodes = [], this.envStack = [], t.prototype.Parse.call(this);
            }, e.prototype.saveText = function () {
              if (this.text) {
                var t = this.stack.env.mathvariant,
                  e = c.default.internalText(this, this.text, t ? {
                    mathvariant: t
                  } : {});
                this.text = "", this.Push(e);
              }
            }, e.prototype.Push = function (e) {
              if (this.text && this.saveText(), e instanceof h.StopItem) return t.prototype.Push.call(this, e);
              e instanceof h.StyleItem ? this.stack.env.mathcolor = this.stack.env.color : e instanceof u.AbstractMmlNode && (this.addAttributes(e), this.nodes.push(e));
            }, e.prototype.PushMath = function (t) {
              var e,
                r,
                n = this.stack.env;
              t.isKind("TeXAtom") || (t = this.create("node", "TeXAtom", [t]));
              try {
                for (var o = i(["mathsize", "mathcolor"]), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  n[Q] && !t.attributes.getExplicit(Q) && (t.isToken || t.isKind("mstyle") || (t = this.create("node", "mstyle", [t])), p.default.setAttribute(t, Q, n[Q]));
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              t.isInferred && (t = this.create("node", "mrow", t.childNodes)), this.nodes.push(t);
            }, e.prototype.addAttributes = function (t) {
              var e,
                r,
                n = this.stack.env;
              if (t.isToken) try {
                for (var o = i(["mathsize", "mathcolor", "mathvariant"]), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  n[Q] && !t.attributes.getExplicit(Q) && p.default.setAttribute(t, Q, n[Q]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.ParseTextArg = function (t, r) {
              return new e(this.GetArgument(t), r = Object.assign(Object.assign({}, this.stack.env), r), this.configuration).mml();
            }, e.prototype.ParseArg = function (t) {
              return new e(this.GetArgument(t), this.stack.env, this.configuration).mml();
            }, e.prototype.Error = function (t, e) {
              for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
              throw new (l.default.bind.apply(l.default, Q([void 0, t, e], a(r), !1)))();
            }, e;
          }(T.default);
        e.TextParser = d;
      },
      6841: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UnicodeConfiguration = e.UnicodeMethods = void 0;
        var o = r(9899),
          i = n(r(3971)),
          a = r(9140),
          Q = n(r(1130)),
          s = n(r(1256)),
          T = r(5368);
        e.UnicodeMethods = {};
        var l = {};
        e.UnicodeMethods.Unicode = function (t, e) {
          var r = t.GetBrackets(e),
            n = null,
            o = null;
          r && (r.replace(/ /g, "").match(/^(\d+(\.\d*)?|\.\d+),(\d+(\.\d*)?|\.\d+)$/) ? (n = r.replace(/ /g, "").split(/,/), o = t.GetBrackets(e)) : o = r);
          var a = Q.default.trimSpaces(t.GetArgument(e)).replace(/^0x/, "x");
          if (!a.match(/^(x[0-9A-Fa-f]+|[0-9]+)$/)) throw new i.default("BadUnicode", "Argument to \\unicode must be a number");
          var c = parseInt(a.match(/^x/) ? "0" + a : a);
          l[c] ? o || (o = l[c][2]) : l[c] = [800, 200, o, c], n && (l[c][0] = Math.floor(1e3 * parseFloat(n[0])), l[c][1] = Math.floor(1e3 * parseFloat(n[1])));
          var u = t.stack.env.font,
            p = {};
          o ? (l[c][2] = p.fontfamily = o.replace(/'/g, "'"), u && (u.match(/bold/) && (p.fontweight = "bold"), u.match(/italic|-mathit/) && (p.fontstyle = "italic"))) : u && (p.mathvariant = u);
          var h = t.create("token", "mtext", p, (0, T.numeric)(a));
          s.default.setProperty(h, "unicode", !0), t.Push(h);
        }, new a.CommandMap("unicode", {
          unicode: "Unicode"
        }, e.UnicodeMethods), e.UnicodeConfiguration = o.Configuration.create("unicode", {
          handler: {
            macro: ["unicode"]
          }
        });
      },
      1442: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.UpgreekConfiguration = void 0;
        var n = r(9899),
          o = r(9140),
          i = r(8317);
        new o.CharacterMap("upgreek", function (t, e) {
          var r = e.attributes || {};
          r.mathvariant = i.TexConstant.Variant.NORMAL;
          var n = t.create("token", "mi", r, e.char);
          t.Push(n);
        }, {
          upalpha: "\u03B1",
          upbeta: "\u03B2",
          upgamma: "\u03B3",
          updelta: "\u03B4",
          upepsilon: "\u03F5",
          upzeta: "\u03B6",
          upeta: "\u03B7",
          uptheta: "\u03B8",
          upiota: "\u03B9",
          upkappa: "\u03BA",
          uplambda: "\u03BB",
          upmu: "\u03BC",
          upnu: "\u03BD",
          upxi: "\u03BE",
          upomicron: "\u03BF",
          uppi: "\u03C0",
          uprho: "\u03C1",
          upsigma: "\u03C3",
          uptau: "\u03C4",
          upupsilon: "\u03C5",
          upphi: "\u03D5",
          upchi: "\u03C7",
          uppsi: "\u03C8",
          upomega: "\u03C9",
          upvarepsilon: "\u03B5",
          upvartheta: "\u03D1",
          upvarpi: "\u03D6",
          upvarrho: "\u03F1",
          upvarsigma: "\u03C2",
          upvarphi: "\u03C6",
          Upgamma: "\u0393",
          Updelta: "\u0394",
          Uptheta: "\u0398",
          Uplambda: "\u039B",
          Upxi: "\u039E",
          Uppi: "\u03A0",
          Upsigma: "\u03A3",
          Upupsilon: "\u03A5",
          Upphi: "\u03A6",
          Uppsi: "\u03A8",
          Upomega: "\u03A9"
        }), e.UpgreekConfiguration = n.Configuration.create("upgreek", {
          handler: {
            macro: ["upgreek"]
          }
        });
      },
      1247: function _(t, e, r) {
        var n = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VerbConfiguration = e.VerbMethods = void 0;
        var o = r(9899),
          i = r(8317),
          a = r(9140),
          Q = n(r(3971));
        e.VerbMethods = {}, e.VerbMethods.Verb = function (t, e) {
          var r = t.GetNext(),
            n = ++t.i;
          if ("" === r) throw new Q.default("MissingArgFor", "Missing argument for %1", e);
          for (; t.i < t.string.length && t.string.charAt(t.i) !== r;) t.i++;
          if (t.i === t.string.length) throw new Q.default("NoClosingDelim", "Can't find closing delimiter for %1", t.currentCS);
          var o = t.string.slice(n, t.i).replace(/ /g, "\xa0");
          t.i++, t.Push(t.create("token", "mtext", {
            mathvariant: i.TexConstant.Variant.MONOSPACE
          }, o));
        }, new a.CommandMap("verb", {
          verb: "Verb"
        }, e.VerbMethods), e.VerbConfiguration = o.Configuration.create("verb", {
          handler: {
            macro: ["verb"]
          }
        });
      },
      5713: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.mathjax = void 0;
        var n = r(3282),
          o = r(805),
          i = r(4542);
        e.mathjax = {
          version: n.VERSION,
          handlers: new o.HandlerList(),
          document: function document(t, r) {
            return e.mathjax.handlers.document(t, r);
          },
          handleRetriesFor: i.handleRetriesFor,
          retryAfter: i.retryAfter,
          asyncLoad: null
        };
      },
      5884: function _(t, e, r) {
        var n = this && this.__assign || function () {
            return n = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, n.apply(this, arguments);
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FontData = e.NOSTRETCH = e.H = e.V = void 0;
        var Q = r(7233);
        e.V = 1, e.H = 2, e.NOSTRETCH = {
          dir: 0
        };
        var s = function () {
          function t(t) {
            var e, r, s, T;
            void 0 === t && (t = null), this.variant = {}, this.delimiters = {}, this.cssFontMap = {}, this.remapChars = {}, this.skewIcFactor = .75;
            var l = this.constructor;
            this.options = (0, Q.userOptions)((0, Q.defaultOptions)({}, l.OPTIONS), t), this.params = n({}, l.defaultParams), this.sizeVariants = i([], o(l.defaultSizeVariants), !1), this.stretchVariants = i([], o(l.defaultStretchVariants), !1), this.cssFontMap = n({}, l.defaultCssFonts);
            try {
              for (var c = a(Object.keys(this.cssFontMap)), u = c.next(); !u.done; u = c.next()) {
                var p = u.value;
                "unknown" === this.cssFontMap[p][0] && (this.cssFontMap[p][0] = this.options.unknownFamily);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                u && !u.done && (r = c.return) && r.call(c);
              } finally {
                if (e) throw e.error;
              }
            }
            this.cssFamilyPrefix = l.defaultCssFamilyPrefix, this.createVariants(l.defaultVariants), this.defineDelimiters(l.defaultDelimiters);
            try {
              for (var h = a(Object.keys(l.defaultChars)), d = h.next(); !d.done; d = h.next()) {
                var f = d.value;
                this.defineChars(f, l.defaultChars[f]);
              }
            } catch (t) {
              s = {
                error: t
              };
            } finally {
              try {
                d && !d.done && (T = h.return) && T.call(h);
              } finally {
                if (s) throw s.error;
              }
            }
            this.defineRemap("accent", l.defaultAccentMap), this.defineRemap("mo", l.defaultMoMap), this.defineRemap("mn", l.defaultMnMap);
          }
          return t.charOptions = function (t, e) {
            var r = t[e];
            return 3 === r.length && (r[3] = {}), r[3];
          }, Object.defineProperty(t.prototype, "styles", {
            get: function get() {
              return this._styles;
            },
            set: function set(t) {
              this._styles = t;
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.createVariant = function (t, e, r) {
            void 0 === e && (e = null), void 0 === r && (r = null);
            var n = {
              linked: [],
              chars: e ? Object.create(this.variant[e].chars) : {}
            };
            r && this.variant[r] && (Object.assign(n.chars, this.variant[r].chars), this.variant[r].linked.push(n.chars), n.chars = Object.create(n.chars)), this.remapSmpChars(n.chars, t), this.variant[t] = n;
          }, t.prototype.remapSmpChars = function (t, e) {
            var r,
              n,
              i,
              Q,
              s = this.constructor;
            if (s.VariantSmp[e]) {
              var T = s.SmpRemap,
                l = [null, null, s.SmpRemapGreekU, s.SmpRemapGreekL];
              try {
                for (var c = a(s.SmpRanges), u = c.next(); !u.done; u = c.next()) {
                  var p = o(u.value, 3),
                    h = p[0],
                    d = p[1],
                    f = p[2],
                    m = s.VariantSmp[e][h];
                  if (m) {
                    for (var L = d; L <= f; L++) if (930 !== L) {
                      var y = m + L - d;
                      t[L] = this.smpChar(T[y] || y);
                    }
                    if (l[h]) try {
                      for (var g = (i = void 0, a(Object.keys(l[h]).map(function (t) {
                          return parseInt(t);
                        }))), v = g.next(); !v.done; v = g.next()) {
                        t[L = v.value] = this.smpChar(m + l[h][L]);
                      }
                    } catch (t) {
                      i = {
                        error: t
                      };
                    } finally {
                      try {
                        v && !v.done && (Q = g.return) && Q.call(g);
                      } finally {
                        if (i) throw i.error;
                      }
                    }
                  }
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  u && !u.done && (n = c.return) && n.call(c);
                } finally {
                  if (r) throw r.error;
                }
              }
            }
            "bold" === e && (t[988] = this.smpChar(120778), t[989] = this.smpChar(120779));
          }, t.prototype.smpChar = function (t) {
            return [,,, {
              smp: t
            }];
          }, t.prototype.createVariants = function (t) {
            var e, r;
            try {
              for (var n = a(t), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                this.createVariant(i[0], i[1], i[2]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                o && !o.done && (r = n.return) && r.call(n);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.defineChars = function (t, e) {
            var r,
              n,
              o = this.variant[t];
            Object.assign(o.chars, e);
            try {
              for (var i = a(o.linked), Q = i.next(); !Q.done; Q = i.next()) {
                var s = Q.value;
                Object.assign(s, e);
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = i.return) && n.call(i);
              } finally {
                if (r) throw r.error;
              }
            }
          }, t.prototype.defineDelimiters = function (t) {
            Object.assign(this.delimiters, t);
          }, t.prototype.defineRemap = function (t, e) {
            this.remapChars.hasOwnProperty(t) || (this.remapChars[t] = {}), Object.assign(this.remapChars[t], e);
          }, t.prototype.getDelimiter = function (t) {
            return this.delimiters[t];
          }, t.prototype.getSizeVariant = function (t, e) {
            return this.delimiters[t].variants && (e = this.delimiters[t].variants[e]), this.sizeVariants[e];
          }, t.prototype.getStretchVariant = function (t, e) {
            return this.stretchVariants[this.delimiters[t].stretchv ? this.delimiters[t].stretchv[e] : 0];
          }, t.prototype.getChar = function (t, e) {
            return this.variant[t].chars[e];
          }, t.prototype.getVariant = function (t) {
            return this.variant[t];
          }, t.prototype.getCssFont = function (t) {
            return this.cssFontMap[t] || ["serif", !1, !1];
          }, t.prototype.getFamily = function (t) {
            return this.cssFamilyPrefix ? this.cssFamilyPrefix + ", " + t : t;
          }, t.prototype.getRemappedChar = function (t, e) {
            return (this.remapChars[t] || {})[e];
          }, t.OPTIONS = {
            unknownFamily: "serif"
          }, t.JAX = "common", t.NAME = "", t.defaultVariants = [["normal"], ["bold", "normal"], ["italic", "normal"], ["bold-italic", "italic", "bold"], ["double-struck", "bold"], ["fraktur", "normal"], ["bold-fraktur", "bold", "fraktur"], ["script", "italic"], ["bold-script", "bold-italic", "script"], ["sans-serif", "normal"], ["bold-sans-serif", "bold", "sans-serif"], ["sans-serif-italic", "italic", "sans-serif"], ["sans-serif-bold-italic", "bold-italic", "bold-sans-serif"], ["monospace", "normal"]], t.defaultCssFonts = {
            normal: ["unknown", !1, !1],
            bold: ["unknown", !1, !0],
            italic: ["unknown", !0, !1],
            "bold-italic": ["unknown", !0, !0],
            "double-struck": ["unknown", !1, !0],
            fraktur: ["unknown", !1, !1],
            "bold-fraktur": ["unknown", !1, !0],
            script: ["cursive", !1, !1],
            "bold-script": ["cursive", !1, !0],
            "sans-serif": ["sans-serif", !1, !1],
            "bold-sans-serif": ["sans-serif", !1, !0],
            "sans-serif-italic": ["sans-serif", !0, !1],
            "sans-serif-bold-italic": ["sans-serif", !0, !0],
            monospace: ["monospace", !1, !1]
          }, t.defaultCssFamilyPrefix = "", t.VariantSmp = {
            bold: [119808, 119834, 120488, 120514, 120782],
            italic: [119860, 119886, 120546, 120572],
            "bold-italic": [119912, 119938, 120604, 120630],
            script: [119964, 119990],
            "bold-script": [120016, 120042],
            fraktur: [120068, 120094],
            "double-struck": [120120, 120146,,, 120792],
            "bold-fraktur": [120172, 120198],
            "sans-serif": [120224, 120250,,, 120802],
            "bold-sans-serif": [120276, 120302, 120662, 120688, 120812],
            "sans-serif-italic": [120328, 120354],
            "sans-serif-bold-italic": [120380, 120406, 120720, 120746],
            monospace: [120432, 120458,,, 120822]
          }, t.SmpRanges = [[0, 65, 90], [1, 97, 122], [2, 913, 937], [3, 945, 969], [4, 48, 57]], t.SmpRemap = {
            119893: 8462,
            119965: 8492,
            119968: 8496,
            119969: 8497,
            119971: 8459,
            119972: 8464,
            119975: 8466,
            119976: 8499,
            119981: 8475,
            119994: 8495,
            119996: 8458,
            120004: 8500,
            120070: 8493,
            120075: 8460,
            120076: 8465,
            120085: 8476,
            120093: 8488,
            120122: 8450,
            120127: 8461,
            120133: 8469,
            120135: 8473,
            120136: 8474,
            120137: 8477,
            120145: 8484
          }, t.SmpRemapGreekU = {
            8711: 25,
            1012: 17
          }, t.SmpRemapGreekL = {
            977: 27,
            981: 29,
            982: 31,
            1008: 28,
            1009: 30,
            1013: 26,
            8706: 25
          }, t.defaultAccentMap = {
            768: "\u02CB",
            769: "\u02CA",
            770: "\u02C6",
            771: "\u02DC",
            772: "\u02C9",
            774: "\u02D8",
            775: "\u02D9",
            776: "\xa8",
            778: "\u02DA",
            780: "\u02C7",
            8594: "\u20D7",
            8242: "'",
            8243: "''",
            8244: "'''",
            8245: "`",
            8246: "``",
            8247: "```",
            8279: "''''",
            8400: "\u21BC",
            8401: "\u21C0",
            8406: "\u2190",
            8417: "\u2194",
            8432: "*",
            8411: "...",
            8412: "....",
            8428: "\u21C1",
            8429: "\u21BD",
            8430: "\u2190",
            8431: "\u2192"
          }, t.defaultMoMap = {
            45: "\u2212"
          }, t.defaultMnMap = {
            45: "\u2212"
          }, t.defaultParams = {
            x_height: .442,
            quad: 1,
            num1: .676,
            num2: .394,
            num3: .444,
            denom1: .686,
            denom2: .345,
            sup1: .413,
            sup2: .363,
            sup3: .289,
            sub1: .15,
            sub2: .247,
            sup_drop: .386,
            sub_drop: .05,
            delim1: 2.39,
            delim2: 1,
            axis_height: .25,
            rule_thickness: .06,
            big_op_spacing1: .111,
            big_op_spacing2: .167,
            big_op_spacing3: .2,
            big_op_spacing4: .6,
            big_op_spacing5: .1,
            surd_height: .075,
            scriptspace: .05,
            nulldelimiterspace: .12,
            delimiterfactor: 901,
            delimitershortfall: .3,
            min_rule_thickness: 1.25,
            separation_factor: 1.75,
            extra_ic: .033
          }, t.defaultDelimiters = {}, t.defaultChars = {}, t.defaultSizeVariants = [], t.defaultStretchVariants = [], t;
        }();
        e.FontData = s;
      },
      5552: function _(t, e) {
        var r = this && this.__read || function (t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
            o,
            i = r.call(t),
            a = [];
          try {
            for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = i.return) && r.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonArrow = e.CommonDiagonalArrow = e.CommonDiagonalStrike = e.CommonBorder2 = e.CommonBorder = e.arrowBBox = e.diagonalArrowDef = e.arrowDef = e.arrowBBoxW = e.arrowBBoxHD = e.arrowHead = e.fullBorder = e.fullPadding = e.fullBBox = e.sideNames = e.sideIndex = e.SOLID = e.PADDING = e.THICKNESS = e.ARROWY = e.ARROWDX = e.ARROWX = void 0, e.ARROWX = 4, e.ARROWDX = 1, e.ARROWY = 2, e.THICKNESS = .067, e.PADDING = .2, e.SOLID = e.THICKNESS + "em solid", e.sideIndex = {
          top: 0,
          right: 1,
          bottom: 2,
          left: 3
        }, e.sideNames = Object.keys(e.sideIndex), e.fullBBox = function (t) {
          return new Array(4).fill(t.thickness + t.padding);
        }, e.fullPadding = function (t) {
          return new Array(4).fill(t.padding);
        }, e.fullBorder = function (t) {
          return new Array(4).fill(t.thickness);
        };
        e.arrowHead = function (t) {
          return Math.max(t.padding, t.thickness * (t.arrowhead.x + t.arrowhead.dx + 1));
        };
        e.arrowBBoxHD = function (t, e) {
          if (t.childNodes[0]) {
            var r = t.childNodes[0].getBBox(),
              n = r.h,
              o = r.d;
            e[0] = e[2] = Math.max(0, t.thickness * t.arrowhead.y - (n + o) / 2);
          }
          return e;
        };
        e.arrowBBoxW = function (t, e) {
          if (t.childNodes[0]) {
            var r = t.childNodes[0].getBBox().w;
            e[1] = e[3] = Math.max(0, t.thickness * t.arrowhead.y - r / 2);
          }
          return e;
        }, e.arrowDef = {
          up: [-Math.PI / 2, !1, !0, "verticalstrike"],
          down: [Math.PI / 2, !1, !0, "verticakstrike"],
          right: [0, !1, !1, "horizontalstrike"],
          left: [Math.PI, !1, !1, "horizontalstrike"],
          updown: [Math.PI / 2, !0, !0, "verticalstrike uparrow downarrow"],
          leftright: [0, !0, !1, "horizontalstrike leftarrow rightarrow"]
        }, e.diagonalArrowDef = {
          updiagonal: [-1, 0, !1, "updiagonalstrike northeastarrow"],
          northeast: [-1, 0, !1, "updiagonalstrike updiagonalarrow"],
          southeast: [1, 0, !1, "downdiagonalstrike"],
          northwest: [1, Math.PI, !1, "downdiagonalstrike"],
          southwest: [-1, Math.PI, !1, "updiagonalstrike"],
          northeastsouthwest: [-1, 0, !0, "updiagonalstrike northeastarrow updiagonalarrow southwestarrow"],
          northwestsoutheast: [1, 0, !0, "downdiagonalstrike northwestarrow southeastarrow"]
        }, e.arrowBBox = {
          up: function up(t) {
            return (0, e.arrowBBoxW)(t, [(0, e.arrowHead)(t), 0, t.padding, 0]);
          },
          down: function down(t) {
            return (0, e.arrowBBoxW)(t, [t.padding, 0, (0, e.arrowHead)(t), 0]);
          },
          right: function right(t) {
            return (0, e.arrowBBoxHD)(t, [0, (0, e.arrowHead)(t), 0, t.padding]);
          },
          left: function left(t) {
            return (0, e.arrowBBoxHD)(t, [0, t.padding, 0, (0, e.arrowHead)(t)]);
          },
          updown: function updown(t) {
            return (0, e.arrowBBoxW)(t, [(0, e.arrowHead)(t), 0, (0, e.arrowHead)(t), 0]);
          },
          leftright: function leftright(t) {
            return (0, e.arrowBBoxHD)(t, [0, (0, e.arrowHead)(t), 0, (0, e.arrowHead)(t)]);
          }
        };
        e.CommonBorder = function (t) {
          return function (r) {
            var n = e.sideIndex[r];
            return [r, {
              renderer: t,
              bbox: function bbox(t) {
                var e = [0, 0, 0, 0];
                return e[n] = t.thickness + t.padding, e;
              },
              border: function border(t) {
                var e = [0, 0, 0, 0];
                return e[n] = t.thickness, e;
              }
            }];
          };
        };
        e.CommonBorder2 = function (t) {
          return function (r, n, o) {
            var i = e.sideIndex[n],
              a = e.sideIndex[o];
            return [r, {
              renderer: t,
              bbox: function bbox(t) {
                var e = t.thickness + t.padding,
                  r = [0, 0, 0, 0];
                return r[i] = r[a] = e, r;
              },
              border: function border(t) {
                var e = [0, 0, 0, 0];
                return e[i] = e[a] = t.thickness, e;
              },
              remove: n + " " + o
            }];
          };
        };
        e.CommonDiagonalStrike = function (t) {
          return function (r) {
            var n = "mjx-" + r.charAt(0) + "strike";
            return [r + "diagonalstrike", {
              renderer: t(n),
              bbox: e.fullBBox
            }];
          };
        };
        e.CommonDiagonalArrow = function (t) {
          return function (n) {
            var o = r(e.diagonalArrowDef[n], 4),
              i = o[0],
              a = o[1],
              Q = o[2];
            return [n + "arrow", {
              renderer: function renderer(e, n) {
                var o = r(e.arrowAW(), 2),
                  s = o[0],
                  T = o[1],
                  l = e.arrow(T, i * (s - a), Q);
                t(e, l);
              },
              bbox: function bbox(t) {
                var e = t.arrowData(),
                  n = e.a,
                  o = e.x,
                  i = e.y,
                  a = r([t.arrowhead.x, t.arrowhead.y, t.arrowhead.dx], 3),
                  Q = a[0],
                  s = a[1],
                  T = a[2],
                  l = r(t.getArgMod(Q + T, s), 2),
                  c = l[0],
                  u = l[1],
                  p = i + (c > n ? t.thickness * u * Math.sin(c - n) : 0),
                  h = o + (c > Math.PI / 2 - n ? t.thickness * u * Math.sin(c + n - Math.PI / 2) : 0);
                return [p, h, p, h];
              },
              remove: o[3]
            }];
          };
        };
        e.CommonArrow = function (t) {
          return function (n) {
            var o = r(e.arrowDef[n], 4),
              i = o[0],
              a = o[1],
              Q = o[2],
              s = o[3];
            return [n + "arrow", {
              renderer: function renderer(e, n) {
                var o = e.getBBox(),
                  s = o.w,
                  T = o.h,
                  l = o.d,
                  c = r(Q ? [T + l, "X"] : [s, "Y"], 2),
                  u = c[0],
                  p = c[1],
                  h = e.getOffset(p),
                  d = e.arrow(u, i, a, p, h);
                t(e, d);
              },
              bbox: e.arrowBBox[n],
              remove: s
            }];
          };
        };
      },
      3055: function _(t, e, r) {
        var _n71,
          o = this && this.__extends || (_n71 = function n(t, e) {
            return _n71 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n71(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n71(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonOutputJax = void 0;
        var s = r(2975),
          T = r(4474),
          l = r(7233),
          c = r(6010),
          u = r(8054),
          p = r(4139),
          h = function (t) {
            function e(e, r, n) {
              void 0 === e && (e = null), void 0 === r && (r = null), void 0 === n && (n = null);
              var o = this,
                i = a((0, l.separateOptions)(e, n.OPTIONS), 2),
                Q = i[0],
                s = i[1];
              return (o = t.call(this, Q) || this).factory = o.options.wrapperFactory || new r(), o.factory.jax = o, o.cssStyles = o.options.cssStyles || new p.CssStyles(), o.font = o.options.font || new n(s), o.unknownCache = new Map(), o;
            }
            return o(e, t), e.prototype.typeset = function (t, e) {
              this.setDocument(e);
              var r = this.createNode();
              return this.toDOM(t, r, e), r;
            }, e.prototype.createNode = function () {
              var t = this.constructor.NAME;
              return this.html("mjx-container", {
                class: "MathJax",
                jax: t
              });
            }, e.prototype.setScale = function (t) {
              var e = this.math.metrics.scale * this.options.scale;
              1 !== e && this.adaptor.setStyle(t, "fontSize", (0, c.percent)(e));
            }, e.prototype.toDOM = function (t, e, r) {
              void 0 === r && (r = null), this.setDocument(r), this.math = t, this.pxPerEm = t.metrics.ex / this.font.params.x_height, t.root.setTeXclass(null), this.setScale(e), this.nodeMap = new Map(), this.container = e, this.processMath(t.root, e), this.nodeMap = null, this.executeFilters(this.postFilters, t, r, e);
            }, e.prototype.getBBox = function (t, e) {
              this.setDocument(e), this.math = t, t.root.setTeXclass(null), this.nodeMap = new Map();
              var r = this.factory.wrap(t.root).getOuterBBox();
              return this.nodeMap = null, r;
            }, e.prototype.getMetrics = function (t) {
              var e, r;
              this.setDocument(t);
              var n = this.adaptor,
                o = this.getMetricMaps(t);
              try {
                for (var i = Q(t.math), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value,
                    l = n.parent(s.start.node);
                  if (s.state() < T.STATE.METRICS && l) {
                    var c = o[s.display ? 1 : 0].get(l),
                      u = c.em,
                      p = c.ex,
                      h = c.containerWidth,
                      d = c.lineWidth,
                      f = c.scale,
                      m = c.family;
                    s.setMetrics(u, p, h, d, f), this.options.mtextInheritFont && (s.outputData.mtextFamily = m), this.options.merrorInheritFont && (s.outputData.merrorFamily = m), s.state(T.STATE.METRICS);
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.getMetricsFor = function (t, e) {
              var r = this.options.mtextInheritFont || this.options.merrorInheritFont,
                n = this.getTestElement(t, e),
                o = this.measureMetrics(n, r);
              return this.adaptor.remove(n), o;
            }, e.prototype.getMetricMaps = function (t) {
              var e,
                r,
                n,
                o,
                i,
                a,
                s,
                l,
                c,
                u,
                p = this.adaptor,
                h = [new Map(), new Map()];
              try {
                for (var d = Q(t.math), f = d.next(); !f.done; f = d.next()) {
                  var m = f.value;
                  if ((x = p.parent(m.start.node)) && m.state() < T.STATE.METRICS) {
                    var L = h[m.display ? 1 : 0];
                    L.has(x) || L.set(x, this.getTestElement(x, m.display));
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  f && !f.done && (r = d.return) && r.call(d);
                } finally {
                  if (e) throw e.error;
                }
              }
              var y = this.options.mtextInheritFont || this.options.merrorInheritFont,
                g = [new Map(), new Map()];
              try {
                for (var v = Q(g.keys()), b = v.next(); !b.done; b = v.next()) {
                  var H = b.value;
                  try {
                    for (var _ = (i = void 0, Q(h[H].keys())), M = _.next(); !M.done; M = _.next()) {
                      var x = M.value;
                      g[H].set(x, this.measureMetrics(h[H].get(x), y));
                    }
                  } catch (t) {
                    i = {
                      error: t
                    };
                  } finally {
                    try {
                      M && !M.done && (a = _.return) && a.call(_);
                    } finally {
                      if (i) throw i.error;
                    }
                  }
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  b && !b.done && (o = v.return) && o.call(v);
                } finally {
                  if (n) throw n.error;
                }
              }
              try {
                for (var O = Q(g.keys()), S = O.next(); !S.done; S = O.next()) {
                  H = S.value;
                  try {
                    for (var V = (c = void 0, Q(h[H].values())), E = V.next(); !E.done; E = V.next()) {
                      x = E.value;
                      p.remove(x);
                    }
                  } catch (t) {
                    c = {
                      error: t
                    };
                  } finally {
                    try {
                      E && !E.done && (u = V.return) && u.call(V);
                    } finally {
                      if (c) throw c.error;
                    }
                  }
                }
              } catch (t) {
                s = {
                  error: t
                };
              } finally {
                try {
                  S && !S.done && (l = O.return) && l.call(O);
                } finally {
                  if (s) throw s.error;
                }
              }
              return g;
            }, e.prototype.getTestElement = function (t, e) {
              var r = this.adaptor;
              if (!this.testInline) {
                this.testInline = this.html("mjx-test", {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    "font-style": "normal",
                    "font-weight": "normal",
                    "font-size": "100%",
                    "font-size-adjust": "none",
                    "text-indent": 0,
                    "text-transform": "none",
                    "letter-spacing": "normal",
                    "word-spacing": "normal",
                    overflow: "hidden",
                    height: "1px",
                    "margin-right": "-1px"
                  }
                }, [this.html("mjx-left-box", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    float: "left"
                  }
                }), this.html("mjx-ex-box", {
                  style: {
                    position: "absolute",
                    overflow: "hidden",
                    width: "1px",
                    height: "60ex"
                  }
                }), this.html("mjx-right-box", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    float: "right"
                  }
                })]), this.testDisplay = r.clone(this.testInline), r.setStyle(this.testDisplay, "display", "table"), r.setStyle(this.testDisplay, "margin-right", ""), r.setStyle(r.firstChild(this.testDisplay), "display", "none");
                var n = r.lastChild(this.testDisplay);
                r.setStyle(n, "display", "table-cell"), r.setStyle(n, "width", "10000em"), r.setStyle(n, "float", "");
              }
              return r.append(t, r.clone(e ? this.testDisplay : this.testInline));
            }, e.prototype.measureMetrics = function (t, e) {
              var r = this.adaptor,
                n = e ? r.fontFamily(t) : "",
                o = r.fontSize(t),
                i = a(r.nodeSize(r.childNode(t, 1)), 2),
                Q = i[0],
                s = i[1],
                T = Q ? s / 60 : o * this.options.exFactor;
              return {
                em: o,
                ex: T,
                containerWidth: Q ? "table" === r.getStyle(t, "display") ? r.nodeSize(r.lastChild(t))[0] - 1 : r.nodeBBox(r.lastChild(t)).left - r.nodeBBox(r.firstChild(t)).left - 2 : 1e6,
                lineWidth: 1e6,
                scale: Math.max(this.options.minScale, this.options.matchFontHeight ? T / this.font.params.x_height / o : 1),
                family: n
              };
            }, e.prototype.styleSheet = function (t) {
              var e, r;
              if (this.setDocument(t), this.cssStyles.clear(), this.cssStyles.addStyles(this.constructor.commonStyles), "getStyles" in t) try {
                for (var n = Q(t.getStyles()), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.cssStyles.addStyles(i);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return this.addWrapperStyles(this.cssStyles), this.addFontStyles(this.cssStyles), this.html("style", {
                id: "MJX-styles"
              }, [this.text("\n" + this.cssStyles.cssText + "\n")]);
            }, e.prototype.addFontStyles = function (t) {
              t.addStyles(this.font.styles);
            }, e.prototype.addWrapperStyles = function (t) {
              var e, r;
              try {
                for (var n = Q(this.factory.getKinds()), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.addClassStyles(this.factory.getNodeClass(i), t);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.addClassStyles = function (t, e) {
              e.addStyles(t.styles);
            }, e.prototype.setDocument = function (t) {
              t && (this.document = t, this.adaptor.document = t.document);
            }, e.prototype.html = function (t, e, r, n) {
              return void 0 === e && (e = {}), void 0 === r && (r = []), this.adaptor.node(t, e, r, n);
            }, e.prototype.text = function (t) {
              return this.adaptor.text(t);
            }, e.prototype.fixed = function (t, e) {
              return void 0 === e && (e = 3), Math.abs(t) < 6e-4 ? "0" : t.toFixed(e).replace(/\.?0+$/, "");
            }, e.prototype.measureText = function (t, e, r) {
              void 0 === r && (r = ["", !1, !1]);
              var n = this.unknownText(t, e);
              if ("-explicitFont" === e) {
                var o = this.cssFontStyles(r);
                this.adaptor.setAttributes(n, {
                  style: o
                });
              }
              return this.measureTextNodeWithCache(n, t, e, r);
            }, e.prototype.measureTextNodeWithCache = function (t, e, r, n) {
              void 0 === n && (n = ["", !1, !1]), "-explicitFont" === r && (r = [n[0], n[1] ? "T" : "F", n[2] ? "T" : "F", ""].join("-")), this.unknownCache.has(r) || this.unknownCache.set(r, new Map());
              var o = this.unknownCache.get(r),
                i = o.get(e);
              if (i) return i;
              var a = this.measureTextNode(t);
              return o.set(e, a), a;
            }, e.prototype.measureXMLnode = function (t) {
              var e = this.adaptor,
                r = this.html("mjx-xml-block", {
                  style: {
                    display: "inline-block"
                  }
                }, [e.clone(t)]),
                n = this.html("mjx-baseline", {
                  style: {
                    display: "inline-block",
                    width: 0,
                    height: 0
                  }
                }),
                o = this.html("mjx-measure-xml", {
                  style: {
                    position: "absolute",
                    display: "inline-block",
                    "font-family": "initial",
                    "line-height": "normal"
                  }
                }, [n, r]);
              e.append(e.parent(this.math.start.node), this.container), e.append(this.container, o);
              var i = this.math.metrics.em * this.math.metrics.scale,
                a = e.nodeBBox(r),
                Q = a.left,
                s = a.right,
                T = a.bottom,
                l = a.top,
                c = (s - Q) / i,
                u = (e.nodeBBox(n).top - l) / i,
                p = (T - l) / i - u;
              return e.remove(this.container), e.remove(o), {
                w: c,
                h: u,
                d: p
              };
            }, e.prototype.cssFontStyles = function (t, e) {
              void 0 === e && (e = {});
              var r = a(t, 3),
                n = r[0],
                o = r[1],
                i = r[2];
              return e["font-family"] = this.font.getFamily(n), o && (e["font-style"] = "italic"), i && (e["font-weight"] = "bold"), e;
            }, e.prototype.getFontData = function (t) {
              return t || (t = new u.Styles()), [this.font.getFamily(t.get("font-family")), "italic" === t.get("font-style"), "bold" === t.get("font-weight")];
            }, e.NAME = "Common", e.OPTIONS = i(i({}, s.AbstractOutputJax.OPTIONS), {
              scale: 1,
              minScale: .5,
              mtextInheritFont: !1,
              merrorInheritFont: !1,
              mtextFont: "",
              merrorFont: "serif",
              mathmlSpacing: !1,
              skipAttributes: {},
              exFactor: .5,
              displayAlign: "center",
              displayIndent: "0",
              wrapperFactory: null,
              font: null,
              cssStyles: null
            }), e.commonStyles = {}, e;
          }(s.AbstractOutputJax);
        e.CommonOutputJax = h;
      },
      7519: function _(t, e, r) {
        var _n72,
          o = this && this.__extends || (_n72 = function n(t, e) {
            return _n72 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n72(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n72(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          Q = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          T = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          l = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonWrapper = void 0;
        var c = r(8912),
          u = r(9007),
          p = r(505),
          h = Q(r(6010)),
          d = r(8054),
          f = r(6469),
          m = r(5884),
          L = 2 / 18;
        function y(t, e) {
          return t ? e < L ? 0 : L : e;
        }
        var g = function (t) {
          function e(e, r, n) {
            void 0 === n && (n = null);
            var o = t.call(this, e, r) || this;
            return o.parent = null, o.removedStyles = null, o.styles = null, o.variant = "", o.bboxComputed = !1, o.stretch = m.NOSTRETCH, o.font = null, o.parent = n, o.font = e.jax.font, o.bbox = f.BBox.zero(), o.getStyles(), o.getVariant(), o.getScale(), o.getSpace(), o.childNodes = r.childNodes.map(function (t) {
              var e = o.wrap(t);
              return e.bbox.pwidth && (r.notParent || r.isKind("math")) && (o.bbox.pwidth = f.BBox.fullWidth), e;
            }), o;
          }
          return o(e, t), Object.defineProperty(e.prototype, "jax", {
            get: function get() {
              return this.factory.jax;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "adaptor", {
            get: function get() {
              return this.factory.jax.adaptor;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "metrics", {
            get: function get() {
              return this.factory.jax.math.metrics;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(e.prototype, "fixesPWidth", {
            get: function get() {
              return !this.node.notParent && !this.node.isToken;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.wrap = function (t, e) {
            void 0 === e && (e = null);
            var r = this.factory.wrap(t, e || this);
            return e && e.childNodes.push(r), this.jax.nodeMap.set(t, r), r;
          }, e.prototype.getBBox = function (t) {
            if (void 0 === t && (t = !0), this.bboxComputed) return this.bbox;
            var e = t ? this.bbox : f.BBox.zero();
            return this.computeBBox(e), this.bboxComputed = t, e;
          }, e.prototype.getOuterBBox = function (t) {
            var e, r;
            void 0 === t && (t = !0);
            var n = this.getBBox(t);
            if (!this.styles) return n;
            var o = new f.BBox();
            Object.assign(o, n);
            try {
              for (var i = s(f.BBox.StyleAdjust), a = i.next(); !a.done; a = i.next()) {
                var Q = T(a.value, 2),
                  l = Q[0],
                  c = Q[1],
                  u = this.styles.get(l);
                u && (o[c] += this.length2em(u, 1, o.rscale));
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (r = i.return) && r.call(i);
              } finally {
                if (e) throw e.error;
              }
            }
            return o;
          }, e.prototype.computeBBox = function (t, e) {
            var r, n;
            void 0 === e && (e = !1), t.empty();
            try {
              for (var o = s(this.childNodes), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                t.append(a.getOuterBBox());
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (r) throw r.error;
              }
            }
            t.clean(), this.fixesPWidth && this.setChildPWidths(e) && this.computeBBox(t, !0);
          }, e.prototype.setChildPWidths = function (t, e, r) {
            var n, o;
            if (void 0 === e && (e = null), void 0 === r && (r = !0), t) return !1;
            r && (this.bbox.pwidth = "");
            var i = !1;
            try {
              for (var a = s(this.childNodes), Q = a.next(); !Q.done; Q = a.next()) {
                var T = Q.value,
                  l = T.getOuterBBox();
                l.pwidth && T.setChildPWidths(t, null === e ? l.w : e, r) && (i = !0);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
            return i;
          }, e.prototype.invalidateBBox = function () {
            this.bboxComputed && (this.bboxComputed = !1, this.parent && this.parent.invalidateBBox());
          }, e.prototype.copySkewIC = function (t) {
            var e = this.childNodes[0];
            (null == e ? void 0 : e.bbox.sk) && (t.sk = e.bbox.sk), (null == e ? void 0 : e.bbox.dx) && (t.dx = e.bbox.dx);
            var r = this.childNodes[this.childNodes.length - 1];
            (null == r ? void 0 : r.bbox.ic) && (t.ic = r.bbox.ic, t.w += t.ic);
          }, e.prototype.getStyles = function () {
            var t = this.node.attributes.getExplicit("style");
            if (t) for (var r = this.styles = new d.Styles(t), n = 0, o = e.removeStyles.length; n < o; n++) {
              var i = e.removeStyles[n];
              r.get(i) && (this.removedStyles || (this.removedStyles = {}), this.removedStyles[i] = r.get(i), r.set(i, ""));
            }
          }, e.prototype.getVariant = function () {
            if (this.node.isToken) {
              var t = this.node.attributes,
                r = t.get("mathvariant");
              if (!t.getExplicit("mathvariant")) {
                var n = t.getList("fontfamily", "fontweight", "fontstyle");
                if (this.removedStyles) {
                  var o = this.removedStyles;
                  o.fontFamily && (n.family = o.fontFamily), o.fontWeight && (n.weight = o.fontWeight), o.fontStyle && (n.style = o.fontStyle);
                }
                n.fontfamily && (n.family = n.fontfamily), n.fontweight && (n.weight = n.fontweight), n.fontstyle && (n.style = n.fontstyle), n.weight && n.weight.match(/^\d+$/) && (n.weight = parseInt(n.weight) > 600 ? "bold" : "normal"), n.family ? r = this.explicitVariant(n.family, n.weight, n.style) : (this.node.getProperty("variantForm") && (r = "-tex-variant"), r = (e.BOLDVARIANTS[n.weight] || {})[r] || r, r = (e.ITALICVARIANTS[n.style] || {})[r] || r);
              }
              this.variant = r;
            }
          }, e.prototype.explicitVariant = function (t, e, r) {
            var n = this.styles;
            return n || (n = this.styles = new d.Styles()), n.set("fontFamily", t), e && n.set("fontWeight", e), r && n.set("fontStyle", r), "-explicitFont";
          }, e.prototype.getScale = function () {
            var t = 1,
              e = this.parent,
              r = e ? e.bbox.scale : 1,
              n = this.node.attributes,
              o = Math.min(n.get("scriptlevel"), 2),
              i = n.get("fontsize"),
              a = this.node.isToken || this.node.isKind("mstyle") ? n.get("mathsize") : n.getInherited("mathsize");
            if (0 !== o) {
              t = Math.pow(n.get("scriptsizemultiplier"), o);
              var Q = this.length2em(n.get("scriptminsize"), .8, 1);
              t < Q && (t = Q);
            }
            this.removedStyles && this.removedStyles.fontSize && !i && (i = this.removedStyles.fontSize), i && !n.getExplicit("mathsize") && (a = i), "1" !== a && (t *= this.length2em(a, 1, 1)), this.bbox.scale = t, this.bbox.rscale = t / r;
          }, e.prototype.getSpace = function () {
            var t = this.isTopEmbellished(),
              e = this.node.hasSpacingAttributes();
            this.jax.options.mathmlSpacing || e ? t && this.getMathMLSpacing() : this.getTeXSpacing(t, e);
          }, e.prototype.getMathMLSpacing = function () {
            var t = this.node.coreMO(),
              e = t.coreParent(),
              r = e.parent;
            if (r && r.isKind("mrow") && 1 !== r.childNodes.length) {
              var n = t.attributes,
                o = n.get("scriptlevel") > 0;
              this.bbox.L = n.isSet("lspace") ? Math.max(0, this.length2em(n.get("lspace"))) : y(o, t.lspace), this.bbox.R = n.isSet("rspace") ? Math.max(0, this.length2em(n.get("rspace"))) : y(o, t.rspace);
              var i = r.childIndex(e);
              if (0 !== i) {
                var a = r.childNodes[i - 1];
                if (a.isEmbellished) {
                  var Q = this.jax.nodeMap.get(a).getBBox();
                  Q.R && (this.bbox.L = Math.max(0, this.bbox.L - Q.R));
                }
              }
            }
          }, e.prototype.getTeXSpacing = function (t, e) {
            if (!e) {
              var r = this.node.texSpacing();
              r && (this.bbox.L = this.length2em(r));
            }
            if (t || e) {
              var n = this.node.coreMO().attributes;
              n.isSet("lspace") && (this.bbox.L = Math.max(0, this.length2em(n.get("lspace")))), n.isSet("rspace") && (this.bbox.R = Math.max(0, this.length2em(n.get("rspace"))));
            }
          }, e.prototype.isTopEmbellished = function () {
            return this.node.isEmbellished && !(this.node.parent && this.node.parent.isEmbellished);
          }, e.prototype.core = function () {
            return this.jax.nodeMap.get(this.node.core());
          }, e.prototype.coreMO = function () {
            return this.jax.nodeMap.get(this.node.coreMO());
          }, e.prototype.getText = function () {
            var t,
              e,
              r = "";
            if (this.node.isToken) try {
              for (var n = s(this.node.childNodes), o = n.next(); !o.done; o = n.next()) {
                var i = o.value;
                i instanceof u.TextNode && (r += i.getText());
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                o && !o.done && (e = n.return) && e.call(n);
              } finally {
                if (t) throw t.error;
              }
            }
            return r;
          }, e.prototype.canStretch = function (t) {
            if (this.stretch = m.NOSTRETCH, this.node.isEmbellished) {
              var e = this.core();
              e && e.node !== this.node && e.canStretch(t) && (this.stretch = e.stretch);
            }
            return 0 !== this.stretch.dir;
          }, e.prototype.getAlignShift = function () {
            var t,
              e = (t = this.node.attributes).getList.apply(t, l([], T(u.indentAttributes), !1)),
              r = e.indentalign,
              n = e.indentshift,
              o = e.indentalignfirst,
              i = e.indentshiftfirst;
            return "indentalign" !== o && (r = o), "auto" === r && (r = this.jax.options.displayAlign), "indentshift" !== i && (n = i), "auto" === n && (n = this.jax.options.displayIndent, "right" !== r || n.match(/^\s*0[a-z]*\s*$/) || (n = ("-" + n.trim()).replace(/^--/, ""))), [r, this.length2em(n, this.metrics.containerWidth)];
          }, e.prototype.getAlignX = function (t, e, r) {
            return "right" === r ? t - (e.w + e.R) * e.rscale : "left" === r ? e.L * e.rscale : (t - e.w * e.rscale) / 2;
          }, e.prototype.getAlignY = function (t, e, r, n, o) {
            return "top" === o ? t - r : "bottom" === o ? n - e : "center" === o ? (t - r - (e - n)) / 2 : 0;
          }, e.prototype.getWrapWidth = function (t) {
            return this.childNodes[t].getBBox().w;
          }, e.prototype.getChildAlign = function (t) {
            return "left";
          }, e.prototype.percent = function (t) {
            return h.percent(t);
          }, e.prototype.em = function (t) {
            return h.em(t);
          }, e.prototype.px = function (t, e) {
            return void 0 === e && (e = -h.BIGDIMEN), h.px(t, e, this.metrics.em);
          }, e.prototype.length2em = function (t, e, r) {
            return void 0 === e && (e = 1), void 0 === r && (r = null), null === r && (r = this.bbox.scale), h.length2em(t, e, r, this.jax.pxPerEm);
          }, e.prototype.unicodeChars = function (t, e) {
            void 0 === e && (e = this.variant);
            var r = (0, p.unicodeChars)(t),
              n = this.font.getVariant(e);
            if (n && n.chars) {
              var o = n.chars;
              r = r.map(function (t) {
                return ((o[t] || [])[3] || {}).smp || t;
              });
            }
            return r;
          }, e.prototype.remapChars = function (t) {
            return t;
          }, e.prototype.mmlText = function (t) {
            return this.node.factory.create("text").setText(t);
          }, e.prototype.mmlNode = function (t, e, r) {
            return void 0 === e && (e = {}), void 0 === r && (r = []), this.node.factory.create(t, e, r);
          }, e.prototype.createMo = function (t) {
            var e = this.node.factory,
              r = e.create("text").setText(t),
              n = e.create("mo", {
                stretchy: !0
              }, [r]);
            n.inheritAttributesFrom(this.node);
            var o = this.wrap(n);
            return o.parent = this, o;
          }, e.prototype.getVariantChar = function (t, e) {
            var r = this.font.getChar(t, e) || [0, 0, 0, {
              unknown: !0
            }];
            return 3 === r.length && (r[3] = {}), r;
          }, e.kind = "unknown", e.styles = {}, e.removeStyles = ["fontSize", "fontFamily", "fontWeight", "fontStyle", "fontVariant", "font"], e.skipAttributes = {
            fontfamily: !0,
            fontsize: !0,
            fontweight: !0,
            fontstyle: !0,
            color: !0,
            background: !0,
            class: !0,
            href: !0,
            style: !0,
            xmlns: !0
          }, e.BOLDVARIANTS = {
            bold: {
              normal: "bold",
              italic: "bold-italic",
              fraktur: "bold-fraktur",
              script: "bold-script",
              "sans-serif": "bold-sans-serif",
              "sans-serif-italic": "sans-serif-bold-italic"
            },
            normal: {
              bold: "normal",
              "bold-italic": "italic",
              "bold-fraktur": "fraktur",
              "bold-script": "script",
              "bold-sans-serif": "sans-serif",
              "sans-serif-bold-italic": "sans-serif-italic"
            }
          }, e.ITALICVARIANTS = {
            italic: {
              normal: "italic",
              bold: "bold-italic",
              "sans-serif": "sans-serif-italic",
              "bold-sans-serif": "sans-serif-bold-italic"
            },
            normal: {
              italic: "normal",
              "bold-italic": "bold",
              "sans-serif-italic": "sans-serif",
              "sans-serif-bold-italic": "bold-sans-serif"
            }
          }, e;
        }(c.AbstractWrapper);
        e.CommonWrapper = g;
      },
      4420: function _(t, e, r) {
        var _n73,
          o = this && this.__extends || (_n73 = function n(t, e) {
            return _n73 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n73(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n73(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonWrapperFactory = void 0;
        var i = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.jax = null, e;
          }
          return o(e, t), Object.defineProperty(e.prototype, "Wrappers", {
            get: function get() {
              return this.node;
            },
            enumerable: !1,
            configurable: !0
          }), e.defaultNodes = {}, e;
        }(r(3811).AbstractWrapperFactory);
        e.CommonWrapperFactory = i;
      },
      9800: function _(t, e, r) {
        var _n74,
          o = this && this.__extends || (_n74 = function n(t, e) {
            return _n74 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n74(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n74(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTeXAtomMixin = void 0;
        var i = r(9007);
        e.CommonTeXAtomMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.computeBBox = function (e, r) {
              if (void 0 === r && (r = !1), t.prototype.computeBBox.call(this, e, r), this.childNodes[0] && this.childNodes[0].bbox.ic && (e.ic = this.childNodes[0].bbox.ic), this.node.texClass === i.TEXCLASS.VCENTER) {
                var n = e.h,
                  o = (n + e.d) / 2 + this.font.params.axis_height - n;
                e.h += o, e.d -= o;
              }
            }, e;
          }(t);
        };
      },
      1160: function _(t, e) {
        var _r3,
          n = this && this.__extends || (_r3 = function r(t, e) {
            return _r3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r3(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r3(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTextNodeMixin = void 0, e.CommonTextNodeMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              var r, n;
              void 0 === e && (e = !1);
              var a = this.parent.variant,
                Q = this.node.getText();
              if ("-explicitFont" === a) {
                var s = this.jax.getFontData(this.parent.styles),
                  T = this.jax.measureText(Q, a, s),
                  l = T.w,
                  c = T.h,
                  u = T.d;
                t.h = c, t.d = u, t.w = l;
              } else {
                var p = this.remappedText(Q, a);
                t.empty();
                try {
                  for (var h = o(p), d = h.next(); !d.done; d = h.next()) {
                    var f = d.value,
                      m = i(this.getVariantChar(a, f), 4),
                      L = (c = m[0], u = m[1], l = m[2], m[3]);
                    if (L.unknown) {
                      var y = this.jax.measureText(String.fromCodePoint(f), a);
                      l = y.w, c = y.h, u = y.d;
                    }
                    t.w += l, c > t.h && (t.h = c), u > t.d && (t.d = u), t.ic = L.ic || 0, t.sk = L.sk || 0, t.dx = L.dx || 0;
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    d && !d.done && (n = h.return) && n.call(h);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                p.length > 1 && (t.sk = 0), t.clean();
              }
            }, e.prototype.remappedText = function (t, e) {
              var r = this.parent.stretch.c;
              return r ? [r] : this.parent.remapChars(this.unicodeChars(t, e));
            }, e.prototype.getStyles = function () {}, e.prototype.getVariant = function () {}, e.prototype.getScale = function () {}, e.prototype.getSpace = function () {}, e;
          }(t);
        };
      },
      1956: function _(t, e, r) {
        var _n75,
          o = this && this.__extends || (_n75 = function n(t, e) {
            return _n75 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n75(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n75(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMactionMixin = e.TooltipData = void 0;
        var Q = r(505);
        e.TooltipData = {
          dx: ".2em",
          dy: ".1em",
          postDelay: 600,
          clearDelay: 100,
          hoverTimer: new Map(),
          clearTimer: new Map(),
          stopTimers: function stopTimers(t, e) {
            e.clearTimer.has(t) && (clearTimeout(e.clearTimer.get(t)), e.clearTimer.delete(t)), e.hoverTimer.has(t) && (clearTimeout(e.hoverTimer.get(t)), e.hoverTimer.delete(t));
          }
        }, e.CommonMactionMixin = function (t) {
          return function (t) {
            function r() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this,
                o = n.constructor.actions,
                Q = n.node.attributes.get("actiontype"),
                s = i(o.get(Q) || [function (t, e) {}, {}], 2),
                T = s[0],
                l = s[1];
              return n.action = T, n.data = l, n.getParameters(), n;
            }
            return o(r, t), Object.defineProperty(r.prototype, "selected", {
              get: function get() {
                var t = this.node.attributes.get("selection"),
                  e = Math.max(1, Math.min(this.childNodes.length, t)) - 1;
                return this.childNodes[e] || this.wrap(this.node.selected);
              },
              enumerable: !1,
              configurable: !0
            }), r.prototype.getParameters = function () {
              var t = this.node.attributes.get("data-offsets"),
                r = i((0, Q.split)(t || ""), 2),
                n = r[0],
                o = r[1];
              this.dx = this.length2em(n || e.TooltipData.dx), this.dy = this.length2em(o || e.TooltipData.dy);
            }, r.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.updateFrom(this.selected.getOuterBBox()), this.selected.setChildPWidths(e);
            }, r;
          }(t);
        };
      },
      7490: function _(t, e) {
        var _r4,
          n = this && this.__extends || (_r4 = function r(t, e) {
            return _r4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r4(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r4(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMathMixin = void 0, e.CommonMathMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getWrapWidth = function (t) {
              return this.parent ? this.getBBox().w : this.metrics.containerWidth / this.jax.pxPerEm;
            }, e;
          }(t);
        };
      },
      7313: function _(t, e, r) {
        var _n76,
          o = this && this.__extends || (_n76 = function n(t, e) {
            return _n76 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n76(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n76(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          Q = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          s = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          T = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          l = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMencloseMixin = void 0;
        var c = Q(r(5552)),
          u = r(505);
        e.CommonMencloseMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, T([], s(e), !1)) || this;
              return n.notations = {}, n.renderChild = null, n.msqrt = null, n.padding = c.PADDING, n.thickness = c.THICKNESS, n.arrowhead = {
                x: c.ARROWX,
                y: c.ARROWY,
                dx: c.ARROWDX
              }, n.TRBL = [0, 0, 0, 0], n.getParameters(), n.getNotations(), n.removeRedundantNotations(), n.initializeNotations(), n.TRBL = n.getBBoxExtenders(), n;
            }
            return o(e, t), e.prototype.getParameters = function () {
              var t = this.node.attributes,
                e = t.get("data-padding");
              void 0 !== e && (this.padding = this.length2em(e, c.PADDING));
              var r = t.get("data-thickness");
              void 0 !== r && (this.thickness = this.length2em(r, c.THICKNESS));
              var n = t.get("data-arrowhead");
              if (void 0 !== n) {
                var o = s((0, u.split)(n), 3),
                  i = o[0],
                  a = o[1],
                  Q = o[2];
                this.arrowhead = {
                  x: i ? parseFloat(i) : c.ARROWX,
                  y: a ? parseFloat(a) : c.ARROWY,
                  dx: Q ? parseFloat(Q) : c.ARROWDX
                };
              }
            }, e.prototype.getNotations = function () {
              var t,
                e,
                r = this.constructor.notations;
              try {
                for (var n = l((0, u.split)(this.node.attributes.get("notation"))), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value,
                    a = r.get(i);
                  a && (this.notations[i] = a, a.renderChild && (this.renderChild = a.renderer));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.removeRedundantNotations = function () {
              var t, e, r, n;
              try {
                for (var o = l(Object.keys(this.notations)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value;
                  if (this.notations[a]) {
                    var Q = this.notations[a].remove || "";
                    try {
                      for (var s = (r = void 0, l(Q.split(/ /))), T = s.next(); !T.done; T = s.next()) {
                        var c = T.value;
                        delete this.notations[c];
                      }
                    } catch (t) {
                      r = {
                        error: t
                      };
                    } finally {
                      try {
                        T && !T.done && (n = s.return) && n.call(s);
                      } finally {
                        if (r) throw r.error;
                      }
                    }
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.initializeNotations = function () {
              var t, e;
              try {
                for (var r = l(Object.keys(this.notations)), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value,
                    i = this.notations[o].init;
                  i && i(this);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = s(this.TRBL, 4),
                n = r[0],
                o = r[1],
                i = r[2],
                a = r[3],
                Q = this.childNodes[0].getBBox();
              t.combine(Q, a, 0), t.h += n, t.d += i, t.w += o, this.setChildPWidths(e);
            }, e.prototype.getBBoxExtenders = function () {
              var t,
                e,
                r = [0, 0, 0, 0];
              try {
                for (var n = l(Object.keys(this.notations)), o = n.next(); !o.done; o = n.next()) {
                  var i = o.value;
                  this.maximizeEntries(r, this.notations[i].bbox(this));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
              return r;
            }, e.prototype.getPadding = function () {
              var t,
                e,
                r = this,
                n = [0, 0, 0, 0];
              try {
                for (var o = l(Object.keys(this.notations)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    Q = this.notations[a].border;
                  Q && this.maximizeEntries(n, Q(this));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return [0, 1, 2, 3].map(function (t) {
                return r.TRBL[t] - n[t];
              });
            }, e.prototype.maximizeEntries = function (t, e) {
              for (var r = 0; r < t.length; r++) t[r] < e[r] && (t[r] = e[r]);
            }, e.prototype.getOffset = function (t) {
              var e = s(this.TRBL, 4),
                r = e[0],
                n = e[1],
                o = e[2],
                i = e[3],
                a = ("X" === t ? n - i : o - r) / 2;
              return Math.abs(a) > .001 ? a : 0;
            }, e.prototype.getArgMod = function (t, e) {
              return [Math.atan2(e, t), Math.sqrt(t * t + e * e)];
            }, e.prototype.arrow = function (t, e, r, n, o) {
              return void 0 === n && (n = ""), void 0 === o && (o = 0), null;
            }, e.prototype.arrowData = function () {
              var t = s([this.padding, this.thickness], 2),
                e = t[0],
                r = t[1] * (this.arrowhead.x + Math.max(1, this.arrowhead.dx)),
                n = this.childNodes[0].getBBox(),
                o = n.h,
                i = n.d,
                a = n.w,
                Q = o + i,
                T = Math.sqrt(Q * Q + a * a),
                l = Math.max(e, r * a / T),
                c = Math.max(e, r * Q / T),
                u = s(this.getArgMod(a + 2 * l, Q + 2 * c), 2);
              return {
                a: u[0],
                W: u[1],
                x: l,
                y: c
              };
            }, e.prototype.arrowAW = function () {
              var t = this.childNodes[0].getBBox(),
                e = t.h,
                r = t.d,
                n = t.w,
                o = s(this.TRBL, 4),
                i = o[0],
                a = o[1],
                Q = o[2],
                T = o[3];
              return this.getArgMod(T + n + a, i + e + r + Q);
            }, e.prototype.createMsqrt = function (t) {
              var e = this.node.factory.create("msqrt");
              e.inheritAttributesFrom(this.node), e.childNodes[0] = t.node;
              var r = this.wrap(e);
              return r.parent = this, r;
            }, e.prototype.sqrtTRBL = function () {
              var t = this.msqrt.getBBox(),
                e = this.msqrt.childNodes[0].getBBox();
              return [t.h - e.h, 0, t.d - e.d, t.w - e.w];
            }, e;
          }(t);
        };
      },
      7555: function _(t, e) {
        var _r5,
          n = this && this.__extends || (_r5 = function r(t, e) {
            return _r5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r5(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r5(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMfencedMixin = void 0, e.CommonMfencedMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.mrow = null, n.createMrow(), n.addMrowChildren(), n;
            }
            return n(e, t), e.prototype.createMrow = function () {
              var t = this.node.factory.create("inferredMrow");
              t.inheritAttributesFrom(this.node), this.mrow = this.wrap(t), this.mrow.parent = this;
            }, e.prototype.addMrowChildren = function () {
              var t,
                e,
                r = this.node,
                n = this.mrow;
              this.addMo(r.open), this.childNodes.length && n.childNodes.push(this.childNodes[0]);
              var o = 0;
              try {
                for (var i = a(this.childNodes.slice(1)), Q = i.next(); !Q.done; Q = i.next()) {
                  var s = Q.value;
                  this.addMo(r.separators[o++]), n.childNodes.push(s);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  Q && !Q.done && (e = i.return) && e.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
              this.addMo(r.close), n.stretchChildren();
            }, e.prototype.addMo = function (t) {
              if (t) {
                var e = this.wrap(t);
                this.mrow.childNodes.push(e), e.parent = this.mrow;
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.updateFrom(this.mrow.getOuterBBox()), this.setChildPWidths(e);
            }, e;
          }(t);
        };
      },
      2688: function _(t, e) {
        var _r6,
          n = this && this.__extends || (_r6 = function r(t, e) {
            return _r6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r6(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r6(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMfracMixin = void 0, e.CommonMfracMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              if (n.bevel = null, n.pad = n.node.getProperty("withDelims") ? 0 : n.font.params.nulldelimiterspace, n.node.attributes.get("bevelled")) {
                var a = n.getBevelData(n.isDisplay()).H,
                  Q = n.bevel = n.createMo("/");
                Q.node.attributes.set("symmetric", !0), Q.canStretch(1), Q.getStretchedVariant([a], !0);
              }
              return n;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), t.empty();
              var r = this.node.attributes.getList("linethickness", "bevelled"),
                n = r.linethickness,
                o = r.bevelled,
                i = this.isDisplay(),
                a = null;
              if (o) this.getBevelledBBox(t, i);else {
                var Q = this.length2em(String(n), .06);
                a = -2 * this.pad, 0 === Q ? this.getAtopBBox(t, i) : (this.getFractionBBox(t, i, Q), a -= .2), a += t.w;
              }
              t.clean(), this.setChildPWidths(e, a);
            }, e.prototype.getFractionBBox = function (t, e, r) {
              var n = this.childNodes[0].getOuterBBox(),
                o = this.childNodes[1].getOuterBBox(),
                i = this.font.params.axis_height,
                a = this.getTUV(e, r),
                Q = a.T,
                s = a.u,
                T = a.v;
              t.combine(n, 0, i + Q + Math.max(n.d * n.rscale, s)), t.combine(o, 0, i - Q - Math.max(o.h * o.rscale, T)), t.w += 2 * this.pad + .2;
            }, e.prototype.getTUV = function (t, e) {
              var r = this.font.params,
                n = r.axis_height,
                o = (t ? 3.5 : 1.5) * e;
              return {
                T: (t ? 3.5 : 1.5) * e,
                u: (t ? r.num1 : r.num2) - n - o,
                v: (t ? r.denom1 : r.denom2) + n - o
              };
            }, e.prototype.getAtopBBox = function (t, e) {
              var r = this.getUVQ(e),
                n = r.u,
                o = r.v,
                i = r.nbox,
                a = r.dbox;
              t.combine(i, 0, n), t.combine(a, 0, -o), t.w += 2 * this.pad;
            }, e.prototype.getUVQ = function (t) {
              var e = this.childNodes[0].getOuterBBox(),
                r = this.childNodes[1].getOuterBBox(),
                n = this.font.params,
                i = o(t ? [n.num1, n.denom1] : [n.num3, n.denom2], 2),
                a = i[0],
                Q = i[1],
                s = (t ? 7 : 3) * n.rule_thickness,
                T = a - e.d * e.scale - (r.h * r.scale - Q);
              return T < s && (a += (s - T) / 2, Q += (s - T) / 2, T = s), {
                u: a,
                v: Q,
                q: T,
                nbox: e,
                dbox: r
              };
            }, e.prototype.getBevelledBBox = function (t, e) {
              var r = this.getBevelData(e),
                n = r.u,
                o = r.v,
                i = r.delta,
                a = r.nbox,
                Q = r.dbox,
                s = this.bevel.getOuterBBox();
              t.combine(a, 0, n), t.combine(s, t.w - i / 2, 0), t.combine(Q, t.w - i / 2, o);
            }, e.prototype.getBevelData = function (t) {
              var e = this.childNodes[0].getOuterBBox(),
                r = this.childNodes[1].getOuterBBox(),
                n = t ? .4 : .15,
                o = Math.max(e.scale * (e.h + e.d), r.scale * (r.h + r.d)) + 2 * n,
                i = this.font.params.axis_height;
              return {
                H: o,
                delta: n,
                u: e.scale * (e.d - e.h) / 2 + i + n,
                v: r.scale * (r.d - r.h) / 2 + i - n,
                nbox: e,
                dbox: r
              };
            }, e.prototype.canStretch = function (t) {
              return !1;
            }, e.prototype.isDisplay = function () {
              var t = this.node.attributes.getList("displaystyle", "scriptlevel"),
                e = t.displaystyle,
                r = t.scriptlevel;
              return e && 0 === r;
            }, e.prototype.getWrapWidth = function (t) {
              var e = this.node.attributes;
              return e.get("bevelled") ? this.childNodes[t].getOuterBBox().w : this.getBBox().w - (this.length2em(e.get("linethickness")) ? .2 : 0) - 2 * this.pad;
            }, e.prototype.getChildAlign = function (t) {
              var e = this.node.attributes;
              return e.get("bevelled") ? "left" : e.get(["numalign", "denomalign"][t]);
            }, e;
          }(t);
        };
      },
      5636: function _(t, e) {
        var _r7,
          n = this && this.__extends || (_r7 = function r(t, e) {
            return _r7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r7(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r7(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMglyphMixin = void 0, e.CommonMglyphMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.getParameters(), n;
            }
            return n(e, t), e.prototype.getParameters = function () {
              var t = this.node.attributes.getList("width", "height", "valign", "src", "index"),
                e = t.width,
                r = t.height,
                n = t.valign,
                o = t.src,
                i = t.index;
              if (o) this.width = "auto" === e ? 1 : this.length2em(e), this.height = "auto" === r ? 1 : this.length2em(r), this.valign = this.length2em(n || "0");else {
                var a = String.fromCodePoint(parseInt(i)),
                  Q = this.node.factory;
                this.charWrapper = this.wrap(Q.create("text").setText(a)), this.charWrapper.parent = this;
              }
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1), this.charWrapper ? t.updateFrom(this.charWrapper.getBBox()) : (t.w = this.width, t.h = this.height + this.valign, t.d = -this.valign);
            }, e;
          }(t);
        };
      },
      5723: function _(t, e) {
        var _r8,
          n = this && this.__extends || (_r8 = function r(t, e) {
            return _r8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r8(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r8(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMiMixin = void 0, e.CommonMiMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (e, r) {
              void 0 === r && (r = !1), t.prototype.computeBBox.call(this, e), this.copySkewIC(e);
            }, e;
          }(t);
        };
      },
      8009: function _(t, e, r) {
        var _n77,
          o = this && this.__extends || (_n77 = function n(t, e) {
            return _n77 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n77(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n77(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMmultiscriptsMixin = e.ScriptNames = e.NextScript = void 0;
        var s = r(6469);
        e.NextScript = {
          base: "subList",
          subList: "supList",
          supList: "subList",
          psubList: "psupList",
          psupList: "psubList"
        }, e.ScriptNames = ["sup", "sup", "psup", "psub"], e.CommonMmultiscriptsMixin = function (t) {
          return function (t) {
            function r() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              return n.scriptData = null, n.firstPrescript = 0, n.getScriptData(), n;
            }
            return o(r, t), r.prototype.combinePrePost = function (t, e) {
              var r = new s.BBox(t);
              return r.combine(e, 0, 0), r;
            }, r.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.font.params.scriptspace,
                n = this.scriptData,
                o = this.combinePrePost(n.sub, n.psub),
                a = this.combinePrePost(n.sup, n.psup),
                Q = i(this.getUVQ(o, a), 2),
                s = Q[0],
                T = Q[1];
              if (t.empty(), n.numPrescripts && (t.combine(n.psup, r, s), t.combine(n.psub, r, T)), t.append(n.base), n.numScripts) {
                var l = t.w;
                t.combine(n.sup, l, s), t.combine(n.sub, l, T), t.w += r;
              }
              t.clean(), this.setChildPWidths(e);
            }, r.prototype.getScriptData = function () {
              var t = this.scriptData = {
                  base: null,
                  sub: s.BBox.empty(),
                  sup: s.BBox.empty(),
                  psub: s.BBox.empty(),
                  psup: s.BBox.empty(),
                  numPrescripts: 0,
                  numScripts: 0
                },
                e = this.getScriptBBoxLists();
              this.combineBBoxLists(t.sub, t.sup, e.subList, e.supList), this.combineBBoxLists(t.psub, t.psup, e.psubList, e.psupList), t.base = e.base[0], t.numPrescripts = e.psubList.length, t.numScripts = e.subList.length;
            }, r.prototype.getScriptBBoxLists = function () {
              var t,
                r,
                n = {
                  base: [],
                  subList: [],
                  supList: [],
                  psubList: [],
                  psupList: []
                },
                o = "base";
              try {
                for (var i = Q(this.childNodes), a = i.next(); !a.done; a = i.next()) {
                  var s = a.value;
                  s.node.isKind("mprescripts") ? o = "psubList" : (n[o].push(s.getOuterBBox()), o = e.NextScript[o]);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (t) throw t.error;
                }
              }
              return this.firstPrescript = n.subList.length + n.supList.length + 2, this.padLists(n.subList, n.supList), this.padLists(n.psubList, n.psupList), n;
            }, r.prototype.padLists = function (t, e) {
              t.length > e.length && e.push(s.BBox.empty());
            }, r.prototype.combineBBoxLists = function (t, e, r, n) {
              for (var o = 0; o < r.length; o++) {
                var a = i(this.getScaledWHD(r[o]), 3),
                  Q = a[0],
                  s = a[1],
                  T = a[2],
                  l = i(this.getScaledWHD(n[o]), 3),
                  c = l[0],
                  u = l[1],
                  p = l[2],
                  h = Math.max(Q, c);
                t.w += h, e.w += h, s > t.h && (t.h = s), T > t.d && (t.d = T), u > e.h && (e.h = u), p > e.d && (e.d = p);
              }
            }, r.prototype.getScaledWHD = function (t) {
              var e = t.w,
                r = t.h,
                n = t.d,
                o = t.rscale;
              return [e * o, r * o, n * o];
            }, r.prototype.getUVQ = function (e, r) {
              var n;
              if (!this.UVQ) {
                var o = i([0, 0, 0], 3),
                  a = o[0],
                  Q = o[1],
                  s = o[2];
                0 === e.h && 0 === e.d ? a = this.getU() : 0 === r.h && 0 === r.d ? a = -this.getV() : (a = (n = i(t.prototype.getUVQ.call(this, e, r), 3))[0], Q = n[1], s = n[2]), this.UVQ = [a, Q, s];
              }
              return this.UVQ;
            }, r;
          }(t);
        };
      },
      5023: function _(t, e) {
        var _r9,
          n = this && this.__extends || (_r9 = function r(t, e) {
            return _r9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r9(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r9(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMnMixin = void 0, e.CommonMnMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.remapChars = function (t) {
              if (t.length) {
                var e = this.font.getRemappedChar("mn", t[0]);
                if (e) {
                  var r = this.unicodeChars(e, this.variant);
                  1 === r.length ? t[0] = r[0] : t = r.concat(t.slice(1));
                }
              }
              return t;
            }, e;
          }(t);
        };
      },
      7096: function _(t, e, r) {
        var _n78,
          o,
          i = this && this.__extends || (_n78 = function n(t, e) {
            return _n78 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n78(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n78(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          a = this && this.__assign || function () {
            return a = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, a.apply(this, arguments);
          },
          Q = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          s = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          T = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMoMixin = e.DirectionVH = void 0;
        var l = r(6469),
          c = r(505),
          u = r(5884);
        e.DirectionVH = ((o = {})[1] = "v", o[2] = "h", o), e.CommonMoMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, s([], Q(e), !1)) || this;
              return n.size = null, n.isAccent = n.node.isAccent, n;
            }
            return i(e, t), e.prototype.computeBBox = function (t, e) {
              if (void 0 === e && (e = !1), this.protoBBox(t), this.node.attributes.get("symmetric") && 2 !== this.stretch.dir) {
                var r = this.getCenterOffset(t);
                t.h += r, t.d -= r;
              }
              this.node.getProperty("mathaccent") && (0 === this.stretch.dir || this.size >= 0) && (t.w = 0);
            }, e.prototype.protoBBox = function (e) {
              var r = 0 !== this.stretch.dir;
              r && null === this.size && this.getStretchedVariant([0]), r && this.size < 0 || (t.prototype.computeBBox.call(this, e), this.copySkewIC(e));
            }, e.prototype.getAccentOffset = function () {
              var t = l.BBox.empty();
              return this.protoBBox(t), -t.w / 2;
            }, e.prototype.getCenterOffset = function (e) {
              return void 0 === e && (e = null), e || (e = l.BBox.empty(), t.prototype.computeBBox.call(this, e)), (e.h + e.d) / 2 + this.font.params.axis_height - e.h;
            }, e.prototype.getVariant = function () {
              this.node.attributes.get("largeop") ? this.variant = this.node.attributes.get("displaystyle") ? "-largeop" : "-smallop" : this.node.attributes.getExplicit("mathvariant") || !1 !== this.node.getProperty("pseudoscript") ? t.prototype.getVariant.call(this) : this.variant = "-tex-variant";
            }, e.prototype.canStretch = function (t) {
              if (0 !== this.stretch.dir) return this.stretch.dir === t;
              if (!this.node.attributes.get("stretchy")) return !1;
              var e = this.getText();
              if (1 !== Array.from(e).length) return !1;
              var r = this.font.getDelimiter(e.codePointAt(0));
              return this.stretch = r && r.dir === t ? r : u.NOSTRETCH, 0 !== this.stretch.dir;
            }, e.prototype.getStretchedVariant = function (t, e) {
              var r, n;
              if (void 0 === e && (e = !1), 0 !== this.stretch.dir) {
                var o = this.getWH(t),
                  i = this.getSize("minsize", 0),
                  Q = this.getSize("maxsize", 1 / 0),
                  s = this.node.getProperty("mathaccent");
                o = Math.max(i, Math.min(Q, o));
                var l = this.font.params.delimiterfactor / 1e3,
                  c = this.font.params.delimitershortfall,
                  u = i || e ? o : s ? Math.min(o / l, o + c) : Math.max(o * l, o - c),
                  p = this.stretch,
                  h = p.c || this.getText().codePointAt(0),
                  d = 0;
                if (p.sizes) try {
                  for (var f = T(p.sizes), m = f.next(); !m.done; m = f.next()) {
                    if (m.value >= u) return s && d && d--, this.variant = this.font.getSizeVariant(h, d), this.size = d, void (p.schar && p.schar[d] && (this.stretch = a(a({}, this.stretch), {
                      c: p.schar[d]
                    })));
                    d++;
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    m && !m.done && (n = f.return) && n.call(f);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                p.stretch ? (this.size = -1, this.invalidateBBox(), this.getStretchBBox(t, this.checkExtendedHeight(o, p), p)) : (this.variant = this.font.getSizeVariant(h, d - 1), this.size = d - 1);
              }
            }, e.prototype.getSize = function (t, e) {
              var r = this.node.attributes;
              return r.isSet(t) && (e = this.length2em(r.get(t), 1, 1)), e;
            }, e.prototype.getWH = function (t) {
              if (0 === t.length) return 0;
              if (1 === t.length) return t[0];
              var e = Q(t, 2),
                r = e[0],
                n = e[1],
                o = this.font.params.axis_height;
              return this.node.attributes.get("symmetric") ? 2 * Math.max(r - o, n + o) : r + n;
            }, e.prototype.getStretchBBox = function (t, e, r) {
              var n;
              r.hasOwnProperty("min") && r.min > e && (e = r.min);
              var o = Q(r.HDW, 3),
                i = o[0],
                a = o[1],
                s = o[2];
              1 === this.stretch.dir ? (i = (n = Q(this.getBaseline(t, e, r), 2))[0], a = n[1]) : s = e, this.bbox.h = i, this.bbox.d = a, this.bbox.w = s;
            }, e.prototype.getBaseline = function (t, e, r) {
              var n = 2 === t.length && t[0] + t[1] === e,
                o = this.node.attributes.get("symmetric"),
                i = Q(n ? t : [e, 0], 2),
                a = i[0],
                s = i[1],
                T = Q([a + s, 0], 2),
                l = T[0],
                c = T[1];
              if (o) {
                var u = this.font.params.axis_height;
                n && (l = 2 * Math.max(a - u, s + u)), c = l / 2 - u;
              } else if (n) c = s;else {
                var p = Q(r.HDW || [.75, .25], 2),
                  h = p[0],
                  d = p[1];
                c = d * (l / (h + d));
              }
              return [l - c, c];
            }, e.prototype.checkExtendedHeight = function (t, e) {
              if (e.fullExt) {
                var r = Q(e.fullExt, 2),
                  n = r[0],
                  o = r[1];
                t = o + Math.ceil(Math.max(0, t - o) / n) * n;
              }
              return t;
            }, e.prototype.remapChars = function (t) {
              var e = this.node.getProperty("primes");
              if (e) return (0, c.unicodeChars)(e);
              if (1 === t.length) {
                var r = this.node.coreParent().parent,
                  n = this.isAccent && !r.isKind("mrow") ? "accent" : "mo",
                  o = this.font.getRemappedChar(n, t[0]);
                o && (t = this.unicodeChars(o, this.variant));
              }
              return t;
            }, e;
          }(t);
        };
      },
      6898: function _(t, e) {
        var _r10,
          n = this && this.__extends || (_r10 = function r(t, e) {
            return _r10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r10(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r10(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMpaddedMixin = void 0, e.CommonMpaddedMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getDimens = function () {
              var t = this.node.attributes.getList("width", "height", "depth", "lspace", "voffset"),
                e = this.childNodes[0].getBBox(),
                r = e.w,
                n = e.h,
                o = e.d,
                i = r,
                a = n,
                Q = o,
                s = 0,
                T = 0,
                l = 0;
              "" !== t.width && (r = this.dimen(t.width, e, "w", 0)), "" !== t.height && (n = this.dimen(t.height, e, "h", 0)), "" !== t.depth && (o = this.dimen(t.depth, e, "d", 0)), "" !== t.voffset && (T = this.dimen(t.voffset, e)), "" !== t.lspace && (s = this.dimen(t.lspace, e));
              var c = this.node.attributes.get("data-align");
              return c && (l = this.getAlignX(r, e, c)), [a, Q, i, n - a, o - Q, r - i, s, T, l];
            }, e.prototype.dimen = function (t, e, r, n) {
              void 0 === r && (r = ""), void 0 === n && (n = null);
              var o = (t = String(t)).match(/width|height|depth/),
                i = o ? e[o[0].charAt(0)] : r ? e[r] : 0,
                a = this.length2em(t, i) || 0;
              return t.match(/^[-+]/) && r && (a += i), null != n && (a = Math.max(n, a)), a;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = o(this.getDimens(), 6),
                n = r[0],
                i = r[1],
                a = r[2],
                Q = r[3],
                s = r[4],
                T = r[5];
              t.w = a + T, t.h = n + Q, t.d = i + s, this.setChildPWidths(e, t.w);
            }, e.prototype.getWrapWidth = function (t) {
              return this.getBBox().w;
            }, e.prototype.getChildAlign = function (t) {
              return this.node.attributes.get("data-align") || "left";
            }, e;
          }(t);
        };
      },
      9086: function _(t, e) {
        var _r11,
          n = this && this.__extends || (_r11 = function r(t, e) {
            return _r11 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r11(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r11(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMrootMixin = void 0, e.CommonMrootMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "surd", {
              get: function get() {
                return 2;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "root", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.combineRootBBox = function (t, e, r) {
              var n = this.childNodes[this.root].getOuterBBox(),
                o = this.getRootDimens(e, r)[1];
              t.combine(n, 0, o);
            }, e.prototype.getRootDimens = function (t, e) {
              var r = this.childNodes[this.surd],
                n = this.childNodes[this.root].getOuterBBox(),
                o = (r.size < 0 ? .5 : .6) * t.w,
                i = n.w,
                a = n.rscale,
                Q = Math.max(i, o / a),
                s = Math.max(0, Q - i);
              return [Q * a - o, this.rootHeight(n, t, r.size, e), s];
            }, e.prototype.rootHeight = function (t, e, r, n) {
              var o = e.h + e.d;
              return (r < 0 ? 1.9 : .55 * o) - (o - n) + Math.max(0, t.d * t.rscale);
            }, e;
          }(t);
        };
      },
      8411: function _(t, e, r) {
        var _n79,
          o = this && this.__extends || (_n79 = function n(t, e) {
            return _n79 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n79(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n79(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonInferredMrowMixin = e.CommonMrowMixin = void 0;
        var s = r(6469);
        e.CommonMrowMixin = function (t) {
          return function (t) {
            function e() {
              for (var e, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
              var T = t.apply(this, a([], i(n), !1)) || this;
              T.stretchChildren();
              try {
                for (var l = Q(T.childNodes), c = l.next(); !c.done; c = l.next()) {
                  var u = c.value;
                  if (u.bbox.pwidth) {
                    T.bbox.pwidth = s.BBox.fullWidth;
                    break;
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (r = l.return) && r.call(l);
                } finally {
                  if (e) throw e.error;
                }
              }
              return T;
            }
            return o(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.stretchChildren = function () {
              var t,
                e,
                r,
                n,
                o,
                i,
                a = [];
              try {
                for (var s = Q(this.childNodes), T = s.next(); !T.done; T = s.next()) {
                  (_ = T.value).canStretch(1) && a.push(_);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  T && !T.done && (e = s.return) && e.call(s);
                } finally {
                  if (t) throw t.error;
                }
              }
              var l = a.length,
                c = this.childNodes.length;
              if (l && c > 1) {
                var u = 0,
                  p = 0,
                  h = l > 1 && l === c;
                try {
                  for (var d = Q(this.childNodes), f = d.next(); !f.done; f = d.next()) {
                    var m = 0 === (_ = f.value).stretch.dir;
                    if (h || m) {
                      var L = _.getOuterBBox(m),
                        y = L.h,
                        g = L.d,
                        v = L.rscale;
                      (y *= v) > u && (u = y), (g *= v) > p && (p = g);
                    }
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    f && !f.done && (n = d.return) && n.call(d);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                try {
                  for (var b = Q(a), H = b.next(); !H.done; H = b.next()) {
                    var _;
                    (_ = H.value).coreMO().getStretchedVariant([u, p]);
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    H && !H.done && (i = b.return) && i.call(b);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
            }, e;
          }(t);
        }, e.CommonInferredMrowMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.getScale = function () {
              this.bbox.scale = this.parent.bbox.scale, this.bbox.rscale = 1;
            }, e;
          }(t);
        };
      },
      4126: function _(t, e) {
        var _r12,
          n = this && this.__extends || (_r12 = function r(t, e) {
            return _r12 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r12(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r12(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsMixin = void 0, e.CommonMsMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this,
                a = n.node.attributes,
                Q = a.getList("lquote", "rquote");
              return "monospace" !== n.variant && (a.isSet("lquote") || '"' !== Q.lquote || (Q.lquote = "\u201C"), a.isSet("rquote") || '"' !== Q.rquote || (Q.rquote = "\u201D")), n.childNodes.unshift(n.createText(Q.lquote)), n.childNodes.push(n.createText(Q.rquote)), n;
            }
            return n(e, t), e.prototype.createText = function (t) {
              var e = this.wrap(this.mmlText(t));
              return e.parent = this, e;
            }, e;
          }(t);
        };
      },
      258: function _(t, e) {
        var _r13,
          n = this && this.__extends || (_r13 = function r(t, e) {
            return _r13 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r13(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r13(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMspaceMixin = void 0, e.CommonMspaceMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.node.attributes;
              t.w = this.length2em(r.get("width"), 0), t.h = this.length2em(r.get("height"), 0), t.d = this.length2em(r.get("depth"), 0);
            }, e.prototype.handleVariant = function () {}, e;
          }(t);
        };
      },
      4093: function _(t, e, r) {
        var _n80,
          o = this && this.__extends || (_n80 = function n(t, e) {
            return _n80 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n80(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n80(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsqrtMixin = void 0;
        var Q = r(6469);
        e.CommonMsqrtMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this,
                o = n.createMo("\u221A");
              o.canStretch(1);
              var Q = n.childNodes[n.base].getOuterBBox(),
                s = Q.h,
                T = Q.d,
                l = n.font.params.rule_thickness,
                c = n.node.attributes.get("displaystyle") ? n.font.params.x_height : l;
              return n.surdH = s + T + 2 * l + c / 4, o.getStretchedVariant([n.surdH - T, T], !0), n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "base", {
              get: function get() {
                return 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "surd", {
              get: function get() {
                return 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "root", {
              get: function get() {
                return null;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.createMo = function (e) {
              var r = t.prototype.createMo.call(this, e);
              return this.childNodes.push(r), r;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.childNodes[this.surd].getBBox(),
                n = new Q.BBox(this.childNodes[this.base].getOuterBBox()),
                o = this.getPQ(r)[1],
                a = this.font.params.rule_thickness,
                s = n.h + o + a,
                T = i(this.getRootDimens(r, s), 1)[0];
              t.h = s + a, this.combineRootBBox(t, r, s), t.combine(r, T, s - r.h), t.combine(n, T + r.w, 0), t.clean(), this.setChildPWidths(e);
            }, e.prototype.combineRootBBox = function (t, e, r) {}, e.prototype.getPQ = function (t) {
              var e = this.font.params.rule_thickness,
                r = this.node.attributes.get("displaystyle") ? this.font.params.x_height : e;
              return [r, t.h + t.d > this.surdH ? (t.h + t.d - (this.surdH - 2 * e - r / 2)) / 2 : e + r / 4];
            }, e.prototype.getRootDimens = function (t, e) {
              return [0, 0, 0, 0];
            }, e;
          }(t);
        };
      },
      905: function _(t, e) {
        var _r14,
          n = this && this.__extends || (_r14 = function r(t, e) {
            return _r14 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r14(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r14(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMsubsupMixin = e.CommonMsupMixin = e.CommonMsubMixin = void 0, e.CommonMsubMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.sub];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getOffset = function () {
              return [0, -this.getV()];
            }, e;
          }(t), e.useIC = !1, e;
        }, e.CommonMsupMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.sup];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getOffset = function () {
              return [this.getAdjustedIc() - (this.baseRemoveIc ? 0 : this.baseIc), this.getU()];
            }, e;
          }(t);
        }, e.CommonMsubsupMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.UVQ = null, e;
            }
            return n(e, t), Object.defineProperty(e.prototype, "subChild", {
              get: function get() {
                return this.childNodes[this.node.sub];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "supChild", {
              get: function get() {
                return this.childNodes[this.node.sup];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.baseChild.getOuterBBox(),
                n = o([this.subChild.getOuterBBox(), this.supChild.getOuterBBox()], 2),
                i = n[0],
                a = n[1];
              t.empty(), t.append(r);
              var Q = this.getBaseWidth(),
                s = this.getAdjustedIc(),
                T = o(this.getUVQ(), 2),
                l = T[0],
                c = T[1];
              t.combine(i, Q, c), t.combine(a, Q + s, l), t.w += this.font.params.scriptspace, t.clean(), this.setChildPWidths(e);
            }, e.prototype.getUVQ = function (t, e) {
              void 0 === t && (t = this.subChild.getOuterBBox()), void 0 === e && (e = this.supChild.getOuterBBox());
              var r = this.baseCore.getOuterBBox();
              if (this.UVQ) return this.UVQ;
              var n = this.font.params,
                i = 3 * n.rule_thickness,
                a = this.length2em(this.node.attributes.get("subscriptshift"), n.sub2),
                Q = this.baseCharZero(r.d * this.baseScale + n.sub_drop * t.rscale),
                s = o([this.getU(), Math.max(Q, a)], 2),
                T = s[0],
                l = s[1],
                c = T - e.d * e.rscale - (t.h * t.rscale - l);
              if (c < i) {
                l += i - c;
                var u = .8 * n.x_height - (T - e.d * e.rscale);
                u > 0 && (T += u, l -= u);
              }
              return T = Math.max(this.length2em(this.node.attributes.get("superscriptshift"), T), T), l = Math.max(this.length2em(this.node.attributes.get("subscriptshift"), l), l), c = T - e.d * e.rscale - (t.h * t.rscale - l), this.UVQ = [T, -l, c], this.UVQ;
            }, e;
          }(t), e.useIC = !1, e;
        };
      },
      6237: function _(t, e, r) {
        var _n81,
          o = this && this.__extends || (_n81 = function n(t, e) {
            return _n81 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n81(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n81(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtableMixin = void 0;
        var s = r(6469),
          T = r(505),
          l = r(7875);
        e.CommonMtableMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              n.numCols = 0, n.numRows = 0, n.data = null, n.pwidthCells = [], n.pWidth = 0, n.numCols = (0, l.max)(n.tableRows.map(function (t) {
                return t.numCells;
              })), n.numRows = n.childNodes.length, n.hasLabels = n.childNodes.reduce(function (t, e) {
                return t || e.node.isKind("mlabeledtr");
              }, !1), n.findContainer(), n.isTop = !n.container || n.container.node.isKind("math") && !n.container.parent, n.isTop && (n.jax.table = n), n.getPercentageWidth();
              var o = n.node.attributes;
              return n.frame = "none" !== o.get("frame"), n.fLine = n.frame && o.get("frame") ? .07 : 0, n.fSpace = n.frame ? n.convertLengths(n.getAttributeArray("framespacing")) : [0, 0], n.cSpace = n.convertLengths(n.getColumnAttributes("columnspacing")), n.rSpace = n.convertLengths(n.getRowAttributes("rowspacing")), n.cLines = n.getColumnAttributes("columnlines").map(function (t) {
                return "none" === t ? 0 : .07;
              }), n.rLines = n.getRowAttributes("rowlines").map(function (t) {
                return "none" === t ? 0 : .07;
              }), n.cWidths = n.getColumnWidths(), n.stretchRows(), n.stretchColumns(), n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "tableRows", {
              get: function get() {
                return this.childNodes;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.findContainer = function () {
              for (var t = this, e = t.parent; e && (e.node.notParent || e.node.isKind("mrow"));) t = e, e = e.parent;
              this.container = e, this.containerI = t.node.childPosition();
            }, e.prototype.getPercentageWidth = function () {
              if (this.hasLabels) this.bbox.pwidth = s.BBox.fullWidth;else {
                var t = this.node.attributes.get("width");
                (0, T.isPercent)(t) && (this.bbox.pwidth = t);
              }
            }, e.prototype.stretchRows = function () {
              for (var t = this.node.attributes.get("equalrows"), e = t ? this.getEqualRowHeight() : 0, r = t ? this.getTableData() : {
                  H: [0],
                  D: [0]
                }, n = r.H, o = r.D, i = this.tableRows, a = 0; a < this.numRows; a++) {
                var Q = t ? [(e + n[a] - o[a]) / 2, (e - n[a] + o[a]) / 2] : null;
                i[a].stretchChildren(Q);
              }
            }, e.prototype.stretchColumns = function () {
              for (var t = 0; t < this.numCols; t++) {
                var e = "number" == typeof this.cWidths[t] ? this.cWidths[t] : null;
                this.stretchColumn(t, e);
              }
            }, e.prototype.stretchColumn = function (t, e) {
              var r,
                n,
                o,
                i,
                a,
                s,
                T = [];
              try {
                for (var l = Q(this.tableRows), c = l.next(); !c.done; c = l.next()) {
                  if (m = c.value.getChild(t)) 0 === (b = m.childNodes[0]).stretch.dir && b.canStretch(2) && T.push(b);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (n = l.return) && n.call(l);
                } finally {
                  if (r) throw r.error;
                }
              }
              var u = T.length,
                p = this.childNodes.length;
              if (u && p > 1) {
                if (null === e) {
                  e = 0;
                  var h = u > 1 && u === p;
                  try {
                    for (var d = Q(this.tableRows), f = d.next(); !f.done; f = d.next()) {
                      var m;
                      if (m = f.value.getChild(t)) {
                        var L = 0 === (b = m.childNodes[0]).stretch.dir;
                        if (h || L) {
                          var y = b.getBBox(L).w;
                          y > e && (e = y);
                        }
                      }
                    }
                  } catch (t) {
                    o = {
                      error: t
                    };
                  } finally {
                    try {
                      f && !f.done && (i = d.return) && i.call(d);
                    } finally {
                      if (o) throw o.error;
                    }
                  }
                }
                try {
                  for (var g = Q(T), v = g.next(); !v.done; v = g.next()) {
                    var b;
                    (b = v.value).coreMO().getStretchedVariant([e]);
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    v && !v.done && (s = g.return) && s.call(g);
                  } finally {
                    if (a) throw a.error;
                  }
                }
              }
            }, e.prototype.getTableData = function () {
              if (this.data) return this.data;
              for (var t = new Array(this.numRows).fill(0), e = new Array(this.numRows).fill(0), r = new Array(this.numCols).fill(0), n = new Array(this.numRows), o = new Array(this.numRows), i = [0], a = this.tableRows, Q = 0; Q < a.length; Q++) {
                for (var s = 0, T = a[Q], l = T.node.attributes.get("rowalign"), c = 0; c < T.numCells; c++) {
                  var u = T.getChild(c);
                  s = this.updateHDW(u, c, Q, l, t, e, r, s), this.recordPWidthCell(u, c);
                }
                n[Q] = t[Q], o[Q] = e[Q], T.labeled && (s = this.updateHDW(T.childNodes[0], 0, Q, l, t, e, i, s)), this.extendHD(Q, t, e, s), this.extendHD(Q, n, o, s);
              }
              var p = i[0];
              return this.data = {
                H: t,
                D: e,
                W: r,
                NH: n,
                ND: o,
                L: p
              }, this.data;
            }, e.prototype.updateHDW = function (t, e, r, n, o, i, a, Q) {
              var s = t.getBBox(),
                T = s.h,
                l = s.d,
                c = s.w,
                u = t.parent.bbox.rscale;
              1 !== t.parent.bbox.rscale && (T *= u, l *= u, c *= u), this.node.getProperty("useHeight") && (T < .75 && (T = .75), l < .25 && (l = .25));
              var p = 0;
              return "baseline" !== (n = t.node.attributes.get("rowalign") || n) && "axis" !== n && (p = T + l, T = l = 0), T > o[r] && (o[r] = T), l > i[r] && (i[r] = l), p > Q && (Q = p), a && c > a[e] && (a[e] = c), Q;
            }, e.prototype.extendHD = function (t, e, r, n) {
              var o = (n - (e[t] + r[t])) / 2;
              o < 1e-5 || (e[t] += o, r[t] += o);
            }, e.prototype.recordPWidthCell = function (t, e) {
              t.childNodes[0] && t.childNodes[0].getBBox().pwidth && this.pwidthCells.push([t, e]);
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r,
                n,
                o = this.getTableData(),
                a = o.H,
                Q = o.D;
              if (this.node.attributes.get("equalrows")) {
                var s = this.getEqualRowHeight();
                r = (0, l.sum)([].concat(this.rLines, this.rSpace)) + s * this.numRows;
              } else r = (0, l.sum)(a.concat(Q, this.rLines, this.rSpace));
              r += 2 * (this.fLine + this.fSpace[1]);
              var c = this.getComputedWidths();
              n = (0, l.sum)(c.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]);
              var u = this.node.attributes.get("width");
              "auto" !== u && (n = Math.max(this.length2em(u, 0) + 2 * this.fLine, n));
              var p = i(this.getBBoxHD(r), 2),
                h = p[0],
                d = p[1];
              t.h = h, t.d = d, t.w = n;
              var f = i(this.getBBoxLR(), 2),
                m = f[0],
                L = f[1];
              t.L = m, t.R = L, (0, T.isPercent)(u) || this.setColumnPWidths();
            }, e.prototype.setChildPWidths = function (t, e, r) {
              var n = this.node.attributes.get("width");
              if (!(0, T.isPercent)(n)) return !1;
              this.hasLabels || (this.bbox.pwidth = "", this.container.bbox.pwidth = "");
              var o = this.bbox,
                i = o.w,
                a = o.L,
                Q = o.R,
                s = this.node.attributes.get("data-width-includes-label"),
                c = Math.max(i, this.length2em(n, Math.max(e, a + i + Q))) - (s ? a + Q : 0),
                u = this.node.attributes.get("equalcolumns") ? Array(this.numCols).fill(this.percent(1 / Math.max(1, this.numCols))) : this.getColumnAttributes("columnwidth", 0);
              this.cWidths = this.getColumnWidthsFixed(u, c);
              var p = this.getComputedWidths();
              return this.pWidth = (0, l.sum)(p.concat(this.cLines, this.cSpace)) + 2 * (this.fLine + this.fSpace[0]), this.isTop && (this.bbox.w = this.pWidth), this.setColumnPWidths(), this.pWidth !== i && this.parent.invalidateBBox(), this.pWidth !== i;
            }, e.prototype.setColumnPWidths = function () {
              var t,
                e,
                r = this.cWidths;
              try {
                for (var n = Q(this.pwidthCells), o = n.next(); !o.done; o = n.next()) {
                  var a = i(o.value, 2),
                    s = a[0],
                    T = a[1];
                  s.setChildPWidths(!1, r[T]) && (s.invalidateBBox(), s.getBBox());
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.getBBoxHD = function (t) {
              var e = i(this.getAlignmentRow(), 2),
                r = e[0],
                n = e[1];
              if (null === n) {
                var o = this.font.params.axis_height,
                  a = t / 2;
                return {
                  top: [0, t],
                  center: [a, a],
                  bottom: [t, 0],
                  baseline: [a, a],
                  axis: [a + o, a - o]
                }[r] || [a, a];
              }
              var Q = this.getVerticalPosition(n, r);
              return [Q, t - Q];
            }, e.prototype.getBBoxLR = function () {
              if (this.hasLabels) {
                var t = this.node.attributes,
                  e = t.get("side"),
                  r = i(this.getPadAlignShift(e), 2),
                  n = r[0],
                  o = r[1],
                  a = this.hasLabels && !!t.get("data-width-includes-label");
                return a && this.frame && this.fSpace[0] && (n -= this.fSpace[0]), "center" !== o || a ? "left" === e ? [n, 0] : [0, n] : [n, n];
              }
              return [0, 0];
            }, e.prototype.getPadAlignShift = function (t) {
              var e = this.getTableData().L + this.length2em(this.node.attributes.get("minlabelspacing")),
                r = i(null == this.styles ? ["", ""] : [this.styles.get("padding-left"), this.styles.get("padding-right")], 2),
                n = r[0],
                o = r[1];
              (n || o) && (e = Math.max(e, this.length2em(n || "0"), this.length2em(o || "0")));
              var a = i(this.getAlignShift(), 2),
                Q = a[0],
                s = a[1];
              return Q === t && (s = "left" === t ? Math.max(e, s) - e : Math.min(-e, s) + e), [e, Q, s];
            }, e.prototype.getAlignShift = function () {
              return this.isTop ? t.prototype.getAlignShift.call(this) : [this.container.getChildAlign(this.containerI), 0];
            }, e.prototype.getWidth = function () {
              return this.pWidth || this.getBBox().w;
            }, e.prototype.getEqualRowHeight = function () {
              var t = this.getTableData(),
                e = t.H,
                r = t.D,
                n = Array.from(e.keys()).map(function (t) {
                  return e[t] + r[t];
                });
              return Math.max.apply(Math, n);
            }, e.prototype.getComputedWidths = function () {
              var t = this,
                e = this.getTableData().W,
                r = Array.from(e.keys()).map(function (r) {
                  return "number" == typeof t.cWidths[r] ? t.cWidths[r] : e[r];
                });
              return this.node.attributes.get("equalcolumns") && (r = Array(r.length).fill((0, l.max)(r))), r;
            }, e.prototype.getColumnWidths = function () {
              var t = this.node.attributes.get("width");
              if (this.node.attributes.get("equalcolumns")) return this.getEqualColumns(t);
              var e = this.getColumnAttributes("columnwidth", 0);
              return "auto" === t ? this.getColumnWidthsAuto(e) : (0, T.isPercent)(t) ? this.getColumnWidthsPercent(e) : this.getColumnWidthsFixed(e, this.length2em(t));
            }, e.prototype.getEqualColumns = function (t) {
              var e,
                r = Math.max(1, this.numCols);
              if ("auto" === t) {
                var n = this.getTableData().W;
                e = (0, l.max)(n);
              } else if ((0, T.isPercent)(t)) e = this.percent(1 / r);else {
                var o = (0, l.sum)([].concat(this.cLines, this.cSpace)) + 2 * this.fSpace[0];
                e = Math.max(0, this.length2em(t) - o) / r;
              }
              return Array(this.numCols).fill(e);
            }, e.prototype.getColumnWidthsAuto = function (t) {
              var e = this;
              return t.map(function (t) {
                return "auto" === t || "fit" === t ? null : (0, T.isPercent)(t) ? t : e.length2em(t);
              });
            }, e.prototype.getColumnWidthsPercent = function (t) {
              var e = this,
                r = t.indexOf("fit") >= 0,
                n = (r ? this.getTableData() : {
                  W: null
                }).W;
              return Array.from(t.keys()).map(function (o) {
                var i = t[o];
                return "fit" === i ? null : "auto" === i ? r ? n[o] : null : (0, T.isPercent)(i) ? i : e.length2em(i);
              });
            }, e.prototype.getColumnWidthsFixed = function (t, e) {
              var r = this,
                n = Array.from(t.keys()),
                o = n.filter(function (e) {
                  return "fit" === t[e];
                }),
                i = n.filter(function (e) {
                  return "auto" === t[e];
                }),
                a = o.length || i.length,
                Q = (a ? this.getTableData() : {
                  W: null
                }).W,
                s = e - (0, l.sum)([].concat(this.cLines, this.cSpace)) - 2 * this.fSpace[0],
                T = s;
              n.forEach(function (e) {
                var n = t[e];
                T -= "fit" === n || "auto" === n ? Q[e] : r.length2em(n, s);
              });
              var c = a && T > 0 ? T / a : 0;
              return n.map(function (e) {
                var n = t[e];
                return "fit" === n ? Q[e] + c : "auto" === n ? Q[e] + (0 === o.length ? c : 0) : r.length2em(n, s);
              });
            }, e.prototype.getVerticalPosition = function (t, e) {
              for (var r = this.node.attributes.get("equalrows"), n = this.getTableData(), o = n.H, a = n.D, Q = r ? this.getEqualRowHeight() : 0, s = this.getRowHalfSpacing(), T = this.fLine, l = 0; l < t; l++) T += s[l] + (r ? Q : o[l] + a[l]) + s[l + 1] + this.rLines[l];
              var c = i(r ? [(Q + o[t] - a[t]) / 2, (Q - o[t] + a[t]) / 2] : [o[t], a[t]], 2),
                u = c[0],
                p = c[1];
              return T += {
                top: 0,
                center: s[t] + (u + p) / 2,
                bottom: s[t] + u + p + s[t + 1],
                baseline: s[t] + u,
                axis: s[t] + u - .25
              }[e] || 0;
            }, e.prototype.getEmHalfSpacing = function (t, e, r) {
              void 0 === r && (r = 1);
              var n = this.em(t * r),
                o = this.addEm(e, 2 / r);
              return o.unshift(n), o.push(n), o;
            }, e.prototype.getRowHalfSpacing = function () {
              var t = this.rSpace.map(function (t) {
                return t / 2;
              });
              return t.unshift(this.fSpace[1]), t.push(this.fSpace[1]), t;
            }, e.prototype.getColumnHalfSpacing = function () {
              var t = this.cSpace.map(function (t) {
                return t / 2;
              });
              return t.unshift(this.fSpace[0]), t.push(this.fSpace[0]), t;
            }, e.prototype.getAlignmentRow = function () {
              var t = i((0, T.split)(this.node.attributes.get("align")), 2),
                e = t[0],
                r = t[1];
              if (null == r) return [e, null];
              var n = parseInt(r);
              return n < 0 && (n += this.numRows + 1), [e, n < 1 || n > this.numRows ? null : n - 1];
            }, e.prototype.getColumnAttributes = function (t, e) {
              void 0 === e && (e = 1);
              var r = this.numCols - e,
                n = this.getAttributeArray(t);
              if (0 === n.length) return null;
              for (; n.length < r;) n.push(n[n.length - 1]);
              return n.length > r && n.splice(r), n;
            }, e.prototype.getRowAttributes = function (t, e) {
              void 0 === e && (e = 1);
              var r = this.numRows - e,
                n = this.getAttributeArray(t);
              if (0 === n.length) return null;
              for (; n.length < r;) n.push(n[n.length - 1]);
              return n.length > r && n.splice(r), n;
            }, e.prototype.getAttributeArray = function (t) {
              var e = this.node.attributes.get(t);
              return e ? (0, T.split)(e) : [this.node.attributes.getDefault(t)];
            }, e.prototype.addEm = function (t, e) {
              var r = this;
              return void 0 === e && (e = 1), t ? t.map(function (t) {
                return r.em(t / e);
              }) : null;
            }, e.prototype.convertLengths = function (t) {
              var e = this;
              return t ? t.map(function (t) {
                return e.length2em(t);
              }) : null;
            }, e;
          }(t);
        };
      },
      5164: function _(t, e) {
        var _r15,
          n = this && this.__extends || (_r15 = function r(t, e) {
            return _r15 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r15(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r15(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtdMixin = void 0, e.CommonMtdMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.invalidateBBox = function () {
              this.bboxComputed = !1;
            }, e.prototype.getWrapWidth = function (t) {
              var e = this.parent.parent,
                r = this.parent,
                n = this.node.childPosition() - (r.labeled ? 1 : 0);
              return "number" == typeof e.cWidths[n] ? e.cWidths[n] : e.getTableData().W[n];
            }, e.prototype.getChildAlign = function (t) {
              return this.node.attributes.get("columnalign");
            }, e;
          }(t);
        };
      },
      6319: function _(t, e) {
        var _r16,
          n = this && this.__extends || (_r16 = function r(t, e) {
            return _r16 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r16(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r16(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMtextMixin = void 0, e.CommonMtextMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getVariant = function () {
              var e = this.jax.options,
                r = this.jax.math.outputData,
                n = (!!r.merrorFamily || !!e.merrorFont) && this.node.Parent.isKind("merror");
              if (r.mtextFamily || e.mtextFont || n) {
                var o = this.node.attributes.get("mathvariant"),
                  i = this.constructor.INHERITFONTS[o] || this.jax.font.getCssFont(o),
                  a = i[0] || (n ? r.merrorFamily || e.merrorFont : r.mtextFamily || e.mtextFont);
                this.variant = this.explicitVariant(a, i[2] ? "bold" : "", i[1] ? "italic" : "");
              } else t.prototype.getVariant.call(this);
            }, e;
          }(t), e.INHERITFONTS = {
            normal: ["", !1, !1],
            bold: ["", !1, !0],
            italic: ["", !0, !1],
            "bold-italic": ["", !0, !0]
          }, e;
        };
      },
      5766: function _(t, e) {
        var _r17,
          n = this && this.__extends || (_r17 = function r(t, e) {
            return _r17 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r17(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r17(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMlabeledtrMixin = e.CommonMtrMixin = void 0, e.CommonMtrMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "fixesPWidth", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "numCells", {
              get: function get() {
                return this.childNodes.length;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "labeled", {
              get: function get() {
                return !1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tableCells", {
              get: function get() {
                return this.childNodes;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getChild = function (t) {
              return this.childNodes[t];
            }, e.prototype.getChildBBoxes = function () {
              return this.childNodes.map(function (t) {
                return t.getBBox();
              });
            }, e.prototype.stretchChildren = function (t) {
              var e, r, n, i, a, Q;
              void 0 === t && (t = null);
              var s = [],
                T = this.labeled ? this.childNodes.slice(1) : this.childNodes;
              try {
                for (var l = o(T), c = l.next(); !c.done; c = l.next()) {
                  (M = c.value.childNodes[0]).canStretch(1) && s.push(M);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  c && !c.done && (r = l.return) && r.call(l);
                } finally {
                  if (e) throw e.error;
                }
              }
              var u = s.length,
                p = this.childNodes.length;
              if (u && p > 1) {
                if (null === t) {
                  var h = 0,
                    d = 0,
                    f = u > 1 && u === p;
                  try {
                    for (var m = o(T), L = m.next(); !L.done; L = m.next()) {
                      var y = 0 === (M = L.value.childNodes[0]).stretch.dir;
                      if (f || y) {
                        var g = M.getBBox(y),
                          v = g.h,
                          b = g.d;
                        v > h && (h = v), b > d && (d = b);
                      }
                    }
                  } catch (t) {
                    n = {
                      error: t
                    };
                  } finally {
                    try {
                      L && !L.done && (i = m.return) && i.call(m);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                  t = [h, d];
                }
                try {
                  for (var H = o(s), _ = H.next(); !_.done; _ = H.next()) {
                    var M;
                    (M = _.value).coreMO().getStretchedVariant(t);
                  }
                } catch (t) {
                  a = {
                    error: t
                  };
                } finally {
                  try {
                    _ && !_.done && (Q = H.return) && Q.call(H);
                  } finally {
                    if (a) throw a.error;
                  }
                }
              }
            }, e;
          }(t);
        }, e.CommonMlabeledtrMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), Object.defineProperty(e.prototype, "numCells", {
              get: function get() {
                return Math.max(0, this.childNodes.length - 1);
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "labeled", {
              get: function get() {
                return !0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "tableCells", {
              get: function get() {
                return this.childNodes.slice(1);
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getChild = function (t) {
              return this.childNodes[t + 1];
            }, e.prototype.getChildBBoxes = function () {
              return this.childNodes.slice(1).map(function (t) {
                return t.getBBox();
              });
            }, e;
          }(t);
        };
      },
      1971: function _(t, e) {
        var _r18,
          n = this && this.__extends || (_r18 = function r(t, e) {
            return _r18 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r18(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r18(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonMunderoverMixin = e.CommonMoverMixin = e.CommonMunderMixin = void 0, e.CommonMunderMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.under];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e, r) {
              if (void 0 === r && (r = !1), this.hasMovableLimits()) t.prototype.computeBBox.call(this, e, r);else {
                e.empty();
                var n = this.baseChild.getOuterBBox(),
                  i = this.scriptChild.getOuterBBox(),
                  a = this.getUnderKV(n, i)[1],
                  Q = this.isLineBelow ? 0 : this.getDelta(!0),
                  s = o(this.getDeltaW([n, i], [0, -Q]), 2),
                  T = s[0],
                  l = s[1];
                e.combine(n, T, 0), e.combine(i, l, a), e.d += this.font.params.big_op_spacing5, e.clean(), this.setChildPWidths(r);
              }
            }, e;
          }(t);
        }, e.CommonMoverMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[this.node.over];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e) {
              if (this.hasMovableLimits()) t.prototype.computeBBox.call(this, e);else {
                e.empty();
                var r = this.baseChild.getOuterBBox(),
                  n = this.scriptChild.getOuterBBox();
                this.node.attributes.get("accent") && (r.h = Math.max(r.h, this.font.params.x_height * r.scale));
                var i = this.getOverKU(r, n)[1],
                  a = this.isLineAbove ? 0 : this.getDelta(),
                  Q = o(this.getDeltaW([r, n], [0, a]), 2),
                  s = Q[0],
                  T = Q[1];
                e.combine(r, s, 0), e.combine(n, T, i), e.h += this.font.params.big_op_spacing5, e.clean();
              }
            }, e;
          }(t);
        }, e.CommonMunderoverMixin = function (t) {
          return function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, i([], o(e), !1)) || this;
              return n.stretchChildren(), n;
            }
            return n(e, t), Object.defineProperty(e.prototype, "underChild", {
              get: function get() {
                return this.childNodes[this.node.under];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "overChild", {
              get: function get() {
                return this.childNodes[this.node.over];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "subChild", {
              get: function get() {
                return this.underChild;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "supChild", {
              get: function get() {
                return this.overChild;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.computeBBox = function (e) {
              if (this.hasMovableLimits()) t.prototype.computeBBox.call(this, e);else {
                e.empty();
                var r = this.overChild.getOuterBBox(),
                  n = this.baseChild.getOuterBBox(),
                  i = this.underChild.getOuterBBox();
                this.node.attributes.get("accent") && (n.h = Math.max(n.h, this.font.params.x_height * n.scale));
                var a = this.getOverKU(n, r)[1],
                  Q = this.getUnderKV(n, i)[1],
                  s = this.getDelta(),
                  T = o(this.getDeltaW([n, i, r], [0, this.isLineBelow ? 0 : -s, this.isLineAbove ? 0 : s]), 3),
                  l = T[0],
                  c = T[1],
                  u = T[2];
                e.combine(n, l, 0), e.combine(r, u, a), e.combine(i, c, Q);
                var p = this.font.params.big_op_spacing5;
                e.h += p, e.d += p, e.clean();
              }
            }, e;
          }(t);
        };
      },
      167: function _(t, e, r) {
        var _n82,
          o = this && this.__extends || (_n82 = function n(t, e) {
            return _n82 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n82(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n82(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          Q = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonScriptbaseMixin = void 0;
        var s = r(9007);
        e.CommonScriptbaseMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, a([], i(e), !1)) || this;
              n.baseScale = 1, n.baseIc = 0, n.baseRemoveIc = !1, n.baseIsChar = !1, n.baseHasAccentOver = null, n.baseHasAccentUnder = null, n.isLineAbove = !1, n.isLineBelow = !1, n.isMathAccent = !1;
              var o = n.baseCore = n.getBaseCore();
              return o ? (n.setBaseAccentsFor(o), n.baseScale = n.getBaseScale(), n.baseIc = n.getBaseIc(), n.baseIsChar = n.isCharBase(), n.isMathAccent = n.baseIsChar && n.scriptChild && !!n.scriptChild.coreMO().node.getProperty("mathaccent"), n.checkLineAccents(), n.baseRemoveIc = !n.isLineAbove && !n.isLineBelow && (!n.constructor.useIC || n.isMathAccent), n) : n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "baseChild", {
              get: function get() {
                return this.childNodes[this.node.base];
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "scriptChild", {
              get: function get() {
                return this.childNodes[1];
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.getBaseCore = function () {
              for (var t = this.getSemanticBase() || this.childNodes[0]; t && (1 === t.childNodes.length && (t.node.isKind("mrow") || t.node.isKind("TeXAtom") && t.node.texClass !== s.TEXCLASS.VCENTER || t.node.isKind("mstyle") || t.node.isKind("mpadded") || t.node.isKind("mphantom") || t.node.isKind("semantics")) || t.node.isKind("munderover") && t.isMathAccent);) this.setBaseAccentsFor(t), t = t.childNodes[0];
              return t || (this.baseHasAccentOver = this.baseHasAccentUnder = !1), t || this.childNodes[0];
            }, e.prototype.setBaseAccentsFor = function (t) {
              t.node.isKind("munderover") && (null === this.baseHasAccentOver && (this.baseHasAccentOver = !!t.node.attributes.get("accent")), null === this.baseHasAccentUnder && (this.baseHasAccentUnder = !!t.node.attributes.get("accentunder")));
            }, e.prototype.getSemanticBase = function () {
              var t = this.node.attributes.getExplicit("data-semantic-fencepointer");
              return this.getBaseFence(this.baseChild, t);
            }, e.prototype.getBaseFence = function (t, e) {
              var r, n;
              if (!t || !t.node.attributes || !e) return null;
              if (t.node.attributes.getExplicit("data-semantic-id") === e) return t;
              try {
                for (var o = Q(t.childNodes), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    s = this.getBaseFence(a, e);
                  if (s) return s;
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  i && !i.done && (n = o.return) && n.call(o);
                } finally {
                  if (r) throw r.error;
                }
              }
              return null;
            }, e.prototype.getBaseScale = function () {
              for (var t = this.baseCore, e = 1; t && t !== this;) {
                e *= t.getOuterBBox().rscale, t = t.parent;
              }
              return e;
            }, e.prototype.getBaseIc = function () {
              return this.baseCore.getOuterBBox().ic * this.baseScale;
            }, e.prototype.getAdjustedIc = function () {
              var t = this.baseCore.getOuterBBox();
              return (t.ic ? 1.05 * t.ic + .05 : 0) * this.baseScale;
            }, e.prototype.isCharBase = function () {
              var t = this.baseCore;
              return (t.node.isKind("mo") && null === t.size || t.node.isKind("mi") || t.node.isKind("mn")) && 1 === t.bbox.rscale && 1 === Array.from(t.getText()).length;
            }, e.prototype.checkLineAccents = function () {
              if (this.node.isKind("munderover")) if (this.node.isKind("mover")) this.isLineAbove = this.isLineAccent(this.scriptChild);else if (this.node.isKind("munder")) this.isLineBelow = this.isLineAccent(this.scriptChild);else {
                this.isLineAbove = this.isLineAccent(this.overChild), this.isLineBelow = this.isLineAccent(this.underChild);
              }
            }, e.prototype.isLineAccent = function (t) {
              var e = t.coreMO().node;
              return e.isToken && "\u2015" === e.getText();
            }, e.prototype.getBaseWidth = function () {
              var t = this.baseChild.getOuterBBox();
              return t.w * t.rscale - (this.baseRemoveIc ? this.baseIc : 0) + this.font.params.extra_ic;
            }, e.prototype.computeBBox = function (t, e) {
              void 0 === e && (e = !1);
              var r = this.getBaseWidth(),
                n = i(this.getOffset(), 2),
                o = n[0],
                a = n[1];
              t.append(this.baseChild.getOuterBBox()), t.combine(this.scriptChild.getOuterBBox(), r + o, a), t.w += this.font.params.scriptspace, t.clean(), this.setChildPWidths(e);
            }, e.prototype.getOffset = function () {
              return [0, 0];
            }, e.prototype.baseCharZero = function (t) {
              var e = !!this.baseCore.node.attributes.get("largeop"),
                r = this.baseScale;
              return this.baseIsChar && !e && 1 === r ? 0 : t;
            }, e.prototype.getV = function () {
              var t = this.baseCore.getOuterBBox(),
                e = this.scriptChild.getOuterBBox(),
                r = this.font.params,
                n = this.length2em(this.node.attributes.get("subscriptshift"), r.sub1);
              return Math.max(this.baseCharZero(t.d * this.baseScale + r.sub_drop * e.rscale), n, e.h * e.rscale - .8 * r.x_height);
            }, e.prototype.getU = function () {
              var t = this.baseCore.getOuterBBox(),
                e = this.scriptChild.getOuterBBox(),
                r = this.font.params,
                n = this.node.attributes.getList("displaystyle", "superscriptshift"),
                o = this.node.getProperty("texprimestyle") ? r.sup3 : n.displaystyle ? r.sup1 : r.sup2,
                i = this.length2em(n.superscriptshift, o);
              return Math.max(this.baseCharZero(t.h * this.baseScale - r.sup_drop * e.rscale), i, e.d * e.rscale + 1 / 4 * r.x_height);
            }, e.prototype.hasMovableLimits = function () {
              var t = this.node.attributes.get("displaystyle"),
                e = this.baseChild.coreMO().node;
              return !t && !!e.attributes.get("movablelimits");
            }, e.prototype.getOverKU = function (t, e) {
              var r = this.node.attributes.get("accent"),
                n = this.font.params,
                o = e.d * e.rscale,
                i = n.rule_thickness * n.separation_factor,
                a = this.baseHasAccentOver ? i : 0,
                Q = this.isLineAbove ? 3 * n.rule_thickness : i,
                s = (r ? Q : Math.max(n.big_op_spacing1, n.big_op_spacing3 - Math.max(0, o))) - a;
              return [s, t.h * t.rscale + s + o];
            }, e.prototype.getUnderKV = function (t, e) {
              var r = this.node.attributes.get("accentunder"),
                n = this.font.params,
                o = e.h * e.rscale,
                i = n.rule_thickness * n.separation_factor,
                a = this.baseHasAccentUnder ? i : 0,
                Q = this.isLineBelow ? 3 * n.rule_thickness : i,
                s = (r ? Q : Math.max(n.big_op_spacing2, n.big_op_spacing4 - o)) - a;
              return [s, -(t.d * t.rscale + s + o)];
            }, e.prototype.getDeltaW = function (t, e) {
              var r, n, o, s;
              void 0 === e && (e = [0, 0, 0]);
              var T = this.node.attributes.get("align"),
                l = t.map(function (t) {
                  return t.w * t.rscale;
                });
              l[0] -= this.baseRemoveIc && !this.baseCore.node.attributes.get("largeop") ? this.baseIc : 0;
              var c = Math.max.apply(Math, a([], i(l), !1)),
                u = [],
                p = 0;
              try {
                for (var h = Q(l.keys()), d = h.next(); !d.done; d = h.next()) {
                  var f = d.value;
                  u[f] = ("center" === T ? (c - l[f]) / 2 : "right" === T ? c - l[f] : 0) + e[f], u[f] < p && (p = -u[f]);
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  d && !d.done && (n = h.return) && n.call(h);
                } finally {
                  if (r) throw r.error;
                }
              }
              if (p) try {
                for (var m = Q(u.keys()), L = m.next(); !L.done; L = m.next()) {
                  f = L.value;
                  u[f] += p;
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  L && !L.done && (s = m.return) && s.call(m);
                } finally {
                  if (o) throw o.error;
                }
              }
              return [1, 2].map(function (e) {
                return u[e] += t[e] ? t[e].dx * t[0].scale : 0;
              }), u;
            }, e.prototype.getDelta = function (t) {
              void 0 === t && (t = !1);
              var e = this.node.attributes.get("accent"),
                r = this.baseCore.getOuterBBox(),
                n = r.sk,
                o = r.ic;
              return ((e && !t ? n : 0) + this.font.skewIcFactor * o) * this.baseScale;
            }, e.prototype.stretchChildren = function () {
              var t,
                e,
                r,
                n,
                o,
                i,
                a = [];
              try {
                for (var s = Q(this.childNodes), T = s.next(); !T.done; T = s.next()) {
                  (b = T.value).canStretch(2) && a.push(b);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  T && !T.done && (e = s.return) && e.call(s);
                } finally {
                  if (t) throw t.error;
                }
              }
              var l = a.length,
                c = this.childNodes.length;
              if (l && c > 1) {
                var u = 0,
                  p = l > 1 && l === c;
                try {
                  for (var h = Q(this.childNodes), d = h.next(); !d.done; d = h.next()) {
                    var f = 0 === (b = d.value).stretch.dir;
                    if (p || f) {
                      var m = b.getOuterBBox(f),
                        L = m.w,
                        y = m.rscale;
                      L * y > u && (u = L * y);
                    }
                  }
                } catch (t) {
                  r = {
                    error: t
                  };
                } finally {
                  try {
                    d && !d.done && (n = h.return) && n.call(h);
                  } finally {
                    if (r) throw r.error;
                  }
                }
                try {
                  for (var g = Q(a), v = g.next(); !v.done; v = g.next()) {
                    var b;
                    (b = v.value).coreMO().getStretchedVariant([u / b.bbox.rscale]);
                  }
                } catch (t) {
                  o = {
                    error: t
                  };
                } finally {
                  try {
                    v && !v.done && (i = g.return) && i.call(g);
                  } finally {
                    if (o) throw o.error;
                  }
                }
              }
            }, e;
          }(t), e.useIC = !0, e;
        };
      },
      5806: function _(t, e) {
        var _r19,
          n = this && this.__extends || (_r19 = function r(t, e) {
            return _r19 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r19(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r19(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonSemanticsMixin = void 0, e.CommonSemanticsMixin = function (t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.computeBBox = function (t, e) {
              if (void 0 === e && (e = !1), this.childNodes.length) {
                var r = this.childNodes[0].getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d;
                t.w = n, t.h = o, t.d = i;
              }
            }, e;
          }(t);
        };
      },
      5920: function _(t, e) {
        var _r20,
          n = this && this.__extends || (_r20 = function r(t, e) {
            return _r20 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r20(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r20(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__assign || function () {
            return o = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, o.apply(this, arguments);
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CommonTeXFontMixin = void 0, e.CommonTeXFontMixin = function (t) {
          var e;
          return e = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e.prototype.getDelimiterData = function (t) {
              return this.getChar("-smallop", t) || this.getChar("-size4", t);
            }, e;
          }(t), e.NAME = "TeX", e.defaultVariants = a(a([], i(t.defaultVariants), !1), [["-smallop", "normal"], ["-largeop", "normal"], ["-size3", "normal"], ["-size4", "normal"], ["-tex-calligraphic", "italic"], ["-tex-bold-calligraphic", "bold-italic"], ["-tex-oldstyle", "normal"], ["-tex-bold-oldstyle", "bold"], ["-tex-mathit", "italic"], ["-tex-variant", "normal"]], !1), e.defaultCssFonts = o(o({}, t.defaultCssFonts), {
            "-smallop": ["serif", !1, !1],
            "-largeop": ["serif", !1, !1],
            "-size3": ["serif", !1, !1],
            "-size4": ["serif", !1, !1],
            "-tex-calligraphic": ["cursive", !0, !1],
            "-tex-bold-calligraphic": ["cursive", !0, !0],
            "-tex-oldstyle": ["serif", !1, !1],
            "-tex-bold-oldstyle": ["serif", !1, !0],
            "-tex-mathit": ["serif", !0, !1]
          }), e.defaultSizeVariants = ["normal", "-smallop", "-largeop", "-size3", "-size4", "-tex-variant"], e.defaultStretchVariants = ["-size4"], e;
        };
      },
      5887: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.boldItalic = void 0, e.boldItalic = {
          47: [.711, .21, .894],
          305: [.452, .008, .394, {
            sk: .0319
          }],
          567: [.451, .201, .439, {
            sk: .0958
          }],
          8260: [.711, .21, .894],
          8710: [.711, 0, .958, {
            sk: .192
          }],
          10744: [.711, .21, .894]
        };
      },
      1103: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.bold = void 0, e.bold = {
          33: [.705, 0, .35],
          34: [.694, -.329, .603],
          35: [.694, .193, .958],
          36: [.75, .056, .575],
          37: [.75, .056, .958],
          38: [.705, .011, .894],
          39: [.694, -.329, .319],
          40: [.75, .249, .447],
          41: [.75, .249, .447],
          42: [.75, -.306, .575],
          43: [.633, .131, .894],
          44: [.171, .194, .319],
          45: [.278, -.166, .383],
          46: [.171, 0, .319],
          47: [.75, .25, .575],
          58: [.444, 0, .319],
          59: [.444, .194, .319],
          60: [.587, .085, .894],
          61: [.393, -.109, .894],
          62: [.587, .085, .894],
          63: [.7, 0, .543],
          64: [.699, .006, .894],
          91: [.75, .25, .319],
          92: [.75, .25, .575],
          93: [.75, .25, .319],
          94: [.694, -.52, .575],
          95: [-.01, .061, .575],
          96: [.706, -.503, .575],
          123: [.75, .25, .575],
          124: [.75, .249, .319],
          125: [.75, .25, .575],
          126: [.344, -.202, .575],
          168: [.695, -.535, .575],
          172: [.371, -.061, .767],
          175: [.607, -.54, .575],
          176: [.702, -.536, .575],
          177: [.728, .035, .894],
          180: [.706, -.503, .575],
          183: [.336, -.166, .319],
          215: [.53, .028, .894],
          247: [.597, .096, .894],
          305: [.442, 0, .278, {
            sk: .0278
          }],
          567: [.442, .205, .306, {
            sk: .0833
          }],
          697: [.563, -.033, .344],
          710: [.694, -.52, .575],
          711: [.66, -.515, .575],
          713: [.607, -.54, .575],
          714: [.706, -.503, .575],
          715: [.706, -.503, .575],
          728: [.694, -.5, .575],
          729: [.695, -.525, .575],
          730: [.702, -.536, .575],
          732: [.694, -.552, .575],
          768: [.706, -.503, 0],
          769: [.706, -.503, 0],
          770: [.694, -.52, 0],
          771: [.694, -.552, 0],
          772: [.607, -.54, 0],
          774: [.694, -.5, 0],
          775: [.695, -.525, 0],
          776: [.695, -.535, 0],
          778: [.702, -.536, 0],
          779: [.714, -.511, 0],
          780: [.66, -.515, 0],
          824: [.711, .21, 0],
          8194: [0, 0, .5],
          8195: [0, 0, .999],
          8196: [0, 0, .333],
          8197: [0, 0, .25],
          8198: [0, 0, .167],
          8201: [0, 0, .167],
          8202: [0, 0, .083],
          8211: [.3, -.249, .575],
          8212: [.3, -.249, 1.15],
          8213: [.3, -.249, 1.15],
          8214: [.75, .248, .575],
          8215: [-.01, .061, .575],
          8216: [.694, -.329, .319],
          8217: [.694, -.329, .319],
          8220: [.694, -.329, .603],
          8221: [.694, -.329, .603],
          8224: [.702, .211, .511],
          8225: [.702, .202, .511],
          8226: [.474, -.028, .575],
          8230: [.171, 0, 1.295],
          8242: [.563, -.033, .344],
          8243: [.563, 0, .688],
          8244: [.563, 0, 1.032],
          8254: [.607, -.54, .575],
          8260: [.75, .25, .575],
          8279: [.563, 0, 1.376],
          8407: [.723, -.513, .575],
          8463: [.694, .008, .668, {
            sk: -.0319
          }],
          8467: [.702, .019, .474, {
            sk: .128
          }],
          8472: [.461, .21, .74],
          8501: [.694, 0, .703],
          8592: [.518, .017, 1.15],
          8593: [.694, .193, .575],
          8594: [.518, .017, 1.15],
          8595: [.694, .194, .575],
          8596: [.518, .017, 1.15],
          8597: [.767, .267, .575],
          8598: [.724, .194, 1.15],
          8599: [.724, .193, 1.15],
          8600: [.694, .224, 1.15],
          8601: [.694, .224, 1.15],
          8602: [.711, .21, 1.15],
          8603: [.711, .21, 1.15],
          8614: [.518, .017, 1.15],
          8617: [.518, .017, 1.282],
          8618: [.518, .017, 1.282],
          8622: [.711, .21, 1.15],
          8636: [.518, -.22, 1.15],
          8637: [.281, .017, 1.15],
          8640: [.518, -.22, 1.15],
          8641: [.281, .017, 1.15],
          8652: [.718, .017, 1.15],
          8653: [.711, .21, 1.15],
          8654: [.711, .21, 1.15],
          8655: [.711, .21, 1.15],
          8656: [.547, .046, 1.15],
          8657: [.694, .193, .703],
          8658: [.547, .046, 1.15],
          8659: [.694, .194, .703],
          8660: [.547, .046, 1.15],
          8661: [.767, .267, .703],
          8704: [.694, .016, .639],
          8707: [.694, 0, .639],
          8708: [.711, .21, .639],
          8709: [.767, .073, .575],
          8710: [.698, 0, .958],
          8712: [.587, .086, .767],
          8713: [.711, .21, .767],
          8715: [.587, .086, .767],
          8716: [.711, .21, .767],
          8722: [.281, -.221, .894],
          8723: [.537, .227, .894],
          8725: [.75, .25, .575],
          8726: [.75, .25, .575],
          8727: [.472, -.028, .575],
          8728: [.474, -.028, .575],
          8729: [.474, -.028, .575],
          8730: [.82, .18, .958, {
            ic: .03
          }],
          8733: [.451, .008, .894],
          8734: [.452, .008, 1.15],
          8736: [.714, 0, .722],
          8739: [.75, .249, .319],
          8740: [.75, .249, .319],
          8741: [.75, .248, .575],
          8742: [.75, .248, .575],
          8743: [.604, .017, .767],
          8744: [.604, .016, .767],
          8745: [.603, .016, .767],
          8746: [.604, .016, .767],
          8747: [.711, .211, .569, {
            ic: .063
          }],
          8764: [.391, -.109, .894],
          8768: [.583, .082, .319],
          8769: [.711, .21, .894],
          8771: [.502, 0, .894],
          8772: [.711, .21, .894],
          8773: [.638, .027, .894],
          8775: [.711, .21, .894],
          8776: [.524, -.032, .894],
          8777: [.711, .21, .894],
          8781: [.533, .032, .894],
          8784: [.721, -.109, .894],
          8800: [.711, .21, .894],
          8801: [.505, 0, .894],
          8802: [.711, .21, .894],
          8804: [.697, .199, .894],
          8805: [.697, .199, .894],
          8810: [.617, .116, 1.15],
          8811: [.618, .116, 1.15],
          8813: [.711, .21, .894],
          8814: [.711, .21, .894],
          8815: [.711, .21, .894],
          8816: [.711, .21, .894],
          8817: [.711, .21, .894],
          8826: [.585, .086, .894],
          8827: [.586, .086, .894],
          8832: [.711, .21, .894],
          8833: [.711, .21, .894],
          8834: [.587, .085, .894],
          8835: [.587, .086, .894],
          8836: [.711, .21, .894],
          8837: [.711, .21, .894],
          8838: [.697, .199, .894],
          8839: [.697, .199, .894],
          8840: [.711, .21, .894],
          8841: [.711, .21, .894],
          8846: [.604, .016, .767],
          8849: [.697, .199, .894],
          8850: [.697, .199, .894],
          8851: [.604, 0, .767],
          8852: [.604, 0, .767],
          8853: [.632, .132, .894],
          8854: [.632, .132, .894],
          8855: [.632, .132, .894],
          8856: [.632, .132, .894],
          8857: [.632, .132, .894],
          8866: [.693, 0, .703],
          8867: [.693, 0, .703],
          8868: [.694, 0, .894],
          8869: [.693, 0, .894],
          8872: [.75, .249, .974],
          8876: [.711, .21, .703],
          8877: [.75, .249, .974],
          8900: [.523, .021, .575],
          8901: [.336, -.166, .319],
          8902: [.502, 0, .575],
          8904: [.54, .039, 1],
          8930: [.711, .21, .894],
          8931: [.711, .21, .894],
          8942: [.951, .029, .319],
          8943: [.336, -.166, 1.295],
          8945: [.871, -.101, 1.323],
          8968: [.75, .248, .511],
          8969: [.75, .248, .511],
          8970: [.749, .248, .511],
          8971: [.749, .248, .511],
          8994: [.405, -.108, 1.15],
          8995: [.392, -.126, 1.15],
          9001: [.75, .249, .447],
          9002: [.75, .249, .447],
          9651: [.711, 0, 1.022],
          9653: [.711, 0, 1.022],
          9657: [.54, .039, .575],
          9661: [.5, .21, 1.022],
          9663: [.5, .21, 1.022],
          9667: [.539, .038, .575],
          9711: [.711, .211, 1.15],
          9824: [.719, .129, .894],
          9825: [.711, .024, .894],
          9826: [.719, .154, .894],
          9827: [.719, .129, .894],
          9837: [.75, .017, .447],
          9838: [.741, .223, .447],
          9839: [.724, .224, .447],
          10072: [.75, .249, .319],
          10216: [.75, .249, .447],
          10217: [.75, .249, .447],
          10229: [.518, .017, 1.805],
          10230: [.518, .017, 1.833],
          10231: [.518, .017, 2.126],
          10232: [.547, .046, 1.868],
          10233: [.547, .046, 1.87],
          10234: [.547, .046, 2.126],
          10236: [.518, .017, 1.833],
          10744: [.711, .21, .894],
          10799: [.53, .028, .894],
          10815: [.686, 0, .9],
          10927: [.696, .199, .894],
          10928: [.697, .199, .894],
          12296: [.75, .249, .447],
          12297: [.75, .249, .447]
        };
      },
      9124: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.delimiters = e.VSIZES = e.HDW3 = e.HDW2 = e.HDW1 = void 0;
        var n = r(5884);
        e.HDW1 = [.75, .25, .875], e.HDW2 = [.85, .349, .667], e.HDW3 = [.583, .082, .5], e.VSIZES = [1, 1.2, 1.8, 2.4, 3];
        var o = {
            c: 47,
            dir: n.V,
            sizes: e.VSIZES
          },
          i = {
            c: 175,
            dir: n.H,
            sizes: [.5],
            stretch: [0, 175],
            HDW: [.59, -.544, .5]
          },
          a = {
            c: 710,
            dir: n.H,
            sizes: [.5, .556, 1, 1.444, 1.889]
          },
          Q = {
            c: 732,
            dir: n.H,
            sizes: [.5, .556, 1, 1.444, 1.889]
          },
          s = {
            c: 8211,
            dir: n.H,
            sizes: [.5],
            stretch: [0, 8211],
            HDW: [.285, -.248, .5]
          },
          T = {
            c: 8592,
            dir: n.H,
            sizes: [1],
            stretch: [8592, 8722],
            HDW: e.HDW3
          },
          l = {
            c: 8594,
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8594],
            HDW: e.HDW3
          },
          c = {
            c: 8596,
            dir: n.H,
            sizes: [1],
            stretch: [8592, 8722, 8594],
            HDW: e.HDW3
          },
          u = {
            c: 8612,
            dir: n.H,
            stretch: [8592, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          p = {
            c: 8614,
            dir: n.H,
            sizes: [1],
            stretch: [8739, 8722, 8594],
            HDW: e.HDW3
          },
          h = {
            c: 8656,
            dir: n.H,
            sizes: [1],
            stretch: [8656, 61],
            HDW: e.HDW3
          },
          d = {
            c: 8658,
            dir: n.H,
            sizes: [1],
            stretch: [0, 61, 8658],
            HDW: e.HDW3
          },
          f = {
            c: 8660,
            dir: n.H,
            sizes: [1],
            stretch: [8656, 61, 8658],
            HDW: e.HDW3
          },
          m = {
            c: 8722,
            dir: n.H,
            sizes: [.778],
            stretch: [0, 8722],
            HDW: e.HDW3
          },
          L = {
            c: 8739,
            dir: n.V,
            sizes: [1],
            stretch: [0, 8739],
            HDW: [.627, .015, .333]
          },
          y = {
            c: 9180,
            dir: n.H,
            sizes: [.778, 1],
            schar: [8994, 8994],
            variants: [5, 0],
            stretch: [57680, 57684, 57681],
            HDW: [.32, .2, .5]
          },
          g = {
            c: 9181,
            dir: n.H,
            sizes: [.778, 1],
            schar: [8995, 8995],
            variants: [5, 0],
            stretch: [57682, 57684, 57683],
            HDW: [.32, .2, .5]
          },
          v = {
            c: 9182,
            dir: n.H,
            stretch: [57680, 57684, 57681, 57685],
            HDW: [.32, .2, .5],
            min: 1.8
          },
          b = {
            c: 9183,
            dir: n.H,
            stretch: [57682, 57684, 57683, 57686],
            HDW: [.32, .2, .5],
            min: 1.8
          },
          H = {
            c: 10216,
            dir: n.V,
            sizes: e.VSIZES
          },
          _ = {
            c: 10217,
            dir: n.V,
            sizes: e.VSIZES
          },
          M = {
            c: 10502,
            dir: n.H,
            stretch: [8656, 61, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          x = {
            c: 10503,
            dir: n.H,
            stretch: [8872, 61, 8658],
            HDW: e.HDW3,
            min: 1.278
          };
        e.delimiters = {
          40: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9115, 9116, 9117],
            HDW: [.85, .349, .875]
          },
          41: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9118, 9119, 9120],
            HDW: [.85, .349, .875]
          },
          45: m,
          47: o,
          61: {
            dir: n.H,
            sizes: [.778],
            stretch: [0, 61],
            HDW: e.HDW3
          },
          91: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9121, 9122, 9123],
            HDW: e.HDW2
          },
          92: {
            dir: n.V,
            sizes: e.VSIZES
          },
          93: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9124, 9125, 9126],
            HDW: e.HDW2
          },
          94: a,
          95: s,
          123: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9127, 9130, 9129, 9128],
            HDW: [.85, .349, .889]
          },
          124: {
            dir: n.V,
            sizes: [1],
            stretch: [0, 8739],
            HDW: [.75, .25, .333]
          },
          125: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9131, 9130, 9133, 9132],
            HDW: [.85, .349, .889]
          },
          126: Q,
          175: i,
          710: a,
          713: i,
          732: Q,
          770: a,
          771: Q,
          818: s,
          8211: s,
          8212: s,
          8213: s,
          8214: {
            dir: n.V,
            sizes: [.602, 1],
            schar: [0, 8741],
            variants: [1, 0],
            stretch: [0, 8741],
            HDW: [.602, 0, .556]
          },
          8215: s,
          8254: i,
          8407: l,
          8592: T,
          8593: {
            dir: n.V,
            sizes: [.888],
            stretch: [8593, 9168],
            HDW: [.6, 0, .667]
          },
          8594: l,
          8595: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8595],
            HDW: [.6, 0, .667]
          },
          8596: c,
          8597: {
            dir: n.V,
            sizes: [1.044],
            stretch: [8593, 9168, 8595],
            HDW: e.HDW1
          },
          8606: {
            dir: n.H,
            sizes: [1],
            stretch: [8606, 8722],
            HDW: e.HDW3
          },
          8608: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8608],
            HDW: e.HDW3
          },
          8612: u,
          8613: {
            dir: n.V,
            stretch: [8593, 9168, 8869],
            HDW: e.HDW1,
            min: 1.555
          },
          8614: p,
          8615: {
            dir: n.V,
            stretch: [8868, 9168, 8595],
            HDW: e.HDW1,
            min: 1.555
          },
          8624: {
            dir: n.V,
            sizes: [.722],
            stretch: [8624, 9168],
            HDW: e.HDW1
          },
          8625: {
            dir: n.V,
            sizes: [.722],
            stretch: [8625, 9168],
            HDW: e.HDW1
          },
          8636: {
            dir: n.H,
            sizes: [1],
            stretch: [8636, 8722],
            HDW: e.HDW3
          },
          8637: {
            dir: n.H,
            sizes: [1],
            stretch: [8637, 8722],
            HDW: e.HDW3
          },
          8638: {
            dir: n.V,
            sizes: [.888],
            stretch: [8638, 9168],
            HDW: e.HDW1
          },
          8639: {
            dir: n.V,
            sizes: [.888],
            stretch: [8639, 9168],
            HDW: e.HDW1
          },
          8640: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8640],
            HDW: e.HDW3
          },
          8641: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8722, 8641],
            HDW: e.HDW3
          },
          8642: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8642],
            HDW: e.HDW1
          },
          8643: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 9168, 8643],
            HDW: e.HDW1
          },
          8656: h,
          8657: {
            dir: n.V,
            sizes: [.888],
            stretch: [8657, 8214],
            HDW: [.599, 0, .778]
          },
          8658: d,
          8659: {
            dir: n.V,
            sizes: [.888],
            stretch: [0, 8214, 8659],
            HDW: [.6, 0, .778]
          },
          8660: f,
          8661: {
            dir: n.V,
            sizes: [1.044],
            stretch: [8657, 8214, 8659],
            HDW: [.75, .25, .778]
          },
          8666: {
            dir: n.H,
            sizes: [1],
            stretch: [8666, 8801],
            HDW: [.464, -.036, .5]
          },
          8667: {
            dir: n.H,
            sizes: [1],
            stretch: [0, 8801, 8667],
            HDW: [.464, -.036, .5]
          },
          8722: m,
          8725: o,
          8730: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [57345, 57344, 9143],
            fullExt: [.65, 2.3],
            HDW: [.85, .35, 1.056]
          },
          8739: L,
          8741: {
            dir: n.V,
            sizes: [1],
            stretch: [0, 8741],
            HDW: [.627, .015, .556]
          },
          8968: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9121, 9122],
            HDW: e.HDW2
          },
          8969: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [9124, 9125],
            HDW: e.HDW2
          },
          8970: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [0, 9122, 9123],
            HDW: e.HDW2
          },
          8971: {
            dir: n.V,
            sizes: e.VSIZES,
            stretch: [0, 9125, 9126],
            HDW: e.HDW2
          },
          8978: y,
          8994: y,
          8995: g,
          9001: H,
          9002: _,
          9130: {
            dir: n.V,
            sizes: [.32],
            stretch: [9130, 9130, 9130],
            HDW: [.29, .015, .889]
          },
          9135: s,
          9136: {
            dir: n.V,
            sizes: [.989],
            stretch: [9127, 9130, 9133],
            HDW: [.75, .25, .889]
          },
          9137: {
            dir: n.V,
            sizes: [.989],
            stretch: [9131, 9130, 9129],
            HDW: [.75, .25, .889]
          },
          9140: {
            dir: n.H,
            stretch: [9484, 8722, 9488],
            HDW: e.HDW3,
            min: 1
          },
          9141: {
            dir: n.H,
            stretch: [9492, 8722, 9496],
            HDW: e.HDW3,
            min: 1
          },
          9168: {
            dir: n.V,
            sizes: [.602, 1],
            schar: [0, 8739],
            variants: [1, 0],
            stretch: [0, 8739],
            HDW: [.602, 0, .333]
          },
          9180: y,
          9181: g,
          9182: v,
          9183: b,
          9184: {
            dir: n.H,
            stretch: [714, 713, 715],
            HDW: [.59, -.544, .5],
            min: 1
          },
          9185: {
            dir: n.H,
            stretch: [715, 713, 714],
            HDW: [.59, -.544, .5],
            min: 1
          },
          9472: s,
          10072: L,
          10216: H,
          10217: _,
          10222: {
            dir: n.V,
            sizes: [.989],
            stretch: [9127, 9130, 9129],
            HDW: [.75, .25, .889]
          },
          10223: {
            dir: n.V,
            sizes: [.989],
            stretch: [9131, 9130, 9133],
            HDW: [.75, .25, .889]
          },
          10229: T,
          10230: l,
          10231: c,
          10232: h,
          10233: d,
          10234: f,
          10235: u,
          10236: p,
          10237: M,
          10238: x,
          10502: M,
          10503: x,
          10574: {
            dir: n.H,
            stretch: [8636, 8722, 8640],
            HDW: e.HDW3,
            min: 2
          },
          10575: {
            dir: n.V,
            stretch: [8638, 9168, 8642],
            HDW: e.HDW1,
            min: 1.776
          },
          10576: {
            dir: n.H,
            stretch: [8637, 8722, 8641],
            HDW: e.HDW3,
            min: 2
          },
          10577: {
            dir: n.V,
            stretch: [8639, 9168, 8643],
            HDW: e.HDW1,
            min: .5
          },
          10586: {
            dir: n.H,
            stretch: [8636, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          10587: {
            dir: n.H,
            stretch: [8739, 8722, 8640],
            HDW: e.HDW3,
            min: 1.278
          },
          10588: {
            dir: n.V,
            stretch: [8638, 9168, 8869],
            HDW: e.HDW1,
            min: 1.556
          },
          10589: {
            dir: n.V,
            stretch: [8868, 9168, 8642],
            HDW: e.HDW1,
            min: 1.556
          },
          10590: {
            dir: n.H,
            stretch: [8637, 8722, 8739],
            HDW: e.HDW3,
            min: 1.278
          },
          10591: {
            dir: n.H,
            stretch: [8739, 8722, 8641],
            HDW: e.HDW3,
            min: 1.278
          },
          10592: {
            dir: n.V,
            stretch: [8639, 9168, 8869],
            HDW: e.HDW1,
            min: 1.776
          },
          10593: {
            dir: n.V,
            stretch: [8868, 9168, 8643],
            HDW: e.HDW1,
            min: 1.776
          },
          12296: H,
          12297: _,
          65079: v,
          65080: b
        };
      },
      6001: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.doubleStruck = void 0, e.doubleStruck = {};
      },
      3696: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.frakturBold = void 0, e.frakturBold = {
          33: [.689, .012, .349],
          34: [.695, -.432, .254],
          38: [.696, .016, .871],
          39: [.695, -.436, .25],
          40: [.737, .186, .459],
          41: [.735, .187, .459],
          42: [.692, -.449, .328],
          43: [.598, .082, .893],
          44: [.107, .191, .328],
          45: [.275, -.236, .893],
          46: [.102, .015, .328],
          47: [.721, .182, .593],
          48: [.501, .012, .593],
          49: [.489, 0, .593],
          50: [.491, 0, .593],
          51: [.487, .193, .593],
          52: [.495, .196, .593],
          53: [.481, .19, .593],
          54: [.704, .012, .593],
          55: [.479, .197, .593],
          56: [.714, .005, .593],
          57: [.487, .195, .593],
          58: [.457, .012, .255],
          59: [.458, .19, .255],
          61: [.343, -.168, .582],
          63: [.697, .014, .428],
          91: [.74, .13, .257],
          93: [.738, .132, .257],
          94: [.734, -.452, .59],
          8216: [.708, -.411, .254],
          8217: [.692, -.394, .254],
          8260: [.721, .182, .593],
          58113: [.63, .027, .587],
          58114: [.693, .212, .394, {
            ic: .014
          }],
          58115: [.681, .219, .387],
          58116: [.473, .212, .593],
          58117: [.684, .027, .393],
          58120: [.679, .22, .981],
          58121: [.717, .137, .727]
        };
      },
      9587: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fraktur = void 0, e.fraktur = {
          33: [.689, .012, .296],
          34: [.695, -.432, .215],
          38: [.698, .011, .738],
          39: [.695, -.436, .212],
          40: [.737, .186, .389],
          41: [.735, .187, .389],
          42: [.692, -.449, .278],
          43: [.598, .082, .756],
          44: [.107, .191, .278],
          45: [.275, -.236, .756],
          46: [.102, .015, .278],
          47: [.721, .182, .502],
          48: [.492, .013, .502],
          49: [.468, 0, .502],
          50: [.474, 0, .502],
          51: [.473, .182, .502],
          52: [.476, .191, .502],
          53: [.458, .184, .502],
          54: [.7, .013, .502],
          55: [.468, .181, .502],
          56: [.705, .01, .502],
          57: [.469, .182, .502],
          58: [.457, .012, .216],
          59: [.458, .189, .216],
          61: [.368, -.132, .756],
          63: [.693, .011, .362],
          91: [.74, .13, .278],
          93: [.738, .131, .278],
          94: [.734, -.452, .5],
          8216: [.708, -.41, .215],
          8217: [.692, -.395, .215],
          8260: [.721, .182, .502],
          58112: [.683, .032, .497],
          58113: [.616, .03, .498],
          58114: [.68, .215, .333],
          58115: [.679, .224, .329],
          58116: [.471, .214, .503],
          58117: [.686, .02, .333],
          58118: [.577, .021, .334, {
            ic: .013
          }],
          58119: [.475, .022, .501, {
            ic: .013
          }]
        };
      },
      8348: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.italic = void 0, e.italic = {
          33: [.716, 0, .307, {
            ic: .073
          }],
          34: [.694, -.379, .514, {
            ic: .024
          }],
          35: [.694, .194, .818, {
            ic: .01
          }],
          37: [.75, .056, .818, {
            ic: .029
          }],
          38: [.716, .022, .767, {
            ic: .035
          }],
          39: [.694, -.379, .307, {
            ic: .07
          }],
          40: [.75, .25, .409, {
            ic: .108
          }],
          41: [.75, .25, .409],
          42: [.75, -.32, .511, {
            ic: .073
          }],
          43: [.557, .057, .767],
          44: [.121, .194, .307],
          45: [.251, -.18, .358],
          46: [.121, 0, .307],
          47: [.716, .215, .778],
          48: [.665, .021, .511, {
            ic: .051
          }],
          49: [.666, 0, .511],
          50: [.666, .022, .511, {
            ic: .04
          }],
          51: [.666, .022, .511, {
            ic: .051
          }],
          52: [.666, .194, .511],
          53: [.666, .022, .511, {
            ic: .056
          }],
          54: [.665, .022, .511, {
            ic: .054
          }],
          55: [.666, .022, .511, {
            ic: .123
          }],
          56: [.666, .021, .511, {
            ic: .042
          }],
          57: [.666, .022, .511, {
            ic: .042
          }],
          58: [.431, 0, .307],
          59: [.431, .194, .307],
          61: [.367, -.133, .767],
          63: [.716, 0, .511, {
            ic: .04
          }],
          64: [.705, .011, .767, {
            ic: .022
          }],
          91: [.75, .25, .307, {
            ic: .139
          }],
          93: [.75, .25, .307, {
            ic: .052
          }],
          94: [.694, -.527, .511, {
            ic: .017
          }],
          95: [-.025, .062, .511, {
            ic: .043
          }],
          126: [.318, -.208, .511, {
            ic: .06
          }],
          305: [.441, .01, .307, {
            ic: .033
          }],
          567: [.442, .204, .332],
          768: [.697, -.5, 0],
          769: [.697, -.5, 0, {
            ic: .039
          }],
          770: [.694, -.527, 0, {
            ic: .017
          }],
          771: [.668, -.558, 0, {
            ic: .06
          }],
          772: [.589, -.544, 0, {
            ic: .054
          }],
          774: [.694, -.515, 0, {
            ic: .062
          }],
          775: [.669, -.548, 0],
          776: [.669, -.554, 0, {
            ic: .045
          }],
          778: [.716, -.542, 0],
          779: [.697, -.503, 0, {
            ic: .065
          }],
          780: [.638, -.502, 0, {
            ic: .029
          }],
          989: [.605, .085, .778],
          8211: [.285, -.248, .511, {
            ic: .043
          }],
          8212: [.285, -.248, 1.022, {
            ic: .016
          }],
          8213: [.285, -.248, 1.022, {
            ic: .016
          }],
          8215: [-.025, .062, .511, {
            ic: .043
          }],
          8216: [.694, -.379, .307, {
            ic: .055
          }],
          8217: [.694, -.379, .307, {
            ic: .07
          }],
          8220: [.694, -.379, .514, {
            ic: .092
          }],
          8221: [.694, -.379, .514, {
            ic: .024
          }],
          8260: [.716, .215, .778],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8710: [.716, 0, .833, {
            sk: .167
          }],
          10744: [.716, .215, .778]
        };
      },
      1376: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.largeop = void 0, e.largeop = {
          40: [1.15, .649, .597],
          41: [1.15, .649, .597],
          47: [1.15, .649, .811],
          91: [1.15, .649, .472],
          92: [1.15, .649, .811],
          93: [1.15, .649, .472],
          123: [1.15, .649, .667],
          125: [1.15, .649, .667],
          710: [.772, -.565, 1],
          732: [.75, -.611, 1],
          770: [.772, -.565, 0],
          771: [.75, -.611, 0],
          8214: [.602, 0, .778],
          8260: [1.15, .649, .811],
          8593: [.6, 0, .667],
          8595: [.6, 0, .667],
          8657: [.599, 0, .778],
          8659: [.6, 0, .778],
          8719: [.95, .45, 1.278],
          8720: [.95, .45, 1.278],
          8721: [.95, .45, 1.444],
          8730: [1.15, .65, 1, {
            ic: .02
          }],
          8739: [.627, .015, .333],
          8741: [.627, .015, .556],
          8747: [1.36, .862, .556, {
            ic: .388
          }],
          8748: [1.36, .862, 1.084, {
            ic: .388
          }],
          8749: [1.36, .862, 1.592, {
            ic: .388
          }],
          8750: [1.36, .862, .556, {
            ic: .388
          }],
          8896: [.95, .45, 1.111],
          8897: [.95, .45, 1.111],
          8898: [.949, .45, 1.111],
          8899: [.95, .449, 1.111],
          8968: [1.15, .649, .528],
          8969: [1.15, .649, .528],
          8970: [1.15, .649, .528],
          8971: [1.15, .649, .528],
          9001: [1.15, .649, .611],
          9002: [1.15, .649, .611],
          9168: [.602, 0, .667],
          10072: [.627, .015, .333],
          10216: [1.15, .649, .611],
          10217: [1.15, .649, .611],
          10752: [.949, .449, 1.511],
          10753: [.949, .449, 1.511],
          10754: [.949, .449, 1.511],
          10756: [.95, .449, 1.111],
          10758: [.95, .45, 1.111],
          10764: [1.36, .862, 2.168, {
            ic: .388
          }],
          12296: [1.15, .649, .611],
          12297: [1.15, .649, .611]
        };
      },
      1439: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.monospace = void 0, e.monospace = {
          32: [0, 0, .525],
          33: [.622, 0, .525],
          34: [.623, -.333, .525],
          35: [.611, 0, .525],
          36: [.694, .082, .525],
          37: [.694, .083, .525],
          38: [.622, .011, .525],
          39: [.611, -.287, .525],
          40: [.694, .082, .525],
          41: [.694, .082, .525],
          42: [.52, -.09, .525],
          43: [.531, -.081, .525],
          44: [.14, .139, .525],
          45: [.341, -.271, .525],
          46: [.14, 0, .525],
          47: [.694, .083, .525],
          58: [.431, 0, .525],
          59: [.431, .139, .525],
          60: [.557, -.055, .525],
          61: [.417, -.195, .525],
          62: [.557, -.055, .525],
          63: [.617, 0, .525],
          64: [.617, .006, .525],
          91: [.694, .082, .525],
          92: [.694, .083, .525],
          93: [.694, .082, .525],
          94: [.611, -.46, .525],
          95: [-.025, .095, .525],
          96: [.681, -.357, .525],
          123: [.694, .083, .525],
          124: [.694, .082, .525],
          125: [.694, .083, .525],
          126: [.611, -.466, .525],
          127: [.612, -.519, .525],
          160: [0, 0, .525],
          305: [.431, 0, .525],
          567: [.431, .228, .525],
          697: [.623, -.334, .525],
          768: [.611, -.485, 0],
          769: [.611, -.485, 0],
          770: [.611, -.46, 0],
          771: [.611, -.466, 0],
          772: [.577, -.5, 0],
          774: [.611, -.504, 0],
          776: [.612, -.519, 0],
          778: [.619, -.499, 0],
          780: [.577, -.449, 0],
          913: [.623, 0, .525],
          914: [.611, 0, .525],
          915: [.611, 0, .525],
          916: [.623, 0, .525],
          917: [.611, 0, .525],
          918: [.611, 0, .525],
          919: [.611, 0, .525],
          920: [.621, .01, .525],
          921: [.611, 0, .525],
          922: [.611, 0, .525],
          923: [.623, 0, .525],
          924: [.611, 0, .525],
          925: [.611, 0, .525],
          926: [.611, 0, .525],
          927: [.621, .01, .525],
          928: [.611, 0, .525],
          929: [.611, 0, .525],
          931: [.611, 0, .525],
          932: [.611, 0, .525],
          933: [.622, 0, .525],
          934: [.611, 0, .525],
          935: [.611, 0, .525],
          936: [.611, 0, .525],
          937: [.622, 0, .525],
          8215: [-.025, .095, .525],
          8242: [.623, -.334, .525],
          8243: [.623, 0, 1.05],
          8244: [.623, 0, 1.575],
          8260: [.694, .083, .525],
          8279: [.623, 0, 2.1],
          8710: [.623, 0, .525]
        };
      },
      331: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.normal = void 0, e.normal = {
          32: [0, 0, .25],
          33: [.716, 0, .278],
          34: [.694, -.379, .5],
          35: [.694, .194, .833],
          36: [.75, .056, .5],
          37: [.75, .056, .833],
          38: [.716, .022, .778],
          39: [.694, -.379, .278],
          40: [.75, .25, .389],
          41: [.75, .25, .389],
          42: [.75, -.32, .5],
          43: [.583, .082, .778],
          44: [.121, .194, .278],
          45: [.252, -.179, .333],
          46: [.12, 0, .278],
          47: [.75, .25, .5],
          48: [.666, .022, .5],
          49: [.666, 0, .5],
          50: [.666, 0, .5],
          51: [.665, .022, .5],
          52: [.677, 0, .5],
          53: [.666, .022, .5],
          54: [.666, .022, .5],
          55: [.676, .022, .5],
          56: [.666, .022, .5],
          57: [.666, .022, .5],
          58: [.43, 0, .278],
          59: [.43, .194, .278],
          60: [.54, .04, .778],
          61: [.583, .082, .778],
          62: [.54, .04, .778],
          63: [.705, 0, .472],
          64: [.705, .011, .778],
          65: [.716, 0, .75],
          66: [.683, 0, .708],
          67: [.705, .021, .722],
          68: [.683, 0, .764],
          69: [.68, 0, .681],
          70: [.68, 0, .653],
          71: [.705, .022, .785],
          72: [.683, 0, .75],
          73: [.683, 0, .361],
          74: [.683, .022, .514],
          75: [.683, 0, .778],
          76: [.683, 0, .625],
          77: [.683, 0, .917],
          78: [.683, 0, .75],
          79: [.705, .022, .778],
          80: [.683, 0, .681],
          81: [.705, .193, .778],
          82: [.683, .022, .736],
          83: [.705, .022, .556],
          84: [.677, 0, .722],
          85: [.683, .022, .75],
          86: [.683, .022, .75],
          87: [.683, .022, 1.028],
          88: [.683, 0, .75],
          89: [.683, 0, .75],
          90: [.683, 0, .611],
          91: [.75, .25, .278],
          92: [.75, .25, .5],
          93: [.75, .25, .278],
          94: [.694, -.531, .5],
          95: [-.025, .062, .5],
          96: [.699, -.505, .5],
          97: [.448, .011, .5],
          98: [.694, .011, .556],
          99: [.448, .011, .444],
          100: [.694, .011, .556],
          101: [.448, .011, .444],
          102: [.705, 0, .306, {
            ic: .066
          }],
          103: [.453, .206, .5],
          104: [.694, 0, .556],
          105: [.669, 0, .278],
          106: [.669, .205, .306],
          107: [.694, 0, .528],
          108: [.694, 0, .278],
          109: [.442, 0, .833],
          110: [.442, 0, .556],
          111: [.448, .01, .5],
          112: [.442, .194, .556],
          113: [.442, .194, .528],
          114: [.442, 0, .392],
          115: [.448, .011, .394],
          116: [.615, .01, .389],
          117: [.442, .011, .556],
          118: [.431, .011, .528],
          119: [.431, .011, .722],
          120: [.431, 0, .528],
          121: [.431, .204, .528],
          122: [.431, 0, .444],
          123: [.75, .25, .5],
          124: [.75, .249, .278],
          125: [.75, .25, .5],
          126: [.318, -.215, .5],
          160: [0, 0, .25],
          163: [.714, .011, .769],
          165: [.683, 0, .75],
          168: [.669, -.554, .5],
          172: [.356, -.089, .667],
          174: [.709, .175, .947],
          175: [.59, -.544, .5],
          176: [.715, -.542, .5],
          177: [.666, 0, .778],
          180: [.699, -.505, .5],
          183: [.31, -.19, .278],
          215: [.491, -.009, .778],
          240: [.749, .021, .556],
          247: [.537, .036, .778],
          305: [.442, 0, .278, {
            sk: .0278
          }],
          567: [.442, .205, .306, {
            sk: .0833
          }],
          697: [.56, -.043, .275],
          710: [.694, -.531, .5],
          711: [.644, -.513, .5],
          713: [.59, -.544, .5],
          714: [.699, -.505, .5],
          715: [.699, -.505, .5],
          728: [.694, -.515, .5],
          729: [.669, -.549, .5],
          730: [.715, -.542, .5],
          732: [.668, -.565, .5],
          768: [.699, -.505, 0],
          769: [.699, -.505, 0],
          770: [.694, -.531, 0],
          771: [.668, -.565, 0],
          772: [.59, -.544, 0],
          774: [.694, -.515, 0],
          775: [.669, -.549, 0],
          776: [.669, -.554, 0],
          778: [.715, -.542, 0],
          779: [.701, -.51, 0],
          780: [.644, -.513, 0],
          824: [.716, .215, 0],
          913: [.716, 0, .75],
          914: [.683, 0, .708],
          915: [.68, 0, .625],
          916: [.716, 0, .833],
          917: [.68, 0, .681],
          918: [.683, 0, .611],
          919: [.683, 0, .75],
          920: [.705, .022, .778],
          921: [.683, 0, .361],
          922: [.683, 0, .778],
          923: [.716, 0, .694],
          924: [.683, 0, .917],
          925: [.683, 0, .75],
          926: [.677, 0, .667],
          927: [.705, .022, .778],
          928: [.68, 0, .75],
          929: [.683, 0, .681],
          931: [.683, 0, .722],
          932: [.677, 0, .722],
          933: [.705, 0, .778],
          934: [.683, 0, .722],
          935: [.683, 0, .75],
          936: [.683, 0, .778],
          937: [.704, 0, .722],
          8192: [0, 0, .5],
          8193: [0, 0, 1],
          8194: [0, 0, .5],
          8195: [0, 0, 1],
          8196: [0, 0, .333],
          8197: [0, 0, .25],
          8198: [0, 0, .167],
          8201: [0, 0, .167],
          8202: [0, 0, .1],
          8203: [0, 0, 0],
          8204: [0, 0, 0],
          8211: [.285, -.248, .5],
          8212: [.285, -.248, 1],
          8213: [.285, -.248, 1],
          8214: [.75, .25, .5],
          8215: [-.025, .062, .5],
          8216: [.694, -.379, .278],
          8217: [.694, -.379, .278],
          8220: [.694, -.379, .5],
          8221: [.694, -.379, .5],
          8224: [.705, .216, .444],
          8225: [.705, .205, .444],
          8226: [.444, -.055, .5],
          8230: [.12, 0, 1.172],
          8242: [.56, -.043, .275],
          8243: [.56, 0, .55],
          8244: [.56, 0, .825],
          8245: [.56, -.043, .275],
          8246: [.56, 0, .55],
          8247: [.56, 0, .825],
          8254: [.59, -.544, .5],
          8260: [.75, .25, .5],
          8279: [.56, 0, 1.1],
          8288: [0, 0, 0],
          8289: [0, 0, 0],
          8290: [0, 0, 0],
          8291: [0, 0, 0],
          8292: [0, 0, 0],
          8407: [.714, -.516, .5],
          8450: [.702, .019, .722],
          8459: [.717, .036, .969, {
            ic: .272,
            sk: .333
          }],
          8460: [.666, .133, .72],
          8461: [.683, 0, .778],
          8462: [.694, .011, .576, {
            sk: -.0278
          }],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8464: [.717, .017, .809, {
            ic: .137,
            sk: .333
          }],
          8465: [.686, .026, .554],
          8466: [.717, .017, .874, {
            ic: .161,
            sk: .306
          }],
          8467: [.705, .02, .417, {
            sk: .111
          }],
          8469: [.683, .02, .722],
          8472: [.453, .216, .636, {
            sk: .111
          }],
          8473: [.683, 0, .611],
          8474: [.701, .181, .778],
          8475: [.717, .017, .85, {
            ic: .037,
            sk: .194
          }],
          8476: [.686, .026, .828],
          8477: [.683, 0, .722],
          8484: [.683, 0, .667],
          8486: [.704, 0, .722],
          8487: [.684, .022, .722],
          8488: [.729, .139, .602],
          8492: [.708, .028, .908, {
            ic: .02,
            sk: .194
          }],
          8493: [.685, .024, .613],
          8496: [.707, .008, .562, {
            ic: .156,
            sk: .139
          }],
          8497: [.735, .036, .895, {
            ic: .095,
            sk: .222
          }],
          8498: [.695, 0, .556],
          8499: [.721, .05, 1.08, {
            ic: .136,
            sk: .444
          }],
          8501: [.694, 0, .611],
          8502: [.763, .021, .667, {
            ic: .02
          }],
          8503: [.764, .043, .444],
          8504: [.764, .043, .667],
          8513: [.705, .023, .639],
          8592: [.511, .011, 1],
          8593: [.694, .193, .5],
          8594: [.511, .011, 1],
          8595: [.694, .194, .5],
          8596: [.511, .011, 1],
          8597: [.772, .272, .5],
          8598: [.72, .195, 1],
          8599: [.72, .195, 1],
          8600: [.695, .22, 1],
          8601: [.695, .22, 1],
          8602: [.437, -.06, 1],
          8603: [.437, -.06, 1],
          8606: [.417, -.083, 1],
          8608: [.417, -.083, 1],
          8610: [.417, -.083, 1.111],
          8611: [.417, -.083, 1.111],
          8614: [.511, .011, 1],
          8617: [.511, .011, 1.126],
          8618: [.511, .011, 1.126],
          8619: [.575, .041, 1],
          8620: [.575, .041, 1],
          8621: [.417, -.083, 1.389],
          8622: [.437, -.06, 1],
          8624: [.722, 0, .5],
          8625: [.722, 0, .5],
          8630: [.461, 0, 1],
          8631: [.46, 0, 1],
          8634: [.65, .083, .778],
          8635: [.65, .083, .778],
          8636: [.511, -.23, 1],
          8637: [.27, .011, 1],
          8638: [.694, .194, .417],
          8639: [.694, .194, .417],
          8640: [.511, -.23, 1],
          8641: [.27, .011, 1],
          8642: [.694, .194, .417],
          8643: [.694, .194, .417],
          8644: [.667, 0, 1],
          8646: [.667, 0, 1],
          8647: [.583, .083, 1],
          8648: [.694, .193, .833],
          8649: [.583, .083, 1],
          8650: [.694, .194, .833],
          8651: [.514, .014, 1],
          8652: [.671, .011, 1],
          8653: [.534, .035, 1],
          8654: [.534, .037, 1],
          8655: [.534, .035, 1],
          8656: [.525, .024, 1],
          8657: [.694, .194, .611],
          8658: [.525, .024, 1],
          8659: [.694, .194, .611],
          8660: [.526, .025, 1],
          8661: [.772, .272, .611],
          8666: [.611, .111, 1],
          8667: [.611, .111, 1],
          8669: [.417, -.083, 1],
          8672: [.437, -.064, 1.334],
          8674: [.437, -.064, 1.334],
          8704: [.694, .022, .556],
          8705: [.846, .021, .5],
          8706: [.715, .022, .531, {
            ic: .035,
            sk: .0833
          }],
          8707: [.694, 0, .556],
          8708: [.716, .215, .556],
          8709: [.772, .078, .5],
          8710: [.716, 0, .833],
          8711: [.683, .033, .833],
          8712: [.54, .04, .667],
          8713: [.716, .215, .667],
          8715: [.54, .04, .667],
          8716: [.716, .215, .667],
          8717: [.44, 0, .429, {
            ic: .027
          }],
          8719: [.75, .25, .944],
          8720: [.75, .25, .944],
          8721: [.75, .25, 1.056],
          8722: [.583, .082, .778],
          8723: [.5, .166, .778],
          8724: [.766, .093, .778],
          8725: [.75, .25, .5],
          8726: [.75, .25, .5],
          8727: [.465, -.035, .5],
          8728: [.444, -.055, .5],
          8729: [.444, -.055, .5],
          8730: [.8, .2, .833, {
            ic: .02
          }],
          8733: [.442, .011, .778],
          8734: [.442, .011, 1],
          8736: [.694, 0, .722],
          8737: [.714, .02, .722],
          8738: [.551, .051, .722],
          8739: [.75, .249, .278],
          8740: [.75, .252, .278, {
            ic: .019
          }],
          8741: [.75, .25, .5],
          8742: [.75, .25, .5, {
            ic: .018
          }],
          8743: [.598, .022, .667],
          8744: [.598, .022, .667],
          8745: [.598, .022, .667],
          8746: [.598, .022, .667],
          8747: [.716, .216, .417, {
            ic: .055
          }],
          8748: [.805, .306, .819, {
            ic: .138
          }],
          8749: [.805, .306, 1.166, {
            ic: .138
          }],
          8750: [.805, .306, .472, {
            ic: .138
          }],
          8756: [.471, .082, .667],
          8757: [.471, .082, .667],
          8764: [.367, -.133, .778],
          8765: [.367, -.133, .778],
          8768: [.583, .083, .278],
          8769: [.467, -.032, .778],
          8770: [.463, -.034, .778],
          8771: [.464, -.036, .778],
          8772: [.716, .215, .778],
          8773: [.589, -.022, .778],
          8775: [.652, .155, .778],
          8776: [.483, -.055, .778],
          8777: [.716, .215, .778],
          8778: [.579, .039, .778],
          8781: [.484, -.016, .778],
          8782: [.492, -.008, .778],
          8783: [.492, -.133, .778],
          8784: [.67, -.133, .778],
          8785: [.609, .108, .778],
          8786: [.601, .101, .778],
          8787: [.601, .102, .778],
          8790: [.367, -.133, .778],
          8791: [.721, -.133, .778],
          8796: [.859, -.133, .778],
          8800: [.716, .215, .778],
          8801: [.464, -.036, .778],
          8802: [.716, .215, .778],
          8804: [.636, .138, .778],
          8805: [.636, .138, .778],
          8806: [.753, .175, .778],
          8807: [.753, .175, .778],
          8808: [.752, .286, .778],
          8809: [.752, .286, .778],
          8810: [.568, .067, 1],
          8811: [.567, .067, 1],
          8812: [.75, .25, .5],
          8813: [.716, .215, .778],
          8814: [.708, .209, .778],
          8815: [.708, .209, .778],
          8816: [.801, .303, .778],
          8817: [.801, .303, .778],
          8818: [.732, .228, .778],
          8819: [.732, .228, .778],
          8820: [.732, .228, .778],
          8821: [.732, .228, .778],
          8822: [.681, .253, .778],
          8823: [.681, .253, .778],
          8824: [.716, .253, .778],
          8825: [.716, .253, .778],
          8826: [.539, .041, .778],
          8827: [.539, .041, .778],
          8828: [.58, .153, .778],
          8829: [.58, .154, .778],
          8830: [.732, .228, .778],
          8831: [.732, .228, .778],
          8832: [.705, .208, .778],
          8833: [.705, .208, .778],
          8834: [.54, .04, .778],
          8835: [.54, .04, .778],
          8836: [.716, .215, .778],
          8837: [.716, .215, .778],
          8838: [.636, .138, .778],
          8839: [.636, .138, .778],
          8840: [.801, .303, .778],
          8841: [.801, .303, .778],
          8842: [.635, .241, .778],
          8843: [.635, .241, .778],
          8846: [.598, .022, .667],
          8847: [.539, .041, .778],
          8848: [.539, .041, .778],
          8849: [.636, .138, .778],
          8850: [.636, .138, .778],
          8851: [.598, 0, .667],
          8852: [.598, 0, .667],
          8853: [.583, .083, .778],
          8854: [.583, .083, .778],
          8855: [.583, .083, .778],
          8856: [.583, .083, .778],
          8857: [.583, .083, .778],
          8858: [.582, .082, .778],
          8859: [.582, .082, .778],
          8861: [.582, .082, .778],
          8862: [.689, 0, .778],
          8863: [.689, 0, .778],
          8864: [.689, 0, .778],
          8865: [.689, 0, .778],
          8866: [.694, 0, .611],
          8867: [.694, 0, .611],
          8868: [.668, 0, .778],
          8869: [.668, 0, .778],
          8872: [.75, .249, .867],
          8873: [.694, 0, .722],
          8874: [.694, 0, .889],
          8876: [.695, 0, .611],
          8877: [.695, 0, .611],
          8878: [.695, 0, .722],
          8879: [.695, 0, .722],
          8882: [.539, .041, .778],
          8883: [.539, .041, .778],
          8884: [.636, .138, .778],
          8885: [.636, .138, .778],
          8888: [.408, -.092, 1.111],
          8890: [.431, .212, .556],
          8891: [.716, 0, .611],
          8892: [.716, 0, .611],
          8896: [.75, .249, .833],
          8897: [.75, .249, .833],
          8898: [.75, .249, .833],
          8899: [.75, .249, .833],
          8900: [.488, -.012, .5],
          8901: [.31, -.19, .278],
          8902: [.486, -.016, .5],
          8903: [.545, .044, .778],
          8904: [.505, .005, .9],
          8905: [.492, -.008, .778],
          8906: [.492, -.008, .778],
          8907: [.694, .022, .778],
          8908: [.694, .022, .778],
          8909: [.464, -.036, .778],
          8910: [.578, .021, .76],
          8911: [.578, .022, .76],
          8912: [.54, .04, .778],
          8913: [.54, .04, .778],
          8914: [.598, .022, .667],
          8915: [.598, .022, .667],
          8916: [.736, .022, .667],
          8918: [.541, .041, .778],
          8919: [.541, .041, .778],
          8920: [.568, .067, 1.333],
          8921: [.568, .067, 1.333],
          8922: [.886, .386, .778],
          8923: [.886, .386, .778],
          8926: [.734, 0, .778],
          8927: [.734, 0, .778],
          8928: [.801, .303, .778],
          8929: [.801, .303, .778],
          8930: [.716, .215, .778],
          8931: [.716, .215, .778],
          8934: [.73, .359, .778],
          8935: [.73, .359, .778],
          8936: [.73, .359, .778],
          8937: [.73, .359, .778],
          8938: [.706, .208, .778],
          8939: [.706, .208, .778],
          8940: [.802, .303, .778],
          8941: [.801, .303, .778],
          8942: [1.3, .03, .278],
          8943: [.31, -.19, 1.172],
          8945: [1.52, -.1, 1.282],
          8965: [.716, 0, .611],
          8966: [.813, .097, .611],
          8968: [.75, .25, .444],
          8969: [.75, .25, .444],
          8970: [.75, .25, .444],
          8971: [.75, .25, .444],
          8988: [.694, -.306, .5],
          8989: [.694, -.306, .5],
          8990: [.366, .022, .5],
          8991: [.366, .022, .5],
          8994: [.388, -.122, 1],
          8995: [.378, -.134, 1],
          9001: [.75, .25, .389],
          9002: [.75, .25, .389],
          9136: [.744, .244, .412],
          9137: [.744, .244, .412],
          9168: [.602, 0, .667],
          9416: [.709, .175, .902],
          9484: [.694, -.306, .5],
          9488: [.694, -.306, .5],
          9492: [.366, .022, .5],
          9496: [.366, .022, .5],
          9585: [.694, .195, .889],
          9586: [.694, .195, .889],
          9632: [.689, 0, .778],
          9633: [.689, 0, .778],
          9642: [.689, 0, .778],
          9650: [.575, .02, .722],
          9651: [.716, 0, .889],
          9652: [.575, .02, .722],
          9653: [.716, 0, .889],
          9654: [.539, .041, .778],
          9656: [.539, .041, .778],
          9657: [.505, .005, .5],
          9660: [.576, .019, .722],
          9661: [.5, .215, .889],
          9662: [.576, .019, .722],
          9663: [.5, .215, .889],
          9664: [.539, .041, .778],
          9666: [.539, .041, .778],
          9667: [.505, .005, .5],
          9674: [.716, .132, .667],
          9711: [.715, .215, 1],
          9723: [.689, 0, .778],
          9724: [.689, 0, .778],
          9733: [.694, .111, .944],
          9824: [.727, .13, .778],
          9825: [.716, .033, .778],
          9826: [.727, .162, .778],
          9827: [.726, .13, .778],
          9837: [.75, .022, .389],
          9838: [.734, .223, .389],
          9839: [.723, .223, .389],
          10003: [.706, .034, .833],
          10016: [.716, .022, .833],
          10072: [.75, .249, .278],
          10216: [.75, .25, .389],
          10217: [.75, .25, .389],
          10222: [.744, .244, .412],
          10223: [.744, .244, .412],
          10229: [.511, .011, 1.609],
          10230: [.511, .011, 1.638],
          10231: [.511, .011, 1.859],
          10232: [.525, .024, 1.609],
          10233: [.525, .024, 1.638],
          10234: [.525, .024, 1.858],
          10236: [.511, .011, 1.638],
          10731: [.716, .132, .667],
          10744: [.716, .215, .778],
          10752: [.75, .25, 1.111],
          10753: [.75, .25, 1.111],
          10754: [.75, .25, 1.111],
          10756: [.75, .249, .833],
          10758: [.75, .249, .833],
          10764: [.805, .306, 1.638, {
            ic: .138
          }],
          10799: [.491, -.009, .778],
          10815: [.683, 0, .75],
          10846: [.813, .097, .611],
          10877: [.636, .138, .778],
          10878: [.636, .138, .778],
          10885: [.762, .29, .778],
          10886: [.762, .29, .778],
          10887: [.635, .241, .778],
          10888: [.635, .241, .778],
          10889: [.761, .387, .778],
          10890: [.761, .387, .778],
          10891: [1.003, .463, .778],
          10892: [1.003, .463, .778],
          10901: [.636, .138, .778],
          10902: [.636, .138, .778],
          10927: [.636, .138, .778],
          10928: [.636, .138, .778],
          10933: [.752, .286, .778],
          10934: [.752, .286, .778],
          10935: [.761, .294, .778],
          10936: [.761, .294, .778],
          10937: [.761, .337, .778],
          10938: [.761, .337, .778],
          10949: [.753, .215, .778],
          10950: [.753, .215, .778],
          10955: [.783, .385, .778],
          10956: [.783, .385, .778],
          12296: [.75, .25, .389],
          12297: [.75, .25, .389],
          57350: [.43, .023, .222, {
            ic: .018
          }],
          57351: [.431, .024, .389, {
            ic: .018
          }],
          57352: [.605, .085, .778],
          57353: [.434, .006, .667, {
            ic: .067
          }],
          57356: [.752, .284, .778],
          57357: [.752, .284, .778],
          57358: [.919, .421, .778],
          57359: [.801, .303, .778],
          57360: [.801, .303, .778],
          57361: [.919, .421, .778],
          57366: [.828, .33, .778],
          57367: [.752, .332, .778],
          57368: [.828, .33, .778],
          57369: [.752, .333, .778],
          57370: [.634, .255, .778],
          57371: [.634, .254, .778],
          119808: [.698, 0, .869],
          119809: [.686, 0, .818],
          119810: [.697, .011, .831],
          119811: [.686, 0, .882],
          119812: [.68, 0, .756],
          119813: [.68, 0, .724],
          119814: [.697, .01, .904],
          119815: [.686, 0, .9],
          119816: [.686, 0, .436],
          119817: [.686, .011, .594],
          119818: [.686, 0, .901],
          119819: [.686, 0, .692],
          119820: [.686, 0, 1.092],
          119821: [.686, 0, .9],
          119822: [.696, .01, .864],
          119823: [.686, 0, .786],
          119824: [.696, .193, .864],
          119825: [.686, .011, .862],
          119826: [.697, .011, .639],
          119827: [.675, 0, .8],
          119828: [.686, .011, .885],
          119829: [.686, .007, .869],
          119830: [.686, .007, 1.189],
          119831: [.686, 0, .869],
          119832: [.686, 0, .869],
          119833: [.686, 0, .703],
          119834: [.453, .006, .559],
          119835: [.694, .006, .639],
          119836: [.453, .006, .511],
          119837: [.694, .006, .639],
          119838: [.452, .006, .527],
          119839: [.7, 0, .351, {
            ic: .101
          }],
          119840: [.455, .201, .575],
          119841: [.694, 0, .639],
          119842: [.695, 0, .319],
          119843: [.695, .2, .351],
          119844: [.694, 0, .607],
          119845: [.694, 0, .319],
          119846: [.45, 0, .958],
          119847: [.45, 0, .639],
          119848: [.452, .005, .575],
          119849: [.45, .194, .639],
          119850: [.45, .194, .607],
          119851: [.45, 0, .474],
          119852: [.453, .006, .454],
          119853: [.635, .005, .447],
          119854: [.45, .006, .639],
          119855: [.444, 0, .607],
          119856: [.444, 0, .831],
          119857: [.444, 0, .607],
          119858: [.444, .2, .607],
          119859: [.444, 0, .511],
          119860: [.716, 0, .75, {
            sk: .139
          }],
          119861: [.683, 0, .759, {
            sk: .0833
          }],
          119862: [.705, .022, .715, {
            ic: .045,
            sk: .0833
          }],
          119863: [.683, 0, .828, {
            sk: .0556
          }],
          119864: [.68, 0, .738, {
            ic: .026,
            sk: .0833
          }],
          119865: [.68, 0, .643, {
            ic: .106,
            sk: .0833
          }],
          119866: [.705, .022, .786, {
            sk: .0833
          }],
          119867: [.683, 0, .831, {
            ic: .057,
            sk: .0556
          }],
          119868: [.683, 0, .44, {
            ic: .064,
            sk: .111
          }],
          119869: [.683, .022, .555, {
            ic: .078,
            sk: .167
          }],
          119870: [.683, 0, .849, {
            ic: .04,
            sk: .0556
          }],
          119871: [.683, 0, .681, {
            sk: .0278
          }],
          119872: [.683, 0, .97, {
            ic: .081,
            sk: .0833
          }],
          119873: [.683, 0, .803, {
            ic: .085,
            sk: .0833
          }],
          119874: [.704, .022, .763, {
            sk: .0833
          }],
          119875: [.683, 0, .642, {
            ic: .109,
            sk: .0833
          }],
          119876: [.704, .194, .791, {
            sk: .0833
          }],
          119877: [.683, .021, .759, {
            sk: .0833
          }],
          119878: [.705, .022, .613, {
            ic: .032,
            sk: .0833
          }],
          119879: [.677, 0, .584, {
            ic: .12,
            sk: .0833
          }],
          119880: [.683, .022, .683, {
            ic: .084,
            sk: .0278
          }],
          119881: [.683, .022, .583, {
            ic: .186
          }],
          119882: [.683, .022, .944, {
            ic: .104
          }],
          119883: [.683, 0, .828, {
            ic: .024,
            sk: .0833
          }],
          119884: [.683, 0, .581, {
            ic: .182
          }],
          119885: [.683, 0, .683, {
            ic: .04,
            sk: .0833
          }],
          119886: [.441, .01, .529],
          119887: [.694, .011, .429],
          119888: [.442, .011, .433, {
            sk: .0556
          }],
          119889: [.694, .01, .52, {
            sk: .167
          }],
          119890: [.442, .011, .466, {
            sk: .0556
          }],
          119891: [.705, .205, .49, {
            ic: .06,
            sk: .167
          }],
          119892: [.442, .205, .477, {
            sk: .0278
          }],
          119894: [.661, .011, .345],
          119895: [.661, .204, .412],
          119896: [.694, .011, .521],
          119897: [.694, .011, .298, {
            sk: .0833
          }],
          119898: [.442, .011, .878],
          119899: [.442, .011, .6],
          119900: [.441, .011, .485, {
            sk: .0556
          }],
          119901: [.442, .194, .503, {
            sk: .0833
          }],
          119902: [.442, .194, .446, {
            ic: .014,
            sk: .0833
          }],
          119903: [.442, .011, .451, {
            sk: .0556
          }],
          119904: [.442, .01, .469, {
            sk: .0556
          }],
          119905: [.626, .011, .361, {
            sk: .0833
          }],
          119906: [.442, .011, .572, {
            sk: .0278
          }],
          119907: [.443, .011, .485, {
            sk: .0278
          }],
          119908: [.443, .011, .716, {
            sk: .0833
          }],
          119909: [.442, .011, .572, {
            sk: .0278
          }],
          119910: [.442, .205, .49, {
            sk: .0556
          }],
          119911: [.442, .011, .465, {
            sk: .0556
          }],
          119912: [.711, 0, .869, {
            sk: .16
          }],
          119913: [.686, 0, .866, {
            sk: .0958
          }],
          119914: [.703, .017, .817, {
            ic: .038,
            sk: .0958
          }],
          119915: [.686, 0, .938, {
            sk: .0639
          }],
          119916: [.68, 0, .81, {
            ic: .015,
            sk: .0958
          }],
          119917: [.68, 0, .689, {
            ic: .12,
            sk: .0958
          }],
          119918: [.703, .016, .887, {
            sk: .0958
          }],
          119919: [.686, 0, .982, {
            ic: .045,
            sk: .0639
          }],
          119920: [.686, 0, .511, {
            ic: .062,
            sk: .128
          }],
          119921: [.686, .017, .631, {
            ic: .063,
            sk: .192
          }],
          119922: [.686, 0, .971, {
            ic: .032,
            sk: .0639
          }],
          119923: [.686, 0, .756, {
            sk: .0319
          }],
          119924: [.686, 0, 1.142, {
            ic: .077,
            sk: .0958
          }],
          119925: [.686, 0, .95, {
            ic: .077,
            sk: .0958
          }],
          119926: [.703, .017, .837, {
            sk: .0958
          }],
          119927: [.686, 0, .723, {
            ic: .124,
            sk: .0958
          }],
          119928: [.703, .194, .869, {
            sk: .0958
          }],
          119929: [.686, .017, .872, {
            sk: .0958
          }],
          119930: [.703, .017, .693, {
            ic: .021,
            sk: .0958
          }],
          119931: [.675, 0, .637, {
            ic: .135,
            sk: .0958
          }],
          119932: [.686, .016, .8, {
            ic: .077,
            sk: .0319
          }],
          119933: [.686, .016, .678, {
            ic: .208
          }],
          119934: [.686, .017, 1.093, {
            ic: .114
          }],
          119935: [.686, 0, .947, {
            sk: .0958
          }],
          119936: [.686, 0, .675, {
            ic: .201
          }],
          119937: [.686, 0, .773, {
            ic: .032,
            sk: .0958
          }],
          119938: [.452, .008, .633],
          119939: [.694, .008, .521],
          119940: [.451, .008, .513, {
            sk: .0639
          }],
          119941: [.694, .008, .61, {
            sk: .192
          }],
          119942: [.452, .008, .554, {
            sk: .0639
          }],
          119943: [.701, .201, .568, {
            ic: .056,
            sk: .192
          }],
          119944: [.452, .202, .545, {
            sk: .0319
          }],
          119945: [.694, .008, .668, {
            sk: -.0319
          }],
          119946: [.694, .008, .405],
          119947: [.694, .202, .471],
          119948: [.694, .008, .604],
          119949: [.694, .008, .348, {
            sk: .0958
          }],
          119950: [.452, .008, 1.032],
          119951: [.452, .008, .713],
          119952: [.452, .008, .585, {
            sk: .0639
          }],
          119953: [.452, .194, .601, {
            sk: .0958
          }],
          119954: [.452, .194, .542, {
            sk: .0958
          }],
          119955: [.452, .008, .529, {
            sk: .0639
          }],
          119956: [.451, .008, .531, {
            sk: .0639
          }],
          119957: [.643, .007, .415, {
            sk: .0958
          }],
          119958: [.452, .008, .681, {
            sk: .0319
          }],
          119959: [.453, .008, .567, {
            sk: .0319
          }],
          119960: [.453, .008, .831, {
            sk: .0958
          }],
          119961: [.452, .008, .659, {
            sk: .0319
          }],
          119962: [.452, .202, .59, {
            sk: .0639
          }],
          119963: [.452, .008, .555, {
            sk: .0639
          }],
          119964: [.717, .008, .803, {
            ic: .213,
            sk: .389
          }],
          119966: [.728, .026, .666, {
            ic: .153,
            sk: .278
          }],
          119967: [.708, .031, .774, {
            ic: .081,
            sk: .111
          }],
          119970: [.717, .037, .61, {
            ic: .128,
            sk: .25
          }],
          119973: [.717, .314, 1.052, {
            ic: .081,
            sk: .417
          }],
          119974: [.717, .037, .914, {
            ic: .29,
            sk: .361
          }],
          119977: [.726, .036, .902, {
            ic: .306,
            sk: .389
          }],
          119978: [.707, .008, .738, {
            ic: .067,
            sk: .167
          }],
          119979: [.716, .037, 1.013, {
            ic: .018,
            sk: .222
          }],
          119980: [.717, .017, .883, {
            sk: .278
          }],
          119982: [.708, .036, .868, {
            ic: .148,
            sk: .333
          }],
          119983: [.735, .037, .747, {
            ic: .249,
            sk: .222
          }],
          119984: [.717, .017, .8, {
            ic: .16,
            sk: .25
          }],
          119985: [.717, .017, .622, {
            ic: .228,
            sk: .222
          }],
          119986: [.717, .017, .805, {
            ic: .221,
            sk: .25
          }],
          119987: [.717, .017, .944, {
            ic: .187,
            sk: .278
          }],
          119988: [.716, .017, .71, {
            ic: .249,
            sk: .194
          }],
          119989: [.717, .016, .821, {
            ic: .211,
            sk: .306
          }],
          120068: [.696, .026, .718],
          120069: [.691, .027, .884],
          120071: [.685, .027, .832],
          120072: [.685, .024, .663],
          120073: [.686, .153, .611],
          120074: [.69, .026, .785],
          120077: [.686, .139, .552],
          120078: [.68, .027, .668, {
            ic: .014
          }],
          120079: [.686, .026, .666],
          120080: [.692, .027, 1.05],
          120081: [.686, .025, .832],
          120082: [.729, .027, .827],
          120083: [.692, .218, .828],
          120084: [.729, .069, .827],
          120086: [.692, .027, .829],
          120087: [.701, .027, .669],
          120088: [.697, .027, .646, {
            ic: .019
          }],
          120089: [.686, .026, .831],
          120090: [.686, .027, 1.046],
          120091: [.688, .027, .719],
          120092: [.686, .218, .833],
          120094: [.47, .035, .5],
          120095: [.685, .031, .513],
          120096: [.466, .029, .389],
          120097: [.609, .033, .499],
          120098: [.467, .03, .401],
          120099: [.681, .221, .326],
          120100: [.47, .209, .504],
          120101: [.688, .205, .521],
          120102: [.673, .02, .279],
          120103: [.672, .208, .281],
          120104: [.689, .025, .389],
          120105: [.685, .02, .28],
          120106: [.475, .026, .767],
          120107: [.475, .022, .527],
          120108: [.48, .028, .489],
          120109: [.541, .212, .5],
          120110: [.479, .219, .489],
          120111: [.474, .021, .389],
          120112: [.478, .029, .443],
          120113: [.64, .02, .333, {
            ic: .015
          }],
          120114: [.474, .023, .517],
          120115: [.53, .028, .512],
          120116: [.532, .028, .774],
          120117: [.472, .188, .389],
          120118: [.528, .218, .499],
          120119: [.471, .214, .391],
          120120: [.701, 0, .722],
          120121: [.683, 0, .667],
          120123: [.683, 0, .722],
          120124: [.683, 0, .667],
          120125: [.683, 0, .611],
          120126: [.702, .019, .778],
          120128: [.683, 0, .389],
          120129: [.683, .077, .5],
          120130: [.683, 0, .778],
          120131: [.683, 0, .667],
          120132: [.683, 0, .944],
          120134: [.701, .019, .778],
          120138: [.702, .012, .556],
          120139: [.683, 0, .667],
          120140: [.683, .019, .722],
          120141: [.683, .02, .722],
          120142: [.683, .019, 1],
          120143: [.683, 0, .722],
          120144: [.683, 0, .722],
          120172: [.686, .031, .847],
          120173: [.684, .031, 1.044],
          120174: [.676, .032, .723],
          120175: [.683, .029, .982],
          120176: [.686, .029, .783],
          120177: [.684, .146, .722],
          120178: [.687, .029, .927],
          120179: [.683, .126, .851],
          120180: [.681, .025, .655],
          120181: [.68, .141, .652],
          120182: [.681, .026, .789, {
            ic: .017
          }],
          120183: [.683, .028, .786],
          120184: [.683, .032, 1.239],
          120185: [.679, .03, .983],
          120186: [.726, .03, .976],
          120187: [.688, .223, .977],
          120188: [.726, .083, .976],
          120189: [.688, .028, .978],
          120190: [.685, .031, .978],
          120191: [.686, .03, .79, {
            ic: .012
          }],
          120192: [.688, .039, .851, {
            ic: .02
          }],
          120193: [.685, .029, .982],
          120194: [.683, .03, 1.235],
          120195: [.681, .035, .849],
          120196: [.688, .214, .984],
          120197: [.677, .148, .711],
          120198: [.472, .032, .603],
          120199: [.69, .032, .59],
          120200: [.473, .026, .464],
          120201: [.632, .028, .589],
          120202: [.471, .027, .472],
          120203: [.687, .222, .388],
          120204: [.472, .208, .595],
          120205: [.687, .207, .615],
          120206: [.686, .025, .331],
          120207: [.682, .203, .332],
          120208: [.682, .025, .464],
          120209: [.681, .024, .337],
          120210: [.476, .031, .921],
          120211: [.473, .028, .654],
          120212: [.482, .034, .609],
          120213: [.557, .207, .604],
          120214: [.485, .211, .596],
          120215: [.472, .026, .46],
          120216: [.479, .034, .523],
          120217: [.648, .027, .393, {
            ic: .014
          }],
          120218: [.472, .032, .589, {
            ic: .014
          }],
          120219: [.546, .027, .604],
          120220: [.549, .032, .918],
          120221: [.471, .188, .459],
          120222: [.557, .221, .589],
          120223: [.471, .214, .461],
          120224: [.694, 0, .667],
          120225: [.694, 0, .667],
          120226: [.705, .011, .639],
          120227: [.694, 0, .722],
          120228: [.691, 0, .597],
          120229: [.691, 0, .569],
          120230: [.704, .011, .667],
          120231: [.694, 0, .708],
          120232: [.694, 0, .278],
          120233: [.694, .022, .472],
          120234: [.694, 0, .694],
          120235: [.694, 0, .542],
          120236: [.694, 0, .875],
          120237: [.694, 0, .708],
          120238: [.715, .022, .736],
          120239: [.694, 0, .639],
          120240: [.715, .125, .736],
          120241: [.694, 0, .646],
          120242: [.716, .022, .556],
          120243: [.688, 0, .681],
          120244: [.694, .022, .688],
          120245: [.694, 0, .667],
          120246: [.694, 0, .944],
          120247: [.694, 0, .667],
          120248: [.694, 0, .667],
          120249: [.694, 0, .611],
          120250: [.46, .01, .481],
          120251: [.694, .011, .517],
          120252: [.46, .01, .444],
          120253: [.694, .01, .517],
          120254: [.461, .01, .444],
          120255: [.705, 0, .306, {
            ic: .041
          }],
          120256: [.455, .206, .5],
          120257: [.694, 0, .517],
          120258: [.68, 0, .239],
          120259: [.68, .205, .267],
          120260: [.694, 0, .489],
          120261: [.694, 0, .239],
          120262: [.455, 0, .794],
          120263: [.455, 0, .517],
          120264: [.46, .01, .5],
          120265: [.455, .194, .517],
          120266: [.455, .194, .517],
          120267: [.455, 0, .342],
          120268: [.46, .01, .383],
          120269: [.571, .01, .361],
          120270: [.444, .01, .517],
          120271: [.444, 0, .461],
          120272: [.444, 0, .683],
          120273: [.444, 0, .461],
          120274: [.444, .204, .461],
          120275: [.444, 0, .435],
          120276: [.694, 0, .733],
          120277: [.694, 0, .733],
          120278: [.704, .011, .703],
          120279: [.694, 0, .794],
          120280: [.691, 0, .642],
          120281: [.691, 0, .611],
          120282: [.705, .011, .733],
          120283: [.694, 0, .794],
          120284: [.694, 0, .331],
          120285: [.694, .022, .519],
          120286: [.694, 0, .764],
          120287: [.694, 0, .581],
          120288: [.694, 0, .978],
          120289: [.694, 0, .794],
          120290: [.716, .022, .794],
          120291: [.694, 0, .703],
          120292: [.716, .106, .794],
          120293: [.694, 0, .703],
          120294: [.716, .022, .611],
          120295: [.688, 0, .733],
          120296: [.694, .022, .764],
          120297: [.694, 0, .733],
          120298: [.694, 0, 1.039],
          120299: [.694, 0, .733],
          120300: [.694, 0, .733],
          120301: [.694, 0, .672],
          120302: [.475, .011, .525],
          120303: [.694, .01, .561],
          120304: [.475, .011, .489],
          120305: [.694, .011, .561],
          120306: [.474, .01, .511],
          120307: [.705, 0, .336, {
            ic: .045
          }],
          120308: [.469, .206, .55],
          120309: [.694, 0, .561],
          120310: [.695, 0, .256],
          120311: [.695, .205, .286],
          120312: [.694, 0, .531],
          120313: [.694, 0, .256],
          120314: [.469, 0, .867],
          120315: [.468, 0, .561],
          120316: [.474, .011, .55],
          120317: [.469, .194, .561],
          120318: [.469, .194, .561],
          120319: [.469, 0, .372],
          120320: [.474, .01, .422],
          120321: [.589, .01, .404],
          120322: [.458, .011, .561],
          120323: [.458, 0, .5],
          120324: [.458, 0, .744],
          120325: [.458, 0, .5],
          120326: [.458, .205, .5],
          120327: [.458, 0, .476],
          120328: [.694, 0, .667],
          120329: [.694, 0, .667, {
            ic: .029
          }],
          120330: [.705, .01, .639, {
            ic: .08
          }],
          120331: [.694, 0, .722, {
            ic: .025
          }],
          120332: [.691, 0, .597, {
            ic: .091
          }],
          120333: [.691, 0, .569, {
            ic: .104
          }],
          120334: [.705, .011, .667, {
            ic: .063
          }],
          120335: [.694, 0, .708, {
            ic: .06
          }],
          120336: [.694, 0, .278, {
            ic: .06
          }],
          120337: [.694, .022, .472, {
            ic: .063
          }],
          120338: [.694, 0, .694, {
            ic: .091
          }],
          120339: [.694, 0, .542],
          120340: [.694, 0, .875, {
            ic: .054
          }],
          120341: [.694, 0, .708, {
            ic: .058
          }],
          120342: [.716, .022, .736, {
            ic: .027
          }],
          120343: [.694, 0, .639, {
            ic: .051
          }],
          120344: [.716, .125, .736, {
            ic: .027
          }],
          120345: [.694, 0, .646, {
            ic: .052
          }],
          120346: [.716, .022, .556, {
            ic: .053
          }],
          120347: [.688, 0, .681, {
            ic: .109
          }],
          120348: [.694, .022, .688, {
            ic: .059
          }],
          120349: [.694, 0, .667, {
            ic: .132
          }],
          120350: [.694, 0, .944, {
            ic: .132
          }],
          120351: [.694, 0, .667, {
            ic: .091
          }],
          120352: [.694, 0, .667, {
            ic: .143
          }],
          120353: [.694, 0, .611, {
            ic: .091
          }],
          120354: [.461, .01, .481],
          120355: [.694, .011, .517, {
            ic: .022
          }],
          120356: [.46, .011, .444, {
            ic: .055
          }],
          120357: [.694, .01, .517, {
            ic: .071
          }],
          120358: [.46, .011, .444, {
            ic: .028
          }],
          120359: [.705, 0, .306, {
            ic: .188
          }],
          120360: [.455, .206, .5, {
            ic: .068
          }],
          120361: [.694, 0, .517],
          120362: [.68, 0, .239, {
            ic: .076
          }],
          120363: [.68, .204, .267, {
            ic: .069
          }],
          120364: [.694, 0, .489, {
            ic: .054
          }],
          120365: [.694, 0, .239, {
            ic: .072
          }],
          120366: [.455, 0, .794],
          120367: [.454, 0, .517],
          120368: [.461, .011, .5, {
            ic: .023
          }],
          120369: [.455, .194, .517, {
            ic: .021
          }],
          120370: [.455, .194, .517, {
            ic: .021
          }],
          120371: [.455, 0, .342, {
            ic: .082
          }],
          120372: [.461, .011, .383, {
            ic: .053
          }],
          120373: [.571, .011, .361, {
            ic: .049
          }],
          120374: [.444, .01, .517, {
            ic: .02
          }],
          120375: [.444, 0, .461, {
            ic: .079
          }],
          120376: [.444, 0, .683, {
            ic: .079
          }],
          120377: [.444, 0, .461, {
            ic: .076
          }],
          120378: [.444, .205, .461, {
            ic: .079
          }],
          120379: [.444, 0, .435, {
            ic: .059
          }],
          120432: [.623, 0, .525],
          120433: [.611, 0, .525],
          120434: [.622, .011, .525],
          120435: [.611, 0, .525],
          120436: [.611, 0, .525],
          120437: [.611, 0, .525],
          120438: [.622, .011, .525],
          120439: [.611, 0, .525],
          120440: [.611, 0, .525],
          120441: [.611, .011, .525],
          120442: [.611, 0, .525],
          120443: [.611, 0, .525],
          120444: [.611, 0, .525],
          120445: [.611, 0, .525],
          120446: [.621, .01, .525],
          120447: [.611, 0, .525],
          120448: [.621, .138, .525],
          120449: [.611, .011, .525],
          120450: [.622, .011, .525],
          120451: [.611, 0, .525],
          120452: [.611, .011, .525],
          120453: [.611, .007, .525],
          120454: [.611, .007, .525],
          120455: [.611, 0, .525],
          120456: [.611, 0, .525],
          120457: [.611, 0, .525],
          120458: [.439, .006, .525],
          120459: [.611, .006, .525],
          120460: [.44, .006, .525],
          120461: [.611, .006, .525],
          120462: [.44, .006, .525],
          120463: [.617, 0, .525],
          120464: [.442, .229, .525],
          120465: [.611, 0, .525],
          120466: [.612, 0, .525],
          120467: [.612, .228, .525],
          120468: [.611, 0, .525],
          120469: [.611, 0, .525],
          120470: [.436, 0, .525, {
            ic: .011
          }],
          120471: [.436, 0, .525],
          120472: [.44, .006, .525],
          120473: [.437, .221, .525],
          120474: [.437, .221, .525, {
            ic: .02
          }],
          120475: [.437, 0, .525],
          120476: [.44, .006, .525],
          120477: [.554, .006, .525],
          120478: [.431, .005, .525],
          120479: [.431, 0, .525],
          120480: [.431, 0, .525],
          120481: [.431, 0, .525],
          120482: [.431, .228, .525],
          120483: [.431, 0, .525],
          120488: [.698, 0, .869],
          120489: [.686, 0, .818],
          120490: [.68, 0, .692],
          120491: [.698, 0, .958],
          120492: [.68, 0, .756],
          120493: [.686, 0, .703],
          120494: [.686, 0, .9],
          120495: [.696, .01, .894],
          120496: [.686, 0, .436],
          120497: [.686, 0, .901],
          120498: [.698, 0, .806],
          120499: [.686, 0, 1.092],
          120500: [.686, 0, .9],
          120501: [.675, 0, .767],
          120502: [.696, .01, .864],
          120503: [.68, 0, .9],
          120504: [.686, 0, .786],
          120506: [.686, 0, .831],
          120507: [.675, 0, .8],
          120508: [.697, 0, .894],
          120509: [.686, 0, .831],
          120510: [.686, 0, .869],
          120511: [.686, 0, .894],
          120512: [.696, 0, .831],
          120513: [.686, .024, .958],
          120546: [.716, 0, .75, {
            sk: .139
          }],
          120547: [.683, 0, .759, {
            sk: .0833
          }],
          120548: [.68, 0, .615, {
            ic: .106,
            sk: .0833
          }],
          120549: [.716, 0, .833, {
            sk: .167
          }],
          120550: [.68, 0, .738, {
            ic: .026,
            sk: .0833
          }],
          120551: [.683, 0, .683, {
            ic: .04,
            sk: .0833
          }],
          120552: [.683, 0, .831, {
            ic: .057,
            sk: .0556
          }],
          120553: [.704, .022, .763, {
            sk: .0833
          }],
          120554: [.683, 0, .44, {
            ic: .064,
            sk: .111
          }],
          120555: [.683, 0, .849, {
            ic: .04,
            sk: .0556
          }],
          120556: [.716, 0, .694, {
            sk: .167
          }],
          120557: [.683, 0, .97, {
            ic: .081,
            sk: .0833
          }],
          120558: [.683, 0, .803, {
            ic: .085,
            sk: .0833
          }],
          120559: [.677, 0, .742, {
            ic: .035,
            sk: .0833
          }],
          120560: [.704, .022, .763, {
            sk: .0833
          }],
          120561: [.68, 0, .831, {
            ic: .056,
            sk: .0556
          }],
          120562: [.683, 0, .642, {
            ic: .109,
            sk: .0833
          }],
          120564: [.683, 0, .78, {
            ic: .026,
            sk: .0833
          }],
          120565: [.677, 0, .584, {
            ic: .12,
            sk: .0833
          }],
          120566: [.705, 0, .583, {
            ic: .117,
            sk: .0556
          }],
          120567: [.683, 0, .667, {
            sk: .0833
          }],
          120568: [.683, 0, .828, {
            ic: .024,
            sk: .0833
          }],
          120569: [.683, 0, .612, {
            ic: .08,
            sk: .0556
          }],
          120570: [.704, 0, .772, {
            ic: .014,
            sk: .0833
          }],
          120572: [.442, .011, .64, {
            sk: .0278
          }],
          120573: [.705, .194, .566, {
            sk: .0833
          }],
          120574: [.441, .216, .518, {
            ic: .025
          }],
          120575: [.717, .01, .444, {
            sk: .0556
          }],
          120576: [.452, .022, .466, {
            sk: .0833
          }],
          120577: [.704, .204, .438, {
            ic: .033,
            sk: .0833
          }],
          120578: [.442, .216, .497, {
            sk: .0556
          }],
          120579: [.705, .01, .469, {
            sk: .0833
          }],
          120580: [.442, .01, .354, {
            sk: .0556
          }],
          120581: [.442, .011, .576],
          120582: [.694, .012, .583],
          120583: [.442, .216, .603, {
            sk: .0278
          }],
          120584: [.442, 0, .494, {
            ic: .036,
            sk: .0278
          }],
          120585: [.704, .205, .438, {
            sk: .111
          }],
          120586: [.441, .011, .485, {
            sk: .0556
          }],
          120587: [.431, .011, .57],
          120588: [.442, .216, .517, {
            sk: .0833
          }],
          120589: [.442, .107, .363, {
            ic: .042,
            sk: .0833
          }],
          120590: [.431, .011, .571],
          120591: [.431, .013, .437, {
            ic: .08,
            sk: .0278
          }],
          120592: [.443, .01, .54, {
            sk: .0278
          }],
          120593: [.442, .218, .654, {
            sk: .0833
          }],
          120594: [.442, .204, .626, {
            sk: .0556
          }],
          120595: [.694, .205, .651, {
            sk: .111
          }],
          120596: [.443, .011, .622],
          120597: [.715, .022, .531, {
            ic: .035,
            sk: .0833
          }],
          120598: [.431, .011, .406, {
            sk: .0556
          }],
          120599: [.705, .011, .591, {
            sk: .0833
          }],
          120600: [.434, .006, .667, {
            ic: .067
          }],
          120601: [.694, .205, .596, {
            sk: .0833
          }],
          120602: [.442, .194, .517, {
            sk: .0833
          }],
          120603: [.431, .01, .828],
          120604: [.711, 0, .869, {
            sk: .16
          }],
          120605: [.686, 0, .866, {
            sk: .0958
          }],
          120606: [.68, 0, .657, {
            ic: .12,
            sk: .0958
          }],
          120607: [.711, 0, .958, {
            sk: .192
          }],
          120608: [.68, 0, .81, {
            ic: .015,
            sk: .0958
          }],
          120609: [.686, 0, .773, {
            ic: .032,
            sk: .0958
          }],
          120610: [.686, 0, .982, {
            ic: .045,
            sk: .0639
          }],
          120611: [.702, .017, .867, {
            sk: .0958
          }],
          120612: [.686, 0, .511, {
            ic: .062,
            sk: .128
          }],
          120613: [.686, 0, .971, {
            ic: .032,
            sk: .0639
          }],
          120614: [.711, 0, .806, {
            sk: .192
          }],
          120615: [.686, 0, 1.142, {
            ic: .077,
            sk: .0958
          }],
          120616: [.686, 0, .95, {
            ic: .077,
            sk: .0958
          }],
          120617: [.675, 0, .841, {
            ic: .026,
            sk: .0958
          }],
          120618: [.703, .017, .837, {
            sk: .0958
          }],
          120619: [.68, 0, .982, {
            ic: .044,
            sk: .0639
          }],
          120620: [.686, 0, .723, {
            ic: .124,
            sk: .0958
          }],
          120622: [.686, 0, .885, {
            ic: .017,
            sk: .0958
          }],
          120623: [.675, 0, .637, {
            ic: .135,
            sk: .0958
          }],
          120624: [.703, 0, .671, {
            ic: .131,
            sk: .0639
          }],
          120625: [.686, 0, .767, {
            sk: .0958
          }],
          120626: [.686, 0, .947, {
            sk: .0958
          }],
          120627: [.686, 0, .714, {
            ic: .076,
            sk: .0639
          }],
          120628: [.703, 0, .879, {
            sk: .0958
          }],
          120630: [.452, .008, .761, {
            sk: .0319
          }],
          120631: [.701, .194, .66, {
            sk: .0958
          }],
          120632: [.451, .211, .59, {
            ic: .027
          }],
          120633: [.725, .008, .522, {
            sk: .0639
          }],
          120634: [.461, .017, .529, {
            sk: .0958
          }],
          120635: [.711, .202, .508, {
            ic: .013,
            sk: .0958
          }],
          120636: [.452, .211, .6, {
            sk: .0639
          }],
          120637: [.702, .008, .562, {
            sk: .0958
          }],
          120638: [.452, .008, .412, {
            sk: .0639
          }],
          120639: [.452, .008, .668],
          120640: [.694, .013, .671],
          120641: [.452, .211, .708, {
            sk: .0319
          }],
          120642: [.452, 0, .577, {
            ic: .031,
            sk: .0319
          }],
          120643: [.711, .201, .508, {
            sk: .128
          }],
          120644: [.452, .008, .585, {
            sk: .0639
          }],
          120645: [.444, .008, .682],
          120646: [.451, .211, .612, {
            sk: .0958
          }],
          120647: [.451, .105, .424, {
            ic: .033,
            sk: .0958
          }],
          120648: [.444, .008, .686],
          120649: [.444, .013, .521, {
            ic: .089,
            sk: .0319
          }],
          120650: [.453, .008, .631, {
            sk: .0319
          }],
          120651: [.452, .216, .747, {
            sk: .0958
          }],
          120652: [.452, .201, .718, {
            sk: .0639
          }],
          120653: [.694, .202, .758, {
            sk: .128
          }],
          120654: [.453, .008, .718],
          120655: [.71, .017, .628, {
            ic: .029,
            sk: .0958
          }],
          120656: [.444, .007, .483, {
            sk: .0639
          }],
          120657: [.701, .008, .692, {
            sk: .0958
          }],
          120658: [.434, .006, .667, {
            ic: .067
          }],
          120659: [.694, .202, .712, {
            sk: .0958
          }],
          120660: [.451, .194, .612, {
            sk: .0958
          }],
          120661: [.444, .008, .975],
          120662: [.694, 0, .733],
          120663: [.694, 0, .733],
          120664: [.691, 0, .581],
          120665: [.694, 0, .917],
          120666: [.691, 0, .642],
          120667: [.694, 0, .672],
          120668: [.694, 0, .794],
          120669: [.716, .022, .856],
          120670: [.694, 0, .331],
          120671: [.694, 0, .764],
          120672: [.694, 0, .672],
          120673: [.694, 0, .978],
          120674: [.694, 0, .794],
          120675: [.688, 0, .733],
          120676: [.716, .022, .794],
          120677: [.691, 0, .794],
          120678: [.694, 0, .703],
          120680: [.694, 0, .794],
          120681: [.688, 0, .733],
          120682: [.715, 0, .856],
          120683: [.694, 0, .794],
          120684: [.694, 0, .733],
          120685: [.694, 0, .856],
          120686: [.716, 0, .794],
          120782: [.654, .01, .575],
          120783: [.655, 0, .575],
          120784: [.654, 0, .575],
          120785: [.655, .011, .575],
          120786: [.656, 0, .575],
          120787: [.655, .011, .575],
          120788: [.655, .011, .575],
          120789: [.676, .011, .575],
          120790: [.654, .011, .575],
          120791: [.654, .011, .575],
          120802: [.678, .022, .5],
          120803: [.678, 0, .5],
          120804: [.677, 0, .5],
          120805: [.678, .022, .5],
          120806: [.656, 0, .5],
          120807: [.656, .021, .5],
          120808: [.677, .022, .5],
          120809: [.656, .011, .5],
          120810: [.678, .022, .5],
          120811: [.677, .022, .5],
          120812: [.715, .022, .55],
          120813: [.716, 0, .55],
          120814: [.716, 0, .55],
          120815: [.716, .022, .55],
          120816: [.694, 0, .55],
          120817: [.694, .022, .55],
          120818: [.716, .022, .55],
          120819: [.695, .011, .55],
          120820: [.715, .022, .55],
          120821: [.716, .022, .55],
          120822: [.621, .01, .525],
          120823: [.622, 0, .525],
          120824: [.622, 0, .525],
          120825: [.622, .011, .525],
          120826: [.624, 0, .525],
          120827: [.611, .01, .525],
          120828: [.622, .011, .525],
          120829: [.627, .01, .525],
          120830: [.621, .01, .525],
          120831: [.622, .011, .525]
        };
      },
      4886: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBoldItalic = void 0, e.sansSerifBoldItalic = {
          305: [.458, 0, .256],
          567: [.458, .205, .286]
        };
      },
      4471: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBold = void 0, e.sansSerifBold = {
          33: [.694, 0, .367],
          34: [.694, -.442, .558],
          35: [.694, .193, .917],
          36: [.75, .056, .55],
          37: [.75, .056, 1.029],
          38: [.716, .022, .831],
          39: [.694, -.442, .306],
          40: [.75, .249, .428],
          41: [.75, .25, .428],
          42: [.75, -.293, .55],
          43: [.617, .116, .856],
          44: [.146, .106, .306],
          45: [.273, -.186, .367],
          46: [.146, 0, .306],
          47: [.75, .249, .55],
          58: [.458, 0, .306],
          59: [.458, .106, .306],
          61: [.407, -.094, .856],
          63: [.705, 0, .519],
          64: [.704, .011, .733],
          91: [.75, .25, .343],
          93: [.75, .25, .343],
          94: [.694, -.537, .55],
          95: [-.023, .11, .55],
          126: [.344, -.198, .55],
          305: [.458, 0, .256],
          567: [.458, .205, .286],
          768: [.694, -.537, 0],
          769: [.694, -.537, 0],
          770: [.694, -.537, 0],
          771: [.694, -.548, 0],
          772: [.66, -.56, 0],
          774: [.694, -.552, 0],
          775: [.695, -.596, 0],
          776: [.695, -.595, 0],
          778: [.694, -.538, 0],
          779: [.694, -.537, 0],
          780: [.657, -.5, 0],
          8211: [.327, -.24, .55],
          8212: [.327, -.24, 1.1],
          8213: [.327, -.24, 1.1],
          8215: [-.023, .11, .55],
          8216: [.694, -.443, .306],
          8217: [.694, -.442, .306],
          8220: [.694, -.443, .558],
          8221: [.694, -.442, .558],
          8260: [.75, .249, .55],
          8710: [.694, 0, .917]
        };
      },
      5181: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifItalic = void 0, e.sansSerifItalic = {
          33: [.694, 0, .319, {
            ic: .036
          }],
          34: [.694, -.471, .5],
          35: [.694, .194, .833, {
            ic: .018
          }],
          36: [.75, .056, .5, {
            ic: .065
          }],
          37: [.75, .056, .833],
          38: [.716, .022, .758],
          39: [.694, -.471, .278, {
            ic: .057
          }],
          40: [.75, .25, .389, {
            ic: .102
          }],
          41: [.75, .25, .389],
          42: [.75, -.306, .5, {
            ic: .068
          }],
          43: [.583, .083, .778],
          44: [.098, .125, .278],
          45: [.259, -.186, .333],
          46: [.098, 0, .278],
          47: [.75, .25, .5, {
            ic: .1
          }],
          48: [.678, .022, .5, {
            ic: .049
          }],
          49: [.678, 0, .5],
          50: [.678, 0, .5, {
            ic: .051
          }],
          51: [.678, .022, .5, {
            ic: .044
          }],
          52: [.656, 0, .5, {
            ic: .021
          }],
          53: [.656, .022, .5, {
            ic: .055
          }],
          54: [.678, .022, .5, {
            ic: .048
          }],
          55: [.656, .011, .5, {
            ic: .096
          }],
          56: [.678, .022, .5, {
            ic: .054
          }],
          57: [.677, .022, .5, {
            ic: .045
          }],
          58: [.444, 0, .278],
          59: [.444, .125, .278],
          61: [.37, -.13, .778, {
            ic: .018
          }],
          63: [.704, 0, .472, {
            ic: .064
          }],
          64: [.705, .01, .667, {
            ic: .04
          }],
          91: [.75, .25, .289, {
            ic: .136
          }],
          93: [.75, .25, .289, {
            ic: .064
          }],
          94: [.694, -.527, .5, {
            ic: .033
          }],
          95: [-.038, .114, .5, {
            ic: .065
          }],
          126: [.327, -.193, .5, {
            ic: .06
          }],
          305: [.444, 0, .239, {
            ic: .019
          }],
          567: [.444, .204, .267, {
            ic: .019
          }],
          768: [.694, -.527, 0],
          769: [.694, -.527, 0, {
            ic: .063
          }],
          770: [.694, -.527, 0, {
            ic: .033
          }],
          771: [.677, -.543, 0, {
            ic: .06
          }],
          772: [.631, -.552, 0, {
            ic: .064
          }],
          774: [.694, -.508, 0, {
            ic: .073
          }],
          775: [.68, -.576, 0],
          776: [.68, -.582, 0, {
            ic: .04
          }],
          778: [.693, -.527, 0],
          779: [.694, -.527, 0, {
            ic: .063
          }],
          780: [.654, -.487, 0, {
            ic: .06
          }],
          913: [.694, 0, .667],
          914: [.694, 0, .667, {
            ic: .029
          }],
          915: [.691, 0, .542, {
            ic: .104
          }],
          916: [.694, 0, .833],
          917: [.691, 0, .597, {
            ic: .091
          }],
          918: [.694, 0, .611, {
            ic: .091
          }],
          919: [.694, 0, .708, {
            ic: .06
          }],
          920: [.715, .022, .778, {
            ic: .026
          }],
          921: [.694, 0, .278, {
            ic: .06
          }],
          922: [.694, 0, .694, {
            ic: .091
          }],
          923: [.694, 0, .611],
          924: [.694, 0, .875, {
            ic: .054
          }],
          925: [.694, 0, .708, {
            ic: .058
          }],
          926: [.688, 0, .667, {
            ic: .098
          }],
          927: [.716, .022, .736, {
            ic: .027
          }],
          928: [.691, 0, .708, {
            ic: .06
          }],
          929: [.694, 0, .639, {
            ic: .051
          }],
          931: [.694, 0, .722, {
            ic: .091
          }],
          932: [.688, 0, .681, {
            ic: .109
          }],
          933: [.716, 0, .778, {
            ic: .065
          }],
          934: [.694, 0, .722, {
            ic: .021
          }],
          935: [.694, 0, .667, {
            ic: .091
          }],
          936: [.694, 0, .778, {
            ic: .076
          }],
          937: [.716, 0, .722, {
            ic: .047
          }],
          8211: [.312, -.236, .5, {
            ic: .065
          }],
          8212: [.312, -.236, 1, {
            ic: .065
          }],
          8213: [.312, -.236, 1, {
            ic: .065
          }],
          8215: [-.038, .114, .5, {
            ic: .065
          }],
          8216: [.694, -.471, .278, {
            ic: .058
          }],
          8217: [.694, -.471, .278, {
            ic: .057
          }],
          8220: [.694, -.471, .5, {
            ic: .114
          }],
          8221: [.694, -.471, .5],
          8260: [.75, .25, .5, {
            ic: .1
          }],
          8710: [.694, 0, .833]
        };
      },
      3526: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerif = void 0, e.sansSerif = {
          33: [.694, 0, .319],
          34: [.694, -.471, .5],
          35: [.694, .194, .833],
          36: [.75, .056, .5],
          37: [.75, .056, .833],
          38: [.716, .022, .758],
          39: [.694, -.471, .278],
          40: [.75, .25, .389],
          41: [.75, .25, .389],
          42: [.75, -.306, .5],
          43: [.583, .082, .778],
          44: [.098, .125, .278],
          45: [.259, -.186, .333],
          46: [.098, 0, .278],
          47: [.75, .25, .5],
          58: [.444, 0, .278],
          59: [.444, .125, .278],
          61: [.37, -.13, .778],
          63: [.704, 0, .472],
          64: [.704, .011, .667],
          91: [.75, .25, .289],
          93: [.75, .25, .289],
          94: [.694, -.527, .5],
          95: [-.038, .114, .5],
          126: [.327, -.193, .5],
          305: [.444, 0, .239],
          567: [.444, .205, .267],
          768: [.694, -.527, 0],
          769: [.694, -.527, 0],
          770: [.694, -.527, 0],
          771: [.677, -.543, 0],
          772: [.631, -.552, 0],
          774: [.694, -.508, 0],
          775: [.68, -.576, 0],
          776: [.68, -.582, 0],
          778: [.694, -.527, 0],
          779: [.694, -.527, 0],
          780: [.654, -.487, 0],
          913: [.694, 0, .667],
          914: [.694, 0, .667],
          915: [.691, 0, .542],
          916: [.694, 0, .833],
          917: [.691, 0, .597],
          918: [.694, 0, .611],
          919: [.694, 0, .708],
          920: [.716, .021, .778],
          921: [.694, 0, .278],
          922: [.694, 0, .694],
          923: [.694, 0, .611],
          924: [.694, 0, .875],
          925: [.694, 0, .708],
          926: [.688, 0, .667],
          927: [.715, .022, .736],
          928: [.691, 0, .708],
          929: [.694, 0, .639],
          931: [.694, 0, .722],
          932: [.688, 0, .681],
          933: [.716, 0, .778],
          934: [.694, 0, .722],
          935: [.694, 0, .667],
          936: [.694, 0, .778],
          937: [.716, 0, .722],
          8211: [.312, -.236, .5],
          8212: [.312, -.236, 1],
          8213: [.312, -.236, 1],
          8215: [-.038, .114, .5],
          8216: [.694, -.471, .278],
          8217: [.694, -.471, .278],
          8220: [.694, -.471, .5],
          8221: [.694, -.471, .5],
          8260: [.75, .25, .5],
          8710: [.694, 0, .833]
        };
      },
      5649: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.scriptBold = void 0, e.scriptBold = {};
      },
      7153: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.script = void 0, e.script = {};
      },
      5745: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallop = void 0, e.smallop = {
          40: [.85, .349, .458],
          41: [.85, .349, .458],
          47: [.85, .349, .578],
          91: [.85, .349, .417],
          92: [.85, .349, .578],
          93: [.85, .349, .417],
          123: [.85, .349, .583],
          125: [.85, .349, .583],
          710: [.744, -.551, .556],
          732: [.722, -.597, .556],
          770: [.744, -.551, 0],
          771: [.722, -.597, 0],
          8214: [.602, 0, .778],
          8260: [.85, .349, .578],
          8593: [.6, 0, .667],
          8595: [.6, 0, .667],
          8657: [.599, 0, .778],
          8659: [.6, 0, .778],
          8719: [.75, .25, .944],
          8720: [.75, .25, .944],
          8721: [.75, .25, 1.056],
          8730: [.85, .35, 1, {
            ic: .02
          }],
          8739: [.627, .015, .333],
          8741: [.627, .015, .556],
          8747: [.805, .306, .472, {
            ic: .138
          }],
          8748: [.805, .306, .819, {
            ic: .138
          }],
          8749: [.805, .306, 1.166, {
            ic: .138
          }],
          8750: [.805, .306, .472, {
            ic: .138
          }],
          8896: [.75, .249, .833],
          8897: [.75, .249, .833],
          8898: [.75, .249, .833],
          8899: [.75, .249, .833],
          8968: [.85, .349, .472],
          8969: [.85, .349, .472],
          8970: [.85, .349, .472],
          8971: [.85, .349, .472],
          9001: [.85, .35, .472],
          9002: [.85, .35, .472],
          9168: [.602, 0, .667],
          10072: [.627, .015, .333],
          10216: [.85, .35, .472],
          10217: [.85, .35, .472],
          10752: [.75, .25, 1.111],
          10753: [.75, .25, 1.111],
          10754: [.75, .25, 1.111],
          10756: [.75, .249, .833],
          10758: [.75, .249, .833],
          10764: [.805, .306, 1.638, {
            ic: .138
          }],
          12296: [.85, .35, .472],
          12297: [.85, .35, .472]
        };
      },
      1411: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphicBold = void 0, e.texCalligraphicBold = {
          65: [.751, .049, .921, {
            ic: .068,
            sk: .224
          }],
          66: [.705, .017, .748, {
            sk: .16
          }],
          67: [.703, .02, .613, {
            sk: .16
          }],
          68: [.686, 0, .892, {
            sk: .0958
          }],
          69: [.703, .016, .607, {
            ic: .02,
            sk: .128
          }],
          70: [.686, .03, .814, {
            ic: .116,
            sk: .128
          }],
          71: [.703, .113, .682, {
            sk: .128
          }],
          72: [.686, .048, .987, {
            sk: .128
          }],
          73: [.686, 0, .642, {
            ic: .104,
            sk: .0319
          }],
          74: [.686, .114, .779, {
            ic: .158,
            sk: .192
          }],
          75: [.703, .017, .871, {
            sk: .0639
          }],
          76: [.703, .017, .788, {
            sk: .16
          }],
          77: [.703, .049, 1.378, {
            sk: .16
          }],
          78: [.84, .049, .937, {
            ic: .168,
            sk: .0958
          }],
          79: [.703, .017, .906, {
            sk: .128
          }],
          80: [.686, .067, .81, {
            ic: .036,
            sk: .0958
          }],
          81: [.703, .146, .939, {
            sk: .128
          }],
          82: [.686, .017, .99, {
            sk: .0958
          }],
          83: [.703, .016, .696, {
            ic: .025,
            sk: .16
          }],
          84: [.72, .069, .644, {
            ic: .303,
            sk: .0319
          }],
          85: [.686, .024, .715, {
            ic: .056,
            sk: .0958
          }],
          86: [.686, .077, .737, {
            ic: .037,
            sk: .0319
          }],
          87: [.686, .077, 1.169, {
            ic: .037,
            sk: .0958
          }],
          88: [.686, 0, .817, {
            ic: .089,
            sk: .16
          }],
          89: [.686, .164, .759, {
            ic: .038,
            sk: .0958
          }],
          90: [.686, 0, .818, {
            ic: .035,
            sk: .16
          }],
          305: [.452, .008, .394, {
            sk: .0319
          }],
          567: [.451, .201, .439, {
            sk: .0958
          }]
        };
      },
      6384: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphic = void 0, e.texCalligraphic = {
          65: [.728, .05, .798, {
            ic: .021,
            sk: .194
          }],
          66: [.705, .022, .657, {
            sk: .139
          }],
          67: [.705, .025, .527, {
            sk: .139
          }],
          68: [.683, 0, .771, {
            sk: .0833
          }],
          69: [.705, .022, .528, {
            ic: .036,
            sk: .111
          }],
          70: [.683, .032, .719, {
            ic: .11,
            sk: .111
          }],
          71: [.704, .119, .595, {
            sk: .111
          }],
          72: [.683, .048, .845, {
            sk: .111
          }],
          73: [.683, 0, .545, {
            ic: .097,
            sk: .0278
          }],
          74: [.683, .119, .678, {
            ic: .161,
            sk: .167
          }],
          75: [.705, .022, .762, {
            sk: .0556
          }],
          76: [.705, .022, .69, {
            sk: .139
          }],
          77: [.705, .05, 1.201, {
            sk: .139
          }],
          78: [.789, .05, .82, {
            ic: .159,
            sk: .0833
          }],
          79: [.705, .022, .796, {
            sk: .111
          }],
          80: [.683, .057, .696, {
            ic: .037,
            sk: .0833
          }],
          81: [.705, .131, .817, {
            sk: .111
          }],
          82: [.682, .022, .848, {
            sk: .0833
          }],
          83: [.705, .022, .606, {
            ic: .036,
            sk: .139
          }],
          84: [.717, .068, .545, {
            ic: .288,
            sk: .0278
          }],
          85: [.683, .028, .626, {
            ic: .061,
            sk: .0833
          }],
          86: [.683, .052, .613, {
            ic: .045,
            sk: .0278
          }],
          87: [.683, .053, .988, {
            ic: .046,
            sk: .0833
          }],
          88: [.683, 0, .713, {
            ic: .094,
            sk: .139
          }],
          89: [.683, .143, .668, {
            ic: .046,
            sk: .0833
          }],
          90: [.683, 0, .725, {
            ic: .042,
            sk: .139
          }]
        };
      },
      6041: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texMathit = void 0, e.texMathit = {
          65: [.716, 0, .743],
          66: [.683, 0, .704],
          67: [.705, .021, .716],
          68: [.683, 0, .755],
          69: [.68, 0, .678],
          70: [.68, 0, .653],
          71: [.705, .022, .774],
          72: [.683, 0, .743],
          73: [.683, 0, .386],
          74: [.683, .021, .525],
          75: [.683, 0, .769],
          76: [.683, 0, .627],
          77: [.683, 0, .897],
          78: [.683, 0, .743],
          79: [.704, .022, .767],
          80: [.683, 0, .678],
          81: [.704, .194, .767],
          82: [.683, .022, .729],
          83: [.705, .022, .562],
          84: [.677, 0, .716],
          85: [.683, .022, .743],
          86: [.683, .022, .743],
          87: [.683, .022, .999],
          88: [.683, 0, .743],
          89: [.683, 0, .743],
          90: [.683, 0, .613],
          97: [.442, .011, .511],
          98: [.694, .011, .46],
          99: [.441, .01, .46],
          100: [.694, .011, .511],
          101: [.442, .01, .46],
          102: [.705, .204, .307],
          103: [.442, .205, .46],
          104: [.694, .011, .511],
          105: [.656, .01, .307],
          106: [.656, .204, .307],
          107: [.694, .011, .46],
          108: [.694, .011, .256],
          109: [.442, .011, .818],
          110: [.442, .011, .562],
          111: [.442, .011, .511],
          112: [.442, .194, .511],
          113: [.442, .194, .46],
          114: [.442, .011, .422],
          115: [.442, .011, .409],
          116: [.626, .011, .332],
          117: [.441, .011, .537],
          118: [.443, .01, .46],
          119: [.443, .011, .664],
          120: [.442, .011, .464],
          121: [.441, .205, .486],
          122: [.442, .011, .409]
        };
      },
      8199: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyleBold = void 0, e.texOldstyleBold = {
          48: [.46, .017, .575],
          49: [.461, 0, .575],
          50: [.46, 0, .575],
          51: [.461, .211, .575],
          52: [.469, .194, .575],
          53: [.461, .211, .575],
          54: [.66, .017, .575],
          55: [.476, .211, .575],
          56: [.661, .017, .575],
          57: [.461, .21, .575],
          65: [.751, .049, .921, {
            ic: .068,
            sk: .224
          }],
          66: [.705, .017, .748, {
            sk: .16
          }],
          67: [.703, .02, .613, {
            sk: .16
          }],
          68: [.686, 0, .892, {
            sk: .0958
          }],
          69: [.703, .016, .607, {
            ic: .02,
            sk: .128
          }],
          70: [.686, .03, .814, {
            ic: .116,
            sk: .128
          }],
          71: [.703, .113, .682, {
            sk: .128
          }],
          72: [.686, .048, .987, {
            sk: .128
          }],
          73: [.686, 0, .642, {
            ic: .104,
            sk: .0319
          }],
          74: [.686, .114, .779, {
            ic: .158,
            sk: .192
          }],
          75: [.703, .017, .871, {
            sk: .0639
          }],
          76: [.703, .017, .788, {
            sk: .16
          }],
          77: [.703, .049, 1.378, {
            sk: .16
          }],
          78: [.84, .049, .937, {
            ic: .168,
            sk: .0958
          }],
          79: [.703, .017, .906, {
            sk: .128
          }],
          80: [.686, .067, .81, {
            ic: .036,
            sk: .0958
          }],
          81: [.703, .146, .939, {
            sk: .128
          }],
          82: [.686, .017, .99, {
            sk: .0958
          }],
          83: [.703, .016, .696, {
            ic: .025,
            sk: .16
          }],
          84: [.72, .069, .644, {
            ic: .303,
            sk: .0319
          }],
          85: [.686, .024, .715, {
            ic: .056,
            sk: .0958
          }],
          86: [.686, .077, .737, {
            ic: .037,
            sk: .0319
          }],
          87: [.686, .077, 1.169, {
            ic: .037,
            sk: .0958
          }],
          88: [.686, 0, .817, {
            ic: .089,
            sk: .16
          }],
          89: [.686, .164, .759, {
            ic: .038,
            sk: .0958
          }],
          90: [.686, 0, .818, {
            ic: .035,
            sk: .16
          }]
        };
      },
      9848: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyle = void 0, e.texOldstyle = {
          48: [.452, .022, .5],
          49: [.453, 0, .5],
          50: [.453, 0, .5],
          51: [.452, .216, .5],
          52: [.464, .194, .5],
          53: [.453, .216, .5],
          54: [.665, .022, .5],
          55: [.463, .216, .5],
          56: [.666, .021, .5],
          57: [.453, .216, .5],
          65: [.728, .05, .798, {
            ic: .021,
            sk: .194
          }],
          66: [.705, .022, .657, {
            sk: .139
          }],
          67: [.705, .025, .527, {
            sk: .139
          }],
          68: [.683, 0, .771, {
            sk: .0833
          }],
          69: [.705, .022, .528, {
            ic: .036,
            sk: .111
          }],
          70: [.683, .032, .719, {
            ic: .11,
            sk: .111
          }],
          71: [.704, .119, .595, {
            sk: .111
          }],
          72: [.683, .048, .845, {
            sk: .111
          }],
          73: [.683, 0, .545, {
            ic: .097,
            sk: .0278
          }],
          74: [.683, .119, .678, {
            ic: .161,
            sk: .167
          }],
          75: [.705, .022, .762, {
            sk: .0556
          }],
          76: [.705, .022, .69, {
            sk: .139
          }],
          77: [.705, .05, 1.201, {
            sk: .139
          }],
          78: [.789, .05, .82, {
            ic: .159,
            sk: .0833
          }],
          79: [.705, .022, .796, {
            sk: .111
          }],
          80: [.683, .057, .696, {
            ic: .037,
            sk: .0833
          }],
          81: [.705, .131, .817, {
            sk: .111
          }],
          82: [.682, .022, .848, {
            sk: .0833
          }],
          83: [.705, .022, .606, {
            ic: .036,
            sk: .139
          }],
          84: [.717, .068, .545, {
            ic: .288,
            sk: .0278
          }],
          85: [.683, .028, .626, {
            ic: .061,
            sk: .0833
          }],
          86: [.683, .052, .613, {
            ic: .045,
            sk: .0278
          }],
          87: [.683, .053, .988, {
            ic: .046,
            sk: .0833
          }],
          88: [.683, 0, .713, {
            ic: .094,
            sk: .139
          }],
          89: [.683, .143, .668, {
            ic: .046,
            sk: .0833
          }],
          90: [.683, 0, .725, {
            ic: .042,
            sk: .139
          }]
        };
      },
      7906: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize3 = void 0, e.texSize3 = {
          40: [1.45, .949, .736],
          41: [1.45, .949, .736],
          47: [1.45, .949, 1.044],
          91: [1.45, .949, .528],
          92: [1.45, .949, 1.044],
          93: [1.45, .949, .528],
          123: [1.45, .949, .75],
          125: [1.45, .949, .75],
          710: [.772, -.564, 1.444],
          732: [.749, -.61, 1.444],
          770: [.772, -.564, 0],
          771: [.749, -.61, 0],
          8260: [1.45, .949, 1.044],
          8730: [1.45, .95, 1, {
            ic: .02
          }],
          8968: [1.45, .949, .583],
          8969: [1.45, .949, .583],
          8970: [1.45, .949, .583],
          8971: [1.45, .949, .583],
          9001: [1.45, .95, .75],
          9002: [1.45, .949, .75],
          10216: [1.45, .95, .75],
          10217: [1.45, .949, .75],
          12296: [1.45, .95, .75],
          12297: [1.45, .949, .75]
        };
      },
      2644: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize4 = void 0, e.texSize4 = {
          40: [1.75, 1.249, .792],
          41: [1.75, 1.249, .792],
          47: [1.75, 1.249, 1.278],
          91: [1.75, 1.249, .583],
          92: [1.75, 1.249, 1.278],
          93: [1.75, 1.249, .583],
          123: [1.75, 1.249, .806],
          125: [1.75, 1.249, .806],
          710: [.845, -.561, 1.889, {
            ic: .013
          }],
          732: [.823, -.583, 1.889],
          770: [.845, -.561, 0, {
            ic: .013
          }],
          771: [.823, -.583, 0],
          8260: [1.75, 1.249, 1.278],
          8730: [1.75, 1.25, 1, {
            ic: .02
          }],
          8968: [1.75, 1.249, .639],
          8969: [1.75, 1.249, .639],
          8970: [1.75, 1.249, .639],
          8971: [1.75, 1.249, .639],
          9001: [1.75, 1.248, .806],
          9002: [1.75, 1.248, .806],
          9115: [1.154, .655, .875],
          9116: [.61, .01, .875],
          9117: [1.165, .644, .875],
          9118: [1.154, .655, .875],
          9119: [.61, .01, .875],
          9120: [1.165, .644, .875],
          9121: [1.154, .645, .667],
          9122: [.602, 0, .667],
          9123: [1.155, .644, .667],
          9124: [1.154, .645, .667],
          9125: [.602, 0, .667],
          9126: [1.155, .644, .667],
          9127: [.899, .01, .889],
          9128: [1.16, .66, .889],
          9129: [.01, .899, .889],
          9130: [.29, .015, .889],
          9131: [.899, .01, .889],
          9132: [1.16, .66, .889],
          9133: [.01, .899, .889],
          9143: [.935, .885, 1.056],
          10216: [1.75, 1.248, .806],
          10217: [1.75, 1.248, .806],
          12296: [1.75, 1.248, .806],
          12297: [1.75, 1.248, .806],
          57344: [.625, .014, 1.056],
          57345: [.605, .014, 1.056, {
            ic: .02
          }],
          57680: [.12, .213, .45, {
            ic: .01
          }],
          57681: [.12, .213, .45, {
            ic: .024
          }],
          57682: [.333, 0, .45, {
            ic: .01
          }],
          57683: [.333, 0, .45, {
            ic: .024
          }],
          57684: [.32, .2, .4, {
            ic: .01
          }],
          57685: [.333, 0, .9, {
            ic: .01
          }],
          57686: [.12, .213, .9, {
            ic: .01
          }]
        };
      },
      4926: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texVariant = void 0, e.texVariant = {
          710: [.845, -.561, 2.333, {
            ic: .013
          }],
          732: [.899, -.628, 2.333],
          770: [.845, -.561, 0, {
            ic: .013
          }],
          771: [.899, -.628, 0],
          1008: [.434, .006, .667, {
            ic: .067
          }],
          8463: [.695, .013, .54, {
            ic: .022
          }],
          8592: [.437, -.064, .5],
          8594: [.437, -.064, .5],
          8652: [.514, .014, 1],
          8708: [.86, .166, .556],
          8709: [.587, 0, .778],
          8722: [.27, -.23, .5],
          8726: [.43, .023, .778],
          8733: [.472, -.028, .778],
          8739: [.43, .023, .222],
          8740: [.43, .023, .222, {
            ic: .018
          }],
          8741: [.431, .023, .389],
          8742: [.431, .024, .389, {
            ic: .018
          }],
          8764: [.365, -.132, .778],
          8776: [.481, -.05, .778],
          8808: [.752, .284, .778],
          8809: [.752, .284, .778],
          8816: [.919, .421, .778],
          8817: [.919, .421, .778],
          8840: [.828, .33, .778],
          8841: [.828, .33, .778],
          8842: [.634, .255, .778],
          8843: [.634, .254, .778],
          8872: [.694, 0, .611],
          8901: [.189, 0, .278],
          8994: [.378, -.122, .778],
          8995: [.378, -.143, .778],
          9651: [.575, .02, .722],
          9661: [.576, .019, .722],
          10887: [.801, .303, .778],
          10888: [.801, .303, .778],
          10955: [.752, .332, .778],
          10956: [.752, .333, .778]
        };
      },
      4097: function _(t, e, r) {
        var _n83,
          o = this && this.__extends || (_n83 = function n(t, e) {
            return _n83 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n83(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n83(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVG = e.XLINKNS = e.SVGNS = void 0;
        var Q = r(3055),
          s = r(7826),
          T = r(42),
          l = r(2597),
          c = r(505),
          u = r(6010);
        e.SVGNS = "http://www.w3.org/2000/svg", e.XLINKNS = "http://www.w3.org/1999/xlink";
        var p = function (t) {
          function r(e) {
            void 0 === e && (e = null);
            var r = t.call(this, e, s.SVGWrapperFactory, T.TeXFont) || this;
            return r.minwidth = 0, r.shift = 0, r.container = null, r.svgStyles = null, r.fontCache = new l.FontCache(r), r;
          }
          return o(r, t), r.prototype.initialize = function () {
            "global" === this.options.fontCache && this.fontCache.clearCache();
          }, r.prototype.clearFontCache = function () {
            this.fontCache.clearCache();
          }, r.prototype.reset = function () {
            this.clearFontCache();
          }, r.prototype.setScale = function (t) {
            1 !== this.options.scale && this.adaptor.setStyle(t, "fontSize", (0, u.percent)(this.options.scale));
          }, r.prototype.escaped = function (t, e) {
            return this.setDocument(e), this.html("span", {}, [this.text(t.math)]);
          }, r.prototype.styleSheet = function (e) {
            if (this.svgStyles) return this.svgStyles;
            var n = this.svgStyles = t.prototype.styleSheet.call(this, e);
            return this.adaptor.setAttribute(n, "id", r.STYLESHEETID), n;
          }, r.prototype.pageElements = function (t) {
            return "global" !== this.options.fontCache || this.findCache(t) ? null : this.svg("svg", {
              id: r.FONTCACHEID,
              style: {
                display: "none"
              }
            }, [this.fontCache.getCache()]);
          }, r.prototype.findCache = function (t) {
            for (var e = this.adaptor, n = e.tags(e.body(t.document), "svg"), o = n.length - 1; o >= 0; o--) if (this.adaptor.getAttribute(n[o], "id") === r.FONTCACHEID) return !0;
            return !1;
          }, r.prototype.processMath = function (t, e) {
            var r = this.container;
            this.container = e;
            var n = this.factory.wrap(t),
              o = a(this.createRoot(n), 2),
              i = o[0],
              Q = o[1];
            this.typesetSVG(n, i, Q), this.container = r;
          }, r.prototype.createRoot = function (t) {
            var r = t.getOuterBBox(),
              n = r.w,
              o = r.h,
              i = r.d,
              a = r.pwidth,
              Q = t.metrics.em / 1e3,
              s = Math.max(n, Q),
              T = Math.max(o + i, Q),
              l = this.svg("g", {
                stroke: "currentColor",
                fill: "currentColor",
                "stroke-width": 0,
                transform: "scale(1,-1)"
              }),
              c = this.adaptor,
              u = c.append(this.container, this.svg("svg", {
                xmlns: e.SVGNS,
                width: this.ex(s),
                height: this.ex(T),
                role: "img",
                focusable: !1,
                style: {
                  "vertical-align": this.ex(-i)
                },
                viewBox: [0, this.fixed(1e3 * -o, 1), this.fixed(1e3 * s, 1), this.fixed(1e3 * T, 1)].join(" ")
              }, [l]));
            if (.001 === s && (c.setAttribute(u, "preserveAspectRatio", "xMidYMid slice"), n < 0 && c.setStyle(this.container, "margin-right", this.ex(n))), a) {
              c.setStyle(u, "min-width", this.ex(s)), c.setAttribute(u, "width", a), c.removeAttribute(u, "viewBox");
              var p = this.fixed(t.metrics.ex / (1e3 * this.font.params.x_height), 6);
              c.setAttribute(l, "transform", "scale(".concat(p, ",-").concat(p, ") translate(0, ").concat(this.fixed(1e3 * -o, 1), ")"));
            }
            return "none" !== this.options.fontCache && c.setAttribute(u, "xmlns:xlink", e.XLINKNS), [u, l];
          }, r.prototype.typesetSVG = function (t, e, r) {
            var n = this.adaptor;
            if (this.minwidth = this.shift = 0, "local" === this.options.fontCache && (this.fontCache.clearCache(), this.fontCache.useLocalID(this.options.localID), n.insert(this.fontCache.getCache(), r)), t.toSVG(r), this.fontCache.clearLocalID(), this.minwidth) n.setStyle(e, "minWidth", this.ex(this.minwidth)), n.setStyle(this.container, "minWidth", this.ex(this.minwidth));else if (this.shift) {
              var o = n.getAttribute(this.container, "justify") || "center";
              this.setIndent(e, o, this.shift);
            }
          }, r.prototype.setIndent = function (t, e, r) {
            "center" !== e && "left" !== e || this.adaptor.setStyle(t, "margin-left", this.ex(r)), "center" !== e && "right" !== e || this.adaptor.setStyle(t, "margin-right", this.ex(-r));
          }, r.prototype.ex = function (t) {
            return t /= this.font.params.x_height, Math.abs(t) < .001 ? "0" : t.toFixed(3).replace(/\.?0+$/, "") + "ex";
          }, r.prototype.svg = function (t, r, n) {
            return void 0 === r && (r = {}), void 0 === n && (n = []), this.html(t, r, n, e.SVGNS);
          }, r.prototype.unknownText = function (t, e) {
            var r = this.math.metrics,
              n = this.font.params.x_height / r.ex * r.em * 1e3,
              o = this.svg("text", {
                "data-variant": e,
                transform: "scale(1,-1)",
                "font-size": this.fixed(n, 1) + "px"
              }, [this.text(t)]),
              i = this.adaptor;
            if ("-explicitFont" !== e) {
              var Q = (0, c.unicodeChars)(t);
              if (1 !== Q.length || Q[0] < 119808 || Q[0] > 120831) {
                var s = a(this.font.getCssFont(e), 3),
                  T = s[0],
                  l = s[1],
                  u = s[2];
                i.setAttribute(o, "font-family", T), l && i.setAttribute(o, "font-style", "italic"), u && i.setAttribute(o, "font-weight", "bold");
              }
            }
            return o;
          }, r.prototype.measureTextNode = function (t) {
            var e = this.adaptor;
            t = e.clone(t), e.removeAttribute(t, "transform");
            var r = this.fixed(1e3 * this.font.params.x_height, 1),
              n = this.svg("svg", {
                position: "absolute",
                visibility: "hidden",
                width: "1ex",
                height: "1ex",
                viewBox: [0, 0, r, r].join(" ")
              }, [t]);
            e.append(e.body(e.document), n);
            var o = e.nodeSize(t, 1e3, !0)[0];
            return e.remove(n), {
              w: o,
              h: .75,
              d: .2
            };
          }, r.NAME = "SVG", r.OPTIONS = i(i({}, Q.CommonOutputJax.OPTIONS), {
            internalSpeechTitles: !0,
            titleID: 0,
            fontCache: "local",
            localID: null
          }), r.commonStyles = {
            'mjx-container[jax="SVG"]': {
              direction: "ltr"
            },
            'mjx-container[jax="SVG"] > svg': {
              overflow: "visible",
              "min-height": "1px",
              "min-width": "1px"
            },
            'mjx-container[jax="SVG"] > svg a': {
              fill: "blue",
              stroke: "blue"
            }
          }, r.FONTCACHEID = "MJX-SVG-global-cache", r.STYLESHEETID = "MJX-SVG-styles", r;
        }(Q.CommonOutputJax);
        e.SVG = p;
      },
      2597: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FontCache = void 0;
        var r = function () {
          function t(t) {
            this.cache = new Map(), this.defs = null, this.localID = "", this.nextID = 0, this.jax = t;
          }
          return t.prototype.cachePath = function (t, e, r) {
            var n = "MJX-" + this.localID + (this.jax.font.getVariant(t).cacheID || "") + "-" + e;
            return this.cache.has(n) || (this.cache.set(n, r), this.jax.adaptor.append(this.defs, this.jax.svg("path", {
              id: n,
              d: r
            }))), n;
          }, t.prototype.clearLocalID = function () {
            this.localID = "";
          }, t.prototype.useLocalID = function (t) {
            void 0 === t && (t = null), this.localID = (null == t ? ++this.nextID : t) + ("" === t ? "" : "-");
          }, t.prototype.clearCache = function () {
            this.cache = new Map(), this.defs = this.jax.svg("defs");
          }, t.prototype.getCache = function () {
            return this.defs;
          }, t;
        }();
        e.FontCache = r;
      },
      768: function _(t, e, r) {
        var _n84,
          o = this && this.__extends || (_n84 = function n(t, e) {
            return _n84 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n84(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n84(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          Q = this && this.__exportStar || function (t, e) {
            for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || a(e, t, r);
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AddPaths = e.SVGFontData = void 0;
        var T = r(5884);
        Q(r(5884), e);
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.charOptions = function (e, r) {
            return t.charOptions.call(this, e, r);
          }, e.OPTIONS = i(i({}, T.FontData.OPTIONS), {
            dynamicPrefix: "./output/svg/fonts"
          }), e.JAX = "SVG", e;
        }(T.FontData);
        e.SVGFontData = l, e.AddPaths = function (t, e, r) {
          var n, o, i, a;
          try {
            for (var Q = s(Object.keys(e)), T = Q.next(); !T.done; T = Q.next()) {
              var c = T.value,
                u = parseInt(c);
              l.charOptions(t, u).p = e[u];
            }
          } catch (t) {
            n = {
              error: t
            };
          } finally {
            try {
              T && !T.done && (o = Q.return) && o.call(Q);
            } finally {
              if (n) throw n.error;
            }
          }
          try {
            for (var p = s(Object.keys(r)), h = p.next(); !h.done; h = p.next()) {
              c = h.value, u = parseInt(c);
              l.charOptions(t, u).c = r[u];
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              h && !h.done && (a = p.return) && a.call(p);
            } finally {
              if (i) throw i.error;
            }
          }
          return t;
        };
      },
      7620: function _(t, e, r) {
        var n = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          i = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && n(e, t, r);
            return o(e, t), e;
          },
          a = this && this.__exportStar || function (t, e) {
            for (var r in t) "default" === r || Object.prototype.hasOwnProperty.call(e, r) || n(e, t, r);
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Arrow = e.DiagonalArrow = e.DiagonalStrike = e.Border2 = e.Border = e.RenderLine = e.lineOffset = e.lineData = e.computeLineData = void 0;
        var Q = i(r(5552));
        a(r(5552), e), e.computeLineData = {
          top: function top(t, e, r, n) {
            return [0, t - n, r, t - n];
          },
          right: function right(t, e, r, n) {
            return [r - n, -e, r - n, t];
          },
          bottom: function bottom(t, e, r, n) {
            return [0, n - e, r, n - e];
          },
          left: function left(t, e, r, n) {
            return [n, -e, n, t];
          },
          vertical: function vertical(t, e, r, n) {
            return [r / 2, t, r / 2, -e];
          },
          horizontal: function horizontal(t, e, r, n) {
            return [0, (t - e) / 2, r, (t - e) / 2];
          },
          up: function up(t, e, r, n) {
            return [n, n - e, r - n, t - n];
          },
          down: function down(t, e, r, n) {
            return [n, t - n, r - n, n - e];
          }
        };
        e.lineData = function (t, r, n) {
          void 0 === n && (n = "");
          var o = t.getBBox(),
            i = o.h,
            a = o.d,
            Q = o.w,
            s = t.thickness / 2;
          return (0, e.lineOffset)(e.computeLineData[r](i, a, Q, s), t, n);
        };
        e.lineOffset = function (t, e, r) {
          if (r) {
            var n = e.getOffset(r);
            n && ("X" === r ? (t[0] -= n, t[2] -= n) : (t[1] -= n, t[3] -= n));
          }
          return t;
        };
        e.RenderLine = function (t, r) {
          return void 0 === r && (r = ""), function (n, o) {
            var i = n.line((0, e.lineData)(n, t, r));
            n.adaptor.append(n.element, i);
          };
        };
        e.Border = function (t) {
          return Q.CommonBorder(function (r, n) {
            r.adaptor.append(r.element, r.line((0, e.lineData)(r, t)));
          })(t);
        };
        e.Border2 = function (t, r, n) {
          return Q.CommonBorder2(function (t, o) {
            t.adaptor.append(t.element, t.line((0, e.lineData)(t, r))), t.adaptor.append(t.element, t.line((0, e.lineData)(t, n)));
          })(t, r, n);
        };
        e.DiagonalStrike = function (t) {
          return Q.CommonDiagonalStrike(function (r) {
            return function (r, n) {
              r.adaptor.append(r.element, r.line((0, e.lineData)(r, t)));
            };
          })(t);
        };
        e.DiagonalArrow = function (t) {
          return Q.CommonDiagonalArrow(function (t, e) {
            t.adaptor.append(t.element, e);
          })(t);
        };
        e.Arrow = function (t) {
          return Q.CommonArrow(function (t, e) {
            t.adaptor.append(t.element, e);
          })(t);
        };
      },
      7079: function _(t, e, r) {
        var _n85,
          o = this && this.__extends || (_n85 = function n(t, e) {
            return _n85 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n85(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n85(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGWrapper = void 0;
        var Q = r(6469),
          s = r(7519),
          T = r(4097),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.element = null, e.dx = 0, e;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              this.addChildren(this.standardSVGnode(t));
            }, e.prototype.addChildren = function (t) {
              var e,
                r,
                n = 0;
              try {
                for (var o = i(this.childNodes), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  Q.toSVG(t);
                  var s = Q.getOuterBBox();
                  Q.element && Q.place(n + s.L * s.rscale, 0), n += (s.L + s.w + s.R) * s.rscale;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.standardSVGnode = function (t) {
              var e = this.createSVGnode(t);
              return this.handleStyles(), this.handleScale(), this.handleBorder(), this.handleColor(), this.handleAttributes(), e;
            }, e.prototype.createSVGnode = function (t) {
              this.element = this.svg("g", {
                "data-mml-node": this.node.kind
              });
              var e = this.node.attributes.get("href");
              if (e) {
                t = this.adaptor.append(t, this.svg("a", {
                  href: e
                }));
                var r = this.getOuterBBox(),
                  n = r.h,
                  o = r.d,
                  i = r.w;
                this.adaptor.append(this.element, this.svg("rect", {
                  "data-hitbox": !0,
                  fill: "none",
                  stroke: "none",
                  "pointer-events": "all",
                  width: this.fixed(i),
                  height: this.fixed(n + o),
                  y: this.fixed(-o)
                }));
              }
              return this.adaptor.append(t, this.element), this.element;
            }, e.prototype.handleStyles = function () {
              var t = this;
              if (this.styles) {
                var e = this.styles.cssText;
                e && this.adaptor.setAttribute(this.element, "style", e), Q.BBox.StyleAdjust.forEach(function (e) {
                  var r = a(e, 3),
                    n = r[0];
                  if (0 === r[2]) {
                    var o = t.styles.get(n);
                    o && (t.dx += t.length2em(o, 1, t.bbox.rscale));
                  }
                });
              }
            }, e.prototype.handleScale = function () {
              if (1 !== this.bbox.rscale) {
                var t = "scale(" + this.fixed(this.bbox.rscale / 1e3, 3) + ")";
                this.adaptor.setAttribute(this.element, "transform", t);
              }
            }, e.prototype.handleColor = function () {
              var t,
                e = this.adaptor,
                r = this.node.attributes,
                n = r.getExplicit("mathcolor"),
                o = r.getExplicit("color"),
                i = r.getExplicit("mathbackground"),
                a = r.getExplicit("background"),
                Q = (null === (t = this.styles) || void 0 === t ? void 0 : t.get("background-color")) || "";
              if ((n || o) && (e.setAttribute(this.element, "fill", n || o), e.setAttribute(this.element, "stroke", n || o)), i || a || Q) {
                var s = this.getOuterBBox(),
                  T = s.h,
                  l = s.d,
                  c = s.w,
                  u = this.svg("rect", {
                    fill: i || a || Q,
                    x: this.fixed(-this.dx),
                    y: this.fixed(-l),
                    width: this.fixed(c),
                    height: this.fixed(T + l),
                    "data-bgcolor": !0
                  }),
                  p = e.firstChild(this.element);
                p ? e.insert(u, p) : e.append(this.element, u);
              }
            }, e.prototype.handleBorder = function () {
              var t, r, n, o;
              if (this.styles) {
                var Q = Array(4).fill(0),
                  s = Array(4),
                  T = Array(4);
                try {
                  for (var l = i([["Top", 0], ["Right", 1], ["Bottom", 2], ["Left", 3]]), c = l.next(); !c.done; c = l.next()) {
                    var u = a(c.value, 2),
                      p = u[0],
                      h = u[1],
                      d = "border" + p,
                      f = this.styles.get(d + "Width");
                    f && (Q[h] = Math.max(0, this.length2em(f, 1, this.bbox.rscale)), s[h] = this.styles.get(d + "Style") || "solid", T[h] = this.styles.get(d + "Color") || "currentColor");
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    c && !c.done && (r = l.return) && r.call(l);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                var m = e.borderFuzz,
                  L = this.getOuterBBox(),
                  y = a([L.h + m, L.d + m, L.w + m], 3),
                  g = y[0],
                  v = y[1],
                  b = y[2],
                  H = [b, g],
                  _ = [-m, g],
                  M = [b, -v],
                  x = [-m, -v],
                  O = [b - Q[1], g - Q[0]],
                  S = [-m + Q[3], g - Q[0]],
                  V = [b - Q[1], -v + Q[2]],
                  E = [-m + Q[3], -v + Q[2]],
                  A = [[_, H, O, S], [M, H, O, V], [x, M, V, E], [x, _, S, E]],
                  C = this.adaptor.firstChild(this.element);
                try {
                  for (var w = i([0, 1, 2, 3]), N = w.next(); !N.done; N = w.next()) {
                    if (Q[h = N.value]) {
                      var P = A[h];
                      "dashed" === s[h] || "dotted" === s[h] ? this.addBorderBroken(P, T[h], s[h], Q[h], h) : this.addBorderSolid(P, T[h], C);
                    }
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    N && !N.done && (o = w.return) && o.call(w);
                  } finally {
                    if (n) throw n.error;
                  }
                }
              }
            }, e.prototype.addBorderSolid = function (t, e, r) {
              var n = this,
                o = this.svg("polygon", {
                  points: t.map(function (t) {
                    var e = a(t, 2),
                      r = e[0],
                      o = e[1];
                    return "".concat(n.fixed(r - n.dx), ",").concat(n.fixed(o));
                  }).join(" "),
                  stroke: "none",
                  fill: e
                });
              r ? this.adaptor.insert(o, r) : this.adaptor.append(this.element, o);
            }, e.prototype.addBorderBroken = function (t, e, r, n, o) {
              var i = "dotted" === r,
                Q = n / 2,
                s = a([[Q, -Q, -Q, -Q], [-Q, Q, -Q, -Q], [Q, Q, -Q, Q], [Q, Q, Q, -Q]][o], 4),
                T = s[0],
                l = s[1],
                c = s[2],
                u = s[3],
                p = a(t, 2),
                h = p[0],
                d = p[1],
                f = h[0] + T - this.dx,
                m = h[1] + l,
                L = d[0] + c - this.dx,
                y = d[1] + u,
                g = Math.abs(o % 2 ? y - m : L - f),
                v = i ? Math.ceil(g / (2 * n)) : Math.ceil((g - n) / (4 * n)),
                b = g / (4 * v + 1),
                H = this.svg("line", {
                  x1: this.fixed(f),
                  y1: this.fixed(m),
                  x2: this.fixed(L),
                  y2: this.fixed(y),
                  "stroke-width": this.fixed(n),
                  stroke: e,
                  "stroke-linecap": i ? "round" : "square",
                  "stroke-dasharray": i ? [1, this.fixed(g / v - .002)].join(" ") : [this.fixed(b), this.fixed(3 * b)].join(" ")
                }),
                _ = this.adaptor,
                M = _.firstChild(this.element);
              M ? _.insert(H, M) : _.append(this.element, H);
            }, e.prototype.handleAttributes = function () {
              var t,
                r,
                n,
                o,
                a = this.node.attributes,
                Q = a.getAllDefaults(),
                s = e.skipAttributes;
              try {
                for (var T = i(a.getExplicitNames()), l = T.next(); !l.done; l = T.next()) {
                  var c = l.value;
                  !1 !== s[c] && (c in Q || s[c] || this.adaptor.hasAttribute(this.element, c)) || this.adaptor.setAttribute(this.element, c, a.getExplicit(c));
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  l && !l.done && (r = T.return) && r.call(T);
                } finally {
                  if (t) throw t.error;
                }
              }
              if (a.get("class")) {
                var u = a.get("class").trim().split(/ +/);
                try {
                  for (var p = i(u), h = p.next(); !h.done; h = p.next()) {
                    var d = h.value;
                    this.adaptor.addClass(this.element, d);
                  }
                } catch (t) {
                  n = {
                    error: t
                  };
                } finally {
                  try {
                    h && !h.done && (o = p.return) && o.call(p);
                  } finally {
                    if (n) throw n.error;
                  }
                }
              }
            }, e.prototype.place = function (t, e, r) {
              if (void 0 === r && (r = null), (t += this.dx) || e) {
                r || (r = this.element, e = this.handleId(e));
                var n = "translate(".concat(this.fixed(t), ",").concat(this.fixed(e), ")"),
                  o = this.adaptor.getAttribute(r, "transform") || "";
                this.adaptor.setAttribute(r, "transform", n + (o ? " " + o : ""));
              }
            }, e.prototype.handleId = function (t) {
              if (!this.node.attributes || !this.node.attributes.get("id")) return t;
              var e = this.adaptor,
                r = this.getBBox().h,
                n = e.childNodes(this.element);
              n.forEach(function (t) {
                return e.remove(t);
              });
              var o = this.svg("g", {
                "data-idbox": !0,
                transform: "translate(0,".concat(this.fixed(-r), ")")
              }, n);
              return e.append(this.element, this.svg("text", {
                "data-id-align": !0
              }, [this.text("")])), e.append(this.element, o), t + r;
            }, e.prototype.firstChild = function () {
              var t = this.adaptor,
                e = t.firstChild(this.element);
              return e && "text" === t.kind(e) && t.getAttribute(e, "data-id-align") && (e = t.firstChild(t.next(e))), e && "rect" === t.kind(e) && t.getAttribute(e, "data-hitbox") && (e = t.next(e)), e;
            }, e.prototype.placeChar = function (t, e, r, n, o) {
              var Q, s;
              void 0 === o && (o = null), null === o && (o = this.variant);
              var T = t.toString(16).toUpperCase(),
                l = a(this.getVariantChar(o, t), 4),
                c = l[2],
                u = l[3];
              if ("p" in u) {
                var p = u.p ? "M" + u.p + "Z" : "";
                this.place(e, r, this.adaptor.append(n, this.charNode(o, T, p)));
              } else if ("c" in u) {
                var h = this.adaptor.append(n, this.svg("g", {
                  "data-c": T
                }));
                this.place(e, r, h), e = 0;
                try {
                  for (var d = i(this.unicodeChars(u.c, o)), f = d.next(); !f.done; f = d.next()) {
                    var m = f.value;
                    e += this.placeChar(m, e, r, h, o);
                  }
                } catch (t) {
                  Q = {
                    error: t
                  };
                } finally {
                  try {
                    f && !f.done && (s = d.return) && s.call(d);
                  } finally {
                    if (Q) throw Q.error;
                  }
                }
              } else if (u.unknown) {
                var L = String.fromCodePoint(t),
                  y = this.adaptor.append(n, this.jax.unknownText(L, o));
                return this.place(e, r, y), this.jax.measureTextNodeWithCache(y, L, o).w;
              }
              return c;
            }, e.prototype.charNode = function (t, e, r) {
              return "none" !== this.jax.options.fontCache ? this.useNode(t, e, r) : this.pathNode(e, r);
            }, e.prototype.pathNode = function (t, e) {
              return this.svg("path", {
                "data-c": t,
                d: e
              });
            }, e.prototype.useNode = function (t, e, r) {
              var n = this.svg("use", {
                  "data-c": e
                }),
                o = "#" + this.jax.fontCache.cachePath(t, e, r);
              return this.adaptor.setAttribute(n, "href", o, T.XLINKNS), n;
            }, e.prototype.drawBBox = function () {
              var t = this.getBBox(),
                e = t.w,
                r = t.h,
                n = t.d,
                o = this.svg("g", {
                  style: {
                    opacity: .25
                  }
                }, [this.svg("rect", {
                  fill: "red",
                  height: this.fixed(r),
                  width: this.fixed(e)
                }), this.svg("rect", {
                  fill: "green",
                  height: this.fixed(n),
                  width: this.fixed(e),
                  y: this.fixed(-n)
                })]),
                i = this.element || this.parent.element;
              this.adaptor.append(i, o);
            }, e.prototype.html = function (t, e, r) {
              return void 0 === e && (e = {}), void 0 === r && (r = []), this.jax.html(t, e, r);
            }, e.prototype.svg = function (t, e, r) {
              return void 0 === e && (e = {}), void 0 === r && (r = []), this.jax.svg(t, e, r);
            }, e.prototype.text = function (t) {
              return this.jax.text(t);
            }, e.prototype.fixed = function (t, e) {
              return void 0 === e && (e = 1), this.jax.fixed(1e3 * t, e);
            }, e.kind = "unknown", e.borderFuzz = .005, e;
          }(s.CommonWrapper);
        e.SVGWrapper = l;
      },
      7826: function _(t, e, r) {
        var _n86,
          o = this && this.__extends || (_n86 = function n(t, e) {
            return _n86 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n86(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n86(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGWrapperFactory = void 0;
        var i = r(4420),
          a = r(6368),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.jax = null, e;
            }
            return o(e, t), e.defaultNodes = a.SVGWrappers, e;
          }(i.CommonWrapperFactory);
        e.SVGWrapperFactory = Q;
      },
      6368: function _(t, e, r) {
        var n;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGWrappers = void 0;
        var o = r(7079),
          i = r(2438),
          a = r(3289),
          Q = r(1618),
          s = r(5896),
          T = r(5710),
          l = r(3735),
          c = r(3365),
          u = r(9375),
          p = r(6465),
          h = r(7512),
          d = r(3572),
          f = r(5535),
          m = r(1107),
          L = r(7725),
          y = r(6670),
          g = r(4445),
          v = r(8835),
          b = r(9950),
          H = r(2558),
          _ = r(3006),
          M = r(8926),
          x = r(988),
          O = r(6614),
          S = r(2417),
          V = r(9645),
          E = r(131),
          A = r(640);
        e.SVGWrappers = ((n = {})[i.SVGmath.kind] = i.SVGmath, n[a.SVGmrow.kind] = a.SVGmrow, n[a.SVGinferredMrow.kind] = a.SVGinferredMrow, n[Q.SVGmi.kind] = Q.SVGmi, n[s.SVGmo.kind] = s.SVGmo, n[T.SVGmn.kind] = T.SVGmn, n[l.SVGms.kind] = l.SVGms, n[c.SVGmtext.kind] = c.SVGmtext, n[u.SVGmerror.kind] = u.SVGmerror, n[p.SVGmspace.kind] = p.SVGmspace, n[h.SVGmpadded.kind] = h.SVGmpadded, n[d.SVGmphantom.kind] = d.SVGmphantom, n[f.SVGmfrac.kind] = f.SVGmfrac, n[m.SVGmsqrt.kind] = m.SVGmsqrt, n[L.SVGmroot.kind] = L.SVGmroot, n[y.SVGmfenced.kind] = y.SVGmfenced, n[g.SVGmsub.kind] = g.SVGmsub, n[g.SVGmsup.kind] = g.SVGmsup, n[g.SVGmsubsup.kind] = g.SVGmsubsup, n[v.SVGmunder.kind] = v.SVGmunder, n[v.SVGmover.kind] = v.SVGmover, n[v.SVGmunderover.kind] = v.SVGmunderover, n[b.SVGmmultiscripts.kind] = b.SVGmmultiscripts, n[H.SVGmtable.kind] = H.SVGmtable, n[_.SVGmtr.kind] = _.SVGmtr, n[_.SVGmlabeledtr.kind] = _.SVGmlabeledtr, n[M.SVGmtd.kind] = M.SVGmtd, n[x.SVGmaction.kind] = x.SVGmaction, n[O.SVGmenclose.kind] = O.SVGmenclose, n[S.SVGsemantics.kind] = S.SVGsemantics, n[S.SVGannotation.kind] = S.SVGannotation, n[S.SVGannotationXML.kind] = S.SVGannotationXML, n[S.SVGxml.kind] = S.SVGxml, n[V.SVGmglyph.kind] = V.SVGmglyph, n[E.SVGTeXAtom.kind] = E.SVGTeXAtom, n[A.SVGTextNode.kind] = A.SVGTextNode, n[o.SVGWrapper.kind] = o.SVGWrapper, n);
      },
      131: function _(t, e, r) {
        var _n87,
          o = this && this.__extends || (_n87 = function n(t, e) {
            return _n87 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n87(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n87(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGTeXAtom = void 0;
        var i = r(7079),
          a = r(9800),
          Q = r(3948),
          s = r(9007),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (e) {
              if (t.prototype.toSVG.call(this, e), this.adaptor.setAttribute(this.element, "data-mjx-texclass", s.TEXCLASSNAMES[this.node.texClass]), this.node.texClass === s.TEXCLASS.VCENTER) {
                var r = this.childNodes[0].getBBox(),
                  n = r.h,
                  o = (n + r.d) / 2 + this.font.params.axis_height - n,
                  i = "translate(0 " + this.fixed(o) + ")";
                this.adaptor.setAttribute(this.element, "transform", i);
              }
            }, e.kind = Q.TeXAtom.prototype.kind, e;
          }((0, a.CommonTeXAtomMixin)(i.SVGWrapper));
        e.SVGTeXAtom = T;
      },
      640: function _(t, e, r) {
        var _n88,
          o = this && this.__extends || (_n88 = function n(t, e) {
            return _n88 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n88(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n88(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGTextNode = void 0;
        var a = r(9007),
          Q = r(7079),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e,
                r,
                n = this.node.getText(),
                o = this.parent.variant;
              if (0 !== n.length) if ("-explicitFont" === o) this.element = this.adaptor.append(t, this.jax.unknownText(n, o));else {
                var a = this.remappedText(n, o);
                this.parent.childNodes.length > 1 && (t = this.element = this.adaptor.append(t, this.svg("g", {
                  "data-mml-node": "text"
                })));
                var Q = 0;
                try {
                  for (var s = i(a), T = s.next(); !T.done; T = s.next()) {
                    var l = T.value;
                    Q += this.placeChar(l, Q, 0, t, o);
                  }
                } catch (t) {
                  e = {
                    error: t
                  };
                } finally {
                  try {
                    T && !T.done && (r = s.return) && r.call(s);
                  } finally {
                    if (e) throw e.error;
                  }
                }
              }
            }, e.kind = a.TextNode.prototype.kind, e.styles = {
              'mjx-container[jax="SVG"] path[data-c], mjx-container[jax="SVG"] use[data-c]': {
                "stroke-width": 3
              }
            }, e;
          }((0, r(1160).CommonTextNodeMixin)(Q.SVGWrapper));
        e.SVGTextNode = s;
      },
      988: function _(t, e, r) {
        var _n89,
          o = this && this.__extends || (_n89 = function n(t, e) {
            return _n89 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n89(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n89(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmaction = void 0;
        var i = r(7079),
          a = r(1956),
          Q = r(1956),
          s = r(9145),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t),
                r = this.selected,
                n = r.getOuterBBox(),
                o = n.h,
                i = n.d,
                a = n.w;
              this.adaptor.append(this.element, this.svg("rect", {
                width: this.fixed(a),
                height: this.fixed(o + i),
                y: this.fixed(-i),
                fill: "none",
                "pointer-events": "all"
              })), r.toSVG(e);
              var Q = r.getOuterBBox();
              r.element && r.place(Q.L * Q.rscale, 0), this.action(this, this.data);
            }, e.prototype.setEventHandler = function (t, e) {
              this.element.addEventListener(t, e);
            }, e.kind = s.MmlMaction.prototype.kind, e.styles = {
              '[jax="SVG"] mjx-tool': {
                display: "inline-block",
                position: "relative",
                width: 0,
                height: 0
              },
              '[jax="SVG"] mjx-tool > mjx-tip': {
                position: "absolute",
                top: 0,
                left: 0
              },
              "mjx-tool > mjx-tip": {
                display: "inline-block",
                padding: ".2em",
                border: "1px solid #888",
                "font-size": "70%",
                "background-color": "#F8F8F8",
                color: "black",
                "box-shadow": "2px 2px 5px #AAAAAA"
              },
              'g[data-mml-node="maction"][data-toggle]': {
                cursor: "pointer"
              },
              "mjx-status": {
                display: "block",
                position: "fixed",
                left: "1em",
                bottom: "1em",
                "min-width": "25%",
                padding: ".2em .4em",
                border: "1px solid #888",
                "font-size": "90%",
                "background-color": "#F8F8F8",
                color: "black"
              }
            }, e.actions = new Map([["toggle", [function (t, e) {
              t.adaptor.setAttribute(t.element, "data-toggle", t.node.attributes.get("selection"));
              var r = t.factory.jax.math,
                n = t.factory.jax.document,
                o = t.node;
              t.setEventHandler("click", function (t) {
                r.end.node || (r.start.node = r.end.node = r.typesetRoot, r.start.n = r.end.n = 0), o.nextToggleSelection(), r.rerender(n), t.stopPropagation();
              });
            }, {}]], ["tooltip", [function (t, e) {
              var r = t.childNodes[1];
              if (r) {
                var n = t.firstChild();
                if (r.node.isKind("mtext")) {
                  var o = r.node.getText();
                  t.adaptor.insert(t.svg("title", {}, [t.text(o)]), n);
                } else {
                  var i = t.adaptor,
                    a = t.jax.container,
                    Q = t.node.factory.create("math", {}, [t.childNodes[1].node]),
                    s = t.html("mjx-tool", {}, [t.html("mjx-tip")]),
                    T = i.append(n, t.svg("foreignObject", {
                      style: {
                        display: "none"
                      }
                    }, [s]));
                  t.jax.processMath(Q, i.firstChild(s)), t.childNodes[1].node.parent = t.node, t.setEventHandler("mouseover", function (r) {
                    e.stopTimers(t, e), e.hoverTimer.set(t, setTimeout(function () {
                      i.setStyle(s, "left", "0"), i.setStyle(s, "top", "0"), i.append(a, s);
                      var e = i.nodeBBox(s),
                        r = i.nodeBBox(t.element),
                        n = (r.right - e.left) / t.metrics.em + t.dx,
                        o = (r.bottom - e.bottom) / t.metrics.em + t.dy;
                      i.setStyle(s, "left", t.px(n)), i.setStyle(s, "top", t.px(o));
                    }, e.postDelay)), r.stopPropagation();
                  }), t.setEventHandler("mouseout", function (r) {
                    e.stopTimers(t, e);
                    var n = setTimeout(function () {
                      return i.append(T, s);
                    }, e.clearDelay);
                    e.clearTimer.set(t, n), r.stopPropagation();
                  });
                }
              }
            }, Q.TooltipData]], ["statusline", [function (t, e) {
              var r = t.childNodes[1];
              if (r && r.node.isKind("mtext")) {
                var n = t.adaptor,
                  o = r.node.getText();
                n.setAttribute(t.element, "data-statusline", o), t.setEventHandler("mouseover", function (r) {
                  if (null === e.status) {
                    var i = n.body(n.document);
                    e.status = n.append(i, t.html("mjx-status", {}, [t.text(o)]));
                  }
                  r.stopPropagation();
                }), t.setEventHandler("mouseout", function (t) {
                  e.status && (n.remove(e.status), e.status = null), t.stopPropagation();
                });
              }
            }, {
              status: null
            }]]]), e;
          }((0, a.CommonMactionMixin)(i.SVGWrapper));
        e.SVGmaction = T;
      },
      2438: function _(t, e, r) {
        var _n90,
          o = this && this.__extends || (_n90 = function n(t, e) {
            return _n90 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n90(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n90(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmath = void 0;
        var Q = r(7079),
          s = r(7490),
          T = r(3233),
          l = r(6469),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (e) {
              t.prototype.toSVG.call(this, e);
              var r = this.adaptor;
              "block" === this.node.attributes.get("display") && (r.setAttribute(this.jax.container, "display", "true"), this.handleDisplay()), this.jax.document.options.internalSpeechTitles && this.handleSpeech();
            }, e.prototype.handleDisplay = function () {
              var t = i(this.getAlignShift(), 2),
                e = t[0],
                r = t[1];
              if ("center" !== e && this.adaptor.setAttribute(this.jax.container, "justify", e), this.bbox.pwidth === l.BBox.fullWidth) {
                if (this.adaptor.setAttribute(this.jax.container, "width", "full"), this.jax.table) {
                  var n = this.jax.table.getOuterBBox(),
                    o = n.L,
                    a = n.w,
                    Q = n.R;
                  "right" === e ? Q = Math.max(Q || -r, -r) : "left" === e ? o = Math.max(o || r, r) : "center" === e && (a += 2 * Math.abs(r)), this.jax.minwidth = Math.max(0, o + a + Q);
                }
              } else this.jax.shift = r;
            }, e.prototype.handleSpeech = function () {
              var t,
                e,
                r = this.adaptor,
                n = this.node.attributes,
                o = n.get("aria-label") || n.get("data-semantic-speech");
              if (o) {
                var i = this.getTitleID(),
                  Q = this.svg("title", {
                    id: i
                  }, [this.text(o)]);
                r.insert(Q, r.firstChild(this.element)), r.setAttribute(this.element, "aria-labeledby", i), r.removeAttribute(this.element, "aria-label");
                try {
                  for (var s = a(this.childNodes[0].childNodes), T = s.next(); !T.done; T = s.next()) {
                    var l = T.value;
                    r.setAttribute(l.element, "aria-hidden", "true");
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    T && !T.done && (e = s.return) && e.call(s);
                  } finally {
                    if (t) throw t.error;
                  }
                }
              }
            }, e.prototype.getTitleID = function () {
              return "mjx-svg-title-" + String(this.jax.options.titleID++);
            }, e.prototype.setChildPWidths = function (e, r, n) {
              return void 0 === r && (r = null), void 0 === n && (n = !0), t.prototype.setChildPWidths.call(this, e, this.parent ? r : this.metrics.containerWidth / this.jax.pxPerEm, !1);
            }, e.kind = T.MmlMath.prototype.kind, e.styles = {
              'mjx-container[jax="SVG"][display="true"]': {
                display: "block",
                "text-align": "center",
                margin: "1em 0"
              },
              'mjx-container[jax="SVG"][display="true"][width="full"]': {
                display: "flex"
              },
              'mjx-container[jax="SVG"][justify="left"]': {
                "text-align": "left"
              },
              'mjx-container[jax="SVG"][justify="right"]': {
                "text-align": "right"
              }
            }, e;
          }((0, s.CommonMathMixin)(Q.SVGWrapper));
        e.SVGmath = c;
      },
      6614: function _(t, e, r) {
        var _n91,
          o = this && this.__extends || (_n91 = function n(t, e) {
            return _n91 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n91(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n91(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__createBinding || (Object.create ? function (t, e, r, n) {
            void 0 === n && (n = r);
            var o = Object.getOwnPropertyDescriptor(e, r);
            o && !("get" in o ? !e.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function get() {
                return e[r];
              }
            }), Object.defineProperty(t, n, o);
          } : function (t, e, r, n) {
            void 0 === n && (n = r), t[n] = e[r];
          }),
          a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
            Object.defineProperty(t, "default", {
              enumerable: !0,
              value: e
            });
          } : function (t, e) {
            t.default = e;
          }),
          Q = this && this.__importStar || function (t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) "default" !== r && Object.prototype.hasOwnProperty.call(t, r) && i(e, t, r);
            return a(e, t), e;
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          T = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmenclose = void 0;
        var l = r(7079),
          c = r(7313),
          u = Q(r(7620)),
          p = r(6661),
          h = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e,
                r,
                n = this.standardSVGnode(t),
                o = this.getBBoxExtenders()[3],
                i = {};
              o > 0 && (i.transform = "translate(" + this.fixed(o) + ", 0)");
              var a = this.adaptor.append(n, this.svg("g", i));
              this.renderChild ? this.renderChild(this, a) : this.childNodes[0].toSVG(a);
              try {
                for (var Q = s(Object.keys(this.notations)), T = Q.next(); !T.done; T = Q.next()) {
                  var l = T.value,
                    c = this.notations[l];
                  !c.renderChild && c.renderer(this, n);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (r = Q.return) && r.call(Q);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.prototype.arrow = function (t, e, r, n, o) {
              void 0 === n && (n = ""), void 0 === o && (o = 0);
              var i = this.getBBox(),
                a = i.w,
                Q = (t - a) / 2,
                s = (i.h - i.d) / 2,
                l = this.thickness,
                c = l / 2,
                u = T([l * this.arrowhead.x, l * this.arrowhead.y, l * this.arrowhead.dx], 3),
                p = u[0],
                h = u[1],
                d = u[2],
                f = r ? this.fill("M", a + Q, s, "l", -(p + d), h, "l", d, c - h, "L", p - Q, s + c, "l", d, h - c, "l", -(p + d), -h, "l", p + d, -h, "l", -d, h - c, "L", a + Q - p, s - c, "l", -d, c - h, "Z") : this.fill("M", a + Q, s, "l", -(p + d), h, "l", d, c - h, "L", -Q, s + c, "l", 0, -l, "L", a + Q - p, s - c, "l", -d, c - h, "Z"),
                m = [];
              if (o && m.push("X" === n ? "translate(".concat(this.fixed(-o), " 0)") : "translate(0 ".concat(this.fixed(o), ")")), e) {
                var L = this.jax.fixed(180 * -e / Math.PI);
                m.push("rotate(".concat(L, " ").concat(this.fixed(a / 2), " ").concat(this.fixed(s), ")"));
              }
              return m.length && this.adaptor.setAttribute(f, "transform", m.join(" ")), f;
            }, e.prototype.line = function (t) {
              var e = T(t, 4),
                r = e[0],
                n = e[1],
                o = e[2],
                i = e[3];
              return this.svg("line", {
                x1: this.fixed(r),
                y1: this.fixed(n),
                x2: this.fixed(o),
                y2: this.fixed(i),
                "stroke-width": this.fixed(this.thickness)
              });
            }, e.prototype.box = function (t, e, r, n) {
              void 0 === n && (n = 0);
              var o = this.thickness,
                i = {
                  x: this.fixed(o / 2),
                  y: this.fixed(o / 2 - r),
                  width: this.fixed(t - o),
                  height: this.fixed(e + r - o),
                  fill: "none",
                  "stroke-width": this.fixed(o)
                };
              return n && (i.rx = this.fixed(n)), this.svg("rect", i);
            }, e.prototype.ellipse = function (t, e, r) {
              var n = this.thickness;
              return this.svg("ellipse", {
                rx: this.fixed((t - n) / 2),
                ry: this.fixed((e + r - n) / 2),
                cx: this.fixed(t / 2),
                cy: this.fixed((e - r) / 2),
                fill: "none",
                "stroke-width": this.fixed(n)
              });
            }, e.prototype.path = function (t) {
              for (var e = this, r = [], n = 1; n < arguments.length; n++) r[n - 1] = arguments[n];
              return this.svg("path", {
                d: r.map(function (t) {
                  return "string" == typeof t ? t : e.fixed(t);
                }).join(" "),
                style: {
                  "stroke-width": this.fixed(this.thickness)
                },
                "stroke-linecap": "round",
                "stroke-linejoin": t,
                fill: "none"
              });
            }, e.prototype.fill = function () {
              for (var t = this, e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              return this.svg("path", {
                d: e.map(function (e) {
                  return "string" == typeof e ? e : t.fixed(e);
                }).join(" ")
              });
            }, e.kind = p.MmlMenclose.prototype.kind, e.notations = new Map([u.Border("top"), u.Border("right"), u.Border("bottom"), u.Border("left"), u.Border2("actuarial", "top", "right"), u.Border2("madruwb", "bottom", "right"), u.DiagonalStrike("up"), u.DiagonalStrike("down"), ["horizontalstrike", {
              renderer: u.RenderLine("horizontal", "Y"),
              bbox: function bbox(t) {
                return [0, t.padding, 0, t.padding];
              }
            }], ["verticalstrike", {
              renderer: u.RenderLine("vertical", "X"),
              bbox: function bbox(t) {
                return [t.padding, 0, t.padding, 0];
              }
            }], ["box", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d;
                t.adaptor.append(t.element, t.box(n, o, i));
              },
              bbox: u.fullBBox,
              border: u.fullBorder,
              remove: "left right top bottom"
            }], ["roundedbox", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d,
                  a = t.thickness + t.padding;
                t.adaptor.append(t.element, t.box(n, o, i, a));
              },
              bbox: u.fullBBox
            }], ["circle", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d;
                t.adaptor.append(t.element, t.ellipse(n, o, i));
              },
              bbox: u.fullBBox
            }], ["phasorangle", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d,
                  a = t.getArgMod(1.75 * t.padding, o + i)[0],
                  Q = t.thickness / 2,
                  s = o + i,
                  T = Math.cos(a);
                t.adaptor.append(t.element, t.path("mitre", "M", n, Q - i, "L", Q + T * Q, Q - i, "L", T * s + Q, s - i - Q));
              },
              bbox: function bbox(t) {
                var e = t.padding / 2,
                  r = t.thickness;
                return [2 * e, e, e + r, 3 * e + r];
              },
              border: function border(t) {
                return [0, 0, t.thickness, 0];
              },
              remove: "bottom"
            }], u.Arrow("up"), u.Arrow("down"), u.Arrow("left"), u.Arrow("right"), u.Arrow("updown"), u.Arrow("leftright"), u.DiagonalArrow("updiagonal"), u.DiagonalArrow("northeast"), u.DiagonalArrow("southeast"), u.DiagonalArrow("northwest"), u.DiagonalArrow("southwest"), u.DiagonalArrow("northeastsouthwest"), u.DiagonalArrow("northwestsoutheast"), ["longdiv", {
              renderer: function renderer(t, e) {
                var r = t.getBBox(),
                  n = r.w,
                  o = r.h,
                  i = r.d,
                  a = t.thickness / 2,
                  Q = t.padding;
                t.adaptor.append(t.element, t.path("round", "M", a, a - i, "a", Q - a / 2, (o + i) / 2 - 4 * a, 0, "0,1", 0, o + i - 2 * a, "L", n - a, o - a));
              },
              bbox: function bbox(t) {
                var e = t.padding,
                  r = t.thickness;
                return [e + r, e, e, 2 * e + r / 2];
              }
            }], ["radical", {
              renderer: function renderer(t, e) {
                t.msqrt.toSVG(e);
                var r = t.sqrtTRBL()[3];
                t.place(-r, 0, e);
              },
              init: function init(t) {
                t.msqrt = t.createMsqrt(t.childNodes[0]);
              },
              bbox: function bbox(t) {
                return t.sqrtTRBL();
              },
              renderChild: !0
            }]]), e;
          }((0, c.CommonMencloseMixin)(l.SVGWrapper));
        e.SVGmenclose = h;
      },
      9375: function _(t, e, r) {
        var _n92,
          o = this && this.__extends || (_n92 = function n(t, e) {
            return _n92 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n92(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n92(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmerror = void 0;
        var i = r(7079),
          a = r(1581),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t),
                r = this.getBBox(),
                n = r.h,
                o = r.d,
                i = r.w;
              this.adaptor.append(this.element, this.svg("rect", {
                "data-background": !0,
                width: this.fixed(i),
                height: this.fixed(n + o),
                y: this.fixed(-o)
              }));
              var a = this.node.attributes.get("title");
              a && this.adaptor.append(this.element, this.svg("title", {}, [this.adaptor.text(a)])), this.addChildren(e);
            }, e.kind = a.MmlMerror.prototype.kind, e.styles = {
              'g[data-mml-node="merror"] > g': {
                fill: "red",
                stroke: "red"
              },
              'g[data-mml-node="merror"] > rect[data-background]': {
                fill: "yellow",
                stroke: "none"
              }
            }, e;
          }(i.SVGWrapper);
        e.SVGmerror = Q;
      },
      6670: function _(t, e, r) {
        var _n93,
          o = this && this.__extends || (_n93 = function n(t, e) {
            return _n93 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n93(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n93(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmfenced = void 0;
        var a = r(7079),
          Q = r(7555),
          s = r(5410),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t);
              this.setChildrenParent(this.mrow), this.mrow.toSVG(e), this.setChildrenParent(this);
            }, e.prototype.setChildrenParent = function (t) {
              var e, r;
              try {
                for (var n = i(this.childNodes), o = n.next(); !o.done; o = n.next()) {
                  o.value.parent = t;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, e.kind = s.MmlMfenced.prototype.kind, e;
          }((0, Q.CommonMfencedMixin)(a.SVGWrapper));
        e.SVGmfenced = T;
      },
      5535: function _(t, e, r) {
        var _n94,
          o = this && this.__extends || (_n94 = function n(t, e) {
            return _n94 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n94(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n94(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmfrac = void 0;
        var a = r(7079),
          Q = r(2688),
          s = r(6850),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              this.standardSVGnode(t);
              var e = this.node.attributes.getList("linethickness", "bevelled"),
                r = e.linethickness,
                n = e.bevelled,
                o = this.isDisplay();
              if (n) this.makeBevelled(o);else {
                var i = this.length2em(String(r), .06);
                0 === i ? this.makeAtop(o) : this.makeFraction(o, i);
              }
            }, e.prototype.makeFraction = function (t, e) {
              var r = this.element,
                n = this.node.attributes.getList("numalign", "denomalign"),
                o = n.numalign,
                a = n.denomalign,
                Q = i(this.childNodes, 2),
                s = Q[0],
                T = Q[1],
                l = s.getOuterBBox(),
                c = T.getOuterBBox(),
                u = this.font.params,
                p = u.axis_height,
                h = this.node.getProperty("withDelims") ? 0 : u.nulldelimiterspace,
                d = Math.max((l.L + l.w + l.R) * l.rscale, (c.L + c.w + c.R) * c.rscale),
                f = this.getAlignX(d, l, o) + .1 + h,
                m = this.getAlignX(d, c, a) + .1 + h,
                L = this.getTUV(t, e),
                y = L.T,
                g = L.u,
                v = L.v;
              s.toSVG(r), s.place(f, p + y + Math.max(l.d * l.rscale, g)), T.toSVG(r), T.place(m, p - y - Math.max(c.h * c.rscale, v)), this.adaptor.append(r, this.svg("rect", {
                width: this.fixed(d + .2),
                height: this.fixed(e),
                x: this.fixed(h),
                y: this.fixed(p - e / 2)
              }));
            }, e.prototype.makeAtop = function (t) {
              var e = this.element,
                r = this.node.attributes.getList("numalign", "denomalign"),
                n = r.numalign,
                o = r.denomalign,
                a = i(this.childNodes, 2),
                Q = a[0],
                s = a[1],
                T = Q.getOuterBBox(),
                l = s.getOuterBBox(),
                c = this.font.params,
                u = this.node.getProperty("withDelims") ? 0 : c.nulldelimiterspace,
                p = Math.max((T.L + T.w + T.R) * T.rscale, (l.L + l.w + l.R) * l.rscale),
                h = this.getAlignX(p, T, n) + u,
                d = this.getAlignX(p, l, o) + u,
                f = this.getUVQ(t),
                m = f.u,
                L = f.v;
              Q.toSVG(e), Q.place(h, m), s.toSVG(e), s.place(d, -L);
            }, e.prototype.makeBevelled = function (t) {
              var e = this.element,
                r = i(this.childNodes, 2),
                n = r[0],
                o = r[1],
                a = this.getBevelData(t),
                Q = a.u,
                s = a.v,
                T = a.delta,
                l = a.nbox,
                c = a.dbox,
                u = (l.L + l.w + l.R) * l.rscale;
              n.toSVG(e), this.bevel.toSVG(e), o.toSVG(e), n.place(l.L * l.rscale, Q), this.bevel.place(u - T / 2, 0), o.place(u + this.bevel.getOuterBBox().w + c.L * c.rscale - T, s);
            }, e.kind = s.MmlMfrac.prototype.kind, e;
          }((0, Q.CommonMfracMixin)(a.SVGWrapper));
        e.SVGmfrac = T;
      },
      9645: function _(t, e, r) {
        var _n95,
          o = this && this.__extends || (_n95 = function n(t, e) {
            return _n95 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n95(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n95(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmglyph = void 0;
        var i = r(7079),
          a = r(5636),
          Q = r(3985),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t);
              if (this.charWrapper) this.charWrapper.toSVG(e);else {
                var r = this.node.attributes.getList("src", "alt"),
                  n = r.src,
                  o = r.alt,
                  i = this.fixed(this.height),
                  a = {
                    width: this.fixed(this.width),
                    height: i,
                    transform: "translate(0 " + this.fixed(this.height + (this.valign || 0)) + ") matrix(1 0 0 -1 0 0)",
                    preserveAspectRatio: "none",
                    "aria-label": o,
                    href: n
                  },
                  Q = this.svg("image", a);
                this.adaptor.append(e, Q);
              }
            }, e.kind = Q.MmlMglyph.prototype.kind, e;
          }((0, a.CommonMglyphMixin)(i.SVGWrapper));
        e.SVGmglyph = s;
      },
      1618: function _(t, e, r) {
        var _n96,
          o = this && this.__extends || (_n96 = function n(t, e) {
            return _n96 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n96(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n96(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmi = void 0;
        var i = r(7079),
          a = r(5723),
          Q = r(450),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = Q.MmlMi.prototype.kind, e;
          }((0, a.CommonMiMixin)(i.SVGWrapper));
        e.SVGmi = s;
      },
      9950: function _(t, e, r) {
        var _n97,
          o = this && this.__extends || (_n97 = function n(t, e) {
            return _n97 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n97(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n97(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmmultiscripts = e.AlignX = void 0;
        var a = r(4445),
          Q = r(8009),
          s = r(6405),
          T = r(505);
        function l(t) {
          return {
            left: function left(t, e) {
              return 0;
            },
            center: function center(t, e) {
              return (e - t) / 2;
            },
            right: function right(t, e) {
              return e - t;
            }
          }[t] || function (t, e) {
            return 0;
          };
        }
        e.AlignX = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (t) {
            var e = this.standardSVGnode(t),
              r = this.scriptData,
              n = this.node.getProperty("scriptalign") || "right left",
              o = i((0, T.split)(n + " " + n), 2),
              a = o[0],
              Q = o[1],
              s = this.combinePrePost(r.sub, r.psub),
              l = this.combinePrePost(r.sup, r.psup),
              c = i(this.getUVQ(s, l), 2),
              u = c[0],
              p = c[1],
              h = 0;
            r.numPrescripts && (h = this.addScripts(.05, u, p, this.firstPrescript, r.numPrescripts, a));
            var d = this.baseChild;
            d.toSVG(e), d.place(h, 0), h += d.getOuterBBox().w, r.numScripts && this.addScripts(h, u, p, 1, r.numScripts, Q);
          }, e.prototype.addScripts = function (t, e, r, n, o, a) {
            var Q = this.adaptor,
              s = l(a),
              T = Q.append(this.element, this.svg("g")),
              c = Q.append(this.element, this.svg("g"));
            this.place(t, e, T), this.place(t, r, c);
            for (var u = n + 2 * o, p = 0; n < u;) {
              var h = i([this.childNodes[n++], this.childNodes[n++]], 2),
                d = h[0],
                f = h[1],
                m = i([d.getOuterBBox(), f.getOuterBBox()], 2),
                L = m[0],
                y = m[1],
                g = i([L.rscale, y.rscale], 2),
                v = g[0],
                b = g[1],
                H = Math.max(L.w * v, y.w * b);
              d.toSVG(c), f.toSVG(T), d.place(p + s(L.w * v, H), 0), f.place(p + s(y.w * b, H), 0), p += H;
            }
            return t + p;
          }, e.kind = s.MmlMmultiscripts.prototype.kind, e;
        }((0, Q.CommonMmultiscriptsMixin)(a.SVGmsubsup));
        e.SVGmmultiscripts = c;
      },
      5710: function _(t, e, r) {
        var _n98,
          o = this && this.__extends || (_n98 = function n(t, e) {
            return _n98 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n98(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n98(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmn = void 0;
        var i = r(7079),
          a = r(5023),
          Q = r(3050),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = Q.MmlMn.prototype.kind, e;
          }((0, a.CommonMnMixin)(i.SVGWrapper));
        e.SVGmn = s;
      },
      5896: function _(t, e, r) {
        var _n99,
          o = this && this.__extends || (_n99 = function n(t, e) {
            return _n99 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n99(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n99(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmo = void 0;
        var Q = r(7079),
          s = r(7096),
          T = r(2756),
          l = .1,
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.node.attributes,
                r = e.get("symmetric") && 2 !== this.stretch.dir,
                n = 0 !== this.stretch.dir;
              n && null === this.size && this.getStretchedVariant([]);
              var o = this.standardSVGnode(t);
              if (n && this.size < 0) this.stretchSVG();else {
                var i = r || e.get("largeop") ? this.fixed(this.getCenterOffset()) : "0",
                  a = this.node.getProperty("mathaccent") ? this.fixed(this.getAccentOffset()) : "0";
                "0" === i && "0" === a || this.adaptor.setAttribute(o, "transform", "translate(".concat(a, " ").concat(i, ")")), this.addChildren(o);
              }
            }, e.prototype.stretchSVG = function () {
              var t = this.stretch.stretch,
                e = this.getStretchVariants(),
                r = this.getBBox();
              1 === this.stretch.dir ? this.stretchVertical(t, e, r) : this.stretchHorizontal(t, e, r);
            }, e.prototype.getStretchVariants = function () {
              var t,
                e,
                r = this.stretch.c || this.getText().codePointAt(0),
                n = [];
              try {
                for (var o = i(this.stretch.stretch.keys()), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  n[Q] = this.font.getStretchVariant(r, Q);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  a && !a.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return n;
            }, e.prototype.stretchVertical = function (t, e, r) {
              var n = r.h,
                o = r.d,
                i = r.w,
                Q = this.addTop(t[0], e[0], n, i),
                s = this.addBot(t[2], e[2], o, i);
              if (4 === t.length) {
                var T = a(this.addMidV(t[3], e[3], i), 2),
                  l = T[0],
                  c = T[1];
                this.addExtV(t[1], e[1], n, 0, Q, l, i), this.addExtV(t[1], e[1], 0, o, c, s, i);
              } else this.addExtV(t[1], e[1], n, o, Q, s, i);
            }, e.prototype.stretchHorizontal = function (t, e, r) {
              var n = r.w,
                o = this.addLeft(t[0], e[0]),
                i = this.addRight(t[2], e[2], n);
              if (4 === t.length) {
                var Q = a(this.addMidH(t[3], e[3], n), 2),
                  s = Q[0],
                  T = Q[1],
                  l = n / 2;
                this.addExtH(t[1], e[1], l, o, l - s), this.addExtH(t[1], e[1], l, T - l, i, l);
              } else this.addExtH(t[1], e[1], n, o, i);
            }, e.prototype.getChar = function (t, e) {
              var r = this.font.getChar(e, t) || [0, 0, 0, null];
              return [r[0], r[1], r[2], r[3] || {}];
            }, e.prototype.addGlyph = function (t, e, r, n, o) {
              return void 0 === o && (o = null), this.placeChar(t, r, n, o || this.element, e);
            }, e.prototype.addTop = function (t, e, r, n) {
              if (!t) return 0;
              var o = a(this.getChar(t, e), 3),
                i = o[0],
                Q = o[1],
                s = o[2];
              return this.addGlyph(t, e, (n - s) / 2, r - i), i + Q;
            }, e.prototype.addExtV = function (t, e, r, n, o, i, Q) {
              var s = this;
              if (t) {
                o = Math.max(0, o - l), i = Math.max(0, i - l);
                var T = this.adaptor,
                  c = a(this.getChar(t, e), 3),
                  u = c[0],
                  p = c[1],
                  h = c[2],
                  d = r + n - o - i,
                  f = 1.5 * d / (u + p),
                  m = (f * (u - p) - d) / 2;
                if (!(d <= 0)) {
                  var L = this.svg("svg", {
                    width: this.fixed(h),
                    height: this.fixed(d),
                    y: this.fixed(i - n),
                    x: this.fixed((Q - h) / 2),
                    viewBox: [0, m, h, d].map(function (t) {
                      return s.fixed(t);
                    }).join(" ")
                  });
                  this.addGlyph(t, e, 0, 0, L);
                  var y = T.lastChild(L);
                  T.setAttribute(y, "transform", "scale(1,".concat(this.jax.fixed(f), ")")), T.append(this.element, L);
                }
              }
            }, e.prototype.addBot = function (t, e, r, n) {
              if (!t) return 0;
              var o = a(this.getChar(t, e), 3),
                i = o[0],
                Q = o[1],
                s = o[2];
              return this.addGlyph(t, e, (n - s) / 2, Q - r), i + Q;
            }, e.prototype.addMidV = function (t, e, r) {
              if (!t) return [0, 0];
              var n = a(this.getChar(t, e), 3),
                o = n[0],
                i = n[1],
                Q = n[2],
                s = (i - o) / 2 + this.font.params.axis_height;
              return this.addGlyph(t, e, (r - Q) / 2, s), [o + s, i - s];
            }, e.prototype.addLeft = function (t, e) {
              return t ? this.addGlyph(t, e, 0, 0) : 0;
            }, e.prototype.addExtH = function (t, e, r, n, o, i) {
              var Q = this;
              if (void 0 === i && (i = 0), t) {
                o = Math.max(0, o - .1), n = Math.max(0, n - .1);
                var s = this.adaptor,
                  T = a(this.getChar(t, e), 3),
                  c = T[0],
                  u = T[1],
                  p = T[2],
                  h = r - n - o,
                  d = c + u + .2,
                  f = h / p * 1.5,
                  m = -(u + l);
                if (!(h <= 0)) {
                  var L = this.svg("svg", {
                    width: this.fixed(h),
                    height: this.fixed(d),
                    x: this.fixed(i + n),
                    y: this.fixed(m),
                    viewBox: [(f * p - h) / 2, m, h, d].map(function (t) {
                      return Q.fixed(t);
                    }).join(" ")
                  });
                  this.addGlyph(t, e, 0, 0, L);
                  var y = s.lastChild(L);
                  s.setAttribute(y, "transform", "scale(" + this.jax.fixed(f) + ",1)"), s.append(this.element, L);
                }
              }
            }, e.prototype.addRight = function (t, e, r) {
              if (!t) return 0;
              var n = this.getChar(t, e)[2];
              return this.addGlyph(t, e, r - n, 0);
            }, e.prototype.addMidH = function (t, e, r) {
              if (!t) return [0, 0];
              var n = this.getChar(t, e)[2];
              return this.addGlyph(t, e, (r - n) / 2, 0), [(r - n) / 2, (r + n) / 2];
            }, e.kind = T.MmlMo.prototype.kind, e;
          }((0, s.CommonMoMixin)(Q.SVGWrapper));
        e.SVGmo = c;
      },
      7512: function _(t, e, r) {
        var _n100,
          o = this && this.__extends || (_n100 = function n(t, e) {
            return _n100 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n100(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n100(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmpadded = void 0;
        var a = r(7079),
          Q = r(6898),
          s = r(7238),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t),
                r = i(this.getDimens(), 9),
                n = r[5],
                o = r[6],
                a = r[7],
                Q = r[8],
                s = this.node.attributes.get("data-align") || "left",
                T = o + Q - (n < 0 && "left" !== s ? "center" === s ? n / 2 : n : 0);
              (T || a) && (e = this.adaptor.append(e, this.svg("g")), this.place(T, a, e)), this.addChildren(e);
            }, e.kind = s.MmlMpadded.prototype.kind, e;
          }((0, Q.CommonMpaddedMixin)(a.SVGWrapper));
        e.SVGmpadded = T;
      },
      3572: function _(t, e, r) {
        var _n101,
          o = this && this.__extends || (_n101 = function n(t, e) {
            return _n101 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n101(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n101(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmphantom = void 0;
        var i = r(7079),
          a = r(5741),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              this.standardSVGnode(t);
            }, e.kind = a.MmlMphantom.prototype.kind, e;
          }(i.SVGWrapper);
        e.SVGmphantom = Q;
      },
      7725: function _(t, e, r) {
        var _n102,
          o = this && this.__extends || (_n102 = function n(t, e) {
            return _n102 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n102(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n102(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmroot = void 0;
        var a = r(1107),
          Q = r(9086),
          s = r(6145),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addRoot = function (t, e, r, n) {
              e.toSVG(t);
              var o = i(this.getRootDimens(r, n), 3),
                a = o[0],
                Q = o[1],
                s = o[2],
                T = e.getOuterBBox();
              e.place(s * T.rscale, Q), this.dx = a;
            }, e.kind = s.MmlMroot.prototype.kind, e;
          }((0, Q.CommonMrootMixin)(a.SVGmsqrt));
        e.SVGmroot = T;
      },
      3289: function _(t, e, r) {
        var _n103,
          o = this && this.__extends || (_n103 = function n(t, e) {
            return _n103 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n103(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n103(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGinferredMrow = e.SVGmrow = void 0;
        var i = r(7079),
          a = r(8411),
          Q = r(8411),
          s = r(9878),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.node.isInferred ? this.element = t : this.standardSVGnode(t);
              this.addChildren(e);
            }, e.kind = s.MmlMrow.prototype.kind, e;
          }((0, a.CommonMrowMixin)(i.SVGWrapper));
        e.SVGmrow = T;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = s.MmlInferredMrow.prototype.kind, e;
        }((0, Q.CommonInferredMrowMixin)(T));
        e.SVGinferredMrow = l;
      },
      3735: function _(t, e, r) {
        var _n104,
          o = this && this.__extends || (_n104 = function n(t, e) {
            return _n104 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n104(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n104(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGms = void 0;
        var i = r(7079),
          a = r(4126),
          Q = r(7265),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = Q.MmlMs.prototype.kind, e;
          }((0, a.CommonMsMixin)(i.SVGWrapper));
        e.SVGms = s;
      },
      6465: function _(t, e, r) {
        var _n105,
          o = this && this.__extends || (_n105 = function n(t, e) {
            return _n105 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n105(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n105(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmspace = void 0;
        var i = r(7079),
          a = r(258),
          Q = r(6030),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = Q.MmlMspace.prototype.kind, e;
          }((0, a.CommonMspaceMixin)(i.SVGWrapper));
        e.SVGmspace = s;
      },
      1107: function _(t, e, r) {
        var _n106,
          o = this && this.__extends || (_n106 = function n(t, e) {
            return _n106 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n106(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n106(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmsqrt = void 0;
        var i = r(7079),
          a = r(4093),
          Q = r(7131),
          s = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.dx = 0, e;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.childNodes[this.surd],
                r = this.childNodes[this.base],
                n = this.root ? this.childNodes[this.root] : null,
                o = e.getBBox(),
                i = r.getOuterBBox(),
                a = this.getPQ(o)[1],
                Q = this.font.params.rule_thickness * this.bbox.scale,
                s = i.h + a + Q,
                T = this.standardSVGnode(t),
                l = this.adaptor.append(T, this.svg("g"));
              this.addRoot(T, n, o, s), e.toSVG(T), e.place(this.dx, s - o.h), r.toSVG(l), r.place(this.dx + o.w, 0), this.adaptor.append(T, this.svg("rect", {
                width: this.fixed(i.w),
                height: this.fixed(Q),
                x: this.fixed(this.dx + o.w),
                y: this.fixed(s - Q)
              }));
            }, e.prototype.addRoot = function (t, e, r, n) {}, e.kind = Q.MmlMsqrt.prototype.kind, e;
          }((0, a.CommonMsqrtMixin)(i.SVGWrapper));
        e.SVGmsqrt = s;
      },
      4445: function _(t, e, r) {
        var _n107,
          o = this && this.__extends || (_n107 = function n(t, e) {
            return _n107 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n107(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n107(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmsubsup = e.SVGmsup = e.SVGmsub = void 0;
        var a = r(6369),
          Q = r(905),
          s = r(905),
          T = r(905),
          l = r(4461),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = l.MmlMsub.prototype.kind, e;
          }((0, Q.CommonMsubMixin)(a.SVGscriptbase));
        e.SVGmsub = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = l.MmlMsup.prototype.kind, e;
        }((0, s.CommonMsupMixin)(a.SVGscriptbase));
        e.SVGmsup = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (t) {
            var e = this.standardSVGnode(t),
              r = i([this.baseChild, this.supChild, this.subChild], 3),
              n = r[0],
              o = r[1],
              a = r[2],
              Q = this.getBaseWidth(),
              s = this.getAdjustedIc(),
              T = i(this.getUVQ(), 2),
              l = T[0],
              c = T[1];
            n.toSVG(e), o.toSVG(e), a.toSVG(e), a.place(Q, c), o.place(Q + s, l);
          }, e.kind = l.MmlMsubsup.prototype.kind, e;
        }((0, T.CommonMsubsupMixin)(a.SVGscriptbase));
        e.SVGmsubsup = p;
      },
      2558: function _(t, e, r) {
        var _n108,
          o = this && this.__extends || (_n108 = function n(t, e) {
            return _n108 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n108(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n108(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmtable = void 0;
        var Q = r(7079),
          s = r(6237),
          T = r(1349),
          l = function (t) {
            function e(e, r, n) {
              void 0 === n && (n = null);
              var o = t.call(this, e, r, n) || this,
                i = {
                  "data-labels": !0
                };
              return o.isTop && (i.transform = "matrix(1 0 0 -1 0 0)"), o.labels = o.svg("g", i), o;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t);
              this.placeRows(e), this.handleColumnLines(e), this.handleRowLines(e), this.handleFrame(e);
              var r = this.handlePWidth(e);
              this.handleLabels(e, t, r);
            }, e.prototype.placeRows = function (t) {
              for (var e, r, n, o = this.node.attributes.get("equalrows"), Q = this.getTableData(), s = Q.H, T = Q.D, l = this.getEqualRowHeight(), c = this.getRowHalfSpacing(), u = a(a([this.fLine], i(this.rLines), !1), [this.fLine], !1), p = this.getBBox().h - u[0], h = 0; h < this.numRows; h++) {
                var d = this.childNodes[h];
                e = i(this.getRowHD(o, l, s[h], T[h]), 2), d.H = e[0], d.D = e[1], r = i([c[h], c[h + 1]], 2), d.tSpace = r[0], d.bSpace = r[1], n = i([u[h], u[h + 1]], 2), d.tLine = n[0], d.bLine = n[1], d.toSVG(t), d.place(0, p - c[h] - d.H), p -= c[h] + d.H + d.D + c[h + 1] + u[h + 1];
              }
            }, e.prototype.getRowHD = function (t, e, r, n) {
              return t ? [(e + r - n) / 2, (e - r + n) / 2] : [r, n];
            }, e.prototype.handleColor = function () {
              t.prototype.handleColor.call(this);
              var e = this.firstChild();
              e && this.adaptor.setAttribute(e, "width", this.fixed(this.getWidth()));
            }, e.prototype.handleColumnLines = function (t) {
              if ("none" !== this.node.attributes.get("columnlines")) {
                var e = this.getColumnAttributes("columnlines");
                if (e) for (var r = this.getColumnHalfSpacing(), n = this.cLines, o = this.getComputedWidths(), i = this.fLine, a = 0; a < e.length; a++) i += r[a] + o[a] + r[a + 1], "none" !== e[a] && this.adaptor.append(t, this.makeVLine(i, e[a], n[a])), i += n[a];
              }
            }, e.prototype.handleRowLines = function (t) {
              if ("none" !== this.node.attributes.get("rowlines")) {
                var e = this.getRowAttributes("rowlines");
                if (e) for (var r = this.node.attributes.get("equalrows"), n = this.getTableData(), o = n.H, a = n.D, Q = this.getEqualRowHeight(), s = this.getRowHalfSpacing(), T = this.rLines, l = this.getBBox().h - this.fLine, c = 0; c < e.length; c++) {
                  var u = i(this.getRowHD(r, Q, o[c], a[c]), 2),
                    p = u[0],
                    h = u[1];
                  l -= s[c] + p + h + s[c + 1], "none" !== e[c] && this.adaptor.append(t, this.makeHLine(l, e[c], T[c])), l -= T[c];
                }
              }
            }, e.prototype.handleFrame = function (t) {
              if (this.frame && this.fLine) {
                var e = this.getBBox(),
                  r = e.h,
                  n = e.d,
                  o = e.w,
                  i = this.node.attributes.get("frame");
                this.adaptor.append(t, this.makeFrame(o, r, n, i));
              }
            }, e.prototype.handlePWidth = function (t) {
              if (!this.pWidth) return 0;
              var e = this.getBBox(),
                r = e.w,
                n = e.L,
                o = e.R,
                i = n + this.pWidth + o,
                a = this.getAlignShift()[0],
                Q = Math.max(this.isTop ? i : 0, this.container.getWrapWidth(this.containerI)) - n - o,
                s = r - (this.pWidth > Q ? Q : this.pWidth),
                T = "left" === a ? 0 : "right" === a ? s : s / 2;
              if (T) {
                var l = this.svg("g", {}, this.adaptor.childNodes(t));
                this.place(T, 0, l), this.adaptor.append(t, l);
              }
              return T;
            }, e.prototype.lineClass = function (t) {
              return "mjx-" + t;
            }, e.prototype.makeFrame = function (t, e, r, n) {
              var o = this.fLine;
              return this.svg("rect", this.setLineThickness(o, n, {
                "data-frame": !0,
                class: this.lineClass(n),
                width: this.fixed(t - o),
                height: this.fixed(e + r - o),
                x: this.fixed(o / 2),
                y: this.fixed(o / 2 - r)
              }));
            }, e.prototype.makeVLine = function (t, e, r) {
              var n = this.getBBox(),
                o = n.h,
                i = n.d,
                a = "dotted" === e ? r / 2 : 0,
                Q = this.fixed(t + r / 2);
              return this.svg("line", this.setLineThickness(r, e, {
                "data-line": "v",
                class: this.lineClass(e),
                x1: Q,
                y1: this.fixed(a - i),
                x2: Q,
                y2: this.fixed(o - a)
              }));
            }, e.prototype.makeHLine = function (t, e, r) {
              var n = this.getBBox().w,
                o = "dotted" === e ? r / 2 : 0,
                i = this.fixed(t - r / 2);
              return this.svg("line", this.setLineThickness(r, e, {
                "data-line": "h",
                class: this.lineClass(e),
                x1: this.fixed(o),
                y1: i,
                x2: this.fixed(n - o),
                y2: i
              }));
            }, e.prototype.setLineThickness = function (t, e, r) {
              return .07 !== t && (r["stroke-thickness"] = this.fixed(t), "solid" !== e && (r["stroke-dasharray"] = ("dotted" === e ? "0," : "") + this.fixed(2 * t))), r;
            }, e.prototype.handleLabels = function (t, e, r) {
              if (this.hasLabels) {
                var n = this.labels,
                  o = this.node.attributes.get("side");
                this.spaceLabels(), this.isTop ? this.topTable(t, n, o) : this.subTable(t, n, o, r);
              }
            }, e.prototype.spaceLabels = function () {
              for (var t = this.adaptor, e = this.getBBox().h, r = this.getTableData().L, n = this.getRowHalfSpacing(), o = e - this.fLine, i = t.firstChild(this.labels), a = 0; a < this.numRows; a++) {
                var Q = this.childNodes[a];
                if (Q.node.isKind("mlabeledtr")) {
                  var s = Q.childNodes[0];
                  o -= n[a] + Q.H, Q.placeCell(s, {
                    x: 0,
                    y: o,
                    w: r,
                    lSpace: 0,
                    rSpace: 0,
                    lLine: 0,
                    rLine: 0
                  }), o -= Q.D + n[a + 1] + this.rLines[a], i = t.next(i);
                } else o -= n[a] + Q.H + Q.D + n[a + 1] + this.rLines[a];
              }
            }, e.prototype.topTable = function (t, e, r) {
              var n = this.adaptor,
                o = this.getBBox(),
                a = o.h,
                Q = o.d,
                s = o.w,
                T = o.L,
                l = o.R,
                c = T + (this.pWidth || s) + l,
                u = this.getTableData().L,
                p = i(this.getPadAlignShift(r), 3),
                h = p[1],
                d = p[2] + ("right" === h ? -c : "center" === h ? -c / 2 : 0) + T,
                f = "matrix(1 0 0 -1 0 0)",
                m = "scale(".concat(this.jax.fixed(1e3 * this.font.params.x_height / this.metrics.ex, 2), ")"),
                L = "translate(0 ".concat(this.fixed(a), ") ").concat(f, " ").concat(m),
                y = this.svg("svg", {
                  "data-table": !0,
                  preserveAspectRatio: "left" === h ? "xMinYMid" : "right" === h ? "xMaxYMid" : "xMidYMid",
                  viewBox: [this.fixed(-d), this.fixed(-a), 1, this.fixed(a + Q)].join(" ")
                }, [this.svg("g", {
                  transform: f
                }, n.childNodes(t))]);
              e = this.svg("svg", {
                "data-labels": !0,
                preserveAspectRatio: "left" === r ? "xMinYMid" : "xMaxYMid",
                viewBox: ["left" === r ? 0 : this.fixed(u), this.fixed(-a), 1, this.fixed(a + Q)].join(" ")
              }, [e]), n.append(t, this.svg("g", {
                transform: L
              }, [y, e])), this.place(-T, 0, t);
            }, e.prototype.subTable = function (t, e, r, n) {
              var o = this.adaptor,
                i = this.getBBox(),
                a = i.w,
                Q = i.L,
                s = i.R,
                T = Q + (this.pWidth || a) + s,
                l = this.getTableData().L,
                c = this.getAlignShift()[0],
                u = Math.max(T, this.container.getWrapWidth(this.containerI));
              this.place("left" === r ? ("left" === c ? 0 : "right" === c ? T - u + n : (T - u) / 2 + n) - Q : ("left" === c ? u : "right" === c ? T + n : (u + T) / 2 + n) - Q - l, 0, e), o.append(t, e);
            }, e.kind = T.MmlMtable.prototype.kind, e.styles = {
              'g[data-mml-node="mtable"] > line[data-line], svg[data-table] > g > line[data-line]': {
                "stroke-width": "70px",
                fill: "none"
              },
              'g[data-mml-node="mtable"] > rect[data-frame], svg[data-table] > g > rect[data-frame]': {
                "stroke-width": "70px",
                fill: "none"
              },
              'g[data-mml-node="mtable"] > .mjx-dashed, svg[data-table] > g > .mjx-dashed': {
                "stroke-dasharray": "140"
              },
              'g[data-mml-node="mtable"] > .mjx-dotted, svg[data-table] > g > .mjx-dotted': {
                "stroke-linecap": "round",
                "stroke-dasharray": "0,140"
              },
              'g[data-mml-node="mtable"] > g > svg': {
                overflow: "visible"
              }
            }, e;
          }((0, s.CommonMtableMixin)(Q.SVGWrapper));
        e.SVGmtable = l;
      },
      8926: function _(t, e, r) {
        var _n109,
          o = this && this.__extends || (_n109 = function n(t, e) {
            return _n109 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n109(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n109(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmtd = void 0;
        var i = r(7079),
          a = r(5164),
          Q = r(4359),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.placeCell = function (t, e, r, n, o) {
              var i = this.getBBox(),
                a = Math.max(i.h, .75),
                Q = Math.max(i.d, .25),
                s = this.node.attributes.get("columnalign"),
                T = this.node.attributes.get("rowalign"),
                l = this.getAlignX(r, i, s),
                c = this.getAlignY(n, o, a, Q, T);
              return this.place(t + l, e + c), [l, c];
            }, e.prototype.placeColor = function (t, e, r, n) {
              var o = this.adaptor,
                i = this.firstChild();
              i && "rect" === o.kind(i) && o.getAttribute(i, "data-bgcolor") && (o.setAttribute(i, "x", this.fixed(t)), o.setAttribute(i, "y", this.fixed(e)), o.setAttribute(i, "width", this.fixed(r)), o.setAttribute(i, "height", this.fixed(n)));
            }, e.kind = Q.MmlMtd.prototype.kind, e;
          }((0, a.CommonMtdMixin)(i.SVGWrapper));
        e.SVGmtd = s;
      },
      3365: function _(t, e, r) {
        var _n110,
          o = this && this.__extends || (_n110 = function n(t, e) {
            return _n110 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n110(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n110(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmtext = void 0;
        var i = r(7079),
          a = r(6319),
          Q = r(4770),
          s = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.kind = Q.MmlMtext.prototype.kind, e;
          }((0, a.CommonMtextMixin)(i.SVGWrapper));
        e.SVGmtext = s;
      },
      3006: function _(t, e, r) {
        var _n111,
          o = this && this.__extends || (_n111 = function n(t, e) {
            return _n111 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n111(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n111(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmlabeledtr = e.SVGmtr = void 0;
        var Q = r(7079),
          s = r(5766),
          T = r(5766),
          l = r(5022),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t);
              this.placeCells(e), this.placeColor();
            }, e.prototype.placeCells = function (t) {
              for (var e = this.parent.getColumnHalfSpacing(), r = a(a([this.parent.fLine], i(this.parent.cLines), !1), [this.parent.fLine], !1), n = this.parent.getComputedWidths(), o = 1 / this.getBBox().rscale, Q = r[0], s = 0; s < this.numCells; s++) {
                var T = this.getChild(s);
                T.toSVG(t), Q += this.placeCell(T, {
                  x: Q,
                  y: 0,
                  lSpace: e[s] * o,
                  rSpace: e[s + 1] * o,
                  w: n[s] * o,
                  lLine: r[s] * o,
                  rLine: r[s + 1] * o
                });
              }
            }, e.prototype.placeCell = function (t, e) {
              var r = e.x,
                n = e.y,
                o = e.lSpace,
                a = e.w,
                Q = e.rSpace,
                s = e.lLine,
                T = e.rLine,
                l = 1 / this.getBBox().rscale,
                c = i([this.H * l, this.D * l], 2),
                u = c[0],
                p = c[1],
                h = i([this.tSpace * l, this.bSpace * l], 2),
                d = h[0],
                f = h[1],
                m = i(t.placeCell(r + o, n, a, u, p), 2),
                L = m[0],
                y = m[1],
                g = o + a + Q;
              return t.placeColor(-(L + o + s / 2), -(p + f + y), g + (s + T) / 2, u + p + d + f), g + T;
            }, e.prototype.placeColor = function () {
              var t = 1 / this.getBBox().rscale,
                e = this.adaptor,
                r = this.firstChild();
              if (r && "rect" === e.kind(r) && e.getAttribute(r, "data-bgcolor")) {
                var n = i([this.tLine / 2 * t, this.bLine / 2 * t], 2),
                  o = n[0],
                  a = n[1],
                  Q = i([this.tSpace * t, this.bSpace * t], 2),
                  s = Q[0],
                  T = Q[1],
                  l = i([this.H * t, this.D * t], 2),
                  c = l[0],
                  u = l[1];
                e.setAttribute(r, "y", this.fixed(-(u + T + a))), e.setAttribute(r, "width", this.fixed(this.parent.getWidth() * t)), e.setAttribute(r, "height", this.fixed(o + s + c + u + T + a));
              }
            }, e.kind = l.MmlMtr.prototype.kind, e;
          }((0, s.CommonMtrMixin)(Q.SVGWrapper));
        e.SVGmtr = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (e) {
            t.prototype.toSVG.call(this, e);
            var r = this.childNodes[0];
            r && r.toSVG(this.parent.labels);
          }, e.kind = l.MmlMlabeledtr.prototype.kind, e;
        }((0, T.CommonMlabeledtrMixin)(c));
        e.SVGmlabeledtr = u;
      },
      8835: function _(t, e, r) {
        var _n112,
          o = this && this.__extends || (_n112 = function n(t, e) {
            return _n112 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n112(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n112(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGmunderover = e.SVGmover = e.SVGmunder = void 0;
        var a = r(4445),
          Q = r(1971),
          s = r(1971),
          T = r(1971),
          l = r(5184),
          c = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (e) {
              if (this.hasMovableLimits()) t.prototype.toSVG.call(this, e);else {
                var r = this.standardSVGnode(e),
                  n = i([this.baseChild, this.scriptChild], 2),
                  o = n[0],
                  a = n[1],
                  Q = i([o.getOuterBBox(), a.getOuterBBox()], 2),
                  s = Q[0],
                  T = Q[1];
                o.toSVG(r), a.toSVG(r);
                var l = this.isLineBelow ? 0 : this.getDelta(!0),
                  c = this.getUnderKV(s, T)[1],
                  u = i(this.getDeltaW([s, T], [0, -l]), 2),
                  p = u[0],
                  h = u[1];
                o.place(p, 0), a.place(h, c);
              }
            }, e.kind = l.MmlMunder.prototype.kind, e;
          }((0, Q.CommonMunderMixin)(a.SVGmsub));
        e.SVGmunder = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (e) {
            if (this.hasMovableLimits()) t.prototype.toSVG.call(this, e);else {
              var r = this.standardSVGnode(e),
                n = i([this.baseChild, this.scriptChild], 2),
                o = n[0],
                a = n[1],
                Q = i([o.getOuterBBox(), a.getOuterBBox()], 2),
                s = Q[0],
                T = Q[1];
              o.toSVG(r), a.toSVG(r);
              var l = this.isLineAbove ? 0 : this.getDelta(),
                c = this.getOverKU(s, T)[1],
                u = i(this.getDeltaW([s, T], [0, l]), 2),
                p = u[0],
                h = u[1];
              o.place(p, 0), a.place(h, c);
            }
          }, e.kind = l.MmlMover.prototype.kind, e;
        }((0, s.CommonMoverMixin)(a.SVGmsup));
        e.SVGmover = u;
        var p = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (e) {
            if (this.hasMovableLimits()) t.prototype.toSVG.call(this, e);else {
              var r = this.standardSVGnode(e),
                n = i([this.baseChild, this.overChild, this.underChild], 3),
                o = n[0],
                a = n[1],
                Q = n[2],
                s = i([o.getOuterBBox(), a.getOuterBBox(), Q.getOuterBBox()], 3),
                T = s[0],
                l = s[1],
                c = s[2];
              o.toSVG(r), Q.toSVG(r), a.toSVG(r);
              var u = this.getDelta(),
                p = this.getOverKU(T, l)[1],
                h = this.getUnderKV(T, c)[1],
                d = i(this.getDeltaW([T, c, l], [0, this.isLineBelow ? 0 : -u, this.isLineAbove ? 0 : u]), 3),
                f = d[0],
                m = d[1],
                L = d[2];
              o.place(f, 0), Q.place(m, h), a.place(L, p);
            }
          }, e.kind = l.MmlMunderover.prototype.kind, e;
        }((0, T.CommonMunderoverMixin)(a.SVGmsubsup));
        e.SVGmunderover = p;
      },
      6369: function _(t, e, r) {
        var _n113,
          o = this && this.__extends || (_n113 = function n(t, e) {
            return _n113 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n113(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n113(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGscriptbase = void 0;
        var a = r(7079),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t),
                r = this.getBaseWidth(),
                n = i(this.getOffset(), 2),
                o = n[0],
                a = n[1];
              this.baseChild.toSVG(e), this.scriptChild.toSVG(e), this.scriptChild.place(r + o, a);
            }, e.kind = "scriptbase", e;
          }((0, r(167).CommonScriptbaseMixin)(a.SVGWrapper));
        e.SVGscriptbase = Q;
      },
      2417: function _(t, e, r) {
        var _n114,
          o = this && this.__extends || (_n114 = function n(t, e) {
            return _n114 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n114(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n114(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SVGxml = e.SVGannotationXML = e.SVGannotation = e.SVGsemantics = void 0;
        var i = r(7079),
          a = r(5806),
          Q = r(9102),
          s = r(9007),
          T = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.toSVG = function (t) {
              var e = this.standardSVGnode(t);
              this.childNodes.length && this.childNodes[0].toSVG(e);
            }, e.kind = Q.MmlSemantics.prototype.kind, e;
          }((0, a.CommonSemanticsMixin)(i.SVGWrapper));
        e.SVGsemantics = T;
        var l = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (e) {
            t.prototype.toSVG.call(this, e);
          }, e.prototype.computeBBox = function () {
            return this.bbox;
          }, e.kind = Q.MmlAnnotation.prototype.kind, e;
        }(i.SVGWrapper);
        e.SVGannotation = l;
        var c = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.kind = Q.MmlAnnotationXML.prototype.kind, e.styles = {
            "foreignObject[data-mjx-xml]": {
              "font-family": "initial",
              "line-height": "normal",
              overflow: "visible"
            }
          }, e;
        }(i.SVGWrapper);
        e.SVGannotationXML = c;
        var u = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.toSVG = function (t) {
            var e = this.adaptor.clone(this.node.getXML()),
              r = this.jax.math.metrics.em * this.jax.math.metrics.scale,
              n = this.fixed(1 / r),
              o = this.getBBox(),
              i = o.w,
              a = o.h,
              Q = o.d;
            this.element = this.adaptor.append(t, this.svg("foreignObject", {
              "data-mjx-xml": !0,
              y: this.jax.fixed(-a * r) + "px",
              width: this.jax.fixed(i * r) + "px",
              height: this.jax.fixed((a + Q) * r) + "px",
              transform: "scale(".concat(n, ") matrix(1 0 0 -1 0 0)")
            }, [e]));
          }, e.prototype.computeBBox = function (t, e) {
            void 0 === e && (e = !1);
            var r = this.jax.measureXMLnode(this.node.getXML()),
              n = r.w,
              o = r.h,
              i = r.d;
            t.w = n, t.h = o, t.d = i;
          }, e.prototype.getStyles = function () {}, e.prototype.getScale = function () {}, e.prototype.getVariant = function () {}, e.kind = s.XMLNode.prototype.kind, e.autoStyle = !1, e;
        }(i.SVGWrapper);
        e.SVGxml = u;
      },
      42: function _(t, e, r) {
        var _n115,
          o = this && this.__extends || (_n115 = function n(t, e) {
            return _n115 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n115(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n115(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TeXFont = void 0;
        var a = r(768),
          Q = r(5920),
          s = r(7040),
          T = r(2560),
          l = r(2810),
          c = r(6982),
          u = r(175),
          p = r(5735),
          h = r(8594),
          d = r(4749),
          f = r(9320),
          m = r(466),
          L = r(9671),
          y = r(3746),
          g = r(3240),
          v = r(1325),
          b = r(4164),
          H = r(8652),
          _ = r(5667),
          M = r(5821),
          x = r(957),
          O = r(1044),
          S = r(7292),
          V = r(2162),
          E = r(9244),
          A = r(5525),
          C = r(9124),
          w = function (t) {
            function e(e) {
              var r, n;
              void 0 === e && (e = null);
              var o = t.call(this, e) || this,
                a = o.constructor;
              try {
                for (var Q = i(Object.keys(a.variantCacheIds)), s = Q.next(); !s.done; s = Q.next()) {
                  var T = s.value;
                  o.variant[T].cacheID = "TEX-" + a.variantCacheIds[T];
                }
              } catch (t) {
                r = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (n = Q.return) && n.call(Q);
                } finally {
                  if (r) throw r.error;
                }
              }
              return o;
            }
            return o(e, t), e.defaultDelimiters = C.delimiters, e.defaultChars = {
              normal: f.normal,
              bold: T.bold,
              italic: p.italic,
              "bold-italic": s.boldItalic,
              "double-struck": l.doubleStruck,
              fraktur: u.fraktur,
              "bold-fraktur": c.frakturBold,
              script: b.script,
              "bold-script": v.scriptBold,
              "sans-serif": g.sansSerif,
              "bold-sans-serif": L.sansSerifBold,
              "sans-serif-italic": y.sansSerifItalic,
              "sans-serif-bold-italic": m.sansSerifBoldItalic,
              monospace: d.monospace,
              "-smallop": H.smallop,
              "-largeop": h.largeop,
              "-size3": V.texSize3,
              "-size4": E.texSize4,
              "-tex-calligraphic": M.texCalligraphic,
              "-tex-bold-calligraphic": _.texCalligraphicBold,
              "-tex-mathit": x.texMathit,
              "-tex-oldstyle": S.texOldstyle,
              "-tex-bold-oldstyle": O.texOldstyleBold,
              "-tex-variant": A.texVariant
            }, e.variantCacheIds = {
              normal: "N",
              bold: "B",
              italic: "I",
              "bold-italic": "BI",
              "double-struck": "D",
              fraktur: "F",
              "bold-fraktur": "BF",
              script: "S",
              "bold-script": "BS",
              "sans-serif": "SS",
              "bold-sans-serif": "BSS",
              "sans-serif-italic": "SSI",
              "sans-serif-bold-italic": "SSBI",
              monospace: "M",
              "-smallop": "SO",
              "-largeop": "LO",
              "-size3": "S3",
              "-size4": "S4",
              "-tex-calligraphic": "C",
              "-tex-bold-calligraphic": "BC",
              "-tex-mathit": "MI",
              "-tex-oldstyle": "OS",
              "-tex-bold-oldstyle": "BOS",
              "-tex-variant": "V"
            }, e;
          }((0, Q.CommonTeXFontMixin)(a.SVGFontData));
        e.TeXFont = w;
      },
      7040: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.boldItalic = void 0;
        var n = r(768),
          o = r(5887);
        e.boldItalic = (0, n.AddPaths)(o.boldItalic, {
          47: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
          305: "24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
          567: "297 360T297 373T294 392T288 400T278 401H276Q237 398 200 363Q181 343 170 325T156 299T149 287T129 282H123H116Q102 282 97 284T92 298Q93 303 98 315T118 349T151 390T201 427T267 451H279Q357 451 388 422T420 354V339L370 138Q321 -60 317 -69Q287 -157 163 -194Q133 -201 99 -201Q39 -201 14 -178T-12 -125Q-12 -94 11 -69T68 -43Q93 -43 108 -57T123 -95Q123 -121 100 -151H104Q131 -151 155 -125T193 -60Q195 -54 244 141T294 345Q297 360 297 373",
          8260: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
          8710: "65 0Q59 6 59 9T61 16Q64 20 334 357T608 698Q616 706 629 710Q630 710 634 710T644 710T656 711Q686 711 694 703Q698 699 700 693Q706 674 805 345T904 14Q904 7 894 1L479 0H65ZM630 342L567 551L232 134L462 133H693Q693 137 630 342",
          10744: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210"
        }, {});
      },
      2560: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.bold = void 0;
        var n = r(768),
          o = r(1103);
        e.bold = (0, n.AddPaths)(o.bold, {
          33: "89 629Q89 663 116 684T171 705Q215 705 237 681T260 634Q260 619 233 434T204 244Q201 237 175 237Q150 237 146 244Q144 248 117 433T89 629ZM90 86Q90 125 116 148T177 171Q211 169 235 146T259 86Q259 48 235 25T175 1Q138 1 114 24T90 86",
          34: "38 572T38 608T61 669T121 694Q167 694 196 657T225 559Q225 520 214 482T186 418T151 370T119 339T99 329T82 340T70 360Q70 365 74 369T92 385T122 414Q142 441 154 471T170 518L172 535L166 532Q160 530 148 527T122 523Q85 523 62 547ZM305 572T305 608T328 669T388 694Q434 694 463 657T492 559Q492 520 481 482T453 418T418 370T386 339T366 329T349 340T337 360Q337 365 341 369T359 385T389 414Q409 441 421 471T436 518L439 535L433 532Q427 530 415 527T389 523Q352 523 329 547",
          35: "64 362Q64 380 87 393H363L366 404Q379 443 390 480T409 542T424 590T435 628T443 655T451 674T458 686T467 692T478 694Q490 694 499 686T509 662Q505 643 427 395Q427 393 523 393H620L623 404Q630 426 652 498T691 624T711 681Q718 694 735 694Q748 694 757 685T766 662Q762 643 684 395Q684 393 777 393H871Q872 392 875 390T881 386T887 381T891 374T893 363Q893 345 871 333L767 332H664L660 319Q660 318 638 245T614 171Q614 169 742 169H871L877 165Q883 161 885 159T890 151T893 138Q893 120 871 109L732 108H594L590 95Q587 84 546 -46Q508 -175 505 -178Q498 -193 478 -193Q462 -193 455 -183T448 -164Q448 -156 530 106Q530 108 434 108H337L333 95Q330 84 289 -46Q251 -175 248 -178Q240 -193 222 -193Q206 -193 199 -183T191 -164Q191 -154 273 106Q273 108 180 108L87 109Q64 117 64 139Q64 156 87 169H293L321 262Q326 277 331 294T340 321L343 330Q343 332 215 332L87 333Q64 343 64 362ZM600 330Q600 332 504 332H407L403 319Q403 318 381 245T357 171Q357 169 453 169H550L578 262Q583 277 588 294T597 321L600 330",
          36: "64 494Q64 541 80 579T120 638T171 674T219 693T253 698H256V750H318V699H323Q355 694 380 686T433 663T480 620T506 556Q510 539 510 520Q510 480 488 463T440 445L422 447Q407 451 398 459Q370 478 370 515Q370 542 384 559T412 580L427 584Q424 589 418 596T386 617T324 636H318V434Q411 419 460 355T510 217Q510 196 507 175T492 122T461 67T404 23T318 -4V-56H256V-5H254Q252 -3 240 -3Q194 4 160 23T108 64T80 112T67 156T64 190Q64 218 81 240T134 262Q171 262 187 240T204 193T190 150T153 125Q146 125 144 123Q142 123 149 113T174 89T218 66Q247 58 255 58Q256 58 256 173V287L239 291Q160 308 112 365T64 494ZM255 636Q246 635 236 632T206 620T173 591T160 543Q160 472 256 448V542Q256 636 255 636ZM320 59Q324 59 333 61T356 70T384 89T406 120T415 167Q415 200 395 225T356 260T318 274V59H320",
          37: "65 549Q65 609 84 652T132 714T187 742T236 750Q265 750 296 734T355 697T431 661T541 644Q662 644 736 730Q751 749 767 749T790 739T797 719Q797 710 768 672T504 329Q212 -47 211 -48Q203 -55 191 -55Q161 -55 161 -25Q161 -17 163 -12L642 609Q608 595 542 595Q515 595 488 599T441 608T405 619T381 628L373 632Q373 630 375 619T380 589T383 548Q383 455 343 401T235 347Q217 347 198 351T154 368T110 403T78 462T65 549ZM320 549Q320 633 295 665T235 698H234Q214 698 196 674Q182 650 182 549Q182 509 183 486T190 441T207 409T238 399Q269 399 294 431T320 549ZM745 -56Q727 -56 708 -52T664 -35T620 0T588 59T575 146T588 232T620 291T663 325T708 343T747 347Q810 347 851 294T893 146Q893 89 879 48T841 -15T794 -46T745 -56ZM830 146Q830 230 805 262T745 295H744Q724 295 706 271Q692 247 692 146Q692 106 693 83T700 38T717 6T748 -4Q779 -4 804 28T830 146",
          38: "255 -11Q209 -11 164 4T84 56T48 146Q48 159 50 171Q57 197 72 218T99 249T152 292Q204 333 204 334L194 356Q185 379 176 421T166 511Q166 538 168 551Q182 613 226 654T332 704Q334 704 343 704T358 705Q412 702 444 661T476 565V559Q476 489 334 371L330 368L335 357Q382 272 485 165L496 154L506 163Q543 200 597 273L671 382H601V444H610L732 441Q821 441 830 444H836V382H741L709 335Q702 324 687 302T665 270T646 244T625 216T605 191T581 162T553 132L537 116Q544 109 557 98T605 69T673 51Q711 51 739 70T767 115V118H829V114Q829 70 786 30T668 -11Q570 -11 474 37L451 49L441 43Q352 -11 255 -11ZM415 564Q415 596 400 625T356 654Q329 654 310 634T285 588Q283 580 283 554Q283 475 309 417L325 431Q415 512 415 564ZM192 182Q192 126 213 89T279 51Q348 51 400 83L389 91Q362 112 338 137T295 186T264 229T240 265T227 286Q226 285 222 280T217 272T211 263T205 251T200 238T196 222T193 204T192 182",
          39: "74 572T74 608T97 669T157 694Q203 694 232 657T261 559Q261 520 250 482T222 418T187 370T155 339T135 329Q128 329 117 340T106 359Q106 365 117 375T144 399T176 440T203 505Q204 511 205 518T208 530V535L202 532Q196 530 184 527T158 523Q121 523 98 547",
          40: "103 166T103 251T121 412T165 541T225 639T287 708T341 750H356H361Q382 750 382 736Q382 732 365 714T323 661T274 576T232 439T214 250Q214 -62 381 -229Q382 -231 382 -234Q382 -249 360 -249H356H341Q314 -231 287 -207T226 -138T165 -41T121 89",
          41: "231 251Q231 354 214 439T173 575T123 661T81 714T64 735Q64 744 73 749H75Q77 749 79 749T84 750T90 750H105Q132 732 159 708T220 639T281 542T325 413T343 251T325 89T281 -40T221 -138T159 -207T105 -249H90Q80 -249 76 -249T68 -245T64 -234Q64 -230 81 -212T123 -160T172 -75T214 61T231 251",
          42: "235 706Q235 724 251 737T287 750Q306 750 322 738T339 706Q339 685 318 580V579Q429 663 436 666Q441 668 449 668Q471 668 486 650T501 612Q501 582 478 572Q476 570 414 549L354 528L414 507Q420 505 430 502T445 497T458 492T470 488T479 483T487 478T493 471T497 463T500 454T501 443Q501 423 486 406T449 388H446Q435 388 370 437Q339 461 318 477V476Q339 371 339 350Q339 332 323 319T287 306T251 319T235 350Q235 371 256 476V477Q145 393 138 390Q133 388 125 388Q103 388 88 406T73 444Q73 474 96 484Q98 486 160 507L220 528L160 549Q154 551 144 554T129 559T116 564T104 568T95 573T87 578T81 585T77 593T74 602T73 613Q73 633 88 650T125 668H128Q139 668 204 619Q235 595 256 579V580Q235 685 235 706",
          43: "64 232T64 250T87 281H416V444Q416 608 418 612Q426 633 446 633T475 613Q477 608 477 444V281H807Q808 280 811 278T817 274T823 269T827 262T829 251Q829 230 807 221L642 220H477V57Q477 -107 475 -112Q468 -131 446 -131Q425 -131 418 -112Q416 -107 416 57V220H251L87 221Q64 232 64 250",
          44: "74 85Q74 120 97 145T159 171Q200 171 226 138Q258 101 258 37Q258 -5 246 -44T218 -109T183 -155T152 -184T135 -194Q129 -194 118 -183T106 -164Q106 -157 115 -149Q121 -145 130 -137T161 -100T195 -35Q197 -28 200 -17T204 3T205 11T199 9T183 3T159 0Q120 0 97 26T74 85",
          45: "13 166V278H318V166H13",
          46: "74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85",
          47: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
          58: "74 359Q74 394 98 419T158 444Q200 444 222 417T245 358Q245 329 224 302T160 274Q116 274 95 301T74 359ZM74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85",
          59: "74 359Q74 394 98 419T158 444Q200 444 222 417T245 358Q245 329 224 302T160 274Q116 274 95 301T74 359ZM74 50T74 86T97 146T158 171Q204 171 226 132T248 38Q248 -23 223 -80T171 -165T135 -194Q129 -194 118 -183T106 -164Q106 -163 106 -160L107 -158Q108 -155 121 -142T150 -107T177 -58Q189 -32 194 3Q195 6 193 6Q172 0 158 0Q121 0 98 25",
          60: "797 -56Q797 -68 790 -76T767 -85H759L434 70Q108 226 105 229Q96 238 96 250Q96 263 105 272Q109 276 271 354T595 508T757 585Q763 587 766 587Q780 587 788 578T797 556Q797 544 788 535Q784 531 490 391L197 251Q213 242 359 173T644 37T788 -34Q797 -43 797 -56",
          61: "87 333Q64 343 64 362Q64 383 84 391Q89 393 448 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H87ZM87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H87",
          62: "127 -85Q110 -85 103 -75T96 -55Q96 -41 106 -34Q119 -24 308 65Q361 90 411 114L696 250L427 379Q106 533 103 537Q96 545 96 557Q96 568 104 577T128 587Q137 586 460 431T788 272Q797 263 797 250Q797 238 788 229Q785 226 459 70L135 -85H127",
          63: "65 570Q65 628 119 664T259 700Q326 700 372 688T440 654T469 613T478 569Q478 505 412 465Q287 391 287 294V283Q287 250 284 244T263 237H256H249Q232 237 229 242T225 272V287Q227 364 253 418Q274 463 311 504Q335 530 335 575Q335 622 323 635T259 648Q231 648 209 644T179 636T170 630L172 628Q174 627 177 625T183 620T190 611T197 601T202 587T204 570Q204 539 185 519T134 499Q105 499 85 517T65 570ZM171 86Q171 125 197 148T258 171Q292 169 316 146T340 86Q340 48 316 25T256 1Q218 1 195 24T171 86",
          64: "64 347Q64 511 171 605T434 699Q487 699 500 698Q624 684 703 621T811 464Q828 414 828 344Q828 232 788 179T691 125Q673 125 657 127T628 132T606 140T588 148T576 156T568 162L566 164Q565 164 549 154T504 135T444 125Q349 125 284 183T218 347Q218 455 284 512T448 569Q554 569 610 479H638Q670 479 674 471Q676 468 676 340V258Q676 213 679 199T694 178Q701 174 713 177Q767 187 767 340Q767 489 678 569T446 649Q299 649 213 566T126 346Q126 307 134 269T166 189T225 116T320 65T455 45H463Q606 51 721 91L746 99H782H801Q829 99 829 85Q829 78 825 75T804 65Q800 63 797 62Q625 -6 451 -6Q271 -6 168 91T64 347ZM547 468Q526 493 504 505T444 517T377 476T346 347Q346 306 354 271T386 206T448 177Q505 177 547 226V468",
          91: "128 -250V750H293V689H189V-189H293V-250H128",
          92: "64 718Q63 731 72 740T94 750Q106 750 113 743Q118 741 122 732L318 256Q508 -208 510 -218Q511 -231 502 -240T480 -250Q460 -250 451 -230Q451 -229 259 238T64 718",
          93: "25 689V750H190V-250H25V-189H129V689H25",
          94: "207 632L287 694Q289 693 368 632T448 570T431 545T413 520Q410 520 350 559L287 597L224 559Q164 520 161 520Q160 520 143 544T126 570T207 632",
          95: "0 -61V-10H574V-61H0",
          96: "114 634Q114 663 136 684T183 706Q191 706 196 705T208 700T219 693T232 681T245 666T262 645T282 620Q332 558 337 553Q338 552 318 527L299 503L223 543Q215 547 202 553T183 563T167 571T153 580T141 587T131 595T124 603T118 612T115 622T114 634",
          123: "504 -207T504 -225T500 -246T476 -250H469Q257 -250 227 -145L225 -135L224 0Q224 15 224 30T224 59T224 84T224 106T223 122T223 133V137Q222 138 221 144T213 162T195 185Q171 206 141 215Q123 222 107 223T84 225T74 229T70 250T73 270T83 276T106 276T141 285Q171 294 195 315Q201 321 206 328T214 341T219 352T222 360L223 363V367Q223 371 223 378T223 394T224 415T224 441T224 470T224 501L225 636Q249 739 426 749Q428 749 443 749T466 750H473Q495 750 499 747T504 725T501 704T480 699Q381 693 357 645Q352 634 351 617T350 497V412Q350 350 338 329Q325 303 298 284T251 258T227 251Q226 251 226 250L227 249Q231 248 238 246T265 236T299 217T329 184T349 137Q350 131 350 3T352 -130Q358 -160 392 -178T480 -199Q497 -200 500 -203",
          124: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
          125: "70 726Q71 744 74 747T99 750H106Q323 750 349 636L350 501Q350 486 350 470T350 441T350 416T350 394T351 378T351 367V363Q352 362 353 356T361 338T379 315Q403 294 433 285Q451 278 467 277T490 275T500 271T504 250T501 230T491 224T468 224T433 215Q403 206 379 185Q373 179 368 172T360 159T355 148T352 140L351 137V133Q351 129 351 122T351 106T350 85T350 59T350 31T350 0L349 -135L347 -145Q317 -250 106 -250H99Q79 -250 75 -247T70 -226Q70 -208 73 -204T95 -199Q193 -193 217 -145Q222 -134 223 -117T224 3Q224 20 224 48T223 86Q223 145 237 175T301 232Q335 249 347 249Q348 249 348 250L347 251Q343 252 336 254T309 264T275 284T245 316T225 363Q224 369 224 497T222 631Q216 660 182 678T95 699Q77 700 74 704T70 726",
          126: "343 202Q320 202 278 225T215 249Q181 249 146 214L134 202L115 219Q111 222 106 226T98 234L96 236Q158 306 165 313Q199 344 230 344Q239 344 244 343Q262 339 300 318T359 297Q393 297 428 332L440 344L459 327Q463 324 468 320T476 312L478 310Q416 240 409 233Q375 202 343 202",
          168: "96 615Q96 650 120 672T178 695Q214 693 234 669T255 615Q255 583 232 559T176 535Q147 535 122 556T96 615ZM319 615Q319 651 343 673T399 695Q426 695 452 675T478 615Q478 578 454 557T395 535Q364 537 342 559T319 615",
          172: "680 371Q683 369 688 366T695 361T698 356T701 346T701 332T702 308V216Q702 196 702 168T703 130Q703 90 697 76T671 61Q650 61 643 81Q641 86 641 198V310H364L87 311Q64 319 64 341Q64 362 84 369Q89 371 385 371H680",
          175: "80 540V607H494V540H80",
          176: "160 618Q160 653 193 677T279 702H284Q381 702 407 647Q414 634 414 618Q414 607 410 596T395 570T355 546T287 536T220 545T181 568T165 594T160 618ZM352 618Q352 645 341 652T301 659H292Q286 659 278 659T268 660Q247 660 236 653T224 638T222 619Q222 591 234 585T287 578Q315 578 326 580T345 590T352 618",
          177: "64 328T64 346T87 377H416V542L417 707Q431 728 443 728Q467 728 475 709Q477 704 477 540V377H807Q808 376 811 374T817 370T823 365T827 358T829 347Q829 326 807 317L642 316H477V25H807Q808 24 811 22T817 18T823 13T827 6T829 -5Q829 -26 807 -35H87Q64 -24 64 -6T87 25H416V316H251L87 317Q64 328 64 346",
          180: "391 706Q419 706 439 683T460 634Q460 608 441 593T366 550Q356 545 351 543L275 503L256 527Q236 552 237 553Q242 558 292 620Q299 629 309 641T324 659T336 673T346 685T354 693T363 699T371 703T380 705T391 706",
          183: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251",
          215: "168 500Q168 515 178 522T195 530H198Q207 530 218 521T282 458Q312 428 331 409L447 294L563 409Q674 520 682 525Q687 529 695 529Q711 529 718 520T726 499V498Q726 489 720 481T666 427Q631 392 606 367L490 251L606 135Q717 23 721 17T726 2Q726 -9 719 -18T695 -28H692Q685 -28 674 -18T608 47Q581 74 563 92L447 207L331 91Q217 -22 208 -27Q206 -28 203 -28H197Q168 -28 168 2Q168 13 178 24T288 135L404 250L288 366Q177 479 173 485T168 500",
          247: "344 495Q344 535 372 566T447 597Q490 597 519 566T548 495Q548 452 518 423T446 393Q404 393 374 423T344 495ZM87 221Q64 230 64 251T84 279Q89 281 448 281H806Q807 280 810 278T816 274T822 269T826 262T828 251Q828 230 806 221H87ZM344 -36T344 6T373 78T446 108Q487 108 517 79T548 6Q548 -35 519 -65T446 -96Q406 -96 375 -66",
          305: "247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
          567: "28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
          697: "240 563Q278 563 304 539T331 480V473Q331 462 316 431T217 236Q199 200 174 151T136 78T123 50Q113 33 105 33Q101 33 72 45T38 60Q35 63 35 65Q35 77 101 293T171 517Q182 542 202 552T240 563",
          710: "207 632L287 694Q289 693 368 632T448 570T431 545T413 520Q410 520 350 559L287 597L224 559Q164 520 161 520Q160 520 143 544T126 570T207 632",
          711: "131 603Q130 604 136 618T150 646T158 659L223 635L287 611L351 635L416 659Q417 660 424 647T437 619T443 603Q440 601 364 558T287 515T210 558T131 603",
          713: "80 540V607H494V540H80",
          714: "391 706Q419 706 439 683T460 634Q460 608 441 593T366 550Q356 545 351 543L275 503L256 527Q236 552 237 553Q242 558 292 620Q299 629 309 641T324 659T336 673T346 685T354 693T363 699T371 703T380 705T391 706",
          715: "114 634Q114 663 136 684T183 706Q191 706 196 705T208 700T219 693T232 681T245 666T262 645T282 620Q332 558 337 553Q338 552 318 527L299 503L223 543Q215 547 202 553T183 563T167 571T153 580T141 587T131 595T124 603T118 612T115 622T114 634",
          728: "287 500Q208 500 155 558T102 689V694H153V685Q153 681 154 674T164 648T186 615T226 590T287 578Q347 578 382 611T421 685V694H472V689Q472 623 422 562T287 500",
          729: "202 610Q202 647 227 671T283 695Q324 695 348 669T372 610T350 551T287 525Q248 525 225 551T202 610",
          730: "160 618Q160 653 193 677T279 702H284Q381 702 407 647Q414 634 414 618Q414 607 410 596T395 570T355 546T287 536T220 545T181 568T165 594T160 618ZM352 618Q352 645 341 652T301 659H292Q286 659 278 659T268 660Q247 660 236 653T224 638T222 619Q222 591 234 585T287 578Q315 578 326 580T345 590T352 618",
          732: "343 552Q320 552 278 575T215 599Q181 599 146 564L134 552L115 569Q111 572 106 576T98 584L96 586Q158 656 165 663Q199 694 230 694Q239 694 244 693Q262 689 300 668T359 647Q393 647 428 682L440 694L459 677Q463 674 468 670T476 662L478 660Q416 590 409 583Q375 552 343 552",
          768: "-461 634Q-461 663 -439 684T-392 706Q-384 706 -379 705T-367 700T-356 693T-343 681T-330 666T-313 645T-293 620Q-243 558 -238 553Q-237 552 -257 527L-276 503L-352 543Q-360 547 -373 553T-392 563T-408 571T-422 580T-434 587T-444 595T-451 603T-457 612T-460 622T-461 634",
          769: "-184 706Q-156 706 -136 683T-115 634Q-115 608 -134 593T-209 550Q-219 545 -224 543L-300 503L-319 527Q-339 552 -338 553Q-333 558 -283 620Q-276 629 -266 641T-251 659T-239 673T-229 685T-221 693T-212 699T-204 703T-195 705T-184 706",
          770: "-368 632L-288 694Q-286 693 -207 632T-127 570T-144 545T-162 520Q-165 520 -225 559L-288 597L-351 559Q-411 520 -414 520Q-415 520 -432 544T-449 570T-368 632",
          771: "-232 552Q-255 552 -297 575T-360 599Q-394 599 -429 564L-441 552L-460 569Q-464 572 -469 576T-476 584L-479 586Q-417 656 -410 663Q-376 694 -345 694Q-336 694 -331 693Q-313 689 -275 668T-216 647Q-182 647 -147 682L-135 694L-116 677Q-112 674 -107 670T-100 662L-97 660Q-159 590 -166 583Q-200 552 -232 552",
          772: "-495 540V607H-81V540H-495",
          774: "-288 500Q-367 500 -420 558T-473 689V694H-422V685Q-422 681 -421 674T-411 648T-389 615T-349 590T-288 578Q-228 578 -193 611T-154 685V694H-103V689Q-103 623 -153 562T-288 500",
          775: "-373 610Q-373 647 -348 671T-292 695Q-251 695 -227 669T-203 610T-225 551T-288 525Q-327 525 -350 551T-373 610",
          776: "-479 615Q-479 650 -456 672T-397 695Q-361 693 -341 669T-320 615Q-320 583 -343 559T-399 535Q-428 535 -453 556T-479 615ZM-256 615Q-256 651 -232 673T-176 695Q-149 695 -123 675T-97 615Q-97 578 -121 557T-180 535Q-211 537 -233 559T-256 615",
          778: "-415 618Q-415 653 -382 677T-296 702H-291Q-194 702 -168 647Q-161 634 -161 618Q-161 607 -165 596T-180 570T-220 546T-288 536T-355 545T-394 568T-410 594T-415 618ZM-223 618Q-223 645 -234 652T-274 659H-283Q-289 659 -297 659T-307 660Q-328 660 -339 653T-351 638T-353 619Q-353 591 -341 585T-288 578Q-260 578 -249 580T-230 590T-223 618",
          779: "-389 511L-442 543Q-442 544 -424 606T-404 674Q-390 705 -361 713Q-360 713 -356 713T-349 714Q-340 714 -330 712Q-273 690 -273 644Q-273 621 -290 604L-342 554L-389 511ZM-198 511L-251 543Q-251 544 -233 606T-213 674Q-199 705 -170 713Q-169 713 -165 713T-158 714Q-127 714 -105 693T-82 647Q-82 638 -84 631T-89 618T-99 604T-112 590T-130 574T-151 554L-198 511",
          780: "-444 603Q-445 604 -439 618T-425 646T-417 659L-352 635L-288 611L-224 635L-159 659Q-158 660 -151 647T-138 619T-132 603Q-135 601 -211 558T-288 515T-365 558T-444 603",
          824: "-705 -210Q-715 -210 -724 -203T-734 -179Q-734 -171 -732 -166Q-730 -163 -474 266T-215 698Q-208 711 -190 711Q-180 711 -171 704T-161 681Q-161 672 -164 667Q-171 654 -425 228T-683 -201Q-692 -210 -705 -210",
          8194: "",
          8195: "",
          8196: "",
          8197: "",
          8198: "",
          8201: "",
          8202: "",
          8211: "0 249V300H574V249H0",
          8212: "0 249V300H1149V249H0",
          8213: "0 249V300H1149V249H0",
          8214: "205 -225Q201 -234 199 -237T191 -244T175 -248T161 -246Q151 -240 146 -229Q145 -224 145 251Q145 725 146 730Q156 750 176 750Q193 748 205 727V-225ZM369 727L372 732Q375 737 377 740T385 747T398 750Q406 750 413 747Q423 740 428 730Q430 720 430 251Q430 -219 428 -229Q423 -240 413 -246Q408 -248 400 -248Q393 -248 388 -247T379 -242T375 -236T371 -230L369 -225V727",
          8215: "0 -61V-10H574V-61H0",
          8216: "58 461Q58 503 70 542T99 607T134 654T165 684T184 694T201 683T213 664Q213 658 202 648T175 624T143 583T116 518Q115 512 114 505T112 493L111 488Q132 500 161 500Q198 500 221 475T245 414T222 354T161 329Q112 329 85 369T58 461",
          8217: "74 572T74 608T97 669T157 694Q203 694 232 657T261 559Q261 520 250 482T222 418T187 370T155 339T135 329Q128 329 117 340T106 359Q106 365 117 375T144 399T176 440T203 505Q204 511 205 518T208 530V535L202 532Q196 530 184 527T158 523Q121 523 98 547",
          8220: "110 461Q110 502 121 541T150 606T185 653T217 684T235 694Q242 694 254 682T266 664Q266 659 254 648T226 623T193 578T167 511Q164 500 164 494T164 487Q188 500 212 500Q251 500 274 475T297 414Q297 378 274 354T212 329Q167 329 139 367T110 461ZM377 461Q377 502 388 541T417 606T452 653T484 684T502 694Q509 694 521 682T533 664Q533 659 521 648T493 623T460 578T434 511Q431 500 431 494T431 487Q455 500 479 500Q518 500 541 475T564 414Q564 378 541 354T479 329Q434 329 406 367T377 461",
          8221: "38 572T38 608T61 669T121 694Q167 694 196 657T225 559Q225 520 214 482T186 418T151 370T119 339T99 329T82 340T70 360Q70 365 74 369T92 385T122 414Q142 441 154 471T170 518L172 535L166 532Q160 530 148 527T122 523Q85 523 62 547ZM305 572T305 608T328 669T388 694Q434 694 463 657T492 559Q492 520 481 482T453 418T418 370T386 339T366 329T349 340T337 360Q337 365 341 369T359 385T389 414Q409 441 421 471T436 518L439 535L433 532Q427 530 415 527T389 523Q352 523 329 547",
          8224: "231 470Q232 471 232 473Q232 477 213 540T193 636Q192 642 192 651T204 677T239 700Q249 702 255 702Q300 702 315 660Q317 653 317 636Q317 603 298 539T279 472V470Q280 470 318 488T383 506Q408 506 423 493T442 467T446 444T443 421T424 396T383 382Q355 382 318 400T279 418Q278 416 285 392T303 334T316 284Q318 268 318 234Q318 149 311 45T296 -127T284 -203Q279 -211 255 -211Q237 -211 233 -210T226 -203Q222 -195 214 -129T199 41T192 234V245Q192 286 212 349Q233 413 231 418Q229 418 192 400T128 382Q102 382 86 396T67 421T64 444T67 466T86 492T128 506Q155 506 192 488T231 470",
          8225: "193 637Q193 663 206 679T231 698T255 702T279 699T304 679T317 637Q317 605 299 557T280 504Q280 503 281 503T320 521T382 539Q410 539 428 521T446 476Q446 454 432 434T383 414H377Q358 414 320 431T281 449L280 448Q280 444 298 396T317 316Q318 310 318 301T306 275T271 252Q261 250 255 250Q210 250 195 292Q193 299 193 316Q193 347 211 395T230 448Q230 449 229 449Q227 449 196 434Q151 414 133 414H127Q102 414 87 427T68 452T64 477Q64 503 81 521T127 539Q143 539 164 532T204 515T226 504Q230 502 230 504Q230 508 212 556T193 637ZM193 184Q193 210 206 226T231 245T255 249T279 246T304 226T317 184Q317 153 299 106T280 53Q280 51 282 51T322 68T383 86Q411 86 428 69T445 24T428 -21T382 -39Q358 -39 322 -22T282 -4Q280 -3 280 -3T280 -6Q281 -13 299 -59T317 -136Q318 -142 318 -151T306 -177T271 -200Q261 -202 255 -202Q210 -202 195 -160Q193 -153 193 -136Q193 -106 211 -60T230 -6Q230 -4 228 -4T188 -21T128 -39Q100 -39 83 -22T65 24Q65 53 82 69T127 86Q150 86 187 69T228 51Q230 50 230 50T230 53Q229 58 211 105T193 184",
          8226: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251",
          8230: "74 85Q74 121 99 146T156 171Q200 171 222 143T245 85Q245 56 224 29T160 1Q118 1 96 27T74 85ZM562 85Q562 121 587 146T644 171Q688 171 710 143T733 85Q733 56 712 29T648 1Q606 1 584 27T562 85ZM1050 85Q1050 121 1075 146T1132 171Q1176 171 1198 143T1221 85Q1221 56 1200 29T1136 1Q1094 1 1072 27T1050 85",
          8242: "240 563Q278 563 304 539T331 480V473Q331 462 316 431T217 236Q199 200 174 151T136 78T123 50Q113 33 105 33Q101 33 72 45T38 60Q35 63 35 65Q35 77 101 293T171 517Q182 542 202 552T240 563",
          8254: "80 540V607H494V540H80",
          8260: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
          8407: "406 694Q406 704 413 713T433 723Q448 723 454 719T467 701Q483 665 522 648Q542 637 542 619Q542 605 536 599T514 586Q468 569 431 532Q411 513 399 513Q386 513 378 522T369 543Q369 557 381 568Q385 572 387 574L400 588H228L56 589Q33 598 33 618Q33 636 56 649H426Q406 676 406 694",
          8463: "477 56Q477 48 479 46T490 43Q522 45 544 75T577 140Q582 156 585 159T605 162H611H622Q642 162 642 148Q642 138 632 114T602 62T550 13T478 -8Q429 -8 394 17T358 83Q358 95 395 199T433 350Q433 400 394 400H388H383Q335 400 291 363Q256 332 236 298Q233 293 202 170T169 40Q160 18 141 5T99 -8Q70 -8 58 9T45 39Q45 51 116 336L167 540H80V607H184L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 142 685T220 690Q293 694 307 694Q324 694 328 679Q328 673 311 607H494V540H294Q286 507 278 473T264 420L260 403Q260 400 269 408Q327 451 393 451H401H410Q425 451 439 450T476 442T515 424T544 391T556 337Q556 286 517 179T477 56",
          8467: "245 -19Q228 -19 212 -16T184 -6T162 9T143 27T129 46T118 66T111 84T106 99T102 111L101 116L69 89L36 62Q31 60 24 62Q-1 88 -1 98Q-1 101 1 105Q1 106 73 170L95 189V197Q95 242 112 317T159 476T241 624T353 701Q357 702 367 702Q428 702 444 641Q446 630 446 606Q446 454 241 246L215 220L212 203Q203 150 203 114Q203 113 203 106T204 95T205 82T209 67T214 54T223 43T236 35T253 32Q277 32 305 44T352 70T389 98T407 112Q409 113 412 113Q420 113 432 95Q445 77 443 70Q440 64 416 44T342 3T245 -19ZM387 615Q387 651 366 651Q342 651 321 604T276 470L241 331Q246 331 280 373T350 486T387 615",
          8472: "399 159Q410 159 421 151T433 126Q433 104 410 85Q408 84 410 78Q411 72 414 66T428 51T455 43Q483 43 506 55T543 83T568 125T584 166T594 206Q595 211 596 214Q610 273 610 301Q610 365 542 365H538Q483 365 429 344T337 292T269 229T225 175T210 150L255 99Q261 92 274 78T292 58T305 41T316 22T321 3T324 -23Q324 -87 283 -148T174 -210H171Q161 -210 152 -209T128 -201T101 -180T81 -141T72 -78Q72 -72 72 -60T73 -45Q79 4 102 65L108 81Q84 117 84 167Q84 273 140 367T269 461Q285 461 285 447Q285 440 282 431Q278 418 276 415T264 410Q228 404 201 336T174 219Q174 218 176 202L184 214Q252 303 348 360T549 417Q614 417 658 391T719 317Q726 292 726 260Q726 148 646 70T451 -8Q407 -8 377 17T346 92Q346 159 396 159H399ZM178 -160Q200 -160 216 -132T232 -75Q232 -63 228 -56T203 -26Q196 -18 192 -14Q185 -5 176 5T161 20T156 27L153 28Q151 28 146 8T137 -42T132 -89Q132 -160 178 -160",
          8501: "590 427Q581 427 579 433T575 450T568 470V468L532 288L541 281Q620 220 634 165L637 154V124Q637 74 628 46Q623 32 612 16T592 0Q580 0 578 19T569 69T538 121Q532 126 385 240T236 355Q234 355 231 338T225 291T222 237Q222 222 223 213T225 201T228 195T231 190Q238 179 261 160T300 119T316 73Q316 41 291 23T231 1Q226 0 149 0H98Q73 0 69 3T64 24Q64 43 67 47T85 51H89Q119 51 134 55T152 64T154 76Q154 95 125 141T96 220Q96 243 104 270T123 319T145 360T164 391T172 404T150 421T102 468T68 529L65 541V570Q65 620 74 648Q79 664 91 679T111 694Q122 694 123 675T132 625T164 573Q168 569 319 452T471 335Q471 337 486 409T502 488Q502 489 491 493T467 511T448 546V573Q448 602 452 624T462 659T474 680T486 691T493 694Q499 694 502 691T507 682T513 673Q517 667 534 651T557 630Q558 629 590 616T631 587Q638 577 638 543Q637 489 622 458T590 427",
          8592: "1063 281Q1084 268 1084 251Q1084 231 1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063",
          8593: "33 396Q14 396 14 423Q14 445 18 449T41 459Q72 466 99 478T147 505T185 537T215 571T238 604T254 635T264 661T270 678L272 685Q276 694 288 694Q298 692 300 689T307 672Q331 592 392 535T535 459Q553 454 557 450T561 423Q561 396 542 396Q531 396 501 405T418 443T329 517L319 529L318 179V-171Q307 -193 288 -193Q265 -193 258 -171L257 179V529L247 517Q209 473 158 444T76 405T33 396",
          8594: "65 251Q65 270 87 281H500L914 282Q881 304 842 357T785 482Q781 500 781 501Q781 512 792 517Q794 518 812 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H500L87 221Q65 228 65 251",
          8595: "14 77Q14 104 33 104Q44 104 74 96T156 57T247 -17L257 -29V321Q257 669 259 675Q268 694 289 694Q295 693 300 691T307 686T313 679T318 672V321L319 -29L329 -17Q366 26 417 55T499 94T542 104Q561 104 561 77Q561 56 557 51T535 41Q481 28 438 0T370 -58T330 -119T308 -167T302 -187Q297 -194 288 -194Q278 -194 273 -186T265 -165T251 -127T220 -77Q151 15 41 41Q22 46 18 50T14 77",
          8596: "305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L404 281H744L914 282Q880 305 839 362T785 484Q781 500 781 503Q781 517 806 518Q809 518 811 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495",
          8597: "33 469Q14 469 14 496Q14 518 18 522T41 532Q121 551 182 608T268 745Q275 767 288 767Q299 767 303 755T320 713T355 650Q424 558 535 532Q553 527 557 523T561 496Q561 469 542 469Q531 469 501 478T418 516T329 590L319 602L318 426V74L319 -102L329 -90Q366 -47 417 -18T499 21T542 31Q561 31 561 4Q561 -17 557 -22T535 -32Q454 -51 393 -108T307 -245Q300 -267 288 -267Q279 -267 274 -259T266 -238T250 -200T220 -150Q151 -58 41 -32Q22 -27 18 -23T14 4Q14 31 33 31Q44 31 74 23T156 -16T247 -90L257 -102V602L247 590Q209 546 158 517T76 478T33 469",
          8598: "429 724Q438 724 452 711T466 690Q466 681 452 671Q361 602 242 599H218L756 135Q832 69 913 -1T1036 -108L1077 -143Q1084 -151 1084 -163Q1084 -180 1074 -187T1054 -194H1052Q1043 -194 939 -105Q866 -42 812 5Q180 549 178 549V546Q179 542 179 539Q183 520 183 483Q183 435 172 390T149 323T130 296Q121 292 115 295Q85 312 85 328Q85 331 95 350T115 406T125 486Q125 540 110 583T79 648T64 675Q64 681 68 687T81 693Q87 693 94 690Q162 657 232 657Q296 657 349 681T420 722Q422 724 429 724",
          8599: "1069 693Q1076 693 1080 687T1085 675Q1085 671 1076 656T1055 621T1034 565T1024 486Q1024 442 1034 406T1054 351T1064 328Q1064 321 1057 313T1042 300L1034 295Q1030 293 1027 293Q1023 293 1020 295T1014 301T1009 308T1005 316T1001 324Q980 368 971 419Q966 442 966 484V492Q966 528 972 553Q971 553 757 368T328 -3T107 -191Q103 -193 94 -193Q78 -193 71 -184T64 -164Q64 -153 72 -143Q79 -136 382 124L934 599H909Q837 599 760 634T683 690Q683 697 696 710T722 724Q726 724 742 714T779 691T838 668T920 657Q959 657 991 666T1043 684T1069 693",
          8600: "65 663Q65 680 74 687T93 694H96Q104 694 118 683T204 610Q280 545 338 495Q969 -49 971 -49L970 -46Q970 -42 970 -39Q966 -20 966 18Q966 65 977 110T1001 177T1019 204Q1028 208 1034 205Q1064 188 1064 172Q1064 169 1054 150T1034 94T1024 14Q1024 -28 1033 -64T1054 -120T1075 -155T1085 -175Q1085 -181 1081 -187T1068 -193Q1062 -193 1055 -190Q987 -157 919 -157Q817 -157 739 -215Q727 -224 720 -224Q712 -224 697 -210Q683 -199 683 -190T697 -171Q788 -102 907 -99H931L393 365Q317 431 236 501T114 608L72 643Q65 651 65 663",
          8601: "80 -193Q73 -193 69 -187T64 -175Q64 -172 79 -150T109 -84T125 14Q125 58 115 94T95 149T85 172Q85 179 92 187T108 200L115 205Q119 207 122 207Q126 207 129 205T135 199T140 192T144 184T148 176Q169 132 178 81Q183 58 183 17Q183 -7 182 -24T178 -48L177 -53Q178 -53 389 129T816 498T1043 692Q1049 694 1054 694Q1070 694 1077 684T1085 664Q1085 653 1077 643Q1070 636 767 376L215 -98L240 -99Q312 -99 389 -134T466 -190Q466 -197 452 -210T429 -224Q422 -224 411 -215Q330 -157 229 -157Q190 -157 158 -166T106 -184T80 -193",
          8614: "65 426Q74 448 95 448Q112 448 125 426V281H500L914 282Q881 304 842 357T785 482Q781 500 781 501Q781 512 792 517Q794 518 812 518H817Q832 518 835 515T844 495Q864 412 923 351T1065 270Q1085 263 1085 251Q1085 240 1077 236T1044 225T995 204Q937 173 898 122T844 6Q840 -10 836 -13T816 -17H811Q786 -16 782 -9Q781 -6 781 -2Q781 1 785 17Q813 138 914 220H500L135 221Q134 221 133 221T130 220H125V76Q115 54 95 54Q73 54 65 76V426",
          8617: "1029 475Q1029 505 1068 505Q1129 501 1173 463T1218 363Q1218 296 1170 259T1066 221H1063L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063Q1105 284 1131 305T1158 361Q1158 385 1146 401Q1122 441 1063 444Q1029 446 1029 475",
          8618: "225 221H218Q159 221 112 260T65 363Q65 431 116 468T221 505Q254 503 254 474Q254 456 245 450T216 443T188 438Q152 427 137 401Q125 385 125 362Q125 334 147 310Q171 288 221 281H632L1046 282Q1013 304 974 357T917 482Q913 500 913 501Q913 512 924 517Q926 518 944 518H949Q964 518 967 515T976 495Q996 412 1055 351T1197 270Q1217 263 1217 251Q1217 240 1209 236T1176 225T1127 204Q1069 173 1030 122T976 6Q972 -10 968 -13T948 -17H943Q918 -16 914 -9Q913 -6 913 -2Q913 1 917 17Q945 138 1046 220H632L225 221",
          8636: "1063 281Q1084 268 1084 251Q1084 231 1063 221L572 220Q79 220 77 221Q64 225 64 244Q64 250 64 254T67 261T71 265T78 268T85 272Q142 302 189 345T258 421T296 484T315 516Q319 518 337 518Q358 518 363 512Q370 504 367 496Q360 469 319 404T219 290L209 282L636 281H1063",
          8637: "1063 281Q1084 268 1084 251Q1084 231 1063 221L636 220H209L219 212Q278 162 319 97T367 5Q370 -3 363 -11Q358 -17 337 -17H332Q318 -17 314 -14T302 7Q278 55 246 95T185 160T130 202T88 228L70 237Q64 243 64 257Q64 274 75 279Q78 281 571 281H1063",
          8640: "65 251Q65 270 87 281H513L940 282L930 290Q871 338 830 403T782 496Q779 510 791 517Q794 518 812 518H817Q831 518 835 515T847 494Q871 445 903 404T966 338T1022 298T1064 272T1083 259Q1085 255 1085 245Q1085 225 1072 221Q1070 220 578 220L87 221Q65 228 65 251",
          8641: "84 279Q89 281 580 281Q1070 281 1074 279Q1085 275 1085 256Q1085 245 1083 241T1066 230Q919 153 847 7Q839 -11 835 -14T817 -17H812Q791 -17 786 -11Q779 -3 782 5Q789 31 830 96T930 212L940 220H513L87 221Q64 229 64 250Q64 272 84 279",
          8652: "65 451Q65 470 87 481H513L940 482L930 490Q871 538 830 603T782 696Q779 710 791 717Q794 718 812 718H817Q831 718 835 715T847 694Q871 645 903 604T966 538T1022 498T1064 472T1083 459Q1085 455 1085 445Q1085 425 1072 421Q1070 420 578 420L87 421Q65 428 65 451ZM1063 281Q1084 268 1084 251Q1084 231 1063 221L636 220H209L219 212Q278 162 319 97T367 5Q370 -3 363 -11Q358 -17 337 -17H332Q318 -17 314 -14T302 7Q278 55 246 95T185 160T130 202T88 228L70 237Q64 243 64 257Q64 274 75 279Q78 281 571 281H1063",
          8656: "1063 169L1068 166Q1072 163 1074 162T1079 157T1083 149T1085 139Q1085 118 1063 109L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393H1063Q1064 392 1069 389T1076 384T1082 375T1085 362Q1085 344 1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1063",
          8657: "672 343Q672 326 670 320T657 313Q644 313 602 335Q577 349 557 361T527 381T509 395T499 403T495 406T494 118Q494 -166 492 -174Q484 -193 465 -193H463Q456 -193 453 -192T444 -186T433 -170V465L423 477Q407 495 394 514T367 554T351 579Q349 576 339 560T313 520T279 477L269 465V-22V-102Q269 -132 269 -145T268 -169T266 -180T260 -185T253 -191Q248 -193 239 -193H237Q218 -193 210 -174Q208 -166 208 118Q208 406 207 406L199 399Q191 392 165 374T100 335Q58 313 45 313Q35 313 33 319T30 343V349Q30 359 30 362T35 369T45 374T66 383T100 401Q267 499 333 680Q339 694 351 694Q361 694 365 687T380 652T407 597Q442 536 489 489T573 420T638 383T670 365Q672 361 672 343",
          8658: "64 362Q64 380 87 393H416L745 394L735 405Q708 436 681 477T654 531Q654 547 679 547H684H689Q703 547 710 540T723 519T750 475T806 411Q914 303 1059 271Q1060 271 1063 270T1068 269T1072 268T1076 266T1079 264T1082 260T1083 256T1084 250Q1084 242 1080 238T1063 231T1035 225T992 211T934 185Q797 112 719 -24Q710 -40 706 -43T689 -46H684Q653 -46 653 -31Q653 -24 661 -10Q694 50 737 99L745 108H416L87 109Q64 117 64 139Q64 156 87 169H449L812 170L826 180Q842 193 860 204T892 223T918 237T937 246L944 250L919 264Q866 290 825 321L811 332H449L87 333Q64 343 64 362",
          8659: "30 157Q30 174 32 180T46 187Q59 187 104 163Q154 136 198 101L207 94Q208 94 208 382Q208 666 210 674Q219 694 241 694Q254 692 262 683Q266 679 267 674Q269 658 269 522V35L279 23Q295 5 308 -14T335 -54T351 -79Q353 -76 363 -60T389 -20T423 23L433 35V671Q439 682 444 686T452 692T463 693H465Q484 693 492 674Q494 666 494 382Q494 94 495 94L504 101Q547 135 593 160T652 187Q665 191 671 177Q672 175 672 157Q672 137 669 134T636 116Q606 101 578 83T528 47T486 9T452 -30T424 -68T403 -103T387 -134T377 -159T370 -176L367 -184Q360 -194 351 -194Q345 -194 342 -192T334 -182T327 -166T315 -137T295 -97Q260 -36 213 11T129 80T63 117T32 136Q30 139 30 157",
          8660: "336 497Q358 541 363 544Q367 547 379 547H384Q401 547 405 545Q418 538 414 525T389 474T346 408L335 393H814L803 408Q781 436 760 474T735 525T744 545Q748 547 765 547Q771 547 774 547T780 546T786 544T790 541T794 535T799 527T805 514T813 497Q841 446 877 406T950 340T1014 301T1068 276L1096 265Q1102 259 1102 251Q1102 240 1085 232Q981 195 902 121Q835 56 798 -25Q791 -40 787 -43T765 -46T744 -44Q735 -40 735 -30Q735 -15 760 28T806 98L814 108H335L343 98Q361 75 378 46T404 -1T414 -24Q418 -37 405 -44Q401 -46 384 -46T363 -43T351 -25Q314 56 247 121Q216 150 182 173T125 206T79 226T53 237Q47 243 47 251Q47 254 47 256T49 261T52 264T57 267T61 268T66 270T71 272Q246 335 336 497ZM985 251Q932 280 882 323L871 332H278Q264 321 253 311T237 297T214 282T164 251L176 244Q221 218 278 169H871Q928 218 973 244L985 251",
          8661: "49 441Q30 441 30 464V471V480Q30 498 44 502Q237 573 331 750Q337 767 351 767Q360 767 368 753T400 702T460 629Q504 584 552 554T632 511T666 497Q672 493 672 471Q672 454 670 449Q664 441 653 441Q639 443 591 465T508 513L495 522L494 386V114L495 -22L508 -13Q543 12 591 34T653 59Q672 59 672 36V29V20Q672 2 658 -2Q465 -71 367 -257Q360 -267 351 -267Q343 -267 336 -257T320 -231T292 -187T242 -129Q198 -84 150 -54T70 -11T36 3Q30 7 30 29Q30 46 32 51Q38 59 49 59Q63 57 111 35T194 -13L208 -22V522L194 513Q159 488 111 466T49 441ZM422 584Q411 594 400 606T383 626T366 648T351 667Q349 665 339 652T314 620T280 584L269 573V-73L280 -84Q305 -108 351 -166Q353 -164 363 -151T389 -119T422 -84L433 -73V573L422 584",
          8704: "1 664Q-2 685 23 693H27Q46 693 54 680T102 578L148 475H492L533 570Q541 586 548 603T560 630T569 650T576 667T582 678T588 686T594 691T600 693T609 694Q622 694 631 684T639 662Q637 653 492 325T341 -8Q333 -16 320 -16Q306 -16 298 -8Q294 -4 147 326L1 656V664ZM464 414H319Q175 414 175 413L319 88L464 414",
          8707: "81 347Q81 359 84 363T104 378H513V633H300L87 634Q64 642 64 664Q64 685 84 692Q89 694 321 694H552Q571 681 574 669V25Q567 7 552 1H87Q64 12 64 30T87 61H513V317H308Q103 317 99 319Q81 328 81 347",
          8709: "285 711Q307 711 326 708T357 701T370 698Q371 698 375 710T383 735T389 750Q395 767 415 767Q431 767 438 757T446 738T436 701T426 670Q426 668 433 664Q468 633 489 588Q511 542 519 488T528 344Q528 286 524 243T508 150T466 63T394 6Q345 -17 287 -17Q265 -17 246 -14T216 -7T203 -4Q191 -47 183 -60T159 -73Q146 -73 137 -63T128 -44Q128 -38 138 -7L148 24L141 30Q134 35 120 49Q94 77 78 113T56 194T48 268T46 344Q46 388 47 416T56 494T78 577T122 644T194 694Q239 711 285 711ZM351 639Q350 639 346 642T337 648T325 654T306 658T283 660Q254 660 221 638T181 567Q171 513 171 375Q171 164 182 129L351 639ZM402 356Q402 516 395 555Q395 557 395 559T394 563T394 566L393 568L223 57Q252 34 286 34H288Q318 34 346 53T387 109Q402 152 402 329V356",
          8710: "901 12Q901 7 892 0H479Q65 0 62 2Q56 6 56 11Q56 14 242 347T433 685Q438 694 450 696Q454 698 480 698H506L523 687Q526 683 711 354T899 17Q901 13 901 12ZM653 137L427 538L202 137L315 136H540L653 137",
          8712: "97 251Q97 393 194 484T417 586Q418 586 436 586T482 586T538 587H648Q649 586 652 584T658 580T664 575T668 568T670 557Q670 536 648 527L534 526Q515 526 491 526T457 526T435 526T417 525T404 523T390 521T374 517Q298 498 243 447T167 324Q159 295 159 283Q159 281 403 281H648Q649 280 652 278T658 274T664 269T668 262T670 251Q670 230 648 221L403 220Q159 220 159 218Q159 206 166 182T190 122T247 50T341 -6Q380 -20 405 -22T534 -25H648Q649 -26 654 -29T661 -34T667 -43T670 -56Q670 -74 648 -85L541 -86Q419 -86 396 -82Q276 -65 187 24T97 251",
          8713: "126 -210Q116 -210 107 -203T97 -179Q97 -171 99 -166Q99 -165 111 -145T150 -80T203 8Q97 104 97 251Q97 393 194 484T417 586Q418 586 436 586T482 586T538 587H549Q565 614 582 643T608 685L616 698Q623 711 641 711Q651 711 660 704T670 681Q670 672 667 667Q666 666 661 657T644 627T620 587H648Q649 586 652 584T658 580T664 575T668 568T670 557Q670 536 648 527L584 526L437 281H648Q649 280 652 278T658 274T664 269T668 262T670 251Q670 230 648 221L403 220H401L283 23Q311 5 341 -6Q380 -20 405 -22T534 -25H648Q649 -26 654 -29T661 -34T667 -43T670 -56Q670 -74 648 -85L541 -86Q419 -86 396 -82Q320 -71 252 -29Q152 -197 148 -201Q139 -210 126 -210ZM235 62L330 220Q159 219 159 218Q159 196 176 150T235 62ZM366 281L513 526Q503 526 487 526T465 526T448 525T433 525T422 525T412 524T403 523T394 521T385 519T374 517Q298 498 243 447T167 324Q159 295 159 283Q159 281 366 281",
          8715: "96 251Q96 268 119 281H363Q607 281 607 283Q607 295 600 319T576 379T519 451T425 507Q386 521 361 523T233 526L119 527Q96 535 96 557Q96 578 116 585Q121 587 229 587Q238 587 257 587T288 588Q366 588 435 568T568 488Q670 388 670 251Q670 155 621 78T499 -39T345 -85Q336 -86 225 -86L119 -85Q96 -77 96 -55Q96 -38 119 -25H233Q356 -24 371 -21Q373 -21 393 -16Q468 3 523 55T599 177Q607 206 607 218Q607 220 363 220L119 221Q96 229 96 251",
          8722: "119 221Q96 230 96 251T116 279Q121 281 448 281H775Q776 280 779 278T785 274T791 269T795 262T797 251Q797 230 775 221H119",
          8723: "64 155Q64 172 87 185H416V476H251L87 477Q64 485 64 507Q64 528 84 535Q89 537 448 537H807Q808 536 811 534T817 530T823 525T827 518T829 507Q829 486 807 477L642 476H477V185H807Q808 184 811 182T817 178T823 173T827 166T829 155Q829 134 807 125L642 124H477V-39Q477 -203 475 -208Q466 -227 446 -227Q427 -227 417 -205L416 -41V124H251L87 125Q64 133 64 155",
          8725: "451 730Q460 750 479 750Q492 750 501 740T510 718Q508 708 318 244L122 -232Q112 -250 95 -250Q82 -250 73 -241T64 -218Q66 -205 258 261T451 730",
          8726: "64 718Q63 731 72 740T94 750Q106 750 113 743Q118 741 122 732L318 256Q508 -208 510 -218Q511 -231 502 -240T480 -250Q460 -250 451 -230Q451 -229 259 238T64 718",
          8727: "236 431Q237 447 251 459T287 472T323 459T338 431Q338 423 328 363L317 300Q318 300 340 317T392 356T435 387Q442 390 450 390Q470 390 485 374T501 335Q501 326 500 320T494 309T486 300T473 293T458 287T438 280T414 272L353 250L414 228Q422 225 436 221T457 214T472 208T485 201T493 192T499 181T501 166Q501 141 484 126T450 111Q447 111 445 111T441 111T437 112T433 114T428 117T422 121T414 127T404 135T391 145T374 158L317 200L328 137Q338 77 338 69Q336 52 321 40T287 28T253 40T236 69Q236 77 246 137L257 200Q256 200 234 183T182 144T139 113Q132 110 124 110Q104 110 89 126T73 165Q73 174 74 180T80 191T88 200T101 207T116 213T136 220T160 228L221 250L160 272Q152 275 138 279T117 286T102 292T89 299T81 308T75 319T73 334Q73 359 90 374T124 389Q127 389 129 389T133 389T137 388T141 386T146 383T152 379T160 373T170 365T183 355T200 342L257 300L246 363Q236 423 236 431",
          8728: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251ZM448 251Q448 325 405 369T286 413Q215 413 171 371T126 251Q126 177 168 133T287 89Q361 89 404 132T448 251",
          8729: "64 251Q64 303 80 344T121 409T175 448T230 469T275 474Q277 474 283 474T292 473Q385 473 447 415T510 251Q510 149 449 89T287 28T126 88T64 251",
          8730: "107 178Q100 178 89 188T78 207Q78 216 84 220Q85 221 124 248T207 304T260 338Q269 340 275 335Q276 334 370 156L463 -20L698 393Q928 800 935 811Q944 820 954 820Q972 820 980 811T988 789Q988 781 858 553Q776 409 718 306Q452 -166 447 -171Q439 -179 422 -180Q405 -180 400 -175Q399 -174 346 -73T241 128T187 229L151 205Q111 178 107 178",
          8733: "65 222Q65 282 88 329T144 401T208 438T261 451H273Q312 451 320 450Q456 431 526 330L537 316Q638 451 778 451Q813 451 830 445V388Q821 391 799 391Q758 391 721 377T660 342T618 301T592 266L584 251Q648 152 697 114Q748 74 804 74H806Q823 74 829 77Q830 77 830 38V-1L820 -3Q801 -7 786 -7H771Q699 -7 632 25T527 114L516 128Q414 -8 276 -8Q192 -8 129 56T65 222ZM256 53Q296 53 332 67T392 102T434 143T461 178L469 193Q405 292 356 330Q308 369 251 369H243Q196 369 156 328T116 221Q116 191 124 161T158 99T225 55Q234 53 256 53",
          8734: "65 219Q65 318 132 385T302 452Q473 452 573 331L589 312L596 320Q710 452 857 452Q948 452 1016 386T1084 225Q1084 125 1017 59T848 -8Q679 -8 576 113L560 132L553 124Q439 -8 292 -8Q200 -8 133 58T65 219ZM1033 224Q1033 291 987 340T875 389Q748 389 648 261Q641 253 642 251Q717 163 748 137Q813 81 880 81Q941 81 987 120T1033 224ZM275 56Q315 56 353 70T418 104T466 144T497 178L507 192Q507 193 474 230T441 269Q355 362 267 362Q210 362 163 324T116 221Q116 150 162 103T275 56",
          8736: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 21 56 23V25Q55 27 55 30Q55 31 56 33V35Q55 37 55 40Q55 42 57 48Q67 63 346 381Q421 467 518 578Q607 680 623 697T647 714Q656 714 661 708T666 694V692Q676 687 676 674Q676 668 673 663Q672 662 637 622T534 503T400 350L147 61L386 60H653Q666 50 666 40V38Q676 31 676 20Q676 8 661 0H71",
          8739: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
          8741: "205 -225Q201 -234 199 -237T191 -244T175 -248T161 -246Q151 -240 146 -229Q145 -224 145 251Q145 725 146 730Q156 750 176 750Q193 748 205 727V-225ZM369 727L372 732Q375 737 377 740T385 747T398 750Q406 750 413 747Q423 740 428 730Q430 720 430 251Q430 -219 428 -229Q423 -240 413 -246Q408 -248 400 -248Q393 -248 388 -247T379 -242T375 -236T371 -230L369 -225V727",
          8743: "95 -16Q78 -16 71 -6T64 14Q64 20 65 22L212 308Q359 593 361 595Q370 604 385 604Q398 602 405 595Q407 593 554 308L701 22Q702 20 702 15Q702 1 693 -8T671 -17Q661 -17 651 -9Q647 -5 515 251L383 506L251 251Q119 -5 116 -8Q108 -16 95 -16",
          8744: "64 572Q64 585 72 594T94 604T116 595Q119 592 251 336L383 81L515 336Q647 592 651 596Q661 604 671 604Q684 604 693 595T702 572Q702 567 701 565L554 279Q407 -6 405 -8Q404 -9 401 -11T397 -14Q392 -16 383 -16H380Q369 -16 361 -8Q359 -6 212 279L65 565Q65 566 65 568T64 572",
          8745: "94 -16Q73 -16 64 8V209Q64 239 64 287Q65 418 69 432Q70 434 70 435Q84 487 125 523T216 575T299 597T354 603H372Q444 603 501 590T591 558T648 515T681 471T696 435Q696 434 697 432Q701 417 702 309Q702 303 702 287Q702 239 702 209V8Q693 -16 672 -16Q650 -16 643 3Q641 8 641 201Q641 397 640 403Q631 472 558 507T383 542Q339 542 298 535T219 511T156 468T126 403Q125 397 125 201Q125 8 123 3Q116 -16 94 -16",
          8746: "672 603Q693 603 702 579V378Q702 348 702 300Q701 169 697 155Q696 153 696 152Q676 78 593 31T383 -16Q265 -16 179 28T70 152Q70 153 69 155Q65 170 64 278Q64 285 64 300Q64 348 64 378Q64 579 65 583Q74 604 94 604T123 584Q125 579 125 386Q125 190 126 184Q135 115 210 80T383 44Q426 44 467 51T546 75T609 119T640 184Q641 190 641 386Q641 579 643 584Q650 603 672 603",
          8747: "204 -71Q204 -108 181 -124T137 -141Q132 -141 132 -142Q142 -161 154 -161Q164 -161 186 -152Q200 -145 210 -135T228 -107T241 -77T249 -38T254 -2T258 38T262 74Q282 265 334 489Q334 490 337 503T341 523T347 544T355 569T365 594T379 620T397 643T420 666T447 685T481 700Q511 711 539 711T587 696T616 656T628 612T632 573Q632 536 610 519T562 501Q534 501 513 519T492 571Q492 608 515 624T559 641Q564 641 564 642Q554 661 542 661Q532 661 510 652Q496 645 486 635T468 607T455 577T447 538T442 502T438 462T434 426Q414 235 362 11Q352 -35 347 -54T328 -101T291 -152Q235 -208 162 -211Q147 -211 136 -208T109 -196T83 -165T67 -108Q64 -94 64 -73Q64 -37 86 -19T134 -1Q162 -1 183 -19T204 -71",
          8764: "64 155Q64 210 84 262T150 353T257 391Q300 391 341 371T417 321T484 264T557 215T637 194Q702 194 745 244T788 367Q796 391 808 391Q815 391 821 381T828 353V342Q828 252 776 181T637 109Q594 109 552 129T476 179T409 236T336 285T256 306Q193 306 149 258T105 132Q98 109 86 109Q76 109 70 122T64 155",
          8768: "64 561Q64 570 76 576T108 583Q174 583 214 535T254 407Q254 368 238 324T202 248T166 173T149 92Q149 43 169 2T217 -39Q231 -40 242 -46T254 -60Q254 -69 241 -75T210 -82Q145 -82 105 -34T64 93Q64 133 80 177T116 253T152 328T169 408Q169 461 148 500T105 540Q92 540 78 545T64 561",
          8771: "64 295Q64 378 117 440T257 502Q298 502 339 485T416 443T486 394T560 352T637 335Q693 335 740 373T788 478Q796 502 808 502Q815 502 821 492T828 465V455Q828 365 771 308T640 250Q603 250 562 265T501 294T439 336L370 382Q308 417 256 417Q205 417 164 388T110 317Q110 316 109 304T107 286T103 270T97 255T86 250Q76 250 70 263T64 295ZM64 6T64 27T87 56H93Q99 56 110 56T137 56T173 56T217 56T267 57T323 57T383 57T448 57H807Q808 56 811 54T815 52T819 49T823 45T826 40T828 34T829 27Q829 7 807 -3H87Q64 6 64 27",
          8773: "64 402Q64 457 84 509T150 600T257 638Q300 638 341 618T417 569T484 511T557 462T637 441Q702 441 745 491T788 614Q796 638 808 638Q815 638 821 628T828 600V589Q828 499 776 428T637 356Q594 356 552 376T476 425T409 483T336 532T256 553Q193 553 149 505T105 379Q98 356 86 356Q76 356 70 369T64 402ZM87 197Q64 207 64 226Q64 247 84 255Q89 257 448 257H807Q808 256 811 254T817 250T823 245T827 238T829 227Q829 209 807 197H87ZM87 -27Q64 -18 64 3Q64 23 86 32Q89 33 448 33H807L812 30Q816 27 818 26T823 21T827 13T829 3Q829 -18 807 -27H87",
          8776: "64 345Q64 423 119 473T250 524Q301 524 356 503T451 455T542 407T636 385Q700 385 743 417T786 481Q786 493 791 508T807 524Q817 524 823 512T829 479Q829 404 776 352T638 300Q590 300 537 321T443 369T352 417T256 439Q207 439 166 417T110 359Q109 357 107 341T100 312T85 300Q77 300 71 313T64 345ZM64 77Q64 155 119 205T250 256Q302 256 357 235T451 187T541 139T636 117Q699 117 742 148T786 213Q786 231 792 243T808 256T823 242T829 208Q829 134 776 83T640 32Q591 32 537 53T443 101T352 149T256 171Q206 171 165 148T110 91Q109 89 107 73T100 44T85 32Q77 32 71 45T64 77",
          8781: "798 533Q812 533 820 524T829 502T819 480T769 440Q655 355 537 330Q492 322 447 322Q401 322 356 330Q289 344 219 381T118 443T73 481Q64 490 64 503Q64 517 72 525T94 533Q99 533 102 532Q107 531 138 507T209 456T314 405T446 382Q604 382 765 515Q788 533 798 533ZM95 -32Q81 -32 73 -23T64 -1Q64 10 74 21T124 61Q213 127 293 153T421 179L422 180Q424 180 426 180T432 180T441 180T452 179Q612 179 769 61Q811 29 820 19T829 -1Q829 -14 821 -23T798 -32Q788 -32 765 -14Q608 118 446 118Q287 118 128 -14Q105 -32 95 -32",
          8784: "87 333Q64 343 64 362Q64 383 84 391Q89 393 448 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H87ZM87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H87ZM362 635Q362 671 387 696T444 721Q488 721 510 693T533 635Q533 606 512 579T448 551Q406 551 384 577T362 635",
          8800: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q165 -163 327 109H87Q64 118 64 139Q64 159 86 168Q89 169 363 169L461 333H87Q64 343 64 362Q64 383 84 391Q89 393 448 393H496Q533 455 583 539T656 660T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q729 664 709 631T645 523T567 393H807Q808 392 811 390T817 386T823 381T827 374T829 363Q829 345 807 333H532L433 169H807L812 166Q816 163 818 162T823 157T827 149T829 139Q829 118 807 109H398Q217 -195 211 -201Q202 -210 189 -210",
          8801: "87 445Q64 454 64 475Q64 497 84 503Q89 505 448 505H807Q808 504 812 502T818 497T823 492T827 484T829 474Q829 456 807 445H87ZM87 221Q64 230 64 251T84 279Q89 281 448 281H807Q808 280 811 278T817 274T823 269T827 262T829 251Q829 230 807 221H87ZM64 6T64 27T87 56H93Q99 56 110 56T137 56T173 56T217 56T267 57T323 57T383 57T448 57H807Q808 56 811 54T815 52T819 49T823 45T826 40T828 34T829 27Q829 7 807 -3H87Q64 6 64 27",
          8804: "797 55Q797 45 790 35T767 25H759L434 180Q108 336 105 339Q96 348 96 360Q96 378 114 388Q126 394 439 544T757 695Q763 697 766 697Q780 697 788 688T797 666Q797 654 788 645Q784 641 507 509T197 361L466 232Q785 80 790 74Q797 66 797 55ZM119 -199Q96 -191 96 -169Q96 -160 102 -152T119 -140H124Q130 -140 140 -140T164 -140T197 -140T237 -140T283 -139T334 -139T389 -139T448 -139H775Q797 -153 797 -169Q797 -187 775 -199H119",
          8805: "127 25Q110 25 103 34T96 54Q96 66 105 75Q109 80 439 238L696 361Q113 637 105 645Q96 654 96 667Q96 679 104 688T128 697Q137 696 460 541T788 382Q797 373 797 360Q797 348 788 339Q785 336 459 180L135 25H127ZM119 -199Q96 -191 96 -169Q96 -160 102 -152T119 -140H124Q130 -140 140 -140T164 -140T197 -140T237 -140T283 -139T334 -139T389 -139T448 -139H775Q797 -153 797 -169Q797 -187 775 -199H119",
          8810: "734 -74T734 -86T727 -107T704 -116H702Q694 -116 584 -55Q473 7 380 58Q87 219 73 229Q64 238 64 250Q64 263 73 272Q87 282 380 443Q695 616 699 617H700Q718 617 726 607T734 588Q734 568 717 560Q705 554 435 404L157 250L439 94Q721 -61 726 -66Q734 -74 734 -86ZM1085 -74T1085 -86T1078 -107T1055 -116H1053Q1045 -116 935 -55Q824 7 731 58Q438 219 424 229Q415 238 415 250Q415 263 424 272Q438 282 731 443Q1046 616 1050 617H1051Q1069 617 1077 607T1085 588Q1085 568 1068 560Q1056 554 786 404L508 250L790 94Q1072 -61 1077 -66Q1085 -74 1085 -86",
          8811: "64 588Q64 600 72 609T94 618H95Q103 618 209 559Q322 496 419 443Q712 282 725 272Q734 263 734 250Q734 238 725 229Q714 220 415 55T110 -113Q103 -116 95 -116Q78 -116 71 -106T64 -86Q64 -74 72 -66Q77 -61 359 94L641 250L363 404Q277 452 173 509Q95 552 82 560T66 576V577Q64 585 64 588ZM415 588Q415 600 423 609T445 618H446Q454 618 560 559Q673 496 770 443Q1063 282 1076 272Q1085 263 1085 250Q1085 238 1076 229Q1065 220 766 55T461 -113Q454 -116 446 -116Q429 -116 422 -106T415 -86Q415 -74 423 -66Q428 -61 710 94L992 250L714 404Q628 452 524 509Q446 552 433 560T417 576V577Q415 585 415 588",
          8826: "797 -57Q797 -65 790 -75T766 -86Q748 -86 741 -74T733 -43T719 8T681 72Q647 112 588 141T475 185T343 207T230 216T136 219Q96 219 96 250Q96 280 132 280H136Q193 281 239 283T347 292T457 310T556 342T643 391T703 460T735 553Q741 585 763 585Q781 585 789 575T797 556Q797 540 792 513T758 434T682 345Q605 285 481 254L462 249Q483 246 526 233T633 185T733 104Q767 63 782 15T797 -57",
          8827: "96 556Q96 568 104 577T126 586Q152 586 158 553Q164 503 188 462T247 394T331 345T429 313T539 294T649 284T758 280H760Q797 280 797 250Q797 219 760 219H758Q627 217 529 204T347 160T216 77T158 -54Q152 -86 126 -86Q110 -86 103 -76T96 -57Q96 -41 101 -14T135 65T211 154Q288 214 412 245L431 250Q410 252 367 265T259 314T160 395Q127 435 112 483T96 556",
          8834: "96 251Q96 389 191 482T417 586Q418 586 428 586T456 586T496 586T546 587T601 587H775Q776 586 779 584T785 580T791 575T795 568T797 557Q797 536 775 527L597 526Q411 525 395 522Q390 521 370 516Q285 494 222 424T158 251Q158 131 246 53Q313 -9 408 -23Q417 -24 597 -25H775Q776 -26 781 -29T788 -34T794 -43T797 -56Q797 -74 775 -85H493Q407 -85 376 -79Q257 -55 177 35T96 251",
          8835: "96 -55Q96 -38 119 -25H296Q482 -24 498 -21Q503 -20 523 -15Q609 7 672 77T735 251T665 431T485 524Q476 525 296 526L119 527Q96 535 96 557Q96 578 116 585Q121 587 300 587Q451 586 476 585T522 579Q632 556 714 468T796 251Q796 112 695 13Q612 -65 497 -82Q473 -86 289 -86L119 -85Q96 -77 96 -55",
          8838: "96 361Q96 499 191 592T417 696Q418 696 428 696T456 696T496 696T546 697T601 697H775Q776 696 779 694T785 690T791 685T795 678T797 667Q797 646 775 637L597 636Q411 635 395 632Q390 631 370 626Q285 604 222 534T158 361Q158 241 246 163Q313 101 408 87Q417 86 597 85H775Q776 84 781 81T788 76T794 67T797 54Q797 36 775 25H493Q407 25 376 31Q257 55 177 145T96 361ZM149 -199Q127 -191 127 -169T149 -140H154Q160 -140 169 -140T192 -140T224 -140T262 -140T306 -139T354 -139T407 -139T463 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H149",
          8839: "96 55Q96 72 119 85H296Q482 86 498 89Q503 90 523 95Q609 117 672 187T735 361T665 541T485 634Q476 635 296 636L119 637Q96 645 96 667Q96 688 116 695Q121 697 300 697Q451 696 476 695T522 689Q632 666 714 578T796 361Q796 222 695 123Q612 45 497 28Q473 24 289 24L119 25Q96 33 96 55ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 433 -139H745Q766 -152 766 -170Q766 -190 745 -199H119",
          8846: "672 603Q693 603 702 579V378Q702 348 702 300Q701 169 697 155Q696 153 696 152Q676 78 593 31T383 -16Q265 -16 179 28T70 152Q70 153 69 155Q65 170 64 278Q64 285 64 300Q64 348 64 378Q64 579 65 583Q74 604 94 604T123 584Q125 579 125 386Q125 190 126 184Q135 115 210 80T383 44Q426 44 467 51T546 75T609 119T640 184Q641 190 641 386Q641 579 643 584Q650 603 672 603ZM353 412Q353 420 353 435T352 456Q352 483 358 495T385 507Q403 506 409 494T415 457Q415 451 415 436T414 411V341H558Q579 329 579 311Q579 289 558 281L486 280H414V136Q400 114 384 114Q363 114 354 136L353 208V280H281L209 281Q187 289 187 310Q187 328 209 341H353V412",
          8849: "127 25Q111 29 104 49V362L105 675Q114 693 127 696H132Q138 696 149 696T174 696T208 696T249 696T297 697T350 697T407 697T468 697H806Q828 683 828 666Q828 646 806 637L485 636H165V85H805Q806 84 809 82T813 80T817 77T821 73T824 68T826 62T827 55Q827 34 806 25H127ZM96 -190T96 -169T119 -140H125Q131 -140 141 -140T167 -140T201 -140T242 -140T290 -139T344 -139T402 -139T463 -139H805Q806 -140 809 -142T813 -144T817 -147T821 -151T824 -156T826 -162T827 -169Q827 -190 806 -199H119Q96 -190 96 -169",
          8850: "66 55Q66 74 89 85H728V636H408L88 637Q66 645 66 667T88 696H94Q99 696 110 696T135 696T169 696T210 696T258 697T311 697T368 697T429 697H767Q786 684 789 672V49Q782 31 767 25H88Q66 32 66 55ZM88 -199Q66 -191 66 -169Q66 -148 87 -140Q91 -139 433 -139H775Q776 -140 779 -142T783 -144T787 -147T791 -151T794 -156T796 -162T797 -169Q797 -189 775 -199H88",
          8851: "131 25Q121 1 100 1Q81 1 71 23L70 301Q70 579 72 583Q77 598 90 602Q95 604 385 604H674Q693 591 696 579V25Q686 1 665 1Q646 1 636 23L635 283V543H131V25",
          8852: "696 25Q689 7 674 1H93Q77 7 71 23L70 301Q70 579 72 583Q80 604 100 604T131 579V61H635V579Q644 603 666 603Q687 603 696 579V25",
          8853: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM416 282V570H414Q341 564 285 535T202 475T156 397T134 332T128 287Q127 283 127 282H416ZM765 288Q760 344 743 389T700 462T647 512T589 543T538 560T499 568L483 570H478V282H766L765 288ZM416 -69V220H127Q130 195 131 189T138 155T150 115T168 76T196 35T234 0T286 -35Q337 -61 410 -69H416ZM483 -69Q554 -60 607 -33T687 21T733 93T756 156T764 209Q766 217 766 220H478V-69H483",
          8854: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM765 288Q753 424 666 497T446 571T227 498T128 288L127 282H766L765 288ZM446 -70Q578 -70 666 4T765 213L766 220H127Q130 195 131 189T138 155T150 115T168 76T196 35T234 0T286 -35Q353 -70 446 -70",
          8855: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM647 512Q567 571 447 571Q340 571 262 523Q237 507 237 505L342 399L447 295L657 505L647 512ZM298 356L192 461Q180 445 161 411Q126 341 126 251Q126 128 192 40L403 250L298 356ZM701 41Q704 41 719 63T750 138T767 250Q767 310 750 362T719 437T701 460L491 250L701 41ZM238 -5Q238 -8 261 -22T336 -53T447 -70Q567 -70 647 -11L657 -4L447 206L342 101Q238 -1 238 -5",
          8856: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM657 505Q656 506 650 510T638 518T623 527T604 537T581 547T553 556T522 563T486 569T446 571Q305 571 216 487T126 251Q126 128 192 40L657 505ZM447 -70Q591 -70 679 16T767 250Q767 308 751 360T719 436T701 460L469 228Q238 -1 238 -5Q238 -8 261 -22T336 -53T447 -70",
          8857: "64 250Q64 350 98 426T189 546T307 610T434 632Q485 632 496 631Q572 621 635 592Q669 575 699 550T760 484T809 384T828 250Q828 77 725 -27T446 -132Q272 -132 168 -27T64 250ZM767 252Q767 395 681 483T446 571Q303 571 215 486T126 249Q126 107 212 19T446 -70Q596 -70 681 18T767 252ZM335 251Q335 297 368 329T441 361Q498 361 527 327T557 250Q557 202 525 171T446 140Q397 140 366 173T335 251",
          8866: "65 672Q76 693 91 693Q115 693 123 674Q125 669 125 523V378H615Q618 376 622 373T628 369T632 366T635 362T636 356T637 347Q637 328 619 319Q615 317 370 317H125V171Q125 25 123 20Q114 1 94 1Q73 1 65 23V672",
          8867: "64 327T64 347T89 378H577V525L578 672Q592 693 604 693Q629 693 638 669V25Q628 1 607 1Q588 1 578 23L577 170V317H88Q64 327 64 347",
          8868: "64 664Q64 675 71 683T87 693H93Q99 693 110 693T137 693T173 693T217 694T267 694T323 694T383 694T448 694H807Q808 693 811 691T817 687T823 682T827 675T829 664Q829 643 807 634L642 633H477V25Q467 1 446 1Q427 1 417 23L416 328V633H251L87 634Q64 643 64 664",
          8869: "65 31Q65 38 66 41T71 50T87 61H416V366L417 672Q431 693 443 693Q468 693 477 669V61H807Q808 60 811 58T817 54T823 49T827 42T829 31Q829 10 807 1H87Q65 10 65 31",
          8872: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V392Q219 393 537 393H896Q897 392 900 390T906 386T912 381T916 374T918 363Q918 345 896 333H190V169H896L900 166Q905 163 907 162T912 157T916 149T918 139Q918 118 896 109H190V-225Q181 -249 160 -249",
          8900: "280 522Q281 523 285 523H289Q301 523 366 457Q404 420 431 393Q533 291 546 277T560 250Q560 239 548 226T431 108Q313 -10 304 -16Q297 -21 287 -21Q278 -21 275 -19Q270 -17 146 107T18 238Q15 242 15 251Q15 258 18 263Q20 268 145 392T274 519L280 522ZM388 350L288 449L188 350L89 250L288 52L487 250L388 350",
          8901: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251",
          8902: "270 491Q274 502 287 502Q298 502 304 491Q304 486 323 396T342 303L438 314Q520 324 534 324Q540 324 545 320T550 307Q550 298 539 290T456 243Q377 198 377 197L416 111Q456 26 456 22Q457 21 457 18Q457 11 451 6T438 0H437Q432 0 415 16Q387 42 358 68L287 133L216 68Q193 47 167 23Q142 0 136 0Q129 0 123 5T117 18Q117 21 118 22Q118 26 158 111L197 197Q197 198 156 221T72 269T26 298Q24 304 24 307Q24 315 29 319T40 324Q53 324 136 314L232 303Q232 306 251 396T270 491",
          8904: "906 251Q906 456 905 456Q550 252 549 251Q549 250 726 148T905 45T906 251ZM967 -14Q958 -38 939 -38H937Q928 -38 923 -35Q919 -34 748 64T500 209L71 -38Q69 -39 63 -39Q42 -39 33 -16V518Q45 540 63 540H65Q72 540 174 481Q247 439 302 407L500 292Q578 339 750 438T929 539H933Q958 539 967 515V-14ZM449 251L94 456Q93 456 93 251Q93 45 94 45L106 52Q119 59 139 71T186 98T242 131T301 165T357 197T404 225T437 244L449 251",
          8942: "74 55Q74 91 99 116T156 141Q200 141 222 113T245 55Q245 26 224 -1T160 -29Q118 -29 96 -3T74 55ZM74 465Q74 501 99 526T156 551Q200 551 222 523T245 465Q245 436 224 409T160 381Q118 381 96 407T74 465ZM74 865Q74 901 99 926T156 951Q200 951 222 923T245 865Q245 836 224 809T160 781Q118 781 96 807T74 865",
          8943: "74 251Q74 286 99 311T156 336Q200 336 222 308T245 250Q245 221 224 194T160 166T96 193T74 251ZM562 251Q562 286 587 311T644 336Q688 336 710 308T733 250Q733 221 712 194T648 166T584 193T562 251ZM1050 251Q1050 286 1075 311T1132 336Q1176 336 1198 308T1221 250Q1221 221 1200 194T1136 166T1072 193T1050 251",
          8945: "129 785Q129 821 154 846T211 871Q255 871 277 843T300 785Q300 756 279 729T215 701Q173 701 151 727T129 785ZM576 485Q576 521 601 546T658 571Q702 571 724 543T747 485Q747 456 726 429T662 401Q620 401 598 427T576 485ZM1023 185Q1023 221 1048 246T1105 271Q1149 271 1171 243T1194 185Q1194 156 1173 129T1109 101Q1067 101 1045 127T1023 185",
          8968: "194 728Q199 743 216 749H220Q223 749 229 749T245 749T265 750T289 750T316 750T345 750H471Q472 749 477 746T484 741T490 732T493 719Q493 701 471 690L362 689H254V-224Q244 -248 223 -248T194 -226V728",
          8969: "317 -224Q307 -248 286 -248Q267 -248 257 -226L256 231V689H148L40 690Q17 698 17 720Q17 741 37 748Q42 750 169 750H295Q314 737 317 725V-224",
          8970: "194 728Q204 749 220 749Q245 749 254 725V-188H471Q472 -189 477 -192T484 -197T490 -206T493 -219Q493 -237 471 -248H216Q200 -242 194 -226V728",
          8971: "17 -219Q17 -201 40 -188H256V270L257 728Q271 749 283 749Q308 749 317 725V-224Q310 -242 295 -248H40L38 -247Q35 -246 34 -245T30 -243T25 -239T21 -234T18 -227T17 -219",
          8994: "95 108Q85 108 75 114T65 139Q65 159 129 227Q316 405 573 405Q654 405 729 387T854 344T950 286T1015 232T1053 191Q1078 160 1083 152Q1084 148 1084 139Q1084 121 1074 115T1054 108Q1040 108 1029 122T990 167T922 223Q819 291 680 309Q641 315 575 315Q508 315 469 309Q303 288 197 201Q168 179 148 155T118 119T95 108",
          8995: "1054 392Q1067 392 1076 384T1085 362Q1085 351 1079 342T1050 310Q983 243 901 200Q753 126 575 126Q494 126 420 141T298 176T205 225T140 272T100 310Q64 346 64 362Q64 370 67 374Q75 393 93 393Q107 393 124 375Q272 214 575 214Q877 214 1025 375Q1039 392 1054 392",
          9001: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
          9002: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720",
          9651: "91 1Q69 10 69 31Q69 39 81 59T168 197Q327 447 485 697Q493 711 510 711Q523 711 532 702Q536 697 743 371T951 41Q953 35 953 31Q953 12 931 1H91ZM690 340Q651 401 604 476T534 586L512 621Q511 622 507 616Q498 604 332 342L154 62L333 61H689L867 62L690 340",
          9653: "91 1Q69 10 69 31Q69 39 81 59T168 197Q327 447 485 697Q493 711 510 711Q523 711 532 702Q536 697 743 371T951 41Q953 35 953 31Q953 12 931 1H91ZM690 340Q651 401 604 476T534 586L512 621Q511 622 507 616Q498 604 332 342L154 62L333 61H689L867 62L690 340",
          9657: "33 518Q45 540 63 540H65Q72 540 174 481Q247 439 302 407Q529 276 533 272Q542 263 542 250Q542 238 533 229Q528 224 304 95T71 -38Q69 -39 63 -39Q42 -39 33 -16V518ZM449 251L94 456Q93 456 93 251Q93 45 94 45L106 52Q119 59 139 71T186 98T242 131T301 165T357 197T404 225T437 244L449 251",
          9661: "68 470Q68 481 75 489T91 499H93Q296 500 512 500H931Q932 499 937 496T945 490T950 482T953 469Q953 465 951 459Q950 455 743 129T532 -202Q524 -210 511 -210Q497 -210 489 -202Q486 -199 281 124T71 456Q68 462 68 470ZM154 439Q155 437 332 158T510 -122Q510 -123 533 -87T600 18T688 157Q866 437 866 438Q867 439 805 439T511 439H154",
          9663: "68 470Q68 481 75 489T91 499H93Q296 500 512 500H931Q932 499 937 496T945 490T950 482T953 469Q953 465 951 459Q950 455 743 129T532 -202Q524 -210 511 -210Q497 -210 489 -202Q486 -199 281 124T71 456Q68 462 68 470ZM154 439Q155 437 332 158T510 -122Q510 -123 533 -87T600 18T688 157Q866 437 866 438Q867 439 805 439T511 439H154",
          9667: "542 -14Q533 -38 514 -38H512Q503 -38 498 -35Q494 -34 270 95T42 229Q33 238 33 251Q33 259 35 264Q36 265 38 268T42 272Q48 278 271 407T504 539H508Q533 539 542 515V-14ZM481 251Q481 456 480 456Q125 252 124 251Q124 250 301 148T480 45T481 251",
          9711: "65 42T65 250T204 584T574 711Q795 711 935 594Q955 577 974 555T1022 490T1067 385T1084 250Q1084 42 945 -84T574 -211T204 -85ZM1024 250Q1024 431 903 540T578 650Q482 650 404 627T274 565T189 474T140 366T125 250Q125 123 186 31T347 -106T573 -150Q772 -150 898 -45T1024 250",
          9824: "675 -18Q536 -18 527 62V70H477V55Q479 14 487 -21T502 -75T509 -101Q509 -120 491 -127Q487 -129 447 -129Q446 -129 439 -129T427 -130Q384 -130 384 -101Q384 -95 391 -76T406 -21T416 55V70H366Q364 52 360 40T342 14T300 -8T230 -17H218Q110 -17 75 117Q64 163 64 209Q64 290 116 357T261 495Q363 574 414 690Q425 719 445 719Q467 719 478 693Q507 627 547 578T623 503T702 438T777 357Q829 285 829 202V197Q826 128 808 81T762 15T714 -11T675 -18",
          9825: "65 491Q65 602 121 656T246 710Q375 710 440 624L447 615Q519 711 638 711Q723 711 775 652T828 491Q828 390 770 313T581 129Q539 95 514 63T483 14T469 -13T446 -24Q434 -24 427 -17T416 0T400 32T371 74Q352 97 310 131T229 199T151 276T89 374T65 491ZM249 649Q188 649 157 603T125 489Q125 409 181 338T352 176Q408 131 437 87L446 73L456 87Q479 121 507 147T579 207T659 278Q768 387 768 489Q768 506 766 524T756 566T731 611T687 642Q668 649 638 649Q609 649 593 644Q547 633 516 604T478 534Q473 505 447 505H445Q420 505 416 534Q407 577 372 608T285 648Q277 649 249 649",
          9826: "409 686Q410 688 412 691T415 696T418 701T421 706T424 709T427 713T431 715T435 717T440 718T446 719Q455 719 460 717T472 704T488 679T516 633T563 567Q624 485 687 422T787 330T826 296T828 282Q828 270 825 265T801 245Q696 161 612 59T477 -133Q465 -154 447 -154Q439 -154 434 -152T425 -146T414 -130T399 -104T372 -62T330 -3Q270 78 207 142T107 234T70 265Q64 274 64 282Q64 296 90 317Q284 472 409 686ZM749 282Q745 286 721 307T681 343T635 388T581 446T525 516T465 601Q462 606 457 613T450 624L447 627V628Q446 628 436 611T402 561T348 489T266 396T155 292L145 282Q147 280 185 245T257 177T343 79T442 -57Q446 -64 447 -64V-63Q450 -59 475 -22T530 56T619 160T749 282",
          9827: "240 527Q240 611 301 665T446 719T590 665T652 527Q652 431 571 373Q578 363 584 352T593 335T597 329L604 335Q611 341 617 345T637 356T667 366Q672 366 680 367T694 368Q767 368 814 310T861 177Q861 109 819 57T713 -12Q690 -17 656 -17Q535 -13 527 62V70H477V55Q479 14 487 -21T502 -75T509 -101Q509 -120 491 -127Q487 -129 447 -129Q446 -129 439 -129T427 -130Q384 -130 384 -101Q384 -95 391 -76T406 -21T416 55V70H366V62Q356 -12 237 -17Q130 -17 71 60Q32 111 32 178Q32 251 78 309T198 368Q217 368 233 364T260 354T279 343T291 333T296 329L300 336Q304 343 310 354T322 373Q240 432 240 527",
          9837: "230 480Q293 480 337 440T381 330V322Q381 240 323 161Q258 71 123 -11L114 -16L97 -17Q70 -17 66 -7Q64 -3 64 366V641Q64 717 65 731T75 748Q78 750 95 750Q117 750 122 742T127 694Q127 685 127 653T126 595V454Q183 480 230 480ZM242 333Q242 405 212 405H207Q147 405 130 370L127 364L126 219Q126 77 128 77Q133 82 140 90T167 127T202 183T229 253T242 333",
          9838: "345 -223Q333 -223 330 -214T327 -178V-116Q327 -23 326 -23L203 -82Q90 -134 77 -140Q65 -142 59 -130Q57 -126 57 295V595Q57 643 57 667T58 704T60 719T63 724Q93 741 101 741Q113 741 116 732T119 680V597Q119 467 120 467Q121 468 180 495T301 552T369 584Q381 586 387 574Q389 570 389 187V-88Q389 -132 389 -154T388 -188T386 -202T383 -206Q353 -223 345 -223ZM327 271Q327 421 326 421L120 323L119 173V23Q120 23 223 72L327 121V271",
          9839: "140 628Q151 628 154 620T158 591V549V484L166 488Q175 492 192 500T223 516L288 548V622V674Q288 681 288 685T289 693T289 699T291 703T295 707T298 709T304 712T311 716Q326 724 332 724Q343 724 346 715T350 685V644V579Q358 583 364 583Q376 583 380 574Q382 570 382 514V481Q382 459 380 454T363 441L350 435V135Q358 139 364 139Q376 139 380 130Q382 126 382 70V37Q382 15 380 10T363 -3L350 -9V-76Q350 -102 348 -106T328 -119Q312 -128 306 -128Q288 -128 288 -99V-77V-40L280 -44Q271 -48 254 -56T223 -72L158 -104V-150V-180Q158 -198 155 -202T135 -216Q119 -224 114 -224Q96 -224 96 -192V-172V-135Q86 -140 81 -140Q70 -140 66 -129Q64 -126 64 -70V-54Q64 -18 66 -12T83 3L96 9V309Q86 304 81 304Q70 304 66 315Q64 318 64 374V407Q64 429 66 434T83 447L96 453V602Q99 609 100 610T118 619Q134 628 140 628ZM288 254Q288 404 287 404L158 340V40L166 44Q175 48 192 56T223 72L288 104V254",
          10072: "160 -249Q138 -249 129 -225V250Q129 725 131 729Q139 750 159 750T190 725V-225Q181 -249 160 -249",
          10216: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
          10217: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720",
          10229: "1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1063L1065 280Q1079 281 1392 281H1719Q1720 280 1723 278T1729 274T1735 269T1739 262T1741 251Q1741 230 1719 221H1063",
          10230: "119 221Q96 230 96 251T116 279Q121 281 448 281H1188L1602 282Q1569 304 1530 357T1473 482Q1469 500 1469 501Q1469 512 1480 517Q1482 518 1500 518H1505Q1520 518 1523 515T1532 495Q1552 412 1611 351T1753 270Q1773 263 1773 251Q1773 240 1765 236T1732 225T1683 204Q1625 173 1586 122T1532 6Q1528 -10 1524 -13T1504 -17H1499Q1474 -16 1470 -9Q1469 -6 1469 -2Q1469 1 1473 17Q1501 138 1602 220H1188L775 221H119",
          10231: "1063 221L649 220H235Q340 133 364 17Q368 1 368 -2Q368 -16 343 -17Q340 -17 338 -17H332Q317 -17 314 -14T305 6Q298 34 285 62T247 126T179 189T78 233Q64 237 64 251Q64 261 74 265T108 277T154 297Q212 328 251 379T305 495Q309 511 313 514T333 518H338Q363 517 367 510Q368 507 368 503Q368 500 364 484Q345 401 287 331Q254 295 235 282L649 281H1476L1890 282Q1857 304 1818 357T1761 482Q1757 500 1757 501Q1757 512 1768 517Q1770 518 1788 518H1793Q1808 518 1811 515T1820 495Q1840 412 1899 351T2041 270Q2061 263 2061 251Q2061 240 2053 236T2020 225T1971 204Q1913 173 1874 122T1820 6Q1816 -10 1812 -13T1792 -17H1787Q1762 -16 1758 -9Q1757 -6 1757 -2Q1757 1 1761 17Q1789 138 1890 220H1476L1063 221",
          10232: "1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1063L1064 168Q1080 169 1423 169H1782L1786 166Q1791 163 1793 162T1798 157T1802 149T1804 139Q1804 118 1782 109H1063L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393H1063Q1064 392 1065 392Q1081 393 1423 393H1782Q1783 392 1786 390T1792 386T1798 381T1802 374T1804 363Q1804 345 1782 333H1063",
          10233: "87 109Q64 118 64 139Q64 159 86 168Q89 169 448 169H1169L1532 170L1546 180Q1562 193 1580 204T1612 223T1638 237T1657 246L1664 250L1639 264Q1586 290 1545 321L1531 332H1169L807 333H87Q64 343 64 362Q64 383 84 391Q89 393 448 393H1136L1465 394L1455 405Q1428 436 1401 477T1374 531Q1374 547 1399 547H1404H1409Q1423 547 1430 540T1443 519T1470 475T1526 411Q1634 303 1779 271Q1780 271 1783 270T1788 269T1792 268T1796 266T1799 264T1802 260T1803 256T1804 250Q1804 242 1800 238T1783 231T1755 225T1712 211T1654 185Q1517 112 1439 -24Q1430 -40 1426 -43T1409 -46H1404Q1373 -46 1373 -31Q1373 -24 1381 -10Q1414 50 1457 99L1465 108H1136L807 109H87",
          10234: "1063 333L700 332H338L324 321Q283 290 230 264L205 250Q266 224 323 180L338 170L700 169H1425L1788 170L1802 180Q1818 193 1836 204T1868 223T1894 237T1913 246L1920 250L1895 264Q1842 290 1801 321L1787 332H1425L1063 333ZM733 393H1392L1721 394L1711 405Q1684 436 1657 477T1630 531Q1630 547 1655 547H1660H1665Q1679 547 1686 540T1699 519T1726 475T1782 411Q1890 303 2035 271Q2036 271 2039 270T2044 269T2048 268T2052 266T2055 264T2058 260T2059 256T2060 250Q2060 242 2056 238T2039 231T2011 225T1968 211T1910 185Q1773 112 1695 -24Q1686 -40 1682 -43T1665 -46H1660Q1629 -46 1629 -31Q1629 -24 1637 -10Q1670 50 1713 99L1721 108H1392L1063 109L733 108H404L412 99Q455 50 488 -10Q498 -27 493 -37Q487 -46 465 -46H460Q446 -46 439 -39T426 -18T399 25T344 89Q239 194 99 229Q96 230 92 231T85 232T79 234T73 235T69 237T66 240T65 244T64 250Q64 267 90 271Q197 295 286 361T430 525Q439 542 442 544T460 547H465Q487 547 492 539Q496 531 496 530Q496 521 471 482T414 405L404 394L733 393",
          10236: "65 426Q74 448 95 448Q112 448 125 426V281H130L132 280H134Q162 281 448 281H1188L1602 282Q1569 304 1530 357T1473 482Q1469 500 1469 501Q1469 512 1480 517Q1482 518 1500 518H1505Q1520 518 1523 515T1532 495Q1552 412 1611 351T1753 270Q1773 263 1773 251Q1773 240 1765 236T1732 225T1683 204Q1625 173 1586 122T1532 6Q1528 -10 1524 -13T1504 -17H1499Q1474 -16 1470 -9Q1469 -6 1469 -2Q1469 1 1473 17Q1501 138 1602 220H1188L775 221H135Q133 220 130 220H125V76Q115 54 95 54Q73 54 65 76V426",
          10744: "189 -210Q179 -210 170 -203T160 -179Q160 -171 162 -166Q164 -163 420 266T679 698Q686 711 704 711Q714 711 723 704T733 681Q733 672 730 667Q723 654 469 228T211 -201Q202 -210 189 -210",
          10799: "168 500Q168 515 178 522T195 530H198Q207 530 218 521T282 458Q312 428 331 409L447 294L563 409Q674 520 682 525Q687 529 695 529Q711 529 718 520T726 499V498Q726 489 720 481T666 427Q631 392 606 367L490 251L606 135Q717 23 721 17T726 2Q726 -9 719 -18T695 -28H692Q685 -28 674 -18T608 47Q581 74 563 92L447 207L331 91Q217 -22 208 -27Q206 -28 203 -28H197Q168 -28 168 2Q168 13 178 24T288 135L404 250L288 366Q177 479 173 485T168 500",
          10815: "39 655Q39 675 43 680T69 686Q110 684 225 684Q267 684 303 684T360 685T385 686Q401 686 405 680T409 651Q409 632 403 628T367 624H348H301V62H598V624H551H532Q502 624 496 628T490 651Q490 673 494 679T514 686Q518 686 558 685T675 684T792 685T836 686Q852 686 856 680T860 651Q860 632 854 628T818 624H799H752V62H799H809Q846 62 853 59T860 36V31V21Q860 6 850 2Q846 0 450 0H156Q75 0 60 1T40 11V18Q39 26 39 31Q39 54 44 58T82 63Q84 63 90 63T100 62H147V624H100H90Q53 624 46 627T39 650V655",
          10927: "796 54Q796 40 788 32T767 24Q741 24 735 57Q729 107 705 148T646 216T563 264T465 297T356 316T245 326T136 330H134Q96 330 96 360Q96 391 134 391H136Q193 392 239 394T347 403T457 421T556 453T643 502T703 571T735 664Q741 696 763 696Q781 696 789 686T797 667Q797 651 792 624T758 545T682 456Q605 396 481 365L462 360Q483 357 526 344T633 296T733 215Q767 173 781 128T796 54ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 448 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H119",
          10928: "127 24Q115 24 106 32T97 55Q97 95 124 156T211 265Q288 325 412 356L431 361Q410 363 367 376T259 425T160 506Q127 546 112 594T96 667Q96 679 104 688T126 697Q152 697 158 664Q164 614 188 573T247 505T331 456T429 424T539 405T649 395T758 391Q797 391 797 360Q797 330 761 330H758Q701 329 655 327T547 318T437 300T337 268T251 219T190 150T158 57Q151 24 127 24ZM119 -199Q96 -190 96 -169T116 -141Q121 -139 448 -139H775Q776 -140 779 -142T785 -146T791 -151T795 -158T797 -169Q797 -190 775 -199H119",
          12296: "127 243V259L223 491Q251 557 286 642Q318 719 324 732T340 748H341Q347 750 351 750Q365 750 373 740T382 723Q382 713 286 482L190 251Q190 249 286 20T382 -219Q382 -232 373 -240T352 -249Q332 -249 323 -229Q320 -220 223 10L127 243",
          12297: "64 720Q64 732 72 741T94 750Q106 750 113 743Q118 741 122 732L319 259V243L122 -231Q112 -249 95 -249Q83 -249 74 -240T64 -218Q64 -210 160 20L256 251L160 482Q64 715 64 720"
        }, {
          8243: "\u2032\u2032",
          8244: "\u2032\u2032\u2032",
          8279: "\u2032\u2032\u2032\u2032",
          8602: "\u2190\u0338",
          8603: "\u2192\u0338",
          8622: "\u2194\u0338",
          8653: "\u21D0\u0338",
          8654: "\u21D4\u0338",
          8655: "\u21D2\u0338",
          8708: "\u2203\u0338",
          8716: "\u220B\u0338",
          8740: "\u2223\u0338",
          8742: "\u2225\u0338",
          8769: "\u223C\u0338",
          8772: "\u2243\u0338",
          8775: "\u2245\u0338",
          8777: "\u2248\u0338",
          8802: "\u2261\u0338",
          8813: "\u224D\u0338",
          8814: "<\u0338",
          8815: ">\u0338",
          8816: "\u2264\u0338",
          8817: "\u2265\u0338",
          8832: "\u227A\u0338",
          8833: "\u227B\u0338",
          8836: "\u2282\u0338",
          8837: "\u2283\u0338",
          8840: "\u2286\u0338",
          8841: "\u2287\u0338",
          8876: "\u22A2\u0338",
          8877: "\u22A8\u0338",
          8930: "\u2291\u0338",
          8931: "\u2292\u0338"
        });
      },
      2810: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.doubleStruck = void 0;
        var n = r(6001);
        Object.defineProperty(e, "doubleStruck", {
          enumerable: !0,
          get: function get() {
            return n.doubleStruck;
          }
        });
      },
      6982: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.frakturBold = void 0;
        var n = r(768),
          o = r(3696);
        e.frakturBold = (0, n.AddPaths)(o.frakturBold, {
          33: "121 621Q121 657 132 673T177 689Q223 689 223 644V635Q223 604 222 595Q221 590 210 490T187 292T175 190V186L166 185L156 184Q156 185 139 393T121 621ZM107 47Q107 70 127 87T174 104Q201 104 221 89T241 48Q241 24 222 6T174 -12Q147 -12 127 6T107 47",
          34: "53 695Q74 695 90 679V622L65 433L52 432H39L27 516Q10 626 10 655Q10 680 26 688Q33 693 39 693Q49 695 53 695ZM151 668Q151 691 191 691Q217 691 224 685T231 661V652Q230 634 219 531L207 433L195 432Q183 432 183 433L168 541Q151 664 151 668",
          38: "290 -14Q186 -14 115 41T44 185Q44 222 54 249T88 300T131 336T189 371Q216 387 216 388Q185 459 185 510Q185 563 206 601T263 659T334 687T405 696Q476 696 503 668T531 603Q531 565 513 536T450 476Q423 459 370 432L334 413L354 384Q474 212 560 139L563 137Q611 185 611 250Q611 295 577 329Q549 356 496 357Q439 357 433 354Q432 354 432 379V403L437 402Q443 402 479 401T557 400Q653 400 735 403T831 407H836Q833 352 833 351L821 352Q809 352 792 352T756 352T720 353T696 354Q680 354 680 353L681 346Q682 339 683 327T685 306Q685 283 681 260T669 218T653 182T635 152T619 129T606 114L602 109Q604 107 618 99T659 81T707 71Q742 71 767 99T804 155L815 183Q815 184 821 183T833 180T839 177Q837 169 834 156T816 110T782 52T727 5T648 -16Q569 -16 499 35H498Q496 35 466 23T387 -1T290 -14ZM418 592Q418 617 398 639T352 661T302 642T278 574Q278 545 288 514T306 465T319 444Q342 456 353 463T382 488T409 529T418 584V592ZM159 239Q159 158 222 98T364 38Q386 38 447 57L469 63L434 98Q349 185 286 275Q258 316 238 345Q233 353 232 353Q159 316 159 239",
          39: "80 645T80 662T93 687T123 695Q158 695 158 659Q158 649 157 643L123 437Q123 436 114 436H104Q104 442 92 538Q80 645 80 662",
          40: "347 719Q325 708 311 698T272 656T233 580T207 455T195 267Q195 30 247 -79Q261 -110 291 -136Q320 -163 347 -172V-179Q347 -186 344 -186Q338 -186 328 -184T287 -165T230 -123Q134 -25 134 271Q134 417 158 514T226 662T335 734L346 737Q347 737 347 728V719",
          41: "264 262Q264 366 253 446T226 572T186 649T145 692T105 714V725Q105 735 107 735Q108 734 121 731T154 719T196 692T242 641T284 560T314 437T326 268Q326 112 299 7Q279 -78 239 -124T116 -185L105 -187V-179L106 -171L109 -169Q130 -161 138 -158T165 -146T190 -127T210 -101T229 -64T243 -12T255 58T261 148T264 262",
          42: "40 516L62 529Q85 542 110 556T140 574L126 582Q112 591 104 595T80 607T40 629Q53 642 57 645L65 652L78 642Q106 620 132 603L152 589V595Q152 630 149 681V692H179V689Q178 681 174 638T171 593Q173 593 240 639L258 652Q260 652 267 643L276 633L260 625Q190 587 175 576Q173 575 180 570Q183 569 186 567Q213 549 256 527L277 515L256 495Q246 501 228 515T194 539T170 554V543Q170 486 178 449H148V456Q152 492 152 550L151 562Q150 562 102 528L53 495Q40 514 40 516",
          43: "422 584L471 598Q472 598 472 440V282H837Q833 273 829 263L821 244L647 243H472V-63L448 -73L423 -82Q422 -82 422 81V243H239Q56 243 56 244Q60 253 65 263L73 282H422V584",
          44: "118 61Q118 80 135 93T169 107Q190 107 221 65T253 -23Q253 -39 251 -49T237 -80T198 -133Q148 -191 144 -191Q142 -191 137 -182T132 -172Q143 -161 160 -131T183 -83Q185 -77 185 -62Q185 -54 184 -48T182 -38T177 -28T171 -19T162 -8T150 6Q130 28 124 38T118 61",
          45: "54 236L73 275H453Q833 275 833 274Q830 265 825 255L818 236H54",
          46: "103 23T103 44T120 83T170 102Q200 102 218 84T237 44Q237 20 216 3T168 -15Q138 -15 121 4",
          47: "272 270Q503 721 506 721L509 720Q512 720 518 719T529 717L550 713L91 -181L66 -182Q41 -182 41 -181L272 270",
          48: "238 -12Q162 -12 102 42T42 185Q42 303 130 393Q163 425 208 452T284 490L313 501Q323 499 339 495T395 472T464 426Q533 357 533 273Q533 201 483 133T364 27T238 -12ZM428 208Q428 255 402 297T342 365T280 404T241 419Q214 419 178 374T142 259Q142 206 168 164T225 99Q259 74 310 74Q326 74 337 75T366 82T396 103T417 141Q428 171 428 208",
          49: "95 481Q102 481 217 485T383 489Q384 489 384 485Q367 397 367 165Q367 58 369 54Q374 46 380 44T410 42H466H546V40Q547 38 547 19L548 0H54V23Q54 29 54 34T54 44L55 47Q79 47 134 46T202 45Q226 45 234 52Q240 57 241 64T245 105Q254 236 254 320V347Q254 369 252 382T240 409T211 431L97 450L96 465Q95 480 95 481",
          50: "307 335Q307 374 283 397T224 421Q187 421 112 387Q105 384 100 382T95 381Q90 387 86 394L77 407L86 413Q219 491 298 491Q370 491 399 460T428 388Q428 373 424 358T409 326T391 297T363 264T335 235T301 202T269 171L199 104Q194 99 205 97Q209 96 214 96Q527 105 544 105Q553 107 563 102Q563 100 557 79T545 34T537 2H377Q338 2 247 2T130 4H44V26L104 77Q185 145 212 172T267 235Q307 291 307 335",
          51: "102 402L108 408Q115 413 122 418T141 431T165 447T194 461T227 474T263 483T302 487H307Q413 487 452 420Q465 400 465 371Q465 334 445 303T396 253T347 225T317 213Q314 213 314 211Q316 209 316 205Q317 201 320 201Q337 201 359 198T411 184T465 156T506 109T523 39Q523 -62 436 -127T229 -193Q179 -193 130 -178T56 -150T31 -133Q31 -132 41 -122L52 -112L63 -117Q128 -148 201 -148Q282 -148 331 -104T381 20Q381 71 363 100T304 145Q243 166 149 166H137V204H146Q179 204 211 210T275 229T326 268T346 329Q346 372 314 401Q292 423 245 423Q188 423 125 383L102 402",
          52: "346 -196Q344 -196 335 -187L336 -148Q337 -127 337 -55V0H13V29L187 253Q362 477 362 479L368 480Q375 481 387 483T411 487T434 491T452 494L459 495Q460 495 470 482V453Q470 389 466 230T461 62Q461 61 513 61T565 60L555 29L546 -1H461V-15Q461 -48 463 -100T465 -154L457 -157Q449 -160 434 -165T405 -175Q347 -196 346 -196ZM339 265V341Q339 362 335 362Q327 362 219 217T110 65V61H337V117Q338 133 338 187T339 265",
          53: "232 192Q176 192 122 152L95 162V481H306Q516 481 516 479Q514 477 501 433L486 389L319 388H152V386V382Q152 379 152 374T151 365Q147 329 146 260V218H149Q211 242 284 242Q353 242 402 224T474 176T508 117T518 55Q518 -62 432 -126T220 -190Q184 -190 151 -185T96 -172T57 -157T31 -145T20 -139T19 -138Q19 -136 27 -125L35 -112L51 -120Q114 -152 174 -152Q257 -152 314 -100T371 46Q371 107 340 149T232 192",
          54: "48 251Q48 330 76 403T150 529T253 623T370 683T485 704Q494 704 520 701T547 695Q547 692 542 659T536 625Q531 624 524 624L512 623L502 628Q489 635 468 640Q452 645 423 645Q403 645 379 640T320 617T255 568T201 481T171 348Q170 341 170 330V325L183 333Q275 385 357 385H361Q464 385 514 312Q546 267 546 217Q546 127 457 58T262 -12Q225 -12 189 3T120 49T68 132T48 251ZM448 165Q448 228 406 274T289 320Q264 320 236 312T190 295T173 284Q173 266 176 241T189 178T214 112T259 61T326 39Q372 39 410 75T448 165",
          55: "57 376L87 479H591V455L584 446Q544 399 491 328T349 117T185 -169L171 -196H159Q152 -197 102 -197Q58 -197 58 -196T56 -185L54 -175L299 158L443 359Q446 367 444 370H254L71 365L57 376",
          56: "88 533Q88 573 120 610T194 668T268 701T307 714Q324 714 352 711T422 695T486 659Q518 625 518 585Q518 536 479 489T384 406L371 398L385 390Q387 389 400 382T420 370T442 356T466 339T489 319T510 295T526 269T538 238T542 204Q542 125 463 60T256 -5Q145 -5 92 52Q45 97 45 165Q45 204 64 237T109 290T163 324T209 345T228 353L214 364Q199 375 179 392T138 431T103 480T88 533ZM405 557Q405 568 402 581T387 612T350 644T286 663Q283 663 280 663T274 664H272Q256 664 228 636T199 572Q199 547 238 507Q268 475 320 437L334 427Q345 433 358 443T388 483T405 549V557ZM304 42Q366 42 398 76T431 155Q431 178 420 200T396 238T359 270T321 296T283 318L263 328Q262 328 230 312Q190 290 175 266T160 198Q160 132 202 87T304 42",
          57: "549 220Q549 23 429 -82T105 -195H84V-189Q84 -179 85 -174V-164H93Q184 -156 238 -132T334 -56Q361 -23 376 16T394 78L397 100L363 88Q329 75 291 61T244 45Q237 44 218 44Q154 44 94 97Q29 152 29 240Q29 350 108 404Q145 429 257 480Q270 487 279 487Q403 487 470 421Q549 347 549 220ZM408 217Q408 276 390 320T346 385T297 415T259 424Q218 424 185 393T151 286Q151 216 213 154Q252 115 321 115Q368 115 388 134T408 217",
          58: "57 398Q57 419 72 438T117 457Q154 457 174 439T194 398Q194 379 176 361T119 343Q85 343 71 362T57 398ZM62 19T62 43T77 85T115 104Q153 104 175 86T197 42Q197 14 171 1T119 -12Q96 -12 79 3",
          59: "56 399Q56 424 73 440T104 456Q114 458 120 458Q149 458 170 440T192 399Q192 380 174 362T120 344Q85 344 71 362T56 399ZM78 53Q78 67 84 76T90 86Q90 88 98 92T116 98Q117 98 121 98T128 99Q152 97 181 58T211 -24Q211 -77 128 -165Q124 -170 121 -173T116 -178T113 -181T110 -185T106 -190L97 -184L88 -177L95 -168Q143 -104 143 -65Q143 -51 137 -40T113 -7T81 35Q78 41 78 53",
          61: "559 342L549 304H22L27 319Q29 328 30 333T33 343H296Q559 343 559 342ZM559 206L549 168H22L27 183Q29 192 30 197T33 207H296Q559 207 559 206",
          63: "121 590Q121 575 128 562T144 542T152 533T115 512L78 491Q55 499 47 516Q40 530 40 553Q40 601 77 632Q155 697 257 697H268Q316 697 355 679Q422 646 422 576Q422 518 388 476Q383 468 376 461T358 444T340 428T316 410T290 390L230 344Q180 307 180 275Q180 261 187 248T202 227L209 219Q209 215 176 193L142 170Q114 177 100 194T84 226V239Q84 259 93 276T113 302T150 331T192 362Q203 370 219 382T247 403T267 422Q312 471 312 546Q312 593 282 623T207 653Q170 653 146 636T121 590ZM95 23T95 49T117 94T173 113Q204 113 223 96T242 54Q242 27 221 7T167 -14Q136 -14 116 4",
          91: "226 711T225 711T86 699V-93H89Q94 -93 157 -96T223 -100H226V-119H223Q134 -119 42 -130H36V740H42Q61 738 156 736H226V723Q226 711 225 711",
          93: "69 732Q116 733 146 734T184 736T197 737T206 738H208V-132Q190 -129 160 -127T99 -125T66 -124H14V-103H19Q20 -103 84 -98T152 -92H158V699H151Q148 700 85 703T18 708H14V732H69",
          94: "1 463T1 464T148 599T296 734Q584 486 584 485L561 472Q538 459 537 461Q296 672 293 672L161 563Q133 539 97 509T44 466L28 452Q27 452 14 457",
          8216: "187 456Q187 437 169 424T138 411Q114 411 84 454T53 538Q53 565 75 597Q109 648 155 697L166 708L181 694L173 681Q124 610 124 577Q124 549 155 511T187 456",
          8217: "125 524Q125 545 92 588T58 651Q58 661 61 667Q65 674 80 683T107 692Q131 692 162 645T193 564Q193 540 176 509T144 460T87 394L78 400L68 406L79 421Q125 489 125 524",
          8260: "272 270Q503 721 506 721L509 720Q512 720 518 719T529 717L550 713L91 -181L66 -182Q41 -182 41 -181L272 270",
          58113: "388 427Q320 485 242 524T128 563H116Q95 563 87 561L77 559Q72 563 69 566T65 570T65 572L75 576Q106 592 154 611T212 630Q230 630 262 622T358 581T492 498L508 486Q512 463 512 396Q512 246 469 112L465 102Q453 94 341 25Q252 -27 247 -27Q243 -27 174 24T97 84Q90 100 90 214Q90 285 98 345Q100 360 102 363T118 377Q175 422 262 465Q264 463 270 460L277 456Q277 455 267 447T244 428T228 414Q206 382 206 269Q206 187 214 164T259 110Q286 89 342 58Q391 131 391 313Q391 355 388 412V427",
          58114: "39 362L37 366L38 368L82 405H133V474Q135 563 143 589T198 658Q210 669 224 676T247 687L255 690H253Q241 690 253 692Q254 692 256 692T260 693Q263 693 262 691L261 690Q300 690 361 662L373 656L388 666Q404 675 405 675L406 674Q406 672 406 670T406 664L408 655L301 555Q300 555 287 564T254 584T221 597Q190 597 176 583T161 550Q161 525 184 495T232 440T261 405H387V399Q377 389 364 379L340 359H258V315Q258 52 228 -18L172 -120L121 -211H109Q102 -212 96 -212L109 -174Q131 -108 135 -80T139 53V76V157V362H39",
          58115: "41 352Q40 354 39 355T37 358L36 360H37Q48 370 61 380L84 400H108Q131 400 131 402Q121 424 104 501L100 519Q109 560 134 602T196 664Q230 681 271 681Q291 681 316 669T358 644L373 631Q373 630 304 553Q299 548 294 547Q292 547 290 546H287Q286 546 274 562T243 593T205 609Q180 609 165 596T150 562Q150 526 191 488L217 462Q248 431 253 405V400H381L384 394L349 352H251V332Q249 271 231 17L227 -37L120 -217L109 -218Q103 -219 97 -219Q97 -218 101 -206T110 -177T118 -151Q126 -129 128 -120T136 -46T141 127Q141 250 136 340V352H41",
          58116: "107 370Q127 384 172 409T255 454T294 473L306 468Q356 446 425 431L435 429L524 468Q528 465 531 461Q499 395 499 271V263Q499 146 509 71T519 -8Q519 -28 512 -45Q510 -50 435 -123T355 -197Q296 -212 257 -212Q209 -212 164 -196T98 -167T67 -143L133 -44H144Q167 -88 216 -111T320 -134Q371 -134 390 -118T410 -69Q410 -52 404 -12T392 60T385 92L193 -29L158 5Q124 39 110 51L96 63V71Q94 79 94 121Q94 130 94 148T93 174Q93 230 96 275T103 344T107 370ZM221 397Q200 334 200 254Q200 170 210 140Q216 126 234 109T268 81L283 71L383 119V127Q384 132 384 241L385 347L368 349Q325 357 290 369T240 389T221 397",
          58117: "103 453Q103 631 95 661Q95 663 102 667T110 672L114 664Q117 655 123 641T131 621L140 597L154 606Q208 641 275 673L297 684Q300 683 302 682T307 679T310 678L314 676Q283 658 256 625Q238 601 231 579T223 515L224 512L282 548Q339 583 341 583T365 548T386 509Q326 443 318 443L316 446Q314 448 311 452T304 460T294 470T283 480T272 488T260 494T248 497Q231 497 223 474Q220 468 218 440T215 407V401H345L309 360H218V314Q218 181 221 139V129L253 108Q306 73 310 73Q315 73 343 83L373 92L374 87Q375 82 375 79T375 74T360 65T308 36T229 -13L208 -27L192 -13Q149 24 90 61Q89 61 89 62L90 68Q91 73 93 87T97 125T100 191T103 291V360H33V366L34 371L85 405H94L103 404V453",
          58120: "602 575Q505 508 505 489Q505 488 505 482T506 463T507 432Q507 314 456 237L449 226L434 216Q420 208 325 143L316 137Q453 82 488 82Q527 82 585 127L596 136Q597 136 599 126L602 115Q578 85 511 27T428 -31Q400 -31 308 10T170 51Q143 51 123 43T92 24T54 -15L34 6L41 14Q65 41 170 129L188 144L204 145Q254 147 293 164T350 208Q378 249 378 344Q378 422 362 478T320 563T268 605T213 618Q177 618 156 600T134 561Q134 539 162 508T217 446T245 394Q245 368 213 337T85 250L62 262Q73 269 86 279T116 308T133 338T108 378T57 439T32 499Q32 556 117 617T291 679Q350 679 393 658Q415 647 433 631T462 600T480 572T490 550T494 541T499 544T516 556T547 578T603 613T689 662L720 679L730 670Q742 659 756 649T785 629T810 615T836 601T855 590Q855 587 860 536T870 419T875 312Q875 114 800 -25Q794 -35 781 -47Q584 -220 398 -220Q322 -220 278 -190Q253 -173 239 -155L244 -150Q248 -145 255 -138T271 -120T290 -100T310 -80T328 -63T341 -51T349 -46Q350 -46 351 -46T354 -47Q357 -47 357 -52Q359 -68 364 -83T383 -118T424 -151T491 -166Q559 -166 613 -129Q629 -118 641 -108T674 -68T710 1T735 107T746 260Q746 433 727 507Q727 512 685 535T615 570L602 575",
          58121: "351 571Q317 571 247 563T171 555Q153 555 133 563T107 584Q94 605 98 609Q101 615 138 658T190 717H207Q204 710 204 699Q204 673 231 666Q235 665 264 665Q296 665 345 667T426 669Q474 669 501 660T545 626Q553 612 553 594Q553 531 498 474T379 384Q371 379 371 378Q371 376 390 376H411H434Q520 376 602 318Q621 303 627 288T633 234Q633 59 540 -34Q465 -109 348 -130Q308 -137 235 -137Q159 -136 143 -129Q132 -125 132 -118V-53Q118 -24 90 -24Q69 -24 37 -39L27 -44L25 -42Q23 -39 21 -35T17 -30Q17 -28 40 -14T103 19T177 44Q183 45 205 45Q219 45 227 44T245 37T259 20T264 -12Q264 -33 262 -48T259 -80Q259 -93 260 -95Q271 -110 305 -110Q343 -110 383 -86T443 -33Q491 34 491 154Q491 223 467 249Q428 288 334 288H322Q288 288 237 276L222 273L206 286L262 367Q279 369 303 377T358 403T410 452T431 524Q431 531 431 533T427 545T416 558T392 566T351 571"
        }, {});
      },
      175: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fraktur = void 0;
        var n = r(768),
          o = r(9587);
        e.fraktur = (0, n.AddPaths)(o.fraktur, {
          33: "102 582T102 620T112 673T152 689Q190 689 190 638Q190 605 167 373L148 187L133 184Q102 582 102 620ZM91 24T91 48T107 88T148 104Q171 104 187 87T204 48Q204 22 188 5T149 -12Q124 -12 108 6",
          34: "33 436Q8 603 8 648Q8 663 9 671T19 687T43 695Q63 695 74 681Q76 678 76 650V623L66 532Q57 443 55 436V432H33V436ZM128 666Q128 691 162 691T196 668Q196 634 186 531Q176 441 176 432H166Q155 432 155 434L142 545Q135 603 130 647Q128 664 128 666",
          38: "181 520Q181 604 231 650T328 697L330 698Q333 698 335 698Q336 698 340 698T346 697Q390 697 418 670T446 604Q446 554 414 511Q384 467 300 417L283 406Q281 405 296 374T347 286T425 182Q466 135 469 135Q470 135 473 140T480 152T486 165Q509 210 509 263Q509 282 507 292Q498 317 488 332T465 352T443 359T418 361Q388 361 357 358L346 356L347 374Q347 394 348 396V399H355Q366 396 535 396Q663 396 689 398L703 399Q703 398 702 375T700 351L688 353Q655 356 601 357Q553 357 553 355Q562 332 562 294Q562 280 561 267T555 241T548 218T539 195T529 175T518 156T508 141T497 126L489 115L496 107Q549 54 596 54Q623 54 644 67T677 101T697 140T708 174L710 187Q710 188 710 188L711 190Q714 190 723 187T733 183Q733 179 732 172T726 145T714 107T694 66T665 27T623 0T569 -11Q500 -11 443 41L434 49L425 42Q348 -9 275 -9Q251 -9 233 -6Q187 -1 152 18T98 60T67 111T52 159T49 195Q49 231 60 261T96 315T141 354T197 390L208 397Q181 459 181 520ZM374 577Q374 607 356 629T311 651Q289 651 271 636Q242 614 242 559Q242 533 249 502T262 453T270 435T279 440T298 453T314 464Q374 503 374 577ZM127 217Q127 145 173 89T291 32Q318 32 347 42T393 63T409 75Q384 100 325 184T227 351Q223 366 220 366Q215 366 178 338Q127 298 127 217",
          39: "69 666Q69 680 79 687T104 695Q112 695 117 694T128 684T134 659L104 438Q104 436 96 436T88 438Q88 447 79 540T69 655V666",
          40: "293 737V719Q291 718 285 714T276 708T268 702T258 695T250 686T241 674Q164 570 164 282Q164 -37 230 -119Q273 -171 292 -171Q293 -171 293 -179V-186H289Q270 -180 259 -175Q175 -132 145 -23T114 275Q114 491 157 598T293 737",
          41: "223 259Q223 386 212 474T178 609T136 677T89 714V735Q121 726 139 713Q276 622 276 273Q276 98 246 -23Q225 -106 189 -139T89 -187V-170L101 -165Q148 -146 172 -110T210 13T223 259",
          42: "118 573Q118 575 76 602L34 629L50 647L55 652L66 642Q76 633 91 620T117 598L128 590Q128 663 125 687V692H151V689V687Q151 685 151 683T150 678T150 672Q145 628 144 605V592L219 652L232 634Q232 632 220 624Q195 610 155 582L146 575L158 567Q178 552 197 540T225 523T233 516Q233 515 226 506T217 495L152 549L143 555V530Q144 509 145 492T148 466T149 454Q149 449 142 449H125V462Q128 522 128 549V562L115 552Q88 531 59 506L45 495Q44 495 39 505T34 516L118 573",
          43: "357 584L399 598V282H709L702 263L696 243H399V-64L379 -73L358 -82Q357 -82 357 81V243H47L51 253Q52 256 54 263T58 272L62 282H357V584",
          44: "99 62Q99 82 114 94T144 107Q159 107 178 77T205 26Q213 5 213 -23Q213 -49 207 -65T181 -113Q128 -189 122 -191Q121 -191 116 -184T111 -174Q111 -173 122 -155T145 -111T156 -62Q156 -44 152 -34T127 4L104 37Q99 49 99 62",
          45: "46 236L62 274Q62 275 384 275H706L699 255L693 236H46",
          46: "87 43Q87 69 104 85T142 102Q164 102 182 86T200 44Q200 20 183 3T141 -15Q118 -15 103 2T87 43",
          47: "230 270Q426 721 428 721Q437 719 447 717L466 713L448 672Q78 -180 77 -181Q77 -182 55 -182L34 -181L230 270",
          48: "212 -13Q184 -13 156 -2T101 32T59 97T42 195Q42 311 132 396Q170 433 211 462T262 492Q272 492 301 477T366 434T429 360T456 258Q456 161 378 74T212 -13ZM381 209Q381 257 365 295T328 355T282 390T243 408T223 413Q220 413 204 403T167 376T137 341Q119 305 119 250Q119 168 159 114T263 59Q308 59 344 93T381 209",
          49: "123 459Q145 459 170 460T217 462T256 464T284 466L295 467Q296 467 296 467T297 468Q299 468 302 466T307 462L309 459Q307 454 304 424T299 341T297 235Q297 139 298 101T302 55T313 44Q316 43 367 43L460 46Q460 35 459 22V-1H450Q402 2 281 6Q222 6 171 4T91 1T56 -1L47 -2V43H121H170Q195 43 201 45T209 56Q212 69 212 214Q212 333 209 365T194 409Q183 417 161 423T121 430L104 432Q103 432 103 446V459H123",
          50: "104 384Q115 394 133 409T199 449T281 474Q321 474 351 447T385 378Q385 328 333 255T228 127T176 72Q176 67 183 65Q184 65 203 65T260 67T331 69L475 73L484 67Q484 64 472 33L460 1H60V17L107 61Q210 159 249 208Q309 283 309 331Q309 363 285 389T228 415Q212 415 184 403T134 379L114 367L104 384",
          51: "305 328Q305 372 279 396T214 421H211Q172 421 128 384L107 398L116 405Q151 437 191 455T251 473H260Q314 473 341 455T382 394Q384 386 384 367T382 338Q362 263 271 217L256 210L257 206L259 202Q260 202 272 201T296 198T324 192T355 179T384 157T410 123T427 75Q429 64 429 41Q429 -59 353 -120T183 -182L88 -164Q81 -162 69 -157T48 -147T39 -141Q39 -139 46 -127L53 -114L69 -122Q129 -149 171 -149Q218 -149 253 -131T305 -83T330 -26T338 29Q338 41 336 55T328 89T308 127T273 153Q228 171 162 171Q158 171 152 171T142 170H127V204H134Q232 214 275 257Q305 292 305 328",
          52: "299 -179Q306 -156 306 -48V0H11V7Q10 10 10 18Q10 23 154 236L298 449Q298 450 339 463L379 476Q385 473 384 470V466Q384 463 384 457T384 444T383 427T383 408Q381 328 381 248Q381 46 384 40H387Q422 40 460 44Q465 44 470 44T478 44L481 45Q481 43 478 24T473 1Q473 -1 464 -1Q462 -1 451 -1T430 0H387V-76L389 -156V-161L311 -191Q299 -181 299 -179ZM299 364H287L277 352Q234 297 186 224T112 104T79 43Q79 42 192 42H306V115Q306 300 299 359V364",
          53: "334 25Q334 99 296 134T207 169Q154 169 107 123L98 114L89 120L80 125V458H420Q420 456 409 418L397 379Q397 378 264 378H131Q130 377 128 376T125 374T124 371T122 368T122 363T121 356T121 345V279V190L130 186L140 190Q196 214 260 214Q311 214 348 197T404 153T431 99T440 42T433 -16T406 -76T356 -130T276 -169T163 -184H156Q110 -184 57 -163L47 -159L53 -147L58 -134Q61 -134 74 -139T110 -148T156 -153Q206 -153 243 -135T299 -87T326 -30T334 25",
          54: "45 240Q45 328 73 406T143 536T235 626T327 681T399 699Q400 699 404 699T411 700Q424 700 441 696T459 689Q459 671 451 637Q451 633 447 632L444 629L434 633Q413 640 384 640H377Q299 640 222 565Q182 531 156 463T129 315V306H136L149 315Q229 376 316 376H318Q393 376 432 326T471 213Q471 129 402 58T237 -13T93 59T45 240ZM391 172Q391 231 354 272T258 314Q230 314 200 302T154 279T133 262L134 249Q154 32 266 32Q315 32 353 64T391 172",
          55: "395 377L391 382H225Q59 382 59 383L74 423Q89 464 89 465Q90 468 94 468Q146 460 350 458H498V442L473 406Q241 75 125 -156L113 -181H40L37 -168L57 -140Q115 -58 199 70T339 287T395 377",
          56: "220 -10Q168 -10 131 6T75 50T48 103T40 157Q40 223 77 266Q103 295 156 328T225 375Q247 393 247 394L206 361Q205 361 193 368T164 391T131 426T102 474T90 531Q90 580 114 615Q146 660 238 698L254 705L262 704Q288 704 332 693T402 656Q434 620 434 568Q434 518 401 475T321 402L305 391L336 368Q339 366 353 356T372 343T389 330T406 316T420 301T434 283T445 265T454 244T458 222T461 195Q461 106 389 48T220 -10ZM350 545Q350 578 337 601T304 634T266 649T234 653L224 654L204 639Q196 634 191 629T182 621T176 614T173 609T170 603T168 597Q165 585 165 567Q165 497 261 424L273 415Q350 467 350 545ZM261 405L263 407Q262 407 261 405ZM258 403Q257 403 255 401L254 399L256 400Q258 402 258 403ZM252 398Q251 398 249 396L248 394L250 395Q252 397 252 398ZM245 36Q276 36 300 45T338 69T360 102T371 136T374 168Q374 211 341 255Q324 275 305 289T235 332Q231 330 215 321T193 307T173 292T153 271T138 247T127 216T123 177Q123 146 132 117T170 62T245 36",
          57: "353 93T352 93T320 79T251 49T201 34Q127 37 87 79Q28 138 28 234Q28 273 37 304T60 355T101 396T152 429T218 462L234 469H243Q348 461 395 417Q466 348 466 201Q466 72 397 -29T211 -163Q155 -179 91 -182H72V-154H80Q144 -154 202 -131T297 -60Q318 -31 333 7T352 68L357 92Q353 93 352 93ZM369 208Q369 240 362 272T339 339T290 394T214 415Q171 415 144 372T116 266Q116 193 154 144T238 95H249Q369 95 369 208",
          58: "50 377T50 400T64 440T99 457Q128 457 146 440T165 399Q165 375 146 359T102 342T64 359ZM53 19T53 43T66 86T103 105Q129 105 148 87T168 41Q168 17 147 3T102 -12Q80 -12 67 3",
          59: "47 399Q47 424 62 441T101 458T143 442T162 400T144 359T101 343Q78 343 63 360T47 399ZM76 86Q76 88 80 91T91 96T106 99Q119 99 131 86Q179 35 179 -25Q179 -64 146 -115T89 -189Q86 -187 83 -185T79 -182T76 -180T75 -177T77 -173T80 -168Q121 -108 121 -64Q121 -44 94 -5T66 52Q66 66 71 75T76 86",
          61: "725 366Q724 365 721 349T716 331V329H385Q54 329 54 331Q55 332 59 349T63 368H394Q725 368 725 366ZM725 169Q724 168 721 152T716 134V132H385Q54 132 54 134Q55 135 59 152T63 171H394Q725 171 725 169",
          63: "46 557Q46 613 103 653T227 693Q287 693 322 659T357 564Q357 517 326 469T259 390T191 326T160 272Q160 240 187 221Q193 217 193 216Q182 209 170 200L147 184Q127 192 113 209T98 250Q98 290 193 376Q287 454 287 542Q287 581 262 616T188 652Q143 652 126 631T108 588Q108 559 140 527L79 490Q46 515 46 557ZM108 47Q108 68 123 85T160 103Q179 103 198 90T217 46Q215 24 201 7T164 -11Q142 -11 125 6T108 47",
          91: "262 -119Q224 -120 191 -123T141 -128T118 -130Q117 -130 117 305V740H122Q141 737 219 736H278V723Q278 711 277 711L159 699V-93H162Q167 -93 220 -96T276 -100Q278 -100 278 -109V-119H262",
          93: "64 733Q89 733 110 734T143 737T158 738H160V-131H154Q101 -125 40 -124H-4V-103H1Q3 -102 57 -98T113 -92H118V700L64 703Q7 707 3 708H-4V732H21Q34 733 64 733",
          94: "0 464L250 734L262 722Q274 712 384 598L495 486Q483 478 467 467L456 459L248 672L154 580L23 452Q17 454 10 458T0 464",
          8216: "117 410Q97 410 71 455T45 539Q45 588 129 694L140 708Q142 708 153 694L147 682Q106 609 106 582V577V571Q106 548 132 511T158 455Q158 434 143 422T117 410",
          8217: "105 529Q105 546 77 588T49 651Q49 658 51 666Q53 672 67 682T92 692Q111 692 137 644T163 563Q163 534 143 497T99 428T74 395Q72 395 65 400T58 407Q105 476 105 523V529",
          8260: "230 270Q426 721 428 721Q437 719 447 717L466 713L448 672Q78 -180 77 -181Q77 -182 55 -182L34 -181L230 270",
          58112: "427 436Q427 434 427 425T429 398T430 362Q430 222 396 109L393 99L305 33Q218 -32 216 -32Q208 -29 142 22L91 68L78 81L77 94Q75 130 75 173Q75 245 87 347L135 385Q178 418 184 424L177 428Q174 429 170 431Q116 454 96 473T75 534Q79 608 154 683Q164 677 164 673Q164 670 157 662T144 637T137 598Q137 552 182 518T280 470T380 447T427 436ZM342 371L275 394L208 417Q203 417 192 399T168 334T156 229Q153 187 153 157Q153 141 156 135Q158 125 208 88T280 51Q306 51 326 120T346 297Q346 339 344 354T342 371",
          58113: "39 551L35 569L52 577Q72 586 98 595T140 610T158 616Q174 612 200 604T293 560T412 477Q414 475 417 472Q428 462 430 450T432 376Q432 223 401 124Q395 106 393 103T382 92Q351 68 281 20T206 -29Q201 -31 137 26L100 60L78 83L77 112Q76 132 76 170Q76 259 86 342L88 360L101 371Q116 386 163 422T215 459Q216 459 224 455T233 450L229 446Q225 442 218 434T203 419Q179 394 175 389T168 372Q156 334 156 262Q156 167 164 137Q168 125 196 102T252 62L278 45Q279 45 285 52T302 78T322 126T339 205T346 316Q346 367 344 389L343 406L326 423Q228 520 113 559L100 564L70 557L39 551",
          58114: "123 386L120 431Q116 476 116 511V520Q116 593 174 649Q207 680 236 680Q258 680 284 664T312 648Q318 648 327 656Q328 657 330 659Q337 664 337 661Q337 660 338 657Q338 652 339 648L268 566L260 574Q234 600 206 600Q182 600 164 585T145 541Q145 492 211 386L267 385H324L299 354H214V312Q214 86 193 -58L192 -69L116 -215H108Q92 -215 92 -212Q93 -211 100 -189T116 -135T128 -80Q134 -41 134 22Q134 54 130 185T125 349V354H29L59 385H91Q123 385 123 386",
          58115: "91 530Q91 564 116 600T164 656T194 678Q195 678 200 678T209 679Q268 679 316 639L293 593Q267 547 263 546H262Q260 546 256 553Q222 613 180 613Q160 613 146 599T132 564T170 474T210 388H318L296 356H206V322Q204 284 204 255Q202 221 202 161V99Q202 28 194 -22T160 -124Q148 -146 116 -199L101 -224L91 -220Q85 -218 84 -217T83 -215L101 -161Q116 -114 119 -73T122 108Q119 334 117 352V356H72L28 357L66 388H92Q118 388 118 389L109 433Q91 514 91 530",
          58116: "254 -150Q293 -150 328 -126T363 -54Q363 -38 352 29T339 98L250 34Q160 -30 159 -30L77 64V71Q74 95 74 174Q74 212 75 243T79 294T83 328T87 352T90 366L117 384Q206 446 238 464L250 471Q277 455 306 443T350 427L365 423Q367 423 405 443T443 465L449 455Q431 414 426 362T418 201Q418 135 420 121Q438 -4 438 -19Q438 -26 438 -31T434 -42T429 -51T420 -63T408 -77T391 -95T370 -119T346 -147T325 -170T309 -187T291 -200T274 -207T252 -213T225 -214Q175 -214 132 -196T70 -160L52 -143Q52 -138 90 -48Q90 -47 95 -47H101Q108 -81 146 -115T254 -150ZM341 136Q341 157 344 242T347 348V355L334 356Q299 359 262 367T203 383T179 391Q177 391 173 377T163 323T158 227Q158 164 161 128V121L174 106Q203 75 223 59L341 127V136",
          58117: "92 446Q92 603 82 664Q94 670 95 670L96 666Q98 661 101 651T108 633Q121 598 121 597L141 612Q247 686 250 686Q251 686 266 679Q261 674 243 659T213 632T190 597T173 546Q172 541 171 530T170 511T170 502Q171 502 222 542L273 582Q308 522 315 504L279 449L269 462Q231 506 215 506Q202 506 190 490Q164 458 164 395V390H279L266 373L254 355H167V306Q169 252 169 217Q170 195 170 147V117L200 92Q234 64 237 64Q243 64 277 81L311 99V75Q310 75 242 27L174 -20L156 -3Q88 60 81 60L79 62Q80 60 82 62Q87 67 87 290V355H57L26 356L73 390H92V446",
          58118: "117 531Q117 533 137 544T178 566L198 577Q200 577 204 575T208 572V570Q208 568 208 566T207 560Q197 496 197 397V392H321L295 353H199V260Q199 157 200 145V122L269 68Q271 67 274 67Q282 67 310 83T342 100Q343 100 345 92T346 83L211 -21L172 12Q117 59 117 63Q117 65 117 87T119 150T120 238V353H75L29 354L65 391H118V460Q117 498 117 531",
          58119: "337 91V78L324 71Q288 53 256 29T206 -8T180 -22Q174 -22 158 -9Q82 46 60 46H59L63 51Q67 56 73 68T85 96Q101 158 101 254Q101 300 95 330T83 370T66 394L53 388Q48 385 41 382T24 374Q22 376 20 378T16 381T13 383T10 385V386L119 475Q150 439 160 430L171 422V409Q173 377 173 300Q173 228 166 183T152 122T145 102Q207 81 242 58L337 104V111Q340 146 340 227Q340 320 339 351T338 408V423L422 469Q425 465 429 462L426 438Q413 354 413 251Q413 152 423 119Q426 110 435 96T452 82Q454 82 509 103Q514 98 514 89Q514 87 507 81T472 51T409 -7L395 -20Q393 -18 390 -17Q386 -14 382 -6Q380 -2 379 1Q369 24 361 40T348 62T341 73T338 84L337 91"
        }, {});
      },
      5735: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.italic = void 0;
        var n = r(768),
          o = r(8348);
        e.italic = (0, n.AddPaths)(o.italic, {
          33: "330 716Q351 716 365 703T380 670V659L304 433Q230 207 227 204Q225 198 205 198Q184 198 184 207T220 439T260 669Q270 694 297 708Q300 709 304 710T311 713T316 714Q324 716 330 716ZM107 51Q110 83 133 102T179 121Q207 121 219 105T231 72Q231 45 209 23T156 0Q138 0 123 11T107 51",
          34: "214 620Q214 647 236 670T289 694Q312 694 326 677T341 633V624Q341 588 327 550T294 482T253 428T216 392T196 379Q191 379 184 388T176 401Q176 404 195 421T243 472T287 547Q299 576 299 582L295 580Q291 578 282 576T264 573Q241 573 228 585T214 620ZM411 620Q411 647 433 670T486 694Q509 694 523 677T538 633V624Q538 588 524 550T491 482T450 428T413 392T393 379Q388 379 381 388T373 401Q373 404 392 421T440 472T484 547Q496 576 496 582L492 580Q488 578 479 576T461 573Q438 573 425 585T411 620",
          35: "281 327H228Q186 327 175 330T164 347Q164 359 176 365Q179 367 292 367H404L563 688Q569 694 578 694T593 686T597 670Q597 667 531 535L448 367H614L773 688Q779 694 787 694Q796 694 802 688T808 674V672L807 670Q807 667 732 517L658 368L736 367H814Q828 357 828 347Q828 336 812 327H637L599 250Q561 174 561 173H662H724Q760 173 769 170T779 153T770 136T729 132Q721 132 696 132T651 133H540L380 -188Q374 -194 366 -194Q357 -194 351 -188T345 -174L346 -172V-170Q346 -167 412 -35L495 133H330L170 -188Q164 -194 156 -194Q147 -194 141 -188T135 -174L136 -172V-170Q136 -167 211 -17L285 133H207L130 134Q115 140 115 153Q115 164 131 173H306L344 250Q382 326 382 327H281ZM592 327H427L389 250Q351 174 351 173H516L554 250Q592 326 592 327",
          37: "301 348Q257 348 231 383T205 480Q205 553 244 629T346 736Q370 750 394 750Q416 750 429 742T458 714Q512 644 606 644Q722 644 802 732Q817 750 827 750Q835 750 841 744T847 730Q847 725 827 700T689 540Q586 421 512 335Q180 -50 176 -52Q172 -56 165 -56Q157 -56 151 -50T145 -35Q145 -29 162 -9T330 186Q392 258 430 302Q711 627 711 628L701 624Q652 607 604 607Q551 607 494 634L479 642V624Q479 544 439 467Q414 416 377 382T301 348ZM270 443Q270 385 303 385H306H308Q326 385 348 407Q384 441 409 504T434 627Q434 713 390 713Q358 713 328 663Q307 631 289 556T270 451V443ZM608 -56Q573 -56 543 -23T513 76Q513 129 536 190T604 296L627 318Q670 347 704 347Q747 347 767 310T788 222Q788 126 732 35T608 -56ZM742 222Q742 310 699 310Q677 310 655 285T620 227Q608 197 593 138T578 42V36Q578 -18 613 -18Q657 -18 699 64T742 222",
          38: "209 444Q209 546 278 631T424 716Q473 716 501 683T530 601Q530 554 511 535T467 515Q446 515 437 527T427 553Q427 578 446 594T481 610H483V617Q480 641 464 660T419 679Q367 679 328 603Q316 578 305 538T288 470L282 443L295 449Q308 455 330 462T371 469Q397 469 413 450T430 404Q430 363 400 329T331 295Q291 295 256 322Q255 322 246 293T227 223T217 158Q217 117 232 88T273 43T327 22T387 15Q457 15 512 37T599 93T652 169T680 248T688 317T678 380T659 423T647 437Q643 435 637 431T613 416T581 392T554 364T538 332Q540 310 541 310Q554 335 587 335Q601 335 613 327T626 300Q626 290 622 279T603 255T563 242Q532 245 512 263T491 320Q494 351 511 377T547 418T600 456T652 494Q676 512 697 539T728 582T738 601Q738 602 736 602Q732 602 726 604T714 616T707 638Q707 661 724 677T764 694Q799 694 802 660Q802 625 767 562T688 467L694 458Q700 449 702 444T711 428T720 408T727 385T733 358T735 327Q735 281 724 235T685 141T617 59T515 1T375 -22Q270 -22 199 34T127 181Q127 216 147 270T207 374L216 386Q209 421 209 444ZM386 412Q386 432 366 432Q345 432 325 418T294 390T284 375Q284 371 289 362T306 343T335 332Q355 332 367 350T383 384T386 412",
          39: "250 620Q250 647 272 670T325 694Q348 694 362 677T377 633V624Q377 566 343 506T275 412T231 379Q226 379 220 388T213 401T232 421T279 472T323 547Q335 573 335 582L331 580Q327 578 318 576T300 573Q277 573 264 585T250 620",
          40: "241 -250Q203 -212 174 -140T144 39Q144 158 180 288T296 544T481 746L487 750H499Q517 750 517 740Q517 736 495 716Q399 630 331 491T236 228T208 3Q208 -73 224 -130T255 -214T271 -244Q271 -250 252 -250H241",
          41: "326 497Q326 546 320 588T304 655T285 699T269 728T262 740Q262 746 267 749L272 750Q276 750 281 750H293Q331 712 360 640T390 461Q390 332 339 171T188 -116Q161 -150 121 -188T47 -250H35Q17 -250 17 -240Q17 -236 39 -216Q135 -130 203 9T298 272T326 497",
          42: "560 658Q569 658 576 649T584 631Q584 625 583 620T577 611T569 603T556 595T540 587T519 578T494 566L428 536Q427 535 433 531T479 502Q525 475 532 469T539 450Q538 435 525 424T497 412Q489 412 482 418T442 456Q400 497 400 494L387 420Q376 353 373 343T352 323Q345 320 336 320H331Q322 320 316 327T309 343Q309 347 334 420L359 496Q358 496 297 456T234 414Q228 411 221 411Q212 411 204 417T195 439Q198 458 209 465T283 502L353 534L300 566Q255 593 247 599T239 616Q239 631 252 644T282 658Q290 658 295 654T335 615L378 573L391 647Q393 657 395 671T398 691T400 706T404 720T408 730T414 739T423 744T434 749Q435 749 439 749T445 750Q467 748 469 728Q469 723 457 685T432 610L420 573L481 613Q548 658 560 658",
          43: "139 237T139 250T151 266T198 270H293H431L465 407Q469 424 476 452Q494 528 500 542T519 557Q526 557 532 552T538 538Q538 536 507 409T472 272Q472 270 604 270Q737 270 741 268Q753 261 753 250Q753 237 742 233T696 229Q687 229 655 229T599 230H462L461 226Q461 224 427 91T392 -47Q387 -57 374 -57Q367 -57 361 -51T355 -37Q355 -31 388 99L421 230H288Q267 230 238 230T199 229Q163 229 151 233",
          44: "106 46Q106 68 121 90T167 120Q168 120 173 120T180 121Q232 121 232 59V54Q232 18 219 -20T186 -88T145 -143T109 -181T88 -194Q84 -194 77 -185T69 -171Q69 -168 70 -166T76 -161T85 -154T101 -139T124 -114Q146 -88 162 -58T183 -12T188 7Q187 7 183 5T172 2T156 0Q129 0 118 14T106 46",
          45: "205 180H131Q102 180 93 181T84 190Q90 238 103 251H334Q341 244 341 241Q341 236 336 214T327 186Q325 181 312 181T205 180",
          46: "107 50Q107 76 129 98T181 121Q203 121 217 108T231 72Q231 47 210 24T156 0Q135 0 121 13T107 50",
          47: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
          48: "414 665Q562 665 562 490Q562 426 534 318Q451 -21 251 -21Q222 -21 202 -15Q155 2 134 40T110 144Q110 201 127 286T187 470T287 614Q348 665 414 665ZM187 98Q187 59 208 37T260 15Q320 15 365 83Q394 128 440 312T487 547Q487 580 471 600T433 627Q428 628 408 628Q381 628 353 609T311 569Q279 526 239 364T190 143Q187 120 187 98",
          49: "248 491Q228 491 228 502Q228 516 236 532Q237 536 246 537T275 541T314 552Q350 567 382 595T430 644L446 664Q450 666 454 666Q468 666 468 658Q468 647 395 359Q321 63 321 59Q321 52 334 50T388 46H422Q428 37 428 35Q428 19 421 5Q416 0 405 0Q400 0 361 1T263 2Q215 2 185 2T142 1T127 0Q110 0 110 11Q110 13 113 25T118 40Q120 46 146 46Q196 46 212 49T235 61Q238 66 295 295L353 526L340 519Q328 512 302 503T248 491",
          50: "159 404Q159 433 176 476T222 562T297 635T395 666Q466 666 508 617T551 497Q551 473 545 446Q534 388 482 333Q441 292 355 240T264 184Q216 151 179 101L171 91Q171 90 177 90Q206 90 269 77T366 64Q385 64 390 65Q418 73 441 98T475 156Q479 168 481 170T495 173H518Q524 167 524 166T521 152Q502 86 459 32T353 -22Q315 -22 259 15T172 53Q156 53 143 36T126 1L121 -16Q119 -22 98 -22H82Q76 -16 76 -13T80 5T98 50T132 111T189 178T274 242Q327 273 364 305T420 370T447 427T460 483Q466 514 466 538Q466 586 443 607T389 629Q338 629 293 584T226 487T204 399Q204 390 204 386T209 378T222 373Q258 376 282 422T307 493Q307 506 302 517T297 531Q297 537 308 546T327 551Q329 550 333 543T340 523T344 497Q344 450 306 393T216 336Q186 336 173 355T159 396V404",
          51: "296 531Q296 536 307 544T322 553Q330 553 338 534T346 501Q346 468 319 440T258 412Q232 412 216 430T200 478Q200 552 281 618Q345 666 416 666Q489 666 525 625T562 530Q562 473 525 419T430 335L416 329Q479 288 479 206Q479 142 440 89T344 7T229 -22Q173 -22 135 12T96 106Q96 192 157 192Q192 192 197 157Q197 134 184 117T142 96Q153 47 180 29Q201 15 232 15Q249 15 275 22Q307 34 331 57Q363 90 379 153T396 246Q396 261 393 272T384 290T371 301T355 308T341 311T326 312H316H307Q287 312 282 313T276 320Q276 323 279 337T283 352Q284 356 290 357T325 358Q364 359 368 360Q386 365 400 372T433 397T464 448T485 527Q487 535 487 556Q487 629 414 629Q350 629 298 580T245 476Q245 450 263 450H264Q280 450 294 463T308 496Q308 508 302 518T296 531",
          52: "448 34Q453 34 463 22T473 5Q473 -2 457 -7Q417 -22 383 -23H366L350 -91Q348 -98 345 -111T340 -130T335 -146T330 -161T325 -172T318 -182T310 -188T299 -193T286 -194Q256 -194 253 -165Q253 -159 271 -83T292 -5Q231 29 169 29Q114 29 91 14Q72 -2 65 1Q46 20 46 28Q46 35 55 43T77 60T96 74Q306 257 396 623Q410 666 444 666Q459 666 468 657T478 634Q478 627 470 595T440 504T387 381T303 239T187 99L164 75H178Q217 75 260 59L304 43Q304 48 325 127Q342 195 346 207T358 228Q372 242 391 242Q403 242 413 235T423 214Q423 205 402 116T378 25Q378 23 387 23Q405 23 418 25T439 31T448 34",
          53: "196 304Q189 309 189 314Q189 317 231 487T275 660Q278 666 283 666Q287 666 302 658T346 643T413 635Q447 635 481 642T537 658T559 666Q561 666 564 663T567 658Q565 637 557 629Q528 600 474 573T359 545Q342 545 327 546T304 550T294 552L291 540Q288 529 283 507T273 465L251 379Q307 420 364 420Q415 420 456 382T497 261Q497 165 429 82T262 -20Q256 -20 247 -21T233 -22Q176 -22 141 15T106 112Q106 208 173 208Q192 208 203 197T214 169Q214 143 195 125T156 107H153V100Q155 73 174 47T239 21Q245 21 259 23Q355 46 392 200Q393 205 394 207Q412 276 412 312Q412 352 396 367T358 383Q288 383 233 314Q226 306 224 305T209 304H196",
          54: "377 434Q425 434 457 404T499 341T509 278Q509 243 496 194T456 105T383 27Q322 -22 256 -22Q142 -22 122 114Q120 130 120 159Q120 221 135 292T195 452T310 599Q390 665 465 665Q565 665 565 583V574Q565 543 546 524Q528 506 504 506Q491 506 478 514T465 543Q465 585 515 602Q505 626 466 626Q419 626 372 587Q334 557 305 503T266 409L255 370Q287 410 339 429Q361 434 377 434ZM424 333Q424 359 411 378T365 397Q318 397 282 356T230 257T205 157T197 94Q197 67 211 45T260 22Q313 22 341 57T386 151Q424 283 424 333",
          55: "466 519Q448 519 435 528T416 550T400 571T376 581Q324 581 271 540T186 437Q185 435 183 432T181 428T179 426T177 424T174 423T171 422T165 422H159Q141 422 141 423Q136 423 136 431Q136 433 190 548T247 665Q249 666 266 666H282Q288 660 288 657Q288 655 284 646T276 628L273 620Q337 666 390 666Q413 666 425 652T438 620T444 584T457 559Q460 557 470 557Q497 557 524 582T571 635T594 665Q595 666 612 666H628Q634 660 634 657Q634 653 618 629T572 556T510 441T437 269T367 43Q356 -22 304 -22Q291 -22 278 -14T263 14Q263 36 281 95T354 269T486 507Q497 524 495 524Q482 519 466 519",
          56: "209 449Q209 545 278 605T416 666Q482 666 517 631T553 546Q553 513 539 482T504 430T463 394T426 370L410 360L430 343Q471 309 483 278T495 211Q495 141 441 75Q363 -21 253 -21Q182 -21 141 18T99 117Q99 161 119 201T170 268T222 308T259 331L272 338L259 349Q212 389 209 449ZM492 542Q492 586 469 605T415 625Q360 625 320 587T279 505Q279 495 281 487T286 474T295 460T306 449T321 436T337 422Q379 386 380 386Q389 386 420 412T472 471Q492 513 492 542ZM163 118Q163 76 189 49T258 21Q316 21 368 64T420 170Q420 193 412 208T395 233T350 271L302 312Q298 312 284 303T249 276T209 235T177 181T163 118",
          57: "297 211Q258 211 230 228T189 273T169 323T163 367Q163 411 183 472T254 585Q327 656 401 665Q403 665 412 665T427 666Q458 664 481 652T518 622T539 580T550 535T553 491Q553 448 544 395T515 277T454 148T358 37Q282 -22 213 -22Q166 -22 137 -1T107 55V64Q107 88 114 104T134 127T154 136T169 138Q185 138 196 128T207 101Q207 82 196 68T172 48L161 43Q161 40 167 36T187 26T219 21Q286 21 344 99Q364 126 382 169T408 241T417 275L412 269Q406 263 395 253T370 234T337 218T297 211ZM476 552Q476 626 417 626Q368 626 330 584Q312 563 300 533T270 433Q248 341 248 312Q248 286 262 267T310 248Q353 248 387 287T440 380T467 480T476 552",
          58: "184 358Q184 385 206 408T258 431Q279 431 293 418T308 383Q308 354 284 332T233 310Q212 310 198 324T184 358ZM107 50Q107 76 129 98T181 121Q203 121 217 108T231 72Q231 47 210 24T156 0Q135 0 121 13T107 50",
          59: "184 358Q184 385 206 408T258 431Q279 431 293 418T308 383Q308 354 284 332T233 310Q212 310 198 324T184 358ZM107 47Q107 77 130 99T180 121Q226 121 226 61Q226 25 214 -14T182 -84T144 -140T109 -180T88 -194T77 -185T70 -172Q70 -169 84 -155T121 -112T161 -48Q180 -10 180 3Q180 4 174 2Q172 2 166 1T156 0Q135 0 121 13T107 47",
          61: "776 357T776 347T761 327H470Q180 327 176 329Q164 334 164 347Q164 359 176 365Q179 367 470 367H761Q776 357 776 347ZM116 143T116 153T131 173H422Q713 173 717 171Q728 166 728 153T717 135Q713 133 422 133H131Q116 143 116 153",
          63: "235 431Q217 431 206 442T195 468Q195 490 215 537T280 638T380 707Q403 716 423 716Q425 716 429 716T436 715Q485 715 518 681T551 590Q551 543 530 503T482 439Q471 428 400 375T318 310Q300 287 300 259Q300 236 315 236Q333 236 352 251T384 300Q386 306 407 306H423Q429 300 429 297Q429 272 393 235T308 198Q287 198 269 215T251 270Q251 330 293 374L374 436Q377 438 401 456T432 480T457 503T481 531T494 561T501 598Q501 614 499 626Q482 678 430 678H426Q392 678 362 660T311 615T280 571T264 540L259 528Q259 527 266 526T283 516T294 492Q294 466 276 449T235 431ZM209 51Q212 83 235 102T281 121Q309 121 321 105T333 72Q333 45 311 23T258 0Q240 0 225 11T209 51",
          64: "198 250Q198 155 248 91T394 26Q514 26 640 80L650 84H675H683Q709 84 709 76Q709 73 708 71Q706 64 660 45T534 8T383 -11T260 24T181 115Q152 168 152 248Q152 410 268 552Q303 590 324 608Q439 705 551 705Q611 705 658 683T733 623T775 543T789 454Q789 380 766 304T720 192Q677 125 617 125Q591 125 573 137T548 160T541 176Q541 178 540 178L534 173Q527 168 515 160T488 144T454 131T417 125Q361 125 320 166T279 284Q279 393 356 481T523 569Q570 569 603 537Q623 515 632 490L637 480L657 479Q684 479 684 470Q684 465 650 333L617 199V185Q616 162 628 162Q677 162 712 278Q743 381 743 442Q743 555 687 611T553 668Q467 668 385 608T250 450T198 250ZM598 445Q598 453 594 470T569 510T518 532Q463 532 410 448T356 271Q356 220 374 191T423 162Q482 162 552 255L575 348Q598 440 598 445",
          91: "205 -221Q205 -239 194 -250H137H106Q73 -250 73 -242Q73 -232 194 255T321 747L324 750H381H417Q435 750 440 748T446 739Q446 730 443 723T437 712L434 710H350L349 706Q349 704 235 249T120 -208Q120 -210 159 -210Q166 -210 175 -210T187 -209Q205 -209 205 -221",
          93: "227 721Q227 739 238 750H295H326Q359 750 359 742Q359 732 238 245T111 -247L108 -250H51H15Q-3 -250 -8 -248T-14 -239Q-14 -230 -11 -223T-5 -212L-2 -210H82L83 -206Q83 -204 197 251T312 708Q312 710 273 710Q266 710 257 710T245 709Q227 709 227 721",
          94: "528 555Q528 549 514 538T496 527Q491 527 470 554Q458 569 449 580L414 625L353 578Q339 567 323 555T298 536L290 529Q286 527 285 527Q279 527 273 533T264 546L260 553Q260 559 263 562Q265 564 342 628T421 693T425 694Q430 694 433 691Q528 563 528 555",
          95: "98 -62Q91 -58 91 -51Q91 -31 100 -26Q102 -25 324 -25H442H500Q536 -25 545 -27T554 -36Q554 -50 548 -56Q546 -60 538 -61Q520 -62 319 -62H98",
          126: "266 208Q262 208 255 215T247 228Q247 233 250 236T274 259Q335 318 369 318Q394 318 420 292T464 265Q485 265 516 291T550 318Q554 318 562 311T571 297Q570 293 551 273T502 231T451 209H447Q421 209 396 235T355 261Q334 261 301 235T266 208",
          305: "75 287Q75 292 82 313T103 362T142 413T196 441H214Q248 441 270 419T293 357Q292 338 289 330T245 208Q193 72 193 46Q193 26 209 26Q228 26 247 43Q273 71 292 136Q295 148 297 150T311 153H317Q327 153 330 153T337 150T340 143Q340 133 330 105T292 41T228 -8Q220 -10 204 -10Q160 -10 141 15T122 71Q122 98 171 227T221 384Q221 396 218 400T203 405Q175 403 156 374T128 312T116 279Q115 278 97 278H81Q75 284 75 287",
          567: "75 284T75 287T81 305T101 343T133 389T180 426T240 442Q273 440 300 420T327 350V332L278 134Q267 92 253 37T233 -45T225 -73Q208 -123 162 -163T54 -204Q8 -204 -15 -181Q-32 -164 -32 -140Q-32 -112 -14 -96T27 -79Q48 -79 57 -91T67 -114Q67 -146 39 -166L44 -167H59H60Q112 -167 145 -74Q148 -65 198 134T251 347Q252 353 252 370Q252 382 251 388T245 399T230 405Q204 405 175 378Q157 360 145 337T126 298T117 280T98 278H81Q75 284 75 287",
          768: "-222 651Q-222 668 -206 682T-174 697Q-155 697 -145 680Q-140 671 -107 599T-74 526Q-74 522 -88 511T-107 500Q-109 500 -113 502T-167 568T-219 637Q-222 643 -222 651",
          769: "-148 500Q-154 500 -163 511T-173 528Q-173 529 -172 530V532Q-170 534 -97 610T-21 688Q-8 697 4 697Q19 697 29 688T39 663T30 638Q26 631 -50 573L-135 507Q-144 500 -148 500",
          770: "17 555Q17 549 3 538T-15 527Q-20 527 -41 554Q-53 569 -62 580L-97 625L-158 578Q-172 567 -188 555T-212 536L-221 529Q-225 527 -226 527Q-232 527 -238 533T-248 546L-251 553Q-251 559 -248 562Q-246 564 -169 628T-90 693T-86 694Q-81 694 -78 691Q17 563 17 555",
          771: "-245 558Q-249 558 -256 565T-264 578Q-264 583 -261 586T-237 609Q-176 668 -142 668Q-117 668 -91 642T-47 615Q-26 615 5 641T39 668Q43 668 51 661T60 647Q59 643 40 623T-9 581T-60 559H-64Q-90 559 -115 585T-156 611Q-177 611 -210 585T-245 558",
          772: "-275 544Q-282 548 -282 554Q-282 561 -279 573T-271 588Q-269 589 -111 589H-27H12Q38 589 46 587T54 578Q54 574 51 563T47 550Q45 546 32 545Q15 544 -118 544H-275",
          774: "-237 641Q-237 694 -218 694H-213Q-195 694 -195 684Q-195 683 -195 679T-197 667T-198 650Q-198 611 -176 589T-117 566Q-74 566 -34 597T23 678Q27 689 30 691T43 694Q62 694 62 684Q62 671 49 645T14 589T-46 537T-123 515Q-175 515 -206 550T-237 641",
          775: "-165 599Q-162 631 -139 650T-93 669Q-65 669 -53 653T-41 620Q-41 593 -63 571T-116 548Q-134 548 -149 559T-165 599",
          776: "-251 601Q-251 626 -230 647T-180 669Q-139 669 -133 625Q-133 595 -155 575T-203 554Q-223 554 -237 567T-251 601ZM-72 599Q-72 632 -48 650T-2 669Q18 669 31 657T45 623Q45 592 22 573T-25 554Q-68 554 -72 599",
          778: "-199 610Q-199 654 -161 685T-79 716Q-39 716 -16 693Q3 674 3 647Q3 607 -34 575T-118 542Q-199 542 -199 610ZM-41 631T-41 655T-83 679H-89Q-129 679 -142 656Q-146 650 -151 632T-156 604Q-156 578 -113 578H-108Q-94 578 -86 579T-69 586T-52 605Q-41 631 -41 655",
          779: "-217 503Q-221 503 -234 510T-248 523Q-248 528 -205 602Q-200 610 -192 623T-180 644T-170 661T-159 676T-151 686T-142 694T-134 696Q-132 697 -121 697Q-88 694 -88 664Q-88 652 -97 640T-152 574Q-214 504 -217 503ZM-64 503Q-68 503 -81 510T-95 523Q-95 528 -52 602Q-47 610 -39 623T-27 644T-17 661T-6 676T2 686T11 694T19 696Q21 697 32 697Q65 694 65 664Q65 652 56 640T1 574Q-61 504 -64 503",
          780: "11 637Q16 637 22 624T29 607Q29 606 27 602Q26 600 -47 552T-125 502H-127Q-133 502 -184 553Q-236 602 -236 608Q-236 612 -224 625T-206 638L-202 637L-196 632Q-190 628 -179 620T-158 603L-116 570Q-109 572 -52 604T11 637",
          989: "477 261Q477 257 473 256T455 253T417 251T348 250H235L155 -77L146 -82Q137 -85 109 -85Q55 -85 55 -77L139 261Q224 596 226 598Q229 603 239 603Q240 603 254 603T290 603T341 604T405 605T477 605Q656 603 687 602T719 596Q719 589 692 588T513 585H319L282 427L242 272Q242 270 351 270Q388 270 410 270T444 269T460 267T469 265T477 261",
          8211: "98 248Q91 252 91 259Q91 279 100 284Q102 285 324 285H442H500Q536 285 545 283T554 274Q554 260 548 254Q546 250 538 249Q520 248 319 248H98",
          8212: "124 248Q117 252 117 259Q117 279 126 284Q128 285 579 285T1033 284Q1037 280 1037 278Q1038 276 1038 274Q1038 253 1029 250Q1026 248 575 248H124",
          8213: "124 248Q117 252 117 259Q117 279 126 284Q128 285 579 285T1033 284Q1037 280 1037 278Q1038 276 1038 274Q1038 253 1029 250Q1026 248 575 248H124",
          8215: "98 -62Q91 -58 91 -51Q91 -31 100 -26Q102 -25 324 -25H442H500Q536 -25 545 -27T554 -36Q554 -50 548 -56Q546 -60 538 -61Q520 -62 319 -62H98",
          8216: "249 379Q228 379 213 396T197 448Q197 533 271 627L278 635Q286 643 295 652T314 671T332 687T344 694Q349 694 355 685T362 671Q362 668 345 654T301 608T256 537Q238 493 240 491Q241 491 245 493T258 498T275 500Q296 500 311 488T326 454Q326 426 304 403T249 379",
          8217: "250 620Q250 647 272 670T325 694Q348 694 362 677T377 633V624Q377 566 343 506T275 412T231 379Q226 379 220 388T213 401T232 421T279 472T323 547Q335 573 335 582L331 580Q327 578 318 576T300 573Q277 573 264 585T250 620",
          8220: "295 379Q274 379 259 396T243 448Q243 533 317 627Q326 638 354 666T391 694Q395 694 402 686T409 673Q409 668 392 654T348 608T302 537Q284 493 286 491Q287 491 291 493T304 498T321 500Q342 500 357 488T372 454Q372 426 350 403T295 379ZM492 379Q471 379 456 396T440 448Q440 533 514 627Q523 638 551 666T588 694Q592 694 599 685T606 672T589 654T544 608T499 537Q481 493 483 491Q484 491 488 493T501 498T518 500Q539 500 554 488T569 454Q569 426 547 403T492 379",
          8221: "214 620Q214 647 236 670T289 694Q312 694 326 677T341 633V624Q341 588 327 550T294 482T253 428T216 392T196 379Q191 379 184 388T176 401Q176 404 195 421T243 472T287 547Q299 576 299 582L295 580Q291 578 282 576T264 573Q241 573 228 585T214 620ZM411 620Q411 647 433 670T486 694Q509 694 523 677T538 633V624Q538 588 524 550T491 482T450 428T413 392T393 379Q388 379 381 388T373 401Q373 404 392 421T440 472T484 547Q496 576 496 582L492 580Q488 578 479 576T461 573Q438 573 425 585T411 620",
          8260: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
          8463: "150 475Q147 475 118 466T82 457Q73 457 64 467T54 487Q54 490 55 492Q63 506 64 506Q67 512 118 526Q162 541 169 546Q173 559 175 575Q181 596 181 604Q181 613 166 617Q164 617 153 618T135 619Q119 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 291 628L278 577L386 612Q466 635 476 635T492 627T499 607Q499 593 489 586Q485 583 373 546L262 512Q262 511 248 455T233 397T236 397T244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26Q42 45 98 257L151 475H150",
          8710: "574 715L582 716Q589 716 595 716Q612 716 616 714Q621 712 621 709Q622 707 705 359T788 8Q786 5 785 3L781 0H416Q52 0 50 2T48 6Q48 9 305 358T567 711Q572 712 574 715ZM599 346L538 602L442 474Q347 345 252 217T157 87T409 86T661 88L654 120Q646 151 629 220T599 346",
          10744: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215"
        }, {});
      },
      8594: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.largeop = void 0;
        var n = r(768),
          o = r(1376);
        e.largeop = (0, n.AddPaths)(o.largeop, {
          40: "180 96T180 250T205 541T266 770T353 944T444 1069T527 1150H555Q561 1144 561 1141Q561 1137 545 1120T504 1072T447 995T386 878T330 721T288 513T272 251Q272 133 280 56Q293 -87 326 -209T399 -405T475 -531T536 -609T561 -640Q561 -643 555 -649H527Q483 -612 443 -568T353 -443T266 -270T205 -41",
          41: "35 1138Q35 1150 51 1150H56H69Q113 1113 153 1069T243 944T330 771T391 541T416 250T391 -40T330 -270T243 -443T152 -568T69 -649H56Q43 -649 39 -647T35 -637Q65 -607 110 -548Q283 -316 316 56Q324 133 324 251Q324 368 316 445Q278 877 48 1123Q36 1137 35 1138",
          47: "78 -649Q56 -646 56 -625Q56 -614 382 261T712 1140Q716 1150 732 1150Q754 1147 754 1126Q754 1116 428 240T98 -639Q94 -649 78 -649",
          91: "224 -649V1150H455V1099H275V-598H455V-649H224",
          92: "754 -625Q754 -649 731 -649Q715 -649 712 -639Q709 -635 383 242T55 1124Q54 1135 61 1142T80 1150Q92 1150 98 1140Q101 1137 427 262T754 -625",
          93: "16 1099V1150H247V-649H16V-598H196V1099H16",
          123: "547 -643L541 -649H528Q515 -649 503 -645Q324 -582 293 -466Q289 -449 289 -428T287 -200L286 42L284 53Q274 98 248 135T196 190T146 222L121 235Q119 239 119 250Q119 262 121 266T133 273Q262 336 284 449L286 460L287 701Q287 737 287 794Q288 949 292 963Q293 966 293 967Q325 1080 508 1148Q516 1150 527 1150H541L547 1144V1130Q547 1117 546 1115T536 1109Q480 1086 437 1046T381 950L379 940L378 699Q378 657 378 594Q377 452 374 438Q373 437 373 436Q350 348 243 282Q192 257 186 254L176 251L188 245Q211 236 234 223T287 189T340 135T373 65Q373 64 374 63Q377 49 378 -93Q378 -156 378 -198L379 -438L381 -449Q393 -504 436 -544T536 -608Q544 -611 545 -613T547 -629V-643",
          125: "119 1130Q119 1144 121 1147T135 1150H139Q151 1150 182 1138T252 1105T326 1046T373 964Q378 942 378 702Q378 469 379 462Q386 394 439 339Q482 296 535 272Q544 268 545 266T547 251Q547 241 547 238T542 231T531 227T510 217T477 194Q390 129 379 39Q378 32 378 -201Q378 -441 373 -463Q342 -580 165 -644Q152 -649 139 -649Q125 -649 122 -646T119 -629Q119 -622 119 -619T121 -614T124 -610T132 -607T143 -602Q195 -579 235 -539T285 -447Q286 -435 287 -199T289 51Q294 74 300 91T329 138T390 197Q412 213 436 226T475 244L489 250L472 258Q455 265 430 279T377 313T327 366T293 434Q289 451 289 472T287 699Q286 941 285 948Q279 978 262 1005T227 1048T184 1080T151 1100T129 1109L127 1110Q119 1113 119 1130",
          710: "1004 603Q1004 600 999 583T991 565L960 574Q929 582 866 599T745 631L500 698Q497 698 254 631Q197 616 134 599T39 574L8 565Q5 565 0 582T-5 603L26 614Q58 624 124 646T248 687L499 772Q999 604 1004 603",
          732: "296 691Q258 691 216 683T140 663T79 639T34 619T16 611Q13 619 8 628L0 644L36 662Q206 749 321 749Q410 749 517 710T703 670Q741 670 783 678T859 698T920 722T965 742T983 750Q986 742 991 733L999 717L963 699Q787 611 664 611Q594 611 484 651T296 691",
          770: "4 603Q4 600 -1 583T-9 565L-40 574Q-71 582 -134 599T-255 631L-500 698Q-503 698 -746 631Q-803 616 -866 599T-961 574L-992 565Q-995 565 -1000 582T-1005 603L-974 614Q-942 624 -876 646T-752 687L-501 772Q-1 604 4 603",
          771: "-704 691Q-742 691 -784 683T-860 663T-921 639T-966 619T-984 611Q-987 619 -992 628L-1000 644L-964 662Q-794 749 -679 749Q-590 749 -483 710T-297 670Q-259 670 -217 678T-141 698T-80 722T-35 742T-17 750Q-14 742 -9 733L-1 717L-37 699Q-213 611 -336 611Q-405 611 -515 651T-704 691",
          8214: "257 0V602H300V0H257ZM478 0V602H521V0H478",
          8260: "78 -649Q56 -646 56 -625Q56 -614 382 261T712 1140Q716 1150 732 1150Q754 1147 754 1126Q754 1116 428 240T98 -639Q94 -649 78 -649",
          8593: "112 421L120 424Q127 427 136 430T161 441T191 458T224 481T260 510T295 546T328 591L333 600L340 589Q380 527 431 489T555 421V377L543 381Q445 418 368 492L355 504V0H312V504L299 492Q222 418 124 381L112 377V421",
          8595: "312 96V600H355V96L368 108Q445 182 543 219L555 223V179L546 176Q538 173 529 169T505 158T475 141T442 119T407 90T372 53T339 9L334 0L327 11Q287 73 236 111T112 179V223L124 219Q222 182 299 108L312 96",
          8657: "142 329Q300 419 389 599Q389 598 399 579T420 541T452 494T497 438T558 383T636 329T708 294L721 289V246Q718 246 694 256T623 293T532 356L522 364L521 182V0H478V405L466 417Q436 450 389 516Q388 515 378 500T352 463T312 417L300 405V0H257V364L247 356Q202 320 155 293T82 256L57 246V289L70 294Q101 305 142 329",
          8659: "257 236V600H300V195L312 183Q342 150 389 84Q390 85 400 100T426 137T466 183L478 195V600H521V418L522 236L532 244Q576 280 623 307T696 344L721 354V311L708 306Q677 295 636 271Q478 181 389 1Q389 2 379 21T358 59T326 106T281 162T220 217T142 271T70 306L57 311V354Q60 354 83 345T154 308T247 244L257 236",
          8719: "220 812Q220 813 218 819T214 829T208 840T199 853T185 866T166 878T140 887T107 893T66 896H56V950H1221V896H1211Q1080 896 1058 812V-311Q1076 -396 1211 -396H1221V-450H725V-396H735Q864 -396 888 -314Q889 -312 889 -311V896H388V292L389 -311Q405 -396 542 -396H552V-450H56V-396H66Q195 -396 219 -314Q220 -312 220 -311V812",
          8720: "220 812Q220 813 218 819T214 829T208 840T199 853T185 866T166 878T140 887T107 893T66 896H56V950H552V896H542Q411 896 389 812L388 208V-396H889V812Q889 813 887 819T883 829T877 840T868 853T854 866T835 878T809 887T776 893T735 896H725V950H1221V896H1211Q1080 896 1058 812V-311Q1076 -396 1211 -396H1221V-450H56V-396H66Q195 -396 219 -314Q220 -312 220 -311V812",
          8721: "60 948Q63 950 665 950H1267L1325 815Q1384 677 1388 669H1348L1341 683Q1320 724 1285 761Q1235 809 1174 838T1033 881T882 898T699 902H574H543H251L259 891Q722 258 724 252Q725 250 724 246Q721 243 460 -56L196 -356Q196 -357 407 -357Q459 -357 548 -357T676 -358Q812 -358 896 -353T1063 -332T1204 -283T1307 -196Q1328 -170 1348 -124H1388Q1388 -125 1381 -145T1356 -210T1325 -294L1267 -449L666 -450Q64 -450 61 -448Q55 -446 55 -439Q55 -437 57 -433L590 177Q590 178 557 222T452 366T322 544L56 909L55 924Q55 945 60 948",
          8730: "1001 1150Q1017 1150 1020 1132Q1020 1127 741 244L460 -643Q453 -650 436 -650H424Q423 -647 423 -645T421 -640T419 -631T415 -617T408 -594T399 -560T385 -512T367 -448T343 -364T312 -259L203 119L138 41L111 67L212 188L264 248L472 -474L983 1140Q988 1150 1001 1150",
          8739: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
          8741: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612ZM368 612Q373 627 388 627Q404 627 409 612Q410 610 410 306T409 0Q406 -15 389 -15Q371 -15 368 0V10Q368 19 368 35T368 73T368 122T367 179T367 241T367 306T367 370T367 433T367 489T368 538T368 576T368 602V612",
          8747: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798",
          8748: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM642 -798Q660 -824 693 -824H695Q723 -824 751 -764T803 -600T848 -391T890 -164Q893 -143 895 -133Q967 292 1051 655T1173 1127Q1179 1145 1183 1157T1200 1201T1227 1257T1261 1306T1305 1346T1356 1360Q1412 1360 1440 1325T1472 1245Q1472 1220 1460 1205T1437 1186T1415 1183Q1394 1183 1377 1198T1360 1239Q1360 1287 1413 1296L1410 1300Q1407 1303 1402 1307T1394 1313Q1379 1323 1361 1323Q1347 1323 1335 1311T1303 1255T1264 1139T1217 936T1161 628Q1102 293 1038 -5T938 -437T883 -629Q806 -862 693 -862Q653 -862 620 -831T583 -746Q583 -711 602 -698T640 -685Q661 -685 678 -700T695 -741Q695 -789 642 -798",
          8749: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM642 -798Q660 -824 693 -824H695Q723 -824 751 -764T803 -600T848 -391T890 -164Q893 -143 895 -133Q967 292 1051 655T1173 1127Q1179 1145 1183 1157T1200 1201T1227 1257T1261 1306T1305 1346T1356 1360Q1412 1360 1440 1325T1472 1245Q1472 1220 1460 1205T1437 1186T1415 1183Q1394 1183 1377 1198T1360 1239Q1360 1287 1413 1296L1410 1300Q1407 1303 1402 1307T1394 1313Q1379 1323 1361 1323Q1347 1323 1335 1311T1303 1255T1264 1139T1217 936T1161 628Q1102 293 1038 -5T938 -437T883 -629Q806 -862 693 -862Q653 -862 620 -831T583 -746Q583 -711 602 -698T640 -685Q661 -685 678 -700T695 -741Q695 -789 642 -798ZM1150 -798Q1168 -824 1201 -824H1203Q1231 -824 1259 -764T1311 -600T1356 -391T1398 -164Q1401 -143 1403 -133Q1475 292 1559 655T1681 1127Q1687 1145 1691 1157T1708 1201T1735 1257T1769 1306T1813 1346T1864 1360Q1920 1360 1948 1325T1980 1245Q1980 1220 1968 1205T1945 1186T1923 1183Q1902 1183 1885 1198T1868 1239Q1868 1287 1921 1296L1918 1300Q1915 1303 1910 1307T1902 1313Q1887 1323 1869 1323Q1855 1323 1843 1311T1811 1255T1772 1139T1725 936T1669 628Q1610 293 1546 -5T1446 -437T1391 -629Q1314 -862 1201 -862Q1161 -862 1128 -831T1091 -746Q1091 -711 1110 -698T1148 -685Q1169 -685 1186 -700T1203 -741Q1203 -789 1150 -798",
          8750: "114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q382 -52 390 2Q314 40 276 99Q230 167 230 249Q230 363 305 436T484 519H494L503 563Q587 939 632 1087T727 1298Q774 1360 828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q766 1323 688 929Q662 811 610 496Q770 416 770 249Q770 147 701 68T516 -21H506L497 -65Q407 -464 357 -623T237 -837Q203 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798ZM480 478Q460 478 435 470T380 444T327 401T287 335T271 249Q271 124 375 56L397 43L431 223L485 478H480ZM519 20Q545 20 578 33T647 72T706 144T730 249Q730 383 603 455Q603 454 597 421T582 343T569 276Q516 22 515 20H519",
          8896: "1055 -401Q1055 -419 1042 -434T1007 -450Q977 -450 963 -423Q959 -417 757 167L555 750L353 167Q151 -417 147 -423Q134 -450 104 -450Q84 -450 70 -436T55 -401Q55 -394 56 -390Q59 -381 284 270T512 925Q525 950 555 950Q583 950 597 926Q599 923 825 270T1054 -391Q1055 -394 1055 -401",
          8897: "55 900Q55 919 69 934T103 950Q134 950 147 924Q152 913 353 333L555 -250L757 333Q958 913 963 924Q978 950 1007 950Q1028 950 1041 935T1055 901Q1055 894 1054 891Q1052 884 826 231T597 -426Q583 -450 556 -450Q527 -450 512 -424Q510 -421 285 229T56 890Q55 893 55 900",
          8898: "57 516Q68 602 104 675T190 797T301 882T423 933T542 949Q594 949 606 948Q780 928 901 815T1048 545Q1053 516 1053 475T1055 49Q1055 -406 1054 -410Q1051 -427 1037 -438T1006 -450T976 -439T958 -411Q957 -407 957 37Q957 484 956 494Q945 643 831 747T554 852Q481 852 411 826Q301 786 232 696T154 494Q153 484 153 37Q153 -407 152 -411Q148 -428 135 -439T104 -450T73 -439T56 -410Q55 -406 55 49Q56 505 57 516",
          8899: "56 911Q58 926 71 938T103 950Q120 950 134 939T152 911Q153 907 153 463Q153 16 154 6Q165 -143 279 -247T556 -352Q716 -352 830 -248T956 6Q957 16 957 463Q957 907 958 911Q962 928 975 939T1006 950T1037 939T1054 911Q1055 906 1055 451Q1054 -5 1053 -16Q1029 -207 889 -328T555 -449Q363 -449 226 -331T62 -45Q57 -16 57 25T55 451Q55 906 56 911",
          8968: "224 -649V1150H511V1099H275V-649H224",
          8969: "16 1099V1150H303V-649H252V1099H16",
          8970: "224 -649V1150H275V-598H511V-649H224",
          8971: "252 -598V1150H303V-649H16V-598H252",
          9001: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
          9002: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649",
          9168: "312 0V602H355V0H312",
          10072: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
          10216: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
          10217: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649",
          10752: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM755 -352Q922 -352 1061 -269T1278 -48T1356 250Q1356 479 1202 652T809 850Q798 851 747 851Q634 851 527 806T337 682T204 491T154 251Q154 128 201 17T329 -176T521 -304T755 -352ZM665 250Q665 290 692 315T758 341Q792 339 818 315T845 250Q845 211 819 186T755 160Q716 160 691 186T665 250",
          10753: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM706 299V850H704Q519 832 386 725T198 476Q181 433 169 379T156 300Q156 299 431 299H706ZM1116 732Q1054 778 982 807T871 842T810 849L804 850V299H1079Q1354 299 1354 300Q1354 311 1352 329T1336 402T1299 506T1228 620T1116 732ZM706 -350V201H431Q156 201 156 200Q156 189 158 171T174 98T211 -6T282 -120T395 -232Q428 -257 464 -277T527 -308T587 -328T636 -339T678 -346T706 -350ZM1354 200Q1354 201 1079 201H804V-350Q808 -349 838 -345T887 -338T940 -323T1010 -295Q1038 -282 1067 -265T1144 -208T1229 -121T1301 0T1349 158Q1354 188 1354 200",
          10754: "668 944Q697 949 744 949Q803 949 814 948Q916 937 1006 902T1154 826T1262 730T1336 638T1380 563Q1454 415 1454 250Q1454 113 1402 -14T1258 -238T1036 -391T755 -449Q608 -449 477 -392T255 -240T110 -16T56 250Q56 387 105 510T239 723T434 871T668 944ZM1143 709Q1138 714 1129 722T1086 752T1017 791T925 826T809 850Q798 851 747 851H728Q659 851 571 823T408 741Q367 713 367 709L755 320L1143 709ZM297 639Q296 639 282 622T247 570T205 491T169 382T154 250T168 118T204 9T247 -70T282 -122L297 -139L685 250L297 639ZM1213 -139Q1214 -139 1228 -122T1263 -70T1305 9T1341 118T1356 250T1342 382T1306 491T1263 570T1228 622L1213 639L825 250L1213 -139ZM367 -209Q373 -215 384 -224T434 -258T514 -302T622 -336T755 -352T887 -338T996 -302T1075 -259T1126 -224L1143 -209L755 180Q754 180 561 -14T367 -209",
          10756: "56 911Q58 926 71 938T103 950Q120 950 134 939T152 911Q153 907 153 463Q153 16 154 6Q165 -143 279 -247T556 -352Q716 -352 830 -248T956 6Q957 16 957 463Q957 907 958 911Q962 928 975 939T1006 950T1037 939T1054 911Q1055 906 1055 451Q1054 -5 1053 -16Q1029 -207 889 -328T555 -449Q363 -449 226 -331T62 -45Q57 -16 57 25T55 451Q55 906 56 911ZM507 554Q511 570 523 581T554 593Q571 593 585 582T603 554Q604 551 604 443V338H709Q817 338 820 337Q835 334 847 321T859 290Q859 254 819 241Q816 240 709 240H604V134Q604 48 604 34T598 11Q583 -15 555 -15Q526 -15 512 11Q507 20 507 34T506 134V240H401H344Q292 240 278 246Q251 259 251 290Q251 309 264 321T290 337Q293 338 401 338H506V443Q506 551 507 554",
          10758: "56 911Q60 927 72 938T103 950Q120 950 134 939T152 911Q153 907 153 277V-352H957V277Q957 907 958 911Q962 928 975 939T1006 950T1036 939T1054 911V891Q1054 871 1054 836T1054 754T1054 647T1055 525T1055 390T1055 250T1055 111T1055 -24T1055 -147T1054 -253T1054 -335T1054 -391V-411Q1047 -442 1016 -449Q1011 -450 552 -450L94 -449Q63 -439 56 -411V-391Q56 -371 56 -336T56 -254T56 -147T55 -25T55 110T55 250T55 389T55 524T55 647T56 753T56 835T56 891V911",
          12296: "112 244V258L473 1130Q482 1150 498 1150Q511 1150 517 1142T523 1125V1118L344 685Q304 587 257 473T187 305L165 251L344 -184L523 -616V-623Q524 -634 517 -641T499 -649Q484 -649 473 -629L112 244",
          12297: "112 -649Q103 -649 95 -642T87 -623V-616L266 -184L445 251Q445 252 356 466T178 898T86 1123Q85 1134 93 1142T110 1150Q126 1150 133 1137Q134 1136 317 695L498 258V244L317 -194Q134 -635 133 -636Q126 -649 112 -649"
        }, {
          10764: "\u222C\u222C"
        });
      },
      4749: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.monospace = void 0;
        var n = r(768),
          o = r(1439);
        e.monospace = (0, n.AddPaths)(o.monospace, {
          32: "",
          33: "206 565Q206 590 222 606T265 622Q287 621 303 606T319 565T314 392L308 216Q299 194 273 194H262Q247 194 241 195T228 200T217 216L211 392Q206 539 206 565ZM206 56Q206 83 223 99T265 115Q288 113 304 99T320 58Q320 33 303 17T262 0Q237 0 222 17T206 56",
          34: "122 575Q122 593 137 608T173 623Q196 623 210 608T225 575Q225 562 218 464Q212 373 211 361T201 341Q193 333 173 333Q154 333 146 341Q138 348 137 360T129 464Q122 561 122 575ZM299 575Q299 593 314 608T350 623Q373 623 387 608T402 575Q402 562 395 464Q389 373 388 361T378 341Q370 333 350 333Q331 333 323 341Q315 348 314 360T306 464Q299 561 299 575",
          35: "93 163Q74 163 65 164T46 173T36 198Q36 210 40 215T61 233H131V236Q132 239 140 307T149 377Q149 379 105 379L61 380Q36 392 36 414Q36 450 86 450Q91 450 99 450T112 449H159Q163 480 167 517Q168 524 170 545T174 573T180 591T191 607T210 611Q223 611 232 604T243 588L245 580Q245 565 238 511T230 451Q230 449 282 449H333Q337 480 341 517Q342 524 343 537T345 556T348 573T352 589T359 600T370 608T384 611Q395 611 406 602T419 580Q419 565 412 511T404 451Q404 449 431 449H442Q477 449 485 429Q489 421 489 414Q489 392 463 380L428 379H394V376Q393 373 385 305T376 235Q376 233 419 233H463L468 230Q472 227 473 227T477 223T482 218T486 213T488 206T489 198Q489 162 436 162Q430 162 422 162T412 163H366V161Q364 159 357 92Q356 85 355 73T353 54T350 37T346 22T339 11T328 3T314 0Q303 0 292 9T279 31Q279 37 287 96T295 162Q295 163 244 163H192V161Q190 159 183 92Q182 85 181 73T179 54T176 37T172 22T165 11T154 3T140 0Q129 0 118 9T105 31Q105 37 113 96T121 162Q121 163 93 163ZM323 377Q323 379 272 379H220V376Q219 373 211 305T202 235Q202 233 253 233H305V236Q306 239 314 307T323 377",
          36: "415 397Q392 397 377 411T362 448Q362 464 376 485Q369 498 362 506T346 520T332 528T315 533T300 538V445L301 353L311 350Q382 334 424 284T466 174Q466 115 425 65T303 -2L300 -3V-30Q300 -64 291 -74Q283 -82 262 -82H255Q234 -82 225 -60L224 -32V-4L213 -2Q152 6 106 51T59 170V180Q59 197 74 213Q89 227 110 227T146 213T162 174Q162 156 147 137Q153 123 161 112T176 95T191 85T205 79T216 76T224 74V283L213 285Q147 298 103 343T58 449Q58 516 108 560T224 614V643V654Q224 666 226 673T237 687T264 694Q289 693 294 683T300 642V615H303Q355 607 390 587T440 540T460 493T466 453Q466 425 451 411T415 397ZM137 452Q137 425 158 404T198 376T223 369Q224 369 224 453T223 537Q198 532 168 509T137 452ZM301 75Q307 75 325 83T365 116T387 171Q387 238 300 267V171Q300 75 301 75",
          37: "35 560Q35 607 54 645T110 693Q111 693 116 693T125 694Q165 692 187 651T210 560Q210 506 186 467T123 428Q84 428 60 466T35 560ZM139 560Q139 574 136 587T130 608T124 615Q122 617 120 614Q106 595 106 561Q106 516 121 506Q123 504 125 507Q139 526 139 560ZM123 -83Q107 -83 98 -73T88 -48Q88 -43 89 -41Q90 -37 229 316T370 675Q381 694 400 694Q416 694 426 684T436 659Q436 654 435 652Q434 647 295 294T153 -65Q144 -83 123 -83ZM314 50Q314 104 338 143T400 183Q439 183 464 144T489 50T465 -43T402 -82Q358 -82 336 -41T314 50ZM417 50Q417 71 413 85T405 102L401 106Q386 95 386 50Q386 29 390 15T398 -2L402 -6Q417 5 417 50",
          38: "96 462Q96 546 132 584T211 622Q255 622 284 583T314 474Q314 395 224 305L208 288Q213 275 226 251L265 185L269 179Q273 184 299 246L332 333L342 363Q342 364 341 365Q334 365 334 393Q334 406 334 410T340 420T356 431H412H440Q467 431 478 424T490 393Q490 376 484 367T470 357T448 355H441H415L399 312Q349 176 322 127L315 115L323 106Q360 65 393 65Q405 65 410 80T416 109Q416 140 452 140Q487 140 487 105Q487 56 460 23T391 -11L286 41L273 53L262 42Q212 -11 151 -11Q97 -11 63 33T28 143Q28 161 30 176T38 205T47 227T60 247T72 261T84 274T94 283L122 311L119 323Q96 392 96 462ZM243 474Q243 533 218 545L215 546Q212 546 210 546Q182 546 169 501Q167 492 167 466Q167 419 179 368L188 377Q234 425 242 461Q243 465 243 474ZM217 129Q185 174 154 235Q121 214 115 176Q113 168 113 143Q113 83 139 67Q141 66 152 66Q191 66 228 112L217 129",
          39: "205 554Q205 577 221 594T263 611Q302 611 325 577T349 490Q349 409 298 347Q285 330 258 309T214 287Q203 289 189 302T175 327Q175 341 185 349T213 369T245 402Q269 437 273 483V497Q264 496 263 496Q240 496 223 513T205 554",
          40: "437 -53Q437 -82 399 -82H394Q377 -82 342 -55Q259 7 213 102T166 306Q166 412 211 507T342 667Q377 694 393 694H399Q437 694 437 665Q437 654 426 643T397 620T356 584T311 525Q301 511 290 488T264 412T250 306Q250 191 300 105T422 -27Q437 -37 437 -53",
          41: "87 664Q87 694 126 694Q138 694 147 690T183 667Q266 605 312 510T358 306Q358 193 307 93T161 -70Q142 -82 126 -82Q105 -82 96 -73T87 -53Q87 -47 88 -44Q92 -36 116 -19T173 34T230 119Q273 206 273 306Q273 408 231 494T109 635Q87 649 87 664",
          42: "222 487Q224 501 235 510T262 520Q279 520 289 510T302 487Q302 458 301 429Q301 421 301 413T301 398T300 386T300 377V374Q300 373 301 373Q304 373 353 403T416 434Q432 434 444 423T456 393Q456 389 456 386T454 379T451 373T448 368T442 363T436 358T427 353T417 348T405 342T391 334Q345 309 339 305L388 279Q400 273 412 266T432 255T441 250Q456 238 456 218Q456 200 445 189T417 177Q403 177 354 207T301 238Q300 238 300 237V234Q300 231 300 226T300 214T301 199T301 182Q302 153 302 124Q300 109 289 100T262 90T235 100T222 124Q222 153 223 182Q223 190 223 198T223 213T224 225T224 234V237Q224 238 223 238Q220 238 171 208T108 177Q92 177 80 188T68 218Q68 237 79 246T134 277Q180 303 185 306L136 332Q124 338 112 345T92 356T83 361Q68 373 68 393Q68 411 79 422T107 434Q121 434 170 404T223 373Q224 373 224 374V377Q224 380 224 385T224 397T223 412T223 429Q222 458 222 487",
          43: "147 271Q138 271 122 271T98 270Q68 270 53 277T38 306T53 335T98 342Q105 342 121 342T147 341H227V423L228 505Q241 531 262 531Q268 531 273 530T282 525T287 519T293 511L297 505V341H377H430Q457 341 467 338T483 321Q487 313 487 306Q487 295 480 286T463 273Q457 271 377 271H297V107Q281 81 262 81Q250 81 242 87T230 100L228 107L227 189V271H147",
          44: "193 37T193 70T213 121T260 140Q302 140 327 108T353 36Q353 -7 336 -43T294 -98T249 -128T215 -139Q204 -139 189 -125Q177 -111 174 -101Q172 -84 183 -77T217 -61T253 -33Q261 -24 272 1L265 0Q234 0 214 18",
          45: "57 306Q57 333 86 341H438Q468 332 468 306T438 271H86Q57 280 57 306",
          46: "193 70Q193 105 214 122T258 140Q291 140 311 120T332 70Q332 44 314 23T262 1Q234 1 214 18T193 70",
          47: "94 -83Q78 -83 68 -73T58 -48Q58 -44 60 -36Q62 -31 227 314T399 673Q410 694 431 694Q445 694 455 684T466 659Q466 656 464 648Q463 643 298 298T125 -62Q114 -83 94 -83",
          58: "193 361Q193 396 214 413T258 431Q291 431 311 411T332 361Q332 335 314 314T262 292Q234 292 214 309T193 361ZM193 70Q193 105 214 122T258 140Q291 140 311 120T332 70Q332 44 314 23T262 1Q234 1 214 18T193 70",
          59: "193 361Q193 396 214 413T258 431Q291 431 311 411T332 361Q332 335 314 314T262 292Q234 292 214 309T193 361ZM193 70Q193 105 214 122T259 140Q301 140 319 108T337 33Q337 -38 291 -88T214 -139Q203 -139 189 -126T175 -97Q175 -85 182 -78T200 -66T225 -50T249 -17Q256 -3 256 0Q252 1 248 1Q242 2 235 5T218 15T200 36T193 70",
          60: "468 90Q468 76 458 66T433 55Q426 55 419 58Q413 61 243 168T68 280Q57 291 57 306T68 332Q72 335 241 442T416 553Q424 557 432 557Q447 557 457 547T468 522T456 496Q454 494 305 399L158 306L305 213Q341 190 390 159Q443 125 452 119T464 106V105Q468 97 468 90",
          61: "38 382Q38 409 67 417H457Q487 408 487 382Q487 358 461 348H64Q51 352 45 360T38 376V382ZM67 195Q38 204 38 230Q38 255 62 264Q66 265 264 265H461L464 264Q467 262 469 261T475 256T481 249T485 240T487 230Q487 204 457 195H67",
          62: "57 522Q57 539 67 548T90 557Q98 557 105 554Q111 551 281 444T456 332Q468 320 468 306T456 280Q452 276 282 169T105 58Q98 55 91 55Q79 55 68 63T57 90Q57 105 68 116Q70 118 219 213L366 306L219 399Q75 491 71 494Q57 507 57 522",
          63: "62 493Q62 540 107 578T253 617Q366 617 414 578T462 490Q462 459 445 434T411 400L394 390Q315 347 296 287Q294 278 293 247V217Q285 201 278 198T246 194T216 197T201 215V245V253Q201 379 351 456Q366 464 375 477Q377 482 377 490Q377 517 339 528T251 540Q182 540 159 517Q166 503 166 490Q166 468 151 453T114 438Q96 438 79 451T62 493ZM190 58Q190 85 208 100T249 115Q272 113 288 99T304 58Q304 33 287 17T246 0T206 16T190 58",
          64: "44 306Q44 445 125 531T302 617Q332 617 358 607T411 574T456 502T479 387Q481 361 481 321Q481 203 421 143Q381 103 332 103Q266 103 225 165T183 307Q183 390 227 449T332 508Q358 508 378 498Q350 541 304 541Q229 541 172 473T115 305Q115 208 171 140T306 71H310Q358 71 397 105Q409 115 436 115Q458 115 462 113Q481 106 481 86Q481 73 468 61Q401 -6 305 -6Q262 -6 217 14T133 71T69 170T44 306ZM410 306Q410 361 386 396T333 431Q300 431 277 394T254 305Q254 256 276 218T332 180Q364 180 387 217T410 306",
          91: "237 -82Q221 -78 214 -58V305Q214 669 216 673Q220 687 231 690T278 694H350H461Q462 693 467 690T474 685T478 679T482 670T483 656Q483 632 471 625T428 617Q422 617 406 617T379 618H298V-7H379H420Q459 -7 471 -13T483 -45Q483 -55 483 -59T477 -70T461 -82H237",
          92: "58 659Q58 673 68 683T93 694Q114 694 125 673Q132 659 297 314T464 -36Q466 -44 466 -48Q466 -66 454 -74T431 -83Q410 -83 399 -62Q391 -47 226 298T60 648Q58 656 58 659",
          93: "41 656Q41 681 53 688T99 695Q107 695 133 695T177 694H288Q307 681 310 669V-58Q303 -76 288 -82H64Q41 -73 41 -45Q41 -21 53 -14T96 -6Q102 -6 118 -6T145 -7H226V618H145H100Q67 618 54 625T41 656",
          94: "138 460Q121 460 109 479T96 512Q96 527 106 534Q109 536 178 571T253 609Q256 611 264 611Q272 610 343 574Q357 567 369 561T389 550T402 543T411 538T416 535T420 532T422 529T425 525Q428 518 428 512Q428 498 416 479T386 460H384Q377 460 316 496L262 526L208 496Q147 460 138 460",
          95: "57 -60Q57 -33 86 -25H438Q468 -34 468 -60T438 -95H86Q57 -86 57 -60",
          96: "176 479Q176 563 227 622T310 681Q324 680 337 667T350 641Q350 627 340 619T312 599T280 566Q256 531 252 485V471Q261 472 262 472Q285 472 302 455T320 414Q320 389 303 373T261 357Q223 357 200 391T176 479",
          123: "430 -7H436Q449 -7 456 -8T469 -19T475 -45Q475 -69 466 -76T434 -83H419Q386 -82 363 -80T308 -69T253 -41T223 7L221 17L220 118V220L218 224Q215 229 214 230T210 235T204 241T195 246T184 252T170 257T151 262T127 265Q118 267 100 267T69 270T52 283Q50 288 50 306V314Q50 335 67 341Q68 342 102 343T172 355T217 386L220 392V493L221 595Q225 611 230 621T251 650T304 679T395 693L406 694Q418 694 426 694Q458 694 466 685Q475 676 475 656T466 627Q458 618 430 618Q319 618 305 587L304 486Q304 476 304 458T305 431Q305 385 295 358T251 311L243 306Q243 305 254 298T281 274T302 231Q304 223 304 125L305 25Q309 16 316 10T352 -1T430 -7",
          124: "228 668Q241 694 262 694Q268 694 273 693T282 688T287 682T293 674L297 668V-57Q282 -82 262 -82Q239 -82 228 -57V668",
          125: "49 655Q49 674 56 682T73 692T106 694Q141 693 167 690T224 677T275 647T303 595L305 392Q313 367 347 356T417 344T457 341Q475 335 475 306Q475 292 473 285T464 273T451 269T430 267Q352 262 327 246Q311 236 305 220L303 17L301 7Q294 -16 277 -33T242 -60T196 -74T150 -80T106 -83Q78 -83 72 -82T58 -74Q49 -65 49 -44Q49 -24 58 -16Q66 -7 94 -7Q143 -7 171 -1T207 10T220 25V125Q220 223 222 231Q228 257 243 274T270 299L281 306Q234 329 222 381Q220 387 220 486V587Q212 597 207 601T173 612T94 618Q66 618 58 627Q49 635 49 655",
          126: "125 467Q113 467 100 480T87 509Q88 520 111 543Q172 602 209 609Q219 611 224 611Q246 611 263 596T290 566T304 551Q319 551 367 594Q383 610 396 610H400Q411 610 424 597T437 568Q436 557 413 534Q348 469 305 466Q278 466 260 481T234 511T220 526Q205 526 157 483Q141 467 129 467H125",
          127: "104 565Q104 590 120 600T155 611Q175 611 180 610Q217 599 217 565Q217 545 202 532T166 519H159H155Q120 519 107 547Q104 553 104 565ZM307 565Q307 580 317 593T346 610Q348 610 350 610T354 611Q355 612 367 612Q395 611 408 597T421 565T409 534T365 519H358Q336 519 322 532T307 565",
          160: "",
          305: "411 76Q441 76 451 69T462 38Q462 29 462 26T460 18T453 9T440 1H94Q72 8 72 33V38Q72 46 72 49T74 58T81 68T94 76H233V355H167L102 356Q80 363 80 393Q80 418 91 425T138 432Q145 432 165 432T200 431H295Q297 429 303 425T310 420T314 415T317 404T317 389T318 363Q318 354 318 314T317 241V76H378H411",
          567: "75 -91T100 -91T138 -107T152 -144V-150L160 -151H193H203Q241 -151 267 -121Q284 -97 288 -73T292 23V151V355H218L145 356Q123 365 123 387V393Q123 422 145 430H148Q151 430 156 430T169 430T185 430T205 431T227 431T251 431H354Q356 430 360 427T365 424T369 420T372 416T373 410T375 402T376 391T377 376T377 356Q377 345 377 286T376 176Q376 -67 371 -88Q362 -123 342 -151T299 -194Q254 -228 180 -228Q84 -226 56 -177Q49 -162 48 -148Q48 -122 61 -107",
          697: "211 572Q211 593 226 608T262 623Q281 623 297 610T313 573Q313 561 307 465Q301 370 299 357T284 336Q279 334 262 334Q240 334 231 343Q226 350 225 362T217 465Q211 549 211 572",
          768: "-409 569Q-409 586 -399 596T-377 610Q-376 610 -372 610T-365 611Q-355 610 -284 588T-210 563Q-195 556 -195 537Q-195 533 -197 522T-208 498T-229 485Q-238 485 -312 508T-388 533Q-400 538 -405 552Q-409 559 -409 569",
          769: "-297 485Q-315 485 -323 505T-331 537Q-331 556 -316 563Q-307 569 -170 610Q-169 610 -165 610T-157 611Q-141 609 -131 600T-119 584T-117 569Q-117 555 -124 545T-138 533Q-140 531 -214 508T-297 485",
          770: "-387 460Q-404 460 -416 479T-429 512Q-429 527 -419 534Q-416 536 -347 571T-272 609Q-269 611 -261 611Q-254 610 -182 574Q-168 567 -156 561T-136 550T-123 543T-114 538T-109 535T-105 532T-103 529T-100 525Q-97 518 -97 512Q-97 498 -109 479T-139 460H-141Q-148 460 -209 496L-263 526L-317 496Q-378 460 -387 460",
          771: "-400 467Q-412 467 -425 480T-438 509Q-437 520 -414 543Q-353 602 -316 609Q-306 611 -301 611Q-279 611 -262 596T-235 566T-221 551Q-206 551 -158 594Q-142 610 -129 610H-125Q-114 610 -101 597T-88 568Q-89 557 -112 534Q-177 469 -220 466Q-247 466 -265 481T-291 511T-305 526Q-320 526 -368 483Q-384 467 -396 467H-400",
          772: "-429 500Q-440 504 -445 511T-450 522T-452 536Q-452 552 -451 556Q-445 571 -434 574T-379 578Q-369 578 -330 578T-261 577H-96Q-94 575 -90 573T-85 569T-81 564T-77 558T-75 550T-74 538Q-74 522 -78 515T-96 500H-429",
          774: "-446 579Q-446 611 -412 611H-407Q-383 609 -378 599T-358 587Q-340 583 -263 583H-235Q-159 583 -152 593Q-145 611 -120 611H-117H-115Q-79 611 -79 577Q-80 552 -95 536T-140 514T-191 506T-251 504H-263H-274Q-311 504 -334 505T-386 513T-431 536T-446 579",
          776: "-421 565Q-421 590 -405 600T-370 611Q-350 611 -345 610Q-308 599 -308 565Q-308 545 -323 532T-359 519H-366H-370Q-405 519 -418 547Q-421 553 -421 565ZM-218 565Q-218 580 -208 593T-179 610Q-177 610 -175 610T-171 611Q-170 612 -158 612Q-130 611 -117 597T-104 565T-116 534T-160 519H-167Q-189 519 -203 532T-218 565",
          778: "-344 558Q-344 583 -321 601T-262 619Q-225 619 -204 600T-182 560Q-182 536 -205 518T-264 499Q-301 499 -322 519T-344 558ZM-223 559Q-223 570 -234 579T-261 588T-289 580T-303 559Q-303 549 -293 540T-263 530T-234 539T-223 559",
          780: "-427 525Q-427 542 -417 559T-392 577Q-385 577 -323 553L-263 530L-203 553Q-143 576 -136 576Q-118 576 -109 559T-99 525Q-99 508 -107 502T-161 481Q-177 475 -186 472Q-256 449 -263 449Q-272 449 -339 472T-412 498Q-420 501 -423 508T-427 520V525",
          913: "191 76Q212 75 220 68T229 38Q229 10 208 1H129H80Q48 1 38 7T28 38Q28 51 29 57T40 69T70 76Q89 76 89 78Q90 79 117 205T173 461T205 599Q212 623 250 623H262H273Q312 623 319 599Q322 591 350 461T406 205T435 78Q435 76 454 76H458Q484 76 493 59Q496 53 496 38Q496 11 478 3Q474 1 395 1H317Q295 8 295 38Q295 65 311 73Q316 75 333 76L348 77V78Q348 80 341 112L334 143H190L183 112Q176 80 176 78Q175 76 178 76Q180 76 191 76ZM318 221Q313 238 288 366T263 519Q263 526 262 527Q261 527 261 520Q261 493 236 365T206 221Q206 219 262 219T318 221",
          914: "39 1Q17 10 17 32V38V46Q17 65 34 73Q40 76 61 76H84V535H61H54Q27 535 19 553Q17 557 17 573Q17 583 17 587T23 599T39 610Q40 611 179 611Q320 610 332 607Q332 607 339 605Q394 591 427 547T461 454Q461 413 436 378T369 325L358 320Q405 311 443 270T482 169Q482 112 445 64T345 3L334 1H39ZM309 533Q302 535 234 535H168V356H230Q284 357 296 358T323 368Q346 380 361 402T377 452Q377 482 358 505T309 533ZM398 176Q396 218 371 246T315 279Q310 280 237 280H168V76H239Q316 77 327 81Q329 82 334 84Q398 107 398 176",
          915: "466 611Q468 609 473 606T479 602T483 598T486 593T487 586T488 576T488 562V526V488Q488 452 470 444Q466 442 446 442Q421 442 413 450Q406 457 405 463T404 501V535H185V76H222H239Q260 76 270 69T281 38Q281 12 270 6T209 0H155H104Q48 0 37 5T25 38Q25 59 35 69Q44 76 76 76H101V535H76H64Q36 535 27 552Q25 557 25 573T27 594Q33 606 43 608T106 611H258H466",
          916: "232 622H237Q242 622 249 622T264 623H293Q295 622 300 619T308 613T314 608T319 601Q322 597 405 316T489 19Q489 9 473 1Q471 0 262 0T51 1Q35 9 35 19Q35 34 118 315T205 601Q214 616 232 622ZM267 501Q266 504 265 510T263 521T261 526V523Q261 508 211 332Q142 91 138 82H386Q385 84 345 224Q281 439 267 501",
          917: "374 271Q374 241 367 232T332 223Q307 223 299 231Q290 240 290 263V279H173V76H418V118V144Q418 167 426 176T460 186Q491 186 500 166Q502 161 502 93V52Q502 25 499 17T480 1H41Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q44 535 38 537T25 548T19 573Q19 602 41 610H47Q53 610 63 610T88 610T121 610T160 611T204 611T251 611H458Q460 609 465 606T471 602T475 598T478 593T479 586T480 576T480 562V526V488Q480 452 462 444Q458 442 438 442Q413 442 405 450Q398 457 397 463T396 501V535H173V355H290V371Q290 394 299 403T332 412Q363 412 372 392Q374 387 374 317V271",
          918: "71 1Q60 5 55 11T49 23T48 39V46Q48 56 58 73T131 183Q171 242 197 282L366 535H144V501Q144 470 143 464T135 450Q127 442 102 442H94Q71 442 62 461Q60 466 60 527L61 589Q70 607 83 610H88Q93 610 102 610T124 610T154 610T188 611T227 611T270 611H454Q456 609 461 606T467 601T471 597T474 591T475 584T476 572V565Q476 555 466 538T393 428Q353 369 327 329L158 76H397V120V146Q397 169 405 179T439 189Q470 189 479 169Q481 164 481 95V48Q481 24 478 16T459 1H71",
          919: "16 571Q16 597 27 604T74 611H125H208Q223 602 226 596T230 573Q230 559 227 551T217 540T204 536T186 535H165V356H359V535H338H333Q306 535 297 552Q295 556 295 573Q295 586 295 590T301 600T317 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V280H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571",
          920: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM262 66Q285 66 300 67T329 74T351 86T366 108T376 138T381 181T383 235T384 306Q384 452 371 492T304 544Q296 545 251 545Q230 545 215 543T188 534T169 520T155 497T147 466T143 423T141 371T140 306Q140 247 141 215T146 151T158 107T179 82T212 69T262 66ZM179 356Q187 378 219 378H223Q240 377 249 372T260 360L261 355Q261 353 262 353T263 355Q263 362 272 369Q280 377 304 377H310Q325 377 331 374T346 356V256Q338 241 331 238T309 234H304Q280 234 272 242Q263 249 263 256Q263 258 262 258T261 256Q261 249 252 242Q244 234 220 234H216Q186 234 179 256V356",
          921: "400 76Q431 76 441 69T452 38Q452 29 452 26T450 18T443 9T430 1H95Q84 6 79 12T73 23T72 38Q72 65 90 73Q96 76 157 76H220V535H157H124Q93 535 83 542T72 573Q72 603 93 610Q97 611 264 611H430Q432 609 436 607T444 602T449 594Q452 588 452 573Q452 546 434 538Q428 535 367 535H304V76H367H400",
          922: "18 549T18 573T29 604T70 611H118H193Q207 603 210 596T214 573Q214 549 198 538Q191 535 172 535H152V421Q152 344 152 326T153 309L242 422L329 534Q327 535 322 536T314 538T308 542T303 548T300 558T298 573Q298 600 316 608Q322 611 392 611H463Q477 602 481 595T485 573Q485 535 446 535H441H420L281 357L436 77L454 76Q473 75 478 73Q495 62 495 38Q495 10 473 1H345Q334 5 329 11T324 21T323 38Q323 51 324 56T332 68T355 77L233 296L152 192V76H172Q191 76 198 73Q214 63 214 38Q214 9 193 1H41Q18 8 18 38Q18 61 35 73Q42 76 61 76H81V535H61Q42 535 35 538Q18 549 18 573",
          923: "30 38Q30 57 38 66T70 76Q88 76 88 78Q89 79 117 207T173 466T205 602Q213 617 231 622H236Q241 622 249 622T264 623H294Q315 609 319 602Q321 598 350 468T407 208T435 78Q436 76 454 76Q470 76 478 73Q495 62 495 38Q495 10 473 1H313Q290 10 290 38Q290 56 297 65T310 74T331 76Q350 76 350 78Q349 80 328 176T285 383T263 520Q263 526 262 527Q261 527 261 521Q261 497 240 388T198 181T174 78Q174 76 193 76Q220 75 227 65Q234 56 234 38Q234 28 234 24T228 13T212 1H52Q30 9 30 32V38",
          924: "50 535Q37 536 31 537T18 547T12 573Q12 598 22 604T62 611H91H121Q147 611 158 607T178 587Q183 579 222 446T261 293Q261 289 262 288Q263 288 263 292Q263 311 298 434T346 588Q353 603 365 607T402 611H435H450Q488 611 500 605T512 573Q512 556 506 547T493 537T474 535H459V76H474Q487 75 493 74T505 64T512 38Q512 11 494 3Q490 1 424 1H386Q355 1 345 7T335 38Q335 55 341 64T354 74T373 76H388V302Q388 512 387 519Q382 482 346 359T304 228Q292 204 262 204T220 228Q215 237 179 359T137 519Q136 512 136 302V76H151Q164 75 170 74T182 64T189 38Q189 11 171 3Q167 1 101 1H63Q32 1 22 7T12 38Q12 55 18 64T31 74T50 76H65V535H50",
          925: "20 571Q20 598 30 604T73 611H105H136Q152 611 160 611T177 607T189 601T198 587T206 568T217 537T231 497Q354 142 365 95L368 84V535H347H342Q314 535 306 552Q304 556 304 573Q304 586 304 590T310 600T326 611H482Q497 602 500 596T504 573Q504 559 501 551T491 540T478 536T460 535H439V25Q432 7 424 4T389 0H374Q334 0 322 31L293 115Q171 468 159 517L156 528V76H177H183Q195 76 202 75T215 64T221 38Q221 10 199 1H43Q32 5 27 11T22 21T21 38V44Q21 66 37 73Q44 76 64 76H85V535H64Q49 535 42 536T28 545T20 571",
          926: "37 555V569Q37 605 60 610H66Q71 610 81 610T105 610T137 610T175 611T217 611T264 611H465Q467 609 471 606T477 602T481 599T484 594T485 588T487 580T487 570T487 554Q487 526 486 520T478 506Q470 498 445 498T412 506Q403 515 403 531V539H121V531Q121 498 86 498H79H71Q48 498 39 517Q37 522 37 555ZM109 318V346Q109 366 113 374T132 389H170Q193 379 193 359V354H331V359Q331 379 354 389H392Q407 381 411 373T415 342V318V290Q415 270 411 262T392 247H354Q331 257 331 277V282H193V277Q193 257 170 247H132Q117 255 113 263T109 294V318ZM56 1Q41 7 37 15T33 42V58V80Q33 101 41 110T77 119Q87 118 91 118T103 114T114 103T117 83V72H407V83Q407 101 416 110T449 119T482 110Q489 103 490 97T491 59V41Q491 24 487 16T469 1H56",
          927: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM363 513Q357 523 347 530T324 540T302 544T280 546H268Q192 546 167 521Q150 501 145 452T140 300Q140 235 142 197T151 130T172 89T207 71T262 65Q317 65 341 81T374 144T384 300Q384 474 363 513",
          928: "60 535Q45 535 38 536T24 545T16 571Q16 603 36 609Q41 611 264 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V535H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60",
          929: "41 1Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q38 535 29 543T19 576Q19 603 41 610H49Q57 610 70 610T100 610T136 611T175 611Q190 611 216 611T255 612Q321 612 363 598T441 537Q480 486 480 427V421Q480 354 447 311T378 251Q339 230 275 230H239H173V76H197Q220 76 227 73Q244 62 244 38Q244 10 222 1H41ZM396 421Q396 461 369 491T300 533Q294 534 233 535H173V306H233Q294 307 300 308Q345 319 370 352T396 421",
          931: "40 575Q40 576 40 579T41 583T41 588T43 593T46 597T50 602T55 606T63 610H68Q74 610 84 610T108 610T139 610T176 611T219 611T264 611H462Q464 609 469 606T475 602T479 598T482 593T483 586T484 576T484 562V526V488Q484 452 466 444Q462 442 442 442Q417 442 409 450Q402 457 401 463T400 501V535H153Q153 533 218 430Q233 405 250 378T276 336T286 319Q290 311 290 307Q290 296 239 211Q229 194 223 184L161 78H400V112Q400 142 401 149T409 163Q418 172 442 172Q473 172 482 152Q484 147 484 86V49Q484 25 481 17T462 1H63Q41 10 41 31Q41 39 43 44Q43 45 81 109T157 238L195 303Q195 307 119 430T41 557T40 575",
          932: "129 38Q129 51 129 55T135 65T151 76H220V535H110V501Q110 470 109 464T101 450Q93 442 68 442H60Q37 442 28 461Q26 466 26 527L27 589Q36 607 49 610H55Q61 610 72 610T97 610T131 610T170 611T215 611T264 611H476Q478 609 483 606T489 602T493 598T496 593T497 586T498 576T498 562V526V488Q498 452 480 444Q476 442 456 442Q431 442 423 450Q416 457 415 463T414 501V535H304V76H374Q389 67 392 61T396 38Q396 10 374 1H151Q140 5 135 11T130 21T129 38",
          933: "38 494Q38 549 74 585T152 621Q168 621 179 619T209 606T241 566T262 492Q262 494 265 507T270 526T276 547T285 569T298 589T315 606T337 617T365 622Q416 622 451 584T486 494Q486 470 469 461Q464 459 445 459H437Q416 459 406 476Q404 479 403 502T393 541T365 558Q350 558 340 548T323 519T312 475T307 419T305 354T304 282Q304 254 304 239V76H358Q372 67 376 60T380 38Q380 10 358 1H167Q145 9 145 32V38Q145 54 148 60T167 76H220V239Q220 256 220 289T220 338T219 383T217 426T214 463T209 497T201 522T189 543T174 555Q168 558 159 558Q139 558 131 541T121 502T118 476Q108 459 84 459H79H71Q38 459 38 494",
          934: "139 573V578Q139 603 161 610H166Q172 610 182 610T204 610T232 611T264 611H364Q379 602 382 595T385 573Q385 544 364 536L334 535H304V441H306Q313 440 325 438T367 426T421 403T464 364T483 306Q483 251 430 216T317 172Q315 172 313 172T308 170H306H304V76H364Q379 67 382 60T385 38Q385 28 385 24T379 12T364 1H161Q139 8 139 33V38Q139 46 139 49T141 58T148 68T161 76H220V170H218Q211 171 199 173T157 185T103 208T60 248T41 306Q41 361 94 396T208 439Q210 439 212 439T216 440L218 441H220V535H190L161 536Q139 543 139 573ZM124 306Q124 286 147 271T194 252L218 247Q220 247 220 306V364H218Q212 364 192 359T148 340T124 306ZM400 305Q400 325 377 340T330 360L306 364Q304 364 304 306Q304 247 306 247Q312 247 332 252T376 271T400 305",
          935: "39 571Q39 597 49 604T93 611H141H218Q233 602 236 595T239 573Q239 538 210 535Q202 535 202 534T215 507T243 454L257 428L307 535H298Q266 538 266 573Q266 584 267 588T273 598T289 611H366H401Q442 611 454 605T466 573Q466 546 448 538Q442 535 421 535H398L299 327Q299 323 362 201L426 77L449 76Q467 76 475 75T489 65T495 38Q495 11 477 3Q473 1 395 1H317Q295 8 295 38Q295 73 325 76L334 77Q333 78 314 117T276 196L257 235L239 196Q221 157 204 118T186 77Q190 76 196 76Q211 74 218 67T227 55T228 38Q228 28 227 24T221 13T206 1H50Q28 9 28 32V38Q28 63 45 73Q51 76 73 76H96L214 324Q215 327 162 431L108 535H85H79Q67 535 60 536T46 546T39 571",
          936: "37 439Q38 451 40 457T52 469T77 475H79Q96 475 107 473T132 456T152 411Q152 409 153 396T154 372V365Q154 291 198 261Q215 251 219 251Q220 251 220 393V535H193L167 536Q145 545 145 567V573Q145 602 167 610Q168 611 264 611H358Q372 602 376 595T380 573Q380 545 358 536L331 535H304V393Q304 251 305 251Q307 251 310 252T323 259T339 272T355 295T367 331Q368 337 370 372Q370 382 371 395T372 411Q376 434 384 448T404 467T425 474T447 475Q461 474 467 473T480 463T487 437Q487 419 481 412Q476 403 459 398Q457 390 453 344T431 263Q415 228 383 205T332 177T306 172H304V76H358Q372 67 376 60T380 38Q380 10 358 1H167Q145 9 145 32V38Q145 54 148 60T167 76H220V172H218Q211 172 192 177T141 205T93 263Q74 298 71 343T67 391L66 398Q47 403 42 411T37 433V439",
          937: "40 404Q40 498 106 560T258 622Q357 622 420 558T484 406Q484 359 469 311T428 205T392 117Q382 84 382 78Q382 76 402 76H421V87Q421 110 431 116T457 123Q474 123 483 114Q490 107 491 100T492 61V42Q492 11 474 3Q470 1 397 1H324Q302 9 302 32V39Q302 104 351 225T400 405Q400 462 361 504T262 546Q200 546 162 504T124 405Q124 346 171 230T223 42V36Q223 11 205 3Q201 1 128 1H55Q39 7 33 23L32 60V80Q32 94 34 102T44 116T68 123Q103 123 103 87V76H123Q142 76 142 78Q142 100 117 156T66 282T40 404",
          8215: "57 -60Q57 -33 86 -25H438Q468 -34 468 -60T438 -95H86Q57 -86 57 -60",
          8242: "211 572Q211 593 226 608T262 623Q281 623 297 610T313 573Q313 561 307 465Q301 370 299 357T284 336Q279 334 262 334Q240 334 231 343Q226 350 225 362T217 465Q211 549 211 572",
          8260: "94 -83Q78 -83 68 -73T58 -48Q58 -44 60 -36Q62 -31 227 314T399 673Q410 694 431 694Q445 694 455 684T466 659Q466 656 464 648Q463 643 298 298T125 -62Q114 -83 94 -83",
          8710: "232 622H237Q242 622 249 622T264 623H293Q295 622 300 619T308 613T314 608T319 601Q322 597 405 316T489 19Q489 9 473 1Q471 0 262 0T51 1Q35 9 35 19Q35 34 118 315T205 601Q214 616 232 622ZM267 501Q266 504 265 510T263 521T261 526V523Q261 508 211 332Q142 91 138 82H386Q385 84 345 224Q281 439 267 501"
        }, {
          8243: "\u2032\u2032",
          8244: "\u2032\u2032\u2032",
          8279: "\u2032\u2032\u2032\u2032"
        });
      },
      9320: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.normal = void 0;
        var n = r(768),
          o = r(331);
        e.normal = (0, n.AddPaths)(o.normal, {
          32: "",
          33: "78 661Q78 682 96 699T138 716T180 700T199 661Q199 654 179 432T158 206Q156 198 139 198Q121 198 119 206Q118 209 98 431T78 661ZM79 61Q79 89 97 105T141 121Q164 119 181 104T198 61Q198 31 181 16T139 1Q114 1 97 16T79 61",
          34: "34 634Q34 659 50 676T93 694Q121 694 144 668T168 579Q168 525 146 476T101 403T73 379Q69 379 60 388T50 401Q50 404 62 417T88 448T116 500T131 572Q131 584 130 584T125 581T112 576T94 573Q69 573 52 590T34 634ZM238 634Q238 659 254 676T297 694Q325 694 348 668T372 579Q372 525 350 476T305 403T277 379Q273 379 264 388T254 401Q254 404 266 417T292 448T320 500T335 572Q335 584 334 584T329 581T316 576T298 573Q273 573 256 590T238 634",
          35: "56 347Q56 360 70 367H313L355 524Q394 676 401 686Q406 694 416 694Q434 694 436 676Q436 672 396 522Q355 374 355 369L354 367H543L585 524Q626 679 630 685Q636 694 646 694Q653 694 659 689T665 678Q665 668 626 522Q585 374 585 369L584 367H762Q777 359 777 347Q777 334 767 331T722 327H667H572L552 251L531 174Q531 173 647 173H720Q756 173 766 170T777 153T762 133H519L477 -24Q436 -179 432 -185Q426 -194 416 -194Q409 -194 403 -189T397 -177Q397 -167 436 -21Q477 125 477 131L478 133H289L247 -24Q206 -179 202 -185Q196 -194 186 -194Q179 -194 173 -189T167 -177Q167 -167 206 -21Q247 125 247 131L248 133H70Q56 140 56 153Q56 168 72 173H260L280 249L301 326Q301 327 186 327H72Q56 332 56 347ZM531 326Q531 327 437 327H342L322 251L301 174Q301 173 395 173H490L510 249L531 326",
          36: "162 187Q162 164 146 149T109 133H103V130Q108 115 115 105Q122 92 131 82T150 64T170 52T190 44T206 40T220 37L227 36V313Q190 320 162 335Q116 358 86 404T55 508Q55 567 85 614T165 685Q186 696 225 704H227V750H273V704L286 703Q369 690 413 631Q441 588 444 531Q444 514 443 509Q439 490 425 479T391 468Q368 468 353 483T337 522Q337 546 353 560T390 575L394 576V578Q386 599 372 614T342 637T314 649T288 656L273 658V408L288 405Q329 394 355 376Q396 348 420 300T444 199Q444 130 408 76T313 1Q286 -9 276 -9H273V-56H227V-10H221Q202 -6 193 -4T155 11T108 41T74 94T55 176V182Q55 227 95 238Q103 240 108 240Q129 240 145 226T162 187ZM225 657Q219 657 204 651T169 632T135 594T121 538Q121 512 131 491T156 457T187 435T213 423T227 420V539Q227 657 225 657ZM378 169Q378 230 339 265T274 301Q273 301 273 169V37Q324 50 351 87T378 169",
          37: "465 605Q428 605 394 614T340 632T319 641Q332 608 332 548Q332 458 293 403T202 347Q145 347 101 402T56 548Q56 637 101 693T202 750Q241 750 272 719Q359 642 464 642Q580 642 650 732Q662 748 668 749Q670 750 673 750Q682 750 688 743T693 726Q178 -47 170 -52Q166 -56 160 -56Q147 -56 142 -45Q137 -36 142 -27Q143 -24 363 304Q469 462 525 546T581 630Q528 605 465 605ZM207 385Q235 385 263 427T292 548Q292 617 267 664T200 712Q193 712 186 709T167 698T147 668T134 615Q132 595 132 548V527Q132 436 165 403Q183 385 203 385H207ZM500 146Q500 234 544 290T647 347Q699 347 737 292T776 146T737 0T646 -56Q590 -56 545 0T500 146ZM651 -18Q679 -18 707 24T736 146Q736 215 711 262T644 309Q637 309 630 306T611 295T591 265T578 212Q577 200 577 146V124Q577 -18 647 -18H651",
          38: "156 540Q156 620 201 668T302 716Q354 716 377 671T401 578Q401 505 287 386L274 373Q309 285 416 148L429 132L437 142Q474 191 543 309L562 341V349Q562 368 541 376T498 385H493V431H502L626 428Q709 428 721 431H727V385H712Q688 384 669 379T639 369T618 354T603 337T591 316T578 295Q537 223 506 176T464 117T454 104Q454 102 471 85T497 62Q543 24 585 24Q618 24 648 48T682 113V121H722V112Q721 94 714 75T692 32T646 -7T574 -22Q491 -19 414 42L402 51L391 42Q312 -22 224 -22Q144 -22 93 25T42 135Q42 153 46 169T55 197T74 225T96 249T125 278T156 308L195 347L190 360Q185 372 182 382T174 411T165 448T159 491T156 540ZM361 576Q361 613 348 646T305 679Q272 679 252 649T232 572Q232 497 255 426L259 411L267 420Q361 519 361 576ZM140 164Q140 103 167 64T240 24Q271 24 304 36T356 61T374 77Q295 156 235 262L220 292L210 310L193 293Q177 277 169 268T151 229T140 164",
          39: "78 634Q78 659 95 676T138 694Q166 694 189 668T212 579Q212 525 190 476T146 403T118 379Q114 379 105 388T95 401Q95 404 107 417T133 448T161 500T176 572Q176 584 175 584T170 581T157 576T139 573Q114 573 96 590T78 634",
          40: "94 250Q94 319 104 381T127 488T164 576T202 643T244 695T277 729T302 750H315H319Q333 750 333 741Q333 738 316 720T275 667T226 581T184 443T167 250T184 58T225 -81T274 -167T316 -220T333 -241Q333 -250 318 -250H315H302L274 -226Q180 -141 137 -14T94 250",
          41: "60 749L64 750Q69 750 74 750H86L114 726Q208 641 251 514T294 250Q294 182 284 119T261 12T224 -76T186 -143T145 -194T113 -227T90 -246Q87 -249 86 -250H74Q66 -250 63 -250T58 -247T55 -238Q56 -237 66 -225Q221 -64 221 250T66 725Q56 737 55 738Q55 746 60 749",
          42: "215 721Q216 732 225 741T248 750Q263 750 273 742T284 721L270 571L327 613Q383 654 388 657T399 660Q412 660 423 650T435 624T424 600T376 575Q363 569 355 566L289 534L355 504L424 470Q435 462 435 447Q435 431 424 420T399 409Q393 409 388 412T327 456L270 498L277 423L284 348Q280 320 250 320T215 348L229 498L172 456Q116 415 111 412T100 409Q87 409 76 420T64 447Q64 461 75 470L144 504L210 534L144 566Q136 570 122 576Q83 593 74 600T64 624Q64 639 75 649T100 660Q106 660 111 657T172 613L229 571Q229 578 222 643T215 721",
          43: "56 237T56 250T70 270H369V420L370 570Q380 583 389 583Q402 583 409 568V270H707Q722 262 722 250T707 230H409V-68Q401 -82 391 -82H389H387Q375 -82 369 -68V230H70Q56 237 56 250",
          44: "78 35T78 60T94 103T137 121Q165 121 187 96T210 8Q210 -27 201 -60T180 -117T154 -158T130 -185T117 -194Q113 -194 104 -185T95 -172Q95 -168 106 -156T131 -126T157 -76T173 -3V9L172 8Q170 7 167 6T161 3T152 1T140 0Q113 0 96 17",
          45: "11 179V252H277V179H11",
          46: "78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60",
          47: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
          48: "96 585Q152 666 249 666Q297 666 345 640T423 548Q460 465 460 320Q460 165 417 83Q397 41 362 16T301 -15T250 -22Q224 -22 198 -16T137 16T82 83Q39 165 39 320Q39 494 96 585ZM321 597Q291 629 250 629Q208 629 178 597Q153 571 145 525T137 333Q137 175 145 125T181 46Q209 16 250 16Q290 16 318 46Q347 76 354 130T362 333Q362 478 354 524T321 597",
          49: "213 578L200 573Q186 568 160 563T102 556H83V602H102Q149 604 189 617T245 641T273 663Q275 666 285 666Q294 666 302 660V361L303 61Q310 54 315 52T339 48T401 46H427V0H416Q395 3 257 3Q121 3 100 0H88V46H114Q136 46 152 46T177 47T193 50T201 52T207 57T213 61V578",
          50: "109 429Q82 429 66 447T50 491Q50 562 103 614T235 666Q326 666 387 610T449 465Q449 422 429 383T381 315T301 241Q265 210 201 149L142 93L218 92Q375 92 385 97Q392 99 409 186V189H449V186Q448 183 436 95T421 3V0H50V19V31Q50 38 56 46T86 81Q115 113 136 137Q145 147 170 174T204 211T233 244T261 278T284 308T305 340T320 369T333 401T340 431T343 464Q343 527 309 573T212 619Q179 619 154 602T119 569T109 550Q109 549 114 549Q132 549 151 535T170 489Q170 464 154 447T109 429",
          51: "127 463Q100 463 85 480T69 524Q69 579 117 622T233 665Q268 665 277 664Q351 652 390 611T430 522Q430 470 396 421T302 350L299 348Q299 347 308 345T337 336T375 315Q457 262 457 175Q457 96 395 37T238 -22Q158 -22 100 21T42 130Q42 158 60 175T105 193Q133 193 151 175T169 130Q169 119 166 110T159 94T148 82T136 74T126 70T118 67L114 66Q165 21 238 21Q293 21 321 74Q338 107 338 175V195Q338 290 274 322Q259 328 213 329L171 330L168 332Q166 335 166 348Q166 366 174 366Q202 366 232 371Q266 376 294 413T322 525V533Q322 590 287 612Q265 626 240 626Q208 626 181 615T143 592T132 580H135Q138 579 143 578T153 573T165 566T175 555T183 540T186 520Q186 498 172 481T127 463",
          52: "462 0Q444 3 333 3Q217 3 199 0H190V46H221Q241 46 248 46T265 48T279 53T286 61Q287 63 287 115V165H28V211L179 442Q332 674 334 675Q336 677 355 677H373L379 671V211H471V165H379V114Q379 73 379 66T385 54Q393 47 442 46H471V0H462ZM293 211V545L74 212L183 211H293",
          53: "164 157Q164 133 148 117T109 101H102Q148 22 224 22Q294 22 326 82Q345 115 345 210Q345 313 318 349Q292 382 260 382H254Q176 382 136 314Q132 307 129 306T114 304Q97 304 95 310Q93 314 93 485V614Q93 664 98 664Q100 666 102 666Q103 666 123 658T178 642T253 634Q324 634 389 662Q397 666 402 666Q410 666 410 648V635Q328 538 205 538Q174 538 149 544L139 546V374Q158 388 169 396T205 412T256 420Q337 420 393 355T449 201Q449 109 385 44T229 -22Q148 -22 99 32T50 154Q50 178 61 192T84 210T107 214Q132 214 148 197T164 157",
          54: "42 313Q42 476 123 571T303 666Q372 666 402 630T432 550Q432 525 418 510T379 495Q356 495 341 509T326 548Q326 592 373 601Q351 623 311 626Q240 626 194 566Q147 500 147 364L148 360Q153 366 156 373Q197 433 263 433H267Q313 433 348 414Q372 400 396 374T435 317Q456 268 456 210V192Q456 169 451 149Q440 90 387 34T253 -22Q225 -22 199 -14T143 16T92 75T56 172T42 313ZM257 397Q227 397 205 380T171 335T154 278T148 216Q148 133 160 97T198 39Q222 21 251 21Q302 21 329 59Q342 77 347 104T352 209Q352 289 347 316T329 361Q302 397 257 397",
          55: "55 458Q56 460 72 567L88 674Q88 676 108 676H128V672Q128 662 143 655T195 646T364 644H485V605L417 512Q408 500 387 472T360 435T339 403T319 367T305 330T292 284T284 230T278 162T275 80Q275 66 275 52T274 28V19Q270 2 255 -10T221 -22Q210 -22 200 -19T179 0T168 40Q168 198 265 368Q285 400 349 489L395 552H302Q128 552 119 546Q113 543 108 522T98 479L95 458V455H55V458",
          56: "70 417T70 494T124 618T248 666Q319 666 374 624T429 515Q429 485 418 459T392 417T361 389T335 371T324 363L338 354Q352 344 366 334T382 323Q457 264 457 174Q457 95 399 37T249 -22Q159 -22 101 29T43 155Q43 263 172 335L154 348Q133 361 127 368Q70 417 70 494ZM286 386L292 390Q298 394 301 396T311 403T323 413T334 425T345 438T355 454T364 471T369 491T371 513Q371 556 342 586T275 624Q268 625 242 625Q201 625 165 599T128 534Q128 511 141 492T167 463T217 431Q224 426 228 424L286 386ZM250 21Q308 21 350 55T392 137Q392 154 387 169T375 194T353 216T330 234T301 253T274 270Q260 279 244 289T218 306L210 311Q204 311 181 294T133 239T107 157Q107 98 150 60T250 21",
          57: "352 287Q304 211 232 211Q154 211 104 270T44 396Q42 412 42 436V444Q42 537 111 606Q171 666 243 666Q245 666 249 666T257 665H261Q273 665 286 663T323 651T370 619T413 560Q456 472 456 334Q456 194 396 97Q361 41 312 10T208 -22Q147 -22 108 7T68 93T121 149Q143 149 158 135T173 96Q173 78 164 65T148 49T135 44L131 43Q131 41 138 37T164 27T206 22H212Q272 22 313 86Q352 142 352 280V287ZM244 248Q292 248 321 297T351 430Q351 508 343 542Q341 552 337 562T323 588T293 615T246 625Q208 625 181 598Q160 576 154 546T147 441Q147 358 152 329T172 282Q197 248 244 248",
          58: "78 370Q78 394 95 412T138 430Q162 430 180 414T199 371Q199 346 182 328T139 310T96 327T78 370ZM78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60",
          59: "78 370Q78 394 95 412T138 430Q162 430 180 414T199 371Q199 346 182 328T139 310T96 327T78 370ZM78 60Q78 85 94 103T137 121Q202 121 202 8Q202 -44 183 -94T144 -169T118 -194Q115 -194 106 -186T95 -174Q94 -171 107 -155T137 -107T160 -38Q161 -32 162 -22T165 -4T165 4Q165 5 161 4T142 0Q110 0 94 18T78 60",
          60: "694 -11T694 -19T688 -33T678 -40Q671 -40 524 29T234 166L90 235Q83 240 83 250Q83 261 91 266Q664 540 678 540Q681 540 687 534T694 519T687 505Q686 504 417 376L151 250L417 124Q686 -4 687 -5Q694 -11 694 -19",
          61: "56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
          62: "84 520Q84 528 88 533T96 539L99 540Q106 540 253 471T544 334L687 265Q694 260 694 250T687 235Q685 233 395 96L107 -40H101Q83 -38 83 -20Q83 -19 83 -17Q82 -10 98 -1Q117 9 248 71Q326 108 378 132L626 250L378 368Q90 504 86 509Q84 513 84 520",
          63: "226 668Q190 668 162 656T124 632L114 621Q116 621 119 620T130 616T145 607T157 591T162 567Q162 544 147 529T109 514T71 528T55 566Q55 625 100 661T199 704Q201 704 210 704T224 705H228Q281 705 320 692T378 656T407 612T416 567Q416 503 361 462Q267 395 247 303Q242 279 242 241V224Q242 205 239 202T222 198T205 201T202 218V249Q204 320 220 371T255 445T292 491T315 537Q317 546 317 574V587Q317 604 315 615T304 640T277 661T226 668ZM162 61Q162 89 180 105T224 121Q247 119 264 104T281 61Q281 31 264 16T222 1Q197 1 180 16T162 61",
          64: "56 347Q56 429 86 498T164 612T270 680T386 705Q522 705 622 603T722 349Q722 126 608 126Q541 126 513 176Q512 177 512 179T510 182L509 183Q508 183 503 177T487 163T464 146T429 132T385 126Q311 126 251 186T190 347Q190 448 251 508T385 568Q426 568 460 548T509 511T531 479H555Q580 479 582 478Q586 477 587 468Q588 454 588 338V260Q588 200 593 182T619 163Q641 163 655 178T674 223T680 273T682 325V330Q682 426 647 500Q611 569 544 618T388 668Q271 668 184 577T96 347Q96 216 180 121T396 26Q421 26 446 28T493 34T535 43T573 52T605 63T629 72T647 80T657 84H716Q722 78 722 74Q722 65 675 45T547 7T392 -11Q255 -11 156 90T56 347ZM274 347Q274 266 308 214T390 162Q420 162 449 182T498 235L504 245V449L498 459Q453 532 387 532Q347 532 311 483T274 347",
          65: "255 0Q240 3 140 3Q48 3 39 0H32V46H47Q119 49 139 88Q140 91 192 245T295 553T348 708Q351 716 366 716H376Q396 715 400 709Q402 707 508 390L617 67Q624 54 636 51T687 46H717V0H708Q699 3 581 3Q458 3 437 0H427V46H440Q510 46 510 64Q510 66 486 138L462 209H229L209 150Q189 91 189 85Q189 72 209 59T259 46H264V0H255ZM447 255L345 557L244 256Q244 255 345 255H447",
          66: "131 622Q124 629 120 631T104 634T61 637H28V683H229H267H346Q423 683 459 678T531 651Q574 627 599 590T624 512Q624 461 583 419T476 360L466 357Q539 348 595 302T651 187Q651 119 600 67T469 3Q456 1 242 0H28V46H61Q103 47 112 49T131 61V622ZM511 513Q511 560 485 594T416 636Q415 636 403 636T371 636T333 637Q266 637 251 636T232 628Q229 624 229 499V374H312L396 375L406 377Q410 378 417 380T442 393T474 417T499 456T511 513ZM537 188Q537 239 509 282T430 336L329 337H229V200V116Q229 57 234 52Q240 47 334 47H383Q425 47 443 53Q486 67 511 104T537 188",
          67: "56 342Q56 428 89 500T174 615T283 681T391 705Q394 705 400 705T408 704Q499 704 569 636L582 624L612 663Q639 700 643 704Q644 704 647 704T653 705H657Q660 705 666 699V419L660 413H626Q620 419 619 430Q610 512 571 572T476 651Q457 658 426 658Q322 658 252 588Q173 509 173 342Q173 221 211 151Q232 111 263 84T328 45T384 29T428 24Q517 24 571 93T626 244Q626 251 632 257H660L666 251V236Q661 133 590 56T403 -21Q262 -21 159 83T56 342",
          68: "130 622Q123 629 119 631T103 634T60 637H27V683H228Q399 682 419 682T461 676Q504 667 546 641T626 573T685 470T708 336Q708 210 634 116T442 3Q429 1 228 0H27V46H60Q102 47 111 49T130 61V622ZM593 338Q593 439 571 501T493 602Q439 637 355 637H322H294Q238 637 234 628Q231 624 231 344Q231 62 232 59Q233 49 248 48T339 46H350Q456 46 515 95Q561 133 577 191T593 338",
          69: "128 619Q121 626 117 628T101 631T58 634H25V680H597V676Q599 670 611 560T625 444V440H585V444Q584 447 582 465Q578 500 570 526T553 571T528 601T498 619T457 629T411 633T353 634Q266 634 251 633T233 622Q233 622 233 621Q232 619 232 497V376H286Q359 378 377 385Q413 401 416 469Q416 471 416 473V493H456V213H416V233Q415 268 408 288T383 317T349 328T297 330Q290 330 286 330H232V196V114Q232 57 237 52Q243 47 289 47H340H391Q428 47 452 50T505 62T552 92T584 146Q594 172 599 200T607 247T612 270V273H652V270Q651 267 632 137T610 3V0H25V46H58Q100 47 109 49T128 61V619",
          70: "128 619Q121 626 117 628T101 631T58 634H25V680H582V676Q584 670 596 560T610 444V440H570V444Q563 493 561 501Q555 538 543 563T516 601T477 622T431 631T374 633H334H286Q252 633 244 631T233 621Q232 619 232 490V363H284Q287 363 303 363T327 364T349 367T372 373T389 385Q407 403 410 459V480H450V200H410V221Q407 276 389 296Q381 303 371 307T348 313T327 316T303 317T284 317H232V189L233 61Q240 54 245 52T270 48T333 46H360V0H348Q324 3 182 3Q51 3 36 0H25V46H58Q100 47 109 49T128 61V619",
          71: "56 342Q56 428 89 500T174 615T283 681T391 705Q394 705 400 705T408 704Q499 704 569 636L582 624L612 663Q639 700 643 704Q644 704 647 704T653 705H657Q660 705 666 699V419L660 413H626Q620 419 619 430Q610 512 571 572T476 651Q457 658 426 658Q401 658 376 654T316 633T254 592T205 519T177 411Q173 369 173 335Q173 259 192 201T238 111T302 58T370 31T431 24Q478 24 513 45T559 100Q562 110 562 160V212Q561 213 557 216T551 220T542 223T526 225T502 226T463 227H437V273H449L609 270Q715 270 727 273H735V227H721Q674 227 668 215Q666 211 666 108V6Q660 0 657 0Q653 0 639 10Q617 25 600 42L587 54Q571 27 524 3T406 -22Q317 -22 238 22T108 151T56 342",
          72: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 500V378H517V622Q510 629 506 631T490 634T447 637H414V683H425Q446 680 569 680Q704 680 713 683H724V637H691Q651 636 640 634T622 622V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V332H232V197L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
          73: "328 0Q307 3 180 3T32 0H21V46H43Q92 46 106 49T126 60Q128 63 128 342Q128 620 126 623Q122 628 118 630T96 635T43 637H21V683H32Q53 680 180 680T328 683H339V637H317Q268 637 254 634T234 623Q232 620 232 342Q232 63 234 60Q238 55 242 53T264 48T317 46H339V0H328",
          74: "89 177Q115 177 133 160T152 112Q152 88 137 72T102 52Q99 51 101 49Q106 43 129 29Q159 15 190 15Q232 15 256 48T286 126Q286 127 286 142T286 183T286 238T287 306T287 378Q287 403 287 429T287 479T287 524T286 563T286 593T286 614V621Q281 630 263 633T182 637H154V683H166Q187 680 332 680Q439 680 457 683H465V637H449Q422 637 401 634Q393 631 389 623Q388 621 388 376T387 123Q377 61 322 20T194 -22Q188 -22 177 -21T160 -20Q96 -9 61 29T25 110Q25 144 44 160T89 177",
          75: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H313Q235 637 233 620Q232 618 232 462L233 307L379 449Q425 494 479 546Q518 584 524 591T531 607V608Q531 630 503 636Q501 636 498 636T493 637H489V683H499Q517 680 630 680Q704 680 716 683H722V637H708Q633 633 589 597Q584 592 495 506T406 419T515 254T631 80Q644 60 662 54T715 46H736V0H728Q719 3 615 3Q493 3 472 0H461V46H469Q515 46 515 72Q515 78 512 84L336 351Q332 348 278 296L232 251V156Q232 62 235 58Q243 47 302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
          76: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q48 680 182 680Q324 680 348 683H360V637H333Q273 637 258 635T233 622L232 342V129Q232 57 237 52Q243 47 313 47Q384 47 410 53Q470 70 498 110T536 221Q536 226 537 238T540 261T542 272T562 273H582V268Q580 265 568 137T554 5V0H25V46H58Q100 47 109 49T128 61V622",
          77: "132 622Q125 629 121 631T105 634T62 637H29V683H135Q221 683 232 682T249 675Q250 674 354 398L458 124L562 398Q666 674 668 675Q671 681 683 682T781 683H887V637H854Q814 636 803 634T785 622V61Q791 51 802 49T854 46H887V0H876Q855 3 736 3Q605 3 596 0H585V46H618Q660 47 669 49T688 61V347Q688 424 688 461T688 546T688 613L687 632Q454 14 450 7Q446 1 430 1T410 7Q409 9 292 316L176 624V606Q175 588 175 543T175 463T175 356L176 86Q187 50 261 46H278V0H269Q254 3 154 3Q52 3 37 0H29V46H46Q78 48 98 56T122 69T132 86V622",
          78: "42 46Q74 48 94 56T118 69T128 86V634H124Q114 637 52 637H25V683H232L235 680Q237 679 322 554T493 303L578 178V598Q572 608 568 613T544 627T492 637H475V683H483Q498 680 600 680Q706 680 715 683H724V637H707Q634 633 622 598L621 302V6L614 0H600Q585 0 582 3T481 150T282 443T171 605V345L172 86Q183 50 257 46H274V0H265Q250 3 150 3Q48 3 33 0H25V46H42",
          79: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM467 647Q426 665 388 665Q360 665 331 654T269 620T213 549T179 439Q174 411 174 354Q174 144 277 61Q327 20 385 20H389H391Q474 20 537 99Q603 188 603 354Q603 411 598 439Q577 592 467 647",
          80: "130 622Q123 629 119 631T103 634T60 637H27V683H214Q237 683 276 683T331 684Q419 684 471 671T567 616Q624 563 624 489Q624 421 573 372T451 307Q429 302 328 301H234V181Q234 62 237 58Q245 47 304 46H337V0H326Q305 3 182 3Q47 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM507 488Q507 514 506 528T500 564T483 597T450 620T397 635Q385 637 307 637H286Q237 637 234 628Q231 624 231 483V342H302H339Q390 342 423 349T481 382Q507 411 507 488",
          81: "56 341Q56 499 157 602T388 705Q521 705 621 601T722 341Q722 275 703 218T660 127T603 63T555 25T525 9Q524 8 524 8H523Q524 5 526 -1T537 -21T555 -47T581 -67T615 -76Q653 -76 678 -56T706 -3Q707 10 716 10Q721 10 728 5L727 -13Q727 -88 697 -140T606 -193Q563 -193 538 -166T498 -83Q483 -23 483 -8L471 -11Q459 -14 435 -18T388 -22Q254 -22 155 81T56 341ZM607 339Q607 429 586 496T531 598T461 649T390 665T318 649T248 598T192 496T170 339Q170 143 277 57Q301 39 305 39L304 42Q304 44 304 46Q301 53 301 68Q301 101 325 128T391 155Q454 155 495 70L501 58Q549 91 578 164Q607 234 607 339ZM385 18Q404 18 425 23T459 33T472 40Q471 47 468 57T449 88T412 115Q398 117 386 117Q367 117 353 102T338 67Q338 48 351 33T385 18",
          82: "130 622Q123 629 119 631T103 634T60 637H27V683H202H236H300Q376 683 417 677T500 648Q595 600 609 517Q610 512 610 501Q610 468 594 439T556 392T511 361T472 343L456 338Q459 335 467 332Q497 316 516 298T545 254T559 211T568 155T578 94Q588 46 602 31T640 16H645Q660 16 674 32T692 87Q692 98 696 101T712 105T728 103T732 90Q732 59 716 27T672 -16Q656 -22 630 -22Q481 -16 458 90Q456 101 456 163T449 246Q430 304 373 320L363 322L297 323H231V192L232 61Q238 51 249 49T301 46H334V0H323Q302 3 181 3Q59 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM491 499V509Q491 527 490 539T481 570T462 601T424 623T362 636Q360 636 340 636T304 637H283Q238 637 234 628Q231 624 231 492V360H289Q390 360 434 378T489 456Q491 467 491 499",
          83: "55 507Q55 590 112 647T243 704H257Q342 704 405 641L426 672Q431 679 436 687T446 700L449 704Q450 704 453 704T459 705H463Q466 705 472 699V462L466 456H448Q437 456 435 459T430 479Q413 605 329 646Q292 662 254 662Q201 662 168 626T135 542Q135 508 152 480T200 435Q210 431 286 412T370 389Q427 367 463 314T500 191Q500 110 448 45T301 -21Q245 -21 201 -4T140 27L122 41Q118 36 107 21T87 -7T78 -21Q76 -22 68 -22H64Q61 -22 55 -16V101Q55 220 56 222Q58 227 76 227H89Q95 221 95 214Q95 182 105 151T139 90T205 42T305 24Q352 24 386 62T420 155Q420 198 398 233T340 281Q284 295 266 300Q261 301 239 306T206 314T174 325T141 343T112 367T85 402Q55 451 55 507",
          84: "36 443Q37 448 46 558T55 671V677H666V671Q667 666 676 556T685 443V437H645V443Q645 445 642 478T631 544T610 593Q593 614 555 625Q534 630 478 630H451H443Q417 630 414 618Q413 616 413 339V63Q420 53 439 50T528 46H558V0H545L361 3Q186 1 177 0H164V46H194Q264 46 283 49T309 63V339V550Q309 620 304 625T271 630H244H224Q154 630 119 601Q101 585 93 554T81 486T76 443V437H36V443",
          85: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 418V291Q232 189 240 145T280 67Q325 24 389 24Q454 24 506 64T571 183Q575 206 575 410V598Q569 608 565 613T541 627T489 637H472V683H481Q496 680 598 680T715 683H724V637H707Q634 633 622 598L621 399Q620 194 617 180Q617 179 615 171Q595 83 531 31T389 -22Q304 -22 226 33T130 192Q129 201 128 412V622",
          86: "114 620Q113 621 110 624T107 627T103 630T98 632T91 634T80 635T67 636T48 637H19V683H28Q46 680 152 680Q273 680 294 683H305V637H284Q223 634 223 620Q223 618 313 372T404 126L490 358Q575 588 575 597Q575 616 554 626T508 637H503V683H512Q527 680 627 680Q718 680 724 683H730V637H723Q648 637 627 596Q627 595 515 291T401 -14Q396 -22 382 -22H374H367Q353 -22 348 -14Q346 -12 231 303Q114 617 114 620",
          87: "792 683Q810 680 914 680Q991 680 1003 683H1009V637H996Q931 633 915 598Q912 591 863 438T766 135T716 -17Q711 -22 694 -22Q676 -22 673 -15Q671 -13 593 231L514 477L435 234Q416 174 391 92T358 -6T341 -22H331Q314 -21 310 -15Q309 -14 208 302T104 622Q98 632 87 633Q73 637 35 637H18V683H27Q69 681 154 681Q164 681 181 681T216 681T249 682T276 683H287H298V637H285Q213 637 213 620Q213 616 289 381L364 144L427 339Q490 535 492 546Q487 560 482 578T475 602T468 618T461 628T449 633T433 636T408 637H380V683H388Q397 680 508 680Q629 680 650 683H660V637H647Q576 637 576 619L727 146Q869 580 869 600Q869 605 863 612T839 627T794 637H783V683H792",
          88: "270 0Q252 3 141 3Q46 3 31 0H23V46H40Q129 50 161 88Q165 94 244 216T324 339Q324 341 235 480T143 622Q133 631 119 634T57 637H37V683H46Q64 680 172 680Q297 680 318 683H329V637H324Q307 637 286 632T263 621Q263 618 322 525T384 431Q385 431 437 511T489 593Q490 595 490 599Q490 611 477 622T436 637H428V683H437Q455 680 566 680Q661 680 676 683H684V637H667Q585 634 551 599Q548 596 478 491Q412 388 412 387Q412 385 514 225T620 62Q628 53 642 50T695 46H726V0H717Q699 3 591 3Q466 3 445 0H434V46H440Q454 46 476 51T499 64Q499 67 463 124T390 238L353 295L350 292Q348 290 343 283T331 265T312 236T286 195Q219 88 218 84Q218 70 234 59T272 46H280V0H270",
          89: "518 0Q497 3 374 3Q253 3 232 0H221V46H254Q313 47 321 58Q324 62 324 167V273L221 446Q117 620 114 623Q106 631 91 634T31 637H11V683H20Q29 680 148 680Q273 680 294 683H305V637H287Q239 636 236 621Q236 619 321 475L407 332L483 460Q502 492 527 534Q563 594 563 604Q563 632 517 637H508V683H517H525Q533 683 545 683T571 682T600 681T626 681Q695 681 731 683H738V637H723Q640 633 613 588Q612 587 517 427L425 273V169V95Q425 66 428 59T444 49Q459 46 506 46H528V0H518",
          90: "69 443Q69 452 74 554T80 683H549Q555 677 555 664Q555 649 554 648Q552 645 366 348T179 50T192 49T263 49H275H302Q333 49 353 50T401 59T447 78T482 115T507 173Q513 200 520 273V282H560V274Q560 272 552 143T543 8V0H302L61 1L58 3Q55 8 55 21V35Q59 43 153 193T340 489T432 637H343Q259 637 214 625T141 573Q109 523 109 445Q109 443 89 443H69",
          91: "118 -250V750H255V710H158V-210H255V-250H118",
          92: "56 731Q56 740 62 745T75 750Q85 750 92 740Q96 733 270 255T444 -231Q444 -239 438 -244T424 -250Q414 -250 407 -240Q404 -236 230 242T56 731",
          93: "22 710V750H159V-250H22V-210H119V710H22",
          94: "112 560L249 694L257 686Q387 562 387 560L361 531Q359 532 303 581L250 627L195 580Q182 569 169 557T148 538L140 532Q138 530 125 546L112 560",
          95: "0 -62V-25H499V-62H0",
          96: "106 655Q106 671 119 685T150 699Q166 699 177 688Q190 671 222 629T275 561T295 533T282 519L267 505L196 563Q119 626 113 634Q106 643 106 655",
          97: "137 305T115 305T78 320T63 359Q63 394 97 421T218 448Q291 448 336 416T396 340Q401 326 401 309T402 194V124Q402 76 407 58T428 40Q443 40 448 56T453 109V145H493V106Q492 66 490 59Q481 29 455 12T400 -6T353 12T329 54V58L327 55Q325 52 322 49T314 40T302 29T287 17T269 6T247 -2T221 -8T190 -11Q130 -11 82 20T34 107Q34 128 41 147T68 188T116 225T194 253T304 268H318V290Q318 324 312 340Q290 411 215 411Q197 411 181 410T156 406T148 403Q170 388 170 359Q170 334 154 320ZM126 106Q126 75 150 51T209 26Q247 26 276 49T315 109Q317 116 318 175Q318 233 317 233Q309 233 296 232T251 223T193 203T147 166T126 106",
          98: "307 -11Q234 -11 168 55L158 37Q156 34 153 28T147 17T143 10L138 1L118 0H98V298Q98 599 97 603Q94 622 83 628T38 637H20V660Q20 683 22 683L32 684Q42 685 61 686T98 688Q115 689 135 690T165 693T176 694H179V543Q179 391 180 391L183 394Q186 397 192 401T207 411T228 421T254 431T286 439T323 442Q401 442 461 379T522 216Q522 115 458 52T307 -11ZM182 98Q182 97 187 90T196 79T206 67T218 55T233 44T250 35T271 29T295 26Q330 26 363 46T412 113Q424 148 424 212Q424 287 412 323Q385 405 300 405Q270 405 239 390T188 347L182 339V98",
          99: "370 305T349 305T313 320T297 358Q297 381 312 396Q317 401 317 402T307 404Q281 408 258 408Q209 408 178 376Q131 329 131 219Q131 137 162 90Q203 29 272 29Q313 29 338 55T374 117Q376 125 379 127T395 129H409Q415 123 415 120Q415 116 411 104T395 71T366 33T318 2T249 -11Q163 -11 99 53T34 214Q34 318 99 383T250 448T370 421T404 357Q404 334 387 320",
          100: "376 495Q376 511 376 535T377 568Q377 613 367 624T316 637H298V660Q298 683 300 683L310 684Q320 685 339 686T376 688Q393 689 413 690T443 693T454 694H457V390Q457 84 458 81Q461 61 472 55T517 46H535V0Q533 0 459 -5T380 -11H373V44L365 37Q307 -11 235 -11Q158 -11 96 50T34 215Q34 315 97 378T244 442Q319 442 376 393V495ZM373 342Q328 405 260 405Q211 405 173 369Q146 341 139 305T131 211Q131 155 138 120T173 59Q203 26 251 26Q322 26 373 103V342",
          101: "28 218Q28 273 48 318T98 391T163 433T229 448Q282 448 320 430T378 380T406 316T415 245Q415 238 408 231H126V216Q126 68 226 36Q246 30 270 30Q312 30 342 62Q359 79 369 104L379 128Q382 131 395 131H398Q415 131 415 121Q415 117 412 108Q393 53 349 21T250 -11Q155 -11 92 58T28 218ZM333 275Q322 403 238 411H236Q228 411 220 410T195 402T166 381T143 340T127 274V267H333V275",
          102: "273 0Q255 3 146 3Q43 3 34 0H26V46H42Q70 46 91 49Q99 52 103 60Q104 62 104 224V385H33V431H104V497L105 564L107 574Q126 639 171 668T266 704Q267 704 275 704T289 705Q330 702 351 679T372 627Q372 604 358 590T321 576T284 590T270 627Q270 647 288 667H284Q280 668 273 668Q245 668 223 647T189 592Q183 572 182 497V431H293V385H185V225Q185 63 186 61T189 57T194 54T199 51T206 49T213 48T222 47T231 47T241 46T251 46H282V0H273",
          103: "329 409Q373 453 429 453Q459 453 472 434T485 396Q485 382 476 371T449 360Q416 360 412 390Q410 404 415 411Q415 412 416 414V415Q388 412 363 393Q355 388 355 386Q355 385 359 381T368 369T379 351T388 325T392 292Q392 230 343 187T222 143Q172 143 123 171Q112 153 112 133Q112 98 138 81Q147 75 155 75T227 73Q311 72 335 67Q396 58 431 26Q470 -13 470 -72Q470 -139 392 -175Q332 -206 250 -206Q167 -206 107 -175Q29 -140 29 -75Q29 -39 50 -15T92 18L103 24Q67 55 67 108Q67 155 96 193Q52 237 52 292Q52 355 102 398T223 442Q274 442 318 416L329 409ZM299 343Q294 371 273 387T221 404Q192 404 171 388T145 343Q142 326 142 292Q142 248 149 227T179 192Q196 182 222 182Q244 182 260 189T283 207T294 227T299 242Q302 258 302 292T299 343ZM403 -75Q403 -50 389 -34T348 -11T299 -2T245 0H218Q151 0 138 -6Q118 -15 107 -34T95 -74Q95 -84 101 -97T122 -127T170 -155T250 -167Q319 -167 361 -139T403 -75",
          104: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 124T102 167T103 217T103 272T103 329Q103 366 103 407T103 482T102 542T102 586T102 603Q99 622 88 628T43 637H25V660Q25 683 27 683L37 684Q47 685 66 686T103 688Q120 689 140 690T170 693T181 694H184V367Q244 442 328 442Q451 442 463 329Q464 322 464 190V104Q464 66 466 59T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
          105: "69 609Q69 637 87 653T131 669Q154 667 171 652T188 609Q188 579 171 564T129 549Q104 549 87 564T69 609ZM247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
          106: "98 609Q98 637 116 653T160 669Q183 667 200 652T217 609Q217 579 200 564T158 549Q133 549 116 564T98 609ZM28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
          107: "36 46H50Q89 46 97 60V68Q97 77 97 91T97 124T98 167T98 217T98 272T98 329Q98 366 98 407T98 482T98 542T97 586T97 603Q94 622 83 628T38 637H20V660Q20 683 22 683L32 684Q42 685 61 686T98 688Q115 689 135 690T165 693T176 694H179V463L180 233L240 287Q300 341 304 347Q310 356 310 364Q310 383 289 385H284V431H293Q308 428 412 428Q475 428 484 431H489V385H476Q407 380 360 341Q286 278 286 274Q286 273 349 181T420 79Q434 60 451 53T500 46H511V0H505Q496 3 418 3Q322 3 307 0H299V46H306Q330 48 330 65Q330 72 326 79Q323 84 276 153T228 222L176 176V120V84Q176 65 178 59T189 49Q210 46 238 46H254V0H246Q231 3 137 3T28 0H20V46H36",
          108: "42 46H56Q95 46 103 60V68Q103 77 103 91T103 124T104 167T104 217T104 272T104 329Q104 366 104 407T104 482T104 542T103 586T103 603Q100 622 89 628T44 637H26V660Q26 683 28 683L38 684Q48 685 67 686T104 688Q121 689 141 690T171 693T182 694H185V379Q185 62 186 60Q190 52 198 49Q219 46 247 46H263V0H255L232 1Q209 2 183 2T145 3T107 3T57 1L34 0H26V46H42",
          109: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 122T103 161T103 203Q103 234 103 269T102 328V351Q99 370 88 376T43 385H25V408Q25 431 27 431L37 432Q47 433 65 434T102 436Q119 437 138 438T167 441T178 442H181V402Q181 364 182 364T187 369T199 384T218 402T247 421T285 437Q305 442 336 442Q351 442 364 440T387 434T406 426T421 417T432 406T441 395T448 384T452 374T455 366L457 361L460 365Q463 369 466 373T475 384T488 397T503 410T523 422T546 432T572 439T603 442Q729 442 740 329Q741 322 741 190V104Q741 66 743 59T754 49Q775 46 803 46H819V0H811L788 1Q764 2 737 2T699 3Q596 3 587 0H579V46H595Q656 46 656 62Q657 64 657 200Q656 335 655 343Q649 371 635 385T611 402T585 404Q540 404 506 370Q479 343 472 315T464 232V168V108Q464 78 465 68T468 55T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
          110: "41 46H55Q94 46 102 60V68Q102 77 102 91T102 122T103 161T103 203Q103 234 103 269T102 328V351Q99 370 88 376T43 385H25V408Q25 431 27 431L37 432Q47 433 65 434T102 436Q119 437 138 438T167 441T178 442H181V402Q181 364 182 364T187 369T199 384T218 402T247 421T285 437Q305 442 336 442Q450 438 463 329Q464 322 464 190V104Q464 66 466 59T477 49Q498 46 526 46H542V0H534L510 1Q487 2 460 2T422 3Q319 3 310 0H302V46H318Q379 46 379 62Q380 64 380 200Q379 335 378 343Q372 371 358 385T334 402T308 404Q263 404 229 370Q202 343 195 315T187 232V168V108Q187 78 188 68T191 55T200 49Q221 46 249 46H265V0H257L234 1Q210 2 183 2T145 3Q42 3 33 0H25V46H41",
          111: "28 214Q28 309 93 378T250 448Q340 448 405 380T471 215Q471 120 407 55T250 -10Q153 -10 91 57T28 214ZM250 30Q372 30 372 193V225V250Q372 272 371 288T364 326T348 362T317 390T268 410Q263 411 252 411Q222 411 195 399Q152 377 139 338T126 246V226Q126 130 145 91Q177 30 250 30",
          112: "36 -148H50Q89 -148 97 -134V-126Q97 -119 97 -107T97 -77T98 -38T98 6T98 55T98 106Q98 140 98 177T98 243T98 296T97 335T97 351Q94 370 83 376T38 385H20V408Q20 431 22 431L32 432Q42 433 61 434T98 436Q115 437 135 438T165 441T176 442H179V416L180 390L188 397Q247 441 326 441Q407 441 464 377T522 216Q522 115 457 52T310 -11Q242 -11 190 33L182 40V-45V-101Q182 -128 184 -134T195 -145Q216 -148 244 -148H260V-194H252L228 -193Q205 -192 178 -192T140 -191Q37 -191 28 -194H20V-148H36ZM424 218Q424 292 390 347T305 402Q234 402 182 337V98Q222 26 294 26Q345 26 384 80T424 218",
          113: "33 218Q33 308 95 374T236 441H246Q330 441 381 372L387 364Q388 364 404 403L420 442H457V156Q457 -132 458 -134Q462 -142 470 -145Q491 -148 519 -148H535V-194H527L504 -193Q480 -192 453 -192T415 -191Q312 -191 303 -194H295V-148H311Q339 -148 360 -145Q369 -141 371 -135T373 -106V-41V49Q313 -11 236 -11Q154 -11 94 53T33 218ZM376 300Q346 389 278 401Q275 401 269 401T261 402Q211 400 171 350T131 214Q131 137 165 82T253 27Q296 27 328 54T376 118V300",
          114: "36 46H50Q89 46 97 60V68Q97 77 97 91T98 122T98 161T98 203Q98 234 98 269T98 328L97 351Q94 370 83 376T38 385H20V408Q20 431 22 431L32 432Q42 433 60 434T96 436Q112 437 131 438T160 441T171 442H174V373Q213 441 271 441H277Q322 441 343 419T364 373Q364 352 351 337T313 322Q288 322 276 338T263 372Q263 381 265 388T270 400T273 405Q271 407 250 401Q234 393 226 386Q179 341 179 207V154Q179 141 179 127T179 101T180 81T180 66V61Q181 59 183 57T188 54T193 51T200 49T207 48T216 47T225 47T235 46T245 46H276V0H267Q249 3 140 3Q37 3 28 0H20V46H36",
          115: "295 316Q295 356 268 385T190 414Q154 414 128 401Q98 382 98 349Q97 344 98 336T114 312T157 287Q175 282 201 278T245 269T277 256Q294 248 310 236T342 195T359 133Q359 71 321 31T198 -10H190Q138 -10 94 26L86 19L77 10Q71 4 65 -1L54 -11H46H42Q39 -11 33 -5V74V132Q33 153 35 157T45 162H54Q66 162 70 158T75 146T82 119T101 77Q136 26 198 26Q295 26 295 104Q295 133 277 151Q257 175 194 187T111 210Q75 227 54 256T33 318Q33 357 50 384T93 424T143 442T187 447H198Q238 447 268 432L283 424L292 431Q302 440 314 448H322H326Q329 448 335 442V310L329 304H301Q295 310 295 316",
          116: "27 422Q80 426 109 478T141 600V615H181V431H316V385H181V241Q182 116 182 100T189 68Q203 29 238 29Q282 29 292 100Q293 108 293 146V181H333V146V134Q333 57 291 17Q264 -10 221 -10Q187 -10 162 2T124 33T105 68T98 100Q97 107 97 248V385H18V422H27",
          117: "383 58Q327 -10 256 -10H249Q124 -10 105 89Q104 96 103 226Q102 335 102 348T96 369Q86 385 36 385H25V408Q25 431 27 431L38 432Q48 433 67 434T105 436Q122 437 142 438T172 441T184 442H187V261Q188 77 190 64Q193 49 204 40Q224 26 264 26Q290 26 311 35T343 58T363 90T375 120T379 144Q379 145 379 161T380 201T380 248V315Q380 361 370 372T320 385H302V431Q304 431 378 436T457 442H464V264Q464 84 465 81Q468 61 479 55T524 46H542V0Q540 0 467 -5T390 -11H383V58",
          118: "338 431Q344 429 422 429Q479 429 503 431H508V385H497Q439 381 423 345Q421 341 356 172T288 -2Q283 -11 263 -11Q244 -11 239 -2Q99 359 98 364Q93 378 82 381T43 385H19V431H25L33 430Q41 430 53 430T79 430T104 429T122 428Q217 428 232 431H240V385H226Q187 384 184 370Q184 366 235 234L286 102L377 341V349Q377 363 367 372T349 383T335 385H331V431H338",
          119: "90 368Q84 378 76 380T40 385H18V431H24L43 430Q62 430 84 429T116 428Q206 428 221 431H229V385H215Q177 383 177 368Q177 367 221 239L265 113L339 328L333 345Q323 374 316 379Q308 384 278 385H258V431H264Q270 428 348 428Q439 428 454 431H461V385H452Q404 385 404 369Q404 366 418 324T449 234T481 143L496 100L537 219Q579 341 579 347Q579 363 564 373T530 385H522V431H529Q541 428 624 428Q692 428 698 431H703V385H697Q696 385 691 385T682 384Q635 377 619 334L559 161Q546 124 528 71Q508 12 503 1T487 -11H479Q460 -11 456 -4Q455 -3 407 133L361 267Q359 263 266 -4Q261 -11 243 -11H238Q225 -11 220 -3L90 368",
          120: "201 0Q189 3 102 3Q26 3 17 0H11V46H25Q48 47 67 52T96 61T121 78T139 96T160 122T180 150L226 210L168 288Q159 301 149 315T133 336T122 351T113 363T107 370T100 376T94 379T88 381T80 383Q74 383 44 385H16V431H23Q59 429 126 429Q219 429 229 431H237V385Q201 381 201 369Q201 367 211 353T239 315T268 274L272 270L297 304Q329 345 329 358Q329 364 327 369T322 376T317 380T310 384L307 385H302V431H309Q324 428 408 428Q487 428 493 431H499V385H492Q443 385 411 368Q394 360 377 341T312 257L296 236L358 151Q424 61 429 57T446 50Q464 46 499 46H516V0H510H502Q494 1 482 1T457 2T432 2T414 3Q403 3 377 3T327 1L304 0H295V46H298Q309 46 320 51T331 63Q331 65 291 120L250 175Q249 174 219 133T185 88Q181 83 181 74Q181 63 188 55T206 46Q208 46 208 23V0H201",
          121: "69 -66Q91 -66 104 -80T118 -116Q118 -134 109 -145T91 -160Q84 -163 97 -166Q104 -168 111 -168Q131 -168 148 -159T175 -138T197 -106T213 -75T225 -43L242 0L170 183Q150 233 125 297Q101 358 96 368T80 381Q79 382 78 382Q66 385 34 385H19V431H26L46 430Q65 430 88 429T122 428Q129 428 142 428T171 429T200 430T224 430L233 431H241V385H232Q183 385 185 366L286 112Q286 113 332 227L376 341V350Q376 365 366 373T348 383T334 385H331V431H337H344Q351 431 361 431T382 430T405 429T422 429Q477 429 503 431H508V385H497Q441 380 422 345Q420 343 378 235T289 9T227 -131Q180 -204 113 -204Q69 -204 44 -177T19 -116Q19 -89 35 -78T69 -66",
          122: "42 263Q44 270 48 345T53 423V431H393Q399 425 399 415Q399 403 398 402L381 378Q364 355 331 309T265 220L134 41L182 40H206Q254 40 283 46T331 77Q352 105 359 185L361 201Q361 202 381 202H401V196Q401 195 393 103T384 6V0H209L34 1L31 3Q28 8 28 17Q28 30 29 31T160 210T294 394H236Q169 393 152 388Q127 382 113 367Q89 344 82 264V255H42V263",
          123: "434 -231Q434 -244 428 -250H410Q281 -250 230 -184Q225 -177 222 -172T217 -161T213 -148T211 -133T210 -111T209 -84T209 -47T209 0Q209 21 209 53Q208 142 204 153Q203 154 203 155Q189 191 153 211T82 231Q71 231 68 234T65 250T68 266T82 269Q116 269 152 289T203 345Q208 356 208 377T209 529V579Q209 634 215 656T244 698Q270 724 324 740Q361 748 377 749Q379 749 390 749T408 750H428Q434 744 434 732Q434 719 431 716Q429 713 415 713Q362 710 332 689T296 647Q291 634 291 499V417Q291 370 288 353T271 314Q240 271 184 255L170 250L184 245Q202 239 220 230T262 196T290 137Q291 131 291 1Q291 -134 296 -147Q306 -174 339 -192T415 -213Q429 -213 431 -216Q434 -219 434 -231",
          124: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
          125: "65 731Q65 745 68 747T88 750Q171 750 216 725T279 670Q288 649 289 635T291 501Q292 362 293 357Q306 312 345 291T417 269Q428 269 431 266T434 250T431 234T417 231Q380 231 345 210T298 157Q293 143 292 121T291 -28V-79Q291 -134 285 -156T256 -198Q202 -250 89 -250Q71 -250 68 -247T65 -230Q65 -224 65 -223T66 -218T69 -214T77 -213Q91 -213 108 -210T146 -200T183 -177T207 -139Q208 -134 209 3L210 139Q223 196 280 230Q315 247 330 250Q305 257 280 270Q225 304 212 352L210 362L209 498Q208 635 207 640Q195 680 154 696T77 713Q68 713 67 716T65 731",
          126: "179 251Q164 251 151 245T131 234T111 215L97 227L83 238Q83 239 95 253T121 283T142 304Q165 318 187 318T253 300T320 282Q335 282 348 288T368 299T388 318L402 306L416 295Q375 236 344 222Q330 215 313 215Q292 215 248 233T179 251",
          160: "",
          163: "699 578Q699 473 635 473Q597 473 595 508Q595 559 654 569V576Q654 619 637 648T581 677Q545 677 513 647T463 561Q460 554 437 464T414 371Q414 370 458 370H502Q508 364 508 362Q505 334 495 324H402L382 241Q377 224 373 206T366 180T361 163T358 151T354 142T350 133T344 120Q340 112 338 107T336 101L354 90Q398 63 422 54T476 44Q515 44 539 73T574 133Q578 144 580 146T598 148Q622 148 622 139Q622 138 620 130Q602 74 555 32T447 -11Q395 -11 317 38L294 51Q271 28 233 9T155 -10Q117 -10 103 5T88 39Q88 73 126 106T224 139Q236 139 247 138T266 134L273 132Q275 132 302 239L323 324H259Q253 330 253 332Q253 350 265 370H300L334 371L355 453Q356 457 360 477T366 501T372 522T379 545T387 565T397 587T409 606T425 627Q453 664 497 689T583 714Q640 714 669 676T699 578ZM245 76Q211 85 195 85Q173 85 158 71T142 42Q142 26 160 26H163Q211 30 245 76",
          165: "515 0Q494 3 374 3Q256 3 235 0H224V46H257Q316 47 324 58Q327 62 327 137V213H133Q121 213 113 213T97 213T86 213T78 213T73 214T70 215T69 216T68 218T67 220Q64 225 66 231T73 240Q76 242 202 242H327V273L247 407H115Q81 407 75 408T67 414Q64 419 66 425T73 434Q76 436 153 436Q228 436 228 437Q227 440 173 530T115 623Q101 637 31 637H11V683H20Q66 681 153 681Q169 681 202 681T262 682L288 683H298V637H280Q230 636 230 621Q230 619 250 584Q255 576 264 561T286 526T305 494L340 437L403 436H467L513 514Q564 596 564 605Q564 608 560 616Q550 634 517 637H508V683H516Q531 680 633 680Q722 680 731 683H738V637H723Q644 632 617 595Q614 591 568 515T521 437T597 436T676 434Q681 432 683 426T682 414T671 409T589 407H503L422 273V242H547Q673 242 676 240Q681 238 683 232T682 220Q682 219 682 218T681 217T679 216T677 215T672 214T664 213T652 213T637 213T616 213H422V139V87Q422 64 425 58T441 49Q456 46 503 46H525V0H515ZM449 406Q449 407 403 407Q358 407 358 406L370 387Q381 368 392 350L404 331Q447 404 449 406",
          168: "95 612Q95 633 112 651T153 669T193 652T210 612Q210 588 194 571T152 554L127 560Q95 577 95 612ZM289 611Q289 634 304 649T335 668Q336 668 340 668T346 669Q369 669 386 652T404 612T387 572T346 554Q323 554 306 570T289 611",
          172: "56 323T56 336T70 356H596Q603 353 611 343V102Q598 89 591 89Q587 89 584 90T579 94T575 98T572 102L571 209V316H70Q56 323 56 336",
          174: "915 266Q915 140 852 38T689 -120T474 -175Q312 -175 188 -71T38 190Q32 220 32 266V287Q32 345 57 416T129 545Q192 624 282 666T464 709Q513 709 522 708Q599 698 665 666T776 590T853 493T900 387T915 287V266ZM875 285Q875 339 853 399T789 517T676 616T519 668Q510 669 465 669Q380 669 299 630T155 514T77 336Q72 312 72 285V266V256Q72 123 163 11Q290 -135 474 -135Q614 -135 727 -46Q875 81 875 266V285ZM276 457Q275 458 274 460T272 463T270 465T267 467T264 469T258 471T252 472T243 473T232 474T218 474H204V514H335Q477 514 499 510Q560 502 610 467T661 375Q661 362 658 350T648 327T635 308T618 292T601 280T583 269T568 262T554 256L547 253Q548 252 556 247T570 237T586 223T602 202T614 174Q616 169 626 123T638 72Q652 23 683 23Q715 23 720 68Q721 78 724 81T740 84T756 82T760 70Q760 47 747 25T715 -7Q700 -14 673 -14Q672 -14 662 -14T643 -12T619 -7T593 2T568 16T547 37T534 67Q531 80 531 97Q531 103 531 116T532 136Q532 218 472 236Q466 238 413 239H360V148L361 58Q366 47 375 44T418 40H432V0H424Q409 3 318 3T212 0H204V40H218Q242 40 253 42T268 47T276 58V457ZM376 473Q365 471 363 464T360 430V366V276H416Q421 276 434 276T453 276T469 277T486 279T501 282T517 287T529 294T542 305Q561 324 561 375Q561 424 545 444T482 472Q478 473 427 474Q415 474 403 474T384 474L376 473",
          175: "69 544V590H430V544H69",
          176: "147 628Q147 669 179 692T244 715Q298 715 325 689T352 629Q352 592 323 567T249 542Q202 542 175 567T147 628ZM313 628Q313 660 300 669T259 678H253Q248 678 242 678T234 679Q217 679 207 674T192 659T188 644T187 629Q187 600 198 590Q210 579 250 579H265Q279 579 288 581T305 595T313 628",
          177: "56 320T56 333T70 353H369V502Q369 651 371 655Q376 666 388 666Q402 666 405 654T409 596V500V353H707Q722 345 722 333Q722 320 707 313H409V40H707Q722 32 722 20T707 0H70Q56 7 56 20T70 40H369V313H70Q56 320 56 333",
          180: "349 699Q367 699 380 686T393 656Q393 651 392 647T387 637T380 627T367 616T351 602T330 585T303 563L232 505L217 519Q203 533 204 533Q204 534 229 567T282 636T313 678L316 681Q318 684 321 686T328 692T337 697T349 699",
          183: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250",
          215: "630 29Q630 9 609 9Q604 9 587 25T493 118L389 222L284 117Q178 13 175 11Q171 9 168 9Q160 9 154 15T147 29Q147 36 161 51T255 146L359 250L255 354Q174 435 161 449T147 471Q147 480 153 485T168 490Q173 490 175 489Q178 487 284 383L389 278L493 382Q570 459 587 475T609 491Q630 491 630 471Q630 464 620 453T522 355L418 250L522 145Q606 61 618 48T630 29",
          240: "75 566V604Q75 624 79 629T102 635Q124 635 127 629T131 588L133 550L191 588L249 628L231 635Q176 654 124 657Q116 657 106 658L95 659Q94 661 94 687T95 715Q99 717 113 717Q195 717 282 679L309 668L331 681Q351 697 391 721Q428 748 435 748Q437 749 446 749Q470 749 473 746Q478 744 478 681V621Q466 615 456 615Q435 615 424 624L422 661V699L382 675L344 648Q353 639 366 630Q480 538 504 413Q509 393 509 333V313Q509 284 507 257T495 184T466 102T413 33T329 -16Q311 -21 275 -21Q226 -21 195 -10Q150 7 110 50T53 141Q42 179 42 227Q42 332 101 403T245 474Q282 474 314 461T359 436T380 415Q386 405 389 408Q389 426 378 475Q368 505 355 529T329 567T306 590T288 603L282 606L120 501Q116 500 102 500Q84 500 75 506V566ZM388 225Q388 376 309 410Q299 416 273 419Q216 419 191 390Q174 371 168 342T162 218Q162 112 184 79Q212 39 273 39Q312 39 342 62T380 121Q388 159 388 225",
          247: "318 466Q318 500 339 518T386 537Q418 537 438 517T458 466Q458 438 440 417T388 396Q355 396 337 417T318 466ZM56 237T56 250T70 270H706Q721 262 721 250T706 230H70Q56 237 56 250ZM318 34Q318 68 339 86T386 105Q418 105 438 85T458 34Q458 6 440 -15T388 -36Q355 -36 337 -15T318 34",
          305: "247 0Q232 3 143 3Q132 3 106 3T56 1L34 0H26V46H42Q70 46 91 49Q100 53 102 60T104 102V205V293Q104 345 102 359T88 378Q74 385 41 385H30V408Q30 431 32 431L42 432Q52 433 70 434T106 436Q123 437 142 438T171 441T182 442H185V62Q190 52 197 50T232 46H255V0H247",
          567: "28 -163Q58 -168 64 -168Q124 -168 135 -77Q137 -65 137 141T136 353Q132 371 120 377T72 385H52V408Q52 431 54 431L58 432Q62 432 70 432T87 433T108 434T133 436Q151 437 171 438T202 441T214 442H218V184Q217 -36 217 -59T211 -98Q195 -145 153 -175T58 -205Q9 -205 -23 -179T-55 -117Q-55 -94 -40 -79T-2 -64T36 -79T52 -118Q52 -143 28 -163",
          697: "79 43Q73 43 52 49T30 61Q30 68 85 293T146 528Q161 560 198 560Q218 560 240 545T262 501Q262 496 260 486Q259 479 173 263T84 45T79 43",
          710: "112 560L249 694L257 686Q387 562 387 560L361 531Q359 532 303 581L250 627L195 580Q182 569 169 557T148 538L140 532Q138 530 125 546L112 560",
          711: "114 611L127 630L136 644Q138 644 193 612Q248 581 250 581L306 612Q361 644 363 644L385 611L318 562L249 513L114 611",
          713: "69 544V590H430V544H69",
          714: "349 699Q367 699 380 686T393 656Q393 651 392 647T387 637T380 627T367 616T351 602T330 585T303 563L232 505L217 519Q203 533 204 533Q204 534 229 567T282 636T313 678L316 681Q318 684 321 686T328 692T337 697T349 699",
          715: "106 655Q106 671 119 685T150 699Q166 699 177 688Q190 671 222 629T275 561T295 533T282 519L267 505L196 563Q119 626 113 634Q106 643 106 655",
          728: "250 515Q179 515 138 565T92 683V694H129V689Q129 688 129 683T130 675Q137 631 169 599T248 567Q304 567 337 608T370 689V694H407V683Q403 617 361 566T250 515",
          729: "190 609Q190 637 208 653T252 669Q275 667 292 652T309 609Q309 579 292 564T250 549Q225 549 208 564T190 609",
          730: "147 628Q147 669 179 692T244 715Q298 715 325 689T352 629Q352 592 323 567T249 542Q202 542 175 567T147 628ZM313 628Q313 660 300 669T259 678H253Q248 678 242 678T234 679Q217 679 207 674T192 659T188 644T187 629Q187 600 198 590Q210 579 250 579H265Q279 579 288 581T305 595T313 628",
          732: "179 601Q164 601 151 595T131 584T111 565L97 577L83 588Q83 589 95 603T121 633T142 654Q165 668 187 668T253 650T320 632Q335 632 348 638T368 649T388 668L402 656L416 645Q375 586 344 572Q330 565 313 565Q292 565 248 583T179 601",
          768: "-394 655Q-394 671 -381 685T-350 699Q-334 699 -323 688Q-310 671 -278 629T-225 561T-205 533T-218 519L-233 505L-304 563Q-381 626 -387 634Q-394 643 -394 655",
          769: "-151 699Q-133 699 -120 686T-107 656Q-107 651 -108 647T-113 637T-120 627T-133 616T-149 602T-170 585T-197 563L-268 505L-283 519Q-297 533 -296 533Q-296 534 -271 567T-218 636T-187 678L-184 681Q-182 684 -179 686T-172 692T-163 697T-151 699",
          770: "-388 560L-251 694L-243 686Q-113 562 -113 560L-139 531Q-141 532 -197 581L-250 627L-305 580Q-318 569 -331 557T-352 538L-360 532Q-362 530 -375 546L-388 560",
          771: "-321 601Q-336 601 -349 595T-369 584T-389 565L-403 577L-417 588Q-417 589 -405 603T-379 633T-358 654Q-335 668 -313 668T-247 650T-180 632Q-165 632 -152 638T-132 649T-112 668L-98 656L-84 645Q-125 586 -156 572Q-170 565 -187 565Q-208 565 -252 583T-321 601",
          772: "-431 544V590H-70V544H-431",
          774: "-250 515Q-321 515 -362 565T-408 683V694H-371V689Q-371 688 -371 683T-370 675Q-363 631 -331 599T-252 567Q-196 567 -163 608T-130 689V694H-93V683Q-97 617 -139 566T-250 515",
          775: "-310 609Q-310 637 -292 653T-248 669Q-225 667 -208 652T-191 609Q-191 579 -208 564T-250 549Q-275 549 -292 564T-310 609",
          776: "-405 612Q-405 633 -388 651T-347 669T-307 652T-290 612Q-290 588 -306 571T-348 554L-373 560Q-405 577 -405 612ZM-211 611Q-211 634 -196 649T-165 668Q-164 668 -160 668T-154 669Q-131 669 -114 652T-96 612T-113 572T-154 554Q-177 554 -194 570T-211 611",
          778: "-353 628Q-353 669 -321 692T-256 715Q-202 715 -175 689T-148 629Q-148 592 -177 567T-251 542Q-298 542 -325 567T-353 628ZM-187 628Q-187 660 -200 669T-241 678H-247Q-252 678 -258 678T-266 679Q-283 679 -293 674T-308 659T-312 644T-313 629Q-313 600 -302 590Q-290 579 -250 579H-235Q-221 579 -212 581T-195 595T-187 628",
          779: "-292 701Q-278 701 -262 690T-246 658Q-246 649 -250 641Q-252 637 -297 574T-344 510L-378 528Q-378 530 -355 598T-327 676Q-316 701 -292 701ZM-126 701Q-112 701 -96 690T-80 658Q-80 649 -84 641Q-86 637 -131 574T-178 510L-212 528Q-212 530 -189 598T-161 676Q-150 701 -126 701",
          780: "-386 611L-373 630L-364 644Q-362 644 -307 612Q-252 581 -250 581L-194 612Q-139 644 -137 644L-115 611L-182 562L-251 513L-386 611",
          824: "-612 -215T-619 -215T-631 -212T-637 -204T-639 -197Q-639 -190 -634 -183Q-621 -157 -400 274T-176 707Q-173 716 -160 716Q-153 716 -148 712T-142 703T-140 696Q-140 691 -372 241T-608 -212Q-612 -215 -619 -215",
          913: "255 0Q240 3 140 3Q48 3 39 0H32V46H47Q119 49 139 88Q140 91 192 245T295 553T348 708Q351 716 366 716H376Q396 715 400 709Q402 707 508 390L617 67Q624 54 636 51T687 46H717V0H708Q699 3 581 3Q458 3 437 0H427V46H440Q510 46 510 64Q510 66 486 138L462 209H229L209 150Q189 91 189 85Q189 72 209 59T259 46H264V0H255ZM447 255L345 557L244 256Q244 255 345 255H447",
          914: "131 622Q124 629 120 631T104 634T61 637H28V683H229H267H346Q423 683 459 678T531 651Q574 627 599 590T624 512Q624 461 583 419T476 360L466 357Q539 348 595 302T651 187Q651 119 600 67T469 3Q456 1 242 0H28V46H61Q103 47 112 49T131 61V622ZM511 513Q511 560 485 594T416 636Q415 636 403 636T371 636T333 637Q266 637 251 636T232 628Q229 624 229 499V374H312L396 375L406 377Q410 378 417 380T442 393T474 417T499 456T511 513ZM537 188Q537 239 509 282T430 336L329 337H229V200V116Q229 57 234 52Q240 47 334 47H383Q425 47 443 53Q486 67 511 104T537 188",
          915: "128 619Q121 626 117 628T101 631T58 634H25V680H554V676Q556 670 568 560T582 444V440H542V444Q542 445 538 478T523 545T492 598Q454 634 349 634H334Q264 634 249 633T233 621Q232 618 232 339L233 61Q240 54 245 52T270 48T333 46H360V0H348Q324 3 182 3Q51 3 36 0H25V46H58Q100 47 109 49T128 61V619",
          916: "51 0Q46 4 46 7Q46 9 215 357T388 709Q391 716 416 716Q439 716 444 709Q447 705 616 357T786 7Q786 4 781 0H51ZM507 344L384 596L137 92L383 91H630Q630 93 507 344",
          917: "128 619Q121 626 117 628T101 631T58 634H25V680H597V676Q599 670 611 560T625 444V440H585V444Q584 447 582 465Q578 500 570 526T553 571T528 601T498 619T457 629T411 633T353 634Q266 634 251 633T233 622Q233 622 233 621Q232 619 232 497V376H286Q359 378 377 385Q413 401 416 469Q416 471 416 473V493H456V213H416V233Q415 268 408 288T383 317T349 328T297 330Q290 330 286 330H232V196V114Q232 57 237 52Q243 47 289 47H340H391Q428 47 452 50T505 62T552 92T584 146Q594 172 599 200T607 247T612 270V273H652V270Q651 267 632 137T610 3V0H25V46H58Q100 47 109 49T128 61V619",
          918: "69 443Q69 452 74 554T80 683H549Q555 677 555 664Q555 649 554 648Q552 645 366 348T179 50T192 49T263 49H275H302Q333 49 353 50T401 59T447 78T482 115T507 173Q513 200 520 273V282H560V274Q560 272 552 143T543 8V0H302L61 1L58 3Q55 8 55 21V35Q59 43 153 193T340 489T432 637H343Q259 637 214 625T141 573Q109 523 109 445Q109 443 89 443H69",
          919: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H302Q262 636 251 634T233 622L232 500V378H517V622Q510 629 506 631T490 634T447 637H414V683H425Q446 680 569 680Q704 680 713 683H724V637H691Q651 636 640 634T622 622V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V332H232V197L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
          920: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM610 339Q610 428 590 495T535 598T463 651T384 668Q332 668 289 638T221 566Q168 485 168 339Q168 274 176 235Q189 158 228 105T324 28Q356 16 388 16Q415 16 442 24T501 54T555 111T594 205T610 339ZM223 263V422H263V388H514V422H554V263H514V297H263V263H223",
          921: "328 0Q307 3 180 3T32 0H21V46H43Q92 46 106 49T126 60Q128 63 128 342Q128 620 126 623Q122 628 118 630T96 635T43 637H21V683H32Q53 680 180 680T328 683H339V637H317Q268 637 254 634T234 623Q232 620 232 342Q232 63 234 60Q238 55 242 53T264 48T317 46H339V0H328",
          922: "128 622Q121 629 117 631T101 634T58 637H25V683H36Q57 680 180 680Q315 680 324 683H335V637H313Q235 637 233 620Q232 618 232 462L233 307L379 449Q425 494 479 546Q518 584 524 591T531 607V608Q531 630 503 636Q501 636 498 636T493 637H489V683H499Q517 680 630 680Q704 680 716 683H722V637H708Q633 633 589 597Q584 592 495 506T406 419T515 254T631 80Q644 60 662 54T715 46H736V0H728Q719 3 615 3Q493 3 472 0H461V46H469Q515 46 515 72Q515 78 512 84L336 351Q332 348 278 296L232 251V156Q232 62 235 58Q243 47 302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V622",
          923: "320 708Q326 716 340 716H348H355Q367 716 372 708Q374 706 423 547T523 226T575 62Q581 52 591 50T634 46H661V0H653Q644 3 532 3Q411 3 390 0H379V46H392Q464 46 464 65Q463 70 390 305T316 539L246 316Q177 95 177 84Q177 72 198 59T248 46H253V0H245Q230 3 130 3Q47 3 38 0H32V46H45Q112 51 127 91Q128 92 224 399T320 708",
          924: "132 622Q125 629 121 631T105 634T62 637H29V683H135Q221 683 232 682T249 675Q250 674 354 398L458 124L562 398Q666 674 668 675Q671 681 683 682T781 683H887V637H854Q814 636 803 634T785 622V61Q791 51 802 49T854 46H887V0H876Q855 3 736 3Q605 3 596 0H585V46H618Q660 47 669 49T688 61V347Q688 424 688 461T688 546T688 613L687 632Q454 14 450 7Q446 1 430 1T410 7Q409 9 292 316L176 624V606Q175 588 175 543T175 463T175 356L176 86Q187 50 261 46H278V0H269Q254 3 154 3Q52 3 37 0H29V46H46Q78 48 98 56T122 69T132 86V622",
          925: "42 46Q74 48 94 56T118 69T128 86V634H124Q114 637 52 637H25V683H232L235 680Q237 679 322 554T493 303L578 178V598Q572 608 568 613T544 627T492 637H475V683H483Q498 680 600 680Q706 680 715 683H724V637H707Q634 633 622 598L621 302V6L614 0H600Q585 0 582 3T481 150T282 443T171 605V345L172 86Q183 50 257 46H274V0H265Q250 3 150 3Q48 3 33 0H25V46H42",
          926: "47 509L55 676Q55 677 333 677T611 676L619 509Q619 508 599 508T579 510Q579 529 575 557T564 589Q550 594 333 594T102 589Q95 586 91 558T87 510Q87 508 67 508T47 509ZM139 260V445H179V394H487V445H527V260H487V311H179V260H139ZM50 0L42 180H62Q82 180 82 178Q82 133 89 105Q92 93 95 90T108 86Q137 83 333 83Q530 83 558 86Q568 87 571 90T577 105Q584 133 584 178Q584 180 604 180H624L616 0H50",
          927: "56 340Q56 423 86 494T164 610T270 680T388 705Q521 705 621 601T722 341Q722 260 693 191T617 75T510 4T388 -22T267 3T160 74T85 189T56 340ZM467 647Q426 665 388 665Q360 665 331 654T269 620T213 549T179 439Q174 411 174 354Q174 144 277 61Q327 20 385 20H389H391Q474 20 537 99Q603 188 603 354Q603 411 598 439Q577 592 467 647",
          928: "128 619Q121 626 117 628T101 631T58 634H25V680H724V634H691Q651 633 640 631T622 619V61Q628 51 639 49T691 46H724V0H713Q692 3 569 3Q434 3 425 0H414V46H447Q489 47 498 49T517 61V634H232V348L233 61Q239 51 250 49T302 46H335V0H324Q303 3 180 3Q45 3 36 0H25V46H58Q100 47 109 49T128 61V619",
          929: "130 622Q123 629 119 631T103 634T60 637H27V683H214Q237 683 276 683T331 684Q419 684 471 671T567 616Q624 563 624 489Q624 421 573 372T451 307Q429 302 328 301H234V181Q234 62 237 58Q245 47 304 46H337V0H326Q305 3 182 3Q47 3 38 0H27V46H60Q102 47 111 49T130 61V622ZM507 488Q507 514 506 528T500 564T483 597T450 620T397 635Q385 637 307 637H286Q237 637 234 628Q231 624 231 483V342H302H339Q390 342 423 349T481 382Q507 411 507 488",
          931: "666 247Q664 244 652 126T638 4V0H351Q131 0 95 0T57 5V6Q54 12 57 17L73 36Q89 54 121 90T182 159L305 299L56 644L55 658Q55 677 60 681Q63 683 351 683H638V679Q640 674 652 564T666 447V443H626V447Q618 505 604 543T559 605Q529 626 478 631T333 637H294H189L293 494Q314 465 345 422Q400 346 400 340Q400 338 399 337L154 57Q407 57 428 58Q476 60 508 68T551 83T575 103Q595 125 608 162T624 225L626 251H666V247",
          932: "36 443Q37 448 46 558T55 671V677H666V671Q667 666 676 556T685 443V437H645V443Q645 445 642 478T631 544T610 593Q593 614 555 625Q534 630 478 630H451H443Q417 630 414 618Q413 616 413 339V63Q420 53 439 50T528 46H558V0H545L361 3Q186 1 177 0H164V46H194Q264 46 283 49T309 63V339V550Q309 620 304 625T271 630H244H224Q154 630 119 601Q101 585 93 554T81 486T76 443V437H36V443",
          933: "55 551Q55 604 91 654T194 705Q240 705 277 681T334 624T367 556T385 498L389 474L392 488Q394 501 400 521T414 566T438 615T473 659T521 692T584 705Q620 705 648 689T691 647T714 597T722 551Q722 540 719 538T699 536Q680 536 677 541Q677 542 677 544T676 548Q676 576 650 596T588 616H582Q538 616 505 582Q466 543 454 477T441 318Q441 301 441 269T442 222V61Q448 55 452 53T478 48T542 46H569V0H557Q533 3 389 3T221 0H209V46H236Q256 46 270 46T295 47T311 48T322 51T328 54T332 57T337 61V209Q337 383 333 415Q313 616 189 616Q154 616 128 597T101 548Q101 540 97 538T78 536Q63 536 59 538T55 551",
          934: "312 622Q310 623 307 625T303 629T297 631T286 634T270 635T246 636T211 637H184V683H196Q220 680 361 680T526 683H538V637H511Q468 637 447 635T422 631T411 622V533L425 531Q525 519 595 466T665 342Q665 301 642 267T583 209T506 172T425 152L411 150V61Q417 55 421 53T447 48T511 46H538V0H526Q502 3 361 3T196 0H184V46H211Q231 46 245 46T270 47T286 48T297 51T303 54T307 57T312 61V150H310Q309 151 289 153T232 166T160 195Q149 201 136 210T103 238T69 284T56 342Q56 414 128 467T294 530Q309 532 310 533H312V622ZM170 342Q170 207 307 188H312V495H309Q301 495 282 491T231 469T186 423Q170 389 170 342ZM415 188Q487 199 519 236T551 342Q551 384 539 414T507 459T470 481T434 491T415 495H410V188H415",
          935: "270 0Q252 3 141 3Q46 3 31 0H23V46H40Q129 50 161 88Q165 94 244 216T324 339Q324 341 235 480T143 622Q133 631 119 634T57 637H37V683H46Q64 680 172 680Q297 680 318 683H329V637H324Q307 637 286 632T263 621Q263 618 322 525T384 431Q385 431 437 511T489 593Q490 595 490 599Q490 611 477 622T436 637H428V683H437Q455 680 566 680Q661 680 676 683H684V637H667Q585 634 551 599Q548 596 478 491Q412 388 412 387Q412 385 514 225T620 62Q628 53 642 50T695 46H726V0H717Q699 3 591 3Q466 3 445 0H434V46H440Q454 46 476 51T499 64Q499 67 463 124T390 238L353 295L350 292Q348 290 343 283T331 265T312 236T286 195Q219 88 218 84Q218 70 234 59T272 46H280V0H270",
          936: "340 622Q338 623 335 625T331 629T325 631T314 634T298 635T274 636T239 637H212V683H224Q248 680 389 680T554 683H566V637H539Q479 637 464 635T439 622L438 407Q438 192 439 192Q443 193 449 195T474 207T507 232T536 276T557 344Q560 365 562 417T573 493Q587 536 620 544Q627 546 671 546H715L722 540V515Q714 509 708 509Q680 505 671 476T658 392T644 307Q599 177 451 153L438 151V106L439 61Q446 54 451 52T476 48T539 46H566V0H554Q530 3 389 3T224 0H212V46H239Q259 46 273 46T298 47T314 48T325 51T331 54T335 57T340 61V151Q126 178 117 406Q115 503 69 509Q55 509 55 526Q55 541 59 543T86 546H107H120Q150 546 161 543T184 528Q198 514 204 493Q212 472 213 420T226 316T272 230Q287 216 303 207T330 194L339 192Q340 192 340 407V622",
          937: "55 454Q55 503 75 546T127 617T197 665T272 695T337 704H352Q396 704 404 703Q527 687 596 615T666 454Q666 392 635 330T559 200T499 83V80H543Q589 81 600 83T617 93Q622 102 629 135T636 172L637 177H677V175L660 89Q645 3 644 2V0H552H488Q461 0 456 3T451 20Q451 89 499 235T548 455Q548 512 530 555T483 622T424 656T361 668Q332 668 303 658T243 626T193 560T174 456Q174 380 222 233T270 20Q270 7 263 0H77V2Q76 3 61 89L44 175V177H84L85 172Q85 171 88 155T96 119T104 93Q109 86 120 84T178 80H222V83Q206 132 162 199T87 329T55 454",
          8192: "",
          8193: "",
          8194: "",
          8195: "",
          8196: "",
          8197: "",
          8198: "",
          8201: "",
          8202: "",
          8203: "",
          8204: "",
          8211: "0 248V285H499V248H0",
          8212: "0 248V285H999V248H0",
          8213: "0 248V285H999V248H0",
          8214: "133 736Q138 750 153 750Q164 750 170 739Q172 735 172 250T170 -239Q164 -250 152 -250Q144 -250 138 -244L137 -243Q133 -241 133 -179T132 250Q132 731 133 736ZM329 739Q334 750 346 750Q353 750 361 744L362 743Q366 741 366 679T367 250T367 -178T362 -243L361 -244Q355 -250 347 -250Q335 -250 329 -239Q327 -235 327 250T329 739",
          8215: "0 -62V-25H499V-62H0",
          8216: "64 494Q64 548 86 597T131 670T160 694Q163 694 172 685T182 672Q182 669 170 656T144 625T116 573T101 501Q101 489 102 489T107 491T120 497T138 500Q163 500 180 483T198 440T181 397T139 379Q110 379 87 405T64 494",
          8217: "78 634Q78 659 95 676T138 694Q166 694 189 668T212 579Q212 525 190 476T146 403T118 379Q114 379 105 388T95 401Q95 404 107 417T133 448T161 500T176 572Q176 584 175 584T170 581T157 576T139 573Q114 573 96 590T78 634",
          8220: "128 494Q128 528 137 560T158 616T185 658T209 685T223 694T236 685T245 670Q244 668 231 654T204 622T178 571T164 501Q164 489 165 489T170 491T183 497T201 500Q226 500 244 483T262 440T245 397T202 379Q173 379 151 405T128 494ZM332 494Q332 528 341 560T362 616T389 658T413 685T427 694T439 685T449 672Q449 669 437 656T411 625T383 573T368 501Q368 489 369 489T374 491T387 497T405 500Q430 500 448 483T466 440T449 397T406 379Q377 379 355 405T332 494",
          8221: "34 634Q34 659 50 676T93 694Q121 694 144 668T168 579Q168 525 146 476T101 403T73 379Q69 379 60 388T50 401Q50 404 62 417T88 448T116 500T131 572Q131 584 130 584T125 581T112 576T94 573Q69 573 52 590T34 634ZM238 634Q238 659 254 676T297 694Q325 694 348 668T372 579Q372 525 350 476T305 403T277 379Q273 379 264 388T254 401Q254 404 266 417T292 448T320 500T335 572Q335 584 334 584T329 581T316 576T298 573Q273 573 256 590T238 634",
          8224: "182 675Q195 705 222 705Q234 705 243 700T253 691T263 675L262 655Q262 620 252 549T240 454V449Q250 451 288 461T346 472T377 461T389 431Q389 417 379 404T346 390Q327 390 288 401T243 412H240V405Q245 367 250 339T258 301T261 274T263 225Q263 124 255 -41T239 -213Q236 -216 222 -216H217Q206 -216 204 -212T200 -186Q199 -175 199 -168Q181 38 181 225Q181 265 182 280T191 327T204 405V412H201Q196 412 157 401T98 390Q76 390 66 403T55 431T65 458T98 472Q116 472 155 462T205 449Q204 452 204 460T201 490T193 547Q182 619 182 655V675",
          8225: "181 658Q181 705 222 705T263 658Q263 633 252 572T240 497Q240 496 241 496Q243 496 285 507T345 519Q365 519 376 508T388 478Q388 466 384 458T375 447T361 438H344Q318 438 282 448T241 459Q240 458 240 456Q240 449 251 384T263 297Q263 278 255 267T238 253T222 250T206 252T190 266T181 297Q181 323 192 383T204 458Q204 459 203 459Q198 459 162 449T101 438H84Q74 443 70 446T61 457T56 478Q56 497 67 508T99 519Q117 519 159 508T203 496Q204 496 204 499Q204 507 193 572T181 658ZM181 202Q181 249 222 249T263 202Q263 185 259 161T249 103T240 48V41H243Q248 41 287 52T346 63T377 52T389 22Q389 8 379 -5T346 -19Q327 -19 288 -8T243 3H240V-4Q243 -24 249 -58T259 -117T263 -158Q263 -177 255 -188T238 -202T222 -205T206 -203T190 -189T181 -158Q181 -141 185 -117T195 -59T204 -4V3H201Q196 3 157 -8T98 -19Q76 -19 66 -6T55 22T65 49T98 63Q117 63 156 52T201 41H204V48Q201 68 195 102T185 161T181 202",
          8226: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251",
          8230: "78 60Q78 84 95 102T138 120Q162 120 180 104T199 61Q199 36 182 18T139 0T96 17T78 60ZM525 60Q525 84 542 102T585 120Q609 120 627 104T646 61Q646 36 629 18T586 0T543 17T525 60ZM972 60Q972 84 989 102T1032 120Q1056 120 1074 104T1093 61Q1093 36 1076 18T1033 0T990 17T972 60",
          8242: "79 43Q73 43 52 49T30 61Q30 68 85 293T146 528Q161 560 198 560Q218 560 240 545T262 501Q262 496 260 486Q259 479 173 263T84 45T79 43",
          8245: "12 501Q12 527 31 542T63 558Q73 560 77 560Q114 560 128 528Q133 518 188 293T244 61Q244 56 223 50T195 43Q192 43 190 45T102 263T14 486Q12 496 12 501",
          8254: "69 544V590H430V544H69",
          8260: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
          8288: "",
          8289: "",
          8290: "",
          8291: "",
          8292: "",
          8407: "377 694Q377 702 382 708T397 714Q404 714 409 709Q414 705 419 690Q429 653 460 633Q471 626 471 615Q471 606 468 603T454 594Q411 572 379 531Q377 529 374 525T369 519T364 517T357 516Q350 516 344 521T337 536Q337 555 384 595H213L42 596Q29 605 29 615Q29 622 42 635H401Q377 673 377 694",
          8450: "684 131Q684 125 672 109T633 71T573 29T489 -5T386 -19Q330 -19 276 -3T174 46T91 134T44 261Q39 283 39 341T44 421Q66 538 143 611T341 699Q344 699 364 700T395 701Q449 698 503 677T585 655Q603 655 611 662T620 678T625 694T639 702Q650 702 657 690V481L653 474Q640 467 628 472Q624 476 618 496T595 541Q562 587 507 625T390 663H381Q337 663 299 625Q212 547 212 336Q212 249 233 179Q274 30 405 30Q533 30 641 130Q658 147 666 147Q671 147 677 143T684 131ZM250 625Q264 643 261 643Q238 635 214 620T161 579T110 510T79 414Q74 384 74 341T79 268Q89 213 113 169T164 101T217 61T260 39L277 34Q270 41 264 48Q199 111 181 254Q178 281 178 344T181 434Q200 559 250 625ZM621 565V625Q617 623 613 623Q603 619 590 619H575L588 605Q608 583 610 579L621 565",
          8459: "331 505Q331 519 382 574T472 629H480Q512 629 529 614T547 576Q547 555 534 532T520 504Q520 493 549 493Q590 493 623 506T668 533L681 546Q731 600 772 641T832 700T852 717Q857 717 860 711T865 697L866 690Q866 688 813 617T708 475T656 403Q682 403 714 404H771L780 416Q1004 707 1167 707Q1209 707 1225 689T1241 646Q1241 604 1209 547T1118 447Q1081 422 1034 405T952 382T888 374T857 370H852L826 334Q733 204 708 144Q691 104 691 76Q691 29 748 29Q768 31 791 48T831 83T862 122T881 146Q883 148 900 148H917Q921 143 921 140T914 127Q810 -8 723 -8Q611 -4 611 100Q611 142 631 191T676 275T721 337T742 367Q716 367 685 366H628L620 355Q618 352 558 268Q486 168 461 141Q405 79 339 34T215 -28Q188 -36 153 -36Q86 -36 58 -11T29 46Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 60Q67 28 99 14T170 0Q214 0 272 47T419 224L505 340L518 357Q513 357 504 356T467 347T415 330T360 300T308 253Q296 238 295 237H278H274Q256 237 256 243Q256 248 263 256Q291 294 330 321T407 362T476 382T530 393T552 398Q556 402 573 423T600 454Q602 457 604 460T608 465L610 467Q565 455 532 455Q465 455 449 483Q447 487 447 498Q447 513 463 538T479 579Q479 593 463 593Q436 593 385 519Q374 504 371 502T360 499H353H349Q331 499 331 505ZM1195 634Q1195 643 1195 648T1185 662T1157 671Q1130 671 1092 644T1019 579T952 502T901 436L882 409L891 410Q900 411 913 412T934 415Q1081 439 1144 520Q1195 590 1195 634",
          8460: "11 -16L1 0Q7 6 25 27T57 62T91 88T128 101Q159 99 195 66L203 59L211 67Q239 95 239 133Q239 158 210 213T152 330T123 430Q123 477 173 536T269 630T320 666Q376 610 440 606H443Q457 606 466 611T519 647L542 664Q543 664 543 654V643L522 622Q434 537 403 537Q388 537 366 543T329 555T293 570T270 580L261 585L253 574Q206 517 206 475Q206 452 218 416T242 356L255 331Q256 331 270 345T324 391T421 459L437 468H453Q545 463 608 421L618 415L623 392Q644 307 644 233Q644 97 612 9Q604 -10 601 -15T581 -35Q505 -104 467 -124Q446 -133 431 -133Q414 -132 399 -126T376 -115T368 -107Q368 -106 392 -75L415 -43Q432 -67 444 -73T472 -79H474Q479 -79 484 -78T501 -69T521 -50T538 -13T551 46Q558 97 558 180Q558 232 557 245Q553 277 547 300T528 349T488 389T424 404Q344 404 276 295Q272 288 273 285Q300 216 300 168Q300 161 300 156T298 145T297 137T293 129T289 123T283 116T277 107Q212 23 178 -13L166 -26L149 -9Q108 32 81 32Q63 32 21 -7L11 -16",
          8461: "14 666Q14 675 26 683H344L351 679Q361 665 351 655Q344 648 317 648Q287 645 282 641Q270 637 269 623T266 497V370H511V497Q511 519 510 553Q509 615 507 626T496 641H495Q489 645 459 648Q420 648 420 665Q420 672 426 679L433 683H751Q762 676 762 666Q762 648 724 648Q684 645 677 632Q675 626 675 341Q675 57 677 52Q684 38 724 35Q762 35 762 16Q762 6 751 -1H433L426 3Q420 10 420 17Q420 35 459 35Q501 38 506 52Q511 64 511 190V323H266V190Q266 60 271 52Q276 38 317 35Q342 35 351 28Q360 17 351 3L344 -1H26Q14 5 14 16Q14 35 53 35Q94 38 99 52Q104 60 104 341T99 632Q93 645 53 648Q14 648 14 666ZM233 341V553Q233 635 239 648H131Q134 641 135 638T137 603T139 517T139 341Q139 131 138 89T132 37Q131 36 131 35H239Q233 47 233 129V341ZM639 341V489Q639 548 639 576T640 620T642 639T646 648H537L542 639Q546 625 546 341Q546 130 545 88T538 37Q537 36 537 35H646Q643 41 643 42T641 55T639 84T639 140V341",
          8462: "137 683Q138 683 209 688T282 694Q294 694 294 685Q294 674 258 534Q220 386 220 383Q220 381 227 388Q288 442 357 442Q411 442 444 415T478 336Q478 285 440 178T402 50Q403 36 407 31T422 26Q450 26 474 56T513 138Q516 149 519 151T535 153Q555 153 555 145Q555 144 551 130Q535 71 500 33Q466 -10 419 -10H414Q367 -10 346 17T325 74Q325 90 361 192T398 345Q398 404 354 404H349Q266 404 205 306L198 293L164 158Q132 28 127 16Q114 -11 83 -11Q69 -11 59 -2T48 16Q48 30 121 320L195 616Q195 629 188 632T149 637H128Q122 643 122 645T124 664Q129 683 137 683",
          8463: "150 475Q147 475 118 466T82 457Q73 457 64 467T54 487Q54 490 55 492Q63 506 64 506Q67 512 118 526Q162 541 169 546Q173 559 175 575Q181 596 181 604Q181 613 166 617Q164 617 153 618T135 619Q119 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 291 628L278 577L386 612Q466 635 476 635T492 627T499 607Q499 593 489 586Q485 583 373 546L262 512Q262 511 248 455T233 397T236 397T244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26Q42 45 98 257L151 475H150",
          8464: "487 225Q398 255 398 342Q398 410 455 492Q491 545 552 582T669 636T800 673T918 712Q930 717 933 717Q939 717 942 706T946 689Q946 686 915 664T830 591T729 480Q691 429 657 351T615 260Q628 260 663 279T733 339T769 426Q769 442 767 459T764 479Q764 484 766 486Q769 488 781 493T797 498Q802 498 803 494T808 472Q813 442 813 425Q813 369 761 315Q692 246 605 224L592 220L584 209Q547 155 487 106T358 25Q270 -17 191 -17Q143 -17 101 1T59 59Q59 96 85 127T148 158Q169 158 179 146T189 119Q189 102 167 89T125 75Q116 75 109 77T101 81T97 80Q96 77 96 72Q96 50 123 36T204 21H216Q249 21 302 49T411 134Q439 161 459 187Q487 220 487 225ZM460 334Q460 308 472 290T498 268L510 263Q515 263 545 313T626 438T723 561Q751 589 775 609T808 636T817 644H816Q813 644 732 618Q681 601 645 584T585 548T549 514T518 476Q460 390 460 334",
          8465: "190 601Q161 601 137 587T97 553T71 512T55 477T48 463Q44 465 39 468L30 473L35 488Q73 594 106 636T199 685Q200 686 211 686Q250 686 326 652T417 617Q435 617 455 626T497 652T522 670Q532 660 532 654Q469 591 390 550L378 543L343 556Q223 601 190 601ZM378 208Q378 249 369 318T360 424Q360 430 360 439T361 451L362 462Q416 526 482 571L495 580L503 577L511 575L499 562Q442 502 442 465Q442 436 452 368T462 246Q462 169 442 128T385 56Q292 -26 195 -26Q150 -26 104 14L96 21L43 -16Q43 -15 43 -14T41 -10T38 0L48 13Q76 50 123 97L150 125Q154 131 159 131Q166 131 171 116T182 81T193 53Q199 43 216 33T261 22Q307 22 344 68Q378 113 378 208",
          8466: "572 704Q607 704 607 693Q607 681 590 664H588Q586 664 584 664T578 663Q504 658 434 592T363 457Q363 426 386 401Q417 371 481 361Q490 360 527 360H562Q565 363 595 404T666 494T755 596T854 682T945 717Q986 717 1010 696T1035 637Q1035 593 996 531T873 414Q809 378 753 360T674 338T651 333Q650 333 633 308T588 245T544 185Q498 126 426 78L413 68H414Q498 47 575 47Q626 47 676 74T755 139L762 148H779H783Q802 148 802 142Q802 137 795 129Q760 81 691 33T544 -16Q470 -16 366 20L341 29L331 24Q239 -17 155 -17H141Q90 -17 61 -12T23 1T14 22Q14 44 39 65T103 95Q126 101 180 101Q224 101 258 98T309 90T330 86Q332 86 353 103T389 135Q401 146 412 158T431 179T450 203T466 225T485 252T505 280L535 322H509Q391 322 340 362T289 452Q289 495 321 547T396 630Q438 665 486 684T572 704ZM978 635Q978 644 977 650T973 661T968 668T961 673T954 676T946 678T938 680Q929 680 925 677Q893 659 795 531T682 377Q683 377 711 385T755 401T801 421T856 453T906 495Q927 516 952 557T978 635ZM274 50Q274 51 258 54T216 61T166 65Q160 65 151 65T140 64Q115 58 102 48T88 31Q88 20 159 20Q191 20 219 27T261 42L274 50",
          8467: "345 104T349 104T361 95T369 80T352 59Q268 -20 206 -20Q170 -20 146 3T113 53T99 104L94 129Q94 130 79 116T48 86T28 70Q22 70 15 79T7 94Q7 98 12 103T58 147L91 179V185Q91 186 91 191T92 200Q92 282 128 400T223 612T336 705Q397 705 397 636V627Q397 453 194 233Q185 223 180 218T174 211T171 208T165 201L163 186Q159 142 159 123Q159 17 208 17Q228 17 253 30T293 56T335 94Q345 104 349 104ZM360 634Q360 655 354 661T336 668Q328 668 322 666T302 645T272 592Q252 547 229 467T192 330L179 273Q179 272 186 280T204 300T221 322Q327 453 355 590Q360 612 360 634",
          8469: "20 664Q20 666 31 683H142Q256 683 258 681Q259 680 279 653T342 572T422 468L582 259V425Q582 451 582 490T583 541Q583 611 573 628T522 648Q500 648 493 654Q484 665 493 679L500 683H691Q702 676 702 666Q702 657 698 652Q688 648 680 648Q633 648 627 612Q624 601 624 294V-8Q616 -20 607 -20Q601 -20 596 -15Q593 -13 371 270L156 548L153 319Q153 284 153 234T152 167Q152 103 156 78T172 44T213 34Q236 34 242 28Q253 17 242 3L236 -1H36Q24 6 24 16Q24 34 56 34Q58 35 69 36T86 40T100 50T109 72Q111 83 111 345V603L96 619Q72 643 44 648Q20 648 20 664ZM413 419L240 648H120L136 628Q137 626 361 341T587 54L589 68Q589 78 589 121V192L413 419",
          8472: "300 74Q300 133 338 133Q350 133 356 126T363 109Q363 88 340 76Q340 71 342 62T358 39T393 26Q435 26 474 67T532 182T551 290Q551 325 535 349T484 373Q430 373 378 348T291 289T228 218T187 157T174 130Q254 30 265 10Q276 -15 276 -41Q276 -101 235 -158T142 -216Q112 -216 90 -195T67 -118Q67 -40 104 64L110 81Q81 118 81 174Q81 268 134 360T247 453Q252 453 255 451T258 447L259 445Q259 432 253 420Q251 416 242 416Q209 411 176 341T142 203Q142 193 143 184T146 170T149 165L158 180Q215 280 303 345T485 410Q548 410 586 368T625 255Q625 157 553 74T389 -10H383Q349 -10 325 14Q302 37 300 74ZM105 -123Q105 -134 106 -141T110 -158T122 -173T145 -178Q155 -178 160 -176Q184 -163 199 -132T214 -73Q214 -69 214 -66T213 -59T212 -53T209 -47T205 -41T199 -33T193 -25T184 -14T174 -1L165 10Q156 22 148 32L139 43Q138 43 130 15T113 -54T105 -123",
          8473: "16 666Q16 675 28 683H195Q334 683 370 682T437 672Q511 657 554 611T597 495Q597 343 404 309Q402 308 401 308Q381 303 319 303H261V181Q261 157 262 120Q262 60 267 50T304 36Q310 35 313 35Q352 35 352 17Q352 10 346 3L339 -1H28Q16 5 16 16Q16 35 53 35Q68 36 75 37T87 42T95 52Q98 61 98 341T95 630Q91 640 83 643T53 648Q16 648 16 666ZM235 35Q228 46 227 84Q226 129 226 337V621L230 635L237 648H128Q128 647 133 632Q136 620 136 341Q136 64 133 50L128 35H235ZM301 341H313Q339 341 354 344T389 362T417 410T426 498Q426 586 401 616T322 647Q301 647 293 643Q271 637 264 621Q261 617 261 479V341H301ZM429 350Q431 350 443 353T476 367T515 391T548 432T562 490Q562 550 524 592Q507 607 484 619Q481 621 448 635L433 639L439 621Q462 578 462 506Q462 448 454 413T437 366T428 350H429",
          8474: "480 -10Q480 -13 486 -24T507 -50T541 -80T588 -104T648 -114Q666 -114 688 -110T714 -106Q724 -106 728 -114T729 -130Q723 -145 663 -163T548 -181Q503 -181 463 -169T395 -139T343 -97T307 -56T284 -19L280 -3L262 1Q188 24 131 81Q57 155 37 275Q34 292 34 342T37 410Q58 528 131 601Q179 652 248 676T388 701Q485 701 562 661Q698 595 731 448Q742 410 742 341T731 235Q707 141 646 81Q616 50 575 27T493 -5L480 -10ZM568 342Q568 613 437 659L395 666Q329 666 286 626Q232 570 213 439Q210 408 210 342T213 246Q231 113 286 57Q309 37 342 23Q357 19 389 19Q420 19 437 23Q469 38 491 57Q568 134 568 342ZM174 341V354Q174 393 175 419T183 484T205 561T246 635L249 639Q246 639 224 627T193 608Q189 606 183 601T169 589T155 577Q69 491 69 344Q69 133 231 52Q247 42 247 46Q247 46 246 48Q231 69 222 85T200 141T177 239Q174 269 174 341ZM708 341Q708 410 689 467T640 556T588 606T546 630Q532 638 531 638Q530 638 531 635Q563 590 577 543Q602 472 602 341V316Q602 264 599 230T580 144T531 48Q529 44 532 45T546 52Q575 68 596 84T642 128T683 200T706 299Q708 327 708 341ZM391 -17H333Q329 -15 326 -15Q324 -15 324 -17Q324 -21 362 -68Q424 -130 506 -143Q518 -144 544 -144Q569 -144 577 -143L589 -141L575 -139Q544 -127 509 -101T453 -37L442 -19L391 -17",
          8475: "224 266Q185 266 156 286T127 354Q127 419 176 487T282 594Q346 642 433 679T615 717Q732 717 802 680L815 673Q824 680 840 690T860 700Q864 700 867 693T872 680L873 673Q873 668 858 659L845 651L853 642Q887 605 887 561Q887 500 840 439Q790 379 681 336Q693 312 693 292Q692 276 689 263T672 229T653 198T620 152L575 87Q557 57 557 33Q557 24 560 17T566 8L569 5Q546 5 508 25T470 76Q470 83 473 92T545 198T616 310Q616 317 615 318T612 319Q603 319 575 315H560L545 291Q492 201 429 135T277 23Q202 -17 142 -17H130Q50 -17 16 17Q-2 35 -2 57Q-2 95 24 126T88 158Q106 158 116 147T127 121Q127 110 122 102Q116 93 99 84T63 75Q58 75 53 76T47 77T45 75T44 67Q45 52 57 42T88 27T120 21T144 19Q174 19 208 36T267 76T324 134T369 189T406 239Q462 319 504 374T616 503T755 631L770 644Q767 647 753 654T697 670T602 680Q493 680 399 631T247 516Q218 485 193 440T168 359Q168 328 188 316T234 303Q255 303 273 315T304 340T343 389T390 448Q428 490 441 510T456 548Q456 557 458 559Q459 560 476 567T496 575Q505 575 505 558Q505 511 434 412Q429 406 427 403Q397 360 378 343Q342 308 300 287T224 266ZM819 564Q819 595 800 619L784 606Q729 557 692 512T605 387L591 365L610 364Q622 364 631 363T641 361Q643 361 651 363Q725 388 772 449T819 564ZM794 141Q794 123 725 63T612 3Q609 3 612 5Q612 5 615 7Q639 19 678 57T742 131L755 148H772H780Q794 148 794 141ZM588 -3Q590 0 593 0H594L593 -1Q592 -1 590 -2L588 -3",
          8476: "27 496Q31 569 102 627T234 685Q236 685 241 685T251 686Q287 686 318 672T367 638T399 598T418 564L423 550Q424 554 434 567T463 601T505 639T561 671T626 685Q672 685 688 659T710 572Q713 533 721 523T766 513Q781 513 787 514T794 516Q796 512 798 509T801 504T802 501T787 493Q702 461 624 401L607 389Q655 383 688 358L697 352V342Q699 330 699 297Q704 209 710 173T734 103Q751 69 765 69Q769 69 806 83L824 90V74Q823 73 759 24T693 -26Q692 -26 660 32L628 90L629 111Q631 159 631 177Q631 278 614 300Q584 340 523 340Q500 340 467 333T431 325Q429 325 429 322Q428 321 426 308T420 275T410 230T392 178T366 125L358 112L342 99Q306 70 269 38T213 -10T193 -26Q192 -26 163 0T116 26Q82 26 50 -8L42 -16L35 -8L27 0L35 10Q43 21 58 38T104 80T158 106Q179 106 218 65L235 48Q238 48 255 60T295 99T329 158Q352 231 352 359Q352 555 242 614Q210 628 187 628Q140 628 116 600T91 548Q91 522 138 464T185 382V376Q185 345 158 313T103 263L76 246Q74 244 64 253L54 260L65 267Q91 285 100 302Q111 318 111 337Q111 355 69 410T27 496ZM562 628Q504 628 443 507L435 491L436 479Q437 471 437 446Q437 396 432 351L529 389L602 426Q673 462 673 463H672Q644 470 637 483T622 553Q608 628 562 628",
          8477: "17 665Q17 672 28 683H221Q415 681 439 677Q461 673 481 667T516 654T544 639T566 623T584 607T597 592T607 578T614 565T618 554L621 548Q626 530 626 497Q626 447 613 419Q578 348 473 326L455 321Q462 310 473 292T517 226T578 141T637 72T686 35Q705 30 705 16Q705 7 693 -1H510Q503 6 404 159L306 310H268V183Q270 67 271 59Q274 42 291 38Q295 37 319 35Q344 35 353 28Q362 17 353 3L346 -1H28Q16 5 16 16Q16 35 55 35Q96 38 101 52Q106 60 106 341T101 632Q95 645 55 648Q17 648 17 665ZM241 35Q238 42 237 45T235 78T233 163T233 337V621L237 635L244 648H133Q136 641 137 638T139 603T141 517T141 341Q141 131 140 89T134 37Q133 36 133 35H241ZM457 496Q457 540 449 570T425 615T400 634T377 643Q374 643 339 648Q300 648 281 635Q271 628 270 610T268 481V346H284Q327 346 375 352Q421 364 439 392T457 496ZM492 537T492 496T488 427T478 389T469 371T464 361Q464 360 465 360Q469 360 497 370Q593 400 593 495Q593 592 477 630L457 637L461 626Q474 611 488 561Q492 537 492 496ZM464 243Q411 317 410 317Q404 317 401 315Q384 315 370 312H346L526 35H619L606 50Q553 109 464 243",
          8484: "39 -1Q29 9 29 12Q29 23 60 77T219 337L410 648H364Q261 648 210 628Q168 612 142 588T109 545T97 509T88 490Q85 489 80 489Q72 489 61 503L70 588Q72 607 75 628T79 662T81 675Q84 677 88 681Q90 683 341 683H592Q604 673 604 666Q604 662 412 348L221 37Q221 35 301 35Q406 35 446 48Q504 68 543 111T597 212Q602 239 617 239Q624 239 629 234T635 223Q635 215 621 113T604 8L597 1Q595 -1 317 -1H39ZM148 637L166 648H112V632Q111 629 110 622T108 612Q108 608 110 608T116 612T129 623T148 637ZM552 646Q552 648 504 648Q452 648 450 643Q448 639 266 343T77 37Q77 35 128 35H179L366 339L552 646ZM572 35Q581 89 581 97L561 77Q542 59 526 48L508 37L539 35H572",
          8486: "55 454Q55 503 75 546T127 617T197 665T272 695T337 704H352Q396 704 404 703Q527 687 596 615T666 454Q666 392 635 330T559 200T499 83V80H543Q589 81 600 83T617 93Q622 102 629 135T636 172L637 177H677V175L660 89Q645 3 644 2V0H552H488Q461 0 456 3T451 20Q451 89 499 235T548 455Q548 512 530 555T483 622T424 656T361 668Q332 668 303 658T243 626T193 560T174 456Q174 380 222 233T270 20Q270 7 263 0H77V2Q76 3 61 89L44 175V177H84L85 172Q85 171 88 155T96 119T104 93Q109 86 120 84T178 80H222V83Q206 132 162 199T87 329T55 454",
          8487: "126 584Q119 584 110 539T97 493Q95 490 73 490Q44 490 44 501Q44 515 62 590Q75 672 82 679Q84 684 177 684Q193 684 214 684T241 685Q265 685 271 682T277 664V648Q271 572 229 434T186 231Q186 173 203 132T247 70T302 42T360 33Q391 33 419 42T474 72T517 133T533 231Q533 297 491 437T442 648Q442 675 446 679Q448 684 542 684Q635 684 637 681Q640 678 657 594T675 501Q675 490 646 490Q624 490 622 493Q620 493 609 538T593 584Q591 585 585 585T569 586T551 588H513Q514 586 518 573T538 531T582 453Q647 340 660 277Q663 259 663 232Q663 194 657 177Q652 151 629 112T560 39Q495 -5 424 -19Q403 -22 360 -22Q318 -22 297 -19Q239 -8 193 18T120 74T80 131T62 177Q56 194 56 229Q56 281 74 328T137 453Q160 491 174 518T193 555T201 575T206 588H168Q160 587 150 587T134 586T126 584",
          8488: "148 590Q95 592 91 627V633L160 729H176Q169 713 169 705Q169 670 244 670Q269 670 305 672T357 675Q405 675 432 661T468 609Q469 605 469 596Q469 572 460 540Q433 463 301 372Q325 378 359 378Q431 378 472 350T519 297Q532 249 532 198Q532 115 500 40T442 -57Q335 -139 202 -139Q165 -139 125 -131L112 -129V-100Q112 -49 106 -33T75 -17Q55 -17 31 -35L22 -42L11 -26L22 -18Q94 36 151 36H160Q171 36 178 33T188 27T194 13T196 -5T197 -32Q198 -79 206 -90Q217 -107 251 -107Q336 -107 389 -33T442 155Q442 240 407 274Q362 319 285 319Q236 319 192 298Q188 298 181 309L224 372Q227 373 234 374T246 376T257 379T271 384T285 391T302 402T321 417Q384 471 384 540Q384 562 366 581T306 600Q292 600 233 595T148 590",
          8492: "256 262Q161 262 161 351Q161 408 203 471T289 570Q380 645 475 676T617 707L627 708Q637 708 644 708Q759 708 831 675L844 669L857 677Q892 700 896 700Q902 700 907 685Q907 683 907 681T908 678T909 676T909 673Q909 671 909 670T906 667T903 664T897 660T889 655L878 647L889 636Q928 598 928 548Q928 529 923 510T907 474T886 442T861 412T837 388T815 368T800 355Q847 323 847 270V263Q847 205 806 145Q766 82 695 37T564 -8Q527 -8 506 10T484 58Q484 85 501 117T543 172Q607 226 685 228Q695 228 698 226Q703 220 692 206Q684 194 682 193T665 191Q625 189 595 172T550 133T529 93T522 66Q522 29 576 29Q642 29 705 109Q785 211 785 270Q785 287 779 300T769 316T755 327L740 319Q682 290 634 290Q611 290 592 294H588L565 261Q559 252 544 231T522 201T504 178T481 151T455 123Q394 63 314 18T159 -28Q103 -28 67 -6T31 54Q31 88 57 123T123 158Q144 158 154 146T164 119Q164 102 142 89T100 75Q94 75 87 77T76 80L72 81Q69 78 69 65Q69 35 102 22T175 9Q184 9 198 11Q248 23 300 70T403 187T508 331T636 489T789 629L801 639Q796 642 786 647T732 661T633 670Q592 670 558 665Q481 651 409 613T286 520Q274 507 258 485T222 424T202 354Q202 299 269 299Q282 299 295 301T318 307T339 317T358 329T376 345T391 362T406 380T420 398T433 417T445 435Q496 512 496 547Q496 559 497 560T516 569Q526 574 530 574Q538 574 538 540Q538 414 427 325Q342 262 256 262ZM689 382Q708 382 753 375L765 387Q860 482 860 555Q860 594 839 610L822 592Q794 563 752 511T680 420T651 380Q655 381 660 381Q664 382 689 382ZM697 344Q692 345 681 345H675Q671 345 665 345T655 344T650 344L648 342Q646 339 645 338Q643 333 639 327H653Q670 329 676 330Q706 342 706 343Q702 344 697 344",
          8493: "299 585Q333 609 384 634T470 672L505 685Q506 685 513 662T531 613T548 580Q553 576 563 576Q575 576 605 585Q607 585 607 575V564Q537 532 496 527Q475 542 456 567T427 610T415 627Q410 627 398 618T382 603Q373 588 373 558T386 475T400 399Q400 337 366 303Q343 281 309 266T254 247T226 242L214 257Q214 258 223 260T251 272T287 299Q304 316 304 360Q304 396 289 451T274 532Q274 553 277 561V564H269Q205 558 172 501T139 358Q139 207 226 127T443 46Q448 46 457 46T470 47L485 48L601 106Q602 106 602 93V80Q551 48 517 25T474 -4T460 -13T443 -19Q409 -24 367 -24Q360 -24 351 -24T335 -23T326 -22Q190 -2 125 87T59 319V328Q62 412 96 487L101 500L118 512Q189 563 245 591L266 601L299 585",
          8496: "280 398L279 400Q278 402 277 405T275 413T272 426T271 443Q271 494 302 544T379 629T472 685T553 707H565H573Q630 707 664 689Q718 661 718 604Q718 548 662 492T553 436Q525 436 508 451T490 492Q490 534 531 579T619 630Q632 630 632 623Q632 619 624 606Q614 593 602 592T578 580Q566 568 549 541T532 497Q532 474 565 474Q577 474 587 476Q600 481 611 489Q630 503 651 535T672 596Q672 660 553 660H548Q494 660 450 616Q421 587 384 531T343 439Q341 420 344 415H345Q346 415 352 415T369 417T391 418Q421 418 440 412T466 398T473 382Q473 367 452 353T398 339Q370 339 348 345T315 359L304 366Q297 365 284 360T234 321T163 234Q120 160 120 117Q120 83 149 57T252 30Q311 30 357 60Q386 79 414 114T452 179Q454 186 454 200Q454 230 415 242Q401 246 373 246Q353 246 347 244Q328 236 313 219T288 184T274 149T265 121T261 109Q260 107 247 102T230 97Q223 97 223 105Q223 148 271 216T386 284Q446 284 483 260T520 195Q520 121 427 57T239 -8Q192 -8 152 2T79 46T46 133Q46 212 107 285T269 394L280 398ZM427 376Q427 377 402 380Q386 380 386 379L425 375L427 376",
          8497: "258 428Q258 489 322 562T482 685T661 735Q726 735 824 693T977 651Q990 651 990 644Q990 639 971 612T948 581Q947 580 938 580Q878 580 784 621T617 663Q544 663 480 635T379 568T320 492T299 431Q299 387 362 387Q404 387 438 402T493 438T527 486T546 531T551 563Q551 569 550 575T549 584T549 590Q551 593 563 602T579 611Q584 611 592 605T608 584T616 548Q616 513 595 477T554 423Q518 392 464 372T349 351Q258 351 258 428ZM324 187T305 187T286 196Q286 202 301 217Q327 242 383 262T484 290L527 297L567 356Q624 441 643 467T688 521Q715 550 752 581T795 613T804 603T808 587T778 547T702 444T626 300H637Q663 302 685 306L697 308L703 317Q745 376 792 400Q806 406 818 406Q849 406 849 375Q847 355 831 338T797 312T763 296L747 290Q744 289 735 266T724 241Q722 240 702 232T664 217T645 210Q638 210 638 218Q638 224 653 246T669 270Q669 271 668 271Q663 270 624 264L607 263Q570 199 529 152Q513 133 484 106T409 45T305 -13T193 -36Q109 -36 74 -10T39 50Q39 86 64 121T128 158Q171 158 171 121Q171 97 141 83Q125 75 107 75Q93 75 80 83Q76 71 76 62Q76 29 117 15T207 0Q324 0 494 248L501 258H495Q368 239 330 195Q324 187 305 187ZM775 335Q806 358 806 368Q805 369 804 369Q800 369 791 360Q774 336 775 335",
          8498: "457 681Q471 695 477 695Q485 695 497 681V12L484 -1H68Q55 14 55 19T68 39H457V328H215L211 335Q198 346 211 359L217 368H457V681",
          8499: "112 -7Q86 -7 58 6T30 48T54 103T113 130Q129 130 141 121T153 94Q153 71 132 59T90 47H80Q95 30 133 30Q180 30 228 63T311 137T402 249T500 361Q566 425 703 529T910 693Q942 721 945 721T958 716T970 709Q974 704 964 691Q961 688 905 622T847 554L595 181Q553 121 527 77T496 19L492 5Q497 5 531 46Q579 98 685 224T850 409L972 524Q994 543 1004 556Q1012 567 1097 643T1186 720Q1194 720 1206 715T1215 703Q1215 701 1191 671T1133 599T1080 530Q1036 461 983 357T862 152Q802 64 799 17Q799 7 800 5T811 2Q836 2 882 37T969 126Q972 130 974 134T978 138T983 139T996 140H1012Q1018 134 1018 132Q1018 122 981 83T889 4T795 -35Q761 -35 745 -12T728 48Q728 122 781 190Q833 269 890 370L927 434L914 422Q848 360 752 245Q643 117 582 51T498 -33T461 -50Q424 -48 424 -4Q424 84 481 172L714 495Q591 406 523 333Q507 316 430 226T313 95Q263 48 221 24T162 -4T120 -7H112",
          8501: "55 613Q55 643 61 663T74 688T85 694Q94 694 94 681Q98 632 134 588L412 285Q416 311 430 397T447 509V519L438 526Q407 554 398 571T388 617T394 664T407 688T418 694Q425 694 427 684Q429 675 454 635T488 586Q490 584 496 579T513 563T537 540Q555 516 555 487Q555 460 549 441T537 416T528 409Q519 409 517 415T513 435T503 463Q492 481 490 481Q454 264 454 246Q454 237 479 212T529 152T555 79Q555 32 538 9Q531 1 524 1Q516 1 516 13Q512 62 476 106Q468 115 337 258T195 412L193 406Q191 401 189 394T183 377T176 352T171 322T167 284T165 240Q165 224 166 220Q171 199 211 152T252 70Q252 45 235 29T203 8T175 1Q170 0 115 0H79Q60 0 58 3T55 20Q55 31 58 34Q60 37 76 37Q112 39 126 46T140 70Q140 96 112 148T83 236Q83 281 102 334T140 419T159 452Q55 556 55 613",
          8502: "56 706V726Q56 763 76 763Q83 763 87 759T98 741Q108 726 116 721L127 717L340 715Q547 712 564 709Q575 705 587 692Q599 680 605 663L609 650V137H676Q687 124 687 115Q687 110 678 100T622 43L558 -21H-9Q-22 -6 -22 -1T-13 14T42 72L107 137H569V339Q569 541 567 546Q558 555 554 557L545 563H329Q118 566 101 569Q90 573 78 586Q54 610 54 661Q54 670 56 706",
          8503: "56 750Q68 764 76 764Q88 764 97 743T125 717Q131 715 240 715T358 713Q421 691 421 640Q421 608 399 588T358 566Q353 566 352 565T351 557L356 526Q356 488 379 346T402 97Q400 21 385 -12Q366 -43 351 -43Q335 -43 329 -10Q316 40 316 64Q316 67 315 67Q313 67 269 26L222 -21H-9Q-22 -7 -22 -1Q-22 4 -14 14T42 73L107 137H311V564H211H164Q115 564 93 573T60 615Q56 630 56 690V750",
          8504: "62 757Q69 764 75 764Q87 764 97 741Q102 731 105 728T117 721L129 715H349Q569 715 580 710Q618 701 635 670Q640 661 640 639Q640 609 622 590Q617 583 604 575T580 566H573V553Q575 547 576 531T582 469T600 353Q624 205 624 104Q624 46 617 17T591 -32Q581 -43 573 -43Q550 -43 540 44Q535 73 533 319V564H322Q117 566 100 570Q90 573 77 586Q54 609 54 663Q54 689 55 706Q55 738 56 745T62 757",
          8513: "239 665Q194 665 154 653T90 629T66 617Q59 617 53 623T46 637Q46 652 66 659Q129 695 197 701Q218 705 248 705Q293 705 335 693Q371 684 435 644Q543 562 573 417Q577 393 577 341Q577 290 573 266Q531 83 384 10Q346 -9 315 -16T234 -23H206Q202 -23 183 -23T152 -21T120 -18T88 -10T63 3T44 24L37 35V297L50 310H235Q248 297 248 290Q248 285 235 270H77V103Q77 88 77 80T77 63T78 50T80 43T82 38T85 35T89 32T95 30Q126 20 206 17Q289 17 330 30Q407 55 460 120T533 275Q538 305 538 342Q538 486 452 575T239 665",
          8592: "944 261T944 250T929 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H929Q944 261 944 250",
          8593: "27 414Q17 414 17 433Q17 437 17 439T17 444T19 447T20 450T22 452T26 453T30 454T36 456Q80 467 120 494T180 549Q227 607 238 678Q240 694 251 694Q259 694 261 684Q261 677 265 659T284 608T320 549Q340 525 363 507T405 479T440 463T467 455T479 451Q483 447 483 433Q483 413 472 413Q467 413 458 416Q342 448 277 545L270 555V-179Q262 -193 252 -193H250H248Q236 -193 230 -179V555L223 545Q192 499 146 467T70 424T27 414",
          8594: "56 237T56 250T70 270H835Q719 357 692 493Q692 494 692 496T691 499Q691 511 708 511H711Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H70Q56 237 56 250",
          8595: "473 86Q483 86 483 67Q483 63 483 61T483 56T481 53T480 50T478 48T474 47T470 46T464 44Q428 35 391 14T316 -55T264 -168Q264 -170 263 -173T262 -180T261 -184Q259 -194 251 -194Q242 -194 238 -176T221 -121T180 -49Q169 -34 155 -21T125 2T95 20T67 33T44 42T27 47L21 49Q17 53 17 67Q17 87 28 87Q33 87 42 84Q158 52 223 -45L230 -55V312Q230 391 230 482T229 591Q229 662 231 676T243 693Q244 694 251 694Q264 692 270 679V-55L277 -45Q307 1 353 33T430 76T473 86",
          8596: "263 479Q267 501 271 506T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H835Q729 349 696 475Q691 493 691 500Q691 511 711 511Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q144 292 194 349T263 479",
          8597: "27 492Q17 492 17 511Q17 515 17 517T17 522T19 525T20 528T22 530T26 531T30 532T36 534Q80 545 120 572T180 627Q210 664 223 701T238 755T250 772T261 762Q261 757 264 741T282 691T319 628Q352 589 390 566T454 536L479 529Q483 525 483 511Q483 491 472 491Q467 491 458 494Q342 526 277 623L270 633V-133L277 -123Q307 -77 353 -45T430 -2T473 8Q483 8 483 -11Q483 -15 483 -17T483 -22T481 -25T480 -28T478 -30T474 -31T470 -32T464 -34Q407 -49 364 -84T300 -157T270 -223T261 -262Q259 -272 250 -272Q242 -272 239 -255T223 -201T180 -127Q169 -112 155 -99T125 -76T95 -58T67 -45T44 -36T27 -31L21 -29Q17 -25 17 -11Q17 9 28 9Q33 9 42 6Q158 -26 223 -123L230 -133V633L223 623Q192 577 146 545T70 502T27 492",
          8598: "204 662Q257 662 301 676T369 705T394 720Q398 720 407 711T417 697Q417 688 389 671T310 639T212 623Q176 623 153 628Q151 628 221 557T546 232Q942 -164 943 -168Q944 -170 944 -174Q944 -182 938 -188T924 -195Q922 -195 916 -193Q912 -191 517 204Q440 281 326 394T166 553L121 598Q126 589 126 541Q126 438 70 349Q59 332 52 332Q48 332 39 341T29 355Q29 358 38 372T57 407T77 464T86 545Q86 583 78 614T63 663T55 683Q55 693 65 693Q73 693 82 688Q136 662 204 662",
          8599: "582 697Q582 701 591 710T605 720Q607 720 630 706T697 677T795 662Q830 662 863 670T914 686T934 694Q942 694 944 685Q944 680 936 663T921 615T913 545Q913 490 927 446T956 379T970 355Q970 351 961 342T947 332Q940 332 929 349Q874 436 874 541Q874 590 878 598L832 553Q787 508 673 395T482 204Q87 -191 83 -193Q77 -195 75 -195Q67 -195 61 -189T55 -174Q55 -170 56 -168Q58 -164 453 232Q707 487 777 557T847 628Q824 623 787 623Q689 623 599 679Q582 690 582 697",
          8600: "55 675Q55 683 60 689T75 695Q77 695 83 693Q87 691 482 296Q532 246 605 174T717 62T799 -20T859 -80T878 -97Q874 -93 874 -41Q874 64 929 151Q940 168 947 168Q951 168 960 159T970 145Q970 143 956 121T928 54T913 -45Q913 -83 920 -114T936 -163T944 -185Q942 -194 934 -194Q932 -194 914 -186T864 -170T795 -162Q743 -162 698 -176T630 -205T605 -220Q601 -220 592 -211T582 -197Q582 -187 611 -170T691 -138T787 -123Q824 -123 847 -128Q848 -128 778 -57T453 268Q58 664 56 668Q55 670 55 675",
          8601: "126 -41Q126 -92 121 -97Q121 -98 139 -80T200 -20T281 61T394 173T517 296Q909 690 916 693Q922 695 924 695Q932 695 938 689T944 674Q944 670 943 668Q942 664 546 268Q292 13 222 -57T153 -128Q176 -123 212 -123Q310 -123 400 -179Q417 -190 417 -197Q417 -201 408 -210T394 -220Q392 -220 369 -206T302 -177T204 -162Q131 -162 67 -194Q63 -195 59 -192T55 -183Q55 -180 62 -163T78 -115T86 -45Q86 10 72 54T44 120T29 145Q29 149 38 158T52 168Q59 168 70 151Q126 62 126 -41",
          8602: "942 250Q942 244 928 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H175L188 214Q210 188 235 145T264 85Q264 75 260 74T231 72L206 74L191 103Q169 142 164 150Q130 195 64 239Q56 244 56 250T64 261Q115 294 142 323T191 397L206 428H231Q255 428 259 426T264 414Q260 397 235 355T188 288L175 272L331 270Q488 270 491 272Q491 275 542 352T597 432Q602 437 609 437Q617 437 622 432T628 417T582 341L537 272L735 270H931Q942 257 942 250",
          8603: "54 250Q54 258 66 270H277L488 272L542 350Q596 431 602 435Q604 437 609 437Q617 437 622 432T628 417T582 341L537 272L608 270H751L822 272L808 288Q786 313 761 355T733 414Q733 424 737 426T766 428H793L806 397Q829 354 864 314Q896 284 928 263Q942 257 942 250T928 237Q887 208 864 185Q829 147 806 103L793 74L766 72Q742 72 738 73T733 85Q735 102 756 137T797 198L817 225L822 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H264L66 232Q54 239 54 250",
          8606: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H276L285 277Q322 306 349 345T388 417H434Q434 413 424 392T393 338T349 279L340 270H634Q933 270 937 266L938 265Q944 259 944 250T938 235L937 234Q933 230 634 230H340L349 221Q372 196 393 163T424 108T434 83H388Q377 116 350 155T285 223L276 230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250",
          8608: "943 250Q895 221 856 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H723L714 223Q677 194 650 155T611 83H565Q565 87 575 108T606 162T650 221L659 230H365Q66 230 62 234L61 235Q55 241 55 250T61 265L62 266Q66 270 365 270H659L650 279Q627 304 606 337T575 392T565 417H611Q622 384 649 345T714 277L723 270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250",
          8610: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H873L882 277Q919 306 946 345T985 417H1031Q1031 413 1021 392T990 338T946 279L937 270V230L946 221Q969 196 990 163T1021 108T1031 83H985Q974 116 947 155T882 223L873 230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250",
          8611: "1054 250Q1006 221 967 177T912 83H889Q866 83 866 84Q866 86 873 103T902 156T952 222L959 230H237L228 223Q191 194 164 155T125 83H79Q79 87 89 108T120 162T164 221L173 230V270L164 279Q141 304 120 337T89 392T79 417H125Q136 384 163 345T228 277L237 270H959L952 278Q924 309 903 344T874 396T866 416Q866 417 889 417H912Q928 367 967 323T1054 250",
          8614: "95 155V109Q95 83 92 73T75 63Q61 63 58 74T54 130Q54 140 54 180T55 250Q55 421 57 425Q61 437 75 437Q88 437 91 428T95 393V345V270H835Q719 357 692 493Q692 494 692 496T691 499Q691 511 708 511H711Q720 511 723 510T729 506T732 497T735 481T743 456Q765 389 816 336T935 261Q944 258 944 250Q944 244 939 241T915 231T877 212Q836 186 806 152T761 85T740 35T732 4Q730 -6 727 -8T711 -11Q691 -11 691 0Q691 7 696 25Q728 151 835 230H95V155",
          8617: "903 424T903 444T929 464Q976 464 1023 434T1070 347Q1070 316 1055 292T1016 256T971 237T929 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270H926Q929 270 941 271T960 275T978 280T998 290T1015 307Q1030 325 1030 347Q1030 355 1027 364T1014 387T983 411T929 424H928Q903 424 903 444",
          8618: "55 347Q55 380 72 404T113 441T159 458T197 464Q222 464 222 444Q222 429 204 426T157 417T110 387Q95 369 95 347Q95 339 98 330T111 307T142 283T196 270H961Q845 357 818 493Q818 494 818 496T817 499Q817 511 834 511H837Q846 511 849 510T855 506T858 497T861 481T869 456Q891 389 942 336T1061 261Q1070 258 1070 250Q1070 244 1065 241T1041 231T1003 212Q962 186 932 152T887 85T866 35T858 4Q856 -6 853 -8T837 -11Q817 -11 817 0Q817 7 822 25Q854 151 961 230H196Q149 230 102 260T55 347",
          8619: "56 250Q103 277 142 322T199 417H221Q244 417 244 416Q244 414 237 397T208 344T158 278L151 270H622V305Q622 356 624 388T635 460T661 521T709 559T785 575Q813 575 833 573T880 561T923 534T952 483T964 405Q964 374 959 350T942 307T918 276T884 255T847 242T804 235T760 231T713 230H662V-27Q654 -41 644 -41H642H640Q628 -41 622 -27V230H151L158 222Q186 191 207 156T236 104T244 84Q244 83 221 83H199Q181 133 142 178T56 250ZM924 403Q924 474 894 505T794 536Q758 536 734 526T696 500T675 453T665 395T662 319V270H699Q826 270 875 295T924 403",
          8620: "35 405Q35 454 48 489T86 542T137 567T195 575Q229 575 251 571T301 554T345 510T370 429Q377 384 377 305V270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250Q896 221 857 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H377V-27Q369 -41 359 -41H357Q342 -41 337 -25V230H286Q247 231 225 232T169 238T115 255T75 284T45 333T35 405ZM75 406Q75 322 123 296T300 270H337V319Q335 432 317 477T240 534Q232 535 197 535Q140 535 108 507T75 406",
          8621: "57 250Q159 311 200 417H246L242 407Q215 340 159 278L152 270H276L315 310Q354 349 358 351Q366 356 376 351Q378 350 455 273L530 196L606 273Q683 350 686 351Q694 354 703 351Q705 350 782 273L858 196L933 273Q1010 350 1012 351Q1022 356 1030 351Q1034 349 1073 310L1112 270H1236L1229 278Q1173 340 1146 407L1142 417H1188Q1233 306 1331 250Q1231 192 1188 83H1142L1146 93Q1173 160 1229 222L1236 230H1168Q1155 230 1139 230T1119 229Q1112 229 1108 229T1099 231T1092 233T1085 238T1078 245T1068 256T1056 269L1021 304L984 267Q948 230 910 191T867 149Q857 144 848 150Q844 151 770 227T694 304T618 228T540 150Q531 144 521 149Q517 152 479 191T404 267L367 304L332 269Q328 264 320 256T310 246T303 239T296 234T289 231T280 229T269 229Q265 229 249 229T220 230H152L159 222Q215 160 242 93L246 83H223L200 84L195 96Q152 190 57 250",
          8622: "491 272Q491 275 542 352T597 432Q602 437 609 437Q617 437 622 432T628 417T582 341L537 272L608 270H751L822 272L808 288Q786 313 761 355T733 414Q733 424 737 426T766 428H793L806 397Q829 354 864 314Q896 284 928 263Q942 257 942 250T928 237Q887 208 864 185Q829 147 806 103L793 74L766 72Q742 72 738 73T733 85Q735 102 756 137T797 198L817 225L822 230H511L457 148Q440 124 420 93Q404 68 400 64T389 60Q381 60 375 66T368 81Q368 88 415 159L462 230H175L188 214Q210 188 235 145T264 85Q264 75 260 74T231 72L206 74L191 103Q169 142 164 150Q130 195 64 239Q56 244 56 250T64 261Q115 294 142 323T191 397L206 428H231Q255 428 259 426T264 414Q260 397 235 355T188 288L175 272L331 270Q488 270 491 272",
          8624: "56 555Q74 567 79 570T107 592T141 625T170 667T198 722H221Q244 722 244 721Q244 718 236 699T207 647T161 587L151 576L291 575H292H293H294H296H297H298H299H300H301H302H304H305H306H307H308H309H310H311H312H314H315H316H317H318H319H320H321H322H323H324H325H327H328H329H330H331H332H333H334H335H336H337H338H339H340H341H342H343H345Q435 574 438 570L439 569L440 568Q444 564 444 287Q444 15 442 12Q436 0 424 0T406 12Q404 15 404 275V535H151L162 523Q187 495 207 462T236 410T244 389H198L193 402Q171 457 131 497T56 555",
          8625: "301 722Q339 618 443 555L437 551Q431 547 422 541T401 526T377 504T352 477T327 443T306 402L301 389H255Q255 392 263 410T291 461T337 523L348 535H95V275Q95 15 93 12Q87 0 75 0T57 12Q55 15 55 287Q55 564 59 568L60 569Q64 573 76 573T208 575L348 576L338 587Q314 613 294 646T264 698T255 721Q255 722 278 722H301",
          8630: "361 210Q373 210 373 182V177Q373 155 370 151T348 139Q303 118 267 84T216 28T201 1Q197 -1 196 -1Q189 -1 184 8Q166 39 143 64T99 104T61 129T32 144T19 150Q17 152 17 179Q17 203 21 208Q28 210 39 206Q106 178 157 135L175 119V126Q179 130 179 155Q182 173 193 201Q228 305 312 374T510 459Q532 461 551 461H567Q678 461 784 386Q835 344 861 301Q902 245 926 173T950 32Q950 15 944 8Q930 -6 917 8Q910 12 910 43Q901 208 801 314T561 421Q453 421 359 359Q300 319 263 258T217 126L216 125Q216 124 216 123T217 122Q219 122 229 131T260 156T301 181Q314 189 336 199T361 210",
          8631: "972 209Q980 209 981 204T982 179Q982 155 979 151T957 139Q915 121 878 86T815 8Q808 -1 803 -1Q801 -1 797 1Q797 6 783 28T732 84T650 139L628 150Q626 152 626 177Q626 201 630 206Q636 210 637 210Q650 210 697 181Q727 166 764 137L784 119L782 132Q767 239 689 318T499 417Q474 421 442 421Q343 421 261 369T130 219Q86 121 86 28Q86 15 79 8Q73 1 66 1T53 8Q46 15 46 30Q46 102 77 192T186 361Q274 443 386 459Q396 460 426 460Q515 460 588 431T703 361T773 271T812 187T822 132Q822 123 825 123Q936 209 972 209",
          8634: "369 543T369 563T397 583Q408 583 440 579L454 577L464 581Q492 592 516 609T552 638T565 650Q604 638 607 637Q606 636 598 628T585 614T570 601T548 584T523 568L510 560L516 558Q522 555 527 553T541 546T559 536T580 523T603 506T626 485Q722 384 722 250Q722 106 622 12T387 -83Q253 -83 155 12T56 250Q56 357 110 433T235 545Q244 550 252 550Q270 550 270 531Q270 522 261 515T238 501T202 477T159 433Q95 352 95 250Q95 131 178 45T388 -42Q511 -42 596 43T682 250Q682 340 636 408T522 511Q495 526 488 526Q488 525 488 525T487 522T485 515L490 506Q505 481 516 451T531 404T535 384L532 385Q529 386 524 387T513 390L491 397L488 408Q472 483 413 542L399 543Q369 543 369 563",
          8635: "170 637L213 650Q270 597 313 581L323 577L337 579Q369 583 380 583Q408 583 408 563T380 543H378L364 542Q305 483 289 408L286 397L264 390Q259 389 254 388T245 385L242 384Q242 387 246 403T261 450T287 506L292 515Q291 519 291 521T290 524T289 526Q284 526 265 517T216 486T160 434T114 354T95 249Q95 132 178 45T388 -42Q513 -42 597 44T682 250Q682 337 638 404T532 506Q529 508 525 510T519 514T515 516T511 519T509 522T508 526T507 531Q507 550 525 550Q533 550 542 545Q569 532 596 511T653 454T702 366T721 250Q721 151 672 74T547 -43T388 -83Q254 -83 155 12T56 250Q56 385 151 485Q164 498 179 509T205 528T228 542T247 551T260 558L267 560L254 568Q215 590 170 637",
          8636: "62 230Q56 236 55 244Q55 252 57 255T69 265Q114 292 151 326T208 391T243 448T265 491T273 509Q276 511 288 511Q304 511 306 505Q309 501 303 484Q293 456 279 430T251 383T223 344T196 313T173 291T156 276L148 270H929Q944 261 944 250T929 230H62",
          8637: "55 256Q56 264 62 270H929Q944 261 944 250T929 230H148Q149 229 165 215T196 185T231 145T270 87T303 16Q309 -1 306 -5Q304 -11 288 -11Q279 -11 276 -10T269 -4T264 10T253 36T231 75Q172 173 69 235Q59 242 57 245T55 256",
          8638: "188 258V694H208L215 682Q246 628 293 594T375 551V528Q375 505 374 505Q369 505 351 510T299 534T237 578L228 587V205Q228 -178 226 -182Q221 -194 208 -194T190 -182Q188 -178 188 258",
          8639: "41 551Q76 559 123 592T201 682L208 694H228V258Q228 -178 226 -182Q221 -194 208 -194T190 -182Q188 -178 188 205V587L179 578Q151 552 117 534T65 511T42 505Q41 505 41 528V551",
          8640: "691 500Q691 511 711 511Q720 511 723 510T730 504T735 490T746 464T768 425Q796 378 835 339T897 285T933 263Q941 258 942 256T944 245T937 230H70Q56 237 56 250T70 270H852Q802 308 762 364T707 455T691 500",
          8641: "56 237T56 250T70 270H937Q944 263 944 256Q944 251 944 250T943 246T940 242T933 238Q794 153 734 7Q729 -7 726 -9T711 -11Q695 -11 693 -5Q690 -1 696 16Q721 84 763 139T852 230H70Q56 237 56 250",
          8642: "190 682Q195 694 208 694T226 683Q228 679 228 296V-87L237 -78Q265 -52 299 -34T351 -11T374 -5Q375 -5 375 -28V-51Q340 -60 293 -92T215 -182L208 -194H188V242Q188 678 190 682",
          8643: "188 295V573Q188 657 189 672T200 692Q206 694 208 694Q221 694 226 683Q228 679 228 242V-194H208L201 -182Q170 -128 123 -94T41 -51V-28Q41 -5 42 -5Q47 -5 65 -10T117 -34T179 -78L188 -87V295",
          8644: "943 500Q895 471 856 427T801 333H778Q755 333 755 334Q755 336 762 353T791 406T841 472L848 480H459Q70 480 67 482Q55 488 55 500T67 518Q70 520 459 520H848L841 528Q813 559 792 594T763 646T755 666Q755 667 778 667H801Q817 617 856 573T943 500ZM56 167Q102 194 141 238T198 333H221Q244 333 244 332Q221 265 161 198L151 187H539Q928 187 930 186Q944 182 944 167Q944 155 934 149Q930 147 541 147H151L160 137Q185 110 205 77T235 24T244 1Q244 0 221 0H199Q158 106 56 167",
          8646: "56 500Q103 527 142 572T199 667H221Q244 667 244 666Q244 664 237 647T208 594T158 528L151 520H539Q928 520 932 518Q944 513 944 500T932 482Q928 480 539 480H151L158 472Q186 441 207 406T236 354T244 334Q244 333 221 333H199Q181 383 142 428T56 500ZM943 167Q835 101 801 0H778Q755 0 755 1T758 9T765 25T771 39Q800 94 839 137L848 147H458Q68 147 66 149Q55 154 55 167Q55 182 69 186Q71 187 460 187H848L838 198Q811 228 791 261T762 314L755 332Q755 333 778 333H801Q841 227 943 167",
          8647: "930 437Q944 426 944 416T934 399Q930 397 540 397H150L159 387Q185 360 205 328T234 277T243 252Q243 237 217 191T159 113L150 103H540Q930 103 934 101Q944 94 944 84Q944 71 930 64L540 63H151Q180 34 203 -2T236 -61L244 -83H198Q178 -31 142 11T66 77L55 83L65 89Q157 145 197 246Q199 250 190 269Q150 359 65 411L55 417L66 423Q106 447 142 489T198 583H244Q202 488 151 437H930",
          8648: "83 551Q190 590 250 694Q251 689 263 671T307 621T380 567Q409 551 416 551Q422 551 447 563T511 608T577 684L582 694Q642 591 749 551V528Q749 505 748 505Q745 505 724 515T669 546T612 590L602 599V-181Q595 -193 585 -193H582H581Q568 -193 565 -183L563 -179L562 209V598L552 589Q517 556 473 531T414 506H412Q411 506 393 514T361 530T324 553T280 589L270 598V-179Q255 -192 250 -193H247Q237 -193 230 -181V599L220 590Q197 567 164 546T110 515T84 505Q83 505 83 528V551",
          8649: "55 416Q55 427 70 437H848Q819 466 796 502T764 561L755 583H801Q821 531 857 489T933 423L944 417L934 411Q843 355 802 254Q800 250 809 231Q849 141 934 89L944 83L933 77Q893 53 857 11T801 -83H755Q797 12 848 63H459L70 64Q55 70 55 84Q55 94 65 101Q69 103 459 103H849L840 113Q806 148 779 196T756 254Q756 255 760 264T770 286T786 315T809 351T840 387L849 397H459Q69 397 65 399Q55 406 55 416",
          8650: "230 681Q240 694 251 694Q260 693 270 680V-98L280 -89Q297 -73 314 -60T348 -38T374 -24T397 -13T412 -6H414Q428 -6 473 -32T552 -89L562 -98V291L563 680Q570 693 582 693Q593 694 602 681V-99L612 -90Q635 -68 668 -47T723 -15T748 -5Q749 -5 749 -28V-51Q642 -91 582 -194L577 -184Q551 -141 512 -108T447 -63T416 -51T385 -63T321 -108T255 -184L250 -194Q189 -89 83 -51V-28Q83 -5 84 -5Q88 -5 109 -15T164 -46T220 -90L230 -99V681",
          8651: "195 504L198 514H221Q244 514 244 512Q244 508 239 490T215 437T171 376L162 367H545Q928 367 932 365Q944 360 944 347T932 329Q928 327 492 327H55V347L67 354Q113 379 146 420T195 504ZM67 171Q70 173 507 173H944V153L932 146Q839 95 804 -4L801 -14H778Q755 -14 755 -12Q768 59 828 124L837 133H454Q71 133 67 135Q55 140 55 153Q55 165 67 171",
          8652: "691 660Q691 671 711 671Q720 671 723 670T730 664T735 650T746 624T768 585Q797 538 836 499T897 445T933 423Q941 418 942 416T944 405T937 390H70Q56 397 56 410T70 430H852Q802 468 762 524T707 615T691 660ZM55 256Q56 264 62 270H929Q944 261 944 250T929 230H148Q149 229 165 215T196 185T231 145T270 87T303 16Q309 -1 306 -5Q304 -11 288 -11Q279 -11 276 -10T269 -4T264 10T253 36T231 75Q172 173 69 235Q59 242 57 245T55 256",
          8653: "397 525Q410 525 414 524T418 516Q418 506 394 467T331 381L319 367H473L624 369L657 445Q674 487 684 507T699 531T709 534Q717 534 722 528T728 516Q728 510 695 434Q689 418 683 402T672 377T668 367H928Q942 355 942 347Q942 341 928 327H791Q651 327 651 325Q649 324 620 251T586 174Q586 172 757 172H928Q942 158 942 152Q942 143 928 132H568L537 54Q510 -9 503 -22T486 -35Q479 -35 473 -29T466 -17T495 61L526 132H319L331 118Q364 81 391 37T418 -17Q418 -23 415 -24T401 -26Q398 -26 397 -26L384 -24L377 -13Q344 49 301 97T218 170T143 210T84 233T55 245Q54 253 59 256T86 267Q281 327 377 512L384 525H397ZM606 325Q606 327 439 327H275Q258 312 179 265L148 249Q228 206 262 181L275 172H544L575 247L606 325",
          8654: "395 -24T395 -19T417 57T440 132H255L266 116Q308 64 340 -6Q342 -17 337 -21Q335 -26 320 -26T302 -19Q302 -15 294 4T265 54T217 117T145 182T49 236Q30 243 33 254Q40 261 49 263Q98 283 142 315T214 379T263 442T293 493T302 519Q305 525 320 525T337 521Q342 516 340 505Q308 435 266 383L255 370L384 367H515Q561 522 569 530Q574 534 580 534Q587 534 594 528T602 516Q602 512 580 441T557 367H651L742 370L731 383Q689 435 657 505Q655 516 660 521Q662 525 677 525T695 519Q695 515 703 496T732 446T780 383T853 317T949 263Q967 258 964 245Q959 240 949 236Q897 215 852 182T779 116T731 52T703 3T695 -19Q692 -26 677 -26T660 -21Q655 -17 657 -6Q670 21 682 42T702 77T717 99T728 114T735 122T739 126T740 130T613 132H482L460 54Q440 -9 433 -23T415 -37Q408 -37 402 -31ZM502 325Q502 327 360 327H217L195 310Q173 291 120 256L111 250Q114 248 143 229T195 190L217 172H335L453 174L502 325ZM886 250Q885 251 865 263T831 286T802 310L780 327H544L535 299Q531 283 511 223L495 174L637 172H780L802 190Q843 225 877 243L886 250",
          8655: "346 174Q348 176 378 249T411 325Q411 327 239 327H68Q55 342 55 347Q55 354 68 367H428L459 445Q487 509 494 521T510 534Q517 534 524 527T531 516Q531 515 502 438L471 367H677L666 381Q631 421 605 463T578 516Q578 522 582 523T599 525H615L619 512Q659 437 714 383T812 309T896 272T942 254Q943 246 938 243T911 232Q718 172 619 -13L615 -24L599 -26Q578 -26 578 -17Q578 -11 587 6T617 53T666 118L677 132H373L339 54Q323 12 313 -8T298 -32T288 -35Q280 -35 275 -29T269 -17Q269 -14 298 57T328 132H68Q55 145 55 152Q55 156 56 158T62 165T68 172H206Q346 172 346 174ZM848 249Q763 297 735 318L722 327H455L422 252L391 174Q391 172 557 172H722L735 181Q773 210 819 234L848 249",
          8656: "944 153Q944 140 929 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H929Q944 359 944 347Q944 336 930 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173H930Q931 172 933 171T936 169T938 167T941 164T942 162T943 158T944 153",
          8657: "228 -179Q227 -180 226 -182T223 -186T221 -189T218 -192T214 -193T208 -194Q196 -194 189 -181L188 125V430L176 419Q122 369 59 338Q46 330 40 330Q38 330 31 337V350Q31 362 33 365T46 374Q60 381 77 390T128 426T190 484T247 567T292 677Q295 688 298 692Q302 694 305 694Q313 694 318 677Q334 619 363 568T420 485T481 427T532 391T564 374Q575 368 577 365T579 350V337Q572 330 570 330Q564 330 551 338Q487 370 435 419L423 430L422 125V-181Q409 -194 401 -194Q397 -194 394 -193T388 -189T385 -184T382 -180V-177V475L373 487Q331 541 305 602Q304 601 300 591T290 571T278 548T260 519T238 488L229 476L228 148V-179",
          8658: "580 514Q580 525 596 525Q601 525 604 525T609 525T613 524T615 523T617 520T619 517T622 512Q659 438 720 381T831 300T927 263Q944 258 944 250T935 239T898 228T840 204Q696 134 622 -12Q618 -21 615 -22T600 -24Q580 -24 580 -17Q580 -13 585 0Q620 69 671 123L681 133H70Q56 140 56 153Q56 168 72 173H725L735 181Q774 211 852 250Q851 251 834 259T789 283T735 319L725 327H72Q56 332 56 347Q56 360 70 367H681L671 377Q638 412 609 458T580 514",
          8659: "401 694Q412 694 422 681V375L423 70L435 81Q487 130 551 162Q564 170 570 170Q572 170 579 163V150Q579 138 577 135T564 126Q541 114 518 99T453 48T374 -46T318 -177Q313 -194 305 -194T293 -178T272 -119T225 -31Q158 70 46 126Q35 132 33 135T31 150V163Q38 170 40 170Q46 170 59 162Q122 131 176 81L188 70V375L189 681Q199 694 208 694Q219 694 228 680V352L229 25L238 12Q279 -42 305 -102Q344 -23 373 13L382 25V678Q387 692 401 694",
          8660: "308 524Q318 526 323 526Q340 526 340 514Q340 507 336 499Q326 476 314 454T292 417T274 391T260 374L255 368Q255 367 500 367Q744 367 744 368L739 374Q734 379 726 390T707 416T685 453T663 499Q658 511 658 515Q658 525 680 525Q687 524 690 523T695 519T701 507Q766 359 902 287Q921 276 939 269T961 259T966 250Q966 246 965 244T960 240T949 236T930 228T902 213Q763 137 701 -7Q697 -16 695 -19T690 -23T680 -25Q658 -25 658 -15Q658 -11 663 1Q673 24 685 46T707 83T725 109T739 126L744 132Q744 133 500 133Q255 133 255 132L260 126Q265 121 273 110T292 84T314 47T336 1Q341 -11 341 -15Q341 -25 319 -25Q312 -24 309 -23T304 -19T298 -7Q233 141 97 213Q83 221 70 227T51 235T41 239T35 243T34 250T35 256T40 261T51 265T70 273T97 287Q235 363 299 509Q305 522 308 524ZM792 319L783 327H216Q183 294 120 256L110 250L120 244Q173 212 207 181L216 173H783L792 181Q826 212 879 244L889 250L879 256Q826 288 792 319",
          8661: "290 755Q298 772 305 772T318 757T343 706T393 633Q431 588 473 558T545 515T579 497V484Q579 464 570 464Q564 464 550 470Q485 497 423 550L422 400V100L423 -50Q485 3 550 30Q565 36 570 36Q579 36 579 16V3Q575 -1 549 -12T480 -53T393 -132Q361 -172 342 -208T318 -258T305 -272T293 -258T268 -208T217 -132Q170 -80 128 -51T61 -12T31 3V16Q31 36 40 36Q46 36 61 30Q86 19 109 6T146 -18T173 -38T188 -50V550Q186 549 173 539T147 519T110 495T61 470Q46 464 40 464Q31 464 31 484V497Q34 500 63 513T135 557T217 633Q267 692 290 755ZM374 598Q363 610 351 625T332 651T316 676T305 695L294 676Q282 657 267 636T236 598L228 589V-89L236 -98Q247 -110 259 -125T278 -151T294 -176T305 -195L316 -176Q328 -157 343 -136T374 -98L382 -89V589L374 598",
          8666: "944 54Q942 44 929 36H372Q372 34 377 26T395 -4T422 -58Q442 -109 442 -110T408 -111H374L370 -100Q282 124 87 243L76 250L87 257Q284 377 370 600L374 611H408Q442 611 442 610Q423 550 381 480Q380 478 379 475T376 471T374 468T372 465V464H929Q942 456 944 446Q944 442 943 439T941 434T938 430T935 428T931 426T928 424H344L336 414Q277 336 200 277L191 270H560Q929 270 933 268Q944 262 944 250Q944 237 933 232Q929 230 560 230H191L200 223Q279 162 336 86L344 76H928Q929 76 931 75T934 73T938 70T941 66T943 61T944 54",
          8667: "56 250Q56 260 68 270H808L799 277Q720 338 663 414L655 424H363Q71 424 68 426Q55 432 55 444T68 462Q71 464 349 464H627Q627 466 622 474T604 504T577 558Q557 609 557 610T591 611H626L629 600Q717 376 912 257L923 250L912 243Q715 123 629 -100L626 -111H591Q557 -111 557 -110Q576 -50 618 20Q619 22 620 25T623 29T625 32T626 35L627 36H349Q71 36 68 38Q55 44 55 56T68 74Q71 76 363 76H655L663 86Q722 164 799 223L808 230H438L68 231Q56 236 56 250",
          8669: "76 230Q68 230 62 237T56 250Q56 257 63 264T91 291Q102 300 108 306L159 351Q168 356 177 351L218 316L303 239L353 195Q376 214 403 239L488 316L529 351Q538 356 546 351Q548 350 594 310L638 270H848L841 278Q813 309 792 344T763 396T755 416Q755 417 778 417H801Q817 367 856 323T943 250Q895 221 856 177T801 83H778Q755 83 755 84Q755 86 762 103T791 156T841 222L848 230H737Q625 230 622 232Q620 233 599 251T558 288L537 306Q537 305 451 228T362 149Q353 146 345 149Q341 150 255 227T169 306Q167 306 129 270Q123 265 115 257T102 245T93 237T84 232T76 230",
          8672: "292 419Q292 400 261 347T211 275H306H364Q400 275 411 271T422 250T411 230T366 225H306H211Q214 222 232 197T271 136T292 82Q292 71 285 68T262 64H250H241Q221 64 216 67T205 83Q186 127 153 167T78 230Q64 238 64 250Q64 258 69 263T82 272T106 288T139 318Q162 342 177 365T198 402T209 425T223 436Q224 437 252 437H258Q292 437 292 419ZM501 237T501 250T515 270H819Q834 262 834 250T819 230H515Q501 237 501 250ZM918 237T918 250T932 270H1236Q1251 262 1251 250T1236 230H932Q918 237 918 250",
          8674: "84 237T84 250T98 270H402Q417 262 417 250T402 230H98Q84 237 84 250ZM501 237T501 250T515 270H819Q834 262 834 250T819 230H515Q501 237 501 250ZM1022 417Q1022 437 1055 437H1067Q1090 437 1097 434T1109 417Q1128 373 1161 333T1236 270Q1251 261 1251 250Q1251 241 1244 236T1216 217T1175 182Q1149 155 1133 128T1109 85T1097 66Q1093 64 1065 64H1053Q1031 64 1025 72T1027 100Q1036 124 1049 147T1073 185T1091 210T1101 223L1103 225H1008H950Q914 225 903 229T892 250T903 270T948 275H1008H1103L1101 277Q1100 280 1091 291T1067 325T1039 374Q1022 408 1022 417",
          8704: "0 673Q0 684 7 689T20 694Q32 694 38 680T82 567L126 451H430L473 566Q483 593 494 622T512 668T519 685Q524 694 538 694Q556 692 556 674Q556 670 426 329T293 -15Q288 -22 278 -22T263 -15Q260 -11 131 328T0 673ZM414 410Q414 411 278 411T142 410L278 55L414 410",
          8705: "404 269Q412 269 418 267T428 261T435 253T441 245L444 240V172Q444 103 443 96Q440 81 431 65T403 27T344 -7T250 -21T156 -8T97 27T69 65T58 96Q56 103 56 413Q56 722 58 729Q74 822 215 845Q221 846 229 846H243Q282 846 290 845Q422 826 443 729Q444 722 444 653V586L442 583Q441 580 440 578T436 573T430 567T423 562T415 558T404 556Q377 556 367 583Q364 590 364 654V719Q363 721 360 726T355 733Q326 766 250 766H249Q235 766 219 765T174 752T137 719V107Q145 83 178 71T251 58H254Q340 58 364 107V172Q364 176 364 187T363 204Q363 269 404 269",
          8706: "202 508Q179 508 169 520T158 547Q158 557 164 577T185 624T230 675T301 710L333 715H345Q378 715 384 714Q447 703 489 661T549 568T566 457Q566 362 519 240T402 53Q321 -22 223 -22Q123 -22 73 56Q42 102 42 148V159Q42 276 129 370T322 465Q383 465 414 434T455 367L458 378Q478 461 478 515Q478 603 437 639T344 676Q266 676 223 612Q264 606 264 572Q264 547 246 528T202 508ZM430 306Q430 372 401 400T333 428Q270 428 222 382Q197 354 183 323T150 221Q132 149 132 116Q132 21 232 21Q244 21 250 22Q327 35 374 112Q389 137 409 196T430 306",
          8707: "56 661T56 674T70 694H487Q497 686 500 679V15Q497 10 487 1L279 0H70Q56 7 56 20T70 40H460V327H84Q70 334 70 347T84 367H460V654H70Q56 661 56 674",
          8709: "331 696Q335 708 339 722T345 744T350 759T357 769T367 772Q374 772 381 767T388 754Q388 746 377 712L366 673L378 661Q460 575 460 344Q460 281 456 234T432 126T373 27Q319 -22 250 -22Q214 -22 180 -7Q168 -3 168 -4L159 -33Q148 -71 142 -75Q138 -78 132 -78Q124 -78 118 -72T111 -60Q111 -52 122 -18L133 21L125 29Q39 111 39 344Q39 596 137 675Q187 716 251 716Q265 716 278 714T296 710T315 703T331 696ZM276 676Q264 679 246 679Q196 679 159 631Q134 597 128 536T121 356Q121 234 127 174T151 80L234 366Q253 430 275 506T308 618L318 654Q318 656 294 669L276 676ZM181 42Q207 16 250 16Q291 16 324 47Q354 78 366 136T378 356Q378 470 372 528T349 616L348 613Q348 611 264 326L181 42",
          8710: "51 0Q46 4 46 7Q46 9 215 357T388 709Q391 716 416 716Q439 716 444 709Q447 705 616 357T786 7Q786 4 781 0H51ZM507 344L384 596L137 92L383 91H630Q630 93 507 344",
          8711: "46 676Q46 679 51 683H781Q786 679 786 676Q786 674 617 326T444 -26Q439 -33 416 -33T388 -26Q385 -22 216 326T46 676ZM697 596Q697 597 445 597T193 596Q195 591 319 336T445 80L697 596",
          8712: "84 250Q84 372 166 450T360 539Q361 539 377 539T419 540T469 540H568Q583 532 583 520Q583 511 570 501L466 500Q355 499 329 494Q280 482 242 458T183 409T147 354T129 306T124 272V270H568Q583 262 583 250T568 230H124V228Q124 207 134 177T167 112T231 48T328 7Q355 1 466 0H570Q583 -10 583 -20Q583 -32 568 -40H471Q464 -40 446 -40T417 -41Q262 -41 172 45Q84 127 84 250",
          8713: "196 25Q84 109 84 250Q84 372 166 450T360 539Q361 539 375 539T413 540T460 540L547 707Q550 716 563 716Q570 716 575 712T581 703T583 696T505 540H568Q583 532 583 520Q583 511 570 501L484 500L366 270H568Q583 262 583 250T568 230H346L247 38Q284 16 328 7Q355 1 466 0H570Q583 -10 583 -20Q583 -32 568 -40H471Q464 -40 447 -40T419 -41Q304 -41 228 3Q117 -211 115 -212Q111 -215 104 -215T92 -212T86 -204T84 -197Q84 -190 89 -183L196 25ZM214 61L301 230H124V228Q124 196 147 147T214 61ZM321 270L440 500Q353 499 329 494Q280 482 242 458T183 409T147 354T129 306T124 272V270H321",
          8715: "83 520Q83 532 98 540H195Q202 540 220 540T249 541Q404 541 494 455Q582 374 582 250Q582 165 539 99T434 0T304 -39Q297 -40 195 -40H98Q83 -32 83 -20Q83 -10 96 0H200Q311 1 337 6Q369 14 401 28Q422 39 445 55Q484 85 508 127T537 191T542 228V230H98Q84 237 84 250T98 270H542V272Q542 280 539 295T527 336T497 391T445 445Q422 461 401 472Q386 479 374 483T347 491T325 495T298 498T273 499T239 500T200 500L96 501Q83 511 83 520",
          8717: "154 -1Q122 -1 112 3T102 26Q102 63 158 63H178Q192 64 206 65T228 66T240 68Q301 85 324 146L329 157H244Q158 157 153 161Q149 162 145 169T140 183Q140 201 158 215L167 221H256L344 223L349 237Q352 262 352 287Q352 308 351 315Q341 352 315 368T256 385Q231 385 206 376T166 356T149 346Q143 346 138 364T132 388Q132 396 147 406Q198 440 252 440Q291 440 318 435Q421 404 451 301Q456 288 456 248V234Q456 151 391 86Q330 25 240 3Q212 -1 154 -1",
          8719: "158 656Q147 684 131 694Q110 707 69 710H55V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H570V-210H584Q618 -208 638 -197T663 -178T673 -155V710H270V277L271 -155Q283 -206 359 -210H373V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
          8720: "158 656Q147 684 131 694Q110 707 69 710H55V750H373V710H359Q325 708 305 698T280 678T271 656L270 223V-210H673V656Q666 672 663 679T639 697T584 710H570V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
          8721: "61 748Q64 750 489 750H913L954 640Q965 609 976 579T993 533T999 516H979L959 517Q936 579 886 621T777 682Q724 700 655 705T436 710H319Q183 710 183 709Q186 706 348 484T511 259Q517 250 513 244L490 216Q466 188 420 134T330 27L149 -187Q149 -188 362 -188Q388 -188 436 -188T506 -189Q679 -189 778 -162T936 -43Q946 -27 959 6H999L913 -249L489 -250Q65 -250 62 -248Q56 -246 56 -239Q56 -234 118 -161Q186 -81 245 -11L428 206Q428 207 242 462L57 717L56 728Q56 744 61 748",
          8722: "84 237T84 250T98 270H679Q694 262 694 250T679 230H98Q84 237 84 250",
          8723: "56 467T56 480T70 500H707Q722 492 722 480T707 460H409V187H707Q722 179 722 167Q722 154 707 147H409V0V-93Q409 -144 406 -155T389 -166Q376 -166 372 -155T368 -105Q368 -96 368 -62T369 -2V147H70Q56 154 56 167T70 187H369V460H70Q56 467 56 480",
          8724: "339 717Q339 739 354 752T388 766Q410 766 424 751T439 716T424 681T390 666Q369 666 354 681T339 717ZM57 237T57 250T71 270H369V425L370 581Q380 594 389 594Q402 594 409 579V270H707Q722 262 722 250T707 230H409V-79Q401 -93 391 -93H389H387Q375 -93 369 -79V230H71Q57 237 57 250",
          8725: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
          8726: "56 731Q56 740 62 745T75 750Q85 750 92 740Q96 733 270 255T444 -231Q444 -239 438 -244T424 -250Q414 -250 407 -240Q404 -236 230 242T56 731",
          8727: "229 286Q216 420 216 436Q216 454 240 464Q241 464 245 464T251 465Q263 464 273 456T283 436Q283 419 277 356T270 286L328 328Q384 369 389 372T399 375Q412 375 423 365T435 338Q435 325 425 315Q420 312 357 282T289 250L355 219L425 184Q434 175 434 161Q434 146 425 136T401 125Q393 125 383 131T328 171L270 213Q283 79 283 63Q283 53 276 44T250 35Q231 35 224 44T216 63Q216 80 222 143T229 213L171 171Q115 130 110 127Q106 124 100 124Q87 124 76 134T64 161Q64 166 64 169T67 175T72 181T81 188T94 195T113 204T138 215T170 230T210 250L74 315Q65 324 65 338Q65 353 74 363T98 374Q106 374 116 368T171 328L229 286",
          8728: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251ZM245 403Q188 403 142 361T96 250Q96 183 141 140T250 96Q284 96 313 109T354 135T375 160Q403 197 403 250Q403 313 360 358T245 403",
          8729: "55 251Q55 328 112 386T249 444T386 388T444 249Q444 171 388 113T250 55Q170 55 113 112T55 251",
          8730: "95 178Q89 178 81 186T72 200T103 230T169 280T207 309Q209 311 212 311H213Q219 311 227 294T281 177Q300 134 312 108L397 -77Q398 -77 501 136T707 565T814 786Q820 800 834 800Q841 800 846 794T853 782V776L620 293L385 -193Q381 -200 366 -200Q357 -200 354 -197Q352 -195 256 15L160 225L144 214Q129 202 113 190T95 178",
          8733: "56 124T56 216T107 375T238 442Q260 442 280 438T319 425T352 407T382 385T406 361T427 336T442 315T455 297T462 285L469 297Q555 442 679 442Q687 442 722 437V398H718Q710 400 694 400Q657 400 623 383T567 343T527 294T503 253T495 235Q495 231 520 192T554 143Q625 44 696 44Q717 44 719 46H722V-5Q695 -11 678 -11Q552 -11 457 141Q455 145 454 146L447 134Q362 -11 235 -11Q157 -11 107 56ZM93 213Q93 143 126 87T220 31Q258 31 292 48T349 88T389 137T413 178T421 196Q421 200 396 239T362 288Q322 345 288 366T213 387Q163 387 128 337T93 213",
          8734: "55 217Q55 305 111 373T254 442Q342 442 419 381Q457 350 493 303L507 284L514 294Q618 442 747 442Q833 442 888 374T944 214Q944 128 889 59T743 -11Q657 -11 580 50Q542 81 506 128L492 147L485 137Q381 -11 252 -11Q166 -11 111 57T55 217ZM907 217Q907 285 869 341T761 397Q740 397 720 392T682 378T648 359T619 335T594 310T574 285T559 263T548 246L543 238L574 198Q605 158 622 138T664 94T714 61T765 51Q827 51 867 100T907 217ZM92 214Q92 145 131 89T239 33Q357 33 456 193L425 233Q364 312 334 337Q285 380 233 380Q171 380 132 331T92 214",
          8736: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 22 57 28Q67 43 346 361Q397 420 474 508Q595 648 616 671T647 694T661 688T666 674Q666 668 663 663Q662 662 627 622T524 503T390 350L120 41L386 40H653Q666 30 666 20Q666 8 651 0H71",
          8737: "71 0L68 2Q65 3 63 5T58 11T55 20Q55 22 57 28Q64 38 348 373T638 712Q644 714 646 714Q653 714 659 709T666 694V693Q666 687 633 647Q619 631 576 580Q528 524 495 485Q336 296 329 289Q328 288 348 264T395 182T433 54L434 40H651Q666 32 666 20T651 0H436Q431 -20 416 -20Q400 -20 396 -4V0H71ZM394 40Q394 51 389 76T366 149T319 234L302 256L119 41L256 40H394",
          8738: "666 -32Q666 -51 646 -51Q639 -51 365 85L75 228Q55 238 55 250Q55 257 59 262T68 268L72 270L611 536Q642 551 647 551T659 547T666 532Q666 521 657 515L525 449Q525 448 535 424T556 352T566 250T556 148T536 77T525 51L657 -15Q666 -21 666 -32ZM526 250Q526 297 517 342T499 409T488 431Q487 431 304 341T121 250T304 159T488 69Q526 143 526 250",
          8739: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
          8740: "118 737Q131 750 138 750L151 746L158 739V579L160 421L213 470Q269 519 276 519Q284 519 290 513T296 499V498Q296 493 291 488T244 445Q225 428 213 417L158 368V-239Q143 -252 136 -252L124 -248L120 -241L118 44V328L62 279Q4 231 0 230Q-8 230 -14 236T-20 250Q-20 257 -11 265T62 332L118 384V737",
          8741: "133 736Q138 750 153 750Q164 750 170 739Q172 735 172 250T170 -239Q164 -250 152 -250Q144 -250 138 -244L137 -243Q133 -241 133 -179T132 250Q132 731 133 736ZM329 739Q334 750 346 750Q353 750 361 744L362 743Q366 741 366 679T367 250T367 -178T362 -243L361 -244Q355 -250 347 -250Q335 -250 329 -239Q327 -235 327 250T329 739",
          8742: "131 737Q134 739 138 743T144 748T151 750T171 737V199L327 357V737Q340 750 347 750Q351 750 353 749T360 743T367 737V397L429 457Q493 518 498 519Q506 519 512 512T518 500Q518 489 442 417L367 339V-237Q352 -250 346 -250L333 -243L327 -237V301L171 143V-237Q156 -250 151 -250T131 -237V101L69 41Q24 -3 15 -12T0 -21Q-8 -21 -14 -14T-20 -2Q-20 5 -7 19T56 81L131 159V737",
          8743: "318 591Q325 598 333 598Q344 598 348 591Q349 590 414 445T545 151T611 -4Q609 -22 591 -22Q588 -22 586 -21T581 -20T577 -17T575 -13T572 -9T570 -4L333 528L96 -4Q87 -20 80 -21Q78 -22 75 -22Q57 -22 55 -4Q55 2 120 150T251 444T318 591",
          8744: "55 580Q56 587 61 592T75 598Q86 598 96 580L333 48L570 580Q579 596 586 597Q588 598 591 598Q609 598 611 580Q611 574 546 426T415 132T348 -15Q343 -22 333 -22T318 -15Q317 -14 252 131T121 425T55 580",
          8745: "88 -21T75 -21T55 -7V200Q55 231 55 280Q56 414 60 428Q61 430 61 431Q77 500 152 549T332 598Q443 598 522 544T610 405Q611 399 611 194V-7Q604 -22 591 -22Q582 -22 572 -9L570 405Q563 433 556 449T529 485Q498 519 445 538T334 558Q251 558 179 518T96 401Q95 396 95 193V-7Q88 -21 75 -21",
          8746: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598",
          8747: "151 -112Q151 -150 106 -161Q106 -165 114 -172T134 -179Q155 -179 170 -146Q181 -120 188 -64T206 101T232 310Q256 472 277 567Q308 716 392 716Q434 716 453 681T472 613Q472 590 458 577T424 564Q404 564 390 578T376 612Q376 650 421 661Q421 663 418 667T407 675T393 679Q387 679 380 675Q360 665 350 619T326 438Q302 190 253 -57Q235 -147 201 -186Q174 -213 138 -216Q93 -216 74 -181T55 -113Q55 -91 69 -78T103 -64Q123 -64 137 -78T151 -112",
          8748: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244",
          8749: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244ZM807 -244Q807 -246 813 -251T833 -263T861 -269Q880 -269 893 -260Q914 -247 926 -218T945 -133T956 -15T970 155T991 367Q994 390 999 438T1008 512T1019 580T1034 647T1055 703T1084 751T1122 784T1173 804Q1175 804 1182 804T1195 805Q1246 802 1275 769T1304 695Q1304 669 1288 657T1255 645Q1236 645 1221 658T1206 694Q1206 705 1210 714T1220 729T1232 737T1242 742L1246 743Q1246 745 1239 751T1219 762T1192 768Q1169 768 1154 756T1128 716T1112 652T1101 559T1092 444T1081 300T1063 133Q1043 -38 1031 -102T997 -207Q950 -306 863 -306Q813 -306 781 -272T749 -196Q749 -170 765 -158T798 -146Q817 -146 832 -159T847 -195Q847 -206 843 -215T833 -230T821 -238T811 -242L807 -244",
          8750: "269 74L256 80Q244 85 227 97T191 128T161 179T148 250Q148 332 199 379T302 433L306 434L307 444Q309 456 313 495T321 553T331 607T345 664T365 712T393 756T431 785T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q471 768 454 752T427 693T414 626T406 536Q405 530 405 527L397 425L404 422Q410 419 421 413T445 399T470 376T494 345T511 303T518 250Q518 205 502 169T460 112T410 80T364 66L360 65L359 55Q357 38 353 4T346 -43T340 -81T333 -118T326 -148T316 -179T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q231 -241 242 -183T266 33L269 74ZM272 122Q272 156 300 391Q300 392 299 392Q287 392 263 379T213 331T187 249Q187 211 205 180T239 137T272 116V122ZM366 107Q378 107 402 119T453 167T479 249Q479 340 394 383V377Q394 375 394 374T393 371T393 366T392 357T391 342T389 321T386 291T382 251T377 199T369 133Q366 112 366 107",
          8756: "273 411Q273 437 291 454T334 471Q358 471 375 454T393 411T376 368T333 351Q307 351 290 368T273 411ZM84 38Q110 38 126 21T143 -22Q143 -46 127 -64T83 -82Q57 -82 41 -65T24 -22Q24 4 41 21T84 38ZM524 -22Q524 4 541 21T584 38Q608 38 625 21T643 -22Q643 -45 627 -63T583 -82Q557 -82 541 -65T524 -22",
          8757: "23 411Q23 437 41 454T84 471Q108 471 125 454T143 411T126 368T83 351Q57 351 40 368T23 411ZM523 411Q523 437 541 454T584 471Q608 471 625 454T643 411T626 368T583 351Q557 351 540 368T523 411ZM274 -22Q274 4 291 21T334 38Q356 38 374 22T392 -22T375 -65T333 -82Q307 -82 291 -65T274 -22",
          8764: "55 166Q55 241 101 304T222 367Q260 367 296 349T362 304T421 252T484 208T554 189Q616 189 655 236T694 338Q694 350 698 358T708 367Q722 367 722 334Q722 260 677 197T562 134H554Q517 134 481 152T414 196T355 248T292 293T223 311Q179 311 145 286Q109 257 96 218T80 156T69 133Q55 133 55 166",
          8765: "222 133Q147 133 102 197T56 335Q56 362 66 365Q71 369 77 364Q83 356 84 335T90 298Q102 254 137 222T223 189Q258 189 292 206T355 250T413 301T477 346T550 367Q628 367 673 309T722 171Q722 133 708 133Q703 133 699 141T694 162Q694 220 655 265T555 311Q519 311 485 293T421 248T363 196T298 152T222 133",
          8768: "55 569Q55 583 83 583Q122 583 151 565T194 519T215 464T222 411Q222 360 194 304T139 193T111 89Q111 38 134 -7T195 -55Q222 -57 222 -69Q222 -83 189 -83Q130 -83 93 -33T55 90Q55 130 72 174T110 252T148 328T166 411Q166 462 144 507T83 555Q55 556 55 569",
          8769: "220 366Q258 366 297 347T361 308T391 288Q394 288 464 370Q494 407 510 425T535 454T546 465T552 467H553Q560 467 566 461T573 448Q573 439 499 350Q424 266 424 261Q424 259 442 247T492 222T554 209Q607 209 646 243Q671 268 680 295T690 341T702 366Q719 366 719 314Q716 265 695 226Q682 199 664 179Q614 132 555 132Q517 132 477 151T412 190T383 210T347 172T278 89T233 37Q228 32 220 32Q210 32 206 38T201 48Q201 57 266 137Q272 144 275 148Q351 231 351 237Q351 239 333 251T283 276T221 289Q159 289 123 248T86 166Q86 156 82 145T73 132Q55 132 55 172Q55 220 79 272Q95 301 111 319Q161 366 220 366",
          8770: "55 439T55 443T56 449T62 456T68 463H706Q720 449 720 443T706 423H68Q55 439 55 443ZM56 72Q56 112 73 152T130 225T224 257Q259 257 294 240T360 199T419 149T484 107T553 90Q603 90 643 125T691 223Q693 257 704 257Q717 257 717 221Q717 147 671 91T554 34Q517 34 481 51T414 93T355 142T291 184T222 201Q172 201 131 167T84 67Q81 34 71 34Q56 37 56 72",
          8771: "55 283Q55 356 103 409T217 463Q262 463 297 447T395 382Q431 355 446 344T493 320T554 307H558Q613 307 652 344T694 433Q694 464 708 464T722 432Q722 356 673 304T564 251H554Q510 251 465 275T387 329T310 382T223 407H219Q164 407 122 367Q91 333 85 295T76 253T69 250Q55 250 55 283ZM56 56Q56 71 72 76H706Q722 70 722 56Q722 44 707 36H70Q56 43 56 56",
          8773: "55 388Q55 463 101 526T222 589Q260 589 296 571T362 526T421 474T484 430T554 411Q616 411 655 458T694 560Q694 572 698 580T708 589Q722 589 722 556Q722 482 677 419T562 356H554Q517 356 481 374T414 418T355 471T292 515T223 533Q179 533 145 508Q109 479 96 440T80 378T69 355Q55 355 55 388ZM56 236Q56 249 70 256H707Q722 248 722 236Q722 225 708 217L390 216H72Q56 221 56 236ZM56 42Q56 57 72 62H708Q722 52 722 42Q722 30 707 22H70Q56 29 56 42",
          8775: "55 417Q55 479 101 528T222 578Q259 578 294 564T393 507Q413 493 434 480T469 460T484 454L537 549Q587 639 595 647Q600 652 607 652Q615 652 621 647T628 634Q628 625 575 536Q524 446 524 443Q527 440 555 440Q603 440 644 469T691 547Q694 578 706 578T718 556Q718 555 718 551T717 545Q717 488 684 445T595 387Q582 384 558 384Q530 384 508 389L493 394L404 238L557 236H708Q720 224 720 217T706 196H379L291 43L499 41H708Q720 29 720 21T706 1H268L226 -71Q186 -143 179 -148Q173 -155 165 -155T152 -150T146 -137Q146 -133 184 -64L222 1H144L66 3L59 7Q54 14 54 20Q54 29 66 41H246L333 194Q333 196 202 196H68Q55 211 55 218T66 236H213L357 238L457 409L437 421Q432 423 393 450T307 500T222 523Q171 523 129 491T84 414Q82 383 70 383Q55 383 55 417",
          8776: "55 319Q55 360 72 393T114 444T163 472T205 482Q207 482 213 482T223 483Q262 483 296 468T393 413L443 381Q502 346 553 346Q609 346 649 375T694 454Q694 465 698 474T708 483Q722 483 722 452Q722 386 675 338T555 289Q514 289 468 310T388 357T308 404T224 426Q164 426 125 393T83 318Q81 289 69 289Q55 289 55 319ZM55 85Q55 126 72 159T114 210T163 238T205 248Q207 248 213 248T223 249Q262 249 296 234T393 179L443 147Q502 112 553 112Q609 112 649 141T694 220Q694 249 708 249T722 217Q722 153 675 104T555 55Q514 55 468 76T388 123T308 170T224 192Q164 192 125 159T83 84Q80 55 69 55Q55 55 55 85",
          8778: "220 523Q163 523 124 486T84 412Q81 383 69 383Q56 383 56 413Q56 441 67 470Q78 508 111 537T187 575Q203 579 219 579Q248 579 271 572Q304 565 393 508Q498 439 551 439Q620 439 662 486Q688 512 693 557Q693 565 697 572T707 579Q719 579 719 548Q719 483 673 434T550 384Q512 384 467 405T386 453T305 501T220 523ZM222 288Q164 288 124 251T84 177Q81 148 69 148Q56 148 56 178Q56 206 67 235Q78 274 111 302T187 339Q198 343 220 343Q244 343 259 341T308 322T393 272Q496 203 553 203Q612 203 651 241T691 312Q693 343 705 343Q719 343 719 313Q719 245 673 199Q626 148 552 148Q513 148 467 170T385 218T304 266T222 288ZM51 -19Q51 -6 62 -1H387Q713 -1 715 -3Q725 -10 725 -20Q725 -27 718 -34Q714 -38 672 -38T387 -39H62Q51 -25 51 -19",
          8781: "55 464Q55 471 60 477T74 484Q80 484 108 464T172 420T268 376T389 356Q436 356 483 368T566 399T630 436T675 467T695 482Q701 484 703 484Q711 484 716 478T722 464Q722 454 707 442Q550 316 389 316Q338 316 286 329T195 362T124 402T76 437T57 456Q55 462 55 464ZM57 45Q66 58 109 88T230 151T381 183Q438 183 494 168T587 135T658 94T703 61T720 45Q722 39 722 36Q722 28 717 22T703 16Q697 16 669 36T606 80T510 124T389 144Q341 144 294 132T211 101T147 64T102 33T82 18Q76 16 74 16Q66 16 61 22T55 36Q55 39 57 45",
          8782: "245 367Q251 415 288 453T392 492Q445 492 485 456T532 367H707Q722 359 722 347Q722 334 711 331T665 327H608H509Q500 332 498 336Q496 338 493 363T472 411Q443 451 389 451H387Q335 451 305 411Q290 392 287 374T282 344T268 327H72Q56 332 56 347Q56 360 70 367H245ZM56 153Q56 168 72 173H268Q277 168 279 164Q281 162 284 137T305 89Q334 49 389 49H391Q442 49 472 89Q487 108 490 126T495 156T509 173H608H666Q701 173 711 170T722 153T707 133H532Q526 81 486 45T389 8Q331 8 291 45T245 133H70Q56 140 56 153",
          8783: "245 367Q251 415 288 453T392 492Q445 492 485 456T532 367H707Q722 359 722 347Q722 334 711 331T665 327H608H509Q500 332 498 336Q496 338 493 363T472 411Q443 451 389 451H387Q335 451 305 411Q290 392 287 374T282 344T268 327H72Q56 332 56 347Q56 360 70 367H245ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
          8784: "56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM329 610Q329 634 346 652T389 670Q413 670 431 654T450 611Q450 586 433 568T390 550T347 567T329 610",
          8785: "421 474T389 474T339 493T321 541Q321 566 337 587T391 609Q456 602 456 541Q456 512 439 493ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM421 -108T389 -108T339 -89T321 -41Q321 -16 337 5T391 27Q456 20 456 -41Q456 -70 439 -89",
          8786: "15 541Q15 569 33 585T75 601T117 585T135 541Q135 514 118 498T75 481T32 498T15 541ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM642 -41Q642 -17 658 0T702 18Q726 18 744 3T762 -41Q762 -67 745 -84T702 -101Q676 -101 659 -85T642 -41",
          8787: "642 541Q642 569 660 585T702 601T744 585T762 541Q762 515 745 498T702 481Q676 481 659 497T642 541ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153ZM14 -41Q14 -15 31 1T74 18Q101 18 118 0T135 -41Q135 -64 118 -83T75 -102Q51 -102 33 -85T14 -41",
          8790: "56 347Q56 360 70 367H707Q722 359 722 347Q722 334 711 331T658 327H586H465L472 318Q496 288 496 250T472 182L465 173H586H663Q700 173 711 170T722 153T707 133H70Q56 140 56 153Q56 168 72 173H312L305 182Q281 212 281 250T305 318L312 327H72Q56 332 56 347ZM473 250Q473 265 472 273T460 297T428 327H349Q328 313 318 298T306 273T304 250Q304 235 305 227T317 203T349 173H428Q449 187 459 202T471 227T473 250",
          8791: "279 612Q279 656 310 688T388 721Q433 721 465 689T498 612Q498 573 470 538T389 503Q336 503 308 538T279 612ZM458 614Q458 637 452 651T433 672T411 679T383 680T352 675T333 664T324 647T321 629T320 611Q320 593 321 584T332 562T359 545Q366 543 389 543H391Q406 543 414 544T435 552T452 573T458 614ZM56 347Q56 360 70 367H707Q722 359 722 347Q722 336 708 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H708Q722 163 722 153Q722 140 707 133H70Q56 140 56 153",
          8796: "192 482H190Q187 483 185 484T181 488T177 493T175 501Q175 506 178 512Q184 523 278 687T375 853Q379 857 383 857Q385 857 387 858T390 859Q397 859 403 853Q405 851 499 687T600 512Q603 506 603 501Q603 488 587 482H192ZM548 523L389 798Q388 798 309 661T230 523T389 522T548 523ZM56 347Q56 360 70 367H708Q723 359 723 347Q723 336 709 328L390 327H72Q56 332 56 347ZM56 153Q56 168 72 173H709Q723 163 723 153Q723 140 708 133H70Q56 140 56 153",
          8800: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183L306 133H70Q56 140 56 153Q56 168 72 173H327L406 327H72Q56 332 56 347Q56 360 70 367H426Q597 702 602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 692 471 367H707Q722 359 722 347Q722 336 708 328L451 327L371 173H708Q722 163 722 153Q722 140 707 133H351Q175 -210 170 -212Q166 -215 159 -215",
          8801: "56 444Q56 457 70 464H707Q722 456 722 444Q722 430 706 424H72Q56 429 56 444ZM56 237T56 250T70 270H707Q722 262 722 250T707 230H70Q56 237 56 250ZM56 56Q56 71 72 76H706Q722 70 722 56Q722 44 707 36H70Q56 43 56 56",
          8804: "674 636Q682 636 688 630T694 615T687 601Q686 600 417 472L151 346L399 228Q687 92 691 87Q694 81 694 76Q694 58 676 56H670L382 192Q92 329 90 331Q83 336 83 348Q84 359 96 365Q104 369 382 500T665 634Q669 636 674 636ZM84 -118Q84 -108 99 -98H678Q694 -104 694 -118Q694 -130 679 -138H98Q84 -131 84 -118",
          8805: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 356 694 346T687 331Q685 329 395 192L107 56H101Q83 58 83 76Q83 77 83 79Q82 86 98 95Q117 105 248 167Q326 204 378 228L626 346L360 472Q291 505 200 548Q112 589 98 597T83 616ZM84 -118Q84 -108 99 -98H678Q694 -104 694 -118Q694 -130 679 -138H98Q84 -131 84 -118",
          8806: "674 753Q682 753 688 747T694 732T687 718Q686 717 417 589L151 463L399 345Q687 209 691 204Q694 198 694 193Q694 175 676 173H670L382 309Q92 446 90 448Q83 453 83 465Q84 476 96 482Q104 486 382 617T665 751Q669 753 674 753ZM84 39Q84 49 99 59H678Q694 53 694 39Q694 26 679 19H98Q84 26 84 39ZM83 -157Q83 -153 84 -150T86 -145T89 -141T92 -139T96 -137T99 -135H678Q694 -146 694 -155Q694 -168 679 -175H98Q84 -168 83 -157",
          8807: "83 733Q83 741 89 747T99 753Q107 753 253 685T543 548T687 478Q694 473 694 463T687 448Q685 446 395 309L107 173H101Q83 175 83 193Q83 194 83 196Q82 203 98 212Q117 222 248 284Q326 321 378 345L626 463L360 589Q291 622 200 665Q112 706 98 714T83 733ZM84 39Q84 49 99 59H678Q694 53 694 39Q694 26 679 19H98Q84 26 84 39ZM83 -157Q83 -153 84 -150T86 -145T89 -141T92 -139T96 -137T99 -135H678Q694 -146 694 -155Q694 -168 679 -175H98Q84 -168 83 -157",
          8808: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
          8809: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
          8810: "639 -48Q639 -54 634 -60T619 -67H618Q612 -67 536 -26Q430 33 329 88Q61 235 59 239Q56 243 56 250T59 261Q62 266 336 415T615 567L619 568Q622 567 625 567Q639 562 639 548Q639 540 633 534Q632 532 374 391L117 250L374 109Q632 -32 633 -34Q639 -40 639 -48ZM944 -48Q944 -54 939 -60T924 -67H923Q917 -67 841 -26Q735 33 634 88Q366 235 364 239Q361 243 361 250T364 261Q367 266 641 415T920 567L924 568Q927 567 930 567Q944 562 944 548Q944 540 938 534Q937 532 679 391L422 250L679 109Q937 -32 938 -34Q944 -40 944 -48",
          8811: "55 539T55 547T60 561T74 567Q81 567 207 498Q297 449 365 412Q633 265 636 261Q639 255 639 250Q639 241 626 232Q614 224 365 88Q83 -65 79 -66Q76 -67 73 -67Q65 -67 60 -61T55 -47Q55 -39 61 -33Q62 -33 95 -15T193 39T320 109L321 110H322L323 111H324L325 112L326 113H327L329 114H330L331 115H332L333 116L334 117H335L336 118H337L338 119H339L340 120L341 121H342L343 122H344L345 123H346L347 124L348 125H349L351 126H352L353 127H354L355 128L356 129H357L358 130H359L360 131H361L362 132L363 133H364L365 134H366L367 135H368L369 136H370L371 137L372 138H373L374 139H375L376 140L378 141L576 251Q63 530 62 533Q55 539 55 547ZM360 539T360 547T365 561T379 567Q386 567 512 498Q602 449 670 412Q938 265 941 261Q944 255 944 250Q944 241 931 232Q919 224 670 88Q388 -65 384 -66Q381 -67 378 -67Q370 -67 365 -61T360 -47Q360 -39 366 -33Q367 -33 400 -15T498 39T625 109L626 110H627L628 111H629L630 112L631 113H632L634 114H635L636 115H637L638 116L639 117H640L641 118H642L643 119H644L645 120L646 121H647L648 122H649L650 123H651L652 124L653 125H654L656 126H657L658 127H659L660 128L661 129H662L663 130H664L665 131H666L667 132L668 133H669L670 134H671L672 135H673L674 136H675L676 137L677 138H678L679 139H680L681 140L683 141L881 251Q368 530 367 533Q360 539 360 547",
          8812: "104 730Q104 749 123 749Q130 749 138 745Q186 717 237 671L250 659L261 670Q297 703 332 726T375 750T389 744T395 730Q395 721 390 717T364 699T322 668Q290 641 283 632Q280 628 281 627T293 612Q425 454 425 250Q425 144 388 51T293 -112Q282 -125 281 -126T283 -132Q306 -162 379 -209Q395 -219 395 -230Q395 -238 389 -244T375 -250T335 -228T262 -171L250 -159L238 -170Q202 -203 167 -226T124 -250T110 -244T104 -230Q104 -219 121 -209Q199 -156 216 -132Q219 -128 218 -127T206 -112Q74 46 74 250T206 612Q217 625 218 626T216 632Q199 656 121 709Q104 719 104 730ZM249 -94Q364 61 364 250Q364 430 265 574Q253 590 249 594L242 583Q134 439 134 250Q134 114 192 -1Q212 -44 242 -83L249 -94",
          8814: "693 -14T693 -20T687 -33T675 -41Q667 -41 506 37L344 112Q342 112 262 -46Q184 -196 176 -205Q172 -209 168 -209T162 -208Q155 -208 151 -203T146 -190Q146 -178 171 -137Q193 -91 251 21L306 132L198 183Q142 208 118 220T88 238T82 249Q82 253 86 261Q92 267 278 357L464 443L529 572Q561 637 577 667T597 703T607 708Q615 708 622 702T629 688Q629 680 575 579L524 474Q524 473 545 482T598 508Q666 541 673 541T686 535T693 521Q693 512 679 504T589 459L493 414L360 150Q366 148 378 142T431 116T529 70Q686 -8 689 -10Q693 -14 693 -20ZM380 277L433 383Q432 385 292 319T151 250T237 209T324 170L380 277",
          8815: "82 514T82 520T89 533T100 541Q106 541 271 463Q434 386 435 386L515 543Q593 699 600 706Q604 708 607 708Q615 708 622 702T629 688T549 526Q509 445 491 407T473 368Q522 343 580 317Q636 291 660 278T688 261T693 250V249Q693 241 681 234T580 184Q533 161 502 146Q317 59 315 59Q312 56 246 -74Q197 -170 186 -189T168 -209Q164 -209 162 -208Q155 -208 151 -203T146 -190Q146 -187 200 -79L253 28L218 11Q182 -6 144 -23T100 -41Q95 -41 89 -35T82 -21Q82 -12 96 -4T186 41L284 88L349 217Q377 273 395 311T413 350Q413 351 253 428Q101 498 86 510Q82 514 82 520ZM624 250Q461 330 455 330Q454 331 453 329T448 321T441 308T430 287T416 259T398 223L342 114L624 250",
          8816: "82 -124Q82 -120 83 -117T89 -110T95 -103H220L284 50Q346 204 344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q664 54 526 121Q513 127 495 136T464 150T438 162T416 173T399 180T388 185L384 186Q383 186 322 41L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H146L93 -141Q82 -134 82 -124ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
          8817: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q384 185 322 39L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H146L93 -141Q82 -134 82 -124Q82 -120 83 -117T89 -110T95 -103H220L273 26Q326 156 326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
          8818: "674 732Q682 732 688 726T694 711T687 697Q686 696 417 568L151 442L399 324Q687 188 691 183Q694 177 694 172Q694 154 676 152H670L382 288Q92 425 90 427Q83 432 83 444Q84 455 96 461Q104 465 382 596T665 730Q669 732 674 732ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
          8819: "90 697Q83 704 83 712T88 726T99 732Q107 732 253 664T543 527T687 457Q694 452 694 442T687 427Q685 425 395 288L107 152H101Q83 154 83 172Q83 173 83 175Q82 182 98 191Q117 201 248 263Q326 300 378 324L626 442L360 568Q91 696 90 697ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
          8822: "734 181Q734 173 728 167T714 161Q711 161 386 280T54 404Q44 408 44 421Q44 432 52 437Q66 443 388 562T714 681Q721 681 727 675T734 661Q734 651 722 645Q711 639 462 546Q441 539 420 531L122 421L420 311L723 198Q734 192 734 181ZM44 247Q44 255 50 261T63 267Q66 267 391 148T723 24Q734 18 734 7T723 -10Q716 -14 391 -133T63 -253Q56 -253 50 -247T44 -233Q44 -223 55 -217Q67 -210 317 -118Q337 -110 357 -103L655 7L357 117L54 230Q44 236 44 247",
          8823: "83 661Q83 668 88 674T104 681Q111 679 396 560Q686 437 687 436Q694 431 694 421T687 406Q686 405 543 344T253 222T101 161Q83 163 83 180Q83 194 95 199Q96 199 130 213T232 257T361 311L621 421L357 532Q307 553 233 584Q121 631 102 640T83 661ZM673 267Q694 267 694 248Q694 237 687 232Q684 229 420 118L156 7L416 -103L683 -215Q694 -222 694 -233Q694 -251 676 -253Q670 -253 524 -192T235 -70T90 -8Q83 -1 83 7Q83 19 94 24Q97 25 378 144T667 266Q669 267 673 267",
          8826: "84 249Q84 262 91 266T117 270Q120 270 126 270T137 269Q388 273 512 333T653 512Q657 539 676 539Q685 538 689 532T694 520V515Q689 469 672 431T626 366T569 320T500 286T435 265T373 249Q379 248 404 242T440 233T477 221T533 199Q681 124 694 -17Q694 -41 674 -41Q658 -41 653 -17Q646 41 613 84T533 154T418 197T284 220T137 229H114Q104 229 98 230T88 235T84 249",
          8827: "84 517Q84 539 102 539Q115 539 119 529T125 503T137 459T171 404Q277 275 640 269H661Q694 269 694 249T661 229H640Q526 227 439 214T283 173T173 98T124 -17Q118 -41 103 -41Q83 -41 83 -17Q88 29 105 67T151 132T208 178T277 212T342 233T404 249Q401 250 380 254T345 263T302 276T245 299Q125 358 92 468Q84 502 84 517",
          8828: "112 270Q83 270 83 290Q83 301 94 307Q98 310 118 310Q516 310 620 464Q635 486 642 510T651 548T657 571T675 580Q693 577 693 559V552Q684 472 628 410T465 314Q436 303 372 290Q373 290 388 287T425 278T465 266Q674 199 693 28L694 17Q688 5 683 3Q677 0 673 0Q656 0 653 24Q623 270 118 270H112ZM110 116Q83 116 83 136T110 156H113Q134 156 160 155T231 146T318 128T407 95T489 44T550 -30T583 -131Q583 -153 563 -153Q556 -153 553 -152T547 -145T542 -127Q531 -54 478 0Q425 53 333 83T123 116H110",
          8829: "668 310Q694 310 694 290Q694 285 691 279Q684 271 664 270Q550 268 464 257T301 220T179 146T124 27Q119 0 103 0T83 16Q83 21 83 31T92 68T113 121T157 177T229 231Q295 268 405 290Q404 290 389 293T352 302T312 314Q138 371 96 500Q83 541 83 562Q83 568 89 574T103 580Q115 580 120 570T126 542T138 497T173 442Q289 310 659 310H668ZM194 -131Q201 -60 241 -6T343 82T477 133T628 155Q632 155 644 155T661 156Q685 155 690 147Q694 143 694 136Q694 132 693 129T689 124T685 120T681 117L656 116Q596 114 543 106T436 79T342 35T272 -33T235 -127Q231 -154 212 -154Q203 -153 199 -147T194 -136V-131",
          8830: "84 442Q84 455 91 459T117 463Q120 463 126 463T137 462Q388 466 512 526T653 705Q657 732 676 732Q685 731 689 725T694 714V708Q689 662 672 624T626 559T569 513T500 479T435 458T373 442Q379 441 404 435T440 426T477 414T533 392Q592 362 630 319T681 241T694 174Q694 153 674 153Q662 153 657 163T652 188T640 231T606 287Q500 416 137 422H114Q104 422 98 423T88 428T84 442ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
          8831: "84 710Q84 732 102 732Q115 732 119 722T125 696T137 652T171 597Q277 468 640 462H661Q694 462 694 442T661 422H640Q578 421 526 417T415 403T309 376T222 333T156 268T124 179Q122 162 118 158T103 153Q100 153 98 153T95 154T93 155T90 158T85 163Q83 167 83 176Q88 222 105 260T151 325T208 371T277 405T342 426T404 442Q401 443 380 447T345 456T302 469T245 492Q125 551 92 661Q84 695 84 710ZM56 -194Q56 -107 106 -51T222 6Q260 6 296 -12T362 -56T420 -108T483 -153T554 -171Q616 -171 654 -128T694 -29Q696 6 708 6Q722 6 722 -26Q722 -102 676 -164T557 -227Q518 -227 481 -209T415 -165T358 -113T294 -69T223 -51Q163 -51 125 -93T83 -196Q81 -228 69 -228Q56 -228 56 -202V-194",
          8832: "386 292Q388 292 439 393T543 598T598 703Q599 703 603 704T609 705Q616 705 622 699T629 685T533 494Q440 308 440 305Q451 310 462 312Q547 342 592 388T651 505Q654 525 658 532T673 539Q680 539 686 533T693 519Q693 495 678 450Q638 341 500 283Q433 259 418 259Q416 259 411 251T406 241T415 239Q482 224 544 190Q674 121 691 -10Q693 -28 691 -32Q684 -43 672 -43Q664 -43 658 -37Q656 -33 650 -6T634 47T589 109T500 168Q473 179 436 190T388 201H386L284 -1Q261 -45 232 -101T191 -181T178 -206Q176 -206 172 -207T166 -208Q160 -208 153 -202T146 -188Q146 -185 246 12Q344 206 344 210Q344 213 305 217T213 225T124 228H95Q82 241 82 248Q82 253 95 268H124Q172 268 236 273T343 283T386 292",
          8833: "103 -43Q96 -43 89 -39T82 -26L84 -10Q105 141 275 212Q342 236 355 236Q360 236 364 245L369 256H360Q284 280 275 283Q115 351 86 490Q82 507 82 517Q82 526 88 532T103 538Q110 538 115 534Q119 531 122 517T128 486T143 444T174 397T231 351T320 310Q371 292 389 292L491 496Q595 701 598 703Q599 703 603 704T609 705Q616 705 622 699T629 685Q629 684 531 485Q431 296 431 288Q431 278 520 273T651 268H680Q693 253 693 248Q693 241 680 228H651Q591 228 491 218T386 201L284 -1Q261 -45 232 -101T191 -181T178 -206Q176 -206 172 -207T166 -208Q160 -208 153 -202T146 -188Q146 -182 302 125L335 190L324 185Q313 185 289 172Q241 153 208 128T159 78T135 31T124 -11T118 -37Q112 -43 103 -43",
          8834: "84 250Q84 372 166 450T360 539Q361 539 370 539T395 539T430 540T475 540T524 540H679Q694 532 694 520Q694 511 681 501L522 500H470H441Q366 500 338 496T266 472Q244 461 224 446T179 404T139 337T124 250V245Q124 157 185 89Q244 25 328 7Q348 2 366 2T522 0H681Q694 -10 694 -20Q694 -32 679 -40H526Q510 -40 480 -40T434 -41Q350 -41 289 -25T172 45Q84 127 84 250",
          8835: "83 520Q83 532 98 540H251Q267 540 297 540T343 541Q427 541 488 525T605 455Q693 374 693 250Q693 165 650 99T545 0T415 -39Q407 -40 251 -40H98Q83 -32 83 -20Q83 -10 96 0H255H308H337Q412 0 439 4T512 28Q533 39 553 54T599 96T639 163T654 250Q654 341 592 411Q557 449 512 472Q468 491 439 495T335 500H306H255L96 501Q83 511 83 520",
          8838: "84 346Q84 468 166 546T360 635Q361 635 370 635T395 635T430 636T475 636T524 636H679Q694 628 694 616Q694 607 681 597L522 596H470H441Q366 596 338 592T266 568Q244 557 224 542T179 500T139 433T124 346V341Q124 253 185 185Q244 121 328 103Q348 98 366 98T522 96H681Q694 86 694 76Q694 64 679 56H526Q510 56 480 56T434 55Q350 55 289 71T172 141Q84 223 84 346ZM104 -131T104 -118T118 -98H679Q694 -106 694 -118T679 -138H118Q104 -131 104 -118",
          8839: "83 616Q83 628 98 636H251Q267 636 297 636T343 637Q427 637 488 621T605 551Q693 470 693 346Q693 261 650 195T545 96T415 57Q407 56 251 56H98Q83 64 83 76Q83 86 96 96H255H308H337Q412 96 439 100T512 124Q533 135 553 150T599 192T639 259T654 346Q654 437 592 507Q557 545 512 568Q468 587 439 591T335 596H306H255L96 597Q83 607 83 616ZM84 -131T84 -118T98 -98H659Q674 -106 674 -118T659 -138H98Q84 -131 84 -118",
          8840: "146 -283Q146 -282 174 -213T202 -143H115Q102 -127 102 -123T115 -103H220L291 68L278 73Q203 101 153 157T86 288Q83 309 83 344Q83 380 86 399Q107 480 160 539Q222 601 298 621Q328 630 345 631T435 635L526 637L560 715Q587 778 593 789T609 801Q616 801 622 795T629 781Q629 780 625 771T614 742T600 706L571 637Q571 635 626 635H680Q693 620 693 613T689 601L682 597L618 595H553L449 346Q425 288 399 223T359 127T346 95H356Q365 95 381 95T417 94T463 93T515 93H682Q693 82 693 74T680 53H511Q420 55 335 55L329 57L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283ZM509 590Q509 595 438 595Q354 595 318 586Q246 567 195 516T126 395Q123 378 123 344T126 293Q141 229 184 181T291 110L306 104L406 346L509 590",
          8841: "82 606T82 613T95 635H251H348Q408 635 435 632T502 615L515 608L520 617Q520 619 558 708Q584 774 591 787T609 801Q616 801 622 795T629 781Q629 775 562 615L551 590L569 577Q646 527 678 437Q691 398 691 344T678 250Q653 182 597 132T469 64Q427 53 366 53H326L295 -25L262 -103H660Q673 -118 673 -124Q673 -129 669 -136L662 -141L453 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H95Q82 -128 82 -123T95 -103H220L251 -25L284 53H189L93 55L86 59Q82 64 82 71T95 93H302L400 333Q498 569 498 573L444 590Q431 593 260 595L93 597L86 601Q82 606 82 613ZM652 344V354Q652 451 575 521Q571 526 557 538T537 551Q534 551 533 548Q533 543 438 319L344 95L371 93H386Q487 93 557 150T649 293Q652 309 652 344",
          8842: "693 72Q693 68 692 66T686 59T680 52H524Q398 52 367 53T309 63Q236 82 180 132T98 250Q84 288 84 343Q84 397 98 437Q126 515 193 568T346 632Q347 632 373 633T440 634T520 635H680Q693 620 693 615Q693 608 680 595H526Q364 595 353 592Q279 582 221 539T138 430Q124 392 124 343Q124 296 138 257Q163 192 221 149T353 95Q364 92 526 92H680Q693 79 693 72ZM102 -132T102 -125T115 -103H382L420 -68Q429 -60 438 -52T452 -39T463 -28T472 -20T478 -14T483 -10T487 -7T490 -6T493 -5T496 -5Q502 -5 508 -12T515 -28Q515 -34 513 -37Q512 -38 507 -42T492 -55T475 -70L440 -101L562 -103H682Q693 -114 693 -122T680 -143H395L355 -179Q289 -241 280 -241Q273 -241 267 -235T260 -221T265 -208T300 -174L335 -143H224L113 -141L106 -137Q102 -132 102 -125",
          8843: "82 615Q82 620 95 635H251Q378 635 409 634T469 623Q540 605 596 555T678 437Q691 397 691 343T678 250Q649 172 581 119T426 55Q415 52 251 52H95Q93 55 89 59T84 65T82 72Q82 79 95 92H249Q411 92 422 95Q496 105 554 148T638 257Q651 296 651 343Q651 391 638 430Q613 495 555 538T422 592Q411 595 249 595H95Q82 608 82 615ZM82 -132T82 -125T95 -103H380L420 -57Q452 -21 460 -14T474 -6Q482 -6 488 -12T495 -25T451 -81L433 -101L549 -103H662Q673 -114 673 -122T660 -143H395L355 -190Q311 -239 309 -239Q305 -241 302 -241Q294 -241 287 -235T280 -221T324 -163L342 -143H218L93 -141L86 -137Q82 -132 82 -125",
          8846: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598ZM313 406Q313 417 313 435T312 459Q312 483 316 493T333 503T349 494T353 461V406V325H515Q516 325 519 323T527 316T531 305T527 294T520 287T515 285H353V204V152Q353 127 350 117T333 107T316 117T312 152Q312 158 312 175T313 204V285H151Q150 285 147 287T139 294T135 305T139 316T146 323T151 325H313V406",
          8847: "83 523Q87 535 99 539H679Q694 531 694 519Q694 506 679 499H123V-1H678Q694 -7 694 -21Q694 -34 679 -41H98Q93 -38 84 -28L83 247V523",
          8848: "64 506T64 519T78 539H699Q706 536 714 526V-28Q706 -38 699 -41H78Q64 -34 64 -21Q64 -6 80 -1H674V499H78Q64 506 64 519",
          8849: "94 620Q98 632 110 636H699Q714 628 714 616T699 596H134V96H698Q714 90 714 76Q714 64 699 56H109Q104 59 95 69L94 344V620ZM84 -118Q84 -103 100 -98H698Q714 -104 714 -118Q714 -130 699 -138H98Q84 -131 84 -118",
          8850: "64 603T64 616T78 636H668Q675 633 683 623V69Q675 59 668 56H78Q64 63 64 76Q64 91 80 96H643V596H78Q64 603 64 616ZM64 -118Q64 -108 79 -98H678Q694 -104 694 -118Q694 -130 679 -138H78Q64 -131 64 -118",
          8851: "83 0Q79 0 76 1T71 3T67 6T65 9T63 13T61 16V301L62 585Q70 595 76 598H592Q602 590 605 583V15Q598 2 587 0Q583 0 580 1T575 3T571 6T569 9T567 13T565 16V558H101V15Q94 2 83 0",
          8852: "77 0Q65 4 61 16V301L62 585Q72 598 81 598Q94 598 101 583V40H565V583Q573 598 585 598Q598 598 605 583V15Q602 10 592 1L335 0H77",
          8853: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM364 542Q308 539 251 509T148 418T96 278V270H369V542H364ZM681 278Q675 338 650 386T592 462T522 509T458 535T412 542H409V270H681V278ZM96 222Q104 150 139 95T219 12T302 -29T366 -42H369V230H96V222ZM681 222V230H409V-42H412Q429 -42 456 -36T521 -10T590 37T649 113T681 222",
          8854: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM681 278Q669 385 591 463T381 542Q283 542 196 471T96 278V270H681V278ZM275 -42T388 -42T585 32T681 222V230H96V222Q108 107 191 33",
          8855: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM582 471Q531 510 496 523Q446 542 381 542Q324 542 272 519T196 471L389 278L485 375L582 471ZM167 442Q95 362 95 250Q95 137 167 58L359 250L167 442ZM610 58Q682 138 682 250Q682 363 610 442L418 250L610 58ZM196 29Q209 16 230 2T295 -27T388 -42Q409 -42 429 -40T465 -33T496 -23T522 -11T544 1T561 13T574 22T582 29L388 222L196 29",
          8856: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM582 471Q581 472 571 480T556 491T539 502T517 514T491 525T460 534T424 539T381 542Q272 542 184 460T95 251Q95 198 113 150T149 80L167 58L582 471ZM388 -42Q513 -42 597 44T682 250Q682 363 610 442L196 29Q209 16 229 2T295 -27T388 -42",
          8857: "56 250Q56 394 156 488T384 583Q530 583 626 485T722 250Q722 110 625 14T390 -83Q249 -83 153 14T56 250ZM682 250Q682 322 649 387T546 497T381 542Q272 542 184 459T95 250Q95 132 178 45T389 -42Q515 -42 598 45T682 250ZM311 250Q311 285 332 304T375 328Q376 328 382 328T392 329Q424 326 445 305T466 250Q466 217 445 195T389 172Q354 172 333 195T311 250",
          8858: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM250 250Q250 316 295 352T384 388Q451 388 489 347T528 250Q528 192 487 152T389 112Q331 112 291 152T250 250ZM488 250Q488 290 460 319T389 349Q348 349 319 320T290 250Q290 208 320 180T389 151Q431 151 459 181T488 250",
          8859: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM204 339Q204 357 215 366T238 375Q247 375 283 348Q300 336 311 328L368 286Q369 286 366 323T359 398T355 437Q357 456 379 465Q380 465 384 465T391 466Q403 465 412 457T423 437Q423 436 420 398T413 323T410 286L467 328Q476 334 486 341T501 353T513 361T523 368T529 372T535 374T541 375Q554 375 564 365T575 339Q575 325 566 318T519 292Q504 285 496 281L430 250L496 219Q552 192 559 188T572 175Q575 168 575 161Q575 148 566 137T541 126H538Q530 126 499 149Q480 163 467 172L410 214Q409 214 412 177T419 102T423 63Q423 59 421 54T411 43T389 36T368 42T357 54T355 63Q355 64 358 102T365 177T368 214L311 172Q302 165 293 159T279 148T268 140T260 134T254 131T250 128T246 127T242 126T238 126Q223 126 214 135T204 161T213 183T282 219L348 250L282 281Q226 308 219 312T206 325Q204 330 204 339",
          8861: "57 250Q57 327 87 392T166 497T270 560T382 582H394Q512 582 610 500Q721 401 721 250Q721 112 626 15T389 -82Q251 -82 154 13T57 250ZM682 129T682 250T596 457T390 543Q269 543 183 457T96 250Q96 132 180 45T389 -43Q511 -43 596 43ZM223 250Q223 263 233 267T280 271Q289 271 325 271T389 270H490Q535 270 545 267T555 250Q555 241 549 235Q544 231 527 231T389 230Q239 230 235 232Q223 236 223 250",
          8862: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM369 365V649H95V365H369ZM682 365V649H409V365H682ZM369 40V325H95V40H369ZM682 40V325H409V40H682",
          8863: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 365V649H95V365H682ZM682 40V325H95V40H682",
          8864: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H707Q714 686 722 676V13Q714 3 707 0H71ZM123 649Q147 625 214 555T335 430T389 374L654 649H123ZM95 70Q99 74 229 209T360 345L95 619V70ZM682 70V619L418 346Q417 344 549 207L682 70ZM654 41L400 304L388 315L123 41L256 40H522L654 41",
          8865: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682ZM330 345Q330 371 347 388T390 405Q412 405 430 389T448 345Q448 317 430 301T389 285T348 301T330 345",
          8866: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V367H540Q555 359 555 347Q555 334 540 327H95V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678",
          8867: "515 678Q515 679 516 681T518 684T521 688T525 691T530 693T537 694Q548 692 555 679V15Q548 2 537 0Q533 0 530 1T525 3T521 6T519 9T517 13T515 16V327H71Q70 327 67 329T59 336T55 347T59 358T66 365T71 367H515V678",
          8868: "55 642T55 648T59 659T66 666T71 668H708Q723 660 723 648T708 628H409V15Q402 2 391 0Q387 0 384 1T379 3T375 6T373 9T371 13T369 16V628H71Q70 628 67 630T59 637",
          8869: "369 652Q369 653 370 655T372 658T375 662T379 665T384 667T391 668Q402 666 409 653V40H708Q723 32 723 20T708 0H71Q70 0 67 2T59 9T55 20T59 31T66 38T71 40H369V652",
          8872: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V367H796Q811 359 811 347Q811 336 797 328L479 327H161L159 328V172L161 173H797Q798 172 800 171T803 169T805 167T808 164T809 162T810 158T811 153Q811 140 796 133H159V-235Q151 -249 141 -249H139",
          8873: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678ZM249 678Q249 679 250 681T252 684T255 688T259 691T264 693T271 694Q282 692 289 679V367H651Q666 359 666 347Q666 334 651 327H289V15Q282 2 271 0Q267 0 264 1T259 3T255 6T253 9T251 13T249 16V678",
          8874: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678ZM237 678Q237 679 238 681T240 684T243 688T247 691T252 693T259 694Q270 692 277 679V15Q270 2 259 0Q255 0 252 1T247 3T243 6T241 9T239 13T237 16V678ZM419 678Q419 679 420 681T422 684T425 688T429 691T434 693T441 694Q452 692 459 679V367H818Q833 359 833 347Q833 334 818 327H459V15Q452 2 441 0Q437 0 434 1T429 3T425 6T423 9T421 13T419 16V678",
          8876: "56 681Q70 695 76 695T96 681V368H243L381 530Q521 692 525 692Q537 700 547 688Q554 682 554 674Q554 671 553 669T548 661T539 649T522 631T499 604T465 565T421 512Q296 373 296 368H416H476Q525 368 539 365T554 348Q554 334 543 328H261L96 141V12Q81 -1 75 -1Q65 -1 58 10L56 50V92L18 48Q7 37 -1 28T-13 14T-19 6T-23 1T-27 0T-33 -1Q-42 -1 -48 4T-55 19Q-55 24 -47 34T12 103L56 155V681ZM205 326Q205 328 152 328H96V263Q96 203 98 203Q99 203 123 231T174 290T205 326",
          8877: "56 681Q70 695 76 695T96 681V466H327L425 579Q522 692 527 692Q529 693 534 693Q542 693 547 688T553 674Q553 668 549 663Q549 662 538 650T504 611T463 563L381 468L461 466H543Q554 453 554 446T541 426H345L209 272L376 270H543Q554 257 554 251T541 230H174L96 141V12Q81 -1 75 -1Q65 -1 58 10L56 50V92L18 48Q7 37 -1 28T-13 14T-19 6T-23 1T-27 0T-33 -1Q-42 -1 -48 4T-55 19Q-55 24 -47 34T12 103L56 155V681ZM267 399L292 426H96V270H158L201 321Q256 382 267 399ZM118 228L119 229Q119 230 109 230H96V201L107 212Q118 227 118 228",
          8878: "56 681Q70 695 77 695T96 683V428L98 175L252 323V681Q264 695 272 695Q278 695 292 681V526Q292 368 296 368Q298 368 447 510Q638 695 642 695H645Q651 695 658 688T665 673Q665 666 661 661Q659 660 639 641T578 582T505 512L356 370L505 368H654Q665 357 665 349Q665 343 652 328H314L303 317L292 308V12Q289 10 285 6T279 1T272 -1Q265 -1 252 12V139Q252 266 249 266L96 119V12Q80 -1 76 -1T70 0T63 6T56 12V79L29 55Q-26 -1 -35 -1Q-42 -1 -48 5T-55 19Q-55 25 -51 30T-15 66Q5 86 18 99L56 135V681",
          8879: "56 681Q70 695 77 695T96 683V428L98 175L252 323V681Q264 695 272 695Q278 695 292 681V466H401L503 563L621 679Q637 695 645 695Q652 695 658 688T665 673Q665 670 663 666Q663 665 651 652T611 612T561 563L458 468L556 466H654Q665 455 665 447T652 426H416L294 308L292 288V270H652Q665 255 665 250T652 230H292V12Q289 10 285 6T279 1T272 -1Q265 -1 252 12V139Q252 266 249 266L96 119V12Q80 -1 76 -1T70 0T63 6T56 12V79L29 55Q-26 -1 -35 -1Q-42 -1 -48 5T-55 19Q-55 25 -51 30T-15 66Q5 86 18 99L56 135V681ZM358 426H292V361L325 392L358 426",
          8882: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26ZM654 11T654 249T653 487T402 369T151 249L275 190Q399 131 524 72T652 11Q654 11 654 249",
          8883: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523ZM376 368Q323 393 254 425T155 472L125 487Q123 487 123 249T125 11Q127 12 252 71T502 190L626 249L376 368",
          8884: "694 71Q686 58 676 56H670L382 192Q92 329 90 331Q83 336 83 346Q83 359 96 364Q101 367 379 498T665 634Q671 636 674 636Q686 636 694 621V71ZM654 108T654 346T653 584T402 466T151 346L275 287Q399 228 524 169T652 108Q654 108 654 346ZM83 -120Q83 -116 84 -113T86 -108T89 -104T92 -102T96 -100T99 -98H678Q679 -98 681 -99T684 -101T688 -104T691 -108T693 -113T694 -120Q692 -130 679 -138H98Q84 -130 83 -120",
          8885: "83 620Q83 621 85 624T92 632T103 636Q107 636 389 503T680 365Q694 357 694 346Q694 336 687 331Q685 329 395 192L107 56H101Q90 58 83 71V620ZM376 465Q323 490 254 522T155 570L125 584Q123 584 123 346T125 108Q127 109 252 168T502 287L626 346L376 465ZM83 -120Q83 -116 84 -113T86 -108T89 -104T92 -102T96 -100T99 -98H678Q679 -98 681 -99T684 -101T688 -104T691 -108T693 -113T694 -120Q692 -130 679 -138H98Q84 -130 83 -120",
          8888: "1055 250Q1055 190 1012 141T896 92Q858 92 828 106T781 140T755 180T741 214L738 228V230H405Q71 230 68 232Q55 238 55 250T68 268Q71 270 405 270H738V272L740 280Q742 287 745 297T754 321T771 348T796 374T832 396T881 408H891Q969 408 1012 360T1055 250ZM896 132Q948 132 981 166T1014 250Q1014 301 985 330T920 367Q914 368 891 368Q853 368 816 338T778 250Q778 198 812 165T896 132",
          8890: "318 -182Q302 -212 280 -212H278H275Q249 -212 239 -182L238 84V351H162L87 352Q57 362 57 391T84 429Q89 431 280 431H470L474 429Q477 427 479 426T484 423T490 417T495 410T499 402T500 391Q500 365 470 352L394 351H318V-182",
          8891: "56 697Q56 706 62 711T75 716Q86 716 90 709Q91 708 104 680T147 592T199 483L305 261L411 483Q443 548 481 629Q512 694 518 705T535 716Q543 716 549 710T555 700Q555 693 501 577T388 340T325 210Q316 194 305 194Q292 194 285 210Q282 219 224 339T111 574T56 697ZM55 14T55 20T59 31T66 38T71 40H540Q555 32 555 20T540 0H71Q70 0 67 2T59 9",
          8892: "55 698Q56 708 70 716H540Q554 708 555 698Q555 694 554 691T552 686T549 682T546 680T542 678T539 676H71Q70 676 68 677T65 679T61 682T58 686T56 691T55 698ZM555 18Q554 12 549 6T536 0H535Q525 0 515 17T459 132Q430 194 410 235L305 455L199 233Q176 185 147 125T105 36T90 7Q85 0 75 0Q63 0 58 11Q55 15 55 21Q58 31 170 266T285 507Q295 522 305 522T320 515Q322 513 439 268L555 24V18",
          8896: "119 -249T97 -249T65 -235T55 -207Q55 -201 56 -198Q58 -190 218 268T380 729Q392 750 416 750Q438 750 451 732Q453 728 534 498T695 36L775 -194Q777 -204 777 -208Q777 -222 767 -235T735 -249Q713 -249 700 -231Q696 -225 557 177L416 579L276 177Q136 -226 132 -231Q119 -249 97 -249",
          8897: "55 708Q55 729 68 739T96 750Q119 750 132 731Q136 726 276 323L416 -79L557 323Q696 725 700 731Q713 749 735 749Q756 749 766 736T777 708Q777 700 696 466T533 1T451 -232Q436 -249 416 -249Q402 -249 391 -241Q384 -236 380 -226Q368 -198 219 230Q55 697 55 708",
          8898: "139 -217Q127 -241 114 -246Q106 -249 97 -249Q67 -249 57 -220Q55 -214 55 102Q55 152 55 221T54 312Q54 422 60 464T91 554Q120 612 165 654T257 714T337 741T392 749Q393 750 402 750Q414 750 422 749Q557 749 660 659T776 430Q777 422 777 102Q777 -214 775 -220Q765 -249 735 -249Q716 -249 708 -241T694 -217L692 428L690 441Q674 540 597 603T416 666H409Q388 666 364 662T294 638T212 581Q156 523 142 441L140 428L139 105V-217",
          8899: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750",
          8900: "242 486Q245 488 250 488Q256 488 258 486Q262 484 373 373T486 258T488 250T486 242T373 127T258 14Q256 12 250 12Q245 12 242 14Q237 16 127 126T14 242Q12 245 12 250T14 258Q16 263 126 373T242 486ZM439 250L250 439L61 250L250 61L439 250",
          8901: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250",
          8902: "210 282Q210 284 225 381T241 480Q241 484 245 484Q249 486 251 486Q258 486 260 477T272 406Q275 390 276 380Q290 286 290 282L388 299Q484 314 487 314H488Q497 314 497 302Q497 297 434 266Q416 257 404 251L315 206L361 118Q372 98 383 75T401 40L407 28Q407 16 395 16Q394 16 392 16L390 17L250 159L110 17L108 16Q106 16 105 16Q93 16 93 28L99 40Q105 52 116 75T139 118L185 206L96 251Q6 296 4 300Q3 301 3 302Q3 314 12 314H13Q16 314 112 299L210 282",
          8903: "366 543Q374 545 382 545Q405 545 419 538Q429 534 443 521T462 496Q466 478 466 467Q466 438 444 412Q422 390 388 390Q352 390 331 412Q311 434 311 467Q311 499 331 518Q345 533 366 543ZM146 472Q146 479 153 485T166 492Q171 492 187 476T279 385L386 278L495 385Q600 492 608 492Q615 492 621 486T628 472Q628 467 614 452T531 367L435 270H706Q720 256 720 250Q720 241 706 230H435L531 132Q600 63 614 48T628 27Q628 20 622 14T608 7Q600 7 495 114L386 221L279 114Q204 39 188 23T166 7Q159 7 153 13T146 27Q146 32 160 47T244 132L339 230H68Q55 243 55 250Q55 255 68 270H339L244 367Q175 436 161 451T146 472ZM466 34Q466 4 447 -20T388 -44Q353 -44 331 -22Q311 1 311 34Q311 66 331 85Q347 101 366 110Q374 112 382 112Q405 112 419 105Q429 100 443 87T462 63Q466 45 466 34",
          8904: "833 50T833 250T832 450T659 351T487 250T658 150T832 50Q833 50 833 250ZM873 10Q866 -5 854 -5Q851 -5 845 -3L449 226L260 115Q51 -5 43 -5Q39 -5 35 -1T28 7L26 11V489Q33 505 43 505Q51 505 260 385L449 274L845 503Q851 505 853 505Q866 505 873 490V10ZM412 250L67 450Q66 450 66 250T67 50Q69 51 240 150T412 250",
          8905: "146 479Q159 492 166 492Q171 492 189 475T279 386L386 279L495 386Q598 492 608 492Q615 492 621 486T628 472Q628 464 522 357L415 250L522 144Q628 37 628 28Q628 21 622 15T608 8Q599 8 495 115L386 221L279 115Q204 40 188 24T166 8Q162 8 160 9T153 15T146 21V479ZM186 77L359 250L186 424V77",
          8906: "146 472Q146 479 152 485T166 492Q171 492 189 475T279 386L386 279L495 386Q598 492 608 492Q615 492 628 479V21Q615 8 608 8Q599 8 495 115L386 221L279 115Q204 40 188 24T166 8Q159 8 153 14T146 28Q146 37 253 144L359 250L253 357Q146 464 146 472ZM588 77V424L499 337L415 250L588 77",
          8907: "55 674Q55 682 62 688T76 694H77Q83 694 100 677T208 561Q320 440 410 342Q462 286 541 201Q677 55 699 30T722 -2Q722 -9 716 -15T701 -22T688 -17Q687 -15 542 141T394 301L388 306L240 146Q119 15 101 -3T75 -22T61 -16T55 -2Q55 4 67 19T158 117Q190 151 209 172L361 336L209 500Q62 657 57 667Q55 671 55 674",
          8908: "84 -22T76 -22T62 -16T55 -2Q55 4 78 30T249 215Q321 293 367 342Q672 672 683 682Q695 694 702 694Q710 694 716 688T722 674Q722 668 710 653T619 555Q587 521 568 500L416 336L568 172Q715 15 720 5Q722 1 722 -2Q722 -9 716 -15T702 -22H700Q693 -22 671 1T537 146L389 306Q387 304 340 253T237 143T135 33L89 -17Q84 -22 76 -22",
          8909: "56 433Q56 464 71 464Q74 464 77 461Q82 454 82 438T91 397T123 347Q166 307 222 307Q264 307 308 331T386 385T465 438T556 463Q631 463 676 408T722 283Q722 250 708 250Q704 250 699 257Q695 265 693 286T682 330Q670 350 655 367Q612 407 556 407Q514 407 470 383T393 329T314 276T222 251Q148 251 102 306T56 433ZM57 56Q57 71 73 76H706Q722 70 722 56Q722 44 707 36H71Q57 43 57 56",
          8910: "83 558Q83 566 89 572T104 578Q108 578 116 577T146 570T190 555T239 526T286 480Q308 453 325 420T351 358T367 304T376 265T380 251T381 253Q381 262 395 312Q428 434 492 499T642 576Q654 578 655 578Q664 578 670 572T676 558Q676 543 657 540T599 524T525 476Q406 362 400 29V8Q400 -21 380 -21Q369 -21 362 -11Q360 -7 360 12Q360 115 348 200T308 360T231 480T111 537Q83 540 83 558",
          8911: "104 -22Q95 -22 89 -16T83 -2Q83 11 98 16T135 23T192 46T256 103Q360 233 360 549Q360 554 360 557T361 563T362 567T364 569T367 572T371 576Q377 578 380 578Q401 578 401 547Q401 543 401 537T400 527Q409 53 648 19Q676 16 676 -2Q676 -10 670 -16T655 -22Q654 -22 642 -20Q556 -9 492 56T395 244Q381 294 381 303Q381 305 380 305T374 275T352 201T310 110T234 27T117 -20Q105 -22 104 -22",
          8912: "84 250Q84 372 166 450T360 539Q361 539 370 539T395 539T430 540T475 540T524 540H679Q694 532 694 520Q694 511 681 501L522 500H470H441Q366 500 338 496T266 472Q244 461 224 446T179 404T139 337T124 250V245Q124 157 185 89Q244 25 328 7Q348 2 366 2T522 0H681Q694 -10 694 -20Q694 -32 679 -40H526Q510 -40 480 -40T434 -41Q350 -41 289 -25T172 45Q84 127 84 250ZM694 134Q694 123 679 114H425H384Q350 114 326 121T277 154Q238 193 238 251Q238 322 295 361Q318 378 339 382T412 387Q423 387 459 387T520 386H679Q694 377 694 366Q694 354 679 346H519Q493 346 458 346T411 347Q360 347 341 342T303 315Q278 287 278 250Q278 210 301 187T351 156Q358 154 519 154H679Q694 146 694 134",
          8913: "83 520Q83 532 98 540H251Q267 540 297 540T343 541Q427 541 488 525T605 455Q693 374 693 250Q693 165 650 99T545 0T415 -39Q407 -40 251 -40H98Q83 -32 83 -20Q83 -10 96 0H255H308H337Q412 0 439 4T512 28Q533 39 553 54T599 96T639 163T654 250Q654 341 592 411Q557 449 512 472Q468 491 439 495T335 500H306H255L96 501Q83 511 83 520ZM83 366Q83 376 96 386H244Q280 386 317 386T378 386L402 387Q456 387 498 348T540 250Q540 203 512 168T446 120Q427 114 353 114H99Q84 120 84 134Q84 147 98 154H258Q284 154 319 154T366 153Q416 153 436 158T474 185Q500 214 500 250Q500 290 477 313T426 344Q419 346 258 346H98Q83 354 83 366",
          8914: "88 -21T75 -21T55 -7V200Q55 231 55 280Q56 414 60 428Q61 430 61 431Q77 500 152 549T332 598Q443 598 522 544T610 405Q611 399 611 194V-7Q604 -22 591 -22Q582 -22 572 -9L570 405Q563 433 556 449T529 485Q498 519 445 538T334 558Q251 558 179 518T96 401Q95 396 95 193V-7Q88 -21 75 -21ZM229 -21H227Q215 -21 209 -7V166Q209 304 209 327T215 363Q226 398 259 421T333 444Q380 444 414 416T455 347Q457 339 457 166V-7Q449 -21 439 -21H437H435Q423 -21 417 -7V164Q417 303 417 325T411 358Q387 403 333 403T255 358Q250 347 250 325T249 164V-7Q241 -21 231 -21H229",
          8915: "591 598H592Q604 598 611 583V376Q611 345 611 296Q610 162 606 148Q605 146 605 145Q586 68 507 23T333 -22Q268 -22 209 -1T106 66T56 173Q55 180 55 384L56 585Q66 598 75 598Q85 598 95 585V378L96 172L98 162Q112 95 181 57T332 18Q415 18 487 58T570 175Q571 180 571 383V583Q579 598 591 598ZM437 598Q450 598 457 583V410Q457 237 455 229Q448 189 414 161T333 132Q291 132 255 157T211 230Q209 237 209 412L210 585Q220 598 229 598Q242 598 249 583V412Q249 273 249 251T255 218Q279 173 333 173T411 218Q416 229 416 251T417 412V583Q425 598 437 598",
          8916: "76 -22Q64 -22 56 -7V176L57 360L59 370Q66 401 83 426T123 468T171 495T221 513T265 522T298 527L311 528H314V625L315 723Q325 736 334 736Q346 736 354 721V528H356L368 527Q380 526 399 523T441 515T490 498T537 472T578 433T606 379Q611 359 611 171V-7Q604 -21 591 -21T571 -7V170Q571 313 571 337T565 375Q555 408 526 432T461 467T402 482T365 487H354V-7Q347 -21 334 -21T314 -7V487H303Q251 484 207 467Q121 438 99 367L97 357L96 174V-9Q86 -22 76 -22",
          8918: "86 261Q92 267 381 404T673 541Q680 541 686 535T693 521T689 510Q684 504 418 379L151 250L418 121Q686 -4 689 -10Q693 -14 693 -21T687 -34T675 -41Q668 -41 380 96T86 239Q82 244 82 250Q82 257 86 261ZM610 250Q610 224 592 198T531 172Q498 172 475 195Q453 214 453 250Q453 308 513 328Q515 330 535 330Q569 328 589 304T610 250",
          8919: "82 521Q82 529 89 535T100 541Q107 541 395 404T689 261Q693 257 693 250T689 239Q684 234 396 97T100 -41Q95 -41 89 -35T82 -21Q82 -12 96 -4Q118 9 358 121L624 250L358 379Q91 503 86 510Q82 514 82 521ZM165 250Q165 282 188 306T239 330Q262 330 275 323Q303 312 318 283Q322 272 322 250Q322 213 300 195Q277 172 246 172Q224 172 213 177Q165 200 165 250",
          8920: "639 -48Q639 -54 634 -60T619 -67H618Q612 -67 536 -26Q430 33 329 88Q61 235 59 239Q56 243 56 250T59 261Q62 266 336 415T615 567L619 568Q622 567 625 567Q639 562 639 548Q639 540 633 534Q632 532 374 391L117 250L374 109Q632 -32 633 -34Q639 -40 639 -48ZM958 -48Q958 -54 953 -60T938 -67H937Q931 -67 855 -26Q749 33 648 88Q380 235 378 239Q375 243 375 250T378 261Q381 266 655 415T934 567L938 568Q941 567 944 567Q958 562 958 548Q958 540 952 534Q951 532 693 391L436 250L693 109Q951 -32 952 -34Q958 -40 958 -48ZM1277 -48Q1277 -54 1272 -60T1257 -67H1256Q1250 -67 1174 -26Q1068 33 967 88Q699 235 697 239Q694 243 694 250T697 261Q700 266 974 415T1253 567L1257 568Q1260 567 1263 567Q1277 562 1277 548Q1277 540 1271 534Q1270 532 1012 391L755 250L1012 109Q1270 -32 1271 -34Q1277 -40 1277 -48",
          8921: "75 -67Q65 -67 60 -61T55 -48Q55 -40 61 -34Q62 -32 329 109L595 250L329 391Q62 532 61 534Q55 540 55 548Q55 562 69 567H77Q81 567 222 493T506 342T653 264Q667 250 653 236Q649 234 504 157T220 7T77 -67H75ZM364 547Q364 563 381 567L384 568Q387 568 518 499T795 353T955 269Q967 261 967 250T955 231Q925 216 780 139T513 -3T383 -67Q373 -67 369 -60T364 -47Q364 -40 370 -34Q373 -31 639 109L904 250L639 391Q373 531 370 534Q364 540 364 547ZM674 538T674 548T681 562T693 567Q699 567 816 505Q915 453 993 412Q1050 382 1132 339Q1241 282 1259 271T1277 250Q1277 241 1263 232Q1246 221 985 84Q698 -67 692 -67Q674 -67 674 -47Q674 -38 680 -33Q683 -30 947 109L1213 250L947 391Q683 530 680 533Q674 538 674 548",
          8922: "674 445Q674 438 669 432T655 425T369 531T90 640Q83 645 83 655Q83 668 95 673Q644 886 654 886Q662 886 668 880T674 866Q674 856 663 850Q649 843 411 751L160 655L407 560Q474 534 561 501Q646 469 660 462T674 445ZM84 250Q84 260 99 270H658Q674 264 674 250Q674 238 659 230H98Q84 237 84 250ZM83 55Q83 68 94 73Q98 76 104 76Q108 75 383 -30T664 -138Q674 -144 674 -155Q674 -165 667 -170Q664 -173 385 -279T104 -386Q85 -386 83 -368Q83 -354 92 -349Q93 -349 347 -251L597 -155L346 -59Q296 -40 223 -12Q118 28 101 36T83 55",
          8923: "111 425T102 425T88 431T83 445V446Q83 455 96 461Q111 469 203 504Q287 536 350 560L597 655L346 751Q94 848 92 850Q83 856 83 866Q83 873 88 879T104 886Q109 885 386 779T667 670Q674 665 674 655T667 640Q665 638 388 532ZM84 250Q84 260 99 270H658Q674 264 674 250Q674 238 659 230H98Q84 237 84 250ZM653 76Q656 76 660 75T669 68T674 56Q674 46 665 40Q663 38 411 -59L160 -155L410 -251Q664 -349 665 -349Q674 -354 674 -368Q672 -386 654 -386Q650 -386 371 -279T90 -170Q83 -165 83 -155Q83 -144 93 -138Q645 76 653 76",
          8926: "113 424Q83 424 83 444Q83 453 96 464H121Q181 466 234 474T341 501T435 545T505 613T542 707Q545 734 564 734Q583 731 583 714Q583 658 560 613T500 538T414 486T321 453T229 434T156 426T113 424ZM112 270Q83 270 83 290Q83 301 94 307Q98 310 118 310Q624 310 653 556Q657 580 675 580Q693 577 693 559V552Q684 472 628 410T465 314Q436 303 372 290Q373 290 388 287T425 278T465 266Q674 199 693 28L694 17L692 14Q691 11 689 8T683 3T673 0Q657 0 653 24Q623 270 118 270H112",
          8927: "195 713Q195 725 201 729T214 734Q227 734 231 722T238 691T255 641T299 580Q405 474 656 464H681Q694 451 694 443Q694 424 670 424H664Q535 424 415 465T235 595Q195 657 195 713ZM668 310Q694 310 694 290Q694 285 691 279Q684 271 664 270Q550 268 464 257T301 220T179 146T124 27Q119 0 103 0T83 16Q83 21 83 31T92 68T113 121T157 177T229 231Q295 268 405 290Q404 290 389 293T352 302T312 314Q138 371 96 500Q83 541 83 562Q83 568 89 574T103 580Q115 580 120 570T126 542T138 497T173 442Q289 310 659 310H668",
          8928: "82 344Q82 349 95 364H124Q266 364 398 390L429 397L509 595Q519 619 536 659Q581 766 590 783T609 801Q616 801 622 795T629 781Q629 776 553 595Q533 548 516 506T489 439T480 415Q482 415 505 426T538 444Q632 498 651 601Q654 621 658 628T673 635Q680 635 686 629T693 615Q693 591 678 546Q636 433 484 375L458 364L451 348Q443 332 443 329T455 324Q480 316 503 307T560 277T619 233T664 170T691 86Q693 68 691 64Q684 53 672 53Q664 53 658 59Q657 60 650 97T617 174T538 244Q515 257 476 273T428 289Q425 289 412 256Q381 179 344 90L262 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 174 -213T202 -143H95Q82 -128 82 -123T95 -103H220L302 97Q384 288 384 299Q384 302 341 308T235 319T124 324H95Q82 337 82 344ZM399 338Q403 338 406 346L409 353L375 344Q375 343 384 341T399 338",
          8929: "146 -283Q146 -282 174 -213T202 -143H95Q82 -127 82 -123T95 -103H220L300 93Q343 196 374 270Q385 294 386 299L373 295Q331 287 289 268Q241 249 208 224T159 174T135 127T124 85T118 59Q112 53 103 53Q91 53 84 64Q82 68 84 86Q96 185 174 248T375 337L400 344Q399 344 381 348T351 355T316 364T276 379T235 398T193 424T155 456T122 497T98 546Q82 587 82 615Q82 622 88 628T102 635Q112 635 116 628T124 601Q128 579 134 562T159 515T207 463T290 418T415 384L422 381L506 586Q571 744 584 772T609 801Q616 801 622 795T629 781T544 577Q525 529 504 478T473 402T462 375Q480 373 500 373Q579 364 651 364H680Q682 361 686 357T691 351T693 344Q693 337 680 324H651Q553 324 451 310L433 308L349 104L262 -101L473 -103H682Q694 -115 694 -123Q694 -133 682 -141L464 -143H246L213 -219Q182 -292 178 -299Q172 -303 166 -303T153 -297T146 -283",
          8934: "86 450Q93 455 380 592T673 730Q680 730 686 724T693 710Q693 702 688 699Q686 693 417 568L151 439L417 310Q685 185 688 179Q693 176 693 168Q693 161 687 155T675 148Q668 148 380 285T86 428Q74 438 86 450ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
          8935: "88 723Q95 730 99 730Q106 730 394 593T688 450Q693 447 693 439T688 428Q683 423 395 286T99 148Q94 148 88 155T82 168Q82 175 86 179Q89 184 357 310L624 439L357 568Q88 694 86 699Q81 703 81 711T88 723ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
          8936: "95 419Q81 433 81 439T95 459H124Q318 459 455 501Q515 521 556 550T615 607T641 659T652 702T659 725Q667 730 673 730Q680 730 686 724T693 710Q693 682 677 641Q668 616 654 594T622 554T586 522T545 497T504 477T464 462T428 452T397 444T375 439Q379 437 410 430T476 411T551 379T625 321T677 237Q693 196 693 168Q693 161 687 155T673 148Q662 148 658 154T651 181Q638 253 591 300T455 377Q318 419 124 419H95ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
          8937: "679 459Q693 445 693 439Q693 430 679 419H651Q455 419 319 377Q231 347 184 300T124 181Q120 161 116 155T102 148Q95 148 89 154T82 168Q82 192 97 237Q111 275 137 306T188 355T249 391T307 414T361 429T399 439Q397 440 364 447T298 467T224 499T149 557T97 641Q82 686 82 710Q82 717 88 723T102 730L115 725Q118 722 124 697Q137 625 184 578T319 501Q456 459 651 459H679ZM55 -205Q55 -175 64 -142T92 -76T145 -22T222 -1Q288 -1 362 -66Q369 -72 372 -75T378 -79T382 -81T384 -79Q389 -74 439 21Q483 100 490 111T504 122Q510 122 518 118T526 103Q526 101 510 69T467 -12T419 -99L413 -112L433 -128Q498 -180 553 -180Q605 -180 646 -139Q672 -112 681 -77T693 -21T706 -1Q719 -1 719 -33Q719 -39 717 -57Q708 -141 655 -190Q625 -224 586 -232Q568 -237 551 -237Q487 -237 413 -172L391 -155Q391 -157 335 -255Q297 -325 286 -342T268 -359Q260 -359 254 -353T248 -339T304 -230L359 -126Q359 -124 337 -107T302 -81Q262 -57 221 -57Q170 -57 130 -93T84 -201Q82 -236 70 -236Q55 -236 55 -205",
          8938: "693 -30Q686 -41 673 -41Q661 -41 506 34L346 110L280 -44Q228 -162 216 -185T193 -208Q177 -208 173 -192Q173 -186 242 -30T311 128Q271 145 184 186T86 236Q82 240 82 246Q82 251 86 259Q96 267 271 350L449 434L506 565Q537 635 551 664T571 700T582 706Q587 706 593 701T600 690Q600 679 553 572Q504 463 504 461L586 501Q672 539 673 539Q679 539 693 525V-30ZM653 10V488L566 445L480 405L422 276Q415 260 405 236T388 199T376 171T368 151T366 145Q368 143 510 77T653 10ZM422 374Q422 376 420 376T285 313T151 248Q315 168 326 163Q415 356 422 374",
          8939: "82 525Q96 539 102 539Q103 539 122 530T186 501T266 463L426 388Q428 388 495 541Q564 694 569 699Q573 706 581 706Q587 706 593 702T600 691Q600 676 533 528Q515 486 506 465T485 418T470 381T466 370Q466 369 575 316Q676 269 689 259Q693 253 693 248Q693 242 689 236Q688 235 506 145Q328 63 324 59Q324 50 266 -70Q224 -169 214 -188T193 -208Q177 -208 173 -192Q173 -183 222 -77Q244 -29 257 2T269 34L186 -6Q108 -43 99 -43Q93 -43 82 -30V525ZM271 416Q129 485 126 485H125Q122 485 122 250Q122 10 124 10L211 50L295 92L411 350Q411 351 271 416ZM624 248L449 332L440 319Q434 297 393 214Q353 121 353 119Q355 119 489 182T624 248",
          8940: "82 -123Q82 -114 93 -103H166L238 -101L293 50Q349 200 349 204L220 266Q166 291 140 304T100 325T84 336T82 344Q82 353 94 360Q112 372 282 453L473 541L482 568Q487 578 529 693Q559 785 569 795Q573 802 581 802Q587 802 593 797T599 786Q599 775 564 675L526 570Q526 568 561 584T633 617T673 635Q679 635 693 621V66Q686 54 679 54Q665 54 526 119Q491 137 458 153T405 177T386 184Q385 182 334 42T282 -101T482 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L473 -143H266L238 -219Q217 -278 210 -290T193 -303Q178 -303 173 -287Q173 -279 198 -214L222 -145Q222 -143 158 -143L93 -141L86 -136Q82 -131 82 -123ZM653 106V584L506 513L453 370Q442 339 428 300T407 243T400 224Q403 222 527 164T653 106ZM453 486Q453 488 451 488T300 417T151 344L224 308Q247 298 285 279T331 257L364 241L453 486",
          8941: "82 621Q96 635 102 635T249 568L420 486L449 473L469 533Q563 789 569 797Q573 801 581 801Q598 801 600 786Q602 781 544 617L484 455Q531 435 584 408Q677 364 689 355Q693 351 693 344Q693 339 692 337T676 325T631 302T538 257Q504 241 465 223T406 195T386 186Q384 184 333 44T282 -101Q282 -103 482 -103H680Q682 -105 684 -108T688 -113T691 -118T693 -124Q693 -134 682 -141L473 -143H266L238 -219Q217 -278 210 -290T193 -303Q178 -303 173 -287Q173 -279 198 -214L222 -145Q222 -143 158 -143L93 -141L86 -136Q82 -131 82 -123Q82 -114 93 -103H166L238 -101L333 159Q326 159 220 106Q110 54 97 54Q89 54 82 66V621ZM298 501Q155 567 142 575L122 584V344Q122 106 124 106Q125 106 180 132T291 185T351 213Q355 217 393 326L433 435Q433 436 298 501ZM549 381Q472 417 471 417L406 241Q408 240 516 291T624 344L549 381",
          8942: "78 30Q78 54 95 72T138 90Q162 90 180 74T199 31Q199 6 182 -12T139 -30T96 -13T78 30ZM78 440Q78 464 95 482T138 500Q162 500 180 484T199 441Q199 416 182 398T139 380T96 397T78 440ZM78 840Q78 864 95 882T138 900Q162 900 180 884T199 841Q199 816 182 798T139 780T96 797T78 840",
          8943: "78 250Q78 274 95 292T138 310Q162 310 180 294T199 251Q199 226 182 208T139 190T96 207T78 250ZM525 250Q525 274 542 292T585 310Q609 310 627 294T646 251Q646 226 629 208T586 190T543 207T525 250ZM972 250Q972 274 989 292T1032 310Q1056 310 1074 294T1093 251Q1093 226 1076 208T1033 190T990 207T972 250",
          8945: "133 760Q133 784 150 802T193 820Q217 820 235 804T254 761Q254 736 237 718T194 700T151 717T133 760ZM580 460Q580 484 597 502T640 520Q664 520 682 504T701 461Q701 436 684 418T641 400T598 417T580 460ZM1027 160Q1027 184 1044 202T1087 220Q1111 220 1129 204T1148 161Q1148 136 1131 118T1088 100T1045 117T1027 160",
          8965: "55 698Q56 708 70 716H540Q554 708 555 698Q555 694 554 691T552 686T549 682T546 680T542 678T539 676H71Q70 676 68 677T65 679T61 682T58 686T56 691T55 698ZM555 18Q554 12 549 6T536 0H535Q525 0 515 17T459 132Q430 194 410 235L305 455L199 233Q176 185 147 125T105 36T90 7Q85 0 75 0Q63 0 58 11Q55 15 55 21Q58 31 170 266T285 507Q295 522 305 522T320 515Q322 513 439 268L555 24V18",
          8966: "55 795Q56 806 70 813H540Q554 806 555 795Q555 791 554 788T552 783T549 779T546 777T542 775T539 773H71Q70 773 68 774T65 776T61 779T58 783T56 788T55 795ZM55 601Q56 612 70 619H540Q554 612 555 601Q555 597 554 594T552 589T549 585T546 583T542 581T539 579H71Q70 579 68 580T65 582T61 585T58 589T56 594T55 601ZM75 -97Q67 -97 61 -91T55 -81Q55 -71 169 166T285 410Q295 425 305 425Q311 425 316 422T323 414L325 410Q327 404 441 167T555 -81Q555 -85 549 -91T535 -97T520 -90Q519 -89 506 -61T463 27T411 136L305 358L199 136Q167 71 129 -10Q98 -75 92 -86T75 -97",
          8968: "174 734Q178 746 190 750H298H369Q400 750 411 747T422 730T411 713T372 709Q365 709 345 709T310 710H214V-235Q206 -248 196 -250Q192 -250 189 -249T184 -247T180 -244T178 -241T176 -237T174 -234V734",
          8969: "21 717T21 730T32 746T75 750H147H256Q266 742 269 735V-235Q262 -248 251 -250Q247 -250 244 -249T239 -247T235 -244T233 -241T231 -237T229 -234V710H133Q119 710 99 710T71 709Q43 709 32 713",
          8970: "174 734Q174 735 175 737T177 740T180 744T184 747T189 749T196 750Q206 748 214 735V-210H310H373Q401 -210 411 -213T422 -230T411 -247T369 -251Q362 -251 338 -251T298 -250H190Q178 -246 174 -234V734",
          8971: "229 734Q229 735 230 737T232 740T235 744T239 747T244 749T251 750Q262 748 269 735V-235Q266 -240 256 -249L147 -250H77Q43 -250 32 -247T21 -230T32 -213T72 -209Q79 -209 99 -209T133 -210H229V734",
          8988: "76 306Q62 306 59 319T55 386V500V596Q55 664 57 676T68 692Q71 694 250 694Q428 694 432 692Q444 685 444 674Q444 665 432 656Q428 654 261 654H95V487Q95 355 95 336T90 312Q84 306 76 306",
          8989: "424 306Q418 306 413 310T406 318L404 321V654H238Q71 654 68 656Q55 662 55 674T68 692Q71 694 250 694H379Q432 694 438 688Q443 683 443 662T444 500T444 338T438 312Q432 306 424 306",
          8990: "55 172V287Q55 341 58 353T76 366Q88 366 95 351V18H261Q428 18 432 16Q444 9 444 -2Q444 -11 432 -20Q428 -22 250 -22H120Q67 -22 61 -16Q56 -11 56 10T55 172",
          8991: "404 351Q410 366 424 366Q437 366 440 353T444 288V172V72Q444 8 443 -4T432 -20Q428 -22 250 -22Q71 -22 68 -20Q55 -14 55 -2T68 16Q71 18 238 18H404V351",
          8994: "55 141Q55 149 72 174T125 234T209 303T329 360T478 388H526Q649 383 765 319Q814 291 858 250T923 179T944 141Q944 133 938 128T924 122Q914 124 912 125T902 139Q766 328 500 328Q415 328 342 308T225 258T150 199T102 148T84 124Q81 122 75 122Q55 127 55 141",
          8995: "923 378Q944 378 944 358Q944 345 912 311T859 259Q710 134 500 134Q288 134 140 259Q55 336 55 358Q55 366 61 372T75 378Q78 378 84 376Q86 376 101 356T147 310T221 257T339 212T500 193Q628 193 734 236Q841 282 903 363Q914 378 923 378",
          9001: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
          9002: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
          9136: "357 741V726Q357 720 349 715Q261 655 242 539Q240 526 240 454T239 315T239 247Q240 235 240 124V40Q240 -17 233 -53T201 -130Q155 -206 78 -244H69H64Q58 -244 57 -243T56 -234Q56 -232 56 -231V-225Q56 -218 63 -215Q153 -153 170 -39Q172 -25 173 119V219Q173 245 174 249Q173 258 173 376V460Q173 515 178 545T201 611Q244 695 327 741L334 744H354L357 741",
          9137: "78 744Q153 706 196 640T239 492V376Q239 341 239 314T238 271T238 253Q239 251 239 223V119V49Q239 -39 254 -85Q263 -111 275 -134T301 -172T326 -197T346 -213T356 -221T357 -232V-241L354 -244H334Q264 -209 222 -146T174 -12Q173 -6 173 95Q173 134 173 191T174 250Q173 258 173 382V451Q173 542 159 585Q145 626 120 658T75 706T56 723V731Q56 741 57 742T66 744H78",
          9168: "312 0V602H355V0H312",
          9416: "451 -175Q328 -175 226 -115T66 47T8 267Q8 303 15 342T39 431T94 531T186 622Q239 663 307 686T424 709H440Q604 709 716 622Q757 592 788 555T838 482T869 414T886 350T892 301T894 267Q894 147 835 45T674 -116T451 -175ZM854 268Q854 375 802 467T657 614T450 670Q283 670 166 552T49 267Q49 99 167 -18T453 -136Q617 -136 735 -18T854 268ZM273 378Q273 430 309 474T409 527Q411 527 417 527T428 528Q498 528 549 484L567 505Q583 528 590 528H594Q600 528 606 522V350L600 344H586Q577 344 574 344T569 347T566 357Q542 491 432 491Q389 491 365 465T340 407Q340 391 344 378T358 356T377 340T400 328T421 321T443 316T459 313Q499 305 517 300T559 279T601 238Q629 195 629 148Q629 80 583 33T471 -14Q392 -14 330 30Q312 6 293 -13Q292 -14 285 -14Q279 -14 273 -8V77V138Q273 160 275 165T286 170H294H307Q313 164 313 158Q313 108 350 67T471 26Q512 26 537 54T562 119Q562 137 558 151T544 176T527 193T504 205T483 212T459 218T441 222Q391 232 368 241T318 273Q273 316 273 378",
          9484: "76 306Q62 306 59 319T55 386V500V596Q55 664 57 676T68 692Q71 694 250 694Q428 694 432 692Q444 685 444 674Q444 665 432 656Q428 654 261 654H95V487Q95 355 95 336T90 312Q84 306 76 306",
          9488: "424 306Q418 306 413 310T406 318L404 321V654H238Q71 654 68 656Q55 662 55 674T68 692Q71 694 250 694H379Q432 694 438 688Q443 683 443 662T444 500T444 338T438 312Q432 306 424 306",
          9492: "55 172V287Q55 341 58 353T76 366Q88 366 95 351V18H261Q428 18 432 16Q444 9 444 -2Q444 -11 432 -20Q428 -22 250 -22H120Q67 -22 61 -16Q56 -11 56 10T55 172",
          9496: "404 351Q410 366 424 366Q437 366 440 353T444 288V172V72Q444 8 443 -4T432 -20Q428 -22 250 -22Q71 -22 68 -20Q55 -14 55 -2T68 16Q71 18 238 18H404V351",
          9585: "19 -195Q13 -195 7 -188T0 -176Q0 -169 18 -151L822 683Q835 694 840 694T852 688T860 674Q860 667 810 614T460 252Q57 -167 44 -179Q27 -195 19 -195",
          9586: "0 675Q0 681 6 687T19 694Q27 694 44 678L460 247Q759 -62 809 -115T860 -175Q860 -183 852 -189T840 -195Q835 -195 822 -184L18 649Q0 667 0 675",
          9632: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
          9633: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682",
          9642: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
          9650: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99",
          9651: "75 0L72 2Q69 3 67 5T62 11T59 20Q59 24 62 30Q65 37 245 370T428 707Q428 708 430 710T436 714T444 716Q451 716 455 712Q459 710 644 368L828 27V20Q828 7 814 0H75ZM610 347L444 653Q443 653 278 347T113 40H775Q775 42 610 347",
          9652: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99",
          9653: "75 0L72 2Q69 3 67 5T62 11T59 20Q59 24 62 30Q65 37 245 370T428 707Q428 708 430 710T436 714T444 716Q451 716 455 712Q459 710 644 368L828 27V20Q828 7 814 0H75ZM610 347L444 653Q443 653 278 347T113 40H775Q775 42 610 347",
          9654: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523",
          9656: "83 523Q83 524 85 527T92 535T103 539Q107 539 389 406T680 268Q694 260 694 249Q694 239 687 234Q685 232 395 95L107 -41H101Q90 -40 83 -26V523",
          9657: "26 489Q33 505 43 505Q51 505 260 385Q464 266 471 259Q473 257 473 250Q473 242 469 239Q459 231 260 115Q51 -5 43 -5Q39 -5 35 -1T28 7L26 11V489ZM412 250L67 450Q66 450 66 250T67 50Q69 51 240 150T412 250",
          9660: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556",
          9661: "59 480Q59 485 61 489T66 495T72 498L75 500H814Q828 493 828 480V474L644 132Q458 -210 455 -212Q451 -215 444 -215T433 -212Q429 -210 342 -49T164 282T64 466Q59 478 59 480ZM775 460H113Q113 459 278 153T444 -153T610 153T775 460",
          9662: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556",
          9663: "59 480Q59 485 61 489T66 495T72 498L75 500H814Q828 493 828 480V474L644 132Q458 -210 455 -212Q451 -215 444 -215T433 -212Q429 -210 342 -49T164 282T64 466Q59 478 59 480ZM775 460H113Q113 459 278 153T444 -153T610 153T775 460",
          9664: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26",
          9666: "694 -26Q686 -40 676 -41H670L382 95Q92 232 90 234Q83 239 83 249Q83 262 96 267Q101 270 379 401T665 537Q671 539 674 539Q686 539 694 524V-26",
          9667: "473 10Q466 -5 454 -5Q451 -5 445 -3Q444 -3 343 56T140 173T35 234Q26 239 26 250T35 266Q40 269 240 384T445 503Q451 505 453 505Q466 505 473 490V10ZM433 50T433 250T432 450T259 351T87 250T258 150T432 50Q433 50 433 250",
          9674: "318 709Q325 716 332 716Q340 716 344 713T474 511Q611 298 611 292Q611 285 526 152Q494 103 474 72Q347 -128 344 -130Q340 -132 333 -132T322 -130Q319 -128 257 -31T131 169T60 278Q56 285 56 292Q56 298 60 305Q73 326 194 516T318 709ZM567 290T567 291T451 475T333 658L100 293Q100 288 215 108L333 -74Q334 -74 450 108",
          9711: "56 250Q56 353 95 442T196 589T335 681T491 715Q573 715 635 693Q694 673 747 635T846 543T917 412T944 250Q944 58 815 -78T500 -215Q457 -215 429 -210Q274 -183 165 -56T56 250ZM500 -176Q664 -176 784 -54T904 250Q904 418 799 536T543 674Q534 675 493 675Q425 675 357 647T229 567T133 432T96 250Q96 160 129 80T217 -56T346 -144T500 -176",
          9723: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71ZM682 40V649H95V40H682",
          9724: "71 0Q59 4 55 16V346L56 676Q64 686 70 689H709Q719 681 722 674V15Q719 10 709 1L390 0H71",
          9733: "367 395Q374 416 398 492T442 627T463 688Q463 692 467 692Q471 694 472 694Q478 694 484 680T523 562Q553 469 576 400L577 395H731H819Q872 395 883 394T895 384Q895 380 891 376T832 333Q794 305 767 285Q643 195 643 194L690 47Q737 -96 737 -103Q737 -111 727 -111Q721 -111 594 -18L472 71L350 -18Q223 -111 217 -111Q207 -111 207 -103Q207 -96 254 47L301 194Q301 195 241 239T118 328T51 378Q49 382 49 384Q49 392 58 393T110 395H213H367",
          9824: "181 -21Q134 -21 96 27T55 193Q55 224 58 247T82 317T143 410Q172 443 234 498Q282 543 314 598T360 687T380 725Q386 727 389 727Q395 727 398 725T406 716T413 702T423 677T439 641Q481 556 544 498Q633 420 678 353T723 204Q723 142 711 94T669 12T590 -21Q520 -21 490 8T459 66V70H409V62Q409 22 416 -17T430 -82T437 -112Q437 -131 407 -131Q403 -131 397 -131T389 -130T382 -130T372 -131Q341 -131 341 -111Q341 -107 348 -82T362 -18T369 62V70H319V66Q319 57 314 44T297 16T257 -10T191 -21H181",
          9825: "55 490Q55 557 71 604T114 674T167 706T222 716Q279 716 322 684T389 605Q391 610 395 617T414 643T447 677T494 704T555 716Q642 716 682 652T723 490Q723 455 718 426T684 342T602 227Q573 196 537 161T485 110T449 63T412 -8Q408 -22 404 -27T389 -33Q382 -33 379 -31T372 -23T366 -8T355 18T335 54Q319 81 298 104T239 163T176 227Q102 310 79 371T55 490ZM198 674Q143 664 119 613T95 491Q95 415 137 346Q174 282 265 194T384 48L389 39Q391 42 397 54T406 71T415 86T427 104T442 122T464 146T491 172Q571 249 613 303Q683 396 683 487Q683 581 649 631Q613 676 556 676Q495 676 457 634T410 538Q407 514 390 514Q386 514 380 517Q372 520 369 536T355 581T319 635Q277 675 223 675H217H208L204 674Q200 674 198 674",
          9826: "370 714Q370 717 375 722T388 727Q398 727 403 721T417 697Q420 692 421 689Q536 465 709 304Q723 291 723 282T709 260Q529 93 406 -153Q402 -162 390 -162H389Q379 -162 376 -158T357 -125Q247 89 89 241L64 265Q55 272 55 282Q55 287 57 290T64 300T77 312T98 331T127 361Q197 435 258 523T344 663L370 714ZM655 299Q568 384 508 470T389 662L376 638Q362 613 341 577T289 497T215 399T123 299L105 282L123 265Q210 180 270 94T389 -98L402 -74Q416 -49 437 -13T489 67T563 165T655 265L673 282L655 299",
          9827: "213 532Q213 615 265 670T389 726Q461 726 513 671T565 532Q565 511 562 492T553 458T541 432T526 409T512 393T498 379L490 371L511 326Q512 326 516 330T528 341T546 353T572 363T606 368Q664 368 707 315T750 174Q750 87 699 33T579 -22Q567 -22 553 -20T517 -10T479 16T459 63V70H409V62Q409 22 416 -17T430 -82T437 -112Q437 -131 407 -131Q403 -131 397 -131T389 -130T382 -130T372 -131Q341 -131 341 -111Q341 -107 348 -82T362 -18T369 62V70H319V63Q315 25 281 2T197 -22Q132 -22 80 32T28 174Q28 255 69 311T175 368Q192 368 207 364T232 353T250 341T262 331T267 326L288 371L280 378Q272 385 267 391T253 407T238 430T226 457T217 492T213 532",
          9837: "200 467Q254 467 293 428T332 321Q332 147 104 -11L88 -22H75Q62 -22 56 -16L55 362V647Q55 743 60 748Q63 750 76 750H83Q87 750 95 744V434L104 440Q144 467 200 467ZM237 322Q237 360 225 388T183 417Q158 417 134 407T101 378Q96 370 96 349T95 197V34Q152 91 194 167T237 322",
          9838: "65 721Q78 734 94 734Q100 734 104 727V444L116 449Q129 454 157 465T208 486Q313 527 314 527Q318 527 324 521V-210Q306 -223 294 -223Q289 -223 284 -216V-13L270 -18Q257 -24 231 -34T180 -54Q77 -96 74 -96T65 -90V721ZM104 13Q282 84 283 85Q284 85 284 252Q284 418 283 418L230 396L140 360L104 346V13",
          9839: "101 -223Q94 -223 93 -217T91 -188V-151Q91 -88 90 -88Q87 -88 80 -92T68 -96Q62 -96 56 -90L55 -50V-22Q55 -8 58 -4T78 5L91 10V177Q91 343 90 343Q87 343 80 339T68 335Q62 335 56 341L55 381V409Q55 423 58 427T78 436L91 441V543V616Q91 643 93 648T106 656Q119 662 126 659Q130 657 130 645T131 554V456L257 503V607L258 710L260 712Q261 715 272 719T286 723Q293 723 295 715T297 671V617Q297 519 298 519Q301 519 307 522T319 526Q327 526 333 521V437L330 435Q328 432 312 427L297 421V254Q297 88 298 88Q301 88 307 91T319 95Q327 95 333 90V6L330 4Q328 1 312 -4L297 -10V-78V-122Q297 -145 295 -149T282 -156Q274 -160 268 -160Q257 -160 257 -130V-89V-25L131 -72V-210Q123 -215 116 -218T104 -222L101 -223ZM257 72V406L131 359V25L257 72",
          10003: "84 231Q84 244 114 264T170 285Q176 285 183 274T224 205Q267 129 268 129Q271 141 279 163T318 250T389 378T502 523T662 673Q702 706 732 706H734Q749 706 749 695Q749 682 730 666T660 607T559 505Q387 299 328 29Q324 0 295 -17T245 -34H241Q234 -34 225 -21T185 46Q166 79 154 101Q84 223 84 231",
          10016: "195 702T195 706T201 716H632Q638 710 638 706T636 700T621 690Q436 581 427 374V357H430Q554 357 645 421Q682 447 711 483T755 542T770 567Q775 572 786 563V131Q777 125 774 125T762 139Q709 228 642 274T482 333Q452 337 430 337H427V320Q430 279 437 247T462 170T521 82T621 4Q630 -2 633 -4T637 -7T638 -12Q638 -16 632 -22H201Q195 -16 195 -12T197 -6T212 4Q397 113 406 320V337H403Q279 337 188 273Q151 247 122 211T78 152T63 127Q58 122 48 131V563Q54 569 59 569Q62 569 71 555Q124 466 191 420T351 361Q381 357 403 357H406V374Q403 415 396 447T371 525T312 613T212 690Q199 697 197 699",
          10072: "139 -249H137Q125 -249 119 -235V251L120 737Q130 750 139 750Q152 750 159 735V-235Q151 -249 141 -249H139",
          10216: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
          10217: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
          10222: "357 741V726Q357 720 349 715Q261 655 242 539Q240 526 240 394V331Q240 259 239 250Q240 242 240 119V49Q240 -42 254 -85Q263 -111 275 -134T301 -172T326 -197T346 -213T356 -221T357 -232V-241L354 -244H334Q264 -209 222 -146T174 -12Q173 -6 173 95Q173 134 173 191T174 250Q173 260 173 376V460Q173 515 178 545T201 611Q244 695 327 741L334 744H354L357 741",
          10223: "78 744Q153 706 196 640T239 492V376Q239 339 239 311T238 269T238 252Q240 236 240 124V40Q240 -18 233 -53T202 -130Q156 -206 79 -244H70H65Q58 -244 57 -242T56 -231T57 -220T64 -215Q153 -154 170 -39Q173 -18 174 119V247Q173 249 173 382V451Q173 542 159 585Q145 626 120 658T75 706T56 723V731Q56 741 57 742T66 744H78",
          10229: "165 270H1510Q1525 262 1525 250T1510 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270",
          10230: "84 237T84 250T98 270H1444Q1328 357 1301 493Q1301 494 1301 496T1300 499Q1300 511 1317 511H1320Q1329 511 1332 510T1338 506T1341 497T1344 481T1352 456Q1374 389 1425 336T1544 261Q1553 258 1553 250Q1553 244 1548 241T1524 231T1486 212Q1445 186 1415 152T1370 85T1349 35T1341 4Q1339 -6 1336 -8T1320 -11Q1300 -11 1300 0Q1300 7 1305 25Q1337 151 1444 230H98Q84 237 84 250",
          10231: "165 270H1694Q1578 357 1551 493Q1551 494 1551 496T1550 499Q1550 511 1567 511H1570Q1579 511 1582 510T1588 506T1591 497T1594 481T1602 456Q1624 389 1675 336T1794 261Q1803 258 1803 250Q1803 244 1798 241T1774 231T1736 212Q1695 186 1665 152T1620 85T1599 35T1591 4Q1589 -6 1586 -8T1570 -11Q1550 -11 1550 0Q1550 7 1555 25Q1587 151 1694 230H165Q167 228 182 216T211 189T244 152T277 96T303 25Q308 7 308 0Q308 -11 288 -11Q281 -11 278 -11T272 -7T267 2T263 21Q245 94 195 151T73 236Q58 242 55 247Q55 254 59 257T73 264Q121 283 158 314T215 375T247 434T264 480L267 497Q269 503 270 505T275 509T288 511Q308 511 308 500Q308 493 303 475Q293 438 278 406T246 352T215 315T185 287T165 270",
          10232: "274 173H1539Q1540 172 1542 171T1545 169T1547 167T1550 164T1551 162T1552 158T1553 153Q1553 140 1538 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H1538Q1553 359 1553 347Q1553 336 1539 328L1221 327H903L900 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173",
          10233: "1218 514Q1218 525 1234 525Q1239 525 1242 525T1247 525T1251 524T1253 523T1255 520T1257 517T1260 512Q1297 438 1358 381T1469 300T1565 263Q1582 258 1582 250T1573 239T1536 228T1478 204Q1334 134 1260 -12Q1256 -21 1253 -22T1238 -24Q1218 -24 1218 -17Q1218 -13 1223 0Q1258 69 1309 123L1319 133H70Q56 140 56 153Q56 168 72 173H1363L1373 181Q1412 211 1490 250Q1489 251 1472 259T1427 283T1373 319L1363 327H710L707 328L390 327H72Q56 332 56 347Q56 360 70 367H1319L1309 377Q1276 412 1247 458T1218 514",
          10234: "1438 514Q1438 525 1454 525Q1459 525 1462 525T1467 525T1471 524T1473 523T1475 520T1477 517T1480 512Q1517 438 1578 381T1689 300T1785 263Q1802 258 1802 250T1793 239T1756 228T1698 204Q1554 134 1480 -12Q1476 -21 1473 -22T1458 -24Q1438 -24 1438 -17Q1438 -13 1443 0Q1478 69 1529 123L1539 133H318L328 123Q379 69 414 0Q419 -13 419 -17Q419 -24 399 -24Q388 -24 385 -23T377 -12Q332 77 253 144T72 237Q62 240 59 242T56 250T59 257T70 262T89 268T119 278T160 296Q303 366 377 512Q382 522 385 523T401 525Q419 524 419 515Q419 510 414 500Q379 431 328 377L318 367H1539L1529 377Q1496 412 1467 458T1438 514ZM274 173H1583L1593 181Q1632 211 1710 250Q1709 251 1692 259T1647 283T1593 319L1583 327H930L927 328L602 327H274L264 319Q225 289 147 250Q148 249 165 241T210 217T264 181L274 173",
          10236: "95 155V109Q95 83 92 73T75 63Q61 63 58 74T54 130Q54 140 54 180T55 250Q55 421 57 425Q61 437 75 437Q88 437 91 428T95 393V345V270H1444Q1328 357 1301 493Q1301 494 1301 496T1300 499Q1300 511 1317 511H1320Q1329 511 1332 510T1338 506T1341 497T1344 481T1352 456Q1374 389 1425 336T1544 261Q1553 258 1553 250Q1553 244 1548 241T1524 231T1486 212Q1445 186 1415 152T1370 85T1349 35T1341 4Q1339 -6 1336 -8T1320 -11Q1300 -11 1300 0Q1300 7 1305 25Q1337 151 1444 230H95V155",
          10731: "318 709Q325 716 332 716Q340 716 344 713T474 511Q611 298 611 292Q611 285 526 152Q494 103 474 72Q347 -128 344 -130Q340 -132 333 -132T322 -130Q319 -128 257 -31T131 169T60 278Q56 285 56 292Q56 298 60 305Q73 326 194 516T318 709",
          10744: "166 -215T159 -215T147 -212T141 -204T139 -197Q139 -190 144 -183Q157 -157 378 274T602 707Q605 716 618 716Q625 716 630 712T636 703T638 696Q638 691 406 241T170 -212Q166 -215 159 -215",
          10752: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM555 -165Q672 -165 767 -108T916 44T970 250Q970 418 861 532T600 664Q591 665 548 665Q446 665 353 614T200 466T140 250V243Q140 88 248 -30Q262 -46 280 -62T338 -105T434 -148T555 -165ZM478 250Q478 288 503 307T551 326Q586 326 609 305T632 250Q632 217 610 196T555 174T500 196T478 250",
          10753: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM513 478Q513 664 512 664Q504 664 481 660T406 637T313 588Q281 564 255 537T211 483T181 431T161 382T150 342T144 310T141 292H513V478ZM798 588Q758 616 711 634T639 658T602 663L597 664V292H969Q969 293 967 309T960 341T949 381T930 430T900 482T856 537T798 588ZM513 -164V208H141Q142 205 144 189T149 160T158 125T173 83T196 39T229 -9Q249 -34 273 -55T318 -92T363 -119T405 -138T444 -150T475 -158T499 -162T513 -164ZM775 -103Q801 -87 823 -68T863 -30T894 10T919 49T937 88T950 123T959 154T964 180T968 198L969 208H597V-164Q599 -163 616 -161T647 -155T683 -145T728 -128T775 -103",
          10754: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM600 664Q591 665 548 665Q414 665 306 583L292 573L423 441L555 310L687 441L818 573L804 583Q714 650 600 664ZM364 118L495 250L364 382L232 513L223 500Q140 391 140 250Q140 107 223 0L232 -13L364 118ZM970 250Q970 389 887 501L878 512Q878 513 861 496T812 447T746 381L615 250L746 118L878 -13L887 0Q970 109 970 250ZM687 59L555 190L423 59L292 -73L306 -83Q416 -166 555 -166T804 -83L818 -73L687 59",
          10756: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750ZM223 276Q223 282 224 287T227 296T232 302T238 308T243 313T250 316L254 319H374V376V406Q374 438 382 454T418 470Q443 467 450 453T458 410V376V319H579Q580 319 583 317T589 313T594 308T600 302T604 295T608 287T609 276Q609 253 587 241Q577 235 513 235H458V178Q458 176 458 166T459 148Q459 84 415 84Q401 84 390 93T375 117Q374 120 374 178V235H319Q317 235 307 235T290 234Q223 234 223 276",
          10758: "777 -217Q766 -244 745 -249H88Q64 -242 57 -220Q55 -214 55 250T57 720Q60 734 70 740Q80 750 96 750Q127 750 137 720Q139 714 139 274V-166H693V274Q693 714 695 720Q705 749 735 749Q766 749 775 719Q777 713 777 248V-217",
          10799: "630 29Q630 9 609 9Q604 9 587 25T493 118L389 222L284 117Q178 13 175 11Q171 9 168 9Q160 9 154 15T147 29Q147 36 161 51T255 146L359 250L255 354Q174 435 161 449T147 471Q147 480 153 485T168 490Q173 490 175 489Q178 487 284 383L389 278L493 382Q570 459 587 475T609 491Q630 491 630 471Q630 464 620 453T522 355L418 250L522 145Q606 61 618 48T630 29",
          10815: "28 660Q28 676 31 679T46 683H50Q87 681 182 681Q217 681 247 681T294 682T315 682Q321 682 323 682T328 679T331 673T332 660Q332 643 328 640T304 637Q239 637 231 626Q229 620 229 334V46H520V334Q520 620 518 626Q510 637 445 637Q426 637 422 640T417 660Q417 675 420 678T432 682H435Q437 682 467 682T569 681T671 681T703 682Q714 682 717 679T721 660Q721 643 717 640T693 637Q628 637 620 626Q619 623 619 342Q619 60 620 57Q628 46 693 46Q714 46 717 43T721 23Q721 5 715 1Q713 0 374 0Q36 0 34 1Q28 5 28 23Q28 40 31 43T56 46Q121 46 129 57Q131 63 131 342Q131 620 129 626Q121 637 56 637Q35 637 32 640T28 660",
          10846: "55 795Q56 806 70 813H540Q554 806 555 795Q555 791 554 788T552 783T549 779T546 777T542 775T539 773H71Q70 773 68 774T65 776T61 779T58 783T56 788T55 795ZM55 601Q56 612 70 619H540Q554 612 555 601Q555 597 554 594T552 589T549 585T546 583T542 581T539 579H71Q70 579 68 580T65 582T61 585T58 589T56 594T55 601ZM75 -97Q67 -97 61 -91T55 -81Q55 -71 169 166T285 410Q295 425 305 425Q311 425 316 422T323 414L325 410Q327 404 441 167T555 -81Q555 -85 549 -91T535 -97T520 -90Q519 -89 506 -61T463 27T411 136L305 358L199 136Q167 71 129 -10Q98 -75 92 -86T75 -97",
          10877: "674 636Q682 636 688 630T694 615T687 601Q686 600 417 472L151 346L399 228Q687 92 691 87Q694 81 694 76Q694 58 676 56H670L382 192Q92 329 90 331Q83 336 83 348Q84 359 96 365Q104 369 382 500T665 634Q669 636 674 636ZM94 170Q102 172 104 172Q110 171 254 103T535 -30T678 -98Q694 -106 694 -118Q694 -136 676 -138H670L382 -2Q92 135 90 137Q83 142 83 154Q84 164 94 170",
          10878: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 356 694 346T687 331Q685 329 395 192L107 56H101Q83 58 83 76Q83 77 83 79Q82 86 98 95Q117 105 248 167Q326 204 378 228L626 346L360 472Q291 505 200 548Q112 589 98 597T83 616ZM674 172Q692 172 694 154Q694 142 687 137Q685 135 395 -2L107 -138H101Q83 -136 83 -118Q83 -106 96 -100Q100 -98 380 35T665 170T674 172",
          10885: "667 761Q669 762 673 762Q682 762 688 756T694 741Q694 731 687 727Q684 724 420 613L156 502L416 392Q476 367 544 338T647 295T682 280Q694 274 694 262Q694 244 676 242Q670 242 524 303T235 425T90 487Q83 493 83 501Q83 514 94 519Q97 520 378 639T667 761ZM55 -23Q55 43 103 90T223 138Q265 138 316 114Q342 100 393 68L443 36Q502 0 554 0Q609 0 650 32T694 109Q694 138 708 138Q710 138 713 136T719 127T722 108Q722 37 673 -9T557 -56Q514 -56 468 -35T387 13T308 60T223 82Q167 82 127 50T83 -27Q81 -56 69 -56Q55 -56 55 -23ZM55 -257Q55 -191 103 -144T223 -96Q265 -96 316 -120Q342 -134 393 -166L443 -198Q502 -234 554 -234Q609 -234 650 -202T694 -125Q694 -96 708 -96Q710 -96 713 -98T719 -107T722 -126Q722 -197 673 -243T557 -290Q514 -290 468 -269T387 -221T308 -174T223 -152Q167 -152 127 -184T83 -261Q80 -290 69 -290Q55 -290 55 -257",
          10886: "90 727Q83 734 83 743Q83 751 89 756T104 762Q111 760 396 641Q686 518 687 517Q694 512 694 502T687 487Q686 486 543 425T253 303T101 242Q83 244 83 262Q83 274 95 280Q96 280 130 294T232 338T361 392L621 502L357 613Q93 724 90 727ZM55 -23Q55 43 103 90T223 138Q265 138 316 114Q342 100 393 68L443 36Q502 0 554 0Q609 0 650 32T694 109Q694 138 708 138Q710 138 713 136T719 127T722 108Q722 37 673 -9T557 -56Q514 -56 468 -35T387 13T308 60T223 82Q167 82 127 50T83 -27Q81 -56 69 -56Q55 -56 55 -23ZM55 -257Q55 -191 103 -144T223 -96Q265 -96 316 -120Q342 -134 393 -166L443 -198Q502 -234 554 -234Q609 -234 650 -202T694 -125Q694 -96 708 -96Q710 -96 713 -98T719 -107T722 -126Q722 -197 673 -243T557 -290Q514 -290 468 -269T387 -221T308 -174T223 -152Q167 -152 127 -184T83 -261Q80 -290 69 -290Q55 -290 55 -257",
          10887: "380 497Q445 528 522 564T636 618T673 635Q680 635 686 628T693 615T689 603Q686 599 418 472L151 343L418 215Q686 88 689 83Q693 79 693 72T687 59T675 52Q669 52 381 189T86 332Q82 337 82 344Q82 350 86 355Q91 359 380 497ZM82 -130T82 -124T95 -103H380L431 -54Q476 -6 486 -6Q491 -6 498 -12T505 -27Q505 -28 505 -29T504 -32Q503 -33 498 -38T485 -53T469 -70L438 -103H680Q682 -106 686 -110T691 -116T693 -123Q693 -130 680 -143H398L346 -192Q300 -241 291 -241Q271 -241 271 -221Q271 -209 306 -179L340 -143H95Q82 -130 82 -124",
          10888: "82 614Q82 620 86 625T94 632T100 635Q106 635 394 498T689 355Q693 349 693 343Q693 338 689 332Q683 327 395 190T100 52Q95 52 89 58T82 72Q82 80 95 88Q114 99 358 215L624 343L358 472Q89 599 86 603Q82 607 82 614ZM82 -130T82 -124T95 -103H380L431 -54Q476 -6 486 -6Q491 -6 498 -12T505 -27Q505 -28 505 -29T504 -32Q503 -33 498 -38T485 -53T469 -70L438 -103H680Q682 -106 686 -110T691 -116T693 -123Q693 -130 680 -143H398L346 -192Q300 -241 291 -241Q271 -241 271 -221Q271 -209 306 -179L340 -143H95Q82 -130 82 -124",
          10889: "86 512Q93 518 381 639T673 761Q680 761 686 755T693 741Q693 733 688 730Q685 723 419 612L155 501L419 390Q685 277 688 272Q693 269 693 261Q693 254 687 248T675 241Q669 241 381 362T86 490Q74 500 86 512ZM70 -59Q57 -59 57 -24Q57 40 104 87Q116 102 146 118Q186 136 231 136Q232 136 242 135T258 133T276 128T302 118T334 101T377 74Q386 69 396 63T411 53T417 50Q435 87 453 134Q491 223 495 227Q498 230 505 230Q513 230 519 225T526 212Q526 203 491 118T453 30Q453 22 489 10T553 -3Q589 -3 622 14Q653 28 669 50T688 90T694 122T706 136Q718 136 718 114Q718 113 718 109T717 103Q717 31 668 -14T554 -60Q529 -60 499 -50T451 -32T433 -24Q431 -24 404 -90T375 -157Q375 -159 402 -178T473 -218T553 -239Q599 -239 641 -211T691 -130Q694 -99 706 -99T718 -122Q718 -123 718 -127T717 -133Q717 -204 668 -249T559 -295Q512 -295 470 -275T355 -206L322 -290Q313 -310 304 -332T289 -367T282 -382Q277 -387 270 -387Q262 -387 255 -382T248 -368Q248 -361 322 -186Q311 -177 280 -166T222 -155Q189 -155 153 -173Q122 -186 106 -208T87 -248T82 -280T71 -294Q57 -294 57 -259Q57 -195 104 -148Q122 -126 155 -113T220 -99Q245 -99 276 -109T324 -127T342 -135Q397 -2 397 1Q386 10 367 23T302 58T222 80Q175 80 132 52T84 -28Q82 -59 70 -59",
          10890: "86 730Q81 734 81 740Q81 747 88 754T99 761Q103 761 392 640T688 512Q693 509 693 501T688 490Q682 484 394 363T99 241Q94 241 88 248T82 261Q82 268 86 272Q89 277 355 390L619 501L355 612Q89 723 86 730ZM70 -59Q57 -59 57 -24Q57 40 104 87Q116 102 146 118Q186 136 231 136Q232 136 242 135T258 133T276 128T302 118T334 101T377 74Q386 69 396 63T411 53T417 50Q435 87 453 134Q491 223 495 227Q498 230 505 230Q513 230 519 225T526 212Q526 203 491 118T453 30Q453 22 489 10T553 -3Q589 -3 622 14Q653 28 669 50T688 90T694 122T706 136Q718 136 718 114Q718 113 718 109T717 103Q717 31 668 -14T554 -60Q529 -60 499 -50T451 -32T433 -24Q431 -24 404 -90T375 -157Q375 -159 402 -178T473 -218T553 -239Q599 -239 641 -211T691 -130Q694 -99 706 -99T718 -122Q718 -123 718 -127T717 -133Q717 -204 668 -249T559 -295Q512 -295 470 -275T355 -206L322 -290Q313 -310 304 -332T289 -367T282 -382Q277 -387 270 -387Q262 -387 255 -382T248 -368Q248 -361 322 -186Q311 -177 280 -166T222 -155Q189 -155 153 -173Q122 -186 106 -208T87 -248T82 -280T71 -294Q57 -294 57 -259Q57 -195 104 -148Q122 -126 155 -113T220 -99Q245 -99 276 -109T324 -127T342 -135Q397 -2 397 1Q386 10 367 23T302 58T222 80Q175 80 132 52T84 -28Q82 -59 70 -59",
          10891: "674 1003Q681 1003 687 999T694 983Q694 973 683 967Q669 959 420 868L162 772L422 676Q683 579 685 577Q694 571 694 560Q694 550 687 546T673 541Q669 542 384 647T93 755Q83 760 83 772Q83 783 91 788Q98 791 383 897T674 1003ZM84 354T84 367T98 387H679Q694 379 694 367Q694 354 679 347H98Q84 354 84 367ZM84 160T84 173T98 193H679Q694 185 694 173Q694 160 679 153H98Q84 160 84 173ZM94 -3Q102 -1 104 -1Q107 -2 392 -107T684 -215Q694 -219 694 -232Q694 -241 687 -247Q686 -248 395 -357Q106 -463 101 -463Q83 -461 83 -443Q83 -431 94 -426Q97 -423 357 -328L615 -232L355 -136Q94 -39 92 -37Q83 -31 83 -21Q83 -9 94 -3",
          10892: "104 541Q98 541 91 545T83 560Q83 571 92 577Q94 579 355 676L615 772L357 868Q108 959 94 967Q83 973 83 983Q83 989 87 996T104 1003Q109 1002 396 896T687 787Q694 781 694 772Q694 759 684 755Q678 752 393 647T104 541ZM84 367Q84 380 98 387H679Q694 379 694 367Q694 356 680 348L390 347H100Q84 352 84 367ZM84 173Q84 188 100 193H680Q694 183 694 173Q694 160 679 153H98Q84 160 84 173ZM674 -1Q682 -1 688 -6T694 -20Q694 -31 685 -37Q683 -39 422 -136L162 -232L420 -328Q680 -423 683 -426Q694 -431 694 -443Q694 -461 676 -463Q671 -463 382 -357Q91 -248 90 -247Q83 -242 83 -232Q83 -220 93 -215Q667 -1 674 -1",
          10901: "674 636Q682 636 688 631T694 616Q694 605 687 601Q685 599 395 462L107 326H101Q83 328 83 345Q83 358 96 365Q102 367 382 500T665 634Q671 636 674 636ZM674 442Q692 442 694 424Q694 412 687 407Q686 406 417 278L151 152L399 34Q687 -102 691 -107Q694 -113 694 -118Q694 -136 676 -138H670L382 -2Q92 135 90 137Q83 142 83 154Q84 165 96 171Q104 175 382 306T665 440Q669 442 674 442",
          10902: "83 616Q83 624 89 630T99 636Q107 636 253 568T543 431T687 361Q694 354 694 346Q694 328 676 326H670L382 462Q317 493 226 535Q119 585 101 595T83 616ZM94 440Q102 442 104 442Q110 441 254 373T535 240T678 172Q679 172 680 171Q694 164 694 153T687 137Q685 135 395 -2L107 -138H101Q83 -136 83 -118Q83 -106 93 -101L128 -84Q163 -68 230 -36T361 26L626 152L360 278Q91 406 90 407Q83 412 83 424Q84 434 94 440",
          10927: "84 346Q84 359 91 363T117 367Q120 367 126 367T137 366Q388 370 512 430T653 609Q657 636 676 636Q685 635 689 629T694 618V612Q689 566 672 528T626 463T569 417T500 383T435 362T373 346Q379 345 404 339T440 330T477 318T533 296Q592 266 630 223T681 145T694 78Q694 57 674 57Q662 57 657 67T652 92T640 135T606 191Q500 320 137 326H114Q104 326 98 327T88 332T84 346ZM84 -131T84 -118T98 -98H679Q694 -106 694 -118T679 -138H98Q84 -131 84 -118",
          10928: "84 614Q84 636 102 636Q115 636 119 626T125 600T137 556T171 501Q277 372 640 366H661Q694 366 694 346T661 326H640Q578 325 526 321T415 307T309 280T222 237T156 172T124 83Q122 66 118 62T103 57Q100 57 98 57T95 58T93 59T90 62T85 67Q83 71 83 80Q88 126 105 164T151 229T208 275T277 309T342 330T404 346Q401 347 380 351T345 360T302 373T245 396Q125 455 92 565Q84 599 84 614ZM84 -131T84 -118T98 -98H679Q694 -106 694 -118T679 -138H98Q84 -131 84 -118",
          10933: "653 734Q653 738 660 745T673 752T686 745T693 723Q672 555 466 485Q390 463 378 463Q373 463 373 461Q373 458 378 458Q390 458 466 436Q562 404 620 350Q682 283 693 198Q693 183 686 176Q681 170 674 170T660 176T653 187Q653 192 652 200T646 228T631 265T602 307T555 350Q435 431 151 441H95Q82 454 82 460T95 481H151Q165 482 197 483T238 485Q427 500 528 554T649 707Q653 729 653 734ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
          10934: "693 466T693 460T680 441H624Q608 439 577 438T538 436Q349 421 248 367T126 214Q122 192 122 187Q122 183 116 177T102 170Q95 170 89 176Q82 183 82 198Q93 283 155 350Q213 404 309 436Q385 458 398 458Q402 458 402 461Q402 463 398 463Q385 463 309 485Q103 555 82 723Q82 738 89 745T102 752T115 745T122 734Q122 721 126 701T155 640T220 572Q340 490 624 481H680Q693 466 693 460ZM82 33Q82 37 83 40T89 47T95 54H473L520 105Q569 156 571 156Q573 157 578 157Q586 157 592 151T598 136Q598 130 562 92L526 56L604 54H682Q693 43 693 35Q693 31 692 28T686 21T680 14H489L342 -139L513 -142H682Q693 -148 693 -160Q693 -167 680 -182H304L258 -230Q248 -240 237 -251T221 -268T211 -278T203 -284T197 -286Q189 -286 184 -280T178 -264Q178 -257 213 -219L249 -182H171L93 -179L86 -175Q82 -170 82 -163Q82 -155 95 -142H289L360 -64L433 14H262L93 16Q82 23 82 33",
          10935: "82 494T82 501T95 521H171Q405 527 511 569Q630 618 651 732Q652 734 653 740T655 748T658 754T663 759T672 761L686 754Q693 747 693 734Q684 668 648 623Q627 591 573 557T442 507L417 501Q428 496 442 494Q520 478 573 444T648 378Q684 333 693 267Q693 254 686 247Q673 234 659 245Q657 247 651 269Q630 383 511 432Q406 474 171 481H95Q82 494 82 501ZM70 -59Q57 -59 57 -26Q57 30 90 73T177 132Q191 136 226 136Q228 136 239 136T253 135T267 132T287 125T311 113T346 95T391 67Q462 20 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 704 136Q717 136 717 115V105Q717 39 671 -9T554 -58Q518 -58 481 -43T382 14Q302 63 273 74Q255 78 222 78Q188 78 173 74Q90 46 84 -28Q82 -59 70 -59ZM71 -294Q57 -294 57 -262Q57 -205 90 -162T177 -104Q191 -99 226 -99Q266 -103 277 -106Q310 -119 391 -168Q455 -212 502 -231Q519 -235 553 -235Q586 -235 602 -231Q640 -218 661 -195T686 -151T693 -115T704 -99Q717 -99 717 -121V-131Q717 -198 671 -246T556 -294Q519 -294 482 -279T382 -222Q307 -175 273 -162Q255 -157 222 -157Q188 -157 173 -162Q133 -175 110 -201T84 -264Q82 -294 71 -294",
          10936: "693 501Q693 493 679 481H604Q369 474 264 432Q143 382 124 269Q116 246 115 245Q101 234 88 247Q82 254 82 267Q89 329 126 378Q147 410 201 444T333 494L357 501Q354 502 340 505T318 510T295 516T269 525T243 535T215 548T188 565Q142 599 126 623Q89 672 82 734Q82 761 102 761L115 756Q116 755 124 732Q143 619 264 569Q371 527 604 521H679Q693 507 693 501ZM70 -59Q57 -59 57 -26Q57 30 90 73T177 132Q191 136 226 136Q228 136 239 136T253 135T267 132T287 125T311 113T346 95T391 67Q462 20 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 704 136Q717 136 717 115V105Q717 39 671 -9T554 -58Q518 -58 481 -43T382 14Q302 63 273 74Q255 78 222 78Q188 78 173 74Q90 46 84 -28Q82 -59 70 -59ZM71 -294Q57 -294 57 -262Q57 -205 90 -162T177 -104Q191 -99 226 -99Q266 -103 277 -106Q310 -119 391 -168Q455 -212 502 -231Q519 -235 553 -235Q586 -235 602 -231Q640 -218 661 -195T686 -151T693 -115T704 -99Q717 -99 717 -121V-131Q717 -198 671 -246T556 -294Q519 -294 482 -279T382 -222Q307 -175 273 -162Q255 -157 222 -157Q188 -157 173 -162Q133 -175 110 -201T84 -264Q82 -294 71 -294",
          10937: "82 494T82 501T95 521H171Q256 523 317 528T441 548T543 584T613 644T651 732Q652 734 653 740T655 748T658 754T663 759T672 761L686 754Q693 747 693 734Q686 686 664 647T615 586T548 545T482 518T417 501Q419 500 451 493T517 471T590 434T657 367T693 267Q693 241 673 241Q664 241 659 245Q656 249 650 273T635 323T593 380T511 432Q406 474 171 481H95Q82 494 82 501ZM57 -26Q57 39 101 87T219 136Q254 136 277 130Q320 114 382 72Q419 50 424 45Q426 45 459 110Q496 178 497 179Q500 180 504 180Q509 180 517 175T526 161Q526 158 495 90L462 25Q462 21 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 706 136T718 115Q718 114 718 111T717 105Q717 39 671 -9T554 -58L459 -33Q450 -29 444 -27T437 -26L371 -155L391 -168Q485 -235 538 -235H553Q586 -235 602 -230Q683 -204 691 -128Q694 -99 706 -99T718 -120Q718 -121 718 -124T717 -130Q717 -199 670 -246T557 -294T393 -228Q353 -205 351 -201Q348 -201 315 -266Q294 -310 285 -323T268 -337Q259 -337 254 -331T248 -317Q248 -305 282 -246L313 -181Q313 -177 273 -161Q255 -157 222 -157Q188 -157 173 -161Q134 -174 113 -198T88 -242T82 -278T71 -294Q57 -294 57 -261Q57 -204 91 -161T179 -104Q195 -99 228 -99Q274 -102 315 -124Q337 -132 337 -130L404 -1L384 12Q319 58 273 74Q255 79 222 79Q188 79 173 74Q133 61 112 37T88 -7T82 -43T70 -59Q57 -59 57 -26",
          10938: "693 501Q693 493 679 481H604Q548 479 509 477T418 469T331 454T257 429T194 392T150 340T124 270Q117 247 115 245Q101 236 88 247Q82 254 82 267Q89 330 126 379Q147 411 202 444T333 494L357 501Q239 531 188 565Q142 599 126 623Q89 672 82 734Q82 761 102 761L115 756Q116 755 124 732Q133 678 166 640T241 579T349 544T470 527T604 521H679Q693 507 693 501ZM57 -26Q57 39 101 87T219 136Q254 136 277 130Q320 114 382 72Q419 50 424 45Q426 45 459 110Q496 178 497 179Q500 180 504 180Q509 180 517 175T526 161Q526 158 495 90L462 25Q462 21 502 5Q519 1 553 1Q586 1 602 5Q641 18 664 45T691 107Q694 136 706 136T718 115Q718 114 718 111T717 105Q717 39 671 -9T554 -58L459 -33Q450 -29 444 -27T437 -26L371 -155L391 -168Q485 -235 538 -235H553Q586 -235 602 -230Q683 -204 691 -128Q694 -99 706 -99T718 -120Q718 -121 718 -124T717 -130Q717 -199 670 -246T557 -294T393 -228Q353 -205 351 -201Q348 -201 315 -266Q294 -310 285 -323T268 -337Q259 -337 254 -331T248 -317Q248 -305 282 -246L313 -181Q313 -177 273 -161Q255 -157 222 -157Q188 -157 173 -161Q134 -174 113 -198T88 -242T82 -278T71 -294Q57 -294 57 -261Q57 -204 91 -161T179 -104Q195 -99 228 -99Q274 -102 315 -124Q337 -132 337 -130L404 -1L384 12Q319 58 273 74Q255 79 222 79Q188 79 173 74Q133 61 112 37T88 -7T82 -43T70 -59Q57 -59 57 -26",
          10949: "84 463Q84 585 166 663T360 752Q361 752 370 752T395 752T430 752T475 753T524 753H679Q694 746 694 733Q694 724 681 714L522 713H470H441Q366 713 338 709T266 685Q244 674 224 659T179 617T139 550T124 463V458Q124 370 185 302Q244 238 328 220Q348 215 366 215T522 213H681Q694 203 694 193Q694 180 679 173H526Q510 173 480 173T434 172Q350 172 289 188T172 258Q84 340 84 463ZM84 -14T84 -1T98 19H679Q694 11 694 -1Q694 -14 679 -21H98Q84 -14 84 -1ZM84 -208T84 -195T98 -175H679Q694 -183 694 -195Q694 -208 679 -215H98Q84 -208 84 -195",
          10950: "83 733Q83 746 98 753H251Q267 753 297 753T343 754Q427 754 488 738T605 668Q693 587 693 463Q693 378 650 312T545 213T415 174Q407 173 251 173H98Q83 180 83 193Q83 203 96 213H255H308H337Q412 213 439 217T512 241Q533 252 553 267T599 309T639 376T654 463Q654 554 592 624Q557 662 512 685Q468 704 439 708T335 713H306H255L96 714Q83 724 83 733ZM84 -14T84 -1T98 19H679Q694 11 694 -1Q694 -14 679 -21H98Q84 -14 84 -1ZM84 -208T84 -195T98 -175H679Q694 -183 694 -195Q694 -208 679 -215H98Q84 -208 84 -195",
          10955: "693 221Q693 214 680 201H524Q398 201 367 202T309 212Q236 230 180 280T98 398Q84 438 84 492T98 585Q126 663 193 716T346 781Q347 781 373 781T440 782T520 783H680Q682 780 686 776T691 770T693 763T680 743H526Q364 743 353 741Q279 730 221 687T138 578Q124 540 124 492T138 405Q163 340 221 297T353 243Q364 241 526 241H680Q682 238 686 234T691 228T693 221ZM82 -48T82 -41T95 -19H462L513 41L569 105Q574 110 582 110T596 104T602 90Q602 87 600 83Q600 77 555 30L515 -17L600 -19H682Q693 -30 693 -38T680 -59H480L415 -137L349 -213L515 -215H682Q693 -226 693 -233T680 -255H313L260 -317Q224 -360 212 -372T192 -385Q184 -385 179 -377T173 -362Q174 -361 218 -306L260 -255H178L93 -253L86 -248Q82 -243 82 -235Q82 -226 93 -215H195L295 -213L362 -137L426 -59H260L93 -57L86 -53Q82 -48 82 -41",
          10956: "82 759T82 763T83 769T89 776T95 783H251Q378 783 409 782T469 772Q540 753 596 703T678 585Q691 546 691 492T678 398Q649 320 581 267T426 203Q415 201 251 201H95Q82 214 82 221Q82 225 83 227T89 234T95 241H249Q411 241 422 243Q496 253 554 296T638 405Q651 444 651 492Q651 539 638 578Q613 643 555 686T422 741Q411 743 249 743H95Q82 759 82 763ZM82 -48T82 -41T95 -19H462L513 41L569 105Q574 110 582 110T596 104T602 90Q602 87 600 83Q600 77 555 30L515 -17L600 -19H682Q693 -30 693 -38T680 -59H480L415 -137L349 -213L515 -215H682Q693 -226 693 -233T680 -255H313L260 -317Q224 -360 212 -372T192 -385Q184 -385 179 -377T173 -362Q174 -361 218 -306L260 -255H178L93 -253L86 -248Q82 -243 82 -235Q82 -226 93 -215H195L295 -213L362 -137L426 -59H260L93 -57L86 -53Q82 -48 82 -41",
          12296: "333 -232Q332 -239 327 -244T313 -250Q303 -250 296 -240Q293 -233 202 6T110 250T201 494T296 740Q299 745 306 749L309 750Q312 750 313 750Q331 750 333 732Q333 727 243 489Q152 252 152 250T243 11Q333 -227 333 -232",
          12297: "55 732Q56 739 61 744T75 750Q85 750 92 740Q95 733 186 494T278 250T187 6T92 -240Q85 -250 75 -250Q67 -250 62 -245T55 -232Q55 -227 145 11Q236 248 236 250T145 489Q55 727 55 732",
          57350: "91 417Q104 430 111 430T131 417V301L171 341Q201 373 207 378T220 384Q227 384 233 377T240 366Q240 357 187 299L131 244V-10Q116 -23 111 -23T91 -10V201L49 157Q20 127 14 121T0 115Q-8 115 -14 121T-20 132Q-20 139 17 178Q29 191 36 199L91 257V417",
          57351: "56 417Q68 431 76 431L89 426L96 419V317L98 215L193 273L291 330V375L293 419Q301 431 311 431Q331 431 331 388L333 355L356 370Q381 384 388 384Q394 384 400 377T407 363Q407 354 367 328L331 308V-10Q316 -23 310 -23Q300 -23 293 -12L291 135V284L98 168L96 77V-12Q84 -24 76 -24L62 -19L58 -12L56 66V144L31 128Q5 114 -2 114Q-8 114 -14 121T-20 136Q-20 142 -14 147T20 170L56 190V417",
          57352: "477 261Q477 257 473 256T455 253T417 251T348 250H235L155 -77L146 -82Q137 -85 109 -85Q55 -85 55 -77L139 261Q224 596 226 598Q229 603 239 603Q240 603 254 603T290 603T341 604T405 605T477 605Q656 603 687 602T719 596Q719 589 692 588T513 585H319L282 427L242 272Q242 270 351 270Q388 270 410 270T444 269T460 267T469 265T477 261",
          57353: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
          57356: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
          57357: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
          57358: "97 172Q82 172 82 190Q82 197 86 201Q94 209 173 246T327 319T402 357Q405 360 434 448T462 539L278 628Q96 713 86 721Q82 725 82 732T88 745T102 752Q103 752 125 742T198 709T293 666Q342 642 385 622T453 590T478 579Q479 579 506 659T562 824T598 915Q602 919 609 919T622 913T629 901Q629 898 571 728Q546 656 531 608T518 559Q555 539 602 519Q664 488 679 479T694 461Q694 457 689 450Q680 443 616 413T494 356T435 326L389 190L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34Q82 44 93 55H198L300 57L342 179Q350 204 361 238T378 286T382 301L246 237Q111 172 97 172ZM624 461Q621 464 560 492Q512 518 503 518Q500 518 500 517Q499 513 488 479T465 413T453 379L624 461",
          57359: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q383 185 344 92T306 -3L486 81Q662 168 673 168Q680 168 686 162T693 148T689 137Q688 136 482 35L280 -59L233 -176Q184 -291 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -279 185 -186T224 -90Q225 -88 223 -88Q219 -88 193 -101Q109 -143 98 -143Q82 -138 82 -122Q82 -116 85 -113T108 -98T171 -67L249 -30L289 61Q297 81 307 107T321 144T326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
          57360: "102 168Q103 168 151 146T247 102T295 81Q299 85 322 144T344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q665 54 526 119Q394 186 386 186Q385 186 342 88L331 61L509 -23Q680 -105 688 -111Q693 -115 693 -122T688 -135T675 -141H673Q664 -141 491 -59Q320 21 316 21H315L249 -136Q183 -293 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 154 -261T181 -197T213 -119L280 41Q280 46 186 86Q157 101 121 119Q92 133 87 136T82 148Q82 155 88 161T102 168ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
          57361: "82 34Q82 44 93 55H198L300 57L342 179Q351 207 362 238T378 286T384 303T238 377Q109 435 86 450Q82 454 82 460T86 472Q90 476 302 579L511 679Q512 679 553 795Q569 842 577 866T592 903T600 917T608 919Q615 919 622 912T629 901Q629 899 595 799Q589 777 581 753T569 717T564 703L618 728Q666 752 673 752T686 746T693 732Q693 723 683 717T615 683L546 650L491 488Q464 410 450 368T438 326Q493 297 562 266Q660 219 677 209T694 190Q694 183 690 177T678 171Q664 171 546 228L424 286Q422 286 382 172L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34ZM495 623Q495 626 493 626T321 544T151 461L398 343Q399 343 405 360T423 415T446 483Q457 513 469 551T488 606T495 623",
          57366: "82 -6Q82 1 95 14H262L295 94Q331 171 331 174Q324 175 312 178T267 194T206 227T146 283T98 368Q84 406 84 461T98 554Q126 632 194 685T349 750Q360 752 480 752H591L604 783Q620 819 624 821Q631 828 640 828Q653 825 658 810Q658 808 646 781L635 754Q635 752 658 752Q680 752 686 746Q693 739 693 732Q693 728 692 726T686 719T680 712H615L506 466Q479 407 451 344T408 248T393 214Q393 210 535 210H680Q693 194 693 190T680 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6ZM571 710Q571 712 469 712Q443 712 416 712T371 711T351 710Q279 700 221 656T138 548Q124 508 124 461T138 374Q186 245 351 212L460 459Q571 709 571 710",
          57367: "82 -14T82 -7T95 15H431L529 170H435Q341 170 333 175Q149 218 98 368Q84 406 84 461Q84 515 98 555Q126 633 193 686T346 750Q347 750 373 750T440 751T520 752H680Q693 739 693 732Q693 727 680 712H526Q364 712 353 710Q268 700 207 646T126 512Q123 496 123 461T126 410Q141 350 180 304T280 232Q312 217 344 214T464 210H555L589 261Q613 301 620 311T635 321Q644 321 650 315T657 301Q657 296 651 286T630 252T604 212Q604 210 642 210H680Q693 197 693 190Q693 186 692 184T686 177T680 170H578L526 92L478 17L580 15H682Q693 4 693 -4T680 -25H451L353 -179L518 -181H682Q694 -193 694 -201Q694 -211 682 -219L504 -221H326L293 -272Q257 -332 246 -332Q238 -332 232 -326T225 -313Q225 -310 226 -308Q226 -305 251 -265T278 -223Q278 -221 186 -221H95Q93 -218 89 -214T84 -208T82 -201T95 -181H306L404 -25H249L93 -23L86 -19Q82 -14 82 -7",
          57368: "82 732Q82 739 95 752H251H348Q420 752 460 744T551 708Q566 697 566 701Q618 815 624 821Q631 828 640 828Q653 825 658 810L600 677Q600 671 615 656T653 605T689 517Q692 496 692 461T689 406Q668 325 615 266Q572 221 513 196T391 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6Q82 1 95 14H262L295 92L331 170H95Q93 172 91 175T87 180T84 185T82 191Q82 199 93 210H220L349 212L549 659Q507 692 462 702T338 712H249H95Q82 727 82 732ZM652 473Q652 513 636 552T603 611T582 632Q581 632 487 422T393 210Q424 210 460 220T535 253T605 316T649 410Q652 427 652 461V473",
          57369: "82 732Q82 739 95 752H251Q415 752 426 750Q539 736 615 657Q667 599 689 517Q692 496 692 461T689 406Q668 325 615 266Q522 170 382 170H355L326 95Q319 80 311 59T298 28T293 17Q293 15 486 15H680Q693 0 693 -6T680 -25H275L213 -179L449 -181H682Q693 -192 693 -199T680 -221H198L178 -270Q153 -333 139 -333Q132 -333 126 -327T119 -314T135 -266T153 -223Q153 -221 124 -221H95Q82 -207 82 -201T95 -181H171L233 -25H162L93 -23L86 -19Q82 -14 82 -7T95 15H251L313 170H202L93 172L86 177Q82 182 82 190Q82 199 93 210H211L329 212L349 261Q366 301 372 311T386 321Q392 321 399 315T407 302Q407 295 390 254T373 210Q374 209 377 209Q412 209 444 217Q512 231 564 273T638 377Q651 414 651 461Q651 509 638 548Q613 613 555 656T422 710Q411 712 249 712H95Q82 727 82 732",
          57370: "693 -115T693 -122T680 -144H315L269 -199Q221 -255 213 -255H212Q203 -255 197 -248T193 -231Q195 -225 229 -184L262 -144H186L113 -142L106 -137Q102 -130 102 -125Q102 -119 115 -104H298L426 52H386Q342 54 309 63Q236 79 180 129T98 249Q84 289 84 343Q84 398 98 436Q126 514 193 567T346 632Q347 632 373 632T440 633T520 634H680Q682 631 686 627T691 621T693 614T680 594H526Q364 594 353 592Q268 581 207 528T126 394Q123 378 123 343T126 292Q141 231 181 185T280 114Q329 92 415 92H462L506 147Q554 203 562 203H563Q572 203 578 196T582 178Q579 173 546 132L513 94L598 92H682Q693 81 693 73T680 52H480L349 -102L515 -104H682Q693 -115 693 -122",
          57371: "82 610T82 614T83 620T89 627T95 634H251Q378 634 409 633T469 623Q540 604 596 554T678 436Q691 397 691 343T678 249Q653 181 597 131T469 63Q427 52 362 52H315L213 -102L438 -104H662Q673 -115 673 -123Q673 -129 660 -144H186L151 -197Q114 -250 109 -253Q106 -254 104 -254Q100 -254 98 -253Q91 -253 87 -248T82 -235Q82 -230 109 -186L138 -144H115Q82 -144 82 -125Q82 -119 95 -104H166L266 49Q266 52 182 52H95Q82 65 82 72Q82 76 83 78T89 85T95 92H295L329 143Q365 195 369 198Q372 203 380 203Q385 203 391 197T398 185Q398 184 398 184L399 182Q399 175 369 129L344 94Q344 92 376 92Q402 92 422 94Q496 104 554 147T638 256Q651 295 651 343Q651 390 638 429Q613 494 555 537T422 592Q411 594 249 594H95Q82 610 82 614",
          119808: "296 0Q278 3 164 3Q58 3 49 0H40V62H92Q144 62 144 64Q388 682 397 689Q403 698 434 698Q463 698 471 689Q475 686 538 530T663 218L724 64Q724 62 776 62H828V0H817Q796 3 658 3Q509 3 485 0H472V62H517Q561 62 561 63L517 175H262L240 120Q218 65 217 64Q217 62 261 62H306V0H296ZM390 237L492 238L440 365Q390 491 388 491Q287 239 287 237H390",
          119809: "720 510Q720 476 704 448T665 404T619 377T580 362L564 359L583 356Q602 353 632 342T690 312Q712 292 725 276Q752 235 752 189V183Q752 160 741 125Q698 18 547 2Q543 1 288 0H39V62H147V624H39V686H264H409Q502 686 542 681T624 655Q720 607 720 510ZM563 513Q563 553 548 578T518 611T486 622Q479 624 385 624H293V382H375Q458 383 467 385Q563 405 563 513ZM590 192Q590 307 505 329Q504 330 503 330L398 331H293V62H391H400H444Q496 62 528 75T580 131Q590 155 590 192",
          119810: "64 343Q64 502 174 599T468 697Q502 697 533 691T586 674T623 655T647 639T657 632L694 663Q703 670 711 677T723 687T730 692T735 695T740 696T746 697Q759 697 762 692T766 668V627V489V449Q766 428 762 424T742 419H732H720Q699 419 697 436Q690 498 657 545Q611 618 532 632Q522 634 496 634Q356 634 286 553Q232 488 232 343T286 133Q355 52 497 52Q597 52 650 112T704 237Q704 248 709 251T729 254H735Q750 254 755 253T763 248T766 234Q766 136 680 63T469 -11Q285 -11 175 86T64 343",
          119811: "39 624V686H270H310H408Q500 686 545 680T638 649Q768 584 805 438Q817 388 817 338Q817 171 702 75Q628 17 515 2Q504 1 270 0H39V62H147V624H39ZM655 337Q655 370 655 390T650 442T639 494T616 540T580 580T526 607T451 623Q443 624 368 624H298V62H377H387H407Q445 62 472 65T540 83T606 129Q629 156 640 195T653 262T655 337",
          119812: "723 286Q721 284 700 145T677 3V0H39V62H147V618H39V680H660V676Q662 670 675 552T691 428V424H629V428Q629 429 627 448T618 494T601 541Q574 593 527 605T382 618H374H304V384H336Q338 384 347 384T361 384T376 386T392 390T407 397T421 407T432 423Q442 444 443 482V501H505V205H443V224Q442 258 435 278T411 307T380 318T336 322H304V62H375H394Q429 62 449 62T497 66T541 76T577 95T609 126T632 170T651 232Q661 287 661 289H723V286",
          119813: "425 0L228 3Q63 3 51 0H39V62H147V618H39V680H644V676Q647 670 659 552T675 428V424H613Q613 433 605 477Q599 511 589 535T562 574T530 599T488 612T441 617T387 618H368H304V371H333Q389 373 411 390T437 468V488H499V192H437V212Q436 244 430 263T408 292T378 305T333 309H304V62H439V0H425",
          119814: "465 -10Q281 -10 173 88T64 343Q64 413 85 471T143 568T217 631T298 670Q371 697 449 697Q452 697 459 697T470 696Q502 696 531 690T582 675T618 658T644 641T656 632L732 695Q734 697 745 697Q758 697 761 692T765 668V627V489V449Q765 428 761 424T741 419H731H724Q705 419 702 422T695 444Q683 520 631 577T495 635Q364 635 295 563Q261 528 247 477T232 343Q232 296 236 260T256 185T296 120T366 76T472 52Q481 51 498 51Q544 51 573 67T607 108Q608 111 608 164V214H464V276H479Q506 273 680 273Q816 273 834 276H845V214H765V113V51Q765 16 763 8T750 0Q742 2 709 16T658 40L648 46Q592 -10 465 -10",
          119815: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V388H595V624H487V686H499Q523 683 673 683Q824 683 848 686H860V624H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V326H304V62H412V0H400",
          119816: "397 0Q370 3 218 3Q65 3 38 0H25V62H139V624H25V686H38Q65 683 218 683Q370 683 397 686H410V624H296V62H410V0H397",
          119817: "174 114Q174 96 169 82T159 63T144 47L155 45Q183 40 203 40Q271 40 290 104Q294 118 294 150T295 380V624H154V686H169Q196 683 365 683Q499 683 517 686H527V624H446V379Q446 183 446 153T441 108Q413 32 315 2Q266 -11 208 -11Q160 -11 118 -2T42 37T8 114V122Q8 150 30 174T91 198T152 174T174 122V114",
          119818: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V338L472 483L634 624H565V686H576Q597 683 728 683Q814 683 829 686H836V624H730L614 524Q507 432 497 422Q496 422 498 418T514 395T553 342T627 241L759 63L805 62H852V0H842Q830 3 701 3Q550 3 526 0H513V62H549Q584 62 584 63Q583 65 486 196T388 328L304 256V62H412V0H400",
          119819: "643 285Q641 280 629 148T612 4V0H39V62H147V624H39V686H51Q75 683 228 683Q415 685 425 686H439V624H304V62H352H378Q492 62 539 138Q551 156 558 178T569 214T576 255T581 289H643V285",
          119820: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H305Q316 679 323 667Q330 653 434 414L546 157L658 414Q766 662 773 674Q778 681 788 686H1052V624H944V62H1052V0H1040Q1016 3 874 3T708 0H696V62H804V341L803 618L786 580Q770 543 735 462T671 315Q540 13 536 9Q528 1 507 1Q485 1 477 9Q472 14 408 162T281 457T217 603Q215 603 215 334V62H323V0H314",
          119821: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H171H265Q288 686 297 686T309 684T315 679Q317 676 500 455T684 233V624H576V686H585Q603 683 718 683T851 686H860V624H752V319Q752 15 750 11Q747 4 742 2T718 0H712Q708 0 706 0T700 0T696 1T693 2T690 4T687 7T684 11T679 16T674 23Q671 27 437 311L215 579V62H323V0H314",
          119822: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 173 697 82T432 -10Q262 -10 163 85T64 339ZM625 454Q618 502 600 538T562 593T515 624T469 639T431 642Q331 642 276 563Q232 493 232 353Q232 315 234 285T244 216T267 148T308 94T372 56Q405 46 432 46Q517 46 567 106T627 267Q631 299 631 353Q631 418 625 454",
          119823: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H253Q435 686 470 685T536 678Q585 668 621 648T675 605T705 557T718 514T721 483T718 451T704 409T673 362T616 322T530 293Q500 288 399 287H304V62H412V0H400ZM553 475Q553 554 537 582T459 622Q451 623 373 624H298V343H372Q457 344 480 350Q527 362 540 390T553 475",
          119824: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 255 768 184Q720 77 611 26L600 21Q635 -26 682 -26H696Q769 -26 769 0Q769 7 774 12T787 18Q805 18 805 -7V-13Q803 -64 785 -106T737 -171Q720 -183 697 -191Q687 -193 668 -193Q636 -193 613 -182T575 -144T552 -94T532 -27Q531 -23 530 -16T528 -6T526 -3L512 -5Q499 -7 477 -8T431 -10Q393 -10 382 -9Q238 8 151 97T64 339ZM326 80Q326 113 356 138T430 163Q492 163 542 100L553 86Q554 85 561 91T578 108Q637 179 637 330Q637 430 619 498T548 604Q500 641 425 641Q408 641 390 637T347 623T299 590T259 535Q226 469 226 338Q226 244 246 180T318 79L325 74Q326 74 326 80ZM506 58Q480 112 433 112Q412 112 395 104T378 77Q378 44 431 44Q480 44 506 58",
          119825: "394 0Q370 3 222 3Q75 3 51 0H39V62H147V624H39V686H234Q256 686 299 686T362 687Q479 687 554 669T681 593Q716 550 716 497Q716 390 568 338Q569 337 572 336T577 332Q605 317 623 300T650 258T662 218T668 172Q678 98 689 76Q707 40 748 40Q770 40 780 54T795 88T801 111Q805 117 827 117H831Q846 117 852 113T858 92Q857 78 852 63T834 30T797 1T739 -11Q630 -11 580 12T511 87Q506 104 506 168Q506 170 506 178T507 194Q507 289 438 313Q424 318 356 318H298V62H406V0H394ZM366 369Q459 370 490 381Q548 402 548 476V498V517Q548 578 513 600Q479 624 392 624H358H298V369H366",
          119826: "64 493Q64 582 120 636T264 696H272Q280 697 285 697Q380 697 454 645L480 669Q484 672 488 676T495 683T500 688T504 691T508 693T511 695T514 696T517 697T522 697Q536 697 539 691T542 652V577Q542 557 542 532T543 500Q543 472 540 465T524 458H511H505Q489 458 485 461T479 478Q472 529 449 564T393 614T336 634T287 639Q228 639 203 610T177 544Q177 517 195 493T247 457Q253 454 343 436T475 391Q574 326 574 207V200Q574 163 559 120Q517 12 389 -9Q380 -10 346 -10Q308 -10 275 -5T221 7T184 22T160 35T151 40L126 17Q122 14 118 10T111 3T106 -2T102 -5T98 -7T95 -9T92 -10T89 -11T84 -11Q70 -11 67 -4T64 35V108Q64 128 64 153T63 185Q63 203 63 211T69 223T77 227T94 228H100Q118 228 122 225T126 205Q130 125 193 88T345 51Q408 51 434 82T460 157Q460 196 439 221T388 257Q384 259 305 276T221 295Q155 313 110 366T64 493",
          119827: "41 425Q41 426 51 545T62 669V675H737V669Q738 665 748 546T758 425V419H696V425Q687 517 669 555T595 607Q578 612 522 613H478V62H631V0H615Q585 3 399 3Q214 3 184 0H168V62H321V613H277H263Q164 613 134 561Q113 527 103 425V419H41V425",
          119828: "570 686Q588 683 703 683T836 686H845V624H737V420Q737 390 737 345T738 284Q738 205 729 164T689 83Q614 -11 465 -11Q321 -11 240 51T148 207Q147 214 147 421V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V405V370V268Q304 181 311 146T346 87Q387 52 466 52Q642 52 667 195Q668 204 669 415V624H561V686H570",
          119829: "592 686H604Q615 685 631 685T666 684T700 684T724 683Q829 683 835 686H843V624H744L611 315Q584 254 546 165Q492 40 482 19T461 -6L460 -7H409Q398 -4 391 9Q385 20 257 315L124 624H25V686H36Q57 683 190 683Q340 683 364 686H377V624H289L384 403L480 185L492 212Q504 240 529 298T575 405L670 624H582V686H592",
          119830: "915 686L1052 683Q1142 683 1157 686H1164V624H1073L957 320Q930 249 900 170T855 52T839 10Q834 0 826 -5Q821 -7 799 -7H792Q777 -7 772 -5T759 10Q759 11 748 39T716 122T676 228L594 442L512 228Q486 159 455 78Q433 19 428 9T416 -5Q411 -7 389 -7H379Q356 -7 349 10Q349 12 334 51T288 170T231 320L116 624H24V686H35Q44 683 183 683Q331 683 355 686H368V624H323Q278 624 278 623L437 207L499 369L561 531L526 624H434V686H445Q454 683 593 683Q741 683 765 686H778V624H733Q688 624 688 623L847 207Q848 207 927 415T1006 624H905V686H915",
          119831: "327 0Q306 3 174 3Q52 3 43 0H33V62H98L162 63L360 333L157 624H48V686H59Q80 683 217 683Q368 683 395 686H408V624H335L393 540L452 458L573 623Q573 624 528 624H483V686H494Q515 683 646 683Q769 683 778 686H787V624H658L575 511Q493 398 493 397L508 376Q522 356 553 312T611 229L727 62H835V0H824Q803 3 667 3Q516 3 489 0H476V62H513L549 63L401 274L247 63Q247 62 292 62H338V0H327",
          119832: "605 0Q581 3 434 3Q286 3 262 0H250V62H358V275L126 624H19V686H30Q54 683 189 683Q361 685 370 686H383V624H308L319 608Q330 591 353 556T396 491L484 359L660 623Q660 624 623 624H585V686H595Q613 683 728 683Q832 683 841 686H849V624H742L509 274V62H618V0H605",
          119833: "80 430L92 686H358Q624 686 628 684Q638 679 638 656Q638 640 637 639Q637 638 445 353Q401 288 351 214T277 103L253 67L256 66Q258 66 265 66T279 66T298 66H343Q380 66 406 68T464 81T518 110T557 164T579 250Q583 278 583 298Q583 299 614 299H645V291Q643 281 636 150T627 8V0H353Q79 0 75 2Q64 7 64 31Q64 48 66 52L259 340L451 623Q451 624 384 624Q294 623 259 612Q155 581 143 446Q142 440 142 432V430H80",
          119834: "64 349Q64 399 107 426T255 453Q346 453 402 423T473 341Q478 327 478 310T479 196V77Q493 63 529 62Q549 62 553 57T558 31Q558 9 552 5T514 0H497H481Q375 0 367 56L356 46Q300 -6 210 -6Q130 -6 81 30T32 121Q32 188 111 226T332 272H350V292Q350 313 348 327T337 361T306 391T248 402T194 399H189Q204 376 204 354Q204 327 187 306T134 284Q97 284 81 305T64 349ZM164 121Q164 89 186 67T238 45Q274 45 307 63T346 108L350 117V226H347Q248 218 206 189T164 121",
          119835: "32 686L123 690Q214 694 215 694H221V409Q289 450 378 450Q479 450 539 387T600 221Q600 122 535 58T358 -6H355Q272 -6 203 53L160 1L129 0H98V301Q98 362 98 435T99 525Q99 591 97 604T83 620Q69 624 42 624H29V686H32ZM227 105L232 99Q237 93 242 87T258 73T280 59T306 49T339 45Q380 45 411 66T451 131Q457 160 457 230Q457 264 456 284T448 329T430 367T396 389T343 398Q282 398 235 355L227 348V105",
          119836: "447 131H458Q478 131 478 117Q478 112 471 95T439 51T377 9Q330 -6 286 -6Q196 -6 135 35Q39 96 39 222Q39 324 101 384Q169 453 286 453Q359 453 411 431T464 353Q464 319 445 302T395 284Q360 284 343 305T325 353Q325 380 338 396H333Q317 398 295 398H292Q280 398 271 397T245 390T218 373T197 338T183 283Q182 275 182 231Q182 199 184 180T193 132T220 85T270 57Q289 50 317 50H326Q385 50 414 115Q419 127 423 129T447 131",
          119837: "351 686L442 690Q533 694 534 694H540V389Q540 327 540 253T539 163Q539 97 541 83T555 66Q569 62 596 62H609V31Q609 0 608 0Q588 0 510 -3T412 -6Q411 -6 411 16V38L401 31Q337 -6 265 -6Q159 -6 99 58T38 224Q38 265 51 303T92 375T165 429T272 449Q359 449 417 412V507V555Q417 597 415 607T402 620Q388 624 361 624H348V686H351ZM411 350Q362 399 291 399Q278 399 256 392T218 371Q195 351 189 320T182 238V221Q182 179 183 159T191 115T212 74Q241 46 288 46Q358 46 404 100L411 109V350",
          119838: "32 225Q32 332 102 392T272 452H283Q382 452 436 401Q494 343 494 243Q494 226 486 222T440 217Q431 217 394 217T327 218H175V209Q175 177 179 154T196 107T236 69T306 50Q312 49 323 49Q376 49 410 85Q421 99 427 111T434 127T442 133T463 135H468Q494 135 494 117Q494 110 489 97T468 66T431 32T373 5T292 -6Q181 -6 107 55T32 225ZM383 276Q377 346 348 374T280 402Q253 402 230 390T195 357Q179 331 176 279V266H383V276",
          119839: "308 0Q290 3 172 3Q58 3 49 0H40V62H109V382H42V444H109V503L110 562L112 572Q127 625 178 658T316 699Q318 699 330 699T348 700Q381 698 404 687T436 658T449 629T452 606Q452 576 432 557T383 537Q355 537 335 555T314 605Q314 635 328 649H325Q311 649 293 644T253 618T227 560Q226 555 226 498V444H340V382H232V62H318V0H308",
          119840: "50 300Q50 368 105 409T255 450Q328 450 376 426L388 420Q435 455 489 455Q517 455 533 441T554 414T558 389Q558 367 544 353T508 339Q484 339 471 354T458 387Q458 397 462 400Q464 401 461 400Q459 400 454 399Q429 392 427 390Q454 353 459 328Q461 315 461 300Q461 240 419 202Q364 149 248 149Q185 149 136 172Q129 158 129 148Q129 105 170 93Q176 91 263 91Q273 91 298 91T334 91T366 89T400 85T432 77T466 64Q544 22 544 -69Q544 -114 506 -145Q438 -201 287 -201Q149 -201 90 -161T30 -70Q30 -58 33 -47T42 -27T54 -13T69 -1T82 6T94 12T101 15Q66 57 66 106Q66 151 90 187L97 197L89 204Q50 243 50 300ZM485 403H492Q491 404 488 404L485 403V403ZM255 200Q279 200 295 206T319 219T331 242T335 268T336 300Q336 337 333 352T317 380Q298 399 255 399Q228 399 211 392T187 371T178 345T176 312V300V289Q176 235 194 219Q215 200 255 200ZM287 -150Q357 -150 400 -128T443 -71Q443 -65 442 -61T436 -50T420 -37T389 -27T339 -21L308 -20Q276 -20 253 -20Q190 -20 180 -20T156 -26Q130 -38 130 -69Q130 -105 173 -127T287 -150",
          119841: "40 686L131 690Q222 694 223 694H229V533L230 372L238 381Q248 394 264 407T317 435T398 450Q428 450 448 447T491 434T529 402T551 346Q553 335 554 198V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V332Q106 387 106 453T107 534Q107 593 105 605T91 620Q77 624 50 624H37V686H40",
          119842: "72 610Q72 649 98 672T159 695Q193 693 217 670T241 610Q241 572 217 549T157 525Q120 525 96 548T72 610ZM46 442L136 446L226 450H232V62H294V0H286Q271 3 171 3Q67 3 49 0H40V62H109V209Q109 358 108 362Q103 380 55 380H43V442H46",
          119843: "104 610Q104 649 130 672T191 695Q225 693 249 670T273 610Q273 572 249 549T189 525Q152 525 128 548T104 610ZM78 442L173 446L268 450H274V196Q274 -5 274 -37T269 -83Q256 -132 201 -166T71 -200Q10 -200 -30 -173T-71 -102Q-71 -70 -51 -51T-1 -31Q27 -31 48 -49T69 -100Q69 -121 53 -147H56Q66 -149 77 -149H80Q90 -149 100 -146T127 -125T149 -73Q151 -55 151 149V362Q150 364 148 366T145 370T142 373T138 375T133 377T124 378T113 379T97 380H75V442H78",
          119844: "32 686L123 690Q214 694 215 694H221V255L377 382H346V444H355Q370 441 476 441Q544 441 556 444H562V382H476L347 277L515 62H587V0H579Q564 3 476 3Q370 3 352 0H343V62H358L373 63L260 206L237 189L216 172V62H285V0H277Q259 3 157 3Q46 3 37 0H29V62H98V332Q98 387 98 453T99 534Q99 593 97 605T83 620Q69 624 42 624H29V686H32",
          119845: "43 686L134 690Q225 694 226 694H232V62H301V0H292Q274 3 170 3Q67 3 49 0H40V62H109V332Q109 387 109 453T110 534Q110 593 108 605T94 620Q80 624 53 624H40V686H43",
          119846: "40 442Q217 450 218 450H224V365Q226 367 235 378T254 397T278 416T314 435T362 448Q376 450 400 450H406Q503 450 534 393Q545 376 545 370Q545 368 555 379Q611 450 716 450Q774 450 809 434Q850 414 861 379T873 276V213V198V62H942V0H933Q915 3 809 3Q702 3 684 0H675V62H744V194V275Q744 348 735 373T690 399Q645 399 607 370T557 290Q555 281 554 171V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V210V303Q106 353 104 363T91 376Q77 380 50 380H37V442H40",
          119847: "40 442Q217 450 218 450H224V407L225 365Q233 378 245 391T289 422T362 448Q374 450 398 450Q428 450 448 447T491 434T529 402T551 346Q553 335 554 198V62H623V0H614Q596 3 489 3Q374 3 365 0H356V62H425V194V275Q425 348 416 373T371 399Q326 399 288 370T238 290Q236 281 235 171V62H304V0H295Q277 3 171 3Q64 3 46 0H37V62H106V210V303Q106 353 104 363T91 376Q77 380 50 380H37V442H40",
          119848: "287 -5Q228 -5 182 10T109 48T63 102T39 161T32 219Q32 272 50 314T94 382T154 423T214 446T265 452H279Q319 452 326 451Q428 439 485 376T542 221Q542 156 514 108T442 33Q384 -5 287 -5ZM399 230V250Q399 280 398 298T391 338T372 372T338 392T282 401Q241 401 212 380Q190 363 183 334T175 230Q175 202 175 189T177 153T183 118T195 91T215 68T245 56T287 50Q348 50 374 84Q388 101 393 132T399 230",
          119849: "32 442L123 446Q214 450 215 450H221V409Q222 409 229 413T251 423T284 436T328 446T382 450Q480 450 540 388T600 223Q600 128 539 61T361 -6H354Q292 -6 236 28L227 34V-132H296V-194H287Q269 -191 163 -191Q56 -191 38 -194H29V-132H98V113V284Q98 330 97 348T93 370T83 376Q69 380 42 380H29V442H32ZM457 224Q457 303 427 349T350 395Q282 395 235 352L227 345V104L233 97Q274 45 337 45Q383 45 420 86T457 224",
          119850: "38 220Q38 273 54 314T95 380T152 421T211 443T264 449Q368 449 429 386L438 377L484 450H540V-132H609V-194H600Q582 -191 475 -191Q360 -191 351 -194H342V-132H411V42Q409 41 399 34T383 25T367 16T347 7T324 1T296 -4T264 -6Q162 -6 100 56T38 220ZM287 46Q368 46 417 127V301L412 312Q398 347 369 371T302 395Q282 395 263 388T225 362T194 308T182 221Q182 126 214 86T287 46",
          119851: "405 293T374 293T324 312T305 361Q305 378 312 394Q315 397 315 399Q305 399 294 394T266 375T238 329T222 249Q221 241 221 149V62H308V0H298Q280 3 161 3Q47 3 38 0H29V62H98V210V303Q98 353 96 363T83 376Q69 380 42 380H29V442H32L118 446Q204 450 205 450H210V414L211 378Q247 449 315 449H321Q384 449 413 422T442 360Q442 332 424 313",
          119852: "38 315Q38 339 45 360T70 404T127 440T223 453Q273 453 320 436L338 445L357 453H366Q380 453 383 447T386 403V387V355Q386 331 383 326T365 321H355H349Q333 321 329 324T324 341Q317 406 224 406H216Q123 406 123 353Q123 334 143 321T188 304T244 294T285 286Q305 281 325 273T373 237T412 172Q414 162 414 142Q414 -6 230 -6Q154 -6 117 22L68 -6H58Q44 -6 41 0T38 42V73Q38 85 38 101T37 122Q37 144 42 148T68 153H75Q87 153 91 151T97 147T103 132Q131 46 220 46H230Q257 46 265 47Q330 58 330 108Q330 127 316 142Q300 156 284 162Q271 168 212 178T122 202Q38 243 38 315",
          119853: "272 49Q320 49 320 136V145V177H382V143Q382 106 380 99Q374 62 349 36T285 -2L272 -5H247Q173 -5 134 27Q109 46 102 74T94 160Q94 171 94 199T95 245V382H21V433H25Q58 433 90 456Q121 479 140 523T162 621V635H224V444H363V382H224V239V207V149Q224 98 228 81T249 55Q261 49 272 49",
          119854: "40 442L134 446Q228 450 229 450H235V273V165Q235 90 238 74T254 52Q268 46 304 46H319Q352 46 380 67T419 121L420 123Q424 135 425 199Q425 201 425 207Q425 233 425 249V316Q425 354 423 363T410 376Q396 380 369 380H356V442L554 450V267Q554 84 556 79Q561 62 610 62H623V31Q623 0 622 0Q603 0 527 -3T432 -6Q431 -6 431 25V56L420 45Q373 6 332 -1Q313 -6 281 -6Q208 -6 165 14T109 87L107 98L106 230Q106 358 104 366Q96 380 50 380H37V442H40",
          119855: "401 444Q413 441 495 441Q568 441 574 444H580V382H510L409 156Q348 18 339 6Q331 -4 320 -4Q318 -4 313 -4T303 -3H288Q273 -3 264 12T221 102Q206 135 197 156L96 382H26V444H34Q49 441 145 441Q252 441 270 444H279V382H231L284 264Q335 149 338 149Q338 150 389 264T442 381Q442 382 418 382H394V444H401",
          119856: "624 444Q636 441 722 441Q797 441 800 444H805V382H741L593 11Q592 10 590 8T586 4T584 2T581 0T579 -2T575 -3T571 -3T567 -4T561 -4T553 -4H542Q525 -4 518 6T490 70Q474 110 463 137L415 257L367 137Q357 111 341 72Q320 17 313 7T289 -4H277Q259 -4 253 -2T238 11L90 382H25V444H32Q47 441 140 441Q243 441 261 444H270V382H222L310 164L382 342L366 382H303V444H310Q322 441 407 441Q508 441 523 444H531V382H506Q481 382 481 380Q482 376 529 259T577 142L674 382H617V444H624",
          119857: "227 0Q212 3 121 3Q40 3 28 0H21V62H117L245 213L109 382H26V444H34Q49 441 143 441Q247 441 265 444H274V382H246L281 339Q315 297 316 297Q320 297 354 341L389 382H352V444H360Q375 441 466 441Q547 441 559 444H566V382H471L355 246L504 63L545 62H586V0H578Q563 3 469 3Q365 3 347 0H338V62H366Q366 63 326 112T285 163L198 63L217 62H235V0H227",
          119858: "84 -102Q84 -110 87 -119T102 -138T133 -149Q148 -148 162 -143T186 -131T206 -114T222 -95T234 -76T243 -59T249 -45T252 -37L269 0L96 382H26V444H34Q49 441 146 441Q252 441 270 444H279V382H255Q232 382 232 380L337 151L442 382H394V444H401Q413 441 495 441Q568 441 574 444H580V382H510L406 152Q298 -84 297 -87Q269 -139 225 -169T131 -200Q85 -200 54 -172T23 -100Q23 -64 44 -50T87 -35Q111 -35 130 -50T152 -92V-100H84V-102",
          119859: "48 262Q48 264 54 349T60 436V444H252Q289 444 336 444T394 445Q441 445 450 441T459 418Q459 406 458 404Q456 399 327 229T194 55H237Q260 56 268 56T297 58T325 65T348 77T370 98T384 128T395 170Q400 197 400 216Q400 217 431 217H462V211Q461 208 453 108T444 6V0H245Q46 0 43 2Q32 7 32 28V33Q32 41 40 52T84 112Q129 170 164 217L298 393H256Q189 392 165 380Q124 360 115 303Q110 280 110 256Q110 254 79 254H48V262",
          119860: "208 74Q208 50 254 46Q272 46 272 35Q272 34 270 22Q267 8 264 4T251 0Q249 0 239 0T205 1T141 2Q70 2 50 0H42Q35 7 35 11Q37 38 48 46H62Q132 49 164 96Q170 102 345 401T523 704Q530 716 547 716H555H572Q578 707 578 706L606 383Q634 60 636 57Q641 46 701 46Q726 46 726 36Q726 34 723 22Q720 7 718 4T704 0Q701 0 690 0T651 1T578 2Q484 2 455 0H443Q437 6 437 9T439 27Q443 40 445 43L449 46H469Q523 49 533 63L521 213H283L249 155Q208 86 208 74ZM516 260Q516 271 504 416T490 562L463 519Q447 492 400 412L310 260L413 259Q516 259 516 260",
          119861: "231 637Q204 637 199 638T194 649Q194 676 205 682Q206 683 335 683Q594 683 608 681Q671 671 713 636T756 544Q756 480 698 429T565 360L555 357Q619 348 660 311T702 219Q702 146 630 78T453 1Q446 0 242 0Q42 0 39 2Q35 5 35 10Q35 17 37 24Q42 43 47 45Q51 46 62 46H68Q95 46 128 49Q142 52 147 61Q150 65 219 339T288 628Q288 635 231 637ZM649 544Q649 574 634 600T585 634Q578 636 493 637Q473 637 451 637T416 636H403Q388 635 384 626Q382 622 352 506Q352 503 351 500L320 374H401Q482 374 494 376Q554 386 601 434T649 544ZM595 229Q595 273 572 302T512 336Q506 337 429 337Q311 337 310 336Q310 334 293 263T258 122L240 52Q240 48 252 48T333 46Q422 46 429 47Q491 54 543 105T595 229",
          119862: "50 252Q50 367 117 473T286 641T490 704Q580 704 633 653Q642 643 648 636T656 626L657 623Q660 623 684 649Q691 655 699 663T715 679T725 690L740 705H746Q760 705 760 698Q760 694 728 561Q692 422 692 421Q690 416 687 415T669 413H653Q647 419 647 422Q647 423 648 429T650 449T651 481Q651 552 619 605T510 659Q484 659 454 652T382 628T299 572T226 479Q194 422 175 346T156 222Q156 108 232 58Q280 24 350 24Q441 24 512 92T606 240Q610 253 612 255T628 257Q648 257 648 248Q648 243 647 239Q618 132 523 55T319 -22Q206 -22 128 53T50 252",
          119863: "287 628Q287 635 230 637Q207 637 200 638T193 647Q193 655 197 667T204 682Q206 683 403 683Q570 682 590 682T630 676Q702 659 752 597T803 431Q803 275 696 151T444 3L430 1L236 0H125H72Q48 0 41 2T33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM703 469Q703 507 692 537T666 584T629 613T590 629T555 636Q553 636 541 636T512 636T479 637H436Q392 637 386 627Q384 623 313 339T242 52Q242 48 253 48T330 47Q335 47 349 47T373 46Q499 46 581 128Q617 164 640 212T683 339T703 469",
          119864: "492 213Q472 213 472 226Q472 230 477 250T482 285Q482 316 461 323T364 330H312Q311 328 277 192T243 52Q243 48 254 48T334 46Q428 46 458 48T518 61Q567 77 599 117T670 248Q680 270 683 272Q690 274 698 274Q718 274 718 261Q613 7 608 2Q605 0 322 0H133Q31 0 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H757Q764 676 764 669Q764 664 751 557T737 447Q735 440 717 440H705Q698 445 698 453L701 476Q704 500 704 528Q704 558 697 578T678 609T643 625T596 632T532 634H485Q397 633 392 631Q388 629 386 622Q385 619 355 499T324 377Q347 376 372 376H398Q464 376 489 391T534 472Q538 488 540 490T557 493Q562 493 565 493T570 492T572 491T574 487T577 483L544 351Q511 218 508 216Q505 213 492 213",
          119865: "48 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H742Q749 676 749 669Q749 664 736 557T722 447Q720 440 702 440H690Q683 445 683 453Q683 454 686 477T689 530Q689 560 682 579T663 610T626 626T575 633T503 634H480Q398 633 393 631Q388 629 386 623Q385 622 352 492L320 363H375Q378 363 398 363T426 364T448 367T472 374T489 386Q502 398 511 419T524 457T529 475Q532 480 548 480H560Q567 475 567 470Q567 467 536 339T502 207Q500 200 482 200H470Q463 206 463 212Q463 215 468 234T473 274Q473 303 453 310T364 317H309L277 190Q245 66 245 60Q245 46 334 46H359Q365 40 365 39T363 19Q359 6 353 0H336Q295 2 185 2Q120 2 86 2T48 1",
          119866: "50 252Q50 367 117 473T286 641T490 704Q580 704 633 653Q642 643 648 636T656 626L657 623Q660 623 684 649Q691 655 699 663T715 679T725 690L740 705H746Q760 705 760 698Q760 694 728 561Q692 422 692 421Q690 416 687 415T669 413H653Q647 419 647 422Q647 423 648 429T650 449T651 481Q651 552 619 605T510 659Q492 659 471 656T418 643T357 615T294 567T236 496T189 394T158 260Q156 242 156 221Q156 173 170 136T206 79T256 45T308 28T353 24Q407 24 452 47T514 106Q517 114 529 161T541 214Q541 222 528 224T468 227H431Q425 233 425 235T427 254Q431 267 437 273H454Q494 271 594 271Q634 271 659 271T695 272T707 272Q721 272 721 263Q721 261 719 249Q714 230 709 228Q706 227 694 227Q674 227 653 224Q646 221 643 215T629 164Q620 131 614 108Q589 6 586 3Q584 1 581 1Q571 1 553 21T530 52Q530 53 528 52T522 47Q448 -22 322 -22Q201 -22 126 55T50 252",
          119867: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 219 683Q260 681 355 681Q389 681 418 681T463 682T483 682Q499 682 499 672Q499 670 497 658Q492 641 487 638H485Q483 638 480 638T473 638T464 637T455 637Q416 636 405 634T387 623Q384 619 355 500Q348 474 340 442T328 395L324 380Q324 378 469 378H614L615 381Q615 384 646 504Q674 619 674 627T617 637Q594 637 587 639T580 648Q580 650 582 660Q586 677 588 679T604 682Q609 682 646 681T740 680Q802 680 835 681T871 682Q888 682 888 672Q888 645 876 638H874Q872 638 869 638T862 638T853 637T844 637Q805 636 794 634T776 623Q773 618 704 340T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q520 50 522 50T528 55T534 64T540 82T547 110T558 153Q565 181 569 198Q602 330 602 331T457 332H312L279 197Q245 63 245 58Q245 51 253 49T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
          119868: "43 1Q26 1 26 10Q26 12 29 24Q34 43 39 45Q42 46 54 46H60Q120 46 136 53Q137 53 138 54Q143 56 149 77T198 273Q210 318 216 344Q286 624 286 626Q284 630 284 631Q274 637 213 637H193Q184 643 189 662Q193 677 195 680T209 683H213Q285 681 359 681Q481 681 487 683H497Q504 676 504 672T501 655T494 639Q491 637 471 637Q440 637 407 634Q393 631 388 623Q381 609 337 432Q326 385 315 341Q245 65 245 59Q245 52 255 50T307 46H339Q345 38 345 37T342 19Q338 6 332 0H316Q279 2 179 2Q143 2 113 2T65 2T43 1",
          119869: "447 625Q447 637 354 637H329Q323 642 323 645T325 664Q329 677 335 683H352Q393 681 498 681Q541 681 568 681T605 682T619 682Q633 682 633 672Q633 670 630 658Q626 642 623 640T604 637Q552 637 545 623Q541 610 483 376Q420 128 419 127Q397 64 333 21T195 -22Q137 -22 97 8T57 88Q57 130 80 152T132 174Q177 174 182 130Q182 98 164 80T123 56Q115 54 115 53T122 44Q148 15 197 15Q235 15 271 47T324 130Q328 142 387 380T447 625",
          119870: "285 628Q285 635 228 637Q205 637 198 638T191 647Q191 649 193 661Q199 681 203 682Q205 683 214 683H219Q260 681 355 681Q389 681 418 681T463 682T483 682Q500 682 500 674Q500 669 497 660Q496 658 496 654T495 648T493 644T490 641T486 639T479 638T470 637T456 637Q416 636 405 634T387 623L306 305Q307 305 490 449T678 597Q692 611 692 620Q692 635 667 637Q651 637 651 648Q651 650 654 662T659 677Q662 682 676 682Q680 682 711 681T791 680Q814 680 839 681T869 682Q889 682 889 672Q889 650 881 642Q878 637 862 637Q787 632 726 586Q710 576 656 534T556 455L509 418L518 396Q527 374 546 329T581 244Q656 67 661 61Q663 59 666 57Q680 47 717 46H738Q744 38 744 37T741 19Q737 6 731 0H720Q680 3 625 3Q503 3 488 0H478Q472 6 472 9T474 27Q478 40 480 43T491 46H494Q544 46 544 71Q544 75 517 141T485 216L427 354L359 301L291 248L268 155Q245 63 245 58Q245 51 253 49T303 46H334Q340 37 340 35Q340 19 333 5Q328 0 317 0Q314 0 280 1T180 2Q118 2 85 2T49 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628",
          119871: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 217 683Q271 680 344 680Q485 680 506 683H518Q524 677 524 674T522 656Q517 641 513 637H475Q406 636 394 628Q387 624 380 600T313 336Q297 271 279 198T252 88L243 52Q243 48 252 48T311 46H328Q360 46 379 47T428 54T478 72T522 106T564 161Q580 191 594 228T611 270Q616 273 628 273H641Q647 264 647 262T627 203T583 83T557 9Q555 4 553 3T537 0T494 -1Q483 -1 418 -1T294 0H116Q32 0 32 10Q32 17 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
          119872: "289 629Q289 635 232 637Q208 637 201 638T194 648Q194 649 196 659Q197 662 198 666T199 671T201 676T203 679T207 681T212 683T220 683T232 684Q238 684 262 684T307 683Q386 683 398 683T414 678Q415 674 451 396L487 117L510 154Q534 190 574 254T662 394Q837 673 839 675Q840 676 842 678T846 681L852 683H948Q965 683 988 683T1017 684Q1051 684 1051 673Q1051 668 1048 656T1045 643Q1041 637 1008 637Q968 636 957 634T939 623Q936 618 867 340T797 59Q797 55 798 54T805 50T822 48T855 46H886Q892 37 892 35Q892 19 885 5Q880 0 869 0Q864 0 828 1T736 2Q675 2 644 2T609 1Q592 1 592 11Q592 13 594 25Q598 41 602 43T625 46Q652 46 685 49Q699 52 704 61Q706 65 742 207T813 490T848 631L654 322Q458 10 453 5Q451 4 449 3Q444 0 433 0Q418 0 415 7Q413 11 374 317L335 624L267 354Q200 88 200 79Q206 46 272 46H282Q288 41 289 37T286 19Q282 3 278 1Q274 0 267 0Q265 0 255 0T221 1T157 2Q127 2 95 1T58 0Q43 0 39 2T35 11Q35 13 38 25T43 40Q45 46 65 46Q135 46 154 86Q158 92 223 354T289 629",
          119873: "234 637Q231 637 226 637Q201 637 196 638T191 649Q191 676 202 682Q204 683 299 683Q376 683 387 683T401 677Q612 181 616 168L670 381Q723 592 723 606Q723 633 659 637Q635 637 635 648Q635 650 637 660Q641 676 643 679T653 683Q656 683 684 682T767 680Q817 680 843 681T873 682Q888 682 888 672Q888 650 880 642Q878 637 858 637Q787 633 769 597L620 7Q618 0 599 0Q585 0 582 2Q579 5 453 305L326 604L261 344Q196 88 196 79Q201 46 268 46H278Q284 41 284 38T282 19Q278 6 272 0H259Q228 2 151 2Q123 2 100 2T63 2T46 1Q31 1 31 10Q31 14 34 26T39 40Q41 46 62 46Q130 49 150 85Q154 91 221 362L289 634Q287 635 234 637",
          119874: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM637 476Q637 565 591 615T476 665Q396 665 322 605Q242 542 200 428T157 216Q157 126 200 73T314 19Q404 19 485 98T608 313Q637 408 637 476",
          119875: "287 628Q287 635 230 637Q206 637 199 638T192 648Q192 649 194 659Q200 679 203 681T397 683Q587 682 600 680Q664 669 707 631T751 530Q751 453 685 389Q616 321 507 303Q500 302 402 301H307L277 182Q247 66 247 59Q247 55 248 54T255 50T272 48T305 46H336Q342 37 342 35Q342 19 335 5Q330 0 319 0Q316 0 282 1T182 2Q120 2 87 2T51 1Q33 1 33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM645 554Q645 567 643 575T634 597T609 619T560 635Q553 636 480 637Q463 637 445 637T416 636T404 636Q391 635 386 627Q384 621 367 550T332 412T314 344Q314 342 395 342H407H430Q542 342 590 392Q617 419 631 471T645 554",
          119876: "399 -80Q399 -47 400 -30T402 -11V-7L387 -11Q341 -22 303 -22Q208 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435Q740 255 592 107Q529 47 461 16L444 8V3Q444 2 449 -24T470 -66T516 -82Q551 -82 583 -60T625 -3Q631 11 638 11Q647 11 649 2Q649 -6 639 -34T611 -100T557 -165T481 -194Q399 -194 399 -87V-80ZM636 468Q636 523 621 564T580 625T530 655T477 665Q429 665 379 640Q277 591 215 464T153 216Q153 110 207 59Q231 38 236 38V46Q236 86 269 120T347 155Q372 155 390 144T417 114T429 82T435 55L448 64Q512 108 557 185T619 334T636 468ZM314 18Q362 18 404 39L403 49Q399 104 366 115Q354 117 347 117Q344 117 341 117T337 118Q317 118 296 98T274 52Q274 18 314 18",
          119877: "230 637Q203 637 198 638T193 649Q193 676 204 682Q206 683 378 683Q550 682 564 680Q620 672 658 652T712 606T733 563T739 529Q739 484 710 445T643 385T576 351T538 338L545 333Q612 295 612 223Q612 212 607 162T602 80V71Q602 53 603 43T614 25T640 16Q668 16 686 38T712 85Q717 99 720 102T735 105Q755 105 755 93Q755 75 731 36Q693 -21 641 -21H632Q571 -21 531 4T487 82Q487 109 502 166T517 239Q517 290 474 313Q459 320 449 321T378 323H309L277 193Q244 61 244 59Q244 55 245 54T252 50T269 48T302 46H333Q339 38 339 37T336 19Q332 6 326 0H311Q275 2 180 2Q146 2 117 2T71 2T50 1Q33 1 33 10Q33 12 36 24Q41 43 46 45Q50 46 61 46H67Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628Q287 635 230 637ZM630 554Q630 586 609 608T523 636Q521 636 500 636T462 637H440Q393 637 386 627Q385 624 352 494T319 361Q319 360 388 360Q466 361 492 367Q556 377 592 426Q608 449 619 486T630 554",
          119878: "308 24Q367 24 416 76T466 197Q466 260 414 284Q308 311 278 321T236 341Q176 383 176 462Q176 523 208 573T273 648Q302 673 343 688T407 704H418H425Q521 704 564 640Q565 640 577 653T603 682T623 704Q624 704 627 704T632 705Q645 705 645 698T617 577T585 459T569 456Q549 456 549 465Q549 471 550 475Q550 478 551 494T553 520Q553 554 544 579T526 616T501 641Q465 662 419 662Q362 662 313 616T263 510Q263 480 278 458T319 427Q323 425 389 408T456 390Q490 379 522 342T554 242Q554 216 546 186Q541 164 528 137T492 78T426 18T332 -20Q320 -22 298 -22Q199 -22 144 33L134 44L106 13Q83 -14 78 -18T65 -22Q52 -22 52 -14Q52 -11 110 221Q112 227 130 227H143Q149 221 149 216Q149 214 148 207T144 186T142 153Q144 114 160 87T203 47T255 29T308 24",
          119879: "40 437Q21 437 21 445Q21 450 37 501T71 602L88 651Q93 669 101 677H569H659Q691 677 697 676T704 667Q704 661 687 553T668 444Q668 437 649 437Q640 437 637 437T631 442L629 445Q629 451 635 490T641 551Q641 586 628 604T573 629Q568 630 515 631Q469 631 457 630T439 622Q438 621 368 343T298 60Q298 48 386 46Q418 46 427 45T436 36Q436 31 433 22Q429 4 424 1L422 0Q419 0 415 0Q410 0 363 1T228 2Q99 2 64 0H49Q43 6 43 9T45 27Q49 40 55 46H83H94Q174 46 189 55Q190 56 191 56Q196 59 201 76T241 233Q258 301 269 344Q339 619 339 625Q339 630 310 630H279Q212 630 191 624Q146 614 121 583T67 467Q60 445 57 441T43 437H40",
          119880: "107 637Q73 637 71 641Q70 643 70 649Q70 673 81 682Q83 683 98 683Q139 681 234 681Q268 681 297 681T342 682T362 682Q378 682 378 672Q378 670 376 658Q371 641 366 638H364Q362 638 359 638T352 638T343 637T334 637Q295 636 284 634T266 623Q265 621 238 518T184 302T154 169Q152 155 152 140Q152 86 183 55T269 24Q336 24 403 69T501 205L552 406Q599 598 599 606Q599 633 535 637Q511 637 511 648Q511 650 513 660Q517 676 519 679T529 683Q532 683 561 682T645 680Q696 680 723 681T752 682Q767 682 767 672Q767 650 759 642Q756 637 737 637Q666 633 648 597Q646 592 598 404Q557 235 548 205Q515 105 433 42T263 -22Q171 -22 116 34T60 167V183Q60 201 115 421Q164 622 164 628Q164 635 107 637",
          119881: "52 648Q52 670 65 683H76Q118 680 181 680Q299 680 320 683H330Q336 677 336 674T334 656Q329 641 325 637H304Q282 635 274 635Q245 630 242 620Q242 618 271 369T301 118L374 235Q447 352 520 471T595 594Q599 601 599 609Q599 633 555 637Q537 637 537 648Q537 649 539 661Q542 675 545 679T558 683Q560 683 570 683T604 682T668 681Q737 681 755 683H762Q769 676 769 672Q769 655 760 640Q757 637 743 637Q730 636 719 635T698 630T682 623T670 615T660 608T652 599T645 592L452 282Q272 -9 266 -16Q263 -18 259 -21L241 -22H234Q216 -22 216 -15Q213 -9 177 305Q139 623 138 626Q133 637 76 637H59Q52 642 52 648",
          119882: "436 683Q450 683 486 682T553 680Q604 680 638 681T677 682Q695 682 695 674Q695 670 692 659Q687 641 683 639T661 637Q636 636 621 632T600 624T597 615Q597 603 613 377T629 138L631 141Q633 144 637 151T649 170T666 200T690 241T720 295T759 362Q863 546 877 572T892 604Q892 619 873 628T831 637Q817 637 817 647Q817 650 819 660Q823 676 825 679T839 682Q842 682 856 682T895 682T949 681Q1015 681 1034 683Q1048 683 1048 672Q1048 666 1045 655T1038 640T1028 637Q1006 637 988 631T958 617T939 600T927 584L923 578L754 282Q586 -14 585 -15Q579 -22 561 -22Q546 -22 542 -17Q539 -14 523 229T506 480L494 462Q472 425 366 239Q222 -13 220 -15T215 -19Q210 -22 197 -22Q178 -22 176 -15Q176 -12 154 304T131 622Q129 631 121 633T82 637H58Q51 644 51 648Q52 671 64 683H76Q118 680 176 680Q301 680 313 683H323Q329 677 329 674T327 656Q322 641 318 637H297Q236 634 232 620Q262 160 266 136L501 550L499 587Q496 629 489 632Q483 636 447 637Q428 637 422 639T416 648Q416 650 418 660Q419 664 420 669T421 676T424 680T428 682T436 683",
          119883: "42 0H40Q26 0 26 11Q26 15 29 27Q33 41 36 43T55 46Q141 49 190 98Q200 108 306 224T411 342Q302 620 297 625Q288 636 234 637H206Q200 643 200 645T202 664Q206 677 212 683H226Q260 681 347 681Q380 681 408 681T453 682T473 682Q490 682 490 671Q490 670 488 658Q484 643 481 640T465 637Q434 634 411 620L488 426L541 485Q646 598 646 610Q646 628 622 635Q617 635 609 637Q594 637 594 648Q594 650 596 664Q600 677 606 683H618Q619 683 643 683T697 681T738 680Q828 680 837 683H845Q852 676 852 672Q850 647 840 637H824Q790 636 763 628T722 611T698 593L687 584Q687 585 592 480L505 384Q505 383 536 304T601 142T638 56Q648 47 699 46Q734 46 734 37Q734 35 732 23Q728 7 725 4T711 1Q708 1 678 1T589 2Q528 2 496 2T461 1Q444 1 444 10Q444 11 446 25Q448 35 450 39T455 44T464 46T480 47T506 54Q523 62 523 64Q522 64 476 181L429 299Q241 95 236 84Q232 76 232 72Q232 53 261 47Q262 47 267 47T273 46Q276 46 277 46T280 45T283 42T284 35Q284 26 282 19Q279 6 276 4T261 1Q258 1 243 1T201 2T142 2Q64 2 42 0",
          119884: "66 637Q54 637 49 637T39 638T32 641T30 647T33 664T42 682Q44 683 56 683Q104 680 165 680Q288 680 306 683H316Q322 677 322 674T320 656Q316 643 310 637H298Q242 637 242 624Q242 619 292 477T343 333L346 336Q350 340 358 349T379 373T411 410T454 461Q546 568 561 587T577 618Q577 634 545 637Q528 637 528 647Q528 649 530 661Q533 676 535 679T549 683Q551 683 578 682T657 680Q684 680 713 681T746 682Q763 682 763 673Q763 669 760 657T755 643Q753 637 734 637Q662 632 617 587Q608 578 477 424L348 273L322 169Q295 62 295 57Q295 46 363 46Q379 46 384 45T390 35Q390 33 388 23Q384 6 382 4T366 1Q361 1 324 1T232 2Q170 2 138 2T102 1Q84 1 84 9Q84 14 87 24Q88 27 89 30T90 35T91 39T93 42T96 44T101 45T107 45T116 46T129 46Q168 47 180 50T198 63Q201 68 227 171L252 274L129 623Q128 624 127 625T125 627T122 629T118 631T113 633T105 634T96 635T83 636T66 637",
          119885: "58 8Q58 23 64 35Q64 36 329 334T596 635L586 637Q575 637 512 637H500H476Q442 637 420 635T365 624T311 598T266 548T228 469Q227 466 226 463T224 458T223 453T222 450L221 448Q218 443 202 443Q185 443 182 453L214 561Q228 606 241 651Q249 679 253 681Q256 683 487 683H718Q723 678 723 675Q723 673 717 649Q189 54 188 52L185 49H274Q369 50 377 51Q452 60 500 100T579 247Q587 272 590 277T603 282H607Q628 282 628 271Q547 5 541 2Q538 0 300 0H124Q58 0 58 8",
          119886: "33 157Q33 258 109 349T280 441Q331 441 370 392Q386 422 416 422Q429 422 439 414T449 394Q449 381 412 234T374 68Q374 43 381 35T402 26Q411 27 422 35Q443 55 463 131Q469 151 473 152Q475 153 483 153H487Q506 153 506 144Q506 138 501 117T481 63T449 13Q436 0 417 -8Q409 -10 393 -10Q359 -10 336 5T306 36L300 51Q299 52 296 50Q294 48 292 46Q233 -10 172 -10Q117 -10 75 30T33 157ZM351 328Q351 334 346 350T323 385T277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q217 26 254 59T298 110Q300 114 325 217T351 328",
          119887: "73 647Q73 657 77 670T89 683Q90 683 161 688T234 694Q246 694 246 685T212 542Q204 508 195 472T180 418L176 399Q176 396 182 402Q231 442 283 442Q345 442 383 396T422 280Q422 169 343 79T173 -11Q123 -11 82 27T40 150V159Q40 180 48 217T97 414Q147 611 147 623T109 637Q104 637 101 637H96Q86 637 83 637T76 640T73 647ZM336 325V331Q336 405 275 405Q258 405 240 397T207 376T181 352T163 330L157 322L136 236Q114 150 114 114Q114 66 138 42Q154 26 178 26Q211 26 245 58Q270 81 285 114T318 219Q336 291 336 325",
          119888: "34 159Q34 268 120 355T306 442Q362 442 394 418T427 355Q427 326 408 306T360 285Q341 285 330 295T319 325T330 359T352 380T366 386H367Q367 388 361 392T340 400T306 404Q276 404 249 390Q228 381 206 359Q162 315 142 235T121 119Q121 73 147 50Q169 26 205 26H209Q321 26 394 111Q403 121 406 121Q410 121 419 112T429 98T420 83T391 55T346 25T282 0T202 -11Q127 -11 81 37T34 159",
          119889: "366 683Q367 683 438 688T511 694Q523 694 523 686Q523 679 450 384T375 83T374 68Q374 26 402 26Q411 27 422 35Q443 55 463 131Q469 151 473 152Q475 153 483 153H487H491Q506 153 506 145Q506 140 503 129Q490 79 473 48T445 8T417 -8Q409 -10 393 -10Q359 -10 336 5T306 36L300 51Q299 52 296 50Q294 48 292 46Q233 -10 172 -10Q117 -10 75 30T33 157Q33 205 53 255T101 341Q148 398 195 420T280 442Q336 442 364 400Q369 394 369 396Q370 400 396 505T424 616Q424 629 417 632T378 637H357Q351 643 351 645T353 664Q358 683 366 683ZM352 326Q329 405 277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q233 26 290 98L298 109L352 326",
          119890: "39 168Q39 225 58 272T107 350T174 402T244 433T307 442H310Q355 442 388 420T421 355Q421 265 310 237Q261 224 176 223Q139 223 138 221Q138 219 132 186T125 128Q125 81 146 54T209 26T302 45T394 111Q403 121 406 121Q410 121 419 112T429 98T420 82T390 55T344 24T281 -1T205 -11Q126 -11 83 42T39 168ZM373 353Q367 405 305 405Q272 405 244 391T199 357T170 316T154 280T149 261Q149 260 169 260Q282 260 327 284T373 353",
          119891: "118 -162Q120 -162 124 -164T135 -167T147 -168Q160 -168 171 -155T187 -126Q197 -99 221 27T267 267T289 382V385H242Q195 385 192 387Q188 390 188 397L195 425Q197 430 203 430T250 431Q298 431 298 432Q298 434 307 482T319 540Q356 705 465 705Q502 703 526 683T550 630Q550 594 529 578T487 561Q443 561 443 603Q443 622 454 636T478 657L487 662Q471 668 457 668Q445 668 434 658T419 630Q412 601 403 552T387 469T380 433Q380 431 435 431Q480 431 487 430T498 424Q499 420 496 407T491 391Q489 386 482 386T428 385H372L349 263Q301 15 282 -47Q255 -132 212 -173Q175 -205 139 -205Q107 -205 81 -186T55 -132Q55 -95 76 -78T118 -61Q162 -61 162 -103Q162 -122 151 -136T127 -157L118 -162",
          119892: "311 43Q296 30 267 15T206 0Q143 0 105 45T66 160Q66 265 143 353T314 442Q361 442 401 394L404 398Q406 401 409 404T418 412T431 419T447 422Q461 422 470 413T480 394Q480 379 423 152T363 -80Q345 -134 286 -169T151 -205Q10 -205 10 -137Q10 -111 28 -91T74 -71Q89 -71 102 -80T116 -111Q116 -121 114 -130T107 -144T99 -154T92 -162L90 -164H91Q101 -167 151 -167Q189 -167 211 -155Q234 -144 254 -122T282 -75Q288 -56 298 -13Q311 35 311 43ZM384 328L380 339Q377 350 375 354T369 368T359 382T346 393T328 402T306 405Q262 405 221 352Q191 313 171 233T151 117Q151 38 213 38Q269 38 323 108L331 118L384 328",
          119894: "184 600Q184 624 203 642T247 661Q265 661 277 649T290 619Q290 596 270 577T226 557Q211 557 198 567T184 600ZM21 287Q21 295 30 318T54 369T98 420T158 442Q197 442 223 419T250 357Q250 340 236 301T196 196T154 83Q149 61 149 51Q149 26 166 26Q175 26 185 29T208 43T235 78T260 137Q263 149 265 151T282 153Q302 153 302 143Q302 135 293 112T268 61T223 11T161 -11Q129 -11 102 10T74 74Q74 91 79 106T122 220Q160 321 166 341T173 380Q173 404 156 404H154Q124 404 99 371T61 287Q60 286 59 284T58 281T56 279T53 278T49 278T41 278H27Q21 284 21 287",
          119895: "297 596Q297 627 318 644T361 661Q378 661 389 651T403 623Q403 595 384 576T340 557Q322 557 310 567T297 596ZM288 376Q288 405 262 405Q240 405 220 393T185 362T161 325T144 293L137 279Q135 278 121 278H107Q101 284 101 286T105 299Q126 348 164 391T252 441Q253 441 260 441T272 442Q296 441 316 432Q341 418 354 401T367 348V332L318 133Q267 -67 264 -75Q246 -125 194 -164T75 -204Q25 -204 7 -183T-12 -137Q-12 -110 7 -91T53 -71Q70 -71 82 -81T95 -112Q95 -148 63 -167Q69 -168 77 -168Q111 -168 139 -140T182 -74L193 -32Q204 11 219 72T251 197T278 308T289 365Q289 372 288 376",
          119896: "121 647Q121 657 125 670T137 683Q138 683 209 688T282 694Q294 694 294 686Q294 679 244 477Q194 279 194 272Q213 282 223 291Q247 309 292 354T362 415Q402 442 438 442Q468 442 485 423T503 369Q503 344 496 327T477 302T456 291T438 288Q418 288 406 299T394 328Q394 353 410 369T442 390L458 393Q446 405 434 405H430Q398 402 367 380T294 316T228 255Q230 254 243 252T267 246T293 238T320 224T342 206T359 180T365 147Q365 130 360 106T354 66Q354 26 381 26Q429 26 459 145Q461 153 479 153H483Q499 153 499 144Q499 139 496 130Q455 -11 378 -11Q333 -11 305 15T277 90Q277 108 280 121T283 145Q283 167 269 183T234 206T200 217T182 220H180Q168 178 159 139T145 81T136 44T129 20T122 7T111 -2Q98 -11 83 -11Q66 -11 57 -1T48 16Q48 26 85 176T158 471L195 616Q196 629 188 632T149 637H144Q134 637 131 637T124 640T121 647",
          119897: "117 59Q117 26 142 26Q179 26 205 131Q211 151 215 152Q217 153 225 153H229Q238 153 241 153T246 151T248 144Q247 138 245 128T234 90T214 43T183 6T137 -11Q101 -11 70 11T38 85Q38 97 39 102L104 360Q167 615 167 623Q167 626 166 628T162 632T157 634T149 635T141 636T132 637T122 637Q112 637 109 637T101 638T95 641T94 647Q94 649 96 661Q101 680 107 682T179 688Q194 689 213 690T243 693T254 694Q266 694 266 686Q266 675 193 386T118 83Q118 81 118 75T117 65V59",
          119898: "21 287Q22 293 24 303T36 341T56 388T88 425T132 442T175 435T205 417T221 395T229 376L231 369Q231 367 232 367L243 378Q303 442 384 442Q401 442 415 440T441 433T460 423T475 411T485 398T493 385T497 373T500 364T502 357L510 367Q573 442 659 442Q713 442 746 415T780 336Q780 285 742 178T704 50Q705 36 709 31T724 26Q752 26 776 56T815 138Q818 149 821 151T837 153Q857 153 857 145Q857 144 853 130Q845 101 831 73T785 17T716 -10Q669 -10 648 17T627 73Q627 92 663 193T700 345Q700 404 656 404H651Q565 404 506 303L499 291L466 157Q433 26 428 16Q415 -11 385 -11Q372 -11 364 -4T353 8T350 18Q350 29 384 161L420 307Q423 322 423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 112 181Q151 335 151 342Q154 357 154 369Q154 405 129 405Q107 405 92 377T69 316T57 280Q55 278 41 278H27Q21 284 21 287",
          119899: "21 287Q22 293 24 303T36 341T56 388T89 425T135 442Q171 442 195 424T225 390T231 369Q231 367 232 367L243 378Q304 442 382 442Q436 442 469 415T503 336T465 179T427 52Q427 26 444 26Q450 26 453 27Q482 32 505 65T540 145Q542 153 560 153Q580 153 580 145Q580 144 576 130Q568 101 554 73T508 17T439 -10Q392 -10 371 17T350 73Q350 92 386 193T423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 112 180T152 343Q153 348 153 366Q153 405 129 405Q91 405 66 305Q60 285 60 284Q58 278 41 278H27Q21 284 21 287",
          119900: "201 -11Q126 -11 80 38T34 156Q34 221 64 279T146 380Q222 441 301 441Q333 441 341 440Q354 437 367 433T402 417T438 387T464 338T476 268Q476 161 390 75T201 -11ZM121 120Q121 70 147 48T206 26Q250 26 289 58T351 142Q360 163 374 216T388 308Q388 352 370 375Q346 405 306 405Q243 405 195 347Q158 303 140 230T121 120",
          119901: "23 287Q24 290 25 295T30 317T40 348T55 381T75 411T101 433T134 442Q209 442 230 378L240 387Q302 442 358 442Q423 442 460 395T497 281Q497 173 421 82T249 -10Q227 -10 210 -4Q199 1 187 11T168 28L161 36Q160 35 139 -51T118 -138Q118 -144 126 -145T163 -148H188Q194 -155 194 -157T191 -175Q188 -187 185 -190T172 -194Q170 -194 161 -194T127 -193T65 -192Q-5 -192 -24 -194H-32Q-39 -187 -39 -183Q-37 -156 -26 -148H-6Q28 -147 33 -136Q36 -130 94 103T155 350Q156 355 156 364Q156 405 131 405Q109 405 94 377T71 316T59 280Q57 278 43 278H29Q23 284 23 287ZM178 102Q200 26 252 26Q282 26 310 49T356 107Q374 141 392 215T411 325V331Q411 405 350 405Q339 405 328 402T306 393T286 380T269 365T254 350T243 336T235 326L232 322Q232 321 229 308T218 264T204 212Q178 106 178 102",
          119902: "33 157Q33 258 109 349T280 441Q340 441 372 389Q373 390 377 395T388 406T404 418Q438 442 450 442Q454 442 457 439T460 434Q460 425 391 149Q320 -135 320 -139Q320 -147 365 -148H390Q396 -156 396 -157T393 -175Q389 -188 383 -194H370Q339 -192 262 -192Q234 -192 211 -192T174 -192T157 -193Q143 -193 143 -185Q143 -182 145 -170Q149 -154 152 -151T172 -148Q220 -148 230 -141Q238 -136 258 -53T279 32Q279 33 272 29Q224 -10 172 -10Q117 -10 75 30T33 157ZM352 326Q329 405 277 405Q242 405 210 374T160 293Q131 214 119 129Q119 126 119 118T118 106Q118 61 136 44T179 26Q233 26 290 98L298 109L352 326",
          119903: "21 287Q22 290 23 295T28 317T38 348T53 381T73 411T99 433T132 442Q161 442 183 430T214 408T225 388Q227 382 228 382T236 389Q284 441 347 441H350Q398 441 422 400Q430 381 430 363Q430 333 417 315T391 292T366 288Q346 288 334 299T322 328Q322 376 378 392Q356 405 342 405Q286 405 239 331Q229 315 224 298T190 165Q156 25 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 114 189T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287",
          119904: "131 289Q131 321 147 354T203 415T300 442Q362 442 390 415T419 355Q419 323 402 308T364 292Q351 292 340 300T328 326Q328 342 337 354T354 372T367 378Q368 378 368 379Q368 382 361 388T336 399T297 405Q249 405 227 379T204 326Q204 301 223 291T278 274T330 259Q396 230 396 163Q396 135 385 107T352 51T289 7T195 -10Q118 -10 86 19T53 87Q53 126 74 143T118 160Q133 160 146 151T160 120Q160 94 142 76T111 58Q109 57 108 57T107 55Q108 52 115 47T146 34T201 27Q237 27 263 38T301 66T318 97T323 122Q323 150 302 164T254 181T195 196T148 231Q131 256 131 289",
          119905: "26 385Q19 392 19 395Q19 399 22 411T27 425Q29 430 36 430T87 431H140L159 511Q162 522 166 540T173 566T179 586T187 603T197 615T211 624T229 626Q247 625 254 615T261 596Q261 589 252 549T232 470L222 433Q222 431 272 431H323Q330 424 330 420Q330 398 317 385H210L174 240Q135 80 135 68Q135 26 162 26Q197 26 230 60T283 144Q285 150 288 151T303 153H307Q322 153 322 145Q322 142 319 133Q314 117 301 95T267 48T216 6T155 -11Q125 -11 98 4T59 56Q57 64 57 83V101L92 241Q127 382 128 383Q128 385 77 385H26",
          119906: "21 287Q21 295 30 318T55 370T99 420T158 442Q204 442 227 417T250 358Q250 340 216 246T182 105Q182 62 196 45T238 27T291 44T328 78L339 95Q341 99 377 247Q407 367 413 387T427 416Q444 431 463 431Q480 431 488 421T496 402L420 84Q419 79 419 68Q419 43 426 35T447 26Q469 29 482 57T512 145Q514 153 532 153Q551 153 551 144Q550 139 549 130T540 98T523 55T498 17T462 -8Q454 -10 438 -10Q372 -10 347 46Q345 45 336 36T318 21T296 6T267 -6T233 -11Q189 -11 155 7Q103 38 103 113Q103 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287",
          119907: "173 380Q173 405 154 405Q130 405 104 376T61 287Q60 286 59 284T58 281T56 279T53 278T49 278T41 278H27Q21 284 21 287Q21 294 29 316T53 368T97 419T160 441Q202 441 225 417T249 361Q249 344 246 335Q246 329 231 291T200 202T182 113Q182 86 187 69Q200 26 250 26Q287 26 319 60T369 139T398 222T409 277Q409 300 401 317T383 343T365 361T357 383Q357 405 376 424T417 443Q436 443 451 425T467 367Q467 340 455 284T418 159T347 40T241 -11Q177 -11 139 22Q102 54 102 117Q102 148 110 181T151 298Q173 362 173 380",
          119908: "580 385Q580 406 599 424T641 443Q659 443 674 425T690 368Q690 339 671 253Q656 197 644 161T609 80T554 12T482 -11Q438 -11 404 5T355 48Q354 47 352 44Q311 -11 252 -11Q226 -11 202 -5T155 14T118 53T104 116Q104 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 293 29 315T52 366T96 418T161 441Q204 441 227 416T250 358Q250 340 217 250T184 111Q184 65 205 46T258 26Q301 26 334 87L339 96V119Q339 122 339 128T340 136T341 143T342 152T345 165T348 182T354 206T362 238T373 281Q402 395 406 404Q419 431 449 431Q468 431 475 421T483 402Q483 389 454 274T422 142Q420 131 420 107V100Q420 85 423 71T442 42T487 26Q558 26 600 148Q609 171 620 213T632 273Q632 306 619 325T593 357T580 385",
          119909: "52 289Q59 331 106 386T222 442Q257 442 286 424T329 379Q371 442 430 442Q467 442 494 420T522 361Q522 332 508 314T481 292T458 288Q439 288 427 299T415 328Q415 374 465 391Q454 404 425 404Q412 404 406 402Q368 386 350 336Q290 115 290 78Q290 50 306 38T341 26Q378 26 414 59T463 140Q466 150 469 151T485 153H489Q504 153 504 145Q504 144 502 134Q486 77 440 33T333 -11Q263 -11 227 52Q186 -10 133 -10H127Q78 -10 57 16T35 71Q35 103 54 123T99 143Q142 143 142 101Q142 81 130 66T107 46T94 41L91 40Q91 39 97 36T113 29T132 26Q168 26 194 71Q203 87 217 139T245 247T261 313Q266 340 266 352Q266 380 251 392T217 404Q177 404 142 372T93 290Q91 281 88 280T72 278H58Q52 284 52 289",
          119910: "21 287Q21 301 36 335T84 406T158 442Q199 442 224 419T250 355Q248 336 247 334Q247 331 231 288T198 191T182 105Q182 62 196 45T238 27Q261 27 281 38T312 61T339 94Q339 95 344 114T358 173T377 247Q415 397 419 404Q432 431 462 431Q475 431 483 424T494 412T496 403Q496 390 447 193T391 -23Q363 -106 294 -155T156 -205Q111 -205 77 -183T43 -117Q43 -95 50 -80T69 -58T89 -48T106 -45Q150 -45 150 -87Q150 -107 138 -122T115 -142T102 -147L99 -148Q101 -153 118 -160T152 -167H160Q177 -167 186 -165Q219 -156 247 -127T290 -65T313 -9T321 21L315 17Q309 13 296 6T270 -6Q250 -11 231 -11Q185 -11 150 11T104 82Q103 89 103 113Q103 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287",
          119911: "347 338Q337 338 294 349T231 360Q211 360 197 356T174 346T162 335T155 324L153 320Q150 317 138 317Q117 317 117 325Q117 330 120 339Q133 378 163 406T229 440Q241 442 246 442Q271 442 291 425T329 392T367 375Q389 375 411 408T434 441Q435 442 449 442H462Q468 436 468 434Q468 430 463 420T449 399T432 377T418 358L411 349Q368 298 275 214T160 106L148 94L163 93Q185 93 227 82T290 71Q328 71 360 90T402 140Q406 149 409 151T424 153Q443 153 443 143Q443 138 442 134Q425 72 376 31T278 -11Q252 -11 232 6T193 40T155 57Q111 57 76 -3Q70 -11 59 -11H54H41Q35 -5 35 -2Q35 13 93 84Q132 129 225 214T340 322Q352 338 347 338",
          119912: "65 0Q45 0 45 18Q48 52 61 60Q65 62 81 62Q155 62 165 74Q166 74 265 228T465 539T569 699Q576 707 583 709T611 711T637 710T649 700Q650 697 695 380L741 63L784 62H827Q839 50 839 45L835 29Q831 9 827 5T806 0Q803 0 790 0T743 1T657 2Q585 2 547 1T504 0Q481 0 481 17Q484 54 497 60Q501 62 541 62Q580 62 580 63Q580 68 573 121T564 179V181H308L271 124Q236 69 236 67T283 62H287Q316 62 316 46Q316 26 307 8Q302 3 295 0L262 1Q242 2 168 2Q119 2 93 1T65 0ZM537 372Q533 402 528 435T521 486T518 504V505Q517 505 433 375L348 244L451 243Q555 243 555 244L537 372",
          119913: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 449 686H477H586Q684 686 733 677T817 634Q853 598 853 547Q853 499 826 460T761 401T695 371T654 360H653L662 358Q670 357 683 354T712 344T744 327T774 303T795 269T804 224Q804 148 732 79T533 1Q524 0 288 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM703 550Q703 571 695 586T675 609T656 619T643 623L545 624H447L417 504Q386 384 386 383T470 382Q554 383 565 385Q632 397 667 447T703 550ZM651 240Q651 265 645 282T626 309T608 322T592 329Q587 330 479 331H373L340 198Q307 65 306 64Q306 62 406 62L507 63L519 65Q565 76 596 107T639 171T651 240",
          119914: "380 -17Q335 -17 293 -10T207 16T130 65T76 144T55 256Q55 306 70 361T122 476T211 582T345 663T525 702H545Q673 702 731 634L777 668Q783 672 789 677T800 685T808 691T814 695T818 698T822 700T825 702T828 703T830 703T833 703Q855 703 855 690Q855 686 823 558T789 426Q786 421 782 420T756 419Q734 420 729 421T724 432Q724 434 725 447T726 472Q726 552 678 604Q640 640 586 640H574Q533 640 494 632T409 604T324 541T260 437Q243 397 227 333T210 219Q210 152 237 117Q255 90 299 68T420 46H429Q506 46 580 100T678 234Q683 249 687 251T712 254H723Q743 254 743 240Q743 232 736 213T710 162T663 100T586 40T477 -5Q433 -17 380 -17",
          119915: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 437 686Q659 686 668 685Q727 680 772 662T842 621T883 568T905 517T913 475Q914 466 914 434Q914 373 892 307T828 179T712 69T548 7Q517 2 494 2T279 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM768 475Q768 515 753 544T718 588T666 611T613 622T563 624H538H532H452L382 344Q311 64 311 63T363 62H405Q490 62 545 76T656 142Q696 185 724 265T760 399T768 475",
          119916: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H811Q817 677 820 673T824 666L825 664Q825 659 814 549T799 433Q793 424 771 424Q752 424 746 427T740 441Q740 445 742 466T744 505Q744 561 722 585T646 616Q639 617 545 618H456Q456 617 427 502T398 385Q398 384 435 384Q461 385 471 385T499 391T526 405T545 433T562 478Q566 494 571 497T595 501H604Q622 501 626 486Q626 482 593 349T557 213Q552 205 530 205Q499 205 499 219Q499 222 503 242T508 281Q508 308 491 314T429 322Q425 322 423 322H382L317 64Q317 62 390 62Q460 62 493 64T569 80T640 124Q665 149 686 187T719 253T733 283Q739 289 760 289Q791 289 791 274Q791 267 763 201T706 71L678 8Q676 4 667 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
          119917: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H795Q801 677 804 673T808 666L809 664Q809 659 798 549T783 433Q777 424 755 424Q736 424 730 427T724 444Q724 448 725 468T727 507V524Q727 541 724 554T713 577T698 594T676 605T653 612T625 616T597 617T566 618T538 618H456L455 614Q455 611 424 491L394 371H429Q454 372 463 372T491 378T517 392T536 419T552 464Q556 481 561 484T586 488Q603 488 607 486Q616 482 616 473Q616 467 584 337T549 201Q542 192 521 192Q503 192 497 195T490 209Q490 212 492 224Q499 251 499 269Q499 288 489 296T465 306T417 308L379 309L348 188Q341 161 334 129T322 80L318 65L317 62H375H409Q430 62 438 59T447 45Q444 8 431 2L426 0L377 1Q347 2 231 2Q152 2 111 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
          119918: "379 -16Q233 -16 145 52T56 255Q56 310 73 368T127 483T216 586T347 663T518 702H540Q562 702 582 700T616 696T644 689T667 681T686 670T702 659T717 647T731 635L776 668Q782 672 788 677T799 685T807 691T813 695T817 698T821 700T824 702T827 703T829 703T832 703Q854 703 854 690Q854 686 822 558T788 426Q785 421 781 420T755 419Q734 420 729 422T723 432Q723 434 724 446T725 469Q725 531 702 571T642 628Q616 640 575 640Q468 640 390 593T272 464Q247 415 229 340T210 214Q210 166 228 132T277 79T343 54T419 46Q445 46 465 50T500 59T526 76T544 96T557 123T566 150T574 182T581 214H519Q511 214 498 214T479 213Q443 213 443 230Q443 250 452 268Q457 273 464 276L514 275Q546 274 657 274Q735 274 768 275T803 276Q826 276 826 258Q823 224 810 216Q806 214 771 214H736Q736 211 710 109T683 5Q678 0 671 0Q666 0 637 14T597 36Q593 38 590 40T585 44T582 44T576 40Q511 -16 379 -16",
          119919: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L399 389Q399 388 547 388H695L753 623Q753 624 709 624H686Q665 624 660 626T650 639Q653 678 668 684Q672 686 681 686Q685 686 726 685T847 684Q902 684 937 684T986 685T1004 686Q1027 686 1027 668Q1023 632 1011 626Q1006 624 957 624H908L839 344Q768 64 768 63T812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66L679 324Q679 326 531 326H383L382 322L317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
          119920: "247 624Q242 624 233 624T220 623Q186 623 186 640Q186 647 190 664T202 684Q206 686 226 686Q277 684 393 684Q435 684 471 684T528 685T553 686Q573 686 573 670Q573 650 564 632Q556 624 537 624H501H449L380 344Q309 64 309 63T356 62Q361 62 370 62T384 63Q417 63 417 46Q417 26 408 8Q403 3 396 0L352 1Q325 2 216 2T82 1L45 0Q30 7 30 16Q33 51 46 60Q51 62 102 62H154L294 623Q294 624 247 624",
          119921: "205 131Q205 105 192 84T165 54L152 45Q152 44 160 42T182 37T213 35H216Q255 35 289 65Q314 90 329 129Q331 136 392 378T453 623Q453 624 393 624H332Q318 631 318 640Q318 647 322 664T334 684Q338 686 359 686Q413 684 533 684Q566 684 605 685T652 686Q677 686 685 683T694 669Q694 664 691 652Q686 631 681 628T647 624H602L542 380Q531 336 518 285T500 212T487 161T475 122T463 97T448 74T429 55Q351 -17 213 -17Q142 -17 99 7T43 70Q42 75 42 93Q42 143 73 168T139 194Q168 194 186 177T205 131",
          119922: "536 0Q522 6 522 18Q522 35 533 57Q539 62 557 62Q595 62 601 65L472 330L365 255L342 160Q318 65 317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L422 481Q386 339 386 337L785 621Q779 624 749 624Q726 624 726 641Q726 645 730 659Q734 675 736 679T747 686L786 685Q812 684 888 684Q908 684 934 685T968 686Q1003 686 1003 669Q1003 646 991 629Q985 624 967 624Q918 624 888 617Q884 617 874 613L865 609Q864 608 732 515T599 420Q599 418 686 242T775 65Q784 62 829 62Q847 62 850 61T860 54Q862 52 862 43Q862 10 845 1Q844 1 842 1T836 0T797 1T694 2Q599 2 573 1L536 0",
          119923: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 409 684Q454 684 492 684T552 685T579 686Q603 686 603 668Q599 632 587 626Q583 624 520 624H457L388 344Q317 64 317 63T353 62H390Q418 62 440 64T493 78T548 110T598 169T643 261Q651 282 655 285T680 289Q696 289 700 288T709 279Q711 274 711 269Q710 265 663 138T613 8Q611 4 602 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
          119924: "258 624H231Q214 624 208 626T199 639Q203 678 216 684Q220 686 347 686H473Q474 685 478 682T484 677Q487 673 535 413L584 153L608 187Q631 221 672 281T761 410Q935 663 943 671Q949 678 962 686H1082H1166Q1201 686 1210 683T1219 668Q1215 632 1203 626Q1199 624 1149 624H1100L1031 344Q960 64 960 63T1004 62H1031Q1063 62 1063 44Q1060 7 1046 2Q1042 0 1034 0Q1030 0 990 1T875 2Q804 2 767 1T725 0H723Q707 0 703 15Q707 54 720 60Q724 62 773 62H822Q961 618 961 619L754 318Q546 15 543 12Q531 0 510 0Q500 0 495 0T484 5T477 19Q477 20 421 315L367 604L299 335Q234 72 234 68Q234 62 302 62Q334 62 334 46Q332 8 317 2Q313 0 306 0Q301 0 267 1T181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
          119925: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 344 686H434Q464 686 477 680Q480 677 607 454Q738 227 739 227Q742 227 789 418T836 618Q836 620 835 620L821 622Q811 622 779 624Q755 624 749 625T740 632Q737 635 737 644Q737 656 742 669T754 685Q755 685 757 685T763 686Q768 686 803 685T890 684Q925 684 951 684T990 685T1006 686Q1014 686 1016 684Q1027 679 1027 668Q1023 632 1011 626Q1007 624 978 624Q912 622 907 617Q907 616 831 314T753 8Q749 0 723 0H712Q699 0 692 7Q692 8 671 44T607 155T526 296L361 580L296 323Q234 74 234 68T302 62H307Q334 62 334 44Q330 6 317 2L313 0L280 1Q260 2 181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
          119926: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 378 791 307Q727 104 527 17Q437 -17 344 -17Q289 -17 242 -5T150 35T79 116T53 245ZM664 489Q664 575 618 611T511 648Q463 648 416 627T334 570Q297 531 270 472T230 355T213 261T208 206Q208 177 215 151T237 98T284 56T358 40Q440 40 510 98T618 270Q664 400 664 489",
          119927: "162 62L302 623Q302 624 258 624H234Q214 624 209 626T200 638Q200 677 217 684Q220 686 439 686Q667 685 684 682Q686 681 693 680Q713 677 733 671T782 649T829 602T847 528Q847 450 784 382T604 293Q571 288 469 287H373L346 176Q340 151 333 122T321 78L317 64Q317 62 361 62H387Q420 62 420 44Q417 10 404 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q43 0 43 17Q43 21 47 33Q52 54 57 58T89 62H113H162ZM692 558Q692 611 617 622Q610 623 529 624H452L381 343H458H492Q604 343 641 389Q662 414 677 471T692 558",
          119928: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 410 808 370T781 277T729 178T643 87T519 14L525 4Q540 -19 553 -25T592 -32Q632 -32 654 -24T680 -7T689 10T704 18Q713 18 717 12T722 0Q722 -8 711 -36T681 -101T624 -166T541 -194Q513 -194 494 -183T465 -157T450 -118T444 -79T443 -41V-7L433 -9Q391 -17 344 -17Q301 -17 263 -10T185 15T118 62T71 138T53 245ZM666 482Q666 529 652 563T614 615T565 640T512 648Q412 648 335 573Q268 506 235 389T201 202Q201 164 210 136T230 95T259 66L262 76Q269 109 302 135T382 162Q401 162 415 159T449 140T484 92L491 78L496 82Q502 86 505 88T515 97T528 107T541 120T555 137T570 156T585 179T599 205T612 235Q629 278 647 351T666 482ZM439 56Q439 58 439 62T435 75T426 92T410 106T383 112Q353 112 332 96T311 63Q311 38 355 38H366Q391 39 415 45T439 56",
          119929: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 422 686H446H525Q634 686 698 674T806 620Q843 583 843 535Q843 505 833 478T805 432T768 396T728 370T690 352T662 342L651 338L654 336Q658 334 667 327T688 310Q719 278 719 237Q719 222 710 165T701 94Q701 35 748 35Q775 35 793 57T819 101Q822 112 826 114T843 117H849Q881 117 881 99Q881 78 852 39T781 -11Q765 -17 728 -17Q537 -13 537 94Q537 110 552 169T567 243Q567 292 529 309Q517 316 508 316T441 318H375L374 314Q374 312 343 189T311 64Q311 62 355 62H382Q414 62 414 44Q410 6 397 2L393 0L351 1Q325 2 221 2Q147 2 108 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM687 555Q687 617 589 623Q581 624 513 624H451L420 498Q413 468 405 436T392 388L388 371Q388 369 458 369Q464 369 485 369T515 369T541 372T570 377T596 386T624 400Q649 417 664 457T683 522T687 555",
          119930: "354 45Q429 45 467 91T506 184Q506 225 477 250Q461 262 384 279T294 300Q238 318 210 362T182 452Q182 493 202 540T257 623Q338 702 449 702Q491 702 501 701Q571 690 610 654Q614 649 617 650Q618 650 650 675T683 702Q685 703 692 703Q714 703 714 690Q714 686 687 578T658 466Q653 458 629 458Q606 458 602 463Q600 465 599 466Q599 467 599 469T598 473Q598 475 599 487T600 511Q600 584 557 614T454 645Q386 645 347 606T308 520Q308 506 311 496T323 477T338 464T360 454T384 446T413 439T441 433Q523 416 549 401Q581 384 602 352Q631 309 631 254Q631 214 615 170T567 83T478 12T347 -16Q322 -16 300 -14T261 -8T230 0T205 10T187 20T172 30L162 37L130 11Q124 7 119 3T110 -4T104 -9T100 -13T96 -15T93 -16T91 -17T88 -17H82Q76 -17 73 -16T69 -14T66 -10T63 -5L90 107Q97 133 106 170Q116 211 120 219T136 228H148Q167 228 173 227T179 218Q179 216 176 200T173 168Q173 102 227 74T354 45",
          119931: "498 62Q511 58 511 43Q511 10 494 1L490 0Q487 0 482 0T424 1T271 2Q201 2 157 2T94 1T72 0H70Q46 0 46 17Q49 54 62 60L66 62H137Q208 62 209 63L218 98Q227 134 244 203T278 339L347 613H300Q262 612 246 611T198 599T146 564Q128 545 114 512T91 454T79 425Q73 419 52 419Q22 419 22 434Q22 440 41 498T80 611L100 666Q105 673 111 675H434Q758 675 762 673Q772 668 772 657Q772 655 756 549T738 434Q735 419 711 419H707Q690 419 686 421Q677 425 677 434Q676 436 678 449T683 485T686 529Q686 553 679 569T662 594T631 607T593 612T544 613H502L433 340Q418 279 400 207T374 100L365 65L364 62H498",
          119932: "856 686Q877 686 877 668Q877 663 873 649T867 631Q861 624 828 624Q762 622 757 617Q757 613 705 409T651 200Q620 112 540 48T328 -16Q251 -16 196 2T113 51T75 112T63 176Q63 202 70 232T117 422Q129 469 141 520T160 598L167 623Q167 624 123 624H96Q79 624 73 626T64 639Q68 678 81 684Q85 686 104 686Q155 684 268 684Q340 684 377 685T418 686Q441 686 441 668Q437 632 425 626Q421 624 371 624H322L270 415Q224 232 217 198T209 141Q209 45 336 45Q372 45 406 52T475 77T540 128T585 211L590 229Q594 247 601 274T617 336T636 409T654 482T670 547T681 595T686 618Q686 620 685 620H683Q681 621 678 621T671 622Q660 622 630 624Q616 624 610 624T598 626T589 630T587 640Q587 647 590 659Q594 677 598 681T613 686Q618 686 653 685T740 684Q775 684 801 684T840 685T856 686",
          119933: "401 686Q415 680 415 668Q415 651 404 629Q398 624 356 624Q318 624 318 623Q318 620 337 508T377 284L397 174L472 285Q548 396 623 507T699 620Q698 621 652 624Q634 624 627 627T619 641Q619 648 622 658Q627 677 631 681T650 686Q654 686 686 685T766 684Q794 684 823 684T858 685Q874 685 878 683T886 671Q886 667 882 651Q877 632 873 628T850 624Q800 624 779 617Q774 617 770 613Q767 610 560 304T350 -5Q346 -9 332 -16H306H291Q270 -16 267 -2Q267 -1 260 37T238 161T210 313L156 624H116H94Q62 624 62 642Q66 678 78 684Q82 686 99 686Q144 684 246 684Q330 684 368 685L401 686",
          119934: "111 624Q109 624 102 624T91 623Q61 623 61 640Q61 660 70 678Q78 686 98 686Q140 684 239 684Q277 684 309 684T360 685T383 686H385Q407 686 407 668Q404 634 391 626Q387 624 348 624Q307 624 307 622Q307 618 332 409Q359 198 359 195L570 532L564 576L558 622V624H522H504Q472 624 472 641Q475 678 488 684L493 686L529 685Q551 684 645 684Q716 684 753 685T795 686Q818 686 818 669Q815 632 802 626Q798 624 759 624Q718 624 718 622Q718 615 743 410Q770 199 770 196Q770 195 806 253T903 406Q1035 618 1035 619Q1025 624 968 624Q943 624 943 641Q943 648 946 659Q950 675 952 679T963 686L998 685Q1020 684 1093 684Q1113 684 1139 685T1173 686Q1207 686 1207 669Q1207 664 1204 652Q1199 631 1194 628T1164 624Q1113 622 1101 615Q1098 612 905 305Q715 -1 709 -7Q699 -17 673 -17Q645 -17 639 -8L581 441Q581 444 442 221Q331 44 314 18T288 -14Q279 -17 263 -17H254Q229 -17 227 -5Q225 2 186 311L147 620V624H111",
          119935: "931 686Q953 686 953 670Q953 650 944 632Q936 624 924 624H914Q823 624 803 611Q800 609 696 503T591 396Q591 394 667 229L743 62H787H814Q846 62 846 44Q843 7 829 2Q825 0 817 0Q813 0 775 1T664 2Q590 2 551 1T508 0H507Q484 0 484 18Q484 19 488 37Q492 56 497 58T534 62L566 63Q567 64 520 169T471 274Q469 274 369 172T268 67L315 62Q320 62 328 62L335 61Q347 58 347 44Q344 10 331 2L326 0L287 1Q263 2 177 2Q95 2 78 1L53 0Q38 6 38 17Q38 40 50 57Q56 62 78 62Q169 62 188 75Q194 77 435 324L444 334L439 347Q437 351 373 492L313 624H268H246Q220 624 212 632Q210 636 210 642Q210 655 215 669T227 684Q230 686 247 686Q295 684 398 684Q438 684 472 684T527 685T551 686Q567 686 572 671Q572 667 568 651Q563 631 558 628T523 624T492 623H488L526 540Q563 457 564 457Q564 456 574 466T604 496T645 537L724 619Q716 622 677 624H673Q645 624 645 640Q645 660 654 678Q659 683 666 686L704 685Q728 684 813 684Q847 684 873 684T913 685T931 686",
          119936: "97 624H73Q40 624 40 640Q40 660 49 678Q57 686 77 686Q122 684 228 684Q269 684 304 684T360 685T385 686Q406 686 406 668Q406 662 403 653Q398 631 393 628T361 624H353Q321 624 321 623T376 491T432 360L448 377Q465 394 493 424T553 490L673 620Q662 624 630 624Q606 624 606 640Q608 678 623 684Q627 686 634 686Q638 686 671 685T755 684Q777 684 805 685T841 686Q861 686 868 683T876 669Q876 664 873 652Q868 631 863 628T829 624Q764 622 747 611Q727 590 590 441L437 275L411 170Q385 65 384 64Q384 62 429 62H453Q473 62 478 60T487 48Q488 44 484 29Q479 6 473 3Q468 0 454 0Q450 0 436 0T386 1T294 2Q220 2 181 1T138 0Q121 0 116 15Q120 54 133 60Q137 62 187 62H236L289 275L142 624H97",
          119937: "223 430Q192 430 192 448Q192 450 225 561T261 677Q265 683 270 684Q273 686 534 686Q796 686 797 685Q805 682 805 673Q805 668 804 661T800 648T798 641Q796 637 531 352L266 67L329 66H364Q412 66 446 70T523 96T596 157Q617 186 630 220T649 273T663 297Q667 299 684 299H688Q715 299 715 281Q715 278 673 145T628 8Q626 4 617 0H348Q289 0 221 0T139 -1Q112 -1 99 -1T78 1T69 5T68 12Q68 16 71 31T77 49L84 57Q91 65 104 79T133 110T170 151T213 196L610 624H540Q533 624 514 624T488 624T467 623T443 620T422 616T398 609T373 600Q292 560 255 449Q251 436 246 433T223 430",
          119938: "222 -8Q140 -8 89 34T38 158Q38 191 48 227Q72 329 151 390T327 452Q361 452 385 443T421 425T433 416H434L441 421Q448 426 460 430T486 435Q509 435 523 422T538 386Q538 380 522 315T488 179T467 93Q466 87 466 72Q466 42 483 42Q505 42 521 75Q531 94 541 134Q546 155 550 158T571 162H576H587Q607 162 607 148Q606 142 604 132T590 94T566 47T528 9T474 -8Q396 -8 358 40Q295 -8 222 -8ZM404 351Q383 401 324 401Q300 401 270 385T221 330Q206 296 186 220Q166 136 166 106Q166 72 184 58T228 43Q256 43 284 57T328 84T343 103Q343 106 374 228L404 351",
          119939: "220 -8Q142 -8 94 35T45 155V167Q45 187 52 218T104 426L153 622H149Q148 622 144 622T134 623T122 624T111 624T101 624T96 625Q84 628 84 642Q84 647 88 661T94 679Q98 684 109 685T185 690Q258 694 272 694Q289 694 293 679Q293 676 263 553L232 429L244 434Q256 440 281 446T331 452Q417 452 465 407T513 285Q513 235 494 184T439 90T346 20T220 -8ZM385 337Q385 400 318 400Q269 400 226 360Q214 349 211 341T191 268Q162 149 162 113Q162 44 226 44Q269 44 299 76T339 135T362 215Q364 222 365 226Q385 303 385 337",
          119940: "362 325Q362 344 371 361T390 386L399 394Q390 401 355 401Q276 401 231 338Q207 301 189 230T170 122Q170 43 264 43Q392 43 457 105Q472 120 480 117Q486 114 497 102T509 83Q509 79 502 70T477 47T432 21T360 1T259 -8Q194 -8 148 9T80 54T49 109T40 167Q40 280 129 365T352 451Q390 451 396 450Q448 442 473 416T499 358T477 302T421 274H417Q393 274 378 288T362 325",
          119941: "222 -8Q140 -8 89 34T38 158Q38 220 68 285T151 391Q230 452 329 452Q382 452 416 428L422 424Q423 424 447 523L472 622H468Q467 622 463 622T453 623T441 624T430 624T420 624T415 625Q403 628 403 642Q403 647 407 661T413 679Q417 684 428 685T504 690Q577 694 591 694Q608 694 612 679L467 91Q466 87 466 72Q466 43 483 43Q518 43 541 134Q546 155 550 158T571 162H576H587Q607 162 607 148Q606 142 604 132T590 94T566 47T528 9T474 -8Q396 -8 358 40Q295 -8 222 -8ZM404 351Q383 401 324 401Q300 401 270 385T221 330Q206 296 186 220Q166 136 166 106Q166 72 184 58T228 43Q256 43 284 57T328 84T343 103Q343 106 374 228L404 351",
          119942: "260 -8Q196 -8 151 9T83 54T52 111T42 169Q42 188 44 210Q50 240 58 266Q127 434 335 451L338 452Q342 452 345 452Q347 452 353 452T363 451Q426 451 464 424T502 352Q502 289 442 250Q381 211 222 211H184Q184 210 181 196T175 162T171 126Q171 43 264 43Q391 43 457 105Q472 120 480 117Q486 114 497 102T509 83Q509 79 502 70T477 47T432 21T360 1T260 -8ZM237 262Q427 266 427 349Q427 368 409 384T354 401Q316 401 287 388T242 354T216 314T202 278L197 263Q197 262 237 262",
          119943: "584 444Q597 439 597 426Q597 409 586 387Q580 382 505 382H434V380Q432 378 421 314T395 162T368 30Q324 -164 203 -199Q194 -201 175 -201Q123 -201 94 -177T64 -117T88 -58T145 -33Q169 -33 184 -47T200 -84Q200 -122 166 -150L174 -151H185Q202 -148 217 -112Q222 -94 240 9Q246 40 262 132T293 303T307 382H247H210Q190 382 182 385T173 400Q177 436 189 442Q193 444 256 444H318L319 446Q337 565 355 602Q373 640 404 664T458 694T503 701Q569 701 596 676T624 617Q624 581 599 557T544 533Q520 533 504 547T488 585Q488 596 491 606T499 624T508 637T516 646L520 650Q515 650 509 651Q459 651 459 561V554L458 518L452 484Q446 448 445 447V444H584",
          119944: "227 0Q142 0 93 43T43 166Q43 207 58 252T104 341T188 414T310 451L313 452Q316 452 319 452Q321 452 326 452T335 451Q367 451 390 443T425 425L436 416L443 421Q450 426 462 430T488 435Q511 435 525 422T540 386Q540 378 483 151T424 -82Q401 -139 335 -170T167 -202Q72 -202 36 -183T0 -125Q0 -90 24 -67T81 -43Q103 -43 119 -56T136 -99Q133 -124 114 -149L123 -150H183Q222 -150 254 -127T299 -74Q300 -71 306 -47T318 -1T324 23Q323 23 310 18T274 6T227 0ZM407 353Q406 354 404 358T400 365T395 371T388 379T381 385T371 391T360 396T346 400T329 401Q300 401 277 389T240 355T219 317T205 280Q171 148 171 109Q171 77 190 64T235 51T296 67Q322 82 337 98L345 106L407 353",
          119945: "477 56Q477 48 479 46T490 43Q522 45 544 75T577 140Q582 156 585 159T605 162H611H622Q642 162 642 148Q642 138 632 114T602 62T550 13T478 -8Q429 -8 394 17T358 83Q358 95 395 199T433 350Q433 400 394 400H388H383Q335 400 291 363Q256 332 236 298Q233 293 202 170T169 40Q160 18 141 5T99 -8Q70 -8 58 9T45 39Q45 51 116 336L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 144 685T220 690Q293 694 307 694Q324 694 328 679Q328 672 294 540Q286 507 278 473T264 420L260 403Q260 400 269 408Q327 451 393 451H401H410Q425 451 439 450T476 442T515 424T544 391T556 337Q556 286 517 179T477 56",
          119946: "205 615Q205 646 229 670T283 694Q310 694 324 679T339 641Q339 610 315 586T258 562Q235 562 220 577T205 615ZM24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
          119947: "321 616Q321 648 346 671T400 694Q425 694 440 680T456 640Q456 609 431 586T376 562Q353 562 337 577T321 616ZM297 360T297 373T294 392T288 400T278 401H276Q241 399 210 372T158 303Q151 287 148 285T129 282H123H116Q102 282 97 284T92 298Q96 331 153 391T279 451Q357 451 388 422T420 354V339L371 142Q363 111 353 71T339 13T329 -30T318 -64T308 -88T296 -109T283 -125T264 -142Q190 -202 88 -202Q44 -202 16 -181T-12 -125Q-12 -93 11 -68T68 -43Q92 -43 108 -58T124 -93Q124 -121 106 -144Q101 -150 103 -150Q120 -150 147 -128T191 -64Q194 -57 242 136T294 345Q297 360 297 373",
          119948: "99 -8Q71 -8 58 9T45 39Q45 51 116 336L188 622H184Q183 622 179 622T169 623T157 624T146 624T136 624T131 625Q119 628 119 642Q119 647 123 661T129 679Q133 684 144 685T220 690Q293 694 307 694Q324 694 328 679Q328 674 280 482Q231 290 231 287Q231 285 234 286Q259 302 294 334T356 390T420 433T493 452Q528 452 546 427T564 364Q564 308 538 282T480 256Q456 256 441 269T425 308Q425 339 444 359T483 384L502 389Q502 395 496 398Q493 400 483 400Q465 400 449 395T409 374T373 347T323 305T268 257Q274 256 282 256Q312 251 329 247T371 232T411 202Q431 181 431 146Q431 132 427 110T422 73Q422 44 440 44H442Q462 44 478 64T502 102T514 141Q518 157 522 159T547 162H558Q578 162 578 148Q578 118 537 56T440 -7H432Q374 -7 337 21T299 94Q299 103 301 116T304 139Q304 164 281 181T235 202L212 206H211Q176 47 160 24Q137 -8 99 -8",
          119949: "157 -8Q138 -8 118 -4T77 11T41 42T27 91V106L156 622H152Q151 622 147 622T137 623T125 624T114 624T104 624T99 625Q87 628 87 642Q87 647 91 661T97 679Q101 684 112 685T188 690Q261 694 275 694Q292 694 296 679L151 91Q150 85 150 71Q150 42 167 42Q186 42 205 75Q216 96 225 134Q230 155 234 158T255 162H260H271Q291 162 291 148Q290 145 289 140T283 118T271 87T254 54T229 23T197 1T157 -8",
          119950: "24 296Q25 302 27 312T41 350T65 397T104 435T159 452Q203 452 234 435Q268 419 285 384L295 392Q305 401 317 410T349 429T389 445Q411 451 446 451Q560 451 592 383Q593 380 594 379L595 375L604 384Q675 452 762 452Q893 452 916 367Q918 356 918 334Q918 285 881 183T841 66Q838 43 849 43Q876 43 901 69T940 138Q945 156 949 159T969 162H975H986Q1006 162 1006 148Q1006 138 996 115T966 63T914 13T841 -8Q794 -8 758 16T721 82Q721 96 758 199T796 351Q796 401 753 401Q702 401 662 369T599 298Q597 294 567 172T533 40Q525 22 506 7T462 -8Q435 -8 422 8T409 39Q409 48 425 114T458 248T476 320Q478 330 478 348T474 377T462 393T449 399T433 400H428Q380 400 336 363Q301 332 281 298Q278 293 247 170T214 40Q206 22 187 7T143 -8T104 7T90 39Q90 47 108 124T146 274L164 347Q166 355 166 372Q166 401 149 401Q129 401 115 379T89 306Q84 288 80 285T55 282H44Q24 282 24 296",
          119951: "24 296Q25 302 27 312T41 350T65 397T104 435T159 452Q203 452 234 435Q268 419 285 384L293 391Q363 452 454 452Q575 446 597 367Q599 356 599 334Q599 285 562 183T522 66Q519 43 530 43Q557 43 582 69T621 138Q626 156 630 159T650 162H656H667Q687 162 687 148Q687 138 677 115T647 63T595 13T522 -8Q475 -8 439 16T402 82Q402 96 439 199T477 351Q477 401 434 401Q421 401 409 398Q341 388 285 305L278 295L247 170Q216 46 214 40Q206 22 187 7T143 -8T104 7T90 39Q90 47 108 124T146 274L164 347Q166 355 166 372Q166 401 149 401Q129 401 115 379T89 306Q84 288 80 285T55 282H44Q24 282 24 296",
          119952: "254 -8Q191 -8 146 9T80 54T49 111T39 169Q39 206 53 247T96 329T176 402T292 446Q317 451 336 451L344 452Q353 452 359 452Q457 452 516 408T576 279Q576 169 488 81T254 -8ZM349 400Q321 400 287 385T231 338Q206 301 188 228T170 126Q170 99 178 83Q198 44 260 44Q367 44 409 157Q419 185 432 238T445 317Q445 336 443 348Q435 372 416 384T384 398T349 400",
          119953: "24 296Q25 302 27 312T41 350T65 397T103 435T157 452Q235 452 273 404Q336 452 409 452Q434 452 458 448T507 432T550 402T581 354T593 285Q593 221 564 159T480 53Q401 -8 302 -8Q290 -8 279 -7T259 -3T242 3T228 9T218 14T212 18L209 20Q208 19 190 -55T171 -131T198 -132H213Q240 -132 240 -150Q237 -187 223 -192Q219 -194 212 -194Q208 -194 176 -193T95 -192Q48 -192 24 -193T-3 -194Q-11 -194 -16 -190T-22 -182T-23 -176Q-20 -142 -7 -134Q-3 -132 20 -132H44L164 354Q165 357 165 372Q165 401 148 401Q113 401 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296ZM465 339Q465 373 447 387T403 401Q375 401 347 387T303 360T288 341Q288 338 257 216L227 93Q248 43 306 43Q332 43 361 59T410 115Q425 147 445 224Q465 309 465 339",
          119954: "38 159Q38 209 58 260T113 355T205 425T327 452Q338 452 348 451T366 449T382 444T394 440T405 434T414 429T422 423T429 418Q440 429 481 440T533 452Q540 452 545 447T550 437Q550 432 481 152Q410 -130 410 -131T437 -132H452Q479 -132 479 -150Q476 -187 462 -192Q458 -194 451 -194Q447 -194 414 -193T330 -192Q277 -192 249 -193T217 -194Q202 -194 197 -179Q197 -175 201 -159Q206 -139 211 -136T243 -132H283L319 15L307 10Q295 4 270 -2T220 -8Q134 -8 86 37T38 159ZM402 353Q402 358 395 368T369 390T324 401Q301 401 282 394T249 369T226 338T208 297T196 258T186 218Q166 141 166 107Q166 44 229 44Q265 44 294 61T337 95Q341 100 371 222T402 353",
          119955: "24 296Q24 298 28 313T42 352T67 398T104 436T154 452Q198 452 230 437T273 404L282 411Q334 452 393 452Q441 452 470 423T500 350Q500 301 473 279T418 256Q395 256 379 270T363 308Q363 366 424 386Q424 388 420 391T405 398T385 401Q363 401 343 390Q321 380 289 341L252 192Q214 42 212 39Q190 -8 142 -8Q117 -8 103 7T89 39Q89 52 127 202T165 369Q165 402 148 402Q139 402 128 393T110 369Q100 348 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296",
          119956: "140 290Q140 311 148 336T176 388T235 433T326 451H336Q355 451 373 449T418 439T460 412T476 363Q476 333 456 311T406 289Q384 289 371 302T357 335Q357 351 364 364T379 384L386 391Q386 392 381 394T362 398T330 400Q299 400 278 393T247 373T235 352T232 335Q232 322 242 312Q258 299 315 290T403 260Q457 224 457 167Q457 152 453 134T435 90T397 43T330 7T229 -8Q133 -8 95 22T57 91Q57 127 81 152T139 177Q161 177 177 164T194 121Q189 80 153 56Q179 43 236 43Q275 43 303 52T343 75T361 101T366 124Q366 148 338 161T272 180T232 186Q187 198 164 227T140 290",
          119957: "82 382H55Q21 382 21 399Q21 422 33 439Q39 444 93 444H144L162 517Q163 522 167 541T174 567T181 589T192 611T206 627T226 639T253 643Q276 643 291 630T306 594Q306 586 288 514Q284 499 280 481T273 454L271 445Q271 444 317 444Q322 444 331 444T345 445Q377 445 377 428Q377 408 368 390Q360 382 341 382H306H255Q182 86 182 75Q182 43 201 43H204Q242 46 279 81Q298 101 309 119T323 145T330 157T350 162H356H363Q377 162 382 160T387 146Q385 136 372 114T337 64T275 14T192 -7Q131 -7 95 19T59 90V105L128 381Q128 382 82 382",
          119958: "189 389Q189 397 187 399T176 401Q150 399 126 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 307 35 331T65 383T117 431T187 452Q237 452 272 427T308 362Q308 347 273 254T238 111Q238 43 291 43Q319 43 344 58T380 86T391 103T426 247T464 396Q472 414 491 429T535 444T574 429T588 397Q588 390 570 315T534 168L516 97Q514 89 514 72Q514 42 531 42Q544 42 556 56Q574 76 589 134Q594 155 598 158T619 162H624H635Q655 162 655 148Q654 142 652 132T638 94T614 47T575 9T520 -8Q509 -8 498 -7T478 -3T461 2T446 8T434 16T424 23T416 29T410 35T406 39L405 41L397 34Q347 -7 288 -7H281Q148 -7 122 78Q116 95 116 125V136Q116 174 152 273T189 389",
          119959: "380 367Q380 397 406 425T465 453Q493 453 516 430T540 357Q540 314 524 250T467 115T373 13Q338 -8 292 -8Q218 -8 167 23T116 129Q116 178 152 275T189 388Q189 396 187 398T176 401Q148 398 125 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 330T64 382T116 431T189 452Q231 452 269 429T308 362Q308 346 273 255T238 114Q238 43 306 43Q336 43 363 65T407 118T437 182T456 239T462 268Q462 290 417 315Q380 335 380 367",
          119960: "636 367Q636 400 664 426T719 453Q748 453 772 431T796 357Q796 321 782 256T727 112T633 6Q604 -8 567 -8Q466 -8 415 43Q414 42 410 38T403 31T396 25T388 18T378 11T367 5T355 0T340 -4T324 -7T306 -8Q249 -8 209 5T151 40T125 84T117 129Q117 176 153 274T190 388Q190 408 158 396Q112 376 90 306Q85 288 81 285T61 282H55H44Q24 282 24 296Q24 305 34 328T63 380T114 430T187 452Q240 452 274 427T309 362Q309 346 275 255T240 117Q240 43 317 43Q325 43 333 45T347 50T359 57T369 66T377 75T383 83T388 90L390 95Q390 99 389 110T387 129Q387 139 391 167Q393 177 419 282T448 396Q456 414 475 429T519 444Q546 444 559 428T572 397Q572 384 542 265T511 114Q511 43 579 43Q608 43 633 66T673 122T699 188T714 244L718 267Q718 291 673 315Q636 335 636 367",
          119961: "74 282H63Q43 282 43 296Q43 298 45 307T56 332T76 365T110 401T159 433Q200 451 233 451H236Q273 451 282 450Q358 437 382 400L392 410Q434 452 483 452Q538 452 568 421T599 346Q599 303 573 280T517 256Q494 256 478 270T462 308Q462 343 488 367Q501 377 520 385Q520 386 516 389T502 396T480 400T462 398Q429 383 415 341Q354 116 354 80T405 44Q449 44 485 74T535 142Q539 156 542 159T562 162H568H579Q599 162 599 148Q599 135 586 111T550 60T485 12T397 -8Q313 -8 266 35L258 44Q215 -7 161 -7H156Q99 -7 71 25T43 95Q43 143 70 165T125 188Q148 188 164 174T180 136Q180 101 154 77Q141 67 122 59Q124 54 136 49T161 43Q183 43 200 61T226 103Q287 328 287 364T236 400Q200 400 164 377T107 302Q103 288 100 285T80 282H74",
          119962: "206 -150Q240 -150 268 -134T314 -95T344 -48T362 -7T367 14Q339 -7 280 -7Q230 -7 195 5T144 39T122 79T115 122Q115 175 152 274T189 388Q189 396 187 398T176 401Q148 398 125 372T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 329T64 381T116 431T188 452Q239 452 273 427T308 361Q308 347 273 253T237 109Q237 43 291 43T388 98Q388 99 425 246T463 396Q471 414 490 429T534 444T573 430T587 399Q587 386 537 186T483 -25Q461 -84 410 -126T296 -188Q248 -202 204 -202Q127 -202 96 -175T64 -114Q64 -82 86 -57T144 -31Q169 -31 184 -45T199 -83Q199 -89 198 -94T196 -104T193 -113T189 -120T184 -128T179 -134T173 -141T168 -147Q189 -150 206 -150",
          119963: "66 -8H60Q34 -8 34 5Q34 9 42 22T70 59T115 110Q162 156 255 229T381 332L389 339H381Q348 332 298 329T212 325T172 321Q168 318 151 318H146Q116 318 116 332Q116 334 118 342Q128 374 154 402Q205 452 265 452Q304 452 352 422T426 392Q441 392 462 421T485 451T508 452H518Q539 452 539 438Q539 431 516 401T458 334Q412 289 312 210Q229 146 191 111L183 103H195Q203 103 213 104T240 107T268 110Q301 114 337 116T391 119T428 123T455 134T469 157Q473 166 495 166Q521 166 525 161Q532 156 528 141Q510 81 456 37T337 -7Q297 -7 251 22T177 52Q154 52 134 38T100 8L88 -7Q86 -8 66 -8",
          119964: "76 60Q83 29 135 29Q190 29 264 81Q280 93 280 95T277 99T265 106T248 118Q189 166 189 237Q189 307 245 388Q267 421 299 436Q336 455 386 455Q488 455 550 403L559 395L571 405Q727 544 944 679L957 687L966 701Q968 704 970 707T973 712T975 714T978 716T982 717T989 717H995Q1004 717 1007 717T1013 714T1016 708Q1016 705 829 403L636 92L630 83Q659 93 685 110T728 143L745 158Q758 158 752 138L748 127L740 119Q676 58 605 42L593 22Q590 17 587 12T583 6T579 2T573 0T564 0H530H484Q480 3 480 8Q480 15 489 26T498 39T497 40Q477 40 423 49T327 74L316 78L302 68Q200 -8 121 -8Q85 -8 60 7T35 53T60 113T123 144Q144 144 153 132T162 106Q162 89 143 75T99 61Q90 61 76 65V60ZM904 614L905 615Q901 615 840 573T700 469T581 369L587 359Q600 340 608 315T618 273T622 238T624 216L764 414Q904 612 904 614ZM525 363Q493 405 379 418H375Q342 418 309 378Q251 300 251 234Q251 174 306 137Q318 128 322 131Q323 132 329 139Q351 161 362 180Q430 273 509 348L525 363ZM579 205Q579 245 571 278T556 323T546 337L521 311Q461 248 422 196T362 121L353 111Q427 85 499 79Q517 77 520 77L525 76L549 111Q551 114 556 121T563 131T568 138T573 147T575 157T577 169T578 185T579 205",
          119966: "367 89Q367 84 353 77T334 70Q325 70 312 83T298 120Q298 169 364 233T496 298Q538 298 563 275T588 220V213Q588 132 501 53T306 -26Q251 -26 211 6T170 114Q171 148 181 184T205 248T232 298T255 334T265 349T246 350Q127 350 77 390T26 480Q26 533 71 581T178 656T295 683Q312 683 312 676Q312 674 311 672L302 660Q294 648 292 647L286 646Q280 646 276 646Q197 641 145 583T93 476Q93 387 265 387Q271 387 277 387T287 388T292 388T313 414T373 483T451 562Q618 712 732 727Q733 727 740 727T753 728Q790 727 804 708T819 665Q819 643 810 617T773 553T699 481T572 414T385 361Q381 361 367 341Q247 172 247 86Q247 11 325 11Q404 11 465 95Q518 165 528 208Q529 212 529 220Q529 237 518 249T480 261Q431 261 387 209T343 126Q343 111 355 101T367 89ZM777 658Q777 691 738 691Q704 691 658 662T570 590T491 504T432 432T410 400H411Q416 400 440 405T505 423T589 455T675 506T743 576Q777 627 777 658",
          119967: "251 272Q199 272 168 298T136 374Q136 432 175 496T267 603Q321 645 395 676T552 708Q610 708 655 694T724 659T763 618T784 584L790 569Q792 569 800 572T819 576T840 578Q855 578 855 571Q855 566 846 554T829 541Q824 541 817 539T804 533T799 529Q802 517 802 483Q802 376 742 256T585 53T392 -31Q353 -31 300 -7L289 -2L277 -6Q242 -17 192 -17Q141 -17 113 -13T77 -3T68 14Q68 20 73 28T93 45T131 58Q152 62 197 62Q241 62 272 48L282 44Q308 65 334 93Q380 145 467 266T622 454Q644 476 664 493T694 517T720 534T740 547Q699 671 540 671Q461 671 385 625T276 534Q265 520 251 499T219 438T202 368Q202 309 267 309Q325 309 396 383T491 545Q492 548 493 552Q494 558 496 559T511 564Q513 565 514 565Q523 568 527 568Q534 568 534 560Q534 554 529 537Q507 442 420 357T251 272ZM332 20Q332 19 341 15T368 6T400 2Q425 2 457 13T531 49T614 125T690 248Q750 376 750 476V490L738 479Q698 436 646 366T554 239T455 121T332 20ZM226 20Q226 25 186 25Q181 25 174 24H166Q161 24 158 23H152Q170 21 197 21Q205 21 213 21T223 20H226",
          119970: "206 318L249 320Q249 327 259 352T282 399Q312 447 366 510T465 610Q588 717 661 717Q695 717 716 701T738 653T704 577Q663 522 610 474T512 397T424 346T359 315T333 306Q331 304 327 290T323 267Q323 229 368 229Q402 229 439 254T505 312T571 382T638 435Q642 437 644 437Q658 437 658 409Q655 403 647 399T624 379T595 326Q583 296 564 267T523 179Q504 126 483 91T423 27Q335 -37 231 -37Q191 -37 157 -30T95 -2T67 53Q67 89 94 123T159 158Q180 158 190 146T200 119Q200 102 178 89T136 75Q128 75 120 78T110 81Q105 81 105 62Q105 38 129 24T180 5T238 1H244Q282 1 319 32Q349 55 371 85T436 190L465 239Q413 192 354 192Q300 192 274 217T245 276Q245 284 242 284Q220 280 187 280Q106 280 59 315T12 409Q12 457 43 508T118 597T210 659T295 683Q308 683 308 675Q308 670 299 658T282 646Q266 646 240 633Q182 606 118 511Q76 448 76 400Q76 368 105 343T206 318ZM677 660Q677 680 646 680Q616 680 565 629Q537 601 514 571Q493 544 455 492T389 398T360 355Q366 357 386 367Q463 406 534 473T641 591T677 660",
          119973: "829 148Q845 148 845 143T841 130T823 109T788 83T730 54T644 22Q637 20 634 19T627 16T622 13T618 10T612 3T604 -6Q510 -112 396 -203T201 -312Q190 -314 171 -314H166Q156 -314 147 -312T123 -304T101 -283T92 -245Q92 -203 117 -160T175 -93Q214 -65 280 -41T390 -6T509 22L532 27L547 47Q673 219 673 225L665 228Q657 231 648 235T627 249T606 270T591 300T584 341Q584 389 614 447T686 544Q735 588 799 615T959 667T1108 713Q1118 717 1119 717Q1125 717 1129 705T1133 689Q1133 686 1115 673Q1051 627 1001 579T918 481T867 403T828 328T805 277Q802 271 801 267T798 261T798 259Q849 270 900 317Q956 371 956 421Q956 438 953 457T950 480Q950 481 950 482L951 484Q953 487 966 492T985 498Q989 498 994 473Q1000 441 1000 423Q1000 362 934 302T790 223L775 220L767 207Q757 191 731 158T685 98T662 63Q662 61 690 70T755 99T811 142L816 148H829ZM646 332Q646 308 659 291T685 268L698 263L735 320Q828 465 865 511Q923 582 1003 643L1005 645Q1004 645 924 620Q775 572 716 492Q646 401 646 332ZM184 -278Q233 -278 311 -212T444 -80L498 -15H496Q468 -20 424 -30T293 -70T174 -133Q167 -140 158 -153T138 -190T127 -232Q127 -278 184 -278",
          119974: "521 506Q521 493 549 493Q608 493 660 527Q667 531 690 555L736 604Q750 619 777 646T825 694T848 716T852 717Q857 717 860 711T865 697L866 690Q866 687 812 615Q654 404 654 401Q655 401 656 401T659 402T665 403T680 404Q718 404 734 374Q735 370 743 376Q745 377 752 382Q806 416 852 466T933 563T982 623Q1028 666 1075 686T1155 706Q1165 706 1173 705T1186 703T1194 699T1199 695T1201 692T1202 688V687L1204 677Q1204 667 1191 670Q1189 670 1183 670T1174 671Q1137 671 1086 643T1001 564Q970 517 899 449T749 339L739 333L736 322Q730 295 703 253T652 165T628 77Q628 21 681 21Q692 21 698 23Q751 46 817 134L827 148H844Q861 148 864 146Q869 140 859 127Q818 75 761 29T665 -17Q649 -17 633 -12T598 4T569 40T558 100Q558 128 563 152T585 205T609 245T643 294Q647 300 645 300Q633 297 615 297Q607 297 600 298T589 300T584 301Q581 301 569 284T536 236T488 171T418 97T331 28Q233 -37 155 -37Q104 -37 68 -17T29 44Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q68 82 68 59Q68 37 85 23T123 5T167 0Q203 0 238 21T311 85T382 174T468 288T563 410Q576 426 588 440T607 462T615 472L605 468Q568 456 533 456H527Q490 456 463 483Q451 496 451 508T468 545T486 581Q486 593 465 593Q448 593 425 568T384 518T364 493Q364 492 347 492Q326 492 326 499T351 537T414 599T477 630Q509 630 528 615T547 576Q547 556 534 533T521 506ZM675 357Q675 368 665 368Q656 368 644 363Q631 355 616 333H628Q640 334 672 341Q675 354 675 357",
          119977: "764 513Q764 482 772 423T780 330Q780 304 778 285T775 256T773 245Q778 252 826 328T932 484T1042 617Q1077 652 1114 678T1173 715T1200 726Q1208 726 1208 717Q1208 711 1206 695L1203 679L1199 675Q1197 675 1187 670T1161 657T1133 639Q1050 583 959 456Q906 381 858 307T779 179T725 83T691 18T679 -6Q677 -8 660 -8H656Q639 -8 639 -1Q639 4 646 17Q685 93 685 173V196Q685 233 681 288T676 380Q676 438 687 487L664 454Q505 230 454 170Q366 64 290 14T163 -36H152Q87 -36 58 -11T29 46Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 59Q67 37 89 19T167 1Q187 1 197 3Q221 9 246 22T292 52T336 91T375 132T411 174T440 212T463 245T478 266Q779 695 784 698Q786 700 802 700H818Q824 694 824 692T809 668T779 604T764 513",
          119978: "259 -8Q230 -7 205 0T153 24T112 74T96 153Q96 254 174 379T374 599T607 707H621Q732 707 778 661Q805 634 805 598Q805 558 775 517T696 452L684 447V441Q684 378 626 273T484 97Q379 7 288 -7Q279 -8 259 -8ZM760 594Q760 670 608 670Q562 670 493 622T347 472Q174 240 174 131Q174 76 205 53T279 29Q294 29 306 32Q405 60 507 205Q592 325 616 401Q625 426 625 435Q625 436 621 436T603 440T569 449Q524 466 515 475Q513 477 513 481T525 496T541 508L548 504Q555 501 565 497T587 488T609 480T625 476Q627 476 626 481Q626 486 623 494T613 513T589 533T548 541Q495 541 413 454T286 281Q265 241 254 201T240 141T235 120Q234 118 217 111T197 104Q195 104 192 107T189 112Q190 125 193 147T220 231T280 348Q335 428 407 493T539 576Q548 578 563 578Q594 578 617 568T653 546T672 518T681 494T683 482Q683 481 684 481Q690 481 707 495T742 538T760 594",
          119979: "571 345Q571 384 612 418T687 452Q698 452 698 445Q698 436 679 417Q677 415 670 415Q650 412 633 389T615 350Q615 340 621 331T634 319T643 315L663 342Q751 462 817 536Q873 595 896 614L907 625Q843 680 701 680Q594 680 499 632T344 516Q317 486 296 449T267 384Q262 366 262 354Q262 332 276 316T326 299H327Q374 299 426 338Q481 376 537 456T597 598Q597 616 599 617Q601 619 614 624T630 630Q639 630 639 604V587V581Q639 519 597 456Q544 377 462 320T318 262Q278 262 250 282T222 350Q222 418 285 504Q360 597 480 656T702 716Q773 716 825 707T898 688T951 660Q962 670 985 685T1012 700Q1018 700 1022 690T1026 673Q1026 670 1019 664Q988 633 988 631Q988 630 999 618T1020 580T1031 522Q1031 471 1003 419T928 330Q854 275 765 264Q757 262 733 262H714L701 245Q615 121 473 42T218 -37Q159 -37 125 -15T90 46Q90 82 116 120T185 158Q203 158 213 147T224 121Q224 110 219 102Q198 75 159 75Q154 75 149 76T143 77T140 77Q137 72 137 53Q138 37 149 26T177 9T205 2T228 0Q313 0 419 74T602 257L620 281L614 285Q607 289 601 294T587 306T576 323T571 345ZM950 529Q950 576 943 576Q940 576 840 439T741 299H751Q804 300 845 334T924 438Q949 490 950 529",
          119980: "330 387Q330 331 402 331Q463 331 514 371T589 459T613 542Q613 559 608 570T598 588T593 596Q593 601 617 610Q632 617 636 616Q675 585 675 527Q675 464 629 409T516 324T387 294Q271 294 271 394V402Q271 438 292 478Q344 582 457 649T672 717Q765 717 825 675T885 548Q885 433 771 298T498 76Q493 73 491 72T486 69T484 67T485 66Q539 41 607 41Q655 41 703 71T780 139L787 148H804Q806 148 809 148Q826 149 826 140Q826 128 786 91T687 19T589 -16H576Q503 -16 414 20L396 27Q279 -17 192 -17Q130 -17 92 2T54 53Q54 92 107 123T222 155Q303 155 401 106L431 91L441 97Q476 118 527 157Q622 236 711 361T801 573Q801 591 795 607T775 641T732 668T660 679Q592 679 528 644T422 560T355 464T330 387ZM201 20Q232 20 267 27T322 40T342 49Q342 52 315 60T243 77T160 86Q150 88 144 88Q130 88 122 79T112 62L111 53Q111 20 201 20",
          119982: "346 463Q346 419 406 386T576 352H588L613 384L681 476Q767 594 842 651T973 708Q1016 708 1016 661Q1016 621 987 562T894 449Q802 375 696 338L682 334L665 312Q638 279 605 233T547 158T482 97Q418 46 332 5T158 -36Q87 -36 58 -11T29 48Q29 82 55 120T123 158Q144 158 154 146T164 119Q164 102 143 89T100 75Q92 75 86 76T77 80T72 82Q67 82 67 59Q67 28 98 14T166 0Q232 0 320 55T491 226Q530 279 551 305L558 314Q558 315 543 315Q417 321 353 365T289 460Q289 566 488 632Q578 662 660 665H679Q685 660 685 657T676 642Q670 633 666 629L664 628Q663 628 661 628T655 628Q606 628 546 615T426 568T350 486Q346 475 346 463ZM976 653Q976 671 959 671Q938 671 919 661T883 629T858 593T835 554Q832 548 830 545Q802 495 775 455T734 400T721 382L736 388Q876 449 946 568Q948 572 949 573Q976 622 976 653",
          119983: "354 350Q264 350 264 426Q264 442 265 448Q279 514 347 582T503 692T662 735Q719 735 774 714T882 672T983 651Q996 651 996 644Q996 639 977 612T954 581Q953 580 938 580Q909 582 884 587L869 591L870 587Q870 583 849 557T796 491T748 422Q729 391 692 313T620 188Q555 105 454 34T253 -37Q214 -37 181 -30T120 -2T92 53Q92 89 119 123T184 158Q205 158 215 146T225 119Q225 102 203 89T161 75Q153 75 145 78T135 81Q130 81 130 62Q130 39 153 24T204 5T267 0Q311 0 358 29T454 117T539 226T629 358T710 476Q726 496 744 516T778 551T807 577T828 595L836 601L785 623Q743 642 713 651T668 661T626 663Q564 663 509 644T418 596T356 535T317 475T305 431Q305 416 312 408Q323 388 369 388Q429 388 465 411T530 480Q557 526 557 565Q557 573 556 579T555 587T555 590Q555 591 568 600T584 611Q588 612 600 603Q622 581 622 549Q622 516 600 475T536 405Q454 350 354 350",
          119984: "55 377Q55 443 122 523T290 660T478 717Q533 717 575 689T618 594Q618 565 611 538T585 477T552 422T506 355T458 288L357 146Q307 68 307 31Q307 20 318 20Q326 20 331 21Q367 27 411 57T490 128L767 500L861 617H908H939Q953 617 956 616T960 609Q960 605 928 566T816 423T648 198Q587 113 571 86Q540 34 540 21Q540 20 545 20Q580 25 623 55T696 124Q702 132 704 133T722 134H739Q744 130 744 127T735 113Q713 80 655 38T548 -14Q527 -17 524 -17Q475 -17 473 47V63L462 55Q364 -17 302 -17Q235 -17 235 69Q235 88 239 105T248 135T268 171T292 205T328 251T369 304Q376 313 395 338T423 374T450 408T476 445T499 479T519 514T534 546T545 579T548 608Q548 647 522 663T460 680Q355 680 243 591T99 406Q97 399 97 383V377Q97 339 153 339Q169 339 175 340Q215 350 241 373T298 444Q333 496 349 535T367 588T374 603Q402 616 408 616Q416 616 416 608Q416 563 393 492T320 378Q233 302 140 302H132Q75 302 57 353Q55 361 55 377",
          119985: "540 717Q542 717 545 717Q562 717 562 710Q562 708 557 702T541 678T517 632T485 544T448 407Q447 405 443 388T438 366T433 345T427 321T420 299T411 274T400 250T387 223T372 197Q363 181 364 181L388 203Q476 284 527 354T620 490T718 612Q754 647 790 673T835 700Q839 700 842 691T848 672L850 662Q850 657 842 653Q803 630 768 600T699 527T653 467T610 405Q554 322 518 282T368 138Q307 84 273 51T231 9T218 -5L207 -17H175Q169 -11 169 -9Q169 -4 183 10Q227 56 258 120T302 234T330 350T356 445Q357 450 360 458L362 464Q317 434 276 434Q221 437 221 479Q221 498 240 521T259 552Q259 565 235 565Q209 565 174 546T105 482Q103 480 102 478T99 474T97 472T95 470T93 468T90 467T86 467T81 467H75Q56 467 56 475Q56 482 82 511T156 570T253 601Q289 601 311 590T334 557Q334 543 312 517T289 478Q289 471 297 471Q327 471 378 514Q384 519 390 531T412 571T451 632Q482 675 524 717H540",
          119986: "232 504Q232 492 263 492Q304 492 356 515L367 520L379 537Q443 632 515 705L527 717H543H552Q564 717 564 709Q564 705 562 703T554 694T540 677T518 643T488 589T448 504T398 385Q368 309 353 281L349 270L523 472L669 634Q726 695 737 706T757 717H765Q786 717 786 710Q786 704 776 691T738 627T675 497Q630 394 609 354T541 244Q456 120 449 111L447 107L448 108Q630 240 700 327Q734 368 788 463Q821 520 841 550T898 619T980 683Q1010 700 1018 700Q1020 700 1023 697T1026 692Q1026 688 1024 671T1020 652Q1018 650 1007 645T988 635Q940 609 902 565T842 477T781 374T699 272Q653 226 535 133Q423 47 373 -2L358 -17H342Q320 -17 320 -11Q320 -7 328 5T354 46T390 112Q416 161 439 217T488 326T564 453L589 490Q587 490 523 414T352 217T166 14Q138 -16 137 -16Q136 -17 120 -17Q106 -17 103 -16T99 -9Q99 -5 100 -3T106 3T116 14T132 35T154 72T184 129T222 212T270 327Q310 426 337 471L326 467Q278 455 243 455Q209 455 188 462T161 478T155 496Q155 508 176 533T198 576Q198 579 198 581T192 588T178 593Q151 593 100 519Q89 504 86 502T75 499H68Q46 499 46 506Q46 510 63 534T112 587T170 627Q178 629 195 629Q235 629 252 613T270 577Q270 556 251 532T232 504",
          119987: "351 351Q308 351 290 373T272 426Q272 487 329 566T478 688Q538 717 584 717Q635 717 681 696T745 620Q752 598 752 564T745 498L741 485Q742 486 769 516T825 573T889 634T962 689T1027 716Q1035 717 1060 717Q1083 716 1096 714T1120 705T1131 686Q1131 668 1109 647T1055 626Q1035 626 1026 638T1016 663Q1016 667 1020 679H1015Q971 671 886 589T728 413L688 360Q688 359 725 359H750Q762 359 766 357T770 348Q769 345 761 335T750 322Q748 321 704 321H660Q651 311 632 282T589 199T565 107Q565 25 653 20Q684 20 720 44T779 95T826 152T850 183L856 184Q861 184 865 184Q888 184 888 173Q883 163 845 117Q770 37 723 10T638 -17Q584 -14 554 17T523 101Q523 147 534 167L532 166Q530 164 526 160T518 153Q378 15 256 -15Q250 -16 226 -16Q161 -16 132 7T103 59Q103 93 129 125T194 158Q232 158 232 121Q233 118 233 113T221 96T188 77Q182 75 168 75T150 78V70Q150 43 178 32T241 20Q340 20 527 286L552 321H524Q489 321 489 330Q489 333 497 344T509 358Q511 359 545 359H579Q580 362 597 389T631 445T661 514T675 586Q675 637 645 658T572 680Q506 680 444 632T348 527T314 434Q314 388 361 388H364H366Q380 388 389 390T416 408T457 454Q487 497 505 536T526 594L529 613Q531 615 545 622T560 630Q568 630 573 613T578 577Q578 518 532 455Q504 413 453 382T351 351",
          119988: "155 280Q116 280 87 300T57 368Q57 409 87 466T192 589Q269 653 345 684T472 716Q572 716 613 675Q644 644 644 599Q644 585 643 574T637 550T629 529T616 505T600 481T578 450T554 416Q494 330 493 328L480 306Q466 278 466 256Q466 227 492 227H496Q514 227 534 234Q541 237 544 241T571 279L762 559Q777 579 792 595Q818 620 856 646T919 686T946 700Q951 700 955 692T959 677Q959 673 947 665T911 639T866 595Q816 538 749 408T640 225Q574 138 464 61T248 -17Q190 -17 144 1T98 62Q98 81 109 102T131 135Q156 156 183 158Q226 158 226 121Q226 111 224 107Q215 93 196 84T162 74Q154 74 147 77H144V70Q146 41 185 31T263 20Q363 20 493 175L507 192H504Q500 191 498 191Q484 189 476 189Q430 189 405 219T379 287Q379 294 379 299T382 311T385 322T391 335T398 347T408 363T420 379T434 399T450 422Q455 429 469 449T488 475T504 499T520 523T533 543T544 565T552 583T557 603T559 620Q559 680 467 680Q402 680 333 646T213 563T131 462T98 373Q98 343 119 330T169 317Q187 317 212 333Q242 354 291 423T352 555Q354 562 355 588Q355 612 356 612Q357 614 371 622T387 630Q391 630 397 623T409 597T415 556Q415 507 380 448T294 344Q216 280 155 280",
          119989: "221 428Q221 487 280 555T425 670T583 717H587Q641 717 665 695T689 646Q689 625 674 600T658 564Q658 550 671 541T695 530T710 528L718 539Q779 613 821 646Q894 707 964 707H970Q1010 707 1025 675Q1032 661 1032 645Q1032 626 1022 607Q1008 579 980 560T897 522Q867 512 836 505T788 496L771 493Q768 493 760 477T736 429T702 370Q700 367 698 363Q696 360 696 359H805Q809 355 809 350Q809 340 791 322Q789 321 728 321H668Q562 179 433 88L419 78L434 73Q505 54 554 54Q609 54 654 82T720 140H752Q758 134 758 132Q758 128 747 113Q711 67 657 32T552 -14Q540 -16 517 -16T480 -15T439 -3T375 27L354 38L338 30Q257 -8 191 -8H184Q154 -8 133 -5T103 1T88 10T83 19T83 29Q83 35 86 44T100 65T127 88T173 105T241 112Q286 112 342 99L360 95L372 105Q434 157 523 270L560 320Q560 321 533 321L507 322Q502 325 502 330Q502 339 521 358Q523 359 556 359H588L669 474L682 491Q676 492 665 494T647 498T632 503T614 510T596 521Q556 547 556 570Q556 585 579 618T603 663Q603 679 568 679Q510 679 452 650T354 581T288 500T262 431Q262 407 280 397T321 387Q331 387 341 390T360 398T376 409T390 423T400 435T409 447L414 454Q457 514 460 562Q460 575 461 576Q461 577 475 586T492 595Q496 595 503 588T514 572Q520 559 520 539Q520 473 452 412T308 351Q269 351 245 370T221 428ZM989 642Q989 667 953 671Q905 671 871 644Q853 632 832 604T799 554T787 531H788Q801 531 842 539T916 561Q989 592 989 642ZM198 29Q230 29 257 36T295 52L306 59Q306 63 259 73Q251 74 209 74Q177 74 158 66T134 48L130 40Q130 29 198 29",
          120068: "22 505Q22 563 94 624T271 685H280Q416 685 443 560Q447 535 447 504Q444 414 405 330L399 319L229 155Q233 154 241 153T253 150T265 145T281 135T301 119T328 93L357 64L402 92Q438 116 473 137L500 154V339Q500 528 495 593V601L559 649Q621 696 624 696L638 686L629 677Q599 650 593 638Q582 614 581 504Q580 490 580 443Q580 314 584 238Q584 235 584 224T584 210T585 199T586 187T588 176T591 164T595 152T601 137T609 121Q630 77 640 77Q661 77 703 101Q704 95 706 90L707 86V84L636 29Q618 15 601 2T574 -19T564 -25L500 121Q499 121 399 48L299 -26Q298 -26 291 -15T272 11T245 42T209 69T165 80Q120 80 58 43L48 37L40 42L32 48L122 117Q196 173 241 211Q319 280 343 327T368 447Q368 535 317 582Q264 633 199 633Q155 633 122 605T86 542Q86 518 133 467T181 387Q181 348 140 309Q113 281 73 260L64 255L50 265L59 273Q112 307 112 345Q112 363 90 387T45 441T22 505",
          120069: "48 506Q48 568 120 629T268 691Q362 691 425 594L431 585L441 594Q478 628 528 657T629 686Q665 686 687 670Q703 658 718 584T753 506Q756 505 763 505Q778 505 804 512L815 516L820 496Q820 494 808 490T774 476T732 454Q720 445 708 437L675 415L640 394L625 383Q626 382 635 382Q652 382 670 379T712 364T754 336T784 289T797 220Q797 172 776 122Q769 106 766 102T745 84Q654 11 619 -8T538 -27Q483 -27 387 10T249 47Q218 47 186 34T133 8T112 -5T104 7T97 21L196 82Q259 120 284 140Q333 181 351 214Q368 251 368 353Q368 588 228 620Q222 621 205 621Q160 621 139 596Q117 569 117 548Q117 526 162 470T208 387Q208 352 179 320T104 264Q88 256 86 256Q83 256 70 266L82 274Q134 309 134 343Q134 352 130 359Q118 377 100 401T72 439T56 470T48 506ZM453 528Q457 496 457 419L458 357L488 367Q554 390 622 425Q673 449 673 453L671 454Q669 456 665 460T657 473T648 498T639 541Q629 597 616 613Q599 633 567 633Q534 633 493 599Q471 577 457 540L453 528ZM713 176Q713 252 661 295T528 339Q512 339 494 336T466 330T455 325Q454 325 452 311T444 270T425 217L420 207L304 118L319 116Q381 111 475 74T602 37Q655 37 684 79T713 176",
          120071: "346 611Q300 611 261 604T194 584T144 555T107 519T82 481T65 443T55 410T50 383T48 367L37 372L27 378V393Q33 524 115 603Q160 648 230 666T365 685Q423 685 434 684Q745 653 745 405Q745 281 694 151L687 133L657 103Q524 -27 470 -27Q456 -27 331 18T157 64Q122 64 84 28Q67 9 57 -6L50 -16L43 -8L35 0Q35 3 46 22T83 74T141 133H154Q208 136 253 161T299 230Q299 259 277 290T232 348T209 392Q209 434 254 479T358 556L368 561L382 550Q382 549 381 548T377 545T371 541Q353 527 326 496T298 444Q298 430 343 365T389 277Q389 240 353 202T267 136L252 127Q304 118 400 83T513 47Q548 47 582 79T635 145Q671 208 671 323Q671 390 651 441T599 524T523 576T436 603T346 611",
          120072: "301 564Q240 564 203 507T165 361Q165 280 190 218T260 119T358 64T474 46Q491 46 499 47L511 48L628 106V80L499 -5Q498 -6 497 -7T494 -10T490 -12T485 -15T478 -17T468 -19T456 -21T439 -22T418 -23T392 -24Q252 -20 169 67T86 315Q86 409 124 491Q128 500 139 508Q211 560 272 591L293 601L325 585L338 594Q374 617 422 639T502 674L532 685Q533 685 540 663T557 614T574 581Q580 575 591 575Q600 575 616 580T634 585V564L623 559Q572 535 532 529L522 527Q491 547 442 627Q442 628 440 627T435 624T428 620Q410 610 405 597T399 559V553Q399 534 409 487Q419 431 427 369L476 400Q526 431 526 432Q531 426 537 420Q565 382 602 359Q611 353 610 352Q609 351 575 332T537 312Q536 312 505 335T463 358Q451 358 439 352T425 337Q394 243 263 223L251 221L243 229L235 236L245 239Q274 247 303 266Q320 277 325 290T330 336Q330 394 315 451T300 531Q300 549 303 561Q303 564 301 564",
          120073: "198 617Q177 617 159 609T128 587T106 557T91 524T82 494T76 472L75 463Q74 463 67 468T59 474Q59 488 63 510T80 564T114 622T170 667T253 686Q272 686 295 680Q330 672 384 645T468 598Q498 580 524 580Q549 580 595 626L612 643V616L599 599Q522 500 482 500Q466 500 435 514L420 521Q388 516 349 486T309 415Q309 396 323 366T352 315T367 294Q367 293 375 301T398 322T429 352L490 410Q537 355 542 332Q542 330 531 315T510 286L499 273Q479 313 449 313Q437 313 419 303T390 282L378 271L394 250Q444 183 470 129Q484 96 484 71Q484 -19 402 -86T223 -153H220Q175 -153 137 -120Q103 -89 103 -8Q103 12 106 40T109 96Q109 132 103 146T72 161Q46 161 16 143L14 154L11 165Q88 219 143 219Q163 219 177 197T192 127Q192 102 186 65T179 4Q179 -60 210 -88T272 -117Q319 -117 362 -75T405 33Q405 72 363 139T278 271T235 368Q235 385 243 404T264 439T292 472T324 500T353 522T374 538L382 543Q382 544 351 562T274 598T198 617",
          120074: "373 560Q373 543 378 509T388 448T394 421Q396 421 416 433T474 474T548 537L538 543Q481 570 452 628L487 659Q521 690 522 690L526 684Q529 677 535 667T551 646T575 625T607 608Q617 606 621 606Q644 606 660 622L664 600L497 455Q495 453 527 453H546Q628 453 665 407L666 406Q710 357 710 297Q710 196 631 109L621 98L577 69Q471 -7 452 -15Q413 -26 370 -26Q239 -26 155 59Q66 148 66 319Q66 442 113 505L191 552Q269 600 270 600H271Q273 600 280 596T293 589T299 586Q300 586 357 623Q413 659 415 659L426 649Q373 604 373 560ZM219 228Q305 262 305 329V343Q305 384 294 434T282 519Q282 562 287 567Q287 569 286 569Q222 556 191 520Q144 464 144 362Q144 213 228 128T420 42Q514 42 568 103T622 255V260Q622 320 578 357Q526 400 453 400Q434 400 410 396L399 394L400 378V372Q400 330 388 301T348 254T305 232T252 217Q245 215 242 214L234 213L226 220L219 228",
          120077: "194 601Q175 601 155 590T121 564T95 533T76 506L69 495Q55 503 55 507Q55 509 60 521Q87 586 132 636T222 686Q251 686 289 660T363 607T422 580Q442 580 466 588T506 604L522 612V591L487 574Q371 517 359 517H357Q332 522 280 561T194 601ZM383 39Q383 96 356 203T329 361Q329 364 329 370T330 378L331 388L339 399Q362 429 394 462T446 513T469 531Q470 531 477 527T484 521L474 509Q411 434 411 379Q411 341 434 223T458 82Q458 1 390 -69T239 -139Q191 -139 162 -123T123 -83T108 -30T101 23T88 64T52 80Q27 80 -4 64L-10 80Q-5 85 13 98T63 128T118 144Q149 144 163 129T179 93T182 38T187 -19Q199 -96 278 -96Q294 -96 309 -91T343 -73T372 -31T383 39",
          120078: "154 37Q219 41 219 142Q219 203 190 302T160 434Q160 445 172 472T209 534T269 602T354 657T460 680H472Q576 680 618 617V599Q618 578 615 555T608 517T602 501Q596 495 587 495Q586 495 586 499Q586 500 586 505T585 513Q567 628 415 628Q384 628 356 621T302 596T260 546T244 466Q244 416 258 377L261 367L276 382Q294 401 317 422T386 471T468 500Q500 500 518 477T544 422T554 386Q555 382 560 376T576 364T601 357Q612 357 623 361Q623 360 621 351T617 340L541 305L465 272Q469 271 476 270T488 266T502 260L512 255L519 242Q533 211 546 157T564 93Q584 53 617 53Q649 53 682 74V54L675 46Q646 17 612 -5T554 -27Q546 -27 538 -23T517 -9T494 28T478 91Q465 172 448 200T378 228Q337 228 289 207L288 196Q288 160 284 138Q283 125 262 98Q185 1 112 -24L102 -27L91 -25Q47 -13 17 31Q17 33 49 69L80 106Q111 37 154 37ZM421 434Q411 436 405 436Q370 436 336 407T275 337L267 325L271 313Q288 257 288 234Q289 234 395 276T502 319Q501 320 499 323T493 330T485 345T475 371Q473 378 468 388T449 416T421 434",
          120079: "251 231Q251 254 206 341T160 468Q160 529 238 605Q313 677 425 685L432 686Q440 686 445 686Q520 686 545 657T571 576Q571 548 568 517T564 480Q564 466 572 460T608 452H623V431L619 430Q618 430 611 428T591 423T566 417L516 404Q497 415 491 419T480 433T475 461Q475 470 477 498T480 546Q480 561 480 569T474 592T459 615T429 631T379 638Q322 638 283 606T239 526Q237 480 280 394Q319 310 320 268V250Q308 235 244 169L203 128H210Q215 128 256 112T357 80T466 64Q526 64 564 88T625 186L629 196Q643 187 644 186Q618 70 604 41Q577 -15 513 -24Q496 -26 476 -26Q418 -26 344 -3T211 45T133 69Q115 69 97 50T65 7T49 -20L45 -16Q41 -11 37 -6T33 0Q33 8 66 69T111 134Q251 156 251 231",
          120080: "687 578Q690 586 719 612T794 665T877 692Q909 692 926 670T953 614T973 570Q983 561 1000 560Q1023 560 1048 569V553L1034 546Q1003 528 972 504T933 466Q905 403 905 264Q905 205 909 172T920 126T940 91Q951 74 959 74T997 87L1027 100V79L956 27Q940 15 922 2T894 -19L885 -26Q883 -26 854 27L825 80V192Q826 314 830 341Q831 345 833 356Q840 398 844 404Q871 444 920 489L917 491Q914 493 911 495T903 501T898 508Q893 516 877 562T852 616Q840 628 818 628Q751 628 702 541L697 532L700 515Q708 467 708 419Q706 348 690 276T662 169T643 126L634 116Q626 105 611 87T581 51L522 -22L514 -15Q470 21 452 21Q431 21 394 -16L384 5L386 9L426 60Q449 87 460 95T486 104Q487 104 491 104T497 103Q514 99 541 81L559 69Q595 96 606 169T618 350Q618 486 598 543T517 601Q484 601 458 570T432 523Q432 516 434 492T436 443Q436 250 369 133L363 122L280 50Q207 -16 192 -27L182 -18Q136 26 106 26Q83 26 62 9T37 -16L27 0L33 10Q41 22 54 39T94 81T143 106Q178 106 225 62L235 53Q283 82 307 117Q352 190 352 359Q352 408 345 451T320 534T267 597T183 621Q159 621 147 617T120 598Q97 574 96 556Q96 528 143 469T191 377T161 311T102 262T70 245Q69 245 59 252T49 260L56 264Q63 268 73 275T94 291T111 312T118 338Q118 355 95 384T50 446T27 506Q31 567 101 626T255 686Q297 686 330 671T382 632T409 595T421 572V571L430 580Q454 610 496 634T588 659H590Q655 659 683 585L687 578",
          120081: "112 334Q112 356 70 410T27 497Q27 553 94 619T229 685Q230 685 236 685T246 686Q303 686 349 654Q373 636 392 607T419 558L426 538L454 576Q474 604 486 618T520 651T569 678T633 686Q668 684 687 673T713 651T730 609Q730 608 732 600T736 588T741 578T747 568T754 561T765 555T779 553Q789 553 817 562Q819 557 819 555V547L790 526Q743 492 730 479T712 447Q697 369 697 281Q697 166 726 108Q741 76 755 68Q759 66 767 66Q789 66 825 93V82Q825 71 822 70Q821 69 763 27T701 -18L692 -25L668 15Q662 25 650 45T635 70L627 85V107Q627 122 626 162T624 285Q624 381 632 398Q638 409 651 425T675 454T696 477T707 489H696Q683 490 679 492T669 507T653 551Q642 588 627 608T584 628Q572 628 560 625T538 616T519 602T502 586T486 568T473 549T463 532T454 517T448 504L445 497Q437 480 437 474Q437 472 439 461T444 421T446 348Q446 205 405 124Q396 105 392 100T368 78Q312 32 278 9T235 -18T214 -22Q191 -22 170 -10T139 12T129 25T160 66T192 105Q193 102 194 98T200 83T213 64T233 49T261 42Q303 42 339 90Q373 134 373 268Q373 397 339 493T235 618Q215 628 191 628Q155 628 126 604T97 548Q97 524 120 493T168 431T192 381Q192 346 164 318T86 260L70 250L54 266L63 272Q112 300 112 334",
          120082: "428 596Q412 596 386 595T350 593Q289 593 270 625Q267 632 267 640Q267 656 280 672T312 705T336 729H343Q351 729 351 728Q342 710 342 703Q342 683 382 676T493 662T604 643Q648 627 677 599T720 535T739 466T744 392Q744 317 732 260T696 166T659 116T621 83Q617 80 615 78Q485 -27 377 -27Q320 -25 272 -9T187 21T122 36H116Q65 36 29 -13L27 -15L12 0Q12 1 32 26T76 78T109 109Q145 123 166 150T187 207Q187 244 134 318T80 412Q80 454 112 498T176 566T213 590Q216 590 224 585L234 580L225 573Q216 566 207 557T188 536T172 511T165 484Q165 448 213 368T261 259Q261 241 252 219T228 179T200 146T176 122L167 112Q170 111 174 111Q188 110 233 91T339 55T453 37Q508 37 556 68T626 152Q655 219 655 328Q655 543 532 582Q484 596 428 596",
          120083: "112 339Q112 354 91 380T49 438T28 497Q28 565 95 628T242 692Q261 692 277 689T307 682T331 670T351 655T367 637T379 619T388 600T395 582T401 565T405 550Q409 554 422 570T453 603T500 641Q573 692 637 692Q656 692 670 686T692 672T705 647T713 618T718 584Q720 568 721 562T728 546T742 534T768 530Q776 531 782 532T791 535T796 536Q799 536 804 521Q801 519 789 513T764 499T738 480Q697 447 680 414Q677 407 677 396Q677 370 713 312T750 210Q750 125 686 57T560 -11Q540 -11 475 13L410 37V31Q410 -9 412 -50T417 -118T420 -150Q419 -150 373 -184T326 -218L305 -208Q305 -207 307 -196T314 -165T322 -116T328 -46T331 43V63L318 66Q270 80 250 80Q233 80 213 70Q183 57 138 -3L128 -16L118 5L125 20Q193 154 282 154Q309 154 331 146V287Q331 444 327 469Q321 522 301 560Q284 590 251 611T184 633Q146 633 119 607T92 550Q92 539 94 534Q100 516 143 460T186 386Q186 366 170 336T119 281Q102 264 70 250L49 260L56 266Q64 271 72 278T90 296T106 317T112 339ZM602 345Q602 357 608 371T622 397T642 421T661 441T678 456L686 462Q663 473 652 486T639 512T634 553Q631 594 624 608T593 631Q587 632 567 632Q539 632 497 600T416 497L410 484V122L467 103Q481 99 502 92T533 82T557 75T578 69T594 66T610 64Q647 64 672 87T697 144Q697 180 650 250T602 345",
          120084: "428 596Q412 596 386 595T350 593Q313 593 291 605T268 638Q268 644 269 648T274 658T284 669T301 689T326 718L336 729H343Q351 729 351 728Q342 710 342 703Q342 683 382 676T493 662T604 643Q744 592 744 398Q744 299 708 213T646 104L603 68L614 55Q670 -5 710 -5Q726 -5 744 1T772 14L781 20Q782 20 782 7V-6L771 -13Q673 -69 665 -69L647 -63Q552 -30 514 8H512Q509 8 500 3T471 -9T428 -23Q405 -27 377 -27Q305 -24 228 6T124 36Q69 36 27 -16Q23 -13 19 -8L11 0L27 20Q93 102 109 109Q145 123 166 150T187 207Q187 244 134 318T80 412Q80 454 112 498T176 566T213 590Q216 590 224 585L234 580L225 573Q216 566 207 557T188 536T172 511T165 484Q165 448 213 368T261 259Q261 241 252 219T228 179T200 146T176 122L167 112Q170 111 174 111Q188 110 233 91T339 55T453 37Q508 37 556 68T626 152Q655 219 655 328Q655 543 532 582Q484 596 428 596",
          120086: "750 276Q750 141 645 57T378 -27Q224 -27 146 67Q66 163 66 307Q66 361 80 412T127 515T217 609T356 676L388 684L420 692L442 681Q545 625 586 608T654 591Q688 591 710 609T737 646L742 665Q742 665 756 654L752 642Q736 594 706 566T621 515L607 510Q580 513 528 542T421 599T335 627Q272 627 214 569Q139 500 139 373Q139 308 159 247T217 136T316 56T455 26Q520 26 566 43T634 90T666 148T676 207Q676 264 649 297T580 338Q574 339 552 339Q516 339 442 325T327 310H324Q303 310 290 312T259 328T232 369Q230 375 230 390Q230 426 259 461Q286 488 338 507Q351 498 351 495L346 492Q342 490 339 488T330 482T320 473T312 462T305 447T303 428Q303 368 366 368Q393 368 487 388T613 409Q656 409 696 385T748 306Q750 294 750 276",
          120087: "289 686Q338 686 439 668T565 649Q606 649 641 672Q656 683 664 690T674 700L675 701Q676 698 676 692V681L641 636Q608 591 602 588Q577 575 528 575Q490 575 438 583L426 585L416 578Q335 520 335 465Q335 437 393 366T452 259Q452 226 406 171Q387 146 351 115L341 106L358 97Q438 58 475 58Q525 58 598 124L608 133Q617 119 617 118Q617 114 606 103Q513 0 448 -27L438 -25Q401 -19 337 14T234 48Q186 48 122 -3L112 -11L106 -3L101 5L110 15Q160 63 209 105L224 117H310Q384 163 384 210Q384 238 329 303T263 398Q262 400 262 404Q262 427 290 476T368 580Q383 596 381 596Q315 622 228 622Q159 622 118 593T76 516Q76 482 96 461T139 431L107 399L75 367Q34 403 34 472Q34 525 64 572T148 652Q207 686 289 686",
          120088: "160 247Q160 291 110 382T59 505Q59 542 106 597T207 690L218 697L229 682Q229 680 216 669T187 644T158 604T144 552Q144 526 165 482T207 387T228 291Q228 277 228 267T224 247T219 232T210 217T199 202T184 184T166 163L118 107Q124 105 132 105T160 98T220 77Q298 47 317 47Q354 47 409 105Q444 142 451 161T458 244V277Q458 339 455 457T447 596L575 686L591 676L583 668Q550 632 541 587T532 449V372V298Q532 198 550 147Q572 79 605 79Q617 79 631 84T656 95L665 100V79L595 27Q578 15 560 2T532 -19L523 -26Q522 -26 490 42L458 111L397 50Q389 42 374 27T355 8T340 -5T325 -16T311 -22T294 -26T274 -27Q232 -25 152 6T35 37Q28 36 19 30T4 18T-8 4T-16 -5Q-25 10 -25 11T-20 18Q-5 34 15 57L54 101Q70 103 86 116Q94 121 113 140T137 166Q160 201 160 247",
          120089: "54 266Q118 307 118 339Q118 360 74 413T27 493Q26 530 59 578T133 651Q187 686 256 686Q299 686 332 673T382 640T409 600T424 567T429 553Q431 553 463 586T542 653T624 686Q663 686 715 652T798 617Q812 617 825 622V606L815 599Q785 576 762 546Q724 495 724 432Q724 397 737 317T750 217Q750 148 711 96Q697 75 639 34T578 -10Q563 -21 555 -23T522 -26Q458 -26 363 29Q253 89 211 89Q192 89 173 83T139 67T114 49T96 34L90 27L80 43L95 59Q121 87 148 110T191 143T213 154Q261 154 300 195Q328 222 340 267T352 406Q352 562 255 611Q222 627 187 627H182Q143 627 115 598Q96 579 96 559Q96 528 144 470T192 381Q192 348 156 314T80 256L70 250L54 266ZM727 548Q701 550 650 583T567 617Q560 617 554 615Q532 610 501 580T445 501L437 485V465Q432 326 378 223L294 150Q321 143 421 87T560 31Q608 31 634 64Q660 102 660 198Q660 226 655 292T650 387Q650 418 658 452L660 462L735 548H727ZM264 150Q265 151 263 151H261Q261 150 264 150ZM280 150H276V149Q280 149 280 150",
          120090: "32 501Q35 564 103 625T264 686Q326 686 365 652Q402 618 420 564L441 585Q486 630 539 670L559 686L572 672Q637 606 665 559L682 576Q787 686 845 686Q877 686 929 656T992 623Q999 621 1016 621Q1041 621 1054 628L1051 617L1047 606Q1042 602 1037 597Q983 557 969 522T954 434Q954 394 961 336T968 221Q968 201 966 184T963 155T956 131T948 113T936 96T923 82T906 66T887 50L816 -2Q815 -3 810 -6T801 -11T791 -16T777 -20T759 -23T735 -25Q691 -25 619 4T505 37H496L463 21Q420 0 389 -20L378 -27H362Q316 -27 275 -9T202 28T150 46H146Q114 46 59 -5L48 -16L41 -6Q40 -4 38 -2T34 2L33 4Q33 8 77 54Q111 87 142 112L154 122H166Q239 127 288 182Q346 244 346 406Q346 489 326 537T259 610Q227 628 195 628Q155 628 128 606T101 549Q101 517 146 465T192 382Q192 348 156 310T85 254L75 250L64 258L55 266Q56 267 74 276T105 301T118 339Q118 362 75 413T32 501ZM952 547Q927 555 877 586T796 617Q744 617 682 525L676 516L677 498Q678 486 678 425Q678 301 652 206Q649 195 613 151T577 102Q577 100 582 100Q618 100 720 51Q761 32 790 32H794Q843 32 869 83Q884 110 884 189Q884 233 879 294T873 400Q874 433 879 451T889 478T915 507T952 547ZM241 105Q249 98 263 88T317 60T393 42Q478 42 547 109Q607 171 607 358Q607 371 607 380T604 417T595 467T577 517T546 566T500 601L479 580Q449 550 433 526L426 516V503Q426 311 357 200L352 191L296 149Q241 107 241 105",
          120091: "96 511L78 527L149 603Q207 666 227 686L237 685Q278 680 306 667T351 631T376 588T395 533L400 516L406 527Q439 600 523 653Q538 664 587 688Q589 688 596 672T613 635T629 606Q643 588 665 588Q677 588 693 596L709 603V585L607 526Q583 536 554 564T512 614Q461 571 435 507T405 381V367H581L563 347Q561 344 558 341T553 335T549 330T546 326L545 325H541Q537 325 488 329T411 334H405V325Q405 198 454 123Q497 54 568 54Q594 54 619 64T660 84L676 95V74L565 -16L553 -20Q528 -27 512 -27Q492 -27 475 -21T444 -5T418 19T398 47T382 77T371 105T363 128T358 145L357 151Q354 151 339 136T294 91T232 37Q152 -22 113 -22Q90 -22 69 -9T38 17T28 32Q28 33 58 68L86 101Q94 81 115 64T165 47Q206 47 249 84Q302 128 325 222Q334 263 336 312V334H312Q198 334 163 324H161Q162 326 182 348L198 367H336V398Q333 508 308 550Q295 570 274 585T227 601Q204 601 181 589T145 565T115 533T96 511",
          120092: "123 345Q123 358 75 415T27 496Q27 533 63 578T121 639Q181 685 256 685Q305 685 332 676T384 635Q419 588 425 542Q468 585 526 628T618 686Q632 667 658 645T704 609T724 594Q740 512 740 385V375V361Q740 128 682 -3Q656 -64 554 -141T361 -218Q319 -218 287 -203T243 -173T230 -150Q230 -148 267 -109L304 -69Q311 -115 341 -142T411 -170Q474 -170 534 -119T624 11Q660 111 660 312Q660 447 633 528L612 549Q578 583 552 596L543 601L528 592Q501 574 483 558Q454 528 436 494L431 484V473Q431 330 376 230Q366 213 359 206T306 159L250 112Q278 105 327 82T399 58Q421 58 440 69T471 92T484 104H485L493 90L480 73Q453 39 429 13Q393 -22 372 -22Q342 -22 260 15T153 53Q97 53 48 -16L38 5Q46 22 74 54T128 108L143 122H155Q226 127 275 168Q352 236 352 399Q352 501 309 564T197 628Q156 628 129 607T102 553Q102 517 147 463T192 383Q192 323 75 250L59 266Q123 314 123 345",
          120094: "86 363Q86 365 128 391T212 444L255 470Q256 470 263 465T283 453T308 442Q338 431 346 431Q350 431 358 436L414 465L421 459L418 434Q404 339 404 262Q404 147 408 119L425 97Q443 74 444 74L467 86L491 97Q492 97 497 83L436 28Q377 -26 374 -26L331 46L329 91L155 -35Q152 -35 114 10T68 65L67 86Q66 100 66 156Q66 177 66 198T68 236T71 268T74 296T77 320T80 338T83 351T86 360V363ZM314 365Q285 367 255 374T206 386L187 392Q181 392 172 376T154 311T145 197Q145 124 151 118Q156 110 187 78L208 56H214Q221 57 253 76L308 109L329 123V136Q328 143 328 257V365H314",
          120095: "177 427Q177 364 181 364Q184 364 192 370T223 395T271 433Q317 469 323 469Q325 469 338 462T377 440T432 413L440 409L441 396Q441 394 441 372T442 334Q442 203 425 108L423 97L400 83Q347 49 296 21T222 -19T196 -31Q192 -29 149 12T87 71L89 89Q100 155 100 319Q100 500 94 627Q94 632 94 638T94 648T94 656T93 662V664Q93 668 97 669T106 670H110Q114 653 118 633L127 596Q127 595 132 597Q136 599 195 642L255 685L272 673Q269 670 256 659T233 637T211 609T190 565T179 508Q177 494 177 427ZM295 377L274 385Q273 385 264 381T242 370T223 361Q213 355 188 340L178 333V123L198 103Q259 42 285 42Q299 42 314 55T339 85Q363 132 363 232Q363 310 358 343V349L345 355Q330 363 295 377",
          120096: "72 208Q72 323 84 361Q84 363 167 414Q248 466 250 466Q255 465 260 465Q283 460 307 450T344 430L357 422L306 343L301 342L296 340Q267 362 247 372T216 384T177 390Q154 349 154 238Q154 220 156 158V145L168 132Q179 121 208 93T244 59Q245 58 246 58Q255 58 302 83T350 108L352 104Q355 100 356 96L358 92Q358 91 274 32T187 -29L177 -20Q160 -6 120 36T77 84Q77 87 75 118T72 208",
          120097: "13 542Q13 544 77 576T147 609Q154 609 185 598T283 551T414 464L427 454V440Q427 436 427 412T428 372Q428 315 426 270T418 197T409 152T400 121T394 103L304 35Q285 21 261 2T225 -25L214 -33Q149 7 97 59L76 80L75 91V171Q75 221 76 254T79 299T80 313Q80 315 78 321Q78 323 78 326L77 330Q79 336 132 384T211 447L219 445Q221 445 224 444L228 443Q229 443 228 441T221 432T206 415L191 395Q175 378 162 339Q152 306 152 250Q152 217 159 140V134L171 121Q194 99 235 74T284 48Q296 48 310 75T337 156T349 267Q349 346 336 400L315 420Q246 489 176 525Q127 545 94 545H73L27 527L13 542",
          120098: "353 103Q353 97 358 87L337 71Q293 38 247 6Q191 -30 189 -30Q188 -30 173 -16T130 26T76 85L74 99Q70 139 70 190Q70 228 73 271T79 338T84 365L94 372Q105 378 126 392T166 417L246 467Q283 417 349 369L364 358L355 349Q249 249 169 180L151 166L152 152V139L165 126Q186 105 215 84T260 62Q267 62 309 82L353 103ZM267 323Q246 337 230 350T204 371T189 385T179 394T174 397Q149 381 149 219V211Q151 211 171 223T220 258T268 299L282 313L267 323",
          120099: "128 387Q128 391 112 456T92 546V555L101 568Q133 617 183 670L193 681L204 673Q238 648 262 648Q276 648 292 656L302 661L308 653Q308 652 278 618L249 585H234Q194 587 159 595Q158 595 156 596H153L150 597Q151 593 152 581T154 564T157 547T164 524T176 494Q199 436 203 400V392H207L323 386Q323 384 309 368L296 351H203V176Q201 -9 198 -32Q194 -61 166 -114Q158 -129 153 -138Q114 -214 110 -221Q105 -221 98 -220L87 -219V-216Q88 -215 106 -150T124 -82Q128 -73 129 155V351H30L64 386H96Q128 386 128 387",
          120100: "27 -144L17 -131L82 -75L146 -20L126 6Q99 37 92 48L78 65L77 79Q75 103 75 158Q75 217 78 268T86 343T91 368Q92 370 109 382T157 413T222 452Q240 465 249 469L251 470Q296 443 350 428L365 424L437 465L442 459Q442 456 441 453T437 444T432 424T427 385T423 317T421 215V133L423 119Q423 111 455 -17Q455 -21 380 -108T290 -201Q290 -202 284 -204T269 -207T252 -209Q172 -209 75 -135L62 -126Q60 -126 44 -135L27 -144ZM349 351Q267 359 178 389Q177 387 173 376T166 358T161 337T157 303T155 259Q155 195 159 135L160 124L170 112Q180 101 204 77T230 53Q231 53 286 88L340 123V141Q340 235 348 329Q348 334 348 339T348 348L349 351ZM364 -59Q364 -37 358 -1T347 64T341 93Q336 93 252 28T149 -57Q226 -134 293 -134Q325 -134 344 -118T364 -69V-59",
          120101: "88 427Q88 486 87 545T84 634T81 667Q81 673 82 673T89 676H94L117 600L200 661Q208 667 218 674T233 684L238 688L254 678Q222 646 216 637Q164 572 164 483V442V371Q187 390 244 431T312 478Q344 446 411 423L428 417L429 396Q434 297 434 218Q430 8 406 -34Q346 -111 262 -195L251 -205L249 -203Q248 -203 244 -199T236 -193Q226 -183 227 -182Q228 -182 244 -169T278 -140T301 -121Q330 -89 340 -22Q355 60 355 171Q355 200 353 244T348 321T344 354Q333 363 307 376T260 390Q241 390 179 350L164 341V121Q180 96 201 66L213 50Q210 46 172 11T131 -24Q130 -24 123 -11T102 25T77 65V78Q80 104 84 227T88 427",
          120102: "72 617Q72 618 102 645T133 673H134Q134 668 175 627L187 615L130 555L116 568Q72 615 72 617ZM27 369Q21 376 14 382L26 392Q83 440 119 474Q158 435 169 427L179 420L176 395Q166 302 166 227Q166 171 174 139Q178 119 186 103T202 81L208 75Q255 100 261 100Q262 100 264 92T267 83Q267 80 208 30T145 -20Q143 -20 118 17L91 55Q98 117 98 193Q98 339 88 369Q71 390 68 390Q63 390 39 376L27 369",
          120103: "101 644L132 672L145 657Q155 642 169 628L182 614L169 600Q148 579 140 570L125 555L112 568Q109 570 91 592T72 615Q72 617 101 644ZM19 -208Q-9 -185 -9 -183Q57 -134 80 -106Q103 -81 110 -19T118 179Q118 294 113 329T86 383Q78 389 76 389Q73 389 57 379L39 367Q26 380 26 381L33 387Q40 393 53 405T79 428L130 474Q147 457 186 428L195 422L196 376Q196 130 192 58T174 -35Q172 -39 104 -114T19 -208",
          120104: "93 348Q93 379 90 503T87 658V670Q87 671 94 671L100 672L112 636Q124 603 124 600L144 616Q196 659 234 682L246 689Q252 686 256 685T268 680L254 667Q225 641 211 626T184 579T168 505V497L178 504Q203 523 237 544L300 584L310 573Q359 522 359 481Q359 476 359 472T358 464T355 456T351 448T346 440T340 433T332 424T323 414T312 402T299 389L255 343L300 342H346L320 309H177V128L193 113Q214 92 244 68L254 60L303 84Q351 108 352 108L362 96Q355 85 277 30T194 -25L170 -4Q146 18 120 41T89 68Q94 85 94 168Q94 184 94 218T93 268V309H58L24 310L51 342H93V348ZM172 342Q217 342 252 374T287 445Q287 472 255 504Q242 517 241 517Q202 498 187 468T168 365V342H172",
          120105: "221 76L267 99Q268 98 269 96T271 88T270 82L262 76Q255 69 241 57T214 34L148 -20L98 56L99 89Q107 247 107 373Q107 494 101 621Q101 653 99 659V665L106 668L113 672L118 655Q122 642 131 617L138 597Q140 597 157 611L240 670L264 685Q265 685 270 680T276 674T269 667T247 647T219 617Q197 587 186 551T173 493T171 438Q171 376 175 282T179 147V117Q184 109 201 93T221 76",
          120106: "20 367L8 379Q9 380 63 425T118 471Q130 460 143 446L168 421V398L169 376L295 475Q362 433 415 418V399Q415 380 416 380T437 394T484 428T529 462L544 474L556 467Q590 449 614 438T646 424L653 421L665 417L664 412Q664 411 664 407T664 397T663 384Q660 342 660 335Q658 303 658 245Q658 186 660 152L661 126L669 115Q680 96 697 79L707 83Q716 87 723 90T735 96T741 100T746 102L747 103V102L750 95Q753 88 753 87L631 -18Q630 -17 622 -3T589 43L576 60L579 72Q592 146 592 218Q592 265 584 321Q581 345 578 350T560 363Q535 376 496 386L481 390Q475 387 425 358L415 351V238V157Q415 142 415 135T417 120T421 110T430 98T441 81L465 47Q462 44 458 41T443 28T420 8L380 -26L333 47L336 62Q339 77 342 109T345 184Q345 223 341 285T333 348Q322 364 258 382L240 388L169 347L168 240Q168 118 171 110L174 106Q178 101 183 93T195 78L217 48Q217 47 196 30T154 -5T133 -21L130 -16Q127 -10 122 0T111 19Q89 56 89 60Q95 76 95 153Q95 239 88 337V365L62 391L20 367",
          120107: "31 368Q20 379 20 380T72 427L121 470L129 463Q137 455 155 441T176 425V367L320 475L329 469Q351 454 385 437T434 417L432 402Q429 362 429 231V128L439 111Q442 107 445 102T449 95T453 90T456 86T459 84T463 82T467 82Q468 82 489 93T511 105T514 95V88L395 -18L340 65L341 77Q347 111 348 178Q348 343 343 353V358L332 363Q298 377 264 382Q260 382 254 382L249 383Q247 383 211 362L176 341V229V147Q176 134 176 127T177 115T179 106T183 99T189 91T197 81Q201 76 206 69T214 57L217 53Q217 52 175 15T132 -22Q132 -20 114 5T88 41Q84 45 84 50Q94 116 94 203Q94 227 93 263T92 324L90 364L67 388L50 378Q32 368 31 368",
          120108: "67 121Q70 265 84 359V364L97 371Q137 394 177 421T238 464T260 480L278 468Q295 457 327 442T394 418L406 414Q412 388 412 300Q412 263 410 228T405 170T399 130T393 103T391 92L381 86Q274 19 165 -28L161 -24Q157 -21 151 -15T136 -2T118 14T101 30T86 46T74 60L67 68V121ZM335 278Q335 286 335 303T334 335L333 349V356H326Q288 360 208 388L183 397Q178 393 172 383T154 333T142 239Q142 192 151 134Q152 124 155 120T175 99Q197 77 219 64T251 47T267 44T281 52T302 80T320 124Q335 182 335 278",
          120109: "23 25Q15 33 12 38L35 59Q82 102 87 105V351L68 378Q42 414 42 422Q42 437 67 472T114 530L125 541Q126 541 132 537T138 532Q121 507 121 488Q121 453 160 413L167 405L166 390L165 372Q169 372 233 421T305 478Q307 479 315 472Q395 421 423 415Q424 415 424 415T425 414L426 410Q426 407 426 401T426 388Q430 335 430 272Q430 139 408 80Q407 78 340 22L273 -33Q200 23 165 23Q164 23 164 -32Q165 -89 168 -155V-170L93 -212L78 -203Q85 -48 87 16V47H79Q53 44 23 25ZM319 41Q346 94 349 212Q349 278 343 343V351L330 357Q318 363 270 381L255 387L245 383Q212 370 178 345L166 336V287Q165 260 165 166V94H175Q219 90 299 51L319 41ZM132 57L129 60Q130 58 132 57ZM158 29Q159 29 155 34T145 45T138 50Q155 29 158 29",
          120110: "399 19Q399 -123 407 -174V-179L332 -219L322 -210L312 -202L314 -185Q320 -83 323 54V95L311 85Q255 40 162 -19Q146 -29 145 -27Q140 -22 103 20L63 65V73Q61 83 61 115Q61 122 61 135T60 154Q60 263 79 353L83 368L94 375Q123 391 147 405T186 429T212 446T229 458T238 466T243 470T247 471L260 464Q274 457 295 448T330 434L341 432L410 479L412 478Q414 476 416 475T419 473L417 461Q399 358 399 19ZM316 367Q287 370 252 377T196 391L176 397H175Q173 397 166 382T149 314T139 187V158Q139 138 141 132T155 114Q158 111 160 109Q210 58 211 58L218 62Q226 67 240 75T266 91L319 124V196Q319 334 325 361V367H316",
          120111: "357 398Q364 398 375 403L386 408Q386 404 387 400V393L369 377Q361 370 350 360T336 347T327 340T316 336T303 335Q270 335 234 371L224 379Q220 375 214 370T198 355L182 340V243Q182 164 183 152T189 129Q195 117 211 100T239 72T254 60T298 81Q342 101 343 101Q344 100 345 92T346 82L200 -21Q174 -5 117 55L97 75L99 92Q106 147 106 196Q106 216 104 282T97 355Q95 359 95 361Q95 364 77 378L65 387L48 380Q30 372 29 372Q28 371 23 375T17 380Q17 384 50 415T107 467L115 474L128 461Q171 421 182 414V382L235 425Q247 435 261 446T283 462L290 468L295 460Q335 398 357 398",
          120112: "272 33Q284 33 290 70T296 138Q296 181 290 198T262 230Q257 232 246 232Q231 232 218 227T156 194L108 167L101 176Q90 192 75 219L69 230V284Q69 346 70 357V377L146 427Q181 450 202 464T223 477L225 476Q227 475 229 474Q231 472 242 466T270 450T296 431Q309 418 326 418Q342 418 361 429T392 450T403 459Q406 445 406 442Q406 440 384 421T338 382L316 363Q315 362 310 362Q292 362 251 371T173 396Q156 403 155 403Q143 386 143 342Q143 305 150 278T168 244Q171 242 181 242L190 243L315 300Q330 295 357 274Q358 273 362 270T366 266T369 261T372 253T373 239T374 217T374 185Q374 157 372 133T368 98T363 71T358 50L336 40Q288 20 255 2T211 -22T198 -29L190 -22Q181 -14 168 -3T138 19T104 38T70 46Q50 46 32 37T3 20T-9 11L-18 23L-1 41Q46 89 62 99T112 110Q141 110 157 103T225 62Q268 33 272 33",
          120113: "228 640L242 627L227 613Q213 599 211 593T203 553Q197 500 196 435V389H301L272 353H195V274Q195 178 196 159L197 123Q249 71 273 68H280L312 83Q344 99 345 99Q348 99 348 78Q348 76 314 52T246 4L212 -20Q211 -20 164 19T112 62Q112 122 113 196Q113 228 113 262T114 318T114 341V353H27L62 389H116L117 431V558L228 640",
          120114: "171 315Q171 252 165 199T153 124L147 103Q147 102 196 80L244 57L335 107V116Q339 161 339 268Q339 315 338 351T337 412V424L420 468Q424 465 427 461L424 435Q412 331 412 226Q412 170 415 145T434 96Q442 84 452 83Q461 83 492 96L506 102Q507 102 510 96T513 88L493 71Q445 32 401 -9Q392 -18 388 -17L384 -16Q358 39 355 44Q336 77 333 77Q261 45 203 -9Q186 -23 181 -23Q177 -23 162 -11T121 18T69 44L57 48L61 54Q65 60 71 73T82 102Q100 156 100 262Q100 305 93 335T80 373T62 396L23 376Q18 377 9 386L119 474Q149 437 171 421V339V315",
          120115: "55 418Q55 443 100 503Q121 530 123 530Q125 528 127 528T131 528T134 528T135 524T131 516Q123 499 123 486Q123 457 159 416L169 405L170 388L171 372Q171 371 244 424L317 477L334 466Q394 428 432 416L433 402Q433 400 433 377T434 336V305Q434 195 420 131Q413 94 406 87Q403 84 298 29L192 -28L172 -8Q139 25 106 52L92 64V70Q95 97 95 198Q95 293 94 318L92 355L84 367Q55 406 55 418ZM174 306Q174 297 173 255T171 184Q171 153 175 136T198 100Q207 94 224 80T255 57T282 49Q304 49 328 80Q359 129 359 243Q359 284 352 345Q351 358 348 360Q333 373 304 384T265 396L251 390Q215 372 186 351L175 344V337Q175 319 174 306",
          120116: "45 425Q45 439 82 485T126 532Q127 532 128 532T131 531T137 529L132 519Q121 499 121 483Q121 473 131 454T156 419L167 408L169 376L185 388Q237 425 291 473L301 466Q337 443 394 416L419 405L418 387V369Q419 369 487 418T560 471L581 459Q597 450 621 437T664 415T684 406Q688 406 688 323Q688 254 679 193T662 103T648 71Q647 70 554 20L464 -28L443 -15Q416 1 386 17T343 40T331 49Q331 52 333 73T337 133T339 216Q339 309 334 339Q333 341 316 353T277 377T246 389Q235 389 201 369T166 346Q166 345 164 247Q164 232 164 210T163 179Q163 139 170 116T205 57L212 48L136 -27Q115 16 87 44L78 53L80 67Q88 124 88 211Q88 282 87 315T83 356T74 371Q45 410 45 425ZM591 352Q580 359 565 365T540 374T517 381T504 385L418 342L417 318V220Q417 212 417 194T417 170T418 152T420 134T424 120T431 106T440 95T454 83Q508 44 544 44Q566 44 583 77Q603 120 605 235Q605 289 600 322Q598 343 597 345T591 352",
          120117: "14 377Q63 428 117 472Q130 462 144 449L193 408V392V376L247 420Q300 464 301 464L310 451Q331 417 363 390L333 365Q303 340 301 340Q293 343 277 364T250 386Q241 386 215 361L195 341Q194 333 193 327T191 318T190 304T188 269Q188 220 192 148Q193 122 195 118T210 101Q255 60 271 60Q276 60 278 61L318 82Q327 86 336 91T351 98L356 101Q359 82 356 79Q354 77 283 27T210 -24L192 -7Q160 23 137 40L126 49L116 40Q66 -13 66 -54Q66 -117 167 -140L179 -142V-147L180 -152L123 -188L112 -185Q58 -170 31 -145Q10 -122 10 -96Q10 -80 22 -53Q44 -10 95 49Q97 51 100 54T104 59T107 64T109 71T111 81T112 97T113 119T114 149T114 188Q114 284 108 347V354L96 365Q76 385 67 385Q62 385 45 377L27 368L14 377",
          120118: "74 58Q89 124 89 241Q89 265 89 278T89 305T88 324T87 336T84 346T81 352T77 359T71 368Q57 388 52 398L45 409Q62 454 98 507L113 528Q128 528 128 524Q128 523 125 518T120 503T117 483V471Q123 456 130 445Q135 438 140 432T148 422T153 415T157 409T160 405T162 402T163 399T163 395V384V365Q165 365 237 419L311 473Q383 430 420 416Q426 414 426 411V404Q426 398 426 388T427 367Q431 233 431 201Q431 -3 391 -52Q387 -58 305 -138T221 -218L218 -217Q216 -216 211 -214T202 -210L184 -202L199 -194Q259 -162 288 -127T334 -19T350 184Q350 257 342 328L340 356Q282 390 262 390Q248 390 178 346L163 336V111L216 45L131 -26L124 -15Q114 3 85 44L74 58",
          120119: "47 335L36 347L52 362Q112 421 167 461L181 471L192 465Q236 444 260 417T284 369Q284 355 276 343T233 291Q195 246 195 245T205 242T241 228T300 198L302 187Q314 138 314 74Q314 -24 291 -95Q290 -100 222 -157L154 -214H145Q102 -214 53 -189T-7 -117Q41 -21 183 122L207 147Q205 149 186 157T140 172T100 180H97V192L140 231Q192 280 199 293Q205 303 205 315Q205 339 185 363T137 388Q119 388 63 347L47 335ZM179 -153Q212 -153 226 -113T240 14Q240 67 233 98T223 132T211 143L222 130Q216 125 206 116T170 82T124 33T88 -20T72 -70Q72 -99 105 -126T179 -153",
          120120: "130 -1H63Q34 -1 26 2T17 17Q17 24 22 29T35 35Q49 35 64 44T88 66Q101 93 210 383Q331 693 335 697T346 701T357 697Q358 696 493 399Q621 104 633 83Q656 35 686 35Q693 35 698 30T703 17Q703 5 693 2T643 -1H541Q388 -1 386 1Q378 6 378 16Q378 24 383 29T397 35Q412 35 434 45T456 65Q456 93 428 170L419 197H197L195 179Q184 134 184 97Q184 82 186 71T190 55T198 45T205 39T214 36L219 35Q241 31 241 17Q241 5 233 2T196 -1H130ZM493 68Q493 51 481 35H619Q604 56 515 256Q486 321 468 361L348 637Q347 637 330 592T313 543Q313 538 358 436T448 219T493 68ZM404 235Q404 239 355 355T295 488L275 430Q241 348 208 232H306Q404 232 404 235ZM155 48Q151 55 148 88V117L135 86Q118 47 117 46L110 37L135 35H159Q157 41 155 48",
          120121: "11 665Q11 672 22 683H213Q407 681 431 677Q582 649 582 515Q582 488 573 468Q554 413 484 372L474 366H475Q620 317 620 178Q620 115 568 69T420 6Q393 1 207 -1H22Q11 10 11 18Q11 35 51 35Q79 37 88 39T102 52Q107 70 107 341T102 630Q97 640 88 643T51 648H46Q11 648 11 665ZM142 341Q142 129 141 88T134 37Q133 36 133 35H240L233 48L229 61V623L233 635L240 648H133L138 639Q142 621 142 341ZM284 370Q365 378 391 411T417 508Q417 551 406 581T378 624T347 643T320 648Q298 648 278 635Q267 628 266 611T264 492V370H284ZM546 515Q546 551 531 577T494 617T454 635T422 641L411 643L420 630Q439 604 445 579T452 510V504Q452 481 451 467T441 430T415 383Q420 383 439 391T483 413T527 455T546 515ZM585 185Q585 221 570 249T534 294T490 320T453 334T436 337L435 336L440 330Q445 325 452 315T467 288T479 246T484 188Q484 145 474 110T454 62T442 48Q442 47 444 47Q450 47 470 54T517 75T564 119T585 185ZM449 184Q449 316 358 332Q355 332 335 333T302 335H264V199Q266 68 270 57Q275 50 289 43Q300 37 324 37Q449 37 449 184",
          120123: "16 666Q16 675 28 683H193Q329 683 364 682T430 672Q534 650 600 585T686 423Q688 406 688 352Q688 274 673 226Q641 130 565 72T381 1Q368 -1 195 -1H28Q16 5 16 16Q16 35 53 35Q68 36 75 37T87 42T95 52Q98 61 98 341T95 630Q91 640 83 643T53 648Q16 648 16 666ZM237 646Q237 648 184 648H128Q128 647 133 632Q136 620 136 341Q136 64 133 50L128 35H237L230 48L226 61V343Q228 620 231 633Q232 636 237 646ZM264 61Q278 40 310 35Q363 35 401 55T461 112T496 193T513 295Q515 333 515 349Q515 411 504 459Q481 598 373 641Q351 648 321 648Q304 648 292 643T277 635T264 621V61ZM461 628Q462 627 471 616T489 594T509 559T529 509T544 441T550 352Q550 165 479 75L468 59Q474 61 484 65T522 87T573 128T618 195T650 290Q654 322 654 354Q654 418 638 464T581 552Q559 576 529 595T480 621L461 628",
          120124: "12 666Q12 675 24 683H582Q590 680 593 672V588Q593 514 591 502T575 490Q567 490 563 495T555 517Q552 556 517 590Q486 623 445 634T340 648H282Q266 636 264 620T260 492V370H277Q329 375 358 391T404 439Q420 480 420 506Q420 529 436 529Q445 529 451 521Q455 517 455 361Q455 333 455 298T456 253Q456 217 453 207T437 197Q420 196 420 217Q420 240 406 270Q377 328 284 335H260V201Q261 174 261 134Q262 73 264 61T278 38Q281 36 282 35H331Q400 35 449 50Q571 93 602 179Q605 203 622 203Q629 203 634 197T640 183Q638 181 624 95T604 3L600 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666ZM137 341Q137 131 136 89T130 37Q129 36 129 35H235Q233 41 231 48L226 61V623L231 635L235 648H129Q132 641 133 638T135 603T137 517T137 341ZM557 603V648H504Q504 646 515 639Q527 634 542 619L557 603ZM420 317V397L406 383Q394 370 380 363L366 355Q373 350 382 346Q400 333 409 328L420 317ZM582 61L586 88Q585 88 582 83Q557 61 526 46L511 37L542 35H577Q577 36 578 39T580 49T582 61",
          120125: "584 499Q569 490 566 490Q558 490 552 497T546 515Q546 535 533 559Q526 574 506 593T469 621Q415 648 326 648Q293 648 287 647T275 641Q264 630 263 617Q262 609 260 492V370L275 372Q323 376 350 392T393 441Q409 473 409 506Q409 529 427 529Q437 529 442 519Q444 511 444 362Q444 212 442 206Q436 197 426 197Q409 197 409 217Q409 265 375 299Q346 328 280 335H260V206Q260 70 262 63Q265 46 276 41T326 35Q362 35 366 28Q377 17 366 3L360 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666Q12 675 24 683H573Q576 678 584 670V499ZM137 341Q137 131 136 89T130 37Q129 36 129 35H182Q233 35 233 39Q226 54 225 92T224 346L226 623L231 635L235 648H129Q132 641 133 638T135 603T137 517T137 341ZM549 603V648H495L506 641Q531 621 533 619L549 603ZM409 317V395L400 386Q390 376 375 366L357 355L373 346Q394 331 397 328L409 317",
          120126: "737 285Q749 277 749 268Q749 260 744 255T730 250Q695 250 677 217Q666 195 666 119Q666 52 664 50Q656 36 555 3Q483 -16 415 -19Q364 -19 348 -17Q226 -3 146 70T44 261Q39 283 39 341T44 421Q66 538 143 611T341 699Q344 699 364 700T395 701Q449 698 503 677T585 655Q603 655 611 662T620 678T625 694T639 702Q650 702 657 690V481L653 474Q640 467 628 472Q624 476 618 496T595 541Q562 587 507 625T390 663H381Q337 663 299 625Q213 547 213 337Q213 75 341 23Q357 19 397 19Q440 19 462 22T492 30T513 45V119Q513 184 506 203Q491 237 435 250Q421 250 415 257Q404 267 415 281L421 285H737ZM250 43Q250 45 243 55T225 87T203 139T185 224T177 343V361Q184 533 250 625Q264 643 261 643Q238 635 214 620T161 579T110 510T79 414Q74 384 74 341T79 268Q106 117 230 52L250 43ZM621 565V625Q617 623 613 623Q603 619 590 619H575L588 605Q608 583 610 579L621 565ZM655 250H517L524 241Q548 213 548 149V114V39Q549 39 562 44T592 55T615 63L630 70V134Q632 190 634 204T648 237Q655 245 655 250",
          120128: "20 666Q20 676 31 683H358Q369 676 369 666Q369 648 331 648Q288 645 282 632Q278 626 278 341Q278 57 282 50Q286 42 295 40T331 35Q369 35 369 16Q369 6 358 -1H31Q20 4 20 16Q20 35 58 35Q84 37 93 39T107 50Q113 60 113 341Q113 623 107 632Q101 645 58 648Q20 648 20 666ZM249 35Q246 40 246 41T244 54T242 83T242 139V341Q242 632 244 639L249 648H140Q146 634 147 596T149 341Q149 124 148 86T140 35H249",
          120129: "79 103Q108 103 129 83T151 38Q151 9 130 -15Q116 -34 130 -37Q133 -39 157 -39Q208 -39 219 -8L226 3V305Q226 612 224 621Q220 636 211 641T166 647Q137 647 128 654Q119 665 128 679L135 683H466Q478 677 478 666Q478 647 439 647Q399 644 393 632Q388 620 388 347Q386 69 384 59Q364 -6 316 -39T184 -77H172Q102 -77 56 -48T6 30Q6 62 26 82T79 103ZM353 354Q353 556 354 596T361 645Q362 646 362 647H253Q257 639 258 628T261 547T262 312V-4L255 -17Q248 -29 250 -29Q253 -29 258 -28T277 -20T302 -5T327 22T348 65Q350 74 353 354ZM115 36Q115 47 105 57T79 67Q73 67 67 66T52 56T44 34Q44 9 62 -8Q66 -11 71 -15T81 -22T86 -24L90 -13Q100 3 102 5Q115 22 115 36",
          120130: "22 666Q22 676 33 683H351L358 679Q368 665 358 655Q351 648 324 648Q288 645 280 637Q275 631 274 605T273 477L275 343L382 446Q473 530 492 553T512 599Q512 617 502 631T475 648Q455 651 455 666Q455 677 465 680T510 683H593H720Q732 676 732 666Q732 659 727 654T713 648Q670 648 589 581Q567 562 490 489T413 415Q413 413 554 245T711 61Q737 35 751 35Q758 35 763 29T768 15Q768 6 758 -1H624Q491 -1 486 3Q480 10 480 17Q480 25 487 30T506 35Q518 36 520 38T520 48L400 195L302 310L286 297L273 283V170Q275 65 277 57Q280 41 300 38Q302 37 324 35Q349 35 358 28Q367 17 358 3L351 -1H33Q22 4 22 16Q22 35 60 35Q101 38 106 52Q111 60 111 341T106 632Q100 645 60 648Q22 648 22 666ZM240 341V553Q240 635 246 648H138Q141 641 142 638T144 603T146 517T146 341Q146 131 145 89T139 37Q138 36 138 35H246Q240 47 240 129V341ZM595 632L615 648H535L542 637Q542 636 544 625T549 610V595L562 606Q565 608 577 618T595 632ZM524 226L386 388Q386 389 378 382T358 361Q330 338 330 333Q330 332 330 332L331 330L533 90Q558 55 558 41V35H684L671 50Q667 54 524 226",
          120131: "12 666Q12 675 24 683H333L340 679Q350 665 340 655Q333 648 309 648Q287 646 279 643T266 630Q264 623 264 346Q264 68 266 57Q274 40 284 35H340Q413 37 460 55Q514 78 553 117T602 197Q605 221 622 221Q629 221 634 215T640 201Q638 194 625 105T611 12Q611 6 600 -1H24Q12 5 12 16Q12 35 51 35Q92 38 97 52Q102 60 102 341T97 632Q91 645 51 648Q12 648 12 666ZM137 341Q137 131 136 89T130 37Q129 36 129 35H237Q235 41 233 48L229 61L226 339Q226 621 229 628Q230 630 231 636T233 643V648H129Q132 641 133 638T135 603T137 517T137 341ZM580 48Q580 59 583 74T586 97Q586 98 585 97T579 92T571 86Q549 64 513 43L500 35H577L580 48",
          120132: "18 666Q18 677 27 680T73 683H146Q261 683 266 679L465 215Q469 215 566 443Q663 676 668 681Q673 683 790 683H908L915 679Q924 664 915 655Q912 648 897 648Q851 639 835 606L833 346Q833 86 835 79Q838 69 849 58T873 41Q877 40 887 38T901 35Q926 35 926 16Q926 6 915 -1H604L597 3Q588 19 597 28Q600 35 615 35Q660 42 673 68L679 79V339Q679 409 679 443T679 520T679 580T677 597Q646 521 584 375T473 117T424 3Q416 -1 410 -1T401 1Q399 3 273 301L148 599L146 343Q146 86 148 79Q152 69 163 58T186 41Q190 40 200 38T215 35Q226 35 235 28Q244 17 235 3L228 -1H28Q17 4 17 17Q17 35 39 35Q84 42 97 68L104 79V639L88 641Q72 644 53 648Q34 648 26 651T18 666ZM457 166Q451 169 449 171T435 198T404 268T344 412L244 648H157L166 637Q169 633 293 346L413 66Q424 88 435 117L457 166ZM817 646Q817 648 766 648H715V72L708 57Q701 45 697 41L695 37Q695 35 757 35H819L813 46Q802 61 800 76Q797 105 797 346L799 612L804 626Q812 638 815 641L817 646ZM124 42Q119 42 119 38Q119 35 128 35Q132 35 132 36Q125 42 124 42",
          120134: "131 601Q180 652 249 676T387 701Q485 701 562 661Q628 629 671 575T731 448Q742 410 742 341T731 234Q707 140 646 81Q549 -19 389 -19Q228 -19 131 81Q57 155 37 274Q34 292 34 341Q34 392 37 410Q58 528 131 601ZM568 341Q568 613 437 659Q406 664 395 665Q329 665 286 625Q232 571 213 439Q210 408 210 341Q210 275 213 245Q232 111 286 57Q309 37 342 23Q357 19 389 19Q420 19 437 23Q469 38 491 57Q568 132 568 341ZM174 341Q174 403 177 441T197 535T249 639Q246 639 224 627T193 608Q189 606 183 601T169 589T155 577Q69 488 69 344Q69 133 231 52Q244 45 246 45Q248 45 246 48Q231 69 222 85T200 141T177 239Q174 269 174 341ZM708 341Q708 415 684 475T635 563T582 610Q578 612 565 619T546 630Q533 637 531 637Q530 637 530 636V635L531 634Q562 591 577 543Q602 471 602 341V316Q602 264 599 230T580 144T531 48L530 47V46Q530 45 531 45Q533 45 547 52T583 75T622 105Q708 195 708 341",
          120138: "54 238Q72 238 72 212Q72 174 106 121Q113 110 132 90T166 59Q221 23 264 23Q315 23 348 41Q368 50 384 79Q393 102 393 129Q393 181 356 219T221 299Q120 343 74 390T28 501Q28 561 55 610Q98 682 212 699Q214 699 231 700T261 701Q309 698 340 687T408 675Q431 678 445 690T465 702Q474 702 481 690V497L477 490Q464 481 450 490Q446 500 446 501Q446 546 386 606T260 666Q215 666 182 639T148 565Q148 528 186 496T319 428Q352 414 370 405T418 379T468 338T506 284Q528 239 528 191Q528 102 456 46T266 -10Q211 -10 176 2T110 15Q86 9 73 -1T53 -12Q44 -12 37 -1V112V182Q37 214 40 226T54 238ZM446 619Q446 648 444 648Q439 646 435 644Q425 644 415 639H404L417 624Q435 606 439 601L446 592V619ZM124 619L128 635Q126 635 108 617Q64 576 64 502Q64 489 65 479T76 449T102 414T150 376T228 335Q335 291 381 245T427 128Q427 94 419 75L415 61Q421 61 448 88Q490 127 490 190Q490 233 475 264Q456 299 430 321Q402 349 369 367T287 404T204 441Q138 481 119 526Q113 544 113 565Q113 596 124 619ZM75 43Q76 43 90 46T110 50H119L106 64L74 101Q72 101 72 72T75 43",
          120139: "33 672Q36 680 44 683H624Q632 680 635 672V490L631 483Q621 479 617 479Q611 479 606 485T600 499Q600 525 584 552Q577 567 558 588T524 617Q479 642 426 646L415 648V355Q415 62 422 52Q425 42 434 40T473 35Q500 35 509 28Q518 17 509 3L502 -1H166L160 3Q149 17 160 28Q167 35 195 35Q224 37 234 39T249 52Q253 66 253 355V648L242 646Q192 642 144 617Q129 609 110 588T84 552Q69 527 69 499Q69 490 64 484T50 478Q39 478 33 490V672ZM113 639L126 648H69V597L84 612Q93 623 113 639ZM389 35Q382 46 381 86Q380 134 380 350V648H289V350Q289 199 288 131T286 53T280 35H389ZM600 597V648H542L555 639Q575 623 584 612L600 597",
          120140: "16 666Q16 677 28 683H341L348 679Q359 665 348 654Q342 648 315 648Q270 644 266 632Q262 627 262 598T261 399Q261 372 261 325T260 260Q260 149 274 99T339 30Q355 25 393 25Q430 25 457 33T494 49T519 72Q562 115 575 205Q576 219 576 379Q576 538 575 550Q568 597 550 622T506 648Q498 648 493 654T487 667T499 683H697Q709 675 709 667T704 654T690 648Q653 648 633 597Q624 573 622 546T619 377Q617 193 613 174Q596 95 544 41Q477 -19 355 -19H344Q275 -16 226 5T153 57T120 110T106 154Q101 172 99 399Q99 618 95 632Q88 644 53 648Q16 648 16 666ZM228 639L233 648H128Q128 647 133 632Q135 621 135 412Q135 197 137 185Q148 115 181 79Q209 51 235 41Q242 36 258 31T277 25Q276 27 268 38T254 59T241 92T228 145Q226 161 226 399Q226 632 228 639ZM604 621Q606 626 619 648H577L586 634Q587 632 591 625T595 614L597 608L604 621",
          120141: "316 683Q327 676 327 666Q327 648 302 648Q272 642 258 628Q249 621 249 608Q252 589 263 556T289 485T322 406T357 325T388 256T411 205L420 185Q423 185 473 317Q547 497 547 590Q547 621 541 632T516 648Q501 648 498 654Q488 664 498 679L504 683H607H660Q695 683 707 680T719 667Q719 660 714 654T700 648Q678 648 658 628L642 614L513 301Q484 231 449 148T397 25T380 -15Q373 -20 368 -20Q361 -20 358 -15Q354 -13 287 135T149 438T67 610Q45 648 18 648Q11 648 6 653T0 666Q0 677 9 680T59 683H164H316ZM216 614Q216 620 216 622T216 628T216 633T217 635T218 638T219 640T221 644T224 648H84L96 632Q118 592 236 330L367 43L387 88L404 132L380 185Q250 468 222 568Q216 590 216 614ZM576 645Q584 628 584 597L587 568L598 597Q609 624 618 637L624 648H600Q576 648 576 645",
          120142: "785 664Q785 670 795 683H982Q994 675 994 665Q994 650 975 648Q953 643 939 619Q931 593 823 292T710 -15Q706 -19 699 -19T688 -15Q682 -6 639 107T555 328T513 437Q513 438 500 409T462 325T413 212Q315 -14 310 -17Q308 -19 302 -19T288 -15L57 619Q45 643 24 648Q5 650 5 665Q5 677 17 683H146H200Q256 683 270 681T285 666Q285 659 280 654T268 648Q253 648 239 634Q230 630 230 619Q230 598 264 481L362 192Q363 193 428 341T493 492Q493 496 473 546T446 608Q426 648 399 648Q392 648 387 653T382 667Q382 678 393 683H679Q690 670 690 665Q690 662 685 655T673 648Q653 648 633 632L622 625V610Q626 576 657 479T719 300T751 218Q754 218 779 294Q847 492 847 581Q847 648 802 648Q796 648 791 652T785 664ZM194 623Q194 630 199 648H82L90 632Q99 616 199 332L302 50Q303 50 322 94T342 141Q342 142 305 245T231 467T194 623ZM585 620Q585 634 593 648H530Q466 648 466 645Q479 632 595 323L699 54Q701 56 718 103T735 154L702 245Q585 562 585 620ZM884 572L890 587Q896 602 903 620T915 645Q915 648 893 648H868L875 634Q883 598 883 576Q883 572 884 572",
          120143: "22 666Q22 677 31 680T80 683H184H335Q346 675 346 667Q346 660 341 655Q335 648 315 648Q280 644 273 637Q273 630 300 583T356 492T386 448Q430 504 450 535T474 577T478 601Q478 620 469 634T444 648Q428 648 428 666Q428 678 436 680T488 683H559H630Q673 683 681 681T690 666Q690 648 673 648Q652 648 619 637Q571 615 517 550Q490 517 450 464T410 408Q415 399 501 273T617 106Q648 61 661 48T688 35Q705 35 705 16Q705 5 695 -1H539Q384 -1 379 3Q373 10 373 17Q373 27 380 31T408 35Q459 40 459 49Q459 59 418 129T335 259Q334 260 332 260Q328 260 273 197Q210 127 208 117Q199 104 199 82Q199 57 213 46T239 35Q247 35 252 29T257 15Q257 10 256 7T253 3T248 0L246 -1H28Q16 7 16 15T21 29T35 35Q61 35 117 88Q289 279 304 297Q307 303 255 377Q117 586 79 626Q60 648 39 648Q32 648 27 653T22 666ZM237 639V648H173Q113 647 113 646Q113 642 137 612Q186 546 302 373T453 139Q497 63 497 43Q497 39 495 35H559Q622 35 622 37Q622 38 583 94T486 233T373 399T277 552T237 639ZM553 637L566 648H504L508 637Q510 630 515 615V603L528 615Q529 616 539 625T553 637ZM170 46Q169 49 167 58T164 70V83L137 59L113 35H175Q175 38 170 46",
          120144: "16 659T16 667T28 683H295Q306 676 306 666Q306 648 284 648Q258 648 255 641Q255 634 265 615T339 479Q418 339 421 339L455 394Q489 448 523 502L557 557Q560 566 560 582Q560 637 504 648Q489 648 486 655Q475 664 486 679L493 683H693Q704 675 704 667Q704 650 684 648Q672 645 653 623Q633 604 614 576T517 426L439 301V183Q442 62 444 59Q449 35 504 35Q521 35 528 30Q538 16 528 3L521 -1H195L188 3Q178 16 188 30Q195 35 213 35Q266 35 273 59Q274 61 277 163V261L75 621Q64 638 58 643T37 648Q28 648 22 653ZM219 637V648H101Q110 634 215 446L313 270V166Q310 59 306 48L301 35H415L410 48Q404 65 404 175V290L317 443Q230 601 226 612Q219 625 219 637ZM608 630L624 648H575Q584 632 588 623L595 610L608 630",
          120172: "821 97Q822 97 824 88T827 77L793 53Q676 -25 670 -28Q669 -29 656 -27L583 123Q583 124 467 46L352 -31L341 -20Q305 18 264 47T192 77Q161 77 60 32L49 40Q37 47 38 49Q39 49 93 83T212 160T297 219Q411 312 411 452Q411 519 360 571T233 624Q180 624 157 601T133 548Q133 524 160 496T214 441T241 393Q241 356 199 321T100 256L86 249L77 256Q68 263 67 263L84 274Q101 286 118 304T135 339T109 384T56 446T29 504Q29 566 118 624Q207 686 309 686Q349 686 360 685Q405 678 439 661T491 625T520 583T534 543T537 511Q537 436 491 344L478 318L455 299Q420 272 308 179L284 160L294 158Q348 154 426 89L437 79Q513 110 579 153V175Q579 183 579 227T580 330T581 446T582 542L583 582L664 630Q681 640 703 653T734 673L744 679Q750 678 756 676L767 674L716 623V585Q716 568 712 463T708 289V250Q708 237 709 218T710 195L711 180L739 130Q768 79 771 79Q775 79 796 88T821 97",
          120173: "160 345Q160 357 144 376T109 413T73 458T57 509Q57 544 95 584Q142 631 205 657T331 684Q382 684 427 658T500 585L505 577L521 588Q537 599 562 614T616 646T679 673T738 684Q790 684 807 666T840 587Q850 552 863 532T888 508Q894 505 906 505Q917 505 930 507T953 512T963 514L964 504Q965 495 965 494T914 467T808 413T745 384H751Q782 380 802 377T854 362T904 334T937 287T951 217Q951 178 937 143T908 91Q903 86 820 34L734 -21L718 -24Q679 -31 639 -31Q561 -31 451 4T271 40Q190 40 119 -2L99 -13L91 1L84 15L86 16Q88 18 132 42T233 100T315 152Q377 199 386 233Q388 240 393 297T399 363Q399 487 353 551Q337 573 306 597T238 622Q201 622 179 602T157 557T214 476T272 396Q272 371 229 334T143 272T96 246Q95 246 85 252T74 259T95 273T138 306T160 345ZM529 443Q529 409 528 385T526 353L525 346Q526 346 649 390T773 435Q749 451 742 464T727 518Q727 519 725 532T721 548T717 562T712 577T706 589T698 601T688 608T675 614T658 616Q626 616 576 582T525 528Q525 527 526 518T528 489T529 443ZM772 57Q774 57 778 58T792 64T808 77T821 103T827 144Q827 222 784 266T660 322Q652 323 611 323H596Q577 323 535 316L523 314Q520 291 505 255L500 241L356 138L366 137Q443 131 518 110T650 72T748 54Q763 54 772 57",
          120174: "460 -32Q373 -32 305 -11T193 45T122 124T83 214T72 303Q72 395 114 476L119 486L313 592L338 568L359 580Q418 615 479 638T568 668T606 675Q607 675 608 676H610Q612 676 615 661T630 621T660 578Q673 568 694 568Q717 568 721 570H726Q724 565 722 559L717 549L706 545Q608 513 583 513Q568 517 559 522T533 546T493 603L490 609Q452 599 452 558Q452 537 469 481T486 393Q486 353 474 331T422 285T296 231L272 223L262 230L253 237Q279 246 314 274T351 338Q351 376 334 442T316 532Q316 546 319 552Q319 554 316 554Q304 554 288 547T250 523T214 466T199 371Q199 218 299 133T541 47Q571 47 585 51T652 81L712 108Q716 104 716 81L706 74Q695 68 673 54T633 29L550 -22L540 -24Q492 -32 460 -32",
          120175: "380 596Q307 596 250 582T158 546T100 493T67 433T56 373V361Q55 361 43 366L31 372V384Q31 455 69 523T173 627Q213 650 284 666T444 683H452Q629 683 735 629Q896 548 896 369Q896 263 839 163Q835 155 818 140Q746 82 662 27T563 -29Q525 -29 386 16T183 62Q147 62 127 52T63 1L48 -14L40 -4L31 5Q83 73 172 149L186 161H199Q291 161 329 181Q357 199 357 231Q357 258 301 316T245 396Q245 423 282 458T349 512T403 543L413 548L425 545L438 541Q373 491 373 462Q373 446 399 415T453 349T480 288Q480 251 433 212Q394 180 348 156L334 148L353 145Q408 134 513 105T654 76Q711 76 745 132T780 277Q780 434 676 517Q637 549 562 572T380 596",
          120176: "527 55Q574 55 619 69T691 97L717 111V85L562 -18Q520 -29 443 -29Q379 -29 325 -15T235 21T180 61T146 98Q74 186 74 307Q74 395 109 472Q113 482 123 489T190 533Q251 568 295 591L308 598L350 580L361 586Q403 612 464 636T564 673T609 686Q610 686 610 685Q612 683 616 670T627 636T646 601Q666 572 686 572H692Q713 572 726 576H728L725 565L723 554L692 544Q660 535 629 526T595 516Q585 514 574 519Q563 527 543 552T507 597T490 617Q467 604 456 579V564Q456 535 473 471T492 393L494 381L613 460L622 446Q630 433 650 411T696 371L703 365L614 312H596L580 322Q568 329 553 340T528 355T510 360Q496 358 491 354T484 345T471 326T435 297Q408 278 370 261T307 235T277 227Q273 227 266 234L256 240L267 245Q280 251 294 258T330 288T353 336Q353 373 335 444T316 530V537Q316 549 322 567Q270 554 233 499T196 370Q196 253 287 157Q392 55 527 55",
          120177: "424 522Q265 596 208 596Q193 596 180 593T150 579T116 542T89 474Q86 465 86 463L59 481L63 494Q87 578 137 627Q191 684 285 684Q334 684 406 658T538 607T621 581Q644 581 706 629L721 640Q722 640 725 630L727 620Q701 592 654 548T582 486L569 487Q533 490 485 504L468 508Q449 503 429 495T387 466T365 422Q365 373 439 299L453 310Q473 325 528 370L588 418Q614 398 642 368T668 331Q667 331 628 296L590 262L582 274Q557 311 526 311Q511 311 487 297T462 278Q462 277 492 244T551 166T581 88Q581 54 570 25T536 -27T505 -56T478 -76Q376 -146 274 -146H270Q199 -146 162 -118T124 -15Q124 12 128 30T132 96V107Q132 144 117 157Q102 169 85 169Q74 169 59 165T32 156T20 151Q20 152 19 158T17 167Q17 168 17 168T17 169T19 170T22 172T27 175T35 179Q131 230 195 230Q231 230 259 202Q270 190 270 171Q269 150 253 87T236 -16Q236 -67 261 -87T322 -107Q380 -107 428 -68Q467 -35 467 30Q467 60 447 91T383 171T316 251Q290 286 278 308T263 339T261 359Q261 384 284 418Q322 469 424 522",
          120178: "742 611Q784 611 812 631V611Q807 607 783 591T718 544T629 476L606 458Q608 458 628 457T667 453T713 443T762 423T804 388T836 335Q844 313 844 289Q844 231 814 182T746 103Q720 82 655 48T546 -18L520 -21Q456 -29 432 -29Q313 -29 223 33Q204 45 183 65T135 119T91 207T74 320Q74 428 109 480Q116 491 127 497T215 546L308 595L343 583L355 591Q387 613 433 636T488 660H489L491 659Q493 658 495 657T500 655L509 650L500 645Q479 635 460 612T441 552Q441 535 447 498T459 433T466 405L625 513L643 526Q620 530 585 546T535 586Q535 587 532 592T527 602T525 610Q525 613 577 649L630 687Q632 687 638 675T653 649T686 623T742 611ZM349 313Q349 328 327 413T305 510V516Q305 531 308 542T314 559T317 566T315 567Q297 567 270 548Q233 524 212 490T191 392Q191 337 206 288T244 207T284 156T316 128Q410 51 535 51Q632 51 675 102T718 217Q718 269 690 314T599 375Q574 381 535 381Q501 381 477 377L466 376Q469 364 469 349Q469 314 457 295T408 258Q366 236 308 219L288 213L279 220L270 227Q284 232 294 236T309 243T320 252T326 260T331 270T336 281Q349 310 349 313",
          120179: "288 139Q288 172 255 224T189 335T156 442Q156 495 242 579Q289 625 361 668Q364 671 368 673T376 678T380 681L384 683L392 676Q401 670 414 661T443 642T477 626T509 619Q543 619 618 668Q625 672 628 674T631 675Q632 673 633 663T633 651L564 595Q556 589 545 580T528 566T516 556T505 548T497 543T488 539T481 537T472 535T463 534T451 534H442Q385 534 304 581L291 589Q290 588 285 583T277 575T269 566T262 555T257 543T255 529V522Q255 507 260 487T276 446T293 409T311 376L321 359Q321 358 322 358T324 359T327 361T333 366Q386 409 481 460L503 472L543 471Q586 471 599 470Q692 459 714 430Q725 416 738 360T752 245Q752 184 742 127T725 51T703 -8Q700 -13 619 -64T518 -123Q508 -126 493 -126Q438 -126 398 -86L427 -52Q456 -17 457 -17Q460 -17 465 -16H473Q474 -21 481 -32T504 -56T539 -69Q572 -69 599 -34Q625 4 625 158Q625 264 609 311T532 378Q508 386 484 386Q455 386 419 372T360 345T337 330L346 313Q375 263 386 227Q389 215 389 202Q389 192 388 184T384 168T376 152T365 138T350 121T331 103T307 81T278 54L194 -24Q130 30 99 30Q85 30 64 20T31 1T16 -10Q15 -11 13 -7Q12 -6 11 -3Q8 4 6 8L32 35Q88 88 117 107T169 126Q177 126 182 125Q218 118 252 84L263 73Q288 113 288 139",
          120180: "500 615Q523 615 550 628T595 655T614 668L623 654L607 642Q512 569 440 534L427 527L413 529Q384 535 340 547T265 565T209 572Q173 572 145 556T101 522T60 465Q58 460 54 460T41 468L32 477L37 487Q96 599 139 640Q187 681 247 681Q275 681 283 680Q313 674 398 645T500 615ZM418 170Q418 186 410 260T401 382Q403 418 403 424L405 433L415 444Q482 515 571 571L582 578Q591 573 607 568L597 560Q522 504 522 450Q522 427 533 357T545 241V228Q545 190 536 159T508 106T478 73T446 48Q343 -25 238 -25Q179 -25 118 15L107 22L79 5Q51 -12 51 -12L38 2L55 18Q106 67 175 122L192 136Q202 130 206 123Q223 91 252 61Q263 50 266 48T278 39T297 32T320 30Q357 30 389 68Q415 102 418 170",
          120181: "65 510Q68 517 74 528T101 569T144 620T202 661T274 680Q308 680 389 628T503 576Q530 576 596 600Q615 607 616 607Q616 602 615 596V585Q605 581 576 568T531 548T485 531T418 509L400 503L358 522Q347 527 327 537T299 550T277 560T257 568T239 573T220 577T201 578H196Q181 578 169 575T135 554T88 502L83 496Q82 496 74 502T65 510ZM424 4Q424 50 395 151T365 313V320Q365 352 369 361T405 403Q431 432 465 462T521 508T547 525L549 524Q551 524 554 523T560 521L571 517L552 498Q515 461 499 430Q485 399 485 366Q485 326 512 231T539 84Q539 -14 460 -77T273 -141Q248 -141 234 -140T198 -131T160 -106T134 -59Q128 -40 124 -16T117 22T108 49T91 69T59 75T15 65L1 59Q-8 76 -7 77Q4 85 22 97T88 129T170 149Q218 149 234 125Q242 112 242 43V21Q242 -17 248 -41T274 -85T322 -105H325H330Q363 -105 396 -75Q424 -47 424 4",
          120182: "234 109Q234 144 194 245T153 404Q153 445 180 490Q232 572 325 626T517 681H524Q612 681 661 658Q683 647 699 632T717 604Q717 600 708 545L699 490L690 489Q681 488 679 488Q675 488 669 504T640 546T577 592Q520 620 446 620Q415 620 386 614T327 594T280 553T262 487Q262 468 265 447T271 413T279 384T285 362L295 371Q320 396 352 421T439 474T538 502Q577 502 596 484T627 428Q642 386 651 373T677 360H682Q698 360 727 369L724 357Q724 354 724 351T722 346V344Q559 289 539 283Q582 272 589 271L615 265L637 189Q662 109 663 108Q668 97 682 84Q698 68 722 68H730H738Q762 68 799 91L803 80L806 70Q795 59 770 40T703 -3T631 -26Q598 -26 578 -8Q548 24 536 92Q524 154 509 183T477 218T428 224Q409 224 385 220T346 212L331 207Q330 205 330 201T331 189T332 178Q332 158 325 116L305 96Q269 60 240 38Q171 -21 123 -21Q72 -21 33 18L20 32L62 74Q96 107 102 112T116 118Q120 118 122 113T131 95T150 69Q171 48 190 48Q198 48 206 51T224 69T234 109ZM519 367Q497 432 450 432Q379 432 313 333L300 314L304 299Q306 294 309 280T315 260L321 235L542 313Q530 325 519 367",
          120183: "277 226Q277 248 253 286T203 369T178 449Q178 490 212 533T284 607Q380 683 532 683Q610 683 639 660T668 583Q668 568 666 546T663 509Q663 478 683 460Q691 452 719 452L738 450Q732 437 729 437Q728 437 652 416T573 394Q554 394 541 409T527 444Q527 449 532 487T538 542Q536 584 501 606T418 628Q389 628 364 620T317 587T295 523Q295 478 333 401T372 276Q372 269 371 267Q371 264 318 206L264 149Q284 141 317 130T433 101T577 82Q619 82 652 95T701 127T728 164T742 196L744 209Q744 210 749 208T759 203T764 199T760 185T751 154T744 129Q714 42 680 13Q628 -28 566 -28Q490 -28 403 -5T249 42T153 66T106 53T70 15T47 -16Q46 -17 30 -5L39 13Q85 100 138 148L147 156L161 157Q218 165 246 179T277 226",
          120184: "134 338Q134 357 81 417T27 504Q27 516 34 530Q55 568 110 615Q190 683 305 683H314Q445 683 495 580L501 569L512 577Q608 646 681 646Q759 646 801 585L808 576L816 583Q860 619 921 650T1041 682Q1063 682 1077 675T1096 660T1112 631T1132 596Q1160 555 1188 555Q1204 555 1228 564Q1230 565 1231 562Q1231 560 1232 554V547L1215 538Q1179 521 1114 475Q1112 474 1106 470T1099 464T1093 459T1088 452T1085 441T1082 425T1081 404T1079 376T1079 339Q1079 282 1084 236T1098 160T1117 112T1138 85T1159 77Q1166 77 1180 81T1207 90L1219 94Q1220 94 1221 86T1222 76L1045 -32Q1044 -32 1004 15L964 64V167Q965 334 970 372V378L994 402Q1032 440 1057 460Q1061 463 1066 467Q1070 469 1070 470T1068 471T1060 474T1050 481Q1040 488 1021 531T996 583Q979 609 947 609Q922 609 887 592T820 537L821 524Q825 484 825 448Q825 268 768 155L759 137L589 -28L579 -20Q533 17 507 17Q475 17 449 -7L436 -18L424 2L441 20Q446 25 456 36T471 52T484 65T497 79T509 90T522 99T534 106T548 112T561 115T576 117Q602 117 639 86Q648 81 648 81Q650 82 657 94T668 112Q711 202 711 373Q711 484 677 533T600 583Q592 583 583 581T569 577T554 568T542 560T528 549T516 539L519 523Q527 485 527 461Q527 444 522 407Q506 266 447 150L437 130L217 -25L208 -15Q165 28 126 28Q89 28 62 1Q47 -14 43 -14Q42 -14 36 -8L28 0L44 17Q96 73 120 92T166 117Q182 123 204 123Q239 123 284 78L295 67Q307 72 337 102Q400 178 400 346Q400 508 325 571Q270 618 208 618Q180 618 168 614T140 594Q124 578 124 564Q124 540 182 480T240 396Q240 359 197 321Q154 285 94 252L80 245L76 248L67 257L61 262L71 268Q82 275 94 284T120 309T134 338",
          120185: "522 492Q521 492 517 502T512 513Q542 444 542 333Q542 226 503 137L498 125L396 53Q308 -8 292 -17T260 -27Q226 -27 191 -9T136 29L145 39Q162 56 192 89L230 129L235 128H241Q276 57 332 57Q358 57 391 80Q403 89 409 100T422 143T428 227Q428 329 406 408T347 530T272 594T196 615Q152 615 135 596T118 558Q118 535 146 502T203 438T232 385Q232 357 195 322T122 265T83 243Q82 242 72 249T61 258L66 262Q72 265 82 273T103 292Q125 314 125 333Q125 351 101 376T51 432T26 492Q26 549 108 614T290 679Q326 679 335 678Q353 675 370 670T400 658T425 642T445 625T463 606T477 588T487 571T495 556T500 543L504 535L523 553Q553 581 569 595T619 632T686 667T757 678Q778 678 793 675T819 664T833 651T844 633T852 617Q884 548 910 548H916Q938 548 962 556L967 542Q967 540 947 531Q909 509 883 492T847 467T838 458Q825 419 825 328Q825 234 833 191T858 121Q875 94 892 77Q898 71 907 71Q912 71 928 76T957 87T971 91L972 88Q972 84 972 81L973 73L957 63Q891 21 806 -23L794 -30L783 -14Q766 13 728 60L713 79V372L724 384Q743 406 765 427T800 460L813 471Q809 472 806 472Q783 479 766 503T741 551T715 594T672 614Q644 614 622 595Q597 576 572 550T534 508L522 492",
          120186: "254 595Q269 583 269 581L262 577Q256 573 247 566T228 549T212 527T205 502Q205 480 266 386T328 277Q328 234 239 150L221 134L231 133Q264 131 376 99T516 62Q567 50 604 50Q614 50 626 52Q643 57 662 71T703 115T739 198T753 323Q753 454 692 517Q652 555 584 565T382 577Q365 577 357 577H308L300 591L292 606Q292 608 342 665L392 724L403 725Q406 725 411 726H416L417 725L412 715Q408 705 408 698Q408 684 423 679Q431 677 516 672T663 655Q757 634 806 593T873 463Q881 421 881 380Q881 340 874 306Q859 223 809 147Q801 134 789 124Q595 -30 456 -30Q395 -30 289 3T147 36Q134 36 121 33T98 26T76 15T59 4T44 -8T32 -17L22 -7L12 4L56 59L100 114L116 118Q217 142 217 199Q217 230 185 276T120 365T87 430Q87 435 109 464T172 534T254 595",
          120187: "247 398Q247 372 206 334T126 272T83 247Q82 247 72 253T61 261Q60 261 61 262T66 265Q127 306 127 343Q127 364 63 430Q42 451 38 458T33 480V490V497Q33 526 63 567Q112 632 170 660T282 688Q341 688 384 667Q454 633 482 566Q483 565 484 566T496 574Q562 623 630 653Q699 681 751 681Q778 681 797 673Q818 662 830 609Q835 580 843 564Q863 524 895 524H901Q917 524 932 528Q936 522 938 518T942 513T942 511Q873 480 836 454Q789 423 789 395Q789 362 834 298T880 200Q880 170 867 145T820 81Q733 -20 647 -20Q581 -20 499 21V9Q499 -16 502 -53T509 -116L512 -141L370 -223L357 -216Q344 -209 344 -208L348 -196Q370 -113 370 33V52L355 58Q307 76 284 76Q258 76 228 60T183 29T141 -11Q137 -7 133 -2L126 7L134 18Q181 89 210 121T278 170Q304 179 328 179Q336 179 358 177L370 175Q368 268 367 359Q367 416 363 434Q362 438 362 441Q348 527 302 574T203 621Q169 621 148 599T127 557Q127 535 187 476T247 398ZM673 315Q673 357 786 442Q786 443 776 444T750 449T727 462Q719 471 716 484V496Q715 507 715 515Q715 571 698 588Q680 611 643 611Q592 611 547 571Q534 558 511 522L499 505V139L543 123Q702 64 744 64Q770 64 781 79T793 112Q793 143 733 217T673 315",
          120188: "254 595Q269 583 269 581L262 577Q256 573 247 566T228 549T212 527T205 502Q205 480 266 386T328 277Q328 234 239 150L221 134L231 133Q264 131 376 99T516 62Q567 50 604 50Q614 50 626 52Q643 57 662 71T703 115T739 198T753 323Q753 454 692 517Q652 555 584 565T382 577Q365 577 357 577H308L300 591L292 606Q292 608 342 665L392 724L403 725Q406 725 411 726H416L417 725L412 715Q408 705 408 698Q408 684 423 679Q431 677 516 672T663 655Q757 634 806 593T873 463Q881 421 881 380Q881 340 874 306Q864 250 838 196T791 126Q748 93 733 82L715 69Q714 68 723 60T748 40T774 23Q806 2 832 2Q849 2 870 6T904 14L917 17Q917 12 918 6V-3L882 -22Q806 -60 778 -73L755 -83Q640 -36 596 -7L586 0L576 -4Q513 -30 457 -30Q394 -30 289 2T149 35Q119 35 93 22T52 -4T36 -17T24 -7T12 4L56 59L100 114L116 118Q217 142 217 199Q217 230 185 276T120 365T87 430Q87 435 109 464T172 534T254 595",
          120189: "31 498Q34 541 76 586T176 659T279 688H290Q377 688 429 653T506 569L511 558L526 572Q620 663 707 682Q722 685 737 685Q781 685 804 665T830 619T838 565T854 525Q866 511 897 511Q917 511 925 513L937 515Q938 515 941 509T944 501T925 493T870 470T803 438Q735 406 735 401Q735 400 741 399T767 390T814 374L828 367L829 307Q829 233 833 202T852 144Q873 109 896 90Q906 82 928 82T976 95V92Q976 88 978 72L807 -28Q768 39 733 87L718 108V149Q718 230 714 257T693 298Q654 333 580 333Q524 333 520 329Q520 300 489 224T443 133Q441 131 333 53T223 -27Q221 -26 204 -11T169 16T136 28Q110 28 66 -8L56 -16Q52 -13 40 -1L48 7Q165 124 211 124Q232 124 287 77L298 67Q309 73 337 97Q397 150 397 347Q397 419 379 474T330 560T269 604T207 619Q177 619 152 601T126 563Q126 540 185 479T244 387Q240 336 160 289Q144 278 98 255L80 246L62 261L79 272Q96 283 113 301T130 337Q130 353 115 373T81 410T47 451T31 498ZM524 358Q537 358 657 405T777 457Q777 459 768 459Q749 462 738 474T723 499T714 539Q706 585 697 599Q681 618 657 618Q632 618 597 595T532 515L525 502L524 441Q524 375 523 369Q523 358 524 358",
          120190: "457 -31Q356 -31 272 6T135 120T82 304Q82 372 106 430T170 527T241 588T305 626Q341 643 386 657T460 678T495 685T554 660T674 609T778 584Q800 584 818 591T848 610T866 633T878 651T883 659L893 649L901 639Q879 574 803 532T666 490Q661 490 657 490T650 491T641 492T633 495T622 500T610 505T595 513T577 522T554 533T527 547Q436 594 415 602Q393 608 374 608Q303 608 253 545T202 386Q202 229 307 135T568 41Q674 41 748 85T822 198Q822 244 779 283T639 322Q595 322 499 303T383 283Q358 283 335 290T291 318T270 374Q270 418 313 460T424 510H431L435 505L440 500Q425 496 403 475T380 427Q380 382 431 373Q437 372 475 372Q543 372 626 388T742 404Q831 404 868 362T905 260Q905 182 831 108Q692 -31 457 -31",
          120191: "666 641Q737 641 794 686L802 662Q790 648 734 596L677 541L664 538Q630 528 583 528Q540 528 482 537L461 541Q402 512 402 456Q402 427 439 387T512 311T549 253Q549 220 455 139L440 126Q541 75 586 75Q600 75 619 80T654 94T685 110T709 124T719 130Q722 125 725 119L730 108Q700 72 568 -18Q551 -30 542 -30Q495 -30 404 6T270 42H263Q213 42 142 -11L131 -19L129 -8Q126 1 126 4Q218 84 301 126L316 134H406L413 142Q436 165 436 189Q436 202 421 221T364 281Q336 307 318 328T296 356T283 381L290 394Q338 478 410 540Q419 549 417 549Q415 550 369 558T268 575T195 584Q153 584 127 567T100 523Q100 499 116 479T151 447T170 433Q170 429 171 428Q171 427 131 394T88 359Q82 363 73 370T47 403T31 457Q31 513 79 565T197 648T332 679Q369 679 490 660T666 641",
          120192: "273 244Q273 281 244 331T186 428T155 502Q155 524 165 536Q239 634 333 688Q338 684 345 680L356 672L344 664Q310 642 295 624T280 582Q280 550 303 505T348 407T371 300Q371 270 362 248L247 123L358 92Q452 64 484 64Q507 64 523 72Q553 87 573 109Q583 121 586 146T593 283Q594 303 594 344Q594 401 591 461T584 558L581 595Q598 600 623 611T672 634T719 659T754 678L768 686Q770 686 784 673L782 670Q781 668 777 664T768 655Q747 635 738 616T721 535T714 359Q714 205 723 176Q727 164 744 133T771 89Q780 75 804 75Q814 75 853 87L867 92L871 73L671 -39L654 -10Q636 20 619 50T600 83Q600 84 589 75T539 34Q478 -16 475 -19Q469 -22 449 -28T414 -34Q410 -34 394 -32Q356 -28 282 -2L237 15Q169 38 126 38Q106 38 85 27T51 4T37 -8T27 -1T18 8Q18 10 70 63T124 116Q154 123 176 131T223 154T260 191T273 244",
          120193: "133 343Q133 360 79 416T25 496Q25 523 58 563T118 624Q197 685 293 685Q331 685 339 684Q453 665 489 558L493 546Q521 570 553 596T640 653T725 684Q753 684 783 672T844 641T889 618Q895 616 912 616Q924 616 936 617T956 620T965 622T966 612V604L952 595Q924 576 895 549Q864 517 856 496T847 448V434Q847 395 848 388L859 323Q874 241 874 212Q874 142 830 96Q796 62 724 14Q661 -29 603 -29Q555 -29 421 28T242 86Q182 86 110 31Q105 28 102 26T99 25Q88 36 88 42Q95 54 222 142Q252 163 262 165Q319 183 344 218Q378 266 378 377Q378 444 362 494T319 571T266 610T212 623Q181 623 156 603T131 562Q131 539 154 512T206 458T243 416Q246 409 246 399Q246 387 242 377T225 351T178 311T94 259L79 251Q72 256 68 261T62 268L61 270L70 277Q131 318 133 343ZM822 526Q778 531 719 564T628 597Q611 597 579 574Q543 543 513 506L505 495L506 473Q506 469 506 461T507 449Q507 348 467 271L462 261L404 218L348 174Q349 173 356 173Q384 169 450 144L546 105Q665 56 708 56Q737 56 746 72T756 118Q756 129 755 135L741 219Q725 314 725 334V344Q725 416 736 431Q748 450 815 510L832 526H822",
          120194: "133 317T133 338T80 413T26 496Q26 532 83 591Q100 608 111 616T151 644T219 672T304 682Q381 682 434 646T506 564L510 557Q513 557 534 573L677 665L707 683L790 561L803 572Q933 682 1001 682Q1037 682 1098 650T1193 616Q1208 616 1222 619L1235 622Q1239 622 1239 616Q1239 611 1240 609Q1240 608 1206 577T1138 503T1104 430Q1104 409 1123 330T1142 208Q1142 183 1136 147Q1127 118 1117 106Q1114 103 1031 48T935 -14Q930 -18 908 -22T862 -27Q826 -27 759 -6T647 26Q597 38 578 38Q573 38 561 33T533 20T505 4T480 -10L469 -16L452 -26L439 -28Q423 -30 411 -30Q358 -30 279 7T169 45Q125 45 58 -5L47 -14L41 -4L35 8Q35 11 56 29T113 75T181 125L200 139H217Q279 143 320 180T377 270T394 393Q394 453 378 498T334 568T277 605T213 617Q177 617 155 607Q140 600 130 587T119 560Q119 545 137 522T177 479T217 434T236 393Q236 324 98 251L89 246L76 253L63 261Q91 275 112 296ZM1088 526Q1066 526 1004 556T909 586Q863 586 816 539L802 526L804 514Q814 461 814 411Q814 319 781 238Q772 214 760 198T730 165T702 136L715 133Q759 122 848 90T973 57Q1003 57 1017 80Q1022 93 1022 116Q1022 152 1003 241T983 377V391Q983 405 985 409T1002 429Q1019 450 1045 475T1090 514L1107 528Q1104 527 1102 527T1096 527T1088 526ZM699 358Q699 391 696 419T688 467T675 503T660 530T642 550T626 563T608 574T593 582Q581 575 559 554T524 512Q523 510 523 477Q523 315 444 218L435 207L368 169Q301 132 301 131Q307 128 315 125L377 99Q476 57 515 57Q534 57 608 94L627 102L636 111Q699 187 699 358",
          120195: "273 679Q354 674 408 633T477 525L484 533Q496 548 524 574T571 615Q594 633 625 649T675 673T699 681Q724 632 747 607Q754 601 756 599T765 594T777 591T794 590Q818 590 834 594V585L835 577L704 513L693 518Q657 534 631 560T597 599Q596 601 581 584Q495 490 489 379V366H562L681 369Q682 369 679 366T668 355T651 341L620 314H485V295Q490 190 543 125T686 60Q720 60 789 88L801 93V89Q798 83 798 66Q781 59 685 -10L665 -25L634 -30Q596 -35 594 -35Q570 -35 536 -23T477 19Q461 37 445 67T418 118L409 138Q401 131 388 120T340 79T273 28T206 -12T151 -31Q129 -31 90 -12T32 22L113 101Q114 101 120 96T136 84T160 69T189 56T221 51Q256 51 305 90Q376 149 376 301V315H293Q276 315 251 315T210 314T190 313L168 312Q168 313 200 340L231 368L238 367Q275 367 311 366H378V387Q376 470 355 512T291 572Q274 579 252 579Q223 579 197 568T156 544T131 519T117 508Q112 512 108 518L99 527L117 545Q177 604 255 665L273 679",
          120196: "34 496Q34 518 53 549T107 610T195 661T310 682Q357 682 398 663T460 611Q467 600 475 583T489 554T495 542Q495 544 531 570T617 629T700 676L724 688Q742 670 756 657T784 635T806 621T830 606T856 592Q878 416 878 340Q878 154 805 -3L798 -20L779 -40Q706 -113 613 -163T421 -214Q359 -214 317 -196T256 -160L306 -63L313 -64L320 -66L326 -79Q337 -104 349 -120T392 -151T470 -166Q576 -166 644 -101Q750 7 750 292Q750 426 721 495T617 565H611Q563 565 513 509L506 501L508 493Q508 490 509 475T510 445Q510 319 458 236L451 225L436 216Q406 198 365 169T318 134L332 127Q336 126 397 103T489 80H493Q527 80 593 129L604 137L607 127Q610 119 610 116Q610 114 592 95T543 46T484 -4Q450 -27 446 -27Q441 -27 402 -18Q365 -9 290 20T188 50Q135 50 64 -7L52 -17L43 -7L34 2L51 19Q118 87 177 132L192 143H215Q259 145 289 155T335 184T355 214T366 245Q382 306 382 388Q382 426 381 436Q368 520 318 570T214 621Q184 621 165 608T142 583T137 562Q137 541 163 508L201 469Q245 425 251 408Q253 403 253 398Q253 383 240 366T212 335T161 295Q128 271 99 253L89 247L77 256L65 266L76 273Q125 301 134 329Q136 334 136 342Q136 357 124 372T88 410T49 455Q34 479 34 496",
          120197: "278 601Q242 601 212 591T167 570T121 533Q114 528 111 525L93 550Q223 661 244 667Q299 677 356 677Q415 677 456 666T515 634T541 596T549 555Q549 513 529 478T480 421T424 388T377 372Q365 370 365 367Q365 365 389 365T450 358T523 337T588 282T623 183Q624 177 624 161Q624 20 524 -60Q415 -148 285 -148Q242 -148 213 -139Q181 -131 159 -109Q136 -87 127 -56T114 6T104 49Q94 69 57 69Q38 69 13 58L1 53Q1 55 0 59T-3 68T-4 76Q78 130 138 142Q150 144 162 144Q213 144 227 120T242 31Q242 -30 263 -66T345 -102Q397 -102 444 -52T491 107Q491 172 471 211T428 265Q392 288 306 288Q269 288 233 284L218 282Q208 289 208 291L229 324L251 359Q250 360 248 360Q239 360 248 371L256 381H273Q344 385 378 409T413 495Q413 537 384 569T278 601",
          120198: "80 129V151Q80 241 99 363Q99 367 111 372T172 401T285 465L297 472Q340 455 405 443L423 440L455 453Q486 467 489 467L497 461L494 451Q480 390 480 292V283Q480 207 483 155L484 143L535 80L558 90L582 99Q586 95 586 83Q586 81 513 25L443 -29Q410 16 386 40L371 55V61Q371 63 371 67T370 74V80L278 25Q186 -29 184 -31Q182 -32 160 -12T112 35T80 75V129ZM359 366Q334 366 300 371T243 382L221 388Q218 388 212 375T200 323T194 228Q194 191 197 152L198 139L217 120Q245 92 269 74L279 66L304 78Q338 95 349 100L369 110V152Q368 164 368 210T367 275Q367 358 366 361V366H359",
          120199: "99 398Q99 610 86 662Q86 665 95 669T106 674L108 669Q109 664 112 654T119 635Q122 626 125 616T130 601L131 596Q214 649 273 678Q295 690 298 690Q299 690 304 688T313 682L317 679Q275 653 240 612Q210 569 210 469V459Q210 450 210 432T211 406L212 378L285 425Q301 435 321 447T350 466L360 472Q360 473 361 473T368 471T401 456T465 429L501 414V408Q504 386 504 309Q504 255 500 203T491 125T485 97Q485 95 445 74T343 23T237 -24L214 -32Q197 -22 165 3T109 49T87 73Q99 169 99 398ZM386 251Q386 320 380 347V350L305 374L282 382L214 348L213 274Q213 184 214 165V131L230 119Q288 76 349 54Q386 137 386 251",
          120200: "227 393Q215 393 210 351T205 269Q205 161 213 153Q220 145 244 125T290 88L312 72L365 92Q414 113 418 113V93L365 60Q255 -9 221 -26L211 -18Q158 21 91 88L90 107Q87 167 87 225Q87 267 90 302T96 351T100 366L295 473L311 470Q340 464 368 454T410 437T424 429L347 334L342 333H337L325 342Q299 363 271 378T228 393H227",
          120201: "88 117Q88 177 91 231T97 310T102 341Q102 343 118 357T168 397T239 447L257 459L268 454L278 449Q242 416 238 412L219 394Q219 391 216 378T211 349T206 307T203 249Q203 211 206 166L208 148Q224 132 261 108T333 70Q341 66 342 67T350 79Q393 157 393 302Q393 368 388 406V411L371 424Q199 558 101 558Q69 558 28 545L18 542L8 549L-1 557L24 569Q61 587 147 621L177 632Q179 631 194 627T216 621T240 613T269 602T302 589T340 571T382 549T431 522T484 488Q504 475 504 472Q511 449 511 365Q511 248 474 129L468 108L451 96Q427 77 347 28T254 -28Q235 -20 174 21T89 86L88 117",
          120202: "309 69Q391 98 416 108Q418 106 422 100T425 92Q419 86 326 30T229 -27Q228 -27 207 -13T154 27T97 76L85 87L84 106Q81 152 81 194Q81 295 93 359L95 369L286 471L313 449Q376 397 414 372L428 362Q428 360 375 318L188 181V170Q188 156 189 153V148L203 138Q228 119 266 94T309 69ZM209 389Q208 388 204 366T194 307T187 244Q187 225 188 225T201 233L245 261Q283 284 291 291Q324 313 324 316L296 334Q280 343 259 357T224 380L210 390Q209 390 209 389",
          120203: "128 400Q127 401 121 422T108 478T99 540V555L111 569Q135 597 165 626T214 671T235 687L249 678Q263 668 282 659T315 650Q335 650 362 666L372 654L286 569H271Q205 576 173 586V583Q173 558 208 492T252 401Q253 399 310 399T367 398L332 355H254V311Q251 160 235 16Q230 -28 226 -36Q225 -38 221 -45Q171 -140 121 -211L113 -222H104Q94 -222 94 -220Q94 -215 105 -187L121 -145Q139 -80 139 35V93Q139 222 135 314L134 354Q134 355 84 355H35L84 399H106Q128 399 128 400",
          120204: "92 71Q92 74 91 88T88 128T86 183Q86 230 91 275T102 342T109 366Q115 372 207 422T305 472Q407 426 431 426Q435 426 476 445L519 465L525 463L532 461Q497 392 497 268Q496 255 496 233Q496 179 516 92T539 -10L541 -22L526 -38Q441 -126 355 -194L339 -206L327 -207Q324 -207 319 -207T310 -208Q242 -208 171 -179T73 -131L56 -141Q40 -150 38 -150Q17 -140 17 -137Q17 -136 18 -136T98 -79L176 -23Q174 -21 134 24T92 71ZM226 393Q224 393 221 372T214 312T210 235Q210 182 214 144L215 132L230 118Q281 70 301 66Q304 66 331 80T373 105L384 112L383 165Q383 224 387 309Q387 314 387 319T387 329T388 336T388 341V343Q388 344 381 344T339 354T249 384Q246 385 243 386T236 389T231 391T228 392L226 393ZM414 -80Q414 -64 411 -43T403 -1T394 37T386 66T382 79Q381 79 286 15T189 -52Q312 -125 365 -125Q397 -125 405 -115T414 -80",
          120205: "95 661Q95 662 103 667T113 672L126 634L137 596L147 602Q235 656 275 677L292 687L303 680Q305 679 307 677T312 674L313 672L310 670Q307 669 301 667T289 660T274 649T259 634Q250 622 244 611T233 585T226 560T222 528T221 497T220 456T219 413V377L232 384Q244 391 271 409T339 455L362 471L383 461Q425 440 491 415L504 410V406Q507 399 507 269Q507 76 486 -21Q485 -30 483 -33T461 -57Q382 -139 299 -207L281 -197L263 -186L266 -185Q268 -184 280 -177T312 -155Q344 -130 353 -116Q394 -59 394 117Q394 162 391 216T386 301T382 335Q382 338 365 346T323 364T281 376L250 362Q220 347 219 347Q213 336 213 232Q213 177 217 144L218 128L224 119Q244 92 263 71L272 60Q206 21 157 -24Q156 -24 151 -16T132 11T98 52L89 62L91 103Q104 289 104 436Q104 471 103 506T101 568T99 616T96 649L95 661",
          120206: "73 613L164 686L184 666Q200 650 214 637T235 620T242 614T203 577T162 540Q158 540 122 570T73 613ZM92 58Q92 63 94 83T98 142T101 234Q101 318 97 358V366L59 387L40 379L21 371Q20 371 12 376T3 382L38 406Q78 431 125 466L138 477Q149 468 186 444L219 422V389Q215 324 215 247Q215 136 222 123Q226 113 238 98T258 83Q263 83 292 94L322 104Q322 103 324 97T327 89Q327 88 317 82T272 52T190 -7Q166 -25 164 -25L112 35Q92 55 92 58",
          120207: "74 611L155 682Q172 666 186 655T208 636L235 614Q227 606 191 574L154 540L135 556Q101 582 84 601L74 611ZM10 377L144 477Q145 476 184 453T229 428L233 425V416Q238 346 238 252Q238 93 215 -16L213 -30L185 -57Q29 -203 19 -203Q17 -203 -19 -189L-9 -183Q52 -146 78 -116T114 -37Q120 31 120 192V237Q120 327 113 351T72 380L53 372Q34 362 32 364L10 377",
          120208: "106 72Q110 105 111 193T114 294V308H74L34 309L83 346H115V430Q114 591 106 652Q105 662 107 665T114 668T123 672Q125 672 139 635L152 597L154 598Q156 600 160 602T167 607Q193 625 226 644T279 672T302 682L312 676L321 670L312 665Q281 649 263 626T241 587T233 547Q232 541 231 530T230 510T230 501Q231 501 265 522T334 564T369 583L380 570Q428 509 428 481Q428 475 427 470T423 459T416 448T404 434T389 418T369 397T344 371L321 347L365 346H409L372 308H227V294Q227 272 230 208T234 138Q234 136 256 119T302 84L324 68L372 88Q421 108 422 108T432 90L421 83Q373 53 270 -5L234 -25L204 -1Q172 25 124 60L106 72ZM336 434Q336 452 327 472T308 503T297 514Q296 514 290 510T275 499T264 490Q230 458 230 358V346H247Q268 346 276 350T302 372Q328 398 335 423Q335 424 335 428T336 434",
          120209: "111 275Q111 406 108 518T104 650V657Q105 657 109 660T117 665T122 666L133 629L144 594L161 606Q218 642 272 670L294 681Q295 681 300 677T306 672L302 669Q298 666 292 662T278 651T263 637T251 621Q232 587 227 530T222 343Q222 226 230 125L231 112L244 98L258 83Q271 87 285 92L312 102V84Q297 72 231 24T163 -23L100 55Q110 141 111 275",
          120210: "115 203Q115 257 114 291T112 338T111 355Q111 357 93 370L75 384L54 375Q32 366 31 365Q27 365 16 378Q25 383 89 430L152 476Q175 453 228 420Q229 420 229 418T229 410T227 394L225 369Q279 400 315 425T363 461T376 471Q480 424 514 416V412Q514 411 514 404T513 392L511 376L520 382Q529 387 548 399T584 422Q599 432 618 444T648 463L657 469H658Q661 469 681 461T735 440T796 420Q803 418 803 416Q801 414 798 390T791 325T788 247Q788 220 790 172T794 123Q799 115 814 97T835 78H838Q841 78 867 89L895 101Q896 101 896 100T897 92T900 78L873 62Q810 23 761 -12L736 -30Q735 -30 729 -22T707 7T671 48L661 59Q674 93 674 207V219Q674 341 670 344Q655 353 591 372L576 376L544 364Q511 351 510 351Q507 349 507 224V132L535 95Q541 87 548 78T560 63L563 58Q563 57 504 15T444 -28L385 53L387 67Q396 114 396 206Q396 289 393 334Q393 346 390 348Q369 358 306 373Q301 373 265 361L228 349V335Q227 322 227 284Q227 206 231 157Q231 151 231 144T232 133V129Q232 125 259 90Q286 56 286 53Q287 53 284 51T273 43T258 31L173 -31L166 -20Q160 -11 145 7T119 38T108 59Q108 62 110 81T113 133T115 203",
          120211: "608 88Q572 65 535 37T477 -8T455 -25Q432 7 389 53L375 68L378 82Q386 160 386 195V221Q386 284 385 307L384 344Q352 359 306 373L286 379L213 353V273Q214 229 214 161V129L275 62L163 -28L150 -14Q136 0 121 16T91 44Q86 48 86 50Q95 83 96 148Q96 224 89 340L88 366L79 374Q69 384 67 385L64 388L55 383Q52 382 44 378T33 373L21 367L13 374Q5 379 5 381Q5 384 69 428L133 473Q135 473 147 464T179 443T215 424L214 400V376Q271 404 342 457L363 472Q363 473 364 473Q366 473 375 469T418 449T502 414L512 411V407Q502 330 502 217V197V132L523 109Q527 104 533 97T543 87T547 83L550 80L578 92Q603 103 604 103Q606 103 608 88",
          120212: "107 102Q107 178 112 242T123 334T129 362Q129 363 140 368T199 400T315 469L336 482L346 476Q409 439 498 414L514 410L515 389Q515 208 502 141Q494 101 491 94Q490 89 478 81Q430 51 375 23T288 -20T254 -34Q250 -34 200 -1T119 56L108 65L107 76V102ZM389 355Q367 358 346 363T309 372T282 381T264 388L257 390H256Q254 390 249 381T238 348T227 293Q226 280 226 237Q226 183 231 146L232 131L244 122Q285 91 323 74T374 57H377L380 68Q405 154 405 267Q405 315 401 349V354L389 355",
          120213: "66 435Q66 445 117 501T173 557Q174 557 183 555T193 551Q174 526 174 509Q174 496 190 472T233 428V386L377 482L399 471Q450 445 509 425Q519 421 519 420L518 419Q518 418 518 416T517 410Q517 405 518 381T519 335Q519 222 501 137Q492 84 489 84L473 75Q457 66 423 44T354 -6L338 -19L329 -13Q320 -8 313 -4T297 4T284 10T270 14T258 17T245 20T233 22V12L241 -161L214 -172Q187 -184 160 -195T131 -207Q127 -207 112 -202L113 -188Q113 -182 115 -77T118 31Q118 32 109 32Q63 27 23 0L10 -9Q5 -4 -1 8Q1 13 52 57T114 101H115L117 123Q117 141 117 230V359L110 367Q85 394 71 421Q66 433 66 435ZM384 83Q386 83 389 110T396 180T400 254Q400 294 395 339L394 349L379 355Q308 383 294 383Q290 383 263 372L234 360L233 245V130Q270 125 305 113T361 92T384 83",
          120214: "362 -196Q375 -92 375 47V78L282 24Q189 -29 188 -30Q187 -30 139 21T90 75Q87 84 87 158Q88 206 94 259T107 342L113 372L308 478L322 473Q374 452 421 444L433 442L503 485Q515 479 515 477Q485 378 485 56Q485 -100 494 -164V-171L381 -211L371 -207L362 -202V-196ZM280 72Q301 77 323 86T358 101T372 110Q372 268 377 346L378 358H374Q368 360 358 360T323 365T257 380L234 386Q231 386 229 379Q215 353 211 310T207 180Q207 152 208 150Q210 142 235 114T280 72",
          120215: "23 367Q21 370 18 374T14 380L13 382L151 472L236 411L238 381L290 426Q298 432 307 439T322 452T333 461T342 467L344 469Q382 410 404 399Q410 397 416 397Q423 397 432 399T446 403L451 405Q453 405 453 399V393Q430 374 404 356T364 328T350 318L349 317Q321 320 276 356Q257 371 256 371Q253 374 249 366T242 351Q232 321 232 236Q232 214 232 205T232 182T233 162T235 148T238 137T242 129T249 120T257 114T268 105T281 95Q313 70 314 70L358 85Q377 92 389 96T402 100V90L403 80L229 -26L221 -18Q195 6 166 29T121 63T105 76T106 82T110 97T114 121T117 158T119 208Q119 269 114 329L113 341L103 350Q90 362 67 380L45 374L23 367",
          120216: "189 331Q190 304 196 282T207 252T214 244Q239 244 348 292L371 302L382 297Q398 290 415 279T433 265Q442 238 442 166Q442 103 423 45Q416 42 380 29T310 3T244 -26L227 -34Q139 40 73 40Q61 40 48 37T24 30T6 22T-8 14L-13 11Q-14 11 -18 18T-23 26T38 75T102 125Q107 128 146 131H153Q192 131 296 56Q318 40 318 43Q323 48 323 114Q323 157 321 177L319 194Q308 208 291 216T261 225Q239 225 160 185L123 167Q85 205 79 227Q78 230 78 304V377L171 428Q264 479 265 478Q268 478 287 465T334 440T384 427Q423 427 475 463L478 453Q481 446 481 442Q481 439 410 391L339 342H331Q309 345 277 361T222 391T198 406T195 399T191 372T189 331",
          120217: "328 69Q401 102 403 102Q404 102 405 94T406 84Q406 83 318 28L230 -27Q223 -21 206 -5T171 25T132 54L124 60V71Q129 154 129 297V359H43L44 363Q44 365 44 367L45 369L48 372Q51 374 57 378T68 387L90 405H129V553L285 648Q304 641 306 640L260 598V592Q259 589 255 505T249 413V405H353V402Q353 399 328 379L303 360H245V319Q245 150 253 125Q257 115 276 101T311 78T328 69",
          120218: "444 -31Q444 -29 384 66Q382 66 364 58T309 30T231 -17Q214 -29 212 -29L197 -20Q172 -4 140 11T88 34L68 42Q68 43 73 49T85 67T100 98T113 149T118 221Q118 272 105 332L100 356L58 383L23 365L9 379L76 425Q141 472 144 472Q144 471 183 443L221 414V404Q224 365 224 275V253Q224 159 196 113Q191 104 193 104Q203 104 285 72L308 62L374 89L375 106Q375 266 373 340Q373 364 371 396V424L430 445L491 467Q493 467 499 463T505 457Q505 456 503 442Q488 335 488 187V158L529 81L534 80Q541 80 568 90L598 101Q605 94 602 87L524 27Q445 -32 444 -31",
          120219: "95 67Q104 80 104 193Q104 261 100 321L98 355L91 363Q56 402 56 421Q56 441 82 472T132 524T159 546Q174 542 175 542Q159 520 159 501Q159 481 205 432L221 415L220 401Q219 394 219 387L288 429Q309 441 325 451T347 465T358 472T365 476L504 415V409Q504 408 505 374T507 318Q507 155 474 91L469 80L343 26Q314 14 281 0T232 -20L216 -27L202 -15Q192 -5 152 28Q141 35 126 45T103 60T95 67ZM386 349Q302 389 287 389Q271 383 253 375L220 361V136Q226 120 256 100T312 68T342 56Q355 56 360 68Q389 134 389 258Q389 310 386 341V349",
          120220: "90 58T90 59T92 64T97 78T102 105T107 150T109 218Q109 290 103 350V356L83 377Q55 407 55 425Q55 445 138 528Q158 549 162 549L164 548Q165 548 167 548T170 547L175 546L172 540Q168 533 165 523T161 502Q161 479 216 430L229 419V382Q232 382 366 471Q407 445 500 408L511 404V387L512 370L595 420Q678 469 679 469L693 462Q756 431 795 417L815 409L814 380Q812 187 782 96Q774 71 766 62T744 48T684 25T577 -23L557 -32L546 -26Q536 -19 519 -10T481 10T436 31T393 47Q384 50 380 50Q380 52 381 58T384 77T387 104Q391 174 391 256V292L390 333L377 340Q350 357 304 373L294 376L227 355V348Q224 322 224 243Q228 117 232 112L235 108Q238 103 245 95T257 80L281 50Q281 49 227 10T172 -29L159 -13Q133 19 116 36T94 56ZM652 64Q658 64 667 84T685 162T697 303V336L686 341Q653 356 619 367L591 376Q590 376 553 361T514 344T512 324T510 275T508 221Q508 167 510 152T521 126Q537 112 590 88T652 64",
          120221: "8 -90Q8 -68 13 -63Q13 -56 53 -8T120 63L128 71L129 85Q133 120 134 182Q134 308 131 331T106 365Q100 367 97 369L75 381L35 365L20 377Q20 378 47 397T110 440T161 471L253 413V396Q253 378 254 378L309 422Q364 466 365 466Q365 467 366 466T370 461T376 454Q403 419 426 396L441 380L438 377Q438 376 433 372T420 359T404 344L372 314Q351 320 338 327T310 344T277 364Q261 364 252 316Q251 306 251 235Q251 136 255 129Q257 127 258 124T268 113T298 92Q334 68 335 68Q340 70 349 73T377 84T408 95T421 99Q422 99 422 90L423 82L334 26Q246 -28 243 -28L200 8Q156 43 148 43Q144 43 130 36T99 9T83 -36Q83 -67 121 -89T198 -118L237 -124V-129L238 -133L193 -160Q183 -166 171 -173T152 -184L146 -188Q140 -187 131 -185T98 -173T56 -154T23 -127T8 -90",
          120222: "280 53Q272 47 246 27T199 -10T176 -27L167 -18Q137 17 107 44L90 60L93 71Q108 130 109 290V331Q109 339 109 344T108 353T107 359T105 364T102 369T97 374T91 381Q60 412 60 432Q60 448 86 479T138 534L164 557Q168 553 180 553Q163 532 163 511Q165 491 186 468Q206 443 231 423V404L232 385L371 477L389 468Q439 441 498 418L512 412V386Q512 360 507 190T500 14Q488 -26 445 -67Q401 -111 355 -148T282 -203T249 -221Q247 -220 230 -210T213 -199T229 -191T269 -172T306 -151Q361 -120 379 14Q391 92 391 182Q391 218 386 305Q384 339 380 341Q363 353 330 366T288 379Q282 379 258 368L230 356V181V141Q230 127 232 120T236 108T251 89T275 59L280 53",
          120223: "153 371Q141 371 126 365T100 354T78 340L65 331L57 338L50 346L62 356Q133 419 222 471Q274 453 306 422T338 366Q338 356 329 346T283 301L243 264L262 257Q298 246 361 214Q378 154 378 73Q378 33 371 -9T356 -74T345 -104Q340 -106 267 -160L191 -214H177Q60 -214 13 -150Q-7 -122 -7 -115Q-7 -112 19 -77T106 25T241 149Q241 152 227 158T181 173T109 185V190L108 194L158 229Q212 267 223 278T234 306Q234 329 208 350T153 371ZM258 1Q258 42 257 68T254 105T252 118Q235 105 210 85T144 22T102 -45Q102 -79 146 -106T234 -133H238Q248 -128 254 -80Q258 -58 258 1",
          120224: "183 181Q183 179 152 91T118 0H28L154 346L280 693Q281 694 333 694H385L511 349Q636 4 638 2Q638 0 584 0H530L464 183H184L183 181ZM324 606Q319 578 292 492T238 332T210 256Q210 254 324 254T438 255L429 281L419 308Q409 336 395 378T365 465T339 551T324 611V606",
          120225: "425 363Q438 363 465 353T526 324T585 270T610 192Q610 132 561 78T426 7Q404 2 387 2T240 0H90V694H227Q373 693 396 689Q484 673 533 623T583 517Q583 494 574 473T551 437T520 409T487 388T456 374T433 366L425 363ZM490 516Q490 527 485 539T467 568T423 599T347 621Q340 622 262 623H188V399H261H286Q432 399 478 475Q490 496 490 516ZM514 190Q514 245 462 280T343 322Q336 323 259 323H188V71H274Q365 72 388 77Q445 88 479 121T514 190",
          120226: "59 347Q59 440 100 521T218 654T392 705Q473 705 550 680Q577 670 577 667Q576 666 572 642T564 595T559 571Q515 601 479 613T392 626Q300 626 232 549T164 347Q164 231 229 150T397 68Q453 68 489 80T568 120L581 129L582 110Q584 91 585 71T587 46Q580 40 566 31T502 5T396 -11Q296 -11 218 41T99 174T59 347",
          120227: "88 0V694H237H258H316Q383 694 425 686T511 648Q578 604 622 525T666 343Q666 190 564 86Q494 18 400 3Q387 1 237 0H88ZM565 341Q565 409 546 463T495 550T429 600T359 621Q348 623 267 623H189V71H267Q272 71 286 71T310 70Q461 70 527 184Q565 251 565 341",
          120228: "86 0V691H541V611H366L190 612V397H513V321H190V85H372L554 86V0H86",
          120229: "86 0V691H526V611H358L190 612V384H485V308H190V0H86",
          120230: "59 346Q59 499 157 601T384 704Q436 704 466 700T541 679Q551 674 560 670T575 664T583 660T588 658T590 656Q590 652 582 605T573 557L564 564Q489 626 392 626Q301 626 233 549T164 347T233 145T392 68Q441 68 506 84V223H388V299H599V38L588 33Q494 -11 393 -11Q296 -11 219 40T100 172T59 346",
          120231: "86 0V694H190V399H517V694H621V0H517V323H190V0H86",
          120232: "87 0V694H191V0H87",
          120233: "181 53Q200 53 215 56T241 66T259 79T272 95T280 109T285 122L287 129V694H388V415V229Q388 135 385 112T369 63Q364 51 355 39T328 12T280 -12T212 -22Q172 -22 130 -12T66 8T43 20L46 42Q50 65 54 88L58 110Q58 111 65 104Q107 53 181 53",
          120234: "88 0V694H188V519L189 343L525 694H638L375 419L651 0H541L309 351L188 225V0H88",
          120235: "87 0V694H191V79L297 80H451L499 81V0H87",
          120236: "92 0V694H228L233 680Q236 675 284 547T382 275T436 106Q446 149 497 292T594 558L640 680L645 694H782V0H689V305L688 606Q688 577 500 78L479 23H392L364 96Q364 97 342 156T296 280T246 418T203 544T186 609V588Q185 568 185 517T185 427T185 305V0H92",
          120237: "88 0V694H235L252 659Q261 639 364 428T526 84V694H619V0H472L455 35Q453 39 330 294T185 601L181 611V0H88",
          120238: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 193 590 86T368 -22Q239 -22 147 84T55 345ZM276 59T368 59T518 146T576 360Q576 473 525 545T401 634Q371 637 362 637Q284 637 222 562T159 360T217 147",
          120239: "88 0V694H230Q347 693 370 692T410 686Q487 667 535 611T583 485Q583 409 527 348T379 276Q369 274 279 274H192V0H88ZM486 485Q486 523 471 551T432 593T391 612T357 621Q350 622 268 623H189V347H268Q350 348 357 349Q370 351 383 354T416 368T450 391T475 429T486 485",
          120240: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 284 665 231T629 143T587 85T551 48L536 35L648 -120L652 -125H531L452 -8L440 -12Q407 -22 369 -22Q239 -22 147 85T55 345ZM579 345Q579 473 517 555T369 637Q279 637 218 554T156 345Q156 223 215 141T368 58Q376 58 382 58T392 58T397 59T401 60T403 61H404Q404 63 360 128T315 194H421L453 150Q485 105 486 105Q490 108 496 113T517 138T545 182T567 247T579 334V345",
          120241: "88 0V694H227H259H302Q365 694 399 689T474 663Q528 637 558 595T589 504Q589 482 584 462T569 426T547 396T522 372T495 353T470 338T449 328T434 322L429 320L440 300Q452 280 477 238T523 160L617 1L565 0Q513 0 512 1Q512 2 424 156L337 309H189V0H88ZM492 504Q492 600 367 620Q354 622 271 623H189V385H271Q363 386 388 392Q432 402 462 430T492 504",
          120242: "55 514Q55 589 115 652T283 716Q315 716 345 711T396 699T432 685T457 672T467 667Q467 666 459 618T449 568Q383 634 282 634Q214 634 182 600T150 525Q150 507 155 492T172 465T194 446T222 432T247 423T272 416T289 412Q353 396 378 384Q432 358 466 307T500 194Q500 110 438 44T272 -22Q215 -22 159 -5T73 28T44 50Q45 51 49 75T57 122T62 146L65 143Q68 140 74 136T88 125T107 111T131 98T160 85T194 74T232 66T274 63H286Q327 63 366 96T406 182Q406 245 352 280Q329 296 265 310T173 339Q124 363 90 409T55 514",
          120243: "36 608V688H644V608H518L392 609V0H288V609L162 608H36",
          120244: "87 450V694H191V449Q192 203 193 194Q200 148 220 117T266 72T311 54T347 49Q404 49 446 84T501 178Q505 195 505 218T507 449V694H600V450Q600 414 600 356Q599 198 595 181Q594 178 594 177Q575 89 505 34T345 -22Q258 -22 184 34T89 196Q88 205 87 450",
          120245: "14 692Q14 694 68 694H122L146 633Q325 165 339 90Q340 87 341 87Q341 124 530 619L558 694H605Q652 694 652 692Q650 690 523 354T390 10L387 0H279L276 10Q271 18 144 354T14 692",
          120246: "115 694Q115 693 156 550T233 266T270 90L271 85Q272 86 272 92Q272 153 405 616L427 694H524L553 590Q672 174 681 95L682 84L684 95Q689 138 728 287T803 563T841 692Q841 694 885 694T929 693Q929 691 829 346L730 0H679L628 1L606 75Q478 524 470 600L469 611L467 600Q458 518 338 101L310 0H213L114 346Q14 691 14 693Q14 694 64 694H115",
          120247: "14 0Q16 5 144 184T275 367L153 528Q121 571 88 615T42 674T28 694H150L228 584Q315 463 316 461L326 448L497 694H610L609 692Q606 689 492 528Q440 454 409 410T378 366Q378 365 515 182L652 0H531L326 292Q326 293 299 254T226 146L128 0H14",
          120248: "4 693L64 694H125L174 621Q335 378 340 364L341 362Q361 398 395 450L558 694H663L383 277V0H282V278L143 485Q112 531 75 586T21 668L4 693",
          120249: "69 617V694H555V643L373 362Q190 81 190 79H234Q244 79 272 79T344 80T419 81H560V0H55V53L237 334Q420 615 420 617Q413 618 387 618Q380 618 334 618T245 617H69",
          120250: "236 387Q209 387 184 382T141 370T111 355T91 342T83 337L82 355Q80 373 79 393T77 417Q77 419 81 421Q86 423 91 426Q155 460 227 460H238Q319 460 368 400Q393 371 400 341T408 252Q408 240 408 207T407 152V0H317V39L306 32Q244 -10 159 -10H152Q109 -10 77 22Q38 61 38 126Q38 142 39 146Q55 199 130 223T295 252H314V277Q314 305 313 310Q308 342 287 364T236 387ZM303 186Q124 180 124 126Q124 105 144 86T208 66Q284 66 309 124Q314 137 314 166V186H303",
          120251: "303 -11Q280 -11 259 -6T222 6T194 21T176 33T168 38V0H75V694H165V550L166 405Q247 455 336 455Q397 455 439 389T482 226Q482 115 428 52T303 -11ZM390 221Q390 283 361 331T265 379Q214 379 177 342L168 334V118Q203 66 258 66Q316 66 353 106T390 221",
          120252: "34 223Q34 327 99 393T245 460Q290 460 301 459Q328 455 354 445T395 427T410 415L396 338L386 344Q377 349 362 357T335 370Q305 381 258 381H252Q182 381 146 315Q126 275 126 224Q126 158 159 113T255 68Q329 68 394 106L408 114L410 93Q411 72 412 52L414 32Q407 27 394 20T338 2T252 -10Q156 -10 95 58T34 223",
          120253: "33 224Q33 321 81 388T197 455Q277 455 342 414L351 408V694H441V0H348V44L338 37Q278 -10 198 -10Q177 -10 168 -8Q99 11 62 90Q33 148 33 224ZM348 337Q307 378 263 378Q260 378 256 378T251 379Q239 379 223 374T182 355T142 305T126 220Q126 90 225 67Q231 66 250 66H255Q306 66 342 115L348 124V337",
          120254: "28 226Q28 329 91 395T235 461Q258 461 279 456T325 436T368 397T399 332T415 238V219H113V215Q113 163 151 114T248 65Q273 65 298 70T341 82T373 96T396 108L403 113Q403 106 406 76T409 38Q409 34 408 33T393 24Q325 -10 252 -10Q155 -10 92 59T28 226ZM340 289L338 297Q335 305 333 310T327 326T317 343T304 358T286 372T263 381T233 385Q212 385 193 376T162 353T140 325T127 301T123 289H340",
          120255: "262 705H267Q300 705 347 694V612L336 616Q303 628 274 628H266Q224 628 199 605Q187 590 184 579T181 541V507V444H287V371H184V0H94V371H27V444H94V492Q94 544 95 550Q102 617 151 661T262 705",
          120256: "55 286Q55 357 105 406T224 455Q280 455 323 421L322 423L318 427Q318 428 339 434T396 448T465 455H471L478 416L485 377Q484 377 474 379T445 383T401 385Q397 385 391 385T381 384L362 383L357 387Q358 386 364 375T375 354T384 325T389 287Q389 217 340 168T221 119Q178 119 138 142Q133 145 131 143Q125 131 125 117Q125 82 155 72L227 71Q230 71 251 71T280 71T310 69T343 65T373 57T403 46T428 30T449 7Q471 -26 471 -62V-71Q471 -136 384 -178Q326 -206 250 -206Q159 -206 102 -172T30 -92Q28 -84 28 -68T31 -37T40 -12T52 7T64 21T75 31T82 38Q60 68 60 106Q60 145 80 180L86 189L80 199Q55 240 55 286ZM304 233T304 287T279 362T220 383Q189 383 165 361T140 287Q140 243 161 217T220 191Q253 191 278 212ZM250 -134Q298 -134 331 -122T375 -96T387 -69Q387 -21 306 -7Q288 -5 216 -5Q161 -5 153 -7Q146 -9 139 -13T122 -31T113 -66Q113 -75 113 -80T127 -97T166 -121Q203 -134 250 -134",
          120257: "163 395Q223 455 307 455Q417 455 438 354Q442 331 443 164V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V694H163V395",
          120258: "67 576V680H171V576H67ZM74 0V444H164V0H74",
          120259: "88 576V680H192V576H88ZM31 -126Q40 -126 48 -125T62 -122T73 -117T82 -111T89 -105T94 -99T98 -92L102 -86V444H192V180Q191 -45 191 -70T184 -113Q171 -152 140 -178T63 -205Q34 -205 4 -197T-43 -181T-59 -171T-51 -133T-41 -96L-38 -99Q-34 -102 -28 -106T-13 -115T7 -123T31 -126",
          120260: "76 0V694H163V257L340 444H449L286 272L292 263Q296 259 378 138T463 12L471 0H372L309 92Q294 114 277 139T250 179T237 198L228 211L160 139V0H76",
          120261: "74 0V694H164V0H74",
          120262: "160 392Q223 455 304 455Q359 455 386 436T430 383L437 391Q495 455 584 455Q694 455 715 354Q719 331 720 164V0H627V157Q626 315 625 320Q611 378 536 378H530Q501 378 481 358Q457 334 450 301T442 209Q442 198 442 172T443 129V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V450H160V392",
          120263: "160 392Q214 446 283 454Q285 454 292 454T303 455H306Q417 455 438 354Q442 331 443 164V0H350V157Q349 315 348 320Q334 378 259 378H253Q224 378 204 358Q180 334 173 301T165 209Q165 198 165 172T166 129V0H73V450H160V392",
          120264: "28 222Q28 323 95 391T244 460Q275 460 281 459Q364 445 417 377T471 219Q471 124 408 57T250 -10Q158 -10 93 57T28 222ZM377 230Q377 277 364 310T328 358T287 379T248 385Q233 385 219 382T186 369T155 342T132 297T122 230Q122 146 159 108T250 69H253Q263 69 274 70T305 81T339 106T365 154T377 230",
          120265: "166 404Q194 424 241 439T337 455H341Q410 455 451 370Q483 307 483 222Q483 128 433 59T306 -10Q282 -10 260 -5T222 7T194 21T176 33T168 38V-194H75V444H165V424L166 404ZM390 222Q390 287 354 331T266 376T177 340L168 332V118Q200 66 257 66Q313 66 351 112T390 222",
          120266: "33 220Q33 325 87 389T206 454Q286 454 341 406L351 398V455H441V-194H348V41L338 35Q276 -8 198 -11Q171 -11 154 -5Q102 12 68 74T33 220ZM126 220Q126 160 161 113T251 65Q305 65 351 123V298L350 301Q349 304 347 308T342 319T336 331T327 343T315 355T300 365T283 373Q273 375 256 375Q208 375 167 332T126 220",
          120267: "171 389Q237 455 320 455H327V373H317Q262 369 220 336T167 248Q165 239 164 119V0H74V450H159V377L171 389",
          120268: "33 326Q33 376 60 408T117 450T175 460H190Q245 460 272 454T345 429Q345 428 338 388L331 349Q278 386 188 386H183Q119 386 119 336Q119 307 142 295T210 276T278 256Q360 213 360 130Q360 108 354 88T332 43T281 5T195 -10Q152 -10 111 1T49 22T28 35Q29 36 32 56T39 95T43 115T51 110T72 99T102 85T143 73T193 68Q274 68 274 123Q274 152 248 167Q234 178 187 186T115 207Q66 229 46 273Q33 298 33 326",
          120269: "333 27Q333 24 314 16T257 -1T184 -10H172Q146 -10 128 14T105 58T99 91Q95 113 95 251V371H18V444H98V571H182V444H316V371H182V253Q183 128 189 104Q199 68 234 68Q277 72 314 98Q315 93 323 61T333 27",
          120270: "353 39Q352 38 344 34T331 27T315 19T295 11T270 3T241 -3T207 -8T168 -10H162Q148 -10 137 -8T111 2T87 30T74 81Q73 89 73 268V444H166V268L167 92Q171 79 174 74T192 64T238 59Q317 59 344 116Q349 128 349 148T350 291V444H443V0H353V39",
          120271: "178 0Q15 441 14 442Q14 444 60 444Q107 444 107 442Q108 441 136 364T196 194T232 67Q233 98 280 234T356 442Q356 444 401 444T446 442L282 0H178",
          120272: "14 444H105L108 434Q192 160 200 74V65L201 75Q206 144 282 399L296 444H381L399 381Q480 112 480 69L481 70Q481 113 562 386L580 444H668L534 1L483 0H432L429 10Q343 294 338 367L337 377Q336 375 336 370Q336 340 313 250T269 88T245 11L242 0H195L148 1L14 444",
          120273: "187 229L6 444H107L227 294L344 444H393L442 443Q439 437 299 268L267 229L460 0H359L294 88Q280 107 262 131T236 166L227 177L100 0H0Q1 1 47 58T140 171T187 229",
          120274: "113 -204Q83 -204 63 -200L43 -197Q43 -196 40 -157T36 -117L48 -121Q79 -133 114 -133Q124 -133 130 -132T145 -121T163 -94Q169 -82 184 -42T200 1L188 29Q176 57 152 115T107 223T62 330T26 416L14 443Q14 444 61 444H109L122 411Q230 155 236 75L237 65V74Q245 161 348 424L356 444H401Q446 444 446 443L396 313Q345 183 293 49T236 -93Q191 -204 123 -204H113",
          120275: "42 370V444H400V395L156 76L279 77H402V0H28V51L273 371L157 370H42",
          120276: "110 0H86Q42 0 42 27Q42 37 148 350T258 667Q269 687 291 692Q295 694 366 694H399Q432 694 448 689T474 667Q477 663 583 350T690 27Q690 0 642 0H617H592Q582 0 575 1T561 2T549 6T541 11T533 18T527 26T522 37T517 49T512 64T506 81L490 130H225Q225 128 208 79T189 27Q185 19 180 14T170 7T156 3T143 1T127 0T110 0ZM439 279Q359 524 359 547L357 555L355 543Q347 503 270 263L259 231H357Q455 231 455 232L439 279",
          120277: "119 1Q98 5 92 28V667Q98 686 118 693Q121 694 272 694H289H346Q439 694 500 681T600 625Q640 580 640 513Q640 451 601 414T504 364L518 361Q568 351 602 329T649 280T666 235T671 197Q671 172 665 147T642 91T586 37T488 5Q456 1 282 1H119ZM489 509Q489 532 479 548T450 573T421 585T394 591Q387 592 315 593H247V404H298H325Q432 404 466 444Q489 470 489 509ZM517 194Q517 235 502 261T458 299T407 313T353 317H329H322H247V101H319H357Q387 101 407 103T452 111T492 133T514 171Q516 176 517 194",
          120278: "423 -11Q339 -11 275 9T171 62T106 143T71 240T61 347Q61 450 93 527Q157 664 313 694Q357 704 416 704Q479 704 517 699T608 676Q634 667 635 660Q635 653 624 592L612 528L609 524Q604 521 601 521Q595 521 583 531T555 555T505 578T428 589H424Q298 589 250 494Q224 438 224 347Q224 292 233 251T265 175T329 122T432 104Q488 104 524 115T604 158Q607 160 610 162T615 165T619 168L621 170Q625 172 630 170T637 163Q638 160 642 109T647 54Q646 49 625 37T568 11T499 -7Q463 -11 423 -11",
          120279: "119 1Q98 5 92 28V667Q98 686 118 693H124Q131 693 142 693T168 694T200 694T237 694H296Q416 694 450 692T525 677Q732 617 732 342Q732 169 644 81Q593 32 528 16T372 0Q356 0 324 0T276 1H119ZM573 349Q573 387 571 413T559 473T532 527T482 567T403 591Q395 592 320 593H250V101H321Q418 102 456 114Q553 144 569 263Q573 303 573 349",
          120280: "277 122Q280 122 380 123T544 125Q552 125 557 125T565 124T569 124Q595 115 595 75V62V47Q595 9 569 2Q564 0 341 0L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 335 691T554 689Q580 682 580 644V632V618Q580 582 554 573Q553 573 551 573T542 572T527 572Q464 572 364 573T260 575H253V412H385H459Q524 412 536 404T549 357Q549 341 549 334T542 318T523 305Q518 303 385 303H253V122H277",
          120281: "512 572Q451 572 356 573T258 575H253V400H370H431Q494 400 506 392T518 345Q518 307 507 299T437 291H370H253V161Q253 141 253 113T254 75Q254 23 245 12T195 0H170L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 327 691T538 689Q564 682 564 644V632V618Q564 582 538 573Q537 573 535 573T526 572T512 572",
          120282: "61 347Q61 405 70 454T105 550T171 631T276 685T426 705Q483 705 537 693T620 668T650 646Q650 645 649 637T645 612T639 578L627 514L624 510Q620 507 615 507T597 520T566 548T512 577T430 590Q223 590 223 347T431 104Q478 104 506 112Q508 112 508 164V215H471L434 216L428 222L427 268Q427 315 429 318Q432 323 444 323T544 324H652Q655 320 659 317V45L656 43Q654 39 624 27T536 2T424 -11Q366 -11 317 -2T219 33T137 97T82 200T61 347",
          120283: "92 667Q101 694 143 694H172H198Q244 694 251 669Q253 663 253 539V415H540V539Q540 558 540 585T539 621Q539 673 550 683T611 694H621H646Q671 694 683 690T700 669Q702 663 702 347T700 25Q696 9 684 5T646 0H621H606Q560 0 550 11T539 76Q539 85 539 116T540 169V306H253V169Q253 147 253 116T254 75Q254 23 245 12T194 0H170L119 1Q99 7 92 28V667",
          120284: "85 667Q94 694 136 694H165H191Q237 694 244 669Q246 663 246 347T244 25Q235 0 192 0H163L112 1Q92 7 85 28V667",
          120285: "236 -22Q190 -22 144 -11T72 12T46 29Q63 147 69 153Q80 164 92 146Q124 91 191 91Q222 91 242 102T267 134Q268 139 268 402Q268 663 270 669Q275 687 294 692Q298 694 347 694H367Q393 694 406 690T425 669Q427 663 427 399Q427 132 426 125Q421 87 404 58T366 15T318 -9T273 -20T236 -22",
          120286: "92 667Q101 694 139 694H163H186Q225 694 234 671Q236 663 236 529L237 392L533 682Q550 694 590 694H623H681Q695 680 695 672Q695 670 693 664Q688 657 561 533L431 405L698 33Q701 28 701 23Q701 7 683 0H626H604Q571 0 564 2T545 13Q544 14 530 33T489 90T437 162L332 307Q331 307 284 260L236 214V122V65Q236 32 231 19T210 2Q205 0 161 0L119 1Q99 7 92 28V667",
          120287: "92 667Q98 684 109 689T142 694H172H198Q244 694 251 669Q253 663 253 389V116L278 117Q410 119 490 119H495Q511 119 517 115T534 93V63V48Q534 9 508 2Q503 0 310 0L119 1Q99 7 92 28V667",
          120288: "92 667Q98 684 109 689T146 695Q152 695 167 695T192 694Q200 694 214 694T234 695Q291 695 305 664Q313 651 400 419T487 165Q487 162 488 162T489 165Q489 187 574 413T671 664Q679 680 695 688Q708 694 785 694H828Q855 694 867 689T884 669Q886 663 886 347T884 25Q876 0 832 0H817H802Q758 0 750 25Q748 31 748 293V555L746 544Q737 509 692 386T606 160T564 52Q548 22 502 22H487H472Q423 22 410 52Q407 59 367 160T283 385T231 546L230 548Q229 548 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
          120289: "92 667Q98 684 109 689T146 694H185Q273 694 279 692Q301 689 315 669Q322 660 419 453L554 163L562 143Q564 143 564 401Q564 663 566 669Q574 694 618 694H633H648Q692 694 700 669Q702 663 702 347T700 25Q696 10 683 5T642 0H596H551Q520 0 505 4T478 25Q471 34 374 241L239 532Q231 550 231 552L229 479Q229 440 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
          120290: "362 715Q364 715 376 715T394 716H400Q542 716 626 643T727 426Q731 395 731 342Q731 271 722 225Q674 -22 396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715ZM568 433Q551 623 396 623Q383 623 370 622T333 612T292 591T257 550T233 485Q223 442 223 350Q223 276 232 227T267 137Q309 74 397 74Q433 74 461 85T507 113T537 156T556 205T566 260T569 310T570 357Q570 409 568 433",
          120291: "641 470Q641 426 630 391T603 334T561 295T513 271T459 259T408 254T361 253H350H337H253V142Q253 125 253 100T254 67Q254 32 249 19T227 2Q222 0 170 0L119 1Q99 7 92 28V667Q98 686 118 693Q121 694 271 694Q428 693 462 688Q641 656 641 470ZM487 467Q487 495 485 510T474 546T442 578T382 592Q375 593 310 593H250V347H309H339Q364 347 380 348T418 354T451 368T474 395T486 438Q487 444 487 467",
          120292: "450 -20Q444 -20 429 -21T396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715Q364 715 376 715T394 716Q732 716 732 340Q732 268 719 210T686 120T647 68T615 39T601 29T638 -22T676 -73Q679 -78 679 -83Q679 -98 661 -106H593Q526 -106 521 -104Q514 -103 507 -97T496 -84T477 -55L454 -19L450 -20ZM554 509Q516 622 391 622Q294 622 250 535Q220 475 220 345Q220 299 222 266T234 198T258 140T299 99T363 74Q378 71 393 71H395L381 92Q367 114 353 136T338 161Q336 165 336 170Q336 186 352 193L361 194Q370 194 384 194T412 194H452Q457 194 460 194T466 194T471 192T476 191T480 188T483 185T487 180T492 174T497 167T504 158L526 129Q532 127 552 175Q573 231 573 348Q573 455 554 509",
          120293: "654 24Q654 9 644 5T612 0H577L521 1Q509 5 503 13Q498 20 421 160L343 304H250V168Q250 147 250 118T251 78Q251 24 242 12T192 0H168L119 1Q99 7 92 28V667Q98 686 118 693H124Q131 693 141 693T165 694T195 694T229 694T280 694T332 695Q389 695 428 691T510 675T582 637T627 569Q641 532 641 493Q641 377 537 331L497 317L493 316L571 177Q653 28 654 24ZM487 472T487 492T485 525T476 553T450 577T404 591Q398 592 322 593H250V391H321Q327 391 353 391T385 392T412 395T438 401T457 412T474 430T483 456",
          120294: "61 503Q61 547 72 583T110 650T186 698T305 716Q405 716 496 671Q513 664 514 657Q514 656 513 648T509 623T503 589L491 525L488 521Q484 518 479 518H475L461 532Q430 565 395 581T305 598Q201 598 201 523Q201 480 240 462T345 431T443 394Q549 324 549 204Q549 160 538 123T502 51T427 -2T308 -22Q180 -22 69 41Q50 52 49 57Q49 58 50 66T54 91T60 125L72 189L75 193Q80 196 84 196Q87 196 104 182T145 149T212 117T304 102Q408 102 408 188Q408 215 396 234T362 263T319 278T267 290T219 302Q149 324 105 380T61 503",
          120295: "67 687Q70 688 366 688Q661 688 666 686Q692 680 692 641V629V615Q692 579 666 570H660Q655 569 648 569Q645 569 624 569T581 570Q505 570 475 572H447V302Q447 31 445 25Q436 0 393 0H364L313 1Q293 7 286 28L285 300V572H257Q227 570 151 570Q130 570 109 570T84 569Q77 569 72 570H66Q48 577 44 588T40 631L41 661Q47 680 67 687",
          120296: "92 667Q101 694 143 694H172H200Q242 694 251 671Q253 663 253 430Q254 189 255 185Q262 134 288 107T384 79Q498 79 516 168Q520 191 521 431Q521 663 523 671Q532 694 572 694H596H618Q639 694 648 692T665 679Q671 672 671 653Q672 632 672 555V432Q671 200 670 190Q652 79 581 29T383 -22Q137 -22 98 166Q92 195 92 303V667",
          120297: "27 667Q27 683 39 688T75 694H101Q155 694 159 692Q182 687 194 665Q202 652 283 419T374 142Q376 165 473 445Q552 664 553 666Q568 694 618 694H639H658Q681 694 693 689T705 667Q705 660 592 347Q481 32 477 28Q466 7 441 1H292Q266 7 255 28Q251 32 140 347Q27 660 27 667",
          120298: "994 694Q1012 683 1014 668Q1014 661 977 519T896 217T845 26Q831 0 783 0H747H711Q685 0 672 5T649 26Q644 36 583 272T517 548Q516 552 516 551Q503 479 437 227Q389 37 383 26Q367 0 323 0H288H254Q207 0 193 26Q191 32 108 346T24 665Q24 685 44 693Q47 694 98 694H115Q152 694 168 668Q174 657 235 417T297 144Q297 134 300 153Q307 204 362 421T427 668Q441 694 488 694H523Q586 694 597 688Q612 683 620 661T651 549Q664 496 673 462Q744 194 750 146V140Q767 223 800 354T857 576T883 668Q897 694 938 694H958H994",
          120299: "52 1Q37 11 37 23Q37 26 39 32Q39 34 158 202L275 369Q275 370 221 441T112 586T55 663Q53 669 53 672Q53 687 68 693H72Q77 693 84 693T99 694T118 694T139 694H176Q203 694 212 692T230 682Q231 681 239 669T265 634T296 591L358 504L418 591Q481 682 486 686Q491 691 499 692Q505 694 569 694H632Q650 685 650 672Q650 667 646 660Q643 654 592 582T491 440T441 369T566 201T693 29Q694 27 694 23Q694 11 677 0H607L537 1Q523 6 519 10T437 131Q422 153 411 170T390 200T375 222T365 237T359 245L357 247L348 232Q339 218 319 188T283 131Q222 37 211 22T186 1H52",
          120300: "635 694H668Q688 694 698 690T708 670Q708 664 704 658L446 278L445 152V27Q442 20 440 17T433 9T419 1L368 0H339Q316 0 305 5T288 26Q286 31 286 154V278L157 468Q135 500 101 550Q43 635 34 650T24 671Q24 686 39 693Q42 694 105 694H122H132Q163 694 180 689T214 666Q225 654 336 485Q373 425 373 420L374 418Q375 419 375 421Q378 432 418 493T496 609T536 667Q543 676 551 681T572 689T591 693T615 694T635 694",
          120301: "411 584Q243 581 131 581Q122 581 116 581T106 582T102 582Q84 589 80 600T76 640L77 667Q83 686 103 693Q106 694 343 694Q579 694 584 692Q592 691 599 684T609 668Q610 665 610 646Q610 614 608 608Q605 603 434 361L261 116Q340 117 402 118T490 119T533 120T560 120H572Q605 120 614 95Q616 89 616 60V46Q616 9 590 2Q585 0 339 0Q92 0 87 2Q79 3 72 10T62 26Q61 29 61 49Q61 84 63 90Q65 94 152 217T325 461T411 584",
          120302: "255 394Q218 394 186 383T138 358T109 333T94 321H91Q88 321 86 322T83 325T80 331T79 339T78 349T77 362T75 377Q72 410 72 420Q72 423 72 425T73 429T74 431T77 433T80 435T85 437Q166 475 262 475Q360 475 413 440Q462 406 471 341Q472 332 472 181Q472 155 472 119T473 73Q473 20 462 10T398 0H380Q349 0 337 8T324 48V65Q298 30 257 10T172 -11Q109 -11 70 37T31 145Q31 276 307 289H321V309Q321 337 318 352T300 381T255 394ZM176 146Q176 116 190 97T231 77Q251 77 266 85Q322 110 322 185Q322 189 322 192T322 198L321 201V234L308 232Q176 220 176 146",
          120303: "54 667Q63 694 102 694H127H151Q190 694 199 671Q201 663 201 544L202 422L211 428Q270 468 355 468Q523 468 523 231Q523 -10 321 -10Q286 -10 261 -2T204 33Q197 11 187 6T142 0H126L81 1Q61 7 54 28V667ZM372 230Q372 317 355 349T280 382Q251 382 204 356V107Q235 76 274 76Q301 76 320 84T349 105T364 139T371 180T372 230",
          120304: "188 233Q188 199 190 177T200 131T225 95T271 83H281Q356 83 421 130Q433 138 434 139Q446 141 448 131Q449 128 453 84T457 36Q455 30 432 20T364 -1T273 -11Q37 -11 37 232Q37 456 244 474Q246 474 257 474T276 475Q349 475 400 455Q443 436 448 431L451 425Q451 419 443 377Q442 372 441 366T439 356T438 348T436 340T435 334T433 330T431 327T429 325T426 324Q420 324 406 336Q376 362 350 372T281 382Q254 382 236 373T208 352T194 317T189 278T188 233",
          120305: "225 -11Q192 -11 164 -3T104 29T55 102T37 227Q37 321 63 376Q111 469 223 469Q292 469 349 433L359 426V546Q359 564 359 589T358 623Q358 675 369 684T433 694H451Q497 694 505 669Q507 663 507 347T505 25Q500 9 487 5T450 0H432H413Q356 0 356 36V40Q298 -11 225 -11ZM356 359Q326 382 286 382Q239 382 215 358Q189 330 189 256V229V203V195Q189 102 231 86Q251 76 274 76Q318 76 356 114V359",
          120306: "30 231Q30 301 51 351T107 426T181 463T262 474H268Q293 474 312 472T366 459T422 427T462 363T480 260Q480 230 466 222T405 213Q395 213 364 213T311 214H173V211Q173 183 183 148T216 96Q244 76 287 76Q319 76 350 85T399 104T433 125T451 136Q463 138 465 128Q466 125 469 84T473 39Q471 29 423 13T330 -9Q321 -10 286 -10Q213 -10 161 11T81 68T42 144T30 231ZM353 292Q350 324 342 344T320 373T294 384T264 387Q191 387 175 286V282H353V292",
          120307: "67 458H78V502V509Q78 538 79 556T90 604T117 651T169 685T253 704Q254 704 258 704T265 705T275 705T287 704Q364 704 381 687V638V607Q381 591 378 585T366 579Q362 581 351 591T323 610T282 618Q238 618 226 587Q224 581 223 519V458H253Q288 458 298 453Q315 441 315 415Q315 399 312 390T299 377T282 372T259 371H255H226V201Q226 31 224 25Q215 0 174 0H150L106 1Q86 7 79 28L78 199V371H69Q29 371 29 412Q29 425 30 431T40 447T67 458",
          120308: "63 108Q63 142 83 176L76 184Q35 227 35 300Q35 469 243 469Q330 469 385 437L397 443Q451 469 508 469Q515 468 517 466T522 456T528 425Q534 392 534 386Q532 379 523 377Q520 377 509 381T477 390T431 398L425 399Q453 362 453 297Q453 268 445 242T417 189T351 146T242 130Q169 130 119 153Q117 141 117 136Q117 95 155 83Q161 81 252 81Q354 80 362 79Q437 71 475 48T526 -24Q532 -42 532 -65Q532 -116 489 -156T341 -204Q323 -206 274 -206H256Q39 -206 18 -84Q17 -79 17 -68Q17 15 82 42L76 53Q63 79 63 108ZM310 300Q310 359 298 377T238 396Q217 396 204 390T186 368T179 339T178 300Q178 245 189 224T244 203T299 224T310 300ZM414 -66Q414 -55 411 -47T401 -32T387 -21T368 -14T346 -10T322 -7T297 -6T271 -6T246 -6H193Q163 -6 154 -10T140 -30Q135 -45 135 -62Q135 -134 274 -134Q414 -134 414 -66",
          120309: "53 667Q62 694 101 694H126H148Q191 694 198 669Q200 663 200 526V390Q263 469 361 469Q390 469 412 465T456 449T491 413T507 351Q508 342 508 185Q508 31 506 25Q498 0 450 0H432H413Q368 0 359 23Q357 31 357 186Q356 345 355 350Q349 369 336 376Q324 381 301 381H298Q269 381 242 362Q217 342 210 316T202 239Q202 229 202 202T203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V667",
          120310: "72 574Q55 583 51 591T46 619V636L47 670L48 673Q50 676 52 678T56 684T63 690T73 694H81Q89 694 102 694T129 695H181Q193 687 196 685T203 676T207 661T208 634Q208 603 204 593T181 574H72ZM54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
          120311: "70 634V648Q70 686 96 693Q100 695 151 695H176Q201 695 213 691T230 670Q232 665 232 634V620Q232 582 206 575Q202 573 151 573H126Q101 573 89 577T72 598Q70 603 70 634ZM-41 -84Q-1 -105 28 -105Q67 -105 78 -85Q83 -77 83 -48T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -62 -124T-52 -89Q-49 -84 -41 -84",
          120312: "496 23Q496 9 487 5T457 0H427H398Q367 0 354 11Q352 12 288 99L226 183L191 150V90V54Q191 30 186 18T165 2Q160 0 124 0L90 1Q70 7 63 28V667Q72 694 108 694H128H146Q183 694 192 671Q194 663 194 496L195 325L254 383Q266 394 281 409T301 429T316 441T329 450T341 455T357 458T376 458H409H436Q461 458 470 454T480 437Q480 430 477 427T445 395Q417 368 396 347L319 271Q319 270 358 217T442 103T494 32Q496 30 496 23",
          120313: "54 667Q63 694 102 694H127H149Q192 694 199 669Q201 663 201 347T199 25Q190 0 149 0H125L81 1Q61 7 54 28V667",
          120314: "197 386Q256 468 366 468Q404 468 430 461T471 438T491 413T503 385Q563 469 666 469Q731 469 769 446T814 350Q815 343 815 185Q815 31 813 25Q808 9 796 5T758 0H737L692 1Q672 7 665 28L664 186V206V290Q664 349 655 365T610 381Q581 381 560 370T529 341T515 311T510 291Q509 286 509 157V82Q509 24 501 12T452 0H431L386 1Q366 7 359 28L358 186V206V290Q358 349 349 365T304 381Q275 381 254 370T223 341T209 311T204 291Q203 286 203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V437Q58 453 80 464H122H142Q167 464 178 460T195 439Q197 434 197 409V386",
          120315: "197 386Q264 468 350 468Q375 468 390 467T429 460T466 443T492 408T507 351Q508 342 508 185Q508 31 506 25Q498 0 450 0H432H413Q368 0 359 23Q357 31 357 186Q356 345 355 350Q349 369 336 376Q324 381 301 381H298Q269 381 242 362Q217 342 210 316T202 239Q202 229 202 202T203 157V82Q203 24 195 12T146 0H125L80 1Q60 7 53 28V437Q58 453 80 464H122H142Q167 464 178 460T195 439Q197 434 197 409V386",
          120316: "274 -11Q32 -11 32 225Q32 346 85 406T249 474H266H271Q302 474 325 471T385 458T451 419T498 346Q518 300 518 225Q518 -11 274 -11ZM367 233Q367 322 350 354T270 387Q240 387 222 377T195 344T184 298T182 233Q182 151 198 117T275 83H282Q318 83 339 104Q355 119 361 146T367 233",
          120317: "125 458H139Q174 458 185 452T202 420L211 426Q245 448 288 458T354 469Q356 469 361 469T369 468Q443 468 481 412Q523 355 523 223Q523 164 509 120T473 51T423 12T371 -7T323 -11Q260 -11 204 33V-65Q204 -80 204 -102T205 -131Q205 -162 200 -175T178 -192Q173 -194 126 -194L81 -193Q61 -187 54 -166V431Q58 447 81 458H125ZM372 230Q372 376 282 376Q247 376 204 352V107L208 103Q213 99 218 95T232 87T251 79T274 76Q323 76 349 116Q372 153 372 230",
          120318: "226 -11Q37 -11 37 236Q37 294 51 338T86 407T135 445T186 464T233 469H235Q300 469 349 422L359 413V425Q359 452 376 464Q384 469 433 469H455Q498 469 505 444Q507 438 507 137Q507 -163 505 -169Q500 -185 487 -189T450 -194H432H413Q367 -194 358 -171Q356 -163 356 -63V40L348 33Q296 -11 231 -11H226ZM281 375Q188 375 188 228Q188 77 275 77Q322 77 359 120V328Q338 357 324 366T281 375",
          120319: "54 437Q58 453 81 464H122H147Q186 464 194 439Q196 434 196 405V377L203 387Q245 456 324 468Q325 468 331 468T340 469Q347 469 356 462V360Q350 355 346 354T339 353T326 353T300 347Q260 337 234 311T202 252Q201 247 201 138Q201 122 201 98T202 66Q202 33 197 20T175 2Q170 0 125 0L81 1Q61 7 54 28V437",
          120320: "37 328Q37 392 75 433T203 474Q254 474 265 473Q319 465 370 442Q378 439 380 432Q380 426 372 384Q364 336 359 333Q358 331 355 331Q348 331 337 341Q282 388 216 388H208Q190 388 180 387T161 377T151 351Q151 333 164 323T224 306L267 297Q314 285 355 246T396 144Q396 17 282 -5Q260 -10 218 -10Q170 -10 124 2T55 26T30 44Q30 48 39 99T49 153Q52 159 60 159Q66 159 70 153Q100 120 133 101T218 82Q231 82 238 83T258 87T277 101T283 126Q283 149 260 160T200 176T153 186Q109 201 73 236T37 328",
          120321: "225 267Q225 202 226 169T232 115T244 88T265 82Q295 84 318 100T345 116Q352 116 354 110T364 77Q373 46 373 43Q373 28 312 9T190 -10Q160 -10 139 1T107 29T89 77T82 136T80 210V258V371H66H59Q39 371 27 386Q20 394 20 417Q21 432 23 437Q35 458 60 458H65H83V510L84 562Q93 589 131 589H154H174Q216 589 223 564Q225 558 225 508V458H274Q330 458 338 453Q355 441 355 415Q355 388 338 376Q330 371 274 371H225V267",
          120322: "53 431Q62 459 100 459Q105 459 114 459T127 458H152Q192 458 201 435Q203 427 203 262Q204 86 208 77Q209 74 216 71Q227 66 258 66H264Q334 66 354 140L356 150L357 290Q357 427 359 435Q365 449 377 453T412 458H432H450Q498 458 506 433Q508 427 508 229T506 25Q498 0 451 0H434H418Q386 0 374 7T360 43V58L352 49Q298 -11 199 -11Q135 -9 101 11T56 80Q52 100 52 273L53 431",
          120323: "26 429T26 435T32 448T44 456Q48 458 85 458H99Q145 458 161 431Q162 429 207 285L251 145L294 284Q333 410 341 430Q351 451 374 456Q379 458 420 458H430Q450 458 457 456T471 443Q473 437 473 435Q473 426 443 325T381 126L350 28Q339 7 316 2Q312 0 250 0Q187 0 183 2Q160 7 149 28L136 68Q124 109 106 166T70 283T39 385",
          120324: "699 458Q717 447 719 432Q719 426 666 230T610 27Q602 10 588 5T548 0H512H482Q431 0 420 17T384 135Q356 241 352 298V308L351 295Q348 251 322 145T290 28Q279 0 233 0H212H191Q146 0 133 27Q130 33 77 229T24 430Q24 449 44 457Q47 458 79 458Q122 458 126 456Q154 450 163 419L233 153Q241 187 272 304T307 431Q318 458 368 458Q394 458 398 456Q421 451 430 431Q434 423 509 147L547 286Q582 416 588 429Q600 454 624 457Q632 458 647 458H663H699",
          120325: "92 0Q87 0 77 0T62 -1Q24 -1 24 22Q24 29 33 41T106 136Q185 237 184 238Q184 239 147 284T73 376T33 427Q31 430 31 436Q31 451 45 457Q48 458 96 458H122Q152 458 163 450T208 394L247 345L282 394Q288 403 297 416T309 434T319 444T328 452T338 455T352 458T372 458H393H440Q457 449 457 435Q457 428 450 419T379 328Q308 239 308 237L389 137Q409 112 436 79Q475 31 475 23Q475 -1 436 -1Q432 -1 422 -1T407 0Q360 0 352 3Q343 6 336 16T291 83L247 151L245 148Q243 145 239 139T229 124T218 106T204 84Q167 24 160 15T141 1L92 0",
          120326: "454 458Q473 446 473 430Q473 426 394 184L311 -68Q291 -119 245 -162T123 -205Q51 -205 46 -190Q44 -187 40 -142T36 -92Q36 -90 36 -88L37 -87Q41 -80 46 -80Q48 -80 73 -92T126 -105Q146 -105 161 -98T185 -76T197 -53T206 -28L215 0L122 212Q29 427 29 435Q29 448 46 457Q49 458 91 458Q93 458 106 458T125 457T140 454T157 446T170 431Q183 410 224 305T266 158Q266 152 266 151Q267 151 268 163Q271 206 302 310T342 432Q354 458 398 458H418H454",
          120327: "268 376Q250 376 180 375T92 374Q69 374 63 380Q46 390 46 419Q46 428 49 437Q57 451 73 457Q76 458 242 458T413 456Q420 455 427 448Q439 438 439 413Q439 392 433 385Q432 383 318 236T204 88Q235 88 306 89T395 90H399Q408 90 414 89T427 84T438 70T442 45Q442 9 416 2Q411 0 236 0H136Q73 0 62 1T41 12Q31 23 31 47Q31 68 36 77Q37 78 51 97T96 155T153 228L268 376",
          120328: "28 0L429 694H533L585 350Q596 275 610 182T632 46L638 3V0H530L528 18Q527 25 515 103T503 183H223L135 29L118 1L73 0H28ZM492 254Q492 256 473 398T454 589V610Q433 552 290 301L264 255L378 254H492",
          120329: "501 363Q557 355 605 316T653 222Q653 148 586 85T403 2Q394 1 240 0Q90 0 90 1L100 46Q109 90 128 177T164 348L238 694H375Q518 693 546 688Q614 674 655 635T696 544Q696 490 648 441T516 368L501 363ZM601 530Q601 568 566 590T479 621Q472 622 394 623H320L297 513Q292 489 286 459T276 415L273 401V399H339H372Q504 399 571 466Q601 498 601 530ZM257 322Q256 320 230 197T203 73Q203 71 289 71Q379 72 387 73Q459 84 507 122T556 210Q556 255 519 283T428 320Q415 322 336 323Q257 323 257 322",
          120330: "124 266Q124 372 179 473T333 639T544 705Q592 705 635 697T698 679L718 670Q719 669 701 621T681 572L676 576Q670 580 661 586T641 598T614 611T583 620Q558 625 526 625Q406 625 318 516T230 276Q230 238 236 212Q251 148 294 108T412 68Q469 68 508 80T598 123Q608 129 608 128Q606 109 603 87L598 45L573 33Q521 7 486 -1T394 -10Q358 -10 346 -8Q260 5 202 62Q124 145 124 266",
          120331: "162 348L236 694H385Q535 693 543 692Q600 682 641 654T705 586T737 506T747 425Q747 296 672 187Q625 114 548 62T384 1Q376 0 262 0Q88 0 88 1L98 46Q107 90 126 177T162 348ZM622 533Q575 624 443 624Q434 624 419 624T399 623H321L263 348Q249 283 234 213T212 107L204 72Q204 71 289 71Q374 72 386 74Q501 94 573 193T646 422Q646 487 622 533",
          120332: "86 2Q88 4 160 346T233 689Q233 691 461 691Q688 691 688 689Q685 686 671 611H495L320 612L319 609Q319 607 297 501L274 397H436Q597 397 597 396L596 391Q595 386 593 376T589 358L581 322L420 321Q258 321 258 320Q209 89 208 87Q208 85 390 85Q417 85 460 85T518 86L572 85Q556 8 554 2V0H86V2",
          120333: "86 2Q88 4 160 346T233 689Q233 691 453 691T673 689Q670 686 656 611H488L320 612Q314 579 302 523T281 427T272 385Q272 384 419 384H567L551 308H255L223 156Q216 124 207 82T194 20L190 2Q190 0 138 0H86V2",
          120334: "125 267Q125 375 182 476T337 641T544 705Q598 705 644 693T710 669T730 655L712 609L693 560L692 557L681 567Q618 626 526 626Q447 626 378 573T269 440T229 277Q229 185 276 127T406 68Q422 68 451 71T502 78T524 84L526 93Q528 102 532 119T539 153L553 222Q553 223 495 223Q436 223 436 224Q436 230 444 262L452 299H662V296Q661 290 635 166T607 40Q606 37 576 25T492 1T391 -11Q272 -11 199 66T125 267",
          120335: "517 2Q518 3 551 161T585 322Q586 323 557 323T422 323H259L190 0H138Q86 0 86 1L96 46Q105 90 124 177T160 348L234 694H337V691Q336 690 306 545T275 399H602L603 403Q603 407 634 551L665 694H768V691Q768 690 695 348T621 2V0H517V2",
          120336: "161 348L235 694H338V691Q338 690 265 348T191 2V0H139Q87 0 87 1L96 46Q106 90 125 177T161 348",
          120337: "377 424L435 694H535V691Q534 685 476 412T416 135Q401 74 350 26T210 -22Q165 -22 124 -11T65 9T46 21L54 41Q62 61 70 83T81 109Q82 111 85 106Q86 105 87 103Q93 94 103 84T135 64T185 53Q238 53 272 76T317 142Q317 145 325 182T348 289T377 424",
          120338: "236 223Q235 222 213 113T188 2V0H138Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H285Q335 694 335 693L330 671Q326 649 316 603T298 518Q289 477 280 433T266 366L261 343L672 694H729L784 693L465 420L651 0H596L541 1L384 350Q383 351 310 288T236 223",
          120339: "161 348L235 694H338V691Q338 690 273 385T208 79Q278 80 362 80H516Q502 11 499 2V0H293Q87 0 87 1L96 46Q106 90 125 177T161 348",
          120340: "375 691Q456 215 459 124V106Q488 177 762 641L793 694H929V691Q929 690 856 348T782 2V0H689V2Q691 4 753 304Q817 604 818 606Q819 611 817 608Q817 607 815 603Q798 559 540 117L484 22H440L397 23L393 42Q393 47 373 169T334 422T315 594V609L250 306Q186 3 185 2Q185 0 138 0Q92 0 92 1L102 46Q111 90 130 177T166 348L240 694H375V691",
          120341: "311 609Q310 608 246 306T181 2V0H134Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H382L383 691Q383 688 418 561T493 286T541 97L544 84L545 89Q545 90 553 128T578 246T610 394L674 694H766V691Q766 690 693 348T619 2V0H472L469 13Q468 17 393 293T312 605L311 609",
          120342: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 321 706 215T555 43T362 -22Q256 -22 187 56T118 254ZM380 58Q452 58 518 116T622 263T661 442Q661 496 646 535T608 594T567 622T534 634Q516 636 496 636Q400 636 313 528T225 264Q225 172 267 115T380 58",
          120343: "162 348L236 694H378Q522 693 530 692Q604 680 647 635T690 524Q690 474 665 430T612 359Q550 299 465 280Q443 275 343 274H250V271Q250 269 235 201T206 68T192 2V0H140Q88 0 88 1L98 46Q107 90 126 177T162 348ZM594 513Q594 560 562 588T477 622Q470 623 394 623H321L293 487L263 349V347H342H347H375Q530 347 578 449Q594 483 594 513",
          120344: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 305 693 194T543 36Q547 29 586 -47T625 -125H504L450 -8Q406 -22 363 -22Q256 -22 187 56T118 254ZM661 437Q661 532 616 584T506 636Q428 636 361 578T257 433T220 258Q220 167 264 113T380 58Q390 58 397 58T408 59T413 60T417 61Q417 63 387 127T356 193Q356 194 409 194H462L485 150L508 105Q509 103 532 125T567 161Q661 278 661 437",
          120345: "162 348L236 694H375H414H445Q507 694 538 690T606 668Q698 623 698 534V528Q698 447 608 377Q582 358 555 345T512 326L497 321L617 0H565L513 1L402 309H255L189 0H138Q88 0 88 1L98 46Q107 90 126 177T162 348ZM603 525Q603 603 499 620Q486 622 403 623H321L297 506Q292 482 285 449T274 402L271 387V385H346Q350 385 363 385T386 384Q548 384 592 479Q603 503 603 525",
          120346: "161 478Q161 568 242 642T435 716Q527 716 599 673L609 667Q595 633 589 615L571 568Q570 568 564 575T546 592T518 611T475 628T417 635Q351 635 305 596T259 507Q259 465 290 444T372 411T432 396Q473 385 509 343T545 236Q545 140 464 59T270 -22Q155 -22 54 48L92 146Q93 146 101 138T124 117T161 92T216 72T288 63Q360 63 403 109T447 204Q447 220 444 233T435 256T421 273T404 285T385 295T366 301T347 306T331 310T315 314T292 321T265 331T235 346T207 367T183 395T168 431T161 478",
          120347: "165 608L182 687Q182 688 486 688H790L789 685L781 645L773 609H521L457 306Q393 3 392 2Q392 0 340 0H288V2Q289 5 353 304T417 605V609L291 608H165",
          120348: "340 -22Q251 -22 191 33T131 177V187Q131 192 131 195T132 205T133 215T136 231T141 253T147 285T156 328T168 384T184 457L235 694H338V691Q338 690 288 451T236 210Q234 194 234 177Q234 138 247 111T280 72T319 54T357 49Q408 49 449 74T510 128Q516 136 521 143T530 158T538 175T545 194T553 220T560 250T569 289T579 336T591 395T606 464L655 694H747V691Q651 243 645 213Q623 149 587 102Q482 -22 340 -22",
          120349: "220 348L161 694H216Q270 694 270 693L283 613Q334 313 346 215Q359 102 359 96Q359 87 358 84Q388 162 684 657L706 694H753Q799 694 799 693L387 0H333Q279 0 279 1L272 45Q264 89 249 177T220 348",
          120350: "596 540Q596 562 597 585T599 609Q599 588 436 255Q402 185 362 104L310 0H213V3Q213 6 188 347T161 694H263L265 664Q290 327 293 184Q293 112 289 85Q290 85 290 87Q290 95 301 123T332 194T373 282T419 380T463 469T498 541T517 579L574 694H671V689L674 646Q678 603 682 538T691 401T699 263T703 160Q703 102 700 87Q719 154 930 576L989 694H1076Q1076 693 903 347L730 0H628V4L626 26Q624 48 622 85T616 168T609 267T603 369T598 464T596 540",
          120351: "14 0Q17 3 184 184T352 367L265 529Q244 567 222 609T188 672L176 692Q176 694 236 694H297L338 612Q387 515 400 489L421 448L645 694H758L708 640Q481 393 456 368Q455 366 500 281T596 104T652 0H531L388 293L128 0H14",
          120352: "151 692Q151 694 212 694H272L418 362L696 683L705 694H758L809 693Q809 692 630 490T444 280Q442 275 413 139L383 1L333 0Q282 0 282 2Q283 3 312 141L341 278L246 484L151 692",
          120353: "67 54Q551 615 551 617Q543 618 517 618Q510 618 463 618T376 617Q200 617 200 618T209 657L216 694H459Q702 694 702 692Q702 689 697 667L692 643L207 80H392Q493 81 577 81Q577 70 560 2V0H55V2L67 54",
          120354: "313 386Q286 386 260 381T217 369T186 355T164 342T155 337Q154 338 159 377T165 418Q251 461 320 461Q322 461 328 461T337 460Q397 460 435 424T473 329Q473 325 473 318T472 308Q432 110 407 2V0H317V2L325 38Q295 21 269 10Q215 -10 156 -10H149Q76 -10 62 69Q61 75 61 90Q61 127 73 150T116 194Q146 215 207 231T348 252H368L373 277Q378 302 378 318Q378 367 339 384Q332 386 313 386ZM150 116Q150 93 171 79T223 65Q259 65 293 85T341 135Q343 140 348 160T353 184Q353 186 342 186Q298 186 231 174T153 134Q150 127 150 116",
          120355: "302 -11Q266 -11 235 1T190 26L176 38Q170 8 168 2V0H121Q75 0 75 1L84 46Q94 90 113 177T149 348L223 694H267Q312 694 312 693T282 551T251 407Q251 406 256 408T271 415Q347 454 430 454H438Q501 454 528 374Q539 339 539 299Q539 179 466 84T302 -11ZM443 275Q443 317 421 348T346 379Q318 379 296 369Q269 359 238 332L193 118L198 109Q220 65 269 65Q350 65 396 130T443 275",
          120356: "75 164Q75 226 100 282T165 377T252 437T342 460H347Q447 460 499 417L483 378Q468 339 468 338Q466 338 455 347T424 366T385 378Q355 382 334 382Q262 382 215 318T168 177Q168 120 196 95T259 69H269Q345 69 420 108Q432 114 432 113T427 72L422 32L402 22Q382 12 344 2T259 -11Q214 -11 180 2T126 36T95 81T79 126T75 164",
          120357: "73 156Q73 224 102 293T184 408T294 455Q375 455 432 413Q438 407 438 410T469 553L499 694H588V691Q588 690 515 348T441 2V0H348V2Q357 29 357 43L352 41Q332 24 288 7T196 -10H190Q178 -10 166 -7T134 8T98 46T75 113Q73 129 73 156ZM419 335Q419 339 412 348T386 368T342 379Q284 379 243 343T184 261T167 168Q167 122 191 94T263 66Q321 66 367 116L374 124L397 229Q419 333 419 335",
          120358: "248 -11Q170 -11 121 41T71 173Q71 265 133 349T285 454Q305 460 318 460H328Q368 460 399 448Q472 414 472 309Q472 274 464 234L462 219H159Q156 198 156 185Q156 137 179 107T237 68Q246 66 268 66Q345 66 427 113V109Q426 108 422 73T417 37Q417 34 409 29Q329 -11 248 -11ZM401 299Q399 337 376 361T316 385Q291 385 266 371Q220 350 184 289H401V299",
          120359: "381 443Q381 440 374 407T366 371H315Q263 371 263 369Q262 368 224 186Q215 145 205 97T189 25L184 2V0H94V2L99 25Q104 48 114 96T134 186Q172 368 173 369Q173 371 139 371H106V373L114 410L121 444H155L188 445L191 455L212 551Q232 612 288 658T415 705Q438 705 464 701T494 694Q478 614 477 614L467 618Q457 621 440 624T406 629H400Q333 629 306 579Q301 568 289 507L275 444H328Q381 444 381 443",
          120360: "113 252Q113 334 177 394T311 454Q332 454 350 451T379 442T398 432T410 424L413 421Q412 423 411 424L409 426Q409 429 434 436T496 449T560 455H568V451Q568 447 567 429T566 394L565 377L553 379Q522 385 479 385Q463 385 456 384L443 383L436 392Q454 357 454 324Q454 243 390 182T249 120Q233 120 219 122T195 128T178 136T167 142L163 145Q149 131 149 105Q149 78 171 72L242 71Q246 71 269 71T303 71T336 68T372 62T403 51T432 32Q461 8 461 -40Q461 -112 383 -159T211 -206Q123 -206 68 -172T12 -86Q12 -55 31 -23T82 32Q90 38 89 39Q89 40 87 44T82 59T80 82Q80 134 126 189Q113 228 113 252ZM369 319Q369 354 350 368T304 383Q274 383 252 369T218 333T202 291T197 255Q197 221 217 206T263 191Q317 191 343 233T369 319ZM373 -59Q373 -41 362 -30T330 -13T291 -7T247 -5H216Q167 -5 158 -6T139 -12Q123 -20 110 -38T97 -76Q97 -102 133 -118T221 -134Q242 -134 267 -130T316 -118T357 -94T373 -59",
          120361: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 1L82 46Q92 90 111 177T147 348L221 694H265Q310 694 310 693T279 544L247 395Q325 455 403 455Q513 455 513 358Q513 334 508 309Q507 304 476 156T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
          120362: "189 578Q190 579 199 627T211 678V680H315V678Q313 675 304 627T293 578V576H189V578ZM168 442T168 443T213 444T258 443T212 225T164 2V0H74V2Q75 7 121 224",
          120363: "211 577L233 680H284Q336 680 336 679L315 576H263Q211 576 211 577ZM19 -204Q-12 -204 -40 -196T-82 -179T-96 -170Q-96 -168 -78 -132L-61 -95L-54 -103Q-32 -126 3 -126Q26 -126 50 -116Q76 -101 83 -85Q84 -79 140 180T196 443Q196 444 241 444T286 443Q286 441 232 186T175 -75Q163 -120 122 -162T19 -204",
          120364: "150 348L224 694H310V691Q218 259 218 258L232 270Q245 281 274 306T327 351L435 444H489L542 443Q542 442 443 357L344 272L471 1L422 0H372L366 14Q359 27 347 54T323 105L273 210Q271 210 231 174L190 139L160 0H118Q76 0 76 1L86 46Q95 90 114 177T150 348",
          120365: "148 348L222 694H311V691Q311 690 238 348T164 2V0H119Q74 0 74 1L84 46Q93 90 112 177T148 348",
          120366: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 2L121 226L169 449Q169 450 213 450H256L249 421Q248 417 247 412T246 404T245 398T244 394T244 392Q250 398 261 407T307 433T379 454H392H400Q451 454 472 439Q482 434 489 427T500 412T506 399T510 388L511 384Q511 384 517 388Q563 431 620 446Q648 455 680 455Q790 455 790 358Q790 334 785 309Q784 304 753 156T720 2V0H627V2L634 34Q641 65 650 110T669 200T686 281T693 321Q693 379 613 379Q553 379 514 302Q503 276 486 202T457 66T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
          120367: "416 321Q416 379 336 379Q276 379 237 302Q226 276 209 202T180 66T166 2V0H119Q73 0 73 2L121 226L169 449Q169 450 213 450H256L249 421Q248 417 247 412T246 404T245 398T244 394T244 392Q250 398 261 407T307 433T379 454H392Q416 454 433 452T470 440T502 411T513 358Q513 334 508 309Q507 304 476 156T443 2V0H350V2L357 34Q364 65 373 110T392 200T409 281T416 321",
          120368: "69 169Q69 238 107 306T211 417T348 461Q419 461 471 412T523 271Q523 161 438 75T247 -11Q170 -11 120 39T69 169ZM432 279Q432 338 401 361T333 385Q280 385 240 352T182 273T164 178Q164 119 195 94T265 68Q306 68 344 94Q380 115 406 169T432 279",
          120369: "259 443Q251 405 251 404L260 409Q269 414 286 421T324 436T375 449T434 455Q482 455 510 417T538 303Q538 169 463 79T302 -11Q226 -11 176 39V36Q175 35 151 -80L127 -193Q127 -194 80 -194H34V-191L102 127L169 443Q169 444 214 444T259 443ZM269 65Q332 65 386 124T441 262Q441 304 422 334T370 373Q356 375 339 375Q293 375 238 331L193 118Q200 103 206 94T229 75T269 65",
          120370: "72 149Q72 272 146 363T304 455Q340 455 371 442T409 423T436 398Q438 411 442 427L448 455H538L400 -193Q400 -194 354 -194Q307 -194 307 -193L356 37V41Q355 41 350 38T332 27T302 13Q247 -10 191 -10H179Q138 -10 105 32T72 149ZM414 298Q402 376 341 376Q277 376 223 317T169 182Q169 121 198 93T265 65Q319 65 365 111L377 123L414 298",
          120371: "240 377L244 380Q248 384 255 390T272 404T296 419T325 434T361 446T401 454Q403 454 408 454T416 455H424L421 442Q419 435 413 405T406 373Q351 373 294 336T216 237Q213 231 201 173T178 60T164 2V0H119Q74 0 74 2L122 226L170 449Q170 450 213 450H255L247 414Q246 409 245 403T243 393T241 385T240 379T240 377",
          120372: "99 299Q99 318 106 341T133 393T195 441T298 461Q336 461 370 453T420 437L436 429Q436 428 421 389T405 350Q356 386 273 386H265Q248 386 237 384T211 371T191 337Q189 329 189 326Q189 320 190 315T194 306T200 299T209 293T218 289T228 285T239 283T251 281T263 278L270 276Q278 275 283 274T298 270T316 264T333 255T351 243T367 228T380 209T388 186T391 157Q391 96 341 43T193 -11Q171 -11 150 -8T114 -1T84 9T61 19T45 28T35 33Q35 36 67 116L76 109Q132 67 211 67Q258 67 279 88T301 135Q301 159 280 170T224 187T180 197Q141 212 120 239T99 299",
          120373: "245 68Q267 68 289 75T322 90L334 98Q338 94 338 28V24L324 19Q268 -4 218 -8Q198 -11 177 -11Q118 -11 118 75Q118 98 123 127Q125 137 149 251T174 369Q174 371 135 371H97V373L105 410L112 444H152L192 445L200 478Q208 512 213 541L219 571H261Q303 571 303 570T290 506L276 444H343Q410 444 410 443Q410 440 403 407T395 371H328Q261 371 261 369Q211 152 211 118Q211 68 245 68",
          120374: "166 -10H160Q146 -10 137 -8T115 0T97 22T90 63Q90 79 130 268L167 443Q167 444 214 444Q260 444 260 443L224 273Q187 97 187 86Q187 70 202 65T250 59Q303 59 336 83T379 139Q380 143 412 292T444 443Q444 444 491 444Q537 444 537 443T491 225T443 2V0H353V2L361 38L352 34Q344 29 326 22T286 7T232 -5T166 -10",
          120375: "177 6L108 442V444H201V442Q202 441 213 371T235 213T246 90V65Q259 117 429 406L450 444H495Q540 444 540 443Q539 442 411 221L282 1L230 0H178L177 6",
          120376: "148 5Q147 8 128 222T109 440L108 444H199V442Q200 441 204 385T214 253T219 140Q219 108 215 76Q215 72 214 67V65L215 66Q219 95 278 221L390 444H475V437Q497 203 497 121Q497 90 494 70Q494 67 494 67L496 73Q520 143 654 405L674 444H718Q762 444 762 443L534 1L483 0H432V5Q429 28 422 126T413 283Q413 343 416 370L417 378Q416 377 416 376Q401 303 248 12L242 0H148V5",
          120377: "317 229Q453 9 460 0H409L359 1L312 88Q266 176 265 176Q265 177 254 165T223 132T182 88L100 0H1L15 14Q29 28 61 59T118 115L236 229L226 244Q108 433 100 444H201L290 294L438 444H537L528 435Q526 432 512 418T468 376T418 327L317 229",
          120378: "11 -117L20 -120Q28 -124 46 -128T84 -132H100Q124 -122 149 -85Q200 -6 200 1Q200 17 155 204T109 442Q109 444 156 444H203Q203 443 208 419T221 357T235 277T248 190T254 114Q254 81 250 67V65Q251 65 251 67Q256 94 297 177Q339 259 422 397L450 444H540Q540 443 386 186T219 -90Q179 -153 145 -179T73 -205Q52 -205 34 -202Q29 -202 21 -201T7 -198L1 -197Q1 -196 6 -157T11 -117",
          120379: "129 408L136 444H315Q494 444 494 443Q494 441 489 419L484 396L164 76L291 77Q418 77 418 76T411 41T402 2V0H215Q28 0 28 2L34 27L38 50L360 371L240 370Q121 370 121 371Q124 388 129 408",
          120432: "191 76Q212 75 220 68T229 38Q229 10 208 1H129H80Q48 1 38 7T28 38Q28 51 29 57T40 69T70 76Q89 76 89 78Q90 79 117 205T173 461T205 599Q212 623 250 623H262H273Q312 623 319 599Q322 591 350 461T406 205T435 78Q435 76 454 76H458Q484 76 493 59Q496 53 496 38Q496 11 478 3Q474 1 395 1H317Q295 8 295 38Q295 65 311 73Q316 75 333 76L348 77V78Q348 80 341 112L334 143H190L183 112Q176 80 176 78Q175 76 178 76Q180 76 191 76ZM318 221Q313 238 288 366T263 519Q263 526 262 527Q261 527 261 520Q261 493 236 365T206 221Q206 219 262 219T318 221",
          120433: "39 1Q17 10 17 32V38V46Q17 65 34 73Q40 76 61 76H84V535H61H54Q27 535 19 553Q17 557 17 573Q17 583 17 587T23 599T39 610Q40 611 179 611Q320 610 332 607Q332 607 339 605Q394 591 427 547T461 454Q461 413 436 378T369 325L358 320Q405 311 443 270T482 169Q482 112 445 64T345 3L334 1H39ZM309 533Q302 535 234 535H168V356H230Q284 357 296 358T323 368Q346 380 361 402T377 452Q377 482 358 505T309 533ZM398 176Q396 218 371 246T315 279Q310 280 237 280H168V76H239Q316 77 327 81Q329 82 334 84Q398 107 398 176",
          120434: "40 305Q40 437 110 529T281 622Q315 622 343 611T387 589T404 578Q409 585 415 596T425 611T435 618T452 622Q472 622 478 609T485 566Q485 559 485 540T484 508V460Q484 413 478 403T442 393Q417 393 409 402Q400 409 400 420Q400 428 395 445T380 487T347 528T295 546Q235 546 180 483T124 306Q124 245 141 197T186 121T241 80T296 66Q346 66 373 103T400 178Q400 209 435 209H442H450Q484 209 484 172Q480 96 421 43T281 -11Q177 -11 109 84T40 305",
          120435: "38 1Q16 8 16 38Q16 62 32 73Q39 76 58 76H78V535H58Q40 535 32 538Q16 548 16 573Q16 587 17 591Q23 604 34 607T83 611H166H176Q188 611 209 611T239 612Q299 612 337 597T415 530Q485 438 485 300Q485 180 431 100T301 3L291 1H38ZM400 301Q400 363 385 410T346 482T303 519T267 534Q261 535 210 535H162V76H214L267 77Q323 89 361 148T400 301",
          120436: "374 271Q374 241 367 232T332 223Q307 223 299 231Q290 240 290 263V279H173V76H418V118V144Q418 167 426 176T460 186Q491 186 500 166Q502 161 502 93V52Q502 25 499 17T480 1H41Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q44 535 38 537T25 548T19 573Q19 602 41 610H47Q53 610 63 610T88 610T121 610T160 611T204 611T251 611H458Q460 609 465 606T471 602T475 598T478 593T479 586T480 576T480 562V526V488Q480 452 462 444Q458 442 438 442Q413 442 405 450Q398 457 397 463T396 501V535H173V355H290V371Q290 394 299 403T332 412Q363 412 372 392Q374 387 374 317V271",
          120437: "384 260Q384 230 377 221T342 212Q317 212 309 220Q300 229 300 252V268H179V76H249Q264 67 267 61T271 38Q271 10 249 1H44Q22 9 22 32V38Q22 63 39 73Q45 76 69 76H95V535H69H59Q42 535 32 542T22 573Q22 602 44 610H50Q56 610 66 610T91 610T125 610T164 611T208 611T257 611H468Q470 609 475 606T481 602T485 598T488 593T489 586T490 576T490 562V526V488Q490 452 472 444Q468 442 448 442Q423 442 415 450Q408 457 407 463T406 501V535H179V344H300V360Q300 383 309 392T342 401Q373 401 382 381Q384 376 384 306V260",
          120438: "38 306Q38 447 105 534T261 622Q280 622 298 618T329 608T350 596T366 585L371 581Q373 581 377 591T390 612T417 622Q437 622 443 609T450 566Q450 559 450 540T449 508V460Q449 413 443 403T407 393Q392 393 386 394T373 402T364 426Q360 472 335 509T271 546Q214 546 168 477T121 308Q121 210 164 138T271 65Q293 65 310 78T337 109T352 147T360 180T362 195Q362 196 333 196L304 197Q282 204 282 227V234Q282 247 282 251T288 261T304 272H474Q488 263 492 256T496 234Q496 211 479 199Q475 197 461 196H449V21Q441 6 434 3T412 -1H407H402Q385 -1 379 3T364 28Q350 14 322 2T260 -11Q173 -11 106 76T38 306",
          120439: "16 571Q16 597 27 604T74 611H125H208Q223 602 226 596T230 573Q230 559 227 551T217 540T204 536T186 535H165V356H359V535H338H333Q306 535 297 552Q295 556 295 573Q295 586 295 590T301 600T317 611H486Q501 602 504 596T508 573Q508 559 505 551T495 540T482 536T464 535H443V76H464H470Q482 76 489 75T502 64T508 38Q508 10 486 1H317Q306 5 301 11T296 21T295 38V44Q295 66 311 73Q318 76 338 76H359V280H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571",
          120440: "400 76Q431 76 441 69T452 38Q452 29 452 26T450 18T443 9T430 1H95Q84 6 79 12T73 23T72 38Q72 65 90 73Q96 76 157 76H220V535H157H124Q93 535 83 542T72 573Q72 603 93 610Q97 611 264 611H430Q432 609 436 607T444 602T449 594Q452 588 452 573Q452 546 434 538Q428 535 367 535H304V76H367H400",
          120441: "202 543T202 573T224 610H228Q231 610 237 610T251 610T269 610T291 611T315 611T342 611H457Q471 602 475 595T479 573Q479 549 462 538Q454 535 432 535H408V328Q408 159 408 133T402 93Q386 48 340 19T229 -11Q158 -11 108 16T57 100Q57 129 73 141T108 154Q128 154 143 140T159 102Q159 93 155 79Q188 65 228 65H230Q290 65 318 106Q323 115 323 139T324 329V535H274L224 536Q202 543 202 573",
          120442: "18 549T18 573T29 604T70 611H118H193Q207 603 210 596T214 573Q214 549 198 538Q191 535 172 535H152V421Q152 344 152 326T153 309L242 422L329 534Q327 535 322 536T314 538T308 542T303 548T300 558T298 573Q298 600 316 608Q322 611 392 611H463Q477 602 481 595T485 573Q485 535 446 535H441H420L281 357L436 77L454 76Q473 75 478 73Q495 62 495 38Q495 10 473 1H345Q334 5 329 11T324 21T323 38Q323 51 324 56T332 68T355 77L233 296L152 192V76H172Q191 76 198 73Q214 63 214 38Q214 9 193 1H41Q18 8 18 38Q18 61 35 73Q42 76 61 76H81V535H61Q42 535 35 538Q18 549 18 573",
          120443: "27 594Q34 605 43 608T84 611H154H213Q258 611 269 605T281 573Q281 546 263 538Q257 535 222 535H185V76H404V118V145Q404 168 411 177T446 186H453Q478 186 486 167Q488 161 488 93V50Q488 24 485 17T466 1L258 0H147H99Q47 0 36 6T25 38Q25 59 35 69Q44 76 76 76H101V535H76H64Q36 535 27 552Q25 557 25 573T27 594",
          120444: "50 535Q37 536 31 537T18 547T12 573Q12 598 22 604T62 611H91H121Q147 611 158 607T178 587Q183 579 222 446T261 293Q261 289 262 288Q263 288 263 292Q263 311 298 434T346 588Q353 603 365 607T402 611H435H450Q488 611 500 605T512 573Q512 556 506 547T493 537T474 535H459V76H474Q487 75 493 74T505 64T512 38Q512 11 494 3Q490 1 424 1H386Q355 1 345 7T335 38Q335 55 341 64T354 74T373 76H388V302Q388 512 387 519Q382 482 346 359T304 228Q292 204 262 204T220 228Q215 237 179 359T137 519Q136 512 136 302V76H151Q164 75 170 74T182 64T189 38Q189 11 171 3Q167 1 101 1H63Q32 1 22 7T12 38Q12 55 18 64T31 74T50 76H65V535H50",
          120445: "20 571Q20 598 30 604T73 611H105H136Q152 611 160 611T177 607T189 601T198 587T206 568T217 537T231 497Q354 142 365 95L368 84V535H347H342Q314 535 306 552Q304 556 304 573Q304 586 304 590T310 600T326 611H482Q497 602 500 596T504 573Q504 559 501 551T491 540T478 536T460 535H439V25Q432 7 424 4T389 0H374Q334 0 322 31L293 115Q171 468 159 517L156 528V76H177H183Q195 76 202 75T215 64T221 38Q221 10 199 1H43Q32 5 27 11T22 21T21 38V44Q21 66 37 73Q44 76 64 76H85V535H64Q49 535 42 536T28 545T20 571",
          120446: "102 588Q140 621 240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 185 460 118T422 23Q382 -10 289 -10H262H235Q142 -10 102 23Q74 50 65 118T56 306Q56 427 64 494T102 588ZM363 513Q357 523 347 530T324 540T302 544T280 546H268Q192 546 167 521Q150 501 145 452T140 300Q140 235 142 197T151 130T172 89T207 71T262 65Q317 65 341 81T374 144T384 300Q384 474 363 513",
          120447: "41 1Q19 9 19 32V38Q19 63 36 73Q42 76 65 76H89V535H65H55Q38 535 29 543T19 576Q19 603 41 610H49Q57 610 70 610T100 610T136 611T175 611Q190 611 216 611T255 612Q321 612 363 598T441 537Q480 486 480 427V421Q480 354 447 311T378 251Q339 230 275 230H239H173V76H197Q220 76 227 73Q244 62 244 38Q244 10 222 1H41ZM396 421Q396 461 369 491T300 533Q294 534 233 535H173V306H233Q294 307 300 308Q345 319 370 352T396 421",
          120448: "56 306Q56 380 58 426T68 510T87 568T120 600T170 617T240 621Q323 621 335 620Q393 613 422 588Q450 560 459 493T468 306Q468 124 447 66Q433 23 394 6L424 -53Q454 -112 454 -118Q454 -128 441 -138H377Q367 -135 363 -129T333 -69L304 -11H254Q205 -10 180 -8T128 6T91 36T70 92T58 178T56 306ZM227 151Q227 171 262 171H276H281Q292 171 296 171T305 170T313 165T317 158T323 145T332 127L353 88Q356 88 361 95T372 131T382 202Q384 228 384 306Q384 452 371 492T304 544Q296 545 251 545Q230 545 215 543T188 534T169 520T155 497T147 466T143 423T141 371T140 306Q140 248 141 217T146 154T157 109T178 83T212 68T262 65H266L264 70Q261 75 256 85T247 105Q227 145 227 151",
          120449: "16 571Q16 598 27 605T76 612Q84 612 108 612T148 611Q268 611 294 605Q346 592 389 550T432 440Q432 394 410 359Q393 329 366 310L358 303Q387 273 399 239Q405 219 405 178T408 106T421 68Q426 65 428 65Q433 65 435 74T438 96T441 112Q450 130 480 130H485Q519 130 522 100Q522 79 516 56T488 11T434 -11Q421 -11 408 -8T377 5T344 37T324 93Q322 101 322 154L321 209Q304 257 257 267Q252 268 207 268H165V76H186H192Q204 76 211 75T224 64T230 38Q230 10 208 1H39Q28 5 23 11T18 21T17 38V44Q17 66 33 73Q40 76 60 76H81V535H60Q45 535 38 536T24 545T16 571ZM348 440Q348 478 321 502T260 532Q252 534 208 535H165V344H208Q212 344 223 344T239 345T252 346T266 348T278 351T293 358Q348 387 348 440",
          120450: "52 454Q52 524 107 572T229 621Q266 621 274 620Q326 610 360 588L371 581Q377 594 379 598T386 610T397 619T412 622Q433 622 439 610T446 570Q446 563 446 545T445 515V479Q445 441 444 432T436 417Q428 408 403 408T370 417Q361 424 361 434Q361 439 360 448T351 476T331 509T295 535T238 546Q194 546 163 522T132 458Q132 435 148 412Q155 401 166 393T192 380T218 371T247 364T270 359Q341 342 349 339Q389 325 418 296T461 229Q472 201 472 164Q469 92 417 41T287 -11Q240 -11 200 -1T143 19L126 29Q117 6 109 -2Q100 -11 84 -11Q64 -11 58 1T51 42Q51 49 51 66T52 95V135Q52 173 53 180T61 194Q70 203 95 203Q119 203 127 194Q136 186 136 168Q143 66 284 66H290Q325 66 350 85Q391 115 391 165Q391 204 369 228T322 260Q320 260 255 275T185 293Q123 309 88 355T52 454",
          120451: "129 38Q129 51 129 55T135 65T151 76H220V535H110V501Q110 470 109 464T101 450Q93 442 68 442H60Q37 442 28 461Q26 466 26 527L27 589Q36 607 49 610H55Q61 610 72 610T97 610T131 610T170 611T215 611T264 611H476Q478 609 483 606T489 602T493 598T496 593T497 586T498 576T498 562V526V488Q498 452 480 444Q476 442 456 442Q431 442 423 450Q416 457 415 463T414 501V535H304V76H374Q389 67 392 61T396 38Q396 10 374 1H151Q140 5 135 11T130 21T129 38",
          120452: "-3 573Q-3 597 8 604T50 612Q57 612 77 612T111 611H200Q214 602 218 595T222 573Q222 549 205 538Q198 535 175 535H151V359Q151 333 151 291Q152 177 156 162Q157 160 157 159Q165 123 193 95T262 66Q303 66 330 94T367 159Q371 175 371 191T373 359V535H349H339Q328 535 322 537T309 548T303 573T306 595T325 611H506Q520 602 524 595T528 573Q528 549 511 538Q504 535 481 535H457V364Q457 189 456 182Q448 101 394 45T262 -11Q189 -11 132 43T68 182Q67 189 67 364V535H43H33Q22 535 16 537T3 548T-3 573",
          120453: "19 578Q19 585 20 590T23 598T29 604T38 608T48 610T62 611T78 612T97 611T119 611H195Q210 602 213 596T217 573Q217 561 216 555T206 542T179 535H164Q166 529 188 435T235 231T261 94L262 84V88Q263 91 263 94Q265 121 289 231T336 438L360 535H345Q308 535 308 566V573Q308 586 308 590T314 600T330 611H484Q499 602 502 595T505 573Q505 560 504 554T493 541T465 535H447L384 278Q321 19 319 14Q309 -7 278 -7H262H246Q215 -7 205 14Q203 19 140 278L78 535H59Q45 535 38 536T25 547T19 573V578",
          120454: "459 611Q491 611 501 605T512 573Q512 538 482 535H474L439 276Q406 26 402 11Q398 2 389 -3Q387 -3 386 -4L380 -7H359H349Q324 -7 313 13Q307 29 285 139T263 275Q263 283 262 283Q261 282 261 274Q261 248 239 137T211 13Q200 -7 175 -7H165H144Q136 -3 127 3Q121 10 117 36T85 276L50 535H42Q26 536 19 545T12 564V573Q12 603 33 610Q37 611 101 611H134Q165 611 175 604T186 573Q186 563 186 559T182 547T169 538T143 535H122V531Q124 517 133 446T155 266T172 96V84L173 102Q176 157 192 243T215 346Q227 367 259 367H262H265Q297 367 309 346Q316 329 332 243T351 102L352 84V96Q356 161 368 266T390 444T402 531V535H381Q366 535 359 536T345 547T338 573Q338 600 356 608Q362 611 425 611H459",
          120455: "39 571Q39 597 49 604T93 611H141H218Q233 602 236 595T239 573Q239 538 210 535Q202 535 202 534T215 507T243 454L257 428L307 535H298Q266 538 266 573Q266 584 267 588T273 598T289 611H366H401Q442 611 454 605T466 573Q466 546 448 538Q442 535 421 535H398L299 327Q299 323 362 201L426 77L449 76Q467 76 475 75T489 65T495 38Q495 11 477 3Q473 1 395 1H317Q295 8 295 38Q295 73 325 76L334 77Q333 78 314 117T276 196L257 235L239 196Q221 157 204 118T186 77Q190 76 196 76Q211 74 218 67T227 55T228 38Q228 28 227 24T221 13T206 1H50Q28 9 28 32V38Q28 63 45 73Q51 76 73 76H96L214 324Q215 327 162 431L108 535H85H79Q67 535 60 536T46 546T39 571",
          120456: "20 573Q20 597 30 604T72 611H121H198Q212 602 216 595T220 573Q220 568 219 563T217 555T214 549T211 544T207 541T203 538T198 537T194 536T190 536L188 535Q179 535 179 534L188 516Q196 497 208 470T232 415T252 363T261 332Q261 329 262 329T263 332Q263 354 333 508L345 534Q345 535 336 535Q305 538 305 567V573Q305 589 308 595T327 611H483Q505 598 505 573Q505 549 488 538Q481 535 460 535H438L304 245V76H325H331Q343 76 350 75T363 64T369 38Q369 10 347 1H178Q167 5 162 11T157 21T156 38V44Q156 66 172 73Q180 76 199 76H220V245L86 535H64Q44 535 36 538Q20 548 20 573",
          120457: "71 1Q60 5 55 11T49 23T48 39V46Q48 56 58 73T131 183Q171 242 197 282L366 535H144V501Q144 470 143 464T135 450Q127 442 102 442H94Q71 442 62 461Q60 466 60 527L61 589Q70 607 83 610H88Q93 610 102 610T124 610T154 610T188 611T227 611T270 611H454Q456 609 461 606T467 601T471 597T474 591T475 584T476 572V565Q476 555 466 538T393 428Q353 369 327 329L158 76H397V120V146Q397 169 405 179T439 189Q470 189 479 169Q481 164 481 95V48Q481 24 478 16T459 1H71",
          120458: "126 306Q105 306 90 321T74 359Q74 439 211 439Q268 439 276 438Q343 426 383 390T430 306Q431 301 431 190V81Q446 79 465 78T492 76T509 72T521 60T524 38Q524 11 506 3Q502 1 466 1Q426 1 406 5T379 14T355 36L345 30Q284 -6 205 -6Q135 -6 92 39T48 141Q48 182 79 212T158 256T252 278T342 285H347V290Q347 315 325 335T267 362Q258 363 224 363Q189 363 185 362H179L178 358Q178 353 178 352T176 345T174 337T170 330T165 322T158 316T150 311T139 308T126 306ZM132 140Q132 115 157 93T224 70Q269 70 302 87T344 133Q346 139 347 175V211H339Q256 209 194 190T132 140",
          120459: "4 573Q4 596 15 603T52 611H90H124Q146 611 155 608T171 591Q173 586 173 491V396L182 402Q217 424 256 431Q280 437 309 437Q376 437 434 379T492 217Q492 162 473 118T422 47T358 8T293 -6Q229 -6 174 38Q171 13 163 7T135 1H131H122Q99 1 90 23L89 279V535H58L27 536Q4 543 4 573ZM409 215Q409 269 377 315T283 361Q255 361 224 344T177 297L173 290V167Q189 124 213 97T278 70Q330 70 369 111T409 215",
          120460: "291 -6Q196 -6 131 60T66 216Q66 296 119 361Q154 403 200 421T273 439Q275 440 293 440H313Q400 440 433 409Q454 388 454 359Q454 335 439 321T402 306Q380 306 365 321T350 357V362L340 363Q339 363 326 363T303 364Q280 364 266 362Q217 352 184 313T151 215Q151 153 199 112T313 70Q341 70 357 85T381 118T394 140Q402 146 424 146Q443 146 447 144Q466 137 466 117Q466 106 457 88T429 47T374 10T291 -6",
          120461: "266 573Q266 596 277 603T314 611H352H385Q411 611 419 607T435 586V76H498Q512 67 516 60T520 38Q520 9 498 1H436Q429 1 417 1T398 0Q375 0 363 7T351 34V43L342 36Q288 -6 223 -6Q143 -6 87 58T31 216Q31 307 88 372T230 437Q292 437 342 405L351 399V535H320L289 536Q266 543 266 573ZM351 290Q347 302 337 316T302 346T244 361Q193 361 154 319T115 215Q115 152 152 111T235 70Q314 70 351 170V290",
          120462: "48 217Q48 295 100 361T248 439L258 440Q268 440 274 440Q329 438 369 416T428 359T456 292T464 228Q464 215 461 208T454 198T442 190L288 189H135L138 179Q153 132 199 102T303 71Q336 71 353 86T380 120T398 143Q404 146 422 146Q453 146 462 126Q464 120 464 116Q464 84 416 39T285 -6Q187 -6 118 59T48 217ZM377 264Q371 291 365 306T341 338T294 362Q288 363 264 363Q225 363 190 336T139 264H377",
          120463: "43 395Q44 405 44 408T47 416T53 423T66 431H176V461Q176 500 182 518Q201 570 252 593T353 617Q399 614 418 593T437 548Q437 528 424 514T387 499Q365 499 353 511T338 537V541H328Q275 536 261 494Q260 490 260 460V431H327Q334 431 346 431T364 432Q392 432 404 425T416 393T405 362T365 355H327H260V76H319Q375 76 388 71T401 38Q401 27 400 23T395 12T379 1H58Q47 6 42 12T36 23T35 38Q35 65 53 73Q59 76 117 76H176V355H121H93Q64 355 54 362T43 395",
          120464: "60 274Q60 337 107 386T233 436Q278 436 316 417L329 410L338 416Q384 442 427 442T489 423T509 381T494 345T460 332Q449 332 440 338Q432 341 427 348T419 360T415 365Q414 364 410 364L383 355Q406 320 406 274Q406 211 358 162T233 112Q189 112 155 128L146 133Q142 125 142 115Q142 99 150 85T175 71Q182 72 187 70Q188 70 195 70T218 70T254 69Q259 69 275 69T297 69T318 68T340 66T361 62T384 57T405 49T428 38Q495 -1 495 -76Q495 -143 427 -186T262 -229Q161 -229 94 -185T29 -73Q30 -60 33 -48T39 -26T47 -8T57 8T67 20T77 30T86 38L91 43Q91 44 86 53T75 80T70 117Q70 142 89 183L83 194Q60 232 60 274ZM321 274Q321 312 296 337T230 362Q197 362 171 338T145 274Q145 235 170 211T233 187Q273 187 297 212T321 274ZM422 -78Q422 -54 408 -38T366 -15T315 -6T255 -4H200Q198 -4 193 -4T183 -3Q148 -3 125 -26T102 -78Q102 -110 151 -132T261 -154Q321 -154 371 -132T422 -78",
          120465: "4 573Q4 596 15 603T52 611H90H124Q146 611 155 608T171 591Q173 586 173 489Q173 394 175 394L186 402Q197 410 219 420T269 434Q278 436 306 436Q343 436 371 423Q411 402 423 365T436 265Q436 257 436 239T435 211V198V76H498Q512 67 516 60T520 38Q520 9 498 1H308Q286 10 286 32V38V46Q286 65 303 73Q309 76 329 76H351V188Q351 204 351 230T352 266Q352 321 341 341T288 361Q253 361 222 341T176 274L174 264L173 170V76H236Q250 67 254 60T258 38Q258 9 236 1H27Q4 8 4 38Q4 53 8 60T27 76H89V535H58L27 536Q4 543 4 573",
          120466: "202 538T202 559T218 596T260 612Q283 612 300 597T317 560Q317 538 300 523T260 507Q235 507 219 522ZM411 76Q441 76 451 69T462 38Q462 29 462 26T460 18T453 9T440 1H94Q72 8 72 33V38Q72 46 72 49T74 58T81 68T94 76H233V355H167L102 356Q80 363 80 393Q80 418 91 425T138 432Q145 432 165 432T200 431H295Q297 429 303 425T310 420T314 415T317 404T317 389T318 363Q318 354 318 314T317 241V76H378H411",
          120467: "261 559Q261 580 277 596T319 612Q342 612 359 597T376 560T360 523T320 507Q296 507 279 523T261 559ZM75 -91T100 -91T138 -107T152 -144V-150L160 -151H193H203Q241 -151 267 -121Q284 -97 288 -73T292 23V151V355H218L145 356Q123 365 123 387V393Q123 422 145 430H148Q151 430 156 430T169 430T185 430T205 431T227 431T251 431H354Q356 430 360 427T365 424T369 420T372 416T373 410T375 402T376 391T377 376T377 356Q377 345 377 286T376 176Q376 -67 371 -88Q362 -123 342 -151T299 -194Q254 -228 180 -228Q84 -226 56 -177Q49 -162 48 -148Q48 -122 61 -107",
          120468: "13 42Q13 63 23 69T69 76H102V535H69H54Q34 535 24 542T13 573Q13 588 15 593Q22 605 29 608T56 611H95Q113 611 122 611T140 610T152 609T159 607T163 603T167 597T173 589V413L174 237L295 355H275Q260 355 253 356T239 367T232 393Q232 419 243 425T304 431H359H464Q479 422 482 415T485 393Q485 364 464 356L431 355H398L293 254L427 76H486Q501 67 504 60T507 38Q507 28 507 24T501 12T486 1H314Q292 8 292 38Q292 62 308 73Q312 75 326 76L338 77L290 140Q279 154 267 171T248 196L242 204L207 171L173 139V76H206H221Q241 76 251 69T262 38Q262 11 244 3Q240 1 138 1Q123 1 100 1T70 0Q32 0 23 7T13 42",
          120469: "51 573Q51 602 73 610H76Q79 610 84 610T97 610T113 610T133 611T155 611T179 611H282Q301 598 304 586V76H452Q466 67 470 60T474 38Q474 10 452 1H73Q51 9 51 32V38Q51 54 54 60T73 76H220V535H146L73 536Q51 545 51 567V573",
          120470: "133 76Q156 74 164 67T172 38Q172 9 151 1H11Q-12 8 -12 38Q-12 61 5 73Q10 75 28 76H45V355H28Q10 356 5 358Q-12 370 -12 393Q-12 419 11 431H52H70Q91 431 100 427T116 405Q163 436 200 436Q255 436 281 390L285 394Q289 398 292 400T301 407T314 415T329 423T346 429T366 434T389 436H392Q425 436 448 411Q469 390 474 360T480 268V232V203V76H497Q520 74 528 67T536 38Q536 9 515 1H396Q374 9 374 32V38Q374 73 402 76H409V191V242Q409 317 404 339T375 361Q343 361 323 332T299 264Q298 258 298 165V76H315Q338 74 346 67T354 38Q354 9 333 1H214Q192 9 192 32V38Q192 73 220 76H227V191V242Q227 317 222 339T193 361Q161 361 141 332T117 264Q116 258 116 165V76H133",
          120471: "89 431Q94 431 105 431T122 432Q173 432 173 399Q173 394 175 394Q176 394 190 404T233 425T298 436Q343 436 371 423Q411 402 423 365T436 265Q436 257 436 239T435 211V198V76H498Q512 67 516 60T520 38Q520 9 498 1H308Q286 9 286 32V38V45Q286 65 303 73Q309 76 329 76H351V188Q351 204 351 230T352 266Q352 321 341 341T288 361Q253 361 222 341T176 274L174 264L173 170V76H236Q250 67 254 60T258 38Q258 9 236 1H27Q4 8 4 38Q4 53 8 60T27 76H89V355H58L27 356Q4 363 4 393Q4 408 8 415T27 431H89",
          120472: "52 216Q52 318 118 379T261 440Q343 440 407 378T472 216Q472 121 410 58T262 -6Q176 -6 114 58T52 216ZM388 225Q388 281 351 322T261 364Q213 364 175 325T136 225Q136 158 174 114T262 70T350 114T388 225",
          120473: "89 431Q93 431 104 431T121 432Q173 432 173 401V396L182 402Q237 437 305 437Q376 437 434 378T492 217Q492 146 459 93T382 17T291 -6Q261 -6 232 5T188 26L174 37Q173 37 173 -54V-146H236Q250 -155 254 -162T258 -184Q258 -213 236 -221H27Q4 -214 4 -184Q4 -169 8 -162T27 -146H89V355H58L27 356Q4 363 4 393Q4 408 8 415T27 431H89ZM409 215Q409 269 377 315T283 361Q255 361 224 344T177 297L173 290V167Q189 124 213 97T278 70Q330 70 369 111T409 215",
          120474: "34 215Q34 309 91 368T222 436Q224 436 231 436T242 437Q309 437 372 390V401Q372 419 381 428T414 437Q426 437 432 436T444 430T456 412V-146H489H504Q524 -146 534 -153T545 -184Q545 -211 527 -219Q523 -221 414 -221Q398 -221 374 -221T342 -222Q304 -222 294 -216T283 -184Q283 -157 301 -149Q307 -146 339 -146H372V-51Q372 43 371 43L364 38Q357 33 345 26T318 12T280 -1T236 -6Q155 -6 95 55T34 215ZM117 215Q117 152 157 111T250 70Q289 70 318 92T363 146Q372 163 372 192V215L371 263Q339 360 254 360Q206 360 162 321T117 215",
          120475: "327 76Q359 76 369 70T380 38Q380 10 359 1H47Q24 8 24 38Q24 54 28 61T47 76H145V355H96L47 356Q24 363 24 393Q24 409 28 416T47 431H207Q223 419 226 414T229 393V387V369Q297 437 394 437Q436 437 461 417T487 368Q487 347 473 332T438 317Q428 317 420 320T407 327T398 337T393 347T390 356L388 361Q348 356 324 345Q228 299 228 170Q228 161 228 151T229 138V76H293H327",
          120476: "72 317Q72 361 108 396T229 439Q231 439 245 439T268 440Q303 439 324 435T353 427T363 423L372 432Q380 440 397 440Q430 440 430 395Q430 390 430 380T429 366V335Q429 311 422 302T387 293Q364 293 355 300T346 316T343 336T325 353Q306 364 257 364Q209 364 178 351T147 317Q147 284 231 272Q327 256 357 247Q458 210 458 129V121Q458 74 413 34T271 -6Q246 -6 224 -3T189 5T165 14T150 22T144 26Q142 23 139 18T135 11T132 6T128 1T124 -2T119 -4T113 -5T104 -6Q84 -6 78 6T71 43Q71 48 71 60T72 79Q72 132 73 141T81 157Q90 166 115 166Q135 166 142 162T157 140Q168 108 191 90T260 70Q297 70 323 76T361 91T379 110T384 129Q384 157 346 171T247 195T165 212Q119 228 96 256T72 317",
          120477: "25 395Q26 405 26 408T29 416T35 423T48 431H145V481L146 532Q154 547 161 550T184 554H189Q218 554 227 534Q229 529 229 480V431H405Q406 430 411 427T418 422T422 416T426 407T427 393Q427 387 427 382T424 374T421 368T417 363T413 360T408 358L405 356L317 355H229V249Q229 237 229 214T228 179Q228 126 241 98T295 70Q354 70 365 149Q366 167 375 174Q383 182 407 182H415Q438 182 446 166Q448 161 448 148Q448 84 398 39T282 -6Q226 -6 189 29T146 128Q145 134 145 247V355H96H72Q45 355 35 362T25 395",
          120478: "4 393Q4 416 15 423T52 431H90Q141 431 151 429T168 417Q171 412 173 409V254L174 100Q182 70 244 70Q320 70 344 119Q349 130 350 144T351 248V355H320L289 356Q266 363 266 393Q266 408 270 415T289 431H351H386Q409 431 418 428T433 411Q435 406 435 241V76H498Q512 67 516 60T520 38Q520 9 498 1H436H394Q372 1 364 5T351 26L342 21Q293 -5 227 -5Q118 -5 96 67Q91 82 90 101T89 227V355H58L27 356Q4 363 4 393",
          120479: "24 392Q24 417 36 424T79 432Q85 432 103 432T132 431H215Q229 422 233 415T237 393Q237 355 198 355H193H172L262 77L352 355H331H323Q288 355 288 393Q288 409 291 415T310 431H478Q491 423 495 416T500 393Q500 364 478 356L452 355H426L374 190Q320 24 318 20Q307 -4 273 -4H262H251Q217 -4 206 20Q204 24 150 190L98 355H72L47 356Q24 363 24 392",
          120480: "54 355Q16 355 16 388V393Q16 423 37 430Q41 431 125 431H162Q206 431 218 425T230 393Q230 366 212 358Q206 355 174 355Q141 355 141 354L150 296Q181 110 181 89V84Q182 85 183 96Q185 118 199 173T218 237Q223 247 245 259H264H268Q294 259 309 240Q315 229 329 174T343 92Q343 84 344 84V86Q344 88 344 91T345 97Q347 125 356 187T374 301T383 354Q383 355 350 355H333Q314 355 304 362T294 393Q294 420 312 428Q318 431 401 431H440Q485 431 496 425T508 393Q508 382 508 377T498 363T470 355L455 354Q455 353 441 271T413 104T396 16Q384 -4 355 -4H351Q315 -4 305 9T280 79Q278 90 276 96Q265 149 265 169Q265 176 264 169Q263 166 263 162Q261 130 248 79T230 18Q220 -4 183 -4H175L151 -3Q134 5 127 17L112 102Q97 188 83 270T69 354Q62 355 54 355",
          120481: "35 393Q35 417 46 424T89 432Q95 432 112 432T141 431H223Q238 422 241 415T244 393Q244 389 244 383T237 367T216 355Q209 355 209 354L234 319Q259 286 260 286L308 354Q308 355 301 355Q285 356 278 365T270 384L271 393Q271 420 289 428Q295 431 376 431H459Q460 430 465 427T472 422T476 416T480 407T481 393Q481 368 470 362T434 355H425H392L344 290Q295 225 295 223Q294 223 309 203T350 149L405 77L439 76H453Q474 76 484 69T495 38Q495 10 473 1H303Q281 9 281 32V38Q281 49 282 54T290 67T313 76Q324 76 324 77L259 173L197 77Q202 76 209 76Q225 75 233 68T241 55T242 38Q242 28 242 24T236 12T221 1H51Q29 9 29 32V38Q29 48 29 51T31 59T38 67T51 76H117L171 149Q224 222 224 223L124 355H90H78Q54 355 45 361T35 393",
          120482: "26 393Q26 417 37 424T80 431H134H217Q232 422 235 416T239 393Q239 379 236 371T226 360T214 356T197 355L179 354V353L188 330Q197 306 209 272T235 201T259 133T271 89V84L274 95Q279 122 298 185T335 300T352 354Q352 355 331 355Q312 355 304 358Q288 368 288 393Q288 408 291 415T310 431H478Q479 430 484 427T491 422T495 416T499 407T500 393Q500 376 493 367T479 357T458 355H452Q426 355 425 353Q420 337 351 124T280 -94Q240 -195 168 -220Q147 -228 125 -228Q89 -228 66 -201T42 -139Q42 -116 56 -102T93 -87Q117 -87 130 -102T144 -135V-138H126Q121 -148 121 -150T130 -152Q182 -147 207 -87Q211 -78 223 -40T236 1Q230 10 102 355H75L49 356Q26 363 26 393",
          120483: "56 1Q40 7 37 14T34 41Q34 59 36 64Q39 67 43 73Q65 95 191 213T341 355H133V334Q133 306 124 297Q116 289 91 289H83Q60 289 51 308Q49 313 49 361L50 409Q59 427 72 430H78Q83 430 92 430T115 430T144 430T179 431T219 431T262 431H450Q452 430 455 428T459 424T463 422T466 419T468 416T469 413T470 409T471 404T472 398T472 391Q472 374 469 368L462 358Q453 349 315 218Q210 122 164 76H391V103Q391 136 400 146Q409 155 433 155Q464 155 473 135Q475 130 475 78V46Q475 24 472 16T453 1H56",
          120488: "296 0Q278 3 164 3Q58 3 49 0H40V62H92Q144 62 144 64Q388 682 397 689Q403 698 434 698Q463 698 471 689Q475 686 538 530T663 218L724 64Q724 62 776 62H828V0H817Q796 3 658 3Q509 3 485 0H472V62H517Q561 62 561 63L517 175H262L240 120Q218 65 217 64Q217 62 261 62H306V0H296ZM390 237L492 238L440 365Q390 491 388 491Q287 239 287 237H390",
          120489: "720 510Q720 476 704 448T665 404T619 377T580 362L564 359L583 356Q602 353 632 342T690 312Q712 292 725 276Q752 235 752 189V183Q752 160 741 125Q698 18 547 2Q543 1 288 0H39V62H147V624H39V686H264H409Q502 686 542 681T624 655Q720 607 720 510ZM563 513Q563 553 548 578T518 611T486 622Q479 624 385 624H293V382H375Q458 383 467 385Q563 405 563 513ZM590 192Q590 307 505 329Q504 330 503 330L398 331H293V62H391H400H444Q496 62 528 75T580 131Q590 155 590 192",
          120490: "425 0L228 3Q63 3 51 0H39V62H147V618H39V680H612V676Q614 670 627 552T643 428V424H581V428Q580 430 576 461T562 524T532 576Q512 596 481 605T426 616T357 618H304V62H439V0H425",
          120491: "901 12Q901 7 892 0H479Q65 0 62 2Q56 6 56 11Q56 14 242 347T433 685Q438 694 450 696Q454 698 480 698H506L523 687Q526 683 711 354T899 17Q901 13 901 12ZM653 137L427 538L202 137L315 136H540L653 137",
          120492: "723 286Q721 284 700 145T677 3V0H39V62H147V618H39V680H660V676Q662 670 675 552T691 428V424H629V428Q629 429 627 448T618 494T601 541Q574 593 527 605T382 618H374H304V384H336Q338 384 347 384T361 384T376 386T392 390T407 397T421 407T432 423Q442 444 443 482V501H505V205H443V224Q442 258 435 278T411 307T380 318T336 322H304V62H375H394Q429 62 449 62T497 66T541 76T577 95T609 126T632 170T651 232Q661 287 661 289H723V286",
          120493: "80 430L92 686H358Q624 686 628 684Q638 679 638 656Q638 640 637 639Q637 638 445 353Q401 288 351 214T277 103L253 67L256 66Q258 66 265 66T279 66T298 66H343Q380 66 406 68T464 81T518 110T557 164T579 250Q583 278 583 298Q583 299 614 299H645V291Q643 281 636 150T627 8V0H353Q79 0 75 2Q64 7 64 31Q64 48 66 52L259 340L451 623Q451 624 384 624Q294 623 259 612Q155 581 143 446Q142 440 142 432V430H80",
          120494: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V388H595V624H487V686H499Q523 683 673 683Q824 683 848 686H860V624H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V326H304V62H412V0H400",
          120495: "629 -10T446 -10T164 89T64 340Q64 380 71 420T102 510T163 596T266 662T418 696H438Q488 696 499 695Q582 686 644 655T741 584T796 495T823 409T829 338Q829 188 729 89ZM439 645Q416 645 390 638T333 615T275 564T236 480Q221 423 221 341Q221 272 230 228Q247 144 301 94T447 43T592 93T663 228Q672 272 672 341Q672 645 439 645ZM286 242V446H348V412H545V446H607V242H545V276H348V242H286",
          120496: "397 0Q370 3 218 3Q65 3 38 0H25V62H139V624H25V686H38Q65 683 218 683Q370 683 397 686H410V624H296V62H410V0H397",
          120497: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H51Q75 683 226 683Q376 683 400 686H412V624H304V338L472 483L634 624H565V686H576Q597 683 728 683Q814 683 829 686H836V624H730L614 524Q507 432 497 422Q496 422 498 418T514 395T553 342T627 241L759 63L805 62H852V0H842Q830 3 701 3Q550 3 526 0H513V62H549Q584 62 584 63Q583 65 486 196T388 328L304 256V62H412V0H400",
          120498: "285 0Q267 3 154 3Q56 3 47 0H40V62H131Q131 63 167 160T244 369T321 578T359 678Q366 698 393 698H404H413Q437 698 446 678Q448 672 560 369T674 62H765V0H754Q733 3 604 3Q453 3 429 0H416V62H461L507 63L355 470Q353 468 279 265L203 63L249 62H294V0H285",
          120499: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H305Q316 679 323 667Q330 653 434 414L546 157L658 414Q766 662 773 674Q778 681 788 686H1052V624H944V62H1052V0H1040Q1016 3 874 3T708 0H696V62H804V341L803 618L786 580Q770 543 735 462T671 315Q540 13 536 9Q528 1 507 1Q485 1 477 9Q472 14 408 162T281 457T217 603Q215 603 215 334V62H323V0H314",
          120500: "314 0Q296 3 181 3T48 0H39V62H147V624H39V686H171H265Q288 686 297 686T309 684T315 679Q317 676 500 455T684 233V624H576V686H585Q603 683 718 683T851 686H860V624H752V319Q752 15 750 11Q747 4 742 2T718 0H712Q708 0 706 0T700 0T696 1T693 2T690 4T687 7T684 11T679 16T674 23Q671 27 437 311L215 579V62H323V0H314",
          120501: "54 465L63 674Q63 675 383 675T703 674L712 465Q712 464 681 464H650V467Q650 490 646 516T632 545Q612 550 383 550H283Q169 550 149 548T124 531Q123 530 123 529Q116 506 116 467V464H85Q54 464 54 465ZM160 256V447H222V414H544V447H606V256H544V289H222V256H160ZM57 0L48 222H110V219Q110 147 125 133Q127 130 130 129T160 127T235 126T383 126Q482 126 530 126T604 127T635 129T641 133Q656 146 656 219V222H718L709 0H57",
          120502: "64 339Q64 431 96 502T182 614T295 675T420 696Q469 696 481 695Q620 680 709 589T798 339Q798 173 697 82T432 -10Q262 -10 163 85T64 339ZM625 454Q618 502 600 538T562 593T515 624T469 639T431 642Q331 642 276 563Q232 493 232 353Q232 315 234 285T244 216T267 148T308 94T372 56Q405 46 432 46Q517 46 567 106T627 267Q631 299 631 353Q631 418 625 454",
          120503: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V618H39V680H860V618H752V62H860V0H848Q824 3 674 3Q523 3 499 0H487V62H595V618H304V62H412V0H400",
          120504: "400 0Q376 3 226 3Q75 3 51 0H39V62H147V624H39V686H253Q435 686 470 685T536 678Q585 668 621 648T675 605T705 557T718 514T721 483T718 451T704 409T673 362T616 322T530 293Q500 288 399 287H304V62H412V0H400ZM553 475Q553 554 537 582T459 622Q451 623 373 624H298V343H372Q457 344 480 350Q527 362 540 390T553 475",
          120506: "766 271Q764 266 750 137T735 4V0H407Q74 0 71 4L70 5Q64 9 64 18Q64 24 82 41T213 158L359 288Q360 288 320 336T214 460Q67 633 66 635Q64 638 64 655Q64 679 75 684Q78 686 407 686H735V682Q738 676 751 558T766 434V430H735Q704 430 704 431Q704 434 703 444T696 477T681 520T654 563T613 598Q578 615 527 619T371 624H281L396 489Q506 358 513 351Q517 342 512 334Q503 325 371 208Q338 179 303 147T249 99L231 83L243 81Q258 81 364 81Q382 81 418 81T470 82T513 83T554 88T587 96T619 109T645 129Q689 173 702 260L704 274Q704 275 735 275H766V271",
          120507: "41 425Q41 426 51 545T62 669V675H737V669Q738 665 748 546T758 425V419H696V425Q687 517 669 555T595 607Q578 612 522 613H478V62H631V0H615Q585 3 399 3Q214 3 184 0H168V62H321V613H277H263Q164 613 134 561Q113 527 103 425V419H41V425",
          120508: "64 556Q69 619 114 658T224 697Q271 697 310 677T375 622T417 554T444 484L447 477V479Q456 516 473 551T516 620T582 676T670 697Q735 697 780 656T829 556Q829 539 818 532H772Q761 539 761 548Q761 571 681 571Q664 571 653 570T623 562T587 537T555 490Q536 448 531 410T525 300V210V62H660V0H646L447 3Q257 1 247 0H233V62H368V210V301Q368 373 363 410T338 490Q324 518 307 536T270 561T240 569T212 571Q132 571 132 548Q132 539 121 532H75Q64 538 64 556",
          120509: "609 0Q582 3 415 3T221 0H207V62H342V168L328 169Q193 180 117 241Q64 286 64 343T117 445Q193 506 328 517L342 518V624H207V686H221Q248 683 415 683T609 686H623V624H488V518L502 517Q637 506 713 445Q766 400 766 343T713 241Q637 180 502 169L488 168V62H623V0H609ZM342 219T342 343T340 467Q328 467 304 459Q277 451 261 439T237 409T228 378T226 343Q226 314 229 296T250 259T301 228Q331 219 341 219Q342 219 342 343ZM604 343Q604 365 602 379T591 413T560 446T503 464L489 467Q488 467 488 343T489 219Q499 219 529 228Q554 236 570 248T593 277T602 308T604 343",
          120510: "327 0Q306 3 174 3Q52 3 43 0H33V62H98L162 63L360 333L157 624H48V686H59Q80 683 217 683Q368 683 395 686H408V624H335L393 540L452 458L573 623Q573 624 528 624H483V686H494Q515 683 646 683Q769 683 778 686H787V624H658L575 511Q493 398 493 397L508 376Q522 356 553 312T611 229L727 62H835V0H824Q803 3 667 3Q516 3 489 0H476V62H513L549 63L401 274L247 63Q247 62 292 62H338V0H327",
          120511: "64 515Q64 532 71 536T104 540H139Q200 540 207 538Q225 533 236 521T253 489T260 454T264 414Q264 340 287 296T347 237Q369 226 373 226Q374 226 374 425V624H239V686H253Q280 683 447 683T641 686H655V624H520V226L522 227Q525 228 531 229T552 240T580 261T606 298T624 354Q627 368 628 394T631 440T637 482T654 518T686 538Q693 540 754 540H794Q817 540 823 536T829 515Q829 500 824 495T811 489T796 483T782 461T775 408Q767 212 568 175Q526 168 521 168Q520 168 520 115V62H655V0H641Q614 3 447 3T253 0H239V62H374V168L364 169Q290 178 243 203Q126 261 118 409Q117 443 111 461T98 484T83 489T70 495T64 515",
          120512: "598 645T415 645T232 458Q232 385 275 239T318 26Q318 8 311 4T272 -1Q265 -1 240 -1T196 0H88V3Q86 5 70 108Q52 211 51 212V215H113V212Q123 149 132 133Q136 124 149 122T202 118Q241 118 241 119Q241 132 132 277Q64 378 64 457Q64 564 158 630T403 696Q487 696 543 685T661 638Q722 599 744 549T766 458Q766 434 761 410T749 368T729 327T709 293T684 258T663 229Q632 187 614 160T592 126L589 119Q589 118 628 118Q667 119 680 121T698 133Q702 140 706 160T714 196L717 212V215H779V212Q778 211 760 108Q744 5 742 3V0H634H562Q528 0 520 4T512 26Q512 92 555 238T598 458Q598 645 415 645",
          120513: "56 673Q56 679 65 686H892Q901 679 901 673Q901 668 714 331T521 -15Q518 -18 506 -24H452Q440 -19 436 -15Q431 -8 337 162T150 501L57 669Q57 670 56 672V673ZM528 136L758 553H297Q298 551 414 341L528 136",
          120546: "208 74Q208 50 254 46Q272 46 272 35Q272 34 270 22Q267 8 264 4T251 0Q249 0 239 0T205 1T141 2Q70 2 50 0H42Q35 7 35 11Q37 38 48 46H62Q132 49 164 96Q170 102 345 401T523 704Q530 716 547 716H555H572Q578 707 578 706L606 383Q634 60 636 57Q641 46 701 46Q726 46 726 36Q726 34 723 22Q720 7 718 4T704 0Q701 0 690 0T651 1T578 2Q484 2 455 0H443Q437 6 437 9T439 27Q443 40 445 43L449 46H469Q523 49 533 63L521 213H283L249 155Q208 86 208 74ZM516 260Q516 271 504 416T490 562L463 519Q447 492 400 412L310 260L413 259Q516 259 516 260",
          120547: "231 637Q204 637 199 638T194 649Q194 676 205 682Q206 683 335 683Q594 683 608 681Q671 671 713 636T756 544Q756 480 698 429T565 360L555 357Q619 348 660 311T702 219Q702 146 630 78T453 1Q446 0 242 0Q42 0 39 2Q35 5 35 10Q35 17 37 24Q42 43 47 45Q51 46 62 46H68Q95 46 128 49Q142 52 147 61Q150 65 219 339T288 628Q288 635 231 637ZM649 544Q649 574 634 600T585 634Q578 636 493 637Q473 637 451 637T416 636H403Q388 635 384 626Q382 622 352 506Q352 503 351 500L320 374H401Q482 374 494 376Q554 386 601 434T649 544ZM595 229Q595 273 572 302T512 336Q506 337 429 337Q311 337 310 336Q310 334 293 263T258 122L240 52Q240 48 252 48T333 46Q422 46 429 47Q491 54 543 105T595 229",
          120548: "49 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 661Q197 674 203 680H714Q721 676 721 669Q721 664 708 557T694 447Q692 440 674 440H662Q655 445 655 454Q655 455 658 480T661 534Q661 572 652 592Q638 619 603 626T501 634H471Q398 633 393 630Q389 628 386 622Q385 619 315 341T245 60Q245 46 333 46H345Q366 46 366 35Q366 33 363 21T358 6Q356 1 339 1Q334 1 292 1T187 2Q122 2 88 2T49 1",
          120549: "574 715L582 716Q589 716 595 716Q612 716 616 714Q621 712 621 709Q622 707 705 359T788 8Q786 5 785 3L781 0H416Q52 0 50 2T48 6Q48 9 305 358T567 711Q572 712 574 715ZM599 346L538 602L442 474Q347 345 252 217T157 87T409 86T661 88L654 120Q646 151 629 220T599 346",
          120550: "492 213Q472 213 472 226Q472 230 477 250T482 285Q482 316 461 323T364 330H312Q311 328 277 192T243 52Q243 48 254 48T334 46Q428 46 458 48T518 61Q567 77 599 117T670 248Q680 270 683 272Q690 274 698 274Q718 274 718 261Q613 7 608 2Q605 0 322 0H133Q31 0 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 659Q197 676 203 680H757Q764 676 764 669Q764 664 751 557T737 447Q735 440 717 440H705Q698 445 698 453L701 476Q704 500 704 528Q704 558 697 578T678 609T643 625T596 632T532 634H485Q397 633 392 631Q388 629 386 622Q385 619 355 499T324 377Q347 376 372 376H398Q464 376 489 391T534 472Q538 488 540 490T557 493Q562 493 565 493T570 492T572 491T574 487T577 483L544 351Q511 218 508 216Q505 213 492 213",
          120551: "58 8Q58 23 64 35Q64 36 329 334T596 635L586 637Q575 637 512 637H500H476Q442 637 420 635T365 624T311 598T266 548T228 469Q227 466 226 463T224 458T223 453T222 450L221 448Q218 443 202 443Q185 443 182 453L214 561Q228 606 241 651Q249 679 253 681Q256 683 487 683H718Q723 678 723 675Q723 673 717 649Q189 54 188 52L185 49H274Q369 50 377 51Q452 60 500 100T579 247Q587 272 590 277T603 282H607Q628 282 628 271Q547 5 541 2Q538 0 300 0H124Q58 0 58 8",
          120552: "228 637Q194 637 192 641Q191 643 191 649Q191 673 202 682Q204 683 219 683Q260 681 355 681Q389 681 418 681T463 682T483 682Q499 682 499 672Q499 670 497 658Q492 641 487 638H485Q483 638 480 638T473 638T464 637T455 637Q416 636 405 634T387 623Q384 619 355 500Q348 474 340 442T328 395L324 380Q324 378 469 378H614L615 381Q615 384 646 504Q674 619 674 627T617 637Q594 637 587 639T580 648Q580 650 582 660Q586 677 588 679T604 682Q609 682 646 681T740 680Q802 680 835 681T871 682Q888 682 888 672Q888 645 876 638H874Q872 638 869 638T862 638T853 637T844 637Q805 636 794 634T776 623Q773 618 704 340T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q520 50 522 50T528 55T534 64T540 82T547 110T558 153Q565 181 569 198Q602 330 602 331T457 332H312L279 197Q245 63 245 58Q245 51 253 49T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628Q285 635 228 637",
          120553: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM640 466Q640 523 625 565T583 628T532 658T479 668Q370 668 273 559T151 255Q150 245 150 213Q150 156 165 116T207 55T259 26T313 17Q385 17 451 63T561 184Q590 234 615 312T640 466ZM510 276Q510 278 512 288L515 298Q515 299 384 299H253L250 285Q246 271 244 268T231 265H227Q216 265 214 266T207 274Q207 278 223 345T244 416Q247 419 260 419H263Q280 419 280 408Q280 406 278 396L275 386Q275 385 406 385H537L540 399Q544 413 546 416T559 419H563Q574 419 576 418T583 410Q583 403 566 339Q549 271 544 267Q542 265 538 265H530H527Q510 265 510 276",
          120554: "43 1Q26 1 26 10Q26 12 29 24Q34 43 39 45Q42 46 54 46H60Q120 46 136 53Q137 53 138 54Q143 56 149 77T198 273Q210 318 216 344Q286 624 286 626Q284 630 284 631Q274 637 213 637H193Q184 643 189 662Q193 677 195 680T209 683H213Q285 681 359 681Q481 681 487 683H497Q504 676 504 672T501 655T494 639Q491 637 471 637Q440 637 407 634Q393 631 388 623Q381 609 337 432Q326 385 315 341Q245 65 245 59Q245 52 255 50T307 46H339Q345 38 345 37T342 19Q338 6 332 0H316Q279 2 179 2Q143 2 113 2T65 2T43 1",
          120555: "285 628Q285 635 228 637Q205 637 198 638T191 647Q191 649 193 661Q199 681 203 682Q205 683 214 683H219Q260 681 355 681Q389 681 418 681T463 682T483 682Q500 682 500 674Q500 669 497 660Q496 658 496 654T495 648T493 644T490 641T486 639T479 638T470 637T456 637Q416 636 405 634T387 623L306 305Q307 305 490 449T678 597Q692 611 692 620Q692 635 667 637Q651 637 651 648Q651 650 654 662T659 677Q662 682 676 682Q680 682 711 681T791 680Q814 680 839 681T869 682Q889 682 889 672Q889 650 881 642Q878 637 862 637Q787 632 726 586Q710 576 656 534T556 455L509 418L518 396Q527 374 546 329T581 244Q656 67 661 61Q663 59 666 57Q680 47 717 46H738Q744 38 744 37T741 19Q737 6 731 0H720Q680 3 625 3Q503 3 488 0H478Q472 6 472 9T474 27Q478 40 480 43T491 46H494Q544 46 544 71Q544 75 517 141T485 216L427 354L359 301L291 248L268 155Q245 63 245 58Q245 51 253 49T303 46H334Q340 37 340 35Q340 19 333 5Q328 0 317 0Q314 0 280 1T180 2Q118 2 85 2T49 1Q31 1 31 11Q31 13 34 25Q38 41 42 43T65 46Q92 46 125 49Q139 52 144 61Q147 65 216 339T285 628",
          120556: "135 2Q114 2 90 2T60 1Q35 1 35 11Q35 28 42 40Q45 46 55 46Q119 46 151 94Q153 97 325 402T498 709Q505 716 526 716Q543 716 549 710Q550 709 560 548T580 224T591 57Q594 52 595 52Q603 47 638 46H663Q670 39 670 35Q669 12 657 0H644Q613 2 530 2Q497 2 469 2T424 2T405 1Q388 1 388 10Q388 15 391 24Q392 27 393 32T395 38T397 41T401 44T406 45T415 46Q473 46 487 64L472 306Q468 365 465 426T459 518L457 550Q456 550 328 322T198 88Q196 80 196 77Q196 49 243 46Q261 46 261 35Q261 34 259 22Q256 7 254 4T240 0Q237 0 211 1T135 2",
          120557: "289 629Q289 635 232 637Q208 637 201 638T194 648Q194 649 196 659Q197 662 198 666T199 671T201 676T203 679T207 681T212 683T220 683T232 684Q238 684 262 684T307 683Q386 683 398 683T414 678Q415 674 451 396L487 117L510 154Q534 190 574 254T662 394Q837 673 839 675Q840 676 842 678T846 681L852 683H948Q965 683 988 683T1017 684Q1051 684 1051 673Q1051 668 1048 656T1045 643Q1041 637 1008 637Q968 636 957 634T939 623Q936 618 867 340T797 59Q797 55 798 54T805 50T822 48T855 46H886Q892 37 892 35Q892 19 885 5Q880 0 869 0Q864 0 828 1T736 2Q675 2 644 2T609 1Q592 1 592 11Q592 13 594 25Q598 41 602 43T625 46Q652 46 685 49Q699 52 704 61Q706 65 742 207T813 490T848 631L654 322Q458 10 453 5Q451 4 449 3Q444 0 433 0Q418 0 415 7Q413 11 374 317L335 624L267 354Q200 88 200 79Q206 46 272 46H282Q288 41 289 37T286 19Q282 3 278 1Q274 0 267 0Q265 0 255 0T221 1T157 2Q127 2 95 1T58 0Q43 0 39 2T35 11Q35 13 38 25T43 40Q45 46 65 46Q135 46 154 86Q158 92 223 354T289 629",
          120558: "234 637Q231 637 226 637Q201 637 196 638T191 649Q191 676 202 682Q204 683 299 683Q376 683 387 683T401 677Q612 181 616 168L670 381Q723 592 723 606Q723 633 659 637Q635 637 635 648Q635 650 637 660Q641 676 643 679T653 683Q656 683 684 682T767 680Q817 680 843 681T873 682Q888 682 888 672Q888 650 880 642Q878 637 858 637Q787 633 769 597L620 7Q618 0 599 0Q585 0 582 2Q579 5 453 305L326 604L261 344Q196 88 196 79Q201 46 268 46H278Q284 41 284 38T282 19Q278 6 272 0H259Q228 2 151 2Q123 2 100 2T63 2T46 1Q31 1 31 10Q31 14 34 26T39 40Q41 46 62 46Q130 49 150 85Q154 91 221 362L289 634Q287 635 234 637",
          120559: "222 668Q222 670 229 677H654Q677 677 705 677T740 678Q764 678 770 676T777 667Q777 662 764 594Q761 579 757 559T751 528L749 519Q747 512 729 512H717Q710 519 710 525Q712 532 715 559T719 591Q718 595 711 595Q682 598 486 598Q252 598 246 592Q239 587 228 552L216 517Q214 512 197 512H185Q178 517 178 522Q178 524 198 591T222 668ZM227 262Q218 262 215 262T209 266L207 270L227 356Q247 435 250 439Q253 443 260 443H267H280Q287 438 287 433Q287 430 285 420T280 402L278 393Q278 392 431 392H585L590 415Q595 436 598 439T612 443H628Q635 438 635 433Q635 431 615 351T594 268Q592 262 575 262H572Q556 262 556 272Q556 280 560 293L565 313H258L252 292Q248 271 245 267T230 262H227ZM60 0Q53 4 53 11Q53 14 68 89T84 169Q88 176 98 176H104H116Q123 169 123 163Q122 160 117 127T112 88Q112 80 243 80H351H454Q554 80 574 81T597 88V89Q603 100 610 121T622 157T630 174Q633 176 646 176H658Q665 171 665 166Q665 164 643 89T618 7Q616 2 607 1T548 0H335H60",
          120560: "740 435Q740 320 676 213T511 42T304 -22Q207 -22 138 35T51 201Q50 209 50 244Q50 346 98 438T227 601Q351 704 476 704Q514 704 524 703Q621 689 680 617T740 435ZM637 476Q637 565 591 615T476 665Q396 665 322 605Q242 542 200 428T157 216Q157 126 200 73T314 19Q404 19 485 98T608 313Q637 408 637 476",
          120561: "48 1Q31 1 31 10Q31 12 34 24Q39 43 44 45Q48 46 59 46H65Q92 46 125 49Q139 52 144 61Q146 66 215 342T285 622Q285 629 281 629Q273 632 228 634H197Q191 640 191 642T193 661Q197 674 203 680H541Q621 680 709 680T812 681Q841 681 855 681T877 679T886 676T887 670Q887 663 885 656Q880 637 875 635Q871 634 860 634H854Q827 634 794 631Q780 628 775 619Q773 614 704 338T634 58Q634 51 638 51Q646 48 692 46H723Q729 38 729 37T726 19Q722 6 716 0H701Q664 2 567 2Q533 2 504 2T458 2T437 1Q420 1 420 10Q420 15 423 24Q428 43 433 45Q437 46 448 46H454Q481 46 514 49Q528 52 533 61Q536 67 572 209T642 491T678 632Q678 634 533 634H388Q387 631 316 347T245 59Q245 55 246 54T253 50T270 48T303 46H334Q340 38 340 37T337 19Q333 6 327 0H312Q275 2 178 2Q144 2 115 2T69 2T48 1",
          120562: "287 628Q287 635 230 637Q206 637 199 638T192 648Q192 649 194 659Q200 679 203 681T397 683Q587 682 600 680Q664 669 707 631T751 530Q751 453 685 389Q616 321 507 303Q500 302 402 301H307L277 182Q247 66 247 59Q247 55 248 54T255 50T272 48T305 46H336Q342 37 342 35Q342 19 335 5Q330 0 319 0Q316 0 282 1T182 2Q120 2 87 2T51 1Q33 1 33 11Q33 13 36 25Q40 41 44 43T67 46Q94 46 127 49Q141 52 146 61Q149 65 218 339T287 628ZM645 554Q645 567 643 575T634 597T609 619T560 635Q553 636 480 637Q463 637 445 637T416 636T404 636Q391 635 386 627Q384 621 367 550T332 412T314 344Q314 342 395 342H407H430Q542 342 590 392Q617 419 631 471T645 554",
          120564: "65 0Q58 4 58 11Q58 16 114 67Q173 119 222 164L377 304Q378 305 340 386T261 552T218 644Q217 648 219 660Q224 678 228 681Q231 683 515 683H799Q804 678 806 674Q806 667 793 559T778 448Q774 443 759 443Q747 443 743 445T739 456Q739 458 741 477T743 516Q743 552 734 574T710 609T663 627T596 635T502 637Q480 637 469 637H339Q344 627 411 486T478 341V339Q477 337 477 336L457 318Q437 300 398 265T322 196L168 57Q167 56 188 56T258 56H359Q426 56 463 58T537 69T596 97T639 146T680 225Q686 243 689 246T702 250H705Q726 250 726 239Q726 238 683 123T639 5Q637 1 610 1Q577 0 348 0H65",
          120565: "40 437Q21 437 21 445Q21 450 37 501T71 602L88 651Q93 669 101 677H569H659Q691 677 697 676T704 667Q704 661 687 553T668 444Q668 437 649 437Q640 437 637 437T631 442L629 445Q629 451 635 490T641 551Q641 586 628 604T573 629Q568 630 515 631Q469 631 457 630T439 622Q438 621 368 343T298 60Q298 48 386 46Q418 46 427 45T436 36Q436 31 433 22Q429 4 424 1L422 0Q419 0 415 0Q410 0 363 1T228 2Q99 2 64 0H49Q43 6 43 9T45 27Q49 40 55 46H83H94Q174 46 189 55Q190 56 191 56Q196 59 201 76T241 233Q258 301 269 344Q339 619 339 625Q339 630 310 630H279Q212 630 191 624Q146 614 121 583T67 467Q60 445 57 441T43 437H40",
          120566: "45 535Q34 535 31 536T28 544Q28 554 39 578T70 631T126 683T206 705Q230 705 251 698T295 671T330 612T344 514Q344 477 342 473V472Q343 472 347 480T361 509T380 547Q471 704 596 704Q615 704 625 702Q659 692 679 663T700 595Q700 565 696 552T687 537T670 535Q656 535 653 536T649 543Q649 544 649 550T650 562Q650 589 629 605T575 621Q502 621 448 547T365 361Q290 70 290 60Q290 46 379 46H404Q410 40 410 39T408 19Q404 6 398 0H381Q340 2 225 2Q184 2 149 2T94 2T69 1Q61 1 58 1T53 4T51 10Q51 11 53 23Q54 25 55 30T56 36T58 40T60 43T62 44T67 46T73 46T82 46H89Q144 46 163 49T190 62L198 93Q206 124 217 169T241 262T262 350T274 404Q281 445 281 486V494Q281 621 185 621Q147 621 116 601T74 550Q71 539 66 537T45 535",
          120567: "356 624Q356 637 267 637H243Q237 642 237 645T239 664Q243 677 249 683H264Q342 681 429 681Q565 681 571 683H583Q589 677 589 674T587 656Q582 641 578 637H540Q516 637 504 637T479 633T463 630T454 623T448 613T443 597T438 576Q436 566 434 556T430 539L428 533Q442 533 472 526T543 502T613 451T642 373Q642 301 567 241T386 158L336 150Q332 150 331 146Q310 66 310 60Q310 46 399 46H424Q430 40 430 39T428 19Q424 6 418 0H401Q360 2 247 2Q207 2 173 2T119 2T95 1Q87 1 84 1T79 4T77 10Q77 11 79 23Q80 25 81 30T82 36T84 40T86 43T88 44T93 46T99 46T108 46H115Q170 46 189 49T216 62Q220 74 228 107L239 150L223 152Q139 164 82 205T24 311Q24 396 125 462Q207 517 335 533L346 578Q356 619 356 624ZM130 291Q130 203 241 188H249Q249 190 287 342L325 495H324Q313 495 291 491T229 466T168 414Q130 357 130 291ZM536 393Q536 440 507 463T418 496L341 187L351 189Q443 201 487 255Q536 314 536 393",
          120568: "42 0H40Q26 0 26 11Q26 15 29 27Q33 41 36 43T55 46Q141 49 190 98Q200 108 306 224T411 342Q302 620 297 625Q288 636 234 637H206Q200 643 200 645T202 664Q206 677 212 683H226Q260 681 347 681Q380 681 408 681T453 682T473 682Q490 682 490 671Q490 670 488 658Q484 643 481 640T465 637Q434 634 411 620L488 426L541 485Q646 598 646 610Q646 628 622 635Q617 635 609 637Q594 637 594 648Q594 650 596 664Q600 677 606 683H618Q619 683 643 683T697 681T738 680Q828 680 837 683H845Q852 676 852 672Q850 647 840 637H824Q790 636 763 628T722 611T698 593L687 584Q687 585 592 480L505 384Q505 383 536 304T601 142T638 56Q648 47 699 46Q734 46 734 37Q734 35 732 23Q728 7 725 4T711 1Q708 1 678 1T589 2Q528 2 496 2T461 1Q444 1 444 10Q444 11 446 25Q448 35 450 39T455 44T464 46T480 47T506 54Q523 62 523 64Q522 64 476 181L429 299Q241 95 236 84Q232 76 232 72Q232 53 261 47Q262 47 267 47T273 46Q276 46 277 46T280 45T283 42T284 35Q284 26 282 19Q279 6 276 4T261 1Q258 1 243 1T201 2T142 2Q64 2 42 0",
          120569: "216 151Q48 174 48 329Q48 361 56 403T65 458Q65 482 58 494T43 507T28 510T21 520Q21 528 23 534T29 544L32 546H72H94Q110 546 119 544T139 536T154 514T159 476V465Q159 445 149 399T138 314Q142 229 197 201Q223 187 226 190L233 218Q240 246 253 300T280 407Q333 619 333 625Q333 637 244 637H220Q214 642 214 645T216 664Q220 677 226 683H241Q321 681 405 681Q543 681 549 683H560Q566 677 566 674T564 656Q559 641 555 637H517Q448 636 436 628Q429 623 423 600T373 404L320 192Q370 201 419 248Q451 281 469 317T500 400T518 457Q529 486 542 505T569 532T594 543T621 546H644H669Q692 546 692 536Q691 509 676 509Q623 509 593 399Q587 377 579 355T552 301T509 244T446 195T359 159Q324 151 314 151Q311 151 310 150T298 106T287 60Q287 46 376 46H401Q407 40 407 39T405 19Q401 6 395 0H378Q337 2 224 2Q184 2 150 2T96 2T72 1Q64 1 61 1T56 4T54 10Q54 11 56 23Q57 25 58 30T59 36T61 40T63 43T65 44T70 46T76 46T85 46H92Q147 46 166 49T193 62L204 106Q216 149 216 151",
          120570: "125 84Q127 78 194 76H243V78Q243 122 208 215T165 350Q164 359 162 389Q162 522 272 610Q328 656 396 680T525 704Q628 704 698 661Q734 637 755 601T781 544T786 504Q786 439 747 374T635 226T537 109Q518 81 518 77Q537 76 557 76Q608 76 620 78T640 92Q646 100 656 119T673 155T683 172Q690 173 698 173Q718 173 718 162Q718 161 681 82T642 2Q639 0 550 0H461Q455 5 455 9T458 28Q472 78 510 149T584 276T648 402T677 525Q677 594 636 631T530 668Q476 668 423 641T335 568Q284 499 271 400Q270 388 270 348Q270 298 277 228T285 115Q285 82 280 49T271 6Q269 1 258 1T175 0H87Q83 3 80 7V18Q80 22 82 98Q84 156 85 163T91 172Q94 173 104 173T119 172Q124 169 124 126Q125 104 125 84",
          120572: "34 156Q34 270 120 356T309 442Q379 442 421 402T478 304Q484 275 485 237V208Q534 282 560 374Q564 388 566 390T582 393Q603 393 603 385Q603 376 594 346T558 261T497 161L486 147L487 123Q489 67 495 47T514 26Q528 28 540 37T557 60Q559 67 562 68T577 70Q597 70 597 62Q597 56 591 43Q579 19 556 5T512 -10H505Q438 -10 414 62L411 69L400 61Q390 53 370 41T325 18T267 -2T203 -11Q124 -11 79 39T34 156ZM208 26Q257 26 306 47T379 90L403 112Q401 255 396 290Q382 405 304 405Q235 405 183 332Q156 292 139 224T121 120Q121 71 146 49T208 26",
          120573: "29 -194Q23 -188 23 -186Q23 -183 102 134T186 465Q208 533 243 584T309 658Q365 705 429 705H431Q493 705 533 667T573 570Q573 465 469 396L482 383Q533 332 533 252Q533 139 448 65T257 -10Q227 -10 203 -2T165 17T143 40T131 59T126 65L62 -188Q60 -194 42 -194H29ZM353 431Q392 431 427 419L432 422Q436 426 439 429T449 439T461 453T472 471T484 495T493 524T501 560Q503 569 503 593Q503 611 502 616Q487 667 426 667Q384 667 347 643T286 582T247 514T224 455Q219 439 186 308T152 168Q151 163 151 147Q151 99 173 68Q204 26 260 26Q302 26 349 51T425 137Q441 171 449 214T457 279Q457 337 422 372Q380 358 347 358H337Q258 358 258 389Q258 396 261 403Q275 431 353 431",
          120574: "31 249Q11 249 11 258Q11 275 26 304T66 365T129 418T206 441Q233 441 239 440Q287 429 318 386T371 255Q385 195 385 170Q385 166 386 166L398 193Q418 244 443 300T486 391T508 430Q510 431 524 431H537Q543 425 543 422Q543 418 522 378T463 251T391 71Q385 55 378 6T357 -100Q341 -165 330 -190T303 -216Q286 -216 286 -188Q286 -138 340 32L346 51L347 69Q348 79 348 100Q348 257 291 317Q251 355 196 355Q148 355 108 329T51 260Q49 251 47 251Q45 249 31 249",
          120575: "195 609Q195 656 227 686T302 717Q319 716 351 709T407 697T433 690Q451 682 451 662Q451 644 438 628T403 612Q382 612 348 641T288 671T249 657T235 628Q235 584 334 463Q401 379 401 292Q401 169 340 80T205 -10H198Q127 -10 83 36T36 153Q36 286 151 382Q191 413 252 434Q252 435 245 449T230 481T214 521T201 566T195 609ZM112 130Q112 83 136 55T204 27Q233 27 256 51T291 111T309 178T316 232Q316 267 309 298T295 344T269 400L259 396Q215 381 183 342T137 256T118 179T112 130",
          120576: "190 -22Q124 -22 76 11T27 107Q27 174 97 232L107 239L99 248Q76 273 76 304Q76 364 144 408T290 452H302Q360 452 405 421Q428 405 428 392Q428 381 417 369T391 356Q382 356 371 365T338 383T283 392Q217 392 167 368T116 308Q116 289 133 272Q142 263 145 262T157 264Q188 278 238 278H243Q308 278 308 247Q308 206 223 206Q177 206 142 219L132 212Q68 169 68 112Q68 39 201 39Q253 39 286 49T328 72T345 94T362 105Q376 103 376 88Q376 79 365 62T334 26T275 -8T190 -22",
          120577: "296 643Q298 704 324 704Q342 704 342 687Q342 682 339 664T336 633Q336 623 337 618T338 611Q339 612 341 612Q343 614 354 616T374 618L384 619H394Q471 619 471 586Q467 548 386 546H372Q338 546 320 564L311 558Q235 506 175 398T114 190Q114 171 116 155T125 127T137 104T153 86T171 72T192 61T213 53T235 46T256 39L322 16Q389 -10 389 -80Q389 -119 364 -154T300 -202Q292 -204 274 -204Q247 -204 225 -196Q210 -192 193 -182T172 -167Q167 -159 173 -148Q180 -139 191 -139Q195 -139 221 -153T283 -168Q298 -166 310 -152T322 -117Q322 -91 302 -75T250 -51T183 -29T116 4T65 62T44 160Q44 287 121 410T293 590L302 595Q296 613 296 643",
          120578: "21 287Q22 290 23 295T28 317T38 348T53 381T73 411T99 433T132 442Q156 442 175 435T205 417T221 395T229 376L231 369Q231 367 232 367L243 378Q304 442 382 442Q436 442 469 415T503 336V326Q503 302 439 53Q381 -182 377 -189Q364 -216 332 -216Q319 -216 310 -208T299 -186Q299 -177 358 57L420 307Q423 322 423 345Q423 404 379 404H374Q288 404 229 303L222 291L189 157Q156 26 151 16Q138 -11 108 -11Q95 -11 87 -5T76 7T74 17Q74 30 114 189T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287",
          120579: "35 200Q35 302 74 415T180 610T319 704Q320 704 327 704T339 705Q393 701 423 656Q462 596 462 495Q462 380 417 261T302 66T168 -10H161Q125 -10 99 10T60 63T41 130T35 200ZM383 566Q383 668 330 668Q294 668 260 623T204 521T170 421T157 371Q206 370 254 370L351 371Q352 372 359 404T375 484T383 566ZM113 132Q113 26 166 26Q181 26 198 36T239 74T287 161T335 307L340 324H145Q145 321 136 286T120 208T113 132",
          120580: "139 -10Q111 -10 92 0T64 25T52 52T48 74Q48 89 55 109T85 199T135 375L137 384Q139 394 140 397T145 409T151 422T160 431T173 439T190 442Q202 442 213 435T225 410Q225 404 214 358T181 238T137 107Q126 74 126 54Q126 43 126 39T130 31T142 27H147Q206 27 255 78Q272 98 281 114T290 138T295 149T313 153Q321 153 324 153T329 152T332 149T332 143Q332 106 276 48T145 -10H139",
          120581: "83 -11Q70 -11 62 -4T51 8T49 17Q49 30 96 217T147 414Q160 442 193 442Q205 441 213 435T223 422T225 412Q225 401 208 337L192 270Q193 269 208 277T235 292Q252 304 306 349T396 412T467 431Q489 431 500 420T512 391Q512 366 494 347T449 327Q430 327 418 338T405 368Q405 370 407 380L397 375Q368 360 315 315L253 266L240 257H245Q262 257 300 251T366 230Q422 203 422 150Q422 140 417 114T411 67Q411 26 437 26Q484 26 513 137Q516 149 519 151T535 153Q554 153 554 144Q554 121 527 64T457 -7Q447 -10 431 -10Q386 -10 360 17T333 90Q333 108 336 122T339 146Q339 170 320 186T271 209T222 218T185 221H180L155 122Q129 22 126 16Q113 -11 83 -11",
          120582: "166 673Q166 685 183 694H202Q292 691 316 644Q322 629 373 486T474 207T524 67Q531 47 537 34T546 15T551 6T555 2T556 -2T550 -11H482Q457 3 450 18T399 152L354 277L340 262Q327 246 293 207T236 141Q211 112 174 69Q123 9 111 -1T83 -12Q47 -12 47 20Q47 37 61 52T199 187Q229 216 266 252T321 306L338 322Q338 323 288 462T234 612Q214 657 183 657Q166 657 166 673",
          120583: "58 -216Q44 -216 34 -208T23 -186Q23 -176 96 116T173 414Q186 442 219 442Q231 441 239 435T249 423T251 413Q251 401 220 279T187 142Q185 131 185 107V99Q185 26 252 26Q261 26 270 27T287 31T302 38T315 45T327 55T338 65T348 77T356 88T365 100L372 110L408 253Q444 395 448 404Q461 431 491 431Q504 431 512 424T523 412T525 402L449 84Q448 79 448 68Q448 43 455 35T476 26Q485 27 496 35Q517 55 537 131Q543 151 547 152Q549 153 557 153H561Q580 153 580 144Q580 138 575 117T555 63T523 13Q510 0 491 -8Q483 -10 467 -10Q446 -10 429 -4T402 11T385 29T376 44T374 51L368 45Q362 39 350 30T324 12T288 -4T246 -11Q199 -11 153 12L129 -85Q108 -167 104 -180T92 -202Q76 -216 58 -216",
          120584: "74 431Q75 431 146 436T219 442Q231 442 231 434Q231 428 185 241L137 51H140L150 55Q161 59 177 67T214 86T261 119T312 165Q410 264 445 394Q458 442 496 442Q509 442 519 434T530 411Q530 390 516 352T469 262T388 162T267 70T106 5Q81 -2 71 -2Q66 -2 59 -1T51 1Q45 5 45 11Q45 13 88 188L132 364Q133 377 125 380T86 385H65Q59 391 59 393T61 412Q65 431 74 431",
          120585: "268 632Q268 704 296 704Q314 704 314 687Q314 682 311 664T308 635T309 620V616H315Q342 619 360 619Q443 619 443 586Q439 548 358 546H344Q326 546 317 549T290 566Q257 550 226 505T195 405Q195 381 201 364T211 342T218 337Q266 347 298 347Q375 347 375 314Q374 297 359 288T327 277T280 275Q234 275 208 283L195 286Q149 260 119 214T88 130Q88 116 90 108Q101 79 129 63T229 20Q238 17 243 15Q337 -21 354 -33Q383 -53 383 -94Q383 -137 351 -171T273 -205Q240 -205 202 -190T158 -167Q156 -163 156 -159Q156 -151 161 -146T176 -140Q182 -140 189 -143Q232 -168 274 -168Q286 -168 292 -165Q313 -151 313 -129Q313 -112 301 -104T232 -75Q214 -68 204 -64Q198 -62 171 -52T136 -38T107 -24T78 -8T56 12T36 37T26 66T21 103Q21 149 55 206T145 301L154 307L148 313Q141 319 136 323T124 338T111 358T103 382T99 413Q99 471 143 524T259 602L271 607Q268 618 268 632",
          120586: "201 -11Q126 -11 80 38T34 156Q34 221 64 279T146 380Q222 441 301 441Q333 441 341 440Q354 437 367 433T402 417T438 387T464 338T476 268Q476 161 390 75T201 -11ZM121 120Q121 70 147 48T206 26Q250 26 289 58T351 142Q360 163 374 216T388 308Q388 352 370 375Q346 405 306 405Q243 405 195 347Q158 303 140 230T121 120",
          120587: "132 -11Q98 -11 98 22V33L111 61Q186 219 220 334L228 358H196Q158 358 142 355T103 336Q92 329 81 318T62 297T53 285Q51 284 38 284Q19 284 19 294Q19 300 38 329T93 391T164 429Q171 431 389 431Q549 431 553 430Q573 423 573 402Q573 371 541 360Q535 358 472 358H408L405 341Q393 269 393 222Q393 170 402 129T421 65T431 37Q431 20 417 5T381 -10Q370 -10 363 -7T347 17T331 77Q330 86 330 121Q330 170 339 226T357 318T367 358H269L268 354Q268 351 249 275T206 114T175 17Q164 -11 132 -11",
          120588: "58 -216Q25 -216 23 -186Q23 -176 73 26T127 234Q143 289 182 341Q252 427 341 441Q343 441 349 441T359 442Q432 442 471 394T510 276Q510 219 486 165T425 74T345 13T266 -10H255H248Q197 -10 165 35L160 41L133 -71Q108 -168 104 -181T92 -202Q76 -216 58 -216ZM424 322Q424 359 407 382T357 405Q322 405 287 376T231 300Q217 269 193 170L176 102Q193 26 260 26Q298 26 334 62Q367 92 389 158T418 266T424 322",
          120589: "31 207Q31 306 115 374T302 442Q341 442 373 430T405 400Q405 392 399 383T379 374Q373 375 348 390T296 405Q222 405 160 357T98 249Q98 232 103 218T112 195T132 175T154 159T186 141T219 122Q234 114 255 102T286 85T299 78L302 74Q306 71 308 69T315 61T322 51T328 40T332 25T334 8Q334 -31 305 -69T224 -107Q194 -107 163 -92Q156 -88 156 -80Q156 -73 162 -67T178 -61Q186 -61 190 -63Q209 -71 224 -71Q244 -71 253 -59T263 -30Q263 -25 263 -21T260 -12T255 -4T248 3T239 9T227 17T213 25T195 34T174 46Q170 48 150 58T122 74T97 90T70 112T51 137T36 169T31 207",
          120590: "184 -11Q116 -11 74 34T31 147Q31 247 104 333T274 430Q275 431 414 431H552Q553 430 555 429T559 427T562 425T565 422T567 420T569 416T570 412T571 407T572 401Q572 357 507 357Q500 357 490 357T476 358H416L421 348Q439 310 439 263Q439 153 359 71T184 -11ZM361 278Q361 358 276 358Q152 358 115 184Q114 180 114 178Q106 141 106 117Q106 67 131 47T188 26Q242 26 287 73Q316 103 334 153T356 233T361 278",
          120591: "39 284Q18 284 18 294Q18 301 45 338T99 398Q134 425 164 429Q170 431 332 431Q492 431 497 429Q517 424 517 402Q517 388 508 376T485 360Q479 358 389 358T299 356Q298 355 283 274T251 109T233 20Q228 5 215 -4T186 -13Q153 -13 153 20V30L203 192Q214 228 227 272T248 336L254 357Q254 358 208 358Q206 358 197 358T183 359Q105 359 61 295Q56 287 53 286T39 284",
          120592: "413 384Q413 406 432 424T473 443Q492 443 507 425T523 367Q523 334 508 270T468 153Q424 63 373 27T282 -10H268Q220 -10 186 2T135 36T111 78T104 121Q104 170 138 262T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 299 34 333T82 404T161 441Q200 441 225 419T250 355Q248 336 247 334Q247 331 232 291T201 199T185 118Q185 68 211 47T275 26Q317 26 355 57T416 132T452 216T465 277Q465 301 457 318T439 343T421 361T413 384",
          120593: "92 210Q92 176 106 149T142 108T185 85T220 72L235 70L237 71L250 112Q268 170 283 211T322 299T370 375T429 423T502 442Q547 442 582 410T618 302Q618 224 575 152T457 35T299 -10Q273 -10 273 -12L266 -48Q260 -83 252 -125T241 -179Q236 -203 215 -212Q204 -218 190 -218Q159 -215 159 -185Q159 -175 214 -2L209 0Q204 2 195 5T173 14T147 28T120 46T94 71T71 103T56 142T50 190Q50 238 76 311T149 431H162Q183 431 183 423Q183 417 175 409Q134 361 114 300T92 210ZM574 278Q574 320 550 344T486 369Q437 369 394 329T323 218Q309 184 295 109L286 64Q304 62 306 62Q423 62 498 131T574 278",
          120594: "576 -125Q576 -147 547 -175T487 -204H476Q394 -204 363 -157Q334 -114 293 26L284 59Q283 58 248 19T170 -66T92 -151T53 -191Q49 -194 43 -194Q36 -194 31 -189T25 -177T38 -154T151 -30L272 102L265 131Q189 405 135 405Q104 405 87 358Q86 351 68 351Q48 351 48 361Q48 369 56 386T89 423T148 442Q224 442 258 400Q276 375 297 320T330 222L341 180Q344 180 455 303T573 429Q579 431 582 431Q600 431 600 414Q600 407 587 392T477 270Q356 138 353 134L362 102Q392 -10 428 -89T490 -168Q504 -168 517 -156T536 -126Q539 -116 543 -115T557 -114T571 -115Q576 -118 576 -125",
          120595: "161 441Q202 441 226 417T250 358Q250 338 218 252T187 127Q190 85 214 61Q235 43 257 37Q275 29 288 29H289L371 360Q455 691 456 692Q459 694 472 694Q492 694 492 687Q492 678 411 356Q329 28 329 27T335 26Q421 26 498 114T576 278Q576 302 568 319T550 343T532 361T524 384Q524 405 541 424T583 443Q602 443 618 425T634 366Q634 337 623 288T605 220Q573 125 492 57T329 -11H319L296 -104Q272 -198 272 -199Q270 -205 252 -205H239Q233 -199 233 -197Q233 -192 256 -102T279 -9Q272 -8 265 -8Q106 14 106 139Q106 174 139 264T173 379Q173 380 173 381Q173 390 173 393T169 400T158 404H154Q131 404 112 385T82 344T65 302T57 280Q55 278 41 278H27Q21 284 21 287Q21 299 34 333T82 404T161 441",
          120596: "495 384Q495 406 514 424T555 443Q574 443 589 425T604 364Q604 334 592 278T555 155T483 38T377 -11Q297 -11 267 66Q266 68 260 61Q201 -11 125 -11Q15 -11 15 139Q15 230 56 325T123 434Q135 441 147 436Q160 429 160 418Q160 406 140 379T94 306T62 208Q61 202 61 187Q61 124 85 100T143 76Q201 76 245 129L253 137V156Q258 297 317 297Q348 297 348 261Q348 243 338 213T318 158L308 135Q309 133 310 129T318 115T334 97T358 83T393 76Q456 76 501 148T546 274Q546 305 533 325T508 357T495 384",
          120597: "202 508Q179 508 169 520T158 547Q158 557 164 577T185 624T230 675T301 710L333 715H345Q378 715 384 714Q447 703 489 661T549 568T566 457Q566 362 519 240T402 53Q321 -22 223 -22Q123 -22 73 56Q42 102 42 148V159Q42 276 129 370T322 465Q383 465 414 434T455 367L458 378Q478 461 478 515Q478 603 437 639T344 676Q266 676 223 612Q264 606 264 572Q264 547 246 528T202 508ZM430 306Q430 372 401 400T333 428Q270 428 222 382Q197 354 183 323T150 221Q132 149 132 116Q132 21 232 21Q244 21 250 22Q327 35 374 112Q389 137 409 196T430 306",
          120598: "227 -11Q149 -11 95 41T40 174Q40 262 87 322Q121 367 173 396T287 430Q289 431 329 431H367Q382 426 382 411Q382 385 341 385H325H312Q191 385 154 277L150 265H327Q340 256 340 246Q340 228 320 219H138V217Q128 187 128 143Q128 77 160 52T231 26Q258 26 284 36T326 57T343 68Q350 68 354 58T358 39Q358 36 357 35Q354 31 337 21T289 0T227 -11",
          120599: "537 500Q537 474 533 439T524 383L521 362Q558 355 561 351Q563 349 563 345Q563 321 552 318Q542 318 521 323L510 326Q496 261 459 187T362 51T241 -11Q100 -11 100 105Q100 139 127 242T154 366Q154 405 128 405Q107 405 92 377T68 316T57 280Q55 278 41 278H27Q21 284 21 287Q21 291 27 313T47 368T79 418Q103 442 134 442Q169 442 201 419T233 344Q232 330 206 228T180 98Q180 26 247 26Q292 26 332 90T404 260L427 349Q422 349 398 359T339 392T289 440Q265 476 265 520Q265 590 312 647T417 705Q463 705 491 670T528 592T537 500ZM464 564Q464 668 413 668Q373 668 339 622T304 522Q304 494 317 470T349 431T388 406T421 391T435 387H436L443 415Q450 443 457 485T464 564",
          120600: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
          120601: "409 688Q413 694 421 694H429H442Q448 688 448 686Q448 679 418 563Q411 535 404 504T392 458L388 442Q388 441 397 441T429 435T477 418Q521 397 550 357T579 260T548 151T471 65T374 11T279 -10H275L251 -105Q245 -128 238 -160Q230 -192 227 -198T215 -205H209Q189 -205 189 -198Q189 -193 211 -103L234 -11Q234 -10 226 -10Q221 -10 206 -8T161 6T107 36T62 89T43 171Q43 231 76 284T157 370T254 422T342 441Q347 441 348 445L378 567Q409 686 409 688ZM122 150Q122 116 134 91T167 53T203 35T237 27H244L337 404Q333 404 326 403T297 395T255 379T211 350T170 304Q152 276 137 237Q122 191 122 150ZM500 282Q500 320 484 347T444 385T405 400T381 404H378L332 217L284 29Q284 27 285 27Q293 27 317 33T357 47Q400 66 431 100T475 170T494 234T500 282",
          120602: "205 -174Q136 -174 102 -153T67 -76Q67 -25 91 85T127 234Q143 289 182 341Q252 427 341 441Q343 441 349 441T359 442Q432 442 471 394T510 276Q510 169 431 80T253 -10Q226 -10 204 -2T169 19T146 44T132 64L128 73Q128 72 124 53T116 5T112 -44Q112 -68 117 -78T150 -95T236 -102Q327 -102 356 -111T386 -154Q386 -166 384 -178Q381 -190 378 -192T361 -194H348Q342 -188 342 -179Q342 -169 315 -169Q294 -169 264 -171T205 -174ZM424 322Q424 359 407 382T357 405Q322 405 287 376T231 300Q221 276 204 217Q188 152 188 116Q188 68 210 47T259 26Q297 26 334 62Q367 92 389 158T418 266T424 322",
          120603: "206 -10Q158 -10 136 24T114 110Q114 233 199 349L205 358H184Q144 358 121 347Q108 340 95 330T75 312T61 295T53 285Q51 284 38 284Q19 284 19 294Q19 300 38 329T93 391T164 429Q171 431 532 431Q799 431 803 430Q823 423 823 402Q823 377 801 364Q790 358 766 358Q748 358 748 357Q748 355 749 348T752 327T754 297Q754 258 738 207T693 107T618 24T520 -10Q488 -10 466 2T432 36T416 77T411 120Q411 128 410 128T404 122Q373 71 323 31T206 -10ZM714 296Q714 316 707 358H251Q250 357 244 348T230 328T212 301T193 267T176 229T164 187T159 144Q159 62 222 62Q290 62 349 127T432 285Q433 286 434 288T435 291T437 293T440 294T444 294T452 294H466Q472 288 472 286Q472 285 464 244T456 170Q456 62 534 62Q604 62 659 139T714 296",
          120604: "65 0Q45 0 45 18Q48 52 61 60Q65 62 81 62Q155 62 165 74Q166 74 265 228T465 539T569 699Q576 707 583 709T611 711T637 710T649 700Q650 697 695 380L741 63L784 62H827Q839 50 839 45L835 29Q831 9 827 5T806 0Q803 0 790 0T743 1T657 2Q585 2 547 1T504 0Q481 0 481 17Q484 54 497 60Q501 62 541 62Q580 62 580 63Q580 68 573 121T564 179V181H308L271 124Q236 69 236 67T283 62H287Q316 62 316 46Q316 26 307 8Q302 3 295 0L262 1Q242 2 168 2Q119 2 93 1T65 0ZM537 372Q533 402 528 435T521 486T518 504V505Q517 505 433 375L348 244L451 243Q555 243 555 244L537 372",
          120605: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 449 686H477H586Q684 686 733 677T817 634Q853 598 853 547Q853 499 826 460T761 401T695 371T654 360H653L662 358Q670 357 683 354T712 344T744 327T774 303T795 269T804 224Q804 148 732 79T533 1Q524 0 288 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624ZM703 550Q703 571 695 586T675 609T656 619T643 623L545 624H447L417 504Q386 384 386 383T470 382Q554 383 565 385Q632 397 667 447T703 550ZM651 240Q651 265 645 282T626 309T608 322T592 329Q587 330 479 331H373L340 198Q307 65 306 64Q306 62 406 62L507 63L519 65Q565 76 596 107T639 171T651 240",
          120606: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H763Q769 677 772 673T776 666L777 664Q777 659 766 549T751 433Q745 424 723 424Q704 424 699 427T693 441Q693 444 695 467T697 513Q697 543 689 563T670 594T636 610T592 617T534 618H516H456L455 614Q455 613 387 339T317 64Q317 62 375 62H411Q430 62 438 59T447 44Q444 7 430 2Q426 0 416 0Q409 0 359 1T231 2Q152 2 111 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
          120607: "65 0Q59 6 59 9T61 16Q64 20 334 357T608 698Q616 706 629 710Q630 710 634 710T644 710T656 711Q686 711 694 703Q698 699 700 693Q706 674 805 345T904 14Q904 7 894 1L479 0H65ZM630 342L567 551L232 134L462 133H693Q693 137 630 342",
          120608: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H811Q817 677 820 673T824 666L825 664Q825 659 814 549T799 433Q793 424 771 424Q752 424 746 427T740 441Q740 445 742 466T744 505Q744 561 722 585T646 616Q639 617 545 618H456Q456 617 427 502T398 385Q398 384 435 384Q461 385 471 385T499 391T526 405T545 433T562 478Q566 494 571 497T595 501H604Q622 501 626 486Q626 482 593 349T557 213Q552 205 530 205Q499 205 499 219Q499 222 503 242T508 281Q508 308 491 314T429 322Q425 322 423 322H382L317 64Q317 62 390 62Q460 62 493 64T569 80T640 124Q665 149 686 187T719 253T733 283Q739 289 760 289Q791 289 791 274Q791 267 763 201T706 71L678 8Q676 4 667 0H58Q47 5 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
          120609: "223 430Q192 430 192 448Q192 450 225 561T261 677Q265 683 270 684Q273 686 534 686Q796 686 797 685Q805 682 805 673Q805 668 804 661T800 648T798 641Q796 637 531 352L266 67L329 66H364Q412 66 446 70T523 96T596 157Q617 186 630 220T649 273T663 297Q667 299 684 299H688Q715 299 715 281Q715 278 673 145T628 8Q626 4 617 0H348Q289 0 221 0T139 -1Q112 -1 99 -1T78 1T69 5T68 12Q68 16 71 31T77 49L84 57Q91 65 104 79T133 110T170 151T213 196L610 624H540Q533 624 514 624T488 624T467 623T443 620T422 616T398 609T373 600Q292 560 255 449Q251 436 246 433T223 430",
          120610: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L399 389Q399 388 547 388H695L753 623Q753 624 709 624H686Q665 624 660 626T650 639Q653 678 668 684Q672 686 681 686Q685 686 726 685T847 684Q902 684 937 684T986 685T1004 686Q1027 686 1027 668Q1023 632 1011 626Q1006 624 957 624H908L839 344Q768 64 768 63T812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66L679 324Q679 326 531 326H383L382 322L317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624",
          120611: "358 -17Q218 -17 136 49T54 243Q54 298 70 356T123 474T211 582T338 663T504 702H527Q578 702 590 701Q709 688 776 622T844 441Q844 379 825 315T765 192T668 86T532 11T358 -17ZM700 474Q700 525 685 561T642 616T587 643T528 652Q390 652 301 534Q252 472 225 373T198 210Q198 160 214 125T256 71T311 44T372 36Q484 36 571 119Q639 189 669 299T700 474ZM366 428Q366 425 364 419T362 411H466L570 412L573 422Q576 437 581 441T604 445Q620 445 623 444Q636 440 636 429Q636 423 616 340T593 253Q586 243 572 243H566Q545 243 539 249Q536 251 535 253T534 258T534 263T535 270T537 277H329L326 266Q323 251 318 247T295 243Q279 243 276 244Q263 248 263 259Q263 265 283 346Q288 366 295 394Q304 431 308 438T326 445H334H338Q366 445 366 428",
          120612: "247 624Q242 624 233 624T220 623Q186 623 186 640Q186 647 190 664T202 684Q206 686 226 686Q277 684 393 684Q435 684 471 684T528 685T553 686Q573 686 573 670Q573 650 564 632Q556 624 537 624H501H449L380 344Q309 64 309 63T356 62Q361 62 370 62T384 63Q417 63 417 46Q417 26 408 8Q403 3 396 0L352 1Q325 2 216 2T82 1L45 0Q30 7 30 16Q33 51 46 60Q51 62 102 62H154L294 623Q294 624 247 624",
          120613: "536 0Q522 6 522 18Q522 35 533 57Q539 62 557 62Q595 62 601 65L472 330L365 255L342 160Q318 65 317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L302 623Q302 624 258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 239 686Q290 684 403 684Q475 684 512 685T553 686Q576 686 576 668Q572 632 560 626Q555 624 506 624H457L422 481Q386 339 386 337L785 621Q779 624 749 624Q726 624 726 641Q726 645 730 659Q734 675 736 679T747 686L786 685Q812 684 888 684Q908 684 934 685T968 686Q1003 686 1003 669Q1003 646 991 629Q985 624 967 624Q918 624 888 617Q884 617 874 613L865 609Q864 608 732 515T599 420Q599 418 686 242T775 65Q784 62 829 62Q847 62 850 61T860 54Q862 52 862 43Q862 10 845 1Q844 1 842 1T836 0T797 1T694 2Q599 2 573 1L536 0",
          120614: "439 0Q425 6 425 18Q425 35 436 57Q442 62 485 62Q525 62 525 64L478 483Q478 484 465 463T422 394T350 277Q222 69 222 68Q223 67 224 67Q229 64 271 62Q290 62 297 59T305 45Q305 38 302 28Q297 9 293 5T274 0Q270 0 238 1T159 2Q133 2 105 2T72 1Q56 1 52 3T44 15Q44 19 48 35Q53 55 58 58T89 62Q142 64 151 73Q154 76 345 387T538 699Q550 711 570 711H580H592Q613 711 618 695Q619 692 654 379T690 63Q690 62 726 62H746Q776 62 776 44Q773 7 759 2Q755 0 747 0Q743 0 707 1T600 2Q502 2 476 1L439 0",
          120615: "258 624H231Q214 624 208 626T199 639Q203 678 216 684Q220 686 347 686H473Q474 685 478 682T484 677Q487 673 535 413L584 153L608 187Q631 221 672 281T761 410Q935 663 943 671Q949 678 962 686H1082H1166Q1201 686 1210 683T1219 668Q1215 632 1203 626Q1199 624 1149 624H1100L1031 344Q960 64 960 63T1004 62H1031Q1063 62 1063 44Q1060 7 1046 2Q1042 0 1034 0Q1030 0 990 1T875 2Q804 2 767 1T725 0H723Q707 0 703 15Q707 54 720 60Q724 62 773 62H822Q961 618 961 619L754 318Q546 15 543 12Q531 0 510 0Q500 0 495 0T484 5T477 19Q477 20 421 315L367 604L299 335Q234 72 234 68Q234 62 302 62Q334 62 334 46Q332 8 317 2Q313 0 306 0Q301 0 267 1T181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
          120616: "258 624H235Q214 624 209 626T199 639Q203 678 216 684Q220 686 344 686H434Q464 686 477 680Q480 677 607 454Q738 227 739 227Q742 227 789 418T836 618Q836 620 835 620L821 622Q811 622 779 624Q755 624 749 625T740 632Q737 635 737 644Q737 656 742 669T754 685Q755 685 757 685T763 686Q768 686 803 685T890 684Q925 684 951 684T990 685T1006 686Q1014 686 1016 684Q1027 679 1027 668Q1023 632 1011 626Q1007 624 978 624Q912 622 907 617Q907 616 831 314T753 8Q749 0 723 0H712Q699 0 692 7Q692 8 671 44T607 155T526 296L361 580L296 323Q234 74 234 68T302 62H307Q334 62 334 44Q330 6 317 2L313 0L280 1Q260 2 181 2Q125 2 96 1T63 0Q48 0 43 15Q43 19 47 35Q52 55 57 58T94 62Q147 64 164 69L233 345Q302 619 302 622Q302 624 258 624",
          120617: "206 466Q175 466 175 484Q175 487 201 574T230 666Q235 673 241 675H547Q853 675 857 673Q867 668 867 657Q867 655 850 569T832 478Q827 466 808 466H802H795Q773 466 771 481Q771 486 775 508T779 541V549H774Q755 552 505 552Q281 551 267 548Q262 548 255 533T242 496T233 472Q228 466 206 466ZM259 255H252Q231 255 228 270Q228 275 248 355T270 439Q277 448 288 448H298Q321 448 326 440Q331 434 326 414Q326 413 486 413H647L650 424Q654 441 658 444T678 448H683H693Q702 448 705 446T714 432L694 348Q674 267 669 261Q664 255 652 255H643Q622 255 617 261Q613 265 613 272T613 283T616 289Q616 290 456 290H295L294 285Q293 280 292 275T288 265T281 257Q278 255 259 255ZM150 131Q150 124 281 123Q346 123 390 123Q640 123 664 126Q668 127 675 127Q686 131 704 198Q708 213 713 216T733 220H738Q755 220 759 218Q768 213 768 203Q768 198 741 105T710 8Q708 4 699 0H388Q77 0 73 2Q62 7 62 18Q62 27 81 115Q99 206 102 212Q106 220 120 220H129Q140 220 145 220T155 215T160 202Q160 196 159 192Q150 145 150 131",
          120618: "53 245Q53 297 70 356T125 478T216 590T349 671T523 703Q656 703 735 637T815 445Q815 378 791 307Q727 104 527 17Q437 -17 344 -17Q289 -17 242 -5T150 35T79 116T53 245ZM664 489Q664 575 618 611T511 648Q463 648 416 627T334 570Q297 531 270 472T230 355T213 261T208 206Q208 177 215 151T237 98T284 56T358 40Q440 40 510 98T618 270Q664 400 664 489",
          120619: "257 618H231Q198 618 198 636Q202 672 214 678L219 680H1011Q1022 675 1026 665Q1022 626 1009 620Q1005 618 956 618H907L906 614Q906 613 838 339T768 64Q768 62 812 62H839Q871 62 871 44Q867 6 854 2L850 0L808 1Q782 2 675 2Q600 2 560 1T516 0Q499 0 494 15Q498 54 511 60Q515 62 564 62H613L614 66Q614 67 682 341T752 616Q752 618 604 618H456L455 614Q455 613 387 339T317 64Q317 62 361 62H388Q420 62 420 44Q416 6 403 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q48 0 43 15Q47 54 60 60Q64 62 113 62H162L163 66Q163 67 231 341T301 616Q301 618 257 618",
          120620: "162 62L302 623Q302 624 258 624H234Q214 624 209 626T200 638Q200 677 217 684Q220 686 439 686Q667 685 684 682Q686 681 693 680Q713 677 733 671T782 649T829 602T847 528Q847 450 784 382T604 293Q571 288 469 287H373L346 176Q340 151 333 122T321 78L317 64Q317 62 361 62H387Q420 62 420 44Q417 10 404 2L399 0L357 1Q331 2 224 2Q149 2 109 1T65 0Q43 0 43 17Q43 21 47 33Q52 54 57 58T89 62H113H162ZM692 558Q692 611 617 622Q610 623 529 624H452L381 343H458H492Q604 343 641 389Q662 414 677 471T692 558",
          120622: "847 430Q828 430 823 434T817 450Q817 454 817 466T818 487Q818 526 809 551T784 591T737 613T675 622T590 624H528H430L513 487Q594 351 596 345Q596 335 590 330Q583 323 418 204L250 81L363 80Q533 80 591 89T694 142Q739 185 765 252Q772 268 776 271T799 274Q816 274 820 272Q832 266 830 254Q829 250 784 130T736 7Q732 3 725 0H405Q84 0 80 2Q69 7 69 18Q69 26 75 32Q76 32 98 48T168 100T255 164L432 293Q429 300 329 465T225 637Q223 675 245 686H888Q900 680 902 671Q902 667 890 556T876 441Q871 430 847 430",
          120623: "498 62Q511 58 511 43Q511 10 494 1L490 0Q487 0 482 0T424 1T271 2Q201 2 157 2T94 1T72 0H70Q46 0 46 17Q49 54 62 60L66 62H137Q208 62 209 63L218 98Q227 134 244 203T278 339L347 613H300Q262 612 246 611T198 599T146 564Q128 545 114 512T91 454T79 425Q73 419 52 419Q22 419 22 434Q22 440 41 498T80 611L100 666Q105 673 111 675H434Q758 675 762 673Q772 668 772 657Q772 655 756 549T738 434Q735 419 711 419H707Q690 419 686 421Q677 425 677 434Q676 436 678 449T683 485T686 529Q686 553 679 569T662 594T631 607T593 612T544 613H502L433 340Q418 279 400 207T374 100L365 65L364 62H498",
          120624: "32 544Q32 586 91 644T229 703Q277 703 311 683T363 628T389 560T397 491V478L404 491Q455 589 526 646T677 703Q730 703 766 671T802 584Q802 551 793 541T766 531H757L736 532L732 535L729 539V549Q731 569 715 575T658 581H650Q545 581 477 443Q453 392 443 351Q441 345 424 273T389 133T371 64Q371 62 428 62H461Q483 62 492 59T501 44Q498 10 485 2L480 0L431 1Q401 2 278 2T127 1L85 0Q71 5 71 17Q71 24 74 33Q77 46 78 49T84 57T95 61T118 62H154H216Q232 126 249 193T273 287T287 345T296 388T299 416T300 452Q294 581 198 581Q154 581 132 575T106 562T99 546T86 533Q82 531 60 531L39 532Q32 537 32 544",
          120625: "323 624H293Q267 624 261 626T251 639Q255 678 268 684Q272 686 293 686Q348 684 475 684Q557 684 600 685T647 686H648Q671 686 671 668Q667 632 655 626Q650 624 588 624H525L500 520Q500 519 520 518T579 507T656 480Q737 440 737 372Q737 294 648 237Q562 180 426 169L412 168L399 118Q386 66 386 65L385 62H443H479Q498 62 506 59T515 44Q511 8 499 2L494 0L447 1Q417 2 298 2Q212 2 167 1T118 0Q100 0 95 15Q99 54 112 60Q116 62 179 62H241Q242 64 254 114T266 167Q266 168 262 168Q256 168 237 170T180 181T110 205T54 249T29 316Q29 391 112 446T327 516Q345 518 349 518Q351 518 353 518L355 519Q356 520 368 570T381 623Q381 624 323 624ZM342 466Q341 467 339 467Q320 467 283 455T225 420Q181 361 181 296Q181 273 193 257T222 233T254 222T277 219L280 220Q281 220 311 342T342 466ZM583 389Q583 409 576 423T557 444T533 456T509 463T492 467H486L455 343Q444 300 437 271T428 231T426 219Q430 219 445 222T483 232T521 250Q551 269 567 310T583 389",
          120626: "931 686Q953 686 953 670Q953 650 944 632Q936 624 924 624H914Q823 624 803 611Q800 609 696 503T591 396Q591 394 667 229L743 62H787H814Q846 62 846 44Q843 7 829 2Q825 0 817 0Q813 0 775 1T664 2Q590 2 551 1T508 0H507Q484 0 484 18Q484 19 488 37Q492 56 497 58T534 62L566 63Q567 64 520 169T471 274Q469 274 369 172T268 67L315 62Q320 62 328 62L335 61Q347 58 347 44Q344 10 331 2L326 0L287 1Q263 2 177 2Q95 2 78 1L53 0Q38 6 38 17Q38 40 50 57Q56 62 78 62Q169 62 188 75Q194 77 435 324L444 334L439 347Q437 351 373 492L313 624H268H246Q220 624 212 632Q210 636 210 642Q210 655 215 669T227 684Q230 686 247 686Q295 684 398 684Q438 684 472 684T527 685T551 686Q567 686 572 671Q572 667 568 651Q563 631 558 628T523 624T492 623H488L526 540Q563 457 564 457Q564 456 574 466T604 496T645 537L724 619Q716 622 677 624H673Q645 624 645 640Q645 660 654 678Q659 683 666 686L704 685Q728 684 813 684Q847 684 873 684T913 685T931 686",
          120627: "205 471Q205 445 196 403T186 333Q186 303 194 281T218 248T240 233T262 224L361 623Q361 624 303 624Q296 624 284 624T266 623Q232 623 232 641Q232 648 235 657Q240 678 244 682T268 686H273Q329 684 457 684Q502 684 540 684T599 685T626 686H628Q651 686 651 668Q649 633 631 624H505L407 227Q410 228 416 229T439 239T472 259T507 294T539 345Q549 365 563 416T597 498T649 538Q657 540 717 540Q725 540 737 540T755 541Q790 541 790 524Q790 512 784 497Q780 491 767 490T742 477Q736 471 731 463T722 449T715 433T710 419T705 403T701 389Q686 340 658 302T599 240T530 201T463 179T404 169L391 168L379 116Q365 67 365 63Q365 62 422 62H455Q477 62 486 59T495 44Q492 10 479 2L474 0L427 1Q397 2 278 2T131 1L90 0Q76 5 76 17Q76 24 79 33Q82 46 83 49T89 57T100 61T123 62H159H221Q247 162 247 168H244Q241 169 239 169Q202 176 178 182T123 207T74 252Q46 291 46 351Q46 375 52 404T59 454Q59 489 40 489Q32 489 27 494T22 507Q22 535 37 538Q40 540 99 540H128Q168 540 186 528T205 471",
          120628: "162 119Q181 115 235 115L273 116Q273 133 231 222T180 345Q173 368 173 391V406V414Q173 477 214 540Q255 600 315 635Q353 661 423 682T585 703Q656 703 711 690T799 656T851 608T879 555T886 503Q886 449 860 401Q840 359 810 322T725 230T643 146Q619 117 619 116T650 115Q707 115 722 120Q730 123 750 165T775 210Q779 212 796 212Q828 212 828 196Q828 191 807 144T764 52L743 7Q740 4 740 4T733 2T717 0T686 0H632H573Q535 0 526 3T517 17Q517 44 544 103T617 243T671 341Q729 454 729 535Q729 599 686 625T583 652Q549 652 517 645T450 616T388 561T344 470T327 340Q327 304 331 237T336 135Q336 93 330 50T313 2Q308 0 208 0H142Q107 0 100 4T93 25Q93 28 93 41T95 77T96 118L100 199Q105 208 109 210T131 212Q147 212 151 210T161 199V160Q161 131 162 125V119",
          120630: "39 166Q39 213 59 261T117 353T219 424T362 452Q420 452 466 433T536 384T573 325T586 269V265Q593 272 609 308T636 381Q640 397 644 399T669 402H680Q700 402 700 388Q700 379 691 351T659 276T604 188L593 173L595 153Q600 79 612 43H618Q634 45 642 51T653 64T658 71Q661 73 684 73Q712 73 712 59Q712 39 685 16T603 -7Q588 -7 575 -5T551 2T532 12T516 24T503 37T494 49T487 60T481 69L469 61Q362 -8 251 -8Q159 -8 99 36T39 166ZM260 43Q310 43 361 63T438 101T465 124Q458 240 453 277Q435 401 354 401Q291 401 245 355Q230 337 217 313Q201 279 186 216T170 126Q170 72 208 54Q230 43 260 43",
          120631: "59 -194H49Q31 -194 28 -182Q28 -178 107 139T192 473Q212 533 248 580T324 652T395 689T450 701H461Q514 701 551 688T605 652T630 607T637 561Q637 546 634 526T611 465T556 393Q572 382 590 347T608 262Q608 146 522 69T299 -8Q279 -8 261 -6T228 2T204 13T183 26T169 37T157 48L150 56L120 -64Q113 -90 104 -128Q93 -175 89 -184T73 -194H59ZM531 592Q531 651 463 651Q399 651 341 600T253 466Q250 458 217 327T182 185Q180 176 180 159Q180 108 212 76T301 44Q330 44 354 51T393 65T423 91T444 118T459 151T468 179T475 206Q490 264 491 296Q491 313 489 326T484 345L482 350Q481 350 477 348T464 344T444 340T413 335T372 333T334 334T301 340T274 355T265 380Q265 444 397 444Q425 444 445 441T476 436L485 433Q489 433 499 458Q509 482 520 527T531 592ZM424 390Q424 393 389 393Q383 393 374 393T362 392Q348 392 333 388Q345 384 379 384Q424 384 424 390",
          120632: "5 269Q5 285 19 312T57 368T124 421T215 451H241Q274 451 303 439T353 406T389 361T416 311T432 266T442 232L444 220L446 216L450 226Q473 278 513 357T561 441Q566 444 584 444H594Q617 444 617 430Q617 426 596 389T536 273T462 110L452 84L451 70Q447 12 427 -76T388 -192Q375 -211 355 -211Q339 -211 332 -198T325 -171Q325 -114 386 64L393 84V98Q393 181 371 241Q360 280 319 303T210 327Q158 327 126 317T84 296T68 272T59 258Q55 256 36 256Q23 256 18 256T9 260T5 269",
          120633: "216 610Q216 640 229 664T262 700T299 719T327 725Q330 725 406 709T487 690Q513 681 513 651Q513 627 494 607T450 587Q417 587 378 631Q346 663 314 663Q286 663 272 639Q271 637 271 634Q271 609 344 536L397 484Q438 448 458 410T478 313Q478 234 443 147T338 18Q298 -8 249 -8Q214 -8 180 0T113 26T60 81T39 168Q39 200 50 237T87 316T160 391T272 442L260 465Q216 553 216 610ZM348 235Q348 274 336 313T310 372L298 392Q295 391 290 390T269 380T241 359T212 323T185 267Q157 168 157 130Q157 83 186 63T255 43Q280 43 300 67Q317 89 332 138T348 235",
          120634: "224 -17Q126 -17 81 22T36 112Q36 178 84 226L93 236L88 246Q79 264 79 289Q79 341 124 388Q201 461 333 461Q402 461 455 425Q480 409 481 390Q481 365 464 350T428 334Q415 334 387 352T313 370Q141 370 141 293Q141 275 146 270Q147 270 148 270T155 272Q202 291 263 291H270Q349 291 349 244Q349 195 281 183Q274 182 239 182Q201 182 184 185T137 200Q123 188 112 168T100 129T112 98T148 81T189 75T237 74H243H251Q288 74 310 75T359 86T398 112Q405 124 417 124Q426 124 432 117T439 100Q439 88 427 70T390 32T322 -3T224 -17ZM286 238Q286 240 253 240Q245 240 234 239T216 237T209 235Q209 232 250 232Q286 232 286 238",
          120635: "361 711Q373 711 381 703T389 683Q389 681 388 676T383 656T376 618V612H379Q385 618 429 618Q521 618 521 572Q521 551 506 534Q483 510 415 507Q385 507 371 511T336 536L326 528Q254 472 204 381T154 209Q154 190 157 177Q159 165 162 154T170 135T182 119T195 106T212 95T229 86T249 78T269 72T290 66T311 60Q385 37 388 36Q437 14 454 -36Q456 -46 456 -64Q456 -83 455 -90Q445 -132 413 -167T333 -202Q300 -202 257 -191T206 -169Q203 -164 203 -158Q203 -148 210 -140T231 -130Q239 -130 263 -139T326 -151H329Q337 -151 342 -150T352 -143T357 -123Q356 -117 355 -113T350 -104T344 -96T335 -90T324 -85T310 -80T294 -74T275 -68T254 -62Q253 -62 231 -56T205 -48T179 -39T150 -26T125 -10T100 11T80 37T62 70T53 109T48 157Q48 281 123 396T317 586V612Q319 638 320 649T325 678T338 703T361 711ZM454 564Q445 567 424 567Q407 567 398 565T387 563Q387 558 411 558Q434 558 450 562L454 564",
          120636: "24 296Q25 302 27 312T41 350T65 397T103 435T157 452Q202 452 233 435Q267 419 284 384L294 392Q304 401 316 410T348 429T388 445Q410 451 445 451H453Q468 451 482 450T519 443T558 425T587 391T600 337V327Q600 311 538 64Q484 -158 478 -168Q457 -211 409 -211Q386 -211 372 -197T357 -161Q357 -158 415 80Q476 330 477 348Q477 366 473 377T461 393T448 399T432 400H427Q379 400 335 363Q300 332 280 298Q277 293 246 170T213 40Q205 22 186 7T142 -8T103 7T89 39Q89 49 106 117T142 260T164 351Q166 363 166 372Q166 402 148 402Q126 402 110 369Q100 350 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296",
          120637: "213 -8Q130 -8 85 50T40 200V207Q40 303 83 428Q122 535 189 608Q279 702 381 702Q410 702 437 693T492 661T537 593T554 486Q554 428 539 362T495 230T425 111T330 25T213 -8ZM433 562Q433 600 419 625T377 651Q363 651 348 644T311 619T268 557T229 453Q225 441 217 411T208 378H401Q433 500 433 562ZM161 140Q161 43 217 43Q249 43 280 74Q310 103 332 150T378 287Q385 313 385 315Q385 316 289 316H192Q191 308 183 275T169 205T161 140",
          120638: "161 -8Q111 -8 75 16T38 85Q38 95 48 121T80 214T123 368L124 374Q126 381 127 386T132 399T139 414T149 428T162 440T180 448T203 452Q226 452 241 439T257 404Q257 386 230 290T171 111Q157 73 157 57Q157 43 166 43Q209 43 258 69T322 144Q326 157 330 159T348 162H355H366Q386 162 386 148Q386 143 383 132T367 100T335 61Q301 27 253 10T161 -8",
          120639: "258 405Q258 394 251 364T237 308T230 281T238 284T270 306T330 349Q365 377 389 394T450 427T519 444Q545 444 559 430T574 391Q574 360 551 336T491 312Q469 312 454 326T439 364Q439 372 438 372Q433 372 395 344T320 289T283 260H285Q287 260 290 260T297 259Q495 248 495 146Q495 132 491 110T486 74Q486 43 505 43Q520 43 531 53Q559 72 578 141Q582 157 586 159T611 162H622Q642 162 642 148T627 100T578 29T504 -7H495Q435 -7 399 22T363 96Q363 111 366 122T369 142Q369 155 364 165T347 182T326 193T298 200T269 204T238 207T212 210L211 206L190 123L169 40Q161 22 142 7T98 -8T59 7T45 39Q45 48 67 139T112 317L134 404Q142 424 161 438T204 452Q226 452 242 440T258 405",
          120640: "95 -13Q70 -13 55 4T40 41Q40 65 61 88Q65 92 210 207T357 322L235 602Q217 640 185 643Q182 643 178 644T173 645Q161 651 161 666Q161 677 167 684T181 692Q189 694 212 694Q335 694 358 660Q362 653 500 340T647 18Q652 10 652 6Q652 -8 622 -8H589H538L526 -5Q506 1 500 8Q494 16 444 128Q442 133 440 138L387 259L265 134Q156 20 137 4T95 -13",
          120641: "294 -8Q265 -8 244 -5T213 1T201 4Q200 4 192 -32T172 -111T155 -168Q134 -211 86 -211Q62 -211 48 -196T34 -158Q37 -144 103 123T174 404Q182 424 201 438T244 452Q271 452 284 436T298 404Q298 392 267 269T235 114Q235 43 305 43Q342 43 375 68T418 110Q420 112 455 253T492 397Q514 444 562 444Q587 444 601 429T615 397Q615 387 599 320T563 178T542 93Q540 81 540 72Q540 42 558 42Q580 42 596 75Q606 94 616 134Q621 155 624 158T646 162H651H662Q682 162 682 148Q681 142 679 132T665 94T641 47T602 9T548 -8Q523 -8 502 -3T468 11T446 27T432 40L429 46Q367 -8 294 -8",
          120642: "88 382Q70 382 65 385T59 402T64 427T78 443Q79 444 157 448T247 452Q256 452 261 448T266 440L267 437Q267 432 223 252L177 71L192 77Q293 117 371 199T480 388Q489 424 511 438T556 452Q579 452 593 438T608 402Q608 378 593 340T540 251T446 152T299 62T96 -1Q91 -2 78 -2Q38 -2 38 15Q38 22 82 198L127 379Q124 382 88 382",
          120643: "287 648Q291 671 293 680T305 700T329 711Q339 711 347 705T356 687Q356 680 351 653T345 619Q345 615 346 615Q358 618 398 618Q490 618 490 572Q490 553 476 536T434 512Q411 508 378 508H366Q332 508 306 534L298 525Q271 496 254 456T237 375Q237 336 244 336Q272 346 319 346H325Q354 346 372 344T406 331T422 300Q422 252 350 238Q332 236 303 236Q286 236 269 238T240 242T218 247T202 252L196 254Q191 254 174 237T141 191T124 139Q124 108 151 92T267 46Q285 40 295 37Q308 33 332 25T366 13T392 3T415 -8T432 -20T445 -36T451 -55T454 -80Q454 -118 427 -153T358 -199Q349 -201 327 -201Q313 -201 298 -200T271 -196T246 -191T226 -185T210 -180T200 -176L196 -174Q187 -170 187 -158T196 -138T216 -130Q217 -130 254 -140T329 -151Q349 -151 349 -135Q349 -127 340 -122T293 -104Q260 -93 238 -85Q130 -48 115 -41Q71 -19 47 15T23 88Q23 126 48 179T130 277L144 288L136 297Q99 336 99 390Q99 456 148 514T285 602V619Q285 624 286 635T287 648ZM355 563Q362 560 376 558Q424 558 423 564Q405 567 390 567Q369 567 355 563ZM279 292Q297 287 315 287Q355 287 355 293Q355 296 321 296Q316 296 308 296L301 295Q295 295 289 294L279 292",
          120644: "254 -8Q191 -8 146 9T80 54T49 111T39 169Q39 206 53 247T96 329T176 402T292 446Q317 451 336 451L344 452Q353 452 359 452Q457 452 516 408T576 279Q576 169 488 81T254 -8ZM349 400Q321 400 287 385T231 338Q206 301 188 228T170 126Q170 99 178 83Q198 44 260 44Q367 44 409 157Q419 185 432 238T445 317Q445 336 443 348Q435 372 416 384T384 398T349 400",
          120645: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 418 444Q591 444 617 444T652 439Q674 426 674 400Q674 378 661 360T625 335Q621 334 549 333H479L477 321Q476 312 476 279Q476 219 491 174T521 104T536 65Q536 38 511 15T457 -8Q403 -8 386 94Q384 110 384 139Q384 181 391 229T406 304L413 331Q413 333 365 333H316L315 329Q315 328 312 314T301 272T288 220Q274 167 258 103Q244 49 240 38T228 18Q225 16 224 14Q200 -8 172 -8Q146 -8 132 7T118 44Q118 54 121 61Q122 65 142 102T190 195T235 293Q250 329 250 333Q177 333 166 332Q115 328 88 301L77 290L55 289",
          120646: "307 -8Q277 -8 251 0T215 14L205 20Q203 18 193 -25T171 -114T155 -168Q134 -211 87 -211Q64 -211 49 -198T34 -162Q34 -158 137 254Q153 299 179 334T232 390T277 419T311 434Q357 451 403 451Q435 451 455 449T506 435T560 400Q603 357 603 285Q603 172 520 82T307 -8ZM474 343Q474 364 458 382T409 400H406Q339 400 299 341Q281 313 264 257Q261 248 242 170T222 89Q222 84 230 74T260 54T308 43Q334 43 365 57T417 110Q437 145 456 228Q474 298 474 332V343",
          120647: "33 209Q33 277 80 334T195 421T330 451H344Q410 451 439 429Q457 417 457 402Q457 386 445 375T420 363Q415 363 406 368T383 383T354 398Q347 400 330 400Q256 400 196 361T135 265V257Q135 242 147 225T174 199L358 107Q400 77 400 28T362 -63T271 -105Q254 -105 229 -99T195 -86Q188 -82 188 -71Q188 -56 197 -50T216 -44Q225 -44 237 -48T270 -53H282Q293 -44 293 -31Q293 -19 283 -10Q278 -4 200 33T115 76Q77 98 55 133T33 209",
          120648: "35 151Q35 190 51 236T99 327T184 404T306 443Q307 443 316 443T342 443T378 444T425 444T476 444Q606 444 626 444T655 439Q677 426 677 400Q677 358 639 340Q625 333 563 333Q510 333 510 331Q518 319 518 272Q518 155 437 74T226 -8Q123 -8 79 41T35 151ZM396 278Q396 314 375 323T305 332Q249 332 222 310T180 243Q171 219 162 178T153 116V110Q153 43 234 43Q347 43 382 199Q383 203 383 204Q396 255 396 278",
          120649: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 386 444Q571 444 577 442Q588 441 599 432T610 402Q610 359 572 340Q561 335 547 334T452 333H353V331Q352 330 342 261T320 119T306 40Q300 18 281 3Q257 -13 233 -13Q210 -13 196 0T181 35Q181 44 182 48Q183 53 229 187T279 331Q279 333 228 333H209Q163 333 136 328T88 301L77 290L55 289",
          120650: "189 388Q189 396 187 398T176 401Q144 399 122 369T89 304Q84 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 330T64 382T116 431T188 452Q232 452 270 430T308 361Q308 345 275 258T241 123Q241 44 336 44H344Q380 44 415 73T474 140T511 214T526 267Q526 280 513 292Q505 301 486 311T456 333T444 367Q444 400 471 426T529 453Q555 453 579 431T604 358Q604 327 592 271T557 172Q550 157 541 142T510 97T464 47T404 9T328 -8Q264 -8 219 5T154 41T125 85T117 131Q117 182 153 277T189 388",
          120651: "238 4Q230 5 218 8T174 26T118 58T73 112T53 190Q53 219 60 246Q77 313 103 362T143 426T163 443Q165 444 186 444Q217 444 217 432Q217 425 188 392Q157 351 137 291T116 206Q116 127 263 109L276 107L288 139Q347 304 414 378T566 452Q621 449 662 412T703 286Q698 167 598 82T357 -8H332V-11Q332 -12 327 -46T317 -116T310 -157Q306 -180 286 -198T234 -216Q211 -216 197 -203T183 -168Q183 -160 184 -155Q184 -152 198 -112T225 -34T238 4ZM637 260Q637 303 607 322T541 341Q502 341 466 319T405 264Q368 218 356 159Q348 111 348 104Q348 103 361 103Q502 103 569 152T637 260",
          120652: "58 -194Q32 -194 32 -164Q32 -153 46 -139L175 -13Q296 104 296 106Q271 232 226 308Q165 401 141 401Q128 401 117 390T100 365Q94 350 91 349T69 346H45Q35 348 35 359Q35 380 62 411T133 450Q143 452 165 452Q286 452 329 402Q347 379 366 333T394 254T404 215Q404 213 405 213Q405 212 420 227T463 268T520 324Q637 437 640 438Q647 444 661 444Q667 444 676 438T685 419Q685 405 670 389T549 271L420 145Q433 85 444 53Q466 -25 509 -88T575 -151Q590 -151 600 -140T617 -114T626 -98Q629 -96 650 -96H655Q681 -96 681 -108Q681 -114 679 -119Q670 -148 646 -169T591 -199Q581 -201 550 -201Q422 -201 381 -143Q345 -88 316 20L311 39L230 -40Q144 -126 114 -153Q85 -182 77 -188T58 -194",
          120653: "244 141Q244 117 254 98T277 70T305 55T329 48T342 47L344 48L424 366Q501 678 505 686Q508 691 512 692T533 694T555 693T562 688T565 683Q565 678 486 362T406 45Q406 43 415 43Q467 49 514 78T590 143T636 213T653 266Q653 282 641 293T613 311T585 332T572 367Q572 397 598 425T657 453Q684 453 708 430T732 358Q732 330 723 287T706 225Q671 124 578 58T401 -8H393L370 -101Q346 -196 345 -197Q340 -202 316 -202H306Q286 -202 286 -188Q286 -187 296 -144T318 -57T331 -8Q331 -6 328 -6Q290 -6 233 11T148 62Q119 97 119 146Q119 181 154 275T190 388Q190 401 181 401Q154 401 129 375T90 306Q85 288 81 285T61 282H55H44Q24 282 24 296Q24 306 34 329T64 381T116 431T189 452Q237 452 273 428T309 362Q309 343 277 260T244 141",
          120654: "532 367Q532 399 559 426T618 453Q645 453 668 430T691 357Q691 319 677 261T649 171Q640 149 626 125T586 68T521 14T438 -7Q401 -7 372 7T333 30T311 57Q246 -8 165 -8Q119 -8 82 19T30 102Q24 126 24 163V178Q24 210 37 255Q61 346 118 424Q141 451 161 451Q174 451 184 443T194 419Q194 402 179 387Q91 273 91 206Q91 159 122 138T189 117T281 145V173Q283 223 294 253Q304 276 323 289T364 303Q386 303 400 287T415 250Q415 219 385 157L378 144Q378 142 388 136T419 124T462 117Q522 117 566 165T610 255Q610 288 561 320Q532 337 532 367",
          120655: "230 475Q202 475 189 492T175 526T186 570T221 631T288 687T389 710Q430 710 438 709Q495 701 537 679T601 629T637 568T653 509T657 459Q657 409 640 341Q617 248 581 180T507 75T424 16T348 -11T282 -17Q171 -17 113 37Q60 88 60 159Q60 192 71 231Q96 336 184 402Q264 462 366 462Q407 462 439 448T497 389L502 380Q503 381 508 403T519 463T525 531Q523 580 499 610T447 648T387 657Q324 657 283 616Q271 604 276 604Q279 604 286 600T302 583T311 555Q311 523 287 499T230 475ZM196 110Q196 41 287 41Q351 41 398 88Q422 111 437 151Q473 243 473 298Q473 386 409 409Q408 409 383 411Q316 411 278 373Q265 360 259 351T241 311T217 226Q196 143 196 110",
          120656: "415 89Q423 89 429 74T436 46Q436 43 434 39Q432 36 420 29T380 11T322 -5Q311 -7 281 -7Q216 -7 168 10T94 54T56 110T44 167V181Q44 262 94 329Q104 343 119 357T162 391T234 425T327 443Q328 443 348 443T383 444Q434 444 442 438Q450 430 450 416Q446 392 424 383L376 382Q306 381 278 369Q230 349 208 294Q199 274 199 268Q199 267 291 267Q305 267 325 267T353 268Q383 268 394 263T406 241Q406 214 380 206Q375 205 279 205T183 203Q174 176 174 140Q174 87 208 65T292 43Q295 43 300 43T307 44Q337 49 372 69T415 89",
          120657: "114 132Q114 153 140 253T166 372Q166 402 148 402Q126 402 110 369Q100 350 90 310Q85 289 82 286T60 282H55H44Q24 282 24 296Q25 302 27 312T41 350T65 397T104 435T158 452Q184 452 211 445T263 414T288 354V339L265 245Q237 134 237 118V107V102Q237 87 239 77T257 56T300 43Q395 43 455 254Q479 346 479 347L460 354Q294 408 294 528Q294 606 350 653T464 701Q536 701 579 659Q634 601 634 491Q634 468 630 438T623 388L620 370Q624 370 631 369T647 364T656 352Q656 347 653 335Q647 317 642 316Q640 315 637 315Q635 315 619 317Q606 319 605 316Q605 315 603 308Q587 248 550 177T457 57Q379 -8 293 -8Q192 -8 153 23T114 116V132ZM519 566Q519 600 507 625T464 651Q425 651 391 617T356 529Q356 501 370 478T404 441T443 417T477 404L491 400Q493 400 499 428T512 497T519 566",
          120658: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
          120659: "274 -7Q232 -4 195 7T125 38T71 94T51 176V190Q51 213 60 242T95 307T156 373T255 425T393 451L397 452L427 568Q434 597 443 636Q452 677 456 685T472 694H486H495Q517 694 517 680L514 665Q510 650 503 621T489 564L460 451H469Q527 447 574 430T657 370T693 266Q693 163 599 82T350 -7H346L322 -100Q301 -190 295 -197Q291 -202 283 -202H269H258Q238 -202 238 -188Q238 -186 260 -96L283 -7H274ZM449 400Q448 400 404 225T359 47T366 45Q464 55 516 119Q542 149 558 199T575 295Q575 387 462 398L449 400ZM384 398Q384 399 381 399Q350 399 298 378T214 308Q168 236 168 149Q168 68 259 49Q282 44 294 44H295L384 398",
          120660: "371 -168Q357 -168 323 -171T245 -175Q143 -175 109 -150T75 -66Q75 -5 100 108T137 254Q153 299 179 334T232 390T277 419T311 434Q357 451 403 451Q435 451 455 449T506 435T560 400Q603 357 603 282Q603 213 569 148T465 38T304 -8Q273 -8 247 -2T204 14T176 31T159 46T152 53Q152 52 148 27T144 -16Q144 -36 150 -44T189 -58T293 -64Q405 -65 432 -75Q466 -88 466 -127Q466 -140 459 -172Q455 -188 451 -191T426 -194H420Q405 -194 400 -191T395 -176Q396 -170 394 -169T378 -168Q373 -168 371 -168ZM236 116Q236 77 258 60T311 43Q369 43 407 94Q429 123 451 206T474 331Q474 400 409 400H406Q339 400 299 341Q276 305 256 227T236 116",
          120661: "55 289H43Q23 289 23 303Q23 308 33 322Q116 434 199 443Q200 444 562 444Q922 444 928 442Q961 434 961 400Q961 376 944 355T886 333H870Q872 322 872 295V279Q872 230 842 165T751 46T618 -8Q581 -8 554 6T513 45T494 84T484 119Q484 121 478 114Q477 113 476 111Q384 -7 268 -7H265Q251 -7 237 -4T199 11T162 54T147 132Q147 149 149 166T155 198T165 229T176 256T189 281T200 301T211 319T220 333H199Q120 333 88 301L77 290L55 289ZM639 103Q674 103 712 122T780 188T811 295Q811 318 808 330V333H289Q274 318 244 263T214 169Q214 133 236 118T288 103Q351 103 412 153T494 278Q497 290 502 292T529 295Q546 295 551 293T556 283Q556 281 553 260T550 218Q550 153 576 128T639 103",
          120662: "110 0H86Q42 0 42 27Q42 37 148 350T258 667Q269 687 291 692Q295 694 366 694H399Q432 694 448 689T474 667Q477 663 583 350T690 27Q690 0 642 0H617H592Q582 0 575 1T561 2T549 6T541 11T533 18T527 26T522 37T517 49T512 64T506 81L490 130H225Q225 128 208 79T189 27Q185 19 180 14T170 7T156 3T143 1T127 0T110 0ZM439 279Q359 524 359 547L357 555L355 543Q347 503 270 263L259 231H357Q455 231 455 232L439 279",
          120663: "119 1Q98 5 92 28V667Q98 686 118 693Q121 694 272 694H289H346Q439 694 500 681T600 625Q640 580 640 513Q640 451 601 414T504 364L518 361Q568 351 602 329T649 280T666 235T671 197Q671 172 665 147T642 91T586 37T488 5Q456 1 282 1H119ZM489 509Q489 532 479 548T450 573T421 585T394 591Q387 592 315 593H247V404H298H325Q432 404 466 444Q489 470 489 509ZM517 194Q517 235 502 261T458 299T407 313T353 317H329H322H247V101H319H357Q387 101 407 103T452 111T492 133T514 171Q516 176 517 194",
          120664: "92 664Q98 683 118 690Q121 691 312 691T508 689Q534 682 534 644V632V618Q534 582 508 573L502 572Q496 572 489 572Q486 572 463 572T416 573Q333 573 291 575H253V303Q253 31 251 25Q242 0 199 0H170L119 1Q99 7 92 28V664",
          120665: "381 692Q386 694 458 694Q516 694 527 693T549 687Q564 680 575 663Q576 658 715 349T856 27Q856 6 838 1H826Q815 1 795 1T747 1T686 1T616 0T539 0T458 0T378 0T300 0T230 0T169 1T122 1T90 1H78Q60 6 60 27Q62 38 201 349T341 663Q356 687 381 692ZM627 148Q626 149 581 250T492 453L447 554Q447 553 446 552Q444 546 326 278L268 148Q268 147 448 147Q627 147 627 148",
          120666: "277 122Q280 122 380 123T544 125Q552 125 557 125T565 124T569 124Q595 115 595 75V62V47Q595 9 569 2Q564 0 341 0L119 1Q99 7 92 28V664Q98 683 118 690Q121 691 335 691T554 689Q580 682 580 644V632V618Q580 582 554 573Q553 573 551 573T542 572T527 572Q464 572 364 573T260 575H253V412H385H459Q524 412 536 404T549 357Q549 341 549 334T542 318T523 305Q518 303 385 303H253V122H277",
          120667: "411 584Q243 581 131 581Q122 581 116 581T106 582T102 582Q84 589 80 600T76 640L77 667Q83 686 103 693Q106 694 343 694Q579 694 584 692Q592 691 599 684T609 668Q610 665 610 646Q610 614 608 608Q605 603 434 361L261 116Q340 117 402 118T490 119T533 120T560 120H572Q605 120 614 95Q616 89 616 60V46Q616 9 590 2Q585 0 339 0Q92 0 87 2Q79 3 72 10T62 26Q61 29 61 49Q61 84 63 90Q65 94 152 217T325 461T411 584",
          120668: "92 667Q101 694 143 694H172H198Q244 694 251 669Q253 663 253 539V415H540V539Q540 558 540 585T539 621Q539 673 550 683T611 694H621H646Q671 694 683 690T700 669Q702 663 702 347T700 25Q696 9 684 5T646 0H621H606Q560 0 550 11T539 76Q539 85 539 116T540 169V306H253V169Q253 147 253 116T254 75Q254 23 245 12T194 0H170L119 1Q99 7 92 28V667",
          120669: "62 340Q62 716 425 716Q511 716 576 696T681 642T747 559T783 458T793 341Q793 264 777 203T721 89T608 7T428 -22Q62 -22 62 340ZM638 333Q638 365 637 387T632 441T621 495T600 542T567 583T518 611T451 628Q443 629 427 629Q402 629 378 624T327 608T276 571T240 511Q217 453 217 345Q217 254 231 204T279 120Q333 69 428 69Q522 69 576 120Q638 183 638 333ZM279 349V373Q279 413 305 420Q309 422 427 422H487Q550 422 563 414T576 369V349Q576 345 576 337T577 324Q577 284 550 277Q545 275 428 275H369Q306 275 293 283T279 329V349",
          120670: "85 667Q94 694 136 694H165H191Q237 694 244 669Q246 663 246 347T244 25Q235 0 192 0H163L112 1Q92 7 85 28V667",
          120671: "92 667Q101 694 139 694H163H186Q225 694 234 671Q236 663 236 529L237 392L533 682Q550 694 590 694H623H681Q695 680 695 672Q695 670 693 664Q688 657 561 533L431 405L698 33Q701 28 701 23Q701 7 683 0H626H604Q571 0 564 2T545 13Q544 14 530 33T489 90T437 162L332 307Q331 307 284 260L236 214V122V65Q236 32 231 19T210 2Q205 0 161 0L119 1Q99 7 92 28V667",
          120672: "106 0H83Q41 0 41 28Q41 39 133 349T229 667Q242 694 296 694H335H375Q403 694 418 689T442 667Q445 660 537 350T630 28Q630 11 619 6T584 0H555H526Q478 0 465 27Q462 32 431 136T366 372T325 555V546Q320 503 287 376T222 141T186 27Q184 22 177 15T165 6Q154 0 106 0",
          120673: "92 667Q98 684 109 689T146 695Q152 695 167 695T192 694Q200 694 214 694T234 695Q291 695 305 664Q313 651 400 419T487 165Q487 162 488 162T489 165Q489 187 574 413T671 664Q679 680 695 688Q708 694 785 694H828Q855 694 867 689T884 669Q886 663 886 347T884 25Q876 0 832 0H817H802Q758 0 750 25Q748 31 748 293V555L746 544Q737 509 692 386T606 160T564 52Q548 22 502 22H487H472Q423 22 410 52Q407 59 367 160T283 385T231 546L230 548Q229 548 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
          120674: "92 667Q98 684 109 689T146 694H185Q273 694 279 692Q301 689 315 669Q322 660 419 453L554 163L562 143Q564 143 564 401Q564 663 566 669Q574 694 618 694H633H648Q692 694 700 669Q702 663 702 347T700 25Q696 10 683 5T642 0H596H551Q520 0 505 4T478 25Q471 34 374 241L239 532Q231 550 231 552L229 479Q229 440 229 293Q229 31 227 25Q222 9 211 5T176 0H158L119 1Q99 7 92 28V667",
          120675: "627 553Q609 553 512 554T366 555Q316 555 220 554T105 553Q96 553 90 553T82 554T78 554Q61 560 57 571T52 605V623L53 661Q59 680 79 687Q82 688 366 688Q649 688 654 686Q680 679 680 639V621V603Q680 563 654 554Q653 554 651 554T642 554T627 553ZM149 423Q152 424 366 424Q579 424 584 422Q610 415 610 376V358V340Q610 300 584 293Q579 291 366 291H232Q162 291 150 293T129 306Q122 315 122 360L123 397Q129 416 149 423ZM108 135Q143 135 226 134T363 133Q407 133 507 134T632 135H645Q675 135 684 110Q686 104 686 68V49Q686 9 660 2Q655 0 364 0L74 1Q57 7 49 21L47 28L46 65V83Q46 126 72 133Q80 135 108 135",
          120676: "362 715Q364 715 376 715T394 716H400Q542 716 626 643T727 426Q731 395 731 342Q731 271 722 225Q674 -22 396 -22Q320 -22 259 -3T148 68T77 201Q62 257 62 342Q62 447 86 522T173 649Q245 707 362 715ZM568 433Q551 623 396 623Q383 623 370 622T333 612T292 591T257 550T233 485Q223 442 223 350Q223 276 232 227T267 137Q309 74 397 74Q433 74 461 85T507 113T537 156T556 205T566 260T569 310T570 357Q570 409 568 433",
          120677: "92 664Q98 683 118 690Q121 691 396 691T676 689Q695 684 700 666Q702 660 702 345Q702 31 700 25Q696 9 684 5T646 0H621H596Q571 0 559 4T542 25Q540 31 540 307V582H253V307Q253 31 251 25Q242 0 199 0H170L119 1Q99 7 92 28V664",
          120678: "641 470Q641 426 630 391T603 334T561 295T513 271T459 259T408 254T361 253H350H337H253V142Q253 125 253 100T254 67Q254 32 249 19T227 2Q222 0 170 0L119 1Q99 7 92 28V667Q98 686 118 693Q121 694 271 694Q428 693 462 688Q641 656 641 470ZM487 467Q487 495 485 510T474 546T442 578T382 592Q375 593 310 593H250V347H309H339Q364 347 380 348T418 354T451 368T474 395T486 438Q487 444 487 467",
          120680: "322 124Q326 124 457 125T672 127H689Q721 127 730 102Q732 96 732 64V48Q732 9 706 2Q701 0 394 0L89 1Q76 5 69 13T62 29V36Q62 37 62 38Q62 47 70 58T126 126Q161 167 185 196Q302 335 302 336L187 463Q74 584 68 594Q61 603 61 639L62 667Q68 686 88 693Q91 694 396 694T706 692Q732 686 732 647V635V621Q732 585 706 576Q705 576 702 576T691 576T670 575L302 578Q302 577 394 475T490 371Q498 362 498 347Q498 336 488 323T408 226L322 124",
          120681: "67 687Q70 688 366 688Q661 688 666 686Q692 680 692 641V629V615Q692 579 666 570H660Q655 569 648 569Q645 569 624 569T581 570Q505 570 475 572H447V302Q447 31 445 25Q436 0 393 0H364L313 1Q293 7 286 28L285 300V572H257Q227 570 151 570Q130 570 109 570T84 569Q77 569 72 570H66Q48 577 44 588T40 631L41 661Q47 680 67 687",
          120682: "62 560Q62 607 94 644T169 698T253 715Q273 715 286 713T322 704T363 677T398 625Q413 597 423 556L428 540Q429 541 436 566T454 620T494 677T561 713Q570 715 593 715Q682 715 737 668T793 560Q793 549 793 545T786 533T767 520H670Q646 532 644 551T632 579Q618 594 591 594Q539 594 524 530T509 321V216Q509 31 507 25Q498 0 455 0H426L375 1Q355 7 348 28L347 232Q346 344 346 441Q346 442 343 468T335 521T312 571T266 594Q252 594 247 593Q228 586 220 576T212 557T209 539T191 523L185 520H88Q75 527 69 534T63 545T62 560",
          120683: "62 292T62 347T80 445T124 511T183 552T243 574T292 584L315 587H319V627L320 667Q329 694 370 694H397H422Q466 694 473 669Q475 663 475 625V587H478Q479 587 500 584T548 575T608 553T668 513T713 446T732 347Q732 253 674 187Q655 167 628 152T576 128T530 116T493 109L478 107H475V69V50Q475 9 449 2Q444 0 395 0L347 1Q327 7 320 28L319 67V107H315L292 110Q269 114 243 119T184 142T124 182T80 249ZM319 197T319 347T318 497Q316 497 307 494T284 485T262 471Q220 438 220 347Q220 285 239 249Q248 234 261 223T286 208T308 200L317 197Q319 197 319 347ZM572 347V357Q572 387 569 407T548 452T496 491Q495 491 494 491T487 493T475 497V197Q518 210 541 232T571 303Q572 312 572 347",
          120684: "52 1Q37 11 37 23Q37 26 39 32Q39 34 158 202L275 369Q275 370 221 441T112 586T55 663Q53 669 53 672Q53 687 68 693H72Q77 693 84 693T99 694T118 694T139 694H176Q203 694 212 692T230 682Q231 681 239 669T265 634T296 591L358 504L418 591Q481 682 486 686Q491 691 499 692Q505 694 569 694H632Q650 685 650 672Q650 667 646 660Q643 654 592 582T491 440T441 369T566 201T693 29Q694 27 694 23Q694 11 677 0H607L537 1Q523 6 519 10T437 131Q422 153 411 170T390 200T375 222T365 237T359 245L357 247L348 232Q339 218 319 188T283 131Q222 37 211 22T186 1H52",
          120685: "61 585Q62 594 62 597T64 606T73 616T89 626H138Q196 626 208 620Q243 602 253 546T261 431T271 309T325 219Q342 205 349 205Q350 205 350 436L351 667Q360 694 401 694H428H454Q495 694 504 671Q506 663 506 436L507 205Q542 222 561 251T586 318T593 392T595 472T602 546Q614 614 661 625Q665 626 708 626H730Q766 626 780 618T794 582Q794 548 768 540Q755 538 754 501T750 410T736 298T680 191T560 120Q550 116 512 109H506V70V50Q506 9 480 2Q475 0 426 0L378 1Q358 7 351 28L350 68V109L335 111Q298 117 267 129T214 156T175 191T146 229T127 272T115 314T109 357T106 395T105 429Q104 537 87 540Q66 548 63 565Q61 570 61 585",
          120686: "241 122Q225 154 191 199T131 278T83 363T61 464Q61 497 68 527T94 591T145 650T228 693T349 715Q354 715 370 715T396 716Q539 716 622 668Q658 647 682 617T715 556T728 505T732 465Q732 415 711 365T663 280T602 200T552 122H632Q649 122 669 122T693 123H697Q736 123 742 98Q744 92 744 62V47Q744 9 718 2Q713 0 591 0L471 1Q454 7 446 21Q444 27 444 45Q444 96 463 154T506 257T549 360T569 469Q569 504 563 530T538 580T485 616T396 629Q313 629 268 594T223 468Q223 419 243 361T286 258T330 152T350 41Q350 14 335 7T276 -1Q267 -1 241 -1T197 0L77 1Q57 7 50 28L49 59V74Q49 114 75 121Q81 123 100 123Q104 123 124 123T161 122H241",
          120782: "266 654H280H282Q500 654 524 418Q529 370 529 320Q529 125 456 52Q397 -10 287 -10Q110 -10 63 154Q45 212 45 316Q45 504 113 585Q140 618 185 636T266 654ZM374 548Q347 604 286 604Q247 604 218 575Q197 552 193 511T188 311Q188 159 196 116Q202 87 225 64T287 41Q339 41 367 87Q379 107 382 152T386 329Q386 518 374 548",
          120783: "481 0L294 3Q136 3 109 0H96V62H227V304Q227 546 225 546Q169 529 97 529H80V591H97Q231 591 308 647L319 655H333Q355 655 359 644Q361 640 361 351V62H494V0H481",
          120784: "175 580Q175 578 185 572T205 551T215 510Q215 467 191 449T137 430Q107 430 83 448T58 511Q58 558 91 592T168 640T259 654Q328 654 383 637Q451 610 484 563T517 459Q517 401 482 360T368 262Q340 243 265 184L210 140H274Q416 140 429 145Q439 148 447 186T455 237H517V233Q516 230 501 119Q489 9 486 4V0H57V25Q57 51 58 54Q60 57 109 106T215 214T288 291Q364 377 364 458Q364 515 328 553T231 592Q214 592 201 589T181 584T175 580",
          120785: "80 503Q80 565 133 610T274 655Q366 655 421 623T491 538Q493 528 493 510Q493 446 453 407T361 348L376 344Q452 324 489 281T526 184Q526 152 514 121T474 58T392 8T265 -11Q175 -11 111 34T48 152Q50 187 72 209T132 232Q171 232 193 208T216 147Q216 136 214 126T207 108T197 94T187 84T178 77T170 72L168 71Q168 70 179 65T215 54T266 48H270Q331 48 350 105Q358 128 358 185Q358 239 348 268T309 313Q292 321 242 322Q205 322 198 324T191 341V348Q191 366 196 369T232 375Q239 375 247 376T260 377T268 378Q284 383 297 393T326 436T341 517Q341 536 339 547T331 573T308 593T266 600Q248 600 241 599Q214 593 183 576Q234 556 234 503Q234 462 210 444T157 426Q126 426 103 446T80 503",
          120786: "531 0Q510 3 381 3Q238 3 214 0H201V62H313V155H32V217L205 434Q342 606 362 630T387 655L391 656Q395 656 401 656T414 656H427Q447 656 451 645Q453 641 453 429V217H542V155H453V62H542V0H531ZM324 217V494L103 218L213 217H324",
          120787: "100 565V605Q100 637 102 646T113 655Q116 655 139 647T202 631T286 623Q332 623 372 631T434 647T459 655Q466 655 469 651T472 643T472 629Q472 613 463 601Q370 487 219 487Q195 487 183 488T169 490T168 433V376Q169 376 174 379T188 387T211 397T244 405T288 409Q390 409 453 352T517 201Q517 106 445 48T253 -11Q169 -11 113 37T57 154Q57 187 79 208T131 229T183 209T206 154Q206 99 155 83Q152 82 157 78Q196 47 253 47Q347 47 358 135Q358 137 358 138Q360 158 360 209Q360 277 355 301T337 338Q315 358 282 358Q202 358 160 303Q153 294 149 292T130 290Q107 290 102 301Q100 304 100 474V565",
          120788: "48 318Q48 395 68 456T120 553T193 613T273 646T350 655Q425 655 461 616T497 524Q497 485 475 468T428 451Q399 451 378 470T357 521Q357 565 403 588Q375 601 351 601Q313 601 282 584Q242 565 222 526Q199 473 199 367Q201 369 210 380T227 396T246 410T275 422T312 426Q438 426 494 332Q526 285 526 208V199Q526 112 465 53Q428 17 388 3T285 -11Q236 -11 195 7T135 43T104 80Q48 165 48 318ZM375 231V244V268Q375 295 373 310T364 342T341 366T299 374H297Q231 374 208 287Q200 257 200 196Q201 120 209 100Q231 47 288 47Q351 47 368 90Q375 112 375 231",
          120789: "256 -11Q231 -11 208 5T185 65Q185 105 193 146T212 220T241 289T275 349T312 402T346 445T377 479T397 502L400 504H301Q156 503 150 497Q142 491 134 456T126 407H64V411Q65 414 82 544T99 675T130 676H161V673Q161 669 162 666T167 661T173 657T181 654T190 652T200 651T210 650T220 649T229 648Q237 648 254 647T276 646Q277 646 426 644H558V620V607Q558 596 551 586T509 537Q489 515 476 500Q390 401 384 393Q349 339 337 259T324 113T322 38Q307 -11 256 -11",
          120790: "80 474Q80 561 139 607T278 654Q357 654 411 632Q490 593 494 509Q494 424 416 376L407 371L418 364Q432 356 447 345T481 312T513 260T526 192Q526 100 461 45T285 -11Q184 -11 116 32T48 164Q48 181 50 196T58 225T69 249T84 270T100 286T117 300T134 311T149 321T162 329L152 336Q120 360 100 397T80 474ZM347 404Q404 446 404 503Q404 579 317 599Q309 600 276 600Q178 600 170 538Q170 532 171 527T173 518T178 509T184 501T194 492T205 484T219 476T235 467T254 456T275 445L347 404ZM289 47Q323 47 351 54T402 82T425 137Q425 147 421 161Q411 183 391 197T303 249Q224 293 223 293Q220 291 215 288T197 273T175 248T157 213T149 167Q149 109 188 78T289 47",
          120791: "178 59Q206 48 238 48Q311 48 345 102Q370 138 375 259V278Q374 278 369 271T350 252T322 232Q297 220 258 220Q172 220 110 275T48 438V446Q54 561 146 618Q199 654 278 654Q321 654 329 653Q526 621 526 330Q526 252 507 190T457 92T388 31T312 -2T240 -11Q165 -11 121 25T77 120Q77 159 99 176T147 193T194 177T217 122Q217 113 216 106T211 92T205 82T198 73T191 67T184 62T178 59ZM374 446V465Q374 523 364 552T315 598Q309 600 293 601Q227 601 210 562Q199 539 199 433Q199 343 204 319T235 279Q250 272 274 271H282Q293 271 303 274T327 288T353 323T371 385Q374 403 374 446",
          120802: "117 621Q174 678 247 678Q305 678 351 647Q396 617 424 557Q460 472 460 328Q460 271 455 224Q448 154 427 104T376 27T314 -10T249 -22Q201 -22 160 1T91 67Q39 154 39 316Q39 541 117 621ZM250 55Q274 55 293 66T324 93T344 136T357 185T364 240T366 291T367 340Q367 373 367 393T363 449T352 507T332 553T299 589T250 601Q217 601 194 584T159 542T141 479T133 411T132 340V331Q132 299 133 277T137 219T147 157T167 107T201 68T250 55",
          120803: "94 612Q172 616 211 632T284 678H307V73H430V0H88V73H213V317Q213 560 212 560Q210 558 197 554T155 546T96 540L83 539V612H94",
          120804: "222 599Q190 599 166 585T128 550T108 509T97 474T93 459L67 492L42 526L47 539Q72 608 120 642T225 677Q304 677 355 644Q449 579 449 454Q449 373 361 290Q351 280 315 250T199 144Q156 103 137 85L293 86H449V0H50V79L216 242Q284 302 317 349T351 456Q351 517 315 558T222 599",
          120805: "333 521Q333 554 313 579T243 604Q154 604 99 514L78 546Q56 577 56 579Q56 580 62 589T82 611T114 637T162 662T222 677Q224 677 231 677T242 678H245Q318 678 374 634T430 520Q430 483 417 452T382 398T351 369T329 354L328 353Q369 333 373 330Q408 306 432 268T457 184Q457 103 397 41T242 -22Q131 -22 51 58L42 68L49 105L55 142L58 138Q62 134 66 130T77 120T91 108T108 96T129 83T152 72T179 63T209 57T242 54Q285 54 319 86T353 184Q353 231 331 267T260 315L213 316H166V354Q166 392 167 392Q233 395 257 405Q290 418 311 450T333 521",
          120806: "271 654L272 656H380V235H471V159H380V0H286V159H28V235L149 443Q269 652 271 654ZM292 235V607Q292 604 290 591T286 571T280 548T269 517T252 476T226 422T189 354T140 267Q136 260 132 253T126 240L123 236Q123 235 207 235H292",
          120807: "257 350Q236 350 218 342T189 323T171 301T160 281L157 273Q157 272 116 272H75V656H416V577H162V486Q162 396 163 396T174 403T207 418T258 426Q339 426 394 360T449 203Q449 113 386 46T226 -21H223Q188 -21 156 -11T102 13T64 42T41 66T33 77Q34 78 44 95T64 128L73 144Q93 112 117 93Q165 54 223 54Q270 54 306 86T345 197Q345 350 257 350",
          120808: "42 318Q42 396 61 460T109 564T173 629T237 666T289 677H301H317Q359 677 408 658V621Q408 585 407 585H406Q359 605 308 605Q246 605 203 556T146 421Q143 403 144 403Q145 402 152 409Q216 469 299 469Q333 469 357 457T407 405Q457 330 457 226Q457 126 402 57Q340 -22 251 -22Q216 -22 183 -7T116 43T63 149T42 318ZM260 393Q216 393 188 365T150 306T141 243Q141 153 172 104Q192 68 230 56Q238 54 251 54Q311 54 342 116Q360 152 360 226Q360 297 344 332Q320 382 277 392Q275 392 270 392T260 393",
          120809: "42 570V656H457V577L447 564Q345 439 295 289T244 0V-11H145V12Q160 330 356 550Q360 556 365 561T374 571L208 570H42",
          120810: "55 500Q55 568 109 623T250 678Q327 678 385 627T444 501Q444 445 410 410T336 357L329 353H330Q378 335 417 293T456 184Q456 93 393 36T249 -22T106 35T43 184Q43 251 82 293T169 353Q171 354 166 356Q165 356 163 357Q113 378 84 416T55 500ZM358 496Q358 557 325 581T250 605Q206 605 174 580T141 496Q141 446 171 420T250 393Q298 393 328 419T358 496ZM245 316Q205 316 172 285T139 185V179Q139 79 222 57Q231 55 250 55H254Q295 55 327 84Q360 120 360 188Q360 254 326 285Q295 316 245 316",
          120811: "44 476Q57 561 116 619T245 677H255Q308 677 349 647Q392 619 424 545T457 334Q457 178 382 78T205 -22Q168 -22 135 -10T86 14L72 25Q73 25 91 58L110 91Q127 78 136 72T163 60T203 54Q238 54 265 71T308 110T335 164T350 214T357 253V257L347 248Q284 187 200 187Q165 187 140 201T87 258Q42 332 42 430Q42 458 44 476ZM269 604Q265 605 254 605Q222 605 199 591T164 554T148 517T141 487Q140 478 140 430T141 373Q146 335 164 307T207 269Q223 263 247 263Q299 266 328 308T358 417Q358 435 356 456T346 511T318 570T269 604",
          120812: "274 -22Q227 -22 190 -9T128 24T87 76T62 135T49 204T44 271T43 336V343V362Q43 407 45 440T56 524T86 613T141 677Q197 715 264 715Q314 715 353 702T418 669T460 616T487 555T500 483T505 413T506 343Q506 310 506 293T503 241T498 185T486 133T467 83T437 42T397 8T343 -13T274 -22ZM355 355V401Q355 448 354 476T349 537T336 587T311 617T272 629Q270 629 266 629T261 628Q219 618 207 568T194 419V355Q194 203 200 156T231 85Q250 66 275 66Q299 66 318 85Q342 109 348 156T355 355",
          120813: "118 560H116Q107 560 100 561T85 572T76 600Q76 612 77 618T83 632T99 644Q102 645 135 646T207 660T275 700Q292 716 310 716Q353 716 360 691Q362 685 362 386V87H446Q464 76 468 69T473 44Q473 12 446 1H118Q105 7 100 13T94 25T93 44V62Q100 79 119 87H210V329Q210 571 208 571Q182 560 118 560",
          120814: "339 477Q339 505 332 531T301 579T242 601Q165 601 136 503Q133 493 130 490T121 486Q116 486 94 514Q86 523 82 528Q46 572 46 577Q46 591 77 632T147 691Q192 716 257 716Q305 716 351 700Q416 674 455 615T494 481Q494 421 463 376T356 266Q326 240 287 205T224 146T199 122H331Q359 122 392 122T431 123H445Q485 123 492 98Q494 92 494 62V47Q494 9 468 2Q463 0 272 0L83 1Q63 7 56 28L55 57V89Q59 97 215 261Q255 303 275 327T317 394T339 477",
          120815: "61 624Q62 630 83 650T153 693T262 716Q328 716 373 698T438 650T465 593T473 536Q473 438 375 376L387 371Q450 350 476 305T503 208Q503 164 492 126T456 53T380 -2T261 -22Q224 -22 189 -15T130 2T86 24T57 43T46 53Q46 56 53 99T62 145Q65 152 71 152Q76 152 90 143T123 121T175 99T248 87Q302 87 321 113T341 202Q341 264 329 292T279 329L232 331L190 332L184 338V411Q190 417 192 417Q193 418 205 419T232 421T252 424Q280 430 299 461T318 539V551Q318 599 283 609Q276 611 257 611Q225 611 199 601T159 577T136 554T120 543T102 560T76 597T62 618T61 624",
          120816: "278 693H282Q285 693 291 693T305 694T322 694T342 694H377Q402 694 411 691T430 677Q434 670 434 646T435 456V249H461H472Q509 249 516 224Q518 219 518 194Q518 178 518 171T511 155T492 142Q488 140 461 140H435V86V53Q435 9 409 2Q405 0 366 0H351Q306 0 298 25Q296 31 296 86V140H179H123Q99 140 80 129T50 106T37 95Q31 95 31 163V208Q31 246 33 251Q251 673 262 684Q268 691 278 693ZM302 249V416L301 576Q301 536 165 276L151 250L226 249H302",
          120817: "109 282Q87 290 83 310V666Q83 667 84 670T87 676T91 682T98 688T108 693Q112 694 269 694T431 692Q457 686 457 648V637V624Q457 588 431 581Q426 579 326 579H227V510Q227 442 229 442Q243 450 288 450Q377 450 435 399T494 222Q494 -22 241 -22Q202 -22 167 -11T109 16T69 49T45 79T37 94T69 151Q91 185 97 185Q105 185 112 170Q127 135 160 111T240 87Q266 87 284 94T311 111T325 142T331 179T332 226Q332 307 324 335T281 363Q228 363 197 306Q189 289 172 282H109",
          120818: "414 589Q410 589 389 600T334 612Q275 612 243 575Q209 538 202 433V422L209 431Q243 487 317 487Q392 487 440 442Q478 402 490 357T503 236Q503 113 454 54Q421 13 381 -4T279 -22Q263 -22 250 -21T214 -15T173 1T133 30T96 77T68 146T50 242Q46 278 46 336Q46 406 52 447Q84 698 312 715L315 716Q318 716 321 716Q323 716 328 716T337 715Q398 715 425 688V596Q419 591 414 589ZM282 87Q324 89 336 117T348 231Q348 310 343 343T324 388T277 399Q249 399 231 373T208 317T202 253Q202 201 207 168T224 117T249 93T282 87",
          120819: "135 38Q135 190 198 335T353 572H215Q185 572 151 572T110 571H96Q55 571 48 596Q46 602 46 633V648Q46 686 72 693Q76 695 124 695Q134 695 183 695T274 694Q472 694 477 692Q503 686 503 648V637Q503 612 502 605T491 588Q300 349 292 46V36Q292 -4 266 -9Q262 -11 214 -11H192Q160 -11 148 -3T135 38",
          120820: "61 518Q61 574 79 614T128 676T192 706T263 715H270Q298 715 318 714T373 701T430 671T470 612T488 517Q488 459 458 423T390 376Q388 375 393 373Q395 372 398 371Q503 330 503 204Q503 -22 275 -22Q209 -22 163 -3T92 49T57 120T46 204Q46 230 50 252T61 289T77 318T96 339T116 353T134 363T148 369T158 373T160 376Q118 389 90 424T61 518ZM344 538Q344 563 340 578T326 600T307 609T279 612Q232 612 218 594T204 518Q204 459 216 439T275 418Q328 418 338 450Q344 464 344 515V538ZM248 88T274 88T315 94T338 117T346 149T349 197Q349 269 342 290Q338 309 320 320T274 331Q246 331 229 320T207 290Q200 269 200 197Q201 163 202 149T210 118T232 94",
          120821: "347 272Q346 272 342 266T330 250T309 230T276 214T230 207Q185 207 150 223Q116 240 90 276T54 357Q46 393 46 468Q46 469 46 484T47 502T48 520T51 540T55 559T61 579T69 599T81 620T96 640T115 661Q174 716 276 716Q299 716 317 714T369 698T426 658T471 580T499 456Q503 402 503 342Q503 115 392 29Q322 -22 231 -22Q163 -22 115 7L82 31Q76 38 81 46Q116 112 127 123Q130 126 134 126T148 116T179 97T226 87Q287 87 318 132Q323 139 326 146T332 165T337 182T340 204T342 225T345 249T347 272ZM201 547T201 454T211 329T262 294Q276 294 285 296T310 312T335 355Q347 391 347 447Q347 520 340 550T317 595Q300 612 277 612Q226 612 214 580",
          120822: "42 305Q42 450 111 535T257 621Q335 621 390 562Q482 468 482 306Q482 174 418 82T262 -10T106 82T42 305ZM257 545Q209 545 168 481T126 320Q126 220 162 147Q204 65 262 65Q318 65 358 139T398 320V328Q395 411 364 470T284 543Q270 545 257 545",
          120823: "99 461Q99 470 99 474T104 487T120 498T151 502Q213 517 251 596Q264 622 283 622Q308 622 319 597V76H373H401Q428 76 439 69T450 38Q450 11 428 1H127Q104 10 104 38Q104 62 115 69T153 76H181H235V269Q235 461 234 461Q184 426 137 424H133Q124 424 119 425T109 431T99 447V461",
          120824: "52 462Q52 528 110 575T247 622H250Q343 622 407 565T472 421Q472 371 446 324T390 248T308 178Q307 177 275 151T214 101L185 77Q185 76 286 76H388V87Q388 105 397 114T430 123T463 114Q470 107 471 100T472 61V42Q472 24 468 16T450 1H75Q53 10 53 32V38V48Q53 57 63 67T127 122Q153 144 169 157L289 256Q388 345 388 419Q388 473 346 509T231 545H224Q176 545 146 499L144 494Q155 476 155 459Q154 459 155 455T154 444T148 430T136 417T114 408Q113 408 110 408T104 407Q80 407 66 422T52 462",
          120825: "260 546Q233 546 211 541T180 531T171 524L174 514Q177 505 177 497Q177 476 162 461T125 446Q106 446 90 459T73 504Q76 540 98 565T150 601T203 616T239 621Q241 622 265 622Q322 620 362 602T420 558T444 513T451 478Q451 386 369 329L375 326Q381 323 386 320T401 311T419 298T436 283T452 263T466 240T475 212T479 180Q479 99 416 44T259 -11T105 28T44 130Q44 154 59 168T95 183Q117 183 132 169T148 131Q148 119 139 101Q175 65 260 65Q316 65 355 97T395 179Q395 211 375 240Q336 292 253 292H234H215Q194 292 185 299T175 330Q175 350 184 359Q192 368 238 370T309 384Q336 398 351 423T367 474Q367 496 350 513Q321 546 260 546",
          120826: "235 1Q213 10 213 32V38V46Q213 65 230 73Q236 76 274 76H314V168H183L52 169Q37 175 33 182T29 205V218L30 244Q53 283 155 443T264 613Q276 623 298 623H323H363Q378 616 385 601V244H429H450Q474 244 484 237T495 206Q495 179 477 171Q471 168 429 168H385V76H425H442Q466 76 476 69T487 38Q487 10 465 1H235ZM314 244V554L117 245L215 244H314",
          120827: "387 189Q387 244 354 278T273 313Q230 313 205 301T163 271T138 249H120Q102 249 97 251Q85 258 83 266T80 311Q80 320 80 359T81 430Q81 587 82 591Q88 605 103 610H108Q112 610 120 610T138 610T163 610T192 611T225 611T260 611H415Q416 610 421 607T428 602T432 596T436 587T437 573Q437 567 437 562T434 554T431 548T427 543T423 540T418 538L415 536L289 535H164V363L170 366Q175 368 184 372T207 380T238 386T276 389Q357 389 414 331T472 187Q472 116 412 53T245 -10Q218 -10 209 -9Q126 5 89 48T52 137Q52 164 68 177T104 191Q130 191 143 175T156 141Q156 132 154 125T149 113T146 107Q146 104 155 95T188 76T245 65Q298 65 342 98T387 189",
          120828: "357 536Q357 546 318 546Q258 546 205 497T133 357V353L144 361Q210 402 285 402Q362 402 414 350Q479 285 479 193Q479 111 418 50T263 -11Q234 -11 207 -3T149 26T97 81T60 171T45 301Q45 444 129 533T319 622Q388 622 421 589T454 510Q454 491 442 475T402 458Q373 458 362 475T350 510Q350 520 354 528L357 536ZM319 326T269 326T179 298T136 223Q136 202 143 174T176 112T237 68Q246 66 265 66Q319 66 360 107Q395 146 395 197Q395 250 356 289Q319 326 269 326",
          120829: "204 -10Q162 -10 162 40Q162 146 198 261T310 477Q311 478 321 491T342 517T358 535H128V524Q128 506 119 497Q111 489 86 489H78Q55 489 46 508Q44 513 44 557V580Q44 605 52 616T88 627H93Q114 627 125 611H458Q474 598 477 593T480 573Q480 559 478 553T469 543T446 521T408 477Q252 290 246 49Q246 43 246 37T246 27T245 22Q243 11 233 1T204 -10",
          120830: "58 460Q58 523 117 572T254 621Q290 621 298 620Q376 607 421 560T466 460Q466 441 460 424T443 393T421 370T397 352T374 340T357 332L350 330L356 328Q363 325 371 321T392 310T415 295T439 274T459 249T473 217T479 179Q479 102 418 46T262 -10T106 46T45 179Q45 202 52 222T70 257T96 284T123 305T148 319T167 328L174 330L170 332Q166 333 159 336T145 343Q104 362 81 393T58 460ZM382 458Q382 491 349 518T263 546Q215 546 179 521T142 458Q142 421 178 395T262 368Q315 368 348 396T382 458ZM396 178Q396 223 358 257T263 292Q206 292 167 258T128 178Q128 137 163 102T262 66Q324 66 360 101T396 178",
          120831: "392 259Q333 210 236 210H233Q163 210 109 262Q46 325 46 411T99 550Q164 622 264 622Q293 622 319 615T376 587T428 532T464 440T479 304Q479 167 400 78T217 -11Q140 -11 105 22T70 101Q70 124 84 138T122 153Q150 153 162 137T174 101Q174 91 168 76Q179 65 216 65Q267 65 300 93Q322 109 339 130T366 173T380 210T388 242T392 259ZM388 389Q388 438 357 492T268 546T185 520Q129 479 129 415Q129 384 138 363Q145 349 156 334T195 302T255 285Q305 285 345 313T388 389"
        }, {
          8243: "\u2032\u2032",
          8244: "\u2032\u2032\u2032",
          8246: "\u2035\u2035",
          8247: "\u2035\u2035\u2035",
          8279: "\u2032\u2032\u2032\u2032",
          8708: "\u2203\u0338",
          8716: "\u220B\u0338",
          8772: "\u2243\u0338",
          8777: "\u2248\u0338",
          8802: "\u2261\u0338",
          8813: "\u224D\u0338",
          8820: "\u2272\u0338",
          8821: "\u2273\u0338",
          8824: "\u2276\u0338",
          8825: "\u2277\u0338",
          8836: "\u2282\u0338",
          8837: "\u2283\u0338",
          8930: "\u2291\u0338",
          8931: "\u2292\u0338",
          10764: "\u222C\u222C"
        });
      },
      466: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBoldItalic = void 0;
        var n = r(768),
          o = r(4886);
        e.sansSerifBoldItalic = (0, n.AddPaths)(o.sansSerifBoldItalic, {
          305: "54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
          567: "-38 -84Q-36 -84 -14 -95T33 -106H38Q70 -103 78 -86Q83 -78 83 -49T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -59 -123Q-50 -96 -47 -91T-38 -84"
        }, {});
      },
      9671: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifBold = void 0;
        var n = r(768),
          o = r(4471);
        e.sansSerifBold = (0, n.AddPaths)(o.sansSerifBold, {
          33: "111 669Q111 680 111 682T113 689T121 693T137 694H184H249Q255 686 256 681Q244 220 239 213Q236 208 229 208T183 207T137 207T127 213T118 431T111 669ZM110 71V95Q110 137 136 144Q140 146 183 146H200Q246 146 254 121Q256 115 256 73V51Q256 9 230 2Q225 0 181 0L138 1Q121 7 113 21L111 28L110 71",
          34: "38 687Q42 693 45 693Q46 694 111 694H176Q179 690 183 687V556L144 501Q139 494 134 486T126 474T120 465T114 457T110 451T106 447T102 445T98 443T94 443T89 442H73H62Q37 442 37 453Q37 458 55 501T74 546Q74 548 59 548L44 549L38 555V687ZM275 687Q279 693 282 693Q283 694 348 694H413Q416 690 420 687V556L381 501Q376 494 371 486T363 474T357 465T351 457T347 451T343 447T339 445T335 443T331 443T326 442H310H299Q274 442 274 453Q274 458 292 501T311 546Q311 548 296 548L281 549L275 555V687",
          35: "61 365Q61 370 62 375T65 383T69 390T74 395T80 399T85 403T90 406L94 407H344L381 536Q418 668 426 680Q431 687 445 692Q451 694 457 694Q477 694 488 682T500 651Q500 645 466 528T431 409Q431 407 504 407H577L609 521Q651 668 656 675Q669 693 691 693Q710 693 721 680T733 651Q733 645 699 528T664 409Q664 407 743 407H823L827 405Q831 403 834 402T841 397T848 389T853 379T855 365Q855 337 823 324L731 323H639L619 253Q599 181 598 180V177H823L827 175Q831 173 834 172T841 167T848 159T853 149T855 135Q855 107 823 94L698 93H573L540 -21Q498 -168 493 -175Q480 -193 458 -193Q439 -193 428 -180T416 -151Q416 -144 450 -27T485 91Q485 93 412 93H340L307 -21Q265 -168 260 -175Q247 -193 225 -193Q206 -193 195 -180T183 -151Q183 -144 217 -27T252 91Q252 93 173 93L94 94Q61 105 61 135Q61 140 62 145T65 153T69 160T74 165T80 169T85 173T90 176L94 177H185L277 178L297 248L318 320V323H206L94 324Q61 335 61 365ZM551 320V323H479Q406 323 405 322Q404 319 385 249T365 178T438 177L510 178L530 248L551 320",
          36: "231 712L232 716Q232 719 232 722T234 729T239 736T246 743T256 748T271 750Q318 750 318 711V703Q393 692 451 656Q469 645 470 640Q470 635 461 587L453 537Q445 529 442 529Q438 529 424 540T384 565T330 585Q328 585 325 585T320 586L318 587V434Q322 433 333 429T350 424T365 418T382 409T399 397T419 380Q488 313 488 213Q488 24 334 -5L318 -8V-17Q318 -56 279 -56H272Q253 -56 243 -46T232 -30T231 -18V-8H224Q170 2 127 20T68 50T49 67Q49 71 58 122T68 176Q71 182 79 182Q83 182 98 169T145 138T216 110Q228 108 229 108H231V288Q167 299 114 356T61 496Q61 537 70 570T94 624T126 661T162 684T195 696T219 701L228 702H231V712ZM231 521Q231 583 230 583Q226 582 220 579T204 561T193 521Q193 491 212 472Q226 458 230 458Q231 458 231 521ZM318 112Q356 131 356 187Q356 237 318 263V112",
          37: "61 549Q61 733 218 749Q220 749 228 749T241 750Q286 750 321 735T369 708T389 683Q422 634 422 548V538Q422 519 420 501T408 453T381 401T328 364T243 347Q61 347 61 549ZM292 549Q292 663 242 663Q221 663 211 648T198 615T196 566V548Q196 471 206 454Q218 434 242 434Q292 434 292 549ZM243 -55Q223 -55 212 -42T201 -13Q201 -2 207 7Q209 11 480 371T758 738Q770 750 788 750Q805 750 817 738T830 709Q830 694 820 681L544 315Q273 -43 269 -47Q258 -55 243 -55ZM606 146Q606 330 763 346Q764 346 773 346T786 347Q831 347 866 332T914 305T934 280Q966 233 966 146V135Q966 115 964 97T952 49T925 -2T872 -40T788 -56Q606 -56 606 146ZM742 146V132Q742 107 743 93T748 62T762 39T787 31Q819 31 832 79Q837 97 837 146Q837 260 787 260Q767 260 757 246T744 214T742 169V146",
          38: "757 117Q762 117 769 110V3Q759 -7 718 -14T641 -22T571 -15T518 1T477 19T453 31L437 23Q350 -19 257 -22Q158 -22 103 30T47 155Q47 188 57 216T87 263T119 292T151 313L182 333L187 336L181 349Q150 431 150 506Q150 605 211 660T347 716Q417 716 471 668T526 543Q526 517 518 495T471 432T360 343L342 330Q342 327 358 306T402 250T458 189L467 181Q518 225 556 289T607 395L620 437Q622 443 630 443Q631 443 679 430Q718 420 725 418T733 409Q733 402 722 365T670 255T573 123Q562 111 563 111Q589 94 644 94Q678 94 703 100T740 111T757 117ZM397 544Q397 573 384 601T346 629Q320 629 299 607T277 538Q277 484 295 429Q301 413 301 412Q302 409 309 415Q397 476 397 544ZM227 258Q197 228 197 177Q197 150 207 126T234 95Q242 93 251 93Q288 93 337 107L349 110L328 131Q266 196 234 248L227 258",
          39: "81 687Q85 693 88 693Q89 694 154 694H219Q222 690 226 687V556L187 501Q182 494 177 486T169 474T163 465T157 457T153 451T149 447T145 445T141 443T137 443T132 442H116H105Q80 442 80 453Q80 458 98 501T117 546Q117 548 102 548L87 549L81 555V687",
          40: "79 250Q79 352 100 441T152 585T213 678T266 733L287 749Q288 750 324 750H359Q366 741 366 738Q366 734 356 721T329 682T296 623T262 531T238 407Q230 346 230 250Q230 142 244 55T278 -82T318 -165T352 -215T366 -238Q366 -242 359 -249H286L277 -242Q79 -74 79 250",
          41: "61 737Q61 750 85 750H106H141L150 742Q348 574 348 250T150 -242L141 -249L106 -250H87Q61 -250 61 -238Q61 -233 74 -216Q157 -113 183 51Q197 130 197 250T183 449Q174 505 158 554T126 634T95 687T71 722T61 737",
          42: "241 579Q241 582 228 639T215 702Q215 722 233 736T271 750Q296 750 315 736T334 702V697Q334 693 328 664T314 607L308 579L352 620Q389 654 397 660T417 668Q447 668 464 647T482 602Q482 591 479 583T472 569T459 559T443 552T421 546T397 538L342 521L397 504Q405 501 420 497T442 490T458 483T472 473T479 460T482 440Q482 416 465 395T417 374Q406 375 398 381T352 422L308 463L314 435Q321 407 327 378T334 345Q336 333 327 319T296 295Q288 293 275 293Q241 293 227 311T215 345Q215 349 221 378T234 435L241 463L197 422Q160 388 152 382T132 374Q102 374 85 395T67 440Q67 451 70 459T77 473T90 483T106 490T128 496T152 504L207 521L152 538Q144 541 129 545T107 552T91 559T77 569T70 582T67 602Q67 626 84 647T132 668Q143 667 151 661T197 620L241 579",
          43: "61 250Q61 276 94 292H386V436V535Q386 577 388 589T401 607Q411 617 427 617Q458 617 468 587Q470 581 470 436V292H762L766 290Q770 288 773 287T780 282T787 274T792 264T794 250Q794 222 762 209L616 208H470V64Q470 -81 468 -87Q458 -116 428 -116T388 -87Q386 -81 386 64V208H240L94 209Q61 220 61 250",
          44: "81 139Q85 145 88 145Q89 146 154 146H219Q222 142 226 139V8L187 -47Q182 -54 177 -62T169 -74T163 -83T157 -91T153 -97T149 -101T145 -103T141 -105T137 -105T132 -106H116H105Q80 -106 80 -95Q80 -90 98 -47T117 -2Q117 0 102 0L87 1L81 7V139",
          45: "12 230Q12 257 26 265T80 274Q88 274 114 274T158 273T201 273T235 274Q276 274 290 266T305 230T291 194T235 185Q226 185 201 185T159 186Q143 186 119 186T85 185Q43 185 28 193T12 230",
          46: "219 146Q222 142 226 139V7L222 4L219 1L154 0Q102 0 94 0T82 6Q80 9 80 74L81 139Q85 145 88 145Q89 146 154 146H219",
          47: "103 -249Q81 -249 71 -235T61 -207Q61 -201 62 -198Q64 -192 235 265T409 727Q418 750 445 750Q464 750 476 737T488 707Q488 701 313 234Q143 -225 137 -232Q126 -249 103 -249",
          58: "226 319L219 313H87L81 319L80 384Q80 437 80 445T86 456Q89 458 154 458H219Q222 454 226 451V319ZM219 146Q222 142 226 139V7L222 4L219 1L154 0Q102 0 94 0T82 6Q80 9 80 74L81 139Q85 145 88 145Q89 146 154 146H219",
          59: "226 319L219 313H87L81 319L80 384Q80 437 80 445T86 456Q89 458 154 458H219Q222 454 226 451V319ZM81 139Q85 145 88 145Q89 146 154 146H219Q222 142 226 139V8L187 -47Q182 -54 177 -62T169 -74T163 -83T157 -91T153 -97T149 -101T145 -103T141 -105T137 -105T132 -106H116H105Q80 -106 80 -95Q80 -90 98 -47T117 -2Q117 0 102 0L87 1L81 7V139",
          61: "94 324Q61 335 61 366Q61 396 91 405Q96 407 429 407H762Q763 406 767 404T774 400T781 395T787 387T792 378T794 365Q794 338 762 324H94ZM94 94Q61 105 61 135Q61 149 69 160T92 175Q97 177 430 177H762L766 175Q770 173 773 172T780 167T787 159T792 149T794 135Q794 107 762 94H94",
          63: "61 644Q61 652 87 666T157 693T244 705Q344 705 400 671T457 551Q457 516 446 490T422 451T387 421T356 391Q330 361 318 332T305 292T303 252Q303 218 300 213T290 208T244 207H220Q194 207 188 213Q187 214 186 215V255Q187 282 188 296T198 345T229 417T288 496Q306 515 306 559Q306 596 296 607T253 618Q214 618 185 607T143 583T120 558T103 547Q99 547 95 551Q93 553 77 597T61 644ZM171 71V95Q171 137 197 144Q201 146 244 146H261Q307 146 315 121Q317 115 317 73V51Q317 9 291 2Q286 0 242 0L199 1Q182 7 174 21L172 28L171 71",
          64: "61 264T61 347T82 494T136 596T217 660T311 694T410 704Q460 704 471 703Q534 694 577 666Q633 623 651 552T670 370V342Q670 249 633 195Q583 116 454 116Q238 116 238 347Q238 443 276 499Q328 578 456 578Q488 578 494 577L504 575Q475 617 430 617H421Q196 617 196 347Q196 215 253 143Q310 76 427 76Q499 76 561 102L575 107H664Q671 97 671 94V89L663 81Q566 -11 422 -11Q365 -11 316 -2T219 33T137 97T82 200ZM469 490Q459 492 453 492Q429 492 405 472Q374 439 374 347Q374 233 423 210Q436 202 454 202L486 210Q536 228 536 347Q536 461 486 484Q476 490 469 490",
          91: "318 -206Q318 -235 305 -243T255 -251Q248 -251 229 -251T198 -250H143Q112 -250 99 -246T81 -225Q79 -219 79 250T81 725Q85 741 98 745T143 750H198Q210 750 229 750T255 751Q291 751 304 743T318 707Q318 680 301 668Q293 663 255 663H224V-163H255Q293 -163 301 -168Q318 -180 318 -206",
          93: "24 706Q24 734 39 742T90 751Q97 751 114 751T143 750H198Q230 750 243 746T261 725Q263 719 263 250T261 -225Q257 -241 244 -245T198 -250H143Q131 -250 112 -250T86 -251Q50 -251 37 -243T24 -207Q24 -180 41 -168Q49 -163 87 -163H118V663H87H71Q24 663 24 706",
          94: "108 550Q108 554 135 589T190 658T219 692Q221 694 275 694Q328 694 330 693Q331 692 381 629T438 557Q441 553 441 549T434 538L399 537Q363 537 362 538Q361 538 318 575L275 611Q274 611 231 575Q188 538 187 538Q186 537 150 537L115 538Q108 545 108 550",
          95: "0 -66Q0 -32 26 -25Q30 -23 274 -23Q469 -23 497 -23T532 -28Q549 -40 549 -67Q549 -93 532 -105Q525 -109 498 -109T275 -110Q31 -110 26 -108Q0 -101 0 -66",
          126: "92 215Q92 259 122 301T204 344Q238 344 264 329T310 300T343 285Q356 285 361 295T369 322T377 344H450Q457 334 457 330Q457 281 427 240T344 198Q312 198 285 213T239 242T206 257Q188 257 182 230T172 199L137 198H120Q102 198 97 200T92 215",
          305: "54 431Q63 458 102 458H127H149Q192 458 199 433Q201 427 201 229T199 25Q190 0 149 0H125L81 1Q61 7 54 28V431",
          567: "-38 -84Q-36 -84 -14 -95T33 -106H38Q70 -103 78 -86Q83 -78 83 -49T84 180Q84 427 86 433Q93 458 136 458H158H180Q201 458 209 456T225 443Q230 436 231 418Q232 397 232 313V183V124V40Q232 -55 228 -87T203 -147Q166 -205 78 -205Q31 -205 -20 -189T-71 -159Q-71 -156 -59 -123Q-50 -96 -47 -91T-38 -84",
          768: "-458 682Q-458 690 -452 692T-426 694H-381H-314L-312 691Q-311 691 -305 682T-287 655T-263 622L-218 555V549Q-218 544 -224 538L-259 537Q-295 537 -296 538Q-298 539 -376 606T-456 676Q-458 680 -458 682",
          769: "-290 537H-310Q-334 537 -334 549Q-334 553 -311 588T-264 656L-241 690Q-240 690 -239 691T-236 693Q-235 694 -167 694H-100Q-93 684 -93 681T-94 677Q-95 675 -173 607T-255 538Q-256 537 -290 537",
          770: "-442 550Q-442 554 -415 589T-360 658T-331 692Q-329 694 -275 694Q-222 694 -220 693Q-219 692 -169 629T-112 557Q-109 552 -109 549Q-109 545 -116 538L-151 537Q-187 537 -188 538Q-189 538 -232 575L-275 611Q-276 611 -319 575Q-362 538 -363 538Q-364 537 -400 537L-435 538Q-442 545 -442 550",
          771: "-458 565Q-458 609 -428 651T-346 694Q-312 694 -286 679T-240 650T-207 635Q-194 635 -189 645T-181 672T-173 694H-100Q-93 684 -93 680Q-93 631 -123 590T-206 548Q-238 548 -265 563T-311 592T-344 607Q-362 607 -368 580T-378 549L-413 548H-430Q-448 548 -453 550T-458 565",
          772: "-84 660Q-81 656 -77 653V567L-81 564L-84 561L-274 560H-383Q-469 560 -471 565L-472 566Q-474 569 -474 611L-473 653Q-469 659 -466 659Q-465 660 -274 660H-84",
          774: "-123 694Q-80 694 -80 657Q-80 626 -99 601T-161 563Q-199 552 -275 552Q-352 552 -389 563Q-470 586 -470 655Q-470 667 -468 673Q-457 694 -435 694H-431Q-408 694 -396 685Q-387 676 -387 671Q-384 661 -275 661Q-167 661 -164 671Q-164 674 -163 677T-151 687T-123 694",
          775: "-329 596Q-346 602 -351 611T-356 638V646Q-356 653 -356 654T-356 661T-355 668T-353 673T-351 679T-347 684T-341 689T-332 693T-274 695H-221Q-202 683 -198 676T-194 645Q-194 632 -195 625T-202 610T-221 596H-329",
          776: "-331 695Q-312 683 -308 676T-304 645Q-304 632 -304 626T-311 610T-331 596L-380 595H-408Q-448 595 -457 617Q-459 621 -459 645T-457 673Q-448 696 -409 696Q-405 696 -396 696T-380 695H-331ZM-247 644Q-247 658 -246 665T-239 680T-221 694Q-217 695 -169 695H-143Q-102 695 -93 672Q-91 664 -91 645V635Q-91 613 -106 602Q-113 597 -121 596T-171 595L-219 596Q-232 600 -238 608T-246 622T-247 644",
          778: "-365 616Q-365 658 -331 676T-256 694Q-253 694 -247 694T-236 693Q-166 693 -139 666Q-119 644 -119 616T-139 565Q-166 538 -237 538H-242Q-365 538 -365 616ZM-181 616Q-181 641 -195 647T-242 654Q-258 654 -266 654T-284 650T-298 638T-303 616Q-303 592 -289 585T-242 577Q-209 577 -195 584T-181 616",
          779: "-426 686Q-424 694 -394 694H-350H-283Q-277 686 -277 682Q-277 673 -317 608T-361 538L-396 537H-420Q-432 537 -436 539T-440 548Q-440 560 -434 616Q-432 633 -430 650T-427 677L-426 686ZM-243 686Q-241 694 -211 694H-167H-100Q-94 686 -94 682Q-94 673 -134 608T-178 538L-213 537H-237Q-249 537 -253 539T-257 548Q-257 560 -251 616Q-249 633 -247 650T-244 677L-243 686",
          780: "-442 645Q-442 657 -418 657H-398Q-393 657 -388 657T-379 657T-371 656T-365 656H-363L-319 620L-276 583Q-275 583 -232 619Q-189 656 -188 656Q-187 657 -151 657H-116Q-109 649 -109 645Q-109 642 -112 637Q-118 629 -168 566T-220 501Q-222 500 -275 500Q-329 500 -331 501Q-442 634 -442 645",
          8211: "0 284Q0 318 26 325Q30 327 274 327Q469 327 497 327T532 322Q549 310 549 283Q549 257 532 245Q525 241 498 241T275 240Q31 240 26 242Q0 249 0 284",
          8212: "0 284Q0 318 26 325Q30 327 549 327T1073 325Q1099 318 1099 284Q1099 249 1073 242Q1068 240 549 240Q31 240 26 242Q0 249 0 284",
          8213: "0 284Q0 318 26 325Q30 327 549 327T1073 325Q1099 318 1099 284Q1099 249 1073 242Q1068 240 549 240Q31 240 26 242Q0 249 0 284",
          8215: "0 -66Q0 -32 26 -25Q30 -23 274 -23Q469 -23 497 -23T532 -28Q549 -40 549 -67Q549 -93 532 -105Q525 -109 498 -109T275 -110Q31 -110 26 -108Q0 -101 0 -66",
          8216: "87 443L81 449V581L119 636Q125 644 131 653T141 667T148 677T154 685T158 689T163 692T167 693T173 694H190H201Q226 694 226 683Q226 678 208 635T189 590Q189 588 204 588H219Q222 584 226 581V449L219 443H87",
          8217: "81 687Q85 693 88 693Q89 694 154 694H219Q222 690 226 687V556L187 501Q182 494 177 486T169 474T163 465T157 457T153 451T149 447T145 445T141 443T137 443T132 442H116H105Q80 442 80 453Q80 458 98 501T117 546Q117 548 102 548L87 549L81 555V687",
          8220: "144 443L138 449V581L176 636Q182 644 188 653T198 667T205 677T211 685T215 689T220 692T224 693T230 694H247H258Q283 694 283 683Q283 678 265 635T246 590Q246 588 261 588H276Q279 584 283 581V449L276 443H144ZM381 443L375 449V581L413 636Q419 644 425 653T435 667T442 677T448 685T452 689T457 692T461 693T467 694H484H495Q520 694 520 683Q520 678 502 635T483 590Q483 588 498 588H513Q516 584 520 581V449L513 443H381",
          8221: "38 687Q42 693 45 693Q46 694 111 694H176Q179 690 183 687V556L144 501Q139 494 134 486T126 474T120 465T114 457T110 451T106 447T102 445T98 443T94 443T89 442H73H62Q37 442 37 453Q37 458 55 501T74 546Q74 548 59 548L44 549L38 555V687ZM275 687Q279 693 282 693Q283 694 348 694H413Q416 690 420 687V556L381 501Q376 494 371 486T363 474T357 465T351 457T347 451T343 447T339 445T335 443T331 443T326 442H310H299Q274 442 274 453Q274 458 292 501T311 546Q311 548 296 548L281 549L275 555V687",
          8260: "103 -249Q81 -249 71 -235T61 -207Q61 -201 62 -198Q64 -192 235 265T409 727Q418 750 445 750Q464 750 476 737T488 707Q488 701 313 234Q143 -225 137 -232Q126 -249 103 -249",
          8710: "381 692Q386 694 458 694Q516 694 527 693T549 687Q564 680 575 663Q576 658 715 349T856 27Q856 6 838 1H826Q815 1 795 1T747 1T686 1T616 0T539 0T458 0T378 0T300 0T230 0T169 1T122 1T90 1H78Q60 6 60 27Q62 38 201 349T341 663Q356 687 381 692ZM627 148Q626 149 581 250T492 453L447 554Q447 553 446 552Q444 546 326 278L268 148Q268 147 448 147Q627 147 627 148"
        }, {});
      },
      3746: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerifItalic = void 0;
        var n = r(768),
          o = r(5181);
        e.sansSerifItalic = (0, n.AddPaths)(o.sansSerifItalic, {
          33: "160 187L257 694H306Q355 694 355 693L238 186H199Q160 186 160 187ZM110 2Q111 3 120 49T131 96Q131 98 180 98T229 96L219 50Q209 3 208 2V0H110V2",
          34: "171 647L180 694H229Q278 694 278 693L276 686Q275 680 273 668T268 644L258 597L182 471H157Q133 471 133 472L189 595Q189 596 174 596H160V598Q160 601 171 647ZM365 647L374 694H423Q472 694 472 693L470 686Q469 680 467 668T462 644L452 597L376 471H351Q327 471 327 472L383 595Q383 596 368 596H354V598Q354 601 365 647",
          35: "793 170Q809 162 809 149Q809 145 807 141T802 135T796 132L793 130H547L472 -27Q397 -184 394 -187Q389 -194 379 -194Q367 -194 362 -183Q359 -179 359 -173Q360 -168 431 -20L503 129Q503 130 410 130H317L242 -27Q167 -184 164 -187Q159 -194 149 -194Q137 -194 132 -183Q129 -179 129 -173Q130 -168 201 -19L273 130H187L100 131Q87 141 87 150Q87 162 102 170H294L331 248Q339 265 349 286T365 318L370 328Q370 330 258 330Q145 330 142 332Q129 338 129 351Q129 362 140 368Q146 370 267 370L391 371L467 527Q542 684 544 686Q544 688 549 691T560 694H562Q565 693 567 692T571 690T575 686T578 681T579 672Q577 665 507 520T436 373L435 370H528L621 371L692 518Q767 675 769 677Q775 694 789 694Q798 694 804 688T809 672Q806 664 737 519L665 371L751 370Q835 370 841 368Q851 362 851 350Q851 337 841 334T799 330H765H741H645L606 250L568 170H793ZM600 328Q600 330 508 330H415Q412 326 338 171Q338 170 431 170H524L561 248Q569 265 579 286T595 318L600 328",
          36: "228 70Q233 92 246 155T270 266T280 316Q271 318 265 320T237 333T200 360T172 403T159 468Q159 537 205 600T325 691Q352 701 360 701Q361 701 361 701T362 703T364 711T368 727L372 750H409Q445 750 445 749L436 705Q436 703 450 702T494 691T554 657L565 649Q562 642 548 604L534 568Q511 591 484 605T440 621L424 623L419 624L372 405Q399 400 424 384Q490 338 490 247V240Q490 156 430 85Q374 13 294 -5L284 -7L280 -30Q279 -35 278 -41T275 -52L274 -55Q274 -56 237 -56Q201 -56 201 -54Q202 -53 205 -34T211 -11Q211 -9 206 -9Q154 -2 115 19Q80 35 56 59L88 141L99 131Q109 121 119 113T141 99T160 89T180 82T197 77T214 73T228 70ZM303 426Q304 427 313 471T332 564T345 620L335 616Q287 596 263 549Q252 525 252 499Q252 470 267 451T298 426Q303 424 303 426ZM302 75Q305 75 315 80T340 98T367 125T390 164T399 214Q399 247 384 268T349 297Q338 247 326 186L302 75",
          37: "268 347Q224 347 195 386T165 488Q165 517 173 552Q191 637 246 693T349 749Q389 749 414 725T448 673T456 614Q456 506 396 427T268 347ZM372 604Q372 674 339 674Q311 674 290 633T261 549T253 482V474Q253 438 272 426Q277 424 286 424Q319 424 345 485T372 604ZM189 -56Q179 -56 173 -49T167 -37Q167 -30 347 198Q425 296 475 360Q780 745 785 747Q790 750 796 750Q814 748 814 730Q814 725 811 719L204 -49Q198 -56 189 -56ZM523 87Q523 184 583 265T713 347Q758 347 786 308T815 207Q815 110 757 28T629 -55Q576 -55 550 -12T523 87ZM729 200Q729 271 696 271Q675 271 658 247T631 189T616 125T611 76Q611 21 644 21H647Q672 21 700 77T729 200",
          38: "219 -22Q158 -22 117 13T71 111Q71 131 74 150T84 185T98 215T118 241T137 262T159 281T179 295T199 308L214 318L258 348L256 362Q254 373 254 413V435Q254 483 271 537T325 641T411 708Q427 715 441 715Q446 716 455 716Q504 716 534 681T565 590Q565 522 519 468T377 347L358 334Q359 333 363 320T374 290T387 262Q404 227 428 187T460 139Q521 183 574 251T651 362T674 409L710 398Q746 388 747 388Q747 381 720 333T635 213T517 94L510 87Q542 57 598 57Q649 57 708 72Q716 75 718 75L709 34L701 -7Q636 -22 578 -22Q531 -22 498 -8T428 34L408 25Q314 -22 219 -22ZM480 579Q480 640 436 640Q410 640 385 615T351 554Q340 513 340 457Q340 413 343 410Q343 406 360 419Q431 471 455 505T480 579ZM245 57Q279 59 311 67T359 81T375 89T358 113T318 178T281 260L274 277L245 257Q167 205 167 135Q167 110 174 93T194 69T217 60T237 57H245",
          39: "228 647L237 694H286Q335 694 335 693L334 686Q332 680 330 668T325 644L315 597L239 471H214Q190 471 190 472L246 595Q246 596 231 596H217V598Q217 601 228 647",
          40: "195 37Q195 -7 200 -47T213 -113T231 -166T250 -204T268 -232T280 -250H204L194 -238Q104 -124 104 55Q104 238 181 432T405 740L417 750H454Q491 750 491 749L468 729Q446 709 411 667T337 565T262 405T208 188Q195 110 195 37",
          41: "300 463Q300 634 222 740L214 750H290L299 740Q300 738 309 726T323 707T337 682T353 651T367 613T379 566T387 510T390 444Q390 314 344 156T203 -125Q179 -155 145 -191Q111 -224 89 -241L78 -250H2Q4 -248 27 -227T65 -189T107 -140T155 -71T200 16T244 129T278 266Q300 372 300 463",
          42: "193 608Q193 628 210 644T246 660Q250 660 252 660T257 658T264 654T272 648T284 638T302 623Q340 590 340 593Q341 594 345 623T354 682T360 715Q365 729 378 739T407 750Q424 750 433 740T443 720Q443 712 427 652L410 591L462 623Q505 650 514 655T534 660Q549 660 558 650T568 625Q568 617 567 611T560 599T551 590T536 580T519 571T496 561T470 548L429 528L474 500Q482 495 492 489T506 481T516 475T523 469T527 464T529 458T530 450Q530 430 514 414T479 397H475Q468 397 460 402T423 433Q414 440 404 448T388 461L383 465L365 344Q348 306 314 306Q302 306 292 313T281 338Q281 347 297 404L313 464L260 433Q201 397 195 397H189Q173 397 165 407T156 432Q156 438 157 443T161 452T166 460T175 468T185 475T198 482T212 489T230 497T250 506L295 528L250 556Q203 582 202 585Q193 591 193 608",
          43: "108 244T108 250T112 261T119 268T124 270H426V272Q428 274 457 419Q489 565 492 573Q497 583 508 583Q516 583 522 577T528 565Q528 553 498 417Q491 384 483 346T471 288L467 270H760Q775 262 775 250T760 230H458Q456 221 426 77T394 -71Q389 -83 375 -83Q367 -83 362 -78T356 -64Q356 -58 387 84Q394 118 401 155T413 210L417 229Q417 230 271 230H124Q123 230 120 232T112 239",
          44: "90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2Q188 0 149 -63L112 -125H63L120 0H105Q90 0 90 2",
          45: "66 257V259H332V257L324 220L317 186H184Q51 186 51 187T58 220T66 257",
          46: "90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2V0H90V2",
          47: "564 744L568 747Q573 750 579 750Q588 750 594 744T599 729Q597 721 321 241T41 -243Q37 -250 27 -250Q6 -250 6 -230Q6 -228 8 -222Q9 -219 285 261T564 744",
          48: "245 -22Q209 -22 181 -11T135 20T107 65T92 116T88 171Q88 235 114 354T194 557Q226 606 269 635T340 671T392 678H395Q422 678 446 670T495 643T534 582T549 481Q549 430 534 350T499 213Q459 89 379 25Q315 -22 247 -22H245ZM430 582Q408 601 378 601Q313 601 269 534Q234 475 205 341Q181 232 181 174Q181 104 209 76Q231 54 260 54T318 73T368 125Q410 194 447 375Q460 445 460 487Q460 555 430 582",
          49: "234 613Q277 613 331 628T428 678H439Q451 678 451 676Q450 671 387 373T323 74T384 73H445L430 0H259L88 1L104 73H229L332 560Q278 541 198 539Q198 540 198 541T199 546T200 554T202 564T205 576L213 612H219Q221 612 226 612T234 613",
          50: "190 460Q189 460 181 475T164 507T155 527Q155 535 182 571Q259 678 380 678Q462 678 506 630T551 513V507Q551 418 487 349Q469 329 441 305T391 265T344 232T316 212Q158 87 158 86T188 85Q194 85 234 85T311 86Q467 86 467 85Q451 9 449 2V0H50Q54 18 58 40L67 79L133 133Q246 226 269 243Q369 318 410 373T452 492Q452 535 433 560T393 592T350 599Q311 599 279 578T231 532T203 484T190 460",
          51: "446 542Q446 576 424 590T372 605Q330 605 288 583T216 524Q209 515 208 516Q207 517 192 549L178 580L187 589Q224 627 276 652T386 678Q456 678 500 642T544 550Q544 515 530 482T495 427T453 387T418 362L403 353L413 348Q440 335 462 313Q500 271 500 217Q500 135 423 57T236 -22T63 59L56 68L85 141Q106 112 125 98Q177 54 254 54Q315 54 355 105T396 218Q396 242 393 254Q380 301 335 313Q327 315 280 316Q233 316 233 318L249 392Q298 392 322 399Q373 408 409 453T446 542",
          52: "78 235L411 656H465Q519 656 519 655T475 447T430 237V235H521V233L505 160Q505 159 459 159H414L380 0H286L320 159H62L63 164Q64 169 66 179T70 198L78 235ZM342 235L421 607Q420 607 419 604Q409 535 197 267Q173 236 173 235H342",
          53: "330 350Q263 350 214 272H133V275Q134 276 174 467L214 655Q214 656 385 656H555V653Q555 652 554 647T550 631T546 613L539 577H284L265 486Q261 464 256 441T248 406L246 395L250 398Q255 401 264 406T286 415T315 423T350 427Q412 427 455 381T498 256Q498 150 415 64T222 -22Q186 -22 155 -12T105 12T74 41T55 65T50 77L51 79Q61 89 78 112L104 145L107 138Q110 130 114 123T125 106T142 88T165 72T196 60T236 55Q282 55 316 79T366 140T389 208T396 267Q396 310 378 330T337 350H330",
          54: "437 605Q397 605 361 585T301 536T261 477T236 426T228 401L236 408Q244 414 260 424T296 445T345 462T402 469H404Q422 469 434 467T465 446T498 394Q515 351 515 307Q515 254 497 193T439 85Q352 -22 246 -22Q220 -22 196 -14T148 15T109 78T94 179Q94 272 123 373Q163 505 257 591T450 678Q474 678 498 674T535 664T548 656L540 621L532 586L520 590Q509 594 485 599T437 605ZM339 392Q281 392 233 334T185 163V158Q185 87 230 61Q244 54 262 54Q325 54 371 122Q395 158 407 217T419 298Q419 337 401 364T339 392",
          55: "173 614L181 656H389Q596 656 596 655L595 650Q594 645 592 635T588 616L580 578L554 551Q313 307 245 4L242 -11H192Q143 -11 143 -10Q144 0 148 17T169 89T212 198T285 327T393 470Q423 504 472 550Q479 555 485 561T496 571L329 570Q163 570 163 571L164 577Q166 583 168 593T173 614",
          56: "159 470Q159 547 229 612T394 678Q467 678 510 636T554 533Q554 512 549 493T535 458T515 429T492 405T467 386T443 372T423 362T409 356L404 354Q404 353 405 353Q411 353 432 341T476 295T500 218Q500 134 424 56T246 -22Q175 -22 126 22T77 143Q77 204 110 251T188 327L202 334Q216 340 229 346T243 353T235 358T214 372T189 393T168 426T159 470ZM467 527Q467 605 375 605Q317 605 281 566T244 472Q244 429 271 411T334 392Q392 392 429 430T467 527ZM405 228Q405 262 384 289T315 316Q257 316 216 266T174 144Q174 95 199 75T262 54Q329 54 367 109T405 228",
          57: "220 594Q303 677 389 677Q545 677 545 479Q545 413 526 327Q493 175 398 77T202 -22Q124 -22 77 25L130 91L137 83Q169 54 218 54Q255 54 290 76T347 129Q364 151 380 182T403 232T411 256Q410 255 390 241T353 217T303 197T236 187Q195 187 173 209Q155 226 140 263T124 352Q124 392 135 435Q154 527 220 594ZM455 497Q455 605 383 605Q340 605 305 577T246 492Q220 411 220 360Q220 278 279 264Q280 264 287 264T299 263Q347 263 387 302Q455 375 455 497",
          58: "174 396L184 444H233Q282 444 282 443Q277 421 272 394L262 346H213Q164 346 164 347Q169 369 174 396ZM90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2V0H90V2",
          59: "174 396L184 444H233Q282 444 282 443Q277 421 272 394L262 346H213Q164 346 164 347Q169 369 174 396ZM90 2Q91 3 100 49T111 96Q111 98 160 98T209 96L199 50Q189 3 188 2Q188 0 149 -63L112 -125H63L120 0H105Q90 0 90 2",
          61: "142 368Q145 370 463 370Q780 370 784 368Q796 364 796 350T784 332Q780 330 463 330Q145 330 142 332Q129 338 129 351Q129 362 142 368ZM88 137T88 150T102 170H738Q739 170 742 168T750 161T754 150T750 139T743 132T738 130H102Q88 137 88 150",
          63: "194 652Q194 654 218 666T284 691T362 704Q444 704 490 678T536 583Q536 541 516 500T459 433Q415 400 387 371T343 313T321 266T307 216L301 186H262Q223 186 223 187Q224 199 228 218T250 288T294 377Q317 413 344 440T391 481T414 499Q442 527 442 574Q442 584 441 590T433 607T409 623T362 629Q335 629 310 624T267 610T235 595T214 582T205 576L200 614Q194 651 194 652ZM173 2Q174 3 183 49T194 96Q194 98 243 98T292 96L282 50Q272 3 271 2V0H173V2",
          64: "120 267Q120 377 179 478T336 642T538 705Q610 705 658 662T707 513Q707 425 681 331Q658 241 590 179T447 117Q386 117 343 163T300 288Q300 397 374 486T544 576Q575 576 608 562Q590 628 517 628Q406 628 309 522T212 278Q212 179 267 122T404 65T550 91H631Q513 -10 390 -10Q265 -10 193 70T120 267ZM600 397Q600 441 581 471T530 501Q476 501 433 436T390 298Q390 254 409 224T462 193Q512 193 556 257T600 397",
          91: "148 252L253 750H339Q425 750 425 749L424 744Q423 739 421 729T417 711L409 675L367 674H325L235 252Q145 -167 145 -172Q145 -174 187 -174H229V-176Q213 -240 213 -250H127Q41 -250 41 -248Q41 -245 148 252",
          93: "353 749Q353 746 303 512T200 27T141 -250H-31Q-31 -240 -15 -176V-174H70L250 674H208L165 675L181 750H267Q353 750 353 749",
          94: "190 527L360 694H434L484 611Q533 528 533 527H457L390 632L385 639L266 527H190",
          95: "59 -75L66 -38H316Q565 -38 565 -39T558 -75T549 -112Q549 -114 299 -114Q50 -114 50 -113L52 -108Q53 -103 55 -93T59 -75",
          126: "330 327Q356 326 388 298T446 269Q470 269 484 327H522Q560 327 560 325L557 316Q554 306 549 292T535 263T512 232T480 208Q453 193 429 193T370 222T315 251Q285 251 275 193H199V197Q214 257 251 292T330 327",
          305: "168 442T168 443T213 444T258 443T212 225T164 2V0H74V2Q75 7 121 224",
          567: "-54 -96L-48 -104Q-41 -111 -27 -118T7 -126Q60 -126 82 -87Q85 -81 140 181L196 443Q196 444 241 444T286 443Q286 441 232 186T175 -75Q163 -120 122 -162T19 -204Q-13 -204 -41 -196T-83 -180T-96 -170Q-55 -96 -54 -96",
          768: "-262 681L-270 694H-177L-132 612Q-89 530 -87 528Q-87 527 -125 527H-163L-208 598Q-254 670 -262 681",
          769: "-96 625L-29 694H63Q42 673 -31 605L-114 527H-190L-176 541Q-160 559 -96 625",
          770: "-310 527L-140 694H-66L-16 611Q33 528 33 527H-43L-110 632L-115 639L-234 527H-310",
          771: "-170 677Q-144 676 -112 648T-54 619Q-30 619 -16 677H22Q60 677 60 675L57 666Q54 656 49 642T35 613T12 582T-20 558Q-47 543 -71 543T-130 572T-185 601Q-215 601 -225 543H-301V547Q-286 607 -249 642T-170 677",
          772: "-314 553L-297 631H-116Q64 631 64 630Q60 612 56 591L47 553L-133 552Q-314 552 -314 553",
          774: "-142 508Q-205 508 -244 548T-284 652Q-284 666 -281 683L-280 694H-204Q-205 689 -205 677Q-205 650 -196 631T-173 604T-147 593T-125 590Q-85 590 -50 618T-5 686L-2 694H73V690Q53 610 -10 559T-142 508",
          775: "-180 578Q-179 579 -170 627T-158 678V680H-54V678Q-56 675 -65 627T-76 578V576H-180V578",
          776: "-273 584Q-272 585 -262 632L-252 678V680H-154V678L-164 632Q-174 585 -175 584Q-175 582 -224 582T-273 584ZM-78 586Q-78 587 -69 632T-58 678V680H40L39 677Q39 676 38 670T34 651T29 628L19 583L-30 582H-79L-78 586",
          778: "-227 597Q-227 639 -186 666T-102 693H-97Q-29 693 -8 649Q-2 637 -2 623Q-2 582 -43 555T-132 527Q-171 527 -199 546T-227 597ZM-59 619Q-59 635 -68 643T-104 652Q-142 652 -156 636T-171 602Q-171 569 -123 569Q-119 569 -111 570T-99 571Q-59 582 -59 619",
          779: "-236 619L-195 694H-149Q-103 694 -103 693L-211 527H-287L-282 536Q-281 539 -236 619ZM-70 619L-29 694H17Q63 694 63 693L-45 527H-121L-116 536Q-115 539 -70 619",
          780: "-283 654H-207L-140 549L-135 542L-16 654H60L-109 487H-147L-184 488L-234 570Q-283 653 -283 654",
          913: "28 0L429 694H533L585 350Q596 275 610 182T632 46L638 3V0H530L528 18Q527 25 515 103T503 183H223L135 29L118 1L73 0H28ZM492 254Q492 256 473 398T454 589V610Q433 552 290 301L264 255L378 254H492",
          914: "501 363Q557 355 605 316T653 222Q653 148 586 85T403 2Q394 1 240 0Q90 0 90 1L100 46Q109 90 128 177T164 348L238 694H375Q518 693 546 688Q614 674 655 635T696 544Q696 490 648 441T516 368L501 363ZM601 530Q601 568 566 590T479 621Q472 622 394 623H320L297 513Q292 489 286 459T276 415L273 401V399H339H372Q504 399 571 466Q601 498 601 530ZM257 322Q256 320 230 197T203 73Q203 71 289 71Q379 72 387 73Q459 84 507 122T556 210Q556 255 519 283T428 320Q415 322 336 323Q257 323 257 322",
          915: "87 2Q88 4 160 346T234 689Q234 691 440 691T646 689Q643 686 629 611H475L321 612Q193 4 191 2V0H87V2",
          916: "273 343L510 694H617Q790 2 790 0H416L42 1L273 343ZM539 576Q536 597 536 600Q536 602 535 605Q534 607 534 607Q527 580 222 130L201 98H651L648 110Q645 123 639 149T627 198Q554 489 539 576",
          917: "86 2Q88 4 160 346T233 689Q233 691 461 691Q688 691 688 689Q685 686 671 611H495L320 612L319 609Q319 607 297 501L274 397H436Q597 397 597 396L596 391Q595 386 593 376T589 358L581 322L420 321Q258 321 258 320Q209 89 208 87Q208 85 390 85Q417 85 460 85T518 86L572 85Q556 8 554 2V0H86V2",
          918: "67 54Q551 615 551 617Q543 618 517 618Q510 618 463 618T376 617Q200 617 200 618T209 657L216 694H459Q702 694 702 692Q702 689 697 667L692 643L207 80H392Q493 81 577 81Q577 70 560 2V0H55V2L67 54",
          919: "517 2Q518 3 551 161T585 322Q586 323 557 323T422 323H259L190 0H138Q86 0 86 1L96 46Q105 90 124 177T160 348L234 694H337V691Q336 690 306 545T275 399H602L603 403Q603 407 634 551L665 694H768V691Q768 690 695 348T621 2V0H517V2",
          920: "119 260Q119 348 157 433T254 579T387 677T533 715Q701 715 772 574Q804 511 804 431Q804 315 744 209T586 41T384 -22Q262 -22 191 59T119 260ZM706 426Q706 524 655 582T525 640Q454 640 395 600T293 502Q256 447 237 383T218 266Q218 168 269 112T401 55Q518 55 612 166T706 426ZM283 349L293 397H473Q652 397 652 396Q647 374 642 347L632 299H452Q273 299 273 300Q278 322 283 349",
          921: "161 348L235 694H338V691Q338 690 265 348T191 2V0H139Q87 0 87 1L96 46Q106 90 125 177T161 348",
          922: "236 223Q235 222 213 113T188 2V0H138Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H285Q335 694 335 693L330 671Q326 649 316 603T298 518Q289 477 280 433T266 366L261 343L672 694H729L784 693L465 420L651 0H596L541 1L384 350Q383 351 310 288T236 223",
          923: "28 0L401 694H504V690Q505 686 543 345T582 1Q582 0 528 0H473V3Q472 6 460 113T435 359T422 558Q422 593 424 603L425 610L424 608Q414 572 343 431Q287 316 143 49L117 1L73 0H28",
          924: "375 691Q456 215 459 124V106Q488 177 762 641L793 694H929V691Q929 690 856 348T782 2V0H689V2Q691 4 753 304Q817 604 818 606Q819 611 817 608Q817 607 815 603Q798 559 540 117L484 22H440L397 23L393 42Q393 47 373 169T334 422T315 594V609L250 306Q186 3 185 2Q185 0 138 0Q92 0 92 1L102 46Q111 90 130 177T166 348L240 694H375V691",
          925: "311 609Q310 608 246 306T181 2V0H134Q88 0 88 1L98 46Q107 90 126 177T162 348L236 694H382L383 691Q383 688 418 561T493 286T541 97L544 84L545 89Q545 90 553 128T578 246T610 394L674 694H766V691Q766 690 693 348T619 2V0H472L469 13Q468 17 393 293T312 605L311 609",
          926: "193 687Q193 688 479 688H765V686Q764 685 755 642L747 600H461L175 601Q175 602 184 645L193 687ZM196 400Q196 401 418 401T640 400L622 315Q622 314 400 314T178 315L196 400ZM42 2Q43 3 51 44T60 87H64Q68 87 75 87T93 87T119 87T151 88T190 88T237 88T291 88T352 88H643Q638 66 634 44T627 13T624 2V0H42V2",
          927: "118 254Q118 366 174 473T324 648T517 716Q627 716 695 638T763 435Q763 321 706 215T555 43T362 -22Q256 -22 187 56T118 254ZM380 58Q452 58 518 116T622 263T661 442Q661 496 646 535T608 594T567 622T534 634Q516 636 496 636Q400 636 313 528T225 264Q225 172 267 115T380 58",
          928: "86 2Q88 4 160 346T233 689Q233 691 501 691Q768 691 768 689Q766 688 694 346T621 2V0H517V2Q518 3 582 304T646 609L648 615H321L190 0H86V2",
          929: "162 348L236 694H378Q522 693 530 692Q604 680 647 635T690 524Q690 474 665 430T612 359Q550 299 465 280Q443 275 343 274H250V271Q250 269 235 201T206 68T192 2V0H140Q88 0 88 1L98 46Q107 90 126 177T162 348ZM594 513Q594 560 562 588T477 622Q470 623 394 623H321L293 487L263 349V347H342H347H375Q530 347 578 449Q594 483 594 513",
          931: "194 655L202 694H508Q813 694 813 693Q809 675 805 653L797 614H559L321 615Q327 606 405 478L485 347Q449 311 348 203T247 86Q247 84 294 84Q303 84 359 84T465 85H684Q684 84 675 42L666 0H360L55 1L195 154Q346 319 347 320L359 333L273 473Q187 614 186 614L187 620Q188 625 190 635T194 655",
          932: "165 608L182 687Q182 688 486 688H790L789 685L781 645L773 609H521L457 306Q393 3 392 2Q392 0 340 0H288V2Q289 5 353 304T417 605V609L291 608H165",
          933: "357 637Q320 637 297 612T266 555H173Q178 576 188 598Q214 651 265 683T373 716Q497 716 497 542V509L504 526Q579 715 711 715Q773 715 808 677T843 589Q843 576 840 555H747L748 557Q748 559 748 563T749 574V580Q749 604 731 622Q715 638 693 638Q591 638 543 465Q531 425 506 309T462 98T441 2V0H337V2Q425 401 436 486Q438 504 438 526Q438 637 364 637H357",
          934: "124 308Q124 399 208 481T433 587Q437 587 437 589Q438 590 449 643L459 694H508Q557 694 557 693Q557 691 546 641T535 587Q543 587 562 583T614 565T674 531T722 472T743 387Q743 288 656 209T449 110L433 106Q411 3 410 2Q410 0 361 0H312L313 3Q313 5 324 56L335 107H331L321 108Q311 110 297 114T266 124T228 141T190 168Q124 225 124 308ZM227 315Q227 282 239 257T270 218T306 197T338 186L350 184H351L386 346Q420 507 420 509H419Q411 509 393 505T342 485T284 444Q227 387 227 315ZM642 381Q642 413 629 437T599 475T563 496T533 507T519 510Q518 510 484 348T450 184Q544 201 593 258T642 381",
          935: "14 0Q17 3 184 184T352 367L265 529Q244 567 222 609T188 672L176 692Q176 694 236 694H297L338 612Q387 515 400 489L421 448L645 694H758L708 640Q481 393 456 368Q455 366 500 281T596 104T652 0H531L388 293L128 0H14",
          936: "325 556Q325 524 310 447T294 330Q294 289 304 260Q314 234 333 216T364 192T380 187L488 694H585V691Q584 689 531 438L478 188H479Q485 188 503 195T555 231T613 305Q637 352 654 435Q662 470 669 496T681 538T690 562T698 578T704 587Q719 609 733 615T772 621H802H854V619L838 546Q838 545 832 545Q775 539 749 418Q716 274 638 196Q616 173 590 156T543 131T503 117T473 110T460 106Q460 105 450 54T438 2V0H340V2Q341 3 351 54T362 106Q363 107 358 108T344 111T322 117T295 128T267 145T239 171T216 207T200 256T194 319Q194 356 203 408T213 483Q213 517 203 530T182 544T171 546Q184 609 187 619V621H239Q286 621 294 620T309 612Q325 596 325 556",
          937: "148 407Q148 475 182 534T269 633T386 694T511 716Q622 716 695 658T769 507Q769 461 747 409T699 321T628 225T562 136Q533 90 533 86Q542 85 557 85Q564 85 583 85T614 86Q695 86 695 85Q679 9 677 2V0H425Q426 3 433 30T447 72T480 131T549 241L554 248Q558 254 563 261T576 281T592 306T609 335T625 366T640 400T653 434T661 466T664 498Q664 562 618 601T497 640Q416 640 351 596T262 482Q250 441 250 392T276 237T302 70V56Q302 28 296 2V0H44V2L62 85Q62 86 143 86L225 85V88Q224 89 224 89T224 91T224 95T223 101T222 110T220 123T216 140T209 163T200 191T188 227Q148 344 148 407",
          8211: "59 275L66 312H316Q565 312 565 311T558 275T549 238Q549 236 299 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
          8212: "59 275L66 312H566Q1065 312 1065 311T1058 275T1049 238Q1049 236 549 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
          8213: "59 275L66 312H566Q1065 312 1065 311T1058 275T1049 238Q1049 236 549 236Q50 236 50 237L52 242Q53 247 55 257T59 275",
          8215: "59 -75L66 -38H316Q565 -38 565 -39T558 -75T549 -112Q549 -114 299 -114Q50 -114 50 -113L52 -108Q53 -103 55 -93T59 -75",
          8216: "309 567L299 520Q289 474 288 473Q288 471 239 471T190 473L192 480Q193 486 196 499T201 522L211 569L287 694H312L335 693L332 685Q328 677 321 661T307 630L279 570L294 569Q309 569 309 567",
          8217: "228 647L237 694H286Q335 694 335 693L334 686Q332 680 330 668T325 644L315 597L239 471H214Q190 471 190 472L246 595Q246 596 231 596H217V598Q217 601 228 647",
          8220: "393 567L383 520Q373 474 372 473Q372 471 323 471T274 473L276 480Q277 486 280 499T285 522L295 569L371 694H396L419 693L416 685Q412 677 405 661T391 630L363 570L378 569Q393 569 393 567ZM587 567L577 520Q567 474 566 473Q566 471 517 471T468 473L470 480Q471 486 474 499T479 522L489 569L565 694H590L613 693L610 685Q606 677 599 661T585 630L557 570L572 569Q587 569 587 567",
          8221: "171 647L180 694H229Q278 694 278 693L276 686Q275 680 273 668T268 644L258 597L182 471H157Q133 471 133 472L189 595Q189 596 174 596H160V598Q160 601 171 647ZM365 647L374 694H423Q472 694 472 693L470 686Q469 680 467 668T462 644L452 597L376 471H351Q327 471 327 472L383 595Q383 596 368 596H354V598Q354 601 365 647",
          8260: "564 744L568 747Q573 750 579 750Q588 750 594 744T599 729Q597 721 321 241T41 -243Q37 -250 27 -250Q6 -250 6 -230Q6 -228 8 -222Q9 -219 285 261T564 744",
          8710: "273 343L510 694H617Q790 2 790 0H416L42 1L273 343ZM539 576Q536 597 536 600Q536 602 535 605Q534 607 534 607Q527 580 222 130L201 98H651L648 110Q645 123 639 149T627 198Q554 489 539 576"
        }, {});
      },
      3240: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sansSerif = void 0;
        var n = r(768),
          o = r(3526);
        e.sansSerif = (0, n.AddPaths)(o.sansSerif, {
          33: "120 187Q120 225 115 440T110 693Q110 694 159 694T208 693Q208 655 203 440T198 187Q198 186 159 186T120 187ZM110 0V98H208V0H110",
          34: "33 596V694H131V597L82 471H32L47 532Q62 593 63 594Q63 596 48 596H33ZM227 596V694H325V597L276 471H226L241 532Q256 593 257 594Q257 596 242 596H227",
          35: "56 350Q56 363 70 370H192Q314 370 314 371L356 526Q396 676 401 685Q406 694 416 694Q423 694 429 689T436 677Q436 673 396 523T355 371Q355 370 449 370Q544 370 544 371L586 526Q628 682 630 685Q636 694 646 694Q653 694 659 689T665 678Q665 670 645 593T605 444L585 371Q585 370 673 370H762Q777 362 777 350Q777 337 767 334T723 330H668H573L567 305Q560 282 545 226L530 171L646 170H721Q756 170 766 167T777 150Q777 138 762 130H640Q518 130 518 129L476 -26Q434 -182 432 -185Q426 -194 416 -194Q409 -194 403 -189T397 -178Q397 -170 417 -93T457 56L477 129Q477 130 383 130Q288 130 288 129L246 -26Q204 -182 202 -185Q196 -194 186 -194Q179 -194 173 -189T167 -178Q167 -170 187 -94T227 56L247 129Q247 130 159 130H70Q56 137 56 150Q56 165 72 170H259L265 195Q273 222 287 275L302 330H186L70 331Q63 334 58 339Q56 343 56 350ZM489 170L532 330H343L337 305Q330 282 315 226L300 171L394 170H489",
          36: "55 509Q55 585 103 638T213 701V750H286V703H289Q312 703 354 689Q372 682 399 666T427 646L413 569Q413 568 403 575Q352 615 291 624H286V405Q357 389 400 331T444 199Q444 128 402 69T286 -7V-56H213V-9Q167 -3 125 14T63 44T44 60Q44 61 52 101L59 140L69 132Q78 125 87 119T107 107T124 97T141 90T157 84T173 80T187 76T201 73T213 70V317L202 319Q141 335 98 386T55 509ZM213 424V620L203 615Q143 587 143 522Q143 455 213 424ZM356 187Q356 208 350 227T334 258T315 280T298 293T287 297Q286 297 286 186V75Q356 110 356 187",
          37: "56 549Q56 639 98 694T195 750Q248 750 290 694T332 548Q332 455 290 401T195 347Q141 347 99 403T56 549ZM248 549Q248 602 234 638T195 674Q145 674 145 549Q145 423 195 423Q219 423 233 459T248 549ZM197 -56Q187 -56 182 -49T176 -35Q176 -33 178 -27Q179 -25 399 356T623 741Q626 750 639 750Q648 750 654 744T659 729Q657 721 435 336T207 -52Q203 -56 197 -56ZM500 146Q500 235 542 291T639 347Q692 347 734 293T776 146Q776 53 733 -1T639 -56Q587 -56 544 -2T500 146ZM692 146Q692 199 678 235T639 271Q589 271 589 146Q589 20 639 20Q663 20 677 56T692 146",
          38: "156 502Q156 600 198 658T302 716Q367 716 405 665T444 549Q444 531 442 523Q426 446 304 348L287 334Q305 297 340 249T402 170T430 139T443 149T472 181T509 231T549 303T583 394Q584 398 586 404Q587 408 587 409Q588 409 626 399T665 388Q663 381 660 369T644 322T614 253T567 176T502 98L491 87Q534 57 584 57Q653 57 700 75Q702 75 702 34T700 -7Q652 -22 586 -22H580Q505 -22 434 26L421 34Q419 33 405 25T374 11T336 -4T285 -17T226 -22Q143 -22 93 31T42 152Q42 184 51 211T81 260T111 291T144 317L184 348L178 365Q156 430 156 502ZM359 552Q359 588 345 614T302 640Q292 640 282 636T260 622T241 590T233 535Q236 474 253 417L257 407L271 419Q312 454 330 479Q359 514 359 552ZM345 102Q262 190 216 277Q215 277 204 267T180 247T165 236Q135 208 135 159Q135 123 152 97T198 61Q207 58 227 58Q286 58 357 89L345 102",
          39: "90 596V694H188V597L139 471H89L104 532Q119 593 120 594Q120 596 105 596H90",
          40: "74 250Q74 564 240 733L257 750H333L323 739Q167 573 167 250T323 -239L333 -250H257L240 -233Q74 -63 74 250",
          41: "221 -73T221 250T65 739L55 750H131L148 733Q314 567 314 250T148 -233L131 -250H55L65 -239Q221 -73 221 250",
          42: "208 717Q211 731 222 740T250 750Q265 750 277 741T291 717Q291 706 290 675T286 617L285 591L329 622Q369 651 376 655T393 659Q411 659 423 647T436 616Q436 609 434 603T429 594T419 585T407 577T389 567T368 556L316 528L368 500Q421 472 429 464Q436 455 436 440Q436 422 423 409T393 396Q390 396 388 396T384 397T380 398T375 401T367 406T358 413T346 422T329 434L285 465Q284 465 285 438T289 381T291 347Q291 327 278 317T250 306Q234 306 222 315T208 339Q208 350 209 381T212 439L214 465L170 434Q130 405 123 401T106 397Q88 397 76 409T63 440Q63 447 65 453T70 462T80 471T92 479T110 489T131 500L183 528L131 556Q78 584 70 592Q63 601 63 616Q63 634 76 647T106 660Q109 660 111 660T115 659T119 658T124 655T132 650T141 643T153 634T170 622L214 591L212 617Q211 643 210 674T208 717",
          43: "56 237T56 250T70 270H369V420L370 570Q380 583 389 583Q402 583 409 568V270H707Q722 262 722 250T707 230H409V-68Q401 -82 391 -82H389H387Q375 -82 369 -68V230H70Q56 237 56 250",
          44: "90 0V98H188V1L139 -125H89L104 -64Q119 -3 120 -2Q120 0 105 0H90",
          45: "11 186V259H277V186H11",
          46: "90 0V98H188V0H90",
          47: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
          58: "90 346V444H188V346H90ZM90 0V98H188V0H90",
          59: "90 346V444H188V346H90ZM90 0V98H188V1L139 -125H89L104 -64Q119 -3 120 -2Q120 0 105 0H90",
          61: "56 350Q56 363 70 370H707Q722 362 722 350Q722 339 708 331L390 330H72Q56 335 56 350ZM56 150Q56 165 72 170H708Q722 160 722 150Q722 138 707 130H70Q56 137 56 150",
          63: "55 652Q63 658 77 666T132 689T214 704T265 703Q303 698 332 684T376 653T401 615T413 578T416 546Q416 475 360 426Q325 396 303 365T273 303T263 256T261 216V186H183V225Q184 281 194 322Q206 368 232 409T276 469T306 495Q323 517 323 550Q323 596 297 612T223 629Q187 629 157 618Q122 607 91 583L83 576L55 652ZM173 0V98H271V0H173",
          64: "422 576Q440 576 456 573T480 566L488 563Q488 565 484 571T472 588T452 607T424 622T387 629Q294 629 220 550T146 347Q146 233 210 155T365 66Q376 65 400 65Q465 68 517 86L532 91H612L598 76Q511 -11 388 -11Q250 -11 153 93T56 347Q56 454 107 538T231 663T378 704Q446 704 492 680T564 608T599 506T611 376Q611 320 607 299Q595 227 546 173T422 118Q343 118 288 185T232 347Q232 444 287 510T422 576ZM520 347Q520 429 487 465T421 501Q385 501 354 461T323 347Q323 270 355 232T422 193Q454 193 487 229T520 347",
          91: "94 -250V750H266V674H181V-174H266V-250H94",
          93: "22 674V750H194V-250H22V-174H107V674H22",
          94: "146 612L212 694H287L353 612Q417 532 420 529Q421 528 418 527Q414 527 383 527H345L250 639Q244 633 199 580L154 527H116Q79 528 79 529Q82 532 146 612",
          95: "0 -114V-38H499V-114H0",
          126: "83 204Q86 254 113 290T186 327Q211 327 251 299T312 270Q337 270 340 315V327H416V316Q413 258 382 226T315 193Q289 193 249 221T187 250Q162 250 159 205V193H83V204",
          305: "74 0V444H164V0H74",
          567: "-35 -95Q-4 -126 34 -126Q58 -126 76 -116T100 -88Q102 -82 102 181V444H192V180Q191 -45 191 -70T184 -113Q171 -152 140 -178T63 -205Q34 -205 4 -197T-43 -181T-59 -171L-47 -133L-35 -95",
          768: "-415 692L-417 694H-324L-262 612Q-249 594 -233 572T-208 539L-200 528L-237 527H-275L-344 608Q-359 625 -378 647T-406 680T-415 692",
          769: "-239 612L-177 694H-84L-86 692Q-86 691 -95 681T-123 648T-157 608L-226 527H-264L-301 528L-293 539Q-285 550 -269 572T-239 612",
          770: "-354 612L-288 694H-213L-147 612Q-83 532 -80 529Q-79 528 -82 527Q-86 527 -117 527H-155L-250 639Q-256 633 -301 580L-346 527H-384Q-421 528 -421 529Q-418 532 -354 612",
          771: "-417 554Q-414 604 -387 640T-314 677Q-289 677 -249 649T-188 620Q-163 620 -160 665V677H-84V666Q-87 608 -118 576T-185 543Q-211 543 -251 571T-313 600Q-338 600 -341 555V543H-417V554",
          772: "-431 552V631H-70V552H-431",
          774: "-250 508Q-331 508 -379 567T-427 689V694H-351V685Q-348 649 -321 620T-250 591Q-206 591 -180 619T-150 685V694H-74V689Q-74 624 -122 566T-250 508",
          775: "-302 576V680H-198V576H-302",
          776: "-397 582V680H-299V582H-397ZM-202 582V680H-104V582H-202",
          778: "-319 611Q-319 649 -285 671T-211 694Q-164 694 -132 671T-99 611Q-99 572 -133 550T-209 527T-285 549T-319 611ZM-155 610Q-155 635 -171 643T-215 651Q-263 651 -263 610Q-263 570 -211 570H-209H-207Q-155 570 -155 610",
          779: "-250 693Q-317 544 -323 527H-399L-343 694H-296Q-250 694 -250 693ZM-84 693Q-151 544 -157 527H-233L-177 694H-130Q-84 694 -84 693",
          780: "-421 652Q-422 653 -419 654Q-415 654 -384 654H-346L-301 601Q-287 585 -275 571T-258 551T-250 542L-155 654H-117Q-80 653 -80 652Q-83 649 -147 569L-213 487H-288L-354 569Q-418 649 -421 652",
          913: "183 181Q183 179 152 91T118 0H28L154 346L280 693Q281 694 333 694H385L511 349Q636 4 638 2Q638 0 584 0H530L464 183H184L183 181ZM324 606Q319 578 292 492T238 332T210 256Q210 254 324 254T438 255L429 281L419 308Q409 336 395 378T365 465T339 551T324 611V606",
          914: "425 363Q438 363 465 353T526 324T585 270T610 192Q610 132 561 78T426 7Q404 2 387 2T240 0H90V694H227Q373 693 396 689Q484 673 533 623T583 517Q583 494 574 473T551 437T520 409T487 388T456 374T433 366L425 363ZM490 516Q490 527 485 539T467 568T423 599T347 621Q340 622 262 623H188V399H261H286Q432 399 478 475Q490 496 490 516ZM514 190Q514 245 462 280T343 322Q336 323 259 323H188V71H274Q365 72 388 77Q445 88 479 121T514 190",
          915: "87 0V691H499V611H345L191 612V0H87",
          916: "203 348L362 694H470L629 348Q789 2 790 1Q790 0 416 0T42 1Q43 2 203 348ZM630 98Q630 100 584 198T481 422T407 603L405 610L403 600Q388 544 191 122L180 99L405 98H630",
          917: "86 0V691H541V611H366L190 612V397H513V321H190V85H372L554 86V0H86",
          918: "69 617V694H555V643L373 362Q190 81 190 79H234Q244 79 272 79T344 80T419 81H560V0H55V53L237 334Q420 615 420 617Q413 618 387 618Q380 618 334 618T245 617H69",
          919: "86 0V694H190V399H517V694H621V0H517V323H190V0H86",
          920: "56 344Q56 430 86 502T164 619T271 690T388 716Q448 716 506 691T613 619T692 501T722 344Q722 188 624 84T389 -21Q252 -21 154 83T56 344ZM624 345Q624 423 597 488T513 596T380 639Q343 639 305 621T232 568T175 475T153 344Q153 216 222 136T388 56Q487 56 555 138T624 345ZM209 299V397H568V299H209",
          921: "87 0V694H191V0H87",
          922: "88 0V694H188V519L189 343L525 694H638L375 419L651 0H541L309 351L188 225V0H88",
          923: "294 606Q294 574 252 430T163 144T117 0H72Q28 0 28 1T141 348L254 694H357L469 348Q582 2 582 1T527 0L473 1L469 11Q469 13 427 141T343 411T296 599L294 610V606",
          924: "92 0V694H228L233 680Q236 675 284 547T382 275T436 106Q446 149 497 292T594 558L640 680L645 694H782V0H689V305L688 606Q688 577 500 78L479 23H392L364 96Q364 97 342 156T296 280T246 418T203 544T186 609V588Q185 568 185 517T185 427T185 305V0H92",
          925: "88 0V694H235L252 659Q261 639 364 428T526 84V694H619V0H472L455 35Q453 39 330 294T185 601L181 611V0H88",
          926: "47 600V688H619V600H47ZM111 314V401H555V314H111ZM42 0V88H624V0H42",
          927: "55 345Q55 504 149 609T361 715Q386 715 406 713Q521 696 600 592T680 344Q680 193 590 86T368 -22Q239 -22 147 84T55 345ZM276 59T368 59T518 146T576 360Q576 473 525 545T401 634Q371 637 362 637Q284 637 222 562T159 360T217 147",
          928: "86 0V691H621V0H517V615H190V0H86",
          929: "88 0V694H230Q347 693 370 692T410 686Q487 667 535 611T583 485Q583 409 527 348T379 276Q369 274 279 274H192V0H88ZM486 485Q486 523 471 551T432 593T391 612T357 621Q350 622 268 623H189V347H268Q350 348 357 349Q370 351 383 354T416 368T450 391T475 429T486 485",
          931: "55 0Q56 3 171 167T288 332Q288 334 172 474L55 615V694H666V614H428L190 615L412 347L322 218Q236 97 228 84L447 85H666V0H55",
          932: "36 608V688H644V608H518L392 609V0H288V609L162 608H36",
          933: "55 565Q59 625 105 670T219 716H222Q310 716 353 627Q376 583 386 524L389 510L393 532Q397 555 407 584T433 644T482 695T557 716Q621 716 669 673T722 565V555H629V563Q627 592 607 615T557 638Q530 638 511 629T479 598T459 553T447 488T442 411T441 319V202V0H337V202Q337 453 331 497Q313 634 226 638Q185 638 167 612T148 563V555H55V565",
          934: "666 347Q666 326 661 302T638 247T594 190T520 140T413 107H410V0H312V54Q312 107 311 107Q286 107 229 128T125 192Q55 260 55 347Q55 396 77 438T131 507T200 552T265 579T311 587Q312 587 312 641V694H410V587H413Q476 576 524 552T598 502T640 444T661 390T666 347ZM310 510Q305 510 291 507T252 492T208 464T172 416T157 347T171 279T204 233T247 205T286 190T310 184H312V347Q312 510 310 510ZM564 347Q564 385 549 416T514 463T470 491T433 505T414 509L410 510V184Q413 184 426 187T464 200T510 227T548 275T564 347",
          935: "14 0Q16 5 144 184T275 367L153 528Q121 571 88 615T42 674T28 694H150L228 584Q315 463 316 461L326 448L497 694H610L609 692Q606 689 492 528Q440 454 409 410T378 366Q378 365 515 182L652 0H531L326 292Q326 293 299 254T226 146L128 0H14",
          936: "340 187V694H438V187Q481 206 495 219Q518 239 533 267T553 332T560 386T562 435Q562 576 593 608Q608 621 637 621H670H722V545H719Q718 545 715 545T710 544Q679 536 666 487Q664 474 662 429T654 344T633 259T580 175T486 119Q450 109 438 108V0H340V108L326 110Q122 149 117 415Q116 460 111 487Q98 536 67 544Q65 544 62 544T58 545H55V621H107Q160 621 163 620Q191 613 202 573Q213 536 213 473T220 351T256 249Q262 239 270 230T285 216T301 205T316 197T329 192T340 187",
          937: "55 462Q55 561 141 638T359 716Q492 716 579 640T666 462Q666 407 642 347T579 222T529 126Q515 91 515 86Q517 85 528 85Q530 85 552 85T596 86H677V0H425V14Q429 79 465 168L492 228Q494 232 504 254T516 283T527 310T539 340T548 368T556 399T560 428T562 460Q562 531 510 585T361 639Q263 639 211 585T159 460Q159 422 170 378T192 309T229 228L256 168Q292 79 296 14V0H44V86H125Q146 86 168 86T193 85L206 86Q206 103 183 148T131 241T79 352T55 462",
          8211: "0 236V312H499V236H0",
          8212: "0 236V312H999V236H0",
          8213: "0 236V312H999V236H0",
          8215: "0 -114V-38H499V-114H0",
          8216: "90 568L140 694H189L174 633Q159 572 158 571Q158 569 173 569H188V471H90V568",
          8217: "90 596V694H188V597L139 471H89L104 532Q119 593 120 594Q120 596 105 596H90",
          8220: "174 568L224 694H273L258 633Q243 572 242 571Q242 569 257 569H272V471H174V568ZM368 568L418 694H467L452 633Q437 572 436 571Q436 569 451 569H466V471H368V568",
          8221: "33 596V694H131V597L82 471H32L47 532Q62 593 63 594Q63 596 48 596H33ZM227 596V694H325V597L276 471H226L241 532Q256 593 257 594Q257 596 242 596H227",
          8260: "423 750Q432 750 438 744T444 730Q444 725 271 248T92 -240Q85 -250 75 -250Q68 -250 62 -245T56 -231Q56 -221 230 257T407 740Q411 750 423 750",
          8710: "203 348L362 694H470L629 348Q789 2 790 1Q790 0 416 0T42 1Q43 2 203 348ZM630 98Q630 100 584 198T481 422T407 603L405 610L403 600Q388 544 191 122L180 99L405 98H630"
        }, {});
      },
      1325: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.scriptBold = void 0;
        var n = r(5649);
        Object.defineProperty(e, "scriptBold", {
          enumerable: !0,
          get: function get() {
            return n.scriptBold;
          }
        });
      },
      4164: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.script = void 0;
        var n = r(7153);
        Object.defineProperty(e, "script", {
          enumerable: !0,
          get: function get() {
            return n.script;
          }
        });
      },
      8652: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallop = void 0;
        var n = r(768),
          o = r(5745);
        e.smallop = (0, n.AddPaths)(o.smallop, {
          40: "152 251Q152 646 388 850H416Q422 844 422 841Q422 837 403 816T357 753T302 649T255 482T236 250Q236 124 255 19T301 -147T356 -251T403 -315T422 -340Q422 -343 416 -349H388Q359 -325 332 -296T271 -213T212 -97T170 56T152 251",
          41: "305 251Q305 -145 69 -349H56Q43 -349 39 -347T35 -338Q37 -333 60 -307T108 -239T160 -136T204 27T221 250T204 473T160 636T108 740T60 807T35 839Q35 850 50 850H56H69Q197 743 256 566Q305 425 305 251",
          47: "481 838Q489 850 500 850Q508 850 515 844T522 827Q521 824 311 248T96 -337Q90 -349 77 -349Q68 -349 62 -343T55 -326Q56 -323 266 253T481 838",
          91: "202 -349V850H394V810H242V-309H394V-349H202",
          92: "522 -326Q522 -337 515 -343T500 -349Q487 -349 481 -337Q477 -328 267 248T55 827Q54 835 60 842T76 850Q89 850 96 838Q100 829 310 253T522 -326",
          93: "22 810V850H214V-349H22V-309H174V810H22",
          123: "477 -343L471 -349H458Q432 -349 367 -325T273 -263Q258 -245 250 -212L249 -51Q249 -27 249 12Q248 118 244 128Q243 129 243 130Q220 189 121 228Q109 232 107 235T105 250Q105 256 105 257T105 261T107 265T111 268T118 272T128 276T142 283T162 291Q224 324 243 371Q243 372 244 373Q248 384 249 469Q249 475 249 489Q249 528 249 552L250 714Q253 728 256 736T271 761T299 789T347 816T422 843Q440 849 441 849H443Q445 849 447 849T452 850T457 850H471L477 844V830Q477 820 476 817T470 811T459 807T437 801T404 785Q353 760 338 724Q333 710 333 550Q333 526 333 492T334 447Q334 393 327 368T295 318Q257 280 181 255L169 251L184 245Q318 198 332 112Q333 106 333 -49Q333 -209 338 -223Q351 -255 391 -277T469 -309Q477 -311 477 -329V-343",
          125: "110 849L115 850Q120 850 125 850Q151 850 215 826T309 764Q324 747 332 714L333 552Q333 528 333 489Q334 383 338 373Q339 372 339 371Q353 336 391 310T469 271Q477 268 477 251Q477 241 476 237T472 232T456 225T428 214Q357 179 339 130Q339 129 338 128Q334 117 333 32Q333 26 333 12Q333 -27 333 -51L332 -212Q328 -228 323 -240T302 -271T255 -307T175 -338Q139 -349 125 -349T108 -346T105 -329Q105 -314 107 -312T130 -304Q233 -271 248 -209Q249 -203 249 -49V57Q249 106 253 125T273 167Q307 213 398 245L413 251L401 255Q265 300 250 389Q249 395 249 550Q249 710 244 724Q224 774 112 811Q105 813 105 830Q105 845 110 849",
          710: "279 669Q273 669 142 610T9 551L0 569Q-8 585 -8 587Q-8 588 -7 588L12 598Q30 608 66 628T136 666L277 744L564 587L555 569Q549 556 547 554T544 552Q539 555 410 612T279 669",
          732: "374 597Q337 597 269 627T160 658Q101 658 34 606L24 597L12 611Q1 624 1 626Q1 627 27 648T55 671Q120 722 182 722Q219 722 286 692T395 661Q454 661 521 713L531 722L543 708Q554 695 554 693Q554 692 528 671T500 648Q434 597 374 597",
          770: "-277 669Q-283 669 -414 610T-547 551L-556 569Q-564 585 -564 587Q-564 588 -563 588L-544 598Q-526 608 -490 628T-420 666L-279 744L8 587L-1 569Q-7 556 -9 554T-12 552Q-17 555 -146 612T-277 669",
          771: "-182 597Q-219 597 -287 627T-396 658Q-455 658 -522 606L-532 597L-544 611Q-555 624 -555 626Q-555 627 -529 648T-501 671Q-436 722 -374 722Q-337 722 -270 692T-161 661Q-102 661 -35 713L-25 722L-13 708Q-2 695 -2 693Q-2 692 -28 671T-56 648Q-122 597 -182 597",
          8214: "257 0V602H300V0H257ZM478 0V602H521V0H478",
          8260: "481 838Q489 850 500 850Q508 850 515 844T522 827Q521 824 311 248T96 -337Q90 -349 77 -349Q68 -349 62 -343T55 -326Q56 -323 266 253T481 838",
          8593: "112 421L120 424Q127 427 136 430T161 441T191 458T224 481T260 510T295 546T328 591L333 600L340 589Q380 527 431 489T555 421V377L543 381Q445 418 368 492L355 504V0H312V504L299 492Q222 418 124 381L112 377V421",
          8595: "312 96V600H355V96L368 108Q445 182 543 219L555 223V179L546 176Q538 173 529 169T505 158T475 141T442 119T407 90T372 53T339 9L334 0L327 11Q287 73 236 111T112 179V223L124 219Q222 182 299 108L312 96",
          8657: "142 329Q300 419 389 599Q389 598 399 579T420 541T452 494T497 438T558 383T636 329T708 294L721 289V246Q718 246 694 256T623 293T532 356L522 364L521 182V0H478V405L466 417Q436 450 389 516Q388 515 378 500T352 463T312 417L300 405V0H257V364L247 356Q202 320 155 293T82 256L57 246V289L70 294Q101 305 142 329",
          8659: "257 236V600H300V195L312 183Q342 150 389 84Q390 85 400 100T426 137T466 183L478 195V600H521V418L522 236L532 244Q576 280 623 307T696 344L721 354V311L708 306Q677 295 636 271Q478 181 389 1Q389 2 379 21T358 59T326 106T281 162T220 217T142 271T70 306L57 311V354Q60 354 83 345T154 308T247 244L257 236",
          8719: "158 656Q147 684 131 694Q110 707 69 710H55V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H570V-210H584Q618 -208 638 -197T663 -178T673 -155V710H270V277L271 -155Q283 -206 359 -210H373V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
          8720: "158 656Q147 684 131 694Q110 707 69 710H55V750H373V710H359Q325 708 305 698T280 678T271 656L270 223V-210H673V656Q666 672 663 679T639 697T584 710H570V750H888V710H874Q840 708 820 698T795 678T786 656V-155Q798 -206 874 -210H888V-250H55V-210H69Q103 -208 123 -197T148 -178T158 -155V656",
          8721: "61 748Q64 750 489 750H913L954 640Q965 609 976 579T993 533T999 516H979L959 517Q936 579 886 621T777 682Q724 700 655 705T436 710H319Q183 710 183 709Q186 706 348 484T511 259Q517 250 513 244L490 216Q466 188 420 134T330 27L149 -187Q149 -188 362 -188Q388 -188 436 -188T506 -189Q679 -189 778 -162T936 -43Q946 -27 959 6H999L913 -249L489 -250Q65 -250 62 -248Q56 -246 56 -239Q56 -234 118 -161Q186 -81 245 -11L428 206Q428 207 242 462L57 717L56 728Q56 744 61 748",
          8730: "263 249Q264 249 315 130T417 -108T470 -228L725 302Q981 837 982 839Q989 850 1001 850Q1008 850 1013 844T1020 832V826L741 243Q645 43 540 -176Q479 -303 469 -324T453 -348Q449 -350 436 -350L424 -349L315 -96Q206 156 205 156L171 130Q138 104 137 104L111 130L263 249",
          8739: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
          8741: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612ZM368 612Q373 627 388 627Q404 627 409 612Q410 610 410 306T409 0Q406 -15 389 -15Q371 -15 368 0V10Q368 19 368 35T368 73T368 122T367 179T367 241T367 306T367 370T367 433T367 489T368 538T368 576T368 602V612",
          8747: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244",
          8748: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244",
          8749: "113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q220 -247 232 -218T251 -133T262 -15T276 155T297 367Q300 390 305 438T314 512T325 580T340 647T361 703T390 751T428 784T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q475 768 460 756T434 716T418 652T407 559T398 444T387 300T369 133Q349 -38 337 -102T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244ZM460 -244Q460 -246 466 -251T486 -263T514 -269Q532 -269 546 -260Q567 -247 579 -218T598 -133T609 -15T623 155T644 367Q647 390 652 438T661 512T672 580T687 647T708 703T737 751T775 784T826 804Q828 804 835 804T848 805Q899 802 928 769T957 695Q957 669 941 657T908 645Q889 645 874 658T859 694Q859 705 863 714T873 729T885 737T895 742L899 743Q899 745 892 751T872 762T845 768Q822 768 807 756T781 716T765 652T754 559T745 444T734 300T716 133Q696 -38 684 -102T650 -207Q603 -306 516 -306Q466 -306 434 -272T402 -196Q402 -170 418 -158T451 -146Q470 -146 485 -159T500 -195Q500 -206 496 -215T486 -230T474 -238T464 -242L460 -244ZM807 -244Q807 -246 813 -251T833 -263T861 -269Q880 -269 893 -260Q914 -247 926 -218T945 -133T956 -15T970 155T991 367Q994 390 999 438T1008 512T1019 580T1034 647T1055 703T1084 751T1122 784T1173 804Q1175 804 1182 804T1195 805Q1246 802 1275 769T1304 695Q1304 669 1288 657T1255 645Q1236 645 1221 658T1206 694Q1206 705 1210 714T1220 729T1232 737T1242 742L1246 743Q1246 745 1239 751T1219 762T1192 768Q1169 768 1154 756T1128 716T1112 652T1101 559T1092 444T1081 300T1063 133Q1043 -38 1031 -102T997 -207Q950 -306 863 -306Q813 -306 781 -272T749 -196Q749 -170 765 -158T798 -146Q817 -146 832 -159T847 -195Q847 -206 843 -215T833 -230T821 -238T811 -242L807 -244",
          8750: "269 74L256 80Q244 85 227 97T191 128T161 179T148 250Q148 332 199 379T302 433L306 434L307 444Q309 456 313 495T321 553T331 607T345 664T365 712T393 756T431 785T479 804Q481 804 488 804T501 805Q552 802 581 769T610 695Q610 669 594 657T561 645Q542 645 527 658T512 694Q512 705 516 714T526 729T538 737T548 742L552 743Q552 745 545 751T525 762T498 768Q471 768 454 752T427 693T414 626T406 536Q405 530 405 527L397 425L404 422Q410 419 421 413T445 399T470 376T494 345T511 303T518 250Q518 205 502 169T460 112T410 80T364 66L360 65L359 55Q357 38 353 4T346 -43T340 -81T333 -118T326 -148T316 -179T303 -207Q256 -306 169 -306Q119 -306 87 -272T55 -196Q55 -170 71 -158T104 -146Q123 -146 138 -159T153 -195Q153 -206 149 -215T139 -230T127 -238T117 -242L113 -244Q113 -246 119 -251T139 -263T167 -269Q186 -269 199 -260Q231 -241 242 -183T266 33L269 74ZM272 122Q272 156 300 391Q300 392 299 392Q287 392 263 379T213 331T187 249Q187 211 205 180T239 137T272 116V122ZM366 107Q378 107 402 119T453 167T479 249Q479 340 394 383V377Q394 375 394 374T393 371T393 366T392 357T391 342T389 321T386 291T382 251T377 199T369 133Q366 112 366 107",
          8896: "119 -249T97 -249T65 -235T55 -207Q55 -201 56 -198Q58 -190 218 268T380 729Q392 750 416 750Q438 750 451 732Q453 728 534 498T695 36L775 -194Q777 -204 777 -208Q777 -222 767 -235T735 -249Q713 -249 700 -231Q696 -225 557 177L416 579L276 177Q136 -226 132 -231Q119 -249 97 -249",
          8897: "55 708Q55 729 68 739T96 750Q119 750 132 731Q136 726 276 323L416 -79L557 323Q696 725 700 731Q713 749 735 749Q756 749 766 736T777 708Q777 700 696 466T533 1T451 -232Q436 -249 416 -249Q402 -249 391 -241Q384 -236 380 -226Q368 -198 219 230Q55 697 55 708",
          8898: "139 -217Q127 -241 114 -246Q106 -249 97 -249Q67 -249 57 -220Q55 -214 55 102Q55 152 55 221T54 312Q54 422 60 464T91 554Q120 612 165 654T257 714T337 741T392 749Q393 750 402 750Q414 750 422 749Q557 749 660 659T776 430Q777 422 777 102Q777 -214 775 -220Q765 -249 735 -249Q716 -249 708 -241T694 -217L692 428L690 441Q674 540 597 603T416 666H409Q388 666 364 662T294 638T212 581Q156 523 142 441L140 428L139 105V-217",
          8899: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750",
          8968: "202 -349V850H449V810H242V-349H202",
          8969: "22 810V850H269V-349H229V810H22",
          8970: "202 -349V850H242V-309H449V-349H202",
          8971: "229 -309V850H269V-349H22V-309H229",
          9001: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
          9002: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832",
          9168: "312 0V602H355V0H312",
          10072: "146 612Q151 627 166 627Q182 627 187 612Q188 610 188 306T187 0Q184 -15 166 -15Q149 -15 146 0V10Q146 19 146 35T146 73T146 122T145 179T145 241T145 306T145 370T145 433T145 489T146 538T146 576T146 602V612",
          10216: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
          10217: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832",
          10752: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM555 -165Q672 -165 767 -108T916 44T970 250Q970 418 861 532T600 664Q591 665 548 665Q446 665 353 614T200 466T140 250V243Q140 88 248 -30Q262 -46 280 -62T338 -105T434 -148T555 -165ZM478 250Q478 288 503 307T551 326Q586 326 609 305T632 250Q632 217 610 196T555 174T500 196T478 250",
          10753: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM513 478Q513 664 512 664Q504 664 481 660T406 637T313 588Q281 564 255 537T211 483T181 431T161 382T150 342T144 310T141 292H513V478ZM798 588Q758 616 711 634T639 658T602 663L597 664V292H969Q969 293 967 309T960 341T949 381T930 430T900 482T856 537T798 588ZM513 -164V208H141Q142 205 144 189T149 160T158 125T173 83T196 39T229 -9Q249 -34 273 -55T318 -92T363 -119T405 -138T444 -150T475 -158T499 -162T513 -164ZM775 -103Q801 -87 823 -68T863 -30T894 10T919 49T937 88T950 123T959 154T964 180T968 198L969 208H597V-164Q599 -163 616 -161T647 -155T683 -145T728 -128T775 -103",
          10754: "555 -250Q420 -250 306 -185T124 -4T56 250Q56 453 193 595T526 749Q528 750 539 750Q554 750 562 749Q688 749 800 687T983 508T1054 250Q1054 112 987 -3T806 -184T555 -250ZM600 664Q591 665 548 665Q414 665 306 583L292 573L423 441L555 310L687 441L818 573L804 583Q714 650 600 664ZM364 118L495 250L364 382L232 513L223 500Q140 391 140 250Q140 107 223 0L232 -13L364 118ZM970 250Q970 389 887 501L878 512Q878 513 861 496T812 447T746 381L615 250L746 118L878 -13L887 0Q970 109 970 250ZM687 59L555 190L423 59L292 -73L306 -83Q416 -166 555 -166T804 -83L818 -73L687 59",
          10756: "96 750Q103 750 109 748T120 744T127 737T133 730T137 723T139 718V395L140 73L142 60Q159 -43 237 -104T416 -166Q521 -166 597 -103T690 60L692 73L694 718Q708 749 735 749Q765 749 775 720Q777 714 777 398Q777 78 776 71Q766 -51 680 -140Q571 -249 416 -249H411Q261 -249 152 -140Q66 -51 56 71Q55 78 55 398Q55 714 57 720Q60 734 70 740Q80 750 96 750ZM223 276Q223 282 224 287T227 296T232 302T238 308T243 313T250 316L254 319H374V376V406Q374 438 382 454T418 470Q443 467 450 453T458 410V376V319H579Q580 319 583 317T589 313T594 308T600 302T604 295T608 287T609 276Q609 253 587 241Q577 235 513 235H458V178Q458 176 458 166T459 148Q459 84 415 84Q401 84 390 93T375 117Q374 120 374 178V235H319Q317 235 307 235T290 234Q223 234 223 276",
          10758: "777 -217Q766 -244 745 -249H88Q64 -242 57 -220Q55 -214 55 250T57 720Q60 734 70 740Q80 750 96 750Q127 750 137 720Q139 714 139 274V-166H693V274Q693 714 695 720Q705 749 735 749Q766 749 775 719Q777 713 777 248V-217",
          12296: "373 850Q392 850 394 832Q394 825 267 538L139 250L267 -38Q394 -325 394 -332Q392 -350 375 -350Q361 -350 356 -338Q354 -331 289 -186T161 103T97 250T160 397T289 685T356 838Q362 850 373 850",
          12297: "77 832Q77 837 82 843T98 850Q110 849 115 838Q117 831 182 686T310 397T374 250T311 103T182 -185T115 -338Q110 -350 96 -350Q79 -350 77 -332Q77 -325 204 -38L332 250L204 538Q77 825 77 832"
        }, {
          10764: "\u222C\u222C"
        });
      },
      5667: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphicBold = void 0;
        var n = r(768),
          o = r(1411);
        e.texCalligraphicBold = (0, n.AddPaths)(o.texCalligraphicBold, {
          65: "761 751Q784 751 784 728V711Q784 570 795 417T820 191Q844 76 865 76Q868 76 902 93T962 112H973Q989 104 989 94Q989 92 987 86Q978 47 846 -11Q812 -25 779 -26Q722 -26 708 9Q688 47 669 161H524L379 162L359 136Q286 43 234 -3T142 -49T71 -19T39 55Q39 92 60 131T103 174Q113 174 117 167T124 149T136 128T166 110Q183 105 190 105Q230 105 341 246Q401 322 453 397T531 514T582 601T611 651H640V663Q640 692 676 718T745 750Q747 750 752 750T761 751ZM658 266Q653 312 649 377T644 489T641 541V556L557 415Q500 325 448 253Q467 261 524 261H568H658V266",
          66: "441 83Q571 83 571 195Q571 246 538 279T466 322T386 333Q378 333 357 330T329 327Q307 327 307 345Q307 354 313 365T347 396T419 430Q546 472 581 498Q594 508 594 535Q594 574 567 589T508 604Q469 604 442 583Q390 546 342 457T265 256Q237 148 186 60Q167 29 144 13Q105 -15 68 -17H65Q40 -17 40 1Q40 7 53 29T87 100T124 210Q162 373 190 575Q188 575 174 567T138 550T98 542Q75 542 75 560Q75 588 123 618Q135 625 203 659T281 696Q299 703 316 703Q339 703 339 685Q339 656 328 583L333 588Q338 592 346 599T367 615T394 634T428 654T467 674T511 690T559 701T611 705Q651 704 681 689Q739 659 739 598Q739 507 595 427L584 421Q585 420 595 416T610 410T626 402T644 392T660 380T677 365T691 347T703 325T710 299T715 268Q717 193 665 130Q622 73 531 28T348 -17Q275 -17 225 10Q206 19 200 24T193 36Q193 57 231 86T311 119H322Q386 83 441 83",
          67: "243 -20Q135 -20 78 48T20 218Q20 280 39 344T98 470T193 580T324 661T488 702H490Q491 702 493 702T498 703T507 703T518 702H526Q599 702 599 631Q599 597 577 550T541 486Q523 463 490 447T431 430Q423 430 419 433Q409 437 409 450Q410 456 432 499T454 567Q454 586 446 594T415 603Q316 603 254 532Q216 487 190 421T164 284Q164 228 181 186T226 122T282 90T340 80Q377 80 405 96T449 131T492 167T553 187H555Q580 187 580 168Q580 153 551 123T476 60T367 4T243 -20",
          68: "107 0Q92 5 92 18Q92 33 113 53T160 86Q170 91 182 94T197 100L206 120Q248 226 273 337T304 501T309 585Q278 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q281 686 447 686H480H517Q692 686 784 631Q885 571 885 450Q885 339 805 239T586 75T286 1Q276 0 187 0H107ZM741 391Q741 424 731 452T694 510T613 558T481 584Q476 584 468 584T457 585L449 586V579Q441 501 425 424T391 292T357 193T330 125T319 100H324Q511 100 628 175Q688 215 714 275T741 391",
          69: "495 516Q485 516 478 520T470 532Q470 537 476 550T482 570Q482 589 465 596T401 603Q344 603 319 582Q295 558 295 519Q295 493 312 474T355 445T407 432T455 427Q477 427 477 409Q477 395 453 371T389 333Q380 330 345 327T279 312T223 272Q181 223 181 176Q181 131 225 107T324 83Q366 83 395 98T448 136T487 167Q517 185 547 187H551Q574 187 574 170Q574 151 535 113T421 36T271 -15Q260 -16 226 -16Q181 -16 152 -9Q104 4 71 33T37 111Q37 140 50 176T106 263T216 356Q215 357 207 362T190 374T172 392T156 419T150 456Q150 521 208 580T341 670T474 702Q475 703 499 703Q528 703 547 701T586 693T615 673T627 637Q627 584 581 550T495 516",
          70: "812 567Q804 567 795 570T786 579Q786 586 647 586H559L558 582Q558 575 539 510T506 407L498 384H775Q788 378 790 368Q790 328 746 298T665 268Q646 268 642 284H457L447 261Q396 150 360 94Q329 46 270 8T149 -30Q123 -30 100 -24T63 -10T37 9T22 26T17 36Q17 59 56 88T135 119Q145 119 149 117T165 104Q187 78 227 72Q232 72 234 76Q245 93 273 145T350 323T424 570L428 586H276Q265 575 239 563T190 551Q180 551 174 556T167 569Q167 580 179 597T213 634T278 668T371 685Q374 686 624 686Q863 685 888 682Q917 678 927 663Q930 658 930 650Q930 624 888 596T812 567",
          71: "50 279Q50 361 88 438T190 570T335 661T503 702H514Q524 703 532 703Q671 703 671 626Q671 580 614 514T495 447Q472 447 472 465Q472 477 499 511T527 562Q527 582 507 592T433 602Q351 602 302 569Q252 535 223 469T194 344Q194 266 237 217T352 168Q401 168 442 205T505 316Q515 345 551 368T622 393H625Q649 393 649 376Q649 371 635 318T612 237Q580 129 540 62T442 -49Q353 -114 264 -114Q259 -114 252 -114L246 -113Q190 -113 142 -107T81 -96Q71 -90 71 -81Q71 -57 110 -30T187 2Q196 2 236 -4T338 -14Q371 -14 377 -9Q410 24 446 113L451 127Q353 68 253 68Q157 68 104 129T50 279",
          72: "42 447Q20 447 20 465Q20 481 47 515T119 589T239 657T392 686Q443 686 463 664T484 616Q484 570 473 506T452 401L441 360Q441 359 550 359H660L663 370Q684 435 716 522T758 624Q771 646 806 666T870 686Q894 686 894 668Q894 667 867 597T804 416T752 218Q737 135 737 93Q737 77 746 65T778 53Q799 53 803 54T814 63Q831 86 864 103T924 120Q946 120 946 100Q945 85 931 63T888 16T806 -27T684 -48H681Q625 -48 603 -10Q593 4 593 29Q593 71 603 131T624 230L634 269Q632 269 624 266Q610 261 600 261T507 259H411L399 222Q344 62 322 21Q301 -7 268 -24T209 -41H207Q187 -41 185 -25Q185 -17 192 2T220 71T261 184Q284 256 284 258Q284 259 227 259H170Q169 259 166 261T162 264T158 266T156 271T155 277Q155 296 184 320T250 356Q259 358 286 359Q312 359 312 360Q314 372 318 385Q332 450 339 526Q339 530 339 535T340 543Q340 586 296 586Q255 586 227 576T188 553T165 523T146 497Q127 476 97 462T42 447",
          73: "56 499Q32 499 32 516Q32 540 64 580T165 649Q241 682 365 685Q366 685 376 685T405 685T445 686T496 686T553 686H732Q746 677 746 668Q746 646 711 620T642 587L572 586H503Q479 546 458 479T424 352T383 224T318 111L309 101L412 100H514L523 109Q567 150 618 153Q644 153 644 135Q644 132 642 124Q629 86 581 52T476 6Q454 2 433 2T216 0Q-11 0 -15 2Q-27 6 -27 18Q-27 37 2 61T59 93Q77 100 142 100H198Q255 177 299 369Q337 513 382 574L391 586H348Q261 586 176 576Q163 543 124 521T56 499",
          74: "286 390Q263 390 263 407Q263 432 293 481T367 566Q511 687 724 687Q738 687 761 687T793 686H923Q937 677 937 668Q937 648 905 623T842 589Q829 587 817 586T802 585T795 583T788 578Q709 506 632 189Q622 153 615 134T588 81T537 17Q482 -39 404 -76T247 -114Q192 -114 158 -100Q53 -61 53 32Q53 59 58 73T79 102Q126 147 177 147Q200 147 200 128Q200 123 198 112T196 96Q196 47 238 17T345 -13Q362 -13 377 -9T404 0T426 16T444 34T459 55T470 76T478 97T483 116T488 132L490 141Q511 222 520 257T554 364T608 486T675 576L685 586H634H612Q532 586 484 564Q453 549 436 526T409 478T395 447Q378 424 345 407T286 390",
          75: "98 542Q75 542 75 560Q75 588 123 618Q132 624 199 657T275 694Q291 703 315 703Q327 703 332 699T338 690T339 670Q339 596 323 505T283 337T237 194T198 90L181 53Q170 31 136 8T68 -17H65Q40 -17 40 0L76 92Q112 185 150 322T194 564V578L168 565Q125 542 98 542ZM834 142Q834 125 819 100T774 48T692 3T576 -16H560Q540 -16 508 6Q469 33 422 108T342 267T309 398Q309 411 310 417T320 442T347 482Q401 542 517 615T710 702Q712 702 721 702T735 703Q772 703 791 690Q819 674 819 646T792 597T733 574H722Q704 584 704 599Q706 607 700 610T672 617L660 613Q609 595 524 538T423 450V440Q423 376 488 247T604 83Q621 70 640 70Q677 70 701 82Q713 87 718 101T737 132T783 160Q792 163 807 163Q834 163 834 142",
          76: "63 -17Q41 -17 41 0Q41 22 85 54Q101 68 113 92T133 141T154 219T182 315Q230 462 306 553Q345 599 391 632T478 678T543 697T582 703Q584 703 589 703T598 702Q643 702 666 676T689 613Q689 588 683 575Q674 551 632 524T552 496Q530 496 530 512Q530 517 531 525T533 538Q533 559 522 577T480 596H476Q462 596 451 588T415 544Q350 447 310 281Q284 181 261 136L255 124H285Q342 123 441 107T583 90L596 89Q603 116 647 144T729 173Q751 173 751 157Q751 118 685 60T523 -15Q514 -16 479 -16Q421 -16 320 0T171 18H155L142 10Q98 -17 63 -17",
          77: "38 20Q38 59 60 99T104 139Q106 139 126 125T176 106H181Q200 106 221 139T286 281Q322 370 342 451T368 581T376 634Q384 657 420 680T487 703Q502 703 507 696T522 649Q538 589 554 537Q579 453 609 372T660 248T686 202Q687 201 739 244T830 322L1166 642Q1225 700 1230 701Q1230 701 1237 703Q1258 703 1258 667L1253 637Q1248 607 1241 558T1227 451T1214 326T1209 202Q1209 77 1232 77Q1237 77 1269 94T1326 112H1329Q1353 112 1353 94Q1353 81 1334 60Q1311 37 1248 7T1150 -24H1141H1135Q1085 -24 1074 26Q1064 75 1064 134Q1064 239 1086 426Q1087 430 1087 434L1061 410Q871 227 783 149L694 76Q653 44 647 40T631 34Q620 34 616 37T594 63Q546 125 514 198Q467 307 423 449L418 466L412 444Q376 310 306 153Q278 88 251 45T201 -18T163 -43T131 -49Q102 -48 70 -31T38 20",
          78: "47 139Q81 105 122 105Q137 105 147 117Q159 134 182 199T234 381T274 610Q275 634 284 647Q297 666 327 684T389 703Q403 703 408 695T428 645Q480 490 567 298Q628 163 673 103Q674 102 674 102T675 106Q732 331 803 551Q842 674 875 725Q908 775 966 807T1081 840H1084Q1105 840 1105 803Q1105 768 1088 733T1051 689Q1045 686 1032 686Q986 683 948 663T901 624Q881 579 837 430T760 154L726 28Q725 28 725 28T723 25Q716 0 682 -24T611 -48Q600 -48 595 -45T576 -23Q522 44 480 124Q417 243 332 463L328 473L325 457Q291 293 227 124Q159 -49 72 -49Q38 -49 5 -28Q-24 -8 -24 21Q-24 58 -3 98T41 139H47",
          79: "433 703Q456 703 456 685Q456 672 441 655T407 627Q402 623 378 611T328 579T276 524Q207 434 207 324Q207 222 270 153T441 84Q566 84 651 177T737 400V405Q737 496 693 549T576 603Q542 603 510 560Q490 537 472 502T442 454Q397 412 346 409Q320 409 320 427Q320 430 322 436Q331 465 360 507T433 594T542 671T677 703Q776 703 829 636T882 468Q882 369 831 277T702 122T528 21T343 -17Q214 -17 139 61T63 257Q63 336 94 409T173 534T272 625T367 684T432 703H433",
          80: "170 -67Q147 -67 147 -49Q147 -42 162 -8T204 99T253 254Q274 332 288 415T305 542L308 585Q277 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H495H537Q622 686 678 677T784 637Q846 598 846 533Q846 452 776 375T597 252T378 206H366L358 181Q341 130 316 68T282 -7Q262 -33 230 -50T170 -67ZM701 468Q701 512 661 540T570 577T461 586H448V582Q446 576 443 545T428 447T395 301L389 280Q390 280 398 284T419 295T441 303Q443 304 484 306T572 321T651 359Q701 402 701 468",
          81: "874 453Q874 372 836 298T750 177T638 89T543 33T486 8L483 7Q485 5 523 -7T622 -32T726 -46Q741 -46 746 -45T755 -41T762 -27Q770 -1 806 23T878 50H890Q905 42 905 33Q905 -8 838 -68T670 -145Q662 -146 628 -146Q538 -146 389 -100T164 -50Q132 -50 132 -32T162 11T227 47Q231 48 286 51T394 62T518 100T641 180Q730 271 730 387Q730 478 673 540T520 602Q410 602 337 525T264 355Q264 284 310 244T420 203Q476 203 568 222Q594 222 594 204Q594 184 565 161T508 128Q433 103 316 103Q227 103 174 157T120 290Q120 382 182 471T343 620T548 697Q578 703 601 703Q604 703 611 703T623 702Q663 702 687 696Q760 679 817 618T874 453",
          82: "159 0Q159 5 172 34T205 114T245 229T284 386T309 575V585H304Q303 585 295 585T282 584Q233 579 207 570T175 553T165 531T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H505H582Q683 686 745 672T834 611Q842 594 842 565Q842 523 824 484T780 419T722 370T669 336T632 318L619 312L626 302Q640 279 667 227T696 172Q717 133 735 112T762 88T784 84Q824 84 872 118T957 153Q981 153 981 136Q981 114 937 78T820 13T684 -17Q646 -17 616 8T569 66T526 151T477 234Q461 256 446 265Q437 272 421 274Q400 274 400 291Q400 311 430 336T495 371Q496 371 543 374T627 392T681 436Q699 467 699 503Q699 550 644 568T471 586H449V582Q449 581 447 559T438 499T422 413T393 298T348 165Q313 73 296 45Q282 24 249 4T185 -17Q159 -17 159 0",
          83: "204 476Q204 525 248 577T372 666T539 703T674 683T721 612Q721 588 714 569Q704 547 669 524T601 499Q573 499 573 516Q573 521 575 527T577 543Q577 563 568 574T548 588L539 590Q490 603 444 603Q418 603 394 597T364 583Q348 567 348 533Q348 493 382 466T459 425T555 387T633 330Q662 292 662 249Q662 153 544 69T257 -16Q218 -16 208 -15Q118 1 64 46Q25 76 25 126Q25 185 82 235T203 290H207Q229 290 231 274Q231 243 180 213Q173 209 172 206T170 189T171 170T183 150T216 121Q273 83 356 83Q412 83 459 100Q493 111 507 141Q518 165 518 185Q518 208 506 228T478 262T437 288T398 306T360 320Q316 335 285 352T239 384T215 416T205 443T204 467V476",
          84: "61 462H59Q38 462 38 479Q38 528 109 594T289 683L304 685L837 687L846 693Q889 720 923 720Q947 720 947 702Q945 671 892 631T776 583Q774 583 772 583T769 582T766 582L764 581H758Q753 581 744 581T722 580T693 580T662 580H563L514 385Q507 355 493 299T475 225T460 172T443 119T426 76T402 24Q386 -11 355 -33T304 -61T266 -69Q242 -69 242 -50Q243 -45 253 -25T278 32T307 115L364 340Q405 511 413 538T436 580H207Q202 572 200 568T197 561T195 552T190 537Q176 511 135 487T61 462",
          85: "124 586Q107 586 74 569T15 552H13Q-10 552 -10 570Q-10 605 70 645T222 686Q283 686 283 631Q283 590 246 504T172 326T135 181Q135 130 157 107T205 83Q221 83 259 106Q347 165 453 301T604 548Q607 557 612 569T619 587T624 600T628 612T632 621T637 628T641 634T647 640T654 645T662 652Q706 686 748 686Q771 686 771 669Q771 656 754 614T700 467T630 229Q615 168 610 105Q610 88 617 78L641 90Q681 111 706 112Q733 112 733 95Q733 82 714 60Q694 40 633 10Q567 -23 532 -24Q507 -24 495 -17Q466 -4 466 32Q466 96 500 225Q277 -17 102 -17Q56 -17 23 17T-10 118Q-10 164 13 234T64 363T115 481T139 567Q139 586 124 586",
          86: "25 608Q25 628 60 657T148 686Q184 683 213 671T273 625T327 538T363 394T380 184L381 134L399 148Q503 226 574 302T667 415T689 467Q688 474 684 482T672 502T645 521T600 532Q576 532 576 567Q576 604 597 644T641 685H649Q701 685 737 648T774 545Q774 457 703 333T461 66Q397 13 332 -32T255 -77Q237 -77 237 -30V-23Q241 20 241 109Q241 483 115 569Q91 586 50 589Q25 589 25 608",
          87: "25 607Q25 629 62 657T142 686Q205 686 248 647T312 541T339 411T347 275Q347 249 345 203V189Q375 219 449 316T587 516Q629 584 629 587Q629 589 626 597T622 607Q622 629 658 656T732 686H744Q755 680 757 678Q757 677 769 649T799 577T835 475T874 339T904 183Q908 157 910 151L925 169Q997 252 1059 343T1121 474Q1120 498 1103 513T1059 532Q1036 532 1036 568Q1036 600 1053 636T1090 683L1097 686H1109Q1147 684 1176 652T1206 551Q1206 460 1131 320T897 7Q859 -33 840 -52T816 -74T804 -77Q788 -77 784 -32Q783 -28 783 -26Q774 108 744 239T691 436T665 501Q664 501 649 475T602 400T528 289T420 146T280 -15Q243 -56 231 -66T210 -77Q191 -77 191 -40Q191 -38 195 -4T204 91T209 217Q209 290 202 351T177 469T126 557T45 589Q25 589 25 607",
          88: "762 562Q762 579 737 584T711 604Q711 630 753 658T834 686Q864 686 885 669T906 627Q906 580 834 522T614 379L584 362V357Q585 354 589 315T597 233T603 183Q610 132 627 116T671 100Q678 100 704 113T754 126T778 107Q776 79 733 45T626 2Q615 1 578 1Q542 1 535 3Q521 7 510 15T491 31T477 54T467 78T460 108T456 137T452 170T449 201Q447 220 445 240T442 270L441 281Q435 281 357 233Q240 165 206 135Q200 128 200 124Q200 113 208 108T226 101T244 96T252 82Q252 61 214 31T129 1H120Q97 1 77 16T56 60Q56 105 133 168T414 345Q428 352 431 354T433 359Q422 493 414 522Q407 551 395 566T373 583T350 586H341L332 580Q290 560 265 560Q243 560 243 577Q243 585 248 596T269 624T306 653T365 676T447 686H456Q472 686 484 683T514 671T543 637T562 576Q565 557 570 501L577 437Q577 436 613 457T694 506T756 551Q762 558 762 562",
          89: "73 555Q49 555 49 573Q49 602 110 644T239 686Q319 686 376 624Q416 584 444 511T483 361T499 240T503 173Q503 165 504 165Q506 165 524 184T556 218Q631 297 674 377T718 485Q718 505 699 526Q673 552 628 552Q619 552 613 562T607 590Q607 617 621 645T658 685Q661 686 671 686Q718 686 757 652T797 545Q797 476 749 369T602 146Q500 29 371 -67T176 -164Q112 -164 74 -120T36 -29Q36 5 55 36T95 67Q104 67 108 59T115 39T128 12T154 -12Q183 -30 216 -30Q239 -30 305 7L361 44L367 49V54Q367 95 364 143T351 273T312 429T243 546Q206 581 156 588L146 581Q108 555 73 555",
          90: "622 574Q522 579 420 579H396Q373 579 364 574T351 550Q339 516 297 490T218 462Q195 462 195 479Q195 487 197 492Q218 565 313 625T509 685Q564 685 650 683T755 680Q787 680 807 683T831 686Q853 686 853 669Q853 657 826 626Q742 532 641 437L619 415L622 414Q626 414 631 414T642 414Q697 411 697 388Q697 367 670 345T607 323Q605 323 592 325T546 329H522L490 302Q457 274 400 226T289 136L260 113L318 112Q345 111 452 109T587 106H627Q650 143 656 170Q666 197 710 225T788 253Q811 253 811 237Q811 211 781 160T710 77Q619 0 515 0Q507 0 497 0T484 1Q434 1 319 3T177 6Q123 6 95 2Q83 2 71 0H68Q46 0 46 17Q46 28 58 44Q68 56 100 80T210 165T383 307L408 329H361L314 330Q297 338 297 350Q297 368 320 388T368 413Q375 415 441 415H506L647 555L664 574H622",
          305: "24 296Q24 305 34 328T63 380T115 430T187 452Q205 452 223 448T262 435T295 406T308 360Q308 345 287 290T240 170T207 87Q202 67 202 57Q202 42 215 42Q235 42 257 64Q288 92 302 140Q307 156 310 159T330 162H336H347Q367 162 367 148Q367 140 357 117T329 65T276 14T201 -8Q158 -8 121 15T83 84Q83 104 133 229T184 358Q189 376 189 388Q189 402 177 402Q156 402 134 380Q103 352 89 304Q84 288 81 285T61 282H55H44Q24 282 24 296",
          567: "297 360T297 373T294 392T288 400T278 401H276Q237 398 200 363Q181 343 170 325T156 299T149 287T129 282H123H116Q102 282 97 284T92 298Q93 303 98 315T118 349T151 390T201 427T267 451H279Q357 451 388 422T420 354V339L370 138Q321 -60 317 -69Q287 -157 163 -194Q133 -201 99 -201Q39 -201 14 -178T-12 -125Q-12 -94 11 -69T68 -43Q93 -43 108 -57T123 -95Q123 -121 100 -151H104Q131 -151 155 -125T193 -60Q195 -54 244 141T294 345Q297 360 297 373"
        }, {});
      },
      5821: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texCalligraphic = void 0;
        var n = r(768),
          o = r(6384);
        e.texCalligraphic = (0, n.AddPaths)(o.texCalligraphic, {
          65: "576 668Q576 688 606 708T660 728Q676 728 675 712V571Q675 409 688 252Q696 122 720 57Q722 53 723 50T728 46T732 43T737 41T743 39L754 45Q788 61 803 61Q819 61 819 47Q818 43 814 35Q799 15 755 -7T675 -30Q659 -30 648 -25T630 -8T621 11T614 34Q603 77 599 106T594 146T591 160V163H460L329 164L316 145Q241 35 196 -7T119 -50T59 -24T30 43Q30 75 46 100T74 125Q81 125 83 120T88 104T96 84Q118 57 151 57Q189 57 277 182Q432 400 542 625L559 659H567Q574 659 575 660T576 668ZM584 249Q579 333 577 386T575 473T574 520V581L563 560Q497 426 412 290L372 228L370 224H371L383 228L393 232H586L584 249",
          66: "304 342Q292 342 292 353Q292 372 323 391Q331 396 417 428T533 487Q563 512 563 555V562Q563 575 557 589T530 618T475 636Q429 636 396 613T330 539Q263 446 210 238Q196 183 173 120Q135 31 121 16Q108 1 85 -10T47 -22T32 -10Q32 -5 44 18T77 93T112 206Q135 296 154 395T182 550T191 615Q191 616 190 616Q188 616 179 611T157 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 693Q295 686 288 635T278 575Q278 572 287 582Q336 635 402 669T540 704Q603 704 633 673T664 599Q664 559 638 523T580 462Q553 440 504 413L491 407L504 402Q566 381 596 338T627 244Q627 172 575 110T444 13T284 -22Q208 -22 158 28Q144 42 146 50Q150 67 178 85T230 103Q236 103 246 95T267 75T302 56T357 47Q436 47 486 93Q526 136 526 198V210Q526 228 518 249T491 292T436 330T350 345Q335 345 321 344T304 342",
          67: "201 -25Q167 -25 136 -14T75 23T29 94T12 202Q12 290 50 394T161 574Q227 642 303 673T433 704Q435 705 457 705Q533 701 533 640Q533 606 507 548T464 474Q431 444 396 444Q381 444 381 453Q381 459 388 473T407 513T428 563Q433 580 433 594Q433 636 381 636Q314 636 260 594T175 489T128 363T112 247Q112 157 153 101T273 44Q347 44 398 121Q413 144 437 157T481 171Q496 171 496 160Q496 150 476 123Q426 56 350 16T201 -25",
          68: "37 475Q19 475 19 487Q19 536 103 604T327 682H356Q386 683 408 683H419Q475 683 506 681T582 668T667 633Q766 571 766 450Q766 365 723 287T611 152T455 57T279 6Q248 1 160 0Q148 0 131 0T108 -1Q72 -1 72 11Q72 24 90 40T133 64L144 68L152 88Q247 328 272 587Q275 613 272 613Q272 613 269 613Q225 610 195 602T149 579T129 556T119 532Q118 530 116 525T113 518Q102 502 80 490T37 475ZM665 407Q665 596 412 613Q403 614 383 614Q370 614 370 612Q370 598 363 542T323 357T242 103L228 69H265Q391 73 481 119Q536 148 575 188T633 268T658 338T665 392V407",
          69: "144 470Q144 556 240 630T451 705Q564 705 564 637Q564 611 540 573Q529 559 505 547T464 534Q448 534 448 545Q448 552 455 562Q463 577 463 591Q463 600 462 604T456 616T436 627T400 635Q396 635 390 635T380 636Q291 636 258 568Q245 544 245 516Q245 463 290 438T391 410Q415 410 415 398Q415 392 407 380T376 356T326 341Q288 340 260 327Q218 311 187 276T143 208T130 151Q130 113 156 88T211 55T268 47Q349 47 403 125Q415 144 439 157T483 171Q499 171 499 160Q499 148 475 120T413 59T315 3T197 -22Q124 -22 77 14T30 105Q30 126 39 154T66 216T122 288T209 354L223 362Q144 400 144 470",
          70: "199 579Q181 579 181 590Q181 598 188 611T212 639T260 666T335 682Q336 682 349 682T383 682T431 682T493 683T561 683Q776 682 784 681Q826 673 829 647Q829 620 797 600T744 580Q728 580 728 595Q729 607 713 610Q698 613 598 614H500L499 610Q499 598 467 486T428 367Q428 365 551 365H674Q683 360 684 355Q687 346 677 329Q666 312 642 299T598 285Q586 285 582 296H402L394 277Q386 258 373 229T346 167T315 102T286 51Q265 22 225 -5T133 -32Q108 -32 87 -25T54 -7T33 15T21 35T18 47Q18 60 44 80T98 103Q108 103 111 101T119 88Q130 66 150 54T179 39T195 37Q199 37 203 43Q217 67 245 125T318 300T391 532Q393 543 398 564T406 598T409 613T339 614H269Q229 579 199 579",
          71: "216 68Q155 68 115 100T59 177T44 273Q44 299 50 333T73 421T133 533T239 632Q346 704 466 704Q508 704 515 703Q555 696 577 681T599 635Q599 605 570 560T523 496Q490 466 455 466Q440 466 440 475T469 526T499 589Q499 605 489 617Q460 636 403 636Q343 636 295 611T220 548T174 464T150 382T144 318Q144 241 180 189T287 137Q325 137 359 160Q428 205 466 322Q472 342 501 359T551 376Q557 376 560 373T564 368L565 365Q560 341 551 302T512 173T451 31Q359 -119 204 -119Q163 -118 127 -109T74 -91T53 -77Q52 -75 52 -71Q52 -54 79 -35T132 -14H140L151 -19Q210 -49 281 -49H289Q312 -49 329 -31Q351 -7 372 36T405 109T416 142L408 136Q401 131 392 125T369 111T338 96T303 82T261 72T216 68",
          72: "18 487Q18 496 29 517T67 566T127 621T216 665T330 683Q359 683 376 669T397 643T400 622Q400 584 382 488T348 343Q348 342 467 342H587L594 366Q615 440 648 534T690 641Q701 656 723 669T764 683Q783 683 783 672L750 578Q716 485 677 346T625 101Q624 92 623 82T622 65T621 56Q621 20 658 20Q666 20 701 25Q709 52 736 69T785 87Q803 87 803 75T791 44T754 3T685 -33T588 -48Q568 -48 562 -46Q522 -31 522 13V23Q531 129 562 250L569 281L565 280Q561 278 556 277T549 274L438 273H328L321 249Q307 202 275 107T232 0Q219 -16 196 -28T155 -41Q149 -41 145 -39T140 -34T139 -29Q139 -24 148 -3T181 86T233 247Q240 270 240 272Q240 273 194 273H169Q139 273 139 285Q139 295 153 308T187 332Q206 341 236 342L260 343L264 359Q278 414 289 482T300 578Q300 613 260 613H254Q198 613 169 592Q148 578 127 544T104 508Q72 478 37 475Q18 475 18 487",
          73: "174 0H31Q-13 0 -21 2T-30 12Q-30 23 -17 36Q9 60 42 68L155 70Q187 102 214 179T257 333T302 491T366 610L369 614H305Q221 611 188 607T145 596T128 569Q119 543 94 529T47 512Q28 512 28 524Q28 527 32 539Q56 614 159 654Q218 678 312 682Q314 682 339 682T404 682T481 683H632Q642 678 642 671Q642 657 621 641T577 617Q570 615 507 614H444Q427 592 406 542Q382 478 355 366T310 209Q280 123 238 78L230 69H330Q442 70 442 74Q443 74 443 77T447 87T460 105Q490 134 527 137Q545 137 545 125Q545 120 542 112Q531 78 491 49T399 7Q379 2 360 2T174 0",
          74: "148 78Q148 16 189 -17T286 -50Q319 -50 348 -33T396 10T426 59T444 101L471 204Q498 306 521 372Q575 532 649 605L659 614H591Q517 613 494 607Q433 591 400 550T360 477Q353 454 325 437T275 419Q256 419 260 435Q280 523 376 597T583 681Q603 683 713 683H830Q839 674 839 671Q839 654 810 634T754 614Q735 614 721 601Q688 571 654 495T600 351T561 209T541 132Q507 29 412 -45T213 -119Q141 -119 94 -77T47 33Q47 55 50 69T58 90T71 103Q105 131 135 131Q152 131 152 120Q152 119 151 114T149 99T148 78",
          75: "194 618Q193 618 182 613T156 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 691Q295 569 250 397Q225 306 197 217T151 81T128 25Q120 8 94 -7T47 -22Q32 -22 32 -10L64 76Q95 163 133 295T185 530Q198 611 194 618ZM331 429Q331 383 364 290T449 117T542 36Q574 36 607 51T652 103Q660 124 677 133T709 143Q727 143 727 128Q727 119 723 111Q704 56 639 17T497 -22H493Q463 -22 425 16Q401 40 382 71Q335 138 296 243T256 399Q256 434 288 473Q342 540 471 622T670 705Q691 704 703 696Q732 678 732 644Q732 613 714 600T677 586Q671 586 667 587T660 592T657 604V619Q657 647 629 647Q623 647 620 646Q576 635 495 583T365 482Q331 448 331 429",
          76: "62 -22T47 -22T32 -11Q32 -1 56 24T83 55Q113 96 138 172T180 320T234 473T323 609Q364 649 419 677T531 705Q559 705 578 696T604 671T615 645T618 623V611Q618 582 615 571T598 548Q581 531 558 520T518 509Q503 509 503 520Q503 523 505 536T507 560Q507 590 494 610T452 630Q423 630 410 617Q367 578 333 492T271 301T233 170Q211 123 204 112L198 103L224 102Q281 102 369 79T509 52H523Q535 64 544 87T579 128Q616 152 641 152Q656 152 656 142Q656 101 588 40T433 -22Q381 -22 289 1T156 28L141 29L131 20Q111 0 87 -11",
          77: "28 9Q28 37 43 63T73 90Q77 90 83 84T103 70T141 57H146Q162 57 178 79T222 167Q266 279 295 371T334 513T349 598T358 651T371 677Q397 705 432 705Q442 705 445 699T452 666Q453 661 453 659Q475 538 509 405T568 207L574 192Q581 178 587 164T594 150Q596 150 635 189T693 248Q765 324 863 438T1024 626T1089 701Q1093 705 1100 705Q1111 705 1111 682Q1111 675 1108 660T1099 611T1086 540Q1041 277 1041 144Q1041 98 1044 75T1050 48T1059 42Q1064 41 1075 46Q1102 61 1121 61Q1137 61 1137 50Q1137 28 1087 0T1000 -29Q983 -29 972 -23T955 -9T945 16T942 45T941 83V96Q941 158 952 256T974 422L985 489Q984 489 939 436T821 300T698 164Q665 128 620 85T568 37Q564 34 558 34Q550 34 546 37T535 54Q512 91 496 127T450 259T389 498L384 518Q349 367 294 223T198 15Q155 -50 117 -50Q87 -50 61 -35T30 -6Q28 2 28 9",
          78: "343 705Q358 705 358 698Q360 696 370 658T411 524T484 319Q536 174 590 82L595 73L615 152Q646 274 683 407Q729 571 752 637T799 727Q852 780 937 788Q939 788 947 788T958 789H962Q979 789 979 765Q979 722 951 692Q942 683 924 683Q888 681 859 672T818 654T803 639Q784 608 708 322T631 15Q631 14 630 15Q630 17 629 15Q628 14 628 12Q621 -4 601 -17T560 -31Q550 -31 546 -28T530 -7Q484 67 458 123T398 272Q352 392 314 514L306 535V534Q306 533 296 488T272 379T234 239T185 100T127 -7T61 -50Q34 -50 4 -34T-27 8Q-27 33 -12 61T18 90Q21 90 36 77T87 57H92Q109 57 123 78T162 173Q206 299 232 417T265 599T276 667Q284 681 304 693T343 705",
          79: "308 428Q289 428 289 438Q289 457 318 508T378 593Q417 638 475 671T599 705Q688 705 732 643T777 483Q777 380 733 285T620 123T464 18T293 -22Q188 -22 123 51T58 245Q58 327 87 403T159 533T249 626T333 685T388 705Q404 705 404 693Q404 674 363 649Q333 632 304 606T239 537T181 429T158 290Q158 179 214 114T364 48Q489 48 583 165T677 438Q677 473 670 505T648 568T601 617T528 636Q518 636 513 635Q486 629 460 600T419 544T392 490Q383 470 372 459Q341 430 308 428",
          80: "37 475Q19 475 19 487Q19 536 103 604T327 682Q329 682 344 682T380 682T421 683H463Q625 683 695 615Q718 591 726 564Q733 547 733 525Q733 412 607 312T321 205H312Q293 205 293 217Q293 224 302 236T333 260T385 274Q558 287 614 407Q633 445 633 477Q633 515 612 543T556 585T481 607T399 614H370L368 603Q352 463 312 312T242 82T202 -13Q190 -33 164 -45T121 -57Q108 -57 108 -45Q108 -40 120 -10T151 73T192 190T233 349T266 539Q267 546 269 565T272 598T274 613H270Q209 613 163 588Q131 572 113 518Q102 502 80 490T37 475",
          81: "114 286Q114 358 151 433T249 569T392 667T558 705Q653 705 713 641T774 460Q774 389 750 322T687 206T600 114T504 46T412 4L399 -2Q542 -62 636 -62Q660 -62 670 -54T686 -27T700 0Q734 34 770 34Q787 34 787 23Q787 -18 720 -74T563 -131Q485 -131 350 -83T145 -34Q127 -34 127 -22Q127 -12 144 5T190 31L200 34L237 35Q386 38 467 79Q550 120 612 210T675 416Q675 510 625 573T484 636Q410 636 346 587T248 469T214 333Q214 306 221 281T243 229T288 188T360 172Q403 172 441 188T490 205Q510 205 510 192Q505 162 432 132T287 102Q206 102 160 155T114 286",
          82: "37 475Q19 475 19 487Q19 503 35 530T83 589T180 647T327 682H374Q387 682 417 682T464 683Q519 683 559 679T642 663T708 625T731 557Q731 481 668 411T504 300Q506 296 512 286T528 257T553 202Q594 105 611 82Q635 47 665 47Q708 47 742 93Q758 113 786 128Q804 136 819 137Q837 137 837 125Q837 115 818 92T767 43T687 -2T589 -22Q549 -22 517 22T467 120T422 221T362 273Q346 273 346 287Q348 301 373 320T436 342Q437 342 446 343T462 345T481 348T504 353T527 362T553 375T577 393Q598 412 614 443T630 511Q630 545 613 566T541 600T393 614Q370 614 370 613L366 584Q349 446 311 307T243 96L213 25Q205 8 179 -7T132 -22Q125 -22 120 -18T117 -8Q117 -5 130 26T163 113T205 239T246 408T274 606V614Q273 614 259 613T231 609T198 602T163 588Q131 572 113 518Q102 502 80 490T37 475",
          83: "554 512Q536 512 536 522Q536 525 539 539T542 564Q542 588 528 604Q515 616 482 625T410 635Q374 635 349 624T312 594T295 561T290 532Q290 505 303 482T342 442T378 419T409 404Q435 391 451 383T494 357T535 323T562 282T574 231Q574 133 464 56T220 -22Q138 -22 78 21T18 123Q18 184 61 227T156 274Q178 274 178 263Q178 260 177 258Q172 247 164 239T151 227T136 218L127 213L124 202Q118 186 118 163Q120 124 165 86T292 48Q374 48 423 86T473 186V193Q473 267 347 327Q268 364 239 389Q191 431 191 486Q191 547 242 600T356 679T470 705Q472 705 478 705T489 704Q551 704 596 682T642 610Q642 566 621 545Q592 516 554 512",
          84: "49 475Q34 475 34 490Q34 552 106 611T261 681Q272 683 507 683H742Q790 717 816 717Q833 717 833 708Q833 682 795 653T714 615Q691 610 588 609Q490 609 490 607L483 580Q476 554 462 496T435 392Q410 289 395 231T363 116T335 34T309 -15T279 -47T242 -64Q231 -68 218 -68Q203 -68 203 -57Q203 -52 211 -38Q224 -7 234 20T251 66T268 123T283 179T304 261T328 360Q342 415 360 488Q380 567 384 582T397 605Q400 607 401 609H302H244Q200 609 188 607T167 596Q145 572 145 541Q145 520 109 498T49 475",
          85: "8 592Q8 616 70 649T193 683Q246 683 246 631Q246 587 205 492T124 297T83 143Q83 101 100 75T154 48Q202 48 287 135T450 342T560 553Q589 635 593 640Q603 656 626 668T669 683H670Q687 683 687 672T670 616T617 463T547 220Q525 137 521 68Q521 54 522 50T533 42L543 47Q573 61 588 61Q604 61 604 47Q599 16 506 -22Q486 -28 468 -28T436 -18T421 18Q421 92 468 258Q468 259 467 257T459 248Q426 206 391 167T303 81T194 6T83 -22Q66 -22 58 -20Q25 -11 4 19T-17 99Q-17 146 8 220T64 358T120 488T146 586Q146 604 141 608T123 613H120Q99 613 72 597T25 580Q8 580 8 592",
          86: "25 633Q25 647 47 665T100 683Q291 683 291 306Q291 264 288 213T282 132L279 102Q281 102 308 126T378 191T464 279T545 381T596 479Q600 490 600 502Q600 527 581 550T523 577Q505 577 505 601Q505 622 516 647T542 681Q546 683 558 683Q605 679 631 645T658 559Q658 423 487 215Q409 126 308 37T190 -52Q177 -52 177 -28Q177 -26 183 15T196 127T203 270Q203 356 192 421T165 523T126 583T83 613T41 620Q25 620 25 633",
          87: "25 633Q25 647 46 665T103 683Q168 683 207 632Q228 608 243 568Q269 485 269 374Q269 324 265 271T256 184L251 150L252 152Q254 153 257 157T264 167T274 180T286 197Q359 293 424 398T519 558T549 616Q549 618 547 624T545 638Q550 654 572 668T615 683Q626 683 632 672T657 595Q726 370 741 128L742 110Q752 122 767 142T823 217T894 321T950 424T976 511Q976 544 958 560T918 577Q906 577 906 602Q906 629 918 651T942 681Q948 683 954 683Q983 683 1008 658T1034 569T999 421T915 257T813 109T724 -3T681 -49Q666 -59 660 -45Q659 -41 657 35T639 233T591 477Q573 551 570 551Q569 551 554 523T507 439T433 315T323 155T182 -25Q160 -52 151 -53Q137 -53 137 -30Q137 -29 148 25T170 168T181 338Q181 424 168 483T131 571T87 609T40 620Q25 620 25 633",
          88: "324 614Q291 576 250 573Q231 573 231 584Q231 589 232 592Q235 601 244 614T271 643T324 671T400 683H403Q462 683 481 610Q485 594 490 545T498 454L501 413Q504 413 551 442T648 509T705 561Q707 565 707 578Q707 610 682 614Q667 614 667 626Q667 641 695 662T755 683Q765 683 775 680T796 662T807 623Q807 596 792 572T713 499T530 376L505 361V356Q508 346 511 278T524 148T557 75Q569 69 580 69Q585 69 593 77Q624 108 660 110Q667 110 670 110T676 106T678 94Q668 59 624 30T510 0Q487 0 471 9T445 32T430 71T422 117T417 173Q416 183 416 188Q413 214 411 244T407 286T405 299Q403 299 344 263T223 182T154 122Q152 118 152 105Q152 69 180 69Q183 69 187 66T191 60L192 58V56Q192 41 163 21T105 0Q94 0 84 3T63 21T52 60Q52 77 56 90T85 131T155 191Q197 223 259 263T362 327T402 352L391 489Q391 492 390 505T387 526T384 547T379 568T372 586T361 602T348 611Q346 612 341 613T333 614H324",
          89: "65 599Q65 618 107 650T204 683Q267 683 312 643T380 533T414 385T424 217Q424 186 423 160T422 123Q426 123 468 170T567 304T650 469Q661 503 661 519Q661 546 639 570Q615 591 583 591Q569 591 569 616Q569 640 582 661T613 683Q624 683 638 679T671 664T702 625T714 558Q714 472 639 329T426 45Q361 -21 282 -82T154 -143Q97 -143 64 -104T31 -20Q31 4 44 25T70 46Q78 46 81 39T87 16T97 -9Q127 -51 182 -51Q184 -51 187 -50H190Q233 -41 314 25Q330 36 330 40Q336 79 336 178Q336 508 223 594Q199 614 158 619L148 620L139 611Q111 586 83 586Q65 586 65 599",
          90: "694 220Q708 220 708 210Q708 195 695 167T658 105T593 42T502 3Q492 1 458 1Q400 1 293 11T150 22Q116 22 92 11T51 0Q37 0 37 10Q37 21 63 44T179 146T367 319L391 343H343L296 344Q285 350 285 358Q285 365 289 372T300 383T313 392T324 398L329 400H450L561 518Q597 558 607 571L621 587H596Q553 589 484 599T383 609Q342 609 326 596T301 555Q294 533 263 514T208 492Q189 492 189 503Q189 510 197 528T215 559Q249 607 318 645T466 683Q504 683 573 673T669 662L690 661Q734 682 748 683Q767 683 767 673Q767 666 746 640Q655 531 555 428L529 400Q529 399 543 399Q604 397 604 366Q604 350 587 337T551 322Q541 322 539 323Q529 328 529 334Q529 339 487 342L470 343L446 320Q272 153 200 96L235 95Q297 95 392 86T533 74H554Q586 116 597 159Q604 179 635 199T694 220"
        }, {});
      },
      957: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texMathit = void 0;
        var n = r(768),
          o = r(6041);
        e.texMathit = (0, n.AddPaths)(o.texMathit, {
          65: "85 46Q112 48 132 56T161 73T176 92T185 104Q185 106 353 407T524 709Q527 716 551 716Q568 716 572 712Q573 711 574 710Q576 708 594 384Q613 54 617 52H618Q626 46 672 46H689Q696 41 696 36Q696 13 683 0H670Q639 2 557 2Q526 2 500 2T459 2T441 1Q425 1 425 10Q425 12 427 24Q428 27 429 31T430 36T432 40T434 43T437 45T443 46T450 46Q514 46 514 69Q514 74 511 136L506 209H292L260 152Q222 84 222 74Q222 48 264 46Q280 46 280 35Q280 33 278 21Q275 7 272 4T259 0Q256 0 232 1T159 2Q135 2 109 1T78 0Q58 0 58 10Q58 14 61 26T66 40Q68 46 85 46ZM504 260Q503 263 496 407T486 553L466 520Q446 486 402 406L318 256Q318 255 411 255H504V260",
          66: "57 11Q57 38 69 45L74 46Q78 46 85 46T99 46Q134 47 145 50T162 62Q164 66 233 344T303 626Q303 627 302 629V631Q296 637 241 637H223Q217 642 217 645T219 664Q223 677 229 683H411L593 682L605 680Q616 678 628 675T660 662T694 639T720 601T732 547Q732 519 726 503Q710 452 662 414T556 360L545 357L556 355Q604 346 641 312T678 221Q678 155 622 92T482 8Q459 2 439 2T256 0H154H105Q74 0 66 2T57 11ZM629 549Q628 550 629 557T627 576T619 600T601 622T570 636Q564 637 490 637Q472 637 454 637T424 636T411 636Q399 635 395 622T364 500Q333 377 332 376Q332 374 408 374L485 375L495 377Q547 390 588 437T629 549ZM504 336Q500 337 410 337Q323 337 322 336Q322 334 305 263T270 122T252 51Q252 47 337 46Q346 46 361 46T384 45Q425 45 455 55T515 95Q574 156 574 235Q574 276 555 304T504 336",
          67: "395 -21Q279 -21 215 56T150 244Q150 402 265 543Q339 630 421 667T562 704Q596 704 604 703Q627 698 647 689T679 669T699 649T711 633T716 627L753 665Q790 704 792 704Q793 705 798 705Q812 705 812 698Q812 694 780 561Q744 422 744 421Q742 416 739 415T721 413H705Q699 419 699 426Q701 432 701 444Q705 464 705 493Q705 524 700 551T681 604T643 644T583 659Q480 659 387 570Q321 502 287 397T252 213Q252 123 297 74Q347 24 421 24Q500 24 564 89T653 240Q656 253 659 255T677 257Q700 257 700 248Q700 242 694 222Q681 183 656 143T593 65T504 3T395 -21",
          68: "56 11Q56 38 68 45L72 46Q77 46 84 46T98 46Q133 47 144 50T161 62Q163 66 232 344T302 626Q302 627 302 629L301 631Q295 637 240 637H222Q216 642 216 645T218 664Q222 677 228 683H403Q582 683 589 682Q672 674 723 608T775 440Q775 312 709 209T562 54Q502 14 432 2Q423 1 243 0H148H102Q72 0 64 2T56 11ZM254 51Q254 46 348 46Q395 46 422 50T484 71Q585 121 633 255Q679 396 679 477Q679 522 665 554T629 603T587 626T548 636Q547 636 536 636T510 636T480 637Q420 637 411 636T398 627Q396 623 325 339T254 51",
          69: "248 634Q216 634 214 638Q213 641 213 646Q213 674 224 678Q226 680 481 680H736Q743 676 743 669Q743 665 729 557T713 447Q711 440 690 440H675Q667 445 667 454Q667 455 671 481T675 536Q675 583 658 604T592 632Q574 634 475 634Q439 634 424 633T405 631T399 625Q397 622 367 501T336 377Q336 376 367 376H388Q451 376 477 389Q493 399 503 419T520 462T528 489Q531 493 549 493Q557 493 561 492T566 491T569 488T572 483L539 351Q507 221 503 216Q503 216 500 213H484Q468 213 465 216Q461 219 461 225Q461 228 466 250T472 290Q472 317 452 323T368 330H324Q323 326 289 191T255 51T331 46H360Q413 46 444 49T511 67T570 113Q589 137 608 175T638 242T652 272Q656 274 670 274Q693 274 693 262L648 148Q590 4 588 2Q585 0 323 0H61Q54 4 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62L194 200Q229 337 264 477T299 623Q299 630 292 631T248 634",
          70: "299 623Q299 630 292 631T247 634H219Q213 640 213 642T215 661Q218 673 225 680H724Q731 676 731 669Q731 665 717 557T701 447Q699 440 678 440H663Q656 444 656 452Q656 457 659 485T663 538Q663 586 644 607T566 633Q564 633 535 633T486 634H458Q404 634 399 625Q396 620 364 492L332 363H380Q446 365 464 373Q496 389 514 458Q518 477 523 479Q527 480 541 480H556Q563 475 563 470Q563 467 532 339T498 207Q496 200 475 200H460Q453 207 453 212Q454 213 456 225T461 254T464 278Q464 304 445 310T369 317H321L289 190Q257 66 257 59Q257 54 261 52T283 48T337 46Q348 46 352 46T360 45T366 42T368 37Q368 32 365 23Q360 4 355 2Q352 1 342 1Q336 1 297 1T199 2Q138 2 106 2T71 1H68Q54 1 54 11Q54 38 66 45L70 46Q75 46 82 46T96 46Q131 47 142 50T159 62L194 200Q229 337 264 477T299 623",
          71: "632 -1Q629 -1 622 5T604 25T583 53Q508 -22 394 -22Q287 -22 219 52T150 244Q150 402 265 543Q339 630 421 667T562 704Q596 704 604 703Q627 698 647 689T679 669T699 649T711 633T716 627L753 665Q790 704 792 704Q793 705 798 705Q812 705 812 698Q812 694 780 561Q744 422 744 421Q742 416 739 415T721 413H705Q699 419 699 426Q701 432 701 444Q705 464 705 493Q705 524 700 551T681 604T643 644T583 659Q480 659 387 570Q319 501 286 394T252 208Q252 156 269 118T314 61T369 33T425 24Q470 24 509 46T566 104Q571 116 583 162T595 214Q595 222 583 223Q561 227 517 227H495Q488 230 488 238Q488 254 495 268Q500 273 511 273Q515 273 532 273T581 272T649 271Q731 271 752 273H761Q767 267 767 264T765 246Q761 233 755 227H742Q698 227 693 213L639 4Q636 -1 632 -1",
          72: "61 0Q54 7 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q480 681 486 683H496Q502 677 502 674T500 656Q496 643 490 637H472Q418 637 406 630Q400 627 396 612T367 500Q360 474 352 442T340 395L336 380Q336 378 466 378H596Q657 622 657 626Q657 627 656 629V631Q650 637 595 637H577Q571 642 571 645T573 664Q577 677 583 683H596Q664 681 729 681Q837 681 843 683H853Q860 676 860 672Q858 647 848 637H819Q783 636 772 634T756 623Q753 618 684 340T614 57Q614 50 621 49T666 46Q697 46 699 40Q701 37 698 21Q693 3 689 1Q686 0 677 0Q673 0 657 0T611 1T546 2Q453 2 428 0H418Q411 7 411 11Q411 27 418 41Q422 46 452 46Q488 47 499 50T516 62Q517 64 550 196T584 331Q584 332 454 332H324L291 197Q257 64 257 56Q257 50 265 49T309 46Q340 46 342 40Q344 37 341 21Q336 3 332 1Q329 0 320 0Q316 0 300 0T254 1T189 2Q96 2 71 0H61",
          73: "235 637Q217 637 213 638T209 649Q209 673 220 682Q222 683 237 683Q278 681 369 681Q404 681 441 682T483 683Q499 683 503 681T508 672Q508 670 505 658T500 643Q498 637 464 637Q425 635 415 633T398 621Q396 618 327 340T257 58T260 52T278 48T322 46Q349 46 349 36Q349 31 346 22Q342 4 337 1Q336 1 334 1T329 0Q325 0 307 0T258 1T190 2Q95 2 67 0H56Q49 7 49 11Q51 38 62 46H91Q129 47 141 50T159 62Q161 66 230 344T300 625Q300 637 235 637",
          74: "361 637Q333 637 331 641Q330 644 330 649Q330 673 341 682Q343 683 360 683Q405 681 500 681Q551 681 577 681T607 682Q622 682 622 673Q622 665 616 647Q614 640 610 639T587 637Q547 636 541 624Q538 618 477 374T413 124Q391 64 333 22T207 -21T109 12T78 86Q78 130 101 150T149 170Q193 170 196 129Q196 100 178 80T137 58L132 57Q134 52 138 46T160 28T205 16Q242 16 273 48T319 122Q322 129 383 371T444 627Q444 637 361 637",
          75: "668 621Q668 635 645 637Q629 637 629 648Q629 650 632 662T637 677Q640 682 653 682Q657 682 688 681T764 680Q786 680 810 681T839 682Q859 682 859 672Q859 655 852 643Q849 637 839 637Q804 637 768 621T717 595T697 578Q696 578 600 497L505 417L508 408Q543 311 574 227T618 106T632 69Q645 47 688 46H707Q713 38 713 37T710 19Q706 6 700 0H688Q659 2 587 2Q557 2 532 2T492 2T474 1Q458 1 458 10Q458 13 460 23Q464 39 466 42T480 46Q526 46 526 72Q526 75 476 213L427 350Q426 350 396 325T334 272T302 242Q302 241 299 230T290 194T279 150Q257 61 257 55Q257 50 265 49T309 46H337Q343 40 343 38T341 19Q337 6 331 0H316Q280 2 190 2Q158 2 131 2T89 2T70 1Q54 1 54 11Q54 38 66 45L70 46Q75 46 82 46T96 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q386 681 414 681T464 682L487 683H496Q502 677 502 674T500 656Q495 641 491 637H462Q426 636 415 634T399 623Q396 618 358 467L320 314Q321 314 484 452Q510 474 552 509Q625 570 646 590T668 621",
          76: "61 0Q54 4 54 11Q54 27 61 41Q65 46 95 46Q131 47 142 50T159 62Q161 66 230 344T300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H240Q275 681 371 681Q407 681 438 681T487 682T509 682Q527 682 527 674Q527 670 524 659Q523 657 523 654T522 649T520 645T519 642T517 640T515 639T512 638T507 637T502 637T494 637H478Q433 636 417 633T396 617Q395 614 325 334T255 51Q255 47 319 47Q387 47 410 52Q459 65 494 98T543 163T570 229T589 273H622Q628 264 628 262Q628 259 584 133T539 5Q537 1 511 1Q482 0 296 0H61",
          77: "72 1Q58 1 58 11Q58 33 66 41Q68 46 87 46Q150 50 168 84Q172 91 238 356T304 626Q304 627 304 629L303 631Q297 637 242 637H224Q218 642 218 645T220 664Q224 677 230 683H326H394Q417 683 422 682T429 676L480 127L502 163Q523 199 560 262T642 400Q801 668 805 676L817 683H1003Q1010 678 1010 672Q1010 650 997 637H979Q915 637 906 623Q903 618 834 340T764 57Q764 50 771 49T817 46H845Q851 38 851 37T848 19Q845 7 838 0H824Q789 2 701 2Q670 2 644 2T603 2T584 1Q569 1 569 11Q569 13 571 25Q576 42 581 45L586 46Q590 46 597 46T611 46Q646 47 657 50T674 62L813 616L634 313Q453 7 452 7Q446 0 428 0Q409 0 407 6Q405 10 379 304T351 604L285 348Q220 83 220 82Q220 65 233 57T279 46H295Q301 38 301 37T298 19Q295 7 288 0H275Q244 2 171 2Q145 2 123 2T88 2T72 1",
          78: "633 637Q624 637 621 639T617 650Q617 670 630 683H641Q682 680 736 680Q836 680 845 683H853Q860 676 860 672Q858 647 848 637H832Q764 633 750 598Q746 590 673 300Q656 230 638 156T610 44L600 7Q598 0 576 0H559Q553 6 448 297L342 588Q341 588 279 336T216 81Q216 49 274 46Q293 46 295 40Q297 37 294 21Q293 19 292 16T291 11T290 7T289 4T287 2T284 1T280 1T275 0T263 0T229 1T167 2Q91 2 70 0H61Q54 7 54 11T57 27Q61 41 64 43T83 46Q146 50 164 84Q167 90 235 362L303 634Q300 635 253 637H220Q214 643 214 645T216 664Q220 677 226 683H314Q386 683 397 683T410 677Q412 675 501 428L591 179Q591 178 592 180T595 189T600 209T610 246T624 303T645 385Q698 595 698 606Q698 618 683 627T633 637",
          79: "149 237Q149 326 186 413T282 563T412 665T552 704Q619 704 667 678T741 611T777 528T788 444Q788 328 728 219T572 44T377 -22Q275 -22 212 50T149 237ZM688 487Q688 570 650 617T548 665Q467 665 398 592T291 413T253 203Q253 119 290 70T387 20Q440 20 489 52T573 135T635 249T675 373T688 487",
          80: "62 0Q55 7 55 11Q55 27 62 41Q66 46 96 46Q132 47 143 50T160 62Q162 66 231 344T301 626Q301 627 300 629V631Q294 637 239 637H221Q215 642 215 645T217 664Q221 677 227 683H404H431H502Q578 683 615 675T684 636Q729 595 729 531Q729 462 671 396T524 308Q499 302 404 301H318L288 182Q258 63 258 55T310 46Q341 46 343 40Q345 37 342 21Q337 3 333 1Q330 0 321 0Q317 0 301 0T255 1T190 2Q97 2 72 0H62ZM626 555V562Q626 620 552 635Q546 636 481 637Q466 637 450 637T423 636T412 636Q401 635 398 627Q396 622 361 484Q353 452 344 416T330 362L325 344Q325 342 390 342H427Q523 342 567 386Q596 415 611 473T626 555",
          81: "460 -107Q460 -72 464 -42T468 -7L457 -10Q446 -14 424 -18T379 -22Q276 -22 213 50T149 237Q149 326 186 413T282 563T412 665T552 704Q664 704 726 631T788 442Q788 305 703 180Q627 64 517 13L506 8Q506 7 508 -12T513 -38T522 -59T538 -79T565 -85Q604 -85 634 -59T672 0Q676 11 684 11Q693 11 695 2Q695 -1 690 -20T673 -69T644 -126T599 -174T538 -194Q464 -194 460 -110Q460 -108 460 -107ZM689 481Q689 578 646 621T551 665Q468 665 391 586Q321 512 285 399T249 202Q249 106 295 58Q310 41 314 41Q315 41 315 46Q315 83 344 118T420 154Q450 154 473 135Q493 114 500 69L502 58L512 65Q571 110 613 192T672 348T689 481ZM472 49Q472 118 415 118Q393 118 373 98T353 51Q353 18 386 18H387Q424 18 472 40V49",
          82: "62 0Q55 7 55 11Q55 27 62 41Q66 46 96 46Q132 47 143 50T160 62Q162 66 231 344T301 626Q301 627 300 629V631Q294 637 239 637H221Q215 642 215 645T217 664Q221 677 227 683H386Q554 682 569 679Q571 678 580 676Q643 662 680 623T717 533Q717 473 667 420T528 337L538 330Q563 314 578 286T594 228Q594 212 588 147T581 65Q581 36 589 26T616 16H618Q637 16 652 37Q668 57 677 94Q679 105 701 105T723 95Q723 89 717 72T698 33T662 -5T610 -22Q555 -22 513 3T471 88Q471 107 486 168T502 244Q502 303 452 320Q445 322 382 323H320L288 192Q255 63 255 55T307 46Q338 46 340 40Q342 37 339 21Q335 3 330 1Q326 0 320 0Q317 0 306 0T265 1T190 2Q99 2 73 0H62ZM612 558Q612 566 612 568T610 581T603 597T590 611T567 625T532 635Q526 636 470 637Q458 637 445 637T422 636T412 636Q402 635 397 627L390 598Q383 570 373 532T354 455T337 389T330 361Q356 360 384 360H415Q483 360 527 382Q557 399 574 424T604 498Q612 533 612 558",
          83: "198 460Q198 551 269 628T432 705Q516 705 557 644L583 673Q589 679 593 684T600 693T605 698T609 702T611 704T614 705T618 705H620Q633 705 633 698T605 577T573 459L570 456H554Q546 456 543 456T536 457T532 460T531 466Q531 469 533 489T536 532Q536 573 525 600T496 640T462 657T427 662Q369 662 325 612T281 503Q281 475 290 458T318 430T356 415T407 401T463 383Q506 360 522 323T538 258V244Q538 141 465 60T300 -22Q198 -22 152 41L143 31Q137 25 126 12T106 -10T95 -21L92 -22Q88 -22 86 -22Q81 -22 78 -20T74 -16V-14Q74 -11 132 221Q134 227 155 227H171Q177 221 177 215Q177 212 175 205T171 182T169 147Q171 99 195 70T246 33T306 25Q358 25 400 70T453 169Q455 180 455 203V210Q455 263 414 285Q409 288 347 305Q271 328 254 339Q239 350 224 371Q198 409 198 460",
          84: "178 437Q173 442 171 446Q171 451 238 654Q243 670 250 677H681H762Q792 677 799 676T806 667Q806 661 788 553T768 444Q768 437 746 437Q727 437 723 445Q723 450 729 492T736 562Q736 589 728 602T693 624Q675 630 622 630H595Q575 630 571 629T564 623Q562 621 492 342T422 59Q422 48 502 46H542Q548 38 548 37T545 19Q541 6 535 0H517Q475 2 357 2Q315 2 279 2T223 2T198 1Q179 1 179 9Q179 14 182 24Q187 42 190 44Q194 46 206 46H232Q289 47 301 49T326 65L395 344Q465 619 465 626Q465 629 462 629Q456 631 411 631Q364 631 336 625T288 597T255 549T224 467Q215 442 210 437H178",
          85: "636 637Q627 637 624 639T620 650Q620 670 633 683H644Q702 681 753 681Q760 681 772 681T796 681T820 682T838 683H845H853Q860 676 860 672Q858 647 848 637H832Q764 633 750 598Q745 588 698 400T648 204Q627 140 584 86Q484 -22 378 -22Q300 -22 247 31T194 167Q194 176 194 182T196 198T200 218T207 248T217 288T231 346T250 422Q300 618 300 626Q300 627 300 629L299 631Q293 637 238 637H220Q214 642 214 645T216 664Q220 677 226 683H239Q307 681 372 681Q480 681 486 683H496Q502 677 502 674T500 656Q496 643 490 637H472Q418 637 406 630Q400 627 394 603T344 410Q299 232 292 198T284 135Q284 102 294 78T322 44T355 29T387 24Q455 24 515 74T604 211Q605 215 653 404T701 607Q701 618 686 627T636 637",
          86: "667 637Q657 637 654 639T650 650Q650 670 663 683H675Q704 681 772 681Q793 681 818 682T847 683Q868 683 868 672Q868 670 865 658T860 643Q857 637 848 637Q785 637 749 587L394 -15Q387 -22 366 -22Q346 -22 342 -16Q341 -13 313 303Q285 622 285 623Q283 631 273 634T229 637Q205 637 205 648Q205 654 208 666T217 682Q219 683 230 683Q276 680 329 680Q444 680 456 683H466Q472 677 472 674T470 656Q466 643 460 637H448Q384 637 384 615Q385 612 406 371T427 126Q427 125 495 240T632 473T704 596Q707 604 707 609Q707 633 667 637",
          87: "234 637H226Q205 637 205 648Q205 673 216 682Q218 683 231 683Q265 681 340 681Q371 681 404 682T443 683Q458 683 462 681T467 672Q467 670 464 658T459 643Q457 637 434 637Q407 636 394 632T378 623T376 613Q376 589 385 377T394 149L511 361Q542 419 596 519L613 551L612 585Q610 621 610 624Q608 637 559 637H555Q537 637 537 647Q537 654 540 664Q544 677 550 683H561Q600 680 656 680Q771 680 783 683H792Q798 677 798 675T796 658Q792 643 790 640T778 637H774Q721 637 708 620L717 385Q726 150 727 149Q727 148 752 193T812 303T882 433T942 546T969 596Q970 600 970 606Q970 610 969 613T966 620T961 625T955 628T949 631T941 633T934 634T927 636T920 637Q903 637 903 648Q903 650 905 664Q909 677 915 683H928Q960 681 1031 681Q1050 681 1073 681T1101 682Q1124 682 1124 672Q1124 655 1117 643Q1114 637 1104 637Q1085 637 1069 632T1043 618T1026 603T1014 588L1009 580L687 -16Q681 -22 660 -22Q643 -22 637 -16Q635 -14 627 223Q617 441 617 464L602 441Q578 397 487 228Q456 171 423 110T372 17T355 -15Q348 -22 328 -22Q312 -22 308 -20T303 -9Q303 -5 291 310T277 627Q273 636 234 637",
          88: "684 0Q670 0 634 1T569 2Q512 2 482 2T449 1Q433 1 433 10Q433 11 435 25Q437 34 438 37T442 43T448 45T459 46T476 49Q506 58 506 64Q506 65 467 179T426 295L382 244Q339 194 295 142T249 86Q245 79 245 72Q245 48 279 46Q293 46 293 32Q293 13 280 0H268Q206 2 151 2Q70 2 64 0Q50 0 50 11Q50 15 53 27Q57 41 60 43T78 46Q154 49 205 100Q207 103 312 225L411 341L407 353Q404 360 381 428T336 560T310 627Q301 636 255 637H229Q223 643 223 645T225 664Q229 677 235 683H246Q288 680 346 680Q462 680 477 683H487Q493 677 493 674T491 656Q488 644 485 641T471 637Q461 635 454 635Q419 626 421 619Q421 617 453 524T486 430T554 509T624 593Q631 604 631 611Q631 622 621 629T598 637Q583 637 583 648Q583 650 585 660Q589 676 591 679T602 683Q606 683 637 682T715 680Q742 680 771 681T804 682Q825 682 825 672Q825 650 817 642Q814 637 797 637Q739 634 700 608Q684 597 659 569T505 389L501 384L557 222Q612 61 616 57Q625 47 671 46Q691 46 697 45T704 36Q704 35 702 23Q701 19 700 14T699 7T696 3T692 1T684 0",
          89: "232 637Q198 637 198 647Q198 651 201 664T210 682Q212 683 223 683Q269 680 325 680Q443 680 455 683H465Q472 676 472 672Q472 656 465 642Q460 637 441 637Q395 634 395 623Q395 621 438 478T482 334T583 460T688 591Q688 593 694 601T700 617Q700 637 668 637H666Q655 637 655 648Q655 654 658 664Q660 672 660 673T663 678T668 682T677 683Q680 683 704 682T776 680Q801 680 828 681T858 682Q875 682 875 673Q875 669 872 657T867 643Q865 637 848 637Q788 634 749 597Q733 581 608 424L487 273L461 170Q454 145 448 118T438 76T434 60Q434 54 436 52T452 48T496 46H514Q520 41 520 38T518 19Q514 6 508 0H495Q427 2 364 2Q350 2 323 2T272 0H250H241Q234 7 234 11Q234 27 241 41Q245 46 275 46Q312 47 323 50T340 64Q340 65 344 79T355 120T368 171L393 274L341 448Q288 622 286 626Q278 636 232 637",
          90: "203 452Q203 455 236 565T270 677Q270 681 274 681Q276 683 488 683H699Q704 678 704 675Q704 663 697 649Q697 647 449 348L201 50L266 49H301Q442 49 495 116Q525 155 556 251Q563 274 565 278T579 282H585Q609 285 609 271Q609 270 570 142T528 8T518 1T466 0H303Q253 0 197 0T131 -1Q112 -1 102 -1T87 1T81 3T80 8Q80 30 89 39Q90 41 204 178T446 470T575 626L584 637H512H504H475Q446 637 426 635T378 624T330 597T289 546T254 467Q247 446 243 444Q239 442 226 442Q203 442 203 452",
          97: "418 53Q418 26 438 26Q466 26 494 131Q500 151 504 152Q507 153 516 153H521Q531 153 534 153T540 150T543 144Q543 141 540 126T529 88T509 43T477 5T434 -11Q404 -11 383 3T354 30T347 48H346Q345 47 342 45T337 40Q282 -11 228 -11Q172 -11 137 34T101 146Q101 260 177 351T333 442Q343 442 352 441T369 437T382 431T393 425T402 417T409 410T414 402T419 396Q423 406 436 414T461 422Q475 422 484 413T494 395Q494 384 459 244T420 88Q418 80 418 58V53ZM397 323Q397 344 382 374T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100V94Q184 54 207 35Q218 26 235 26Q279 26 330 91Q343 109 346 118T372 217Q397 317 397 323",
          98: "158 683Q163 683 223 688T300 694Q312 694 312 685T279 544Q243 405 243 403L256 412Q268 422 292 432T338 442Q395 442 431 398T467 284Q467 175 393 82T229 -11Q175 -11 142 32T108 142Q108 176 115 207T166 412Q177 458 190 510T209 588T216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683ZM178 109Q178 27 234 27Q247 27 254 29Q295 44 323 94Q343 129 363 208T384 332Q384 354 382 361Q369 405 332 405Q282 405 228 326L222 317L205 250Q178 142 178 109",
          99: "257 -10Q183 -10 143 37T103 155Q103 257 173 341T337 440Q341 441 348 441H358Q421 441 445 415T469 356Q469 320 450 305T410 289Q392 289 381 299T370 325Q370 362 404 378L414 383Q392 402 365 405Q322 405 285 375T227 294Q217 271 202 213T187 119Q187 27 263 27Q299 27 330 40Q361 51 386 71T424 106T440 121Q444 121 455 110T466 96Q466 92 458 81T432 54T390 24T331 0T257 -10",
          100: "418 54Q418 26 438 26Q466 26 494 131Q500 151 504 152Q507 153 516 153H521H526Q543 153 543 144Q543 143 541 129Q531 91 521 65T487 14T434 -11T383 3T354 30T347 48H346Q345 47 342 45T337 40Q282 -11 228 -11Q172 -11 137 34T101 146Q101 255 174 348T337 441Q354 441 368 437T390 427T404 414T413 404T417 400L471 616Q471 629 464 632T425 637H404Q398 643 398 645T400 664Q405 683 413 683Q418 683 478 688T555 694Q567 694 567 686Q567 676 495 389L419 86Q418 80 418 61V54ZM397 323Q397 329 394 340T385 367T365 394T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100Q184 71 191 56Q204 26 235 26Q267 26 300 57T344 112Q347 117 372 217T397 323",
          101: "107 166Q107 230 131 283T193 369T270 420T345 441Q346 441 352 441T361 442H364Q409 442 439 418T470 355Q470 270 366 239Q308 223 218 223H205Q189 164 189 125Q189 83 206 55T261 27Q309 27 353 50T426 109Q436 121 440 121T453 111T466 97Q469 92 455 77Q424 41 372 16T258 -10Q184 -10 146 41T107 166ZM416 333T416 354T401 390T360 405Q322 405 292 384T246 336T223 288T215 261Q215 260 240 260Q262 261 276 262T314 266T353 275T384 291T408 317",
          102: "351 608Q351 642 389 661Q368 668 365 668Q358 668 352 664Q349 663 347 661T342 654T337 647T333 637T330 627T327 614T324 601T321 587T318 571L291 432Q291 431 343 431H394Q400 426 400 423T398 404Q394 390 389 386L335 385H282L255 246Q212 20 189 -51Q136 -199 58 -204Q22 -204 0 -185T-23 -134Q-23 -100 -3 -85T37 -69Q54 -69 65 -80T76 -108Q76 -115 75 -119Q70 -134 61 -144T46 -158L39 -161Q39 -162 42 -163T50 -166T61 -168Q77 -168 91 -145Q98 -128 105 -95L125 -1Q145 90 146 98Q149 109 163 180T189 317T202 384T158 385H114Q108 390 108 393T110 412Q113 424 120 431H165Q211 431 211 433Q213 435 219 473T237 561T266 639Q282 667 310 686T367 705Q402 705 426 686T450 635Q450 600 430 585T390 569Q373 569 362 580T351 608",
          103: "103 163Q106 263 173 347T320 441Q322 441 329 441T341 442Q387 439 419 398Q420 399 420 400Q421 402 425 406T440 416T464 422Q476 421 485 413T494 396Q494 386 465 268T407 38T377 -77Q365 -123 310 -164T179 -205Q46 -205 46 -139Q46 -114 64 -97T106 -79Q127 -79 136 -91T146 -115Q146 -127 141 -138T130 -155T124 -162T125 -163Q133 -166 170 -168Q200 -168 217 -162Q242 -153 264 -130T297 -78Q298 -74 305 -46T320 10T327 38Q326 38 317 31T291 15T256 2Q249 1 231 1Q182 1 143 38T103 163ZM398 324Q398 330 395 346T375 383T332 405Q330 405 326 405T320 404Q291 396 263 365Q230 324 208 239T185 115Q185 38 238 38Q258 38 279 50T312 77T336 106L348 122Q349 125 373 223T398 324",
          104: "398 44Q398 26 414 26Q431 26 451 43Q477 71 496 136Q499 148 501 150T515 153H521Q531 153 534 153T541 150T544 143Q544 133 534 105T496 41T432 -8Q424 -10 408 -10Q370 -10 348 12T326 72Q326 93 342 135Q397 288 397 349Q397 367 396 372Q386 405 357 405Q283 405 228 310Q217 290 212 274T180 152Q153 42 148 26T135 3Q121 -11 102 -11Q89 -11 80 -3T69 19L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683Q163 683 223 688T300 694Q312 694 312 685Q312 674 277 539Q241 395 241 393Q242 394 249 399T259 407T271 415T285 424T300 431T318 437T338 440T362 442Q423 442 449 410T475 338Q475 290 437 178T398 44",
          105: "234 599Q234 620 251 638T292 656Q306 656 319 647T332 617Q332 594 313 577T273 560Q260 560 247 569T234 599ZM75 287Q75 292 82 313T103 362T142 413T196 441H214Q248 441 270 419T293 357Q292 338 289 330T245 208Q193 72 193 46Q193 26 209 26Q228 26 247 43Q273 71 292 136Q295 148 297 150T311 153H317Q327 153 330 153T337 150T340 143Q340 133 330 105T292 41T228 -8Q220 -10 204 -10Q160 -10 141 15T122 71Q122 98 171 227T221 384Q221 396 218 400T203 405Q175 403 156 374T128 312T116 279Q115 278 97 278H81Q75 284 75 287",
          106: "266 600Q266 622 283 639T322 656Q340 656 352 645T364 616Q364 596 347 578T305 560Q291 560 279 569T266 600ZM75 287Q75 293 86 316T117 369T168 420T236 442Q282 442 304 415T327 358V332L278 134Q269 98 260 60T246 3T236 -36T227 -66T220 -85T213 -101T204 -114Q181 -150 139 -177T46 -204Q8 -204 -12 -186T-32 -140Q-32 -112 -14 -96T27 -79Q48 -79 57 -91T67 -114Q67 -146 38 -166Q42 -168 49 -168Q75 -168 98 -147T130 -108T146 -71Q150 -59 199 138T250 346Q253 359 253 373Q253 405 230 405Q206 405 184 386T149 345T126 301L117 280Q115 278 98 278H81Q75 284 75 287",
          107: "158 683Q163 683 223 688T300 694Q312 694 312 686Q312 679 262 478L211 273Q212 272 219 276T248 299T296 349Q317 371 328 382T360 410T399 434T439 442Q462 442 480 427T498 373Q498 329 479 313T437 296Q420 296 409 305T398 331Q398 357 413 372T445 391Q454 392 448 399Q445 405 431 405Q408 405 377 385Q351 368 314 327T250 261Q243 257 243 254Q249 254 279 243T328 220Q366 192 366 146Q366 131 361 109T355 62V54Q355 26 376 26Q379 26 387 28Q420 36 443 130Q449 151 454 152Q457 153 465 153H470Q484 153 488 152T492 144Q492 141 489 126T476 88T454 42T420 5T372 -11Q331 -11 306 17T280 88Q280 100 283 119T287 146Q287 172 265 190T221 215T198 220Q197 220 173 121Q152 37 148 24T135 3Q121 -11 102 -11Q89 -11 80 -3T69 19L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683",
          108: "162 61Q162 26 183 26Q211 26 239 131Q245 151 249 152Q252 153 261 153H266H271Q288 153 288 144Q288 143 286 129Q276 91 266 65T232 14T179 -11Q144 -11 116 12T87 81Q87 96 88 102L216 616Q216 629 209 632T170 637H149Q143 643 143 645T145 664Q150 683 158 683Q163 683 223 688T300 694Q312 694 312 686Q312 676 240 389L164 86Q162 74 162 61",
          109: "81 278Q75 284 75 289Q77 299 89 338Q101 373 114 396T142 428T166 439T186 442H189Q225 440 251 417Q266 401 271 384L275 374L286 386Q342 442 414 442Q428 442 440 440T461 435T479 427T493 418T503 407T511 397T516 387T520 378T523 370L524 366Q546 395 583 418T667 442Q729 442 755 411T782 338Q782 290 743 178T704 45Q704 26 720 26Q773 26 802 136Q805 148 807 150T822 153H828Q838 153 841 153T848 150T851 143Q851 137 843 115T821 63T778 12T715 -10Q671 -10 652 16T632 71Q632 88 668 191T704 349Q704 367 703 372Q693 405 664 405Q637 405 613 393T571 360T547 329T534 309Q523 290 518 274T487 151Q455 24 452 16Q438 -11 408 -11T376 18Q376 26 411 167T447 314Q449 325 449 346Q449 372 444 384Q431 405 408 405Q334 405 276 305Q266 289 262 273T231 151Q199 24 196 16Q182 -11 152 -11T120 18Q120 26 159 182T200 347Q202 361 202 372Q202 405 181 405Q168 405 159 391Q145 374 132 328T117 280T98 278H81",
          110: "449 44Q449 26 465 26Q482 26 502 43Q528 71 547 136Q550 148 552 150T566 153H572Q582 153 585 153T592 150T595 143Q595 133 585 105T547 41T483 -8Q475 -10 459 -10Q421 -10 399 12T377 72Q377 93 393 135Q448 288 448 349Q448 367 447 372Q437 405 408 405Q381 405 357 393T315 360T291 329T278 309Q267 290 262 274T231 151Q199 24 196 16Q182 -11 152 -11T120 18Q120 23 159 181Q199 343 199 346Q202 360 202 372Q202 406 183 406Q163 406 148 374Q142 360 135 338T124 299T117 280T98 278H81Q75 284 75 287Q76 293 78 303T90 341T110 388T141 425T184 442Q195 442 204 441T221 436T235 429T247 421T256 412T262 403T267 394T271 387T273 381L274 378V374L287 387Q342 442 414 442Q474 442 500 410T526 338Q526 290 488 178T449 44",
          111: "103 155Q103 266 185 354T366 442Q435 442 476 394T517 275Q517 169 436 79T255 -11Q194 -11 149 32T103 155ZM187 119Q187 67 209 47T260 26Q290 26 321 47Q354 68 380 113T426 260Q432 291 432 315Q432 361 408 385Q388 405 358 405Q319 405 283 374T227 294Q217 271 202 213T187 119",
          112: "81 278Q75 284 75 287Q93 379 131 417Q154 442 189 442Q222 440 243 423T272 382L280 390Q335 442 389 442Q446 442 482 398T518 284Q518 212 480 137T375 19Q321 -10 291 -10H282H278Q237 -10 204 28L202 32L181 -51Q160 -135 160 -139Q160 -147 205 -148H230Q236 -155 236 -157T233 -175Q230 -187 227 -190T214 -194Q211 -194 202 -194T169 -193T108 -192Q40 -192 21 -194H13Q6 -187 6 -183T9 -167Q13 -153 16 -151T39 -148Q73 -147 78 -136Q82 -128 139 104Q199 337 199 347Q202 362 202 372Q202 406 182 406Q169 406 159 391Q145 374 132 328T117 280T98 278H81ZM221 111Q234 26 286 26Q307 26 336 47T385 116Q398 147 416 217T435 332Q435 354 433 361Q420 405 383 405Q333 405 279 326L273 317L221 111",
          113: "228 -11Q172 -11 137 33T101 147Q101 205 125 266T201 377T318 441Q322 442 333 442Q388 442 420 394L429 403Q439 413 455 423T481 437T494 442Q498 442 501 439T504 434Q504 425 435 149Q364 -135 364 -139Q364 -147 409 -148H434Q440 -155 440 -157T437 -175Q433 -191 429 -193Q425 -194 418 -194Q416 -194 406 -194T372 -193T309 -192Q259 -192 233 -192T204 -193Q190 -193 190 -184Q190 -181 192 -169Q196 -153 199 -151T219 -148Q266 -148 277 -141Q283 -137 305 -51L325 29L316 22Q270 -11 228 -11ZM397 323Q397 329 394 340T385 367T365 394T333 405Q302 405 271 372Q249 349 235 316T203 215Q184 135 184 108V100Q184 71 191 56Q204 26 235 26Q267 26 300 57T344 112Q347 117 372 217T397 323",
          114: "81 278Q75 284 75 289Q77 301 89 339Q122 442 183 442Q219 442 241 425T271 384L283 396Q327 442 384 442Q424 442 454 421T484 362Q484 327 464 312T424 296Q407 296 396 305T385 331Q385 352 394 365T414 384T424 390Q409 405 378 405Q322 405 276 315L268 300L234 161Q200 25 196 16Q182 -11 152 -11T120 18Q120 23 159 181Q199 343 199 346Q202 360 202 372Q202 405 182 405Q164 405 150 377T128 316T117 280Q115 278 98 278H81",
          115: "153 285Q153 349 197 395T311 442Q355 442 386 420T418 356Q418 321 401 308T365 294Q336 294 331 326Q331 336 334 345T343 359T353 368T362 374L366 376Q365 379 362 383T344 396T308 404Q265 404 246 377T226 325T244 289T287 275T339 258T383 212Q395 188 395 163Q395 132 379 95T333 32Q279 -11 207 -11Q154 -11 115 13T76 86Q76 108 83 123T102 145T121 153T135 156Q154 156 164 145T175 117Q175 82 142 66L132 62Q131 62 131 61Q131 57 139 49T166 34T210 26Q250 26 277 44T312 83T321 123Q321 153 301 166T248 185T204 198Q176 211 162 241Q153 258 153 285",
          116: "94 385Q87 392 87 395Q87 399 90 411T95 425Q97 430 103 430T149 431H196L215 511Q218 521 222 539T228 565T234 585T242 603T251 615T264 623T281 626Q311 626 315 597Q315 591 296 513T275 433Q275 431 320 431H366Q373 424 373 420Q373 398 360 385H263L189 86Q188 80 188 61V54Q188 29 201 27Q213 23 229 30Q253 37 276 66T316 138Q321 149 324 151T342 153H347Q364 153 364 146T360 130Q331 63 290 26T202 -11Q158 -11 135 18T111 81Q111 93 129 168T166 314L184 383Q184 385 139 385H94",
          117: "75 287Q75 299 89 333T135 404T205 441Q246 441 269 420T293 357Q292 338 259 245T225 95Q225 26 274 26Q301 26 324 43T358 77T369 99Q369 102 406 249T446 404Q460 431 490 431T522 402Q522 394 485 245T446 89Q443 74 443 56Q443 28 461 26Q487 26 507 86Q524 130 524 146Q524 147 530 153H547Q570 153 570 144Q570 138 561 109T544 62Q530 29 512 12Q492 -11 454 -11Q429 -9 410 2T385 23T376 41L363 28Q350 16 325 3T269 -10Q204 -10 176 25T148 108Q148 161 184 262T221 383Q221 405 206 405Q178 405 158 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287",
          118: "387 386Q387 407 406 425T445 443Q466 443 479 423T492 371Q492 330 473 253Q411 18 307 -8Q298 -10 279 -10Q208 -10 179 26T149 114Q149 162 185 261T221 384Q221 405 206 405Q177 405 157 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287T79 304T93 342T119 388T158 425T210 441H218Q243 441 268 421T293 357Q292 337 259 245T226 102Q226 26 285 26Q328 26 360 72T422 237Q429 265 429 290Q428 324 408 349T387 386",
          119: "591 386Q591 407 610 425T649 443Q670 443 683 423T696 371Q696 327 672 232T621 85Q575 -11 493 -11Q469 -11 449 -6T418 8T398 24T386 38L382 43Q347 -10 293 -10H286Q221 -10 186 21T150 115Q150 164 185 262T221 384Q221 405 206 405Q177 405 157 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287T79 304T93 342T119 388T158 425T210 441H218Q243 441 268 421T293 357Q292 336 260 246T227 108Q227 26 292 26H295Q332 26 361 93L366 103V119Q366 122 367 133T369 150Q372 167 401 282T433 404Q446 431 477 431Q507 431 509 402Q509 396 500 358T474 254T446 140Q444 126 444 104V92Q444 66 459 46T502 26H505Q527 28 545 43T577 88T602 149T623 226Q633 265 633 290Q632 324 612 349T591 386",
          120: "275 356Q275 383 262 394T233 405Q196 405 166 371T121 289Q119 280 116 279T98 278H81Q77 282 76 283T75 288T78 300Q88 332 109 363T153 411Q195 442 235 442Q306 442 333 386Q373 442 427 442Q461 442 487 421T513 364T494 312T453 296Q436 296 425 305T414 331Q414 352 424 366T446 386L456 390Q448 404 421 404H418Q382 404 358 341Q355 332 328 227T298 105Q295 90 295 75Q295 26 339 26Q365 26 388 43T424 82T444 123T451 146L457 153H474Q490 153 493 152T496 144Q496 133 486 110T456 58T404 10T333 -11Q276 -11 237 45Q197 -11 146 -11Q108 -11 83 10T58 67Q58 99 76 117T119 135Q136 135 147 124T158 96Q158 89 157 85Q149 57 125 45L115 41Q125 26 151 26Q171 26 187 45T214 93Q217 102 244 210T273 330Q275 339 275 356",
          121: "75 287Q75 299 89 333T135 404T205 441Q246 441 269 420T293 357Q292 338 259 245T225 95Q225 26 274 26Q325 26 367 93L405 245Q442 393 446 404Q460 431 490 431T522 402Q522 400 416 -24Q389 -102 327 -153T196 -205Q152 -205 122 -181T91 -119Q91 -84 110 -67T152 -49Q170 -49 180 -60T191 -87Q191 -108 174 -128Q167 -134 157 -138T146 -144Q155 -153 159 -156T173 -163T199 -167Q229 -167 255 -149T297 -105T325 -52T342 -6T347 15Q315 -10 269 -10Q204 -10 176 25T148 108Q148 161 184 262T221 383Q221 405 206 405Q178 405 158 375T128 313T116 279Q115 278 97 278H81Q75 284 75 287",
          122: "160 317Q158 317 155 317Q136 317 136 324Q136 351 171 396T260 442Q292 442 321 410T365 375H369Q384 375 404 408L425 441Q427 442 444 442H460Q466 436 466 434Q466 419 426 367Q387 314 294 222T178 105L170 95L181 94Q198 93 236 81T295 68Q328 68 356 89T395 141Q398 150 401 151T419 153Q441 153 441 144Q441 110 394 50T282 -11Q251 -11 221 23T171 57Q157 57 143 47T121 26T104 3T95 -10Q93 -11 76 -11H60Q54 -5 54 -2Q54 3 61 14Q103 88 233 215Q349 329 349 338L302 351Q269 362 247 362Q227 362 212 356T192 342T183 327T178 320Q175 317 160 317"
        }, {});
      },
      1044: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyleBold = void 0;
        var n = r(768),
          o = r(8199);
        e.texOldstyleBold = (0, n.AddPaths)(o.texOldstyleBold, {
          48: "259 460H279Q352 460 403 444T491 378Q528 320 528 219Q528 100 475 45Q417 -17 287 -17Q152 -17 99 44T46 219Q46 246 47 265T57 318T82 376T131 422T210 454Q234 460 259 460ZM389 229V271Q389 351 371 380T280 409Q232 409 208 385Q194 371 190 345T185 229V210Q185 108 194 83Q208 35 287 35Q317 35 336 42Q372 55 380 85T389 204V229",
          49: "119 417Q191 417 240 428T310 450T338 461Q353 461 357 452T361 400Q361 389 361 342T360 254V62H420H456Q483 62 488 58T494 35V29Q494 13 491 7T473 0Q468 0 424 1T295 2T167 1T117 0Q114 0 111 0T107 1Q96 8 96 27V35Q96 54 102 58T140 62H170H229V213Q229 363 228 363Q220 360 196 358T150 356L130 355H93Q84 360 82 365T80 386Q80 404 81 407T95 417H119",
          50: "214 399Q202 399 191 398T175 395T170 392L171 390Q172 389 174 386T178 379T181 369T182 355Q182 328 165 312T123 296Q99 296 82 312T64 356Q64 397 105 428T253 460Q301 460 337 456T411 441T476 403T514 338Q516 328 516 310V304Q516 257 470 227Q456 217 427 205T376 184L354 176Q350 174 325 162T277 139L254 128Q414 129 428 130H439Q450 148 453 166T460 188T486 193H493Q515 193 517 178Q517 171 502 94T484 11Q481 3 472 2T410 0H269Q65 0 62 2Q55 5 53 10T51 32Q51 54 56 58Q60 62 173 131Q296 207 318 224Q368 264 368 308Q368 342 342 363T283 392T214 399",
          51: "80 309Q80 367 131 414T276 461Q388 461 441 417T494 313Q494 265 463 223T373 155L361 151L376 147Q436 132 480 92T525 -15T487 -127T393 -192T274 -211Q179 -211 114 -167T48 -53Q48 -18 69 5T128 29Q168 29 188 5T208 -50Q208 -59 207 -67T203 -81T197 -92T190 -101T183 -109T177 -114T170 -118L167 -121Q160 -125 164 -127Q167 -129 176 -133Q215 -152 268 -152H273Q337 -152 356 -92Q364 -69 364 -14Q364 45 352 74T303 120Q287 125 240 125H230Q201 125 196 127T191 146V152Q192 170 196 173T233 178Q234 178 241 178T252 179T262 181T274 183T285 188T297 195T308 205T319 218T328 235T337 257Q345 280 345 320V330Q345 345 343 355T335 379T312 399T270 407Q226 407 177 377Q226 356 226 310Q226 270 204 253T153 235Q123 235 102 253T80 309",
          52: "180 0Q155 0 124 0T84 -1Q48 -1 40 3T32 27V37Q32 59 34 63T204 265T377 465Q380 468 383 468H387Q391 468 398 468T411 469Q432 469 438 468T449 459Q451 455 451 258V62H489H498Q531 62 536 58T542 31Q542 9 537 5T504 0H489H451V-132H489H498Q530 -132 536 -136T542 -163Q542 -181 538 -187T522 -194Q518 -194 483 -193T378 -192Q281 -192 256 -193L217 -194Q203 -189 203 -169V-163V-158Q203 -140 209 -136T246 -132H265H314V0H180ZM325 62V320L105 63L215 62H325",
          53: "131 29Q159 26 175 12T194 -13T197 -35V-41Q197 -58 195 -66Q191 -76 185 -84T173 -97T161 -105T152 -109L148 -110Q148 -112 158 -121T195 -141T252 -152Q274 -152 280 -151Q335 -137 349 -104T363 9Q363 85 356 114T322 157Q305 166 286 166Q251 166 223 154T182 131T162 109Q154 98 150 96T130 93Q107 93 102 104Q100 107 100 279V371V424Q100 461 110 461Q114 461 123 458T149 450T183 441Q234 429 286 429Q313 429 340 432T387 440T422 449T447 457T458 461Q472 461 472 435Q472 420 470 418Q464 405 438 379T352 325T226 297Q189 297 171 301H168V182Q169 182 174 185T190 194T213 205T248 213T292 217Q391 217 454 159T517 5Q517 -92 444 -151T255 -211Q167 -211 112 -160T57 -44Q57 -12 76 8T131 29",
          54: "48 316Q48 398 70 462T124 562T198 621T274 652T339 660Q377 660 384 659Q497 632 497 532Q497 507 482 487T431 466Q397 466 381 486T365 530Q365 569 405 593Q382 603 381 603Q361 607 350 607Q316 607 279 589T221 533Q199 489 196 385L195 370Q196 371 203 379T217 395T237 410T263 424Q283 431 313 431Q409 431 468 368Q526 310 526 208Q526 131 492 81T405 5Q359 -17 289 -17Q256 -17 227 -11T163 17T105 73T65 170T48 316ZM293 380Q244 380 220 331T196 212Q196 104 216 80Q240 41 292 41Q295 41 301 41T309 42Q338 46 355 62Q372 81 375 108T379 230Q378 314 372 333Q358 375 299 380H293",
          55: "95 210H88Q66 210 64 225Q64 229 82 345T102 465Q106 476 125 476H131Q162 476 162 458Q162 451 213 448Q221 448 238 447T260 446Q261 446 410 444Q436 444 468 444T509 445Q544 445 551 440T558 413V404Q558 395 547 380T478 301L392 202Q354 150 339 81T321 -104V-132Q321 -187 286 -203Q273 -211 255 -211Q236 -211 217 -199T190 -160Q189 -153 189 -130Q194 17 282 156Q309 200 370 270Q404 307 400 307H293Q151 306 146 303Q140 300 132 259T120 215Q115 210 95 210",
          56: "48 164Q48 199 59 228T92 277T128 307T163 329Q159 332 155 336Q135 346 110 382Q80 427 80 477Q80 564 147 620Q202 660 264 660Q266 660 275 660T290 661Q384 661 439 619T494 506Q494 486 489 468T477 437T459 413T440 395T421 380T406 370L410 368Q414 365 421 361T437 351T456 335T476 316T495 291T511 262T522 228T526 189Q526 93 460 38T282 -17Q242 -17 205 -9T130 19T71 75T48 164ZM406 506Q406 545 379 576T283 607Q218 606 193 585T168 536Q168 522 172 513T195 490T224 471T275 443L346 403Q406 446 406 506ZM291 42Q365 42 395 70T425 134V141Q425 170 401 190T319 242Q308 248 302 251Q286 260 266 271T235 288L225 294Q222 292 217 289T198 274T175 249T157 212T148 163Q148 116 179 79T291 42",
          57: "175 -140Q198 -152 236 -152Q294 -152 332 -116Q356 -91 366 -54T379 62V78L376 74Q372 70 366 64T352 50T333 35T308 23Q289 17 262 17Q168 17 108 77T48 235Q48 273 59 317Q81 381 141 421T276 461Q279 461 285 461T295 460Q326 460 354 454T415 426T471 371T510 277T526 136Q526 42 501 -28T432 -136T341 -192T240 -210Q199 -210 169 -201T121 -178T94 -146T80 -112T77 -82Q77 -51 95 -33T143 -15Q170 -15 189 -33T209 -81Q209 -116 175 -140ZM377 244V274Q377 300 376 316T368 352T348 384T312 405Q307 406 283 406Q257 406 238 396T213 376T205 361Q196 341 196 259V233V181Q196 122 211 96T278 69H298Q330 82 345 104Q367 134 376 190Q377 200 377 244",
          65: "761 751Q784 751 784 728V711Q784 570 795 417T820 191Q844 76 865 76Q868 76 902 93T962 112H973Q989 104 989 94Q989 92 987 86Q978 47 846 -11Q812 -25 779 -26Q722 -26 708 9Q688 47 669 161H524L379 162L359 136Q286 43 234 -3T142 -49T71 -19T39 55Q39 92 60 131T103 174Q113 174 117 167T124 149T136 128T166 110Q183 105 190 105Q230 105 341 246Q401 322 453 397T531 514T582 601T611 651H640V663Q640 692 676 718T745 750Q747 750 752 750T761 751ZM658 266Q653 312 649 377T644 489T641 541V556L557 415Q500 325 448 253Q467 261 524 261H568H658V266",
          66: "441 83Q571 83 571 195Q571 246 538 279T466 322T386 333Q378 333 357 330T329 327Q307 327 307 345Q307 354 313 365T347 396T419 430Q546 472 581 498Q594 508 594 535Q594 574 567 589T508 604Q469 604 442 583Q390 546 342 457T265 256Q237 148 186 60Q167 29 144 13Q105 -15 68 -17H65Q40 -17 40 1Q40 7 53 29T87 100T124 210Q162 373 190 575Q188 575 174 567T138 550T98 542Q75 542 75 560Q75 588 123 618Q135 625 203 659T281 696Q299 703 316 703Q339 703 339 685Q339 656 328 583L333 588Q338 592 346 599T367 615T394 634T428 654T467 674T511 690T559 701T611 705Q651 704 681 689Q739 659 739 598Q739 507 595 427L584 421Q585 420 595 416T610 410T626 402T644 392T660 380T677 365T691 347T703 325T710 299T715 268Q717 193 665 130Q622 73 531 28T348 -17Q275 -17 225 10Q206 19 200 24T193 36Q193 57 231 86T311 119H322Q386 83 441 83",
          67: "243 -20Q135 -20 78 48T20 218Q20 280 39 344T98 470T193 580T324 661T488 702H490Q491 702 493 702T498 703T507 703T518 702H526Q599 702 599 631Q599 597 577 550T541 486Q523 463 490 447T431 430Q423 430 419 433Q409 437 409 450Q410 456 432 499T454 567Q454 586 446 594T415 603Q316 603 254 532Q216 487 190 421T164 284Q164 228 181 186T226 122T282 90T340 80Q377 80 405 96T449 131T492 167T553 187H555Q580 187 580 168Q580 153 551 123T476 60T367 4T243 -20",
          68: "107 0Q92 5 92 18Q92 33 113 53T160 86Q170 91 182 94T197 100L206 120Q248 226 273 337T304 501T309 585Q278 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q281 686 447 686H480H517Q692 686 784 631Q885 571 885 450Q885 339 805 239T586 75T286 1Q276 0 187 0H107ZM741 391Q741 424 731 452T694 510T613 558T481 584Q476 584 468 584T457 585L449 586V579Q441 501 425 424T391 292T357 193T330 125T319 100H324Q511 100 628 175Q688 215 714 275T741 391",
          69: "495 516Q485 516 478 520T470 532Q470 537 476 550T482 570Q482 589 465 596T401 603Q344 603 319 582Q295 558 295 519Q295 493 312 474T355 445T407 432T455 427Q477 427 477 409Q477 395 453 371T389 333Q380 330 345 327T279 312T223 272Q181 223 181 176Q181 131 225 107T324 83Q366 83 395 98T448 136T487 167Q517 185 547 187H551Q574 187 574 170Q574 151 535 113T421 36T271 -15Q260 -16 226 -16Q181 -16 152 -9Q104 4 71 33T37 111Q37 140 50 176T106 263T216 356Q215 357 207 362T190 374T172 392T156 419T150 456Q150 521 208 580T341 670T474 702Q475 703 499 703Q528 703 547 701T586 693T615 673T627 637Q627 584 581 550T495 516",
          70: "812 567Q804 567 795 570T786 579Q786 586 647 586H559L558 582Q558 575 539 510T506 407L498 384H775Q788 378 790 368Q790 328 746 298T665 268Q646 268 642 284H457L447 261Q396 150 360 94Q329 46 270 8T149 -30Q123 -30 100 -24T63 -10T37 9T22 26T17 36Q17 59 56 88T135 119Q145 119 149 117T165 104Q187 78 227 72Q232 72 234 76Q245 93 273 145T350 323T424 570L428 586H276Q265 575 239 563T190 551Q180 551 174 556T167 569Q167 580 179 597T213 634T278 668T371 685Q374 686 624 686Q863 685 888 682Q917 678 927 663Q930 658 930 650Q930 624 888 596T812 567",
          71: "50 279Q50 361 88 438T190 570T335 661T503 702H514Q524 703 532 703Q671 703 671 626Q671 580 614 514T495 447Q472 447 472 465Q472 477 499 511T527 562Q527 582 507 592T433 602Q351 602 302 569Q252 535 223 469T194 344Q194 266 237 217T352 168Q401 168 442 205T505 316Q515 345 551 368T622 393H625Q649 393 649 376Q649 371 635 318T612 237Q580 129 540 62T442 -49Q353 -114 264 -114Q259 -114 252 -114L246 -113Q190 -113 142 -107T81 -96Q71 -90 71 -81Q71 -57 110 -30T187 2Q196 2 236 -4T338 -14Q371 -14 377 -9Q410 24 446 113L451 127Q353 68 253 68Q157 68 104 129T50 279",
          72: "42 447Q20 447 20 465Q20 481 47 515T119 589T239 657T392 686Q443 686 463 664T484 616Q484 570 473 506T452 401L441 360Q441 359 550 359H660L663 370Q684 435 716 522T758 624Q771 646 806 666T870 686Q894 686 894 668Q894 667 867 597T804 416T752 218Q737 135 737 93Q737 77 746 65T778 53Q799 53 803 54T814 63Q831 86 864 103T924 120Q946 120 946 100Q945 85 931 63T888 16T806 -27T684 -48H681Q625 -48 603 -10Q593 4 593 29Q593 71 603 131T624 230L634 269Q632 269 624 266Q610 261 600 261T507 259H411L399 222Q344 62 322 21Q301 -7 268 -24T209 -41H207Q187 -41 185 -25Q185 -17 192 2T220 71T261 184Q284 256 284 258Q284 259 227 259H170Q169 259 166 261T162 264T158 266T156 271T155 277Q155 296 184 320T250 356Q259 358 286 359Q312 359 312 360Q314 372 318 385Q332 450 339 526Q339 530 339 535T340 543Q340 586 296 586Q255 586 227 576T188 553T165 523T146 497Q127 476 97 462T42 447",
          73: "56 499Q32 499 32 516Q32 540 64 580T165 649Q241 682 365 685Q366 685 376 685T405 685T445 686T496 686T553 686H732Q746 677 746 668Q746 646 711 620T642 587L572 586H503Q479 546 458 479T424 352T383 224T318 111L309 101L412 100H514L523 109Q567 150 618 153Q644 153 644 135Q644 132 642 124Q629 86 581 52T476 6Q454 2 433 2T216 0Q-11 0 -15 2Q-27 6 -27 18Q-27 37 2 61T59 93Q77 100 142 100H198Q255 177 299 369Q337 513 382 574L391 586H348Q261 586 176 576Q163 543 124 521T56 499",
          74: "286 390Q263 390 263 407Q263 432 293 481T367 566Q511 687 724 687Q738 687 761 687T793 686H923Q937 677 937 668Q937 648 905 623T842 589Q829 587 817 586T802 585T795 583T788 578Q709 506 632 189Q622 153 615 134T588 81T537 17Q482 -39 404 -76T247 -114Q192 -114 158 -100Q53 -61 53 32Q53 59 58 73T79 102Q126 147 177 147Q200 147 200 128Q200 123 198 112T196 96Q196 47 238 17T345 -13Q362 -13 377 -9T404 0T426 16T444 34T459 55T470 76T478 97T483 116T488 132L490 141Q511 222 520 257T554 364T608 486T675 576L685 586H634H612Q532 586 484 564Q453 549 436 526T409 478T395 447Q378 424 345 407T286 390",
          75: "98 542Q75 542 75 560Q75 588 123 618Q132 624 199 657T275 694Q291 703 315 703Q327 703 332 699T338 690T339 670Q339 596 323 505T283 337T237 194T198 90L181 53Q170 31 136 8T68 -17H65Q40 -17 40 0L76 92Q112 185 150 322T194 564V578L168 565Q125 542 98 542ZM834 142Q834 125 819 100T774 48T692 3T576 -16H560Q540 -16 508 6Q469 33 422 108T342 267T309 398Q309 411 310 417T320 442T347 482Q401 542 517 615T710 702Q712 702 721 702T735 703Q772 703 791 690Q819 674 819 646T792 597T733 574H722Q704 584 704 599Q706 607 700 610T672 617L660 613Q609 595 524 538T423 450V440Q423 376 488 247T604 83Q621 70 640 70Q677 70 701 82Q713 87 718 101T737 132T783 160Q792 163 807 163Q834 163 834 142",
          76: "63 -17Q41 -17 41 0Q41 22 85 54Q101 68 113 92T133 141T154 219T182 315Q230 462 306 553Q345 599 391 632T478 678T543 697T582 703Q584 703 589 703T598 702Q643 702 666 676T689 613Q689 588 683 575Q674 551 632 524T552 496Q530 496 530 512Q530 517 531 525T533 538Q533 559 522 577T480 596H476Q462 596 451 588T415 544Q350 447 310 281Q284 181 261 136L255 124H285Q342 123 441 107T583 90L596 89Q603 116 647 144T729 173Q751 173 751 157Q751 118 685 60T523 -15Q514 -16 479 -16Q421 -16 320 0T171 18H155L142 10Q98 -17 63 -17",
          77: "38 20Q38 59 60 99T104 139Q106 139 126 125T176 106H181Q200 106 221 139T286 281Q322 370 342 451T368 581T376 634Q384 657 420 680T487 703Q502 703 507 696T522 649Q538 589 554 537Q579 453 609 372T660 248T686 202Q687 201 739 244T830 322L1166 642Q1225 700 1230 701Q1230 701 1237 703Q1258 703 1258 667L1253 637Q1248 607 1241 558T1227 451T1214 326T1209 202Q1209 77 1232 77Q1237 77 1269 94T1326 112H1329Q1353 112 1353 94Q1353 81 1334 60Q1311 37 1248 7T1150 -24H1141H1135Q1085 -24 1074 26Q1064 75 1064 134Q1064 239 1086 426Q1087 430 1087 434L1061 410Q871 227 783 149L694 76Q653 44 647 40T631 34Q620 34 616 37T594 63Q546 125 514 198Q467 307 423 449L418 466L412 444Q376 310 306 153Q278 88 251 45T201 -18T163 -43T131 -49Q102 -48 70 -31T38 20",
          78: "47 139Q81 105 122 105Q137 105 147 117Q159 134 182 199T234 381T274 610Q275 634 284 647Q297 666 327 684T389 703Q403 703 408 695T428 645Q480 490 567 298Q628 163 673 103Q674 102 674 102T675 106Q732 331 803 551Q842 674 875 725Q908 775 966 807T1081 840H1084Q1105 840 1105 803Q1105 768 1088 733T1051 689Q1045 686 1032 686Q986 683 948 663T901 624Q881 579 837 430T760 154L726 28Q725 28 725 28T723 25Q716 0 682 -24T611 -48Q600 -48 595 -45T576 -23Q522 44 480 124Q417 243 332 463L328 473L325 457Q291 293 227 124Q159 -49 72 -49Q38 -49 5 -28Q-24 -8 -24 21Q-24 58 -3 98T41 139H47",
          79: "433 703Q456 703 456 685Q456 672 441 655T407 627Q402 623 378 611T328 579T276 524Q207 434 207 324Q207 222 270 153T441 84Q566 84 651 177T737 400V405Q737 496 693 549T576 603Q542 603 510 560Q490 537 472 502T442 454Q397 412 346 409Q320 409 320 427Q320 430 322 436Q331 465 360 507T433 594T542 671T677 703Q776 703 829 636T882 468Q882 369 831 277T702 122T528 21T343 -17Q214 -17 139 61T63 257Q63 336 94 409T173 534T272 625T367 684T432 703H433",
          80: "170 -67Q147 -67 147 -49Q147 -42 162 -8T204 99T253 254Q274 332 288 415T305 542L308 585Q277 585 234 577T179 557Q172 550 166 532T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H495H537Q622 686 678 677T784 637Q846 598 846 533Q846 452 776 375T597 252T378 206H366L358 181Q341 130 316 68T282 -7Q262 -33 230 -50T170 -67ZM701 468Q701 512 661 540T570 577T461 586H448V582Q446 576 443 545T428 447T395 301L389 280Q390 280 398 284T419 295T441 303Q443 304 484 306T572 321T651 359Q701 402 701 468",
          81: "874 453Q874 372 836 298T750 177T638 89T543 33T486 8L483 7Q485 5 523 -7T622 -32T726 -46Q741 -46 746 -45T755 -41T762 -27Q770 -1 806 23T878 50H890Q905 42 905 33Q905 -8 838 -68T670 -145Q662 -146 628 -146Q538 -146 389 -100T164 -50Q132 -50 132 -32T162 11T227 47Q231 48 286 51T394 62T518 100T641 180Q730 271 730 387Q730 478 673 540T520 602Q410 602 337 525T264 355Q264 284 310 244T420 203Q476 203 568 222Q594 222 594 204Q594 184 565 161T508 128Q433 103 316 103Q227 103 174 157T120 290Q120 382 182 471T343 620T548 697Q578 703 601 703Q604 703 611 703T623 702Q663 702 687 696Q760 679 817 618T874 453",
          82: "159 0Q159 5 172 34T205 114T245 229T284 386T309 575V585H304Q303 585 295 585T282 584Q233 579 207 570T175 553T165 531T156 509Q140 484 105 466T44 447Q20 447 20 465Q20 482 34 510T76 565Q122 608 173 632Q279 686 448 686H505H582Q683 686 745 672T834 611Q842 594 842 565Q842 523 824 484T780 419T722 370T669 336T632 318L619 312L626 302Q640 279 667 227T696 172Q717 133 735 112T762 88T784 84Q824 84 872 118T957 153Q981 153 981 136Q981 114 937 78T820 13T684 -17Q646 -17 616 8T569 66T526 151T477 234Q461 256 446 265Q437 272 421 274Q400 274 400 291Q400 311 430 336T495 371Q496 371 543 374T627 392T681 436Q699 467 699 503Q699 550 644 568T471 586H449V582Q449 581 447 559T438 499T422 413T393 298T348 165Q313 73 296 45Q282 24 249 4T185 -17Q159 -17 159 0",
          83: "204 476Q204 525 248 577T372 666T539 703T674 683T721 612Q721 588 714 569Q704 547 669 524T601 499Q573 499 573 516Q573 521 575 527T577 543Q577 563 568 574T548 588L539 590Q490 603 444 603Q418 603 394 597T364 583Q348 567 348 533Q348 493 382 466T459 425T555 387T633 330Q662 292 662 249Q662 153 544 69T257 -16Q218 -16 208 -15Q118 1 64 46Q25 76 25 126Q25 185 82 235T203 290H207Q229 290 231 274Q231 243 180 213Q173 209 172 206T170 189T171 170T183 150T216 121Q273 83 356 83Q412 83 459 100Q493 111 507 141Q518 165 518 185Q518 208 506 228T478 262T437 288T398 306T360 320Q316 335 285 352T239 384T215 416T205 443T204 467V476",
          84: "61 462H59Q38 462 38 479Q38 528 109 594T289 683L304 685L837 687L846 693Q889 720 923 720Q947 720 947 702Q945 671 892 631T776 583Q774 583 772 583T769 582T766 582L764 581H758Q753 581 744 581T722 580T693 580T662 580H563L514 385Q507 355 493 299T475 225T460 172T443 119T426 76T402 24Q386 -11 355 -33T304 -61T266 -69Q242 -69 242 -50Q243 -45 253 -25T278 32T307 115L364 340Q405 511 413 538T436 580H207Q202 572 200 568T197 561T195 552T190 537Q176 511 135 487T61 462",
          85: "124 586Q107 586 74 569T15 552H13Q-10 552 -10 570Q-10 605 70 645T222 686Q283 686 283 631Q283 590 246 504T172 326T135 181Q135 130 157 107T205 83Q221 83 259 106Q347 165 453 301T604 548Q607 557 612 569T619 587T624 600T628 612T632 621T637 628T641 634T647 640T654 645T662 652Q706 686 748 686Q771 686 771 669Q771 656 754 614T700 467T630 229Q615 168 610 105Q610 88 617 78L641 90Q681 111 706 112Q733 112 733 95Q733 82 714 60Q694 40 633 10Q567 -23 532 -24Q507 -24 495 -17Q466 -4 466 32Q466 96 500 225Q277 -17 102 -17Q56 -17 23 17T-10 118Q-10 164 13 234T64 363T115 481T139 567Q139 586 124 586",
          86: "25 608Q25 628 60 657T148 686Q184 683 213 671T273 625T327 538T363 394T380 184L381 134L399 148Q503 226 574 302T667 415T689 467Q688 474 684 482T672 502T645 521T600 532Q576 532 576 567Q576 604 597 644T641 685H649Q701 685 737 648T774 545Q774 457 703 333T461 66Q397 13 332 -32T255 -77Q237 -77 237 -30V-23Q241 20 241 109Q241 483 115 569Q91 586 50 589Q25 589 25 608",
          87: "25 607Q25 629 62 657T142 686Q205 686 248 647T312 541T339 411T347 275Q347 249 345 203V189Q375 219 449 316T587 516Q629 584 629 587Q629 589 626 597T622 607Q622 629 658 656T732 686H744Q755 680 757 678Q757 677 769 649T799 577T835 475T874 339T904 183Q908 157 910 151L925 169Q997 252 1059 343T1121 474Q1120 498 1103 513T1059 532Q1036 532 1036 568Q1036 600 1053 636T1090 683L1097 686H1109Q1147 684 1176 652T1206 551Q1206 460 1131 320T897 7Q859 -33 840 -52T816 -74T804 -77Q788 -77 784 -32Q783 -28 783 -26Q774 108 744 239T691 436T665 501Q664 501 649 475T602 400T528 289T420 146T280 -15Q243 -56 231 -66T210 -77Q191 -77 191 -40Q191 -38 195 -4T204 91T209 217Q209 290 202 351T177 469T126 557T45 589Q25 589 25 607",
          88: "762 562Q762 579 737 584T711 604Q711 630 753 658T834 686Q864 686 885 669T906 627Q906 580 834 522T614 379L584 362V357Q585 354 589 315T597 233T603 183Q610 132 627 116T671 100Q678 100 704 113T754 126T778 107Q776 79 733 45T626 2Q615 1 578 1Q542 1 535 3Q521 7 510 15T491 31T477 54T467 78T460 108T456 137T452 170T449 201Q447 220 445 240T442 270L441 281Q435 281 357 233Q240 165 206 135Q200 128 200 124Q200 113 208 108T226 101T244 96T252 82Q252 61 214 31T129 1H120Q97 1 77 16T56 60Q56 105 133 168T414 345Q428 352 431 354T433 359Q422 493 414 522Q407 551 395 566T373 583T350 586H341L332 580Q290 560 265 560Q243 560 243 577Q243 585 248 596T269 624T306 653T365 676T447 686H456Q472 686 484 683T514 671T543 637T562 576Q565 557 570 501L577 437Q577 436 613 457T694 506T756 551Q762 558 762 562",
          89: "73 555Q49 555 49 573Q49 602 110 644T239 686Q319 686 376 624Q416 584 444 511T483 361T499 240T503 173Q503 165 504 165Q506 165 524 184T556 218Q631 297 674 377T718 485Q718 505 699 526Q673 552 628 552Q619 552 613 562T607 590Q607 617 621 645T658 685Q661 686 671 686Q718 686 757 652T797 545Q797 476 749 369T602 146Q500 29 371 -67T176 -164Q112 -164 74 -120T36 -29Q36 5 55 36T95 67Q104 67 108 59T115 39T128 12T154 -12Q183 -30 216 -30Q239 -30 305 7L361 44L367 49V54Q367 95 364 143T351 273T312 429T243 546Q206 581 156 588L146 581Q108 555 73 555",
          90: "622 574Q522 579 420 579H396Q373 579 364 574T351 550Q339 516 297 490T218 462Q195 462 195 479Q195 487 197 492Q218 565 313 625T509 685Q564 685 650 683T755 680Q787 680 807 683T831 686Q853 686 853 669Q853 657 826 626Q742 532 641 437L619 415L622 414Q626 414 631 414T642 414Q697 411 697 388Q697 367 670 345T607 323Q605 323 592 325T546 329H522L490 302Q457 274 400 226T289 136L260 113L318 112Q345 111 452 109T587 106H627Q650 143 656 170Q666 197 710 225T788 253Q811 253 811 237Q811 211 781 160T710 77Q619 0 515 0Q507 0 497 0T484 1Q434 1 319 3T177 6Q123 6 95 2Q83 2 71 0H68Q46 0 46 17Q46 28 58 44Q68 56 100 80T210 165T383 307L408 329H361L314 330Q297 338 297 350Q297 368 320 388T368 413Q375 415 441 415H506L647 555L664 574H622"
        }, {});
      },
      7292: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texOldstyle = void 0;
        var n = r(768),
          o = r(9848);
        e.texOldstyle = (0, n.AddPaths)(o.texOldstyle, {
          48: "39 213Q39 274 53 319T89 389T139 429T192 448T242 452Q347 452 400 400Q460 335 460 213Q460 -22 250 -22Q39 -22 39 213ZM364 242Q364 279 363 301T355 348T338 385T306 406T254 415Q250 415 245 415T238 416Q217 416 190 404T150 368Q136 339 136 221Q136 114 146 78T200 23Q219 16 250 16Q280 16 299 23Q341 41 352 77T364 221V242",
          49: "116 410Q176 412 215 423T269 443T288 453H291Q293 453 301 447V254Q301 62 303 60Q307 52 322 49T394 46Q418 46 422 43T426 23Q426 8 424 4T411 0Q407 0 369 1T258 2T148 1T106 0Q96 0 94 4T91 23Q91 40 95 43T123 46Q180 46 195 49T215 61Q216 63 216 220V376Q192 367 119 364H93L86 371V403L92 410H116",
          50: "55 334Q55 386 105 419T236 453Q333 453 390 413T448 307Q448 278 437 256T406 218T365 193T318 172T277 151L248 134Q219 118 191 102T163 84T267 83L382 85H391Q399 99 406 126Q410 143 413 145T429 148Q440 148 442 147T449 139Q449 137 435 73T420 7Q420 6 414 0H233Q94 0 71 0T46 5Q46 5 46 6Q44 8 44 24Q44 39 46 41Q47 44 98 78T212 155T294 212Q347 257 347 304Q347 354 306 380T203 407Q150 407 120 377Q118 375 123 373Q146 362 146 332Q146 315 133 302T101 288Q85 288 70 298T55 334",
          51: "69 312Q69 377 122 414T233 452Q333 452 381 409T430 313Q430 268 402 223T311 149L301 144Q307 143 317 140T355 123T402 92T439 44T456 -25Q456 -101 396 -158T241 -216Q154 -216 98 -173T42 -68Q42 -58 44 -50T50 -35T57 -25T66 -17T75 -13T82 -10L87 -8Q92 -7 102 -7Q132 -7 147 -25T162 -66Q162 -112 118 -125L113 -126Q113 -129 127 -140T173 -162T239 -173Q268 -173 292 -158Q345 -124 345 -24Q345 33 329 67Q298 125 229 125H210H172Q166 131 166 142Q166 159 172 161Q178 161 208 164T244 169Q251 169 263 176T291 199T316 245T327 314Q327 413 238 413Q182 413 130 369Q177 350 181 312Q181 289 166 273T125 257Q102 257 86 272T69 312",
          52: "163 0Q139 0 109 0T71 -1Q43 -1 36 2T28 15V27V46L190 270Q325 457 330 462Q333 464 352 464H371L377 458V46H464L471 40V6L464 0H377V-65V-108Q377 -131 379 -137T391 -144Q409 -148 446 -148H464Q468 -151 471 -155V-187L464 -194H453Q395 -192 325 -192Q222 -192 210 -194H199L193 -188V-154L199 -148H228Q241 -148 250 -148T265 -146T275 -145T281 -143T284 -141T286 -138T289 -134V0H163ZM295 46V350L75 46H295",
          53: "159 -44Q159 -66 145 -80T109 -96H102L107 -105Q148 -173 228 -173Q255 -173 280 -162Q351 -128 351 -6V8Q351 67 344 98T316 151Q288 176 255 176Q175 176 136 109Q129 100 114 100Q97 100 95 106Q93 110 93 277V403Q93 451 98 451Q100 452 103 452Q105 452 124 445T177 431T251 423Q294 423 328 430T380 445T401 453Q410 453 410 435V422Q332 331 203 331Q152 331 140 339Q139 339 139 254V168Q194 214 256 214Q332 214 390 154T448 0Q448 -95 381 -155T229 -216Q153 -216 104 -166T50 -49Q50 -15 66 -1T105 13Q128 13 143 -3T159 -44",
          54: "42 313Q42 401 68 472T133 583T215 644T296 665H304Q317 665 329 664T360 657T393 640T418 608T432 557Q432 533 422 519T401 502T380 498Q358 498 343 512T328 550Q328 591 367 601L372 602Q372 604 365 609T341 620T307 626Q260 626 226 600T174 537Q147 483 143 376V356Q192 434 266 434Q317 434 357 409Q406 375 435 317Q456 268 456 210V192Q456 169 451 149Q440 90 387 34T253 -22Q225 -22 199 -14T143 16T92 75T56 172T42 313ZM251 396Q211 396 178 354T145 217Q145 159 152 122T166 73T187 47Q216 21 252 21Q294 21 321 47Q342 68 349 99T356 203V232Q356 264 354 285T345 331T322 373T280 395Q274 396 251 396",
          55: "75 246Q64 246 62 247T55 255Q55 259 72 357T90 458L94 462H99Q104 463 109 463H121Q128 460 128 452Q128 445 134 441T165 435T233 432T356 431H478L485 425V392L414 298Q408 290 385 260T358 223T337 191T317 154T302 116T289 68T282 14T275 -55T274 -137Q274 -173 272 -177Q262 -216 223 -216Q170 -216 170 -157V-148Q172 -78 189 -12T237 109T288 196T338 266Q345 275 348 279Q395 340 395 342Q396 343 376 343T274 343Q122 342 117 339T103 294T90 248Q88 246 75 246",
          56: "69 496Q69 570 124 618T247 666Q321 666 375 624T429 515Q429 468 405 433T320 361L346 344Q385 320 403 301T439 250Q456 212 456 181V172V160Q456 141 449 119T426 71T386 26T326 -8T246 -21Q160 -21 102 30T43 155Q43 265 167 332L176 337L161 347Q105 384 87 423Q69 458 69 496ZM371 513Q371 567 334 596T249 626Q198 626 163 598T127 532Q127 521 129 511T138 492T150 476T167 460T185 447T207 433T228 420L284 384L294 391Q346 424 363 469Q371 486 371 513ZM190 21T250 21T351 56T393 140Q393 180 362 213Q354 221 317 246T246 292L212 313Q210 313 200 307T173 287T142 256T117 212T106 157Q106 100 148 61",
          57: "171 -101Q171 -118 163 -130T146 -146T134 -151Q132 -151 132 -152Q132 -154 140 -159T167 -168T206 -173Q274 -173 317 -108Q356 -50 356 79V86L350 77Q308 9 231 9Q150 9 92 81Q42 141 42 228Q42 289 64 333Q93 390 142 421T235 452Q237 452 244 452T255 453Q289 453 321 439T386 391T437 290T457 128Q457 -29 381 -122T206 -216Q148 -216 108 -187T67 -104Q67 -75 84 -62T119 -49Q141 -49 156 -63T171 -101ZM242 46Q293 46 324 94T355 223Q355 323 337 356Q316 401 275 410Q267 412 248 412Q206 412 179 386Q155 360 149 328T143 224Q143 120 163 88Q192 46 242 46",
          65: "576 668Q576 688 606 708T660 728Q676 728 675 712V571Q675 409 688 252Q696 122 720 57Q722 53 723 50T728 46T732 43T737 41T743 39L754 45Q788 61 803 61Q819 61 819 47Q818 43 814 35Q799 15 755 -7T675 -30Q659 -30 648 -25T630 -8T621 11T614 34Q603 77 599 106T594 146T591 160V163H460L329 164L316 145Q241 35 196 -7T119 -50T59 -24T30 43Q30 75 46 100T74 125Q81 125 83 120T88 104T96 84Q118 57 151 57Q189 57 277 182Q432 400 542 625L559 659H567Q574 659 575 660T576 668ZM584 249Q579 333 577 386T575 473T574 520V581L563 560Q497 426 412 290L372 228L370 224H371L383 228L393 232H586L584 249",
          66: "304 342Q292 342 292 353Q292 372 323 391Q331 396 417 428T533 487Q563 512 563 555V562Q563 575 557 589T530 618T475 636Q429 636 396 613T330 539Q263 446 210 238Q196 183 173 120Q135 31 121 16Q108 1 85 -10T47 -22T32 -10Q32 -5 44 18T77 93T112 206Q135 296 154 395T182 550T191 615Q191 616 190 616Q188 616 179 611T157 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 693Q295 686 288 635T278 575Q278 572 287 582Q336 635 402 669T540 704Q603 704 633 673T664 599Q664 559 638 523T580 462Q553 440 504 413L491 407L504 402Q566 381 596 338T627 244Q627 172 575 110T444 13T284 -22Q208 -22 158 28Q144 42 146 50Q150 67 178 85T230 103Q236 103 246 95T267 75T302 56T357 47Q436 47 486 93Q526 136 526 198V210Q526 228 518 249T491 292T436 330T350 345Q335 345 321 344T304 342",
          67: "201 -25Q167 -25 136 -14T75 23T29 94T12 202Q12 290 50 394T161 574Q227 642 303 673T433 704Q435 705 457 705Q533 701 533 640Q533 606 507 548T464 474Q431 444 396 444Q381 444 381 453Q381 459 388 473T407 513T428 563Q433 580 433 594Q433 636 381 636Q314 636 260 594T175 489T128 363T112 247Q112 157 153 101T273 44Q347 44 398 121Q413 144 437 157T481 171Q496 171 496 160Q496 150 476 123Q426 56 350 16T201 -25",
          68: "37 475Q19 475 19 487Q19 536 103 604T327 682H356Q386 683 408 683H419Q475 683 506 681T582 668T667 633Q766 571 766 450Q766 365 723 287T611 152T455 57T279 6Q248 1 160 0Q148 0 131 0T108 -1Q72 -1 72 11Q72 24 90 40T133 64L144 68L152 88Q247 328 272 587Q275 613 272 613Q272 613 269 613Q225 610 195 602T149 579T129 556T119 532Q118 530 116 525T113 518Q102 502 80 490T37 475ZM665 407Q665 596 412 613Q403 614 383 614Q370 614 370 612Q370 598 363 542T323 357T242 103L228 69H265Q391 73 481 119Q536 148 575 188T633 268T658 338T665 392V407",
          69: "144 470Q144 556 240 630T451 705Q564 705 564 637Q564 611 540 573Q529 559 505 547T464 534Q448 534 448 545Q448 552 455 562Q463 577 463 591Q463 600 462 604T456 616T436 627T400 635Q396 635 390 635T380 636Q291 636 258 568Q245 544 245 516Q245 463 290 438T391 410Q415 410 415 398Q415 392 407 380T376 356T326 341Q288 340 260 327Q218 311 187 276T143 208T130 151Q130 113 156 88T211 55T268 47Q349 47 403 125Q415 144 439 157T483 171Q499 171 499 160Q499 148 475 120T413 59T315 3T197 -22Q124 -22 77 14T30 105Q30 126 39 154T66 216T122 288T209 354L223 362Q144 400 144 470",
          70: "199 579Q181 579 181 590Q181 598 188 611T212 639T260 666T335 682Q336 682 349 682T383 682T431 682T493 683T561 683Q776 682 784 681Q826 673 829 647Q829 620 797 600T744 580Q728 580 728 595Q729 607 713 610Q698 613 598 614H500L499 610Q499 598 467 486T428 367Q428 365 551 365H674Q683 360 684 355Q687 346 677 329Q666 312 642 299T598 285Q586 285 582 296H402L394 277Q386 258 373 229T346 167T315 102T286 51Q265 22 225 -5T133 -32Q108 -32 87 -25T54 -7T33 15T21 35T18 47Q18 60 44 80T98 103Q108 103 111 101T119 88Q130 66 150 54T179 39T195 37Q199 37 203 43Q217 67 245 125T318 300T391 532Q393 543 398 564T406 598T409 613T339 614H269Q229 579 199 579",
          71: "216 68Q155 68 115 100T59 177T44 273Q44 299 50 333T73 421T133 533T239 632Q346 704 466 704Q508 704 515 703Q555 696 577 681T599 635Q599 605 570 560T523 496Q490 466 455 466Q440 466 440 475T469 526T499 589Q499 605 489 617Q460 636 403 636Q343 636 295 611T220 548T174 464T150 382T144 318Q144 241 180 189T287 137Q325 137 359 160Q428 205 466 322Q472 342 501 359T551 376Q557 376 560 373T564 368L565 365Q560 341 551 302T512 173T451 31Q359 -119 204 -119Q163 -118 127 -109T74 -91T53 -77Q52 -75 52 -71Q52 -54 79 -35T132 -14H140L151 -19Q210 -49 281 -49H289Q312 -49 329 -31Q351 -7 372 36T405 109T416 142L408 136Q401 131 392 125T369 111T338 96T303 82T261 72T216 68",
          72: "18 487Q18 496 29 517T67 566T127 621T216 665T330 683Q359 683 376 669T397 643T400 622Q400 584 382 488T348 343Q348 342 467 342H587L594 366Q615 440 648 534T690 641Q701 656 723 669T764 683Q783 683 783 672L750 578Q716 485 677 346T625 101Q624 92 623 82T622 65T621 56Q621 20 658 20Q666 20 701 25Q709 52 736 69T785 87Q803 87 803 75T791 44T754 3T685 -33T588 -48Q568 -48 562 -46Q522 -31 522 13V23Q531 129 562 250L569 281L565 280Q561 278 556 277T549 274L438 273H328L321 249Q307 202 275 107T232 0Q219 -16 196 -28T155 -41Q149 -41 145 -39T140 -34T139 -29Q139 -24 148 -3T181 86T233 247Q240 270 240 272Q240 273 194 273H169Q139 273 139 285Q139 295 153 308T187 332Q206 341 236 342L260 343L264 359Q278 414 289 482T300 578Q300 613 260 613H254Q198 613 169 592Q148 578 127 544T104 508Q72 478 37 475Q18 475 18 487",
          73: "174 0H31Q-13 0 -21 2T-30 12Q-30 23 -17 36Q9 60 42 68L155 70Q187 102 214 179T257 333T302 491T366 610L369 614H305Q221 611 188 607T145 596T128 569Q119 543 94 529T47 512Q28 512 28 524Q28 527 32 539Q56 614 159 654Q218 678 312 682Q314 682 339 682T404 682T481 683H632Q642 678 642 671Q642 657 621 641T577 617Q570 615 507 614H444Q427 592 406 542Q382 478 355 366T310 209Q280 123 238 78L230 69H330Q442 70 442 74Q443 74 443 77T447 87T460 105Q490 134 527 137Q545 137 545 125Q545 120 542 112Q531 78 491 49T399 7Q379 2 360 2T174 0",
          74: "148 78Q148 16 189 -17T286 -50Q319 -50 348 -33T396 10T426 59T444 101L471 204Q498 306 521 372Q575 532 649 605L659 614H591Q517 613 494 607Q433 591 400 550T360 477Q353 454 325 437T275 419Q256 419 260 435Q280 523 376 597T583 681Q603 683 713 683H830Q839 674 839 671Q839 654 810 634T754 614Q735 614 721 601Q688 571 654 495T600 351T561 209T541 132Q507 29 412 -45T213 -119Q141 -119 94 -77T47 33Q47 55 50 69T58 90T71 103Q105 131 135 131Q152 131 152 120Q152 119 151 114T149 99T148 78",
          75: "194 618Q193 618 182 613T156 601T131 594Q113 594 113 605Q113 623 144 644Q154 650 205 676T267 703Q277 705 279 705Q295 705 295 691Q295 569 250 397Q225 306 197 217T151 81T128 25Q120 8 94 -7T47 -22Q32 -22 32 -10L64 76Q95 163 133 295T185 530Q198 611 194 618ZM331 429Q331 383 364 290T449 117T542 36Q574 36 607 51T652 103Q660 124 677 133T709 143Q727 143 727 128Q727 119 723 111Q704 56 639 17T497 -22H493Q463 -22 425 16Q401 40 382 71Q335 138 296 243T256 399Q256 434 288 473Q342 540 471 622T670 705Q691 704 703 696Q732 678 732 644Q732 613 714 600T677 586Q671 586 667 587T660 592T657 604V619Q657 647 629 647Q623 647 620 646Q576 635 495 583T365 482Q331 448 331 429",
          76: "62 -22T47 -22T32 -11Q32 -1 56 24T83 55Q113 96 138 172T180 320T234 473T323 609Q364 649 419 677T531 705Q559 705 578 696T604 671T615 645T618 623V611Q618 582 615 571T598 548Q581 531 558 520T518 509Q503 509 503 520Q503 523 505 536T507 560Q507 590 494 610T452 630Q423 630 410 617Q367 578 333 492T271 301T233 170Q211 123 204 112L198 103L224 102Q281 102 369 79T509 52H523Q535 64 544 87T579 128Q616 152 641 152Q656 152 656 142Q656 101 588 40T433 -22Q381 -22 289 1T156 28L141 29L131 20Q111 0 87 -11",
          77: "28 9Q28 37 43 63T73 90Q77 90 83 84T103 70T141 57H146Q162 57 178 79T222 167Q266 279 295 371T334 513T349 598T358 651T371 677Q397 705 432 705Q442 705 445 699T452 666Q453 661 453 659Q475 538 509 405T568 207L574 192Q581 178 587 164T594 150Q596 150 635 189T693 248Q765 324 863 438T1024 626T1089 701Q1093 705 1100 705Q1111 705 1111 682Q1111 675 1108 660T1099 611T1086 540Q1041 277 1041 144Q1041 98 1044 75T1050 48T1059 42Q1064 41 1075 46Q1102 61 1121 61Q1137 61 1137 50Q1137 28 1087 0T1000 -29Q983 -29 972 -23T955 -9T945 16T942 45T941 83V96Q941 158 952 256T974 422L985 489Q984 489 939 436T821 300T698 164Q665 128 620 85T568 37Q564 34 558 34Q550 34 546 37T535 54Q512 91 496 127T450 259T389 498L384 518Q349 367 294 223T198 15Q155 -50 117 -50Q87 -50 61 -35T30 -6Q28 2 28 9",
          78: "343 705Q358 705 358 698Q360 696 370 658T411 524T484 319Q536 174 590 82L595 73L615 152Q646 274 683 407Q729 571 752 637T799 727Q852 780 937 788Q939 788 947 788T958 789H962Q979 789 979 765Q979 722 951 692Q942 683 924 683Q888 681 859 672T818 654T803 639Q784 608 708 322T631 15Q631 14 630 15Q630 17 629 15Q628 14 628 12Q621 -4 601 -17T560 -31Q550 -31 546 -28T530 -7Q484 67 458 123T398 272Q352 392 314 514L306 535V534Q306 533 296 488T272 379T234 239T185 100T127 -7T61 -50Q34 -50 4 -34T-27 8Q-27 33 -12 61T18 90Q21 90 36 77T87 57H92Q109 57 123 78T162 173Q206 299 232 417T265 599T276 667Q284 681 304 693T343 705",
          79: "308 428Q289 428 289 438Q289 457 318 508T378 593Q417 638 475 671T599 705Q688 705 732 643T777 483Q777 380 733 285T620 123T464 18T293 -22Q188 -22 123 51T58 245Q58 327 87 403T159 533T249 626T333 685T388 705Q404 705 404 693Q404 674 363 649Q333 632 304 606T239 537T181 429T158 290Q158 179 214 114T364 48Q489 48 583 165T677 438Q677 473 670 505T648 568T601 617T528 636Q518 636 513 635Q486 629 460 600T419 544T392 490Q383 470 372 459Q341 430 308 428",
          80: "37 475Q19 475 19 487Q19 536 103 604T327 682Q329 682 344 682T380 682T421 683H463Q625 683 695 615Q718 591 726 564Q733 547 733 525Q733 412 607 312T321 205H312Q293 205 293 217Q293 224 302 236T333 260T385 274Q558 287 614 407Q633 445 633 477Q633 515 612 543T556 585T481 607T399 614H370L368 603Q352 463 312 312T242 82T202 -13Q190 -33 164 -45T121 -57Q108 -57 108 -45Q108 -40 120 -10T151 73T192 190T233 349T266 539Q267 546 269 565T272 598T274 613H270Q209 613 163 588Q131 572 113 518Q102 502 80 490T37 475",
          81: "114 286Q114 358 151 433T249 569T392 667T558 705Q653 705 713 641T774 460Q774 389 750 322T687 206T600 114T504 46T412 4L399 -2Q542 -62 636 -62Q660 -62 670 -54T686 -27T700 0Q734 34 770 34Q787 34 787 23Q787 -18 720 -74T563 -131Q485 -131 350 -83T145 -34Q127 -34 127 -22Q127 -12 144 5T190 31L200 34L237 35Q386 38 467 79Q550 120 612 210T675 416Q675 510 625 573T484 636Q410 636 346 587T248 469T214 333Q214 306 221 281T243 229T288 188T360 172Q403 172 441 188T490 205Q510 205 510 192Q505 162 432 132T287 102Q206 102 160 155T114 286",
          82: "37 475Q19 475 19 487Q19 503 35 530T83 589T180 647T327 682H374Q387 682 417 682T464 683Q519 683 559 679T642 663T708 625T731 557Q731 481 668 411T504 300Q506 296 512 286T528 257T553 202Q594 105 611 82Q635 47 665 47Q708 47 742 93Q758 113 786 128Q804 136 819 137Q837 137 837 125Q837 115 818 92T767 43T687 -2T589 -22Q549 -22 517 22T467 120T422 221T362 273Q346 273 346 287Q348 301 373 320T436 342Q437 342 446 343T462 345T481 348T504 353T527 362T553 375T577 393Q598 412 614 443T630 511Q630 545 613 566T541 600T393 614Q370 614 370 613L366 584Q349 446 311 307T243 96L213 25Q205 8 179 -7T132 -22Q125 -22 120 -18T117 -8Q117 -5 130 26T163 113T205 239T246 408T274 606V614Q273 614 259 613T231 609T198 602T163 588Q131 572 113 518Q102 502 80 490T37 475",
          83: "554 512Q536 512 536 522Q536 525 539 539T542 564Q542 588 528 604Q515 616 482 625T410 635Q374 635 349 624T312 594T295 561T290 532Q290 505 303 482T342 442T378 419T409 404Q435 391 451 383T494 357T535 323T562 282T574 231Q574 133 464 56T220 -22Q138 -22 78 21T18 123Q18 184 61 227T156 274Q178 274 178 263Q178 260 177 258Q172 247 164 239T151 227T136 218L127 213L124 202Q118 186 118 163Q120 124 165 86T292 48Q374 48 423 86T473 186V193Q473 267 347 327Q268 364 239 389Q191 431 191 486Q191 547 242 600T356 679T470 705Q472 705 478 705T489 704Q551 704 596 682T642 610Q642 566 621 545Q592 516 554 512",
          84: "49 475Q34 475 34 490Q34 552 106 611T261 681Q272 683 507 683H742Q790 717 816 717Q833 717 833 708Q833 682 795 653T714 615Q691 610 588 609Q490 609 490 607L483 580Q476 554 462 496T435 392Q410 289 395 231T363 116T335 34T309 -15T279 -47T242 -64Q231 -68 218 -68Q203 -68 203 -57Q203 -52 211 -38Q224 -7 234 20T251 66T268 123T283 179T304 261T328 360Q342 415 360 488Q380 567 384 582T397 605Q400 607 401 609H302H244Q200 609 188 607T167 596Q145 572 145 541Q145 520 109 498T49 475",
          85: "8 592Q8 616 70 649T193 683Q246 683 246 631Q246 587 205 492T124 297T83 143Q83 101 100 75T154 48Q202 48 287 135T450 342T560 553Q589 635 593 640Q603 656 626 668T669 683H670Q687 683 687 672T670 616T617 463T547 220Q525 137 521 68Q521 54 522 50T533 42L543 47Q573 61 588 61Q604 61 604 47Q599 16 506 -22Q486 -28 468 -28T436 -18T421 18Q421 92 468 258Q468 259 467 257T459 248Q426 206 391 167T303 81T194 6T83 -22Q66 -22 58 -20Q25 -11 4 19T-17 99Q-17 146 8 220T64 358T120 488T146 586Q146 604 141 608T123 613H120Q99 613 72 597T25 580Q8 580 8 592",
          86: "25 633Q25 647 47 665T100 683Q291 683 291 306Q291 264 288 213T282 132L279 102Q281 102 308 126T378 191T464 279T545 381T596 479Q600 490 600 502Q600 527 581 550T523 577Q505 577 505 601Q505 622 516 647T542 681Q546 683 558 683Q605 679 631 645T658 559Q658 423 487 215Q409 126 308 37T190 -52Q177 -52 177 -28Q177 -26 183 15T196 127T203 270Q203 356 192 421T165 523T126 583T83 613T41 620Q25 620 25 633",
          87: "25 633Q25 647 46 665T103 683Q168 683 207 632Q228 608 243 568Q269 485 269 374Q269 324 265 271T256 184L251 150L252 152Q254 153 257 157T264 167T274 180T286 197Q359 293 424 398T519 558T549 616Q549 618 547 624T545 638Q550 654 572 668T615 683Q626 683 632 672T657 595Q726 370 741 128L742 110Q752 122 767 142T823 217T894 321T950 424T976 511Q976 544 958 560T918 577Q906 577 906 602Q906 629 918 651T942 681Q948 683 954 683Q983 683 1008 658T1034 569T999 421T915 257T813 109T724 -3T681 -49Q666 -59 660 -45Q659 -41 657 35T639 233T591 477Q573 551 570 551Q569 551 554 523T507 439T433 315T323 155T182 -25Q160 -52 151 -53Q137 -53 137 -30Q137 -29 148 25T170 168T181 338Q181 424 168 483T131 571T87 609T40 620Q25 620 25 633",
          88: "324 614Q291 576 250 573Q231 573 231 584Q231 589 232 592Q235 601 244 614T271 643T324 671T400 683H403Q462 683 481 610Q485 594 490 545T498 454L501 413Q504 413 551 442T648 509T705 561Q707 565 707 578Q707 610 682 614Q667 614 667 626Q667 641 695 662T755 683Q765 683 775 680T796 662T807 623Q807 596 792 572T713 499T530 376L505 361V356Q508 346 511 278T524 148T557 75Q569 69 580 69Q585 69 593 77Q624 108 660 110Q667 110 670 110T676 106T678 94Q668 59 624 30T510 0Q487 0 471 9T445 32T430 71T422 117T417 173Q416 183 416 188Q413 214 411 244T407 286T405 299Q403 299 344 263T223 182T154 122Q152 118 152 105Q152 69 180 69Q183 69 187 66T191 60L192 58V56Q192 41 163 21T105 0Q94 0 84 3T63 21T52 60Q52 77 56 90T85 131T155 191Q197 223 259 263T362 327T402 352L391 489Q391 492 390 505T387 526T384 547T379 568T372 586T361 602T348 611Q346 612 341 613T333 614H324",
          89: "65 599Q65 618 107 650T204 683Q267 683 312 643T380 533T414 385T424 217Q424 186 423 160T422 123Q426 123 468 170T567 304T650 469Q661 503 661 519Q661 546 639 570Q615 591 583 591Q569 591 569 616Q569 640 582 661T613 683Q624 683 638 679T671 664T702 625T714 558Q714 472 639 329T426 45Q361 -21 282 -82T154 -143Q97 -143 64 -104T31 -20Q31 4 44 25T70 46Q78 46 81 39T87 16T97 -9Q127 -51 182 -51Q184 -51 187 -50H190Q233 -41 314 25Q330 36 330 40Q336 79 336 178Q336 508 223 594Q199 614 158 619L148 620L139 611Q111 586 83 586Q65 586 65 599",
          90: "694 220Q708 220 708 210Q708 195 695 167T658 105T593 42T502 3Q492 1 458 1Q400 1 293 11T150 22Q116 22 92 11T51 0Q37 0 37 10Q37 21 63 44T179 146T367 319L391 343H343L296 344Q285 350 285 358Q285 365 289 372T300 383T313 392T324 398L329 400H450L561 518Q597 558 607 571L621 587H596Q553 589 484 599T383 609Q342 609 326 596T301 555Q294 533 263 514T208 492Q189 492 189 503Q189 510 197 528T215 559Q249 607 318 645T466 683Q504 683 573 673T669 662L690 661Q734 682 748 683Q767 683 767 673Q767 666 746 640Q655 531 555 428L529 400Q529 399 543 399Q604 397 604 366Q604 350 587 337T551 322Q541 322 539 323Q529 328 529 334Q529 339 487 342L470 343L446 320Q272 153 200 96L235 95Q297 95 392 86T533 74H554Q586 116 597 159Q604 179 635 199T694 220"
        }, {});
      },
      2162: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize3 = void 0;
        var n = r(768),
          o = r(7906);
        e.texSize3 = (0, n.AddPaths)(o.texSize3, {
          40: "701 -940Q701 -943 695 -949H664Q662 -947 636 -922T591 -879T537 -818T475 -737T412 -636T350 -511T295 -362T250 -186T221 17T209 251Q209 962 573 1361Q596 1386 616 1405T649 1437T664 1450H695Q701 1444 701 1441Q701 1436 681 1415T629 1356T557 1261T476 1118T400 927T340 675T308 359Q306 321 306 250Q306 -139 400 -430T690 -924Q701 -936 701 -940",
          41: "34 1438Q34 1446 37 1448T50 1450H56H71Q73 1448 99 1423T144 1380T198 1319T260 1238T323 1137T385 1013T440 864T485 688T514 485T526 251Q526 134 519 53Q472 -519 162 -860Q139 -885 119 -904T86 -936T71 -949H56Q43 -949 39 -947T34 -937Q88 -883 140 -813Q428 -430 428 251Q428 453 402 628T338 922T245 1146T145 1309T46 1425Q44 1427 42 1429T39 1433T36 1436L34 1438",
          47: "81 -949Q71 -949 63 -941T55 -921Q55 -917 56 -915Q59 -906 498 264T939 1438Q945 1450 960 1450Q972 1450 980 1441T988 1421Q982 1403 839 1020L398 -155Q107 -934 103 -938Q96 -949 81 -949",
          91: "247 -949V1450H516V1388H309V-887H516V-949H247",
          92: "988 -922Q988 -933 980 -941T962 -949Q947 -949 940 -938Q936 -934 645 -155L204 1020Q56 1416 56 1424Q56 1433 62 1441T84 1450Q97 1448 103 1439Q107 1435 398 656L839 -519Q988 -918 988 -922",
          93: "11 1388V1450H280V-949H11V-887H218V1388H11",
          123: "618 -943L612 -949H582L568 -943Q472 -903 411 -841T332 -703Q327 -682 327 -653T325 -350Q324 -28 323 -18Q317 24 301 61T264 124T221 171T179 205T147 225T132 234Q130 238 130 250Q130 255 130 258T131 264T132 267T134 269T139 272T144 275Q207 308 256 367Q310 436 323 519Q324 529 325 851Q326 1124 326 1154T332 1205Q369 1358 566 1443L582 1450H612L618 1444V1429Q618 1413 616 1411L608 1406Q599 1402 585 1393T552 1372T515 1343T479 1305T449 1257T429 1200Q425 1180 425 1152T423 851Q422 579 422 549T416 498Q407 459 388 424T346 364T297 318T250 284T214 264T197 254L188 251L205 242Q290 200 345 138T416 3Q421 -18 421 -48T423 -349Q423 -397 423 -472Q424 -677 428 -694Q429 -697 429 -699Q434 -722 443 -743T465 -782T491 -816T519 -845T548 -868T574 -886T595 -899T610 -908L616 -910Q618 -912 618 -928V-943",
          125: "131 1414T131 1429T133 1447T148 1450H153H167L182 1444Q276 1404 336 1343T415 1207Q421 1184 421 1154T423 851L424 531L426 517Q434 462 460 415T518 339T571 296T608 274Q615 270 616 267T618 251Q618 241 618 238T615 232T608 227Q542 194 491 132T426 -15L424 -29L423 -350Q422 -622 422 -652T415 -706Q397 -780 337 -841T182 -943L167 -949H153Q137 -949 134 -946T131 -928Q131 -914 132 -911T144 -904Q146 -903 148 -902Q299 -820 323 -680Q324 -663 325 -349T327 -19Q355 145 541 241L561 250L541 260Q356 355 327 520Q326 537 325 850T323 1181Q315 1227 293 1267T244 1332T193 1374T151 1401T132 1413Q131 1414 131 1429",
          710: "1439 564Q1434 564 1080 631T722 698Q719 698 362 631Q7 564 4 564L0 583Q-4 602 -4 603L720 772L1083 688Q1446 603 1447 603Q1447 602 1443 583L1439 564",
          732: "1 643Q1 646 76 671T271 722T476 749Q555 749 626 736T742 706T856 676T999 662Q1088 662 1192 684T1363 727T1432 749Q1432 745 1437 731T1442 716Q1442 714 1381 693T1212 645T1012 611Q1000 610 955 610Q851 610 701 653T444 697Q355 697 251 676T80 632T11 610Q11 614 6 628T1 643",
          770: "-5 564Q-9 564 -363 631T-722 698Q-725 698 -1082 631Q-1437 564 -1440 564L-1444 583Q-1448 602 -1448 603L-724 772L-361 688Q2 603 3 603Q3 602 -1 583L-5 564",
          771: "-1443 643Q-1443 646 -1368 671T-1173 722T-968 749Q-889 749 -818 736T-702 706T-588 676T-445 662Q-356 662 -252 684T-81 727T-12 749Q-12 745 -7 731T-2 716Q-2 714 -63 693T-232 645T-432 611Q-444 610 -489 610Q-593 610 -743 653T-1000 697Q-1089 697 -1193 676T-1364 632T-1433 610Q-1433 614 -1438 628T-1443 643",
          8260: "81 -949Q71 -949 63 -941T55 -921Q55 -917 56 -915Q59 -906 498 264T939 1438Q945 1450 960 1450Q972 1450 980 1441T988 1421Q982 1403 839 1020L398 -155Q107 -934 103 -938Q96 -949 81 -949",
          8730: "424 -948Q422 -947 313 -434T202 80L170 31Q165 24 157 10Q137 -21 137 -21Q131 -16 124 -8L111 5L264 248L473 -720Q473 -717 727 359T983 1440Q989 1450 1001 1450Q1007 1450 1013 1445T1020 1433Q1020 1425 742 244T460 -941Q458 -950 439 -950H436Q424 -950 424 -948",
          8968: "246 -949V1450H571V1388H308V-949H246",
          8969: "11 1388V1450H336V-949H274V1388H11",
          8970: "246 -949V1450H308V-887H571V-949H246",
          8971: "274 -887V1450H336V-949H11V-887H274",
          9001: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
          9002: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424",
          10216: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
          10217: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424",
          12296: "126 242V259L361 845Q595 1431 597 1435Q610 1450 624 1450Q634 1450 644 1443T654 1419V1411L422 831Q190 253 190 250T422 -331L654 -910V-919Q654 -936 644 -943T624 -950Q612 -950 597 -935Q595 -931 361 -345L126 242",
          12297: "94 1424Q94 1426 97 1432T107 1444T124 1450Q141 1450 152 1435Q154 1431 388 845L623 259V242L388 -345Q153 -933 152 -934Q142 -949 127 -949H125Q95 -949 95 -919V-910L327 -331Q559 247 559 250T327 831Q94 1411 94 1424"
        }, {});
      },
      9244: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texSize4 = void 0;
        var n = r(768),
          o = r(2644);
        e.texSize4 = (0, n.AddPaths)(o.texSize4, {
          40: "758 -1237T758 -1240T752 -1249H736Q718 -1249 717 -1248Q711 -1245 672 -1199Q237 -706 237 251T672 1700Q697 1730 716 1749Q718 1750 735 1750H752Q758 1744 758 1741Q758 1737 740 1713T689 1644T619 1537T540 1380T463 1176Q348 802 348 251Q348 -242 441 -599T744 -1218Q758 -1237 758 -1240",
          41: "33 1741Q33 1750 51 1750H60H65Q73 1750 81 1743T119 1700Q554 1207 554 251Q554 -707 119 -1199Q76 -1250 66 -1250Q65 -1250 62 -1250T56 -1249Q55 -1249 53 -1249T49 -1250Q33 -1250 33 -1239Q33 -1236 50 -1214T98 -1150T163 -1052T238 -910T311 -727Q443 -335 443 251Q443 402 436 532T405 831T339 1142T224 1438T50 1716Q33 1737 33 1741",
          47: "1166 1738Q1176 1750 1189 1750T1211 1742T1221 1721Q1221 1720 1221 1718T1220 1715Q1219 1708 666 238T111 -1237Q102 -1249 86 -1249Q74 -1249 65 -1240T56 -1220Q56 -1219 56 -1217T57 -1214Q58 -1207 611 263T1166 1738",
          91: "269 -1249V1750H577V1677H342V-1176H577V-1249H269",
          92: "56 1720Q56 1732 64 1741T85 1750Q104 1750 111 1738Q113 1734 666 264T1220 -1214Q1220 -1215 1220 -1217T1221 -1220Q1221 -1231 1212 -1240T1191 -1249Q1175 -1249 1166 -1237Q1164 -1233 611 237T57 1715Q57 1716 56 1718V1720",
          93: "5 1677V1750H313V-1249H5V-1176H240V1677H5",
          123: "661 -1243L655 -1249H622L604 -1240Q503 -1190 434 -1107T348 -909Q346 -897 346 -499L345 -98L343 -82Q335 3 287 87T157 223Q146 232 145 236Q144 240 144 250Q144 265 145 268T157 278Q242 333 288 417T343 583L345 600L346 1001Q346 1398 348 1410Q379 1622 600 1739L622 1750H655L661 1744V1727V1721Q661 1712 661 1710T657 1705T648 1700T630 1690T602 1668Q589 1659 574 1643T531 1593T484 1508T459 1398Q458 1389 458 1001Q458 614 457 605Q441 435 301 316Q254 277 202 251L250 222Q260 216 301 185Q443 66 457 -104Q458 -113 458 -501Q458 -888 459 -897Q463 -944 478 -988T509 -1060T548 -1114T580 -1149T602 -1167Q620 -1183 634 -1192T653 -1202T659 -1207T661 -1220V-1226V-1243",
          125: "144 1727Q144 1743 146 1746T162 1750H167H183L203 1740Q274 1705 325 1658T403 1562T440 1478T456 1410Q458 1398 458 1001Q459 661 459 624T465 558Q470 526 480 496T502 441T529 395T559 356T588 325T615 301T637 284T654 273L660 269V266Q660 263 660 259T661 250V239Q661 236 661 234T660 232T656 229T649 224Q577 179 528 105T465 -57Q460 -86 460 -123T458 -499V-661Q458 -857 457 -893T447 -955Q425 -1048 359 -1120T203 -1239L183 -1249H168Q150 -1249 147 -1246T144 -1226Q144 -1213 145 -1210T153 -1202Q169 -1193 186 -1181T232 -1140T282 -1081T322 -1000T345 -897Q346 -888 346 -501Q346 -113 347 -104Q359 58 503 184Q554 226 603 250Q504 299 430 393T347 605Q346 614 346 1002Q346 1389 345 1398Q338 1493 288 1573T153 1703Q146 1707 145 1710T144 1727",
          710: "5 561Q-4 561 -9 582T-14 618Q-14 623 -13 625Q-11 628 461 736T943 845Q945 845 1417 738T1896 628Q1902 628 1902 618Q1902 607 1897 584T1883 561Q1881 561 1412 654L945 750L476 654Q6 561 5 561",
          732: "1212 583Q1124 583 1048 603T923 647T799 691T635 711Q524 711 375 679T120 615L16 583Q14 584 12 587T9 592Q-2 650 2 659Q2 669 38 687Q54 696 146 723T309 767Q527 823 666 823Q759 823 837 803T964 759T1088 715T1252 695Q1363 695 1512 727T1764 791T1871 823Q1872 822 1874 819T1878 814Q1885 783 1885 753Q1885 748 1884 747Q1884 738 1849 719Q1836 712 1740 682T1484 617T1212 583",
          770: "-1884 561Q-1893 561 -1898 582T-1903 618Q-1903 623 -1902 625Q-1900 628 -1428 736T-946 845Q-944 845 -472 738T7 628Q13 628 13 618Q13 607 8 584T-6 561Q-8 561 -477 654L-944 750L-1413 654Q-1883 561 -1884 561",
          771: "-677 583Q-765 583 -841 603T-966 647T-1090 691T-1254 711Q-1365 711 -1514 679T-1768 615L-1873 583Q-1875 584 -1877 587T-1880 592Q-1891 650 -1887 659Q-1887 669 -1851 687Q-1835 696 -1743 723T-1580 767Q-1362 823 -1223 823Q-1130 823 -1052 803T-925 759T-801 715T-637 695Q-526 695 -377 727T-125 791T-18 823Q-17 822 -15 819T-11 814Q-4 782 -4 753Q-4 748 -5 747Q-5 738 -40 719Q-53 712 -149 682T-405 617T-677 583",
          8260: "1166 1738Q1176 1750 1189 1750T1211 1742T1221 1721Q1221 1720 1221 1718T1220 1715Q1219 1708 666 238T111 -1237Q102 -1249 86 -1249Q74 -1249 65 -1240T56 -1220Q56 -1219 56 -1217T57 -1214Q58 -1207 611 263T1166 1738",
          8730: "983 1739Q988 1750 1001 1750Q1008 1750 1013 1745T1020 1733Q1020 1726 742 244T460 -1241Q458 -1250 439 -1250H436Q424 -1250 424 -1248L410 -1166Q395 -1083 367 -920T312 -601L201 44L137 -83L111 -57L187 96L264 247Q265 246 369 -357Q470 -958 473 -963L727 384Q979 1729 983 1739",
          8968: "269 -1249V1750H633V1677H342V-1249H269",
          8969: "5 1677V1750H369V-1249H296V1677H5",
          8970: "269 -1249V1750H342V-1176H633V-1249H269",
          8971: "296 -1176V1750H369V-1249H5V-1176H296",
          9001: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
          9002: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
          9115: "837 1154Q843 1148 843 1145Q843 1141 818 1106T753 1002T667 841T574 604T494 299Q417 -84 417 -609Q417 -641 416 -647T411 -654Q409 -655 366 -655Q299 -655 297 -654Q292 -652 292 -643T291 -583Q293 -400 304 -242T347 110T432 470T574 813T785 1136Q787 1139 790 1142T794 1147T796 1150T799 1152T802 1153T807 1154T813 1154H819H837",
          9116: "413 -9Q412 -9 407 -9T388 -10T354 -10Q300 -10 297 -9Q294 -8 293 -5Q291 5 291 127V300Q291 602 292 605L296 609Q298 610 366 610Q382 610 392 610T407 610T412 609Q416 609 416 592T417 473V127Q417 -9 413 -9",
          9117: "843 -635Q843 -638 837 -644H820Q801 -644 800 -643Q792 -635 785 -626Q684 -503 605 -363T473 -75T385 216T330 518T302 809T291 1093Q291 1144 291 1153T296 1164Q298 1165 366 1165Q409 1165 411 1164Q415 1163 416 1157T417 1119Q417 529 517 109T833 -617Q843 -631 843 -635",
          9118: "31 1143Q31 1154 49 1154H59Q72 1154 75 1152T89 1136Q190 1013 269 873T401 585T489 294T544 -8T572 -299T583 -583Q583 -634 583 -643T577 -654Q575 -655 508 -655Q465 -655 463 -654Q459 -653 458 -647T457 -609Q457 -58 371 340T100 1037Q87 1059 61 1098T31 1143",
          9119: "579 -9Q578 -9 573 -9T554 -10T520 -10Q466 -10 463 -9Q460 -8 459 -5Q457 5 457 127V300Q457 602 458 605L462 609Q464 610 532 610Q548 610 558 610T573 610T578 609Q582 609 582 592T583 473V127Q583 -9 579 -9",
          9120: "56 -644H50Q31 -644 31 -635Q31 -632 37 -622Q69 -579 100 -527Q286 -228 371 170T457 1119Q457 1161 462 1164Q464 1165 520 1165Q575 1165 577 1164Q582 1162 582 1153T583 1093Q581 910 570 752T527 400T442 40T300 -303T89 -626Q78 -640 75 -642T61 -644H56",
          9121: "319 -645V1154H666V1070H403V-645H319",
          9122: "319 0V602H403V0H319",
          9123: "319 -644V1155H403V-560H666V-644H319",
          9124: "0 1070V1154H347V-645H263V1070H0",
          9125: "263 0V602H347V0H263",
          9126: "263 -560V1155H347V-644H0V-560H263",
          9127: "712 899L718 893V876V865Q718 854 704 846Q627 793 577 710T510 525Q510 524 509 521Q505 493 504 349Q504 345 504 334Q504 277 504 240Q504 -2 503 -4Q502 -8 494 -9T444 -10Q392 -10 390 -9Q387 -8 386 -5Q384 5 384 230Q384 262 384 312T383 382Q383 481 392 535T434 656Q510 806 664 892L677 899H712",
          9128: "389 1159Q391 1160 455 1160Q496 1160 498 1159Q501 1158 502 1155Q504 1145 504 924Q504 691 503 682Q494 549 425 439T243 259L229 250L243 241Q349 175 421 66T503 -182Q504 -191 504 -424Q504 -600 504 -629T499 -659H498Q496 -660 444 -660T390 -659Q387 -658 386 -655Q384 -645 384 -425V-282Q384 -176 377 -116T342 10Q325 54 301 92T255 155T214 196T183 222T171 232Q170 233 170 250T171 268Q171 269 191 284T240 331T300 407T354 524T383 679Q384 691 384 925Q384 1152 385 1155L389 1159",
          9129: "718 -893L712 -899H677L666 -893Q542 -825 468 -714T385 -476Q384 -466 384 -282Q384 3 385 5L389 9Q392 10 444 10Q486 10 494 9T503 4Q504 2 504 -239V-310V-366Q504 -470 508 -513T530 -609Q546 -657 569 -698T617 -767T661 -812T699 -843T717 -856T718 -876V-893",
          9130: "384 150V266Q384 304 389 309Q391 310 455 310Q496 310 498 309Q502 308 503 298Q504 283 504 150Q504 32 504 12T499 -9H498Q496 -10 444 -10T390 -9Q386 -8 385 2Q384 17 384 150",
          9131: "170 875Q170 892 172 895T189 899H194H211L222 893Q345 826 420 715T503 476Q504 467 504 230Q504 51 504 21T499 -9H498Q496 -10 444 -10Q402 -10 394 -9T385 -4Q384 -2 384 240V311V366Q384 469 380 513T358 609Q342 657 319 698T271 767T227 812T189 843T171 856T170 875",
          9132: "389 1159Q391 1160 455 1160Q496 1160 498 1159Q501 1158 502 1155Q504 1145 504 925V782Q504 676 511 616T546 490Q563 446 587 408T633 345T674 304T705 278T717 268Q718 267 718 250T717 232Q717 231 697 216T648 169T588 93T534 -24T505 -179Q504 -191 504 -425Q504 -600 504 -629T499 -659H498Q496 -660 444 -660T390 -659Q387 -658 386 -655Q384 -645 384 -424Q384 -191 385 -182Q394 -49 463 61T645 241L659 250L645 259Q539 325 467 434T385 682Q384 692 384 873Q384 1153 385 1155L389 1159",
          9133: "384 -239V-57Q384 4 389 9Q391 10 455 10Q496 10 498 9Q501 8 502 5Q504 -5 504 -230Q504 -261 504 -311T505 -381Q505 -486 492 -551T435 -691Q357 -820 222 -893L211 -899H195Q176 -899 173 -896T170 -874Q170 -858 171 -855T184 -846Q262 -793 312 -709T378 -525Q378 -524 379 -522Q383 -493 384 -351Q384 -345 384 -334Q384 -276 384 -239",
          9143: "742 -871Q740 -873 737 -876T733 -880T730 -882T724 -884T714 -885H702L222 569L180 484Q138 399 137 399Q131 404 124 412L111 425L265 736L702 -586V168L703 922Q713 935 722 935Q734 935 742 920V-871",
          10216: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
          10217: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
          12296: "140 242V260L386 994Q633 1729 635 1732Q643 1745 657 1749Q658 1749 662 1749T668 1750Q682 1749 692 1740T702 1714V1705L214 251L703 -1204L702 -1213Q702 -1230 692 -1239T667 -1248H664Q647 -1248 635 -1231Q633 -1228 386 -493L140 242",
          12297: "103 1714Q103 1732 114 1741T137 1750Q157 1750 170 1732Q172 1729 419 994L665 260V242L419 -493Q172 -1228 170 -1231Q158 -1248 141 -1248H138Q123 -1248 113 -1239T103 -1213V-1204L591 251L103 1705V1714",
          57344: "722 -14H720Q708 -14 702 0V306L703 612Q713 625 722 625Q734 625 742 610V0Q734 -14 724 -14H722",
          57345: "702 589Q706 601 718 605H1061Q1076 597 1076 585Q1076 572 1061 565H742V0Q734 -14 724 -14H722H720Q708 -14 702 0V589",
          57680: "-18 -213L-24 -207V-172L-16 -158Q75 2 260 84Q334 113 415 119Q418 119 427 119T440 120Q454 120 457 117T460 98V60V25Q460 7 457 4T441 0Q308 0 193 -55T25 -205Q21 -211 18 -212T-1 -213H-18",
          57681: "-10 60Q-10 104 -10 111T-5 118Q-1 120 10 120Q96 120 190 84Q375 2 466 -158L474 -172V-207L468 -213H451H447Q437 -213 434 -213T428 -209T423 -202T414 -187T396 -163Q331 -82 224 -41T9 0Q-4 0 -7 3T-10 25V60",
          57682: "-24 327L-18 333H-1Q11 333 15 333T22 329T27 322T35 308T54 284Q115 203 225 162T441 120Q454 120 457 117T460 95V60V28Q460 8 457 4T442 0Q355 0 260 36Q75 118 -16 278L-24 292V327",
          57683: "-10 60V95Q-10 113 -7 116T9 120Q151 120 250 171T396 284Q404 293 412 305T424 324T431 331Q433 333 451 333H468L474 327V292L466 278Q375 118 190 36Q95 0 8 0Q-5 0 -7 3T-10 24V60",
          57684: "-10 0V120H410V0H-10"
        }, {
          57685: "\uE153\uE152",
          57686: "\uE151\uE150"
        });
      },
      5525: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.texVariant = void 0;
        var n = r(768),
          o = r(4926);
        e.texVariant = (0, n.AddPaths)(o.texVariant, {
          710: "1 561Q-3 563 -6 577T-12 604L-14 618Q-14 625 -7 628T23 635Q31 636 36 637Q63 641 621 745Q1148 845 1165 845Q1167 845 1752 739L2338 630Q2346 630 2346 618Q2340 565 2332 561Q2329 561 1749 654Q1617 675 1466 699T1241 736T1167 748Q1165 748 1093 737T867 700T583 654Q3 561 1 561",
          732: "804 788Q717 788 606 772T397 732T213 685T75 645T18 628Q11 628 11 632Q8 637 4 668T2 704Q2 713 36 732Q55 739 242 795Q622 898 826 898Q893 898 947 895Q1009 887 1056 872T1187 819Q1286 776 1356 758T1527 739Q1614 739 1725 755T1934 795T2118 842T2256 882T2313 899Q2320 899 2320 895Q2323 890 2327 860T2329 824Q2329 818 2296 795Q2273 787 2089 732Q1810 657 1598 632Q1562 629 1492 629Q1389 629 1320 644T1144 708Q1048 751 977 769T804 788",
          770: "-2332 561Q-2336 563 -2340 577T-2346 604L-2347 618Q-2347 625 -2340 628T-2310 635Q-2302 636 -2297 637Q-2270 641 -1712 745Q-1185 845 -1168 845Q-1166 845 -581 739L5 630Q13 630 13 618Q7 565 -1 561Q-4 561 -584 654Q-716 675 -867 699T-1092 736T-1166 748Q-1168 748 -1240 737T-1466 700T-1750 654Q-2330 561 -2332 561",
          771: "-1529 788Q-1616 788 -1727 772T-1936 732T-2120 685T-2258 645T-2315 628Q-2322 628 -2322 632Q-2325 637 -2329 668T-2331 704Q-2331 713 -2297 732Q-2278 739 -2091 795Q-1711 898 -1507 898Q-1440 898 -1386 895Q-1324 887 -1277 872T-1146 819Q-1047 776 -977 758T-806 739Q-719 739 -608 755T-399 795T-215 842T-77 882T-20 899Q-13 899 -13 895Q-10 890 -6 860T-4 824Q-4 818 -37 795Q-60 787 -244 732Q-523 657 -735 632Q-771 629 -841 629Q-944 629 -1013 644T-1189 708Q-1285 751 -1356 769T-1529 788",
          1008: "228 325Q170 322 156 316T127 309Q108 309 104 314Q99 319 99 322T108 341Q125 376 171 400T268 425H271Q302 425 319 396Q328 377 328 358Q328 332 324 314Q311 270 286 221Q274 194 274 192H275Q339 234 484 325T639 421Q669 434 691 434T723 425T734 406Q734 394 719 381Q715 376 644 330L575 287L566 267Q543 233 526 176Q520 160 515 143T508 115T506 105Q506 103 533 103Q585 103 607 110T641 118Q670 118 670 107Q670 100 661 85Q643 50 598 27T504 3Q465 3 450 36Q441 51 441 73Q441 84 444 96Q452 146 484 205L497 236L324 125Q143 12 135 10Q103 -6 77 -6Q61 -6 49 2T37 21Q37 36 49 46T124 96L195 141L204 156Q219 179 243 248T264 323Q264 325 228 325",
          8463: "182 599Q182 611 174 615T133 619Q118 619 114 621T109 630Q109 636 114 656T122 681Q125 685 202 688Q272 695 286 695Q304 695 304 684Q304 682 295 644T282 597Q282 592 360 592H399Q430 592 445 587T460 563Q460 552 451 541L442 535H266L251 468Q247 453 243 436T236 409T233 399Q233 395 244 404Q295 441 357 441Q405 441 445 417T485 333Q485 284 449 178T412 58T426 44Q447 44 466 68Q485 87 500 130L509 152H531H543Q562 152 562 144Q562 128 546 93T494 23T415 -13Q385 -13 359 3T322 44Q318 52 318 77Q318 99 352 196T386 337Q386 386 346 386Q318 386 286 370Q267 361 245 338T211 292Q207 287 193 235T162 113T138 21Q128 7 122 4Q105 -12 83 -12Q66 -12 54 -2T42 26L166 530Q166 534 161 534T129 535Q127 535 122 535T112 534Q74 534 74 562Q74 570 77 576T84 585T96 589T109 591T124 592T138 592L182 595V599",
          8592: "292 419Q292 400 261 347T211 275H306Q319 275 338 275T364 276Q399 276 410 271T422 250T411 230T366 225H306H211Q214 222 232 197T271 136T292 82Q292 71 285 68T262 64H250H241Q221 64 216 67T205 83Q186 127 153 167T78 230Q64 238 64 250Q64 258 69 263T82 272T106 288T139 318Q162 342 177 365T198 402T209 425T223 436Q224 437 252 437H258Q292 437 292 419",
          8594: "188 417Q188 437 221 437H233Q256 437 263 434T275 417Q294 373 327 333T402 270Q417 261 417 250Q417 241 410 236T382 217T341 182Q315 155 299 128T275 85T263 66Q259 64 231 64H219Q197 64 191 72T193 100Q202 124 215 147T239 185T257 210T267 223L269 225H174H116Q80 225 69 229T58 250T70 271T114 276Q121 276 140 276T174 275H269L267 277Q266 280 257 291T233 325T205 374Q188 408 188 417",
          8652: "755 512Q755 514 778 514H801L804 503Q805 501 812 486T824 462T839 437T862 408T892 381T932 354L944 347V327H507Q70 327 67 329Q55 335 55 347T67 365Q70 367 454 367H837L828 376Q803 403 785 437T761 489T755 512ZM55 153V173H492Q928 173 932 171Q944 166 944 153T932 135Q928 133 545 133H162L171 124Q198 95 216 61T239 8L244 -12Q244 -14 221 -14H198L195 -4Q160 95 67 146L55 153",
          8708: "55 676Q55 688 66 694H199L333 696L351 772Q364 827 370 843T386 860Q393 860 399 854T406 841Q406 836 391 765L375 696Q375 694 431 694H484Q491 688 497 681V12L493 5L486 1L353 -1H219L202 -79Q184 -153 180 -159Q175 -166 165 -166Q146 -166 146 -148Q146 -141 161 -76T177 -4Q177 -1 122 -1H68Q55 12 55 20T66 39H126L186 41L219 181Q226 215 234 251T246 305T251 325Q251 328 166 328H79Q68 345 68 347Q68 352 75 359L82 368H262L291 505Q298 539 306 575T319 630T324 650V654H68Q55 669 55 676ZM457 368V654H411Q366 654 366 652Q365 651 361 634T349 580T333 514Q303 373 302 372V368H457ZM457 39V328H375Q293 328 293 325Q292 322 260 183T228 41T344 39H457",
          8709: "624 470Q624 468 639 446T668 382T683 291Q683 181 612 99T437 -1Q425 -2 387 -2T337 -1Q245 18 193 70L179 81L131 39Q96 8 89 3T75 -3Q55 -3 55 17Q55 24 61 30T111 73Q154 113 151 113Q151 114 140 130T115 177T95 241Q94 253 94 291T95 341Q112 431 173 495Q265 587 385 587Q410 587 437 581Q522 571 582 513L595 501L642 541Q689 586 695 586Q696 586 697 586T699 587Q706 587 713 583T720 568Q720 560 711 551T664 510Q651 499 642 490T628 475T624 470ZM564 477Q517 522 448 539Q428 546 375 546Q290 546 229 492T144 370Q133 332 133 279Q136 228 151 195Q157 179 168 160T184 141Q186 141 375 307T564 477ZM642 290Q642 318 637 343T625 386T611 416T598 436T593 444Q590 444 402 277T213 108Q213 104 231 89T293 55T392 37Q495 37 568 111T642 290",
          8722: "84 237T84 250T98 270H402Q417 262 417 250T402 230H98Q84 237 84 250",
          8726: "91 404T91 410T97 423T111 430Q117 430 395 224Q676 13 678 10Q685 3 685 -3T678 -16T664 -23Q658 -23 380 184T98 397Q91 404 91 410",
          8733: "56 250Q56 346 122 409T276 472Q349 472 407 430T486 326L489 316Q490 317 493 326T501 345T514 367T531 393Q557 425 602 448T698 472Q722 472 722 452Q722 437 702 435T642 421T571 377Q520 323 520 250Q520 179 568 126T693 68Q722 66 722 48Q722 28 698 28Q636 28 576 67T493 174L490 184Q489 181 483 167T475 150T468 136T458 120T447 107T432 90T412 73Q350 28 277 28Q188 28 122 91T56 250ZM199 68T278 68T408 122T459 250Q459 322 414 370T308 430Q302 431 273 431Q204 431 150 380T96 250Q96 176 147 122",
          8739: "91 417Q104 430 111 430T131 417V-10Q116 -23 111 -23T91 -10V417",
          8740: "91 417Q104 430 111 430T131 417V301L171 341Q201 373 207 378T220 384Q227 384 233 377T240 366Q240 357 187 299L131 244V-10Q116 -23 111 -23T91 -10V201L49 157Q20 127 14 121T0 115Q-8 115 -14 121T-20 132Q-20 139 17 178Q29 191 36 199L91 257V417",
          8741: "55 417Q69 431 76 431T95 419V-12Q84 -23 76 -23Q72 -23 69 -22T62 -16T55 -10V417ZM293 419Q300 431 310 431L324 424L331 417V-10Q316 -23 309 -23L297 -19L293 -12V419",
          8742: "56 417Q68 431 76 431L89 426L96 419V317L98 215L193 273L291 330V375L293 419Q301 431 311 431Q331 431 331 388L333 355L356 370Q381 384 388 384Q394 384 400 377T407 363Q407 354 367 328L331 308V-10Q316 -23 310 -23Q300 -23 293 -12L291 135V284L98 168L96 77V-12Q84 -24 76 -24L62 -19L58 -12L56 66V144L31 128Q5 114 -2 114Q-8 114 -14 121T-20 136Q-20 142 -14 147T20 170L56 190V417",
          8764: "73 132Q55 132 55 172Q55 220 79 272Q95 301 111 319Q148 353 195 363Q199 364 212 364Q262 364 294 350T408 272Q472 222 522 212Q537 208 555 208Q606 208 646 243Q671 268 680 296T691 342T702 365Q713 365 716 354T719 314Q714 236 664 179L660 176Q657 173 654 170T644 163T631 154T615 146T596 139T574 134T549 132Q510 132 465 156T386 211T307 265T223 290Q162 290 124 249T86 165Q86 155 82 144T73 132",
          8776: "55 326Q55 394 101 437T226 481Q268 479 313 460T392 419T469 379T555 361Q622 361 662 401Q686 423 688 450Q693 479 702 479H705Q719 479 719 442Q719 367 670 327T554 286Q512 286 466 304T386 345T307 385T220 404Q184 404 157 394T120 374L111 363Q86 339 86 317Q86 288 71 288Q55 288 55 326ZM55 90Q55 164 105 205T226 246Q269 243 314 224T392 183T470 144T558 126Q622 126 662 166Q686 187 688 214Q693 244 704 244Q716 244 719 210Q719 165 702 132T658 82T605 58T552 50T498 58T447 77T384 110Q322 146 302 152Q263 168 220 168Q179 168 144 152Q128 147 107 125T86 81Q86 52 71 52Q55 52 55 90",
          8808: "86 472Q93 477 381 614T673 752Q680 752 686 746T693 732T689 721Q686 715 418 590L151 461L418 332Q684 207 689 201Q693 195 693 190Q693 183 687 177T675 170Q668 170 380 307T86 450Q82 454 82 461Q82 467 86 472ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
          8809: "89 745Q95 752 100 752Q106 752 394 615T689 472Q693 468 693 461T689 450Q684 445 396 308T100 170Q95 170 89 176T82 190Q82 195 86 201Q91 208 358 332L624 461L358 590Q90 715 86 721Q82 725 82 731Q82 739 89 745ZM369 101V126Q369 156 382 156H384Q385 157 386 157Q409 157 409 115V98V54H680Q693 39 693 34T680 14H409V-142H680Q693 -155 693 -162Q693 -167 680 -182H409V-273Q396 -284 388 -284Q382 -284 369 -275V-182H95Q82 -167 82 -162Q82 -155 95 -142H369V14H95Q93 17 89 21T84 27T82 34T83 40T89 47T95 54H369V101",
          8816: "82 34Q82 44 93 55H198L300 57L342 179Q351 207 362 238T378 286T384 303T238 377Q109 435 86 450Q82 454 82 460T86 472Q90 476 302 579L511 679Q512 679 553 795Q569 842 577 866T592 903T600 917T608 919Q615 919 622 912T629 901Q629 899 595 799Q589 777 581 753T569 717T564 703L618 728Q666 752 673 752T686 746T693 732Q693 723 683 717T615 683L546 650L491 488Q464 410 450 368T438 326Q493 297 562 266Q660 219 677 209T694 190Q694 183 690 177T678 171Q664 171 546 228L424 286Q422 286 382 172L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34ZM495 623Q495 626 493 626T321 544T151 461L398 343Q399 343 405 360T423 415T446 483Q457 513 469 551T488 606T495 623",
          8817: "97 172Q82 172 82 190Q82 197 86 201Q94 209 173 246T327 319T402 357Q405 360 434 448T462 539L278 628Q96 713 86 721Q82 725 82 732T88 745T102 752Q103 752 125 742T198 709T293 666Q342 642 385 622T453 590T478 579Q479 579 506 659T562 824T598 915Q602 919 609 919T622 913T629 901Q629 898 571 728Q546 656 531 608T518 559Q555 539 602 519Q664 488 679 479T694 461Q694 457 689 450Q680 443 616 413T494 356T435 326L389 190L342 57L513 55H682Q694 43 694 34Q694 28 689 21L682 17L506 15H329L322 -8Q320 -13 310 -41T295 -85L275 -141H680Q682 -143 684 -146T688 -151T691 -156T693 -162Q693 -172 682 -179L473 -181H262L220 -303Q192 -388 185 -404T166 -421Q160 -421 153 -415T146 -403Q146 -400 179 -302T220 -185Q220 -181 158 -181L93 -179L86 -174Q82 -169 82 -161Q82 -152 93 -141H164L233 -139L260 -63L286 15H189L93 17L86 21Q82 26 82 34Q82 44 93 55H198L300 57L342 179Q350 204 361 238T378 286T382 301L246 237Q111 172 97 172ZM624 461Q621 464 560 492Q512 518 503 518Q500 518 500 517Q499 513 488 479T465 413T453 379L624 461",
          8840: "82 -6Q82 1 95 14H262L295 94Q331 171 331 174Q324 175 312 178T267 194T206 227T146 283T98 368Q84 406 84 461T98 554Q126 632 194 685T349 750Q360 752 480 752H591L604 783Q620 819 624 821Q631 828 640 828Q653 825 658 810Q658 808 646 781L635 754Q635 752 658 752Q680 752 686 746Q693 739 693 732Q693 728 692 726T686 719T680 712H615L506 466Q479 407 451 344T408 248T393 214Q393 210 535 210H680Q693 194 693 190T680 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6ZM571 710Q571 712 469 712Q443 712 416 712T371 711T351 710Q279 700 221 656T138 548Q124 508 124 461T138 374Q186 245 351 212L460 459Q571 709 571 710",
          8841: "82 732Q82 739 95 752H251H348Q420 752 460 744T551 708Q566 697 566 701Q618 815 624 821Q631 828 640 828Q653 825 658 810L600 677Q600 671 615 656T653 605T689 517Q692 496 692 461T689 406Q668 325 615 266Q572 221 513 196T391 170H373L340 92L304 14H680Q693 1 693 -6Q693 -11 680 -26H286L253 -103L218 -179L451 -181H682Q694 -193 694 -201Q694 -212 682 -219L440 -221H200L178 -270Q160 -309 154 -319T139 -330Q122 -330 118 -312L155 -223Q155 -221 126 -221H95Q82 -206 82 -201T95 -181H175L206 -108Q237 -35 242 -30Q242 -26 169 -26H95Q82 -11 82 -6Q82 1 95 14H262L295 92L331 170H95Q93 172 91 175T87 180T84 185T82 191Q82 199 93 210H220L349 212L549 659Q507 692 462 702T338 712H249H95Q82 727 82 732ZM652 473Q652 513 636 552T603 611T582 632Q581 632 487 422T393 210Q424 210 460 220T535 253T605 316T649 410Q652 427 652 461V473",
          8842: "693 -115T693 -122T680 -144H315L269 -199Q221 -255 213 -255H212Q203 -255 197 -248T193 -231Q195 -225 229 -184L262 -144H186L113 -142L106 -137Q102 -130 102 -125Q102 -119 115 -104H298L426 52H386Q342 54 309 63Q236 79 180 129T98 249Q84 289 84 343Q84 398 98 436Q126 514 193 567T346 632Q347 632 373 632T440 633T520 634H680Q682 631 686 627T691 621T693 614T680 594H526Q364 594 353 592Q268 581 207 528T126 394Q123 378 123 343T126 292Q141 231 181 185T280 114Q329 92 415 92H462L506 147Q554 203 562 203H563Q572 203 578 196T582 178Q579 173 546 132L513 94L598 92H682Q693 81 693 73T680 52H480L349 -102L515 -104H682Q693 -115 693 -122",
          8843: "82 610T82 614T83 620T89 627T95 634H251Q378 634 409 633T469 623Q540 604 596 554T678 436Q691 397 691 343T678 249Q653 181 597 131T469 63Q427 52 362 52H315L213 -102L438 -104H662Q673 -115 673 -123Q673 -129 660 -144H186L151 -197Q114 -250 109 -253Q106 -254 104 -254Q100 -254 98 -253Q91 -253 87 -248T82 -235Q82 -230 109 -186L138 -144H115Q82 -144 82 -125Q82 -119 95 -104H166L266 49Q266 52 182 52H95Q82 65 82 72Q82 76 83 78T89 85T95 92H295L329 143Q365 195 369 198Q372 203 380 203Q385 203 391 197T398 185Q398 184 398 184L399 182Q399 175 369 129L344 94Q344 92 376 92Q402 92 422 94Q496 104 554 147T638 256Q651 295 651 343Q651 390 638 429Q613 494 555 537T422 592Q411 594 249 594H95Q82 610 82 614",
          8872: "55 678Q55 679 56 681T58 684T61 688T65 691T70 693T77 694Q88 692 95 679V464H540Q554 456 555 446Q555 442 554 439T552 434T549 430T546 428T542 426T539 424H95V270H539Q540 270 542 269T545 267T549 264T552 260T554 255T555 248Q554 238 540 230H95V15Q88 2 77 0Q73 0 70 1T65 3T61 6T59 9T57 13T55 16V678",
          8901: "71 0Q59 4 55 16V96L56 176Q59 180 66 187L70 189H209Q219 181 222 174V15Q219 10 209 1L140 0H71",
          8994: "77 122Q68 122 63 126T57 135T55 142Q55 151 68 176T111 235T177 302T271 356T388 378Q451 378 508 355T602 300T668 233T709 174T722 142Q722 124 704 122Q692 122 685 134T658 179T606 243Q511 338 390 338Q354 338 320 329Q251 312 193 263T97 141Q87 123 77 122",
          8995: "389 143Q324 143 266 164T171 215T107 277T67 330T55 358T60 371T77 378Q85 377 92 367T116 331T158 280Q256 182 389 182Q475 182 552 227T675 351Q688 378 704 378Q722 376 722 358Q722 352 710 330T670 276T605 215T511 164T389 143",
          9651: "99 -20Q84 -11 84 0Q84 5 148 145T278 424L342 563Q347 575 360 575Q368 575 375 570Q376 569 441 430T571 148T637 0Q637 -11 622 -20H99ZM476 260L360 509L248 266Q137 24 135 22Q135 20 360 20Q586 20 586 21L476 260",
          9661: "84 556Q84 567 99 576H622Q637 567 637 556Q637 551 572 409T441 127T375 -14Q368 -19 360 -19H358Q349 -19 342 -7T296 92Q249 193 211 275Q84 550 84 556ZM586 534Q586 536 361 536Q135 536 135 535L358 52L361 47L473 290Q584 532 586 534",
          10887: "102 168Q103 168 151 146T247 102T295 81Q299 85 322 144T344 206L218 268Q153 297 123 313T87 333T82 344T86 355Q104 369 291 455Q491 552 491 553L542 673Q581 767 590 784T609 801Q616 801 622 795T629 781Q629 773 586 677Q546 581 546 577L609 606Q669 635 673 635Q680 635 686 629T693 615Q693 610 692 608T670 593T604 561L524 521L400 226L542 157Q617 123 649 107T687 85T694 72Q694 66 690 60T679 54Q665 54 526 119Q394 186 386 186Q385 186 342 88L331 61L509 -23Q680 -105 688 -111Q693 -115 693 -122T688 -135T675 -141H673Q664 -141 491 -59Q320 21 316 21H315L249 -136Q183 -293 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -282 154 -261T181 -197T213 -119L280 41Q280 46 186 86Q157 101 121 119Q92 133 87 136T82 148Q82 155 88 161T102 168ZM418 370L466 495Q464 495 308 420T151 344T204 317T311 267T364 244Q364 247 418 370",
          10888: "97 54Q82 54 82 72Q82 79 86 84Q95 91 222 153L351 215L398 324L442 433L258 519Q95 597 87 604Q82 608 82 615T88 628T102 635Q107 635 424 484L458 468L524 630Q593 789 597 795Q601 801 609 801Q616 801 622 795T629 781L562 615L493 450L589 406Q665 371 679 362T694 344Q694 339 693 337T677 326T631 302T538 257Q504 241 465 223T406 195T386 186Q383 185 344 92T306 -3L486 81Q662 168 673 168Q680 168 686 162T693 148T689 137Q688 136 482 35L280 -59L233 -176Q184 -291 178 -299Q172 -303 166 -303T153 -297T146 -283Q146 -279 185 -186T224 -90Q225 -88 223 -88Q219 -88 193 -101Q109 -143 98 -143Q82 -138 82 -122Q82 -116 85 -113T108 -98T171 -67L249 -30L289 61Q297 81 307 107T321 144T326 157L218 106Q109 54 97 54ZM553 379Q480 412 480 415Q479 415 460 372T423 285T406 241Q408 240 516 291T624 344L553 379",
          10955: "82 -14T82 -7T95 15H431L529 170H435Q341 170 333 175Q149 218 98 368Q84 406 84 461Q84 515 98 555Q126 633 193 686T346 750Q347 750 373 750T440 751T520 752H680Q693 739 693 732Q693 727 680 712H526Q364 712 353 710Q268 700 207 646T126 512Q123 496 123 461T126 410Q141 350 180 304T280 232Q312 217 344 214T464 210H555L589 261Q613 301 620 311T635 321Q644 321 650 315T657 301Q657 296 651 286T630 252T604 212Q604 210 642 210H680Q693 197 693 190Q693 186 692 184T686 177T680 170H578L526 92L478 17L580 15H682Q693 4 693 -4T680 -25H451L353 -179L518 -181H682Q694 -193 694 -201Q694 -211 682 -219L504 -221H326L293 -272Q257 -332 246 -332Q238 -332 232 -326T225 -313Q225 -310 226 -308Q226 -305 251 -265T278 -223Q278 -221 186 -221H95Q93 -218 89 -214T84 -208T82 -201T95 -181H306L404 -25H249L93 -23L86 -19Q82 -14 82 -7",
          10956: "82 732Q82 739 95 752H251Q415 752 426 750Q539 736 615 657Q667 599 689 517Q692 496 692 461T689 406Q668 325 615 266Q522 170 382 170H355L326 95Q319 80 311 59T298 28T293 17Q293 15 486 15H680Q693 0 693 -6T680 -25H275L213 -179L449 -181H682Q693 -192 693 -199T680 -221H198L178 -270Q153 -333 139 -333Q132 -333 126 -327T119 -314T135 -266T153 -223Q153 -221 124 -221H95Q82 -207 82 -201T95 -181H171L233 -25H162L93 -23L86 -19Q82 -14 82 -7T95 15H251L313 170H202L93 172L86 177Q82 182 82 190Q82 199 93 210H211L329 212L349 261Q366 301 372 311T386 321Q392 321 399 315T407 302Q407 295 390 254T373 210Q374 209 377 209Q412 209 444 217Q512 231 564 273T638 377Q651 414 651 461Q651 509 638 548Q613 613 555 656T422 710Q411 712 249 712H95Q82 727 82 732"
        }, {});
      },
      5865: function _(t, e, r) {
        var _n116,
          o = this && this.__extends || (_n116 = function n(t, e) {
            return _n116 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n116(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n116(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MJContextMenu = void 0;
        var Q = r(5073),
          s = r(6186),
          T = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.mathItem = null, e.annotation = "", e.annotationTypes = {}, e;
            }
            return o(e, t), e.prototype.post = function (e, r) {
              if (this.mathItem) {
                if (void 0 !== r) {
                  var n = this.mathItem.inputJax.name,
                    o = this.findID("Show", "Original");
                  o.content = "MathML" === n ? "Original MathML" : n + " Commands", this.findID("Copy", "Original").content = o.content;
                  var i = this.findID("Settings", "semantics");
                  "MathML" === n ? i.disable() : i.enable(), this.getAnnotationMenu(), this.dynamicSubmenus();
                }
                t.prototype.post.call(this, e, r);
              }
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.mathItem = null;
            }, e.prototype.findID = function () {
              for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
              var o = this,
                a = null;
              try {
                for (var Q = i(r), T = Q.next(); !T.done; T = Q.next()) {
                  var l = T.value;
                  o ? (a = o.find(l), o = a instanceof s.Submenu ? a.submenu : null) : a = null;
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  T && !T.done && (e = Q.return) && e.call(Q);
                } finally {
                  if (t) throw t.error;
                }
              }
              return a;
            }, e.prototype.getAnnotationMenu = function () {
              var t = this,
                e = this.getAnnotations(this.getSemanticNode());
              this.createAnnotationMenu("Show", e, function () {
                return t.showAnnotation.post();
              }), this.createAnnotationMenu("Copy", e, function () {
                return t.copyAnnotation();
              });
            }, e.prototype.getSemanticNode = function () {
              for (var t = this.mathItem.root; t && !t.isKind("semantics");) {
                if (t.isToken || 1 !== t.childNodes.length) return null;
                t = t.childNodes[0];
              }
              return t;
            }, e.prototype.getAnnotations = function (t) {
              var e,
                r,
                n = [];
              if (!t) return n;
              try {
                for (var o = i(t.childNodes), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  if (Q.isKind("annotation")) {
                    var s = this.annotationMatch(Q);
                    if (s) {
                      var T = Q.childNodes.reduce(function (t, e) {
                        return t + e.toString();
                      }, "");
                      n.push([s, T]);
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return n;
            }, e.prototype.annotationMatch = function (t) {
              var e,
                r,
                n = t.attributes.get("encoding");
              try {
                for (var o = i(Object.keys(this.annotationTypes)), a = o.next(); !a.done; a = o.next()) {
                  var Q = a.value;
                  if (this.annotationTypes[Q].indexOf(n) >= 0) return Q;
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = o.return) && r.call(o);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e.prototype.createAnnotationMenu = function (t, e, r) {
              var n = this,
                o = this.findID(t, "Annotation");
              o.submenu = this.factory.get("subMenu")(this.factory, {
                items: e.map(function (t) {
                  var e = a(t, 2),
                    o = e[0],
                    i = e[1];
                  return {
                    type: "command",
                    id: o,
                    content: o,
                    action: function action() {
                      n.annotation = i, r();
                    }
                  };
                }),
                id: "annotations"
              }, o), e.length ? o.enable() : o.disable();
            }, e.prototype.dynamicSubmenus = function () {
              var t, r;
              try {
                for (var n = i(e.DynamicSubmenus), o = n.next(); !o.done; o = n.next()) {
                  var Q = a(o.value, 2),
                    s = Q[0],
                    T = Q[1],
                    l = this.find(s);
                  if (l) {
                    var c = T(this, l);
                    l.submenu = c, c.items.length ? l.enable() : l.disable();
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.DynamicSubmenus = new Map(), e;
          }(Q.ContextMenu);
        e.MJContextMenu = T;
      },
      8310: function _(t, e, r) {
        var n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__importDefault || function (t) {
            return t && t.__esModule ? t : {
              default: t
            };
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Menu = void 0;
        var a = r(5713),
          Q = r(4474),
          s = r(9515),
          T = r(7233),
          l = r(5865),
          c = r(473),
          u = r(4414),
          p = r(4922),
          h = r(6914),
          d = r(3463),
          f = r(7309),
          m = i(r(5445)),
          L = s.MathJax,
          y = "undefined" != typeof window && window.navigator && "Mac" === window.navigator.platform.substr(0, 3),
          g = function () {
            function t(t, e) {
              void 0 === e && (e = {});
              var r = this;
              this.settings = null, this.defaultSettings = null, this.menu = null, this.MmlVisitor = new c.MmlVisitor(), this.jax = {
                CHTML: null,
                SVG: null
              }, this.rerenderStart = Q.STATE.LAST, this.about = new p.Info('<b style="font-size:120%;">MathJax</b> v' + a.mathjax.version, function () {
                var t = [];
                return t.push("Input Jax: " + r.document.inputJax.map(function (t) {
                  return t.name;
                }).join(", ")), t.push("Output Jax: " + r.document.outputJax.name), t.push("Document Type: " + r.document.kind), t.join("<br/>");
              }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.help = new p.Info("<b>MathJax Help</b>", function () {
                return ["<p><b>MathJax</b> is a JavaScript library that allows page", " authors to include mathematics within their web pages.", " As a reader, you don't need to do anything to make that happen.</p>", "<p><b>Browsers</b>: MathJax works with all modern browsers including", " Edge, Firefox, Chrome, Safari, Opera, and most mobile browsers.</p>", "<p><b>Math Menu</b>: MathJax adds a contextual menu to equations.", " Right-click or CTRL-click on any mathematics to access the menu.</p>", '<div style="margin-left: 1em;">', "<p><b>Show Math As:</b> These options allow you to view the formula's", " source markup (as MathML or in its original format).</p>", "<p><b>Copy to Clipboard:</b> These options copy the formula's source markup,", " as MathML or in its original format, to the clipboard", " (in browsers that support that).</p>", "<p><b>Math Settings:</b> These give you control over features of MathJax,", " such the size of the mathematics, and the mechanism used", " to display equations.</p>", "<p><b>Accessibility</b>: MathJax can work with screen", " readers to make mathematics accessible to the visually impaired.", " Turn on the explorer to enable generation of speech strings", " and the ability to investigate expressions interactively.</p>", "<p><b>Language</b>: This menu lets you select the language used by MathJax", " for its menus and warning messages. (Not yet implemented in version 3.)</p>", "</div>", "<p><b>Math Zoom</b>: If you are having difficulty reading an", " equation, MathJax can enlarge it to help you see it better, or", " you can scall all the math on the page to make it larger.", " Turn these features on in the <b>Math Settings</b> menu.</p>", "<p><b>Preferences</b>: MathJax uses your browser's localStorage database", " to save the preferences set via this menu locally in your browser.  These", " are not used to track you, and are not transferred or used remotely by", " MathJax in any way.</p>"].join("\n");
              }, '<a href="https://www.mathjax.org">www.mathjax.org</a>'), this.mathmlCode = new u.SelectableInfo("MathJax MathML Expression", function () {
                if (!r.menu.mathItem) return "";
                var t = r.toMML(r.menu.mathItem);
                return "<pre>" + r.formatSource(t) + "</pre>";
              }, ""), this.originalText = new u.SelectableInfo("MathJax Original Source", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.mathItem.math;
                return '<pre style="font-size:125%; margin:0">' + r.formatSource(t) + "</pre>";
              }, ""), this.annotationText = new u.SelectableInfo("MathJax Annotation Text", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.annotation;
                return '<pre style="font-size:125%; margin:0">' + r.formatSource(t) + "</pre>";
              }, ""), this.zoomBox = new p.Info("MathJax Zoomed Expression", function () {
                if (!r.menu.mathItem) return "";
                var t = r.menu.mathItem.typesetRoot.cloneNode(!0);
                return t.style.margin = "0", '<div style="font-size: ' + 1.25 * parseFloat(r.settings.zscale) + '%">' + t.outerHTML + "</div>";
              }, ""), this.document = t, this.options = (0, T.userOptions)((0, T.defaultOptions)({}, this.constructor.OPTIONS), e), this.initSettings(), this.mergeUserSettings(), this.initMenu(), this.applySettings();
            }
            return Object.defineProperty(t.prototype, "isLoading", {
              get: function get() {
                return t.loading > 0;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "loadingPromise", {
              get: function get() {
                return this.isLoading ? (t._loadingPromise || (t._loadingPromise = new Promise(function (e, r) {
                  t._loadingOK = e, t._loadingFailed = r;
                })), t._loadingPromise) : Promise.resolve();
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.initSettings = function () {
              this.settings = this.options.settings, this.jax = this.options.jax;
              var t = this.document.outputJax;
              this.jax[t.name] = t, this.settings.renderer = t.name, L._.a11y && L._.a11y.explorer && Object.assign(this.settings, this.document.options.a11y), this.settings.scale = t.options.scale, this.defaultSettings = Object.assign({}, this.settings);
            }, t.prototype.initMenu = function () {
              var t = this,
                e = new h.Parser([["contextMenu", l.MJContextMenu.fromJson.bind(l.MJContextMenu)]]);
              this.menu = e.parse({
                type: "contextMenu",
                id: "MathJax_Menu",
                pool: [this.variable("texHints"), this.variable("semantics"), this.variable("zoom"), this.variable("zscale"), this.variable("renderer", function (e) {
                  return t.setRenderer(e);
                }), this.variable("alt"), this.variable("cmd"), this.variable("ctrl"), this.variable("shift"), this.variable("scale", function (e) {
                  return t.setScale(e);
                }), this.variable("explorer", function (e) {
                  return t.setExplorer(e);
                }), this.a11yVar("highlight"), this.a11yVar("backgroundColor"), this.a11yVar("backgroundOpacity"), this.a11yVar("foregroundColor"), this.a11yVar("foregroundOpacity"), this.a11yVar("speech"), this.a11yVar("subtitles"), this.a11yVar("braille"), this.a11yVar("viewBraille"), this.a11yVar("locale", function (t) {
                  return m.default.setupEngine({
                    locale: t
                  });
                }), this.a11yVar("speechRules", function (e) {
                  var r = n(e.split("-"), 2),
                    o = r[0],
                    i = r[1];
                  t.document.options.sre.domain = o, t.document.options.sre.style = i;
                }), this.a11yVar("magnification"), this.a11yVar("magnify"), this.a11yVar("treeColoring"), this.a11yVar("infoType"), this.a11yVar("infoRole"), this.a11yVar("infoPrefix"), this.variable("autocollapse"), this.variable("collapsible", function (e) {
                  return t.setCollapsible(e);
                }), this.variable("inTabOrder", function (e) {
                  return t.setTabOrder(e);
                }), this.variable("assistiveMml", function (e) {
                  return t.setAssistiveMml(e);
                })],
                items: [this.submenu("Show", "Show Math As", [this.command("MathMLcode", "MathML Code", function () {
                  return t.mathmlCode.post();
                }), this.command("Original", "Original Form", function () {
                  return t.originalText.post();
                }), this.submenu("Annotation", "Annotation")]), this.submenu("Copy", "Copy to Clipboard", [this.command("MathMLcode", "MathML Code", function () {
                  return t.copyMathML();
                }), this.command("Original", "Original Form", function () {
                  return t.copyOriginal();
                }), this.submenu("Annotation", "Annotation")]), this.rule(), this.submenu("Settings", "Math Settings", [this.submenu("Renderer", "Math Renderer", this.radioGroup("renderer", [["CHTML"], ["SVG"]])), this.rule(), this.submenu("ZoomTrigger", "Zoom Trigger", [this.command("ZoomNow", "Zoom Once Now", function () {
                  return t.zoom(null, "", t.menu.mathItem);
                }), this.rule(), this.radioGroup("zoom", [["Click"], ["DoubleClick", "Double-Click"], ["NoZoom", "No Zoom"]]), this.rule(), this.label("TriggerRequires", "Trigger Requires:"), this.checkbox(y ? "Option" : "Alt", y ? "Option" : "Alt", "alt"), this.checkbox("Command", "Command", "cmd", {
                  hidden: !y
                }), this.checkbox("Control", "Control", "ctrl", {
                  hiddne: y
                }), this.checkbox("Shift", "Shift", "shift")]), this.submenu("ZoomFactor", "Zoom Factor", this.radioGroup("zscale", [["150%"], ["175%"], ["200%"], ["250%"], ["300%"], ["400%"]])), this.rule(), this.command("Scale", "Scale All Math...", function () {
                  return t.scaleAllMath();
                }), this.rule(), this.checkbox("texHints", "Add TeX hints to MathML", "texHints"), this.checkbox("semantics", "Add original as annotation", "semantics"), this.rule(), this.command("Reset", "Reset to defaults", function () {
                  return t.resetDefaults();
                })]), this.submenu("Accessibility", "Accessibility", [this.checkbox("Activate", "Activate", "explorer"), this.submenu("Speech", "Speech", [this.checkbox("Speech", "Speech Output", "speech"), this.checkbox("Subtitles", "Speech Subtitles", "subtitles"), this.checkbox("Braille", "Braille Output", "braille"), this.checkbox("View Braille", "Braille Subtitles", "viewBraille"), this.rule(), this.submenu("A11yLanguage", "Language"), this.rule(), this.submenu("Mathspeak", "Mathspeak Rules", this.radioGroup("speechRules", [["mathspeak-default", "Verbose"], ["mathspeak-brief", "Brief"], ["mathspeak-sbrief", "Superbrief"]])), this.submenu("Clearspeak", "Clearspeak Rules", this.radioGroup("speechRules", [["clearspeak-default", "Auto"]])), this.submenu("ChromeVox", "ChromeVox Rules", this.radioGroup("speechRules", [["chromevox-default", "Standard"], ["chromevox-alternative", "Alternative"]]))]), this.submenu("Highlight", "Highlight", [this.submenu("Background", "Background", this.radioGroup("backgroundColor", [["Blue"], ["Red"], ["Green"], ["Yellow"], ["Cyan"], ["Magenta"], ["White"], ["Black"]])), {
                  type: "slider",
                  variable: "backgroundOpacity",
                  content: " "
                }, this.submenu("Foreground", "Foreground", this.radioGroup("foregroundColor", [["Black"], ["White"], ["Magenta"], ["Cyan"], ["Yellow"], ["Green"], ["Red"], ["Blue"]])), {
                  type: "slider",
                  variable: "foregroundOpacity",
                  content: " "
                }, this.rule(), this.radioGroup("highlight", [["None"], ["Hover"], ["Flame"]]), this.rule(), this.checkbox("TreeColoring", "Tree Coloring", "treeColoring")]), this.submenu("Magnification", "Magnification", [this.radioGroup("magnification", [["None"], ["Keyboard"], ["Mouse"]]), this.rule(), this.radioGroup("magnify", [["200%"], ["300%"], ["400%"], ["500%"]])]), this.submenu("Semantic Info", "Semantic Info", [this.checkbox("Type", "Type", "infoType"), this.checkbox("Role", "Role", "infoRole"), this.checkbox("Prefix", "Prefix", "infoPrefix")], !0), this.rule(), this.checkbox("Collapsible", "Collapsible Math", "collapsible"), this.checkbox("AutoCollapse", "Auto Collapse", "autocollapse", {
                  disabled: !0
                }), this.rule(), this.checkbox("InTabOrder", "Include in Tab Order", "inTabOrder"), this.checkbox("AssistiveMml", "Include Hidden MathML", "assistiveMml")]), this.submenu("Language", "Language"), this.rule(), this.command("About", "About MathJax", function () {
                  return t.about.post();
                }), this.command("Help", "MathJax Help", function () {
                  return t.help.post();
                })]
              });
              var r = this.menu;
              this.about.attachMenu(r), this.help.attachMenu(r), this.originalText.attachMenu(r), this.annotationText.attachMenu(r), this.mathmlCode.attachMenu(r), this.zoomBox.attachMenu(r), this.checkLoadableItems(), this.enableExplorerItems(this.settings.explorer), r.showAnnotation = this.annotationText, r.copyAnnotation = this.copyAnnotation.bind(this), r.annotationTypes = this.options.annotationTypes, f.CssStyles.addInfoStyles(this.document.document), f.CssStyles.addMenuStyles(this.document.document);
            }, t.prototype.checkLoadableItems = function () {
              var t, e;
              if (L && L._ && L.loader && L.startup) !this.settings.collapsible || L._.a11y && L._.a11y.complexity || this.loadA11y("complexity"), !this.settings.explorer || L._.a11y && L._.a11y.explorer || this.loadA11y("explorer"), !this.settings.assistiveMml || L._.a11y && L._.a11y["assistive-mml"] || this.loadA11y("assistive-mml");else {
                var r = this.menu;
                try {
                  for (var n = o(Object.keys(this.jax)), i = n.next(); !i.done; i = n.next()) {
                    var a = i.value;
                    this.jax[a] || r.findID("Settings", "Renderer", a).disable();
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    i && !i.done && (e = n.return) && e.call(n);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                r.findID("Accessibility", "Activate").disable(), r.findID("Accessibility", "AutoCollapse").disable(), r.findID("Accessibility", "Collapsible").disable();
              }
            }, t.prototype.enableExplorerItems = function (t) {
              var e,
                r,
                n = this.menu.findID("Accessibility", "Activate").menu;
              try {
                for (var i = o(n.items.slice(1)), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value;
                  if (Q instanceof d.Rule) break;
                  t ? Q.enable() : Q.disable();
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.mergeUserSettings = function () {
              try {
                var e = localStorage.getItem(t.MENU_STORAGE);
                if (!e) return;
                Object.assign(this.settings, JSON.parse(e)), this.setA11y(this.settings);
              } catch (t) {
                console.log("MathJax localStorage error: " + t.message);
              }
            }, t.prototype.saveUserSettings = function () {
              var e,
                r,
                n = {};
              try {
                for (var i = o(Object.keys(this.settings)), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value;
                  this.settings[Q] !== this.defaultSettings[Q] && (n[Q] = this.settings[Q]);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              try {
                Object.keys(n).length ? localStorage.setItem(t.MENU_STORAGE, JSON.stringify(n)) : localStorage.removeItem(t.MENU_STORAGE);
              } catch (t) {
                console.log("MathJax localStorage error: " + t.message);
              }
            }, t.prototype.setA11y = function (t) {
              L._.a11y && L._.a11y.explorer && L._.a11y.explorer_ts.setA11yOptions(this.document, t);
            }, t.prototype.getA11y = function (t) {
              if (L._.a11y && L._.a11y.explorer) return void 0 !== this.document.options.a11y[t] ? this.document.options.a11y[t] : this.document.options.sre[t];
            }, t.prototype.applySettings = function () {
              this.setTabOrder(this.settings.inTabOrder), this.document.options.enableAssistiveMml = this.settings.assistiveMml, this.document.outputJax.options.scale = parseFloat(this.settings.scale), this.settings.renderer !== this.defaultSettings.renderer && this.setRenderer(this.settings.renderer);
            }, t.prototype.setScale = function (t) {
              this.document.outputJax.options.scale = parseFloat(t), this.document.rerender();
            }, t.prototype.setRenderer = function (t) {
              var e = this;
              if (this.jax[t]) this.setOutputJax(t);else {
                var r = t.toLowerCase();
                this.loadComponent("output/" + r, function () {
                  var n = L.startup;
                  r in n.constructors && (n.useOutput(r, !0), n.output = n.getOutputJax(), e.jax[t] = n.output, e.setOutputJax(t));
                });
              }
            }, t.prototype.setOutputJax = function (t) {
              this.jax[t].setAdaptor(this.document.adaptor), this.document.outputJax = this.jax[t], this.rerender();
            }, t.prototype.setTabOrder = function (t) {
              this.menu.store.inTaborder(t);
            }, t.prototype.setAssistiveMml = function (t) {
              this.document.options.enableAssistiveMml = t, !t || L._.a11y && L._.a11y["assistive-mml"] ? this.rerender() : this.loadA11y("assistive-mml");
            }, t.prototype.setExplorer = function (t) {
              this.enableExplorerItems(t), this.document.options.enableExplorer = t, !t || L._.a11y && L._.a11y.explorer ? this.rerender(this.settings.collapsible ? Q.STATE.RERENDER : Q.STATE.COMPILED) : this.loadA11y("explorer");
            }, t.prototype.setCollapsible = function (t) {
              this.document.options.enableComplexity = t, !t || L._.a11y && L._.a11y.complexity ? this.rerender(Q.STATE.COMPILED) : this.loadA11y("complexity");
            }, t.prototype.scaleAllMath = function () {
              var t = (100 * parseFloat(this.settings.scale)).toFixed(1).replace(/.0$/, ""),
                e = prompt("Scale all mathematics (compared to surrounding text) by", t + "%");
              if (e) if (e.match(/^\s*\d+(\.\d*)?\s*%?\s*$/)) {
                var r = parseFloat(e) / 100;
                r ? this.menu.pool.lookup("scale").setValue(String(r)) : alert("The scale should not be zero");
              } else alert("The scale should be a percentage (e.g., 120%)");
            }, t.prototype.resetDefaults = function () {
              var e, r;
              t.loading++;
              var n = this.menu.pool,
                i = this.defaultSettings;
              try {
                for (var a = o(Object.keys(this.settings)), s = a.next(); !s.done; s = a.next()) {
                  var T = s.value,
                    l = n.lookup(T);
                  if (l) {
                    l.setValue(i[T]);
                    var c = l.items[0];
                    c && c.executeCallbacks_();
                  } else this.settings[T] = i[T];
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (r = a.return) && r.call(a);
                } finally {
                  if (e) throw e.error;
                }
              }
              t.loading--, this.rerender(Q.STATE.COMPILED);
            }, t.prototype.checkComponent = function (e) {
              var r = t.loadingPromises.get(e);
              r && a.mathjax.retryAfter(r);
            }, t.prototype.loadComponent = function (e, r) {
              if (!t.loadingPromises.has(e)) {
                var n = L.loader;
                if (n) {
                  t.loading++;
                  var o = n.load(e).then(function () {
                    t.loading--, t.loadingPromises.delete(e), r(), 0 === t.loading && t._loadingPromise && (t._loadingPromise = null, t._loadingOK());
                  }).catch(function (e) {
                    t._loadingPromise ? (t._loadingPromise = null, t._loadingFailed(e)) : console.log(e);
                  });
                  t.loadingPromises.set(e, o);
                }
              }
            }, t.prototype.loadA11y = function (e) {
              var r = this,
                n = !Q.STATE.ENRICHED;
              this.loadComponent("a11y/" + e, function () {
                var o = L.startup;
                a.mathjax.handlers.unregister(o.handler), o.handler = o.getHandler(), a.mathjax.handlers.register(o.handler);
                var i = r.document;
                r.document = o.document = o.getDocument(), r.document.menu = r, r.document.outputJax.reset(), r.transferMathList(i), r.document.processed = i.processed, t._loadingPromise || (r.document.outputJax.reset(), r.rerender("complexity" === e || n ? Q.STATE.COMPILED : Q.STATE.TYPESET));
              });
            }, t.prototype.transferMathList = function (t) {
              var e,
                r,
                n = this.document.options.MathItem;
              try {
                for (var i = o(t.math), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value,
                    s = new n();
                  Object.assign(s, Q), this.document.math.push(s);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
            }, t.prototype.formatSource = function (t) {
              return t.trim().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }, t.prototype.toMML = function (t) {
              return this.MmlVisitor.visitTree(t.root, t, {
                texHints: this.settings.texHints,
                semantics: this.settings.semantics && "MathML" !== t.inputJax.name
              });
            }, t.prototype.zoom = function (t, e, r) {
              t && !this.isZoomEvent(t, e) || (this.menu.mathItem = r, t && this.menu.post(t), this.zoomBox.post());
            }, t.prototype.isZoomEvent = function (t, e) {
              return this.settings.zoom === e && (!this.settings.alt || t.altKey) && (!this.settings.ctrl || t.ctrlKey) && (!this.settings.cmd || t.metaKey) && (!this.settings.shift || t.shiftKey);
            }, t.prototype.rerender = function (e) {
              void 0 === e && (e = Q.STATE.TYPESET), this.rerenderStart = Math.min(e, this.rerenderStart), t.loading || (this.rerenderStart <= Q.STATE.COMPILED && this.document.reset({
                inputJax: []
              }), this.document.rerender(this.rerenderStart), this.rerenderStart = Q.STATE.LAST);
            }, t.prototype.copyMathML = function () {
              this.copyToClipboard(this.toMML(this.menu.mathItem));
            }, t.prototype.copyOriginal = function () {
              this.copyToClipboard(this.menu.mathItem.math.trim());
            }, t.prototype.copyAnnotation = function () {
              this.copyToClipboard(this.menu.annotation.trim());
            }, t.prototype.copyToClipboard = function (t) {
              var e = document.createElement("textarea");
              e.value = t, e.setAttribute("readonly", ""), e.style.cssText = "height: 1px; width: 1px; padding: 1px; position: absolute; left: -10px", document.body.appendChild(e), e.select();
              try {
                document.execCommand("copy");
              } catch (t) {
                alert("Can't copy to clipboard: " + t.message);
              }
              document.body.removeChild(e);
            }, t.prototype.addMenu = function (t) {
              var e = this,
                r = t.typesetRoot;
              r.addEventListener("contextmenu", function () {
                return e.menu.mathItem = t;
              }, !0), r.addEventListener("keydown", function () {
                return e.menu.mathItem = t;
              }, !0), r.addEventListener("click", function (r) {
                return e.zoom(r, "Click", t);
              }, !0), r.addEventListener("dblclick", function (r) {
                return e.zoom(r, "DoubleClick", t);
              }, !0), this.menu.store.insert(r);
            }, t.prototype.clear = function () {
              this.menu.store.clear();
            }, t.prototype.variable = function (t, e) {
              var r = this;
              return {
                name: t,
                getter: function getter() {
                  return r.settings[t];
                },
                setter: function setter(n) {
                  r.settings[t] = n, e && e(n), r.saveUserSettings();
                }
              };
            }, t.prototype.a11yVar = function (t, e) {
              var r = this;
              return {
                name: t,
                getter: function getter() {
                  return r.getA11y(t);
                },
                setter: function setter(n) {
                  r.settings[t] = n;
                  var o = {};
                  o[t] = n, r.setA11y(o), e && e(n), r.saveUserSettings();
                }
              };
            }, t.prototype.submenu = function (t, e, r, n) {
              var i, a;
              void 0 === r && (r = []), void 0 === n && (n = !1);
              var Q = [];
              try {
                for (var s = o(r), T = s.next(); !T.done; T = s.next()) {
                  var l = T.value;
                  Array.isArray(l) ? Q = Q.concat(l) : Q.push(l);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  T && !T.done && (a = s.return) && a.call(s);
                } finally {
                  if (i) throw i.error;
                }
              }
              return {
                type: "submenu",
                id: t,
                content: e,
                menu: {
                  items: Q
                },
                disabled: 0 === Q.length || n
              };
            }, t.prototype.command = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "command",
                id: t,
                content: e,
                action: r
              }, n);
            }, t.prototype.checkbox = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "checkbox",
                id: t,
                content: e,
                variable: r
              }, n);
            }, t.prototype.radioGroup = function (t, e) {
              var r = this;
              return e.map(function (e) {
                return r.radio(e[0], e[1] || e[0], t);
              });
            }, t.prototype.radio = function (t, e, r, n) {
              return void 0 === n && (n = {}), Object.assign({
                type: "radio",
                id: t,
                content: e,
                variable: r
              }, n);
            }, t.prototype.label = function (t, e) {
              return {
                type: "label",
                id: t,
                content: e
              };
            }, t.prototype.rule = function () {
              return {
                type: "rule"
              };
            }, t.MENU_STORAGE = "MathJax-Menu-Settings", t.OPTIONS = {
              settings: {
                texHints: !0,
                semantics: !1,
                zoom: "NoZoom",
                zscale: "200%",
                renderer: "CHTML",
                alt: !1,
                cmd: !1,
                ctrl: !1,
                shift: !1,
                scale: 1,
                autocollapse: !1,
                collapsible: !1,
                inTabOrder: !0,
                assistiveMml: !0,
                explorer: !1
              },
              jax: {
                CHTML: null,
                SVG: null
              },
              annotationTypes: (0, T.expandable)({
                TeX: ["TeX", "LaTeX", "application/x-tex"],
                StarMath: ["StarMath 5.0"],
                Maple: ["Maple"],
                ContentMathML: ["MathML-Content", "application/mathml-content+xml"],
                OpenMath: ["OpenMath"]
              })
            }, t.loading = 0, t.loadingPromises = new Map(), t._loadingPromise = null, t._loadingOK = null, t._loadingFailed = null, t;
          }();
        e.Menu = g;
      },
      4001: function _(t, e, r) {
        var _n117,
          o = this && this.__extends || (_n117 = function n(t, e) {
            return _n117 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n117(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n117(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) for (var o in e = arguments[r]) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
              return t;
            }, i.apply(this, arguments);
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          s = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuHandler = e.MenuMathDocumentMixin = e.MenuMathItemMixin = void 0;
        var T = r(5713),
          l = r(4474),
          c = r(7233),
          u = r(8310);
        function p(t) {
          return function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addMenu = function (t, e) {
              void 0 === e && (e = !1), this.state() >= l.STATE.CONTEXT_MENU || (this.isEscaped || !t.options.enableMenu && !e || t.menu.addMenu(this), this.state(l.STATE.CONTEXT_MENU));
            }, e.prototype.checkLoading = function (t) {
              t.checkLoading();
            }, e;
          }(t);
        }
        function h(t) {
          var e;
          return e = function (t) {
            function e() {
              for (var e = [], r = 0; r < arguments.length; r++) e[r] = arguments[r];
              var n = t.apply(this, Q([], a(e), !1)) || this;
              n.menu = new n.options.MenuClass(n, n.options.menuOptions);
              var o = n.constructor.ProcessBits;
              return o.has("context-menu") || o.allocate("context-menu"), n.options.MathItem = p(n.options.MathItem), n;
            }
            return o(e, t), e.prototype.addMenu = function () {
              var t, e;
              if (!this.processed.isSet("context-menu")) {
                try {
                  for (var r = s(this.math), n = r.next(); !n.done; n = r.next()) {
                    n.value.addMenu(this);
                  }
                } catch (e) {
                  t = {
                    error: e
                  };
                } finally {
                  try {
                    n && !n.done && (e = r.return) && e.call(r);
                  } finally {
                    if (t) throw t.error;
                  }
                }
                this.processed.set("context-menu");
              }
              return this;
            }, e.prototype.checkLoading = function () {
              this.menu.isLoading && T.mathjax.retryAfter(this.menu.loadingPromise.catch(function (t) {
                return console.log(t);
              }));
              var t = this.menu.settings;
              return t.collapsible && (this.options.enableComplexity = !0, this.menu.checkComponent("a11y/complexity")), t.explorer && (this.options.enableEnrichment = !0, this.options.enableExplorer = !0, this.menu.checkComponent("a11y/explorer")), this;
            }, e.prototype.state = function (e, r) {
              return void 0 === r && (r = !1), t.prototype.state.call(this, e, r), e < l.STATE.CONTEXT_MENU && this.processed.clear("context-menu"), this;
            }, e.prototype.updateDocument = function () {
              return t.prototype.updateDocument.call(this), this.menu.menu.store.sort(), this;
            }, e;
          }(t), e.OPTIONS = i(i({
            enableEnrichment: !0,
            enableComplexity: !0,
            enableExplorer: !0,
            enrichSpeech: "none",
            enrichError: function enrichError(t, e, r) {
              return console.warn("Enrichment Error:", r);
            }
          }, t.OPTIONS), {
            MenuClass: u.Menu,
            menuOptions: u.Menu.OPTIONS,
            enableMenu: !0,
            sre: t.OPTIONS.sre || (0, c.expandable)({}),
            a11y: t.OPTIONS.a11y || (0, c.expandable)({}),
            renderActions: (0, c.expandable)(i(i({}, t.OPTIONS.renderActions), {
              addMenu: [l.STATE.CONTEXT_MENU],
              checkLoading: [l.STATE.UNPROCESSED + 1]
            }))
          }), e;
        }
        (0, l.newState)("CONTEXT_MENU", 170), e.MenuMathItemMixin = p, e.MenuMathDocumentMixin = h, e.MenuHandler = function (t) {
          return t.documentClass = h(t.documentClass), t;
        };
      },
      473: function _(t, e, r) {
        var _n118,
          o = this && this.__extends || (_n118 = function n(t, e) {
            return _n118 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n118(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n118(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlVisitor = void 0;
        var i = r(9259),
          a = r(7233),
          Q = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.options = {
                texHints: !0,
                semantics: !1
              }, e.mathItem = null, e;
            }
            return o(e, t), e.prototype.visitTree = function (t, e, r) {
              return void 0 === e && (e = null), void 0 === r && (r = {}), this.mathItem = e, (0, a.userOptions)(this.options, r), this.visitNode(t, "");
            }, e.prototype.visitTeXAtomNode = function (e, r) {
              return this.options.texHints ? t.prototype.visitTeXAtomNode.call(this, e, r) : e.childNodes[0] && 1 === e.childNodes[0].childNodes.length ? this.visitNode(e.childNodes[0], r) : r + "<mrow" + this.getAttributes(e) + ">\n" + this.childNodeMml(e, r + "  ", "\n") + r + "</mrow>";
            }, e.prototype.visitMathNode = function (e, r) {
              if (!this.options.semantics || "TeX" !== this.mathItem.inputJax.name) return t.prototype.visitDefault.call(this, e, r);
              var n = e.childNodes.length && e.childNodes[0].childNodes.length > 1;
              return r + "<math" + this.getAttributes(e) + ">\n" + r + "  <semantics>\n" + (n ? r + "    <mrow>\n" : "") + this.childNodeMml(e, r + (n ? "      " : "    "), "\n") + (n ? r + "    </mrow>\n" : "") + r + '    <annotation encoding="application/x-tex">' + this.mathItem.math + "</annotation>\n" + r + "  </semantics>\n" + r + "</math>";
            }, e;
          }(i.SerializedMmlVisitor);
        e.MmlVisitor = Q;
      },
      4414: function _(t, e, r) {
        var _n119,
          o = this && this.__extends || (_n119 = function n(t, e) {
            return _n119 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n119(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n119(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectableInfo = void 0;
        var i = r(4922),
          a = r(2165),
          Q = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return o(e, t), e.prototype.addEvents = function (t) {
              var e = this;
              t.addEventListener("keypress", function (t) {
                "a" === t.key && (t.ctrlKey || t.metaKey) && (e.selectAll(), e.stop(t));
              });
            }, e.prototype.selectAll = function () {
              document.getSelection().selectAllChildren(this.html.querySelector("pre"));
            }, e.prototype.copyToClipboard = function () {
              this.selectAll();
              try {
                document.execCommand("copy");
              } catch (t) {
                alert("Can't copy to clipboard: " + t.message);
              }
              document.getSelection().removeAllRanges();
            }, e.prototype.generateHtml = function () {
              var e = this;
              t.prototype.generateHtml.call(this);
              var r = this.html.querySelector("span." + a.HtmlClasses.INFOSIGNATURE).appendChild(document.createElement("input"));
              r.type = "button", r.value = "Copy to Clipboard", r.addEventListener("click", function (t) {
                return e.copyToClipboard();
              });
            }, e;
          }(i.Info);
        e.SelectableInfo = Q;
      },
      9923: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.asyncLoad = void 0;
        var n = r(5713);
        e.asyncLoad = function (t) {
          return n.mathjax.asyncLoad ? new Promise(function (e, r) {
            var o = n.mathjax.asyncLoad(t);
            o instanceof Promise ? o.then(function (t) {
              return e(t);
            }).catch(function (t) {
              return r(t);
            }) : e(o);
          }) : Promise.reject("Can't load '".concat(t, "': No asyncLoad method specified"));
        };
      },
      6469: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BBox = void 0;
        var n = r(6010),
          o = function () {
            function t(t) {
              void 0 === t && (t = {
                w: 0,
                h: -n.BIGDIMEN,
                d: -n.BIGDIMEN
              }), this.w = t.w || 0, this.h = "h" in t ? t.h : -n.BIGDIMEN, this.d = "d" in t ? t.d : -n.BIGDIMEN, this.L = this.R = this.ic = this.sk = this.dx = 0, this.scale = this.rscale = 1, this.pwidth = "";
            }
            return t.zero = function () {
              return new t({
                h: 0,
                d: 0,
                w: 0
              });
            }, t.empty = function () {
              return new t();
            }, t.prototype.empty = function () {
              return this.w = 0, this.h = this.d = -n.BIGDIMEN, this;
            }, t.prototype.clean = function () {
              this.w === -n.BIGDIMEN && (this.w = 0), this.h === -n.BIGDIMEN && (this.h = 0), this.d === -n.BIGDIMEN && (this.d = 0);
            }, t.prototype.rescale = function (t) {
              this.w *= t, this.h *= t, this.d *= t;
            }, t.prototype.combine = function (t, e, r) {
              void 0 === e && (e = 0), void 0 === r && (r = 0);
              var n = t.rscale,
                o = e + n * (t.w + t.L + t.R),
                i = r + n * t.h,
                a = n * t.d - r;
              o > this.w && (this.w = o), i > this.h && (this.h = i), a > this.d && (this.d = a);
            }, t.prototype.append = function (t) {
              var e = t.rscale;
              this.w += e * (t.w + t.L + t.R), e * t.h > this.h && (this.h = e * t.h), e * t.d > this.d && (this.d = e * t.d);
            }, t.prototype.updateFrom = function (t) {
              this.h = t.h, this.d = t.d, this.w = t.w, t.pwidth && (this.pwidth = t.pwidth);
            }, t.fullWidth = "100%", t.StyleAdjust = [["borderTopWidth", "h"], ["borderRightWidth", "w"], ["borderBottomWidth", "d"], ["borderLeftWidth", "w", 0], ["paddingTop", "h"], ["paddingRight", "w"], ["paddingBottom", "d"], ["paddingLeft", "w", 0]], t;
          }();
        e.BBox = o;
      },
      6751: function _(t, e) {
        var _r21,
          n = this && this.__extends || (_r21 = function r(t, e) {
            return _r21 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _r21(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function n() {
              this.constructor = t;
            }
            _r21(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
          }),
          o = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          a = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BitFieldClass = e.BitField = void 0;
        var Q = function () {
          function t() {
            this.bits = 0;
          }
          return t.allocate = function () {
            for (var e, r, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
            try {
              for (var a = o(n), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                if (this.has(s)) throw new Error("Bit already allocated for " + s);
                if (this.next === t.MAXBIT) throw new Error("Maximum number of bits already allocated");
                this.names.set(s, this.next), this.next <<= 1;
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (r = a.return) && r.call(a);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.has = function (t) {
            return this.names.has(t);
          }, t.prototype.set = function (t) {
            this.bits |= this.getBit(t);
          }, t.prototype.clear = function (t) {
            this.bits &= ~this.getBit(t);
          }, t.prototype.isSet = function (t) {
            return !!(this.bits & this.getBit(t));
          }, t.prototype.reset = function () {
            this.bits = 0;
          }, t.prototype.getBit = function (t) {
            var e = this.constructor.names.get(t);
            if (!e) throw new Error("Unknown bit-field name: " + t);
            return e;
          }, t.MAXBIT = 1 << 31, t.next = 1, t.names = new Map(), t;
        }();
        e.BitField = Q, e.BitFieldClass = function () {
          for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
          var r = function (t) {
            function e() {
              return null !== t && t.apply(this, arguments) || this;
            }
            return n(e, t), e;
          }(Q);
          return r.allocate.apply(r, a([], i(t), !1)), r;
        };
      },
      5368: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.numeric = e.translate = e.remove = e.add = e.entities = e.options = void 0;
        var n = r(4542),
          o = r(9923);
        e.options = {
          loadMissingEntities: !0
        }, e.entities = {
          ApplyFunction: "\u2061",
          Backslash: "\u2216",
          Because: "\u2235",
          Breve: "\u02D8",
          Cap: "\u22D2",
          CenterDot: "\xb7",
          CircleDot: "\u2299",
          CircleMinus: "\u2296",
          CirclePlus: "\u2295",
          CircleTimes: "\u2297",
          Congruent: "\u2261",
          ContourIntegral: "\u222E",
          Coproduct: "\u2210",
          Cross: "\u2A2F",
          Cup: "\u22D3",
          CupCap: "\u224D",
          Dagger: "\u2021",
          Del: "\u2207",
          Delta: "\u0394",
          Diamond: "\u22C4",
          DifferentialD: "\u2146",
          DotEqual: "\u2250",
          DoubleDot: "\xa8",
          DoubleRightTee: "\u22A8",
          DoubleVerticalBar: "\u2225",
          DownArrow: "\u2193",
          DownLeftVector: "\u21BD",
          DownRightVector: "\u21C1",
          DownTee: "\u22A4",
          Downarrow: "\u21D3",
          Element: "\u2208",
          EqualTilde: "\u2242",
          Equilibrium: "\u21CC",
          Exists: "\u2203",
          ExponentialE: "\u2147",
          FilledVerySmallSquare: "\u25AA",
          ForAll: "\u2200",
          Gamma: "\u0393",
          Gg: "\u22D9",
          GreaterEqual: "\u2265",
          GreaterEqualLess: "\u22DB",
          GreaterFullEqual: "\u2267",
          GreaterLess: "\u2277",
          GreaterSlantEqual: "\u2A7E",
          GreaterTilde: "\u2273",
          Hacek: "\u02C7",
          Hat: "^",
          HumpDownHump: "\u224E",
          HumpEqual: "\u224F",
          Im: "\u2111",
          ImaginaryI: "\u2148",
          Integral: "\u222B",
          Intersection: "\u22C2",
          InvisibleComma: "\u2063",
          InvisibleTimes: "\u2062",
          Lambda: "\u039B",
          Larr: "\u219E",
          LeftAngleBracket: "\u27E8",
          LeftArrow: "\u2190",
          LeftArrowRightArrow: "\u21C6",
          LeftCeiling: "\u2308",
          LeftDownVector: "\u21C3",
          LeftFloor: "\u230A",
          LeftRightArrow: "\u2194",
          LeftTee: "\u22A3",
          LeftTriangle: "\u22B2",
          LeftTriangleEqual: "\u22B4",
          LeftUpVector: "\u21BF",
          LeftVector: "\u21BC",
          Leftarrow: "\u21D0",
          Leftrightarrow: "\u21D4",
          LessEqualGreater: "\u22DA",
          LessFullEqual: "\u2266",
          LessGreater: "\u2276",
          LessSlantEqual: "\u2A7D",
          LessTilde: "\u2272",
          Ll: "\u22D8",
          Lleftarrow: "\u21DA",
          LongLeftArrow: "\u27F5",
          LongLeftRightArrow: "\u27F7",
          LongRightArrow: "\u27F6",
          Longleftarrow: "\u27F8",
          Longleftrightarrow: "\u27FA",
          Longrightarrow: "\u27F9",
          Lsh: "\u21B0",
          MinusPlus: "\u2213",
          NestedGreaterGreater: "\u226B",
          NestedLessLess: "\u226A",
          NotDoubleVerticalBar: "\u2226",
          NotElement: "\u2209",
          NotEqual: "\u2260",
          NotExists: "\u2204",
          NotGreater: "\u226F",
          NotGreaterEqual: "\u2271",
          NotLeftTriangle: "\u22EA",
          NotLeftTriangleEqual: "\u22EC",
          NotLess: "\u226E",
          NotLessEqual: "\u2270",
          NotPrecedes: "\u2280",
          NotPrecedesSlantEqual: "\u22E0",
          NotRightTriangle: "\u22EB",
          NotRightTriangleEqual: "\u22ED",
          NotSubsetEqual: "\u2288",
          NotSucceeds: "\u2281",
          NotSucceedsSlantEqual: "\u22E1",
          NotSupersetEqual: "\u2289",
          NotTilde: "\u2241",
          NotVerticalBar: "\u2224",
          Omega: "\u03A9",
          OverBar: "\u203E",
          OverBrace: "\u23DE",
          PartialD: "\u2202",
          Phi: "\u03A6",
          Pi: "\u03A0",
          PlusMinus: "\xb1",
          Precedes: "\u227A",
          PrecedesEqual: "\u2AAF",
          PrecedesSlantEqual: "\u227C",
          PrecedesTilde: "\u227E",
          Product: "\u220F",
          Proportional: "\u221D",
          Psi: "\u03A8",
          Rarr: "\u21A0",
          Re: "\u211C",
          ReverseEquilibrium: "\u21CB",
          RightAngleBracket: "\u27E9",
          RightArrow: "\u2192",
          RightArrowLeftArrow: "\u21C4",
          RightCeiling: "\u2309",
          RightDownVector: "\u21C2",
          RightFloor: "\u230B",
          RightTee: "\u22A2",
          RightTeeArrow: "\u21A6",
          RightTriangle: "\u22B3",
          RightTriangleEqual: "\u22B5",
          RightUpVector: "\u21BE",
          RightVector: "\u21C0",
          Rightarrow: "\u21D2",
          Rrightarrow: "\u21DB",
          Rsh: "\u21B1",
          Sigma: "\u03A3",
          SmallCircle: "\u2218",
          Sqrt: "\u221A",
          Square: "\u25A1",
          SquareIntersection: "\u2293",
          SquareSubset: "\u228F",
          SquareSubsetEqual: "\u2291",
          SquareSuperset: "\u2290",
          SquareSupersetEqual: "\u2292",
          SquareUnion: "\u2294",
          Star: "\u22C6",
          Subset: "\u22D0",
          SubsetEqual: "\u2286",
          Succeeds: "\u227B",
          SucceedsEqual: "\u2AB0",
          SucceedsSlantEqual: "\u227D",
          SucceedsTilde: "\u227F",
          SuchThat: "\u220B",
          Sum: "\u2211",
          Superset: "\u2283",
          SupersetEqual: "\u2287",
          Supset: "\u22D1",
          Therefore: "\u2234",
          Theta: "\u0398",
          Tilde: "\u223C",
          TildeEqual: "\u2243",
          TildeFullEqual: "\u2245",
          TildeTilde: "\u2248",
          UnderBar: "_",
          UnderBrace: "\u23DF",
          Union: "\u22C3",
          UnionPlus: "\u228E",
          UpArrow: "\u2191",
          UpDownArrow: "\u2195",
          UpTee: "\u22A5",
          Uparrow: "\u21D1",
          Updownarrow: "\u21D5",
          Upsilon: "\u03A5",
          Vdash: "\u22A9",
          Vee: "\u22C1",
          VerticalBar: "\u2223",
          VerticalTilde: "\u2240",
          Vvdash: "\u22AA",
          Wedge: "\u22C0",
          Xi: "\u039E",
          amp: "&",
          acute: "\xb4",
          aleph: "\u2135",
          alpha: "\u03B1",
          amalg: "\u2A3F",
          and: "\u2227",
          ang: "\u2220",
          angmsd: "\u2221",
          angsph: "\u2222",
          ape: "\u224A",
          backprime: "\u2035",
          backsim: "\u223D",
          backsimeq: "\u22CD",
          beta: "\u03B2",
          beth: "\u2136",
          between: "\u226C",
          bigcirc: "\u25EF",
          bigodot: "\u2A00",
          bigoplus: "\u2A01",
          bigotimes: "\u2A02",
          bigsqcup: "\u2A06",
          bigstar: "\u2605",
          bigtriangledown: "\u25BD",
          bigtriangleup: "\u25B3",
          biguplus: "\u2A04",
          blacklozenge: "\u29EB",
          blacktriangle: "\u25B4",
          blacktriangledown: "\u25BE",
          blacktriangleleft: "\u25C2",
          bowtie: "\u22C8",
          boxdl: "\u2510",
          boxdr: "\u250C",
          boxminus: "\u229F",
          boxplus: "\u229E",
          boxtimes: "\u22A0",
          boxul: "\u2518",
          boxur: "\u2514",
          bsol: "\\",
          bull: "\u2022",
          cap: "\u2229",
          check: "\u2713",
          chi: "\u03C7",
          circ: "\u02C6",
          circeq: "\u2257",
          circlearrowleft: "\u21BA",
          circlearrowright: "\u21BB",
          circledR: "\xae",
          circledS: "\u24C8",
          circledast: "\u229B",
          circledcirc: "\u229A",
          circleddash: "\u229D",
          clubs: "\u2663",
          colon: ":",
          comp: "\u2201",
          ctdot: "\u22EF",
          cuepr: "\u22DE",
          cuesc: "\u22DF",
          cularr: "\u21B6",
          cup: "\u222A",
          curarr: "\u21B7",
          curlyvee: "\u22CE",
          curlywedge: "\u22CF",
          dagger: "\u2020",
          daleth: "\u2138",
          ddarr: "\u21CA",
          deg: "\xb0",
          delta: "\u03B4",
          digamma: "\u03DD",
          div: "\xf7",
          divideontimes: "\u22C7",
          dot: "\u02D9",
          doteqdot: "\u2251",
          dotplus: "\u2214",
          dotsquare: "\u22A1",
          dtdot: "\u22F1",
          ecir: "\u2256",
          efDot: "\u2252",
          egs: "\u2A96",
          ell: "\u2113",
          els: "\u2A95",
          empty: "\u2205",
          epsi: "\u03B5",
          epsiv: "\u03F5",
          erDot: "\u2253",
          eta: "\u03B7",
          eth: "\xf0",
          flat: "\u266D",
          fork: "\u22D4",
          frown: "\u2322",
          gEl: "\u2A8C",
          gamma: "\u03B3",
          gap: "\u2A86",
          gimel: "\u2137",
          gnE: "\u2269",
          gnap: "\u2A8A",
          gne: "\u2A88",
          gnsim: "\u22E7",
          gt: ">",
          gtdot: "\u22D7",
          harrw: "\u21AD",
          hbar: "\u210F",
          hellip: "\u2026",
          hookleftarrow: "\u21A9",
          hookrightarrow: "\u21AA",
          imath: "\u0131",
          infin: "\u221E",
          intcal: "\u22BA",
          iota: "\u03B9",
          jmath: "\u0237",
          kappa: "\u03BA",
          kappav: "\u03F0",
          lEg: "\u2A8B",
          lambda: "\u03BB",
          lap: "\u2A85",
          larrlp: "\u21AB",
          larrtl: "\u21A2",
          lbrace: "{",
          lbrack: "[",
          le: "\u2264",
          leftleftarrows: "\u21C7",
          leftthreetimes: "\u22CB",
          lessdot: "\u22D6",
          lmoust: "\u23B0",
          lnE: "\u2268",
          lnap: "\u2A89",
          lne: "\u2A87",
          lnsim: "\u22E6",
          longmapsto: "\u27FC",
          looparrowright: "\u21AC",
          lowast: "\u2217",
          loz: "\u25CA",
          lt: "<",
          ltimes: "\u22C9",
          ltri: "\u25C3",
          macr: "\xaf",
          malt: "\u2720",
          mho: "\u2127",
          mu: "\u03BC",
          multimap: "\u22B8",
          nLeftarrow: "\u21CD",
          nLeftrightarrow: "\u21CE",
          nRightarrow: "\u21CF",
          nVDash: "\u22AF",
          nVdash: "\u22AE",
          natur: "\u266E",
          nearr: "\u2197",
          nharr: "\u21AE",
          nlarr: "\u219A",
          not: "\xac",
          nrarr: "\u219B",
          nu: "\u03BD",
          nvDash: "\u22AD",
          nvdash: "\u22AC",
          nwarr: "\u2196",
          omega: "\u03C9",
          omicron: "\u03BF",
          or: "\u2228",
          osol: "\u2298",
          period: ".",
          phi: "\u03C6",
          phiv: "\u03D5",
          pi: "\u03C0",
          piv: "\u03D6",
          prap: "\u2AB7",
          precnapprox: "\u2AB9",
          precneqq: "\u2AB5",
          precnsim: "\u22E8",
          prime: "\u2032",
          psi: "\u03C8",
          quot: '"',
          rarrtl: "\u21A3",
          rbrace: "}",
          rbrack: "]",
          rho: "\u03C1",
          rhov: "\u03F1",
          rightrightarrows: "\u21C9",
          rightthreetimes: "\u22CC",
          ring: "\u02DA",
          rmoust: "\u23B1",
          rtimes: "\u22CA",
          rtri: "\u25B9",
          scap: "\u2AB8",
          scnE: "\u2AB6",
          scnap: "\u2ABA",
          scnsim: "\u22E9",
          sdot: "\u22C5",
          searr: "\u2198",
          sect: "\xa7",
          sharp: "\u266F",
          sigma: "\u03C3",
          sigmav: "\u03C2",
          simne: "\u2246",
          smile: "\u2323",
          spades: "\u2660",
          sub: "\u2282",
          subE: "\u2AC5",
          subnE: "\u2ACB",
          subne: "\u228A",
          supE: "\u2AC6",
          supnE: "\u2ACC",
          supne: "\u228B",
          swarr: "\u2199",
          tau: "\u03C4",
          theta: "\u03B8",
          thetav: "\u03D1",
          tilde: "\u02DC",
          times: "\xd7",
          triangle: "\u25B5",
          triangleq: "\u225C",
          upsi: "\u03C5",
          upuparrows: "\u21C8",
          veebar: "\u22BB",
          vellip: "\u22EE",
          weierp: "\u2118",
          xi: "\u03BE",
          yen: "\xa5",
          zeta: "\u03B6",
          zigrarr: "\u21DD",
          nbsp: "\xa0",
          rsquo: "\u2019",
          lsquo: "\u2018"
        };
        var i = {};
        function a(t, r) {
          if ("#" === r.charAt(0)) return Q(r.slice(1));
          if (e.entities[r]) return e.entities[r];
          if (e.options.loadMissingEntities) {
            var a = r.match(/^[a-zA-Z](fr|scr|opf)$/) ? RegExp.$1 : r.charAt(0).toLowerCase();
            i[a] || (i[a] = !0, (0, n.retryAfter)((0, o.asyncLoad)("./util/entities/" + a + ".js")));
          }
          return t;
        }
        function Q(t) {
          var e = "x" === t.charAt(0) ? parseInt(t.slice(1), 16) : parseInt(t);
          return String.fromCodePoint(e);
        }
        e.add = function (t, r) {
          Object.assign(e.entities, t), i[r] = !0;
        }, e.remove = function (t) {
          delete e.entities[t];
        }, e.translate = function (t) {
          return t.replace(/&([a-z][a-z0-9]*|#(?:[0-9]+|x[0-9a-f]+));/gi, a);
        }, e.numeric = Q;
      },
      7525: function _(t, e, r) {
        var _n120,
          o = this && this.__extends || (_n120 = function n(t, e) {
            return _n120 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            }, _n120(t, e);
          }, function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
            function r() {
              this.constructor = t;
            }
            _n120(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          Q = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.FunctionList = void 0;
        var s = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.execute = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(this), s = o.next(); !s.done; s = o.next()) {
                var T = s.value,
                  l = T.item.apply(T, Q([], a(r), !1));
                if (!1 === l) return !1;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return !0;
          }, e.prototype.asyncExecute = function () {
            for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
            var r = -1,
              n = this.items;
            return new Promise(function (e, o) {
              !function i() {
                for (var s; ++r < n.length;) {
                  var T = (s = n[r]).item.apply(s, Q([], a(t), !1));
                  if (T instanceof Promise) return void T.then(i).catch(function (t) {
                    return o(t);
                  });
                  if (!1 === T) return void e(!1);
                }
                e(!0);
              }();
            });
          }, e;
        }(r(8666).PrioritizedList);
        e.FunctionList = s;
      },
      103: function _(t, e) {
        var r = this && this.__generator || function (t, e) {
            var r,
              n,
              o,
              i,
              a = {
                label: 0,
                sent: function sent() {
                  if (1 & o[0]) throw o[1];
                  return o[1];
                },
                trys: [],
                ops: []
              };
            return i = {
              next: Q(0),
              throw: Q(1),
              return: Q(2)
            }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
              return this;
            }), i;
            function Q(i) {
              return function (Q) {
                return function (i) {
                  if (r) throw new TypeError("Generator is already executing.");
                  for (; a;) try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                      case 0:
                      case 1:
                        o = i;
                        break;
                      case 4:
                        return a.label++, {
                          value: i[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = i[1], i = [0];
                        continue;
                      case 7:
                        i = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                          a.label = i[1];
                          break;
                        }
                        if (6 === i[0] && a.label < o[1]) {
                          a.label = o[1], o = i;
                          break;
                        }
                        if (o && a.label < o[2]) {
                          a.label = o[2], a.ops.push(i);
                          break;
                        }
                        o[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    i = e.call(t, a);
                  } catch (t) {
                    i = [6, t], n = 0;
                  } finally {
                    r = o = 0;
                  }
                  if (5 & i[0]) throw i[1];
                  return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                  };
                }([i, Q]);
              };
            }
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LinkedList = e.ListItem = e.END = void 0, e.END = Symbol();
        var a = function a(t) {
          void 0 === t && (t = null), this.next = null, this.prev = null, this.data = t;
        };
        e.ListItem = a;
        var Q = function () {
          function t() {
            for (var t = [], r = 0; r < arguments.length; r++) t[r] = arguments[r];
            this.list = new a(e.END), this.list.next = this.list.prev = this.list, this.push.apply(this, o([], n(t), !1));
          }
          return t.prototype.isBefore = function (t, e) {
            return t < e;
          }, t.prototype.push = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r), Q = o.next(); !Q.done; Q = o.next()) {
                var s = Q.value,
                  T = new a(s);
                T.next = this.list, T.prev = this.list.prev, this.list.prev = T, T.prev.next = T;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                Q && !Q.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return this;
          }, t.prototype.pop = function () {
            var t = this.list.prev;
            return t.data === e.END ? null : (this.list.prev = t.prev, t.prev.next = this.list, t.next = t.prev = null, t.data);
          }, t.prototype.unshift = function () {
            for (var t, e, r = [], n = 0; n < arguments.length; n++) r[n] = arguments[n];
            try {
              for (var o = i(r.slice(0).reverse()), Q = o.next(); !Q.done; Q = o.next()) {
                var s = Q.value,
                  T = new a(s);
                T.next = this.list.next, T.prev = this.list, this.list.next = T, T.next.prev = T;
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                Q && !Q.done && (e = o.return) && e.call(o);
              } finally {
                if (t) throw t.error;
              }
            }
            return this;
          }, t.prototype.shift = function () {
            var t = this.list.next;
            return t.data === e.END ? null : (this.list.next = t.next, t.next.prev = this.list, t.next = t.prev = null, t.data);
          }, t.prototype.remove = function () {
            for (var t, r, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            var a = new Map();
            try {
              for (var Q = i(n), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                a.set(T, !0);
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (r = Q.return) && r.call(Q);
              } finally {
                if (t) throw t.error;
              }
            }
            for (var l = this.list.next; l.data !== e.END;) {
              var c = l.next;
              a.has(l.data) && (l.prev.next = l.next, l.next.prev = l.prev, l.next = l.prev = null), l = c;
            }
          }, t.prototype.clear = function () {
            return this.list.next.prev = this.list.prev.next = null, this.list.next = this.list.prev = this.list, this;
          }, t.prototype[Symbol.iterator] = function () {
            var t;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  t = this.list.next, r.label = 1;
                case 1:
                  return t.data === e.END ? [3, 3] : [4, t.data];
                case 2:
                  return r.sent(), t = t.next, [3, 1];
                case 3:
                  return [2];
              }
            });
          }, t.prototype.reversed = function () {
            var t;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  t = this.list.prev, r.label = 1;
                case 1:
                  return t.data === e.END ? [3, 3] : [4, t.data];
                case 2:
                  return r.sent(), t = t.prev, [3, 1];
                case 3:
                  return [2];
              }
            });
          }, t.prototype.insert = function (t, r) {
            void 0 === r && (r = null), null === r && (r = this.isBefore.bind(this));
            for (var n = new a(t), o = this.list.next; o.data !== e.END && r(o.data, n.data);) o = o.next;
            return n.prev = o.prev, n.next = o, o.prev.next = o.prev = n, this;
          }, t.prototype.sort = function (e) {
            var r, n;
            void 0 === e && (e = null), null === e && (e = this.isBefore.bind(this));
            var o = [];
            try {
              for (var a = i(this), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                o.push(new t(s));
              }
            } catch (t) {
              r = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (n = a.return) && n.call(a);
              } finally {
                if (r) throw r.error;
              }
            }
            for (this.list.next = this.list.prev = this.list; o.length > 1;) {
              var T = o.shift(),
                l = o.shift();
              T.merge(l, e), o.push(T);
            }
            return o.length && (this.list = o[0].list), this;
          }, t.prototype.merge = function (t, r) {
            var o, i, a, Q, s;
            void 0 === r && (r = null), null === r && (r = this.isBefore.bind(this));
            for (var T = this.list.next, l = t.list.next; T.data !== e.END && l.data !== e.END;) r(l.data, T.data) ? (o = n([T, l], 2), l.prev.next = o[0], T.prev.next = o[1], i = n([T.prev, l.prev], 2), l.prev = i[0], T.prev = i[1], a = n([t.list, this.list], 2), this.list.prev.next = a[0], t.list.prev.next = a[1], Q = n([t.list.prev, this.list.prev], 2), this.list.prev = Q[0], t.list.prev = Q[1], T = (s = n([l.next, T], 2))[0], l = s[1]) : T = T.next;
            return l.data !== e.END && (this.list.prev.next = t.list.next, t.list.next.prev = this.list.prev, t.list.prev.next = this.list, this.list.prev = t.list.prev, t.list.next = t.list.prev = t.list), this;
          }, t;
        }();
        e.LinkedList = Q;
      },
      7233: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookup = e.separateOptions = e.selectOptionsFromKeys = e.selectOptions = e.userOptions = e.defaultOptions = e.insert = e.copy = e.keys = e.makeArray = e.expandable = e.Expandable = e.OPTIONS = e.REMOVE = e.APPEND = e.isObject = void 0;
        var i = {}.constructor;
        function a(t) {
          return "object" == typeof t && null !== t && (t.constructor === i || t.constructor === Q);
        }
        e.isObject = a, e.APPEND = "[+]", e.REMOVE = "[-]", e.OPTIONS = {
          invalidOption: "warn",
          optionError: function optionError(t, r) {
            if ("fatal" === e.OPTIONS.invalidOption) throw new Error(t);
            console.warn("MathJax: " + t);
          }
        };
        var Q = function Q() {};
        function s(t) {
          return Object.assign(Object.create(Q.prototype), t);
        }
        function T(t) {
          return t ? Object.keys(t).concat(Object.getOwnPropertySymbols(t)) : [];
        }
        function l(t) {
          var e,
            n,
            o = {};
          try {
            for (var i = r(T(t)), u = i.next(); !u.done; u = i.next()) {
              var p = u.value,
                h = Object.getOwnPropertyDescriptor(t, p),
                d = h.value;
              Array.isArray(d) ? h.value = c([], d, !1) : a(d) && (h.value = l(d)), h.enumerable && (o[p] = h);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              u && !u.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          return Object.defineProperties(t.constructor === Q ? s({}) : {}, o);
        }
        function c(t, i, s) {
          var u, p;
          void 0 === s && (s = !0);
          var h = function h(r) {
            if (s && void 0 === t[r] && t.constructor !== Q) return "symbol" == typeof r && (r = r.toString()), e.OPTIONS.optionError('Invalid option "'.concat(r, '" (no default value).'), r), "continue";
            var u = i[r],
              p = t[r];
            if (!a(u) || null === p || "object" != typeof p && "function" != typeof p) Array.isArray(u) ? (t[r] = [], c(t[r], u, !1)) : a(u) ? t[r] = l(u) : t[r] = u;else {
              var h = T(u);
              Array.isArray(p) && (1 === h.length && (h[0] === e.APPEND || h[0] === e.REMOVE) && Array.isArray(u[h[0]]) || 2 === h.length && h.sort().join(",") === e.APPEND + "," + e.REMOVE && Array.isArray(u[e.APPEND]) && Array.isArray(u[e.REMOVE])) ? (u[e.REMOVE] && (p = t[r] = p.filter(function (t) {
                return u[e.REMOVE].indexOf(t) < 0;
              })), u[e.APPEND] && (t[r] = o(o([], n(p), !1), n(u[e.APPEND]), !1))) : c(p, u, s);
            }
          };
          try {
            for (var d = r(T(i)), f = d.next(); !f.done; f = d.next()) {
              h(f.value);
            }
          } catch (t) {
            u = {
              error: t
            };
          } finally {
            try {
              f && !f.done && (p = d.return) && p.call(d);
            } finally {
              if (u) throw u.error;
            }
          }
          return t;
        }
        function u(t) {
          for (var e, n, o = [], i = 1; i < arguments.length; i++) o[i - 1] = arguments[i];
          var a = {};
          try {
            for (var Q = r(o), s = Q.next(); !s.done; s = Q.next()) {
              var T = s.value;
              t.hasOwnProperty(T) && (a[T] = t[T]);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              s && !s.done && (n = Q.return) && n.call(Q);
            } finally {
              if (e) throw e.error;
            }
          }
          return a;
        }
        e.Expandable = Q, e.expandable = s, e.makeArray = function (t) {
          return Array.isArray(t) ? t : [t];
        }, e.keys = T, e.copy = l, e.insert = c, e.defaultOptions = function (t) {
          for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
          return e.forEach(function (e) {
            return c(t, e, !1);
          }), t;
        }, e.userOptions = function (t) {
          for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
          return e.forEach(function (e) {
            return c(t, e, !0);
          }), t;
        }, e.selectOptions = u, e.selectOptionsFromKeys = function (t, e) {
          return u.apply(void 0, o([t], n(Object.keys(e)), !1));
        }, e.separateOptions = function (t) {
          for (var e, n, o, i, a = [], Q = 1; Q < arguments.length; Q++) a[Q - 1] = arguments[Q];
          var s = [];
          try {
            for (var T = r(a), l = T.next(); !l.done; l = T.next()) {
              var c = l.value,
                u = {},
                p = {};
              try {
                for (var h = (o = void 0, r(Object.keys(t || {}))), d = h.next(); !d.done; d = h.next()) {
                  var f = d.value;
                  (void 0 === c[f] ? p : u)[f] = t[f];
                }
              } catch (t) {
                o = {
                  error: t
                };
              } finally {
                try {
                  d && !d.done && (i = h.return) && i.call(h);
                } finally {
                  if (o) throw o.error;
                }
              }
              s.push(u), t = p;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              l && !l.done && (n = T.return) && n.call(T);
            } finally {
              if (e) throw e.error;
            }
          }
          return s.unshift(t), s;
        }, e.lookup = function (t, e, r) {
          return void 0 === r && (r = null), e.hasOwnProperty(t) ? e[t] : r;
        };
      },
      8666: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PrioritizedList = void 0;
        var r = function () {
          function t() {
            this.items = [], this.items = [];
          }
          return t.prototype[Symbol.iterator] = function () {
            var t = 0,
              e = this.items;
            return {
              next: function next() {
                return {
                  value: e[t++],
                  done: t > e.length
                };
              }
            };
          }, t.prototype.add = function (e, r) {
            void 0 === r && (r = t.DEFAULTPRIORITY);
            var n = this.items.length;
            do {
              n--;
            } while (n >= 0 && r < this.items[n].priority);
            return this.items.splice(n + 1, 0, {
              item: e,
              priority: r
            }), e;
          }, t.prototype.remove = function (t) {
            var e = this.items.length;
            do {
              e--;
            } while (e >= 0 && this.items[e].item !== t);
            e >= 0 && this.items.splice(e, 1);
          }, t.DEFAULTPRIORITY = 5, t;
        }();
        e.PrioritizedList = r;
      },
      4542: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.retryAfter = e.handleRetriesFor = void 0, e.handleRetriesFor = function (t) {
          return new Promise(function e(r, n) {
            try {
              r(t());
            } catch (t) {
              t.retry && t.retry instanceof Promise ? t.retry.then(function () {
                return e(r, n);
              }).catch(function (t) {
                return n(t);
              }) : t.restart && t.restart.isCallback ? MathJax.Callback.After(function () {
                return e(r, n);
              }, t.restart) : n(t);
            }
          });
        }, e.retryAfter = function (t) {
          var e = new Error("MathJax retry");
          throw e.retry = t, e;
        };
      },
      4139: function _(t, e) {
        var r = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssStyles = void 0;
        var n = function () {
          function t(t) {
            void 0 === t && (t = null), this.styles = {}, this.addStyles(t);
          }
          return Object.defineProperty(t.prototype, "cssText", {
            get: function get() {
              return this.getStyleString();
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.addStyles = function (t) {
            var e, n;
            if (t) try {
              for (var o = r(Object.keys(t)), i = o.next(); !i.done; i = o.next()) {
                var a = i.value;
                this.styles[a] || (this.styles[a] = {}), Object.assign(this.styles[a], t[a]);
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                i && !i.done && (n = o.return) && n.call(o);
              } finally {
                if (e) throw e.error;
              }
            }
          }, t.prototype.removeStyles = function () {
            for (var t, e, n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];
            try {
              for (var i = r(n), a = i.next(); !a.done; a = i.next()) {
                var Q = a.value;
                delete this.styles[Q];
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                a && !a.done && (e = i.return) && e.call(i);
              } finally {
                if (t) throw t.error;
              }
            }
          }, t.prototype.clear = function () {
            this.styles = {};
          }, t.prototype.getStyleString = function () {
            return this.getStyleRules().join("\n\n");
          }, t.prototype.getStyleRules = function () {
            var t,
              e,
              n = Object.keys(this.styles),
              o = new Array(n.length),
              i = 0;
            try {
              for (var a = r(n), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value;
                o[i++] = s + " {\n" + this.getStyleDefString(this.styles[s]) + "\n}";
              }
            } catch (e) {
              t = {
                error: e
              };
            } finally {
              try {
                Q && !Q.done && (e = a.return) && e.call(a);
              } finally {
                if (t) throw t.error;
              }
            }
            return o;
          }, t.prototype.getStyleDefString = function (t) {
            var e,
              n,
              o = Object.keys(t),
              i = new Array(o.length),
              a = 0;
            try {
              for (var Q = r(o), s = Q.next(); !s.done; s = Q.next()) {
                var T = s.value;
                i[a++] = "  " + T + ": " + t[T] + ";";
              }
            } catch (t) {
              e = {
                error: t
              };
            } finally {
              try {
                s && !s.done && (n = Q.return) && n.call(Q);
              } finally {
                if (e) throw e.error;
              }
            }
            return i.join("\n");
          }, t;
        }();
        e.CssStyles = n;
      },
      8054: function _(t, e) {
        var r = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          n = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          o = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Styles = void 0;
        var i = ["top", "right", "bottom", "left"],
          a = ["width", "style", "color"];
        function Q(t) {
          for (var e = t.split(/((?:'[^']*'|"[^"]*"|,[\s\n]|[^\s\n])*)/g), r = []; e.length > 1;) e.shift(), r.push(e.shift());
          return r;
        }
        function s(t) {
          var e,
            n,
            o = Q(this.styles[t]);
          0 === o.length && o.push(""), 1 === o.length && o.push(o[0]), 2 === o.length && o.push(o[0]), 3 === o.length && o.push(o[1]);
          try {
            for (var i = r(y.connect[t].children), a = i.next(); !a.done; a = i.next()) {
              var s = a.value;
              this.setStyle(this.childName(t, s), o.shift());
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        function T(t) {
          var e,
            n,
            o = y.connect[t].children,
            i = [];
          try {
            for (var a = r(o), Q = a.next(); !Q.done; Q = a.next()) {
              var s = Q.value,
                T = this.styles[t + "-" + s];
              if (!T) return void delete this.styles[t];
              i.push(T);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              Q && !Q.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
          i[3] === i[1] && (i.pop(), i[2] === i[0] && (i.pop(), i[1] === i[0] && i.pop())), this.styles[t] = i.join(" ");
        }
        function l(t) {
          var e, n;
          try {
            for (var o = r(y.connect[t].children), i = o.next(); !i.done; i = o.next()) {
              var a = i.value;
              this.setStyle(this.childName(t, a), this.styles[t]);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              i && !i.done && (n = o.return) && n.call(o);
            } finally {
              if (e) throw e.error;
            }
          }
        }
        function c(t) {
          var e,
            i,
            a = o([], n(y.connect[t].children), !1),
            Q = this.styles[this.childName(t, a.shift())];
          try {
            for (var s = r(a), T = s.next(); !T.done; T = s.next()) {
              var l = T.value;
              if (this.styles[this.childName(t, l)] !== Q) return void delete this.styles[t];
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              T && !T.done && (i = s.return) && i.call(s);
            } finally {
              if (e) throw e.error;
            }
          }
          this.styles[t] = Q;
        }
        var u = /^(?:[\d.]+(?:[a-z]+)|thin|medium|thick|inherit|initial|unset)$/,
          p = /^(?:none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset|inherit|initial|unset)$/;
        function h(t) {
          var e,
            n,
            o,
            i,
            a = {
              width: "",
              style: "",
              color: ""
            };
          try {
            for (var s = r(Q(this.styles[t])), T = s.next(); !T.done; T = s.next()) {
              var l = T.value;
              l.match(u) && "" === a.width ? a.width = l : l.match(p) && "" === a.style ? a.style = l : a.color = l;
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              T && !T.done && (n = s.return) && n.call(s);
            } finally {
              if (e) throw e.error;
            }
          }
          try {
            for (var c = r(y.connect[t].children), h = c.next(); !h.done; h = c.next()) {
              var d = h.value;
              this.setStyle(this.childName(t, d), a[d]);
            }
          } catch (t) {
            o = {
              error: t
            };
          } finally {
            try {
              h && !h.done && (i = c.return) && i.call(c);
            } finally {
              if (o) throw o.error;
            }
          }
        }
        function d(t) {
          var e,
            n,
            o = [];
          try {
            for (var i = r(y.connect[t].children), a = i.next(); !a.done; a = i.next()) {
              var Q = a.value,
                s = this.styles[this.childName(t, Q)];
              s && o.push(s);
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              a && !a.done && (n = i.return) && n.call(i);
            } finally {
              if (e) throw e.error;
            }
          }
          o.length ? this.styles[t] = o.join(" ") : delete this.styles[t];
        }
        var f = {
          style: /^(?:normal|italic|oblique|inherit|initial|unset)$/,
          variant: new RegExp("^(?:" + ["normal|none", "inherit|initial|unset", "common-ligatures|no-common-ligatures", "discretionary-ligatures|no-discretionary-ligatures", "historical-ligatures|no-historical-ligatures", "contextual|no-contextual", "(?:stylistic|character-variant|swash|ornaments|annotation)\\([^)]*\\)", "small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps", "lining-nums|oldstyle-nums|proportional-nums|tabular-nums", "diagonal-fractions|stacked-fractions", "ordinal|slashed-zero", "jis78|jis83|jis90|jis04|simplified|traditional", "full-width|proportional-width", "ruby"].join("|") + ")$"),
          weight: /^(?:normal|bold|bolder|lighter|[1-9]00|inherit|initial|unset)$/,
          stretch: new RegExp("^(?:" + ["normal", "(?:(?:ultra|extra|semi)-)?condensed", "(?:(?:semi|extra|ulta)-)?expanded", "inherit|initial|unset"].join("|") + ")$"),
          size: new RegExp("^(?:" + ["xx-small|x-small|small|medium|large|x-large|xx-large|larger|smaller", "[d.]+%|[d.]+[a-z]+", "inherit|initial|unset"].join("|") + ")(?:/(?:normal|[d.+](?:%|[a-z]+)?))?$")
        };
        function m(t) {
          var e,
            o,
            i,
            a,
            s = Q(this.styles[t]),
            T = {
              style: "",
              variant: [],
              weight: "",
              stretch: "",
              size: "",
              family: "",
              "line-height": ""
            };
          try {
            for (var l = r(s), c = l.next(); !c.done; c = l.next()) {
              var u = c.value;
              T.family = u;
              try {
                for (var p = (i = void 0, r(Object.keys(f))), h = p.next(); !h.done; h = p.next()) {
                  var d = h.value;
                  if ((Array.isArray(T[d]) || "" === T[d]) && u.match(f[d])) if ("size" === d) {
                    var m = n(u.split(/\//), 2),
                      L = m[0],
                      g = m[1];
                    T[d] = L, g && (T["line-height"] = g);
                  } else "" === T.size && (Array.isArray(T[d]) ? T[d].push(u) : T[d] = u);
                }
              } catch (t) {
                i = {
                  error: t
                };
              } finally {
                try {
                  h && !h.done && (a = p.return) && a.call(p);
                } finally {
                  if (i) throw i.error;
                }
              }
            }
          } catch (t) {
            e = {
              error: t
            };
          } finally {
            try {
              c && !c.done && (o = l.return) && o.call(l);
            } finally {
              if (e) throw e.error;
            }
          }
          !function (t, e) {
            var n, o;
            try {
              for (var i = r(y.connect[t].children), a = i.next(); !a.done; a = i.next()) {
                var Q = a.value,
                  s = this.childName(t, Q);
                if (Array.isArray(e[Q])) {
                  var T = e[Q];
                  T.length && (this.styles[s] = T.join(" "));
                } else "" !== e[Q] && (this.styles[s] = e[Q]);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                a && !a.done && (o = i.return) && o.call(i);
              } finally {
                if (n) throw n.error;
              }
            }
          }(t, T), delete this.styles[t];
        }
        function L(t) {}
        var y = function () {
          function t(t) {
            void 0 === t && (t = ""), this.parse(t);
          }
          return Object.defineProperty(t.prototype, "cssText", {
            get: function get() {
              var t,
                e,
                n = [];
              try {
                for (var o = r(Object.keys(this.styles)), i = o.next(); !i.done; i = o.next()) {
                  var a = i.value,
                    Q = this.parentName(a);
                  this.styles[Q] || n.push(a + ": " + this.styles[a] + ";");
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  i && !i.done && (e = o.return) && e.call(o);
                } finally {
                  if (t) throw t.error;
                }
              }
              return n.join(" ");
            },
            enumerable: !1,
            configurable: !0
          }), t.prototype.set = function (e, r) {
            for (e = this.normalizeName(e), this.setStyle(e, r), t.connect[e] && !t.connect[e].combine && (this.combineChildren(e), delete this.styles[e]); e.match(/-/) && (e = this.parentName(e), t.connect[e]);) t.connect[e].combine.call(this, e);
          }, t.prototype.get = function (t) {
            return t = this.normalizeName(t), this.styles.hasOwnProperty(t) ? this.styles[t] : "";
          }, t.prototype.setStyle = function (e, r) {
            this.styles[e] = r, t.connect[e] && t.connect[e].children && t.connect[e].split.call(this, e), "" === r && delete this.styles[e];
          }, t.prototype.combineChildren = function (e) {
            var n,
              o,
              i = this.parentName(e);
            try {
              for (var a = r(t.connect[e].children), Q = a.next(); !Q.done; Q = a.next()) {
                var s = Q.value,
                  T = this.childName(i, s);
                t.connect[T].combine.call(this, T);
              }
            } catch (t) {
              n = {
                error: t
              };
            } finally {
              try {
                Q && !Q.done && (o = a.return) && o.call(a);
              } finally {
                if (n) throw n.error;
              }
            }
          }, t.prototype.parentName = function (t) {
            var e = t.replace(/-[^-]*$/, "");
            return t === e ? "" : e;
          }, t.prototype.childName = function (e, r) {
            return r.match(/-/) ? r : (t.connect[e] && !t.connect[e].combine && (r += e.replace(/.*-/, "-"), e = this.parentName(e)), e + "-" + r);
          }, t.prototype.normalizeName = function (t) {
            return t.replace(/[A-Z]/g, function (t) {
              return "-" + t.toLowerCase();
            });
          }, t.prototype.parse = function (t) {
            void 0 === t && (t = "");
            var e = this.constructor.pattern;
            this.styles = {};
            for (var r = t.replace(e.comment, "").split(e.style); r.length > 1;) {
              var o = n(r.splice(0, 3), 3),
                i = o[0],
                a = o[1],
                Q = o[2];
              if (i.match(/[^\s\n]/)) return;
              this.set(a, Q);
            }
          }, t.pattern = {
            style: /([-a-z]+)[\s\n]*:[\s\n]*((?:'[^']*'|"[^"]*"|\n|.)*?)[\s\n]*(?:;|$)/g,
            comment: /\/\*[^]*?\*\//g
          }, t.connect = {
            padding: {
              children: i,
              split: s,
              combine: T
            },
            border: {
              children: i,
              split: l,
              combine: c
            },
            "border-top": {
              children: a,
              split: h,
              combine: d
            },
            "border-right": {
              children: a,
              split: h,
              combine: d
            },
            "border-bottom": {
              children: a,
              split: h,
              combine: d
            },
            "border-left": {
              children: a,
              split: h,
              combine: d
            },
            "border-width": {
              children: i,
              split: s,
              combine: null
            },
            "border-style": {
              children: i,
              split: s,
              combine: null
            },
            "border-color": {
              children: i,
              split: s,
              combine: null
            },
            font: {
              children: ["style", "variant", "weight", "stretch", "line-height", "size", "family"],
              split: m,
              combine: L
            }
          }, t;
        }();
        e.Styles = y;
      },
      6010: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.px = e.emRounded = e.em = e.percent = e.length2em = e.MATHSPACE = e.RELUNITS = e.UNITS = e.BIGDIMEN = void 0, e.BIGDIMEN = 1e6, e.UNITS = {
          px: 1,
          in: 96,
          cm: 96 / 2.54,
          mm: 96 / 25.4
        }, e.RELUNITS = {
          em: 1,
          ex: .431,
          pt: .1,
          pc: 1.2,
          mu: 1 / 18
        }, e.MATHSPACE = {
          veryverythinmathspace: 1 / 18,
          verythinmathspace: 2 / 18,
          thinmathspace: 3 / 18,
          mediummathspace: 4 / 18,
          thickmathspace: 5 / 18,
          verythickmathspace: 6 / 18,
          veryverythickmathspace: 7 / 18,
          negativeveryverythinmathspace: -1 / 18,
          negativeverythinmathspace: -2 / 18,
          negativethinmathspace: -3 / 18,
          negativemediummathspace: -4 / 18,
          negativethickmathspace: -5 / 18,
          negativeverythickmathspace: -6 / 18,
          negativeveryverythickmathspace: -7 / 18,
          thin: .04,
          medium: .06,
          thick: .1,
          normal: 1,
          big: 2,
          small: 1 / Math.sqrt(2),
          infinity: e.BIGDIMEN
        }, e.length2em = function (t, r, n, o) {
          if (void 0 === r && (r = 0), void 0 === n && (n = 1), void 0 === o && (o = 16), "string" != typeof t && (t = String(t)), "" === t || null == t) return r;
          if (e.MATHSPACE[t]) return e.MATHSPACE[t];
          var i = t.match(/^\s*([-+]?(?:\.\d+|\d+(?:\.\d*)?))?(pt|em|ex|mu|px|pc|in|mm|cm|%)?/);
          if (!i) return r;
          var a = parseFloat(i[1] || "1"),
            Q = i[2];
          return e.UNITS.hasOwnProperty(Q) ? a * e.UNITS[Q] / o / n : e.RELUNITS.hasOwnProperty(Q) ? a * e.RELUNITS[Q] : "%" === Q ? a / 100 * r : a * r;
        }, e.percent = function (t) {
          return (100 * t).toFixed(1).replace(/\.?0+$/, "") + "%";
        }, e.em = function (t) {
          return Math.abs(t) < .001 ? "0" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
        }, e.emRounded = function (t, e) {
          return void 0 === e && (e = 16), t = (Math.round(t * e) + .05) / e, Math.abs(t) < .001 ? "0em" : t.toFixed(3).replace(/\.?0+$/, "") + "em";
        }, e.px = function (t, r, n) {
          return void 0 === r && (r = -e.BIGDIMEN), void 0 === n && (n = 16), t *= n, r && t < r && (t = r), Math.abs(t) < .1 ? "0" : t.toFixed(1).replace(/\.0$/, "") + "px";
        };
      },
      7875: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.max = e.sum = void 0, e.sum = function (t) {
          return t.reduce(function (t, e) {
            return t + e;
          }, 0);
        }, e.max = function (t) {
          return t.reduce(function (t, e) {
            return Math.max(t, e);
          }, 0);
        };
      },
      505: function _(t, e) {
        var r = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          n = this && this.__spreadArray || function (t, e, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = e.length; o < i; o++) !n && o in e || (n || (n = Array.prototype.slice.call(e, 0, o)), n[o] = e[o]);
            return t.concat(n || Array.prototype.slice.call(e));
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.split = e.isPercent = e.unicodeString = e.unicodeChars = e.quotePattern = e.sortLength = void 0, e.sortLength = function (t, e) {
          return t.length !== e.length ? e.length - t.length : t === e ? 0 : t < e ? -1 : 1;
        }, e.quotePattern = function (t) {
          return t.replace(/([\^$(){}+*?\-|\[\]\:\\])/g, "\\$1");
        }, e.unicodeChars = function (t) {
          return Array.from(t).map(function (t) {
            return t.codePointAt(0);
          });
        }, e.unicodeString = function (t) {
          return String.fromCodePoint.apply(String, n([], r(t), !1));
        }, e.isPercent = function (t) {
          return !!t.match(/%\s*$/);
        }, e.split = function (t) {
          return t.trim().split(/\s+/);
        };
      },
      7718: function _(t, e) {
        /*!
         *************************************************************************
         *
         *  mhchemParser.ts
         *  4.1.1
         *
         *  Parser for the \ce command and \pu command for MathJax and Co.
         *
         *  mhchem's \ce is a tool for writing beautiful chemical equations easily.
         *  mhchem's \pu is a tool for writing physical units easily.
         *
         *  ----------------------------------------------------------------------
         *
         *  Copyright (c) 2015-2021 Martin Hensel
         *
         *  Licensed under the Apache License, Version 2.0 (the "License");
         *  you may not use this file except in compliance with the License.
         *  You may obtain a copy of the License at
         *
         *      http://www.apache.org/licenses/LICENSE-2.0
         *
         *  Unless required by applicable law or agreed to in writing, software
         *  distributed under the License is distributed on an "AS IS" BASIS,
         *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         *  See the License for the specific language governing permissions and
         *  limitations under the License.
         *
         *  ----------------------------------------------------------------------
         *
         *  https://github.com/mhchem/mhchemParser
         *
         */
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.mhchemParser = void 0;
        var r = function () {
          function t() {}
          return t.toTex = function (t, e) {
            return i.go(o.go(t, e), "tex" !== e);
          }, t;
        }();
        function n(t) {
          var e,
            r,
            n = {};
          for (e in t) for (r in t[e]) {
            var o = r.split("|");
            t[e][r].stateArray = o;
            for (var i = 0; i < o.length; i++) n[o[i]] = [];
          }
          for (e in t) for (r in t[e]) for (o = t[e][r].stateArray || [], i = 0; i < o.length; i++) {
            var a = t[e][r];
            a.action_ = [].concat(a.action_);
            for (var Q = 0; Q < a.action_.length; Q++) "string" == typeof a.action_[Q] && (a.action_[Q] = {
              type_: a.action_[Q]
            });
            for (var s = e.split("|"), T = 0; T < s.length; T++) if ("*" === o[i]) {
              var l = void 0;
              for (l in n) n[l].push({
                pattern: s[T],
                task: a
              });
            } else n[o[i]].push({
              pattern: s[T],
              task: a
            });
          }
          return n;
        }
        e.mhchemParser = r;
        var o = {
            go: function go(t, e) {
              if (!t) return [];
              void 0 === e && (e = "ce");
              var r,
                n = "0",
                i = {};
              i.parenthesisLevel = 0, t = (t = (t = t.replace(/\n/g, " ")).replace(/[\u2212\u2013\u2014\u2010]/g, "-")).replace(/[\u2026]/g, "...");
              for (var a = 10, Q = [];;) {
                r !== t ? (a = 10, r = t) : a--;
                var s = o.stateMachines[e],
                  T = s.transitions[n] || s.transitions["*"];
                t: for (var l = 0; l < T.length; l++) {
                  var c = o.patterns.match_(T[l].pattern, t);
                  if (c) {
                    for (var u = T[l].task, p = 0; p < u.action_.length; p++) {
                      var h = void 0;
                      if (s.actions[u.action_[p].type_]) h = s.actions[u.action_[p].type_](i, c.match_, u.action_[p].option);else {
                        if (!o.actions[u.action_[p].type_]) throw ["MhchemBugA", "mhchem bug A. Please report. (" + u.action_[p].type_ + ")"];
                        h = o.actions[u.action_[p].type_](i, c.match_, u.action_[p].option);
                      }
                      o.concatArray(Q, h);
                    }
                    if (n = u.nextState || n, !(t.length > 0)) return Q;
                    if (u.revisit || (t = c.remainder), !u.toContinue) break t;
                  }
                }
                if (a <= 0) throw ["MhchemBugU", "mhchem bug U. Please report."];
              }
            },
            concatArray: function concatArray(t, e) {
              if (e) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) t.push(e[r]);else t.push(e);
            },
            patterns: {
              patterns: {
                empty: /^$/,
                else: /^./,
                else2: /^./,
                space: /^\s/,
                "space A": /^\s(?=[A-Z\\$])/,
                space$: /^\s$/,
                "a-z": /^[a-z]/,
                x: /^x/,
                x$: /^x$/,
                i$: /^i$/,
                letters: /^(?:[a-zA-Z\u03B1-\u03C9\u0391-\u03A9?@]|(?:\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))))+/,
                "\\greek": /^\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega|Gamma|Delta|Theta|Lambda|Xi|Pi|Sigma|Upsilon|Phi|Psi|Omega)(?:\s+|\{\}|(?![a-zA-Z]))/,
                "one lowercase latin letter $": /^(?:([a-z])(?:$|[^a-zA-Z]))$/,
                "$one lowercase latin letter$ $": /^\$(?:([a-z])(?:$|[^a-zA-Z]))\$$/,
                "one lowercase greek letter $": /^(?:\$?[\u03B1-\u03C9]\$?|\$?\\(?:alpha|beta|gamma|delta|epsilon|zeta|eta|theta|iota|kappa|lambda|mu|nu|xi|omicron|pi|rho|sigma|tau|upsilon|phi|chi|psi|omega)\s*\$?)(?:\s+|\{\}|(?![a-zA-Z]))$/,
                digits: /^[0-9]+/,
                "-9.,9": /^[+\-]?(?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))/,
                "-9.,9 no missing 0": /^[+\-]?[0-9]+(?:[.,][0-9]+)?/,
                "(-)(9.,9)(e)(99)": function e99(t) {
                  var e = t.match(/^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))?(\((?:[0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+))\))?(?:(?:([eE])|\s*(\*|x|\\times|\u00D7)\s*10\^)([+\-]?[0-9]+|\{[+\-]?[0-9]+\}))?/);
                  return e && e[0] ? {
                    match_: e.slice(1),
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                "(-)(9)^(-9)": /^(\+\-|\+\/\-|\+|\-|\\pm\s?)?([0-9]+(?:[,.][0-9]+)?|[0-9]*(?:\.[0-9]+)?)\^([+\-]?[0-9]+|\{[+\-]?[0-9]+\})/,
                "state of aggregation $": function state_of_aggregation_$(t) {
                  var e = o.patterns.findObserveGroups(t, "", /^\([a-z]{1,3}(?=[\),])/, ")", "");
                  if (e && e.remainder.match(/^($|[\s,;\)\]\}])/)) return e;
                  var r = t.match(/^(?:\((?:\\ca\s?)?\$[amothc]\$\))/);
                  return r ? {
                    match_: r[0],
                    remainder: t.substr(r[0].length)
                  } : null;
                },
                "_{(state of aggregation)}$": /^_\{(\([a-z]{1,3}\))\}/,
                "{[(": /^(?:\\\{|\[|\()/,
                ")]}": /^(?:\)|\]|\\\})/,
                ", ": /^[,;]\s*/,
                ",": /^[,;]/,
                ".": /^[.]/,
                ". __* ": /^([.\u22C5\u00B7\u2022]|[*])\s*/,
                "...": /^\.\.\.(?=$|[^.])/,
                "^{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "^{", "", "", "}");
                },
                "^($...$)": function $$(t) {
                  return o.patterns.findObserveGroups(t, "^", "$", "$", "");
                },
                "^a": /^\^([0-9]+|[^\\_])/,
                "^\\x{}{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "^", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "^\\x{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "^", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "^\\x": /^\^(\\[a-zA-Z]+)\s*/,
                "^(-1)": /^\^(-?\d+)/,
                "'": /^'/,
                "_{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "_{", "", "", "}");
                },
                "_($...$)": function _$$(t) {
                  return o.patterns.findObserveGroups(t, "_", "$", "$", "");
                },
                _9: /^_([+\-]?[0-9]+|[^\\])/,
                "_\\x{}{}": function _X(t) {
                  return o.patterns.findObserveGroups(t, "_", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "_\\x{}": function _X(t) {
                  return o.patterns.findObserveGroups(t, "_", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "_\\x": /^_(\\[a-zA-Z]+)\s*/,
                "^_": /^(?:\^(?=_)|\_(?=\^)|[\^_]$)/,
                "{}^": /^\{\}(?=\^)/,
                "{}": /^\{\}/,
                "{...}": function _(t) {
                  return o.patterns.findObserveGroups(t, "", "{", "}", "");
                },
                "{(...)}": function _(t) {
                  return o.patterns.findObserveGroups(t, "{", "", "", "}");
                },
                "$...$": function $$(t) {
                  return o.patterns.findObserveGroups(t, "", "$", "$", "");
                },
                "${(...)}$__$(...)$": function $$__$$(t) {
                  return o.patterns.findObserveGroups(t, "${", "", "", "}$") || o.patterns.findObserveGroups(t, "$", "", "", "$");
                },
                "=<>": /^[=<>]/,
                "#": /^[#\u2261]/,
                "+": /^\+/,
                "-$": /^-(?=[\s_},;\]/]|$|\([a-z]+\))/,
                "-9": /^-(?=[0-9])/,
                "- orbital overlap": /^-(?=(?:[spd]|sp)(?:$|[\s,;\)\]\}]))/,
                "-": /^-/,
                "pm-operator": /^(?:\\pm|\$\\pm\$|\+-|\+\/-)/,
                operator: /^(?:\+|(?:[\-=<>]|<<|>>|\\approx|\$\\approx\$)(?=\s|$|-?[0-9]))/,
                arrowUpDown: /^(?:v|\(v\)|\^|\(\^\))(?=$|[\s,;\)\]\}])/,
                "\\bond{(...)}": function bond(t) {
                  return o.patterns.findObserveGroups(t, "\\bond{", "", "", "}");
                },
                "->": /^(?:<->|<-->|->|<-|<=>>|<<=>|<=>|[\u2192\u27F6\u21CC])/,
                CMT: /^[CMT](?=\[)/,
                "[(...)]": function _(t) {
                  return o.patterns.findObserveGroups(t, "[", "", "", "]");
                },
                "1st-level escape": /^(&|\\\\|\\hline)\s*/,
                "\\,": /^(?:\\[,\ ;:])/,
                "\\x{}{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "", /^\\[a-zA-Z]+\{/, "}", "", "", "{", "}", "", !0);
                },
                "\\x{}": function x(t) {
                  return o.patterns.findObserveGroups(t, "", /^\\[a-zA-Z]+\{/, "}", "");
                },
                "\\ca": /^\\ca(?:\s+|(?![a-zA-Z]))/,
                "\\x": /^(?:\\[a-zA-Z]+\s*|\\[_&{}%])/,
                orbital: /^(?:[0-9]{1,2}[spdfgh]|[0-9]{0,2}sp)(?=$|[^a-zA-Z])/,
                others: /^[\/~|]/,
                "\\frac{(...)}": function frac(t) {
                  return o.patterns.findObserveGroups(t, "\\frac{", "", "", "}", "{", "", "", "}");
                },
                "\\overset{(...)}": function overset(t) {
                  return o.patterns.findObserveGroups(t, "\\overset{", "", "", "}", "{", "", "", "}");
                },
                "\\underset{(...)}": function underset(t) {
                  return o.patterns.findObserveGroups(t, "\\underset{", "", "", "}", "{", "", "", "}");
                },
                "\\underbrace{(...)}": function underbrace(t) {
                  return o.patterns.findObserveGroups(t, "\\underbrace{", "", "", "}_", "{", "", "", "}");
                },
                "\\color{(...)}": function color(t) {
                  return o.patterns.findObserveGroups(t, "\\color{", "", "", "}");
                },
                "\\color{(...)}{(...)}": function color(t) {
                  return o.patterns.findObserveGroups(t, "\\color{", "", "", "}", "{", "", "", "}") || o.patterns.findObserveGroups(t, "\\color", "\\", "", /^(?=\{)/, "{", "", "", "}");
                },
                "\\ce{(...)}": function ce(t) {
                  return o.patterns.findObserveGroups(t, "\\ce{", "", "", "}");
                },
                "\\pu{(...)}": function pu(t) {
                  return o.patterns.findObserveGroups(t, "\\pu{", "", "", "}");
                },
                oxidation$: /^(?:[+-][IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
                "d-oxidation$": /^(?:[+-]?\s?[IVX]+|\\pm\s*0|\$\\pm\$\s*0)$/,
                "roman numeral": /^[IVX]+/,
                "1/2$": /^[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+(?:\$[a-z]\$|[a-z])?$/,
                amount: function amount(t) {
                  var e;
                  if (e = t.match(/^(?:(?:(?:\([+\-]?[0-9]+\/[0-9]+\)|[+\-]?(?:[0-9]+|\$[a-z]\$|[a-z])\/[0-9]+|[+\-]?[0-9]+[.,][0-9]+|[+\-]?\.[0-9]+|[+\-]?[0-9]+)(?:[a-z](?=\s*[A-Z]))?)|[+\-]?[a-z](?=\s*[A-Z])|\+(?!\s))/)) return {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  };
                  var r = o.patterns.findObserveGroups(t, "", "$", "$", "");
                  return r && (e = r.match_.match(/^\$(?:\(?[+\-]?(?:[0-9]*[a-z]?[+\-])?[0-9]*[a-z](?:[+\-][0-9]*[a-z]?)?\)?|\+|-)\$$/)) ? {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                amount2: function amount2(t) {
                  return this.amount(t);
                },
                "(KV letters),": /^(?:[A-Z][a-z]{0,2}|i)(?=,)/,
                formula$: function formula$(t) {
                  if (t.match(/^\([a-z]+\)$/)) return null;
                  var e = t.match(/^(?:[a-z]|(?:[0-9\ \+\-\,\.\(\)]+[a-z])+[0-9\ \+\-\,\.\(\)]*|(?:[a-z][0-9\ \+\-\,\.\(\)]+)+[a-z]?)$/);
                  return e ? {
                    match_: e[0],
                    remainder: t.substr(e[0].length)
                  } : null;
                },
                uprightEntities: /^(?:pH|pOH|pC|pK|iPr|iBu)(?=$|[^a-zA-Z])/,
                "/": /^\s*(\/)\s*/,
                "//": /^\s*(\/\/)\s*/,
                "*": /^\s*[*.]\s*/
              },
              findObserveGroups: function findObserveGroups(t, e, r, n, o, i, a, Q, s, T) {
                var l = function l(t, e) {
                    if ("string" == typeof e) return 0 !== t.indexOf(e) ? null : e;
                    var r = t.match(e);
                    return r ? r[0] : null;
                  },
                  c = l(t, e);
                if (null === c) return null;
                if (t = t.substr(c.length), null === (c = l(t, r))) return null;
                var u = function (t, e, r) {
                  for (var n = 0; e < t.length;) {
                    var o = t.charAt(e),
                      i = l(t.substr(e), r);
                    if (null !== i && 0 === n) return {
                      endMatchBegin: e,
                      endMatchEnd: e + i.length
                    };
                    if ("{" === o) n++;else if ("}" === o) {
                      if (0 === n) throw ["ExtraCloseMissingOpen", "Extra close brace or missing open brace"];
                      n--;
                    }
                    e++;
                  }
                  return null;
                }(t, c.length, n || o);
                if (null === u) return null;
                var p = t.substring(0, n ? u.endMatchEnd : u.endMatchBegin);
                if (i || a) {
                  var h = this.findObserveGroups(t.substr(u.endMatchEnd), i, a, Q, s);
                  if (null === h) return null;
                  var d = [p, h.match_];
                  return {
                    match_: T ? d.join("") : d,
                    remainder: h.remainder
                  };
                }
                return {
                  match_: p,
                  remainder: t.substr(u.endMatchEnd)
                };
              },
              match_: function match_(t, e) {
                var r = o.patterns.patterns[t];
                if (void 0 === r) throw ["MhchemBugP", "mhchem bug P. Please report. (" + t + ")"];
                if ("function" == typeof r) return o.patterns.patterns[t](e);
                var n = e.match(r);
                return n ? n.length > 2 ? {
                  match_: n.slice(1),
                  remainder: e.substr(n[0].length)
                } : {
                  match_: n[1] || n[0],
                  remainder: e.substr(n[0].length)
                } : null;
              }
            },
            actions: {
              "a=": function a(t, e) {
                t.a = (t.a || "") + e;
              },
              "b=": function b(t, e) {
                t.b = (t.b || "") + e;
              },
              "p=": function p(t, e) {
                t.p = (t.p || "") + e;
              },
              "o=": function o(t, e) {
                t.o = (t.o || "") + e;
              },
              "q=": function q(t, e) {
                t.q = (t.q || "") + e;
              },
              "d=": function d(t, e) {
                t.d = (t.d || "") + e;
              },
              "rm=": function rm(t, e) {
                t.rm = (t.rm || "") + e;
              },
              "text=": function text(t, e) {
                t.text_ = (t.text_ || "") + e;
              },
              insert: function insert(t, e, r) {
                return {
                  type_: r
                };
              },
              "insert+p1": function insertP1(t, e, r) {
                return {
                  type_: r,
                  p1: e
                };
              },
              "insert+p1+p2": function insertP1P2(t, e, r) {
                return {
                  type_: r,
                  p1: e[0],
                  p2: e[1]
                };
              },
              copy: function copy(t, e) {
                return e;
              },
              write: function write(t, e, r) {
                return r;
              },
              rm: function rm(t, e) {
                return {
                  type_: "rm",
                  p1: e
                };
              },
              text: function text(t, e) {
                return o.go(e, "text");
              },
              "tex-math": function texMath(t, e) {
                return o.go(e, "tex-math");
              },
              "tex-math tight": function texMath_tight(t, e) {
                return o.go(e, "tex-math tight");
              },
              bond: function bond(t, e, r) {
                return {
                  type_: "bond",
                  kind_: r || e
                };
              },
              "color0-output": function color0Output(t, e) {
                return {
                  type_: "color0",
                  color: e
                };
              },
              ce: function ce(t, e) {
                return o.go(e, "ce");
              },
              pu: function pu(t, e) {
                return o.go(e, "pu");
              },
              "1/2": function _2(t, e) {
                var r = [];
                e.match(/^[+\-]/) && (r.push(e.substr(0, 1)), e = e.substr(1));
                var n = e.match(/^([0-9]+|\$[a-z]\$|[a-z])\/([0-9]+)(\$[a-z]\$|[a-z])?$/);
                return n[1] = n[1].replace(/\$/g, ""), r.push({
                  type_: "frac",
                  p1: n[1],
                  p2: n[2]
                }), n[3] && (n[3] = n[3].replace(/\$/g, ""), r.push({
                  type_: "tex-math",
                  p1: n[3]
                })), r;
              },
              "9,9": function _(t, e) {
                return o.go(e, "9,9");
              }
            },
            stateMachines: {
              tex: {
                transitions: n({
                  empty: {
                    0: {
                      action_: "copy"
                    }
                  },
                  "\\ce{(...)}": {
                    0: {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "ce", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\pu{(...)}": {
                    0: {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  else: {
                    0: {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              ce: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  else: {
                    "0|1|2": {
                      action_: "beginsWithBond=false",
                      revisit: !0,
                      toContinue: !0
                    }
                  },
                  oxidation$: {
                    0: {
                      action_: "oxidation-output"
                    }
                  },
                  CMT: {
                    r: {
                      action_: "rdt=",
                      nextState: "rt"
                    },
                    rd: {
                      action_: "rqt=",
                      nextState: "rdt"
                    }
                  },
                  arrowUpDown: {
                    "0|1|2|as": {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "1"
                    }
                  },
                  uprightEntities: {
                    "0|1|2": {
                      action_: ["o=", "output"],
                      nextState: "1"
                    }
                  },
                  orbital: {
                    "0|1|2|3": {
                      action_: "o=",
                      nextState: "o"
                    }
                  },
                  "->": {
                    "0|1|2|3": {
                      action_: "r=",
                      nextState: "r"
                    },
                    "a|as": {
                      action_: ["output", "r="],
                      nextState: "r"
                    },
                    "*": {
                      action_: ["output", "r="],
                      nextState: "r"
                    }
                  },
                  "+": {
                    o: {
                      action_: "d= kv",
                      nextState: "d"
                    },
                    "d|D": {
                      action_: "d=",
                      nextState: "d"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "qd|qD": {
                      action_: "d=",
                      nextState: "qd"
                    },
                    dq: {
                      action_: ["output", "d="],
                      nextState: "d"
                    },
                    3: {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "0"
                    }
                  },
                  amount: {
                    "0|2": {
                      action_: "a=",
                      nextState: "a"
                    }
                  },
                  "pm-operator": {
                    "0|1|2|a|as": {
                      action_: ["sb=false", "output", {
                        type_: "operator",
                        option: "\\pm"
                      }],
                      nextState: "0"
                    }
                  },
                  operator: {
                    "0|1|2|a|as": {
                      action_: ["sb=false", "output", "operator"],
                      nextState: "0"
                    }
                  },
                  "-$": {
                    "o|q": {
                      action_: ["charge or bond", "output"],
                      nextState: "qd"
                    },
                    d: {
                      action_: "d=",
                      nextState: "d"
                    },
                    D: {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    qd: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "qD|dq": {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    }
                  },
                  "-9": {
                    "3|o": {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "3"
                    }
                  },
                  "- orbital overlap": {
                    o: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    },
                    d: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    }
                  },
                  "-": {
                    "0|1|2": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "beginsWithBond=true", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    3: {
                      action_: {
                        type_: "bond",
                        option: "-"
                      }
                    },
                    a: {
                      action_: ["output", {
                        type_: "insert",
                        option: "hyphen"
                      }],
                      nextState: "2"
                    },
                    as: {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    },
                    b: {
                      action_: "b="
                    },
                    o: {
                      action_: {
                        type_: "- after o/d",
                        option: !1
                      },
                      nextState: "2"
                    },
                    q: {
                      action_: {
                        type_: "- after o/d",
                        option: !1
                      },
                      nextState: "2"
                    },
                    "d|qd|dq": {
                      action_: {
                        type_: "- after o/d",
                        option: !0
                      },
                      nextState: "2"
                    },
                    "D|qD|p": {
                      action_: ["output", {
                        type_: "bond",
                        option: "-"
                      }],
                      nextState: "3"
                    }
                  },
                  amount2: {
                    "1|3": {
                      action_: "a=",
                      nextState: "a"
                    }
                  },
                  letters: {
                    "0|1|2|3|a|as|b|p|bp|o": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "q|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    },
                    "d|D|qd|qD": {
                      action_: "o after d",
                      nextState: "o"
                    }
                  },
                  digits: {
                    o: {
                      action_: "q=",
                      nextState: "q"
                    },
                    "d|D": {
                      action_: "q=",
                      nextState: "dq"
                    },
                    q: {
                      action_: ["output", "o="],
                      nextState: "o"
                    },
                    a: {
                      action_: "o=",
                      nextState: "o"
                    }
                  },
                  "space A": {
                    "b|p|bp": {
                      action_: []
                    }
                  },
                  space: {
                    a: {
                      action_: [],
                      nextState: "as"
                    },
                    0: {
                      action_: "sb=false"
                    },
                    "1|2": {
                      action_: "sb=true"
                    },
                    "r|rt|rd|rdt|rdq": {
                      action_: "output",
                      nextState: "0"
                    },
                    "*": {
                      action_: ["output", "sb=true"],
                      nextState: "1"
                    }
                  },
                  "1st-level escape": {
                    "1|2": {
                      action_: ["output", {
                        type_: "insert+p1",
                        option: "1st-level escape"
                      }]
                    },
                    "*": {
                      action_: ["output", {
                        type_: "insert+p1",
                        option: "1st-level escape"
                      }],
                      nextState: "0"
                    }
                  },
                  "[(...)]": {
                    "r|rt": {
                      action_: "rd=",
                      nextState: "rd"
                    },
                    "rd|rdt": {
                      action_: "rq=",
                      nextState: "rdq"
                    }
                  },
                  "...": {
                    "o|d|D|dq|qd|qD": {
                      action_: ["output", {
                        type_: "bond",
                        option: "..."
                      }],
                      nextState: "3"
                    },
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, {
                        type_: "insert",
                        option: "ellipsis"
                      }],
                      nextState: "1"
                    }
                  },
                  ". __* ": {
                    "*": {
                      action_: ["output", {
                        type_: "insert",
                        option: "addition compound"
                      }],
                      nextState: "1"
                    }
                  },
                  "state of aggregation $": {
                    "*": {
                      action_: ["output", "state of aggregation"],
                      nextState: "1"
                    }
                  },
                  "{[(": {
                    "a|as|o": {
                      action_: ["o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    },
                    "0|1|2|3": {
                      action_: ["o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    },
                    "*": {
                      action_: ["output", "o=", "output", "parenthesisLevel++"],
                      nextState: "2"
                    }
                  },
                  ")]}": {
                    "0|1|2|3|b|p|bp|o": {
                      action_: ["o=", "parenthesisLevel--"],
                      nextState: "o"
                    },
                    "a|as|d|D|q|qd|qD|dq": {
                      action_: ["output", "o=", "parenthesisLevel--"],
                      nextState: "o"
                    }
                  },
                  ", ": {
                    "*": {
                      action_: ["output", "comma"],
                      nextState: "0"
                    }
                  },
                  "^_": {
                    "*": {
                      action_: []
                    }
                  },
                  "^{(...)}|^($...$)": {
                    "0|1|2|as": {
                      action_: "b=",
                      nextState: "b"
                    },
                    p: {
                      action_: "b=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "d= kv",
                      nextState: "D"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qD"
                    },
                    "d|D|qd|qD|dq": {
                      action_: ["output", "d="],
                      nextState: "D"
                    }
                  },
                  "^a|^\\x{}{}|^\\x{}|^\\x|'": {
                    "0|1|2|as": {
                      action_: "b=",
                      nextState: "b"
                    },
                    p: {
                      action_: "b=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "d= kv",
                      nextState: "d"
                    },
                    q: {
                      action_: "d=",
                      nextState: "qd"
                    },
                    "d|qd|D|qD": {
                      action_: "d="
                    },
                    dq: {
                      action_: ["output", "d="],
                      nextState: "d"
                    }
                  },
                  "_{(state of aggregation)}$": {
                    "d|D|q|qd|qD|dq": {
                      action_: ["output", "q="],
                      nextState: "q"
                    }
                  },
                  "_{(...)}|_($...$)|_9|_\\x{}{}|_\\x{}|_\\x": {
                    "0|1|2|as": {
                      action_: "p=",
                      nextState: "p"
                    },
                    b: {
                      action_: "p=",
                      nextState: "bp"
                    },
                    "3|o": {
                      action_: "q=",
                      nextState: "q"
                    },
                    "d|D": {
                      action_: "q=",
                      nextState: "dq"
                    },
                    "q|qd|qD|dq": {
                      action_: ["output", "q="],
                      nextState: "q"
                    }
                  },
                  "=<>": {
                    "0|1|2|3|a|as|o|q|d|D|qd|qD|dq": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "bond"],
                      nextState: "3"
                    }
                  },
                  "#": {
                    "0|1|2|3|a|as|o": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, {
                        type_: "bond",
                        option: "#"
                      }],
                      nextState: "3"
                    }
                  },
                  "{}^": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, {
                        type_: "insert",
                        option: "tinySkip"
                      }],
                      nextState: "1"
                    }
                  },
                  "{}": {
                    "*": {
                      action_: {
                        type_: "output",
                        option: 1
                      },
                      nextState: "1"
                    }
                  },
                  "{...}": {
                    "0|1|2|3|a|as|b|p|bp": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "o|d|D|q|qd|qD|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    }
                  },
                  "$...$": {
                    a: {
                      action_: "a="
                    },
                    "0|1|2|3|as|b|p|bp|o": {
                      action_: "o=",
                      nextState: "o"
                    },
                    "as|o": {
                      action_: "o="
                    },
                    "q|d|D|qd|qD|dq": {
                      action_: ["output", "o="],
                      nextState: "o"
                    }
                  },
                  "\\bond{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "bond"],
                      nextState: "3"
                    }
                  },
                  "\\frac{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "frac-output"],
                      nextState: "3"
                    }
                  },
                  "\\overset{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "overset-output"],
                      nextState: "3"
                    }
                  },
                  "\\underset{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "underset-output"],
                      nextState: "3"
                    }
                  },
                  "\\underbrace{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "underbrace-output"],
                      nextState: "3"
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "color-output"],
                      nextState: "3"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "color0-output"]
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 2
                      }, "ce"],
                      nextState: "3"
                    }
                  },
                  "\\,": {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "copy"],
                      nextState: "1"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }],
                      nextState: "3"
                    }
                  },
                  "\\x{}{}|\\x{}|\\x": {
                    "0|1|2|3|a|as|b|p|bp|o|c0": {
                      action_: ["o=", "output"],
                      nextState: "3"
                    },
                    "*": {
                      action_: ["output", "o=", "output"],
                      nextState: "3"
                    }
                  },
                  others: {
                    "*": {
                      action_: [{
                        type_: "output",
                        option: 1
                      }, "copy"],
                      nextState: "3"
                    }
                  },
                  else2: {
                    a: {
                      action_: "a to o",
                      nextState: "o",
                      revisit: !0
                    },
                    as: {
                      action_: ["output", "sb=true"],
                      nextState: "1",
                      revisit: !0
                    },
                    "r|rt|rd|rdt|rdq": {
                      action_: ["output"],
                      nextState: "0",
                      revisit: !0
                    },
                    "*": {
                      action_: ["output", "copy"],
                      nextState: "3"
                    }
                  }
                }),
                actions: {
                  "o after d": function o_after_d(t, e) {
                    var r;
                    if ((t.d || "").match(/^[1-9][0-9]*$/)) {
                      var n = t.d;
                      t.d = void 0, (r = this.output(t)).push({
                        type_: "tinySkip"
                      }), t.b = n;
                    } else r = this.output(t);
                    return o.actions["o="](t, e), r;
                  },
                  "d= kv": function d_kv(t, e) {
                    t.d = e, t.dType = "kv";
                  },
                  "charge or bond": function charge_or_bond(t, e) {
                    if (t.beginsWithBond) {
                      var r = [];
                      return o.concatArray(r, this.output(t)), o.concatArray(r, o.actions.bond(t, e, "-")), r;
                    }
                    t.d = e;
                  },
                  "- after o/d": function _after_o_d(t, e, r) {
                    var n = o.patterns.match_("orbital", t.o || ""),
                      i = o.patterns.match_("one lowercase greek letter $", t.o || ""),
                      a = o.patterns.match_("one lowercase latin letter $", t.o || ""),
                      Q = o.patterns.match_("$one lowercase latin letter$ $", t.o || ""),
                      s = "-" === e && (n && "" === n.remainder || i || a || Q);
                    !s || t.a || t.b || t.p || t.d || t.q || n || !a || (t.o = "$" + t.o + "$");
                    var T = [];
                    return s ? (o.concatArray(T, this.output(t)), T.push({
                      type_: "hyphen"
                    })) : (n = o.patterns.match_("digits", t.d || ""), r && n && "" === n.remainder ? (o.concatArray(T, o.actions["d="](t, e)), o.concatArray(T, this.output(t))) : (o.concatArray(T, this.output(t)), o.concatArray(T, o.actions.bond(t, e, "-")))), T;
                  },
                  "a to o": function a_to_o(t) {
                    t.o = t.a, t.a = void 0;
                  },
                  "sb=true": function sbTrue(t) {
                    t.sb = !0;
                  },
                  "sb=false": function sbFalse(t) {
                    t.sb = !1;
                  },
                  "beginsWithBond=true": function beginsWithBondTrue(t) {
                    t.beginsWithBond = !0;
                  },
                  "beginsWithBond=false": function beginsWithBondFalse(t) {
                    t.beginsWithBond = !1;
                  },
                  "parenthesisLevel++": function parenthesisLevel(t) {
                    t.parenthesisLevel++;
                  },
                  "parenthesisLevel--": function parenthesisLevel(t) {
                    t.parenthesisLevel--;
                  },
                  "state of aggregation": function state_of_aggregation(t, e) {
                    return {
                      type_: "state of aggregation",
                      p1: o.go(e, "o")
                    };
                  },
                  comma: function comma(t, e) {
                    var r = e.replace(/\s*$/, "");
                    return r !== e && 0 === t.parenthesisLevel ? {
                      type_: "comma enumeration L",
                      p1: r
                    } : {
                      type_: "comma enumeration M",
                      p1: r
                    };
                  },
                  output: function output(t, e, r) {
                    var n;
                    if (t.r) {
                      var i = void 0;
                      i = "M" === t.rdt ? o.go(t.rd, "tex-math") : "T" === t.rdt ? [{
                        type_: "text",
                        p1: t.rd || ""
                      }] : o.go(t.rd, "ce");
                      var a = void 0;
                      a = "M" === t.rqt ? o.go(t.rq, "tex-math") : "T" === t.rqt ? [{
                        type_: "text",
                        p1: t.rq || ""
                      }] : o.go(t.rq, "ce"), n = {
                        type_: "arrow",
                        r: t.r,
                        rd: i,
                        rq: a
                      };
                    } else n = [], (t.a || t.b || t.p || t.o || t.q || t.d || r) && (t.sb && n.push({
                      type_: "entitySkip"
                    }), t.o || t.q || t.d || t.b || t.p || 2 === r ? t.o || t.q || t.d || !t.b && !t.p ? t.o && "kv" === t.dType && o.patterns.match_("d-oxidation$", t.d || "") ? t.dType = "oxidation" : t.o && "kv" === t.dType && !t.q && (t.dType = void 0) : (t.o = t.a, t.d = t.b, t.q = t.p, t.a = t.b = t.p = void 0) : (t.o = t.a, t.a = void 0), n.push({
                      type_: "chemfive",
                      a: o.go(t.a, "a"),
                      b: o.go(t.b, "bd"),
                      p: o.go(t.p, "pq"),
                      o: o.go(t.o, "o"),
                      q: o.go(t.q, "pq"),
                      d: o.go(t.d, "oxidation" === t.dType ? "oxidation" : "bd"),
                      dType: t.dType
                    }));
                    for (var Q in t) "parenthesisLevel" !== Q && "beginsWithBond" !== Q && delete t[Q];
                    return n;
                  },
                  "oxidation-output": function oxidationOutput(t, e) {
                    var r = ["{"];
                    return o.concatArray(r, o.go(e, "oxidation")), r.push("}"), r;
                  },
                  "frac-output": function fracOutput(t, e) {
                    return {
                      type_: "frac-ce",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "overset-output": function oversetOutput(t, e) {
                    return {
                      type_: "overset",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "underset-output": function undersetOutput(t, e) {
                    return {
                      type_: "underset",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "underbrace-output": function underbraceOutput(t, e) {
                    return {
                      type_: "underbrace",
                      p1: o.go(e[0], "ce"),
                      p2: o.go(e[1], "ce")
                    };
                  },
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "ce")
                    };
                  },
                  "r=": function r(t, e) {
                    t.r = e;
                  },
                  "rdt=": function rdt(t, e) {
                    t.rdt = e;
                  },
                  "rd=": function rd(t, e) {
                    t.rd = e;
                  },
                  "rqt=": function rqt(t, e) {
                    t.rqt = e;
                  },
                  "rq=": function rq(t, e) {
                    t.rq = e;
                  },
                  operator: function operator(t, e, r) {
                    return {
                      type_: "operator",
                      kind_: r || e
                    };
                  }
                }
              },
              a: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "1",
                      revisit: !0
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math tight",
                      nextState: "1"
                    }
                  },
                  ",": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "commaDecimal"
                      }
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              o: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "1",
                      revisit: !0
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "\\ca": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "circa"
                      }
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "text", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {}
              },
              text: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "{...}": {
                    "*": {
                      action_: "text="
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "\\greek": {
                    "*": {
                      action_: ["output", "rm"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: ["output", "copy"]
                    }
                  },
                  else: {
                    "*": {
                      action_: "text="
                    }
                  }
                }),
                actions: {
                  output: function output(t) {
                    if (t.text_) {
                      var e = {
                        type_: "text",
                        p1: t.text_
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              pq: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "state of aggregation $": {
                    "*": {
                      action_: "state of aggregation"
                    }
                  },
                  i$: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "(KV letters),": {
                    0: {
                      action_: "rm",
                      nextState: "0"
                    }
                  },
                  formula$: {
                    0: {
                      action_: [],
                      nextState: "f",
                      revisit: !0
                    }
                  },
                  "1/2$": {
                    0: {
                      action_: "1/2"
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: "text"
                    }
                  },
                  "a-z": {
                    f: {
                      action_: "tex-math"
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "-9.,9": {
                    "*": {
                      action_: "9,9"
                    }
                  },
                  ",": {
                    "*": {
                      action_: {
                        type_: "insert+p1",
                        option: "comma enumeration S"
                      }
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: "color-output"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: "color0-output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: "ce"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "state of aggregation": function state_of_aggregation(t, e) {
                    return {
                      type_: "state of aggregation subscript",
                      p1: o.go(e, "o")
                    };
                  },
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "pq")
                    };
                  }
                }
              },
              bd: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  x$: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  formula$: {
                    0: {
                      action_: [],
                      nextState: "f",
                      revisit: !0
                    }
                  },
                  else: {
                    0: {
                      action_: [],
                      nextState: "!f",
                      revisit: !0
                    }
                  },
                  "-9.,9 no missing 0": {
                    "*": {
                      action_: "9,9"
                    }
                  },
                  ".": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "electron dot"
                      }
                    }
                  },
                  "a-z": {
                    f: {
                      action_: "tex-math"
                    }
                  },
                  x: {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "KV x"
                      }
                    }
                  },
                  letters: {
                    "*": {
                      action_: "rm"
                    }
                  },
                  "'": {
                    "*": {
                      action_: {
                        type_: "insert",
                        option: "prime"
                      }
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  "{(...)}": {
                    "*": {
                      action_: "text"
                    }
                  },
                  "\\color{(...)}{(...)}": {
                    "*": {
                      action_: "color-output"
                    }
                  },
                  "\\color{(...)}": {
                    "*": {
                      action_: "color0-output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: "ce"
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: [{
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "copy"
                    }
                  },
                  else2: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "color-output": function colorOutput(t, e) {
                    return {
                      type_: "color",
                      color1: e[0],
                      color2: o.go(e[1], "bd")
                    };
                  }
                }
              },
              oxidation: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  "roman numeral": {
                    "*": {
                      action_: "roman-numeral"
                    }
                  },
                  "${(...)}$__$(...)$": {
                    "*": {
                      action_: "tex-math"
                    }
                  },
                  else: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  "roman-numeral": function romanNumeral(t, e) {
                    return {
                      type_: "roman numeral",
                      p1: e
                    };
                  }
                }
              },
              "tex-math": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: ["output", "ce"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "{...}|\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "o="
                    }
                  },
                  else: {
                    "*": {
                      action_: "o="
                    }
                  }
                }),
                actions: {
                  output: function output(t) {
                    if (t.o) {
                      var e = {
                        type_: "tex-math",
                        p1: t.o
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              "tex-math tight": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "\\ce{(...)}": {
                    "*": {
                      action_: ["output", "ce"]
                    }
                  },
                  "\\pu{(...)}": {
                    "*": {
                      action_: ["output", {
                        type_: "write",
                        option: "{"
                      }, "pu", {
                        type_: "write",
                        option: "}"
                      }]
                    }
                  },
                  "{...}|\\,|\\x{}{}|\\x{}|\\x": {
                    "*": {
                      action_: "o="
                    }
                  },
                  "-|+": {
                    "*": {
                      action_: "tight operator"
                    }
                  },
                  else: {
                    "*": {
                      action_: "o="
                    }
                  }
                }),
                actions: {
                  "tight operator": function tight_operator(t, e) {
                    t.o = (t.o || "") + "{" + e + "}";
                  },
                  output: function output(t) {
                    if (t.o) {
                      var e = {
                        type_: "tex-math",
                        p1: t.o
                      };
                      for (var r in t) delete t[r];
                      return e;
                    }
                  }
                }
              },
              "9,9": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: []
                    }
                  },
                  ",": {
                    "*": {
                      action_: "comma"
                    }
                  },
                  else: {
                    "*": {
                      action_: "copy"
                    }
                  }
                }),
                actions: {
                  comma: function comma() {
                    return {
                      type_: "commaDecimal"
                    };
                  }
                }
              },
              pu: {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  space$: {
                    "*": {
                      action_: ["output", "space"]
                    }
                  },
                  "{[(|)]}": {
                    "0|a": {
                      action_: "copy"
                    }
                  },
                  "(-)(9)^(-9)": {
                    0: {
                      action_: "number^",
                      nextState: "a"
                    }
                  },
                  "(-)(9.,9)(e)(99)": {
                    0: {
                      action_: "enumber",
                      nextState: "a"
                    }
                  },
                  space: {
                    "0|a": {
                      action_: []
                    }
                  },
                  "pm-operator": {
                    "0|a": {
                      action_: {
                        type_: "operator",
                        option: "\\pm"
                      },
                      nextState: "0"
                    }
                  },
                  operator: {
                    "0|a": {
                      action_: "copy",
                      nextState: "0"
                    }
                  },
                  "//": {
                    d: {
                      action_: "o=",
                      nextState: "/"
                    }
                  },
                  "/": {
                    d: {
                      action_: "o=",
                      nextState: "/"
                    }
                  },
                  "{...}|else": {
                    "0|d": {
                      action_: "d=",
                      nextState: "d"
                    },
                    a: {
                      action_: ["space", "d="],
                      nextState: "d"
                    },
                    "/|q": {
                      action_: "q=",
                      nextState: "q"
                    }
                  }
                }),
                actions: {
                  enumber: function enumber(t, e) {
                    var r = [];
                    return "+-" === e[0] || "+/-" === e[0] ? r.push("\\pm ") : e[0] && r.push(e[0]), e[1] && (o.concatArray(r, o.go(e[1], "pu-9,9")), e[2] && (e[2].match(/[,.]/) ? o.concatArray(r, o.go(e[2], "pu-9,9")) : r.push(e[2])), (e[3] || e[4]) && ("e" === e[3] || "*" === e[4] ? r.push({
                      type_: "cdot"
                    }) : r.push({
                      type_: "times"
                    }))), e[5] && r.push("10^{" + e[5] + "}"), r;
                  },
                  "number^": function number(t, e) {
                    var r = [];
                    return "+-" === e[0] || "+/-" === e[0] ? r.push("\\pm ") : e[0] && r.push(e[0]), o.concatArray(r, o.go(e[1], "pu-9,9")), r.push("^{" + e[2] + "}"), r;
                  },
                  operator: function operator(t, e, r) {
                    return {
                      type_: "operator",
                      kind_: r || e
                    };
                  },
                  space: function space() {
                    return {
                      type_: "pu-space-1"
                    };
                  },
                  output: function output(t) {
                    var e,
                      r = o.patterns.match_("{(...)}", t.d || "");
                    r && "" === r.remainder && (t.d = r.match_);
                    var n = o.patterns.match_("{(...)}", t.q || "");
                    if (n && "" === n.remainder && (t.q = n.match_), t.d && (t.d = t.d.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), t.d = t.d.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F")), t.q) {
                      t.q = t.q.replace(/\u00B0C|\^oC|\^{o}C/g, "{}^{\\circ}C"), t.q = t.q.replace(/\u00B0F|\^oF|\^{o}F/g, "{}^{\\circ}F");
                      var i = {
                        d: o.go(t.d, "pu"),
                        q: o.go(t.q, "pu")
                      };
                      "//" === t.o ? e = {
                        type_: "pu-frac",
                        p1: i.d,
                        p2: i.q
                      } : (e = i.d, i.d.length > 1 || i.q.length > 1 ? e.push({
                        type_: " / "
                      }) : e.push({
                        type_: "/"
                      }), o.concatArray(e, i.q));
                    } else e = o.go(t.d, "pu-2");
                    for (var a in t) delete t[a];
                    return e;
                  }
                }
              },
              "pu-2": {
                transitions: n({
                  empty: {
                    "*": {
                      action_: "output"
                    }
                  },
                  "*": {
                    "*": {
                      action_: ["output", "cdot"],
                      nextState: "0"
                    }
                  },
                  "\\x": {
                    "*": {
                      action_: "rm="
                    }
                  },
                  space: {
                    "*": {
                      action_: ["output", "space"],
                      nextState: "0"
                    }
                  },
                  "^{(...)}|^(-1)": {
                    1: {
                      action_: "^(-1)"
                    }
                  },
                  "-9.,9": {
                    0: {
                      action_: "rm=",
                      nextState: "0"
                    },
                    1: {
                      action_: "^(-1)",
                      nextState: "0"
                    }
                  },
                  "{...}|else": {
                    "*": {
                      action_: "rm=",
                      nextState: "1"
                    }
                  }
                }),
                actions: {
                  cdot: function cdot() {
                    return {
                      type_: "tight cdot"
                    };
                  },
                  "^(-1)": function _(t, e) {
                    t.rm += "^{" + e + "}";
                  },
                  space: function space() {
                    return {
                      type_: "pu-space-2"
                    };
                  },
                  output: function output(t) {
                    var e = [];
                    if (t.rm) {
                      var r = o.patterns.match_("{(...)}", t.rm || "");
                      e = r && "" === r.remainder ? o.go(r.match_, "pu") : {
                        type_: "rm",
                        p1: t.rm
                      };
                    }
                    for (var n in t) delete t[n];
                    return e;
                  }
                }
              },
              "pu-9,9": {
                transitions: n({
                  empty: {
                    0: {
                      action_: "output-0"
                    },
                    o: {
                      action_: "output-o"
                    }
                  },
                  ",": {
                    0: {
                      action_: ["output-0", "comma"],
                      nextState: "o"
                    }
                  },
                  ".": {
                    0: {
                      action_: ["output-0", "copy"],
                      nextState: "o"
                    }
                  },
                  else: {
                    "*": {
                      action_: "text="
                    }
                  }
                }),
                actions: {
                  comma: function comma() {
                    return {
                      type_: "commaDecimal"
                    };
                  },
                  "output-0": function output0(t) {
                    var e = [];
                    if (t.text_ = t.text_ || "", t.text_.length > 4) {
                      var r = t.text_.length % 3;
                      0 === r && (r = 3);
                      for (var n = t.text_.length - 3; n > 0; n -= 3) e.push(t.text_.substr(n, 3)), e.push({
                        type_: "1000 separator"
                      });
                      e.push(t.text_.substr(0, r)), e.reverse();
                    } else e.push(t.text_);
                    for (var o in t) delete t[o];
                    return e;
                  },
                  "output-o": function outputO(t) {
                    var e = [];
                    if (t.text_ = t.text_ || "", t.text_.length > 4) {
                      var r = t.text_.length - 3,
                        n = void 0;
                      for (n = 0; n < r; n += 3) e.push(t.text_.substr(n, 3)), e.push({
                        type_: "1000 separator"
                      });
                      e.push(t.text_.substr(n));
                    } else e.push(t.text_);
                    for (var o in t) delete t[o];
                    return e;
                  }
                }
              }
            }
          },
          i = {
            go: function go(t, e) {
              if (!t) return "";
              for (var r = "", n = !1, o = 0; o < t.length; o++) {
                var a = t[o];
                "string" == typeof a ? r += a : (r += i._go2(a), "1st-level escape" === a.type_ && (n = !0));
              }
              return e && !n && r && (r = "{" + r + "}"), r;
            },
            _goInner: function _goInner(t) {
              return i.go(t, !1);
            },
            _go2: function _go2(t) {
              var e;
              switch (t.type_) {
                case "chemfive":
                  e = "";
                  var r = {
                    a: i._goInner(t.a),
                    b: i._goInner(t.b),
                    p: i._goInner(t.p),
                    o: i._goInner(t.o),
                    q: i._goInner(t.q),
                    d: i._goInner(t.d)
                  };
                  r.a && (r.a.match(/^[+\-]/) && (r.a = "{" + r.a + "}"), e += r.a + "\\,"), (r.b || r.p) && (e += "{\\vphantom{A}}", e += "^{\\hphantom{" + (r.b || "") + "}}_{\\hphantom{" + (r.p || "") + "}}", e += "\\mkern-1.5mu", e += "{\\vphantom{A}}", e += "^{\\smash[t]{\\vphantom{2}}\\llap{" + (r.b || "") + "}}", e += "_{\\vphantom{2}\\llap{\\smash[t]{" + (r.p || "") + "}}}"), r.o && (r.o.match(/^[+\-]/) && (r.o = "{" + r.o + "}"), e += r.o), "kv" === t.dType ? ((r.d || r.q) && (e += "{\\vphantom{A}}"), r.d && (e += "^{" + r.d + "}"), r.q && (e += "_{\\smash[t]{" + r.q + "}}")) : "oxidation" === t.dType ? (r.d && (e += "{\\vphantom{A}}", e += "^{" + r.d + "}"), r.q && (e += "{\\vphantom{A}}", e += "_{\\smash[t]{" + r.q + "}}")) : (r.q && (e += "{\\vphantom{A}}", e += "_{\\smash[t]{" + r.q + "}}"), r.d && (e += "{\\vphantom{A}}", e += "^{" + r.d + "}"));
                  break;
                case "rm":
                case "roman numeral":
                  e = "\\mathrm{" + t.p1 + "}";
                  break;
                case "text":
                  t.p1.match(/[\^_]/) ? (t.p1 = t.p1.replace(" ", "~").replace("-", "\\text{-}"), e = "\\mathrm{" + t.p1 + "}") : e = "\\text{" + t.p1 + "}";
                  break;
                case "state of aggregation":
                  e = "\\mskip2mu " + i._goInner(t.p1);
                  break;
                case "state of aggregation subscript":
                  e = "\\mskip1mu " + i._goInner(t.p1);
                  break;
                case "bond":
                  if (!(e = i._getBond(t.kind_))) throw ["MhchemErrorBond", "mhchem Error. Unknown bond type (" + t.kind_ + ")"];
                  break;
                case "frac":
                  var n = "\\frac{" + t.p1 + "}{" + t.p2 + "}";
                  e = "\\mathchoice{\\textstyle" + n + "}{" + n + "}{" + n + "}{" + n + "}";
                  break;
                case "pu-frac":
                  var o = "\\frac{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  e = "\\mathchoice{\\textstyle" + o + "}{" + o + "}{" + o + "}{" + o + "}";
                  break;
                case "tex-math":
                case "1st-level escape":
                  e = t.p1 + " ";
                  break;
                case "frac-ce":
                  e = "\\frac{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "overset":
                  e = "\\overset{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "underset":
                  e = "\\underset{" + i._goInner(t.p1) + "}{" + i._goInner(t.p2) + "}";
                  break;
                case "underbrace":
                  e = "\\underbrace{" + i._goInner(t.p1) + "}_{" + i._goInner(t.p2) + "}";
                  break;
                case "color":
                  e = "{\\color{" + t.color1 + "}{" + i._goInner(t.color2) + "}}";
                  break;
                case "color0":
                  e = "\\color{" + t.color + "}";
                  break;
                case "arrow":
                  var a = {
                      rd: i._goInner(t.rd),
                      rq: i._goInner(t.rq)
                    },
                    Q = i._getArrow(t.r);
                  a.rd || a.rq ? "<=>" === t.r || "<=>>" === t.r || "<<=>" === t.r || "<--\x3e" === t.r ? (Q = "\\long" + Q, a.rd && (Q = "\\overset{" + a.rd + "}{" + Q + "}"), a.rq && (Q = "<--\x3e" === t.r ? "\\underset{\\lower2mu{" + a.rq + "}}{" + Q + "}" : "\\underset{\\lower6mu{" + a.rq + "}}{" + Q + "}"), Q = " {}\\mathrel{" + Q + "}{} ") : (a.rq && (Q += "[{" + a.rq + "}]"), Q = " {}\\mathrel{\\x" + (Q += "{" + a.rd + "}") + "}{} ") : Q = " {}\\mathrel{\\long" + Q + "}{} ", e = Q;
                  break;
                case "operator":
                  e = i._getOperator(t.kind_);
                  break;
                case "space":
                  e = " ";
                  break;
                case "tinySkip":
                  e = "\\mkern2mu";
                  break;
                case "entitySkip":
                case "pu-space-1":
                  e = "~";
                  break;
                case "pu-space-2":
                  e = "\\mkern3mu ";
                  break;
                case "1000 separator":
                  e = "\\mkern2mu ";
                  break;
                case "commaDecimal":
                  e = "{,}";
                  break;
                case "comma enumeration L":
                  e = "{" + t.p1 + "}\\mkern6mu ";
                  break;
                case "comma enumeration M":
                  e = "{" + t.p1 + "}\\mkern3mu ";
                  break;
                case "comma enumeration S":
                  e = "{" + t.p1 + "}\\mkern1mu ";
                  break;
                case "hyphen":
                  e = "\\text{-}";
                  break;
                case "addition compound":
                  e = "\\,{\\cdot}\\,";
                  break;
                case "electron dot":
                  e = "\\mkern1mu \\bullet\\mkern1mu ";
                  break;
                case "KV x":
                  e = "{\\times}";
                  break;
                case "prime":
                  e = "\\prime ";
                  break;
                case "cdot":
                  e = "\\cdot ";
                  break;
                case "tight cdot":
                  e = "\\mkern1mu{\\cdot}\\mkern1mu ";
                  break;
                case "times":
                  e = "\\times ";
                  break;
                case "circa":
                  e = "{\\sim}";
                  break;
                case "^":
                  e = "uparrow";
                  break;
                case "v":
                  e = "downarrow";
                  break;
                case "ellipsis":
                  e = "\\ldots ";
                  break;
                case "/":
                  e = "/";
                  break;
                case " / ":
                  e = "\\,/\\,";
                  break;
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
              return e;
            },
            _getArrow: function _getArrow(t) {
              switch (t) {
                case "->":
                case "\u2192":
                case "\u27F6":
                  return "rightarrow";
                case "<-":
                  return "leftarrow";
                case "<->":
                  return "leftrightarrow";
                case "<--\x3e":
                  return "leftrightarrows";
                case "<=>":
                case "\u21CC":
                  return "rightleftharpoons";
                case "<=>>":
                  return "Rightleftharpoons";
                case "<<=>":
                  return "Leftrightharpoons";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            },
            _getBond: function _getBond(t) {
              switch (t) {
                case "-":
                case "1":
                  return "{-}";
                case "=":
                case "2":
                  return "{=}";
                case "#":
                case "3":
                  return "{\\equiv}";
                case "~":
                  return "{\\tripledash}";
                case "~-":
                  return "{\\rlap{\\lower.1em{-}}\\raise.1em{\\tripledash}}";
                case "~=":
                case "~--":
                  return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{\\tripledash}}-}";
                case "-~-":
                  return "{\\rlap{\\lower.2em{-}}\\rlap{\\raise.2em{-}}\\tripledash}";
                case "...":
                  return "{{\\cdot}{\\cdot}{\\cdot}}";
                case "....":
                  return "{{\\cdot}{\\cdot}{\\cdot}{\\cdot}}";
                case "->":
                  return "{\\rightarrow}";
                case "<-":
                  return "{\\leftarrow}";
                case "<":
                  return "{<}";
                case ">":
                  return "{>}";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            },
            _getOperator: function _getOperator(t) {
              switch (t) {
                case "+":
                  return " {}+{} ";
                case "-":
                  return " {}-{} ";
                case "=":
                  return " {}={} ";
                case "<":
                  return " {}<{} ";
                case ">":
                  return " {}>{} ";
                case "<<":
                  return " {}\\ll{} ";
                case ">>":
                  return " {}\\gg{} ";
                case "\\pm":
                  return " {}\\pm{} ";
                case "\\approx":
                case "$\\approx$":
                  return " {}\\approx{} ";
                case "v":
                case "(v)":
                  return " \\downarrow{} ";
                case "^":
                case "(^)":
                  return " \\uparrow{} ";
                default:
                  throw ["MhchemBugT", "mhchem bug T. Please report."];
              }
            }
          };
      },
      9329: function _(t, e, r) {
        var _n121,
          o = this && this.__extends || (_n121 = function n(t, e) {
            return _n121 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n121(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n121(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEntry = void 0;
        var i = r(9328),
          a = r(2165),
          Q = function (t) {
            function e(e, r) {
              var n = t.call(this) || this;
              return n._menu = e, n._type = r, n.className = a.HtmlClasses.MENUITEM, n.role = "menuitem", n.hidden = !1, n;
            }
            return o(e, t), Object.defineProperty(e.prototype, "menu", {
              get: function get() {
                return this._menu;
              },
              set: function set(t) {
                this._menu = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "type", {
              get: function get() {
                return this._type;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.hide = function () {
              this.hidden = !0, this.menu.generateMenu();
            }, e.prototype.show = function () {
              this.hidden = !1, this.menu.generateMenu();
            }, e.prototype.isHidden = function () {
              return this.hidden;
            }, e;
          }(i.MenuElement);
        e.AbstractEntry = Q;
      },
      1340: function _(t, e, r) {
        var _n122,
          o = this && this.__extends || (_n122 = function n(t, e) {
            return _n122 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n122(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n122(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractItem = void 0;
        var a = r(9329),
          Q = r(2556),
          s = r(2165),
          T = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, r) || this;
              return i._content = n, i.disabled = !1, i.callbacks = [], i._id = o || n, i;
            }
            return o(e, t), Object.defineProperty(e.prototype, "content", {
              get: function get() {
                return this._content;
              },
              set: function set(t) {
                this._content = t, this.generateHtml(), this.menu && this.menu.generateHtml();
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "id", {
              get: function get() {
                return this._id;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.press = function () {
              this.disabled || (this.executeAction(), this.executeCallbacks_());
            }, e.prototype.executeAction = function () {}, e.prototype.registerCallback = function (t) {
              -1 === this.callbacks.indexOf(t) && this.callbacks.push(t);
            }, e.prototype.unregisterCallback = function (t) {
              var e = this.callbacks.indexOf(t);
              -1 !== e && this.callbacks.splice(e, 1);
            }, e.prototype.mousedown = function (t) {
              this.press(), this.stop(t);
            }, e.prototype.mouseover = function (t) {
              this.focus(), this.stop(t);
            }, e.prototype.mouseout = function (t) {
              this.deactivate(), this.stop(t);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.setAttribute("aria-disabled", "false"), e.textContent = this.content;
            }, e.prototype.activate = function () {
              this.disabled || this.html.classList.add(s.HtmlClasses.MENUACTIVE);
            }, e.prototype.deactivate = function () {
              this.html.classList.remove(s.HtmlClasses.MENUACTIVE);
            }, e.prototype.focus = function () {
              this.menu.focused = this, t.prototype.focus.call(this), this.activate();
            }, e.prototype.unfocus = function () {
              this.deactivate(), t.prototype.unfocus.call(this);
            }, e.prototype.escape = function (t) {
              Q.MenuUtil.close(this);
            }, e.prototype.up = function (t) {
              this.menu.up(t);
            }, e.prototype.down = function (t) {
              this.menu.down(t);
            }, e.prototype.left = function (t) {
              this.menu.left(t);
            }, e.prototype.right = function (t) {
              this.menu.right(t);
            }, e.prototype.space = function (t) {
              this.press();
            }, e.prototype.disable = function () {
              this.disabled = !0;
              var t = this.html;
              t.classList.add(s.HtmlClasses.MENUDISABLED), t.setAttribute("aria-disabled", "true");
            }, e.prototype.enable = function () {
              this.disabled = !1;
              var t = this.html;
              t.classList.remove(s.HtmlClasses.MENUDISABLED), t.removeAttribute("aria-disabled");
            }, e.prototype.executeCallbacks_ = function () {
              var t, e;
              try {
                for (var r = i(this.callbacks), n = r.next(); !n.done; n = r.next()) {
                  var o = n.value;
                  try {
                    o(this);
                  } catch (t) {
                    Q.MenuUtil.error(t, "Callback for menu entry " + this.id + " failed.");
                  }
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  n && !n.done && (e = r.return) && e.call(r);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e;
          }(a.AbstractEntry);
        e.AbstractItem = T;
      },
      1484: function _(t, e, r) {
        var _n123,
          o = this && this.__extends || (_n123 = function n(t, e) {
            return _n123 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n123(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n123(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractMenu = void 0;
        var a = r(8372),
          Q = r(1340),
          s = r(2165),
          T = r(6186),
          l = function (t) {
            function e() {
              var e = null !== t && t.apply(this, arguments) || this;
              return e.className = s.HtmlClasses.CONTEXTMENU, e.role = "menu", e._items = [], e._baseMenu = null, e;
            }
            return o(e, t), Object.defineProperty(e.prototype, "baseMenu", {
              get: function get() {
                return this._baseMenu;
              },
              set: function set(t) {
                this._baseMenu = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "items", {
              get: function get() {
                return this._items;
              },
              set: function set(t) {
                this._items = t;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "pool", {
              get: function get() {
                return this.variablePool;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "focused", {
              get: function get() {
                return this._focused;
              },
              set: function set(t) {
                if (this._focused !== t) {
                  this._focused || this.unfocus();
                  var e = this._focused;
                  this._focused = t, e && e.unfocus();
                }
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.up = function (t) {
              var e = this.items.filter(function (t) {
                return t instanceof Q.AbstractItem && !t.isHidden();
              });
              if (0 !== e.length) if (this.focused) {
                var r = e.indexOf(this.focused);
                -1 !== r && e[r = r ? --r : e.length - 1].focus();
              } else e[e.length - 1].focus();
            }, e.prototype.down = function (t) {
              var e = this.items.filter(function (t) {
                return t instanceof Q.AbstractItem && !t.isHidden();
              });
              if (0 !== e.length) if (this.focused) {
                var r = e.indexOf(this.focused);
                -1 !== r && e[r = ++r === e.length ? 0 : r].focus();
              } else e[0].focus();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.generateMenu();
            }, e.prototype.generateMenu = function () {
              var t,
                e,
                r = this.html;
              r.classList.add(s.HtmlClasses.MENU);
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if (a.isHidden()) {
                    var Q = a.html;
                    Q.parentNode && Q.parentNode.removeChild(Q);
                  } else r.appendChild(a.html);
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.post = function (e, r) {
              this.variablePool.update(), t.prototype.post.call(this, e, r);
            }, e.prototype.unpostSubmenus = function () {
              var t,
                e,
                r = this.items.filter(function (t) {
                  return t instanceof T.Submenu;
                });
              try {
                for (var n = i(r), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  a.submenu.unpost(), a !== this.focused && a.unfocus();
                }
              } catch (e) {
                t = {
                  error: e
                };
              } finally {
                try {
                  o && !o.done && (e = n.return) && e.call(n);
                } finally {
                  if (t) throw t.error;
                }
              }
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.unpostSubmenus(), this.focused = null;
            }, e.prototype.find = function (t) {
              var e, r;
              try {
                for (var n = i(this.items), o = n.next(); !o.done; o = n.next()) {
                  var a = o.value;
                  if ("rule" !== a.type) {
                    if (a.id === t) return a;
                    if ("submenu" === a.type) {
                      var Q = a.submenu.find(t);
                      if (Q) return Q;
                    }
                  }
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  o && !o.done && (r = n.return) && r.call(n);
                } finally {
                  if (e) throw e.error;
                }
              }
              return null;
            }, e;
          }(a.AbstractPostable);
        e.AbstractMenu = l;
      },
      2868: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractNavigatable = void 0;
        var n = r(3205),
          o = r(8853),
          i = function () {
            function t() {
              this.bubble = !1;
            }
            return t.prototype.bubbleKey = function () {
              this.bubble = !0;
            }, t.prototype.keydown = function (t) {
              switch (t.keyCode) {
                case n.KEY.ESCAPE:
                  this.escape(t);
                  break;
                case n.KEY.RIGHT:
                  this.right(t);
                  break;
                case n.KEY.LEFT:
                  this.left(t);
                  break;
                case n.KEY.UP:
                  this.up(t);
                  break;
                case n.KEY.DOWN:
                  this.down(t);
                  break;
                case n.KEY.RETURN:
                case n.KEY.SPACE:
                  this.space(t);
                  break;
                default:
                  return;
              }
              this.bubble ? this.bubble = !1 : this.stop(t);
            }, t.prototype.escape = function (t) {}, t.prototype.space = function (t) {}, t.prototype.left = function (t) {}, t.prototype.right = function (t) {}, t.prototype.up = function (t) {}, t.prototype.down = function (t) {}, t.prototype.stop = function (t) {
              t && (t.stopPropagation(), t.preventDefault(), t.cancelBubble = !0);
            }, t.prototype.mousedown = function (t) {
              return this.stop(t);
            }, t.prototype.mouseup = function (t) {
              return this.stop(t);
            }, t.prototype.mouseover = function (t) {
              return this.stop(t);
            }, t.prototype.mouseout = function (t) {
              return this.stop(t);
            }, t.prototype.click = function (t) {
              return this.stop(t);
            }, t.prototype.addEvents = function (t) {
              t.addEventListener(o.MOUSE.DOWN, this.mousedown.bind(this)), t.addEventListener(o.MOUSE.UP, this.mouseup.bind(this)), t.addEventListener(o.MOUSE.OVER, this.mouseover.bind(this)), t.addEventListener(o.MOUSE.OUT, this.mouseout.bind(this)), t.addEventListener(o.MOUSE.CLICK, this.click.bind(this)), t.addEventListener("keydown", this.keydown.bind(this)), t.addEventListener("dragstart", this.stop.bind(this)), t.addEventListener(o.MOUSE.SELECTSTART, this.stop.bind(this)), t.addEventListener("contextmenu", this.stop.bind(this)), t.addEventListener(o.MOUSE.DBLCLICK, this.stop.bind(this));
            }, t;
          }();
        e.AbstractNavigatable = i;
      },
      8372: function _(t, e, r) {
        var _n124,
          o = this && this.__extends || (_n124 = function n(t, e) {
            return _n124 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n124(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n124(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractPostable = void 0;
        var i = function (t) {
          function e() {
            var e = null !== t && t.apply(this, arguments) || this;
            return e.posted = !1, e;
          }
          return o(e, t), e.prototype.isPosted = function () {
            return this.posted;
          }, e.prototype.post = function (t, e) {
            this.posted || (void 0 !== t && void 0 !== e && this.html.setAttribute("style", "left: " + t + "px; top: " + e + "px;"), this.display(), this.posted = !0);
          }, e.prototype.unpost = function () {
            if (this.posted) {
              var t = this.html;
              t.parentNode && t.parentNode.removeChild(t), this.posted = !1;
            }
          }, e;
        }(r(9328).MenuElement);
        e.AbstractPostable = i;
      },
      6765: function _(t, e, r) {
        var _n125,
          o = this && this.__extends || (_n125 = function n(t, e) {
            return _n125 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n125(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n125(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractVariableItem = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.generateHtml = function () {
            t.prototype.generateHtml.call(this);
            var e = this.html;
            this.span || this.generateSpan(), e.appendChild(this.span), this.update();
          }, e.prototype.register = function () {
            this.variable.register(this);
          }, e.prototype.unregister = function () {
            this.variable.unregister(this);
          }, e.prototype.update = function () {
            this.updateAria(), this.span && this.updateSpan();
          }, e;
        }(r(1340).AbstractItem);
        e.AbstractVariableItem = i;
      },
      5179: function _(t, e, r) {
        var _n126,
          o = this && this.__extends || (_n126 = function n(t, e) {
            return _n126 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n126(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n126(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CloseButton = void 0;
        var i = r(8372),
          a = r(2165),
          Q = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.element = e, r.className = a.HtmlClasses.MENUCLOSE, r.role = "button", r;
            }
            return o(e, t), e.prototype.generateHtml = function () {
              var t = document.createElement("span");
              t.classList.add(this.className), t.setAttribute("role", this.role), t.setAttribute("tabindex", "0");
              var e = document.createElement("span");
              e.textContent = "\xd7", t.appendChild(e), this.html = t;
            }, e.prototype.display = function () {}, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.element.unpost();
            }, e.prototype.keydown = function (e) {
              this.bubbleKey(), t.prototype.keydown.call(this, e);
            }, e.prototype.space = function (t) {
              this.unpost(), this.stop(t);
            }, e.prototype.mousedown = function (t) {
              this.unpost(), this.stop(t);
            }, e;
          }(i.AbstractPostable);
        e.CloseButton = Q;
      },
      5073: function _(t, e, r) {
        var _n127,
          o = this && this.__extends || (_n127 = function n(t, e) {
            return _n127 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n127(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n127(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContextMenu = void 0;
        var i = r(1484),
          a = r(2165),
          Q = r(1932),
          s = r(2358),
          T = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.factory = e, r.id = "", r.moving = !1, r._store = new Q.MenuStore(r), r.widgets = [], r.variablePool = new s.VariablePool(), r;
            }
            return o(e, t), e.fromJson = function (t, e) {
              var r = e.pool,
                n = e.items,
                o = e.id,
                i = void 0 === o ? "" : o,
                a = new this(t);
              a.id = i;
              var Q = t.get("variable");
              r.forEach(function (e) {
                return Q(t, e, a.pool);
              });
              var s = t.get("items")(t, n, a);
              return a.items = s, a;
            }, e.prototype.generateHtml = function () {
              this.isPosted() && this.unpost(), t.prototype.generateHtml.call(this), this._frame = document.createElement("div"), this._frame.classList.add(a.HtmlClasses.MENUFRAME);
              var e = "left: 0px; top: 0px; z-index: 200; width: 100%; height: 100%; border: 0px; padding: 0px; margin: 0px;";
              this._frame.setAttribute("style", "position: absolute; " + e);
              var r = document.createElement("div");
              r.setAttribute("style", "position: fixed; " + e), this._frame.appendChild(r), r.addEventListener("mousedown", function (t) {
                this.unpost(), this.unpostWidgets(), this.stop(t);
              }.bind(this));
            }, e.prototype.display = function () {
              document.body.appendChild(this.frame), this.frame.appendChild(this.html), this.focus();
            }, e.prototype.escape = function (t) {
              this.unpost(), this.unpostWidgets();
            }, e.prototype.unpost = function () {
              if (t.prototype.unpost.call(this), !(this.widgets.length > 0)) {
                this.frame.parentNode.removeChild(this.frame);
                var e = this.store;
                this.moving || e.insertTaborder(), e.active.focus();
              }
            }, e.prototype.left = function (t) {
              this.move_(this.store.previous());
            }, e.prototype.right = function (t) {
              this.move_(this.store.next());
            }, Object.defineProperty(e.prototype, "frame", {
              get: function get() {
                return this._frame;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "store", {
              get: function get() {
                return this._store;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.post = function (e, r) {
              if (void 0 !== r) return this.moving || this.store.removeTaborder(), void t.prototype.post.call(this, e, r);
              var n,
                o,
                i,
                a = e;
              if (a instanceof Event ? (n = a.target, this.stop(a)) : n = a, a instanceof MouseEvent && (o = a.pageX, i = a.pageY, o || i || !a.clientX || (o = a.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, i = a.clientY + document.body.scrollTop + document.documentElement.scrollTop)), !o && !i && n) {
                var Q = window.pageXOffset || document.documentElement.scrollLeft,
                  s = window.pageYOffset || document.documentElement.scrollTop,
                  T = n.getBoundingClientRect();
                o = (T.right + T.left) / 2 + Q, i = (T.bottom + T.top) / 2 + s;
              }
              this.store.active = n, this.anchor = this.store.active;
              var l = this.html;
              o + l.offsetWidth > document.body.offsetWidth - 5 && (o = document.body.offsetWidth - l.offsetWidth - 5), this.post(o, i);
            }, e.prototype.registerWidget = function (t) {
              this.widgets.push(t);
            }, e.prototype.unregisterWidget = function (t) {
              var e = this.widgets.indexOf(t);
              e > -1 && this.widgets.splice(e, 1), 0 === this.widgets.length && this.unpost();
            }, e.prototype.unpostWidgets = function () {
              this.widgets.forEach(function (t) {
                return t.unpost();
              });
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e.prototype.move_ = function (t) {
              this.anchor && t !== this.anchor && (this.moving = !0, this.unpost(), this.post(t), this.moving = !1);
            }, e;
          }(i.AbstractMenu);
        e.ContextMenu = T;
      },
      7309: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssStyles = void 0;
        var n = r(2165);
        !function (t) {
          function e(t) {
            return "." + (n.HtmlClasses[t] || t);
          }
          var r = {};
          r[e("INFOCLOSE")] = "{  top:.2em; right:.2em;}", r[e("INFOCONTENT")] = "{  overflow:auto; text-align:left; font-size:80%;  padding:.4em .6em; border:1px inset; margin:1em 0px;  max-height:20em; max-width:30em; background-color:#EEEEEE;  white-space:normal;}", r[e("INFO") + e("MOUSEPOST")] = "{outline:none;}", r[e("INFO")] = '{  position:fixed; left:50%; width:auto; text-align:center;  border:3px outset; padding:1em 2em; background-color:#DDDDDD;  color:black;  cursor:default; font-family:message-box; font-size:120%;  font-style:normal; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 15px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius:15px;               /* Safari and Chrome */  -moz-border-radius:15px;                  /* Firefox */  -khtml-border-radius:15px;                /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */  filter:progid:DXImageTransform.Microsoft.dropshadow(OffX=2, OffY=2, Color="gray", Positive="true"); /* IE */}';
          var o = {};
          o[e("MENU")] = "{  position:absolute;  background-color:white;  color:black;  width:auto; padding:5px 0px;  border:1px solid #CCCCCC; margin:0; cursor:default;  font: menu; text-align:left; text-indent:0; text-transform:none;  line-height:normal; letter-spacing:normal; word-spacing:normal;  word-wrap:normal; white-space:nowrap; float:none; z-index:201;  border-radius: 5px;                     /* Opera 10.5 and IE9 */  -webkit-border-radius: 5px;             /* Safari and Chrome */  -moz-border-radius: 5px;                /* Firefox */  -khtml-border-radius: 5px;              /* Konqueror */  box-shadow:0px 10px 20px #808080;         /* Opera 10.5 and IE9 */  -webkit-box-shadow:0px 10px 20px #808080; /* Safari 3 & Chrome */  -moz-box-shadow:0px 10px 20px #808080;    /* Forefox 3.5 */  -khtml-box-shadow:0px 10px 20px #808080;  /* Konqueror */}", o[e("MENUITEM")] = "{  padding: 1px 2em;  background:transparent;}", o[e("MENUARROW")] = "{  position:absolute; right:.5em; padding-top:.25em; color:#666666;  font-family: null; font-size: .75em}", o[e("MENUACTIVE") + " " + e("MENUARROW")] = "{color:white}", o[e("MENUARROW") + e("RTL")] = "{left:.5em; right:auto}", o[e("MENUCHECK")] = "{  position:absolute; left:.7em;  font-family: null}", o[e("MENUCHECK") + e("RTL")] = "{ right:.7em; left:auto }", o[e("MENURADIOCHECK")] = "{  position:absolute; left: .7em;}", o[e("MENURADIOCHECK") + e("RTL")] = "{  right: .7em; left:auto}", o[e("MENUINPUTBOX")] = "{  padding-left: 1em; right:.5em; color:#666666;  font-family: null;}", o[e("MENUINPUTBOX") + e("RTL")] = "{  left: .1em;}", o[e("MENUCOMBOBOX")] = "{  left:.1em; padding-bottom:.5em;}", o[e("MENUSLIDER")] = "{  left: .1em;}", o[e("SLIDERVALUE")] = "{  position:absolute; right:.1em; padding-top:.25em; color:#333333;  font-size: .75em}", o[e("SLIDERBAR")] = "{  outline: none; background: #d3d3d3}", o[e("MENULABEL")] = "{  padding: 1px 2em 3px 1.33em;  font-style:italic}", o[e("MENURULE")] = "{  border-top: 1px solid #DDDDDD;  margin: 4px 3px;}", o[e("MENUDISABLED")] = "{  color:GrayText}", o[e("MENUACTIVE")] = "{  background-color: #606872;  color: white;}", o[e("MENUDISABLED") + ":focus"] = "{  background-color: #E8E8E8}", o[e("MENULABEL") + ":focus"] = "{  background-color: #E8E8E8}", o[e("CONTEXTMENU") + ":focus"] = "{  outline:none}", o[e("CONTEXTMENU") + " " + e("MENUITEM") + ":focus"] = "{  outline:none}", o[e("SELECTIONMENU")] = "{  position:relative; float:left;  border-bottom: none; -webkit-box-shadow:none; -webkit-border-radius:0px; }", o[e("SELECTIONITEM")] = "{  padding-right: 1em;}", o[e("SELECTION")] = "{  right: 40%; width:50%; }", o[e("SELECTIONBOX")] = "{  padding: 0em; max-height:20em; max-width: none;  background-color:#FFFFFF;}", o[e("SELECTIONDIVIDER")] = "{  clear: both; border-top: 2px solid #000000;}", o[e("MENU") + " " + e("MENUCLOSE")] = "{  top:-10px; left:-10px}";
          var i = {};
          i[e("MENUCLOSE")] = '{  position:absolute;  cursor:pointer;  display:inline-block;  border:2px solid #AAA;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  font-family: "Courier New", Courier;  font-size:24px;  color:#F0F0F0}', i[e("MENUCLOSE") + " span"] = "{  display:block; background-color:#AAA; border:1.5px solid;  border-radius:18px;  -webkit-border-radius: 18px;             /* Safari and Chrome */  -moz-border-radius: 18px;                /* Firefox */  -khtml-border-radius: 18px;              /* Konqueror */  line-height:0;  padding:8px 0 6px     /* may need to be browser-specific */}", i[e("MENUCLOSE") + ":hover"] = "{  color:white!important;  border:2px solid #CCC!important}", i[e("MENUCLOSE") + ":hover span"] = "{  background-color:#CCC!important}", i[e("MENUCLOSE") + ":hover:focus"] = "{  outline:none}";
          var a = !1,
            Q = !1,
            s = !1;
          function T(t) {
            s || (l(i, t), s = !0);
          }
          function l(t, e) {
            var r = e || document,
              n = r.createElement("style");
            n.type = "text/css";
            var o = "";
            for (var i in t) o += i, o += " ", o += t[i], o += "\n";
            n.innerHTML = o, r.head.appendChild(n);
          }
          t.addMenuStyles = function (t) {
            Q || (l(o, t), Q = !0, T(t));
          }, t.addInfoStyles = function (t) {
            a || (l(r, t), a = !0, T(t));
          };
        }(e.CssStyles || (e.CssStyles = {}));
      },
      2165: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlAttrs = e.HtmlClasses = void 0;
        function r(t) {
          return "CtxtMenu_" + t;
        }
        function n(t) {
          return r(t);
        }
        function o(t) {
          return r(t);
        }
        e.HtmlClasses = {
          ATTACHED: n("Attached"),
          CONTEXTMENU: n("ContextMenu"),
          MENU: n("Menu"),
          MENUARROW: n("MenuArrow"),
          MENUACTIVE: n("MenuActive"),
          MENUCHECK: n("MenuCheck"),
          MENUCLOSE: n("MenuClose"),
          MENUCOMBOBOX: n("MenuComboBox"),
          MENUDISABLED: n("MenuDisabled"),
          MENUFRAME: n("MenuFrame"),
          MENUITEM: n("MenuItem"),
          MENULABEL: n("MenuLabel"),
          MENURADIOCHECK: n("MenuRadioCheck"),
          MENUINPUTBOX: n("MenuInputBox"),
          MENURULE: n("MenuRule"),
          MENUSLIDER: n("MenuSlider"),
          MOUSEPOST: n("MousePost"),
          RTL: n("RTL"),
          INFO: n("Info"),
          INFOCLOSE: n("InfoClose"),
          INFOCONTENT: n("InfoContent"),
          INFOSIGNATURE: n("InfoSignature"),
          INFOTITLE: n("InfoTitle"),
          SLIDERVALUE: n("SliderValue"),
          SLIDERBAR: n("SliderBar"),
          SELECTION: n("Selection"),
          SELECTIONBOX: n("SelectionBox"),
          SELECTIONMENU: n("SelectionMenu"),
          SELECTIONDIVIDER: n("SelectionDivider"),
          SELECTIONITEM: n("SelectionItem")
        }, e.HtmlAttrs = {
          COUNTER: o("Counter"),
          KEYDOWNFUNC: o("keydownFunc"),
          CONTEXTMENUFUNC: o("contextmenuFunc"),
          OLDTAB: o("Oldtabindex"),
          TOUCHFUNC: o("TouchFunc")
        };
      },
      4922: function _(t, e, r) {
        var _n128,
          o = this && this.__extends || (_n128 = function n(t, e) {
            return _n128 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n128(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n128(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Info = void 0;
        var i = r(5179),
          a = r(2165),
          Q = function (t) {
            function e(e, r, n) {
              var o = t.call(this) || this;
              return o.title = e, o.signature = n, o.className = a.HtmlClasses.INFO, o.role = "dialog", o.contentDiv = o.generateContent(), o.close = o.generateClose(), o.content = r || function () {
                return "";
              }, o;
            }
            return o(e, t), e.prototype.attachMenu = function (t) {
              this.menu = t;
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.appendChild(this.generateTitle()), e.appendChild(this.contentDiv), e.appendChild(this.generateSignature()), e.appendChild(this.close.html), e.setAttribute("tabindex", "0");
            }, e.prototype.post = function () {
              t.prototype.post.call(this);
              var e = document.documentElement,
                r = this.html,
                n = window.innerHeight || e.clientHeight || e.scrollHeight || 0,
                o = Math.floor(-r.offsetWidth / 2),
                i = Math.floor((n - r.offsetHeight) / 3);
              r.setAttribute("style", "margin-left: " + o + "px; top: " + i + "px;"), window.event instanceof MouseEvent && r.classList.add(a.HtmlClasses.MOUSEPOST), r.focus();
            }, e.prototype.display = function () {
              this.menu.registerWidget(this), this.contentDiv.innerHTML = this.content();
              var t = this.menu.html;
              t.parentNode && t.parentNode.removeChild(t), this.menu.frame.appendChild(this.html);
            }, e.prototype.click = function (t) {}, e.prototype.keydown = function (e) {
              this.bubbleKey(), t.prototype.keydown.call(this, e);
            }, e.prototype.escape = function (t) {
              this.unpost();
            }, e.prototype.unpost = function () {
              t.prototype.unpost.call(this), this.html.classList.remove(a.HtmlClasses.MOUSEPOST), this.menu.unregisterWidget(this);
            }, e.prototype.generateClose = function () {
              var t = new i.CloseButton(this),
                e = t.html;
              return e.classList.add(a.HtmlClasses.INFOCLOSE), e.setAttribute("aria-label", "Close Dialog Box"), t;
            }, e.prototype.generateTitle = function () {
              var t = document.createElement("span");
              return t.innerHTML = this.title, t.classList.add(a.HtmlClasses.INFOTITLE), t;
            }, e.prototype.generateContent = function () {
              var t = document.createElement("div");
              return t.classList.add(a.HtmlClasses.INFOCONTENT), t.setAttribute("tabindex", "0"), t;
            }, e.prototype.generateSignature = function () {
              var t = document.createElement("span");
              return t.innerHTML = this.signature, t.classList.add(a.HtmlClasses.INFOSIGNATURE), t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(r(8372).AbstractPostable);
        e.Info = Q;
      },
      1409: function _(t, e, r) {
        var _n129,
          o = this && this.__extends || (_n129 = function n(t, e) {
            return _n129 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n129(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n129(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Checkbox = void 0;
        var i = r(6765),
          a = r(2556),
          Q = r(2165),
          s = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "checkbox", r, o) || this;
              return i.role = "menuitemcheckbox", i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(!this.variable.getValue()), a.MenuUtil.close(this);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.textContent = "\u2713", this.span.classList.add(Q.HtmlClasses.MENUCHECK);
            }, e.prototype.updateAria = function () {
              this.html.setAttribute("aria-checked", this.variable.getValue() ? "true" : "false");
            }, e.prototype.updateSpan = function () {
              this.span.style.display = this.variable.getValue() ? "" : "none";
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Checkbox = s;
      },
      9886: function _(t, e, r) {
        var _n130,
          o = this && this.__extends || (_n130 = function n(t, e) {
            return _n130 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n130(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n130(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Combo = void 0;
        var i = r(6765),
          a = r(2556),
          Q = r(2165),
          s = r(3205),
          T = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "combobox", r, o) || this;
              return i.role = "combobox", i.inputEvent = !1, i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.input.value, a.MenuUtil.getActiveElement(this));
            }, e.prototype.space = function (e) {
              t.prototype.space.call(this, e), a.MenuUtil.close(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.input.focus();
            }, e.prototype.unfocus = function () {
              t.prototype.unfocus.call(this), this.updateSpan();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(Q.HtmlClasses.MENUCOMBOBOX);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.classList.add(Q.HtmlClasses.MENUINPUTBOX), this.input = document.createElement("input"), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.setAttribute("size", "10em"), this.input.setAttribute("type", "text"), this.input.setAttribute("tabindex", "-1"), this.span.appendChild(this.input);
            }, e.prototype.inputKey = function (t) {
              this.bubbleKey(), this.inputEvent = !0;
            }, e.prototype.keydown = function (e) {
              if (this.inputEvent && e.keyCode !== s.KEY.ESCAPE && e.keyCode !== s.KEY.RETURN) return this.inputEvent = !1, void e.stopPropagation();
              t.prototype.keydown.call(this, e), e.stopPropagation();
            }, e.prototype.updateAria = function () {}, e.prototype.updateSpan = function () {
              var t;
              try {
                t = this.variable.getValue(a.MenuUtil.getActiveElement(this));
              } catch (e) {
                t = "";
              }
              this.input.value = t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Combo = T;
      },
      3467: function _(t, e, r) {
        var _n131,
          o = this && this.__extends || (_n131 = function n(t, e) {
            return _n131 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n131(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n131(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Command = void 0;
        var i = r(1340),
          a = r(2556),
          Q = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "command", r, o) || this;
              return i.command = n, i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.action, e.id);
            }, e.prototype.executeAction = function () {
              try {
                this.command(a.MenuUtil.getActiveElement(this));
              } catch (t) {
                a.MenuUtil.error(t, "Illegal command callback.");
              }
              a.MenuUtil.close(this);
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Command = Q;
      },
      2965: function _(t, e, r) {
        var _n132,
          o = this && this.__extends || (_n132 = function n(t, e) {
            return _n132 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n132(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n132(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Label = void 0;
        var i = r(1340),
          a = r(2165),
          Q = function (t) {
            function e(e, r, n) {
              return t.call(this, e, "label", r, n) || this;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.id);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(a.HtmlClasses.MENULABEL);
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Label = Q;
      },
      385: function _(t, e, r) {
        var _n133,
          o = this && this.__extends || (_n133 = function n(t, e) {
            return _n133 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n133(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n133(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Radio = void 0;
        var i = r(6765),
          a = r(2556),
          Q = r(2165),
          s = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "radio", r, o) || this;
              return i.role = "menuitemradio", i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.id), a.MenuUtil.close(this);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.span.textContent = "\u2713", this.span.classList.add(Q.HtmlClasses.MENURADIOCHECK);
            }, e.prototype.updateAria = function () {
              this.html.setAttribute("aria-checked", this.variable.getValue() === this.id ? "true" : "false");
            }, e.prototype.updateSpan = function () {
              this.span.style.display = this.variable.getValue() === this.id ? "" : "none";
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Radio = s;
      },
      3463: function _(t, e, r) {
        var _n134,
          o = this && this.__extends || (_n134 = function n(t, e) {
            return _n134 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n134(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n134(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Rule = void 0;
        var i = r(9329),
          a = r(2165),
          Q = function (t) {
            function e(e) {
              var r = t.call(this, e, "rule") || this;
              return r.className = a.HtmlClasses.MENUITEM, r.role = "separator", r;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r);
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              e.classList.add(a.HtmlClasses.MENURULE), e.setAttribute("aria-orientation", "vertical");
            }, e.prototype.addEvents = function (t) {}, e.prototype.toJson = function () {
              return {
                type: "rule"
              };
            }, e;
          }(i.AbstractEntry);
        e.Rule = Q;
      },
      7625: function _(t, e, r) {
        var _n135,
          o = this && this.__extends || (_n135 = function n(t, e) {
            return _n135 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n135(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n135(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Slider = void 0;
        var i = r(6765),
          a = r(2556),
          Q = r(2165),
          s = r(3205),
          T = function (t) {
            function e(e, r, n, o) {
              var i = t.call(this, e, "slider", r, o) || this;
              return i.role = "slider", i.labelId = "ctx_slideLabel" + a.MenuUtil.counter(), i.valueId = "ctx_slideValue" + a.MenuUtil.counter(), i.inputEvent = !1, i.variable = e.pool.lookup(n), i.register(), i;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              return new this(r, e.content, e.variable, e.id);
            }, e.prototype.executeAction = function () {
              this.variable.setValue(this.input.value, a.MenuUtil.getActiveElement(this)), this.update();
            }, e.prototype.space = function (e) {
              t.prototype.space.call(this, e), a.MenuUtil.close(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.input.focus();
            }, e.prototype.unfocus = function () {
              t.prototype.unfocus.call(this), this.updateSpan();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.html.classList.add(Q.HtmlClasses.MENUSLIDER), this.valueSpan = document.createElement("span"), this.valueSpan.setAttribute("id", this.valueId), this.valueSpan.classList.add(Q.HtmlClasses.SLIDERVALUE), this.html.appendChild(this.valueSpan);
            }, e.prototype.generateSpan = function () {
              this.span = document.createElement("span"), this.labelSpan = document.createElement("span"), this.labelSpan.setAttribute("id", this.labelId), this.labelSpan.appendChild(this.html.childNodes[0]), this.html.appendChild(this.labelSpan), this.input = document.createElement("input"), this.input.setAttribute("type", "range"), this.input.setAttribute("min", "0"), this.input.setAttribute("max", "100"), this.input.setAttribute("aria-valuemin", "0"), this.input.setAttribute("aria-valuemax", "100"), this.input.setAttribute("aria-labelledby", this.labelId), this.input.addEventListener("keydown", this.inputKey.bind(this)), this.input.addEventListener("input", this.executeAction.bind(this)), this.input.classList.add(Q.HtmlClasses.SLIDERBAR), this.span.appendChild(this.input);
            }, e.prototype.inputKey = function (t) {
              this.inputEvent = !0;
            }, e.prototype.mousedown = function (t) {
              t.stopPropagation();
            }, e.prototype.mouseup = function (t) {
              event.stopPropagation();
            }, e.prototype.keydown = function (e) {
              var r = e.keyCode;
              return r === s.KEY.UP || r === s.KEY.DOWN ? (e.preventDefault(), void t.prototype.keydown.call(this, e)) : this.inputEvent && r !== s.KEY.ESCAPE && r !== s.KEY.RETURN ? (this.inputEvent = !1, void e.stopPropagation()) : (t.prototype.keydown.call(this, e), void e.stopPropagation());
            }, e.prototype.updateAria = function () {
              var t = this.variable.getValue();
              t && this.input && (this.input.setAttribute("aria-valuenow", t), this.input.setAttribute("aria-valuetext", t + "%"));
            }, e.prototype.updateSpan = function () {
              var t;
              try {
                t = this.variable.getValue(a.MenuUtil.getActiveElement(this)), this.valueSpan.innerHTML = t + "%";
              } catch (e) {
                t = "";
              }
              this.input.value = t;
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractVariableItem);
        e.Slider = T;
      },
      6186: function _(t, e, r) {
        var _n136,
          o = this && this.__extends || (_n136 = function n(t, e) {
            return _n136 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n136(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n136(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Submenu = void 0;
        var i = r(1340),
          a = r(2165),
          Q = function (t) {
            function e(e, r, n) {
              var o = t.call(this, e, "submenu", r, n) || this;
              return o._submenu = null, o;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              var n = e.content,
                o = e.menu,
                i = new this(r, n, e.id),
                a = t.get("subMenu")(t, o, i);
              return i.submenu = a, i;
            }, Object.defineProperty(e.prototype, "submenu", {
              get: function get() {
                return this._submenu;
              },
              set: function set(t) {
                this._submenu = t;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.mouseover = function (t) {
              this.focus(), this.stop(t);
            }, e.prototype.mouseout = function (t) {
              this.stop(t);
            }, e.prototype.unfocus = function () {
              if (this.submenu.isPosted()) {
                if (this.menu.focused !== this) return t.prototype.unfocus.call(this), void this.menu.unpostSubmenus();
                this.html.setAttribute("tabindex", "-1"), this.html.blur();
              } else t.prototype.unfocus.call(this);
            }, e.prototype.focus = function () {
              t.prototype.focus.call(this), this.submenu.isPosted() || this.disabled || this.submenu.post();
            }, e.prototype.executeAction = function () {
              this.submenu.isPosted() ? this.submenu.unpost() : this.submenu.post();
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this);
              var e = this.html;
              this.span = document.createElement("span"), this.span.textContent = "\u25BA", this.span.classList.add(a.HtmlClasses.MENUARROW), e.appendChild(this.span), e.setAttribute("aria-haspopup", "true");
            }, e.prototype.left = function (e) {
              this.submenu.isPosted() ? this.submenu.unpost() : t.prototype.left.call(this, e);
            }, e.prototype.right = function (t) {
              this.submenu.isPosted() ? this.submenu.down(t) : this.submenu.post();
            }, e.prototype.toJson = function () {
              return {
                type: ""
              };
            }, e;
          }(i.AbstractItem);
        e.Submenu = Q;
      },
      3205: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.KEY = void 0, function (t) {
          t[t.RETURN = 13] = "RETURN", t[t.ESCAPE = 27] = "ESCAPE", t[t.SPACE = 32] = "SPACE", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN";
        }(e.KEY || (e.KEY = {}));
      },
      9328: function _(t, e, r) {
        var _n137,
          o = this && this.__extends || (_n137 = function n(t, e) {
            return _n137 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n137(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n137(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuElement = void 0;
        var i = function (t) {
          function e() {
            return null !== t && t.apply(this, arguments) || this;
          }
          return o(e, t), e.prototype.addAttributes = function (t) {
            for (var e in t) this.html.setAttribute(e, t[e]);
          }, Object.defineProperty(e.prototype, "html", {
            get: function get() {
              return this._html || this.generateHtml(), this._html;
            },
            set: function set(t) {
              this._html = t, this.addEvents(t);
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.generateHtml = function () {
            var t = document.createElement("div");
            t.classList.add(this.className), t.setAttribute("role", this.role), this.html = t;
          }, e.prototype.focus = function () {
            var t = this.html;
            t.setAttribute("tabindex", "0"), t.focus();
          }, e.prototype.unfocus = function () {
            var t = this.html;
            t.hasAttribute("tabindex") && t.setAttribute("tabindex", "-1");
            try {
              t.blur();
            } catch (t) {}
            t.blur();
          }, e;
        }(r(2868).AbstractNavigatable);
        e.MenuElement = i;
      },
      1932: function _(t, e, r) {
        var n = this && this.__values || function (t) {
          var e = "function" == typeof Symbol && Symbol.iterator,
            r = e && t[e],
            n = 0;
          if (r) return r.call(t);
          if (t && "number" == typeof t.length) return {
            next: function next() {
              return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
              };
            }
          };
          throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuStore = void 0;
        var o = r(2556),
          i = r(2165),
          a = r(3205),
          Q = function () {
            function t(t) {
              this.menu = t, this.store = [], this._active = null, this.counter = 0, this.attachedClass = i.HtmlClasses.ATTACHED + "_" + o.MenuUtil.counter(), this.taborder = !0, this.attrMap = {};
            }
            return Object.defineProperty(t.prototype, "active", {
              get: function get() {
                return this._active;
              },
              set: function set(t) {
                do {
                  if (-1 !== this.store.indexOf(t)) {
                    this._active = t;
                    break;
                  }
                  t = t.parentNode;
                } while (t);
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.next = function () {
              var t = this.store.length;
              if (0 === t) return this.active = null, null;
              var e = this.store.indexOf(this.active);
              return e = -1 === e ? 0 : e < t - 1 ? e + 1 : 0, this.active = this.store[e], this.active;
            }, t.prototype.previous = function () {
              var t = this.store.length;
              if (0 === t) return this.active = null, null;
              var e = t - 1,
                r = this.store.indexOf(this.active);
              return r = -1 === r || 0 === r ? e : r - 1, this.active = this.store[r], this.active;
            }, t.prototype.clear = function () {
              this.remove(this.store);
            }, t.prototype.insert = function (t) {
              var e,
                r,
                o = t instanceof HTMLElement ? [t] : t;
              try {
                for (var i = n(o), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value;
                  this.insertElement(Q);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              this.sort();
            }, t.prototype.remove = function (t) {
              var e,
                r,
                o = t instanceof HTMLElement ? [t] : t;
              try {
                for (var i = n(o), a = i.next(); !a.done; a = i.next()) {
                  var Q = a.value;
                  this.removeElement(Q);
                }
              } catch (t) {
                e = {
                  error: t
                };
              } finally {
                try {
                  a && !a.done && (r = i.return) && r.call(i);
                } finally {
                  if (e) throw e.error;
                }
              }
              this.sort();
            }, t.prototype.inTaborder = function (t) {
              this.taborder && !t && this.removeTaborder(), !this.taborder && t && this.insertTaborder(), this.taborder = t;
            }, t.prototype.insertTaborder = function () {
              this.taborder && this.insertTaborder_();
            }, t.prototype.removeTaborder = function () {
              this.taborder && this.removeTaborder_();
            }, t.prototype.insertElement = function (t) {
              t.classList.contains(this.attachedClass) || (t.classList.add(this.attachedClass), this.taborder && this.addTabindex(t), this.addEvents(t));
            }, t.prototype.removeElement = function (t) {
              t.classList.contains(this.attachedClass) && (t.classList.remove(this.attachedClass), this.taborder && this.removeTabindex(t), this.removeEvents(t));
            }, t.prototype.sort = function () {
              var t = document.getElementsByClassName(this.attachedClass);
              this.store = [].slice.call(t);
            }, t.prototype.insertTaborder_ = function () {
              this.store.forEach(function (t) {
                return t.setAttribute("tabindex", "0");
              });
            }, t.prototype.removeTaborder_ = function () {
              this.store.forEach(function (t) {
                return t.setAttribute("tabindex", "-1");
              });
            }, t.prototype.addTabindex = function (t) {
              t.hasAttribute("tabindex") && t.setAttribute(i.HtmlAttrs.OLDTAB, t.getAttribute("tabindex")), t.setAttribute("tabindex", "0");
            }, t.prototype.removeTabindex = function (t) {
              t.hasAttribute(i.HtmlAttrs.OLDTAB) ? (t.setAttribute("tabindex", t.getAttribute(i.HtmlAttrs.OLDTAB)), t.removeAttribute(i.HtmlAttrs.OLDTAB)) : t.removeAttribute("tabindex");
            }, t.prototype.addEvents = function (t) {
              t.hasAttribute(i.HtmlAttrs.COUNTER) || (this.addEvent(t, "contextmenu", this.menu.post.bind(this.menu)), this.addEvent(t, "keydown", this.keydown.bind(this)), t.setAttribute(i.HtmlAttrs.COUNTER, this.counter.toString()), this.counter++);
            }, t.prototype.addEvent = function (t, e, r) {
              var n = i.HtmlAttrs[e.toUpperCase() + "FUNC"];
              this.attrMap[n + this.counter] = r, t.addEventListener(e, r);
            }, t.prototype.removeEvents = function (t) {
              if (t.hasAttribute(i.HtmlAttrs.COUNTER)) {
                var e = t.getAttribute(i.HtmlAttrs.COUNTER);
                this.removeEvent(t, "contextmenu", e), this.removeEvent(t, "keydown", e), t.removeAttribute(i.HtmlAttrs.COUNTER);
              }
            }, t.prototype.removeEvent = function (t, e, r) {
              var n = i.HtmlAttrs[e.toUpperCase() + "FUNC"],
                o = this.attrMap[n + r];
              t.removeEventListener(e, o);
            }, t.prototype.keydown = function (t) {
              t.keyCode === a.KEY.SPACE && (this.menu.post(t), t.preventDefault(), t.stopImmediatePropagation());
            }, t;
          }();
        e.MenuStore = Q;
      },
      2556: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MenuUtil = void 0, function (t) {
          t.close = function (t) {
            var e = t.menu;
            e.baseMenu ? e.baseMenu.unpost() : e.unpost();
          }, t.getActiveElement = function (t) {
            var e = t.menu;
            return (e.baseMenu ? e.baseMenu : e).store.active;
          }, t.error = function (t, e) {
            console.error("ContextMenu Error: " + e);
          }, t.counter = function () {
            return e++;
          };
          var e = 0;
        }(e.MenuUtil || (e.MenuUtil = {}));
      },
      8853: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MOUSE = void 0, e.MOUSE = {
          CLICK: "click",
          DBLCLICK: "dblclick",
          DOWN: "mousedown",
          UP: "mouseup",
          OVER: "mouseover",
          OUT: "mouseout",
          MOVE: "mousemove",
          SELECTEND: "selectend",
          SELECTSTART: "selectstart"
        };
      },
      6914: function _(t, e, r) {
        var n = this && this.__rest || function (t, e) {
            var r = {};
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
              var o = 0;
              for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
            }
            return r;
          },
          o = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          },
          i = this && this.__values || function (t) {
            var e = "function" == typeof Symbol && Symbol.iterator,
              r = e && t[e],
              n = 0;
            if (r) return r.call(t);
            if (t && "number" == typeof t.length) return {
              next: function next() {
                return t && n >= t.length && (t = void 0), {
                  value: t && t[n++],
                  done: !t
                };
              }
            };
            throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
          },
          a = this && this.__spread || function () {
            for (var t = [], e = 0; e < arguments.length; e++) t = t.concat(o(arguments[e]));
            return t;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Parser = void 0;
        var Q = r(3467),
          s = r(5073),
          T = r(3737),
          l = r(1409),
          c = r(9886),
          u = r(2965),
          p = r(385),
          h = r(6186),
          d = r(3463),
          f = r(7625),
          m = r(4834),
          L = r(2100),
          y = r(2308),
          g = function () {
            function t(t) {
              var e = this;
              void 0 === t && (t = []), this._initList = [["command", Q.Command.fromJson.bind(Q.Command)], ["checkbox", l.Checkbox.fromJson.bind(l.Checkbox)], ["combo", c.Combo.fromJson.bind(c.Combo)], ["slider", f.Slider.fromJson.bind(f.Slider)], ["label", u.Label.fromJson.bind(u.Label)], ["radio", p.Radio.fromJson.bind(p.Radio)], ["rule", d.Rule.fromJson.bind(d.Rule)], ["submenu", h.Submenu.fromJson.bind(h.Submenu)], ["contextMenu", s.ContextMenu.fromJson.bind(s.ContextMenu)], ["subMenu", m.SubMenu.fromJson.bind(m.SubMenu)], ["variable", T.Variable.fromJson.bind(T.Variable)], ["items", this.items.bind(this)], ["selectionMenu", L.SelectionMenu.fromJson.bind(L.SelectionMenu)], ["selectionBox", L.SelectionBox.fromJson.bind(L.SelectionBox)]], this._factory = new y.ParserFactory(this._initList), t.forEach(function (t) {
                var r = o(t, 2),
                  n = r[0],
                  i = r[1];
                return e.factory.add(n, i);
              });
            }
            return Object.defineProperty(t.prototype, "factory", {
              get: function get() {
                return this._factory;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.items = function (t, e, r) {
              var n,
                o,
                a = [];
              try {
                for (var Q = i(e), s = Q.next(); !s.done; s = Q.next()) {
                  var T = s.value,
                    l = this.parse(T, r);
                  l && (r.items.push(l), T.disabled && l.disable(), T.hidden && a.push(l));
                }
              } catch (t) {
                n = {
                  error: t
                };
              } finally {
                try {
                  s && !s.done && (o = Q.return) && o.call(Q);
                } finally {
                  if (n) throw n.error;
                }
              }
              return a.forEach(function (t) {
                return t.hide();
              }), r.items;
            }, t.prototype.parse = function (t) {
              for (var e = [], r = 1; r < arguments.length; r++) e[r - 1] = arguments[r];
              var o = t.type,
                i = n(t, ["type"]),
                Q = this.factory.get(o);
              return Q ? Q.apply(void 0, a([this.factory, i], e)) : null;
            }, t;
          }();
        e.Parser = g;
      },
      2308: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ParserFactory = void 0;
        var r = function () {
          function t(t) {
            this._parser = new Map(t);
          }
          return t.prototype.get = function (t) {
            return this._parser.get(t);
          }, t.prototype.add = function (t, e) {
            this._parser.set(t, e);
          }, t;
        }();
        e.ParserFactory = r;
      },
      2100: function _(t, e, r) {
        var _n138,
          o = this && this.__extends || (_n138 = function n(t, e) {
            return _n138 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n138(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n138(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }),
          i = this && this.__read || function (t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
              o,
              i = r.call(t),
              a = [];
            try {
              for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) a.push(n.value);
            } catch (t) {
              o = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = i.return) && r.call(i);
              } finally {
                if (o) throw o.error;
              }
            }
            return a;
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SelectionBox = e.SelectionMenu = void 0;
        var a = r(2556),
          Q = r(2165),
          s = r(1484),
          T = r(4922),
          l = function (t) {
            function e(e) {
              var r = t.call(this) || this;
              return r.anchor = e, r.className = Q.HtmlClasses.SELECTIONMENU, r.variablePool = r.anchor.menu.pool, r.baseMenu = r.anchor.menu, r;
            }
            return o(e, t), e.fromJson = function (t, e, r) {
              var n = e.title,
                o = e.values,
                i = e.variable,
                a = new this(r),
                Q = t.get("label")(t, {
                  content: n || "",
                  id: n || "id"
                }, a),
                s = t.get("rule")(t, {}, a),
                T = o.map(function (e) {
                  return t.get("radio")(t, {
                    content: e,
                    variable: i,
                    id: e
                  }, a);
                }),
                l = [Q, s].concat(T);
              return a.items = l, a;
            }, e.prototype.generateHtml = function () {
              t.prototype.generateHtml.call(this), this.items.forEach(function (t) {
                return t.html.classList.add(Q.HtmlClasses.SELECTIONITEM);
              });
            }, e.prototype.display = function () {}, e.prototype.right = function (t) {
              this.anchor.right(t);
            }, e.prototype.left = function (t) {
              this.anchor.left(t);
            }, e;
          }(s.AbstractMenu);
        e.SelectionMenu = l;
        var c = function (t) {
          function e(e, r, n, o) {
            void 0 === n && (n = "none"), void 0 === o && (o = "vertical");
            var i = t.call(this, e, null, r) || this;
            return i.style = n, i.grid = o, i._selections = [], i.prefix = "ctxt-selection", i._balanced = !0, i;
          }
          return o(e, t), e.fromJson = function (t, e, r) {
            var n = e.title,
              o = e.signature,
              i = e.selections,
              a = new this(n, o, e.order, e.grid);
            a.attachMenu(r);
            var Q = i.map(function (e) {
              return t.get("selectionMenu")(t, e, a);
            });
            return a.selections = Q, a;
          }, e.prototype.attachMenu = function (t) {
            this.menu = t;
          }, Object.defineProperty(e.prototype, "selections", {
            get: function get() {
              return this._selections;
            },
            set: function set(t) {
              var e = this;
              this._selections = [], t.forEach(function (t) {
                return e.addSelection(t);
              });
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.addSelection = function (t) {
            t.anchor = this, this._selections.push(t);
          }, e.prototype.rowDiv = function (t) {
            var e = this,
              r = document.createElement("div");
            this.contentDiv.appendChild(r);
            var n = t.map(function (t) {
                return r.appendChild(t.html), t.html.id || (t.html.id = e.prefix + a.MenuUtil.counter()), t.html.getBoundingClientRect();
              }),
              o = n.map(function (t) {
                return t.width;
              }),
              i = o.reduce(function (t, e) {
                return t + e;
              }, 0),
              s = n.reduce(function (t, e) {
                return Math.max(t, e.height);
              }, 0);
            return r.classList.add(Q.HtmlClasses.SELECTIONDIVIDER), r.setAttribute("style", "height: " + s + "px;"), [r, i, s, o];
          }, e.prototype.display = function () {
            if (t.prototype.display.call(this), this.order(), this.selections.length) {
              for (var e = [], r = 0, n = [], o = this.getChunkSize(this.selections.length), a = function a(t) {
                  var a = Q.selections.slice(t, t + o),
                    s = i(Q.rowDiv(a), 4),
                    T = s[0],
                    l = s[1],
                    c = s[2],
                    u = s[3];
                  e.push(T), r = Math.max(r, l), a.forEach(function (t) {
                    return t.html.style.height = c + "px";
                  }), n = Q.combineColumn(n, u);
                }, Q = this, s = 0; s < this.selections.length; s += o) a(s);
              this._balanced && (this.balanceColumn(e, n), r = n.reduce(function (t, e) {
                return t + e;
              }, 20)), e.forEach(function (t) {
                return t.style.width = r + "px";
              });
            }
          }, e.prototype.getChunkSize = function (t) {
            switch (this.grid) {
              case "square":
                return Math.floor(Math.sqrt(t));
              case "horizontal":
                return Math.floor(t / e.chunkSize);
              default:
                return e.chunkSize;
            }
          }, e.prototype.balanceColumn = function (t, e) {
            t.forEach(function (t) {
              for (var r = Array.from(t.children), n = 0, o = void 0; o = r[n]; n++) o.style.width = e[n] + "px";
            });
          }, e.prototype.combineColumn = function (t, e) {
            for (var r = [], n = 0; t[n] || e[n];) {
              if (!t[n]) {
                r = r.concat(e.slice(n));
                break;
              }
              if (!e[n]) {
                r = r.concat(t.slice(n));
                break;
              }
              r.push(Math.max(t[n], e[n])), n++;
            }
            return r;
          }, e.prototype.left = function (t) {
            var e = this;
            this.move(t, function (t) {
              return (0 === t ? e.selections.length : t) - 1;
            });
          }, e.prototype.right = function (t) {
            var e = this;
            this.move(t, function (t) {
              return t === e.selections.length - 1 ? 0 : t + 1;
            });
          }, e.prototype.generateHtml = function () {
            t.prototype.generateHtml.call(this), this.html.classList.add(Q.HtmlClasses.SELECTION);
          }, e.prototype.generateContent = function () {
            var e = t.prototype.generateContent.call(this);
            return e.classList.add(Q.HtmlClasses.SELECTIONBOX), e.removeAttribute("tabindex"), e;
          }, e.prototype.findSelection = function (t) {
            var e = t.target,
              r = null;
            if (e.id && (r = this.selections.find(function (t) {
              return t.html.id === e.id;
            })), !r) {
              var n = e.parentElement.id;
              r = this.selections.find(function (t) {
                return t.html.id === n;
              });
            }
            return r;
          }, e.prototype.move = function (t, e) {
            var r = this.findSelection(t);
            r.focused && r.focused.unfocus();
            var n = e(this.selections.indexOf(r));
            this.selections[n].focus();
          }, e.prototype.order = function () {
            this.selections.sort(e.orderMethod.get(this.style));
          }, e.prototype.toJson = function () {
            return {
              type: ""
            };
          }, e.chunkSize = 4, e.orderMethod = new Map([["alphabetical", function (t, e) {
            return t.items[0].content.localeCompare(e.items[0].content);
          }], ["none", function (t, e) {
            return 1;
          }], ["decreasing", function (t, e) {
            var r = t.items.length,
              n = e.items.length;
            return r < n ? 1 : n < r ? -1 : 0;
          }], ["increasing", function (t, e) {
            var r = t.items.length,
              n = e.items.length;
            return r < n ? -1 : n < r ? 1 : 0;
          }]]), e;
        }(T.Info);
        e.SelectionBox = c;
      },
      4834: function _(t, e, r) {
        var _n139,
          o = this && this.__extends || (_n139 = function n(t, e) {
            return _n139 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
            }, _n139(t, e);
          }, function (t, e) {
            function r() {
              this.constructor = t;
            }
            _n139(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          });
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SubMenu = void 0;
        var i = function (t) {
          function e(e) {
            var r = t.call(this) || this;
            return r._anchor = e, r.variablePool = r.anchor.menu.pool, r.setBaseMenu(), r;
          }
          return o(e, t), e.fromJson = function (t, e, r) {
            var n = e.items,
              o = new this(r),
              i = t.get("items")(t, n, o);
            return o.items = i, o;
          }, Object.defineProperty(e.prototype, "anchor", {
            get: function get() {
              return this._anchor;
            },
            enumerable: !1,
            configurable: !0
          }), e.prototype.post = function () {
            if (this.anchor.menu.isPosted()) {
              for (var e = this.anchor.html, r = this.html, n = this.baseMenu.frame, o = e.offsetWidth, i = o - 2, a = 0; e && e !== n;) i += e.offsetLeft, a += e.offsetTop, e = e.parentNode;
              i + r.offsetWidth > document.body.offsetWidth - 5 && (i = Math.max(5, i - o - r.offsetWidth + 6)), t.prototype.post.call(this, i, a);
            }
          }, e.prototype.display = function () {
            this.baseMenu.frame.appendChild(this.html);
          }, e.prototype.setBaseMenu = function () {
            var t = this;
            do {
              t = t.anchor.menu;
            } while (t instanceof e);
            this.baseMenu = t;
          }, e.prototype.left = function (t) {
            this.focused = null, this.anchor.focus();
          }, e.prototype.toJson = function () {
            return {
              type: ""
            };
          }, e;
        }(r(1484).AbstractMenu);
        e.SubMenu = i;
      },
      3737: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Variable = void 0;
        var n = r(2556),
          o = function () {
            function t(t, e, r) {
              this._name = t, this.getter = e, this.setter = r, this.items = [];
            }
            return t.fromJson = function (t, e, r) {
              var n = new this(e.name, e.getter, e.setter);
              r.insert(n);
            }, Object.defineProperty(t.prototype, "name", {
              get: function get() {
                return this._name;
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getValue = function (t) {
              try {
                return this.getter(t);
              } catch (t) {
                return n.MenuUtil.error(t, "Command of variable " + this.name + " failed."), null;
              }
            }, t.prototype.setValue = function (t, e) {
              try {
                this.setter(t, e);
              } catch (t) {
                n.MenuUtil.error(t, "Command of variable " + this.name + " failed.");
              }
              this.update();
            }, t.prototype.register = function (t) {
              -1 === this.items.indexOf(t) && this.items.push(t);
            }, t.prototype.unregister = function (t) {
              var e = this.items.indexOf(t);
              -1 !== e && this.items.splice(e, 1);
            }, t.prototype.update = function () {
              this.items.forEach(function (t) {
                return t.update();
              });
            }, t.prototype.registerCallback = function (t) {
              this.items.forEach(function (e) {
                return e.registerCallback(t);
              });
            }, t.prototype.unregisterCallback = function (t) {
              this.items.forEach(function (e) {
                return e.unregisterCallback(t);
              });
            }, t.prototype.toJson = function () {
              return {
                type: "variable",
                name: this.name,
                getter: this.getter.toString(),
                setter: this.setter.toString()
              };
            }, t;
          }();
        e.Variable = o;
      },
      2358: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.VariablePool = void 0;
        var r = function () {
          function t() {
            this.pool = {};
          }
          return t.prototype.insert = function (t) {
            this.pool[t.name] = t;
          }, t.prototype.lookup = function (t) {
            return this.pool[t];
          }, t.prototype.remove = function (t) {
            delete this.pool[t];
          }, t.prototype.update = function () {
            for (var t in this.pool) this.pool[t].update();
          }, t;
        }();
        e.VariablePool = r;
      },
      3921: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractAudioRenderer = void 0;
        var n = r(5897);
        e.AbstractAudioRenderer = /*#__PURE__*/function () {
          function _class() {
            _classCallCheck(this, _class);
            this.separator_ = " ";
          }
          _createClass(_class, [{
            key: "setSeparator",
            value: function setSeparator(t) {
              this.separator_ = t;
            }
          }, {
            key: "getSeparator",
            value: function getSeparator() {
              return "braille" === n.default.getInstance().modality ? "" : this.separator_;
            }
          }, {
            key: "error",
            value: function error(t) {
              return null;
            }
          }, {
            key: "merge",
            value: function merge(t) {
              var e = "";
              var r = t.length - 1;
              for (var _n140, o = 0; _n140 = t[o]; o++) if (e += _n140.speech, o < r) {
                var _t2 = _n140.attributes.separator;
                e += void 0 !== _t2 ? _t2 : this.getSeparator();
              }
              return e;
            }
          }, {
            key: "finalize",
            value: function finalize(t) {
              return t;
            }
          }, {
            key: "pauseValue",
            value: function pauseValue(t) {
              var e;
              switch (t) {
                case "long":
                  e = 750;
                  break;
                case "medium":
                  e = 500;
                  break;
                case "short":
                  e = 250;
                  break;
                default:
                  e = parseInt(t, 10);
              }
              return Math.floor(e * n.default.getInstance().getRate() / 100);
            }
          }]);
          return _class;
        }();
      },
      4196: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AcssRenderer = void 0;
        var n = r(4440),
          o = r(8496),
          i = r(3706),
          a = r(182);
        var Q = /*#__PURE__*/function (_a$MarkupRenderer) {
          _inherits(Q, _a$MarkupRenderer);
          function Q() {
            _classCallCheck(this, Q);
            return _possibleConstructorReturn(this, _getPrototypeOf(Q).apply(this, arguments));
          }
          _createClass(Q, [{
            key: "markup",
            value: function markup(t) {
              this.setScaleFunction(-2, 2, 0, 10, 0);
              var e = i.personalityMarkup(t),
                r = [],
                n = {
                  open: []
                };
              var o = null,
                a = !1;
              for (var _t3, _Q = 0; _t3 = e[_Q]; _Q++) {
                if (i.isMarkupElement(_t3)) {
                  i.mergeMarkup(n, _t3);
                  continue;
                }
                if (i.isPauseElement(_t3)) {
                  a && (o = i.mergePause(o, _t3, Math.max));
                  continue;
                }
                var _e3 = '"' + this.merge(_t3.span) + '"';
                a = !0, o && (r.push(this.pause(o)), o = null);
                var _Q2 = this.prosody_(n);
                r.push(_Q2 ? "(text (" + _Q2 + ") " + _e3 + ")" : _e3);
              }
              return "(exp " + r.join(" ") + ")";
            }
          }, {
            key: "error",
            value: function error(t) {
              return '(error "' + o.Move.get(t) + '")';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              switch (e = this.applyScaleFunction(e), t) {
                case n.personalityProps.RATE:
                  return "(richness . " + e + ")";
                case n.personalityProps.PITCH:
                  return "(average-pitch . " + e + ")";
                case n.personalityProps.VOLUME:
                  return "(stress . " + e + ")";
              }
              return "(value . " + e + ")";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return "(pause . " + this.pauseValue(t[n.personalityProps.PAUSE]) + ")";
            }
          }, {
            key: "prosody_",
            value: function prosody_(t) {
              var e = t.open,
                r = [];
              for (var _n141, _o = 0; _n141 = e[_o]; _o++) r.push(this.prosodyElement(_n141, t[_n141]));
              return r.join(" ");
            }
          }]);
          return Q;
        }(a.MarkupRenderer);
        e.AcssRenderer = Q;
      },
      3706: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isSpanElement = e.isPauseElement = e.isMarkupElement = e.personalityMarkup = e.sortClose = e.mergeMarkup = e.mergePause = void 0;
        var n = r(707),
          o = r(4440),
          i = r(9536);
        function a(t, e, r) {
          return (r || function (r, n) {
            return "number" == typeof r && "number" == typeof n ? r + n : "number" == typeof r ? n : "number" == typeof n ? r : [t, e].sort()[0];
          }).call(null, t, e);
        }
        e.mergePause = function (t, e, r) {
          return t ? {
            pause: a(t.pause, e.pause, r)
          } : e;
        }, e.mergeMarkup = function (t, e) {
          delete t.open, e.close.forEach(function (e) {
            return delete t[e];
          }), e.open.forEach(function (r) {
            return t[r] = e[r];
          });
          var r = Object.keys(t);
          t.open = r;
        }, e.sortClose = function (t, e) {
          if (t.length <= 1) return t;
          var r = [];
          for (var _n142, _o2 = 0; _n142 = e[_o2], t.length; _o2++) _n142.close && _n142.close.length && _n142.close.forEach(function (e) {
            var n = t.indexOf(e);
            -1 !== n && (r.unshift(e), t.splice(n, 1));
          });
          return r;
        };
        var Q = {},
          s = [];
        function T(t, e) {
          var r = t[t.length - 1];
          if (r) {
            if (p(e) && p(r)) {
              if (void 0 === r.join) return void (r.span = r.span.concat(e.span));
              var _t4 = r.span.pop(),
                _n143 = e.span.shift();
              return r.span.push(_t4 + r.join + _n143), r.span = r.span.concat(e.span), void (r.join = e.join);
            }
            u(e) && u(r) ? r.pause = a(r.pause, e.pause) : t.push(e);
          } else t.push(e);
        }
        function l(t, e) {
          t.rate && (e.rate = t.rate), t.pitch && (e.pitch = t.pitch), t.volume && (e.volume = t.volume);
        }
        function c(t) {
          return "object" == typeof t && t.open;
        }
        function u(t) {
          return "object" == typeof t && 1 === Object.keys(t).length && Object.keys(t)[0] === o.personalityProps.PAUSE;
        }
        function p(t) {
          var e = Object.keys(t);
          return "object" == typeof t && (1 === e.length && "span" === e[0] || 2 === e.length && ("span" === e[0] && "join" === e[1] || "span" === e[1] && "join" === e[0]));
        }
        function h(t, e, r, n, Q) {
          var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
          if (s) {
            var _s = t[t.length - 1];
            var _T;
            if (_s && (_T = _s[o.personalityProps.JOIN]), _s && !e.speech && Q && u(_s)) {
              var _t5 = o.personalityProps.PAUSE;
              _s[_t5] = a(_s[_t5], Q[_t5]), Q = null;
            }
            if (_s && e.speech && 0 === Object.keys(r).length && p(_s)) {
              if (void 0 !== _T) {
                var _t6 = _s.span.pop();
                e = new i.Span(_t6.speech + _T + e.speech, _t6.attributes);
              }
              _s.span.push(e), e = new i.Span("", {}), _s[o.personalityProps.JOIN] = n;
            }
          }
          0 !== Object.keys(r).length && t.push(r), e.speech && t.push({
            span: [e],
            join: n
          }), Q && t.push(Q);
        }
        function d(t, e) {
          if (!e) return t;
          var r = {};
          var _iterator = _createForOfIteratorHelper(o.personalityPropList),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _n145 = _step.value;
              var _o4 = t[_n145],
                _i2 = e[_n145];
              if (!_o4 && !_i2 || _o4 && _i2 && _o4 === _i2) continue;
              var _a = _o4 || 0;
              c(r) || (r.open = [], r.close = []), _o4 || r.close.push(_n145), _i2 || r.open.push(_n145), _i2 && _o4 && (r.close.push(_n145), r.open.push(_n145)), e[_n145] = _a, r[_n145] = _a, Q[_n145] ? Q[_n145].push(_a) : Q[_n145] = [_a];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (c(r)) {
            var _t7 = r.close.slice();
            for (; _t7.length > 0;) {
              var _o3 = s.pop();
              var _i = (0, n.setdifference)(_o3, _t7);
              if (_t7 = (0, n.setdifference)(_t7, _o3), _o3 = _i, 0 !== _t7.length) {
                if (0 !== _o3.length) {
                  r.close = r.close.concat(_o3), r.open = r.open.concat(_o3);
                  for (var _t8, _n144 = 0; _t8 = _o3[_n144]; _n144++) r[_t8] = e[_t8];
                }
              } else 0 !== _o3.length && s.push(_o3);
            }
            s.push(r.open);
          }
          return r;
        }
        e.personalityMarkup = function (t) {
          Q = {}, s = [];
          var e = [];
          var r = {};
          for (var _n146, _i3 = 0; _n146 = t[_i3]; _i3++) {
            var _t9 = null;
            var _i4 = _n146.descriptionSpan(),
              _a2 = _n146.personality,
              _Q3 = _a2[o.personalityProps.JOIN];
            delete _a2[o.personalityProps.JOIN], void 0 !== _a2[o.personalityProps.PAUSE] && (_t9 = _defineProperty({}, o.personalityProps.PAUSE, _a2[o.personalityProps.PAUSE]), delete _a2[o.personalityProps.PAUSE]);
            h(e, _i4, d(_a2, r), _Q3, _t9, !0);
          }
          return e = e.concat(function () {
            var t = [];
            for (var _e4 = s.length - 1; _e4 >= 0; _e4--) {
              var _r22 = s[_e4];
              if (_r22.length) {
                var _e5 = {
                  open: [],
                  close: []
                };
                for (var _t11 = 0; _t11 < _r22.length; _t11++) {
                  var _n147 = _r22[_t11];
                  _e5.close.push(_n147), _e5[_n147] = 0;
                }
                t.push(_e5);
              }
            }
            return t;
          }()), e = function (t) {
            var e = {},
              r = [];
            for (var _n148, _o5 = 0; _n148 = t[_o5]; _o5++) {
              if (!c(_n148)) {
                T(r, _n148);
                continue;
              }
              if (!_n148.close || 1 !== _n148.close.length || _n148.open.length) {
                l(_n148, e), r.push(_n148);
                continue;
              }
              var _i5 = t[_o5 + 1];
              if (!_i5 || p(_i5)) {
                l(_n148, e), r.push(_n148);
                continue;
              }
              var _a3 = u(_i5) ? _i5 : null;
              _a3 && (_i5 = t[_o5 + 2]), _i5 && c(_i5) && _i5.open[0] === _n148.close[0] && !_i5.close.length && _i5[_i5.open[0]] === e[_i5.open[0]] ? _a3 ? (T(r, _a3), _o5 += 2) : _o5 += 1 : (l(_n148, e), r.push(_n148));
            }
            return r;
          }(e), e;
        }, e.isMarkupElement = c, e.isPauseElement = u, e.isSpanElement = p;
      },
      7052: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AuditoryDescription = void 0;
        var n = r(2105),
          o = r(9536);
        var i = /*#__PURE__*/function () {
          function i(_ref) {
            var t = _ref.context,
              e = _ref.text,
              r = _ref.userValue,
              n = _ref.annotation,
              o = _ref.attributes,
              _i6 = _ref.personality,
              a = _ref.layout;
            _classCallCheck(this, i);
            this.context = t || "", this.text = e || "", this.userValue = r || "", this.annotation = n || "", this.attributes = o || {}, this.personality = _i6 || {}, this.layout = a || "";
          }
          _createClass(i, [{
            key: "isEmpty",
            value: function isEmpty() {
              return 0 === this.context.length && 0 === this.text.length && 0 === this.userValue.length && 0 === this.annotation.length;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t, e;
              if (this.personality) {
                t = {};
                for (var _e6 in this.personality) t[_e6] = this.personality[_e6];
              }
              if (this.attributes) {
                e = {};
                for (var _t12 in this.attributes) e[_t12] = this.attributes[_t12];
              }
              return new i({
                context: this.context,
                text: this.text,
                userValue: this.userValue,
                annotation: this.annotation,
                personality: t,
                attributes: e,
                layout: this.layout
              });
            }
          }, {
            key: "toString",
            value: function toString() {
              return 'AuditoryDescription(context="' + this.context + '"  text="' + this.text + '"  userValue="' + this.userValue + '"  annotation="' + this.annotation + '")';
            }
          }, {
            key: "descriptionString",
            value: function descriptionString() {
              return this.context && this.text ? this.context + " " + this.text : this.context || this.text;
            }
          }, {
            key: "descriptionSpan",
            value: function descriptionSpan() {
              return new o.Span(this.descriptionString(), this.attributes);
            }
          }, {
            key: "equals",
            value: function equals(t) {
              return this.context === t.context && this.text === t.text && this.userValue === t.userValue && this.annotation === t.annotation;
            }
          }], [{
            key: "create",
            value: function create(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return t.text = n.Grammar.getInstance().apply(t.text, e), new i(t);
            }
          }]);
          return i;
        }();
        e.AuditoryDescription = i;
      },
      8290: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isXml = e.registerRenderer = e.error = e.finalize = e.merge = e.markup = e.getSeparator = e.setSeparator = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(4196),
          a = r(8639),
          Q = r(8990),
          s = r(6660),
          T = r(9536),
          l = r(7504),
          c = r(3757),
          u = r(4032),
          p = r(2456),
          h = new l.SsmlRenderer(),
          d = new Map([[o.Markup.NONE, new u.StringRenderer()], [o.Markup.PUNCTUATION, new Q.PunctuationRenderer()], [o.Markup.LAYOUT, new a.LayoutRenderer()], [o.Markup.ACSS, new i.AcssRenderer()], [o.Markup.SABLE, new s.SableRenderer()], [o.Markup.VOICEXML, h], [o.Markup.SSML, h], [o.Markup.SSML_STEP, new c.SsmlStepRenderer()]]);
        e.setSeparator = function (t) {
          var e = d.get(n.default.getInstance().markup);
          e && e.setSeparator(t);
        }, e.getSeparator = function () {
          var t = d.get(n.default.getInstance().markup);
          return t ? t.getSeparator() : "";
        }, e.markup = function (t) {
          var e = d.get(n.default.getInstance().markup);
          return e ? e.markup(t) : "";
        }, e.merge = function (t) {
          var e = t.map(function (t) {
              return "string" == typeof t ? new T.Span(t, {}) : t;
            }),
            r = d.get(n.default.getInstance().markup);
          return r ? r.merge(e) : t.join();
        }, e.finalize = function (t) {
          var e = d.get(n.default.getInstance().markup);
          return e ? e.finalize(t) : t;
        }, e.error = function (t) {
          var e = d.get(n.default.getInstance().markup);
          return e ? e.error(t) : "";
        }, e.registerRenderer = function (t, e) {
          d.set(t, e);
        }, e.isXml = function () {
          return d.get(n.default.getInstance().markup) instanceof p.XmlRenderer;
        };
      },
      8639: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.LayoutRenderer = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(4440),
          a = r(3706),
          Q = r(2456);
        var s = /*#__PURE__*/function (_Q$XmlRenderer) {
          _inherits(s, _Q$XmlRenderer);
          function s() {
            _classCallCheck(this, s);
            return _possibleConstructorReturn(this, _getPrototypeOf(s).apply(this, arguments));
          }
          _createClass(s, [{
            key: "finalize",
            value: function finalize(t) {
              return function (t) {
                T = "";
                var e = o.parseInput("<all>".concat(t, "</all>"));
                return n.Debugger.getInstance().output(o.formatXml(e.toString())), T = p(e), T;
              }(t);
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return "";
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              return t === i.personalityProps.LAYOUT ? "<".concat(e, ">") : "";
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</".concat(t, ">");
            }
          }, {
            key: "markup",
            value: function markup(t) {
              var e = [];
              var r = [];
              var _iterator2 = _createForOfIteratorHelper(t),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _n149 = _step2.value;
                  if (!_n149.layout) {
                    r.push(_n149);
                    continue;
                  }
                  e.push(this.processContent(r)), r = [];
                  var _t13 = _n149.layout;
                  _t13.match(/^begin/) ? e.push("<" + _t13.replace(/^begin/, "") + ">") : _t13.match(/^end/) ? e.push("</" + _t13.replace(/^end/, "") + ">") : console.warn("Something went wrong with layout markup: " + _t13);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              return e.push(this.processContent(r)), e.join("");
            }
          }, {
            key: "processContent",
            value: function processContent(t) {
              var e = [],
                r = a.personalityMarkup(t);
              for (var _t14, _n150 = 0; _t14 = r[_n150]; _n150++) _t14.span ? e.push(this.merge(_t14.span)) : a.isPauseElement(_t14);
              return e.join("");
            }
          }]);
          return s;
        }(Q.XmlRenderer);
        e.LayoutRenderer = s;
        var T = "";
        var l = {
          TABLE: function TABLE(t) {
            var e = m(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(1).slice(0, -1), t.width = t.width.slice(1).slice(0, -1);
            });
            var _L = L(e),
              _L2 = _slicedToArray(_L, 2),
              r = _L2[0],
              n = _L2[1];
            return e = y(e, n), g(e, r);
          },
          CASES: function CASES(t) {
            var e = m(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(0, -1), t.width = t.width.slice(0, -1);
            });
            var _L3 = L(e),
              _L4 = _slicedToArray(_L3, 2),
              r = _L4[0],
              n = _L4[1];
            return e = y(e, n), g(e, r);
          },
          CAYLEY: function CAYLEY(t) {
            var e = m(t);
            e.forEach(function (t) {
              t.cells = t.cells.slice(1).slice(0, -1), t.width = t.width.slice(1).slice(0, -1), t.sep = t.sep + t.sep;
            });
            var _L5 = L(e),
              _L6 = _slicedToArray(_L5, 2),
              r = _L6[0],
              n = _L6[1],
              o = {
                lfence: "",
                rfence: "",
                cells: n.map(function (t) {
                  return "\u2810" + new Array(t).join("\u2812");
                }),
                width: n,
                height: 1,
                sep: e[0].sep
              };
            return e.splice(1, 0, o), e = y(e, n), g(e, r);
          },
          MATRIX: function MATRIX(t) {
            var e = m(t);
            var _L7 = L(e),
              _L8 = _slicedToArray(_L7, 2),
              r = _L8[0],
              n = _L8[1];
            return e = y(e, n), g(e, r);
          },
          CELL: p,
          FENCE: p,
          ROW: p,
          FRACTION: function FRACTION(t) {
            var _Array$from = Array.from(t.childNodes),
              _Array$from2 = _slicedToArray(_Array$from, 5),
              e = _Array$from2[0],
              r = _Array$from2[1],
              n = _Array$from2[3],
              o = _Array$from2[4],
              i = c(r),
              a = c(n),
              Q = d(i),
              s = d(a);
            var T = Math.max(Q, s);
            var l = e + new Array(T + 1).join("\u2812") + o;
            return T = l.length, "".concat(_(i, T), "\n").concat(l, "\n").concat(_(a, T));
          },
          NUMERATOR: M,
          DENOMINATOR: M
        };
        function c(t) {
          var e = o.tagName(t),
            r = l[e];
          return r ? r(t) : t.textContent;
        }
        function u(t, e) {
          if (!t || !e) return t + e;
          var r = h(t),
            n = h(e),
            o = r - n;
          t = o < 0 ? f(t, n, d(t)) : t, e = o > 0 ? f(e, r, d(e)) : e;
          var i = t.split(/\r\n|\r|\n/),
            a = e.split(/\r\n|\r|\n/),
            Q = [];
          for (var _t15 = 0; _t15 < i.length; _t15++) Q.push(i[_t15] + a[_t15]);
          return Q.join("\n");
        }
        function p(t) {
          var e = "";
          for (var _i7 = 0, _Array$from3 = Array.from(t.childNodes); _i7 < _Array$from3.length; _i7++) {
            var _r23 = _Array$from3[_i7];
            e = _r23.nodeType !== o.NodeType.TEXT_NODE ? u(e, c(_r23)) : u(e, _r23.textContent);
          }
          return e;
        }
        function h(t) {
          return t.split(/\r\n|\r|\n/).length;
        }
        function d(t) {
          return t.split(/\r\n|\r|\n/).reduce(function (t, e) {
            return Math.max(e.length, t);
          }, 0);
        }
        function f(t, e, r) {
          return t = function (t, e) {
            var r = e - h(t);
            return t + (r > 0 ? new Array(r + 1).join("\n") : "");
          }(t, e), function (t, e) {
            var r = t.split(/\r\n|\r|\n/),
              n = [];
            var _iterator3 = _createForOfIteratorHelper(r),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t16 = _step3.value;
                var _r24 = e - _t16.length;
                n.push(_t16 + (_r24 > 0 ? new Array(_r24 + 1).join("\u2800") : ""));
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            return n.join("\n");
          }(t, r);
        }
        function m(t) {
          var e = Array.from(t.childNodes),
            r = [];
          for (var _i8 = 0, _e7 = e; _i8 < _e7.length; _i8++) {
            var _t17 = _e7[_i8];
            _t17.nodeType === o.NodeType.ELEMENT_NODE && r.push(H(_t17));
          }
          return r;
        }
        function L(t) {
          var e = t.reduce(function (t, e) {
              return Math.max(e.height, t);
            }, 0),
            r = [];
          var _loop = function _loop(_e8) {
            r.push(t.map(function (t) {
              return t.width[_e8];
            }).reduce(function (t, e) {
              return Math.max(t, e);
            }, 0));
          };
          for (var _e8 = 0; _e8 < t[0].width.length; _e8++) {
            _loop(_e8);
          }
          return [e, r];
        }
        function y(t, e) {
          var r = [];
          var _iterator4 = _createForOfIteratorHelper(t),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _n151 = _step4.value;
              if (0 === _n151.height) continue;
              var _t18 = [];
              for (var _r25 = 0; _r25 < _n151.cells.length; _r25++) _t18.push(f(_n151.cells[_r25], _n151.height, e[_r25]));
              _n151.cells = _t18, r.push(_n151);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return r;
        }
        function g(t, e) {
          if (1 === e) return t.map(function (t) {
            return t.lfence + t.cells.join(t.sep) + t.rfence;
          }).join("\n");
          var r = [];
          var _iterator5 = _createForOfIteratorHelper(t),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e9 = _step5.value;
              var _t19 = v(_e9.sep, _e9.height);
              var _n152 = _e9.cells.shift();
              for (; _e9.cells.length;) _n152 = u(_n152, _t19), _n152 = u(_n152, _e9.cells.shift());
              _n152 = u(v(_e9.lfence, _e9.height), _n152), _n152 = u(_n152, v(_e9.rfence, _e9.height)), r.push(_n152), r.push(_e9.lfence + new Array(d(_n152) - 3).join(_e9.sep) + _e9.rfence);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          return r.slice(0, -1).join("\n");
        }
        function v(t, e) {
          var r = "";
          for (; e;) r += t + "\n", e--;
          return r.slice(0, -1);
        }
        function b(t) {
          return t.nodeType === o.NodeType.ELEMENT_NODE && "FENCE" === o.tagName(t) ? c(t) : "";
        }
        function H(t) {
          var e = Array.from(t.childNodes),
            r = b(e[0]),
            n = b(e[e.length - 1]);
          r && e.shift(), n && e.pop();
          var i = "";
          var a = [];
          for (var _i9 = 0, _e10 = e; _i9 < _e10.length; _i9++) {
            var _t20 = _e10[_i9];
            if (_t20.nodeType === o.NodeType.TEXT_NODE) {
              i = _t20.textContent;
              continue;
            }
            var _e11 = c(_t20);
            a.push(_e11);
          }
          return {
            lfence: r,
            rfence: n,
            sep: i,
            cells: a,
            height: a.reduce(function (t, e) {
              return Math.max(h(e), t);
            }, 0),
            width: a.map(d)
          };
        }
        function _(t, e) {
          var r = (e - d(t)) / 2,
            _ref2 = Math.floor(r) === r ? [r, r] : [Math.floor(r), Math.ceil(r)],
            _ref3 = _slicedToArray(_ref2, 2),
            n = _ref3[0],
            o = _ref3[1],
            i = t.split(/\r\n|\r|\n/),
            a = [],
            _ref4 = [new Array(n + 1).join("\u2800"), new Array(o + 1).join("\u2800")],
            Q = _ref4[0],
            s = _ref4[1];
          var _iterator6 = _createForOfIteratorHelper(i),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _t21 = _step6.value;
              a.push(Q + _t21 + s);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          return a.join("\n");
        }
        function M(t) {
          var e = t.firstChild,
            r = p(t);
          if (e && e.nodeType === o.NodeType.ELEMENT_NODE) {
            if ("ENGLISH" === o.tagName(e)) return "\u2830" + r;
            if ("NUMBER" === o.tagName(e)) return "\u283C" + r;
          }
          return r;
        }
      },
      182: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MarkupRenderer = void 0;
        var n = r(4440),
          o = r(3921);
        var i = /*#__PURE__*/function (_o$AbstractAudioRende) {
          _inherits(i, _o$AbstractAudioRende);
          function i() {
            var _this;
            _classCallCheck(this, i);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.ignoreElements = [n.personalityProps.LAYOUT], _this.scaleFunction = null;
            return _this;
          }
          _createClass(i, [{
            key: "setScaleFunction",
            value: function setScaleFunction(t, e, r, n) {
              var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
              this.scaleFunction = function (i) {
                var a = (i - t) / (e - t),
                  Q = r * (1 - a) + n * a;
                return +(Math.round(Q + "e+" + o) + "e-" + o);
              };
            }
          }, {
            key: "applyScaleFunction",
            value: function applyScaleFunction(t) {
              return this.scaleFunction ? this.scaleFunction(t) : t;
            }
          }, {
            key: "ignoreElement",
            value: function ignoreElement(t) {
              return -1 !== this.ignoreElements.indexOf(t);
            }
          }]);
          return i;
        }(o.AbstractAudioRenderer);
        e.MarkupRenderer = i;
      },
      8990: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.PunctuationRenderer = void 0;
        var n = r(4440),
          o = r(3921),
          i = r(3706);
        var a = /*#__PURE__*/function (_o$AbstractAudioRende2) {
          _inherits(a, _o$AbstractAudioRende2);
          function a() {
            _classCallCheck(this, a);
            return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
          }
          _createClass(a, [{
            key: "markup",
            value: function markup(t) {
              var e = i.personalityMarkup(t);
              var r = "",
                o = null,
                a = !1;
              for (var _t22, Q = 0; _t22 = e[Q]; Q++) i.isMarkupElement(_t22) || (i.isPauseElement(_t22) ? a && (o = i.mergePause(o, _t22, Math.max)) : (o && (r += this.pause(o[n.personalityProps.PAUSE]), o = null), r += (a ? this.getSeparator() : "") + this.merge(_t22.span), a = !0));
              return r;
            }
          }, {
            key: "pause",
            value: function pause(t) {
              var e;
              return e = "number" == typeof t ? t <= 250 ? "short" : t <= 500 ? "medium" : "long" : t, a.PAUSE_PUNCTUATION.get(e) || "";
            }
          }]);
          return a;
        }(o.AbstractAudioRenderer);
        e.PunctuationRenderer = a, a.PAUSE_PUNCTUATION = new Map([["short", ","], ["medium", ";"], ["long", "."]]);
      },
      6660: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SableRenderer = void 0;
        var n = r(4440),
          o = r(2456);
        var i = /*#__PURE__*/function (_o$XmlRenderer) {
          _inherits(i, _o$XmlRenderer);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "finalize",
            value: function finalize(t) {
              return '<?xml version="1.0"?><!DOCTYPE SABLE PUBLIC "-//SABLE//DTD SABLE speech mark up//EN" "Sable.v0_2.dtd" []><SABLE>' + this.getSeparator() + t + this.getSeparator() + "</SABLE>";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return '<BREAK MSEC="' + this.pauseValue(t[n.personalityProps.PAUSE]) + '"/>';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              switch (e = this.applyScaleFunction(e), t) {
                case n.personalityProps.PITCH:
                  return '<PITCH RANGE="' + e + '%">';
                case n.personalityProps.RATE:
                  return '<RATE SPEED="' + e + '%">';
                case n.personalityProps.VOLUME:
                  return '<VOLUME LEVEL="' + e + '%">';
                default:
                  return "<" + t.toUpperCase() + ' VALUE="' + e + '">';
              }
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</" + t.toUpperCase() + ">";
            }
          }]);
          return i;
        }(o.XmlRenderer);
        e.SableRenderer = i;
      },
      9536: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Span = void 0;
        e.Span = /*#__PURE__*/function () {
          function _class2(t, e) {
            _classCallCheck(this, _class2);
            this.speech = t, this.attributes = e;
          }
          return _class2;
        }();
      },
      7504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SsmlRenderer = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2456);
        var a = /*#__PURE__*/function (_i$XmlRenderer) {
          _inherits(a, _i$XmlRenderer);
          function a() {
            _classCallCheck(this, a);
            return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
          }
          _createClass(a, [{
            key: "finalize",
            value: function finalize(t) {
              return '<?xml version="1.0"?><speak version="1.1" xmlns="http://www.w3.org/2001/10/synthesis"><prosody rate="' + n.default.getInstance().getRate() + '%">' + this.getSeparator() + t + this.getSeparator() + "</prosody></speak>";
            }
          }, {
            key: "pause",
            value: function pause(t) {
              return '<break time="' + this.pauseValue(t[o.personalityProps.PAUSE]) + 'ms"/>';
            }
          }, {
            key: "prosodyElement",
            value: function prosodyElement(t, e) {
              var r = (e = Math.floor(this.applyScaleFunction(e))) < 0 ? e.toString() : "+" + e.toString();
              return "<prosody " + t.toLowerCase() + '="' + r + (t === o.personalityProps.VOLUME ? ">" : '%">');
            }
          }, {
            key: "closeTag",
            value: function closeTag(t) {
              return "</prosody>";
            }
          }]);
          return a;
        }(i.XmlRenderer);
        e.SsmlRenderer = a;
      },
      3757: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SsmlStepRenderer = void 0;
        var n = r(7504);
        var o = /*#__PURE__*/function (_n$SsmlRenderer) {
          _inherits(o, _n$SsmlRenderer);
          function o() {
            _classCallCheck(this, o);
            return _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments));
          }
          _createClass(o, [{
            key: "markup",
            value: function markup(t) {
              return o.MARKS = {}, _superPropGet(o, "markup", this, 3)([t]);
            }
          }, {
            key: "merge",
            value: function merge(t) {
              var e = [];
              for (var _r26 = 0; _r26 < t.length; _r26++) {
                var _n153 = t[_r26],
                  i = _n153.attributes.extid;
                i && !o.MARKS[i] && (e.push('<mark name="' + i + '"/>'), o.MARKS[i] = !0), 1 === _n153.speech.length && _n153.speech.match(/[a-zA-Z]/) ? e.push('<say-as interpret-as="' + o.CHARACTER_ATTR + '">' + _n153.speech + "</say-as>") : e.push(_n153.speech);
              }
              return e.join(this.getSeparator());
            }
          }]);
          return o;
        }(n.SsmlRenderer);
        e.SsmlStepRenderer = o, o.CHARACTER_ATTR = "character", o.MARKS = {};
      },
      4032: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StringRenderer = void 0;
        var n = r(3921),
          o = r(3706);
        var i = /*#__PURE__*/function (_n$AbstractAudioRende) {
          _inherits(i, _n$AbstractAudioRende);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "markup",
            value: function markup(t) {
              var e = "";
              var r = (0, o.personalityMarkup)(t).filter(function (t) {
                return t.span;
              });
              if (!r.length) return e;
              var n = r.length - 1;
              for (var _t23, _o6 = 0; _t23 = r[_o6]; _o6++) {
                if (_t23.span && (e += this.merge(_t23.span)), _o6 >= n) continue;
                var _r27 = _t23.join;
                e += void 0 === _r27 ? this.getSeparator() : _r27;
              }
              return e;
            }
          }]);
          return i;
        }(n.AbstractAudioRenderer);
        e.StringRenderer = i;
      },
      2456: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.XmlRenderer = void 0;
        var n = r(5897),
          o = r(3706),
          i = r(182);
        var a = /*#__PURE__*/function (_i$MarkupRenderer) {
          _inherits(a, _i$MarkupRenderer);
          function a() {
            _classCallCheck(this, a);
            return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
          }
          _createClass(a, [{
            key: "markup",
            value: function markup(t) {
              var _this2 = this;
              this.setScaleFunction(-2, 2, -100, 100, 2);
              var e = o.personalityMarkup(t),
                r = [],
                i = [];
              var _loop2 = function _loop2(_t24) {
                if (_t24.span) r.push(_this2.merge(_t24.span));else if (o.isPauseElement(_t24)) r.push(_this2.pause(_t24));else {
                  if (_t24.close.length) for (var _e12 = 0; _e12 < _t24.close.length; _e12++) {
                    var _e13 = i.pop();
                    if (-1 === _t24.close.indexOf(_e13)) throw new n.SREError("Unknown closing markup element: " + _e13);
                    r.push(_this2.closeTag(_e13));
                  }
                  if (_t24.open.length) {
                    o.sortClose(_t24.open.slice(), e.slice(_a4 + 1)).forEach(function (e) {
                      r.push(_this2.prosodyElement(e, _t24[e])), i.push(e);
                    });
                  }
                }
              };
              for (var _t24, _a4 = 0; _t24 = e[_a4]; _a4++) {
                _loop2(_t24);
              }
              return r.join(" ");
            }
          }]);
          return a;
        }(i.MarkupRenderer);
        e.XmlRenderer = a;
      },
      707: function _(t, e) {
        function r(t, e) {
          return t ? e ? t.filter(function (t) {
            return e.indexOf(t) < 0;
          }) : t : [];
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.union = e.setdifference = e.interleaveLists = e.removeEmpty = void 0, e.removeEmpty = function (t) {
          return t.filter(function (t) {
            return t;
          });
        }, e.interleaveLists = function (t, e) {
          var r = [];
          for (; t.length || e.length;) t.length && r.push(t.shift()), e.length && r.push(e.shift());
          return r;
        }, e.setdifference = r, e.union = function (t, e) {
          return t && e ? t.concat(r(e, t)) : t || e || [];
        };
      },
      2139: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.loadScript = e.loadMapsForIE_ = e.installWGXpath_ = e.loadWGXpath_ = e.mapsForIE = e.detectEdge = e.detectIE = void 0;
        var n = r(2315),
          o = r(5274);
        function i(t) {
          s(n.default.WGXpath), a(t);
        }
        function a(t, e) {
          var r = e || 1;
          "undefined" == typeof wgxpath && r < 10 ? setTimeout(function () {
            a(t, r++);
          }, 200) : r >= 10 || (n.default.wgxpath = wgxpath, t ? n.default.wgxpath.install({
            document: document
          }) : n.default.wgxpath.install(), o.xpath.evaluate = document.evaluate, o.xpath.result = XPathResult, o.xpath.createNSResolver = document.createNSResolver);
        }
        function Q() {
          s(n.default.mathmapsIePath);
        }
        function s(t) {
          var e = n.default.document.createElement("script");
          e.type = "text/javascript", e.src = t, n.default.document.head ? n.default.document.head.appendChild(e) : n.default.document.body.appendChild(e);
        }
        e.detectIE = function () {
          return "undefined" != typeof window && "ActiveXObject" in window && "clipboardData" in window && (Q(), i(), !0);
        }, e.detectEdge = function () {
          var t;
          return "undefined" != typeof window && "MSGestureEvent" in window && null === (null === (t = window.chrome) || void 0 === t ? void 0 : t.loadTimes) && (document.evaluate = null, i(!0), !0);
        }, e.mapsForIE = null, e.loadWGXpath_ = i, e.installWGXpath_ = a, e.loadMapsForIE_ = Q, e.loadScript = s;
      },
      2057: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Debugger = void 0;
        var n = r(2315);
        var o = /*#__PURE__*/function () {
          function o() {
            _classCallCheck(this, o);
            this.isActive_ = !1, this.outputFunction_ = console.info, this.stream_ = null;
          }
          _createClass(o, [{
            key: "init",
            value: function init(t) {
              t && this.startDebugFile_(t), this.isActive_ = !0;
            }
          }, {
            key: "output",
            value: function output() {
              for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
                t[_key] = arguments[_key];
              }
              this.isActive_ && this.output_(t);
            }
          }, {
            key: "generateOutput",
            value: function generateOutput(t) {
              this.isActive_ && this.output_(t.apply(t, []));
            }
          }, {
            key: "exit",
            value: function exit() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
              this.isActive_ && this.stream_ && this.stream_.end("", "", t);
            }
          }, {
            key: "startDebugFile_",
            value: function startDebugFile_(t) {
              this.stream_ = n.default.fs.createWriteStream(t), this.outputFunction_ = function () {
                for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  t[_key2] = arguments[_key2];
                }
                this.stream_.write(t.join(" ")), this.stream_.write("\n");
              }.bind(this), this.stream_.on("error", function (t) {
                console.info("Invalid log file. Debug information sent to console."), this.outputFunction_ = console.info;
              }.bind(this)), this.stream_.on("finish", function () {
                console.info("Finalizing debug file.");
              });
            }
          }, {
            key: "output_",
            value: function output_(t) {
              this.outputFunction_.apply(console.info === this.outputFunction_ ? console : this.outputFunction_, ["Speech Rule Engine Debugger:"].concat(t));
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return o.instance = o.instance || new o(), o.instance;
            }
          }]);
          return o;
        }();
        e.Debugger = o;
      },
      5740: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.serializeXml = e.cloneNode = e.tagName = e.querySelectorAll = e.querySelectorAllByAttrValue = e.querySelectorAllByAttr = e.formatXml = e.createTextNode = e.createElementNS = e.createElement = e.replaceNode = e.NodeType = e.parseInput = e.XML_ENTITIES = e.trimInput_ = e.toArray = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2315),
          a = r(5274);
        function Q(t) {
          var e = [];
          for (var _r28 = 0, _n154 = t.length; _r28 < _n154; _r28++) e.push(t[_r28]);
          return e;
        }
        function s(t) {
          return (t = t.replace(/&nbsp;/g, "\xa0")).replace(/>[ \f\n\r\t\v\u200b]+</g, "><").trim();
        }
        function T(t, e) {
          if (!e) return [!1, ""];
          var r = t.match(/^<([^> ]+).*>/),
            n = e.match(/^<\/([^>]+)>(.*)/);
          return r && n && r[1] === n[1] ? [!0, n[2]] : [!1, ""];
        }
        e.toArray = Q, e.trimInput_ = s, e.XML_ENTITIES = {
          "&lt;": !0,
          "&gt;": !0,
          "&amp;": !0,
          "&quot;": !0,
          "&apos;": !0
        }, e.parseInput = function (t) {
          var e = new i.default.xmldom.DOMParser(),
            r = s(t),
            Q = !!r.match(/&(?!lt|gt|amp|quot|apos)\w+;/g);
          if (!r) throw new Error("Empty input!");
          try {
            var _t25 = e.parseFromString(r, Q ? "text/html" : "text/xml");
            return n.default.getInstance().mode === o.Mode.HTTP ? (a.xpath.currentDocument = _t25, Q ? _t25.body.childNodes[0] : _t25.documentElement) : _t25.documentElement;
          } catch (t) {
            throw new n.SREError("Illegal input: " + t.message);
          }
        }, function (t) {
          t[t.ELEMENT_NODE = 1] = "ELEMENT_NODE", t[t.ATTRIBUTE_NODE = 2] = "ATTRIBUTE_NODE", t[t.TEXT_NODE = 3] = "TEXT_NODE", t[t.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", t[t.ENTITY_REFERENCE_NODE = 5] = "ENTITY_REFERENCE_NODE", t[t.ENTITY_NODE = 6] = "ENTITY_NODE", t[t.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", t[t.COMMENT_NODE = 8] = "COMMENT_NODE", t[t.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", t[t.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", t[t.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE", t[t.NOTATION_NODE = 12] = "NOTATION_NODE";
        }(e.NodeType || (e.NodeType = {})), e.replaceNode = function (t, e) {
          t.parentNode && (t.parentNode.insertBefore(e, t), t.parentNode.removeChild(t));
        }, e.createElement = function (t) {
          return i.default.document.createElement(t);
        }, e.createElementNS = function (t, e) {
          return i.default.document.createElementNS(t, e);
        }, e.createTextNode = function (t) {
          return i.default.document.createTextNode(t);
        }, e.formatXml = function (t) {
          var e = "",
            r = /(>)(<)(\/*)/g,
            n = 0,
            o = (t = t.replace(r, "$1\r\n$2$3")).split("\r\n");
          for (r = /(\.)*(<)(\/*)/g, o = o.map(function (t) {
            return t.replace(r, "$1\r\n$2$3").split("\r\n");
          }).reduce(function (t, e) {
            return t.concat(e);
          }, []); o.length;) {
            var _t26 = o.shift();
            if (!_t26) continue;
            var _r29 = 0;
            if (_t26.match(/^<\w[^>/]*>[^>]+$/)) {
              var _e14 = T(_t26, o[0]);
              _e14[0] ? _e14[1] ? (_t26 += o.shift().slice(0, -_e14[1].length), _e14[1].trim() && o.unshift(_e14[1])) : _t26 += o.shift() : _r29 = 1;
            } else if (_t26.match(/^<\/\w/)) 0 !== n && (n -= 1);else if (_t26.match(/^<\w[^>]*[^/]>.*$/)) _r29 = 1;else if (_t26.match(/^<\w[^>]*\/>.+$/)) {
              var _e15 = _t26.indexOf(">") + 1;
              _t26.slice(_e15).trim() && o.unshift(), _t26 = _t26.slice(0, _e15);
            } else _r29 = 0;
            e += new Array(n + 1).join("  ") + _t26 + "\r\n", n += _r29;
          }
          return e;
        }, e.querySelectorAllByAttr = function (t, e) {
          return t.querySelectorAll ? Q(t.querySelectorAll("[".concat(e, "]"))) : a.evalXPath(".//*[@".concat(e, "]"), t);
        }, e.querySelectorAllByAttrValue = function (t, e, r) {
          return t.querySelectorAll ? Q(t.querySelectorAll("[".concat(e, "=\"").concat(r, "\"]"))) : a.evalXPath(".//*[@".concat(e, "=\"").concat(r, "\"]"), t);
        }, e.querySelectorAll = function (t, e) {
          return t.querySelectorAll ? Q(t.querySelectorAll(e)) : a.evalXPath(".//".concat(e), t);
        }, e.tagName = function (t) {
          return t.tagName.toUpperCase();
        }, e.cloneNode = function (t) {
          return t.cloneNode(!0);
        }, e.serializeXml = function (t) {
          return new i.default.xmldom.XMLSerializer().serializeToString(t);
        };
      },
      5897: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.EnginePromise = e.SREError = void 0;
        var n = r(1676),
          o = r(4440),
          i = r(2057),
          a = r(1377);
        var Q = /*#__PURE__*/function (_Error) {
          _inherits(Q, _Error);
          function Q() {
            var _this3;
            var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            _classCallCheck(this, Q);
            _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this)), _this3.message = t, _this3.name = "SRE Error";
            return _this3;
          }
          return Q;
        }(_wrapNativeSuper(Error));
        e.SREError = Q;
        var s = /*#__PURE__*/function () {
          function s() {
            _classCallCheck(this, s);
            this.customLoader = null, this.parsers = {}, this.comparator = null, this.mode = o.Mode.SYNC, this.init = !0, this.delay = !1, this.comparators = {}, this.domain = "mathspeak", this.style = n.DynamicCstr.DEFAULT_VALUES[n.Axis.STYLE], this._defaultLocale = n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE], this.locale = this.defaultLocale, this.subiso = "", this.modality = n.DynamicCstr.DEFAULT_VALUES[n.Axis.MODALITY], this.speech = o.Speech.NONE, this.markup = o.Markup.NONE, this.walker = "Table", this.structure = !1, this.ruleSets = [], this.strict = !1, this.isIE = !1, this.isEdge = !1, this.rate = "100", this.pprint = !1, this.config = !1, this.rules = "", this.prune = "", this.evaluator = s.defaultEvaluator, this.defaultParser = new n.DynamicCstrParser(n.DynamicCstr.DEFAULT_ORDER), this.parser = this.defaultParser, this.dynamicCstr = n.DynamicCstr.defaultCstr();
          }
          _createClass(s, [{
            key: "getRate",
            value: function getRate() {
              var t = parseInt(this.rate, 10);
              return isNaN(t) ? 100 : t;
            }
          }, {
            key: "setDynamicCstr",
            value: function setDynamicCstr(t) {
              if (this.defaultLocale && (n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE] = this.defaultLocale), t) {
                var _e16 = Object.keys(t);
                for (var _r30 = 0; _r30 < _e16.length; _r30++) {
                  var _o7 = _e16[_r30];
                  if (-1 !== n.DynamicCstr.DEFAULT_ORDER.indexOf(_o7)) {
                    var _e17 = t[_o7];
                    this[_o7] = _e17;
                  }
                }
              }
              o.DOMAIN_TO_STYLES[this.domain] = this.style;
              var e = [this.locale, this.modality, this.domain, this.style].join("."),
                r = n.DynamicProperties.createProp([n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.MODALITY]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.DOMAIN]], [n.DynamicCstr.DEFAULT_VALUES[n.Axis.STYLE]]),
                i = this.comparators[this.domain],
                a = this.parsers[this.domain];
              this.parser = a || this.defaultParser, this.dynamicCstr = this.parser.parse(e), this.dynamicCstr.updateProperties(r.getProperties()), this.comparator = i ? i() : new n.DefaultComparator(this.dynamicCstr);
            }
          }, {
            key: "configurate",
            value: function configurate(t) {
              this.mode !== o.Mode.HTTP || this.config || (!function (t) {
                var e = document.documentElement.querySelectorAll('script[type="text/x-sre-config"]');
                for (var _r31 = 0, _n155 = e.length; _r31 < _n155; _r31++) {
                  var _n156 = void 0;
                  try {
                    _n156 = e[_r31].innerHTML;
                    var _o8 = JSON.parse(_n156);
                    for (var _e18 in _o8) t[_e18] = _o8[_e18];
                  } catch (t) {
                    i.Debugger.getInstance().output("Illegal configuration ", _n156);
                  }
                }
              }(t), this.config = !0), function (t) {
                if ("undefined" != typeof SREfeature) for (var _i10 = 0, _Object$entries = Object.entries(SREfeature); _i10 < _Object$entries.length; _i10++) {
                  var _Object$entries$_i = _slicedToArray(_Object$entries[_i10], 2),
                    _e19 = _Object$entries$_i[0],
                    _r32 = _Object$entries$_i[1];
                  t[_e19] = _r32;
                }
              }(t);
            }
          }, {
            key: "setCustomLoader",
            value: function setCustomLoader(t) {
              t && (this.customLoader = t);
            }
          }, {
            key: "defaultLocale",
            set: function set(t) {
              this._defaultLocale = a.Variables.ensureLocale(t, this._defaultLocale);
            },
            get: function get() {
              return this._defaultLocale;
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return s.instance = s.instance || new s(), s.instance;
            }
          }, {
            key: "defaultEvaluator",
            value: function defaultEvaluator(t, e) {
              return t;
            }
          }, {
            key: "evaluateNode",
            value: function evaluateNode(t) {
              return s.nodeEvaluator(t);
            }
          }]);
          return s;
        }();
        e.default = s, s.BINARY_FEATURES = ["strict", "structure", "pprint"], s.STRING_FEATURES = ["markup", "style", "domain", "speech", "walker", "defaultLocale", "locale", "delay", "modality", "rate", "rules", "subiso", "prune"], s.nodeEvaluator = function (t) {
          return [];
        };
        var T = /*#__PURE__*/function () {
          function T() {
            _classCallCheck(this, T);
          }
          _createClass(T, null, [{
            key: "get",
            value: function get() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : s.getInstance().locale;
              return T.promises[t] || Promise.resolve("");
            }
          }, {
            key: "getall",
            value: function getall() {
              return Promise.all(Object.values(T.promises));
            }
          }]);
          return T;
        }();
        e.EnginePromise = T, T.loaded = {}, T.promises = {};
      },
      4440: function _(t, e) {
        var r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DOMAIN_TO_STYLES = e.Markup = e.Speech = e.personalityPropList = e.personalityProps = e.Mode = void 0, function (t) {
          t.SYNC = "sync", t.ASYNC = "async", t.HTTP = "http";
        }(e.Mode || (e.Mode = {})), function (t) {
          t.PITCH = "pitch", t.RATE = "rate", t.VOLUME = "volume", t.PAUSE = "pause", t.JOIN = "join", t.LAYOUT = "layout";
        }(r = e.personalityProps || (e.personalityProps = {})), e.personalityPropList = [r.PITCH, r.RATE, r.VOLUME, r.PAUSE, r.JOIN], function (t) {
          t.NONE = "none", t.SHALLOW = "shallow", t.DEEP = "deep";
        }(e.Speech || (e.Speech = {})), function (t) {
          t.NONE = "none", t.LAYOUT = "layout", t.PUNCTUATION = "punctuation", t.SSML = "ssml", t.SSML_STEP = "ssml_step", t.ACSS = "acss", t.SABLE = "sable", t.VOICEXML = "voicexml";
        }(e.Markup || (e.Markup = {})), e.DOMAIN_TO_STYLES = {
          mathspeak: "default",
          clearspeak: "default"
        };
      },
      6828: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                s(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function Q(t) {
              try {
                s(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, Q);
            }
            s((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.setup = void 0;
        var o = r(7491),
          i = r(6141),
          a = r(2139),
          Q = r(5897),
          s = r(7248),
          T = r(2315);
        e.setup = function (t) {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var e, r;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  e = Q.default.getInstance();
                  "default" !== t.domain || "speech" !== t.modality && t.modality && "speech" !== e.modality || (t.domain = "mathspeak");
                  r = function r(_r33) {
                    void 0 !== t[_r33] && (e[_r33] = t[_r33]);
                  };
                  return _context.abrupt("return", (r("mode"), e.configurate(t), Q.default.BINARY_FEATURES.forEach(function (r) {
                    void 0 !== t[r] && (e[r] = !!t[r]);
                  }), Q.default.STRING_FEATURES.forEach(r), t.json && (T.default.jsonPath = s.makePath(t.json)), t.xpath && (T.default.WGXpath = t.xpath), e.setCustomLoader(t.custom), function (t) {
                    t.isIE = a.detectIE(), t.isEdge = a.detectEdge();
                  }(e), o.setLocale(), e.setDynamicCstr(), e.init ? (Q.EnginePromise.promises.init = new Promise(function (t, e) {
                    setTimeout(function () {
                      t("init");
                    }, 10);
                  }), e.init = !1, Q.EnginePromise.get()) : e.delay ? (e.delay = !1, Q.EnginePromise.get()) : i.loadLocale()));
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
        };
      },
      8496: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Event = e.EventType = e.Move = e.KeyCode = void 0, function (t) {
          t[t.ENTER = 13] = "ENTER", t[t.ESC = 27] = "ESC", t[t.SPACE = 32] = "SPACE", t[t.PAGE_UP = 33] = "PAGE_UP", t[t.PAGE_DOWN = 34] = "PAGE_DOWN", t[t.END = 35] = "END", t[t.HOME = 36] = "HOME", t[t.LEFT = 37] = "LEFT", t[t.UP = 38] = "UP", t[t.RIGHT = 39] = "RIGHT", t[t.DOWN = 40] = "DOWN", t[t.TAB = 9] = "TAB", t[t.LESS = 188] = "LESS", t[t.GREATER = 190] = "GREATER", t[t.DASH = 189] = "DASH", t[t.ZERO = 48] = "ZERO", t[t.ONE = 49] = "ONE", t[t.TWO = 50] = "TWO", t[t.THREE = 51] = "THREE", t[t.FOUR = 52] = "FOUR", t[t.FIVE = 53] = "FIVE", t[t.SIX = 54] = "SIX", t[t.SEVEN = 55] = "SEVEN", t[t.EIGHT = 56] = "EIGHT", t[t.NINE = 57] = "NINE", t[t.A = 65] = "A", t[t.B = 66] = "B", t[t.C = 67] = "C", t[t.D = 68] = "D", t[t.E = 69] = "E", t[t.F = 70] = "F", t[t.G = 71] = "G", t[t.H = 72] = "H", t[t.I = 73] = "I", t[t.J = 74] = "J", t[t.K = 75] = "K", t[t.L = 76] = "L", t[t.M = 77] = "M", t[t.N = 78] = "N", t[t.O = 79] = "O", t[t.P = 80] = "P", t[t.Q = 81] = "Q", t[t.R = 82] = "R", t[t.S = 83] = "S", t[t.T = 84] = "T", t[t.U = 85] = "U", t[t.V = 86] = "V", t[t.W = 87] = "W", t[t.X = 88] = "X", t[t.Y = 89] = "Y", t[t.Z = 90] = "Z";
        }(e.KeyCode || (e.KeyCode = {})), e.Move = new Map([[13, "ENTER"], [27, "ESC"], [32, "SPACE"], [33, "PAGE_UP"], [34, "PAGE_DOWN"], [35, "END"], [36, "HOME"], [37, "LEFT"], [38, "UP"], [39, "RIGHT"], [40, "DOWN"], [9, "TAB"], [188, "LESS"], [190, "GREATER"], [189, "DASH"], [48, "ZERO"], [49, "ONE"], [50, "TWO"], [51, "THREE"], [52, "FOUR"], [53, "FIVE"], [54, "SIX"], [55, "SEVEN"], [56, "EIGHT"], [57, "NINE"], [65, "A"], [66, "B"], [67, "C"], [68, "D"], [69, "E"], [70, "F"], [71, "G"], [72, "H"], [73, "I"], [74, "J"], [75, "K"], [76, "L"], [77, "M"], [78, "N"], [79, "O"], [80, "P"], [81, "Q"], [82, "R"], [83, "S"], [84, "T"], [85, "U"], [86, "V"], [87, "W"], [88, "X"], [89, "Y"], [90, "Z"]]), function (t) {
          t.CLICK = "click", t.DBLCLICK = "dblclick", t.MOUSEDOWN = "mousedown", t.MOUSEUP = "mouseup", t.MOUSEOVER = "mouseover", t.MOUSEOUT = "mouseout", t.MOUSEMOVE = "mousemove", t.SELECTSTART = "selectstart", t.KEYPRESS = "keypress", t.KEYDOWN = "keydown", t.KEYUP = "keyup", t.TOUCHSTART = "touchstart", t.TOUCHMOVE = "touchmove", t.TOUCHEND = "touchend", t.TOUCHCANCEL = "touchcancel";
        }(e.EventType || (e.EventType = {}));
        e.Event = /*#__PURE__*/function () {
          function _class3(t, e, r) {
            _classCallCheck(this, _class3);
            this.src = t, this.type = e, this.callback = r;
          }
          _createClass(_class3, [{
            key: "add",
            value: function add() {
              this.src.addEventListener(this.type, this.callback);
            }
          }, {
            key: "remove",
            value: function remove() {
              this.src.removeEventListener(this.type, this.callback);
            }
          }]);
          return _class3;
        }();
      },
      7248: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localePath = e.makePath = void 0;
        var n = r(2315);
        function o(t) {
          return t.match("/$") ? t : t + "/";
        }
        e.makePath = o, e.localePath = function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "json";
          return o(n.default.jsonPath) + t + (e.match(/^\./) ? e : "." + e);
        };
      },
      3769: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.KeyProcessor = e.Processor = void 0;
        var n = r(8496);
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.name = t, this.process = e.processor, this.postprocess = e.postprocessor || function (t, e) {
              return t;
            }, this.processor = this.postprocess ? function (t) {
              return this.postprocess(this.process(t), t);
            } : this.process, this.print = e.print || o.stringify_, this.pprint = e.pprint || this.print;
          }
          _createClass(o, null, [{
            key: "stringify_",
            value: function stringify_(t) {
              return t ? t.toString() : t;
            }
          }]);
          return o;
        }();
        e.Processor = o, o.LocalState = {
          walker: null,
          speechGenerator: null,
          highlighter: null
        };
        var i = /*#__PURE__*/function (_o9) {
          _inherits(i, _o9);
          function i(t, e) {
            var _this4;
            _classCallCheck(this, i);
            _this4 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, t, e)), _this4.key = e.key || i.getKey_;
            return _this4;
          }
          _createClass(i, null, [{
            key: "getKey_",
            value: function getKey_(t) {
              return "string" == typeof t ? n.KeyCode[t.toUpperCase()] : t;
            }
          }]);
          return i;
        }(o);
        e.KeyProcessor = i;
      },
      6499: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.keypress = e.output = e.print = e.process = e.set = void 0;
        var n = r(8290),
          o = r(5714),
          i = r(3090),
          a = r(4356),
          Q = r(1414),
          s = r(9552),
          T = r(9543),
          l = r(3362),
          c = r(1204),
          u = r(5740),
          p = r(5897),
          h = r(4440),
          d = r(3769),
          f = r(5274),
          m = new Map();
        function L(t) {
          m.set(t.name, t);
        }
        function y(t) {
          var e = m.get(t);
          if (!e) throw new p.SREError("Unknown processor " + t);
          return e;
        }
        function g(t, e) {
          var r = y(t);
          try {
            return r.processor(e);
          } catch (t) {
            throw new p.SREError("Processing error for expression " + e);
          }
        }
        function v(t, e) {
          var r = y(t);
          return p.default.getInstance().pprint ? r.pprint(e) : r.print(e);
        }
        e.set = L, e.process = g, e.print = v, e.output = function (t, e) {
          var r = y(t);
          try {
            var _t27 = r.processor(e);
            return p.default.getInstance().pprint ? r.pprint(_t27) : r.print(_t27);
          } catch (t) {
            throw new p.SREError("Processing error for expression " + e);
          }
        }, e.keypress = function (t, e) {
          var r = y(t),
            n = r instanceof d.KeyProcessor ? r.key(e) : e,
            o = r.processor(n);
          return p.default.getInstance().pprint ? r.pprint(o) : r.print(o);
        }, L(new d.Processor("semantic", {
          processor: function processor(t) {
            var e = u.parseInput(t);
            return Q.xmlTree(e);
          },
          postprocessor: function postprocessor(t, e) {
            var r = p.default.getInstance().speech;
            if (r === h.Speech.NONE) return t;
            var o = u.cloneNode(t);
            var i = T.computeMarkup(o);
            if (r === h.Speech.SHALLOW) return t.setAttribute("speech", n.finalize(i)), t;
            var a = f.evalXPath(".//*[@id]", t),
              Q = f.evalXPath(".//*[@id]", o);
            for (var _t28, _e20, _r34 = 0; _t28 = a[_r34], _e20 = Q[_r34]; _r34++) i = T.computeMarkup(_e20), _t28.setAttribute("speech", n.finalize(i));
            return t;
          },
          pprint: function pprint(t) {
            return u.formatXml(t.toString());
          }
        })), L(new d.Processor("speech", {
          processor: function processor(t) {
            var e = u.parseInput(t),
              r = Q.xmlTree(e),
              o = T.computeSpeech(r);
            return n.finalize(n.markup(o));
          },
          pprint: function pprint(t) {
            var e = t.toString();
            return n.isXml() ? u.formatXml(e) : e;
          }
        })), L(new d.Processor("json", {
          processor: function processor(t) {
            var e = u.parseInput(t);
            return Q.getTree(e).toJson();
          },
          postprocessor: function postprocessor(t, e) {
            var r = p.default.getInstance().speech;
            if (r === h.Speech.NONE) return t;
            var o = u.parseInput(e),
              i = Q.xmlTree(o),
              a = T.computeMarkup(i);
            if (r === h.Speech.SHALLOW) return t.stree.speech = n.finalize(a), t;
            var _s2 = function s(t) {
              var e = f.evalXPath(".//*[@id=".concat(t.id, "]"), i)[0],
                r = T.computeMarkup(e);
              t.speech = n.finalize(r), t.children && t.children.forEach(_s2);
            };
            return _s2(t.stree), t;
          },
          print: function print(t) {
            return JSON.stringify(t);
          },
          pprint: function pprint(t) {
            return JSON.stringify(t, null, 2);
          }
        })), L(new d.Processor("description", {
          processor: function processor(t) {
            var e = u.parseInput(t),
              r = Q.xmlTree(e);
            return T.computeSpeech(r);
          },
          print: function print(t) {
            return JSON.stringify(t);
          },
          pprint: function pprint(t) {
            return JSON.stringify(t, null, 2);
          }
        })), L(new d.Processor("enriched", {
          processor: function processor(t) {
            return o.semanticMathmlSync(t);
          },
          postprocessor: function postprocessor(t, e) {
            var r = c.getSemanticRoot(t);
            var n;
            switch (p.default.getInstance().speech) {
              case h.Speech.NONE:
                break;
              case h.Speech.SHALLOW:
                n = s.generator("Adhoc"), n.getSpeech(r, t);
                break;
              case h.Speech.DEEP:
                n = s.generator("Tree"), n.getSpeech(t, t);
            }
            return t;
          },
          pprint: function pprint(t) {
            return u.formatXml(t.toString());
          }
        })), L(new d.Processor("walker", {
          processor: function processor(t) {
            var e = s.generator("Node");
            d.Processor.LocalState.speechGenerator = e, e.setOptions({
              modality: p.default.getInstance().modality,
              locale: p.default.getInstance().locale,
              domain: p.default.getInstance().domain,
              style: p.default.getInstance().style
            }), d.Processor.LocalState.highlighter = i.highlighter({
              color: "black"
            }, {
              color: "white"
            }, {
              renderer: "NativeMML"
            });
            var r = g("enriched", t),
              n = v("enriched", r);
            return d.Processor.LocalState.walker = l.walker(p.default.getInstance().walker, r, e, d.Processor.LocalState.highlighter, n), d.Processor.LocalState.walker;
          },
          print: function print(t) {
            return d.Processor.LocalState.walker.speech();
          }
        })), L(new d.KeyProcessor("move", {
          processor: function processor(t) {
            if (!d.Processor.LocalState.walker) return null;
            return !1 === d.Processor.LocalState.walker.move(t) ? n.error(t) : d.Processor.LocalState.walker.speech();
          }
        })), L(new d.Processor("number", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.numberToWords(e);
          }
        })), L(new d.Processor("ordinal", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.wordOrdinal(e);
          }
        })), L(new d.Processor("numericOrdinal", {
          processor: function processor(t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.LOCALE.NUMBERS.numericOrdinal(e);
          }
        })), L(new d.Processor("vulgar", {
          processor: function processor(t) {
            var _t$split$map = t.split("/").map(function (t) {
                return parseInt(t, 10);
              }),
              _t$split$map2 = _slicedToArray(_t$split$map, 2),
              e = _t$split$map2[0],
              r = _t$split$map2[1];
            return isNaN(e) || isNaN(r) ? "" : g("speech", "<mfrac><mn>".concat(e, "</mn><mn>").concat(r, "</mn></mfrac>"));
          }
        }));
      },
      2998: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                s(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function Q(t) {
              try {
                s(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, Q);
            }
            s((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localePath = e.exit = e.move = e.walk = e.processFile = e.file = e.vulgar = e.numericOrdinal = e.ordinal = e.number = e.toEnriched = e.toDescription = e.toJson = e.toSemantic = e.toSpeech = e.localeLoader = e.engineReady = e.engineSetup = e.setupEngine = e.version = void 0;
        var o = r(5897),
          i = r(6828),
          a = r(4440),
          Q = r(7248),
          s = r(6499),
          T = r(2315),
          l = r(1377),
          c = r(6141);
        function u(t) {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", (0, i.setup)(t));
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
        }
        function p(t, e) {
          return s.process(t, e);
        }
        function h(t, e, r) {
          switch (o.default.getInstance().mode) {
            case a.Mode.ASYNC:
              return function (t, e, r) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var n, i;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return T.default.fs.promises.readFile(e, {
                          encoding: "utf8"
                        });
                      case 2:
                        n = _context3.sent;
                        i = s.output(t, n);
                        if (!r) {
                          _context3.next = 12;
                          break;
                        }
                        _context3.prev = 5;
                        T.default.fs.promises.writeFile(r, i);
                        _context3.next = 12;
                        break;
                      case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3["catch"](5);
                        throw new o.SREError("Can not write to file: " + r);
                      case 12:
                        return _context3.abrupt("return", i);
                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[5, 9]]);
                }));
              }(t, e, r);
            case a.Mode.SYNC:
              return function (t, e, r) {
                var n = function (t) {
                    var e;
                    try {
                      e = T.default.fs.readFileSync(t, {
                        encoding: "utf8"
                      });
                    } catch (e) {
                      throw new o.SREError("Can not open file: " + t);
                    }
                    return e;
                  }(e),
                  i = s.output(t, n);
                if (r) try {
                  T.default.fs.writeFileSync(r, i);
                } catch (t) {
                  throw new o.SREError("Can not write to file: " + r);
                }
                return i;
              }(t, e, r);
            default:
              throw new o.SREError("Can process files in ".concat(o.default.getInstance().mode, " mode"));
          }
        }
        e.version = l.Variables.VERSION, e.setupEngine = u, e.engineSetup = function () {
          var t = ["mode"].concat(o.default.STRING_FEATURES, o.default.BINARY_FEATURES),
            e = o.default.getInstance(),
            r = {};
          return t.forEach(function (t) {
            r[t] = e[t];
          }), r.json = T.default.jsonPath, r.xpath = T.default.WGXpath, r.rules = e.ruleSets.slice(), r;
        }, e.engineReady = function () {
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", u({}).then(function () {
                    return o.EnginePromise.getall();
                  }));
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
        }, e.localeLoader = c.standardLoader, e.toSpeech = function (t) {
          return p("speech", t);
        }, e.toSemantic = function (t) {
          return p("semantic", t);
        }, e.toJson = function (t) {
          return p("json", t);
        }, e.toDescription = function (t) {
          return p("description", t);
        }, e.toEnriched = function (t) {
          return p("enriched", t);
        }, e.number = function (t) {
          return p("number", t);
        }, e.ordinal = function (t) {
          return p("ordinal", t);
        }, e.numericOrdinal = function (t) {
          return p("numericOrdinal", t);
        }, e.vulgar = function (t) {
          return p("vulgar", t);
        }, e.file = {}, e.file.toSpeech = function (t, e) {
          return h("speech", t, e);
        }, e.file.toSemantic = function (t, e) {
          return h("semantic", t, e);
        }, e.file.toJson = function (t, e) {
          return h("json", t, e);
        }, e.file.toDescription = function (t, e) {
          return h("description", t, e);
        }, e.file.toEnriched = function (t, e) {
          return h("enriched", t, e);
        }, e.processFile = h, e.walk = function (t) {
          return s.output("walker", t);
        }, e.move = function (t) {
          return s.keypress("move", t);
        }, e.exit = function (t) {
          var e = t || 0;
          o.EnginePromise.getall().then(function () {
            return process.exit(e);
          });
        }, e.localePath = Q.localePath, T.default.documentSupported ? u({
          mode: a.Mode.HTTP
        }).then(function () {
          return u({});
        }) : u({
          mode: a.Mode.SYNC
        }).then(function () {
          return u({
            mode: a.Mode.ASYNC
          });
        });
      },
      2315: function _(__unused_webpack_module, exports, __webpack_require__) {
        var __dirname = "/";
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var variables_1 = __webpack_require__(1377);
        var SystemExternal = /*#__PURE__*/function () {
          function SystemExternal() {
            _classCallCheck(this, SystemExternal);
          }
          _createClass(SystemExternal, null, [{
            key: "extRequire",
            value: function extRequire(library) {
              if ("undefined" != typeof process) {
                var nodeRequire = eval("require");
                return nodeRequire(library);
              }
              return null;
            }
          }]);
          return SystemExternal;
        }();
        exports.default = SystemExternal, SystemExternal.windowSupported = !("undefined" == typeof window), SystemExternal.documentSupported = SystemExternal.windowSupported && !(void 0 === window.document), SystemExternal.xmldom = SystemExternal.documentSupported ? window : SystemExternal.extRequire("xmldom-sre"), SystemExternal.document = SystemExternal.documentSupported ? window.document : new SystemExternal.xmldom.DOMImplementation().createDocument("", "", 0), SystemExternal.xpath = SystemExternal.documentSupported ? document : function () {
          var t = {
            document: {},
            XPathResult: {}
          };
          return SystemExternal.extRequire("wicked-good-xpath").install(t), t.document.XPathResult = t.XPathResult, t.document;
        }(), SystemExternal.mathmapsIePath = "https://cdn.jsdelivr.net/npm/sre-mathmaps-ie@" + variables_1.Variables.VERSION + "mathmaps_ie.js", SystemExternal.commander = SystemExternal.documentSupported ? null : SystemExternal.extRequire("commander"), SystemExternal.fs = SystemExternal.documentSupported ? null : SystemExternal.extRequire("fs"), SystemExternal.url = variables_1.Variables.url, SystemExternal.jsonPath = (SystemExternal.documentSupported ? SystemExternal.url : process.env.SRE_JSON_PATH || __webpack_require__.g.SRE_JSON_PATH || __dirname + "/mathmaps") + "/", SystemExternal.WGXpath = variables_1.Variables.WGXpath, SystemExternal.wgxpath = null;
      },
      1377: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Variables = void 0;
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
          }
          _createClass(r, null, [{
            key: "ensureLocale",
            value: function ensureLocale(t, e) {
              return r.LOCALES.get(t) ? t : (console.error("Locale ".concat(t, " does not exist! Using ").concat(r.LOCALES.get(e), " instead.")), e);
            }
          }]);
          return r;
        }();
        e.Variables = r, r.VERSION = "4.0.6", r.LOCALES = new Map([["ca", "Catalan"], ["da", "Danish"], ["de", "German"], ["en", "English"], ["es", "Spanish"], ["fr", "French"], ["hi", "Hindi"], ["it", "Italian"], ["nb", "Bokm\xe5l"], ["nn", "Nynorsk"], ["sv", "Swedish"], ["nemeth", "Nemeth"]]), r.mathjaxVersion = "3.2.1", r.url = "https://cdn.jsdelivr.net/npm/speech-rule-engine@" + r.VERSION + "/lib/mathmaps", r.WGXpath = "https://cdn.jsdelivr.net/npm/wicked-good-xpath@1.3.0/dist/wgxpath.install.js";
      },
      5274: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.updateEvaluator = e.evaluateString = e.evaluateBoolean = e.getLeafNodes = e.evalXPath = e.resolveNameSpace = e.xpath = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(2315);
        function a() {
          return "undefined" != typeof XPathResult;
        }
        e.xpath = {
          currentDocument: null,
          evaluate: a() ? document.evaluate : i.default.xpath.evaluate,
          result: a() ? XPathResult : i.default.xpath.XPathResult,
          createNSResolver: a() ? document.createNSResolver : i.default.xpath.createNSResolver
        };
        var Q = {
          xhtml: "http://www.w3.org/1999/xhtml",
          mathml: "http://www.w3.org/1998/Math/MathML",
          mml: "http://www.w3.org/1998/Math/MathML",
          svg: "http://www.w3.org/2000/svg"
        };
        function s(t) {
          return Q[t] || null;
        }
        e.resolveNameSpace = s;
        var T = function T() {
          _classCallCheck(this, T);
          this.lookupNamespaceURI = s;
        };
        function l(t, r, i) {
          return n.default.getInstance().mode !== o.Mode.HTTP || n.default.getInstance().isIE || n.default.getInstance().isEdge ? e.xpath.evaluate(t, r, new T(), i, null) : e.xpath.currentDocument.evaluate(t, r, s, i, null);
        }
        function c(t, r) {
          var n;
          try {
            n = l(t, r, e.xpath.result.ORDERED_NODE_ITERATOR_TYPE);
          } catch (t) {
            return [];
          }
          var o = [];
          for (var _t29 = n.iterateNext(); _t29; _t29 = n.iterateNext()) o.push(_t29);
          return o;
        }
        e.evalXPath = c, e.getLeafNodes = function (t) {
          return c(".//*[count(*)=0]", t);
        }, e.evaluateBoolean = function (t, r) {
          var n;
          try {
            n = l(t, r, e.xpath.result.BOOLEAN_TYPE);
          } catch (t) {
            return !1;
          }
          return n.booleanValue;
        }, e.evaluateString = function (t, r) {
          var n;
          try {
            n = l(t, r, e.xpath.result.STRING_TYPE);
          } catch (t) {
            return "";
          }
          return n.stringValue;
        }, e.updateEvaluator = function (t) {
          if (n.default.getInstance().mode !== o.Mode.HTTP) return;
          var r = t;
          for (; r && !r.evaluate;) r = r.parentNode;
          r && r.evaluate ? e.xpath.currentDocument = r : t.ownerDocument && (e.xpath.currentDocument = t.ownerDocument);
        };
      },
      9268: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractEnrichCase = void 0;
        e.AbstractEnrichCase = /*#__PURE__*/function () {
          function _class4(t) {
            _classCallCheck(this, _class4);
            this.semantic = t;
          }
          return _class4;
        }();
      },
      6061: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseBinomial = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$AbstractEnrichCase) {
          _inherits(Q, _o$AbstractEnrichCase);
          function Q(t) {
            var _this5;
            _classCallCheck(this, Q);
            _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t)), _this5.mml = t.mathmlTree;
            return _this5;
          }
          _createClass(Q, [{
            key: "getMathml",
            value: function getMathml() {
              if (!this.semantic.childNodes.length) return this.mml;
              var t = this.semantic.childNodes[0];
              if (this.mml = (0, i.walkTree)(t), this.mml.hasAttribute(a.Attribute.TYPE)) {
                var _t30 = n.createElement("mrow");
                _t30.setAttribute(a.Attribute.ADDED, "true"), n.replaceNode(this.mml, _t30), _t30.appendChild(this.mml), this.mml = _t30;
              }
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !t.mathmlTree && "line" === t.type && "binomial" === t.role;
            }
          }]);
          return Q;
        }(o.AbstractEnrichCase);
        e.CaseBinomial = Q;
      },
      5765: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseDoubleScript = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$AbstractEnrichCase2) {
          _inherits(Q, _o$AbstractEnrichCase2);
          function Q(t) {
            var _this6;
            _classCallCheck(this, Q);
            _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t)), _this6.mml = t.mathmlTree;
            return _this6;
          }
          _createClass(Q, [{
            key: "getMathml",
            value: function getMathml() {
              var _this7 = this;
              var t = this.semantic.childNodes[0],
                e = t.childNodes[0],
                r = this.semantic.childNodes[1],
                n = t.childNodes[1],
                o = i.walkTree(r),
                Q = i.walkTree(e),
                s = i.walkTree(n);
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml.setAttribute(a.Attribute.CHILDREN, (0, a.makeIdList)([e, n, r])), [Q, s, o].forEach(function (t) {
                return i.getInnerNode(t).setAttribute(a.Attribute.PARENT, _this7.mml.getAttribute(a.Attribute.ID));
              }), this.mml.setAttribute(a.Attribute.TYPE, t.role), i.addCollapsedAttribute(this.mml, [this.semantic.id, [t.id, e.id, n.id], r.id]), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree || !t.childNodes.length) return !1;
              var e = n.tagName(t.mathmlTree),
                r = t.childNodes[0].role;
              return "MSUBSUP" === e && "subsup" === r || "MUNDEROVER" === e && "underover" === r;
            }
          }]);
          return Q;
        }(o.AbstractEnrichCase);
        e.CaseDoubleScript = Q;
      },
      7251: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseEmbellished = void 0;
        var n = r(5740),
          o = r(5952),
          i = r(9268),
          a = r(5765),
          Q = r(7014),
          s = r(6887),
          T = r(5452),
          l = r(2298);
        var c = /*#__PURE__*/function (_i$AbstractEnrichCase) {
          _inherits(c, _i$AbstractEnrichCase);
          function c(t) {
            var _this8;
            _classCallCheck(this, c);
            _this8 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, t)), _this8.fenced = null, _this8.fencedMml = null, _this8.fencedMmlNodes = [], _this8.ofence = null, _this8.ofenceMml = null, _this8.ofenceMap = {}, _this8.cfence = null, _this8.cfenceMml = null, _this8.cfenceMap = {}, _this8.parentCleanup = [];
            return _this8;
          }
          _createClass(c, [{
            key: "getMathml",
            value: function getMathml() {
              this.getFenced_(), this.fencedMml = T.walkTree(this.fenced), this.getFencesMml_(), "empty" !== this.fenced.type || this.fencedMml.parentNode || (this.fencedMml.setAttribute(l.Attribute.ADDED, "true"), this.cfenceMml.parentNode.insertBefore(this.fencedMml, this.cfenceMml)), this.getFencedMml_();
              return this.rewrite_();
            }
          }, {
            key: "fencedElement",
            value: function fencedElement(t) {
              return "fenced" === t.type || "matrix" === t.type || "vector" === t.type;
            }
          }, {
            key: "getFenced_",
            value: function getFenced_() {
              var t = this.semantic;
              for (; !this.fencedElement(t);) t = t.childNodes[0];
              this.fenced = t.childNodes[0], this.ofence = t.contentNodes[0], this.cfence = t.contentNodes[1], c.fencedMap_(this.ofence, this.ofenceMap), c.fencedMap_(this.cfence, this.cfenceMap);
            }
          }, {
            key: "getFencedMml_",
            value: function getFencedMml_() {
              var t = this.ofenceMml.nextSibling;
              for (t = t === this.fencedMml ? t : this.fencedMml; t && t !== this.cfenceMml;) this.fencedMmlNodes.push(t), t = t.nextSibling;
            }
          }, {
            key: "getFencesMml_",
            value: function getFencesMml_() {
              var t = this.semantic;
              var e = Object.keys(this.ofenceMap),
                r = Object.keys(this.cfenceMap);
              for (; !(this.ofenceMml && this.cfenceMml || t === this.fenced);) -1 === e.indexOf(t.fencePointer) || this.ofenceMml || (this.ofenceMml = t.mathmlTree), -1 === r.indexOf(t.fencePointer) || this.cfenceMml || (this.cfenceMml = t.mathmlTree), t = t.childNodes[0];
              this.ofenceMml || (this.ofenceMml = this.ofence.mathmlTree), this.cfenceMml || (this.cfenceMml = this.cfence.mathmlTree), this.ofenceMml && (this.ofenceMml = T.ascendNewNode(this.ofenceMml)), this.cfenceMml && (this.cfenceMml = T.ascendNewNode(this.cfenceMml));
            }
          }, {
            key: "rewrite_",
            value: function rewrite_() {
              var t = this.semantic,
                e = null;
              var r = this.introduceNewLayer_();
              for ((0, l.setAttributes)(r, this.fenced.parent); !this.fencedElement(t);) {
                var _o10 = t.mathmlTree,
                  _i11 = this.specialCase_(t, _o10);
                if (_i11) t = _i11;else {
                  (0, l.setAttributes)(_o10, t);
                  var _e21 = [];
                  for (var _r35, _n157 = 1; _r35 = t.childNodes[_n157]; _n157++) _e21.push(T.walkTree(_r35));
                  t = t.childNodes[0];
                }
                var _a5 = n.createElement("dummy"),
                  _Q4 = _o10.childNodes[0];
                n.replaceNode(_o10, _a5), n.replaceNode(r, _o10), n.replaceNode(_o10.childNodes[0], r), n.replaceNode(_a5, _Q4), e || (e = _o10);
              }
              return T.walkTree(this.ofence), T.walkTree(this.cfence), this.cleanupParents_(), e || r;
            }
          }, {
            key: "specialCase_",
            value: function specialCase_(t, e) {
              var r = n.tagName(e);
              var o,
                i = null;
              if ("MSUBSUP" === r ? (i = t.childNodes[0], o = a.CaseDoubleScript) : "MMULTISCRIPTS" === r && ("superscript" === t.type || "subscript" === t.type ? o = Q.CaseMultiscripts : "tensor" === t.type && (o = s.CaseTensor), i = o && t.childNodes[0] && "subsup" === t.childNodes[0].role ? t.childNodes[0] : t), !i) return null;
              var T = i.childNodes[0],
                l = c.makeEmptyNode_(T.id);
              return i.childNodes[0] = l, e = new o(t).getMathml(), i.childNodes[0] = T, this.parentCleanup.push(e), i.childNodes[0];
            }
          }, {
            key: "introduceNewLayer_",
            value: function introduceNewLayer_() {
              var t = this.fullFence(this.ofenceMml),
                e = this.fullFence(this.cfenceMml);
              var r = n.createElement("mrow");
              if (n.replaceNode(this.fencedMml, r), this.fencedMmlNodes.forEach(function (t) {
                return r.appendChild(t);
              }), r.insertBefore(t, this.fencedMml), r.appendChild(e), !r.parentNode) {
                var _t31 = n.createElement("mrow");
                for (; r.childNodes.length > 0;) _t31.appendChild(r.childNodes[0]);
                r.appendChild(_t31), r = _t31;
              }
              return r;
            }
          }, {
            key: "fullFence",
            value: function fullFence(t) {
              var e = this.fencedMml.parentNode;
              var r = t;
              for (; r.parentNode && r.parentNode !== e;) r = r.parentNode;
              return r;
            }
          }, {
            key: "cleanupParents_",
            value: function cleanupParents_() {
              this.parentCleanup.forEach(function (t) {
                var e = t.childNodes[1].getAttribute(l.Attribute.PARENT);
                t.childNodes[0].setAttribute(l.Attribute.PARENT, e);
              });
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !(!t.mathmlTree || !t.fencePointer || t.mathmlTree.getAttribute("data-semantic-type"));
            }
          }, {
            key: "makeEmptyNode_",
            value: function makeEmptyNode_(t) {
              var e = n.createElement("mrow"),
                r = new o.SemanticNode(t);
              return r.type = "empty", r.mathmlTree = e, r;
            }
          }, {
            key: "fencedMap_",
            value: function fencedMap_(t, e) {
              e[t.id] = t.mathmlTree, t.embellished && c.fencedMap_(t.childNodes[0], e);
            }
          }]);
          return c;
        }(i.AbstractEnrichCase);
        e.CaseEmbellished = c;
      },
      6265: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseLimit = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$AbstractEnrichCase3) {
          _inherits(Q, _o$AbstractEnrichCase3);
          function Q(t) {
            var _this9;
            _classCallCheck(this, Q);
            _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t)), _this9.mml = t.mathmlTree;
            return _this9;
          }
          _createClass(Q, [{
            key: "getMathml",
            value: function getMathml() {
              var t = this.semantic.childNodes;
              return "limboth" !== this.semantic.type && this.mml.childNodes.length >= 3 && (this.mml = i.introduceNewLayer([this.mml], this.semantic)), (0, a.setAttributes)(this.mml, this.semantic), t[0].mathmlTree || (t[0].mathmlTree = this.semantic.mathmlTree), t.forEach(Q.walkTree_), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree || !t.childNodes.length) return !1;
              var e = n.tagName(t.mathmlTree),
                r = t.type;
              return ("limupper" === r || "limlower" === r) && ("MSUBSUP" === e || "MUNDEROVER" === e) || "limboth" === r && ("MSUB" === e || "MUNDER" === e || "MSUP" === e || "MOVER" === e);
            }
          }, {
            key: "walkTree_",
            value: function walkTree_(t) {
              t && i.walkTree(t);
            }
          }]);
          return Q;
        }(o.AbstractEnrichCase);
        e.CaseLimit = Q;
      },
      6514: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseLine = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase) {
          _inherits(a, _n$AbstractEnrichCase);
          function a(t) {
            var _this10;
            _classCallCheck(this, a);
            _this10 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t)), _this10.mml = t.mathmlTree;
            return _this10;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              return this.semantic.contentNodes.length && o.walkTree(this.semantic.contentNodes[0]), this.semantic.childNodes.length && o.walkTree(this.semantic.childNodes[0]), (0, i.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && "line" === t.type;
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseLine = a;
      },
      6839: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseMultiindex = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$AbstractEnrichCase4) {
          _inherits(Q, _o$AbstractEnrichCase4);
          function Q(t) {
            var _this11;
            _classCallCheck(this, Q);
            _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t)), _this11.mml = t.mathmlTree;
            return _this11;
          }
          _createClass(Q, [{
            key: "completeMultiscript",
            value: function completeMultiscript(t, e) {
              var _this12 = this;
              var r = n.toArray(this.mml.childNodes).slice(1);
              var o = 0;
              var s = function s(t) {
                var _loop3 = function _loop3(_e22) {
                  var t = r[o];
                  if (t && _e22 === parseInt(i.getInnerNode(t).getAttribute(a.Attribute.ID))) i.getInnerNode(t).setAttribute(a.Attribute.PARENT, _this12.semantic.id.toString()), o++;else {
                    var _r36 = _this12.semantic.querySelectorAll(function (t) {
                      return t.id === _e22;
                    });
                    _this12.mml.insertBefore(Q.createNone_(_r36[0]), t || null);
                  }
                };
                for (var _e22, _n158 = 0; _e22 = t[_n158]; _n158++) {
                  _loop3(_e22);
                }
              };
              s(t), r[o] && "MPRESCRIPTS" !== n.tagName(r[o]) ? this.mml.insertBefore(r[o], n.createElement("mprescripts")) : o++, s(e);
            }
          }], [{
            key: "multiscriptIndex",
            value: function multiscriptIndex(t) {
              return "punctuated" === t.type && "dummy" === t.contentNodes[0].role ? i.collapsePunctuated(t) : (i.walkTree(t), t.id);
            }
          }, {
            key: "createNone_",
            value: function createNone_(t) {
              var e = n.createElement("none");
              return t && (0, a.setAttributes)(e, t), e.setAttribute(a.Attribute.ADDED, "true"), e;
            }
          }]);
          return Q;
        }(o.AbstractEnrichCase);
        e.CaseMultiindex = Q;
      },
      7014: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseMultiscripts = void 0;
        var n = r(5740),
          o = r(5656),
          i = r(6839),
          a = r(5452),
          Q = r(2298);
        var s = /*#__PURE__*/function (_i$CaseMultiindex) {
          _inherits(s, _i$CaseMultiindex);
          _createClass(s, null, [{
            key: "test",
            value: function test(t) {
              if (!t.mathmlTree) return !1;
              return "MMULTISCRIPTS" === n.tagName(t.mathmlTree) && ("superscript" === t.type || "subscript" === t.type);
            }
          }]);
          function s(t) {
            _classCallCheck(this, s);
            return _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, t));
          }
          _createClass(s, [{
            key: "getMathml",
            value: function getMathml() {
              var t, e, r;
              if ((0, Q.setAttributes)(this.mml, this.semantic), this.semantic.childNodes[0] && "subsup" === this.semantic.childNodes[0].role) {
                var _n159 = this.semantic.childNodes[0];
                t = _n159.childNodes[0], e = i.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]), r = i.CaseMultiindex.multiscriptIndex(_n159.childNodes[1]);
                var _s3 = [this.semantic.id, [_n159.id, t.id, r], e];
                a.addCollapsedAttribute(this.mml, _s3), this.mml.setAttribute(Q.Attribute.TYPE, _n159.role), this.completeMultiscript(o.SemanticSkeleton.interleaveIds(r, e), []);
              } else {
                t = this.semantic.childNodes[0], e = i.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]);
                var _r37 = [this.semantic.id, t.id, e];
                a.addCollapsedAttribute(this.mml, _r37);
              }
              var n = o.SemanticSkeleton.collapsedLeafs(r || [], e),
                s = a.walkTree(t);
              return a.getInnerNode(s).setAttribute(Q.Attribute.PARENT, this.semantic.id.toString()), n.unshift(t.id), this.mml.setAttribute(Q.Attribute.CHILDREN, n.join(",")), this.mml;
            }
          }]);
          return s;
        }(i.CaseMultiindex);
        e.CaseMultiscripts = s;
      },
      3416: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseProof = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase2) {
          _inherits(a, _n$AbstractEnrichCase2);
          function a(t) {
            var _this13;
            _classCallCheck(this, a);
            _this13 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t)), _this13.mml = t.mathmlTree;
            return _this13;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              return this.semantic.childNodes.length ? (this.semantic.contentNodes.forEach(function (t) {
                o.walkTree(t), (0, i.setAttributes)(t.mathmlTree, t);
              }), this.semantic.childNodes.forEach(function (t) {
                o.walkTree(t);
              }), (0, i.setAttributes)(this.mml, this.semantic), this.mml.getAttribute("data-semantic-id") === this.mml.getAttribute("data-semantic-parent") && this.mml.removeAttribute("data-semantic-parent"), this.mml) : this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && ("inference" === t.type || "premises" === t.type);
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseProof = a;
      },
      5699: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseTable = void 0;
        var n = r(5740),
          o = r(9268),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$AbstractEnrichCase5) {
          _inherits(Q, _o$AbstractEnrichCase5);
          function Q(t) {
            var _this14;
            _classCallCheck(this, Q);
            _this14 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t)), _this14.inner = [], _this14.mml = t.mathmlTree;
            return _this14;
          }
          _createClass(Q, [{
            key: "getMathml",
            value: function getMathml() {
              var t = i.cloneContentNode(this.semantic.contentNodes[0]),
                e = this.semantic.contentNodes[1] ? i.cloneContentNode(this.semantic.contentNodes[1]) : null;
              if (this.inner = this.semantic.childNodes.map(i.walkTree), this.mml) {
                if ("MFENCED" === n.tagName(this.mml)) {
                  var _r38 = this.mml.childNodes;
                  this.mml.insertBefore(t, _r38[0] || null), e && this.mml.appendChild(e), this.mml = i.rewriteMfenced(this.mml);
                } else {
                  var _r39 = [t, this.mml];
                  e && _r39.push(e), this.mml = i.introduceNewLayer(_r39, this.semantic);
                }
              } else this.mml = i.introduceNewLayer([t].concat(this.inner, [e]), this.semantic);
              return (0, a.setAttributes)(this.mml, this.semantic), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return "matrix" === t.type || "vector" === t.type || "cases" === t.type;
            }
          }]);
          return Q;
        }(o.AbstractEnrichCase);
        e.CaseTable = Q;
      },
      6887: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseTensor = void 0;
        var n = r(5656),
          o = r(6839),
          i = r(5452),
          a = r(2298);
        var Q = /*#__PURE__*/function (_o$CaseMultiindex) {
          _inherits(Q, _o$CaseMultiindex);
          _createClass(Q, null, [{
            key: "test",
            value: function test(t) {
              return !!t.mathmlTree && "tensor" === t.type;
            }
          }]);
          function Q(t) {
            _classCallCheck(this, Q);
            return _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t));
          }
          _createClass(Q, [{
            key: "getMathml",
            value: function getMathml() {
              i.walkTree(this.semantic.childNodes[0]);
              var t = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[1]),
                e = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[2]),
                r = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[3]),
                Q = o.CaseMultiindex.multiscriptIndex(this.semantic.childNodes[4]);
              (0, a.setAttributes)(this.mml, this.semantic);
              var s = [this.semantic.id, this.semantic.childNodes[0].id, t, e, r, Q];
              i.addCollapsedAttribute(this.mml, s);
              var T = n.SemanticSkeleton.collapsedLeafs(t, e, r, Q);
              return T.unshift(this.semantic.childNodes[0].id), this.mml.setAttribute(a.Attribute.CHILDREN, T.join(",")), this.completeMultiscript(n.SemanticSkeleton.interleaveIds(r, Q), n.SemanticSkeleton.interleaveIds(t, e)), this.mml;
            }
          }]);
          return Q;
        }(o.CaseMultiindex);
        e.CaseTensor = Q;
      },
      9236: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CaseText = void 0;
        var n = r(9268),
          o = r(5452),
          i = r(2298);
        var a = /*#__PURE__*/function (_n$AbstractEnrichCase3) {
          _inherits(a, _n$AbstractEnrichCase3);
          function a(t) {
            var _this15;
            _classCallCheck(this, a);
            _this15 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t)), _this15.mml = t.mathmlTree;
            return _this15;
          }
          _createClass(a, [{
            key: "getMathml",
            value: function getMathml() {
              var t = [],
                e = o.collapsePunctuated(this.semantic, t);
              return this.mml = o.introduceNewLayer(t, this.semantic), (0, i.setAttributes)(this.mml, this.semantic), this.mml.removeAttribute(i.Attribute.CONTENT), o.addCollapsedAttribute(this.mml, e), this.mml;
            }
          }], [{
            key: "test",
            value: function test(t) {
              return "punctuated" === t.type && ("text" === t.role || t.contentNodes.every(function (t) {
                return "dummy" === t.role;
              }));
            }
          }]);
          return a;
        }(n.AbstractEnrichCase);
        e.CaseText = a;
      },
      5714: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.prepareMmlString = e.testTranslation__ = e.semanticMathml = e.semanticMathmlSync = e.semanticMathmlNode = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(5897),
          a = r(1414),
          Q = r(5452),
          s = r(2298);
        function T(t) {
          var e = o.cloneNode(t),
            r = a.getTree(e);
          return Q.enrich(e, r);
        }
        function l(t) {
          return T(o.parseInput(t));
        }
        function c(t) {
          return t.match(/^<math/) || (t = "<math>" + t), t.match(/\/math>$/) || (t += "</math>"), t;
        }
        r(1513), e.semanticMathmlNode = T, e.semanticMathmlSync = l, e.semanticMathml = function (t, e) {
          i.EnginePromise.getall().then(function () {
            var r = o.parseInput(t);
            e(T(r));
          });
        }, e.testTranslation__ = function (t) {
          n.Debugger.getInstance().init();
          var e = l(c(t)).toString();
          return (0, s.removeAttributePrefix)(e), n.Debugger.getInstance().exit(), e;
        }, e.prepareMmlString = c;
      },
      2298: function _(t, e) {
        var r;
        function n(t) {
          return t.map(function (t) {
            return t.id;
          }).join(",");
        }
        function o(t, e) {
          var n = [];
          "mglyph" === e.role && n.push("image"), e.attributes.href && n.push("link"), n.length && t.setAttribute(r.POSTFIX, n.join(" "));
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.addPrefix = e.removeAttributePrefix = e.setPostfix = e.setAttributes = e.makeIdList = e.EnrichAttributes = e.Attribute = e.Prefix = void 0, e.Prefix = "data-semantic-", function (t) {
          t.ADDED = "data-semantic-added", t.ALTERNATIVE = "data-semantic-alternative", t.CHILDREN = "data-semantic-children", t.COLLAPSED = "data-semantic-collapsed", t.CONTENT = "data-semantic-content", t.EMBELLISHED = "data-semantic-embellished", t.FENCEPOINTER = "data-semantic-fencepointer", t.FONT = "data-semantic-font", t.ID = "data-semantic-id", t.ANNOTATION = "data-semantic-annotation", t.OPERATOR = "data-semantic-operator", t.OWNS = "data-semantic-owns", t.PARENT = "data-semantic-parent", t.POSTFIX = "data-semantic-postfix", t.PREFIX = "data-semantic-prefix", t.ROLE = "data-semantic-role", t.SPEECH = "data-semantic-speech", t.STRUCTURE = "data-semantic-structure", t.TYPE = "data-semantic-type";
        }(r = e.Attribute || (e.Attribute = {})), e.EnrichAttributes = [r.ADDED, r.ALTERNATIVE, r.CHILDREN, r.COLLAPSED, r.CONTENT, r.EMBELLISHED, r.FENCEPOINTER, r.FONT, r.ID, r.ANNOTATION, r.OPERATOR, r.OWNS, r.PARENT, r.POSTFIX, r.PREFIX, r.ROLE, r.SPEECH, r.STRUCTURE, r.TYPE], e.makeIdList = n, e.setAttributes = function (t, i) {
          t.setAttribute(r.TYPE, i.type);
          var a = i.allAttributes();
          for (var _r40, _n160 = 0; _r40 = a[_n160]; _n160++) t.setAttribute(e.Prefix + _r40[0].toLowerCase(), _r40[1]);
          i.childNodes.length && t.setAttribute(r.CHILDREN, n(i.childNodes)), i.contentNodes.length && t.setAttribute(r.CONTENT, n(i.contentNodes)), i.parent && t.setAttribute(r.PARENT, i.parent.id.toString()), o(t, i);
        }, e.setPostfix = o, e.removeAttributePrefix = function (t) {
          return t.toString().replace(new RegExp(e.Prefix, "g"), "");
        }, e.addPrefix = function (t) {
          return e.Prefix + t;
        };
      },
      3532: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.factory = e.getCase = void 0, e.getCase = function (t) {
          for (var r, n = 0; r = e.factory[n]; n++) if (r.test(t)) return r.constr(t);
          return null;
        }, e.factory = [];
      },
      1513: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(6061),
          o = r(5765),
          i = r(7251),
          a = r(6265),
          Q = r(6514),
          s = r(7014),
          T = r(3416),
          l = r(5699),
          c = r(6887),
          u = r(9236);
        r(3532).factory.push({
          test: a.CaseLimit.test,
          constr: function constr(t) {
            return new a.CaseLimit(t);
          }
        }, {
          test: i.CaseEmbellished.test,
          constr: function constr(t) {
            return new i.CaseEmbellished(t);
          }
        }, {
          test: o.CaseDoubleScript.test,
          constr: function constr(t) {
            return new o.CaseDoubleScript(t);
          }
        }, {
          test: c.CaseTensor.test,
          constr: function constr(t) {
            return new c.CaseTensor(t);
          }
        }, {
          test: s.CaseMultiscripts.test,
          constr: function constr(t) {
            return new s.CaseMultiscripts(t);
          }
        }, {
          test: Q.CaseLine.test,
          constr: function constr(t) {
            return new Q.CaseLine(t);
          }
        }, {
          test: n.CaseBinomial.test,
          constr: function constr(t) {
            return new n.CaseBinomial(t);
          }
        }, {
          test: T.CaseProof.test,
          constr: function constr(t) {
            return new T.CaseProof(t);
          }
        }, {
          test: l.CaseTable.test,
          constr: function constr(t) {
            return new l.CaseTable(t);
          }
        }, {
          test: u.CaseText.test,
          constr: function constr(t) {
            return new u.CaseText(t);
          }
        });
      },
      5452: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.printNodeList__ = e.collapsePunctuated = e.formattedOutput_ = e.formattedOutput = e.getInnerNode = e.setOperatorAttribute_ = e.createInvisibleOperator_ = e.rewriteMfenced = e.cloneContentNode = e.addCollapsedAttribute = e.parentNode_ = e.isIgnorable_ = e.unitChild_ = e.descendNode_ = e.ascendNewNode = e.validLca_ = e.pathToRoot_ = e.attachedElement_ = e.prunePath_ = e.mathmlLca_ = e.lcaType = e.functionApplication_ = e.isDescendant_ = e.insertNewChild_ = e.mergeChildren_ = e.collectChildNodes_ = e.collateChildNodes_ = e.childrenSubset_ = e.moveSemanticAttributes_ = e.introduceLayerAboveLca = e.introduceNewLayer = e.walkTree = e.enrich = e.SETTINGS = void 0;
        var n = r(2057),
          o = r(5740),
          i = r(5897),
          a = r(3588),
          Q = r(7516),
          s = r(5656),
          T = r(4795),
          l = r(2298),
          c = r(3532);
        function u(t) {
          var e = (0, c.getCase)(t);
          var r;
          if (e) return r = e.getMathml(), V(r);
          if (1 === t.mathml.length) return n.Debugger.getInstance().output("Walktree Case 0"), r = t.mathml[0], l.setAttributes(r, t), t.childNodes.length && (n.Debugger.getInstance().output("Walktree Case 0.1"), t.childNodes.forEach(function (t) {
            "empty" === t.type && r.appendChild(u(t));
          })), V(r);
          var o = t.contentNodes.map(N);
          I(t, o);
          var i = t.childNodes.map(u),
            a = s.SemanticSkeleton.combineContentChildren(t, o, i);
          if (r = t.mathmlTree, null === r) n.Debugger.getInstance().output("Walktree Case 1"), r = p(a, t);else {
            var _t32 = x(a);
            n.Debugger.getInstance().output("Walktree Case 2"), _t32 ? (n.Debugger.getInstance().output("Walktree Case 2.1"), r = _t32.parentNode) : (n.Debugger.getInstance().output("Walktree Case 2.2"), r = R(r));
          }
          return r = P(r), y(r, a, t), l.setAttributes(r, t), V(r);
        }
        function p(t, e) {
          var r = _(t);
          var i = r.node;
          var a = r.type;
          if (a !== H.VALID || !T.hasEmptyTag(i)) if (n.Debugger.getInstance().output("Walktree Case 1.1"), i = o.createElement("mrow"), a === H.PRUNED) n.Debugger.getInstance().output("Walktree Case 1.1.0"), i = h(i, r.node, t);else if (t[0]) {
            n.Debugger.getInstance().output("Walktree Case 1.1.1");
            var _e23 = x(t),
              _r41 = f(_e23.parentNode, t);
            o.replaceNode(_e23, i), _r41.forEach(function (t) {
              i.appendChild(t);
            });
          }
          return e.mathmlTree || (e.mathmlTree = i), i;
        }
        function h(t, e, r) {
          var i = E(e);
          if (T.hasMathTag(i)) {
            n.Debugger.getInstance().output("Walktree Case 1.1.0.0"), d(i, t), o.toArray(i.childNodes).forEach(function (e) {
              t.appendChild(e);
            });
            var _e24 = t;
            t = i, i = _e24;
          }
          var a = r.indexOf(e);
          return r[a] = i, o.replaceNode(i, t), t.appendChild(i), r.forEach(function (e) {
            t.appendChild(e);
          }), t;
        }
        function d(t, e) {
          var _iterator7 = _createForOfIteratorHelper(l.EnrichAttributes),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _r42 = _step7.value;
              t.hasAttribute(_r42) && (e.setAttribute(_r42, t.getAttribute(_r42)), t.removeAttribute(_r42));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
        function f(t, e) {
          var r = o.toArray(t.childNodes);
          var n = 1 / 0,
            i = -1 / 0;
          return e.forEach(function (t) {
            var e = r.indexOf(t);
            -1 !== e && (n = Math.min(n, e), i = Math.max(i, e));
          }), r.slice(n, i + 1);
        }
        function m(t, e, r) {
          var n = [];
          var i = o.toArray(t.childNodes),
            a = !1;
          for (; i.length;) {
            var _t33 = i.shift();
            if (_t33.hasAttribute(l.Attribute.TYPE)) {
              n.push(_t33);
              continue;
            }
            var _e25 = L(_t33);
            0 !== _e25.length && (1 !== _e25.length ? (a ? _t33.setAttribute("AuxiliaryImplicit", !0) : a = !0, i = _e25.concat(i)) : n.push(_t33));
          }
          var Q = [],
            s = r.childNodes.map(function (t) {
              return t.mathmlTree;
            });
          for (; s.length;) {
            var _t34 = s.pop();
            if (_t34) {
              if (-1 !== n.indexOf(_t34)) break;
              -1 !== e.indexOf(_t34) && Q.unshift(_t34);
            }
          }
          return n.concat(Q);
        }
        function L(t) {
          var e = [];
          var r = o.toArray(t.childNodes);
          for (; r.length;) {
            var _t35 = r.shift();
            _t35.nodeType === o.NodeType.ELEMENT_NODE && (_t35.hasAttribute(l.Attribute.TYPE) ? e.push(_t35) : r = o.toArray(_t35.childNodes).concat(r));
          }
          return e;
        }
        function y(t, e, r) {
          var n = "implicit" === r.role && Q.flags.combine_juxtaposition ? m(t, e, r) : o.toArray(t.childNodes);
          if (!n.length) return void e.forEach(function (e) {
            t.appendChild(e);
          });
          var i = 0;
          for (; e.length;) {
            var _r43 = e[0];
            n[i] === _r43 || b(n[i], _r43) ? (e.shift(), i++) : n[i] && -1 === e.indexOf(n[i]) ? i++ : (v(_r43, t) || g(t, n[i], _r43), e.shift());
          }
        }
        function g(t, e, r) {
          if (!e) return void t.insertBefore(r, null);
          var n = e,
            o = w(n);
          for (; o && o.firstChild === n && !n.hasAttribute("AuxiliaryImplicit") && o !== t;) n = o, o = w(n);
          o && (o.insertBefore(r, n), n.removeAttribute("AuxiliaryImplicit"));
        }
        function v(t, e) {
          if (!t) return !1;
          do {
            if ((t = t.parentNode) === e) return !0;
          } while (t);
          return !1;
        }
        function b(t, e) {
          var r = a.functionApplication();
          if (t && e && t.textContent && e.textContent && t.textContent === r && e.textContent === r && "true" === e.getAttribute(l.Attribute.ADDED)) {
            for (var _r44, _n161 = 0; _r44 = t.attributes[_n161]; _n161++) e.hasAttribute(_r44.nodeName) || e.setAttribute(_r44.nodeName, _r44.nodeValue);
            return o.replaceNode(t, e), !0;
          }
          return !1;
        }
        var H;
        function _(t) {
          var e = x(t);
          if (!e) return {
            type: H.INVALID,
            node: null
          };
          var r = x(t.slice().reverse());
          if (e === r) return {
            type: H.VALID,
            node: e
          };
          var n = O(e),
            o = M(n, t),
            i = O(r, function (t) {
              return -1 !== o.indexOf(t);
            }),
            a = i[0],
            Q = o.indexOf(a);
          return -1 === Q ? {
            type: H.INVALID,
            node: null
          } : {
            type: o.length !== n.length ? H.PRUNED : S(o[Q + 1], i[1]) ? H.VALID : H.INVALID,
            node: a
          };
        }
        function M(t, e) {
          var r = 0;
          for (; t[r] && -1 === e.indexOf(t[r]);) r++;
          return t.slice(0, r + 1);
        }
        function x(t) {
          var e = 0,
            r = null;
          for (; !r && e < t.length;) t[e].parentNode && (r = t[e]), e++;
          return r;
        }
        function O(t, e) {
          var r = e || function (t) {
              return !1;
            },
            n = [t];
          for (; !r(t) && !T.hasMathTag(t) && t.parentNode;) t = w(t), n.unshift(t);
          return n;
        }
        function S(t, e) {
          return !(!t || !e || t.previousSibling || e.nextSibling);
        }
        function V(t) {
          for (; !T.hasMathTag(t) && A(t);) t = w(t);
          return t;
        }
        function E(t) {
          var e = o.toArray(t.childNodes);
          if (!e) return t;
          var r = e.filter(function (t) {
            return t.nodeType === o.NodeType.ELEMENT_NODE && !T.hasIgnoreTag(t);
          });
          return 1 === r.length && T.hasEmptyTag(r[0]) && !r[0].hasAttribute(l.Attribute.TYPE) ? E(r[0]) : t;
        }
        function A(t) {
          var e = w(t);
          return !(!e || !T.hasEmptyTag(e)) && o.toArray(e.childNodes).every(function (e) {
            return e === t || C(e);
          });
        }
        function C(t) {
          if (t.nodeType !== o.NodeType.ELEMENT_NODE) return !0;
          if (!t || T.hasIgnoreTag(t)) return !0;
          var e = o.toArray(t.childNodes);
          return !(!T.hasEmptyTag(t) && e.length || T.hasDisplayTag(t) || t.hasAttribute(l.Attribute.TYPE) || T.isOrphanedGlyph(t)) && o.toArray(t.childNodes).every(C);
        }
        function w(t) {
          return t.parentNode;
        }
        function N(t) {
          if (t.mathml.length) return u(t);
          var r = e.SETTINGS.implicit ? k(t) : o.createElement("mrow");
          return t.mathml = [r], r;
        }
        function P(t) {
          if ("MFENCED" !== o.tagName(t)) return t;
          var e = o.createElement("mrow");
          for (var _r45, _n162 = 0; _r45 = t.attributes[_n162]; _n162++) -1 === ["open", "close", "separators"].indexOf(_r45.name) && e.setAttribute(_r45.name, _r45.value);
          return o.toArray(t.childNodes).forEach(function (t) {
            e.appendChild(t);
          }), o.replaceNode(t, e), e;
        }
        function k(t) {
          var e = o.createElement("mo"),
            r = o.createTextNode(t.textContent);
          return e.appendChild(r), l.setAttributes(e, t), e.setAttribute(l.Attribute.ADDED, "true"), e;
        }
        function I(t, e) {
          var r = t.type + (t.textContent ? "," + t.textContent : "");
          e.forEach(function (t) {
            R(t).setAttribute(l.Attribute.OPERATOR, r);
          });
        }
        function R(t) {
          var e = o.toArray(t.childNodes);
          if (!e) return t;
          var r = e.filter(function (t) {
              return !C(t);
            }),
            n = [];
          for (var _t36, _e26 = 0; _t36 = r[_e26]; _e26++) if (T.hasEmptyTag(_t36)) {
            var _e27 = R(_t36);
            _e27 && _e27 !== _t36 && n.push(_e27);
          } else n.push(_t36);
          return 1 === n.length ? n[0] : t;
        }
        function D(t, e, r, n) {
          var o = n || !1;
          j(t, "Original MathML", o), j(r, "Semantic Tree", o), j(e, "Semantically enriched MathML", o);
        }
        function j(t, e, r) {
          var n = o.formatXml(t.toString());
          r ? console.info(e + ":\n```html\n" + l.removeAttributePrefix(n) + "\n```\n") : console.info(n);
        }
        e.SETTINGS = {
          collapsed: !0,
          implicit: !0
        }, e.enrich = function (t, e) {
          var r = o.cloneNode(t);
          return u(e.root), i.default.getInstance().structure && t.setAttribute(l.Attribute.STRUCTURE, s.SemanticSkeleton.fromStructure(t, e).toString()), n.Debugger.getInstance().generateOutput(function () {
            return D(r, t, e, !0), [];
          }), t;
        }, e.walkTree = u, e.introduceNewLayer = p, e.introduceLayerAboveLca = h, e.moveSemanticAttributes_ = d, e.childrenSubset_ = f, e.collateChildNodes_ = m, e.collectChildNodes_ = L, e.mergeChildren_ = y, e.insertNewChild_ = g, e.isDescendant_ = v, e.functionApplication_ = b, function (t) {
          t.VALID = "valid", t.INVALID = "invalid", t.PRUNED = "pruned";
        }(H = e.lcaType || (e.lcaType = {})), e.mathmlLca_ = _, e.prunePath_ = M, e.attachedElement_ = x, e.pathToRoot_ = O, e.validLca_ = S, e.ascendNewNode = V, e.descendNode_ = E, e.unitChild_ = A, e.isIgnorable_ = C, e.parentNode_ = w, e.addCollapsedAttribute = function (t, e) {
          var r = new s.SemanticSkeleton(e);
          t.setAttribute(l.Attribute.COLLAPSED, r.toString());
        }, e.cloneContentNode = N, e.rewriteMfenced = P, e.createInvisibleOperator_ = k, e.setOperatorAttribute_ = I, e.getInnerNode = R, e.formattedOutput = D, e.formattedOutput_ = j, e.collapsePunctuated = function (t, e) {
          var r = !!e,
            n = e || [],
            o = t.parent,
            i = t.contentNodes.map(function (t) {
              return t.id;
            });
          i.unshift("c");
          var a = [t.id, i];
          for (var _e28, _i12 = 0; _e28 = t.childNodes[_i12]; _i12++) {
            var _t37 = u(_e28);
            n.push(_t37);
            var _i13 = R(_t37);
            o && !r && _i13.setAttribute(l.Attribute.PARENT, o.id.toString()), a.push(_e28.id);
          }
          return a;
        }, e.printNodeList__ = function (t, e) {
          console.info(t), o.toArray(e).forEach(function (t) {
            console.info(t.toString());
          }), console.info("<<<<<<<<<<<<<<<<<");
        };
      },
      5105: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractHighlighter = void 0;
        var n = r(5274),
          o = r(2298);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.color = null, this.mactionName = "", this.currentHighlights = [];
          }
          _createClass(i, [{
            key: "highlight",
            value: function highlight(t) {
              var _this16 = this;
              this.currentHighlights.push(t.map(function (t) {
                var e = _this16.highlightNode(t);
                return _this16.setHighlighted(t), e;
              }));
            }
          }, {
            key: "highlightAll",
            value: function highlightAll(t) {
              var e = this.getMactionNodes(t);
              for (var _t38, _r46 = 0; _t38 = e[_r46]; _r46++) this.highlight([_t38]);
            }
          }, {
            key: "unhighlight",
            value: function unhighlight() {
              var _this17 = this;
              var t = this.currentHighlights.pop();
              t && t.forEach(function (t) {
                _this17.isHighlighted(t.node) && (_this17.unhighlightNode(t), _this17.unsetHighlighted(t.node));
              });
            }
          }, {
            key: "unhighlightAll",
            value: function unhighlightAll() {
              for (; this.currentHighlights.length > 0;) this.unhighlight();
            }
          }, {
            key: "setColor",
            value: function setColor(t) {
              this.color = t;
            }
          }, {
            key: "colorString",
            value: function colorString() {
              return this.color.rgba();
            }
          }, {
            key: "addEvents",
            value: function addEvents(t, e) {
              var r = this.getMactionNodes(t);
              for (var _t39, _n163 = 0; _t39 = r[_n163]; _n163++) for (var _r47 in e) _t39.addEventListener(_r47, e[_r47]);
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByClassName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              var e = t.className || t.getAttribute("class");
              return !!e && !!e.match(new RegExp(this.mactionName));
            }
          }, {
            key: "isHighlighted",
            value: function isHighlighted(t) {
              return t.hasAttribute(i.ATTR);
            }
          }, {
            key: "setHighlighted",
            value: function setHighlighted(t) {
              t.setAttribute(i.ATTR, "true");
            }
          }, {
            key: "unsetHighlighted",
            value: function unsetHighlighted(t) {
              t.removeAttribute(i.ATTR);
            }
          }, {
            key: "colorizeAll",
            value: function colorizeAll(t) {
              var _this18 = this;
              n.evalXPath(".//*[@".concat(o.Attribute.ID, "]"), t).forEach(function (t) {
                return _this18.colorize(t);
              });
            }
          }, {
            key: "uncolorizeAll",
            value: function uncolorizeAll(t) {
              var _this19 = this;
              n.evalXPath(".//*[@".concat(o.Attribute.ID, "]"), t).forEach(function (t) {
                return _this19.uncolorize(t);
              });
            }
          }, {
            key: "colorize",
            value: function colorize(t) {
              var e = (0, o.addPrefix)("foreground");
              t.hasAttribute(e) && (t.setAttribute(e + "-old", t.style.color), t.style.color = t.getAttribute(e));
            }
          }, {
            key: "uncolorize",
            value: function uncolorize(t) {
              var e = (0, o.addPrefix)("foreground") + "-old";
              t.hasAttribute(e) && (t.style.color = t.getAttribute(e));
            }
          }]);
          return i;
        }();
        e.AbstractHighlighter = i, i.ATTR = "sre-highlight";
      },
      6937: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ChtmlHighlighter = void 0;
        var n = r(933);
        var o = /*#__PURE__*/function (_n$CssHighlighter) {
          _inherits(o, _n$CssHighlighter);
          function o() {
            _classCallCheck(this, o);
            return _possibleConstructorReturn(this, _getPrototypeOf(o).call(this));
          }
          _createClass(o, [{
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName.toUpperCase() === this.mactionName.toUpperCase();
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }]);
          return o;
        }(n.CssHighlighter);
        e.ChtmlHighlighter = o;
      },
      8396: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ContrastPicker = e.ColorPicker = void 0;
        var r = {
          red: {
            red: 255,
            green: 0,
            blue: 0
          },
          green: {
            red: 0,
            green: 255,
            blue: 0
          },
          blue: {
            red: 0,
            green: 0,
            blue: 255
          },
          yellow: {
            red: 255,
            green: 255,
            blue: 0
          },
          cyan: {
            red: 0,
            green: 255,
            blue: 255
          },
          magenta: {
            red: 255,
            green: 0,
            blue: 255
          },
          white: {
            red: 255,
            green: 255,
            blue: 255
          },
          black: {
            red: 0,
            green: 0,
            blue: 0
          }
        };
        function n(t, e) {
          var n = t || {
            color: e
          };
          var o = Object.prototype.hasOwnProperty.call(n, "color") ? r[n.color] : n;
          return o || (o = r[e]), o.alpha = Object.prototype.hasOwnProperty.call(n, "alpha") ? n.alpha : 1, function (t) {
            var e = function e(t) {
              return t = Math.max(t, 0), t = Math.min(255, t), Math.round(t);
            };
            return t.red = e(t.red), t.green = e(t.green), t.blue = e(t.blue), t.alpha = Math.max(t.alpha, 0), t.alpha = Math.min(1, t.alpha), t;
          }(o);
        }
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.foreground = n(e, o.DEFAULT_FOREGROUND_), this.background = n(t, o.DEFAULT_BACKGROUND_);
          }
          _createClass(o, [{
            key: "rgba",
            value: function rgba() {
              var t = function t(_t40) {
                return "rgba(" + _t40.red + "," + _t40.green + "," + _t40.blue + "," + _t40.alpha + ")";
              };
              return {
                background: t(this.background),
                foreground: t(this.foreground)
              };
            }
          }, {
            key: "rgb",
            value: function rgb() {
              var t = function t(_t41) {
                return "rgb(" + _t41.red + "," + _t41.green + "," + _t41.blue + ")";
              };
              return {
                background: t(this.background),
                alphaback: this.background.alpha.toString(),
                foreground: t(this.foreground),
                alphafore: this.foreground.alpha.toString()
              };
            }
          }, {
            key: "hex",
            value: function hex() {
              var t = function t(_t42) {
                return "#" + o.toHex(_t42.red) + o.toHex(_t42.green) + o.toHex(_t42.blue);
              };
              return {
                background: t(this.background),
                alphaback: this.background.alpha.toString(),
                foreground: t(this.foreground),
                alphafore: this.foreground.alpha.toString()
              };
            }
          }], [{
            key: "toHex",
            value: function toHex(t) {
              var e = t.toString(16);
              return 1 === e.length ? "0" + e : e;
            }
          }]);
          return o;
        }();
        e.ColorPicker = o, o.DEFAULT_BACKGROUND_ = "blue", o.DEFAULT_FOREGROUND_ = "black";
        e.ContrastPicker = /*#__PURE__*/function () {
          function _class5() {
            _classCallCheck(this, _class5);
            this.hue = 10, this.sat = 100, this.light = 50, this.incr = 50;
          }
          _createClass(_class5, [{
            key: "generate",
            value: function generate() {
              return e = function (t, e, r, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10) {
                e = e > 1 ? e / 100 : e, r = r > 1 ? r / 100 : r;
                var n = (1 - Math.abs(2 * r - 1)) * e,
                  o = n * (1 - Math.abs(t / 60 % 2 - 1)),
                  i = r - n / 2;
                var a = 0,
                  Q = 0,
                  s = 0;
                return 0 <= t && t < 60 ? (_ref5 = [n, o, 0], a = _ref5[0], Q = _ref5[1], s = _ref5[2], _ref5) : 60 <= t && t < 120 ? (_ref6 = [o, n, 0], a = _ref6[0], Q = _ref6[1], s = _ref6[2], _ref6) : 120 <= t && t < 180 ? (_ref7 = [0, n, o], a = _ref7[0], Q = _ref7[1], s = _ref7[2], _ref7) : 180 <= t && t < 240 ? (_ref8 = [0, o, n], a = _ref8[0], Q = _ref8[1], s = _ref8[2], _ref8) : 240 <= t && t < 300 ? (_ref9 = [o, 0, n], a = _ref9[0], Q = _ref9[1], s = _ref9[2], _ref9) : 300 <= t && t < 360 && (_ref10 = [n, 0, o], a = _ref10[0], Q = _ref10[1], s = _ref10[2], _ref10), {
                  red: a + i,
                  green: Q + i,
                  blue: s + i
                };
              }(this.hue, this.sat, this.light), "rgb(" + (t = {
                red: Math.round(255 * e.red),
                green: Math.round(255 * e.green),
                blue: Math.round(255 * e.blue)
              }).red + "," + t.green + "," + t.blue + ")";
              var t, e;
            }
          }, {
            key: "increment",
            value: function increment() {
              this.hue = (this.hue + this.incr) % 360;
            }
          }]);
          return _class5;
        }();
      },
      933: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CssHighlighter = void 0;
        var n = r(5105);
        var o = /*#__PURE__*/function (_n$AbstractHighlighte) {
          _inherits(o, _n$AbstractHighlighte);
          function o() {
            var _this20;
            _classCallCheck(this, o);
            _this20 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this)), _this20.mactionName = "mjx-maction";
            return _this20;
          }
          _createClass(o, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = {
                  node: t,
                  background: t.style.backgroundColor,
                  foreground: t.style.color
                },
                r = this.colorString();
              return t.style.backgroundColor = r.background, t.style.color = r.foreground, e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              t.node.style.backgroundColor = t.background, t.node.style.color = t.foreground;
            }
          }]);
          return o;
        }(n.AbstractHighlighter);
        e.CssHighlighter = o;
      },
      3090: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.highlighterMapping_ = e.addEvents = e.highlighter = void 0;
        var n = r(6937),
          o = r(8396),
          i = r(933),
          a = r(2598),
          Q = r(4500),
          s = r(7071),
          T = r(4346),
          l = r(2222);
        e.highlighter = function (t, r, n) {
          var i = new o.ColorPicker(t, r),
            a = "NativeMML" === n.renderer && "Safari" === n.browser ? "MML-CSS" : "SVG" === n.renderer && "v3" === n.browser ? "SVG-V3" : n.renderer,
            Q = new (e.highlighterMapping_[a] || e.highlighterMapping_.NativeMML)();
          return Q.setColor(i), Q;
        }, e.addEvents = function (t, r, n) {
          var o = e.highlighterMapping_[n.renderer];
          o && new o().addEvents(t, r);
        }, e.highlighterMapping_ = {
          SVG: T.SvgHighlighter,
          "SVG-V3": l.SvgV3Highlighter,
          NativeMML: s.MmlHighlighter,
          "HTML-CSS": a.HtmlHighlighter,
          "MML-CSS": Q.MmlCssHighlighter,
          CommonHTML: i.CssHighlighter,
          CHTML: n.ChtmlHighlighter
        };
      },
      2598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.HtmlHighlighter = void 0;
        var n = r(5740),
          o = r(5105);
        var i = /*#__PURE__*/function (_o$AbstractHighlighte) {
          _inherits(i, _o$AbstractHighlighte);
          function i() {
            var _this21;
            _classCallCheck(this, i);
            _this21 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this)), _this21.mactionName = "maction";
            return _this21;
          }
          _createClass(i, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = {
                  node: t,
                  foreground: t.style.color,
                  position: t.style.position
                },
                r = this.color.rgb();
              t.style.color = r.foreground, t.style.position = "relative";
              var o = t.bbox;
              if (o && o.w) {
                var _i14 = .05,
                  a = 0,
                  Q = n.createElement("span"),
                  s = parseFloat(t.style.paddingLeft || "0");
                Q.style.backgroundColor = r.background, Q.style.opacity = r.alphaback.toString(), Q.style.display = "inline-block", Q.style.height = o.h + o.d + 2 * _i14 + "em", Q.style.verticalAlign = -o.d + "em", Q.style.marginTop = Q.style.marginBottom = -_i14 + "em", Q.style.width = o.w + 2 * a + "em", Q.style.marginLeft = s - a + "em", Q.style.marginRight = -o.w - a - s + "em", t.parentNode.insertBefore(Q, t), e.box = Q;
              }
              return e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node;
              e.style.color = t.foreground, e.style.position = t.position, t.box && t.box.parentNode.removeChild(t.box);
            }
          }]);
          return i;
        }(o.AbstractHighlighter);
        e.HtmlHighlighter = i;
      },
      4500: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlCssHighlighter = void 0;
        var n = r(933);
        var o = /*#__PURE__*/function (_n$CssHighlighter2) {
          _inherits(o, _n$CssHighlighter2);
          function o() {
            var _this22;
            _classCallCheck(this, o);
            _this22 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this)), _this22.mactionName = "maction";
            return _this22;
          }
          _createClass(o, [{
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName === this.mactionName;
            }
          }]);
          return o;
        }(n.CssHighlighter);
        e.MmlCssHighlighter = o;
      },
      7071: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MmlHighlighter = void 0;
        var n = r(5105);
        var o = /*#__PURE__*/function (_n$AbstractHighlighte2) {
          _inherits(o, _n$AbstractHighlighte2);
          function o() {
            var _this23;
            _classCallCheck(this, o);
            _this23 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this)), _this23.mactionName = "maction";
            return _this23;
          }
          _createClass(o, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e = t.getAttribute("style");
              return e += ";background-color: " + this.colorString().background, e += ";color: " + this.colorString().foreground, t.setAttribute("style", e), {
                node: t
              };
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node.getAttribute("style");
              e = e.replace(";background-color: " + this.colorString().background, ""), e = e.replace(";color: " + this.colorString().foreground, ""), t.node.setAttribute("style", e);
            }
          }, {
            key: "colorString",
            value: function colorString() {
              return this.color.rgba();
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(t.getElementsByTagName(this.mactionName));
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.tagName === this.mactionName;
            }
          }]);
          return o;
        }(n.AbstractHighlighter);
        e.MmlHighlighter = o;
      },
      4346: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgHighlighter = void 0;
        var n = r(5740),
          o = r(5105);
        var i = /*#__PURE__*/function (_o$AbstractHighlighte2) {
          _inherits(i, _o$AbstractHighlighte2);
          function i() {
            var _this24;
            _classCallCheck(this, i);
            _this24 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this)), _this24.mactionName = "mjx-svg-maction";
            return _this24;
          }
          _createClass(i, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e;
              if (this.isHighlighted(t)) return e = {
                node: t.previousSibling || t,
                background: t.style.backgroundColor,
                foreground: t.style.color
              }, e;
              if ("svg" === t.tagName) {
                var _e29 = {
                  node: t,
                  background: t.style.backgroundColor,
                  foreground: t.style.color
                };
                return t.style.backgroundColor = this.colorString().background, t.style.color = this.colorString().foreground, _e29;
              }
              var r = n.createElementNS("http://www.w3.org/2000/svg", "rect");
              var i;
              if ("use" === t.nodeName) {
                var _e30 = n.createElementNS("http://www.w3.org/2000/svg", "g");
                t.parentNode.insertBefore(_e30, t), _e30.appendChild(t), i = _e30.getBBox(), _e30.parentNode.replaceChild(t, _e30);
              } else i = t.getBBox();
              r.setAttribute("x", (i.x - 40).toString()), r.setAttribute("y", (i.y - 40).toString()), r.setAttribute("width", (i.width + 80).toString()), r.setAttribute("height", (i.height + 80).toString());
              var a = t.getAttribute("transform");
              return a && r.setAttribute("transform", a), r.setAttribute("fill", this.colorString().background), r.setAttribute(o.AbstractHighlighter.ATTR, "true"), t.parentNode.insertBefore(r, t), e = {
                node: r,
                foreground: t.getAttribute("fill")
              }, t.setAttribute("fill", this.colorString().foreground), e;
            }
          }, {
            key: "setHighlighted",
            value: function setHighlighted(t) {
              "svg" === t.tagName && _superPropGet(i, "setHighlighted", this, 3)([t]);
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              if ("background" in t) return t.node.style.backgroundColor = t.background, void (t.node.style.color = t.foreground);
              t.foreground ? t.node.nextSibling.setAttribute("fill", t.foreground) : t.node.nextSibling.removeAttribute("fill"), t.node.parentNode.removeChild(t.node);
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              var e = t.className || t.getAttribute("class");
              return e = void 0 !== e.baseVal ? e.baseVal : e, !!e && !!e.match(new RegExp(this.mactionName));
            }
          }]);
          return i;
        }(o.AbstractHighlighter);
        e.SvgHighlighter = i;
      },
      2222: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SvgV3Highlighter = void 0;
        var n = r(5740),
          o = r(5274),
          i = r(5105),
          a = r(8396),
          Q = r(4346);
        var s = /*#__PURE__*/function (_Q$SvgHighlighter) {
          _inherits(s, _Q$SvgHighlighter);
          function s() {
            var _this25;
            _classCallCheck(this, s);
            _this25 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this)), _this25.mactionName = "maction";
            return _this25;
          }
          _createClass(s, [{
            key: "highlightNode",
            value: function highlightNode(t) {
              var e;
              if (this.isHighlighted(t)) return e = {
                node: t,
                background: this.colorString().background,
                foreground: this.colorString().foreground
              }, e;
              if ("svg" === t.tagName || "MJX-CONTAINER" === t.tagName) return e = {
                node: t,
                background: t.style.backgroundColor,
                foreground: t.style.color
              }, t.style.backgroundColor = this.colorString().background, t.style.color = this.colorString().foreground, e;
              var r = n.createElementNS("http://www.w3.org/2000/svg", "rect");
              r.setAttribute("sre-highlighter-added", "true");
              var o = t.getBBox();
              r.setAttribute("x", (o.x - 40).toString()), r.setAttribute("y", (o.y - 40).toString()), r.setAttribute("width", (o.width + 80).toString()), r.setAttribute("height", (o.height + 80).toString());
              var Q = t.getAttribute("transform");
              if (Q && r.setAttribute("transform", Q), r.setAttribute("fill", this.colorString().background), t.setAttribute(i.AbstractHighlighter.ATTR, "true"), t.parentNode.insertBefore(r, t), e = {
                node: t,
                foreground: t.getAttribute("fill")
              }, "rect" === t.nodeName) {
                var _e31 = new a.ColorPicker({
                  alpha: 0,
                  color: "black"
                });
                t.setAttribute("fill", _e31.rgba().foreground);
              } else t.setAttribute("fill", this.colorString().foreground);
              return e;
            }
          }, {
            key: "unhighlightNode",
            value: function unhighlightNode(t) {
              var e = t.node.previousSibling;
              if (e && e.hasAttribute("sre-highlighter-added")) return t.foreground ? t.node.setAttribute("fill", t.foreground) : t.node.removeAttribute("fill"), void t.node.parentNode.removeChild(e);
              t.node.style.backgroundColor = t.background, t.node.style.color = t.foreground;
            }
          }, {
            key: "isMactionNode",
            value: function isMactionNode(t) {
              return t.getAttribute("data-mml-node") === this.mactionName;
            }
          }, {
            key: "getMactionNodes",
            value: function getMactionNodes(t) {
              return Array.from(o.evalXPath(".//*[@data-mml-node=\"".concat(this.mactionName, "\"]"), t));
            }
          }]);
          return s;
        }(Q.SvgHighlighter);
        e.SvgV3Highlighter = s;
      },
      7222: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.StaticTrieNode = e.AbstractTrieNode = void 0;
        var n = r(2057),
          o = r(4391);
        var i = /*#__PURE__*/function () {
          function i(t, e) {
            _classCallCheck(this, i);
            this.constraint = t, this.test = e, this.children_ = {}, this.kind = o.TrieNodeKind.ROOT;
          }
          _createClass(i, [{
            key: "getConstraint",
            value: function getConstraint() {
              return this.constraint;
            }
          }, {
            key: "getKind",
            value: function getKind() {
              return this.kind;
            }
          }, {
            key: "applyTest",
            value: function applyTest(t) {
              return this.test(t);
            }
          }, {
            key: "addChild",
            value: function addChild(t) {
              var e = t.getConstraint(),
                r = this.children_[e];
              return this.children_[e] = t, r;
            }
          }, {
            key: "getChild",
            value: function getChild(t) {
              return this.children_[t];
            }
          }, {
            key: "getChildren",
            value: function getChildren() {
              var t = [];
              for (var _e32 in this.children_) t.push(this.children_[_e32]);
              return t;
            }
          }, {
            key: "findChildren",
            value: function findChildren(t) {
              var e = [];
              for (var _r48 in this.children_) {
                var _n164 = this.children_[_r48];
                _n164.applyTest(t) && e.push(_n164);
              }
              return e;
            }
          }, {
            key: "removeChild",
            value: function removeChild(t) {
              delete this.children_[t];
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.constraint;
            }
          }]);
          return i;
        }();
        e.AbstractTrieNode = i;
        e.StaticTrieNode = /*#__PURE__*/function (_i15) {
          _inherits(_class6, _i15);
          function _class6(t, e) {
            var _this26;
            _classCallCheck(this, _class6);
            _this26 = _possibleConstructorReturn(this, _getPrototypeOf(_class6).call(this, t, e)), _this26.rule_ = null, _this26.kind = o.TrieNodeKind.STATIC;
            return _this26;
          }
          _createClass(_class6, [{
            key: "getRule",
            value: function getRule() {
              return this.rule_;
            }
          }, {
            key: "setRule",
            value: function setRule(t) {
              this.rule_ && n.Debugger.getInstance().output("Replacing rule " + this.rule_ + " with " + t), this.rule_ = t;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.getRule() ? this.constraint + "\n==> " + this.getRule().action : this.constraint;
            }
          }]);
          return _class6;
        }(i);
      },
      4508: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Trie = void 0;
        var n = r(4391),
          o = r(9701);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.root = (0, o.getNode)(n.TrieNodeKind.ROOT, "", null);
          }
          _createClass(i, [{
            key: "addRule",
            value: function addRule(t) {
              var e = this.root;
              var r = t.context,
                o = t.dynamicCstr.getValues();
              for (var _t43 = 0, _i16 = o.length; _t43 < _i16; _t43++) e = this.addNode_(e, o[_t43], n.TrieNodeKind.DYNAMIC, r);
              e = this.addNode_(e, t.precondition.query, n.TrieNodeKind.QUERY, r);
              var i = t.precondition.constraints;
              for (var _t44 = 0, _o11 = i.length; _t44 < _o11; _t44++) e = this.addNode_(e, i[_t44], n.TrieNodeKind.BOOLEAN, r);
              e.setRule(t);
            }
          }, {
            key: "lookupRules",
            value: function lookupRules(t, e) {
              var r = [this.root];
              var o = [];
              var _loop4 = function _loop4() {
                var t = e.shift(),
                  o = [];
                for (; r.length;) {
                  r.shift().getChildren().forEach(function (e) {
                    e.getKind() === n.TrieNodeKind.DYNAMIC && -1 === t.indexOf(e.getConstraint()) || o.push(e);
                  });
                }
                r = o.slice();
              };
              for (; e.length;) {
                _loop4();
              }
              for (; r.length;) {
                var _e33 = r.shift();
                if (_e33.getRule) {
                  var _t45 = _e33.getRule();
                  _t45 && o.push(_t45);
                }
                var _n165 = _e33.findChildren(t);
                r = r.concat(_n165);
              }
              return o;
            }
          }, {
            key: "hasSubtrie",
            value: function hasSubtrie(t) {
              var e = this.root;
              for (var _r49 = 0, _n166 = t.length; _r49 < _n166; _r49++) {
                var _n167 = t[_r49];
                if (e = e.getChild(_n167), !e) return !1;
              }
              return !0;
            }
          }, {
            key: "toString",
            value: function toString() {
              return i.printWithDepth_(this.root, 0, "");
            }
          }, {
            key: "collectRules",
            value: function collectRules() {
              return i.collectRules_(this.root);
            }
          }, {
            key: "order",
            value: function order() {
              return i.order_(this.root);
            }
          }, {
            key: "enumerate",
            value: function enumerate(t) {
              return this.enumerate_(this.root, t);
            }
          }, {
            key: "byConstraint",
            value: function byConstraint(t) {
              var e = this.root;
              for (; t.length && e;) {
                var _r50 = t.shift();
                e = e.getChild(_r50);
              }
              return e || null;
            }
          }, {
            key: "enumerate_",
            value: function enumerate_(t, e) {
              e = e || {};
              var r = t.getChildren();
              for (var _t46, _o12 = 0; _t46 = r[_o12]; _o12++) _t46.kind === n.TrieNodeKind.DYNAMIC && (e[_t46.getConstraint()] = this.enumerate_(_t46, e[_t46.getConstraint()]));
              return e;
            }
          }, {
            key: "addNode_",
            value: function addNode_(t, e, r, n) {
              var i = t.getChild(e);
              return i || (i = (0, o.getNode)(r, e, n), t.addChild(i)), i;
            }
          }], [{
            key: "collectRules_",
            value: function collectRules_(t) {
              var e = [];
              var r = [t];
              for (; r.length;) {
                var _t47 = r.shift();
                if (_t47.getKind() === n.TrieNodeKind.QUERY || _t47.getKind() === n.TrieNodeKind.BOOLEAN) {
                  var _r51 = _t47.getRule();
                  _r51 && e.unshift(_r51);
                }
                r = r.concat(_t47.getChildren());
              }
              return e;
            }
          }, {
            key: "printWithDepth_",
            value: function printWithDepth_(t, e, r) {
              r += new Array(e + 2).join(e.toString()) + ": " + t.toString() + "\n";
              var n = t.getChildren();
              for (var _t48, _o13 = 0; _t48 = n[_o13]; _o13++) r = i.printWithDepth_(_t48, e + 1, r);
              return r;
            }
          }, {
            key: "order_",
            value: function order_(t) {
              var e = t.getChildren();
              if (!e.length) return 0;
              var r = Math.max.apply(null, e.map(i.order_));
              return Math.max(e.length, r);
            }
          }]);
          return i;
        }();
        e.Trie = i;
      },
      4391: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TrieNodeKind = void 0, function (t) {
          t.ROOT = "root", t.DYNAMIC = "dynamic", t.QUERY = "query", t.BOOLEAN = "boolean", t.STATIC = "static";
        }(e.TrieNodeKind || (e.TrieNodeKind = {}));
      },
      9701: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BooleanTrieNode = e.QueryTrieNode = e.constraintTest_ = e.DynamicTrieNode = e.RootTrieNode = e.getNode = void 0;
        var n = r(5740),
          o = r(5274),
          i = r(2105),
          a = r(2780),
          Q = r(7222),
          s = r(7222),
          T = r(4391);
        e.getNode = function (t, e, r) {
          switch (t) {
            case T.TrieNodeKind.ROOT:
              return new l();
            case T.TrieNodeKind.DYNAMIC:
              return new c(e);
            case T.TrieNodeKind.QUERY:
              return new h(e, r);
            case T.TrieNodeKind.BOOLEAN:
              return new d(e, r);
            default:
              return null;
          }
        };
        var l = /*#__PURE__*/function (_Q$AbstractTrieNode) {
          _inherits(l, _Q$AbstractTrieNode);
          function l() {
            var _this27;
            _classCallCheck(this, l);
            _this27 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, "", function () {
              return !0;
            })), _this27.kind = T.TrieNodeKind.ROOT;
            return _this27;
          }
          return l;
        }(Q.AbstractTrieNode);
        e.RootTrieNode = l;
        var c = /*#__PURE__*/function (_Q$AbstractTrieNode2) {
          _inherits(c, _Q$AbstractTrieNode2);
          function c(t) {
            var _this28;
            _classCallCheck(this, c);
            _this28 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, t, function (e) {
              return e === t;
            })), _this28.kind = T.TrieNodeKind.DYNAMIC;
            return _this28;
          }
          return c;
        }(Q.AbstractTrieNode);
        e.DynamicTrieNode = c;
        var u = {
          "=": function _(t, e) {
            return t === e;
          },
          "!=": function _(t, e) {
            return t !== e;
          },
          "<": function _(t, e) {
            return t < e;
          },
          ">": function _(t, e) {
            return t > e;
          },
          "<=": function _(t, e) {
            return t <= e;
          },
          ">=": function _(t, e) {
            return t >= e;
          }
        };
        function p(t) {
          if (t.match(/^self::\*$/)) return function (t) {
            return !0;
          };
          if (t.match(/^self::\w+$/)) {
            var _e34 = t.slice(6).toUpperCase();
            return function (t) {
              return t.tagName && n.tagName(t) === _e34;
            };
          }
          if (t.match(/^self::\w+:\w+$/)) {
            var _e35 = t.split(":"),
              _r52 = o.resolveNameSpace(_e35[2]);
            if (!_r52) return null;
            var _n168 = _e35[3].toUpperCase();
            return function (t) {
              return t.localName && t.localName.toUpperCase() === _n168 && t.namespaceURI === _r52;
            };
          }
          if (t.match(/^@\w+$/)) {
            var _e36 = t.slice(1);
            return function (t) {
              return t.hasAttribute && t.hasAttribute(_e36);
            };
          }
          if (t.match(/^@\w+="[\w\d ]+"$/)) {
            var _e37 = t.split("="),
              _r53 = _e37[0].slice(1),
              _n169 = _e37[1].slice(1, -1);
            return function (t) {
              return t.hasAttribute && t.hasAttribute(_r53) && t.getAttribute(_r53) === _n169;
            };
          }
          if (t.match(/^@\w+!="[\w\d ]+"$/)) {
            var _e38 = t.split("!="),
              _r54 = _e38[0].slice(1),
              _n170 = _e38[1].slice(1, -1);
            return function (t) {
              return !t.hasAttribute || !t.hasAttribute(_r54) || t.getAttribute(_r54) !== _n170;
            };
          }
          if (t.match(/^contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)$/)) {
            var _e39 = t.split('"')[1];
            return function (t) {
              return !!i.Grammar.getInstance().getParameter(_e39);
            };
          }
          if (t.match(/^not\(\s*contains\(\s*@grammar\s*,\s*"[\w\d ]+"\s*\)\s*\)$/)) {
            var _e40 = t.split('"')[1];
            return function (t) {
              return !i.Grammar.getInstance().getParameter(_e40);
            };
          }
          if (t.match(/^name\(\.\.\/\.\.\)="\w+"$/)) {
            var _e41 = t.split('"')[1].toUpperCase();
            return function (t) {
              var r, o;
              return (null === (o = null === (r = t.parentNode) || void 0 === r ? void 0 : r.parentNode) || void 0 === o ? void 0 : o.tagName) && n.tagName(t.parentNode.parentNode) === _e41;
            };
          }
          if (t.match(/^count\(preceding-sibling::\*\)=\d+$/)) {
            var _e42 = t.split("="),
              _r55 = parseInt(_e42[1], 10);
            return function (t) {
              var e;
              return (null === (e = t.parentNode) || void 0 === e ? void 0 : e.childNodes[_r55]) === t;
            };
          }
          if (t.match(/^.+\[@category!?=".+"\]$/)) {
            var _t$match = t.match(/^(.+)\[@category(!?=)"(.+)"\]$/),
              _t$match2 = _slicedToArray(_t$match, 4),
              _e43 = _t$match2[1],
              _r56 = _t$match2[2],
              _n171 = _t$match2[3];
            var _i17 = _n171.match(/^unit:(.+)$/);
            var _Q5 = "";
            return _i17 && (_n171 = _i17[1], _Q5 = ":unit"), function (t) {
              var i = o.evalXPath(_e43, t)[0];
              if (i) {
                var _t49 = a.lookupCategory(i.textContent + _Q5);
                return "=" === _r56 ? _t49 === _n171 : _t49 !== _n171;
              }
              return !1;
            };
          }
          if (t.match(/^string-length\(.+\)\W+\d+/)) {
            var _t$match3 = t.match(/^string-length\((.+)\)(\W+)(\d+)/),
              _t$match4 = _slicedToArray(_t$match3, 4),
              _e44 = _t$match4[1],
              _r57 = _t$match4[2],
              _n172 = _t$match4[3],
              _i18 = u[_r57] || u["="],
              _a6 = parseInt(_n172, 10);
            return function (t) {
              var r = o.evalXPath(_e44, t)[0];
              return !!r && _i18(Array.from(r.textContent).length, _a6);
            };
          }
          return null;
        }
        e.constraintTest_ = p;
        var h = /*#__PURE__*/function (_s$StaticTrieNode) {
          _inherits(h, _s$StaticTrieNode);
          function h(t, e) {
            var _this29;
            _classCallCheck(this, h);
            _this29 = _possibleConstructorReturn(this, _getPrototypeOf(h).call(this, t, p(t))), _this29.context = e, _this29.kind = T.TrieNodeKind.QUERY;
            return _this29;
          }
          _createClass(h, [{
            key: "applyTest",
            value: function applyTest(t) {
              return this.test ? this.test(t) : this.context.applyQuery(t, this.constraint) === t;
            }
          }]);
          return h;
        }(s.StaticTrieNode);
        e.QueryTrieNode = h;
        var d = /*#__PURE__*/function (_s$StaticTrieNode2) {
          _inherits(d, _s$StaticTrieNode2);
          function d(t, e) {
            var _this30;
            _classCallCheck(this, d);
            _this30 = _possibleConstructorReturn(this, _getPrototypeOf(d).call(this, t, p(t))), _this30.context = e, _this30.kind = T.TrieNodeKind.BOOLEAN;
            return _this30;
          }
          _createClass(d, [{
            key: "applyTest",
            value: function applyTest(t) {
              return this.test ? this.test(t) : this.context.applyConstraint(t, this.constraint);
            }
          }]);
          return d;
        }(s.StaticTrieNode);
        e.BooleanTrieNode = d;
      },
      7491: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.completeLocale = e.getLocale = e.setLocale = e.locales = void 0;
        var n = r(5897),
          o = r(1377),
          i = r(2105),
          a = r(4249),
          Q = r(8657),
          s = r(173),
          T = r(9393),
          l = r(7978),
          c = r(5540),
          u = r(5218),
          p = r(3887),
          h = r(8384),
          d = r(7206),
          f = r(7734),
          m = r(7264),
          L = r(4356);
        function y() {
          var t = o.Variables.ensureLocale(n.default.getInstance().locale, n.default.getInstance().defaultLocale);
          return n.default.getInstance().locale = t, e.locales[t]();
        }
        e.locales = {
          ca: a.ca,
          da: Q.da,
          de: s.de,
          en: T.en,
          es: l.es,
          fr: c.fr,
          hi: u.hi,
          it: p.it,
          nb: h.nb,
          nn: f.nn,
          sv: m.sv,
          nemeth: d.nemeth
        }, e.setLocale = function () {
          var t = y();
          if (function (t) {
            var e = n.default.getInstance().subiso;
            -1 === t.SUBISO.all.indexOf(e) && (n.default.getInstance().subiso = t.SUBISO.default);
            t.SUBISO.current = n.default.getInstance().subiso;
          }(t), t) {
            var _iterator8 = _createForOfIteratorHelper(Object.getOwnPropertyNames(t)),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e46 = _step8.value;
                L.LOCALE[_e46] = t[_e46];
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
            for (var _i19 = 0, _Object$entries2 = Object.entries(t.CORRECTIONS); _i19 < _Object$entries2.length; _i19++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i19], 2),
                _e45 = _Object$entries2$_i[0],
                _r58 = _Object$entries2$_i[1];
              i.Grammar.getInstance().setCorrection(_e45, _r58);
            }
          }
        }, e.getLocale = y, e.completeLocale = function (t) {
          var r = e.locales[t.locale];
          if (!r) return void console.error("Locale " + t.locale + " does not exist!");
          var n = t.kind.toUpperCase(),
            o = t.messages;
          if (!o) return;
          var i = r();
          for (var _i20 = 0, _Object$entries3 = Object.entries(o); _i20 < _Object$entries3.length; _i20++) {
            var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i20], 2),
              _t50 = _Object$entries3$_i[0],
              _e47 = _Object$entries3$_i[1];
            i[n][_t50] = _e47;
          }
        };
      },
      4356: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.createLocale = e.LOCALE = void 0;
        var n = r(7549);
        function o() {
          return {
            FUNCTIONS: (0, n.FUNCTIONS)(),
            MESSAGES: (0, n.MESSAGES)(),
            ALPHABETS: (0, n.ALPHABETS)(),
            NUMBERS: (0, n.NUMBERS)(),
            COMBINERS: {},
            CORRECTIONS: {},
            SUBISO: (0, n.SUBISO)()
          };
        }
        e.LOCALE = o(), e.createLocale = o;
      },
      2536: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.localeFontCombiner = e.extractString = e.localEnclose = e.localRole = e.localFont = e.combinePostfixIndex = e.nestingToString = void 0;
        var n = r(4356),
          o = r(4977);
        function i(t, e) {
          return void 0 === t ? e : "string" == typeof t ? t : t[0];
        }
        e.nestingToString = function (t) {
          switch (t) {
            case 1:
              return n.LOCALE.MESSAGES.MS.ONCE || "";
            case 2:
              return n.LOCALE.MESSAGES.MS.TWICE;
            default:
              return t.toString();
          }
        }, e.combinePostfixIndex = function (t, e) {
          return t === n.LOCALE.MESSAGES.MS.ROOTINDEX || t === n.LOCALE.MESSAGES.MS.INDEX ? t : t + " " + e;
        }, e.localFont = function (t) {
          return i(n.LOCALE.MESSAGES.font[t], t);
        }, e.localRole = function (t) {
          return i(n.LOCALE.MESSAGES.role[t], t);
        }, e.localEnclose = function (t) {
          return i(n.LOCALE.MESSAGES.enclose[t], t);
        }, e.extractString = i, e.localeFontCombiner = function (t) {
          return "string" == typeof t ? {
            font: t,
            combiner: n.LOCALE.ALPHABETS.combiner
          } : {
            font: t[0],
            combiner: n.LOCALE.COMBINERS[t[1]] || o.Combiners[t[1]] || n.LOCALE.ALPHABETS.combiner
          };
        };
      },
      4249: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ca = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(614),
          a = r(4977),
          Q = function Q(t, e, r) {
            return t = "sans serif " + (r ? r + " " + t : t), e ? t + " " + e : t;
          };
        var s = null;
        e.ca = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.sansserif = Q, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.combineRootIndex = o.combinePostfixIndex, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return t + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t + " ");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*os$/.test(t) ? t + "sos" : /.*s$/.test(t) ? t + "os" : /.*ga$/.test(t) ? t.slice(0, -2) + "gues" : /.*\xe7a$/.test(t) ? t.slice(0, -2) + "ces" : /.*ca$/.test(t) ? t.slice(0, -2) + "ques" : /.*ja$/.test(t) ? t.slice(0, -2) + "ges" : /.*qua$/.test(t) ? t.slice(0, -3) + "q\xfces" : /.*a$/.test(t) ? t.slice(0, -1) + "es" : /.*(e|i)$/.test(t) ? t + "ns" : /.*\xed$/.test(t) ? t.slice(0, -1) + "ins" : t + "s";
            }, t.FUNCTIONS.si = function (t, e) {
              return e.match(/^metre/) && (t = t.replace(/a$/, "\xe0").replace(/o$/, "\xf2").replace(/i$/, "\xed")), t + e;
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t;
          }()), s;
        };
      },
      8657: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.da = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(3866),
          a = r(4977);
        var Q = null;
        e.da = function () {
          return Q || (Q = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.FUNCTIONS.fontRegexp = function (e) {
              return e === t.ALPHABETS.capPrefix.default ? RegExp("^" + e + " ") : RegExp(" " + e + "$");
            }, t.ALPHABETS.combiner = a.Combiners.postfixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t;
          }()), Q;
        };
      },
      173: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.de = void 0;
        var n = r(2105),
          o = r(2536),
          i = r(4356),
          a = r(1435),
          Q = function Q(t, e, r) {
            return "s" === r && (e = e.split(" ").map(function (t) {
              return t.replace(/s$/, "");
            }).join(" "), r = ""), t = r ? r + " " + t : t, e ? e + " " + t : t;
          },
          s = function s(t, e, r) {
            return t = r && "s" !== r ? r + " " + t : t, e ? t + " " + e : t;
          };
        var T = null;
        e.de = function () {
          return T || (T = function () {
            var t = (0, i.createLocale)();
            return t.NUMBERS = a.default, t.COMBINERS.germanPostfix = s, t.ALPHABETS.combiner = Q, t.FUNCTIONS.radicalNestDepth = function (e) {
              return e > 1 ? t.NUMBERS.numberToWords(e) + "fach" : "";
            }, t.FUNCTIONS.combineRootIndex = function (t, e) {
              var r = e ? e + "wurzel" : "";
              return t.replace("Wurzel", r);
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              var n = (e ? e + " " : "") + (t = r.match(/exponent$/) ? t + "r" : t);
              return r.match(/ /) ? r.replace(/ /, " " + n + " ") : n + " " + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return t = t.split(" ").map(function (t) {
                return t.replace(/s$/, "(|s)");
              }).join(" "), new RegExp("((^" + t + " )|( " + t + "$))");
            }, t.CORRECTIONS.correctOne = function (t) {
              return t.replace(/^eins$/, "ein");
            }, t.CORRECTIONS.localFontNumber = function (t) {
              return (0, o.localFont)(t).split(" ").map(function (t) {
                return t.replace(/s$/, "");
              }).join(" ");
            }, t.CORRECTIONS.lowercase = function (t) {
              return t.toLowerCase();
            }, t.CORRECTIONS.article = function (t) {
              var e = n.Grammar.getInstance().getParameter("case"),
                r = n.Grammar.getInstance().getParameter("plural");
              return "dative" === e ? {
                der: "dem",
                die: r ? "den" : "der",
                das: "dem"
              }[t] : t;
            }, t.CORRECTIONS.masculine = function (t) {
              return "dative" === n.Grammar.getInstance().getParameter("case") ? t + "n" : t;
            }, t;
          }()), T;
        };
      },
      9393: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.en = void 0;
        var n = r(2105),
          o = r(4356),
          i = r(2536),
          a = r(310),
          Q = r(4977);
        var s = null;
        e.en = function () {
          return s || (s = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = a.default, t.FUNCTIONS.radicalNestDepth = i.nestingToString, t.FUNCTIONS.plural = function (t) {
              return /.*s$/.test(t) ? t : t + "s";
            }, t.ALPHABETS.combiner = Q.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = a.default.numberToWords, t.CORRECTIONS.article = function (t) {
              return n.Grammar.getInstance().getParameter("noArticle") ? "" : t;
            }, t;
          }()), s;
        };
      },
      7978: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.es = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(4634),
          a = r(4977),
          Q = function Q(t, e, r) {
            return t = "sans serif " + (r ? r + " " + t : t), e ? t + " " + e : t;
          };
        var s = null;
        e.es = function () {
          return s || (s = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.sansserif = Q, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.combineRootIndex = o.combinePostfixIndex, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return t + r;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t + " ");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*(a|e|i|o|u)$/.test(t) ? t + "s" : /.*z$/.test(t) ? t.slice(0, -1) + "ces" : /.*c$/.test(t) ? t.slice(0, -1) + "ques" : /.*g$/.test(t) ? t + "ues" : /.*\u00f3n$/.test(t) ? t.slice(0, -2) + "ones" : t + "es";
            }, t.FUNCTIONS.si = function (t, e) {
              return e.match(/^metro/) && (t = t.replace(/a$/, "\xe1").replace(/o$/, "\xf3").replace(/i$/, "\xed")), t + e;
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t;
          }()), s;
        };
      },
      5540: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.fr = void 0;
        var n = r(2105),
          o = r(4356),
          i = r(2536),
          a = r(2350),
          Q = r(4977);
        var s = null;
        e.fr = function () {
          return s || (s = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = a.default, t.FUNCTIONS.radicalNestDepth = i.nestingToString, t.FUNCTIONS.combineRootIndex = i.combinePostfixIndex, t.FUNCTIONS.combineNestedFraction = function (t, e, r) {
              return r.replace(/ $/g, "") + e + t;
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return r + " " + t;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp(" (en |)" + t + "$");
            }, t.FUNCTIONS.plural = function (t) {
              return /.*s$/.test(t) ? t : t + "s";
            }, t.CORRECTIONS.article = function (t) {
              return n.Grammar.getInstance().getParameter("noArticle") ? "" : t;
            }, t.ALPHABETS.combiner = Q.Combiners.romanceCombiner, t.SUBISO = {
              default: "fr",
              current: "fr",
              all: ["fr", "be", "ch"]
            }, t;
          }()), s;
        };
      },
      5218: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.hi = void 0;
        var n = r(4356),
          o = r(4438),
          i = r(4977),
          a = r(2536);
        var Q = null;
        e.hi = function () {
          return Q || (Q = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = o.default, t.ALPHABETS.combiner = i.Combiners.prefixCombiner, t.FUNCTIONS.radicalNestDepth = a.nestingToString, t;
          }()), Q;
        };
      },
      3887: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.it = void 0;
        var n = r(2536),
          o = r(4356),
          i = r(8825),
          a = r(4977),
          Q = function Q(t, e, r) {
            return t.match(/^[a-zA-Z]$/) && (e = e.replace("cerchiato", "cerchiata")), t = r ? t + " " + r : t, e ? t + " " + e : t;
          };
        var s = null;
        e.it = function () {
          return s || (s = function () {
            var t = (0, o.createLocale)();
            return t.NUMBERS = i.default, t.COMBINERS.italianPostfix = Q, t.FUNCTIONS.radicalNestDepth = n.nestingToString, t.FUNCTIONS.combineRootIndex = n.combinePostfixIndex, t.FUNCTIONS.combineNestedFraction = function (t, e, r) {
              return r.replace(/ $/g, "") + e + t;
            }, t.FUNCTIONS.combineNestedRadical = function (t, e, r) {
              return r + " " + t;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp(" (en |)" + t + "$");
            }, t.ALPHABETS.combiner = a.Combiners.romanceCombiner, t;
          }()), s;
        };
      },
      8384: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nb = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(8274),
          a = r(4977);
        var Q = null;
        e.nb = function () {
          return Q || (Q = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t;
          }()), Q;
        };
      },
      7206: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nemeth = void 0;
        var n = r(4356),
          o = r(3720),
          i = r(4977),
          a = function a(t) {
            return t.match(RegExp("^" + u.ALPHABETS.languagePrefix.english)) ? t.slice(1) : t;
          },
          Q = function Q(t, e, r) {
            return t = a(t), e ? t + e : t;
          },
          s = function s(t, e, r) {
            return e + a(t);
          },
          T = function T(t, e, r) {
            return e + (r || "") + (t = a(t)) + "\u283B";
          },
          l = function l(t, e, r) {
            return e + (r || "") + (t = a(t)) + "\u283B\u283B";
          },
          c = function c(t, e, r) {
            return e + (t = a(t)) + "\u283E";
          };
        var u = null;
        e.nemeth = function () {
          return u || (u = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = o.default, t.COMBINERS = {
              postfixCombiner: Q,
              germanCombiner: s,
              embellishCombiner: T,
              doubleEmbellishCombiner: l,
              parensCombiner: c
            }, t.FUNCTIONS.fracNestDepth = function (t) {
              return !1;
            }, t.FUNCTIONS.fontRegexp = function (t) {
              return RegExp("^" + t);
            }, t.FUNCTIONS.si = i.identityTransformer, t.ALPHABETS.combiner = function (t, e, r) {
              return e ? e + r + t : a(t);
            }, t.ALPHABETS.digitTrans = {
              default: o.default.numberToWords
            }, t;
          }()), u;
        };
      },
      7734: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.nn = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(8274),
          a = r(4977);
        var Q = null;
        e.nn = function () {
          return Q || (Q = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.SUBISO = {
              default: "",
              current: "",
              all: ["", "alt"]
            }, t;
          }()), Q;
        };
      },
      7264: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.sv = void 0;
        var n = r(4356),
          o = r(2536),
          i = r(3898),
          a = r(4977);
        var Q = null;
        e.sv = function () {
          return Q || (Q = function () {
            var t = (0, n.createLocale)();
            return t.NUMBERS = i.default, t.FUNCTIONS.radicalNestDepth = o.nestingToString, t.FUNCTIONS.fontRegexp = function (t) {
              return new RegExp("((^" + t + " )|( " + t + "$))");
            }, t.ALPHABETS.combiner = a.Combiners.prefixCombiner, t.ALPHABETS.digitTrans.default = i.default.numberToWords, t.CORRECTIONS.correctOne = function (t) {
              return t.replace(/^ett$/, "en");
            }, t;
          }()), Q;
        };
      },
      7549: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SUBISO = e.FUNCTIONS = e.ALPHABETS = e.NUMBERS = e.MESSAGES = void 0;
        var n = r(4977);
        e.MESSAGES = function () {
          return {
            MS: {},
            MSroots: {},
            font: {},
            embellish: {},
            role: {},
            enclose: {},
            navigate: {},
            regexp: {},
            unitTimes: ""
          };
        }, e.NUMBERS = function () {
          return {
            zero: "zero",
            ones: [],
            tens: [],
            large: [],
            special: {},
            wordOrdinal: n.identityTransformer,
            numericOrdinal: n.identityTransformer,
            numberToWords: n.identityTransformer,
            numberToOrdinal: n.pluralCase,
            vulgarSep: " ",
            numSep: " "
          };
        }, e.ALPHABETS = function () {
          return {
            latinSmall: [],
            latinCap: [],
            greekSmall: [],
            greekCap: [],
            capPrefix: {
              default: ""
            },
            smallPrefix: {
              default: ""
            },
            digitPrefix: {
              default: ""
            },
            languagePrefix: {},
            digitTrans: {
              default: n.identityTransformer,
              mathspeak: n.identityTransformer,
              clearspeak: n.identityTransformer
            },
            letterTrans: {
              default: n.identityTransformer
            },
            combiner: function combiner(t, e, r) {
              return t;
            }
          };
        }, e.FUNCTIONS = function () {
          return {
            fracNestDepth: function fracNestDepth(t) {
              return n.vulgarFractionSmall(t, 10, 100);
            },
            radicalNestDepth: function radicalNestDepth(t) {
              return "";
            },
            combineRootIndex: function combineRootIndex(t, e) {
              return t;
            },
            combineNestedFraction: n.Combiners.identityCombiner,
            combineNestedRadical: n.Combiners.identityCombiner,
            fontRegexp: function fontRegexp(t) {
              return new RegExp("^" + t.split(/ |-/).join("( |-)") + "( |-)");
            },
            si: n.siCombiner,
            plural: n.identityTransformer
          };
        }, e.SUBISO = function () {
          return {
            default: "",
            current: "",
            all: []
          };
        };
      },
      614: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = Math.floor(e / 100),
            n = r ? 1 === r ? "cent" : Q.ones[r] + "-cents" : "",
            o = function (t) {
              var e = t % 100;
              if (e < 20) return Q.ones[e];
              var r = Math.floor(e / 10),
                n = Q.tens[r],
                o = Q.ones[e % 10];
              return n && o ? n + (2 === r ? "-i-" : "-") + o : n || o;
            }(e % 100);
          return n && o ? n + Q.numSep + o : n || o;
        }
        function i(t) {
          if (0 === t) return Q.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n173 = t % (e > 1 ? 1e6 : 1e3);
            if (_n173) {
              var _t51 = Q.large[e];
              if (e) {
                if (1 === e) r = (1 === _n173 ? "" : o(_n173) + Q.numSep) + _t51 + (r ? Q.numSep + r : "");else {
                  var _e48 = i(_n173);
                  _t51 = 1 === _n173 ? _t51 : _t51.replace(/\u00f3$/, "ons"), r = _e48 + Q.numSep + _t51 + (r ? Q.numSep + r : "");
                }
              } else r = o(_n173);
            }
            t = Math.floor(t / (e > 1 ? 1e6 : 1e3)), e++;
          }
          return r;
        }
        function a(t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("f" === e ? "a" : "n");
        }
        var Q = (0, r(7549).NUMBERS)();
        Q.numericOrdinal = a, Q.numberToWords = i, Q.numberToOrdinal = function (t, e) {
          if (t > 1999) return a(t);
          if (t <= 10) return Q.special.onesOrdinals[t - 1];
          var r = i(t);
          return r.match(/mil$/) ? r.replace(/mil$/, "mil\xb7l\xe8sima") : r.match(/u$/) ? r.replace(/u$/, "vena") : r.match(/a$/) ? r.replace(/a$/, "ena") : r + (r.match(/e$/) ? "na" : "ena");
        }, e.default = Q;
      },
      3866: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === Q.ones[1] ? e ? "et" : "en" : t;
        }
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            o = "",
            i = Q.ones[Math.floor(r / 100)];
          if (o += i ? n(i, !0) + " hundrede" : "", r %= 100, r) if (o += o ? " og " : "", i = e ? Q.special.smallOrdinals[r] : Q.ones[r], i) o += i;else {
            var _t52 = e ? Q.special.tensOrdinals[Math.floor(r / 10)] : Q.tens[Math.floor(r / 10)];
            i = Q.ones[r % 10], o += i ? n(i) + "og" + _t52 : _t52;
          }
          return o;
        }
        function i(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (0 === t) return Q.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var r = 0,
            i = "";
          for (; t > 0;) {
            var _a7 = t % 1e3;
            if (_a7) {
              var _t53 = o(_a7, e && !r);
              if (r) {
                var _e49 = Q.large[r],
                  _o14 = _a7 > 1 ? "er" : "";
                i = n(_t53, r <= 1) + " " + _e49 + _o14 + (i ? " og " : "") + i;
              } else i = n(_t53) + i;
            }
            t = Math.floor(t / 1e3), r++;
          }
          return i;
        }
        function a(t) {
          if (t % 100) return i(t, !0);
          var e = i(t);
          return e.match(/e$/) ? e : e + "e";
        }
        var Q = (0, r(7549).NUMBERS)();
        Q.wordOrdinal = a, Q.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, Q.numberToWords = i, Q.numberToOrdinal = function (t, e) {
          return 1 === t ? e ? "hel" : "hele" : 2 === t ? e ? "halv" : "halve" : a(t) + (e ? "dele" : "del");
        }, e.default = Q;
      },
      1435: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === Q.ones[1] ? e ? "eine" : "ein" : t;
        }
        function o(t) {
          var e = t % 1e3,
            r = "",
            o = Q.ones[Math.floor(e / 100)];
          if (r += o ? n(o) + "hundert" : "", e %= 100, e) if (r += r ? Q.numSep : "", o = Q.ones[e], o) r += o;else {
            var _t54 = Q.tens[Math.floor(e / 10)];
            o = Q.ones[e % 10], r += o ? n(o) + "und" + _t54 : _t54;
          }
          return r;
        }
        function i(t) {
          if (0 === t) return Q.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _i21 = t % 1e3;
            if (_i21) {
              var _a8 = o(t % 1e3);
              if (e) {
                var _t55 = Q.large[e],
                  _o15 = e > 1 && _i21 > 1 ? _t55.match(/e$/) ? "n" : "en" : "";
                r = n(_a8, e > 1) + _t55 + _o15 + r;
              } else r = n(_a8, e > 1) + r;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/ein$/, "eins");
        }
        function a(t) {
          if (1 === t) return "erste";
          if (3 === t) return "dritte";
          if (7 === t) return "siebte";
          if (8 === t) return "achte";
          return i(t) + (t < 19 ? "te" : "ste");
        }
        var Q = (0, r(7549).NUMBERS)();
        Q.wordOrdinal = a, Q.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, Q.numberToWords = i, Q.numberToOrdinal = function (t, e) {
          return 1 === t ? "eintel" : 2 === t ? e ? "halbe" : "halb" : a(t) + "l";
        }, e.default = Q;
      },
      310: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = t % 1e3,
            r = "";
          return r += a.ones[Math.floor(e / 100)] ? a.ones[Math.floor(e / 100)] + a.numSep + "hundred" : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e] || a.tens[Math.floor(e / 10)] + (e % 10 ? a.numSep + a.ones[e % 10] : "")), r;
        }
        function o(t) {
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            t % 1e3 && (r = n(t % 1e3) + (e ? "-" + a.large[e] + "-" : "") + r), t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        function i(t) {
          var e = o(t);
          return e.match(/one$/) ? e = e.slice(0, -3) + "first" : e.match(/two$/) ? e = e.slice(0, -3) + "second" : e.match(/three$/) ? e = e.slice(0, -5) + "third" : e.match(/five$/) ? e = e.slice(0, -4) + "fifth" : e.match(/eight$/) ? e = e.slice(0, -5) + "eighth" : e.match(/nine$/) ? e = e.slice(0, -4) + "ninth" : e.match(/twelve$/) ? e = e.slice(0, -6) + "twelfth" : e.match(/ty$/) ? e = e.slice(0, -2) + "tieth" : e += "th", e;
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = t % 100,
            r = t.toString();
          if (e > 10 && e < 20) return r + "th";
          switch (t % 10) {
            case 1:
              return r + "st";
            case 2:
              return r + "nd";
            case 3:
              return r + "rd";
            default:
              return r + "th";
          }
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          if (1 === t) return e ? "oneths" : "oneth";
          if (2 === t) return e ? "halves" : "half";
          var r = i(t);
          return e ? r + "s" : r;
        }, e.default = a;
      },
      4634: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = Math.floor(e / 100),
            n = i.special.hundreds[r],
            o = function (t) {
              var e = t % 100;
              if (e < 30) return i.ones[e];
              var r = i.tens[Math.floor(e / 10)],
                n = i.ones[e % 10];
              return r && n ? r + " y " + n : r || n;
            }(e % 100);
          return 1 === r ? o ? n + "to " + o : n : n && o ? n + " " + o : n || o;
        }
        var i = (0, r(7549).NUMBERS)();
        i.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("f" === e ? "a" : "o");
        }, i.numberToWords = function (t) {
          if (0 === t) return i.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n174 = t % 1e3;
            if (_n174) {
              var _t56 = i.large[e];
              var a = o(_n174);
              e ? 1 === _n174 ? (_t56 = _t56.match("/^mil( |$)/") ? _t56 : "un " + _t56, r = _t56 + (r ? " " + r : "")) : (_t56 = _t56.replace(/\u00f3n$/, "ones"), r = o(_n174) + " " + _t56 + (r ? " " + r : "")) : r = a;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r;
        }, i.numberToOrdinal = function (t, e) {
          if (t > 1999) return t.toString() + "a";
          if (t <= 12) return i.special.onesOrdinals[t - 1];
          var r = [];
          if (t >= 1e3 && (t -= 1e3, r.push("mil\xe9sima")), !t) return r.join(" ");
          var n = 0;
          return n = Math.floor(t / 100), n > 0 && (r.push(i.special.hundredsOrdinals[n - 1]), t %= 100), t <= 12 ? r.push(i.special.onesOrdinals[t - 1]) : (n = Math.floor(t / 10), n > 0 && (r.push(i.special.tensOrdinals[n - 1]), t %= 10), t > 0 && r.push(i.special.onesOrdinals[t - 1])), r.join(" ");
        }, e.default = i;
      },
      2350: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5897),
          o = r(2105),
          i = r(7549);
        function a(t) {
          var e = t % 1e3,
            r = "";
          if (r += l.ones[Math.floor(e / 100)] ? l.ones[Math.floor(e / 100)] + "-cent" : "", e %= 100, e) {
            r += r ? "-" : "";
            var _t57 = l.ones[e];
            if (_t57) r += _t57;else {
              var _n175 = l.tens[Math.floor(e / 10)];
              _n175.match(/-dix$/) ? (_t57 = l.ones[e % 10 + 10], r += _n175.replace(/-dix$/, "") + "-" + _t57) : r += _n175 + (e % 10 ? "-" + l.ones[e % 10] : "");
            }
          }
          var n = r.match(/s-\w+$/);
          return n ? r.replace(/s-\w+$/, n[0].slice(1)) : r.replace(/-un$/, "-et-un");
        }
        function Q(t) {
          if (0 === t) return l.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          l.special["tens-" + n.default.getInstance().subiso] && (l.tens = l.special["tens-" + n.default.getInstance().subiso]);
          var e = 0,
            r = "";
          for (; t > 0;) {
            var _n176 = t % 1e3;
            if (_n176) {
              var _t58 = l.large[e];
              var _o16 = a(_n176);
              if (_t58 && _t58.match(/^mille /)) {
                var _n177 = _t58.replace(/^mille /, "");
                r = r.match(RegExp(_n177)) ? _o16 + (e ? "-mille-" : "") + r : r.match(RegExp(_n177.replace(/s$/, ""))) ? _o16 + (e ? "-mille-" : "") + r.replace(_n177.replace(/s$/, ""), _n177) : _o16 + (e ? "-" + _t58 + "-" : "") + r;
              } else _t58 = 1 === _n176 && _t58 ? _t58.replace(/s$/, "") : _t58, r = _o16 + (e ? "-" + _t58 + "-" : "") + r;
            }
            t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        var s = {
          1: "uni\xe8me",
          2: "demi",
          3: "tiers",
          4: "quart"
        };
        function T(t) {
          if (1 === t) return "premi\xe8re";
          var e = Q(t);
          return e.match(/^neuf$/) ? e = e.slice(0, -1) + "v" : e.match(/cinq$/) ? e += "u" : e.match(/trois$/) ? e += "" : (e.match(/e$/) || e.match(/s$/)) && (e = e.slice(0, -1)), e += "i\xe8me", e;
        }
        var l = (0, i.NUMBERS)();
        l.wordOrdinal = T, l.numericOrdinal = function (t) {
          var e = o.Grammar.getInstance().getParameter("gender");
          return 1 === t ? t.toString() + ("m" === e ? "er" : "re") : t.toString() + "e";
        }, l.numberToWords = Q, l.numberToOrdinal = function (t, e) {
          var r = s[t] || T(t);
          return 3 === t ? r : e ? r + "s" : r;
        }, e.default = l;
      },
      4438: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 32)) return t.toString();
          var e = 0,
            r = "";
          var n = function (t) {
            var e = t % 1e3,
              r = "";
            return r += a.ones[Math.floor(e / 100)] ? a.ones[Math.floor(e / 100)] + a.numSep + a.special.hundred : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e]), r;
          }(t % 1e3);
          if (!(t = Math.floor(t / 1e3))) return n;
          for (; t > 0;) {
            var _n178 = t % 100;
            _n178 && (r = a.ones[_n178] + a.numSep + a.large[e] + (r ? a.numSep + r : "")), t = Math.floor(t / 100), e++;
          }
          return n ? r + a.numSep + n : r;
        }
        function i(t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          if (t <= 0) return t.toString();
          if (t < 10) return "f" === e ? a.special.ordinalsFeminine[t] : a.special.ordinalsMasculine[t];
          return o(t) + ("f" === e ? "\u0935\u0940\u0902" : "\u0935\u093E\u0901");
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t > 0 && t < 10 ? "f" === e ? a.special.simpleSmallOrdinalsFeminine[t] : a.special.simpleSmallOrdinalsMasculine[t] : t.toString().split("").map(function (t) {
            var e = parseInt(t, 10);
            return isNaN(e) ? "" : a.special.simpleNumbers[e];
          }).join("") + ("f" === e ? "\u0935\u0940\u0902" : "\u0935\u093E\u0901");
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          return t <= 10 ? a.special.smallDenominators[t] : i(t) + " \u0905\u0902\u0936";
        }, e.default = a;
      },
      8825: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2105);
        function o(t) {
          var e = t % 1e3,
            r = "";
          if (r += Q.ones[Math.floor(e / 100)] ? Q.ones[Math.floor(e / 100)] + Q.numSep + "cento" : "", e %= 100, e) {
            r += r ? Q.numSep : "";
            var _t59 = Q.ones[e];
            if (_t59) r += _t59;else {
              var _t60 = Q.tens[Math.floor(e / 10)];
              var _n179 = e % 10;
              1 !== _n179 && 8 !== _n179 || (_t60 = _t60.slice(0, -1)), r += _t60, r += _n179 ? Q.numSep + Q.ones[e % 10] : "";
            }
          }
          return r;
        }
        function i(t) {
          if (0 === t) return Q.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          if (1 === t && n.Grammar.getInstance().getParameter("fraction")) return "un";
          var e = 0,
            r = "";
          for (; t > 0;) {
            t % 1e3 && (r = o(t % 1e3) + (e ? "-" + Q.large[e] + "-" : "") + r), t = Math.floor(t / 1e3), e++;
          }
          return r.replace(/-$/, "");
        }
        function a(t) {
          var e = "m" === n.Grammar.getInstance().getParameter("gender") ? "o" : "a";
          var r = Q.special.onesOrdinals[t];
          return r ? r.slice(0, -1) + e : (r = i(t), r.slice(0, -1) + "esim" + e);
        }
        var Q = (0, r(7549).NUMBERS)();
        Q.wordOrdinal = a, Q.numericOrdinal = function (t) {
          var e = n.Grammar.getInstance().getParameter("gender");
          return t.toString() + ("m" === e ? "o" : "a");
        }, Q.numberToWords = i, Q.numberToOrdinal = function (t, e) {
          if (2 === t) return e ? "mezzi" : "mezzo";
          var r = a(t);
          if (!e) return r;
          var n = r.match(/o$/) ? "i" : "e";
          return r.slice(0, -1) + n;
        }, e.default = Q;
      },
      3720: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          return t.toString().split("").map(function (t) {
            return o.ones[parseInt(t, 10)];
          }).join("");
        }
        var o = (0, r(7549).NUMBERS)();
        o.numberToWords = n, o.numberToOrdinal = n, e.default = o;
      },
      8274: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5897);
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            n = "";
          var o = Math.floor(r / 100),
            a = Q.ones[o];
          if (n += a ? (1 === o ? "" : a) + "hundre" : "", r %= 100, r) {
            if (n += n ? "og" : "", e) {
              var _t61 = Q.special.smallOrdinals[r];
              if (_t61) return n + _t61;
              if (r % 10) return n + Q.tens[Math.floor(r / 10)] + Q.special.smallOrdinals[r % 10];
            }
            n += Q.ones[r] || Q.tens[Math.floor(r / 10)] + (r % 10 ? Q.ones[r % 10] : "");
          }
          return e ? i(n) : n;
        }
        function i(t) {
          var e = Q.special.endOrdinal[0];
          return "a" === e && t.match(/en$/) ? t.slice(0, -2) + Q.special.endOrdinal : t.match(/(d|n)$/) || t.match(/hundre$/) ? t + "de" : t.match(/i$/) ? t + Q.special.endOrdinal : "a" === e && t.match(/e$/) ? t.slice(0, -1) + Q.special.endOrdinal : (t.match(/e$/), t + "nde");
        }
        function a(t) {
          return l(t, !0);
        }
        var Q = (0, r(7549).NUMBERS)();
        function s(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t === Q.ones[1] ? "ein" === t ? "eitt " : e ? "et" : "ett" : t;
        }
        function T(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = t % 1e3,
            n = "",
            o = Q.ones[Math.floor(r / 100)];
          if (n += o ? s(o) + "hundre" : "", r %= 100, r) {
            if (n += n ? "og" : "", e) {
              var _t62 = Q.special.smallOrdinals[r];
              if (_t62) return n + _t62;
            }
            if (o = Q.ones[r], o) n += o;else {
              var _t63 = Q.tens[Math.floor(r / 10)];
              o = Q.ones[r % 10], n += o ? o + "og" + _t63 : _t63;
            }
          }
          return e ? i(n) : n;
        }
        function l(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var r = "alt" === n.default.getInstance().subiso ? function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (0 === t) return e ? Q.special.smallOrdinals[0] : Q.zero;
            if (t >= Math.pow(10, 36)) return t.toString();
            var r = 0,
              n = "";
            for (; t > 0;) {
              var _o17 = t % 1e3;
              if (_o17) {
                var _i22 = T(t % 1e3, !r && e);
                !r && e && (e = !e), n = (1 === r ? s(_i22, !0) : _i22) + (r > 1 ? Q.numSep : "") + (r ? Q.large[r] + (r > 1 && _o17 > 1 ? "er" : "") : "") + (r > 1 && n ? Q.numSep : "") + n;
              }
              t = Math.floor(t / 1e3), r++;
            }
            return e ? n + (n.match(/tusen$/) ? "de" : "te") : n;
          }(t, e) : function (t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
            if (0 === t) return e ? Q.special.smallOrdinals[0] : Q.zero;
            if (t >= Math.pow(10, 36)) return t.toString();
            var r = 0,
              n = "";
            for (; t > 0;) {
              var _i23 = t % 1e3;
              if (_i23) {
                var _a9 = o(t % 1e3, !r && e);
                !r && e && (e = !e), n = _a9 + (r ? " " + Q.large[r] + (r > 1 && _i23 > 1 ? "er" : "") + (n ? " " : "") : "") + n;
              }
              t = Math.floor(t / 1e3), r++;
            }
            return e ? n + (n.match(/tusen$/) ? "de" : "te") : n;
          }(t, e);
          return r;
        }
        Q.wordOrdinal = a, Q.numericOrdinal = function (t) {
          return t.toString() + ".";
        }, Q.numberToWords = l, Q.numberToOrdinal = function (t, e) {
          return a(t);
        }, e.default = Q;
      },
      3898: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        function n(t) {
          var e = t % 1e3,
            r = "";
          var n = Math.floor(e / 100);
          return r += a.ones[n] ? (1 === n ? "" : a.ones[n] + a.numSep) + "hundra" : "", e %= 100, e && (r += r ? a.numSep : "", r += a.ones[e] || a.tens[Math.floor(e / 10)] + (e % 10 ? a.numSep + a.ones[e % 10] : "")), r;
        }
        function o(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (0 === t) return a.zero;
          if (t >= Math.pow(10, 36)) return t.toString();
          var r = 0,
            o = "";
          for (; t > 0;) {
            var _i24 = t % 1e3;
            if (_i24) {
              var Q = a.large[r],
                s = _i24 > 1 && r > 1 && !e ? "er" : "";
              o = (1 === r && 1 === _i24 ? "" : (r > 1 && 1 === _i24 ? "en" : n(t % 1e3)) + (r > 1 ? " " : "")) + (r ? Q + s + (r > 1 ? " " : "") : "") + o;
            }
            t = Math.floor(t / 1e3), r++;
          }
          return o.replace(/ $/, "");
        }
        function i(t) {
          var e = o(t, !0);
          return e.match(/^noll$/) ? e = "nollte" : e.match(/ett$/) ? e = e.replace(/ett$/, "f\xf6rsta") : e.match(/tv\xe5$/) ? e = e.replace(/tv\xe5$/, "andra") : e.match(/tre$/) ? e = e.replace(/tre$/, "tredje") : e.match(/fyra$/) ? e = e.replace(/fyra$/, "fj\xe4rde") : e.match(/fem$/) ? e = e.replace(/fem$/, "femte") : e.match(/sex$/) ? e = e.replace(/sex$/, "sj\xe4tte") : e.match(/sju$/) ? e = e.replace(/sju$/, "sjunde") : e.match(/\xe5tta$/) ? e = e.replace(/\xe5tta$/, "\xe5ttonde") : e.match(/nio$/) ? e = e.replace(/nio$/, "nionde") : e.match(/tio$/) ? e = e.replace(/tio$/, "tionde") : e.match(/elva$/) ? e = e.replace(/elva$/, "elfte") : e.match(/tolv$/) ? e = e.replace(/tolv$/, "tolfte") : e.match(/tusen$/) ? e = e.replace(/tusen$/, "tusonde") : e.match(/jard$/) || e.match(/jon$/) ? e += "te" : e += "de", e;
        }
        var a = (0, r(7549).NUMBERS)();
        a.wordOrdinal = i, a.numericOrdinal = function (t) {
          var e = t.toString();
          return e.match(/11$|12$/) ? e + ":e" : e + (e.match(/1$|2$/) ? ":a" : ":e");
        }, a.numberToWords = o, a.numberToOrdinal = function (t, e) {
          if (1 === t) return "hel";
          if (2 === t) return e ? "halva" : "halv";
          var r = i(t);
          return r = r.match(/de$/) ? r.replace(/de$/, "") : r, r + (e ? "delar" : "del");
        }, e.default = a;
      },
      4977: function _(t, e) {
        function r(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
          if (!t.childNodes || !t.childNodes[0] || !t.childNodes[0].childNodes || t.childNodes[0].childNodes.length < 2 || "number" !== t.childNodes[0].childNodes[0].tagName || "integer" !== t.childNodes[0].childNodes[0].getAttribute("role") || "number" !== t.childNodes[0].childNodes[1].tagName || "integer" !== t.childNodes[0].childNodes[1].getAttribute("role")) return {
            convertible: !1,
            content: t.textContent
          };
          var r = t.childNodes[0].childNodes[1].textContent,
            n = t.childNodes[0].childNodes[0].textContent,
            o = Number(r),
            i = Number(n);
          return isNaN(o) || isNaN(i) ? {
            convertible: !1,
            content: "".concat(n, " ").concat(e, " ").concat(r)
          } : {
            convertible: !0,
            enumerator: i,
            denominator: o
          };
        }
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.vulgarFractionSmall = e.convertVulgarFraction = e.Combiners = e.siCombiner = e.identityTransformer = e.pluralCase = void 0, e.pluralCase = function (t, e) {
          return t.toString();
        }, e.identityTransformer = function (t) {
          return t.toString();
        }, e.siCombiner = function (t, e) {
          return t + e.toLowerCase();
        }, e.Combiners = {}, e.Combiners.identityCombiner = function (t, e, r) {
          return t + e + r;
        }, e.Combiners.prefixCombiner = function (t, e, r) {
          return t = r ? r + " " + t : t, e ? e + " " + t : t;
        }, e.Combiners.postfixCombiner = function (t, e, r) {
          return t = r ? r + " " + t : t, e ? t + " " + e : t;
        }, e.Combiners.romanceCombiner = function (t, e, r) {
          return t = r ? t + " " + r : t, e ? t + " " + e : t;
        }, e.convertVulgarFraction = r, e.vulgarFractionSmall = function (t, e, n) {
          var o = r(t);
          if (o.convertible) {
            var _t64 = o.enumerator,
              _r59 = o.denominator;
            return _t64 > 0 && _t64 < e && _r59 > 0 && _r59 < n;
          }
          return !1;
        };
      },
      4504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Condition = e.BaseRuleStore = void 0;
        var n = r(7052),
          o = r(1676),
          i = r(4650),
          a = r(4106);
        var Q = /*#__PURE__*/function () {
          function Q() {
            _classCallCheck(this, Q);
            this.context = new a.SpeechRuleContext(), this.parseOrder = o.DynamicCstr.DEFAULT_ORDER, this.parser = new o.DynamicCstrParser(this.parseOrder), this.locale = o.DynamicCstr.DEFAULT_VALUES[o.Axis.LOCALE], this.modality = o.DynamicCstr.DEFAULT_VALUES[o.Axis.MODALITY], this.domain = "", this.initialized = !1, this.inherits = null, this.kind = "standard", this.customTranscriptions = {}, this.preconditions = new Map(), this.speechRules_ = [], this.rank = 0, this.parseMethods = {
              Rule: this.defineRule,
              Generator: this.generateRules,
              Action: this.defineAction,
              Precondition: this.definePrecondition,
              Ignore: this.ignoreRules
            };
          }
          _createClass(Q, [{
            key: "defineRule",
            value: function defineRule(t, e, r, n) {
              for (var _len3 = arguments.length, o = new Array(_len3 > 4 ? _len3 - 4 : 0), _key3 = 4; _key3 < _len3; _key3++) {
                o[_key3 - 4] = arguments[_key3];
              }
              var a = this.parseAction(r),
                Q = this.parsePrecondition(n, o),
                s = this.parseCstr(e);
              if (!(a && Q && s)) return console.error("Rule Error: ".concat(n, ", (").concat(e, "): ").concat(r)), null;
              var T = new i.SpeechRule(t, s, Q, a);
              return T.precondition.rank = this.rank++, this.addRule(T), T;
            }
          }, {
            key: "addRule",
            value: function addRule(t) {
              t.context = this.context, this.speechRules_.unshift(t);
            }
          }, {
            key: "deleteRule",
            value: function deleteRule(t) {
              var e = this.speechRules_.indexOf(t);
              -1 !== e && this.speechRules_.splice(e, 1);
            }
          }, {
            key: "findRule",
            value: function findRule(t) {
              for (var _e50, _r60 = 0; _e50 = this.speechRules_[_r60]; _r60++) if (t(_e50)) return _e50;
              return null;
            }
          }, {
            key: "findAllRules",
            value: function findAllRules(t) {
              return this.speechRules_.filter(t);
            }
          }, {
            key: "evaluateDefault",
            value: function evaluateDefault(t) {
              var e = t.textContent.slice(0);
              return e.match(/^\s+$/) ? this.evaluateWhitespace(e) : this.evaluateString(e);
            }
          }, {
            key: "evaluateWhitespace",
            value: function evaluateWhitespace(t) {
              return [];
            }
          }, {
            key: "evaluateCustom",
            value: function evaluateCustom(t) {
              var e = this.customTranscriptions[t];
              return void 0 !== e ? n.AuditoryDescription.create({
                text: e
              }, {
                adjust: !0,
                translate: !1
              }) : null;
            }
          }, {
            key: "evaluateCharacter",
            value: function evaluateCharacter(t) {
              return this.evaluateCustom(t) || n.AuditoryDescription.create({
                text: t
              }, {
                adjust: !0,
                translate: !0
              });
            }
          }, {
            key: "removeDuplicates",
            value: function removeDuplicates(t) {
              for (var _e51, _r61 = this.speechRules_.length - 1; _e51 = this.speechRules_[_r61]; _r61--) _e51 !== t && t.dynamicCstr.equal(_e51.dynamicCstr) && Q.comparePreconditions_(_e51, t) && this.speechRules_.splice(_r61, 1);
            }
          }, {
            key: "getSpeechRules",
            value: function getSpeechRules() {
              return this.speechRules_;
            }
          }, {
            key: "setSpeechRules",
            value: function setSpeechRules(t) {
              this.speechRules_ = t;
            }
          }, {
            key: "getPreconditions",
            value: function getPreconditions() {
              return this.preconditions;
            }
          }, {
            key: "parseCstr",
            value: function parseCstr(t) {
              try {
                return this.parser.parse(this.locale + "." + this.modality + (this.domain ? "." + this.domain : "") + "." + t);
              } catch (e) {
                if ("RuleError" === e.name) return console.error("Rule Error ", "Illegal Dynamic Constraint: ".concat(t, "."), e.message), null;
                throw e;
              }
            }
          }, {
            key: "parsePrecondition",
            value: function parsePrecondition(t, e) {
              try {
                var _r62 = this.parsePrecondition_(t);
                t = _r62[0];
                var _n180 = _r62.slice(1);
                var _iterator9 = _createForOfIteratorHelper(e),
                  _step9;
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _t65 = _step9.value;
                    _n180 = _n180.concat(this.parsePrecondition_(_t65));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
                return _construct(i.Precondition, [t].concat(_toConsumableArray(_n180)));
              } catch (r) {
                if ("RuleError" === r.name) return console.error("Rule Error ", "Illegal preconditions: ".concat(t, ", ").concat(e, "."), r.message), null;
                throw r;
              }
            }
          }, {
            key: "parseAction",
            value: function parseAction(t) {
              try {
                return i.Action.fromString(t);
              } catch (e) {
                if ("RuleError" === e.name) return console.error("Rule Error ", "Illegal action: ".concat(t, "."), e.message), null;
                throw e;
              }
            }
          }, {
            key: "parse",
            value: function parse(t) {
              this.modality = t.modality || this.modality, this.locale = t.locale || this.locale, this.domain = t.domain || this.domain, this.context.parse(t.functions || []), "actions" !== t.kind && (this.kind = t.kind || this.kind, this.inheritRules()), this.parseRules(t.rules || []);
            }
          }, {
            key: "parseRules",
            value: function parseRules(t) {
              for (var _e52, _r63 = 0; _e52 = t[_r63]; _r63++) {
                var _t66 = _e52[0],
                  _r64 = this.parseMethods[_t66];
                _t66 && _r64 && _r64.apply(this, _e52.slice(1));
              }
            }
          }, {
            key: "generateRules",
            value: function generateRules(t) {
              var e = this.context.customGenerators.lookup(t);
              e && e(this);
            }
          }, {
            key: "defineAction",
            value: function defineAction(t, e) {
              var _this31 = this;
              var r;
              try {
                r = i.Action.fromString(e);
              } catch (t) {
                if ("RuleError" === t.name) return void console.error("Action Error ", e, t.message);
                throw t;
              }
              var n = this.getFullPreconditions(t);
              if (!n) return void console.error("Action Error: No precondition for action ".concat(t));
              this.ignoreRules(t);
              var o = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
              n.conditions.forEach(function (_ref11) {
                var _ref12 = _slicedToArray(_ref11, 2),
                  e = _ref12[0],
                  n = _ref12[1];
                var a = _this31.parseCstr(e.toString().replace(o, ""));
                _this31.addRule(new i.SpeechRule(t, a, n, r));
              });
            }
          }, {
            key: "getFullPreconditions",
            value: function getFullPreconditions(t) {
              var e = this.preconditions.get(t);
              return e || !this.inherits ? e : this.inherits.getFullPreconditions(t);
            }
          }, {
            key: "definePrecondition",
            value: function definePrecondition(t, e, r) {
              for (var _len4 = arguments.length, n = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
                n[_key4 - 3] = arguments[_key4];
              }
              var o = this.parsePrecondition(r, n),
                i = this.parseCstr(e);
              o && i ? (o.rank = this.rank++, this.preconditions.set(t, new s(i, o))) : console.error("Precondition Error: ".concat(r, ", (").concat(e, ")"));
            }
          }, {
            key: "inheritRules",
            value: function inheritRules() {
              var _this32 = this;
              if (!this.inherits || !this.inherits.getSpeechRules().length) return;
              var t = new RegExp("^\\w+\\.\\w+\\." + (this.domain ? "\\w+\\." : ""));
              this.inherits.getSpeechRules().forEach(function (e) {
                var r = _this32.parseCstr(e.dynamicCstr.toString().replace(t, ""));
                _this32.addRule(new i.SpeechRule(e.name, r, e.precondition, e.action));
              });
            }
          }, {
            key: "ignoreRules",
            value: function ignoreRules(t) {
              var r = this.findAllRules(function (e) {
                return e.name === t;
              });
              for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                e[_key5 - 1] = arguments[_key5];
              }
              if (!e.length) return void r.forEach(this.deleteRule.bind(this));
              var n = [];
              for (var _i25 = 0, _e53 = e; _i25 < _e53.length; _i25++) {
                var _t67 = _e53[_i25];
                var _e54 = this.parseCstr(_t67);
                var _iterator10 = _createForOfIteratorHelper(r),
                  _step10;
                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    var _t68 = _step10.value;
                    _e54.equal(_t68.dynamicCstr) ? this.deleteRule(_t68) : n.push(_t68);
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }
                r = n, n = [];
              }
            }
          }, {
            key: "parsePrecondition_",
            value: function parsePrecondition_(t) {
              var e = this.context.customGenerators.lookup(t);
              return e ? e() : [t];
            }
          }], [{
            key: "compareStaticConstraints_",
            value: function compareStaticConstraints_(t, e) {
              if (t.length !== e.length) return !1;
              for (var _r65, _n181 = 0; _r65 = t[_n181]; _n181++) if (-1 === e.indexOf(_r65)) return !1;
              return !0;
            }
          }, {
            key: "comparePreconditions_",
            value: function comparePreconditions_(t, e) {
              var r = t.precondition,
                n = e.precondition;
              return r.query === n.query && Q.compareStaticConstraints_(r.constraints, n.constraints);
            }
          }]);
          return Q;
        }();
        e.BaseRuleStore = Q;
        var s = /*#__PURE__*/function () {
          function s(t, e) {
            _classCallCheck(this, s);
            this.base = t, this._conditions = [], this.constraints = [], this.allCstr = {}, this.constraints.push(t), this.addCondition(t, e);
          }
          _createClass(s, [{
            key: "addConstraint",
            value: function addConstraint(t) {
              if (this.constraints.filter(function (e) {
                return e.equal(t);
              }).length) return;
              this.constraints.push(t);
              var e = [];
              var _iterator11 = _createForOfIteratorHelper(this.conditions),
                _step11;
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var _step11$value = _slicedToArray(_step11.value, 2),
                    _r66 = _step11$value[0],
                    _n182 = _step11$value[1];
                  this.base.equal(_r66) && e.push([t, _n182]);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              this._conditions = this._conditions.concat(e);
            }
          }, {
            key: "addBaseCondition",
            value: function addBaseCondition(t) {
              this.addCondition(this.base, t);
            }
          }, {
            key: "addFullCondition",
            value: function addFullCondition(t) {
              var _this33 = this;
              this.constraints.forEach(function (e) {
                return _this33.addCondition(e, t);
              });
            }
          }, {
            key: "addCondition",
            value: function addCondition(t, e) {
              var r = t.toString() + " " + e.toString();
              this.allCstr.condStr || (this.allCstr[r] = !0, this._conditions.push([t, e]));
            }
          }, {
            key: "conditions",
            get: function get() {
              return this._conditions;
            }
          }]);
          return s;
        }();
        e.Condition = s;
      },
      2469: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BrailleStore = void 0;
        var n = r(7630),
          o = r(9935);
        var i = /*#__PURE__*/function (_o$MathStore) {
          _inherits(i, _o$MathStore);
          function i() {
            var _this34;
            _classCallCheck(this, i);
            _this34 = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this34.modality = "braille", _this34.customTranscriptions = {
              "\u22CA": "\u2808\u2821\u2833"
            };
            return _this34;
          }
          _createClass(i, [{
            key: "evaluateString",
            value: function evaluateString(t) {
              var e = [],
                r = Array.from(t);
              for (var _t69 = 0; _t69 < r.length; _t69++) e.push(this.evaluateCharacter(r[_t69]));
              return e;
            }
          }, {
            key: "annotations",
            value: function annotations() {
              for (var _t70, _e55 = 0; _t70 = this.annotators[_e55]; _e55++) (0, n.activate)(this.locale, _t70);
            }
          }]);
          return i;
        }(o.MathStore);
        e.BrailleStore = i;
      },
      1676: function _(t, e) {
        var r;
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DefaultComparator = e.DynamicCstrParser = e.DynamicCstr = e.DynamicProperties = e.Axis = void 0, function (t) {
          t.DOMAIN = "domain", t.STYLE = "style", t.LOCALE = "locale", t.TOPIC = "topic", t.MODALITY = "modality";
        }(r = e.Axis || (e.Axis = {}));
        var n = /*#__PURE__*/function () {
          function n(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.keys(t);
            _classCallCheck(this, n);
            this.properties = t, this.order = e;
          }
          _createClass(n, [{
            key: "getProperties",
            value: function getProperties() {
              return this.properties;
            }
          }, {
            key: "getOrder",
            value: function getOrder() {
              return this.order;
            }
          }, {
            key: "getAxes",
            value: function getAxes() {
              return this.order;
            }
          }, {
            key: "getProperty",
            value: function getProperty(t) {
              return this.properties[t];
            }
          }, {
            key: "updateProperties",
            value: function updateProperties(t) {
              this.properties = t;
            }
          }, {
            key: "allProperties",
            value: function allProperties() {
              var _this35 = this;
              var t = [];
              return this.order.forEach(function (e) {
                return t.push(_this35.getProperty(e).slice());
              }), t;
            }
          }, {
            key: "toString",
            value: function toString() {
              var _this36 = this;
              var t = [];
              return this.order.forEach(function (e) {
                return t.push(e + ": " + _this36.getProperty(e).toString());
              }), t.join("\n");
            }
          }], [{
            key: "createProp",
            value: function createProp() {
              var e = o.DEFAULT_ORDER,
                r = {};
              for (var _n183 = 0, _o18 = arguments.length, i = e.length; _n183 < _o18 && _n183 < i; _n183++) r[e[_n183]] = _n183 < 0 || arguments.length <= _n183 ? undefined : arguments[_n183];
              return new n(r);
            }
          }]);
          return n;
        }();
        e.DynamicProperties = n;
        var o = /*#__PURE__*/function (_n184) {
          _inherits(o, _n184);
          function o(t, e) {
            var _this37;
            _classCallCheck(this, o);
            var r = {};
            for (var _i26 = 0, _Object$entries4 = Object.entries(t); _i26 < _Object$entries4.length; _i26++) {
              var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i26], 2),
                _e56 = _Object$entries4$_i[0],
                _n185 = _Object$entries4$_i[1];
              r[_e56] = [_n185];
            }
            _this37 = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, r, e)), _this37.components = t;
            return _this37;
          }
          _createClass(o, [{
            key: "getComponents",
            value: function getComponents() {
              return this.components;
            }
          }, {
            key: "getValue",
            value: function getValue(t) {
              return this.components[t];
            }
          }, {
            key: "getValues",
            value: function getValues() {
              var _this38 = this;
              return this.order.map(function (t) {
                return _this38.getValue(t);
              });
            }
          }, {
            key: "allProperties",
            value: function allProperties() {
              var t = _superPropGet(o, "allProperties", this, 3)([]);
              for (var _e57, _r67, _n186 = 0; _e57 = t[_n186], _r67 = this.order[_n186]; _n186++) {
                var _t71 = this.getValue(_r67);
                -1 === _e57.indexOf(_t71) && _e57.unshift(_t71);
              }
              return t;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.getValues().join(".");
            }
          }, {
            key: "equal",
            value: function equal(t) {
              var e = t.getAxes();
              if (this.order.length !== e.length) return !1;
              for (var _r68, _n187 = 0; _r68 = e[_n187]; _n187++) {
                var _e58 = this.getValue(_r68);
                if (!_e58 || t.getValue(_r68) !== _e58) return !1;
              }
              return !0;
            }
          }], [{
            key: "createCstr",
            value: function createCstr() {
              var e = o.DEFAULT_ORDER,
                r = {};
              for (var _n188 = 0, _o19 = arguments.length, i = e.length; _n188 < _o19 && _n188 < i; _n188++) r[e[_n188]] = _n188 < 0 || arguments.length <= _n188 ? undefined : arguments[_n188];
              return new o(r);
            }
          }, {
            key: "defaultCstr",
            value: function defaultCstr() {
              return o.createCstr.apply(null, o.DEFAULT_ORDER.map(function (t) {
                return o.DEFAULT_VALUES[t];
              }));
            }
          }, {
            key: "validOrder",
            value: function validOrder(t) {
              var e = o.DEFAULT_ORDER.slice();
              return t.every(function (t) {
                var r = e.indexOf(t);
                return -1 !== r && e.splice(r, 1);
              });
            }
          }]);
          return o;
        }(n);
        e.DynamicCstr = o, o.DEFAULT_ORDER = [r.LOCALE, r.MODALITY, r.DOMAIN, r.STYLE, r.TOPIC], o.BASE_LOCALE = "base", o.DEFAULT_VALUE = "default", o.DEFAULT_VALUES = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, r.LOCALE, "en"), r.DOMAIN, o.DEFAULT_VALUE), r.STYLE, o.DEFAULT_VALUE), r.TOPIC, o.DEFAULT_VALUE), r.MODALITY, "speech");
        e.DynamicCstrParser = /*#__PURE__*/function () {
          function _class7(t) {
            _classCallCheck(this, _class7);
            this.order = t;
          }
          _createClass(_class7, [{
            key: "parse",
            value: function parse(t) {
              var e = t.split("."),
                r = {};
              if (e.length > this.order.length) throw new Error("Invalid dynamic constraint: " + r);
              var n = 0;
              for (var _t72, _o20 = 0; _t72 = this.order[_o20], e.length; _o20++, n++) {
                var _n189 = e.shift();
                r[_t72] = _n189;
              }
              return new o(r, this.order.slice(0, n));
            }
          }]);
          return _class7;
        }();
        e.DefaultComparator = /*#__PURE__*/function () {
          function _class8(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new n(t.getProperties(), t.getOrder());
            _classCallCheck(this, _class8);
            this.reference = t, this.fallback = e, this.order = this.reference.getOrder();
          }
          _createClass(_class8, [{
            key: "getReference",
            value: function getReference() {
              return this.reference;
            }
          }, {
            key: "setReference",
            value: function setReference(t, e) {
              this.reference = t, this.fallback = e || new n(t.getProperties(), t.getOrder()), this.order = this.reference.getOrder();
            }
          }, {
            key: "match",
            value: function match(t) {
              var _this39 = this;
              var e = t.getAxes();
              return e.length === this.reference.getAxes().length && e.every(function (e) {
                var r = t.getValue(e);
                return r === _this39.reference.getValue(e) || -1 !== _this39.fallback.getProperty(e).indexOf(r);
              });
            }
          }, {
            key: "compare",
            value: function compare(t, e) {
              var r = !1;
              for (var _n190, _o21 = 0; _n190 = this.order[_o21]; _o21++) {
                var _o22 = t.getValue(_n190),
                  i = e.getValue(_n190);
                if (!r) {
                  var _t73 = this.reference.getValue(_n190);
                  if (_t73 === _o22 && _t73 !== i) return -1;
                  if (_t73 === i && _t73 !== _o22) return 1;
                  if (_t73 === _o22 && _t73 === i) continue;
                  _t73 !== _o22 && _t73 !== i && (r = !0);
                }
                var a = this.fallback.getProperty(_n190),
                  Q = a.indexOf(_o22),
                  s = a.indexOf(i);
                if (Q < s) return -1;
                if (s < Q) return 1;
              }
              return 0;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.reference.toString() + "\n" + this.fallback.toString();
            }
          }]);
          return _class8;
        }();
      },
      2105: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.numbersToAlpha = e.Grammar = e.ATTRIBUTE = void 0;
        var n = r(5740),
          o = r(5897),
          i = r(2536),
          a = r(4356);
        e.ATTRIBUTE = "grammar";
        var Q = /*#__PURE__*/function () {
          function Q() {
            _classCallCheck(this, Q);
            this.currentFlags = {}, this.parameters_ = {}, this.corrections_ = {}, this.preprocessors_ = {}, this.stateStack_ = [];
          }
          _createClass(Q, [{
            key: "clear",
            value: function clear() {
              this.parameters_ = {}, this.stateStack_ = [];
            }
          }, {
            key: "setParameter",
            value: function setParameter(t, e) {
              var r = this.parameters_[t];
              return e ? this.parameters_[t] = e : delete this.parameters_[t], r;
            }
          }, {
            key: "getParameter",
            value: function getParameter(t) {
              return this.parameters_[t];
            }
          }, {
            key: "setCorrection",
            value: function setCorrection(t, e) {
              this.corrections_[t] = e;
            }
          }, {
            key: "setPreprocessor",
            value: function setPreprocessor(t, e) {
              this.preprocessors_[t] = e;
            }
          }, {
            key: "getCorrection",
            value: function getCorrection(t) {
              return this.corrections_[t];
            }
          }, {
            key: "getState",
            value: function getState() {
              var t = [];
              for (var _e59 in this.parameters_) {
                var _r69 = this.parameters_[_e59];
                t.push("string" == typeof _r69 ? _e59 + ":" + _r69 : _e59);
              }
              return t.join(" ");
            }
          }, {
            key: "pushState",
            value: function pushState(t) {
              for (var _e60 in t) t[_e60] = this.setParameter(_e60, t[_e60]);
              this.stateStack_.push(t);
            }
          }, {
            key: "popState",
            value: function popState() {
              var t = this.stateStack_.pop();
              for (var _e61 in t) this.setParameter(_e61, t[_e61]);
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(t) {
              if (t && t.nodeType === n.NodeType.ELEMENT_NODE) {
                var _r70 = this.getState();
                _r70 && t.setAttribute(e.ATTRIBUTE, _r70);
              }
            }
          }, {
            key: "preprocess",
            value: function preprocess(t) {
              return this.runProcessors_(t, this.preprocessors_);
            }
          }, {
            key: "correct",
            value: function correct(t) {
              return this.runProcessors_(t, this.corrections_);
            }
          }, {
            key: "apply",
            value: function apply(t, e) {
              return this.currentFlags = e || {}, t = this.currentFlags.adjust || this.currentFlags.preprocess ? Q.getInstance().preprocess(t) : t, (this.parameters_.translate || this.currentFlags.translate) && (t = Q.translateString_(t)), t = this.currentFlags.adjust || this.currentFlags.correct ? Q.getInstance().correct(t) : t, this.currentFlags = {}, t;
            }
          }, {
            key: "runProcessors_",
            value: function runProcessors_(t, e) {
              for (var _r71 in this.parameters_) {
                var _n191 = e[_r71];
                if (!_n191) continue;
                var _o23 = this.parameters_[_r71];
                t = !0 === _o23 ? _n191(t) : _n191(t, _o23);
              }
              return t;
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return Q.instance = Q.instance || new Q(), Q.instance;
            }
          }, {
            key: "parseInput",
            value: function parseInput(t) {
              var e = {},
                r = t.split(":");
              for (var _t74 = 0, _n192 = r.length; _t74 < _n192; _t74++) {
                var _n193 = r[_t74].split("="),
                  _o24 = _n193[0].trim();
                _n193[1] ? e[_o24] = _n193[1].trim() : _o24.match(/^!/) ? e[_o24.slice(1)] = !1 : e[_o24] = !0;
              }
              return e;
            }
          }, {
            key: "parseState",
            value: function parseState(t) {
              var e = {},
                r = t.split(" ");
              for (var _t75 = 0, _n194 = r.length; _t75 < _n194; _t75++) {
                var _n195 = r[_t75].split(":"),
                  _o25 = _n195[0],
                  _i27 = _n195[1];
                e[_o25] = _i27 || !0;
              }
              return e;
            }
          }, {
            key: "translateString_",
            value: function translateString_(t) {
              if (t.match(/:unit$/)) return Q.translateUnit_(t);
              var e = o.default.getInstance();
              var r = e.evaluator(t, e.dynamicCstr);
              return r = null === r ? t : r, Q.getInstance().getParameter("plural") && (r = a.LOCALE.FUNCTIONS.plural(r)), r;
            }
          }, {
            key: "translateUnit_",
            value: function translateUnit_(t) {
              t = Q.prepareUnit_(t);
              var e = o.default.getInstance(),
                r = Q.getInstance().getParameter("plural"),
                n = e.strict,
                i = "".concat(e.locale, ".").concat(e.modality, ".default");
              var s, T;
              return e.strict = !0, r && (s = e.defaultParser.parse(i + ".plural"), T = e.evaluator(t, s)), T ? (e.strict = n, T) : (s = e.defaultParser.parse(i + ".default"), T = e.evaluator(t, s), e.strict = n, T ? (r && (T = a.LOCALE.FUNCTIONS.plural(T)), T) : Q.cleanUnit_(t));
            }
          }, {
            key: "prepareUnit_",
            value: function prepareUnit_(t) {
              var e = t.match(/:unit$/);
              return e ? t.slice(0, e.index).replace(/\s+/g, " ") + t.slice(e.index) : t;
            }
          }, {
            key: "cleanUnit_",
            value: function cleanUnit_(t) {
              return t.match(/:unit$/) ? t.replace(/:unit$/, "") : t;
            }
          }]);
          return Q;
        }();
        function s(t, e) {
          if (!e || !t) return t;
          var r = a.LOCALE.FUNCTIONS.fontRegexp(i.localFont(e));
          return t.replace(r, "");
        }
        function T(t) {
          return t.match(/\d+/) ? a.LOCALE.NUMBERS.numberToWords(parseInt(t, 10)) : t;
        }
        e.Grammar = Q, e.numbersToAlpha = T, Q.getInstance().setCorrection("localFont", i.localFont), Q.getInstance().setCorrection("localRole", i.localRole), Q.getInstance().setCorrection("localEnclose", i.localEnclose), Q.getInstance().setCorrection("ignoreFont", s), Q.getInstance().setPreprocessor("annotation", function (t, e) {
          return t + ":" + e;
        }), Q.getInstance().setPreprocessor("noTranslateText", function (t) {
          return t.match(new RegExp("^[" + a.LOCALE.MESSAGES.regexp.TEXT + "]+$")) && (Q.getInstance().currentFlags.translate = !1), t;
        }), Q.getInstance().setCorrection("ignoreCaps", function (t) {
          var e = a.LOCALE.ALPHABETS.capPrefix[o.default.getInstance().domain];
          return void 0 === e && (e = a.LOCALE.ALPHABETS.capPrefix.default), s(t, e);
        }), Q.getInstance().setPreprocessor("numbers2alpha", T);
      },
      2780: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.enumerate = e.lookupString = e.lookupCategory = e.lookupRule = e.addSiUnitRules = e.addUnitRules = e.addFunctionRules = e.addSymbolRules = e.defineRule = e.defineRules = e.setSiPrefixes = void 0;
        var n = r(2057),
          o = r(5897),
          i = r(7491),
          a = r(4658),
          Q = r(1676);
        var s = Q.DynamicCstr.DEFAULT_VALUES[Q.Axis.LOCALE],
          T = Q.DynamicCstr.DEFAULT_VALUES[Q.Axis.MODALITY],
          l = {};
        e.setSiPrefixes = function (t) {
          l = t;
        };
        var c = {};
        function u(t, e, r, n) {
          var o = g(e);
          v(o, r), o.defineRulesFromMappings(t, s, T, e, n);
        }
        function p(t) {
          if (y(t)) return;
          var e = t.names,
            r = t.mappings,
            n = t.category;
          for (var _t76, _o26 = 0; _t76 = e[_o26]; _o26++) u(_t76, _t76, n, r);
        }
        function h(t) {
          var _loop5 = function _loop5() {
            var e = _Object$keys[_i28];
            var r = Object.assign({}, t);
            r.mappings = {};
            var n = l[e];
            r.key = e + r.key, r.names = r.names.map(function (t) {
              return e + t;
            });
            for (var _i29 = 0, _Object$keys2 = Object.keys(t.mappings); _i29 < _Object$keys2.length; _i29++) {
              var _e62 = _Object$keys2[_i29];
              r.mappings[_e62] = {};
              for (var _i30 = 0, _Object$keys3 = Object.keys(t.mappings[_e62]); _i30 < _Object$keys3.length; _i30++) {
                var _o27 = _Object$keys3[_i30];
                r.mappings[_e62][_o27] = i.locales[s]().FUNCTIONS.si(n, t.mappings[_e62][_o27]);
              }
            }
            L(r);
          };
          for (var _i28 = 0, _Object$keys = Object.keys(l); _i28 < _Object$keys.length; _i28++) {
            _loop5();
          }
          L(t);
        }
        function d(t, e) {
          var r = c[t];
          return r ? r.lookupRule(null, e) : null;
        }
        function f(t, e) {
          var r = d(t, e);
          return r ? r.action : null;
        }
        function m(t, e) {
          return e = e || {}, t.length ? (e[t[0]] = m(t.slice(1), e[t[0]]), e) : e;
        }
        function L(t) {
          var e = t.names;
          e && (t.names = e.map(function (t) {
            return t + ":unit";
          })), p(t);
        }
        function y(t) {
          return !(!t.locale && !t.modality) && (s = t.locale || s, T = t.modality || T, !0);
        }
        function g(t) {
          var e = c[t];
          return e ? (n.Debugger.getInstance().output("Store exists! " + t), e) : (e = new a.MathSimpleStore(), c[t] = e, e);
        }
        function v(t, e) {
          e && (t.category = e);
        }
        e.defineRules = u, e.defineRule = function (t, e, r, n, o, i) {
          var a = g(o);
          v(a, n), a.defineRuleFromStrings(t, s, T, e, r, o, i);
        }, e.addSymbolRules = function (t) {
          if (y(t)) return;
          var e = a.MathSimpleStore.parseUnicode(t.key);
          u(t.key, e, t.category, t.mappings);
        }, e.addFunctionRules = p, e.addUnitRules = function (t) {
          y(t) || (t.si ? h(t) : L(t));
        }, e.addSiUnitRules = h, e.lookupRule = d, e.lookupCategory = function (t) {
          var e = c[t];
          return e ? e.category : "";
        }, e.lookupString = f, o.default.getInstance().evaluator = f, e.enumerate = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          for (var _i31 = 0, _Object$values = Object.values(c); _i31 < _Object$values.length; _i31++) {
            var _e63 = _Object$values[_i31];
            var _iterator12 = _createForOfIteratorHelper(_e63.rules.entries()),
              _step12;
            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _step12$value = _slicedToArray(_step12.value, 2),
                  _r72 = _step12$value[1];
                var _iterator13 = _createForOfIteratorHelper(_r72),
                  _step13;
                try {
                  for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                    var _e64 = _step13.value.cstr;
                    t = m(_e64.getValues(), t);
                  }
                } catch (err) {
                  _iterator13.e(err);
                } finally {
                  _iterator13.f();
                }
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }
          }
          return t;
        };
      },
      4658: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathSimpleStore = void 0;
        var n = r(5897),
          o = r(1676);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.category = "", this.rules = new Map();
          }
          _createClass(i, [{
            key: "defineRulesFromMappings",
            value: function defineRulesFromMappings(t, e, r, n, o) {
              for (var _i32 in o) for (var a in o[_i32]) {
                var Q = o[_i32][a];
                this.defineRuleFromStrings(t, e, r, _i32, a, n, Q);
              }
            }
          }, {
            key: "getRules",
            value: function getRules(t) {
              var e = this.rules.get(t);
              return e || (e = [], this.rules.set(t, e)), e;
            }
          }, {
            key: "defineRuleFromStrings",
            value: function defineRuleFromStrings(t, e, r, o, i, a, Q) {
              var s = this.getRules(e);
              var T = n.default.getInstance().parsers[o] || n.default.getInstance().defaultParser,
                l = n.default.getInstance().comparators[o],
                c = "".concat(e, ".").concat(r, ".").concat(o, ".").concat(i),
                u = T.parse(c),
                p = l ? l() : n.default.getInstance().comparator,
                h = p.getReference();
              p.setReference(u);
              var d = {
                cstr: u,
                action: Q
              };
              s = s.filter(function (t) {
                return !u.equal(t.cstr);
              }), s.push(d), this.rules.set(e, s), p.setReference(h);
            }
          }, {
            key: "lookupRule",
            value: function lookupRule(t, e) {
              var r = this.getRules(e.getValue(o.Axis.LOCALE));
              return r = r.filter(function (t) {
                return i.testDynamicConstraints_(e, t);
              }), 1 === r.length ? r[0] : r.length ? r.sort(function (t, e) {
                return n.default.getInstance().comparator.compare(t.cstr, e.cstr);
              })[0] : null;
            }
          }], [{
            key: "parseUnicode",
            value: function parseUnicode(t) {
              var e = parseInt(t, 16);
              return String.fromCodePoint(e);
            }
          }, {
            key: "testDynamicConstraints_",
            value: function testDynamicConstraints_(t, e) {
              return n.default.getInstance().strict ? e.cstr.equal(t) : n.default.getInstance().comparator.match(e.cstr);
            }
          }]);
          return i;
        }();
        e.MathSimpleStore = i;
      },
      9935: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathStore = void 0;
        var n = r(707),
          o = r(4356),
          i = r(7630),
          a = r(4504),
          Q = r(4650);
        var s = /*#__PURE__*/function (_a$BaseRuleStore) {
          _inherits(s, _a$BaseRuleStore);
          function s() {
            var _this40;
            _classCallCheck(this, s);
            _this40 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this)), _this40.annotators = [], _this40.parseMethods.Alias = _this40.defineAlias, _this40.parseMethods.SpecializedRule = _this40.defineSpecializedRule, _this40.parseMethods.Specialized = _this40.defineSpecialized;
            return _this40;
          }
          _createClass(s, [{
            key: "initialize",
            value: function initialize() {
              this.initialized || (this.annotations(), this.initialized = !0);
            }
          }, {
            key: "annotations",
            value: function annotations() {
              for (var _t77, _e65 = 0; _t77 = this.annotators[_e65]; _e65++) (0, i.activate)(this.domain, _t77);
            }
          }, {
            key: "defineAlias",
            value: function defineAlias(t, e) {
              for (var _len6 = arguments.length, r = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
                r[_key6 - 2] = arguments[_key6];
              }
              var n = this.parsePrecondition(e, r);
              if (!n) return void console.error("Precondition Error: ".concat(e, " ").concat(r));
              var o = this.preconditions.get(t);
              o ? o.addFullCondition(n) : console.error("Alias Error: No precondition by the name of ".concat(t));
            }
          }, {
            key: "defineRulesAlias",
            value: function defineRulesAlias(t, e) {
              var _this41 = this;
              for (var _len7 = arguments.length, r = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
                r[_key7 - 2] = arguments[_key7];
              }
              var n = this.findAllRules(function (e) {
                return e.name === t;
              });
              if (0 === n.length) throw new Q.OutputError("Rule with name " + t + " does not exist.");
              var o = [];
              n.forEach(function (t) {
                (function (t) {
                  var e = t.dynamicCstr.toString(),
                    r = t.action.toString();
                  for (var _t78, _n196 = 0; _t78 = o[_n196]; _n196++) if (_t78.action === r && _t78.cstr === e) return !1;
                  return o.push({
                    cstr: e,
                    action: r
                  }), !0;
                })(t) && _this41.addAlias_(t, e, r);
              });
            }
          }, {
            key: "defineSpecializedRule",
            value: function defineSpecializedRule(t, e, r, n) {
              var o = this.parseCstr(e),
                i = this.findRule(function (e) {
                  return e.name === t && o.equal(e.dynamicCstr);
                }),
                a = this.parseCstr(r);
              if (!i && n) throw new Q.OutputError("Rule named " + t + " with style " + e + " does not exist.");
              var s = n ? Q.Action.fromString(n) : i.action,
                T = new Q.SpeechRule(i.name, a, i.precondition, s);
              this.addRule(T);
            }
          }, {
            key: "defineSpecialized",
            value: function defineSpecialized(t, e, r) {
              var n = this.parseCstr(r);
              if (!n) return void console.error("Dynamic Constraint Error: ".concat(r));
              var o = this.preconditions.get(t);
              o ? o.addConstraint(n) : console.error("Alias Error: No precondition by the name of ".concat(t));
            }
          }, {
            key: "evaluateString",
            value: function evaluateString(t) {
              var e = [];
              if (t.match(/^\s+$/)) return e;
              var r = this.matchNumber_(t);
              if (r && r.length === t.length) return e.push(this.evaluateCharacter(r.number)), e;
              var i = n.removeEmpty(t.replace(/\s/g, " ").split(" "));
              for (var _t79, _n197 = 0; _t79 = i[_n197]; _n197++) if (1 === _t79.length) e.push(this.evaluateCharacter(_t79));else if (_t79.match(new RegExp("^[" + o.LOCALE.MESSAGES.regexp.TEXT + "]+$"))) e.push(this.evaluateCharacter(_t79));else {
                var _n198 = _t79;
                for (; _n198;) {
                  r = this.matchNumber_(_n198);
                  var _t80 = _n198.match(new RegExp("^[" + o.LOCALE.MESSAGES.regexp.TEXT + "]+"));
                  if (r) e.push(this.evaluateCharacter(r.number)), _n198 = _n198.substring(r.length);else if (_t80) e.push(this.evaluateCharacter(_t80[0])), _n198 = _n198.substring(_t80[0].length);else {
                    var _t81 = Array.from(_n198),
                      _r73 = _t81[0];
                    e.push(this.evaluateCharacter(_r73)), _n198 = _t81.slice(1).join("");
                  }
                }
              }
              return e;
            }
          }, {
            key: "parse",
            value: function parse(t) {
              _superPropGet(s, "parse", this, 3)([t]), this.annotators = t.annotators || [];
            }
          }, {
            key: "addAlias_",
            value: function addAlias_(t, e, r) {
              var n = this.parsePrecondition(e, r),
                o = new Q.SpeechRule(t.name, t.dynamicCstr, n, t.action);
              o.name = t.name, this.addRule(o);
            }
          }, {
            key: "matchNumber_",
            value: function matchNumber_(t) {
              var e = t.match(new RegExp("^" + o.LOCALE.MESSAGES.regexp.NUMBER)),
                r = t.match(new RegExp("^" + s.regexp.NUMBER));
              if (!e && !r) return null;
              var n = r && r[0] === t;
              if (e && e[0] === t || !n) return e ? {
                number: e[0],
                length: e[0].length
              } : null;
              return {
                number: r[0].replace(new RegExp(s.regexp.DIGIT_GROUP, "g"), "X").replace(new RegExp(s.regexp.DECIMAL_MARK, "g"), o.LOCALE.MESSAGES.regexp.DECIMAL_MARK).replace(/X/g, o.LOCALE.MESSAGES.regexp.DIGIT_GROUP.replace(/\\/g, "")),
                length: r[0].length
              };
            }
          }]);
          return s;
        }(a.BaseRuleStore);
        e.MathStore = s, s.regexp = {
          NUMBER: "((\\d{1,3})(?=(,| ))((,| )\\d{3})*(\\.\\d+)?)|^\\d*\\.\\d+|^\\d+",
          DECIMAL_MARK: "\\.",
          DIGIT_GROUP: ","
        };
      },
      4650: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.OutputError = e.Precondition = e.Action = e.Component = e.ActionType = e.SpeechRule = void 0;
        var n = r(5897),
          o = r(2105);
        var i;
        function a(t) {
          switch (t) {
            case "[n]":
              return i.NODE;
            case "[m]":
              return i.MULTI;
            case "[t]":
              return i.TEXT;
            case "[p]":
              return i.PERSONALITY;
            default:
              throw "Parse error: " + t;
          }
        }
        e.SpeechRule = /*#__PURE__*/function () {
          function _class9(t, e, r, n) {
            _classCallCheck(this, _class9);
            this.name = t, this.dynamicCstr = e, this.precondition = r, this.action = n, this.context = null;
          }
          _createClass(_class9, [{
            key: "toString",
            value: function toString() {
              return this.name + " | " + this.dynamicCstr.toString() + " | " + this.precondition.toString() + " ==> " + this.action.toString();
            }
          }]);
          return _class9;
        }(), function (t) {
          t.NODE = "NODE", t.MULTI = "MULTI", t.TEXT = "TEXT", t.PERSONALITY = "PERSONALITY";
        }(i = e.ActionType || (e.ActionType = {}));
        var Q = /*#__PURE__*/function () {
          function Q(_ref13) {
            var t = _ref13.type,
              e = _ref13.content,
              r = _ref13.attributes,
              n = _ref13.grammar;
            _classCallCheck(this, Q);
            this.type = t, this.content = e, this.attributes = r, this.grammar = n;
          }
          _createClass(Q, [{
            key: "toString",
            value: function toString() {
              var t = "";
              t += function (t) {
                switch (t) {
                  case i.NODE:
                    return "[n]";
                  case i.MULTI:
                    return "[m]";
                  case i.TEXT:
                    return "[t]";
                  case i.PERSONALITY:
                    return "[p]";
                  default:
                    throw "Unknown type error: " + t;
                }
              }(this.type), t += this.content ? " " + this.content : "";
              var e = this.attributesToString();
              return t += e ? " " + e : "", t;
            }
          }, {
            key: "grammarToString",
            value: function grammarToString() {
              return this.getGrammar().join(":");
            }
          }, {
            key: "getGrammar",
            value: function getGrammar() {
              var t = [];
              for (var _e66 in this.grammar) !0 === this.grammar[_e66] ? t.push(_e66) : !1 === this.grammar[_e66] ? t.push("!" + _e66) : t.push(_e66 + "=" + this.grammar[_e66]);
              return t;
            }
          }, {
            key: "attributesToString",
            value: function attributesToString() {
              var t = this.getAttributes(),
                e = this.grammarToString();
              return e && t.push("grammar:" + e), t.length > 0 ? "(" + t.join(", ") + ")" : "";
            }
          }, {
            key: "getAttributes",
            value: function getAttributes() {
              var t = [];
              for (var _e67 in this.attributes) {
                var _r74 = this.attributes[_e67];
                "true" === _r74 ? t.push(_e67) : t.push(_e67 + ":" + _r74);
              }
              return t;
            }
          }], [{
            key: "grammarFromString",
            value: function grammarFromString(t) {
              return o.Grammar.parseInput(t);
            }
          }, {
            key: "fromString",
            value: function fromString(t) {
              var e = {
                type: a(t.substring(0, 3))
              };
              var r = t.slice(3).trim();
              if (!r) throw new l("Missing content.");
              switch (e.type) {
                case i.TEXT:
                  if ('"' === r[0]) {
                    var _t82 = c(r, "\\(")[0].trim();
                    if ('"' !== _t82.slice(-1)) throw new l("Invalid string syntax.");
                    e.content = _t82, r = r.slice(_t82.length).trim(), -1 === r.indexOf("(") && (r = "");
                    break;
                  }
                case i.NODE:
                case i.MULTI:
                  {
                    var _t83 = r.indexOf(" (");
                    if (-1 === _t83) {
                      e.content = r.trim(), r = "";
                      break;
                    }
                    e.content = r.substring(0, _t83).trim(), r = r.slice(_t83).trim();
                  }
              }
              if (r) {
                var _t84 = Q.attributesFromString(r);
                _t84.grammar && (e.grammar = _t84.grammar, delete _t84.grammar), Object.keys(_t84).length && (e.attributes = _t84);
              }
              return new Q(e);
            }
          }, {
            key: "attributesFromString",
            value: function attributesFromString(t) {
              if ("(" !== t[0] || ")" !== t.slice(-1)) throw new l("Invalid attribute expression: " + t);
              var e = {},
                r = c(t.slice(1, -1), ",");
              for (var _t85 = 0, _n199 = r.length; _t85 < _n199; _t85++) {
                var _n200 = r[_t85],
                  _i33 = _n200.indexOf(":");
                if (-1 === _i33) e[_n200.trim()] = "true";else {
                  var _t86 = _n200.substring(0, _i33).trim(),
                    _r75 = _n200.slice(_i33 + 1).trim();
                  e[_t86] = _t86 === o.ATTRIBUTE ? Q.grammarFromString(_r75) : _r75;
                }
              }
              return e;
            }
          }]);
          return Q;
        }();
        e.Component = Q;
        var s = /*#__PURE__*/function () {
          function s(t) {
            _classCallCheck(this, s);
            this.components = t;
          }
          _createClass(s, [{
            key: "toString",
            value: function toString() {
              return this.components.map(function (t) {
                return t.toString();
              }).join("; ");
            }
          }], [{
            key: "fromString",
            value: function fromString(t) {
              var e = c(t, ";").filter(function (t) {
                  return t.match(/\S/);
                }).map(function (t) {
                  return t.trim();
                }),
                r = [];
              for (var _t87 = 0, _n201 = e.length; _t87 < _n201; _t87++) {
                var _n202 = Q.fromString(e[_t87]);
                _n202 && r.push(_n202);
              }
              return new s(r);
            }
          }]);
          return s;
        }();
        e.Action = s;
        var T = /*#__PURE__*/function () {
          function T(t) {
            _classCallCheck(this, T);
            for (var _len8 = arguments.length, e = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
              e[_key8 - 1] = arguments[_key8];
            }
            this.query = t, this.constraints = e;
            var _this$presetPriority = this.presetPriority(),
              _this$presetPriority2 = _slicedToArray(_this$presetPriority, 2),
              r = _this$presetPriority2[0],
              n = _this$presetPriority2[1];
            this.priority = r ? n : this.calculatePriority();
          }
          _createClass(T, [{
            key: "toString",
            value: function toString() {
              var t = this.constraints.join(", ");
              return "".concat(this.query, ", ").concat(t, " (").concat(this.priority, ", ").concat(this.rank, ")");
            }
          }, {
            key: "calculatePriority",
            value: function calculatePriority() {
              var t = T.constraintValue(this.query, T.queryPriorities);
              if (!t) return 0;
              var e = this.query.match(/^self::.+\[(.+)\]/)[1];
              return 100 * t + 10 * T.constraintValue(e, T.attributePriorities);
            }
          }, {
            key: "presetPriority",
            value: function presetPriority() {
              if (!this.constraints.length) return [!1, 0];
              var t = this.constraints[this.constraints.length - 1].match(/^priority=(.*$)/);
              if (!t) return [!1, 0];
              this.constraints.pop();
              var e = parseFloat(t[1]);
              return [!0, isNaN(e) ? 0 : e];
            }
          }], [{
            key: "constraintValue",
            value: function constraintValue(t, e) {
              for (var _r76, _n203 = 0; _r76 = e[_n203]; _n203++) if (t.match(_r76)) return ++_n203;
              return 0;
            }
          }]);
          return T;
        }();
        e.Precondition = T, T.queryPriorities = [/^self::\*\[.+\]$/, /^self::[\w-]+\[.+\]$/], T.attributePriorities = [/^@[\w-]+$/, /^@[\w-]+!=".+"$/, /^not\(contains\(@[\w-]+,\s*".+"\)\)$/, /^contains\(@[\w-]+,".+"\)$/, /^@[\w-]+=".+"$/];
        var l = /*#__PURE__*/function (_n$SREError) {
          _inherits(l, _n$SREError);
          function l(t) {
            var _this42;
            _classCallCheck(this, l);
            _this42 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, t)), _this42.name = "RuleError";
            return _this42;
          }
          return l;
        }(n.SREError);
        function c(t, e) {
          var r = [];
          var n = "";
          for (; "" !== t;) {
            var _o28 = t.search(e);
            if (-1 === _o28) {
              if ((t.match(/"/g) || []).length % 2 != 0) throw new l("Invalid string in expression: " + t);
              r.push(n + t), n = "", t = "";
            } else if ((t.substring(0, _o28).match(/"/g) || []).length % 2 == 0) r.push(n + t.substring(0, _o28)), n = "", t = t.substring(_o28 + 1);else {
              var _e68 = t.substring(_o28).search('"');
              if (-1 === _e68) throw new l("Invalid string in expression: " + t);
              n += t.substring(0, _o28 + _e68 + 1), t = t.substring(_o28 + _e68 + 1);
            }
          }
          return n && r.push(n), r;
        }
        e.OutputError = l;
      },
      4106: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SpeechRuleContext = void 0;
        var n = r(5274),
          o = r(5662);
        e.SpeechRuleContext = /*#__PURE__*/function () {
          function _class10() {
            _classCallCheck(this, _class10);
            this.customQueries = new o.CustomQueries(), this.customStrings = new o.CustomStrings(), this.contextFunctions = new o.ContextFunctions(), this.customGenerators = new o.CustomGenerators();
          }
          _createClass(_class10, [{
            key: "applyCustomQuery",
            value: function applyCustomQuery(t, e) {
              var r = this.customQueries.lookup(e);
              return r ? r(t) : null;
            }
          }, {
            key: "applySelector",
            value: function applySelector(t, e) {
              return this.applyCustomQuery(t, e) || n.evalXPath(e, t);
            }
          }, {
            key: "applyQuery",
            value: function applyQuery(t, e) {
              var r = this.applySelector(t, e);
              return r.length > 0 ? r[0] : null;
            }
          }, {
            key: "applyConstraint",
            value: function applyConstraint(t, e) {
              return !!this.applyQuery(t, e) || n.evaluateBoolean(e, t);
            }
          }, {
            key: "constructString",
            value: function constructString(t, e) {
              if (!e) return "";
              if ('"' === e.charAt(0)) return e.slice(1, -1);
              var r = this.customStrings.lookup(e);
              return r ? r(t) : n.evaluateString(e, t);
            }
          }, {
            key: "parse",
            value: function parse(t) {
              var e = Array.isArray(t) ? t : Object.entries(t);
              for (var _t88, _r77 = 0; _t88 = e[_r77]; _r77++) {
                switch (_t88[0].slice(0, 3)) {
                  case "CQF":
                    this.customQueries.add(_t88[0], _t88[1]);
                    break;
                  case "CSF":
                    this.customStrings.add(_t88[0], _t88[1]);
                    break;
                  case "CTF":
                    this.contextFunctions.add(_t88[0], _t88[1]);
                    break;
                  case "CGF":
                    this.customGenerators.add(_t88[0], _t88[1]);
                    break;
                  default:
                    console.error("FunctionError: Invalid function name " + _t88[0]);
                }
              }
            }
          }]);
          return _class10;
        }();
      },
      2362: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.storeFactory = e.SpeechRuleEngine = void 0;
        var n = r(7052),
          o = r(2057),
          i = r(5740),
          a = r(5897),
          Q = r(4440),
          s = r(5274),
          T = r(7283),
          l = r(7599),
          c = r(2469),
          u = r(1676),
          p = r(2105),
          h = r(9935),
          d = r(4650),
          f = r(4508);
        var m = /*#__PURE__*/function () {
          function m() {
            _classCallCheck(this, m);
            this.trie = null, this.evaluators_ = {}, this.trie = new f.Trie();
          }
          _createClass(m, [{
            key: "evaluateNode",
            value: function evaluateNode(t) {
              (0, s.updateEvaluator)(t);
              var e = new Date().getTime();
              var r = [];
              try {
                r = this.evaluateNode_(t);
              } catch (t) {
                console.error("Something went wrong computing speech."), o.Debugger.getInstance().output(t);
              }
              var n = new Date().getTime();
              return o.Debugger.getInstance().output("Time:", n - e), r;
            }
          }, {
            key: "toString",
            value: function toString() {
              return this.trie.collectRules().map(function (t) {
                return t.toString();
              }).join("\n");
            }
          }, {
            key: "runInSetting",
            value: function runInSetting(t, e) {
              var r = a.default.getInstance(),
                n = {};
              for (var _e69 in t) n[_e69] = r[_e69], r[_e69] = t[_e69];
              r.setDynamicCstr();
              var o = e();
              for (var _t89 in n) r[_t89] = n[_t89];
              return r.setDynamicCstr(), o;
            }
          }, {
            key: "addStore",
            value: function addStore(t) {
              var _this43 = this;
              var e = y(t);
              "abstract" !== e.kind && e.getSpeechRules().forEach(function (t) {
                return _this43.trie.addRule(t);
              }), this.addEvaluator(e);
            }
          }, {
            key: "processGrammar",
            value: function processGrammar(t, e, r) {
              var n = {};
              for (var _o29 in r) {
                var _i34 = r[_o29];
                n[_o29] = "string" == typeof _i34 ? t.constructString(e, _i34) : _i34;
              }
              p.Grammar.getInstance().pushState(n);
            }
          }, {
            key: "addEvaluator",
            value: function addEvaluator(t) {
              var e = t.evaluateDefault.bind(t),
                r = this.evaluators_[t.locale];
              if (r) return void (r[t.modality] = e);
              var n = {};
              n[t.modality] = e, this.evaluators_[t.locale] = n;
            }
          }, {
            key: "getEvaluator",
            value: function getEvaluator(t, e) {
              var r = this.evaluators_[t] || this.evaluators_[u.DynamicCstr.DEFAULT_VALUES[u.Axis.LOCALE]];
              return r[e] || r[u.DynamicCstr.DEFAULT_VALUES[u.Axis.MODALITY]];
            }
          }, {
            key: "enumerate",
            value: function enumerate(t) {
              return this.trie.enumerate(t);
            }
          }, {
            key: "evaluateNode_",
            value: function evaluateNode_(t) {
              return t ? (this.updateConstraint_(), this.evaluateTree_(t)) : [];
            }
          }, {
            key: "evaluateTree_",
            value: function evaluateTree_(t) {
              var e = a.default.getInstance();
              var r;
              o.Debugger.getInstance().output(e.mode !== Q.Mode.HTTP ? t.toString() : t), p.Grammar.getInstance().setAttribute(t);
              var i = this.lookupRule(t, e.dynamicCstr);
              if (!i) return e.strict ? [] : (r = this.getEvaluator(e.locale, e.modality)(t), t.attributes && this.addPersonality_(r, {}, !1, t), r);
              o.Debugger.getInstance().generateOutput(function () {
                return ["Apply Rule:", i.name, i.dynamicCstr.toString(), (e.mode, Q.Mode.HTTP, t).toString()];
              });
              var T = i.context,
                l = i.action.components;
              r = [];
              for (var _e70, _o30 = 0; _e70 = l[_o30]; _o30++) {
                var _o31 = [];
                var _i35 = _e70.content || "",
                  _Q6 = _e70.attributes || {};
                var _l = !1;
                _e70.grammar && this.processGrammar(T, t, _e70.grammar);
                var _c = null;
                if (_Q6.engine) {
                  _c = a.default.getInstance().dynamicCstr.getComponents();
                  var _t90 = p.Grammar.parseInput(_Q6.engine);
                  a.default.getInstance().setDynamicCstr(_t90);
                }
                switch (_e70.type) {
                  case d.ActionType.NODE:
                    {
                      var _e71 = T.applyQuery(t, _i35);
                      _e71 && (_o31 = this.evaluateTree_(_e71));
                    }
                    break;
                  case d.ActionType.MULTI:
                    {
                      _l = !0;
                      var _e72 = T.applySelector(t, _i35);
                      _e72.length > 0 && (_o31 = this.evaluateNodeList_(T, _e72, _Q6.sepFunc, T.constructString(t, _Q6.separator), _Q6.ctxtFunc, T.constructString(t, _Q6.context)));
                    }
                    break;
                  case d.ActionType.TEXT:
                    {
                      var _e73 = _Q6.span,
                        _r78 = {};
                      if (_e73) {
                        var _n204 = (0, s.evalXPath)(_e73, t);
                        _n204.length && (_r78.extid = _n204[0].getAttribute("extid"));
                      }
                      var _a10 = T.constructString(t, _i35);
                      (_a10 || "" === _a10) && (_o31 = Array.isArray(_a10) ? _a10.map(function (t) {
                        return n.AuditoryDescription.create({
                          text: t.speech,
                          attributes: t.attributes
                        }, {
                          adjust: !0
                        });
                      }) : [n.AuditoryDescription.create({
                        text: _a10,
                        attributes: _r78
                      }, {
                        adjust: !0
                      })]);
                    }
                    break;
                  case d.ActionType.PERSONALITY:
                  default:
                    _o31 = [n.AuditoryDescription.create({
                      text: _i35
                    })];
                }
                _o31[0] && !_l && (_Q6.context && (_o31[0].context = T.constructString(t, _Q6.context) + (_o31[0].context || "")), _Q6.annotation && (_o31[0].annotation = _Q6.annotation)), this.addLayout(_o31, _Q6, _l), _e70.grammar && p.Grammar.getInstance().popState(), r = r.concat(this.addPersonality_(_o31, _Q6, _l, t)), _c && a.default.getInstance().setDynamicCstr(_c);
              }
              return r;
            }
          }, {
            key: "evaluateNodeList_",
            value: function evaluateNodeList_(t, e, r, o, i, a) {
              if (!e.length) return [];
              var Q = o || "",
                s = a || "",
                T = t.contextFunctions.lookup(i),
                l = T ? T(e, s) : function () {
                  return s;
                },
                c = t.contextFunctions.lookup(r),
                u = c ? c(e, Q) : function () {
                  return [n.AuditoryDescription.create({
                    text: Q
                  }, {
                    translate: !0
                  })];
                };
              var p = [];
              for (var _t91, _r79 = 0; _t91 = e[_r79]; _r79++) {
                var _n205 = this.evaluateTree_(_t91);
                if (_n205.length > 0 && (_n205[0].context = l() + (_n205[0].context || ""), p = p.concat(_n205), _r79 < e.length - 1)) {
                  var _t92 = u();
                  p = p.concat(_t92);
                }
              }
              return p;
            }
          }, {
            key: "addLayout",
            value: function addLayout(t, e, r) {
              var o = e.layout;
              o && (o.match(/^begin/) ? t.unshift(new n.AuditoryDescription({
                text: "",
                layout: o
              })) : o.match(/^end/) ? t.push(new n.AuditoryDescription({
                text: "",
                layout: o
              })) : (t.unshift(new n.AuditoryDescription({
                text: "",
                layout: "begin".concat(o)
              })), t.push(new n.AuditoryDescription({
                text: "",
                layout: "end".concat(o)
              }))));
            }
          }, {
            key: "addPersonality_",
            value: function addPersonality_(t, e, r, o) {
              var i = {};
              var a = null;
              var _iterator14 = _createForOfIteratorHelper(Q.personalityPropList),
                _step14;
              try {
                for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                  var _t93 = _step14.value;
                  var _r81 = e[_t93];
                  if (void 0 === _r81) continue;
                  var _n206 = parseFloat(_r81),
                    _o32 = isNaN(_n206) ? '"' === _r81.charAt(0) ? _r81.slice(1, -1) : _r81 : _n206;
                  _t93 === Q.personalityProps.PAUSE ? a = _o32 : i[_t93] = _o32;
                }
              } catch (err) {
                _iterator14.e(err);
              } finally {
                _iterator14.f();
              }
              for (var _e74, _r80 = 0; _e74 = t[_r80]; _r80++) this.addRelativePersonality_(_e74, i), this.addExternalAttributes_(_e74, o);
              if (r && t.length && delete t[t.length - 1].personality[Q.personalityProps.JOIN], a && t.length) {
                var _e75 = t[t.length - 1];
                _e75.text || Object.keys(_e75.personality).length ? t.push(n.AuditoryDescription.create({
                  text: "",
                  personality: {
                    pause: a
                  }
                })) : _e75.personality[Q.personalityProps.PAUSE] = a;
              }
              return t;
            }
          }, {
            key: "addExternalAttributes_",
            value: function addExternalAttributes_(t, e) {
              if (e.hasAttributes()) {
                var _r82 = e.attributes;
                for (var _e76 = _r82.length - 1; _e76 >= 0; _e76--) {
                  var _n207 = _r82[_e76].name;
                  !t.attributes[_n207] && _n207.match(/^ext/) && (t.attributes[_n207] = _r82[_e76].value);
                }
              }
            }
          }, {
            key: "addRelativePersonality_",
            value: function addRelativePersonality_(t, e) {
              if (!t.personality) return t.personality = e, t;
              var r = t.personality;
              for (var _t94 in e) r[_t94] && "number" == typeof r[_t94] && "number" == typeof e[_t94] ? r[_t94] = r[_t94] + e[_t94] : r[_t94] || (r[_t94] = e[_t94]);
              return t;
            }
          }, {
            key: "updateConstraint_",
            value: function updateConstraint_() {
              var t = a.default.getInstance().dynamicCstr,
                e = a.default.getInstance().strict,
                r = this.trie,
                n = {};
              var o = t.getValue(u.Axis.LOCALE),
                i = t.getValue(u.Axis.MODALITY),
                Q = t.getValue(u.Axis.DOMAIN);
              r.hasSubtrie([o, i, Q]) || (Q = u.DynamicCstr.DEFAULT_VALUES[u.Axis.DOMAIN], r.hasSubtrie([o, i, Q]) || (i = u.DynamicCstr.DEFAULT_VALUES[u.Axis.MODALITY], r.hasSubtrie([o, i, Q]) || (o = u.DynamicCstr.DEFAULT_VALUES[u.Axis.LOCALE]))), n[u.Axis.LOCALE] = [o], n[u.Axis.MODALITY] = ["summary" !== i ? i : u.DynamicCstr.DEFAULT_VALUES[u.Axis.MODALITY]], n[u.Axis.DOMAIN] = ["speech" !== i ? u.DynamicCstr.DEFAULT_VALUES[u.Axis.DOMAIN] : Q];
              var s = t.getOrder();
              for (var _r83, _o33 = 0; _r83 = s[_o33]; _o33++) if (!n[_r83]) {
                var _o34 = t.getValue(_r83),
                  _i36 = this.makeSet_(_o34, t.preference),
                  _a11 = u.DynamicCstr.DEFAULT_VALUES[_r83];
                e || _o34 === _a11 || _i36.push(_a11), n[_r83] = _i36;
              }
              t.updateProperties(n);
            }
          }, {
            key: "makeSet_",
            value: function makeSet_(t, e) {
              return e && Object.keys(e).length ? t.split(":") : [t];
            }
          }, {
            key: "lookupRule",
            value: function lookupRule(t, e) {
              if (!t || t.nodeType !== i.NodeType.ELEMENT_NODE && t.nodeType !== i.NodeType.TEXT_NODE) return null;
              var r = this.lookupRules(t, e);
              return r.length > 0 ? this.pickMostConstraint_(e, r) : null;
            }
          }, {
            key: "lookupRules",
            value: function lookupRules(t, e) {
              return this.trie.lookupRules(t, e.allProperties());
            }
          }, {
            key: "pickMostConstraint_",
            value: function pickMostConstraint_(t, e) {
              var r = a.default.getInstance().comparator;
              return e.sort(function (t, e) {
                return r.compare(t.dynamicCstr, e.dynamicCstr) || e.precondition.priority - t.precondition.priority || e.precondition.constraints.length - t.precondition.constraints.length || e.precondition.rank - t.precondition.rank;
              }), o.Debugger.getInstance().generateOutput(function () {
                return e.map(function (t) {
                  return t.name + "(" + t.dynamicCstr.toString() + ")";
                });
              }.bind(this)), e[0];
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return m.instance = m.instance || new m(), m.instance;
            }
          }, {
            key: "debugSpeechRule",
            value: function debugSpeechRule(t, e) {
              var r = t.precondition,
                n = t.context.applyQuery(e, r.query);
              o.Debugger.getInstance().output(r.query, n ? n.toString() : n), r.constraints.forEach(function (r) {
                return o.Debugger.getInstance().output(r, t.context.applyConstraint(e, r));
              });
            }
          }, {
            key: "debugNamedSpeechRule",
            value: function debugNamedSpeechRule(t, e) {
              var r = m.getInstance().trie.collectRules().filter(function (e) {
                return e.name == t;
              });
              for (var _n208, _i37 = 0; _n208 = r[_i37]; _i37++) o.Debugger.getInstance().output("Rule", t, "DynamicCstr:", _n208.dynamicCstr.toString(), "number", _i37), m.debugSpeechRule(_n208, e);
            }
          }]);
          return m;
        }();
        e.SpeechRuleEngine = m;
        var L = new Map();
        function y(t) {
          var e = "".concat(t.locale, ".").concat(t.modality, ".").concat(t.domain);
          if ("actions" === t.kind) {
            var _r84 = L.get(e);
            return _r84.parse(t), _r84;
          }
          l.init(), t && !t.functions && (t.functions = T.getStore(t.locale, t.modality, t.domain));
          var r = "braille" === t.modality ? new c.BrailleStore() : new h.MathStore();
          return L.set(e, r), t.inherits && (r.inherits = L.get("".concat(t.inherits, ".").concat(t.modality, ".").concat(t.domain))), r.parse(t), r.initialize(), r;
        }
        e.storeFactory = y, a.default.nodeEvaluator = m.getInstance().evaluateNode.bind(m.getInstance());
      },
      5662: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.CustomGenerators = e.ContextFunctions = e.CustomStrings = e.CustomQueries = void 0;
        var r = /*#__PURE__*/function () {
          function r(t, e) {
            _classCallCheck(this, r);
            this.prefix = t, this.store = e;
          }
          _createClass(r, [{
            key: "add",
            value: function add(t, e) {
              this.checkCustomFunctionSyntax_(t) && (this.store[t] = e);
            }
          }, {
            key: "addStore",
            value: function addStore(t) {
              var e = Object.keys(t.store);
              for (var _r85, n = 0; _r85 = e[n]; n++) this.add(_r85, t.store[_r85]);
            }
          }, {
            key: "lookup",
            value: function lookup(t) {
              return this.store[t];
            }
          }, {
            key: "checkCustomFunctionSyntax_",
            value: function checkCustomFunctionSyntax_(t) {
              var e = new RegExp("^" + this.prefix);
              return !!t.match(e) || (console.error("FunctionError: Invalid function name. Expected prefix " + this.prefix), !1);
            }
          }]);
          return r;
        }();
        e.CustomQueries = /*#__PURE__*/function (_r86) {
          _inherits(_class11, _r86);
          function _class11() {
            _classCallCheck(this, _class11);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class11).call(this, "CQF", {}));
          }
          return _class11;
        }(r);
        e.CustomStrings = /*#__PURE__*/function (_r87) {
          _inherits(_class12, _r87);
          function _class12() {
            _classCallCheck(this, _class12);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class12).call(this, "CSF", {}));
          }
          return _class12;
        }(r);
        e.ContextFunctions = /*#__PURE__*/function (_r88) {
          _inherits(_class13, _r88);
          function _class13() {
            _classCallCheck(this, _class13);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class13).call(this, "CTF", {}));
          }
          return _class13;
        }(r);
        e.CustomGenerators = /*#__PURE__*/function (_r89) {
          _inherits(_class14, _r89);
          function _class14() {
            _classCallCheck(this, _class14);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class14).call(this, "CGF", {}));
          }
          return _class14;
        }(r);
      },
      365: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.contentIterator = e.pauseSeparator = e.nodeCounter = void 0;
        var n = r(7052),
          o = r(5274),
          i = r(5897);
        e.nodeCounter = function (t, e) {
          var r = t.length;
          var n = 0,
            o = e;
          return e || (o = ""), function () {
            return n < r && (n += 1), o + " " + n;
          };
        }, e.pauseSeparator = function (t, e) {
          var r = parseFloat(e),
            o = isNaN(r) ? e : r;
          return function () {
            return [n.AuditoryDescription.create({
              text: "",
              personality: {
                pause: o
              }
            })];
          };
        }, e.contentIterator = function (t, e) {
          var r;
          return r = t.length > 0 ? o.evalXPath("../../content/*", t[0]) : [], function () {
            var t = r.shift(),
              o = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!t) return o;
            var a = i.default.evaluateNode(t);
            return o.concat(a);
          };
        };
      },
      1414: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getTreeFromString = e.getTree = e.xmlTree = void 0;
        var n = r(5740),
          o = r(7075);
        function i(t) {
          return new o.SemanticTree(t);
        }
        e.xmlTree = function (t) {
          return i(t).xml();
        }, e.getTree = i, e.getTreeFromString = function (t) {
          return i(n.parseInput(t));
        };
      },
      7630: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.annotate = e.activate = e.register = e.visitors = e.annotators = void 0;
        var n = r(9265);
        e.annotators = new Map(), e.visitors = new Map(), e.register = function (t) {
          var r = t.domain + ":" + t.name;
          t instanceof n.SemanticAnnotator ? e.annotators.set(r, t) : e.visitors.set(r, t);
        }, e.activate = function (t, r) {
          var n = t + ":" + r,
            o = e.annotators.get(n) || e.visitors.get(n);
          o && (o.active = !0);
        }, e.annotate = function (t) {
          var _iterator15 = _createForOfIteratorHelper(e.annotators.values()),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _r90 = _step15.value;
              _r90.active && _r90.annotate(t);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          var _iterator16 = _createForOfIteratorHelper(e.visitors.values()),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _r91 = _step16.value;
              _r91.active && _r91.visit(t, Object.assign({}, _r91.def));
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        };
      },
      9265: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticVisitor = e.SemanticAnnotator = void 0;
        e.SemanticAnnotator = /*#__PURE__*/function () {
          function _class15(t, e, r) {
            _classCallCheck(this, _class15);
            this.domain = t, this.name = e, this.func = r, this.active = !1;
          }
          _createClass(_class15, [{
            key: "annotate",
            value: function annotate(t) {
              t.childNodes.forEach(this.annotate.bind(this)), t.addAnnotation(this.domain, this.func(t));
            }
          }]);
          return _class15;
        }();
        e.SemanticVisitor = /*#__PURE__*/function () {
          function _class16(t, e, r) {
            var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            _classCallCheck(this, _class16);
            this.domain = t, this.name = e, this.func = r, this.def = n, this.active = !1;
          }
          _createClass(_class16, [{
            key: "visit",
            value: function visit(t, e) {
              var r = this.func(t, e);
              t.addAnnotation(this.domain, r[0]);
              for (var _e77, n = 0; _e77 = t.childNodes[n]; n++) r = this.visit(_e77, r[1]);
              return r;
            }
          }]);
          return _class16;
        }();
      },
      3588: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookupSecondary = e.isEmbellishedType = e.isMatchingFence = e.functionApplication = e.invisibleComma = e.invisiblePlus = e.invisibleTimes = e.lookupMeaning = e.lookupRole = e.lookupType = e.equal = e.allLettersRegExp = void 0;
        var r = String.fromCodePoint(8291),
          n = ["\uFF0C", "\uFE50", ",", r],
          o = ["\xaf", "\u2012", "\u2013", "\u2014", "\u2015", "\uFE58", "-", "\u207B", "\u208B", "\u2212", "\u2796", "\uFE63", "\uFF0D", "\u2010", "\u2011", "\u203E", "_"],
          i = ["~", "\u0303", "\u223C", "\u02DC", "\u223D", "\u02F7", "\u0334", "\u0330"],
          a = {
            "(": ")",
            "[": "]",
            "{": "}",
            "\u2045": "\u2046",
            "\u2329": "\u232A",
            "\u2768": "\u2769",
            "\u276A": "\u276B",
            "\u276C": "\u276D",
            "\u276E": "\u276F",
            "\u2770": "\u2771",
            "\u2772": "\u2773",
            "\u2774": "\u2775",
            "\u27C5": "\u27C6",
            "\u27E6": "\u27E7",
            "\u27E8": "\u27E9",
            "\u27EA": "\u27EB",
            "\u27EC": "\u27ED",
            "\u27EE": "\u27EF",
            "\u2983": "\u2984",
            "\u2985": "\u2986",
            "\u2987": "\u2988",
            "\u2989": "\u298A",
            "\u298B": "\u298C",
            "\u298D": "\u298E",
            "\u298F": "\u2990",
            "\u2991": "\u2992",
            "\u2993": "\u2994",
            "\u2995": "\u2996",
            "\u2997": "\u2998",
            "\u29D8": "\u29D9",
            "\u29DA": "\u29DB",
            "\u29FC": "\u29FD",
            "\u2E22": "\u2E23",
            "\u2E24": "\u2E25",
            "\u2E26": "\u2E27",
            "\u2E28": "\u2E29",
            "\u3008": "\u3009",
            "\u300A": "\u300B",
            "\u300C": "\u300D",
            "\u300E": "\u300F",
            "\u3010": "\u3011",
            "\u3014": "\u3015",
            "\u3016": "\u3017",
            "\u3018": "\u3019",
            "\u301A": "\u301B",
            "\u301D": "\u301E",
            "\uFD3E": "\uFD3F",
            "\uFE17": "\uFE18",
            "\uFE59": "\uFE5A",
            "\uFE5B": "\uFE5C",
            "\uFE5D": "\uFE5E",
            "\uFF08": "\uFF09",
            "\uFF3B": "\uFF3D",
            "\uFF5B": "\uFF5D",
            "\uFF5F": "\uFF60",
            "\uFF62": "\uFF63",
            "\u2308": "\u2309",
            "\u230A": "\u230B",
            "\u230C": "\u230D",
            "\u230E": "\u230F",
            "\u231C": "\u231D",
            "\u231E": "\u231F",
            "\u239B": "\u239E",
            "\u239C": "\u239F",
            "\u239D": "\u23A0",
            "\u23A1": "\u23A4",
            "\u23A2": "\u23A5",
            "\u23A3": "\u23A6",
            "\u23A7": "\u23AB",
            "\u23A8": "\u23AC",
            "\u23A9": "\u23AD",
            "\u23B0": "\u23B1",
            "\u23B8": "\u23B9"
          },
          Q = {
            "\u23B4": "\u23B5",
            "\u23DC": "\u23DD",
            "\u23DE": "\u23DF",
            "\u23E0": "\u23E1",
            "\uFE35": "\uFE36",
            "\uFE37": "\uFE38",
            "\uFE39": "\uFE3A",
            "\uFE3B": "\uFE3C",
            "\uFE3D": "\uFE3E",
            "\uFE3F": "\uFE40",
            "\uFE41": "\uFE42",
            "\uFE43": "\uFE44",
            "\uFE47": "\uFE48"
          },
          s = Object.keys(a),
          T = Object.values(a);
        T.push("\u301F");
        var l = Object.keys(Q),
          c = Object.values(Q),
          u = ["|", "\xa6", "\u2223", "\u23D0", "\u23B8", "\u23B9", "\u2758", "\uFF5C", "\uFFE4", "\uFE31", "\uFE32"],
          p = ["\u2016", "\u2225", "\u2980", "\u2AF4"],
          h = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
          d = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "\u0131", "\u0237"],
          f = ["\uFF21", "\uFF22", "\uFF23", "\uFF24", "\uFF25", "\uFF26", "\uFF27", "\uFF28", "\uFF29", "\uFF2A", "\uFF2B", "\uFF2C", "\uFF2D", "\uFF2E", "\uFF2F", "\uFF30", "\uFF31", "\uFF32", "\uFF33", "\uFF34", "\uFF35", "\uFF36", "\uFF37", "\uFF38", "\uFF39", "\uFF3A"],
          m = ["\uFF41", "\uFF42", "\uFF43", "\uFF44", "\uFF45", "\uFF46", "\uFF47", "\uFF48", "\uFF49", "\uFF4A", "\uFF4B", "\uFF4C", "\uFF4D", "\uFF4E", "\uFF4F", "\uFF50", "\uFF51", "\uFF52", "\uFF53", "\uFF54", "\uFF55", "\uFF56", "\uFF57", "\uFF58", "\uFF59", "\uFF5A"],
          L = ["\uD835\uDC00", "\uD835\uDC01", "\uD835\uDC02", "\uD835\uDC03", "\uD835\uDC04", "\uD835\uDC05", "\uD835\uDC06", "\uD835\uDC07", "\uD835\uDC08", "\uD835\uDC09", "\uD835\uDC0A", "\uD835\uDC0B", "\uD835\uDC0C", "\uD835\uDC0D", "\uD835\uDC0E", "\uD835\uDC0F", "\uD835\uDC10", "\uD835\uDC11", "\uD835\uDC12", "\uD835\uDC13", "\uD835\uDC14", "\uD835\uDC15", "\uD835\uDC16", "\uD835\uDC17", "\uD835\uDC18", "\uD835\uDC19"],
          y = ["\uD835\uDC1A", "\uD835\uDC1B", "\uD835\uDC1C", "\uD835\uDC1D", "\uD835\uDC1E", "\uD835\uDC1F", "\uD835\uDC20", "\uD835\uDC21", "\uD835\uDC22", "\uD835\uDC23", "\uD835\uDC24", "\uD835\uDC25", "\uD835\uDC26", "\uD835\uDC27", "\uD835\uDC28", "\uD835\uDC29", "\uD835\uDC2A", "\uD835\uDC2B", "\uD835\uDC2C", "\uD835\uDC2D", "\uD835\uDC2E", "\uD835\uDC2F", "\uD835\uDC30", "\uD835\uDC31", "\uD835\uDC32", "\uD835\uDC33"],
          g = ["\uD835\uDC34", "\uD835\uDC35", "\uD835\uDC36", "\uD835\uDC37", "\uD835\uDC38", "\uD835\uDC39", "\uD835\uDC3A", "\uD835\uDC3B", "\uD835\uDC3C", "\uD835\uDC3D", "\uD835\uDC3E", "\uD835\uDC3F", "\uD835\uDC40", "\uD835\uDC41", "\uD835\uDC42", "\uD835\uDC43", "\uD835\uDC44", "\uD835\uDC45", "\uD835\uDC46", "\uD835\uDC47", "\uD835\uDC48", "\uD835\uDC49", "\uD835\uDC4A", "\uD835\uDC4B", "\uD835\uDC4C", "\uD835\uDC4D"],
          v = ["\uD835\uDC4E", "\uD835\uDC4F", "\uD835\uDC50", "\uD835\uDC51", "\uD835\uDC52", "\uD835\uDC53", "\uD835\uDC54", "\u210E", "\uD835\uDC56", "\uD835\uDC57", "\uD835\uDC58", "\uD835\uDC59", "\uD835\uDC5A", "\uD835\uDC5B", "\uD835\uDC5C", "\uD835\uDC5D", "\uD835\uDC5E", "\uD835\uDC5F", "\uD835\uDC60", "\uD835\uDC61", "\uD835\uDC62", "\uD835\uDC63", "\uD835\uDC64", "\uD835\uDC65", "\uD835\uDC66", "\uD835\uDC67", "\uD835\uDEA4", "\uD835\uDEA5"],
          b = ["\uD835\uDC68", "\uD835\uDC69", "\uD835\uDC6A", "\uD835\uDC6B", "\uD835\uDC6C", "\uD835\uDC6D", "\uD835\uDC6E", "\uD835\uDC6F", "\uD835\uDC70", "\uD835\uDC71", "\uD835\uDC72", "\uD835\uDC73", "\uD835\uDC74", "\uD835\uDC75", "\uD835\uDC76", "\uD835\uDC77", "\uD835\uDC78", "\uD835\uDC79", "\uD835\uDC7A", "\uD835\uDC7B", "\uD835\uDC7C", "\uD835\uDC7D", "\uD835\uDC7E", "\uD835\uDC7F", "\uD835\uDC80", "\uD835\uDC81"],
          H = ["\uD835\uDC82", "\uD835\uDC83", "\uD835\uDC84", "\uD835\uDC85", "\uD835\uDC86", "\uD835\uDC87", "\uD835\uDC88", "\uD835\uDC89", "\uD835\uDC8A", "\uD835\uDC8B", "\uD835\uDC8C", "\uD835\uDC8D", "\uD835\uDC8E", "\uD835\uDC8F", "\uD835\uDC90", "\uD835\uDC91", "\uD835\uDC92", "\uD835\uDC93", "\uD835\uDC94", "\uD835\uDC95", "\uD835\uDC96", "\uD835\uDC97", "\uD835\uDC98", "\uD835\uDC99", "\uD835\uDC9A", "\uD835\uDC9B"],
          _ = ["\uD835\uDC9C", "\u212C", "\uD835\uDC9E", "\uD835\uDC9F", "\u2130", "\u2131", "\uD835\uDCA2", "\u210B", "\u2110", "\uD835\uDCA5", "\uD835\uDCA6", "\u2112", "\u2133", "\uD835\uDCA9", "\uD835\uDCAA", "\uD835\uDCAB", "\uD835\uDCAC", "\u211B", "\uD835\uDCAE", "\uD835\uDCAF", "\uD835\uDCB0", "\uD835\uDCB1", "\uD835\uDCB2", "\uD835\uDCB3", "\uD835\uDCB4", "\uD835\uDCB5", "\u2118"],
          M = ["\uD835\uDCB6", "\uD835\uDCB7", "\uD835\uDCB8", "\uD835\uDCB9", "\u212F", "\uD835\uDCBB", "\u210A", "\uD835\uDCBD", "\uD835\uDCBE", "\uD835\uDCBF", "\uD835\uDCC0", "\uD835\uDCC1", "\uD835\uDCC2", "\uD835\uDCC3", "\u2134", "\uD835\uDCC5", "\uD835\uDCC6", "\uD835\uDCC7", "\uD835\uDCC8", "\uD835\uDCC9", "\uD835\uDCCA", "\uD835\uDCCB", "\uD835\uDCCC", "\uD835\uDCCD", "\uD835\uDCCE", "\uD835\uDCCF", "\u2113"],
          x = ["\uD835\uDCD0", "\uD835\uDCD1", "\uD835\uDCD2", "\uD835\uDCD3", "\uD835\uDCD4", "\uD835\uDCD5", "\uD835\uDCD6", "\uD835\uDCD7", "\uD835\uDCD8", "\uD835\uDCD9", "\uD835\uDCDA", "\uD835\uDCDB", "\uD835\uDCDC", "\uD835\uDCDD", "\uD835\uDCDE", "\uD835\uDCDF", "\uD835\uDCE0", "\uD835\uDCE1", "\uD835\uDCE2", "\uD835\uDCE3", "\uD835\uDCE4", "\uD835\uDCE5", "\uD835\uDCE6", "\uD835\uDCE7", "\uD835\uDCE8", "\uD835\uDCE9"],
          O = ["\uD835\uDCEA", "\uD835\uDCEB", "\uD835\uDCEC", "\uD835\uDCED", "\uD835\uDCEE", "\uD835\uDCEF", "\uD835\uDCF0", "\uD835\uDCF1", "\uD835\uDCF2", "\uD835\uDCF3", "\uD835\uDCF4", "\uD835\uDCF5", "\uD835\uDCF6", "\uD835\uDCF7", "\uD835\uDCF8", "\uD835\uDCF9", "\uD835\uDCFA", "\uD835\uDCFB", "\uD835\uDCFC", "\uD835\uDCFD", "\uD835\uDCFE", "\uD835\uDCFF", "\uD835\uDD00", "\uD835\uDD01", "\uD835\uDD02", "\uD835\uDD03"],
          S = ["\uD835\uDD04", "\uD835\uDD05", "\u212D", "\uD835\uDD07", "\uD835\uDD08", "\uD835\uDD09", "\uD835\uDD0A", "\u210C", "\u2111", "\uD835\uDD0D", "\uD835\uDD0E", "\uD835\uDD0F", "\uD835\uDD10", "\uD835\uDD11", "\uD835\uDD12", "\uD835\uDD13", "\uD835\uDD14", "\u211C", "\uD835\uDD16", "\uD835\uDD17", "\uD835\uDD18", "\uD835\uDD19", "\uD835\uDD1A", "\uD835\uDD1B", "\uD835\uDD1C", "\u2128"],
          V = ["\uD835\uDD1E", "\uD835\uDD1F", "\uD835\uDD20", "\uD835\uDD21", "\uD835\uDD22", "\uD835\uDD23", "\uD835\uDD24", "\uD835\uDD25", "\uD835\uDD26", "\uD835\uDD27", "\uD835\uDD28", "\uD835\uDD29", "\uD835\uDD2A", "\uD835\uDD2B", "\uD835\uDD2C", "\uD835\uDD2D", "\uD835\uDD2E", "\uD835\uDD2F", "\uD835\uDD30", "\uD835\uDD31", "\uD835\uDD32", "\uD835\uDD33", "\uD835\uDD34", "\uD835\uDD35", "\uD835\uDD36", "\uD835\uDD37"],
          E = ["\uD835\uDD38", "\uD835\uDD39", "\u2102", "\uD835\uDD3B", "\uD835\uDD3C", "\uD835\uDD3D", "\uD835\uDD3E", "\u210D", "\uD835\uDD40", "\uD835\uDD41", "\uD835\uDD42", "\uD835\uDD43", "\uD835\uDD44", "\u2115", "\uD835\uDD46", "\u2119", "\u211A", "\u211D", "\uD835\uDD4A", "\uD835\uDD4B", "\uD835\uDD4C", "\uD835\uDD4D", "\uD835\uDD4E", "\uD835\uDD4F", "\uD835\uDD50", "\u2124"],
          A = ["\uD835\uDD52", "\uD835\uDD53", "\uD835\uDD54", "\uD835\uDD55", "\uD835\uDD56", "\uD835\uDD57", "\uD835\uDD58", "\uD835\uDD59", "\uD835\uDD5A", "\uD835\uDD5B", "\uD835\uDD5C", "\uD835\uDD5D", "\uD835\uDD5E", "\uD835\uDD5F", "\uD835\uDD60", "\uD835\uDD61", "\uD835\uDD62", "\uD835\uDD63", "\uD835\uDD64", "\uD835\uDD65", "\uD835\uDD66", "\uD835\uDD67", "\uD835\uDD68", "\uD835\uDD69", "\uD835\uDD6A", "\uD835\uDD6B"],
          C = ["\uD835\uDD6C", "\uD835\uDD6D", "\uD835\uDD6E", "\uD835\uDD6F", "\uD835\uDD70", "\uD835\uDD71", "\uD835\uDD72", "\uD835\uDD73", "\uD835\uDD74", "\uD835\uDD75", "\uD835\uDD76", "\uD835\uDD77", "\uD835\uDD78", "\uD835\uDD79", "\uD835\uDD7A", "\uD835\uDD7B", "\uD835\uDD7C", "\uD835\uDD7D", "\uD835\uDD7E", "\uD835\uDD7F", "\uD835\uDD80", "\uD835\uDD81", "\uD835\uDD82", "\uD835\uDD83", "\uD835\uDD84", "\uD835\uDD85"],
          w = ["\uD835\uDD86", "\uD835\uDD87", "\uD835\uDD88", "\uD835\uDD89", "\uD835\uDD8A", "\uD835\uDD8B", "\uD835\uDD8C", "\uD835\uDD8D", "\uD835\uDD8E", "\uD835\uDD8F", "\uD835\uDD90", "\uD835\uDD91", "\uD835\uDD92", "\uD835\uDD93", "\uD835\uDD94", "\uD835\uDD95", "\uD835\uDD96", "\uD835\uDD97", "\uD835\uDD98", "\uD835\uDD99", "\uD835\uDD9A", "\uD835\uDD9B", "\uD835\uDD9C", "\uD835\uDD9D", "\uD835\uDD9E", "\uD835\uDD9F"],
          N = ["\uD835\uDDA0", "\uD835\uDDA1", "\uD835\uDDA2", "\uD835\uDDA3", "\uD835\uDDA4", "\uD835\uDDA5", "\uD835\uDDA6", "\uD835\uDDA7", "\uD835\uDDA8", "\uD835\uDDA9", "\uD835\uDDAA", "\uD835\uDDAB", "\uD835\uDDAC", "\uD835\uDDAD", "\uD835\uDDAE", "\uD835\uDDAF", "\uD835\uDDB0", "\uD835\uDDB1", "\uD835\uDDB2", "\uD835\uDDB3", "\uD835\uDDB4", "\uD835\uDDB5", "\uD835\uDDB6", "\uD835\uDDB7", "\uD835\uDDB8", "\uD835\uDDB9"],
          P = ["\uD835\uDDBA", "\uD835\uDDBB", "\uD835\uDDBC", "\uD835\uDDBD", "\uD835\uDDBE", "\uD835\uDDBF", "\uD835\uDDC0", "\uD835\uDDC1", "\uD835\uDDC2", "\uD835\uDDC3", "\uD835\uDDC4", "\uD835\uDDC5", "\uD835\uDDC6", "\uD835\uDDC7", "\uD835\uDDC8", "\uD835\uDDC9", "\uD835\uDDCA", "\uD835\uDDCB", "\uD835\uDDCC", "\uD835\uDDCD", "\uD835\uDDCE", "\uD835\uDDCF", "\uD835\uDDD0", "\uD835\uDDD1", "\uD835\uDDD2", "\uD835\uDDD3"],
          k = ["\uD835\uDDD4", "\uD835\uDDD5", "\uD835\uDDD6", "\uD835\uDDD7", "\uD835\uDDD8", "\uD835\uDDD9", "\uD835\uDDDA", "\uD835\uDDDB", "\uD835\uDDDC", "\uD835\uDDDD", "\uD835\uDDDE", "\uD835\uDDDF", "\uD835\uDDE0", "\uD835\uDDE1", "\uD835\uDDE2", "\uD835\uDDE3", "\uD835\uDDE4", "\uD835\uDDE5", "\uD835\uDDE6", "\uD835\uDDE7", "\uD835\uDDE8", "\uD835\uDDE9", "\uD835\uDDEA", "\uD835\uDDEB", "\uD835\uDDEC", "\uD835\uDDED"],
          I = ["\uD835\uDDEE", "\uD835\uDDEF", "\uD835\uDDF0", "\uD835\uDDF1", "\uD835\uDDF2", "\uD835\uDDF3", "\uD835\uDDF4", "\uD835\uDDF5", "\uD835\uDDF6", "\uD835\uDDF7", "\uD835\uDDF8", "\uD835\uDDF9", "\uD835\uDDFA", "\uD835\uDDFB", "\uD835\uDDFC", "\uD835\uDDFD", "\uD835\uDDFE", "\uD835\uDDFF", "\uD835\uDE00", "\uD835\uDE01", "\uD835\uDE02", "\uD835\uDE03", "\uD835\uDE04", "\uD835\uDE05", "\uD835\uDE06", "\uD835\uDE07"],
          R = ["\uD835\uDE08", "\uD835\uDE09", "\uD835\uDE0A", "\uD835\uDE0B", "\uD835\uDE0C", "\uD835\uDE0D", "\uD835\uDE0E", "\uD835\uDE0F", "\uD835\uDE10", "\uD835\uDE11", "\uD835\uDE12", "\uD835\uDE13", "\uD835\uDE14", "\uD835\uDE15", "\uD835\uDE16", "\uD835\uDE17", "\uD835\uDE18", "\uD835\uDE19", "\uD835\uDE1A", "\uD835\uDE1B", "\uD835\uDE1C", "\uD835\uDE1D", "\uD835\uDE1E", "\uD835\uDE1F", "\uD835\uDE20", "\uD835\uDE21"],
          D = ["\uD835\uDE22", "\uD835\uDE23", "\uD835\uDE24", "\uD835\uDE25", "\uD835\uDE26", "\uD835\uDE27", "\uD835\uDE28", "\uD835\uDE29", "\uD835\uDE2A", "\uD835\uDE2B", "\uD835\uDE2C", "\uD835\uDE2D", "\uD835\uDE2E", "\uD835\uDE2F", "\uD835\uDE30", "\uD835\uDE31", "\uD835\uDE32", "\uD835\uDE33", "\uD835\uDE34", "\uD835\uDE35", "\uD835\uDE36", "\uD835\uDE37", "\uD835\uDE38", "\uD835\uDE39", "\uD835\uDE3A", "\uD835\uDE3B"],
          j = ["\uD835\uDE3C", "\uD835\uDE3D", "\uD835\uDE3E", "\uD835\uDE3F", "\uD835\uDE40", "\uD835\uDE41", "\uD835\uDE42", "\uD835\uDE43", "\uD835\uDE44", "\uD835\uDE45", "\uD835\uDE46", "\uD835\uDE47", "\uD835\uDE48", "\uD835\uDE49", "\uD835\uDE4A", "\uD835\uDE4B", "\uD835\uDE4C", "\uD835\uDE4D", "\uD835\uDE4E", "\uD835\uDE4F", "\uD835\uDE50", "\uD835\uDE51", "\uD835\uDE52", "\uD835\uDE53", "\uD835\uDE54", "\uD835\uDE55"],
          B = ["\uD835\uDE56", "\uD835\uDE57", "\uD835\uDE58", "\uD835\uDE59", "\uD835\uDE5A", "\uD835\uDE5B", "\uD835\uDE5C", "\uD835\uDE5D", "\uD835\uDE5E", "\uD835\uDE5F", "\uD835\uDE60", "\uD835\uDE61", "\uD835\uDE62", "\uD835\uDE63", "\uD835\uDE64", "\uD835\uDE65", "\uD835\uDE66", "\uD835\uDE67", "\uD835\uDE68", "\uD835\uDE69", "\uD835\uDE6A", "\uD835\uDE6B", "\uD835\uDE6C", "\uD835\uDE6D", "\uD835\uDE6E", "\uD835\uDE6F"],
          F = ["\uD835\uDE70", "\uD835\uDE71", "\uD835\uDE72", "\uD835\uDE73", "\uD835\uDE74", "\uD835\uDE75", "\uD835\uDE76", "\uD835\uDE77", "\uD835\uDE78", "\uD835\uDE79", "\uD835\uDE7A", "\uD835\uDE7B", "\uD835\uDE7C", "\uD835\uDE7D", "\uD835\uDE7E", "\uD835\uDE7F", "\uD835\uDE80", "\uD835\uDE81", "\uD835\uDE82", "\uD835\uDE83", "\uD835\uDE84", "\uD835\uDE85", "\uD835\uDE86", "\uD835\uDE87", "\uD835\uDE88", "\uD835\uDE89"],
          Z = ["\uD835\uDE8A", "\uD835\uDE8B", "\uD835\uDE8C", "\uD835\uDE8D", "\uD835\uDE8E", "\uD835\uDE8F", "\uD835\uDE90", "\uD835\uDE91", "\uD835\uDE92", "\uD835\uDE93", "\uD835\uDE94", "\uD835\uDE95", "\uD835\uDE96", "\uD835\uDE97", "\uD835\uDE98", "\uD835\uDE99", "\uD835\uDE9A", "\uD835\uDE9B", "\uD835\uDE9C", "\uD835\uDE9D", "\uD835\uDE9E", "\uD835\uDE9F", "\uD835\uDEA0", "\uD835\uDEA1", "\uD835\uDEA2", "\uD835\uDEA3"],
          G = ["\u2145", "\u2146", "\u2147", "\u2148", "\u2149"],
          q = ["\u0391", "\u0392", "\u0393", "\u0394", "\u0395", "\u0396", "\u0397", "\u0398", "\u0399", "\u039A", "\u039B", "\u039C", "\u039D", "\u039E", "\u039F", "\u03A0", "\u03A1", "\u03A3", "\u03A4", "\u03A5", "\u03A6", "\u03A7", "\u03A8", "\u03A9"],
          U = ["\u03B1", "\u03B2", "\u03B3", "\u03B4", "\u03B5", "\u03B6", "\u03B7", "\u03B8", "\u03B9", "\u03BA", "\u03BB", "\u03BC", "\u03BD", "\u03BE", "\u03BF", "\u03C0", "\u03C1", "\u03C2", "\u03C3", "\u03C4", "\u03C5", "\u03C6", "\u03C7", "\u03C8", "\u03C9"],
          W = ["\uD835\uDEA8", "\uD835\uDEA9", "\uD835\uDEAA", "\uD835\uDEAB", "\uD835\uDEAC", "\uD835\uDEAD", "\uD835\uDEAE", "\uD835\uDEAF", "\uD835\uDEB0", "\uD835\uDEB1", "\uD835\uDEB2", "\uD835\uDEB3", "\uD835\uDEB4", "\uD835\uDEB5", "\uD835\uDEB6", "\uD835\uDEB7", "\uD835\uDEB8", "\uD835\uDEBA", "\uD835\uDEBB", "\uD835\uDEBC", "\uD835\uDEBD", "\uD835\uDEBE", "\uD835\uDEBF", "\uD835\uDEC0"],
          X = ["\uD835\uDEC2", "\uD835\uDEC3", "\uD835\uDEC4", "\uD835\uDEC5", "\uD835\uDEC6", "\uD835\uDEC7", "\uD835\uDEC8", "\uD835\uDEC9", "\uD835\uDECA", "\uD835\uDECB", "\uD835\uDECC", "\uD835\uDECD", "\uD835\uDECE", "\uD835\uDECF", "\uD835\uDED0", "\uD835\uDED1", "\uD835\uDED2", "\uD835\uDED3", "\uD835\uDED4", "\uD835\uDED5", "\uD835\uDED6", "\uD835\uDED7", "\uD835\uDED8", "\uD835\uDED9", "\uD835\uDEDA"],
          z = ["\uD835\uDEE2", "\uD835\uDEE3", "\uD835\uDEE4", "\uD835\uDEE5", "\uD835\uDEE6", "\uD835\uDEE7", "\uD835\uDEE8", "\uD835\uDEE9", "\uD835\uDEEA", "\uD835\uDEEB", "\uD835\uDEEC", "\uD835\uDEED", "\uD835\uDEEE", "\uD835\uDEEF", "\uD835\uDEF0", "\uD835\uDEF1", "\uD835\uDEF2", "\uD835\uDEF4", "\uD835\uDEF5", "\uD835\uDEF6", "\uD835\uDEF7", "\uD835\uDEF8", "\uD835\uDEF9", "\uD835\uDEFA"],
          $ = ["\uD835\uDEFC", "\uD835\uDEFD", "\uD835\uDEFE", "\uD835\uDEFF", "\uD835\uDF00", "\uD835\uDF01", "\uD835\uDF02", "\uD835\uDF03", "\uD835\uDF04", "\uD835\uDF05", "\uD835\uDF06", "\uD835\uDF07", "\uD835\uDF08", "\uD835\uDF09", "\uD835\uDF0A", "\uD835\uDF0B", "\uD835\uDF0C", "\uD835\uDF0D", "\uD835\uDF0E", "\uD835\uDF0F", "\uD835\uDF10", "\uD835\uDF11", "\uD835\uDF12", "\uD835\uDF13", "\uD835\uDF14"],
          K = ["\uD835\uDF1C", "\uD835\uDF1D", "\uD835\uDF1E", "\uD835\uDF1F", "\uD835\uDF20", "\uD835\uDF21", "\uD835\uDF22", "\uD835\uDF23", "\uD835\uDF24", "\uD835\uDF25", "\uD835\uDF26", "\uD835\uDF27", "\uD835\uDF28", "\uD835\uDF29", "\uD835\uDF2A", "\uD835\uDF2B", "\uD835\uDF2C", "\uD835\uDF2E", "\uD835\uDF2F", "\uD835\uDF30", "\uD835\uDF31", "\uD835\uDF32", "\uD835\uDF33", "\uD835\uDF34"],
          J = ["\uD835\uDF36", "\uD835\uDF37", "\uD835\uDF38", "\uD835\uDF39", "\uD835\uDF3A", "\uD835\uDF3B", "\uD835\uDF3C", "\uD835\uDF3D", "\uD835\uDF3E", "\uD835\uDF3F", "\uD835\uDF40", "\uD835\uDF41", "\uD835\uDF42", "\uD835\uDF43", "\uD835\uDF44", "\uD835\uDF45", "\uD835\uDF46", "\uD835\uDF47", "\uD835\uDF48", "\uD835\uDF49", "\uD835\uDF4A", "\uD835\uDF4B", "\uD835\uDF4C", "\uD835\uDF4D", "\uD835\uDF4E"],
          Y = ["\uD835\uDF56", "\uD835\uDF57", "\uD835\uDF58", "\uD835\uDF59", "\uD835\uDF5A", "\uD835\uDF5B", "\uD835\uDF5C", "\uD835\uDF5D", "\uD835\uDF5E", "\uD835\uDF5F", "\uD835\uDF60", "\uD835\uDF61", "\uD835\uDF62", "\uD835\uDF63", "\uD835\uDF64", "\uD835\uDF65", "\uD835\uDF66", "\uD835\uDF68", "\uD835\uDF69", "\uD835\uDF6A", "\uD835\uDF6B", "\uD835\uDF6C", "\uD835\uDF6D", "\uD835\uDF6E"],
          tt = ["\uD835\uDF70", "\uD835\uDF71", "\uD835\uDF72", "\uD835\uDF73", "\uD835\uDF74", "\uD835\uDF75", "\uD835\uDF76", "\uD835\uDF77", "\uD835\uDF78", "\uD835\uDF79", "\uD835\uDF7A", "\uD835\uDF7B", "\uD835\uDF7C", "\uD835\uDF7D", "\uD835\uDF7E", "\uD835\uDF7F", "\uD835\uDF80", "\uD835\uDF81", "\uD835\uDF82", "\uD835\uDF83", "\uD835\uDF84", "\uD835\uDF85", "\uD835\uDF86", "\uD835\uDF87", "\uD835\uDF88"],
          et = ["\uD835\uDF90", "\uD835\uDF91", "\uD835\uDF92", "\uD835\uDF93", "\uD835\uDF94", "\uD835\uDF95", "\uD835\uDF96", "\uD835\uDF97", "\uD835\uDF98", "\uD835\uDF99", "\uD835\uDF9A", "\uD835\uDF9B", "\uD835\uDF9C", "\uD835\uDF9D", "\uD835\uDF9E", "\uD835\uDF9F", "\uD835\uDFA0", "\uD835\uDFA2", "\uD835\uDFA3", "\uD835\uDFA4", "\uD835\uDFA5", "\uD835\uDFA6", "\uD835\uDFA7", "\uD835\uDFA8"],
          rt = ["\uD835\uDFAA", "\uD835\uDFAB", "\uD835\uDFAC", "\uD835\uDFAD", "\uD835\uDFAE", "\uD835\uDFAF", "\uD835\uDFB0", "\uD835\uDFB1", "\uD835\uDFB2", "\uD835\uDFB3", "\uD835\uDFB4", "\uD835\uDFB5", "\uD835\uDFB6", "\uD835\uDFB7", "\uD835\uDFB8", "\uD835\uDFB9", "\uD835\uDFBA", "\uD835\uDFBB", "\uD835\uDFBC", "\uD835\uDFBD", "\uD835\uDFBE", "\uD835\uDFBF", "\uD835\uDFC0", "\uD835\uDFC1", "\uD835\uDFC2"],
          nt = ["\u213C", "\u213D", "\u213E", "\u213F"],
          ot = ["\u03D0", "\u03D1", "\u03D5", "\u03D6", "\u03D7", "\u03F0", "\u03F1", "\u03F5", "\u03F6", "\u03F4"],
          it = ["\uD835\uDEDC", "\uD835\uDEDD", "\uD835\uDEDE", "\uD835\uDEDF", "\uD835\uDEE0", "\uD835\uDEE1"],
          at = ["\uD835\uDF16", "\uD835\uDF17", "\uD835\uDF18", "\uD835\uDF19", "\uD835\uDF1A", "\uD835\uDF1B"],
          Qt = ["\uD835\uDF8A", "\uD835\uDF8B", "\uD835\uDF8C", "\uD835\uDF8D", "\uD835\uDF8E", "\uD835\uDF8F"],
          st = ["\u2135", "\u2136", "\u2137", "\u2138"],
          Tt = h.concat(d, f, m, L, y, g, b, H, v, _, M, x, O, S, V, E, A, C, w, N, P, k, I, R, D, j, B, F, Z, G, q, U, W, X, z, $, K, J, Y, tt, nt, ot, et, rt, it, at, Qt, st);
        e.allLettersRegExp = new RegExp(Tt.join("|"));
        var lt = ["+", "\xb1", "\u2213", "\u2214", "\u2227", "\u2228", "\u2229", "\u222A", "\u228C", "\u228D", "\u228E", "\u2293", "\u2294", "\u229D", "\u229E", "\u22A4", "\u22A5", "\u22BA", "\u22BB", "\u22BC", "\u22C4", "\u22CE", "\u22CF", "\u22D2", "\u22D3", "\u2A5E", "\u2295", "\u22D4"],
          ct = String.fromCodePoint(8292);
        lt.push(ct);
        var ut = ["\u2020", "\u2021", "\u2210", "\u2217", "\u2218", "\u2219", "\u2240", "\u229A", "\u229B", "\u22A0", "\u22A1", "\u22C5", "\u22C6", "\u22C7", "\u22C8", "\u22C9", "\u22CA", "\u22CB", "\u22CC", "\u25CB", "\xb7", "*", "\u2297", "\u2299"],
          pt = String.fromCodePoint(8290);
        ut.push(pt);
        var ht = String.fromCodePoint(8289),
          dt = ["\xbc", "\xbd", "\xbe", "\u2150", "\u2151", "\u2152", "\u2153", "\u2154", "\u2155", "\u2156", "\u2157", "\u2158", "\u2159", "\u215A", "\u215B", "\u215C", "\u215D", "\u215E", "\u215F", "\u2189"],
          ft = ["\xb2", "\xb3", "\xb9", "\u2070", "\u2074", "\u2075", "\u2076", "\u2077", "\u2078", "\u2079"].concat(["\u2080", "\u2081", "\u2082", "\u2083", "\u2084", "\u2085", "\u2086", "\u2087", "\u2088", "\u2089"], ["\u2460", "\u2461", "\u2462", "\u2463", "\u2464", "\u2465", "\u2466", "\u2467", "\u2468", "\u2469", "\u246A", "\u246B", "\u246C", "\u246D", "\u246E", "\u246F", "\u2470", "\u2471", "\u2472", "\u2473", "\u24EA", "\u24EB", "\u24EC", "\u24ED", "\u24EE", "\u24EF", "\u24F0", "\u24F1", "\u24F2", "\u24F3", "\u24F4", "\u24F5", "\u24F6", "\u24F7", "\u24F8", "\u24F9", "\u24FA", "\u24FB", "\u24FC", "\u24FD", "\u24FE", "\u24FF", "\u2776", "\u2777", "\u2778", "\u2779", "\u277A", "\u277B", "\u277C", "\u277D", "\u277E", "\u277F", "\u2780", "\u2781", "\u2782", "\u2783", "\u2784", "\u2785", "\u2786", "\u2787", "\u2788", "\u2789", "\u278A", "\u278B", "\u278C", "\u278D", "\u278E", "\u278F", "\u2790", "\u2791", "\u2792", "\u2793", "\u3248", "\u3249", "\u324A", "\u324B", "\u324C", "\u324D", "\u324E", "\u324F", "\u3251", "\u3252", "\u3253", "\u3254", "\u3255", "\u3256", "\u3257", "\u3258", "\u3259", "\u325A", "\u325B", "\u325C", "\u325D", "\u325E", "\u325F", "\u32B1", "\u32B2", "\u32B3", "\u32B4", "\u32B5", "\u32B6", "\u32B7", "\u32B8", "\u32B9", "\u32BA", "\u32BB", "\u32BC", "\u32BD", "\u32BE", "\u32BF"], ["\u2474", "\u2475", "\u2476", "\u2477", "\u2478", "\u2479", "\u247A", "\u247B", "\u247C", "\u247D", "\u247E", "\u247F", "\u2480", "\u2481", "\u2482", "\u2483", "\u2484", "\u2485", "\u2486", "\u2487"], ["\u2488", "\u2489", "\u248A", "\u248B", "\u248C", "\u248D", "\u248E", "\u248F", "\u2490", "\u2491", "\u2492", "\u2493", "\u2494", "\u2495", "\u2496", "\u2497", "\u2498", "\u2499", "\u249A", "\u249B", "\uD83C\uDD00", "\uD83C\uDD01", "\uD83C\uDD02", "\uD83C\uDD03", "\uD83C\uDD04", "\uD83C\uDD05", "\uD83C\uDD06", "\uD83C\uDD07", "\uD83C\uDD08", "\uD83C\uDD09", "\uD83C\uDD0A"]),
          mt = ["cos", "cot", "csc", "sec", "sin", "tan", "arccos", "arccot", "arccsc", "arcsec", "arcsin", "arctan", "arc cos", "arc cot", "arc csc", "arc sec", "arc sin", "arc tan"].concat(["cosh", "coth", "csch", "sech", "sinh", "tanh", "arcosh", "arcoth", "arcsch", "arsech", "arsinh", "artanh", "arccosh", "arccoth", "arccsch", "arcsech", "arcsinh", "arctanh"], ["deg", "det", "dim", "hom", "ker", "Tr", "tr"], ["log", "ln", "lg", "exp", "expt", "gcd", "gcd", "arg", "im", "re", "Pr"]),
          Lt = [{
            set: ["!", '"', "#", "%", "&", ";", "?", "@", "\\", "\xa1", "\xa7", "\xb6", "\xbf", "\u2017", "\u2020", "\u2021", "\u2022", "\u2023", "\u2024", "\u2025", "\u2027", "\u2030", "\u2031", "\u2038", "\u203B", "\u203C", "\u203D", "\u203E", "\u2041", "\u2042", "\u2043", "\u2047", "\u2048", "\u2049", "\u204B", "\u204C", "\u204D", "\u204E", "\u204F", "\u2050", "\u2051", "\u2053", "\u2055", "\u2056", "\u2058", "\u2059", "\u205A", "\u205B", "\u205C", "\u205D", "\u205E", "\uFE10", "\uFE14", "\uFE15", "\uFE16", "\uFE30", "\uFE45", "\uFE46", "\uFE49", "\uFE4A", "\uFE4B", "\uFE4C", "\uFE54", "\uFE56", "\uFE57", "\uFE5F", "\uFE60", "\uFE61", "\uFE68", "\uFE6A", "\uFE6B", "\uFF01", "\uFF02", "\uFF03", "\uFF05", "\uFF06", "\uFF07", "\uFF0A", "\uFF0F", "\uFF1B", "\uFF1F", "\uFF20", "\uFF3C"],
            type: "punctuation",
            role: "unknown"
          }, {
            set: ["\uFE13", ":", "\uFF1A", "\uFE55"],
            type: "punctuation",
            role: "colon"
          }, {
            set: n,
            type: "punctuation",
            role: "comma"
          }, {
            set: ["\u2026", "\u22EE", "\u22EF", "\u22F0", "\u22F1", "\uFE19"],
            type: "punctuation",
            role: "ellipsis"
          }, {
            set: [".", "\uFE52", "\uFF0E"],
            type: "punctuation",
            role: "fullstop"
          }, {
            set: o,
            type: "operator",
            role: "dash"
          }, {
            set: i,
            type: "operator",
            role: "tilde"
          }, {
            set: ["'", "\u2032", "\u2033", "\u2034", "\u2035", "\u2036", "\u2037", "\u2057", "\u02B9", "\u02BA"],
            type: "punctuation",
            role: "prime"
          }, {
            set: ["\xb0"],
            type: "punctuation",
            role: "degree"
          }, {
            set: s,
            type: "fence",
            role: "open"
          }, {
            set: T,
            type: "fence",
            role: "close"
          }, {
            set: l,
            type: "fence",
            role: "top"
          }, {
            set: c,
            type: "fence",
            role: "bottom"
          }, {
            set: u,
            type: "fence",
            role: "neutral"
          }, {
            set: p,
            type: "fence",
            role: "metric"
          }, {
            set: d,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: h,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: m,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: f,
            type: "identifier",
            role: "latinletter",
            font: "normal"
          }, {
            set: y,
            type: "identifier",
            role: "latinletter",
            font: "bold"
          }, {
            set: L,
            type: "identifier",
            role: "latinletter",
            font: "bold"
          }, {
            set: v,
            type: "identifier",
            role: "latinletter",
            font: "italic"
          }, {
            set: g,
            type: "identifier",
            role: "latinletter",
            font: "italic"
          }, {
            set: H,
            type: "identifier",
            role: "latinletter",
            font: "bold-italic"
          }, {
            set: b,
            type: "identifier",
            role: "latinletter",
            font: "bold-italic"
          }, {
            set: M,
            type: "identifier",
            role: "latinletter",
            font: "script"
          }, {
            set: _,
            type: "identifier",
            role: "latinletter",
            font: "script"
          }, {
            set: O,
            type: "identifier",
            role: "latinletter",
            font: "bold-script"
          }, {
            set: x,
            type: "identifier",
            role: "latinletter",
            font: "bold-script"
          }, {
            set: V,
            type: "identifier",
            role: "latinletter",
            font: "fraktur"
          }, {
            set: S,
            type: "identifier",
            role: "latinletter",
            font: "fraktur"
          }, {
            set: A,
            type: "identifier",
            role: "latinletter",
            font: "double-struck"
          }, {
            set: E,
            type: "identifier",
            role: "latinletter",
            font: "double-struck"
          }, {
            set: w,
            type: "identifier",
            role: "latinletter",
            font: "bold-fraktur"
          }, {
            set: C,
            type: "identifier",
            role: "latinletter",
            font: "bold-fraktur"
          }, {
            set: P,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif"
          }, {
            set: N,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif"
          }, {
            set: I,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold"
          }, {
            set: k,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold"
          }, {
            set: D,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-italic"
          }, {
            set: R,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-italic"
          }, {
            set: B,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold-italic"
          }, {
            set: j,
            type: "identifier",
            role: "latinletter",
            font: "sans-serif-bold-italic"
          }, {
            set: Z,
            type: "identifier",
            role: "latinletter",
            font: "monospace"
          }, {
            set: F,
            type: "identifier",
            role: "latinletter",
            font: "monospace"
          }, {
            set: G,
            type: "identifier",
            role: "latinletter",
            font: "double-struck-italic"
          }, {
            set: U,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: q,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: X,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: W,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: $,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: z,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: J,
            type: "identifier",
            role: "greekletter",
            font: "bold-italic"
          }, {
            set: K,
            type: "identifier",
            role: "greekletter",
            font: "bold-italic"
          }, {
            set: tt,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: Y,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: et,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold-italic"
          }, {
            set: rt,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold-italic"
          }, {
            set: nt,
            type: "identifier",
            role: "greekletter",
            font: "double-struck"
          }, {
            set: ot,
            type: "identifier",
            role: "greekletter",
            font: "normal"
          }, {
            set: it,
            type: "identifier",
            role: "greekletter",
            font: "bold"
          }, {
            set: at,
            type: "identifier",
            role: "greekletter",
            font: "italic"
          }, {
            set: Qt,
            type: "identifier",
            role: "greekletter",
            font: "sans-serif-bold"
          }, {
            set: st,
            type: "identifier",
            role: "otherletter",
            font: "normal"
          }, {
            set: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            type: "number",
            role: "integer",
            font: "normal"
          }, {
            set: ["\uFF10", "\uFF11", "\uFF12", "\uFF13", "\uFF14", "\uFF15", "\uFF16", "\uFF17", "\uFF18", "\uFF19"],
            type: "number",
            role: "integer",
            font: "normal"
          }, {
            set: ["\uD835\uDFCE", "\uD835\uDFCF", "\uD835\uDFD0", "\uD835\uDFD1", "\uD835\uDFD2", "\uD835\uDFD3", "\uD835\uDFD4", "\uD835\uDFD5", "\uD835\uDFD6", "\uD835\uDFD7"],
            type: "number",
            role: "integer",
            font: "bold"
          }, {
            set: ["\uD835\uDFD8", "\uD835\uDFD9", "\uD835\uDFDA", "\uD835\uDFDB", "\uD835\uDFDC", "\uD835\uDFDD", "\uD835\uDFDE", "\uD835\uDFDF", "\uD835\uDFE0", "\uD835\uDFE1"],
            type: "number",
            role: "integer",
            font: "double-struck"
          }, {
            set: ["\uD835\uDFE2", "\uD835\uDFE3", "\uD835\uDFE4", "\uD835\uDFE5", "\uD835\uDFE6", "\uD835\uDFE7", "\uD835\uDFE8", "\uD835\uDFE9", "\uD835\uDFEA", "\uD835\uDFEB"],
            type: "number",
            role: "integer",
            font: "sans-serif"
          }, {
            set: ["\uD835\uDFEC", "\uD835\uDFED", "\uD835\uDFEE", "\uD835\uDFEF", "\uD835\uDFF0", "\uD835\uDFF1", "\uD835\uDFF2", "\uD835\uDFF3", "\uD835\uDFF4", "\uD835\uDFF5"],
            type: "number",
            role: "integer",
            font: "sans-serif-bold"
          }, {
            set: ["\uD835\uDFF6", "\uD835\uDFF7", "\uD835\uDFF8", "\uD835\uDFF9", "\uD835\uDFFA", "\uD835\uDFFB", "\uD835\uDFFC", "\uD835\uDFFD", "\uD835\uDFFE", "\uD835\uDFFF"],
            type: "number",
            role: "integer",
            font: "monospace"
          }, {
            set: dt,
            type: "number",
            role: "float"
          }, {
            set: ft,
            type: "number",
            role: "othernumber"
          }, {
            set: lt,
            type: "operator",
            role: "addition"
          }, {
            set: ut,
            type: "operator",
            role: "multiplication"
          }, {
            set: ["\xaf", "-", "\u2052", "\u207B", "\u208B", "\u2212", "\u2216", "\u2238", "\u2242", "\u2296", "\u229F", "\u2796", "\u2A29", "\u2A2A", "\u2A2B", "\u2A2C", "\u2A3A", "\u2A41", "\uFE63", "\uFF0D", "\u2010", "\u2011"],
            type: "operator",
            role: "subtraction"
          }, {
            set: ["/", "\xf7", "\u2044", "\u2215", "\u2298", "\u27CC", "\u29BC", "\u2A38"],
            type: "operator",
            role: "division"
          }, {
            set: ["\u2200", "\u2203", "\u2206", "\u2207", "\u2202", "\u2201", "\u2204"],
            type: "operator",
            role: "prefix operator"
          }, {
            set: ["\uD835\uDEC1", "\uD835\uDEDB", "\uD835\uDFCA", "\uD835\uDFCB"],
            type: "operator",
            role: "prefix operator",
            font: "bold"
          }, {
            set: ["\uD835\uDEFB", "\uD835\uDF15"],
            type: "operator",
            role: "prefix operator",
            font: "italic"
          }, {
            set: ["\uD835\uDF6F", "\uD835\uDF89"],
            type: "operator",
            role: "prefix operator",
            font: "sans-serif-bold"
          }, {
            set: ["=", "~", "\u207C", "\u208C", "\u223C", "\u223D", "\u2243", "\u2245", "\u2248", "\u224A", "\u224B", "\u224C", "\u224D", "\u224E", "\u2251", "\u2252", "\u2253", "\u2254", "\u2255", "\u2256", "\u2257", "\u2258", "\u2259", "\u225A", "\u225B", "\u225C", "\u225D", "\u225E", "\u225F", "\u2261", "\u2263", "\u29E4", "\u2A66", "\u2A6E", "\u2A6F", "\u2A70", "\u2A71", "\u2A72", "\u2A73", "\u2A74", "\u2A75", "\u2A76", "\u2A77", "\u2A78", "\u22D5", "\u2A6D", "\u2A6A", "\u2A6B", "\u2A6C", "\uFE66", "\uFF1D", "\u2A6C", "\u229C", "\u2237"],
            type: "relation",
            role: "equality"
          }, {
            set: ["<", ">", "\u2241", "\u2242", "\u2244", "\u2246", "\u2247", "\u2249", "\u224F", "\u2250", "\u2260", "\u2262", "\u2264", "\u2265", "\u2266", "\u2267", "\u2268", "\u2269", "\u226A", "\u226B", "\u226C", "\u226D", "\u226E", "\u226F", "\u2270", "\u2271", "\u2272", "\u2273", "\u2274", "\u2275", "\u2276", "\u2277", "\u2278", "\u2279", "\u227A", "\u227B", "\u227C", "\u227D", "\u227E", "\u227F", "\u2280", "\u2281", "\u22D6", "\u22D7", "\u22D8", "\u22D9", "\u22DA", "\u22DB", "\u22DC", "\u22DD", "\u22DE", "\u22DF", "\u22E0", "\u22E1", "\u22E6", "\u22E7", "\u22E8", "\u22E9", "\u2A79", "\u2A7A", "\u2A7B", "\u2A7C", "\u2A7D", "\u2A7E", "\u2A7F", "\u2A80", "\u2A81", "\u2A82", "\u2A83", "\u2A84", "\u2A85", "\u2A86", "\u2A87", "\u2A88", "\u2A89", "\u2A8A", "\u2A8B", "\u2A8C", "\u2A8D", "\u2A8E", "\u2A8F", "\u2A90", "\u2A91", "\u2A92", "\u2A93", "\u2A94", "\u2A95", "\u2A96", "\u2A97", "\u2A98", "\u2A99", "\u2A9A", "\u2A9B", "\u2A9C", "\u2A9D", "\u2A9E", "\u2A9F", "\u2AA0", "\u2AA1", "\u2AA2", "\u2AA3", "\u2AA4", "\u2AA5", "\u2AA6", "\u2AA7", "\u2AA8", "\u2AA9", "\u2AAA", "\u2AAB", "\u2AAC", "\u2AAD", "\u2AAE", "\u2AAF", "\u2AB0", "\u2AB1", "\u2AB2", "\u2AB3", "\u2AB4", "\u2AB5", "\u2AB6", "\u2AB7", "\u2AB8", "\u2AB9", "\u2ABA", "\u2ABB", "\u2ABC", "\u2AF7", "\u2AF8", "\u2AF9", "\u2AFA", "\u29C0", "\u29C1", "\uFE64", "\uFE65", "\uFF1C", "\uFF1E"],
            type: "relation",
            role: "inequality"
          }, {
            set: ["\u22E2", "\u22E3", "\u22E4", "\u22E5", "\u2282", "\u2283", "\u2284", "\u2285", "\u2286", "\u2287", "\u2288", "\u2289", "\u228A", "\u228B", "\u228F", "\u2290", "\u2291", "\u2292", "\u2ABD", "\u2ABE", "\u2ABF", "\u2AC0", "\u2AC1", "\u2AC2", "\u2AC3", "\u2AC4", "\u2AC5", "\u2AC6", "\u2AC7", "\u2AC8", "\u2AC9", "\u2ACA", "\u2ACB", "\u2ACC", "\u2ACD", "\u2ACE", "\u2ACF", "\u2AD0", "\u2AD1", "\u2AD2", "\u2AD3", "\u2AD4", "\u2AD5", "\u2AD6", "\u2AD7", "\u2AD8", "\u22D0", "\u22D1", "\u22EA", "\u22EB", "\u22EC", "\u22ED", "\u22B2", "\u22B3", "\u22B4", "\u22B5"],
            type: "relation",
            role: "set"
          }, {
            set: ["\u22A2", "\u22A3", "\u22A6", "\u22A7", "\u22A8", "\u22A9", "\u22AA", "\u22AB", "\u22AC", "\u22AD", "\u22AE", "\u22AF", "\u2ADE", "\u2ADF", "\u2AE0", "\u2AE1", "\u2AE2", "\u2AE3", "\u2AE4", "\u2AE5", "\u2AE6", "\u2AE7", "\u2AE8", "\u2AE9", "\u2AEA", "\u2AEB", "\u2AEC", "\u2AED"],
            type: "relation",
            role: "unknown"
          }, {
            set: ["\u2190", "\u2191", "\u2192", "\u2193", "\u2194", "\u2195", "\u2196", "\u2197", "\u2198", "\u2199", "\u219A", "\u219B", "\u219C", "\u219D", "\u219E", "\u219F", "\u21A0", "\u21A1", "\u21A2", "\u21A3", "\u21A4", "\u21A5", "\u21A6", "\u21A7", "\u21A8", "\u21A9", "\u21AA", "\u21AB", "\u21AC", "\u21AD", "\u21AE", "\u21AF", "\u21B0", "\u21B1", "\u21B2", "\u21B3", "\u21B4", "\u21B5", "\u21B6", "\u21B7", "\u21B8", "\u21B9", "\u21BA", "\u21BB", "\u21C4", "\u21C5", "\u21C6", "\u21C7", "\u21C8", "\u21C9", "\u21CA", "\u21CD", "\u21CE", "\u21CF", "\u21D0", "\u21D1", "\u21D2", "\u21D3", "\u21D4", "\u21D5", "\u21D6", "\u21D7", "\u21D8", "\u21D9", "\u21DA", "\u21DB", "\u21DC", "\u21DD", "\u21DE", "\u21DF", "\u21E0", "\u21E1", "\u21E2", "\u21E3", "\u21E4", "\u21E5", "\u21E6", "\u21E7", "\u21E8", "\u21E9", "\u21EA", "\u21EB", "\u21EC", "\u21ED", "\u21EE", "\u21EF", "\u21F0", "\u21F1", "\u21F2", "\u21F3", "\u21F4", "\u21F5", "\u21F6", "\u21F7", "\u21F8", "\u21F9", "\u21FA", "\u21FB", "\u21FC", "\u21FD", "\u21FE", "\u21FF", "\u2301", "\u2303", "\u2304", "\u2324", "\u238B", "\u2794", "\u2798", "\u2799", "\u279A", "\u279B", "\u279C", "\u279D", "\u279E", "\u279F", "\u27A0", "\u27A1", "\u27A2", "\u27A3", "\u27A4", "\u27A5", "\u27A6", "\u27A7", "\u27A8", "\u27A9", "\u27AA", "\u27AB", "\u27AC", "\u27AD", "\u27AE", "\u27AF", "\u27B1", "\u27B2", "\u27B3", "\u27B4", "\u27B5", "\u27B6", "\u27B7", "\u27B8", "\u27B9", "\u27BA", "\u27BB", "\u27BC", "\u27BD", "\u27BE", "\u27F0", "\u27F1", "\u27F2", "\u27F3", "\u27F4", "\u27F5", "\u27F6", "\u27F7", "\u27F8", "\u27F9", "\u27FA", "\u27FB", "\u27FC", "\u27FD", "\u27FE", "\u27FF", "\u2900", "\u2901", "\u2902", "\u2903", "\u2904", "\u2905", "\u2906", "\u2907", "\u2908", "\u2909", "\u290A", "\u290B", "\u290C", "\u290D", "\u290E", "\u290F", "\u2910", "\u2911", "\u2912", "\u2913", "\u2914", "\u2915", "\u2916", "\u2917", "\u2918", "\u2919", "\u291A", "\u291B", "\u291C", "\u291D", "\u291E", "\u291F", "\u2920", "\u2921", "\u2922", "\u2923", "\u2924", "\u2925", "\u2926", "\u2927", "\u2928", "\u2929", "\u292A", "\u292D", "\u292E", "\u292F", "\u2930", "\u2931", "\u2932", "\u2933", "\u2934", "\u2935", "\u2936", "\u2937", "\u2938", "\u2939", "\u293A", "\u293B", "\u293C", "\u293D", "\u293E", "\u293F", "\u2940", "\u2941", "\u2942", "\u2943", "\u2944", "\u2945", "\u2946", "\u2947", "\u2948", "\u2949", "\u2970", "\u2971", "\u2972", "\u2973", "\u2974", "\u2975", "\u2976", "\u2977", "\u2978", "\u2979", "\u297A", "\u297B", "\u29B3", "\u29B4", "\u29BD", "\u29EA", "\u29EC", "\u29ED", "\u2A17", "\u2B00", "\u2B01", "\u2B02", "\u2B03", "\u2B04", "\u2B05", "\u2B06", "\u2B07", "\u2B08", "\u2B09", "\u2B0A", "\u2B0B", "\u2B0C", "\u2B0D", "\u2B0E", "\u2B0F", "\u2B10", "\u2B11", "\u2B30", "\u2B31", "\u2B32", "\u2B33", "\u2B34", "\u2B35", "\u2B36", "\u2B37", "\u2B38", "\u2B39", "\u2B3A", "\u2B3B", "\u2B3C", "\u2B3D", "\u2B3E", "\u2B3F", "\u2B40", "\u2B41", "\u2B42", "\u2B43", "\u2B44", "\u2B45", "\u2B46", "\u2B47", "\u2B48", "\u2B49", "\u2B4A", "\u2B4B", "\u2B4C", "\uFFE9", "\uFFEA", "\uFFEB", "\uFFEC", "\u21BC", "\u21BD", "\u21BE", "\u21BF", "\u21C0", "\u21C1", "\u21C2", "\u21C3", "\u21CB", "\u21CC", "\u294A", "\u294B", "\u294C", "\u294D", "\u294E", "\u294F", "\u2950", "\u2951", "\u2952", "\u2953", "\u2954", "\u2955", "\u2956", "\u2957", "\u2958", "\u2959", "\u295A", "\u295B", "\u295C", "\u295D", "\u295E", "\u295F", "\u2960", "\u2961", "\u2962", "\u2963", "\u2964", "\u2965", "\u2966", "\u2967", "\u2968", "\u2969", "\u296A", "\u296B", "\u296C", "\u296D", "\u296E", "\u296F", "\u297C", "\u297D", "\u297E", "\u297F"],
            type: "relation",
            role: "arrow"
          }, {
            set: ["\u2208", "\u220A", "\u22F2", "\u22F3", "\u22F4", "\u22F5", "\u22F6", "\u22F7", "\u22F8", "\u22F9", "\u22FF"],
            type: "operator",
            role: "element"
          }, {
            set: ["\u2209"],
            type: "operator",
            role: "nonelement"
          }, {
            set: ["\u220B", "\u220D", "\u22FA", "\u22FB", "\u22FC", "\u22FD", "\u22FE"],
            type: "operator",
            role: "reelement"
          }, {
            set: ["\u220C"],
            type: "operator",
            role: "renonelement"
          }, {
            set: ["\u2140", "\u220F", "\u2210", "\u2211", "\u22C0", "\u22C1", "\u22C2", "\u22C3", "\u2A00", "\u2A01", "\u2A02", "\u2A03", "\u2A04", "\u2A05", "\u2A06", "\u2A07", "\u2A08", "\u2A09", "\u2A0A", "\u2A0B", "\u2AFC", "\u2AFF"],
            type: "largeop",
            role: "sum"
          }, {
            set: ["\u222B", "\u222C", "\u222D", "\u222E", "\u222F", "\u2230", "\u2231", "\u2232", "\u2233", "\u2A0C", "\u2A0D", "\u2A0E", "\u2A0F", "\u2A10", "\u2A11", "\u2A12", "\u2A13", "\u2A14", "\u2A15", "\u2A16", "\u2A17", "\u2A18", "\u2A19", "\u2A1A", "\u2A1B", "\u2A1C"],
            type: "largeop",
            role: "integral"
          }, {
            set: ["\u221F", "\u2220", "\u2221", "\u2222", "\u22BE", "\u22BF", "\u25B3", "\u25B7", "\u25BD", "\u25C1"],
            type: "operator",
            role: "geometry"
          }, {
            set: ["inf", "lim", "liminf", "limsup", "max", "min", "sup", "injlim", "projlim", "inj lim", "proj lim"],
            type: "function",
            role: "limit function"
          }, {
            set: mt,
            type: "function",
            role: "prefix function"
          }, {
            set: ["mod", "rem"],
            type: "operator",
            role: "prefix function"
          }],
          yt = function () {
            var t = {};
            var _loop6 = function _loop6(_e78) {
              _e78.set.forEach(function (r) {
                t[r] = {
                  role: _e78.role || "unknown",
                  type: _e78.type || "unknown",
                  font: _e78.font || "unknown"
                };
              });
            };
            for (var _e78, _r92 = 0; _e78 = Lt[_r92]; _r92++) {
              _loop6(_e78);
            }
            return t;
          }();
        e.equal = function (t, e) {
          return t.type === e.type && t.role === e.role && t.font === e.font;
        }, e.lookupType = function (t) {
          var e;
          return (null === (e = yt[t]) || void 0 === e ? void 0 : e.type) || "unknown";
        }, e.lookupRole = function (t) {
          var e;
          return (null === (e = yt[t]) || void 0 === e ? void 0 : e.role) || "unknown";
        }, e.lookupMeaning = function (t) {
          return yt[t] || {
            role: "unknown",
            type: "unknown",
            font: "unknown"
          };
        }, e.invisibleTimes = function () {
          return pt;
        }, e.invisiblePlus = function () {
          return ct;
        }, e.invisibleComma = function () {
          return r;
        }, e.functionApplication = function () {
          return ht;
        }, e.isMatchingFence = function (t, e) {
          return -1 !== u.indexOf(t) || -1 !== p.indexOf(t) ? t === e : a[t] === e || Q[t] === e;
        }, e.isEmbellishedType = function (t) {
          return "operator" === t || "relation" === t || "fence" === t || "punctuation" === t;
        };
        var gt = new Map();
        function vt(t, e) {
          return "".concat(t, " ").concat(e);
        }
        function bt(t, e) {
          var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
          var _iterator17 = _createForOfIteratorHelper(e),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _n209 = _step17.value;
              gt.set(vt(t, _n209), r || t);
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
        }
        bt("d", ["d", "\u2146", "\uFF44", "\uD835\uDC1D", "\uD835\uDC51", "\uD835\uDCB9", "\uD835\uDCED", "\uD835\uDD21", "\uD835\uDD55", "\uD835\uDD89", "\uD835\uDDBD", "\uD835\uDDF1", "\uD835\uDE25", "\uD835\uDE8D"]), bt("bar", o), bt("tilde", i), e.lookupSecondary = function (t, e) {
          return gt.get(vt(t, e));
        };
      },
      8158: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMeaningCollator = e.SemanticNodeCollator = e.SemanticDefault = void 0;
        var n = r(3588),
          o = r(3882);
        var i = /*#__PURE__*/function () {
          function i() {
            _classCallCheck(this, i);
            this.map = {};
          }
          _createClass(i, [{
            key: "add",
            value: function add(t, e) {
              this.map[i.key(t, e.font)] = e;
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t.meaning());
            }
          }, {
            key: "retrieve",
            value: function retrieve(t, e) {
              return this.map[i.key(t, e)];
            }
          }, {
            key: "retrieveNode",
            value: function retrieveNode(t) {
              return this.retrieve(t.textContent, t.font);
            }
          }, {
            key: "size",
            value: function size() {
              return Object.keys(this.map).length;
            }
          }], [{
            key: "key",
            value: function key(t, e) {
              return e ? t + ":" + e : t;
            }
          }]);
          return i;
        }();
        e.SemanticDefault = i;
        var a = /*#__PURE__*/function () {
          function a() {
            _classCallCheck(this, a);
            this.map = {};
          }
          _createClass(a, [{
            key: "add",
            value: function add(t, e) {
              var r = this.map[t];
              r ? r.push(e) : this.map[t] = [e];
            }
          }, {
            key: "retrieve",
            value: function retrieve(t, e) {
              return this.map[i.key(t, e)];
            }
          }, {
            key: "retrieveNode",
            value: function retrieveNode(t) {
              return this.retrieve(t.textContent, t.font);
            }
          }, {
            key: "copy",
            value: function copy() {
              var t = this.copyCollator();
              for (var _e79 in this.map) t.map[_e79] = this.map[_e79];
              return t;
            }
          }, {
            key: "minimize",
            value: function minimize() {
              for (var _t95 in this.map) 1 === this.map[_t95].length && delete this.map[_t95];
            }
          }, {
            key: "minimalCollator",
            value: function minimalCollator() {
              var t = this.copy();
              for (var _e80 in t.map) 1 === t.map[_e80].length && delete t.map[_e80];
              return t;
            }
          }, {
            key: "isMultiValued",
            value: function isMultiValued() {
              for (var _t96 in this.map) if (this.map[_t96].length > 1) return !0;
              return !1;
            }
          }, {
            key: "isEmpty",
            value: function isEmpty() {
              return !Object.keys(this.map).length;
            }
          }]);
          return a;
        }();
        var Q = /*#__PURE__*/function (_a12) {
          _inherits(Q, _a12);
          function Q() {
            _classCallCheck(this, Q);
            return _possibleConstructorReturn(this, _getPrototypeOf(Q).apply(this, arguments));
          }
          _createClass(Q, [{
            key: "copyCollator",
            value: function copyCollator() {
              return new Q();
            }
          }, {
            key: "add",
            value: function add(t, e) {
              var r = i.key(t, e.font);
              _superPropGet(Q, "add", this, 3)([r, e]);
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t);
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = [];
              for (var _e81 in this.map) {
                var _r93 = Array(_e81.length + 3).join(" "),
                  _n210 = this.map[_e81],
                  _o35 = [];
                for (var _t97, _e82 = 0; _t97 = _n210[_e82]; _e82++) _o35.push(_t97.toString());
                t.push(_e81 + ": " + _o35.join("\n" + _r93));
              }
              return t.join("\n");
            }
          }, {
            key: "collateMeaning",
            value: function collateMeaning() {
              var t = new s();
              for (var _e83 in this.map) t.map[_e83] = this.map[_e83].map(function (t) {
                return t.meaning();
              });
              return t;
            }
          }]);
          return Q;
        }(a);
        e.SemanticNodeCollator = Q;
        var s = /*#__PURE__*/function (_a13) {
          _inherits(s, _a13);
          function s() {
            _classCallCheck(this, s);
            return _possibleConstructorReturn(this, _getPrototypeOf(s).apply(this, arguments));
          }
          _createClass(s, [{
            key: "copyCollator",
            value: function copyCollator() {
              return new s();
            }
          }, {
            key: "add",
            value: function add(t, e) {
              var r = this.retrieve(t, e.font);
              if (!r || !r.find(function (t) {
                return n.equal(t, e);
              })) {
                var _r94 = i.key(t, e.font);
                _superPropGet(s, "add", this, 3)([_r94, e]);
              }
            }
          }, {
            key: "addNode",
            value: function addNode(t) {
              this.add(t.textContent, t.meaning());
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = [];
              for (var _e84 in this.map) {
                var _r95 = Array(_e84.length + 3).join(" "),
                  _n211 = this.map[_e84],
                  _o36 = [];
                for (var _t98, _e85 = 0; _t98 = _n211[_e85]; _e85++) _o36.push("{type: " + _t98.type + ", role: " + _t98.role + ", font: " + _t98.font + "}");
                t.push(_e84 + ": " + _o36.join("\n" + _r95));
              }
              return t.join("\n");
            }
          }, {
            key: "reduce",
            value: function reduce() {
              for (var _t99 in this.map) 1 !== this.map[_t99].length && (this.map[_t99] = (0, o.reduce)(this.map[_t99]));
            }
          }, {
            key: "default",
            value: function _default() {
              var t = new i();
              for (var _e86 in this.map) 1 === this.map[_e86].length && (t.map[_e86] = this.map[_e86][0]);
              return t;
            }
          }, {
            key: "newDefault",
            value: function newDefault() {
              var t = this.default();
              this.reduce();
              var e = this.default();
              return t.size() !== e.size() ? e : null;
            }
          }]);
          return s;
        }(a);
        e.SemanticMeaningCollator = s;
      },
      9911: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMultiHeuristic = e.SemanticTreeHeuristic = e.SemanticAbstractHeuristic = void 0;
        var r = function r(t, e) {
          var _r96 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (t) {
            return !1;
          };
          _classCallCheck(this, r);
          this.name = t, this.apply = e, this.applicable = _r96;
        };
        e.SemanticAbstractHeuristic = r;
        e.SemanticTreeHeuristic = /*#__PURE__*/function (_r97) {
          _inherits(_class17, _r97);
          function _class17() {
            _classCallCheck(this, _class17);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class17).apply(this, arguments));
          }
          return _class17;
        }(r);
        e.SemanticMultiHeuristic = /*#__PURE__*/function (_r98) {
          _inherits(_class18, _r98);
          function _class18() {
            _classCallCheck(this, _class18);
            return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
          }
          return _class18;
        }(r);
      },
      7516: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.lookup = e.run = e.add = e.blacklist = e.flags = e.updateFactory = e.factory = void 0, e.factory = null, e.updateFactory = function (t) {
          e.factory = t;
        };
        var r = new Map();
        function n(t) {
          return r.get(t);
        }
        e.flags = {
          combine_juxtaposition: !0,
          convert_juxtaposition: !0,
          multioperator: !0
        }, e.blacklist = {}, e.add = function (t) {
          var n = t.name;
          r.set(n, t), e.flags[n] || (e.flags[n] = !1);
        }, e.run = function (t, r, o) {
          var i = n(t);
          return i && !e.blacklist[t] && (e.flags[t] || i.applicable(r)) ? i.apply(r) : o ? o(r) : r;
        }, e.lookup = n;
      },
      94: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(2057),
          o = r(5897),
          i = r(3588),
          a = r(7516),
          Q = r(9911),
          s = r(5609),
          T = r(3308),
          l = r(4795);
        function c(t, e, r) {
          var n = null;
          if (!t.length) return n;
          var o = r[r.length - 1],
            i = o && o.length,
            a = e && e.length,
            Q = T.default.getInstance();
          if (i && a) {
            if ("infixop" === e[0].type && "implicit" === e[0].role) return n = t.pop(), o.push(Q.postfixNode_(o.pop(), t)), n;
            n = t.shift();
            var _r99 = Q.prefixNode_(e.shift(), t);
            return e.unshift(_r99), n;
          }
          return i ? (o.push(Q.postfixNode_(o.pop(), t)), n) : (a && e.unshift(Q.prefixNode_(e.shift(), t)), n);
        }
        function u(t, e, r) {
          if (!e.length) return t;
          var o = t.pop(),
            i = e.shift(),
            Q = r.shift();
          if (s.isImplicitOp(i)) {
            n.Debugger.getInstance().output("Juxta Heuristic Case 2");
            var _a14 = (o ? [o, i] : [i]).concat(Q);
            return u(t.concat(_a14), e, r);
          }
          if (!o) return n.Debugger.getInstance().output("Juxta Heuristic Case 3"), u([i].concat(Q), e, r);
          var T = Q.shift();
          if (!T) {
            n.Debugger.getInstance().output("Juxta Heuristic Case 9");
            var _Q7 = a.factory.makeBranchNode("infixop", [o, e.shift()], [i], i.textContent);
            return _Q7.role = "implicit", a.run("combine_juxtaposition", _Q7), e.unshift(_Q7), u(t, e, r);
          }
          if (s.isOperator(o) || s.isOperator(T)) return n.Debugger.getInstance().output("Juxta Heuristic Case 4"), u(t.concat([o, i, T]).concat(Q), e, r);
          var l = null;
          return s.isImplicitOp(o) && s.isImplicitOp(T) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 5"), o.contentNodes.push(i), o.contentNodes = o.contentNodes.concat(T.contentNodes), o.childNodes.push(T), o.childNodes = o.childNodes.concat(T.childNodes), T.childNodes.forEach(function (t) {
            return t.parent = o;
          }), i.parent = o, o.addMathmlNodes(i.mathml), o.addMathmlNodes(T.mathml), l = o) : s.isImplicitOp(o) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 6"), o.contentNodes.push(i), o.childNodes.push(T), T.parent = o, i.parent = o, o.addMathmlNodes(i.mathml), o.addMathmlNodes(T.mathml), l = o) : s.isImplicitOp(T) ? (n.Debugger.getInstance().output("Juxta Heuristic Case 7"), T.contentNodes.unshift(i), T.childNodes.unshift(o), o.parent = T, i.parent = T, T.addMathmlNodes(i.mathml), T.addMathmlNodes(o.mathml), l = T) : (n.Debugger.getInstance().output("Juxta Heuristic Case 8"), l = a.factory.makeBranchNode("infixop", [o, T], [i], i.textContent), l.role = "implicit"), t.push(l), u(t.concat(Q), e, r);
        }
        a.add(new Q.SemanticTreeHeuristic("combine_juxtaposition", function (t) {
          for (var _e87, _r100 = t.childNodes.length - 1; _e87 = t.childNodes[_r100]; _r100--) {
            var _t$childNodes, _t$contentNodes;
            s.isImplicitOp(_e87) && !_e87.nobreaking && ((_t$childNodes = t.childNodes).splice.apply(_t$childNodes, [_r100, 1].concat(_toConsumableArray(_e87.childNodes))), (_t$contentNodes = t.contentNodes).splice.apply(_t$contentNodes, [_r100, 0].concat(_toConsumableArray(_e87.contentNodes))), _e87.childNodes.concat(_e87.contentNodes).forEach(function (e) {
              e.parent = t;
            }), t.addMathmlNodes(_e87.mathml));
          }
          return t;
        })), a.add(new Q.SemanticTreeHeuristic("propagateSimpleFunction", function (t) {
          return "infixop" !== t.type && "fraction" !== t.type || !t.childNodes.every(s.isSimpleFunction) || (t.role = "composed function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new Q.SemanticTreeHeuristic("simpleNamedFunction", function (t) {
          return "unit" !== t.role && -1 !== ["f", "g", "h", "F", "G", "H"].indexOf(t.textContent) && (t.role = "simple function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new Q.SemanticTreeHeuristic("propagateComposedFunction", function (t) {
          return "fenced" === t.type && "composed function" === t.childNodes[0].role && (t.role = "composed function"), t;
        }, function (t) {
          return "clearspeak" === o.default.getInstance().domain;
        })), a.add(new Q.SemanticTreeHeuristic("multioperator", function (t) {
          if ("unknown" !== t.role || t.textContent.length <= 1) return;
          var e = _toConsumableArray(t.textContent).map(i.lookupMeaning).reduce(function (t, e) {
            return t && e.role && "unknown" !== e.role && e.role !== t ? "unknown" === t ? e.role : null : t;
          }, "unknown");
          e && (t.role = e);
        })), a.add(new Q.SemanticMultiHeuristic("convert_juxtaposition", function (t) {
          var e = l.partitionNodes(t, function (t) {
            return t.textContent === i.invisibleTimes() && "operator" === t.type;
          });
          e = e.rel.length ? function (t) {
            var e = [],
              r = [];
            var n = t.comp.shift(),
              o = null,
              i = [];
            for (; t.comp.length;) if (i = [], n.length) o && e.push(o), r.push(n), o = t.rel.shift(), n = t.comp.shift();else {
              for (o && i.push(o); !n.length && t.comp.length;) n = t.comp.shift(), i.push(t.rel.shift());
              o = c(i, n, r);
            }
            i.length || n.length ? (e.push(o), r.push(n)) : (i.push(o), c(i, n, r));
            return {
              rel: e,
              comp: r
            };
          }(e) : e, t = e.comp[0];
          for (var _r101, _n212, _o37 = 1; _r101 = e.comp[_o37], _n212 = e.rel[_o37 - 1]; _o37++) t.push(_n212), t = t.concat(_r101);
          return e = l.partitionNodes(t, function (t) {
            return t.textContent === i.invisibleTimes() && ("operator" === t.type || "infixop" === t.type);
          }), e.rel.length ? u(e.comp.shift(), e.rel, e.comp) : t;
        })), a.add(new Q.SemanticTreeHeuristic("simple2prefix", function (t) {
          return t.textContent.length > 1 && !t.textContent[0].match(/[A-Z]/) && (t.role = "prefix function"), t;
        }, function (t) {
          return "braille" === o.default.getInstance().modality && "identifier" === t.type;
        })), a.add(new Q.SemanticTreeHeuristic("detect_cycle", function (t) {
          t.type = "matrix", t.role = "cycle";
          var e = t.childNodes[0];
          return e.type = "row", e.role = "cycle", e.textContent = "", e.contentNodes = [], t;
        }, function (t) {
          return "fenced" === t.type && "infixop" === t.childNodes[0].type && "implicit" === t.childNodes[0].role && t.childNodes[0].childNodes.every(function (t) {
            return "number" === t.type;
          }) && t.childNodes[0].contentNodes.every(function (t) {
            return "space" === t.role;
          });
        }));
      },
      7228: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticMathml = void 0;
        var n = r(5740),
          o = r(5250),
          i = r(5609),
          a = r(3308),
          Q = r(4795);
        var s = /*#__PURE__*/function (_o$SemanticAbstractPa) {
          _inherits(s, _o$SemanticAbstractPa);
          function s() {
            var _this44;
            _classCallCheck(this, s);
            _this44 = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, "MathML")), _this44.parseMap_ = {
              SEMANTICS: _this44.semantics_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MATH: _this44.rows_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MROW: _this44.rows_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MPADDED: _this44.rows_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSTYLE: _this44.rows_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MFRAC: _this44.fraction_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSUB: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSUP: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSUBSUP: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MOVER: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MUNDER: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MUNDEROVER: _this44.limits_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MROOT: _this44.root_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSQRT: _this44.sqrt_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MTABLE: _this44.table_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MLABELEDTR: _this44.tableLabeledRow_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MTR: _this44.tableRow_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MTD: _this44.tableCell_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MS: _this44.text_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MTEXT: _this44.text_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MSPACE: _this44.space_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              "ANNOTATION-XML": _this44.text_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MI: _this44.identifier_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MN: _this44.number_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MO: _this44.operator_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MFENCED: _this44.fenced_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MENCLOSE: _this44.enclosed_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MMULTISCRIPTS: _this44.multiscripts_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              ANNOTATION: _this44.empty_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              NONE: _this44.empty_.bind(_assertThisInitialized(_assertThisInitialized(_this44))),
              MACTION: _this44.action_.bind(_assertThisInitialized(_assertThisInitialized(_this44)))
            };
            var t = {
              type: "identifier",
              role: "numbersetletter",
              font: "double-struck"
            };
            ["C", "H", "N", "P", "Q", "R", "Z", "\u2102", "\u210D", "\u2115", "\u2119", "\u211A", "\u211D", "\u2124"].forEach(function (e) {
              return _this44.getFactory().defaultMap.add(e, t);
            }.bind(_assertThisInitialized(_assertThisInitialized(_this44))));
            return _this44;
          }
          _createClass(s, [{
            key: "parse",
            value: function parse(t) {
              a.default.getInstance().setNodeFactory(this.getFactory());
              var e = n.toArray(t.childNodes),
                r = n.tagName(t),
                o = this.parseMap_[r],
                i = (o || this.dummy_.bind(this))(t, e);
              return Q.addAttributes(i, t), -1 !== ["MATH", "MROW", "MPADDED", "MSTYLE", "SEMANTICS"].indexOf(r) || (i.mathml.unshift(t), i.mathmlTree = t), i;
            }
          }, {
            key: "semantics_",
            value: function semantics_(t, e) {
              return e.length ? this.parse(e[0]) : this.getFactory().makeEmptyNode();
            }
          }, {
            key: "rows_",
            value: function rows_(t, e) {
              var r = t.getAttribute("semantics");
              if (r && r.match("bspr_")) return a.default.proof(t, r, this.parseList.bind(this));
              var n;
              return 1 === (e = Q.purgeNodes(e)).length ? (n = this.parse(e[0]), "empty" !== n.type || n.mathmlTree || (n.mathmlTree = t)) : n = a.default.getInstance().row(this.parseList(e)), n.mathml.unshift(t), n;
            }
          }, {
            key: "fraction_",
            value: function fraction_(t, e) {
              if (!e.length) return this.getFactory().makeEmptyNode();
              var r = this.parse(e[0]),
                n = e[1] ? this.parse(e[1]) : this.getFactory().makeEmptyNode();
              return a.default.getInstance().fractionLikeNode(r, n, t.getAttribute("linethickness"), "true" === t.getAttribute("bevelled"));
            }
          }, {
            key: "limits_",
            value: function limits_(t, e) {
              return a.default.getInstance().limitNode(n.tagName(t), this.parseList(e));
            }
          }, {
            key: "root_",
            value: function root_(t, e) {
              return e[1] ? this.getFactory().makeBranchNode("root", [this.parse(e[1]), this.parse(e[0])], []) : this.sqrt_(t, e);
            }
          }, {
            key: "sqrt_",
            value: function sqrt_(t, e) {
              var r = this.parseList(Q.purgeNodes(e));
              return this.getFactory().makeBranchNode("sqrt", [a.default.getInstance().row(r)], []);
            }
          }, {
            key: "table_",
            value: function table_(t, e) {
              var r = t.getAttribute("semantics");
              if (r && r.match("bspr_")) return a.default.proof(t, r, this.parseList.bind(this));
              var n = this.getFactory().makeBranchNode("table", this.parseList(e), []);
              return n.mathmlTree = t, a.default.tableToMultiline(n), n;
            }
          }, {
            key: "tableRow_",
            value: function tableRow_(t, e) {
              var r = this.getFactory().makeBranchNode("row", this.parseList(e), []);
              return r.role = "table", r;
            }
          }, {
            key: "tableLabeledRow_",
            value: function tableLabeledRow_(t, e) {
              if (!e.length) return this.tableRow_(t, e);
              var r = this.parse(e[0]);
              r.role = "label";
              var n = this.getFactory().makeBranchNode("row", this.parseList(e.slice(1)), [r]);
              return n.role = "table", n;
            }
          }, {
            key: "tableCell_",
            value: function tableCell_(t, e) {
              var r = this.parseList(Q.purgeNodes(e));
              var n;
              n = r.length ? 1 === r.length && i.isType(r[0], "empty") ? r : [a.default.getInstance().row(r)] : [];
              var o = this.getFactory().makeBranchNode("cell", n, []);
              return o.role = "table", o;
            }
          }, {
            key: "space_",
            value: function space_(t, e) {
              var r = t.getAttribute("width"),
                o = r && r.match(/[a-z]*$/);
              if (!o) return this.empty_(t, e);
              var i = o[0],
                Q = parseFloat(r.slice(0, o.index)),
                s = {
                  cm: .4,
                  pc: .5,
                  em: .5,
                  ex: 1,
                  in: .15,
                  pt: 5,
                  mm: 5
                }[i];
              if (!s || isNaN(Q) || Q < s) return this.empty_(t, e);
              var T = this.getFactory().makeUnprocessed(t);
              return a.default.getInstance().text(T, n.tagName(t));
            }
          }, {
            key: "text_",
            value: function text_(t, e) {
              var r = this.leaf_(t, e);
              return t.textContent ? (r.updateContent(t.textContent, !0), a.default.getInstance().text(r, n.tagName(t))) : r;
            }
          }, {
            key: "identifier_",
            value: function identifier_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.getInstance().identifierNode(r, a.default.getInstance().font(t.getAttribute("mathvariant")), t.getAttribute("class"));
            }
          }, {
            key: "number_",
            value: function number_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.number(r), r;
            }
          }, {
            key: "operator_",
            value: function operator_(t, e) {
              var r = this.leaf_(t, e);
              return a.default.getInstance().operatorNode(r), r;
            }
          }, {
            key: "fenced_",
            value: function fenced_(t, e) {
              var r = this.parseList(Q.purgeNodes(e)),
                n = s.getAttribute_(t, "separators", ","),
                o = s.getAttribute_(t, "open", "("),
                i = s.getAttribute_(t, "close", ")"),
                T = a.default.getInstance().mfenced(o, i, n, r);
              return a.default.getInstance().tablesInRow([T])[0];
            }
          }, {
            key: "enclosed_",
            value: function enclosed_(t, e) {
              var r = this.parseList(Q.purgeNodes(e)),
                n = this.getFactory().makeBranchNode("enclose", [a.default.getInstance().row(r)], []);
              return n.role = t.getAttribute("notation") || "unknown", n;
            }
          }, {
            key: "multiscripts_",
            value: function multiscripts_(t, e) {
              if (!e.length) return this.getFactory().makeEmptyNode();
              var r = this.parse(e.shift());
              if (!e.length) return r;
              var o = [],
                i = [],
                s = [],
                T = [];
              var l = !1,
                c = 0;
              for (var _t100, _r102 = 0; _t100 = e[_r102]; _r102++) "MPRESCRIPTS" !== n.tagName(_t100) ? (l ? 1 & c ? o.push(_t100) : i.push(_t100) : 1 & c ? s.push(_t100) : T.push(_t100), c++) : (l = !0, c = 0);
              return Q.purgeNodes(o).length || Q.purgeNodes(i).length ? a.default.getInstance().tensor(r, this.parseList(i), this.parseList(o), this.parseList(T), this.parseList(s)) : a.default.getInstance().pseudoTensor(r, this.parseList(T), this.parseList(s));
            }
          }, {
            key: "empty_",
            value: function empty_(t, e) {
              return this.getFactory().makeEmptyNode();
            }
          }, {
            key: "action_",
            value: function action_(t, e) {
              return e.length > 1 ? this.parse(e[1]) : this.getFactory().makeUnprocessed(t);
            }
          }, {
            key: "dummy_",
            value: function dummy_(t, e) {
              var r = this.getFactory().makeUnprocessed(t);
              return r.role = t.tagName, r.textContent = t.textContent, r;
            }
          }, {
            key: "leaf_",
            value: function leaf_(t, e) {
              if (1 === e.length && e[0].nodeType !== n.NodeType.TEXT_NODE) {
                var _r103 = this.getFactory().makeUnprocessed(t);
                return _r103.role = e[0].tagName, Q.addAttributes(_r103, e[0]), _r103;
              }
              return this.getFactory().makeLeafNode(t.textContent, a.default.getInstance().font(t.getAttribute("mathvariant")));
            }
          }], [{
            key: "getAttribute_",
            value: function getAttribute_(t, e, r) {
              if (!t.hasAttribute(e)) return r;
              var n = t.getAttribute(e);
              return n.match(/^\s*$/) ? null : n;
            }
          }]);
          return s;
        }(o.SemanticAbstractParser);
        e.SemanticMathml = s;
      },
      5952: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticNode = void 0;
        var n = r(5740),
          o = r(3588),
          i = r(4795);
        var a = /*#__PURE__*/function () {
          function a(t) {
            _classCallCheck(this, a);
            this.id = t, this.mathml = [], this.parent = null, this.type = "unknown", this.role = "unknown", this.font = "unknown", this.embellished = null, this.fencePointer = "", this.childNodes = [], this.textContent = "", this.mathmlTree = null, this.contentNodes = [], this.annotation = {}, this.attributes = {}, this.nobreaking = !1;
          }
          _createClass(a, [{
            key: "querySelectorAll",
            value: function querySelectorAll(t) {
              var e = [];
              for (var _r104, _n213 = 0; _r104 = this.childNodes[_n213]; _n213++) e = e.concat(_r104.querySelectorAll(t));
              for (var _r105, _n214 = 0; _r105 = this.contentNodes[_n214]; _n214++) e = e.concat(_r105.querySelectorAll(t));
              return t(this) && e.unshift(this), e;
            }
          }, {
            key: "xml",
            value: function xml(t, e) {
              var r = function r(_r106, n) {
                  var o = n.map(function (r) {
                      return r.xml(t, e);
                    }),
                    i = t.createElementNS("", _r106);
                  for (var _t101, _e88 = 0; _t101 = o[_e88]; _e88++) i.appendChild(_t101);
                  return i;
                },
                n = t.createElementNS("", this.type);
              return e || this.xmlAttributes(n), n.textContent = this.textContent, this.contentNodes.length > 0 && n.appendChild(r("content", this.contentNodes)), this.childNodes.length > 0 && n.appendChild(r("children", this.childNodes)), n;
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              var e = n.parseInput("<snode/>");
              return n.serializeXml(this.xml(e, t));
            }
          }, {
            key: "allAttributes",
            value: function allAttributes() {
              var t = [];
              return t.push(["role", this.role]), "unknown" !== this.font && t.push(["font", this.font]), Object.keys(this.annotation).length && t.push(["annotation", this.xmlAnnotation()]), this.embellished && t.push(["embellished", this.embellished]), this.fencePointer && t.push(["fencepointer", this.fencePointer]), t.push(["id", this.id.toString()]), t;
            }
          }, {
            key: "xmlAnnotation",
            value: function xmlAnnotation() {
              var _this45 = this;
              var t = [];
              var _loop7 = function _loop7(_e89) {
                _this45.annotation[_e89].forEach(function (r) {
                  t.push(_e89 + ":" + r);
                });
              };
              for (var _e89 in this.annotation) {
                _loop7(_e89);
              }
              return t.join(";");
            }
          }, {
            key: "toJson",
            value: function toJson() {
              var t = {};
              t.type = this.type;
              var e = this.allAttributes();
              for (var _r107, _n215 = 0; _r107 = e[_n215]; _n215++) t[_r107[0]] = _r107[1].toString();
              return this.textContent && (t.$t = this.textContent), this.childNodes.length && (t.children = this.childNodes.map(function (t) {
                return t.toJson();
              })), this.contentNodes.length && (t.content = this.contentNodes.map(function (t) {
                return t.toJson();
              })), t;
            }
          }, {
            key: "updateContent",
            value: function updateContent(t, e) {
              var r = e ? t.replace(/^[ \f\n\r\t\v\u200b]*/, "").replace(/[ \f\n\r\t\v\u200b]*$/, "") : t.trim();
              if (t = t && !r ? t : r, this.textContent === t) return;
              var n = (0, o.lookupMeaning)(t);
              this.textContent = t, this.role = n.role, this.type = n.type, this.font = n.font;
            }
          }, {
            key: "addMathmlNodes",
            value: function addMathmlNodes(t) {
              for (var _e90, _r108 = 0; _e90 = t[_r108]; _r108++) -1 === this.mathml.indexOf(_e90) && this.mathml.push(_e90);
            }
          }, {
            key: "appendChild",
            value: function appendChild(t) {
              this.childNodes.push(t), this.addMathmlNodes(t.mathml), t.parent = this;
            }
          }, {
            key: "replaceChild",
            value: function replaceChild(t, e) {
              var r = this.childNodes.indexOf(t);
              if (-1 === r) return;
              t.parent = null, e.parent = this, this.childNodes[r] = e;
              var n = t.mathml.filter(function (t) {
                  return -1 === e.mathml.indexOf(t);
                }),
                o = e.mathml.filter(function (e) {
                  return -1 === t.mathml.indexOf(e);
                });
              this.removeMathmlNodes(n), this.addMathmlNodes(o);
            }
          }, {
            key: "appendContentNode",
            value: function appendContentNode(t) {
              t && (this.contentNodes.push(t), this.addMathmlNodes(t.mathml), t.parent = this);
            }
          }, {
            key: "removeContentNode",
            value: function removeContentNode(t) {
              if (t) {
                var _e91 = this.contentNodes.indexOf(t);
                -1 !== _e91 && this.contentNodes.slice(_e91, 1);
              }
            }
          }, {
            key: "equals",
            value: function equals(t) {
              if (!t) return !1;
              if (this.type !== t.type || this.role !== t.role || this.textContent !== t.textContent || this.childNodes.length !== t.childNodes.length || this.contentNodes.length !== t.contentNodes.length) return !1;
              for (var _e92, _r109, _n216 = 0; _e92 = this.childNodes[_n216], _r109 = t.childNodes[_n216]; _n216++) if (!_e92.equals(_r109)) return !1;
              for (var _e93, _r110, _n217 = 0; _e93 = this.contentNodes[_n217], _r110 = t.contentNodes[_n217]; _n217++) if (!_e93.equals(_r110)) return !1;
              return !0;
            }
          }, {
            key: "displayTree",
            value: function displayTree() {
              console.info(this.displayTree_(0));
            }
          }, {
            key: "addAnnotation",
            value: function addAnnotation(t, e) {
              e && this.addAnnotation_(t, e);
            }
          }, {
            key: "getAnnotation",
            value: function getAnnotation(t) {
              var e = this.annotation[t];
              return e || [];
            }
          }, {
            key: "hasAnnotation",
            value: function hasAnnotation(t, e) {
              var r = this.annotation[t];
              return !!r && -1 !== r.indexOf(e);
            }
          }, {
            key: "parseAnnotation",
            value: function parseAnnotation(t) {
              var e = t.split(";");
              for (var _t102 = 0, _r111 = e.length; _t102 < _r111; _t102++) {
                var _r112 = e[_t102].split(":");
                this.addAnnotation(_r112[0], _r112[1]);
              }
            }
          }, {
            key: "meaning",
            value: function meaning() {
              return {
                type: this.type,
                role: this.role,
                font: this.font
              };
            }
          }, {
            key: "xmlAttributes",
            value: function xmlAttributes(t) {
              var e = this.allAttributes();
              for (var _r113, _n218 = 0; _r113 = e[_n218]; _n218++) t.setAttribute(_r113[0], _r113[1]);
              this.addExternalAttributes(t);
            }
          }, {
            key: "addExternalAttributes",
            value: function addExternalAttributes(t) {
              for (var _e94 in this.attributes) t.setAttribute(_e94, this.attributes[_e94]);
            }
          }, {
            key: "removeMathmlNodes",
            value: function removeMathmlNodes(t) {
              var e = this.mathml;
              for (var _r114, _n219 = 0; _r114 = t[_n219]; _n219++) {
                var _t103 = e.indexOf(_r114);
                -1 !== _t103 && e.splice(_t103, 1);
              }
              this.mathml = e;
            }
          }, {
            key: "displayTree_",
            value: function displayTree_(t) {
              t++;
              var e = Array(t).join("  ");
              var r = "";
              r += "\n" + e + this.toString(), r += "\n" + e + "MathmlTree:", r += "\n" + e + this.mathmlTreeString(), r += "\n" + e + "MathML:";
              for (var _t104, _n220 = 0; _t104 = this.mathml[_n220]; _n220++) r += "\n" + e + _t104.toString();
              return r += "\n" + e + "Begin Content", this.contentNodes.forEach(function (e) {
                r += e.displayTree_(t);
              }), r += "\n" + e + "End Content", r += "\n" + e + "Begin Children", this.childNodes.forEach(function (e) {
                r += e.displayTree_(t);
              }), r += "\n" + e + "End Children", r;
            }
          }, {
            key: "mathmlTreeString",
            value: function mathmlTreeString() {
              return this.mathmlTree ? this.mathmlTree.toString() : "EMPTY";
            }
          }, {
            key: "addAnnotation_",
            value: function addAnnotation_(t, e) {
              var r = this.annotation[t];
              r ? r.push(e) : this.annotation[t] = [e];
            }
          }], [{
            key: "fromXml",
            value: function fromXml(t) {
              var e = parseInt(t.getAttribute("id"), 10),
                r = new a(e);
              return r.type = t.tagName, a.setAttribute(r, t, "role"), a.setAttribute(r, t, "font"), a.setAttribute(r, t, "embellished"), a.setAttribute(r, t, "fencepointer", "fencePointer"), t.getAttribute("annotation") && r.parseAnnotation(t.getAttribute("annotation")), i.addAttributes(r, t), a.processChildren(r, t), r;
            }
          }, {
            key: "setAttribute",
            value: function setAttribute(t, e, r, n) {
              n = n || r;
              var o = e.getAttribute(r);
              o && (t[n] = o);
            }
          }, {
            key: "processChildren",
            value: function processChildren(t, e) {
              var _iterator18 = _createForOfIteratorHelper(n.toArray(e.childNodes)),
                _step18;
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  var _r115 = _step18.value;
                  if (_r115.nodeType === n.NodeType.TEXT_NODE) {
                    t.textContent = _r115.textContent;
                    continue;
                  }
                  var _e95 = n.toArray(_r115.childNodes).map(a.fromXml);
                  _e95.forEach(function (e) {
                    return e.parent = t;
                  }), "CONTENT" === n.tagName(_r115) ? t.contentNodes = _e95 : t.childNodes = _e95;
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
            }
          }]);
          return a;
        }();
        e.SemanticNode = a;
      },
      6537: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticNodeFactory = void 0;
        var n = r(8158),
          o = r(8158),
          i = r(5952);
        e.SemanticNodeFactory = /*#__PURE__*/function () {
          function _class19() {
            _classCallCheck(this, _class19);
            this.leafMap = new o.SemanticNodeCollator(), this.defaultMap = new n.SemanticDefault(), this.idCounter_ = -1;
          }
          _createClass(_class19, [{
            key: "makeNode",
            value: function makeNode(t) {
              return this.createNode_(t);
            }
          }, {
            key: "makeUnprocessed",
            value: function makeUnprocessed(t) {
              var e = this.createNode_();
              return e.mathml = [t], e.mathmlTree = t, e;
            }
          }, {
            key: "makeEmptyNode",
            value: function makeEmptyNode() {
              var t = this.createNode_();
              return t.type = "empty", t;
            }
          }, {
            key: "makeContentNode",
            value: function makeContentNode(t) {
              var e = this.createNode_();
              return e.updateContent(t), e;
            }
          }, {
            key: "makeMultipleContentNodes",
            value: function makeMultipleContentNodes(t, e) {
              var r = [];
              for (var _n221 = 0; _n221 < t; _n221++) r.push(this.makeContentNode(e));
              return r;
            }
          }, {
            key: "makeLeafNode",
            value: function makeLeafNode(t, e) {
              if (!t) return this.makeEmptyNode();
              var r = this.makeContentNode(t);
              r.font = e || r.font;
              var n = this.defaultMap.retrieveNode(r);
              return n && (r.type = n.type, r.role = n.role, r.font = n.font), this.leafMap.addNode(r), r;
            }
          }, {
            key: "makeBranchNode",
            value: function makeBranchNode(t, e, r, n) {
              var o = this.createNode_();
              return n && o.updateContent(n), o.type = t, o.childNodes = e, o.contentNodes = r, e.concat(r).forEach(function (t) {
                t.parent = o, o.addMathmlNodes(t.mathml);
              }), o;
            }
          }, {
            key: "createNode_",
            value: function createNode_(t) {
              return void 0 !== t ? this.idCounter_ = Math.max(this.idCounter_, t) : t = ++this.idCounter_, new i.SemanticNode(t);
            }
          }]);
          return _class19;
        }();
      },
      3882: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticComparator = e.reduce = e.sort = e.apply = e.add = void 0;
        var r = [];
        function n(t) {
          r.push(t);
        }
        function o(t, e) {
          for (var _n222, _o38 = 0; _n222 = r[_o38]; _o38++) {
            var _r116 = _n222.compare(t, e);
            if (0 !== _r116) return _r116;
          }
          return 0;
        }
        function i(t) {
          t.sort(o);
        }
        e.add = n, e.apply = o, e.sort = i, e.reduce = function (t) {
          if (t.length <= 1) return t;
          var e = t.slice();
          i(e);
          var r = [];
          var n;
          do {
            n = e.pop(), r.push(n);
          } while (n && e.length && 0 === o(e[e.length - 1], n));
          return r;
        };
        var a = /*#__PURE__*/function () {
          function a(t) {
            var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            _classCallCheck(this, a);
            this.comparator = t, this.type = e, n(this);
          }
          _createClass(a, [{
            key: "compare",
            value: function compare(t, e) {
              return this.type && this.type === t.type && this.type === e.type ? this.comparator(t, e) : 0;
            }
          }]);
          return a;
        }();
        e.SemanticComparator = a, new a(function (t, e) {
          return "simple function" === t.role ? 1 : "simple function" === e.role ? -1 : 0;
        }, "identifier");
      },
      5250: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticAbstractParser = void 0;
        var n = r(6537);
        e.SemanticAbstractParser = /*#__PURE__*/function () {
          function _class20(t) {
            _classCallCheck(this, _class20);
            this.type = t, this.factory_ = new n.SemanticNodeFactory();
          }
          _createClass(_class20, [{
            key: "getFactory",
            value: function getFactory() {
              return this.factory_;
            }
          }, {
            key: "setFactory",
            value: function setFactory(t) {
              this.factory_ = t;
            }
          }, {
            key: "getType",
            value: function getType() {
              return this.type;
            }
          }, {
            key: "parseList",
            value: function parseList(t) {
              var e = [];
              for (var _r117, _n223 = 0; _r117 = t[_n223]; _n223++) e.push(this.parse(_r117));
              return e;
            }
          }]);
          return _class20;
        }();
      },
      5609: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.isMembership = e.elligibleRightNeutral = e.elligibleLeftNeutral = e.compareNeutralFences = e.isNeutralFence = e.isImplicitOp = e.isImplicit = e.isPureUnit = e.isUnitCounter = e.isNumber = e.isSingletonSetContent = e.scriptedElement_ = e.illegalSingleton_ = e.isSetNode = e.isRightBrace = e.isLeftBrace = e.isSimpleFunction = e.singlePunctAtPosition = e.isSimpleFunctionHead = e.isLimitBase = e.isBinomial = e.lineIsLabelled = e.tableIsMultiline = e.tableIsCases = e.isFencedElement = e.tableIsMatrixOrVector = e.isTableOrMultiline = e.isElligibleEmbellishedFence = e.isFence = e.isPunctuation = e.isRelation = e.isOperator = e.isEmbellished = e.isGeneralFunctionBoundary = e.isIntegralDxBoundarySingle = e.isIntegralDxBoundary = e.isBigOpBoundary = e.isPrefixFunctionBoundary = e.isSimpleFunctionScope = e.isAccent = e.isRole = e.embellishedType = e.isType = void 0;
        var n = r(3588),
          o = r(4795);
        function i(t, e) {
          return t.type === e;
        }
        function a(t, e) {
          return t.embellished === e;
        }
        function Q(t, e) {
          return t.role === e;
        }
        function s(t) {
          return l(t) || c(t);
        }
        function T(t) {
          return i(t, "operator") || a(t, "operator");
        }
        function l(t) {
          return i(t, "relation") || a(t, "relation");
        }
        function c(t) {
          return i(t, "punctuation") || a(t, "punctuation");
        }
        function u(t) {
          return i(t, "fence") || a(t, "fence");
        }
        function p(t) {
          return !t.embellished || !function (t) {
            return i(t, "tensor") && (!i(t.childNodes[1], "empty") || !i(t.childNodes[2], "empty")) && (!i(t.childNodes[3], "empty") || !i(t.childNodes[4], "empty"));
          }(t) && (!Q(t, "close") || !i(t, "tensor")) && (!Q(t, "open") || !i(t, "subscript") && !i(t, "superscript")) && p(t.childNodes[0]);
        }
        function h(t) {
          return !!t && (i(t, "table") || i(t, "multiline"));
        }
        function d(t) {
          return !!t && i(t, "fenced") && (Q(t, "leftright") || y(t)) && 1 === t.childNodes.length;
        }
        function f(t) {
          return !!t && -1 !== ["{", "\uFE5B", "\uFF5B"].indexOf(t.textContent);
        }
        function m(t) {
          return !!t && -1 !== ["}", "\uFE5C", "\uFF5D"].indexOf(t.textContent);
        }
        function L(t) {
          return "number" === t.type && ("integer" === t.role || "float" === t.role);
        }
        function y(t) {
          return "neutral" === t.role || "metric" === t.role;
        }
        e.isType = i, e.embellishedType = a, e.isRole = Q, e.isAccent = function (t) {
          var e = new RegExp("\u221E|\u1AB2");
          return i(t, "fence") || i(t, "punctuation") || i(t, "operator") && !t.textContent.match(e) || i(t, "relation") || i(t, "identifier") && Q(t, "unknown") && !t.textContent.match(n.allLettersRegExp) && !t.textContent.match(e);
        }, e.isSimpleFunctionScope = function (t) {
          var e = t.childNodes;
          if (0 === e.length) return !0;
          if (e.length > 1) return !1;
          var r = e[0];
          if ("infixop" === r.type) {
            if ("implicit" !== r.role) return !1;
            if (r.childNodes.some(function (t) {
              return i(t, "infixop");
            })) return !1;
          }
          return !0;
        }, e.isPrefixFunctionBoundary = function (t) {
          return T(t) && !Q(t, "division") || i(t, "appl") || s(t);
        }, e.isBigOpBoundary = function (t) {
          return T(t) || s(t);
        }, e.isIntegralDxBoundary = function (t, e) {
          return !!e && i(e, "identifier") && n.lookupSecondary("d", t.textContent);
        }, e.isIntegralDxBoundarySingle = function (t) {
          if (i(t, "identifier")) {
            var _e96 = t.textContent[0];
            return _e96 && t.textContent[1] && n.lookupSecondary("d", _e96);
          }
          return !1;
        }, e.isGeneralFunctionBoundary = s, e.isEmbellished = function (t) {
          return t.embellished ? t.embellished : n.isEmbellishedType(t.type) ? t.type : null;
        }, e.isOperator = T, e.isRelation = l, e.isPunctuation = c, e.isFence = u, e.isElligibleEmbellishedFence = function (t) {
          return !(!t || !u(t)) && (!t.embellished || p(t));
        }, e.isTableOrMultiline = h, e.tableIsMatrixOrVector = function (t) {
          return !!t && d(t) && h(t.childNodes[0]);
        }, e.isFencedElement = d, e.tableIsCases = function (t, e) {
          return e.length > 0 && Q(e[e.length - 1], "openfence");
        }, e.tableIsMultiline = function (t) {
          return t.childNodes.every(function (t) {
            return t.childNodes.length <= 1;
          });
        }, e.lineIsLabelled = function (t) {
          return i(t, "line") && t.contentNodes.length && Q(t.contentNodes[0], "label");
        }, e.isBinomial = function (t) {
          return 2 === t.childNodes.length;
        }, e.isLimitBase = function t(e) {
          return i(e, "largeop") || i(e, "limboth") || i(e, "limlower") || i(e, "limupper") || i(e, "function") && Q(e, "limit function") || (i(e, "overscore") || i(e, "underscore")) && t(e.childNodes[0]);
        }, e.isSimpleFunctionHead = function (t) {
          return "identifier" === t.type || "latinletter" === t.role || "greekletter" === t.role || "otherletter" === t.role;
        }, e.singlePunctAtPosition = function (t, e, r) {
          return 1 === e.length && ("punctuation" === t[r].type || "punctuation" === t[r].embellished) && t[r] === e[0];
        }, e.isSimpleFunction = function (t) {
          return i(t, "identifier") && Q(t, "simple function");
        }, e.isLeftBrace = f, e.isRightBrace = m, e.isSetNode = function (t) {
          return f(t.contentNodes[0]) && m(t.contentNodes[1]);
        }, e.illegalSingleton_ = ["punctuation", "punctuated", "relseq", "multirel", "table", "multiline", "cases", "inference"], e.scriptedElement_ = ["limupper", "limlower", "limboth", "subscript", "superscript", "underscore", "overscore", "tensor"], e.isSingletonSetContent = function t(r) {
          var n = r.type;
          return -1 === e.illegalSingleton_.indexOf(n) && ("infixop" !== n || "implicit" === r.role) && ("fenced" === n ? "leftright" !== r.role || t(r.childNodes[0]) : -1 === e.scriptedElement_.indexOf(n) || t(r.childNodes[0]));
        }, e.isNumber = L, e.isUnitCounter = function (t) {
          return L(t) || "vulgar" === t.role || "mixed" === t.role;
        }, e.isPureUnit = function (t) {
          var e = t.childNodes;
          return "unit" === t.role && (!e.length || "unit" === e[0].role);
        }, e.isImplicit = function (t) {
          return "implicit" === t.role || "unit" === t.role && !!t.contentNodes.length && t.contentNodes[0].textContent === n.invisibleTimes();
        }, e.isImplicitOp = function (t) {
          return "infixop" === t.type && "implicit" === t.role;
        }, e.isNeutralFence = y, e.compareNeutralFences = function (t, e) {
          return y(t) && y(e) && (0, o.getEmbellishedInner)(t).textContent === (0, o.getEmbellishedInner)(e).textContent;
        }, e.elligibleLeftNeutral = function (t) {
          return !!y(t) && (!t.embellished || "superscript" !== t.type && "subscript" !== t.type && ("tensor" !== t.type || "empty" === t.childNodes[3].type && "empty" === t.childNodes[4].type));
        }, e.elligibleRightNeutral = function (t) {
          return !!y(t) && (!t.embellished || "tensor" !== t.type || "empty" === t.childNodes[1].type && "empty" === t.childNodes[2].type);
        }, e.isMembership = function (t) {
          return ["element", "nonelement", "reelement", "renonelement"].includes(t.role);
        };
      },
      3308: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(5740),
          o = r(3588),
          i = r(7516),
          a = r(6537),
          Q = r(5609),
          s = r(4795);
        var T = /*#__PURE__*/function () {
          function T() {
            _classCallCheck(this, T);
            this.funcAppls = {}, this.factory_ = new a.SemanticNodeFactory(), i.updateFactory(this.factory_);
          }
          _createClass(T, [{
            key: "setNodeFactory",
            value: function setNodeFactory(t) {
              T.getInstance().factory_ = t, i.updateFactory(T.getInstance().factory_);
            }
          }, {
            key: "getNodeFactory",
            value: function getNodeFactory() {
              return T.getInstance().factory_;
            }
          }, {
            key: "identifierNode",
            value: function identifierNode(t, e, r) {
              if ("MathML-Unit" === r) t.type = "identifier", t.role = "unit";else if (!e && 1 === t.textContent.length && ("integer" === t.role || "latinletter" === t.role || "greekletter" === t.role) && "normal" === t.font) return t.font = "italic", i.run("simpleNamedFunction", t);
              return "unknown" === t.type && (t.type = "identifier"), T.exprFont_(t), i.run("simpleNamedFunction", t);
            }
          }, {
            key: "implicitNode",
            value: function implicitNode(t) {
              if (t = T.getInstance().getMixedNumbers_(t), 1 === (t = T.getInstance().combineUnits_(t)).length) return t[0];
              var e = T.getInstance().implicitNode_(t);
              return i.run("combine_juxtaposition", e);
            }
          }, {
            key: "text",
            value: function text(t, e) {
              return T.exprFont_(t), t.type = "text", "MS" === e ? (t.role = "string", t) : "MSPACE" === e || t.textContent.match(/^\s*$/) ? (t.role = "space", t) : t;
            }
          }, {
            key: "row",
            value: function row(t) {
              return 0 === (t = t.filter(function (t) {
                return !Q.isType(t, "empty");
              })).length ? T.getInstance().factory_.makeEmptyNode() : (t = T.getInstance().getFencesInRow_(t), t = T.getInstance().tablesInRow(t), t = T.getInstance().getPunctuationInRow_(t), t = T.getInstance().getTextInRow_(t), t = T.getInstance().getFunctionsInRow_(t), T.getInstance().relationsInRow_(t));
            }
          }, {
            key: "limitNode",
            value: function limitNode(t, e) {
              if (!e.length) return T.getInstance().factory_.makeEmptyNode();
              var r,
                n = e[0],
                o = "unknown";
              if (!e[1]) return n;
              if (Q.isLimitBase(n)) {
                r = T.MML_TO_LIMIT_[t];
                var _i38 = r.length;
                if (o = r.type, e = e.slice(0, r.length + 1), 1 === _i38 && Q.isAccent(e[1]) || 2 === _i38 && Q.isAccent(e[1]) && Q.isAccent(e[2])) return r = T.MML_TO_BOUNDS_[t], T.getInstance().accentNode_(n, e, r.type, r.length, r.accent);
                if (2 === _i38) {
                  if (Q.isAccent(e[1])) return n = T.getInstance().accentNode_(n, [n, e[1]], {
                    MSUBSUP: "subscript",
                    MUNDEROVER: "underscore"
                  }[t], 1, !0), e[2] ? T.getInstance().makeLimitNode_(n, [n, e[2]], null, "limupper") : n;
                  if (e[2] && Q.isAccent(e[2])) return n = T.getInstance().accentNode_(n, [n, e[2]], {
                    MSUBSUP: "superscript",
                    MUNDEROVER: "overscore"
                  }[t], 1, !0), T.getInstance().makeLimitNode_(n, [n, e[1]], null, "limlower");
                  e[_i38] || (o = "limlower");
                }
                return T.getInstance().makeLimitNode_(n, e, null, o);
              }
              return r = T.MML_TO_BOUNDS_[t], T.getInstance().accentNode_(n, e, r.type, r.length, r.accent);
            }
          }, {
            key: "tablesInRow",
            value: function tablesInRow(t) {
              var e = s.partitionNodes(t, Q.tableIsMatrixOrVector),
                r = [];
              for (var _t105, _n224 = 0; _t105 = e.rel[_n224]; _n224++) r = r.concat(e.comp.shift()), r.push(T.tableToMatrixOrVector_(_t105));
              r = r.concat(e.comp.shift()), e = s.partitionNodes(r, Q.isTableOrMultiline), r = [];
              for (var _t106, _n225 = 0; _t106 = e.rel[_n225]; _n225++) {
                var _n226 = e.comp.shift();
                Q.tableIsCases(_t106, _n226) && T.tableToCases_(_t106, _n226.pop()), r = r.concat(_n226), r.push(_t106);
              }
              return r.concat(e.comp.shift());
            }
          }, {
            key: "mfenced",
            value: function mfenced(t, e, r, n) {
              if (r && n.length > 0) {
                var _t107 = T.nextSeparatorFunction_(r),
                  _e97 = [n.shift()];
                n.forEach(function (r) {
                  _e97.push(T.getInstance().factory_.makeContentNode(_t107())), _e97.push(r);
                }), n = _e97;
              }
              return t && e ? T.getInstance().horizontalFencedNode_(T.getInstance().factory_.makeContentNode(t), T.getInstance().factory_.makeContentNode(e), n) : (t && n.unshift(T.getInstance().factory_.makeContentNode(t)), e && n.push(T.getInstance().factory_.makeContentNode(e)), T.getInstance().row(n));
            }
          }, {
            key: "fractionLikeNode",
            value: function fractionLikeNode(t, e, r, n) {
              var o;
              if (!n && s.isZeroLength(r)) {
                var _r118 = T.getInstance().factory_.makeBranchNode("line", [t], []),
                  _n227 = T.getInstance().factory_.makeBranchNode("line", [e], []);
                return o = T.getInstance().factory_.makeBranchNode("multiline", [_r118, _n227], []), T.binomialForm_(o), T.classifyMultiline(o), o;
              }
              return o = T.getInstance().fractionNode_(t, e), n && o.addAnnotation("general", "bevelled"), o;
            }
          }, {
            key: "tensor",
            value: function tensor(t, e, r, n, o) {
              var i = T.getInstance().factory_.makeBranchNode("tensor", [t, T.getInstance().scriptNode_(e, "leftsub"), T.getInstance().scriptNode_(r, "leftsuper"), T.getInstance().scriptNode_(n, "rightsub"), T.getInstance().scriptNode_(o, "rightsuper")], []);
              return i.role = t.role, i.embellished = Q.isEmbellished(t), i;
            }
          }, {
            key: "pseudoTensor",
            value: function pseudoTensor(t, e, r) {
              var n = function n(t) {
                  return !Q.isType(t, "empty");
                },
                o = e.filter(n).length,
                i = r.filter(n).length;
              if (!o && !i) return t;
              var a = o ? i ? "MSUBSUP" : "MSUB" : "MSUP",
                s = [t];
              return o && s.push(T.getInstance().scriptNode_(e, "rightsub", !0)), i && s.push(T.getInstance().scriptNode_(r, "rightsuper", !0)), T.getInstance().limitNode(a, s);
            }
          }, {
            key: "font",
            value: function font(t) {
              var e = T.MATHJAX_FONTS[t];
              return e || t;
            }
          }, {
            key: "proof",
            value: function proof(t, e, r) {
              if (e.inference || e.axiom || console.log("Noise"), e.axiom) {
                var _e98 = T.getInstance().cleanInference(t.childNodes),
                  _n228 = _e98.length ? T.getInstance().factory_.makeBranchNode("inference", r(_e98), []) : T.getInstance().factory_.makeEmptyNode();
                return _n228.role = "axiom", _n228.mathmlTree = t, _n228;
              }
              var n = T.getInstance().inference(t, e, r);
              return e.proof && (n.role = "proof", n.childNodes[0].role = "final"), n;
            }
          }, {
            key: "inference",
            value: function inference(t, e, r) {
              if (e.inferenceRule) {
                var _e99 = T.getInstance().getFormulas(t, [], r);
                return T.getInstance().factory_.makeBranchNode("inference", [_e99.conclusion, _e99.premises], []);
              }
              var o = e.labelledRule,
                i = n.toArray(t.childNodes),
                a = [];
              "left" !== o && "both" !== o || a.push(T.getInstance().getLabel(t, i, r, "left")), "right" !== o && "both" !== o || a.push(T.getInstance().getLabel(t, i, r, "right"));
              var Q = T.getInstance().getFormulas(t, i, r),
                s = T.getInstance().factory_.makeBranchNode("inference", [Q.conclusion, Q.premises], a);
              return s.mathmlTree = t, s;
            }
          }, {
            key: "getLabel",
            value: function getLabel(t, e, r, o) {
              var i = T.getInstance().findNestedRow(e, "prooflabel", o),
                a = T.getInstance().factory_.makeBranchNode("rulelabel", r(n.toArray(i.childNodes)), []);
              return a.role = o, a.mathmlTree = i, a;
            }
          }, {
            key: "getFormulas",
            value: function getFormulas(t, e, r) {
              var o = e.length ? T.getInstance().findNestedRow(e, "inferenceRule") : t,
                i = "up" === T.getSemantics(o).inferenceRule,
                a = i ? o.childNodes[1] : o.childNodes[0],
                Q = i ? o.childNodes[0] : o.childNodes[1],
                s = a.childNodes[0].childNodes[0],
                l = n.toArray(s.childNodes[0].childNodes),
                c = [];
              var u = 1;
              var _iterator19 = _createForOfIteratorHelper(l),
                _step19;
              try {
                for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                  var _t108 = _step19.value;
                  u % 2 && c.push(_t108.childNodes[0]), u++;
                }
              } catch (err) {
                _iterator19.e(err);
              } finally {
                _iterator19.f();
              }
              var p = r(c),
                h = r(n.toArray(Q.childNodes[0].childNodes))[0],
                d = T.getInstance().factory_.makeBranchNode("premises", p, []);
              d.mathmlTree = s;
              var f = T.getInstance().factory_.makeBranchNode("conclusion", [h], []);
              return f.mathmlTree = Q.childNodes[0].childNodes[0], {
                conclusion: f,
                premises: d
              };
            }
          }, {
            key: "findNestedRow",
            value: function findNestedRow(t, e, r) {
              return T.getInstance().findNestedRow_(t, e, 0, r);
            }
          }, {
            key: "cleanInference",
            value: function cleanInference(t) {
              return n.toArray(t).filter(function (t) {
                return "MSPACE" !== n.tagName(t);
              });
            }
          }, {
            key: "operatorNode",
            value: function operatorNode(t) {
              return "unknown" === t.type && (t.type = "operator"), i.run("multioperator", t);
            }
          }, {
            key: "implicitNode_",
            value: function implicitNode_(t) {
              var e = T.getInstance().factory_.makeMultipleContentNodes(t.length - 1, o.invisibleTimes());
              T.matchSpaces_(t, e);
              var r = T.getInstance().infixNode_(t, e[0]);
              return r.role = "implicit", e.forEach(function (t) {
                t.parent = r;
              }), r.contentNodes = e, r;
            }
          }, {
            key: "infixNode_",
            value: function infixNode_(t, e) {
              var r = T.getInstance().factory_.makeBranchNode("infixop", t, [e], s.getEmbellishedInner(e).textContent);
              return r.role = e.role, i.run("propagateSimpleFunction", r);
            }
          }, {
            key: "explicitMixed_",
            value: function explicitMixed_(t) {
              var e = s.partitionNodes(t, function (t) {
                return t.textContent === o.invisiblePlus();
              });
              if (!e.rel.length) return t;
              var r = [];
              for (var _t109, _n229 = 0; _t109 = e.rel[_n229]; _n229++) {
                var _o39 = e.comp[_n229],
                  _i39 = e.comp[_n229 + 1],
                  _a15 = _o39.length - 1;
                if (_o39[_a15] && _i39[0] && Q.isType(_o39[_a15], "number") && !Q.isRole(_o39[_a15], "mixed") && Q.isType(_i39[0], "fraction")) {
                  var _t110 = T.getInstance().factory_.makeBranchNode("number", [_o39[_a15], _i39[0]], []);
                  _t110.role = "mixed", r = r.concat(_o39.slice(0, _a15)), r.push(_t110), _i39.shift();
                } else r = r.concat(_o39), r.push(_t109);
              }
              return r.concat(e.comp[e.comp.length - 1]);
            }
          }, {
            key: "concatNode_",
            value: function concatNode_(t, e, r) {
              if (0 === e.length) return t;
              var n = e.map(function (t) {
                  return s.getEmbellishedInner(t).textContent;
                }).join(" "),
                o = T.getInstance().factory_.makeBranchNode(r, [t], e, n);
              return e.length > 1 && (o.role = "multiop"), o;
            }
          }, {
            key: "prefixNode_",
            value: function prefixNode_(t, e) {
              var r = s.partitionNodes(e, function (t) {
                return Q.isRole(t, "subtraction");
              });
              var n = T.getInstance().concatNode_(t, r.comp.pop(), "prefixop");
              for (1 === n.contentNodes.length && "addition" === n.contentNodes[0].role && "+" === n.contentNodes[0].textContent && (n.role = "positive"); r.rel.length > 0;) n = T.getInstance().concatNode_(n, [r.rel.pop()], "prefixop"), n.role = "negative", n = T.getInstance().concatNode_(n, r.comp.pop(), "prefixop");
              return n;
            }
          }, {
            key: "postfixNode_",
            value: function postfixNode_(t, e) {
              return e.length ? T.getInstance().concatNode_(t, e, "postfixop") : t;
            }
          }, {
            key: "combineUnits_",
            value: function combineUnits_(t) {
              var e = s.partitionNodes(t, function (t) {
                return !Q.isRole(t, "unit");
              });
              if (t.length === e.rel.length) return e.rel;
              var r = [];
              var n, o;
              do {
                var _t111 = e.comp.shift();
                n = e.rel.shift();
                var _i40 = null;
                o = r.pop(), o && (_t111.length && Q.isUnitCounter(o) ? _t111.unshift(o) : r.push(o)), 1 === _t111.length && (_i40 = _t111.pop()), _t111.length > 1 && (_i40 = T.getInstance().implicitNode_(_t111), _i40.role = "unit"), _i40 && r.push(_i40), n && r.push(n);
              } while (n);
              return r;
            }
          }, {
            key: "getMixedNumbers_",
            value: function getMixedNumbers_(t) {
              var e = s.partitionNodes(t, function (t) {
                return Q.isType(t, "fraction") && Q.isRole(t, "vulgar");
              });
              if (!e.rel.length) return t;
              var r = [];
              for (var _t112, _n230 = 0; _t112 = e.rel[_n230]; _n230++) {
                var _o40 = e.comp[_n230],
                  _i41 = _o40.length - 1;
                if (_o40[_i41] && Q.isType(_o40[_i41], "number") && (Q.isRole(_o40[_i41], "integer") || Q.isRole(_o40[_i41], "float"))) {
                  var _e100 = T.getInstance().factory_.makeBranchNode("number", [_o40[_i41], _t112], []);
                  _e100.role = "mixed", r = r.concat(_o40.slice(0, _i41)), r.push(_e100);
                } else r = r.concat(_o40), r.push(_t112);
              }
              return r.concat(e.comp[e.comp.length - 1]);
            }
          }, {
            key: "getTextInRow_",
            value: function getTextInRow_(t) {
              if (t.length <= 1) return t;
              var e = s.partitionNodes(t, function (t) {
                return Q.isType(t, "text");
              });
              if (0 === e.rel.length) return t;
              var r = [];
              var n = e.comp[0];
              n.length > 0 && r.push(T.getInstance().row(n));
              for (var _t113, _o41 = 0; _t113 = e.rel[_o41]; _o41++) r.push(_t113), n = e.comp[_o41 + 1], n.length > 0 && r.push(T.getInstance().row(n));
              return [T.getInstance().dummyNode_(r)];
            }
          }, {
            key: "relationsInRow_",
            value: function relationsInRow_(t) {
              var e = s.partitionNodes(t, Q.isRelation),
                r = e.rel[0];
              if (!r) return T.getInstance().operationsInRow_(t);
              if (1 === t.length) return t[0];
              var n = e.comp.map(T.getInstance().operationsInRow_);
              var o;
              return e.rel.some(function (t) {
                return !t.equals(r);
              }) ? (o = T.getInstance().factory_.makeBranchNode("multirel", n, e.rel), e.rel.every(function (t) {
                return t.role === r.role;
              }) && (o.role = r.role), o) : (o = T.getInstance().factory_.makeBranchNode("relseq", n, e.rel, s.getEmbellishedInner(r).textContent), o.role = r.role, o);
            }
          }, {
            key: "operationsInRow_",
            value: function operationsInRow_(t) {
              if (0 === t.length) return T.getInstance().factory_.makeEmptyNode();
              if (1 === (t = T.getInstance().explicitMixed_(t)).length) return t[0];
              var e = [];
              for (; t.length > 0 && Q.isOperator(t[0]);) e.push(t.shift());
              if (0 === t.length) return T.getInstance().prefixNode_(e.pop(), e);
              if (1 === t.length) return T.getInstance().prefixNode_(t[0], e);
              t = i.run("convert_juxtaposition", t);
              var r = s.sliceNodes(t, Q.isOperator),
                n = T.getInstance().prefixNode_(T.getInstance().implicitNode(r.head), e);
              return r.div ? T.getInstance().operationsTree_(r.tail, n, r.div) : n;
            }
          }, {
            key: "operationsTree_",
            value: function operationsTree_(t, e, r, n) {
              var o = n || [];
              if (0 === t.length) {
                if (o.unshift(r), "infixop" === e.type) {
                  var _t114 = T.getInstance().postfixNode_(e.childNodes.pop(), o);
                  return e.appendChild(_t114), e;
                }
                return T.getInstance().postfixNode_(e, o);
              }
              var i = s.sliceNodes(t, Q.isOperator);
              if (0 === i.head.length) return o.push(i.div), T.getInstance().operationsTree_(i.tail, e, r, o);
              var a = T.getInstance().prefixNode_(T.getInstance().implicitNode(i.head), o),
                l = T.getInstance().appendOperand_(e, r, a);
              return i.div ? T.getInstance().operationsTree_(i.tail, l, i.div, []) : l;
            }
          }, {
            key: "appendOperand_",
            value: function appendOperand_(t, e, r) {
              if ("infixop" !== t.type) return T.getInstance().infixNode_([t, r], e);
              var n = T.getInstance().appendDivisionOp_(t, e, r);
              return n || (T.getInstance().appendExistingOperator_(t, e, r) ? t : "multiplication" === e.role ? T.getInstance().appendMultiplicativeOp_(t, e, r) : T.getInstance().appendAdditiveOp_(t, e, r));
            }
          }, {
            key: "appendDivisionOp_",
            value: function appendDivisionOp_(t, e, r) {
              return "division" === e.role ? Q.isImplicit(t) ? T.getInstance().infixNode_([t, r], e) : T.getInstance().appendLastOperand_(t, e, r) : "division" === t.role ? T.getInstance().infixNode_([t, r], e) : null;
            }
          }, {
            key: "appendLastOperand_",
            value: function appendLastOperand_(t, e, r) {
              var n = t,
                o = t.childNodes[t.childNodes.length - 1];
              for (; o && "infixop" === o.type && !Q.isImplicit(o);) n = o, o = n.childNodes[t.childNodes.length - 1];
              var i = T.getInstance().infixNode_([n.childNodes.pop(), r], e);
              return n.appendChild(i), t;
            }
          }, {
            key: "appendMultiplicativeOp_",
            value: function appendMultiplicativeOp_(t, e, r) {
              if (Q.isImplicit(t)) return T.getInstance().infixNode_([t, r], e);
              var n = t,
                o = t.childNodes[t.childNodes.length - 1];
              for (; o && "infixop" === o.type && !Q.isImplicit(o);) n = o, o = n.childNodes[t.childNodes.length - 1];
              var i = T.getInstance().infixNode_([n.childNodes.pop(), r], e);
              return n.appendChild(i), t;
            }
          }, {
            key: "appendAdditiveOp_",
            value: function appendAdditiveOp_(t, e, r) {
              return T.getInstance().infixNode_([t, r], e);
            }
          }, {
            key: "appendExistingOperator_",
            value: function appendExistingOperator_(t, e, r) {
              return !(!t || "infixop" !== t.type || Q.isImplicit(t)) && (t.contentNodes[0].equals(e) ? (t.appendContentNode(e), t.appendChild(r), !0) : T.getInstance().appendExistingOperator_(t.childNodes[t.childNodes.length - 1], e, r));
            }
          }, {
            key: "getFencesInRow_",
            value: function getFencesInRow_(t) {
              var e = s.partitionNodes(t, Q.isFence);
              e = T.purgeFences_(e);
              var r = e.comp.shift();
              return T.getInstance().fences_(e.rel, e.comp, [], [r]);
            }
          }, {
            key: "fences_",
            value: function fences_(t, e, r, n) {
              if (0 === t.length && 0 === r.length) return n[0];
              var o = function o(t) {
                return Q.isRole(t, "open");
              };
              if (0 === t.length) {
                var _t115 = n.shift();
                for (; r.length > 0;) {
                  if (o(r[0])) {
                    var _e101 = r.shift();
                    T.fenceToPunct_(_e101), _t115.push(_e101);
                  } else {
                    var _e102 = s.sliceNodes(r, o),
                      _i42 = _e102.head.length - 1,
                      _a16 = T.getInstance().neutralFences_(_e102.head, n.slice(0, _i42));
                    n = n.slice(_i42), _t115.push.apply(_t115, _toConsumableArray(_a16)), _e102.div && _e102.tail.unshift(_e102.div), r = _e102.tail;
                  }
                  _t115.push.apply(_t115, _toConsumableArray(n.shift()));
                }
                return _t115;
              }
              var i = r[r.length - 1],
                a = t[0].role;
              if ("open" === a || Q.isNeutralFence(t[0]) && (!i || !Q.compareNeutralFences(t[0], i))) {
                r.push(t.shift());
                var _o42 = e.shift();
                return _o42 && n.push(_o42), T.getInstance().fences_(t, e, r, n);
              }
              if (i && "close" === a && "open" === i.role) {
                var _o43 = T.getInstance().horizontalFencedNode_(r.pop(), t.shift(), n.pop());
                return n.push(n.pop().concat([_o43], e.shift())), T.getInstance().fences_(t, e, r, n);
              }
              if (i && Q.compareNeutralFences(t[0], i)) {
                if (!Q.elligibleLeftNeutral(i) || !Q.elligibleRightNeutral(t[0])) {
                  r.push(t.shift());
                  var _o44 = e.shift();
                  return _o44 && n.push(_o44), T.getInstance().fences_(t, e, r, n);
                }
                var _o45 = T.getInstance().horizontalFencedNode_(r.pop(), t.shift(), n.pop());
                return n.push(n.pop().concat([_o45], e.shift())), T.getInstance().fences_(t, e, r, n);
              }
              if (i && "close" === a && Q.isNeutralFence(i) && r.some(o)) {
                var _i43 = s.sliceNodes(r, o, !0),
                  _a17 = n.pop(),
                  _Q8 = n.length - _i43.tail.length + 1,
                  _l2 = T.getInstance().neutralFences_(_i43.tail, n.slice(_Q8));
                n = n.slice(0, _Q8);
                var c = T.getInstance().horizontalFencedNode_(_i43.div, t.shift(), n.pop().concat(_l2, _a17));
                return n.push(n.pop().concat([c], e.shift())), T.getInstance().fences_(t, e, _i43.head, n);
              }
              var l = t.shift();
              return T.fenceToPunct_(l), n.push(n.pop().concat([l], e.shift())), T.getInstance().fences_(t, e, r, n);
            }
          }, {
            key: "neutralFences_",
            value: function neutralFences_(t, e) {
              if (0 === t.length) return t;
              if (1 === t.length) return T.fenceToPunct_(t[0]), t;
              var r = t.shift();
              if (!Q.elligibleLeftNeutral(r)) {
                T.fenceToPunct_(r);
                var _n231 = e.shift();
                return _n231.unshift(r), _n231.concat(T.getInstance().neutralFences_(t, e));
              }
              var n = s.sliceNodes(t, function (t) {
                return Q.compareNeutralFences(t, r);
              });
              if (!n.div) {
                T.fenceToPunct_(r);
                var _n232 = e.shift();
                return _n232.unshift(r), _n232.concat(T.getInstance().neutralFences_(t, e));
              }
              if (!Q.elligibleRightNeutral(n.div)) return T.fenceToPunct_(n.div), t.unshift(r), T.getInstance().neutralFences_(t, e);
              var o = T.getInstance().combineFencedContent_(r, n.div, n.head, e);
              if (n.tail.length > 0) {
                var _t116 = o.shift(),
                  _e103 = T.getInstance().neutralFences_(n.tail, o);
                return _t116.concat(_e103);
              }
              return o[0];
            }
          }, {
            key: "combineFencedContent_",
            value: function combineFencedContent_(t, e, r, n) {
              if (0 === r.length) {
                var _r119 = T.getInstance().horizontalFencedNode_(t, e, n.shift());
                return n.length > 0 ? n[0].unshift(_r119) : n = [[_r119]], n;
              }
              var o = n.shift(),
                i = r.length - 1,
                a = n.slice(0, i),
                Q = (n = n.slice(i)).shift(),
                s = T.getInstance().neutralFences_(r, a);
              o.push.apply(o, _toConsumableArray(s)), o.push.apply(o, _toConsumableArray(Q));
              var l = T.getInstance().horizontalFencedNode_(t, e, o);
              return n.length > 0 ? n[0].unshift(l) : n = [[l]], n;
            }
          }, {
            key: "horizontalFencedNode_",
            value: function horizontalFencedNode_(t, e, r) {
              var n = T.getInstance().row(r);
              var o = T.getInstance().factory_.makeBranchNode("fenced", [n], [t, e]);
              return "open" === t.role ? (T.getInstance().classifyHorizontalFence_(o), o = i.run("propagateComposedFunction", o)) : o.role = t.role, o = i.run("detect_cycle", o), T.rewriteFencedNode_(o);
            }
          }, {
            key: "classifyHorizontalFence_",
            value: function classifyHorizontalFence_(t) {
              t.role = "leftright";
              var e = t.childNodes;
              if (!Q.isSetNode(t) || e.length > 1) return;
              if (0 === e.length || "empty" === e[0].type) return void (t.role = "set empty");
              var r = e[0].type;
              if (1 === e.length && Q.isSingletonSetContent(e[0])) return void (t.role = "set singleton");
              var n = e[0].role;
              if ("punctuated" === r && "sequence" === n) {
                if ("comma" !== e[0].contentNodes[0].role) return 1 !== e[0].contentNodes.length || "vbar" !== e[0].contentNodes[0].role && "colon" !== e[0].contentNodes[0].role ? void 0 : (t.role = "set extended", void T.getInstance().setExtension_(t));
                t.role = "set collection";
              }
            }
          }, {
            key: "setExtension_",
            value: function setExtension_(t) {
              var e = t.childNodes[0].childNodes[0];
              e && "infixop" === e.type && 1 === e.contentNodes.length && Q.isMembership(e.contentNodes[0]) && (e.addAnnotation("set", "intensional"), e.contentNodes[0].addAnnotation("set", "intensional"));
            }
          }, {
            key: "getPunctuationInRow_",
            value: function getPunctuationInRow_(t) {
              if (t.length <= 1) return t;
              var e = function e(t) {
                  var e = t.type;
                  return "punctuation" === e || "text" === e || "operator" === e || "relation" === e;
                },
                r = s.partitionNodes(t, function (r) {
                  if (!Q.isPunctuation(r)) return !1;
                  if (Q.isPunctuation(r) && !Q.isRole(r, "ellipsis")) return !0;
                  var n = t.indexOf(r);
                  if (0 === n) return !t[1] || !e(t[1]);
                  var o = t[n - 1];
                  if (n === t.length - 1) return !e(o);
                  var i = t[n + 1];
                  return !e(o) || !e(i);
                });
              if (0 === r.rel.length) return t;
              var n = [];
              var o = r.comp.shift();
              o.length > 0 && n.push(T.getInstance().row(o));
              var i = 0;
              for (; r.comp.length > 0;) n.push(r.rel[i++]), o = r.comp.shift(), o.length > 0 && n.push(T.getInstance().row(o));
              return [T.getInstance().punctuatedNode_(n, r.rel)];
            }
          }, {
            key: "punctuatedNode_",
            value: function punctuatedNode_(t, e) {
              var r = T.getInstance().factory_.makeBranchNode("punctuated", t, e);
              if (e.length === t.length) {
                var _t117 = e[0].role;
                if ("unknown" !== _t117 && e.every(function (e) {
                  return e.role === _t117;
                })) return r.role = _t117, r;
              }
              return Q.singlePunctAtPosition(t, e, 0) ? r.role = "startpunct" : Q.singlePunctAtPosition(t, e, t.length - 1) ? r.role = "endpunct" : e.every(function (t) {
                return Q.isRole(t, "dummy");
              }) ? r.role = "text" : e.every(function (t) {
                return Q.isRole(t, "space");
              }) ? r.role = "space" : r.role = "sequence", r;
            }
          }, {
            key: "dummyNode_",
            value: function dummyNode_(t) {
              var e = T.getInstance().factory_.makeMultipleContentNodes(t.length - 1, o.invisibleComma());
              return e.forEach(function (t) {
                t.role = "dummy";
              }), T.getInstance().punctuatedNode_(t, e);
            }
          }, {
            key: "accentRole_",
            value: function accentRole_(t, e) {
              if (!Q.isAccent(t)) return !1;
              var r = t.textContent,
                n = o.lookupSecondary("bar", r) || o.lookupSecondary("tilde", r) || t.role;
              return t.role = "underscore" === e ? "underaccent" : "overaccent", t.addAnnotation("accent", n), !0;
            }
          }, {
            key: "accentNode_",
            value: function accentNode_(t, e, r, n, o) {
              var i = (e = e.slice(0, n + 1))[1],
                a = e[2];
              var Q;
              if (!o && a && (Q = T.getInstance().factory_.makeBranchNode("subscript", [t, i], []), Q.role = "subsup", e = [Q, a], r = "superscript"), o) {
                var _n233 = T.getInstance().accentRole_(i, r);
                if (a) {
                  T.getInstance().accentRole_(a, "overscore") && !_n233 ? (Q = T.getInstance().factory_.makeBranchNode("overscore", [t, a], []), e = [Q, i], r = "underscore") : (Q = T.getInstance().factory_.makeBranchNode("underscore", [t, i], []), e = [Q, a], r = "overscore"), Q.role = "underover";
                }
              }
              return T.getInstance().makeLimitNode_(t, e, Q, r);
            }
          }, {
            key: "makeLimitNode_",
            value: function makeLimitNode_(t, e, r, n) {
              if ("limupper" === n && "limlower" === t.type) return t.childNodes.push(e[1]), e[1].parent = t, t.type = "limboth", t;
              if ("limlower" === n && "limupper" === t.type) return t.childNodes.splice(1, -1, e[1]), e[1].parent = t, t.type = "limboth", t;
              var o = T.getInstance().factory_.makeBranchNode(n, e, []),
                i = Q.isEmbellished(t);
              return r && (r.embellished = i), o.embellished = i, o.role = t.role, o;
            }
          }, {
            key: "getFunctionsInRow_",
            value: function getFunctionsInRow_(t, e) {
              var r = e || [];
              if (0 === t.length) return r;
              var n = t.shift(),
                o = T.classifyFunction_(n, t);
              if (!o) return r.push(n), T.getInstance().getFunctionsInRow_(t, r);
              var i = T.getInstance().getFunctionsInRow_(t, []),
                a = T.getInstance().getFunctionArgs_(n, i, o);
              return r.concat(a);
            }
          }, {
            key: "getFunctionArgs_",
            value: function getFunctionArgs_(t, e, r) {
              var n, o, i;
              switch (r) {
                case "integral":
                  {
                    var _r120 = T.getInstance().getIntegralArgs_(e);
                    if (!_r120.intvar && !_r120.integrand.length) return _r120.rest.unshift(t), _r120.rest;
                    var _n234 = T.getInstance().row(_r120.integrand);
                    return i = T.getInstance().integralNode_(t, _n234, _r120.intvar), _r120.rest.unshift(i), _r120.rest;
                  }
                case "prefix":
                  if (e[0] && "fenced" === e[0].type) {
                    var _r121 = e.shift();
                    return Q.isNeutralFence(_r121) || (_r121.role = "leftright"), i = T.getInstance().functionNode_(t, _r121), e.unshift(i), e;
                  }
                  if (n = s.sliceNodes(e, Q.isPrefixFunctionBoundary), n.head.length) o = T.getInstance().row(n.head), n.div && n.tail.unshift(n.div);else {
                    if (!n.div || !Q.isType(n.div, "appl")) return e.unshift(t), e;
                    o = n.div;
                  }
                  return i = T.getInstance().functionNode_(t, o), n.tail.unshift(i), n.tail;
                case "bigop":
                  return n = s.sliceNodes(e, Q.isBigOpBoundary), n.head.length ? (o = T.getInstance().row(n.head), i = T.getInstance().bigOpNode_(t, o), n.div && n.tail.unshift(n.div), n.tail.unshift(i), n.tail) : (e.unshift(t), e);
                default:
                  {
                    if (0 === e.length) return [t];
                    var _r122 = e[0];
                    return "fenced" === _r122.type && !Q.isNeutralFence(_r122) && Q.isSimpleFunctionScope(_r122) ? (_r122.role = "leftright", T.propagateFunctionRole_(t, "simple function"), i = T.getInstance().functionNode_(t, e.shift()), e.unshift(i), e) : (e.unshift(t), e);
                  }
              }
            }
          }, {
            key: "getIntegralArgs_",
            value: function getIntegralArgs_(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              if (0 === t.length) return {
                integrand: e,
                intvar: null,
                rest: t
              };
              var r = t[0];
              if (Q.isGeneralFunctionBoundary(r)) return {
                integrand: e,
                intvar: null,
                rest: t
              };
              if (Q.isIntegralDxBoundarySingle(r)) return r.role = "integral", {
                integrand: e,
                intvar: r,
                rest: t.slice(1)
              };
              if (t[1] && Q.isIntegralDxBoundary(r, t[1])) {
                var _n235 = T.getInstance().prefixNode_(t[1], [r]);
                return _n235.role = "integral", {
                  integrand: e,
                  intvar: _n235,
                  rest: t.slice(2)
                };
              }
              return e.push(t.shift()), T.getInstance().getIntegralArgs_(t, e);
            }
          }, {
            key: "functionNode_",
            value: function functionNode_(t, e) {
              var r = T.getInstance().factory_.makeContentNode(o.functionApplication()),
                n = T.getInstance().funcAppls[t.id];
              n && (r.mathmlTree = n.mathmlTree, r.mathml = n.mathml, r.annotation = n.annotation, r.attributes = n.attributes, delete T.getInstance().funcAppls[t.id]), r.type = "punctuation", r.role = "application";
              var i = T.getFunctionOp_(t, function (t) {
                return Q.isType(t, "function") || Q.isType(t, "identifier") && Q.isRole(t, "simple function");
              });
              return T.getInstance().functionalNode_("appl", [t, e], i, [r]);
            }
          }, {
            key: "bigOpNode_",
            value: function bigOpNode_(t, e) {
              var r = T.getFunctionOp_(t, function (t) {
                return Q.isType(t, "largeop");
              });
              return T.getInstance().functionalNode_("bigop", [t, e], r, []);
            }
          }, {
            key: "integralNode_",
            value: function integralNode_(t, e, r) {
              e = e || T.getInstance().factory_.makeEmptyNode(), r = r || T.getInstance().factory_.makeEmptyNode();
              var n = T.getFunctionOp_(t, function (t) {
                return Q.isType(t, "largeop");
              });
              return T.getInstance().functionalNode_("integral", [t, e, r], n, []);
            }
          }, {
            key: "functionalNode_",
            value: function functionalNode_(t, e, r, n) {
              var o = e[0];
              var i;
              r && (i = r.parent, n.push(r));
              var a = T.getInstance().factory_.makeBranchNode(t, e, n);
              return a.role = o.role, i && (r.parent = i), a;
            }
          }, {
            key: "fractionNode_",
            value: function fractionNode_(t, e) {
              var r = T.getInstance().factory_.makeBranchNode("fraction", [t, e], []);
              return r.role = r.childNodes.every(function (t) {
                return Q.isType(t, "number") && Q.isRole(t, "integer");
              }) ? "vulgar" : r.childNodes.every(Q.isPureUnit) ? "unit" : "division", i.run("propagateSimpleFunction", r);
            }
          }, {
            key: "scriptNode_",
            value: function scriptNode_(t, e, r) {
              var n;
              switch (t.length) {
                case 0:
                  n = T.getInstance().factory_.makeEmptyNode();
                  break;
                case 1:
                  if (n = t[0], r) return n;
                  break;
                default:
                  n = T.getInstance().dummyNode_(t);
              }
              return n.role = e, n;
            }
          }, {
            key: "findNestedRow_",
            value: function findNestedRow_(t, e, r, o) {
              if (r > 3) return null;
              for (var _i44, _a18 = 0; _i44 = t[_a18]; _a18++) {
                var _t118 = n.tagName(_i44);
                if ("MSPACE" !== _t118) {
                  if ("MROW" === _t118) return T.getInstance().findNestedRow_(n.toArray(_i44.childNodes), e, r + 1, o);
                  if (T.findSemantics(_i44, e, o)) return _i44;
                }
              }
              return null;
            }
          }], [{
            key: "getInstance",
            value: function getInstance() {
              return T.instance = T.instance || new T(), T.instance;
            }
          }, {
            key: "tableToMultiline",
            value: function tableToMultiline(t) {
              if (Q.tableIsMultiline(t)) {
                t.type = "multiline";
                for (var _e104, _r123 = 0; _e104 = t.childNodes[_r123]; _r123++) T.rowToLine_(_e104, "multiline");
                1 === t.childNodes.length && !Q.lineIsLabelled(t.childNodes[0]) && Q.isFencedElement(t.childNodes[0].childNodes[0]) && T.tableToMatrixOrVector_(T.rewriteFencedLine_(t)), T.binomialForm_(t), T.classifyMultiline(t);
              } else T.classifyTable(t);
            }
          }, {
            key: "number",
            value: function number(t) {
              "unknown" !== t.type && "identifier" !== t.type || (t.type = "number"), T.numberRole_(t), T.exprFont_(t);
            }
          }, {
            key: "classifyMultiline",
            value: function classifyMultiline(t) {
              var e = 0;
              var r = t.childNodes.length;
              var n;
              for (; e < r && (!(n = t.childNodes[e]) || !n.childNodes.length);) e++;
              if (e >= r) return;
              var o = n.childNodes[0].role;
              "unknown" !== o && t.childNodes.every(function (t) {
                var e = t.childNodes[0];
                return !e || e.role === o && (Q.isType(e, "relation") || Q.isType(e, "relseq"));
              }) && (t.role = o);
            }
          }, {
            key: "classifyTable",
            value: function classifyTable(t) {
              var e = T.computeColumns_(t);
              T.classifyByColumns_(t, e, "equality") || T.classifyByColumns_(t, e, "inequality", ["equality"]) || T.classifyByColumns_(t, e, "arrow") || T.detectCaleyTable(t);
            }
          }, {
            key: "detectCaleyTable",
            value: function detectCaleyTable(t) {
              if (!t.mathmlTree) return !1;
              var e = t.mathmlTree,
                r = e.getAttribute("columnlines"),
                n = e.getAttribute("rowlines");
              return !(!r || !n) && !(!T.cayleySpacing(r) || !T.cayleySpacing(n)) && (t.role = "cayley", !0);
            }
          }, {
            key: "cayleySpacing",
            value: function cayleySpacing(t) {
              var e = t.split(" ");
              return ("solid" === e[0] || "dashed" === e[0]) && e.slice(1).every(function (t) {
                return "none" === t;
              });
            }
          }, {
            key: "proof",
            value: function proof(t, e, r) {
              var n = T.separateSemantics(e);
              return T.getInstance().proof(t, n, r);
            }
          }, {
            key: "findSemantics",
            value: function findSemantics(t, e, r) {
              var n = null == r ? null : r,
                o = T.getSemantics(t);
              return !!o && !!o[e] && (null == n || o[e] === n);
            }
          }, {
            key: "getSemantics",
            value: function getSemantics(t) {
              var e = t.getAttribute("semantics");
              return e ? T.separateSemantics(e) : null;
            }
          }, {
            key: "removePrefix",
            value: function removePrefix(t) {
              var _t$split = t.split("_"),
                _t$split2 = _toArray(_t$split),
                e = _t$split2.slice(1);
              return e.join("_");
            }
          }, {
            key: "separateSemantics",
            value: function separateSemantics(t) {
              var e = {};
              return t.split(";").forEach(function (t) {
                var _t$split3 = t.split(":"),
                  _t$split4 = _slicedToArray(_t$split3, 2),
                  r = _t$split4[0],
                  n = _t$split4[1];
                e[T.removePrefix(r)] = n;
              }), e;
            }
          }, {
            key: "matchSpaces_",
            value: function matchSpaces_(t, e) {
              for (var _r124, _n236 = 0; _r124 = e[_n236]; _n236++) {
                var _e105 = t[_n236].mathmlTree,
                  _o46 = t[_n236 + 1].mathmlTree;
                if (!_e105 || !_o46) continue;
                var _i45 = _e105.nextSibling;
                if (!_i45 || _i45 === _o46) continue;
                var _a19 = T.getSpacer_(_i45);
                _a19 && (_r124.mathml.push(_a19), _r124.mathmlTree = _a19, _r124.role = "space");
              }
            }
          }, {
            key: "getSpacer_",
            value: function getSpacer_(t) {
              if ("MSPACE" === n.tagName(t)) return t;
              for (; s.hasEmptyTag(t) && 1 === t.childNodes.length;) if (t = t.childNodes[0], "MSPACE" === n.tagName(t)) return t;
              return null;
            }
          }, {
            key: "fenceToPunct_",
            value: function fenceToPunct_(t) {
              var e = T.FENCE_TO_PUNCT_[t.role];
              if (e) {
                for (; t.embellished;) t.embellished = "punctuation", Q.isRole(t, "subsup") || Q.isRole(t, "underover") || (t.role = e), t = t.childNodes[0];
                t.type = "punctuation", t.role = e;
              }
            }
          }, {
            key: "classifyFunction_",
            value: function classifyFunction_(t, e) {
              if ("appl" === t.type || "bigop" === t.type || "integral" === t.type) return "";
              if (e[0] && e[0].textContent === o.functionApplication()) {
                T.getInstance().funcAppls[t.id] = e.shift();
                var _r125 = "simple function";
                return i.run("simple2prefix", t), "prefix function" !== t.role && "limit function" !== t.role || (_r125 = t.role), T.propagateFunctionRole_(t, _r125), "prefix";
              }
              var r = T.CLASSIFY_FUNCTION_[t.role];
              return r || (Q.isSimpleFunctionHead(t) ? "simple" : "");
            }
          }, {
            key: "propagateFunctionRole_",
            value: function propagateFunctionRole_(t, e) {
              if (t) {
                if ("infixop" === t.type) return;
                Q.isRole(t, "subsup") || Q.isRole(t, "underover") || (t.role = e), T.propagateFunctionRole_(t.childNodes[0], e);
              }
            }
          }, {
            key: "getFunctionOp_",
            value: function getFunctionOp_(t, e) {
              if (e(t)) return t;
              for (var _r126, _n237 = 0; _r126 = t.childNodes[_n237]; _n237++) {
                var _t119 = T.getFunctionOp_(_r126, e);
                if (_t119) return _t119;
              }
              return null;
            }
          }, {
            key: "tableToMatrixOrVector_",
            value: function tableToMatrixOrVector_(t) {
              var e = t.childNodes[0];
              Q.isType(e, "multiline") ? T.tableToVector_(t) : T.tableToMatrix_(t), t.contentNodes.forEach(e.appendContentNode.bind(e));
              for (var _t120, _r127 = 0; _t120 = e.childNodes[_r127]; _r127++) T.assignRoleToRow_(_t120, T.getComponentRoles_(e));
              return e.parent = null, e;
            }
          }, {
            key: "tableToVector_",
            value: function tableToVector_(t) {
              var e = t.childNodes[0];
              e.type = "vector", 1 !== e.childNodes.length ? T.binomialForm_(e) : T.tableToSquare_(t);
            }
          }, {
            key: "binomialForm_",
            value: function binomialForm_(t) {
              Q.isBinomial(t) && (t.role = "binomial", t.childNodes[0].role = "binomial", t.childNodes[1].role = "binomial");
            }
          }, {
            key: "tableToMatrix_",
            value: function tableToMatrix_(t) {
              var e = t.childNodes[0];
              e.type = "matrix", e.childNodes && e.childNodes.length > 0 && e.childNodes[0].childNodes && e.childNodes.length === e.childNodes[0].childNodes.length ? T.tableToSquare_(t) : e.childNodes && 1 === e.childNodes.length && (e.role = "rowvector");
            }
          }, {
            key: "tableToSquare_",
            value: function tableToSquare_(t) {
              var e = t.childNodes[0];
              Q.isNeutralFence(t) ? e.role = "determinant" : e.role = "squarematrix";
            }
          }, {
            key: "getComponentRoles_",
            value: function getComponentRoles_(t) {
              var e = t.role;
              return e && "unknown" !== e ? e : t.type.toLowerCase() || "unknown";
            }
          }, {
            key: "tableToCases_",
            value: function tableToCases_(t, e) {
              for (var _e106, _r128 = 0; _e106 = t.childNodes[_r128]; _r128++) T.assignRoleToRow_(_e106, "cases");
              return t.type = "cases", t.appendContentNode(e), Q.tableIsMultiline(t) && T.binomialForm_(t), t;
            }
          }, {
            key: "rewriteFencedLine_",
            value: function rewriteFencedLine_(t) {
              var e = t.childNodes[0],
                r = t.childNodes[0].childNodes[0],
                n = t.childNodes[0].childNodes[0].childNodes[0];
              return r.parent = t.parent, t.parent = r, n.parent = e, r.childNodes = [t], e.childNodes = [n], r;
            }
          }, {
            key: "rowToLine_",
            value: function rowToLine_(t, e) {
              var r = e || "unknown";
              Q.isType(t, "row") && (t.type = "line", t.role = r, 1 === t.childNodes.length && Q.isType(t.childNodes[0], "cell") && (t.childNodes = t.childNodes[0].childNodes, t.childNodes.forEach(function (e) {
                e.parent = t;
              })));
            }
          }, {
            key: "assignRoleToRow_",
            value: function assignRoleToRow_(t, e) {
              Q.isType(t, "line") ? t.role = e : Q.isType(t, "row") && (t.role = e, t.childNodes.forEach(function (t) {
                Q.isType(t, "cell") && (t.role = e);
              }));
            }
          }, {
            key: "nextSeparatorFunction_",
            value: function nextSeparatorFunction_(t) {
              var e;
              if (t) {
                if (t.match(/^\s+$/)) return null;
                e = t.replace(/\s/g, "").split("").filter(function (t) {
                  return t;
                });
              } else e = [","];
              return function () {
                return e.length > 1 ? e.shift() : e[0];
              };
            }
          }, {
            key: "numberRole_",
            value: function numberRole_(t) {
              if ("unknown" !== t.role) return;
              var e = _toConsumableArray(t.textContent).filter(function (t) {
                  return t.match(/[^\s]/);
                }),
                r = e.map(o.lookupMeaning);
              if (r.every(function (t) {
                return "number" === t.type && "integer" === t.role || "punctuation" === t.type && "comma" === t.role;
              })) return t.role = "integer", void ("0" === e[0] && t.addAnnotation("general", "basenumber"));
              r.every(function (t) {
                return "number" === t.type && "integer" === t.role || "punctuation" === t.type;
              }) ? t.role = "float" : t.role = "othernumber";
            }
          }, {
            key: "exprFont_",
            value: function exprFont_(t) {
              if ("unknown" !== t.font) return;
              var e = _toConsumableArray(t.textContent).map(o.lookupMeaning).reduce(function (t, e) {
                return t && e.font && "unknown" !== e.font && e.font !== t ? "unknown" === t ? e.font : null : t;
              }, "unknown");
              e && (t.font = e);
            }
          }, {
            key: "purgeFences_",
            value: function purgeFences_(t) {
              var e = t.rel,
                r = t.comp,
                n = [],
                o = [];
              for (; e.length > 0;) {
                var _t121 = e.shift();
                var _i46 = r.shift();
                Q.isElligibleEmbellishedFence(_t121) ? (n.push(_t121), o.push(_i46)) : (T.fenceToPunct_(_t121), _i46.push(_t121), _i46 = _i46.concat(r.shift()), r.unshift(_i46));
              }
              return o.push(r.shift()), {
                rel: n,
                comp: o
              };
            }
          }, {
            key: "rewriteFencedNode_",
            value: function rewriteFencedNode_(t) {
              var e = t.contentNodes[0],
                r = t.contentNodes[1];
              var n = T.rewriteFence_(t, e);
              return t.contentNodes[0] = n.fence, n = T.rewriteFence_(n.node, r), t.contentNodes[1] = n.fence, t.contentNodes[0].parent = t, t.contentNodes[1].parent = t, n.node.parent = null, n.node;
            }
          }, {
            key: "rewriteFence_",
            value: function rewriteFence_(t, e) {
              if (!e.embellished) return {
                node: t,
                fence: e
              };
              var r = e.childNodes[0],
                n = T.rewriteFence_(t, r);
              return Q.isType(e, "superscript") || Q.isType(e, "subscript") || Q.isType(e, "tensor") ? (Q.isRole(e, "subsup") || (e.role = t.role), r !== n.node && (e.replaceChild(r, n.node), r.parent = t), T.propagateFencePointer_(e, r), {
                node: e,
                fence: n.fence
              }) : (e.replaceChild(r, n.fence), e.mathmlTree && -1 === e.mathml.indexOf(e.mathmlTree) && e.mathml.push(e.mathmlTree), {
                node: n.node,
                fence: e
              });
            }
          }, {
            key: "propagateFencePointer_",
            value: function propagateFencePointer_(t, e) {
              t.fencePointer = e.fencePointer || e.id.toString(), t.embellished = null;
            }
          }, {
            key: "classifyByColumns_",
            value: function classifyByColumns_(t, e, r, n) {
              return !!(3 === e.length && T.testColumns_(e, 1, function (t) {
                return T.isPureRelation_(t, r);
              }) || 2 === e.length && (T.testColumns_(e, 1, function (t) {
                return T.isEndRelation_(t, r) || T.isPureRelation_(t, r);
              }) || T.testColumns_(e, 0, function (t) {
                return T.isEndRelation_(t, r, !0) || T.isPureRelation_(t, r);
              }))) && (t.role = r, !0);
            }
          }, {
            key: "isEndRelation_",
            value: function isEndRelation_(t, e, r) {
              var n = r ? t.childNodes.length - 1 : 0;
              return Q.isType(t, "relseq") && Q.isRole(t, e) && Q.isType(t.childNodes[n], "empty");
            }
          }, {
            key: "isPureRelation_",
            value: function isPureRelation_(t, e) {
              return Q.isType(t, "relation") && Q.isRole(t, e);
            }
          }, {
            key: "computeColumns_",
            value: function computeColumns_(t) {
              var e = [];
              for (var _r129, _n238 = 0; _r129 = t.childNodes[_n238]; _n238++) for (var _t122, _n239 = 0; _t122 = _r129.childNodes[_n239]; _n239++) {
                e[_n239] ? e[_n239].push(_t122) : e[_n239] = [_t122];
              }
              return e;
            }
          }, {
            key: "testColumns_",
            value: function testColumns_(t, e, r) {
              var n = t[e];
              return !!n && n.some(function (t) {
                return t.childNodes.length && r(t.childNodes[0]);
              }) && n.every(function (t) {
                return !t.childNodes.length || r(t.childNodes[0]);
              });
            }
          }]);
          return T;
        }();
        e.default = T, T.FENCE_TO_PUNCT_ = {
          metric: "metric",
          neutral: "vbar",
          open: "openfence",
          close: "closefence"
        }, T.MML_TO_LIMIT_ = {
          MSUB: {
            type: "limlower",
            length: 1
          },
          MUNDER: {
            type: "limlower",
            length: 1
          },
          MSUP: {
            type: "limupper",
            length: 1
          },
          MOVER: {
            type: "limupper",
            length: 1
          },
          MSUBSUP: {
            type: "limboth",
            length: 2
          },
          MUNDEROVER: {
            type: "limboth",
            length: 2
          }
        }, T.MML_TO_BOUNDS_ = {
          MSUB: {
            type: "subscript",
            length: 1,
            accent: !1
          },
          MSUP: {
            type: "superscript",
            length: 1,
            accent: !1
          },
          MSUBSUP: {
            type: "subscript",
            length: 2,
            accent: !1
          },
          MUNDER: {
            type: "underscore",
            length: 1,
            accent: !0
          },
          MOVER: {
            type: "overscore",
            length: 1,
            accent: !0
          },
          MUNDEROVER: {
            type: "underscore",
            length: 2,
            accent: !0
          }
        }, T.CLASSIFY_FUNCTION_ = {
          integral: "integral",
          sum: "bigop",
          "prefix function": "prefix",
          "limit function": "prefix",
          "simple function": "prefix",
          "composed function": "prefix"
        }, T.MATHJAX_FONTS = {
          "-tex-caligraphic": "caligraphic",
          "-tex-caligraphic-bold": "caligraphic-bold",
          "-tex-calligraphic": "caligraphic",
          "-tex-calligraphic-bold": "caligraphic-bold",
          "-tex-oldstyle": "oldstyle",
          "-tex-oldstyle-bold": "oldstyle-bold",
          "-tex-mathit": "italic"
        };
      },
      5656: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticSkeleton = void 0;
        var n = r(707),
          o = r(5274),
          i = r(2298);
        var a = /*#__PURE__*/function () {
          function a(t) {
            _classCallCheck(this, a);
            this.parents = null, this.levelsMap = null, t = 0 === t ? t : t || [], this.array = t;
          }
          _createClass(a, [{
            key: "populate",
            value: function populate() {
              this.parents && this.levelsMap || (this.parents = {}, this.levelsMap = {}, this.populate_(this.array, this.array, []));
            }
          }, {
            key: "toString",
            value: function toString() {
              return a.makeSexp_(this.array);
            }
          }, {
            key: "populate_",
            value: function populate_(t, e, r) {
              if (a.simpleCollapseStructure(t)) return t = t, this.levelsMap[t] = e, void (this.parents[t] = t === r[0] ? r.slice(1) : r);
              var n = a.contentCollapseStructure(t) ? t.slice(1) : t,
                o = [n[0]].concat(r);
              for (var _e107 = 0, _r130 = n.length; _e107 < _r130; _e107++) {
                var _r131 = n[_e107];
                this.populate_(_r131, t, o);
              }
            }
          }, {
            key: "isRoot",
            value: function isRoot(t) {
              return t === this.levelsMap[t][0];
            }
          }, {
            key: "directChildren",
            value: function directChildren(t) {
              if (!this.isRoot(t)) return [];
              return this.levelsMap[t].slice(1).map(function (t) {
                return a.simpleCollapseStructure(t) ? t : a.contentCollapseStructure(t) ? t[1] : t[0];
              });
            }
          }, {
            key: "subtreeNodes",
            value: function subtreeNodes(t) {
              if (!this.isRoot(t)) return [];
              var e = function (_e108) {
                  function e(_x, _x2) {
                    return _e108.apply(this, arguments);
                  }
                  e.toString = function () {
                    return _e108.toString();
                  };
                  return e;
                }(function (t, r) {
                  a.simpleCollapseStructure(t) ? r.push(t) : (t = t, a.contentCollapseStructure(t) && (t = t.slice(1)), t.forEach(function (t) {
                    return e(t, r);
                  }));
                }),
                r = this.levelsMap[t],
                n = [];
              return e(r.slice(1), n), n;
            }
          }], [{
            key: "fromTree",
            value: function fromTree(t) {
              return a.fromNode(t.root);
            }
          }, {
            key: "fromNode",
            value: function fromNode(t) {
              return new a(a.fromNode_(t));
            }
          }, {
            key: "fromString",
            value: function fromString(t) {
              return new a(a.fromString_(t));
            }
          }, {
            key: "simpleCollapseStructure",
            value: function simpleCollapseStructure(t) {
              return "number" == typeof t;
            }
          }, {
            key: "contentCollapseStructure",
            value: function contentCollapseStructure(t) {
              return !!t && !a.simpleCollapseStructure(t) && "c" === t[0];
            }
          }, {
            key: "interleaveIds",
            value: function interleaveIds(t, e) {
              return n.interleaveLists(a.collapsedLeafs(t), a.collapsedLeafs(e));
            }
          }, {
            key: "collapsedLeafs",
            value: function collapsedLeafs() {
              for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                t[_key9] = arguments[_key9];
              }
              return t.reduce(function (t, e) {
                return t.concat((r = e, a.simpleCollapseStructure(r) ? [r] : (r = r, a.contentCollapseStructure(r[1]) ? r.slice(2) : r.slice(1))));
                var r;
              }, []);
            }
          }, {
            key: "fromStructure",
            value: function fromStructure(t, e) {
              return new a(a.tree_(t, e.root));
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r) {
              switch (t.type) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return n.interleaveLists(r, e);
                case "prefixop":
                  return e.concat(r);
                case "postfixop":
                  return r.concat(e);
                case "fenced":
                  return r.unshift(e[0]), r.push(e[1]), r;
                case "appl":
                  return [r[0], e[0], r[1]];
                case "root":
                  return [r[1], r[0]];
                case "row":
                case "line":
                  return e.length && r.unshift(e[0]), r;
                default:
                  return r;
              }
            }
          }, {
            key: "makeSexp_",
            value: function makeSexp_(t) {
              return a.simpleCollapseStructure(t) ? t.toString() : a.contentCollapseStructure(t) ? "(c " + t.slice(1).map(a.makeSexp_).join(" ") + ")" : "(" + t.map(a.makeSexp_).join(" ") + ")";
            }
          }, {
            key: "fromString_",
            value: function fromString_(t) {
              var e = t.replace(/\(/g, "[");
              return e = e.replace(/\)/g, "]"), e = e.replace(/ /g, ","), e = e.replace(/c/g, '"c"'), JSON.parse(e);
            }
          }, {
            key: "fromNode_",
            value: function fromNode_(t) {
              if (!t) return [];
              var e = t.contentNodes;
              var r;
              e.length && (r = e.map(a.fromNode_), r.unshift("c"));
              var n = t.childNodes;
              if (!n.length) return e.length ? [t.id, r] : t.id;
              var o = n.map(a.fromNode_);
              return e.length && o.unshift(r), o.unshift(t.id), o;
            }
          }, {
            key: "tree_",
            value: function tree_(t, e) {
              if (!e) return [];
              if (!e.childNodes.length) return e.id;
              var r = e.id,
                n = [r],
                Q = o.evalXPath(".//self::*[@".concat(i.Attribute.ID, "=").concat(r, "]"), t)[0],
                s = a.combineContentChildren(e, e.contentNodes.map(function (t) {
                  return t;
                }), e.childNodes.map(function (t) {
                  return t;
                }));
              Q && a.addOwns_(Q, s);
              for (var _e109, _r132 = 0; _e109 = s[_r132]; _r132++) n.push(a.tree_(t, _e109));
              return n;
            }
          }, {
            key: "addOwns_",
            value: function addOwns_(t, e) {
              var r = t.getAttribute(i.Attribute.COLLAPSED),
                n = r ? a.realLeafs_(a.fromString(r).array) : e.map(function (t) {
                  return t.id;
                });
              t.setAttribute(i.Attribute.OWNS, n.join(" "));
            }
          }, {
            key: "realLeafs_",
            value: function realLeafs_(t) {
              if (a.simpleCollapseStructure(t)) return [t];
              if (a.contentCollapseStructure(t)) return [];
              t = t;
              var e = [];
              for (var _r133 = 1; _r133 < t.length; _r133++) e = e.concat(a.realLeafs_(t[_r133]));
              return e;
            }
          }]);
          return a;
        }();
        e.SemanticSkeleton = a;
      },
      7075: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticTree = void 0;
        var n = r(5740),
          o = r(7630),
          i = r(9265),
          a = r(7228),
          Q = r(5952),
          s = r(5609);
        r(94);
        var T = /*#__PURE__*/function () {
          function T(t) {
            _classCallCheck(this, T);
            this.mathml = t, this.parser = new a.SemanticMathml(), this.root = this.parser.parse(t), this.collator = this.parser.getFactory().leafMap.collateMeaning();
            var e = this.collator.newDefault();
            e && (this.parser = new a.SemanticMathml(), this.parser.getFactory().defaultMap = e, this.root = this.parser.parse(t)), l.visit(this.root, {}), (0, o.annotate)(this.root);
          }
          _createClass(T, [{
            key: "xml",
            value: function xml(t) {
              var e = n.parseInput("<stree></stree>"),
                r = this.root.xml(e.ownerDocument, t);
              return e.appendChild(r), e;
            }
          }, {
            key: "toString",
            value: function toString(t) {
              return n.serializeXml(this.xml(t));
            }
          }, {
            key: "formatXml",
            value: function formatXml(t) {
              var e = this.toString(t);
              return n.formatXml(e);
            }
          }, {
            key: "displayTree",
            value: function displayTree() {
              this.root.displayTree();
            }
          }, {
            key: "replaceNode",
            value: function replaceNode(t, e) {
              var r = t.parent;
              r ? r.replaceChild(t, e) : this.root = e;
            }
          }, {
            key: "toJson",
            value: function toJson() {
              var t = {};
              return t.stree = this.root.toJson(), t;
            }
          }], [{
            key: "empty",
            value: function empty() {
              var t = n.parseInput("<math/>"),
                e = new T(t);
              return e.mathml = t, e;
            }
          }, {
            key: "fromNode",
            value: function fromNode(t, e) {
              var r = T.empty();
              return r.root = t, e && (r.mathml = e), r;
            }
          }, {
            key: "fromRoot",
            value: function fromRoot(t, e) {
              var r = t;
              for (; r.parent;) r = r.parent;
              var n = T.fromNode(r);
              return e && (n.mathml = e), n;
            }
          }, {
            key: "fromXml",
            value: function fromXml(t) {
              var e = T.empty();
              return t.childNodes[0] && (e.root = Q.SemanticNode.fromXml(t.childNodes[0])), e;
            }
          }]);
          return T;
        }();
        e.SemanticTree = T;
        var l = new i.SemanticVisitor("general", "unit", function (t, e) {
          if ("infixop" === t.type && ("multiplication" === t.role || "implicit" === t.role)) {
            var _e110 = t.childNodes;
            _e110.length && (s.isPureUnit(_e110[0]) || s.isUnitCounter(_e110[0])) && t.childNodes.slice(1).every(s.isPureUnit) && (t.role = "unit");
          }
          return !1;
        });
      },
      4795: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.partitionNodes = e.sliceNodes = e.getEmbellishedInner = e.addAttributes = e.isZeroLength = e.purgeNodes = e.isOrphanedGlyph = e.hasDisplayTag = e.hasEmptyTag = e.hasIgnoreTag = e.hasLeafTag = e.hasMathTag = e.directSpeechKeys = e.DISPLAYTAGS = e.EMPTYTAGS = e.IGNORETAGS = e.LEAFTAGS = void 0;
        var n = r(5740);
        function o(t) {
          return !!t && -1 !== e.LEAFTAGS.indexOf(n.tagName(t));
        }
        function i(t, e, r) {
          r && t.reverse();
          var n = [];
          for (var _o47, _i47 = 0; _o47 = t[_i47]; _i47++) {
            if (e(_o47)) return r ? {
              head: t.slice(_i47 + 1).reverse(),
              div: _o47,
              tail: n.reverse()
            } : {
              head: n,
              div: _o47,
              tail: t.slice(_i47 + 1)
            };
            n.push(_o47);
          }
          return r ? {
            head: [],
            div: null,
            tail: n.reverse()
          } : {
            head: n,
            div: null,
            tail: []
          };
        }
        e.LEAFTAGS = ["MO", "MI", "MN", "MTEXT", "MS", "MSPACE"], e.IGNORETAGS = ["MERROR", "MPHANTOM", "MALIGNGROUP", "MALIGNMARK", "MPRESCRIPTS", "ANNOTATION", "ANNOTATION-XML"], e.EMPTYTAGS = ["MATH", "MROW", "MPADDED", "MACTION", "NONE", "MSTYLE", "SEMANTICS"], e.DISPLAYTAGS = ["MROOT", "MSQRT"], e.directSpeechKeys = ["aria-label", "exact-speech", "alt"], e.hasMathTag = function (t) {
          return !!t && "MATH" === n.tagName(t);
        }, e.hasLeafTag = o, e.hasIgnoreTag = function (t) {
          return !!t && -1 !== e.IGNORETAGS.indexOf(n.tagName(t));
        }, e.hasEmptyTag = function (t) {
          return !!t && -1 !== e.EMPTYTAGS.indexOf(n.tagName(t));
        }, e.hasDisplayTag = function (t) {
          return !!t && -1 !== e.DISPLAYTAGS.indexOf(n.tagName(t));
        }, e.isOrphanedGlyph = function (t) {
          return !!t && "MGLYPH" === n.tagName(t) && !o(t.parentNode);
        }, e.purgeNodes = function (t) {
          var r = [];
          for (var _o48, _i48 = 0; _o48 = t[_i48]; _i48++) {
            if (_o48.nodeType !== n.NodeType.ELEMENT_NODE) continue;
            var _t123 = n.tagName(_o48);
            -1 === e.IGNORETAGS.indexOf(_t123) && (-1 !== e.EMPTYTAGS.indexOf(_t123) && 0 === _o48.childNodes.length || r.push(_o48));
          }
          return r;
        }, e.isZeroLength = function (t) {
          if (!t) return !1;
          if (-1 !== ["negativeveryverythinmathspace", "negativeverythinmathspace", "negativethinmathspace", "negativemediummathspace", "negativethickmathspace", "negativeverythickmathspace", "negativeveryverythickmathspace"].indexOf(t)) return !0;
          var e = t.match(/[0-9.]+/);
          return !!e && 0 === parseFloat(e[0]);
        }, e.addAttributes = function (t, r) {
          if (r.hasAttributes()) {
            var _n240 = r.attributes;
            for (var _r134 = _n240.length - 1; _r134 >= 0; _r134--) {
              var _o49 = _n240[_r134].name;
              _o49.match(/^ext/) && (t.attributes[_o49] = _n240[_r134].value, t.nobreaking = !0), -1 !== e.directSpeechKeys.indexOf(_o49) && (t.attributes["ext-speech"] = _n240[_r134].value, t.nobreaking = !0), _o49.match(/texclass$/) && (t.attributes.texclass = _n240[_r134].value), "href" === _o49 && (t.attributes.href = _n240[_r134].value, t.nobreaking = !0);
            }
          }
        }, e.getEmbellishedInner = function t(e) {
          return e && e.embellished && e.childNodes.length > 0 ? t(e.childNodes[0]) : e;
        }, e.sliceNodes = i, e.partitionNodes = function (t, e) {
          var r = t;
          var n = [],
            o = [];
          var a = null;
          do {
            a = i(r, e), o.push(a.head), n.push(a.div), r = a.tail;
          } while (a.div);
          return n.pop(), {
            rel: n,
            comp: o
          };
        };
      },
      6278: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractSpeechGenerator = void 0;
        var n = r(6828),
          o = r(2298),
          i = r(1214),
          a = r(9543);
        e.AbstractSpeechGenerator = /*#__PURE__*/function () {
          function _class21() {
            _classCallCheck(this, _class21);
            this.modality = o.addPrefix("speech"), this.rebuilt_ = null, this.options_ = {};
          }
          _createClass(_class21, [{
            key: "getRebuilt",
            value: function getRebuilt() {
              return this.rebuilt_;
            }
          }, {
            key: "setRebuilt",
            value: function setRebuilt(t) {
              this.rebuilt_ = t;
            }
          }, {
            key: "setOptions",
            value: function setOptions(t) {
              this.options_ = t || {}, this.modality = o.addPrefix(this.options_.modality || "speech");
            }
          }, {
            key: "getOptions",
            value: function getOptions() {
              return this.options_;
            }
          }, {
            key: "start",
            value: function start() {}
          }, {
            key: "end",
            value: function end() {}
          }, {
            key: "generateSpeech",
            value: function generateSpeech(t, e) {
              return this.rebuilt_ || (this.rebuilt_ = new i.RebuildStree(e)), (0, n.setup)(this.options_), a.computeMarkup(this.getRebuilt().xml);
            }
          }]);
          return _class21;
        }();
      },
      1452: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AdhocSpeechGenerator = void 0;
        var n = r(6278);
        var o = /*#__PURE__*/function (_n$AbstractSpeechGene) {
          _inherits(o, _n$AbstractSpeechGene);
          function o() {
            _classCallCheck(this, o);
            return _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments));
          }
          _createClass(o, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              var r = this.generateSpeech(t, e);
              return t.setAttribute(this.modality, r), r;
            }
          }]);
          return o;
        }(n.AbstractSpeechGenerator);
        e.AdhocSpeechGenerator = o;
      },
      5152: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ColorGenerator = void 0;
        var n = r(2298),
          o = r(8396),
          i = r(1214),
          a = r(1204),
          Q = r(6278);
        var s = /*#__PURE__*/function (_Q$AbstractSpeechGene) {
          _inherits(s, _Q$AbstractSpeechGene);
          function s() {
            var _this46;
            _classCallCheck(this, s);
            _this46 = _possibleConstructorReturn(this, _getPrototypeOf(s).apply(this, arguments)), _this46.modality = (0, n.addPrefix)("foreground"), _this46.contrast = new o.ContrastPicker();
            return _this46;
          }
          _createClass(s, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return a.getAttribute(t, this.modality);
            }
          }, {
            key: "generateSpeech",
            value: function generateSpeech(t, e) {
              return this.getRebuilt() || this.setRebuilt(new i.RebuildStree(t)), this.colorLeaves_(t), a.getAttribute(t, this.modality);
            }
          }, {
            key: "colorLeaves_",
            value: function colorLeaves_(t) {
              var _this47 = this;
              var e = [];
              s.visitStree_(this.getRebuilt().streeRoot, e, {});
              var _loop8 = function _loop8() {
                var r = _e111[_i49];
                var e = _this47.contrast.generate();
                var n = !1;
                n = Array.isArray(r) ? r.map(function (r) {
                  return _this47.colorLeave_(t, r, e);
                }).reduce(function (t, e) {
                  return t || e;
                }, !1) : _this47.colorLeave_(t, r.toString(), e), n && _this47.contrast.increment();
              };
              for (var _i49 = 0, _e111 = e; _i49 < _e111.length; _i49++) {
                _loop8();
              }
            }
          }, {
            key: "colorLeave_",
            value: function colorLeave_(t, e, r) {
              var n = a.getBySemanticId(t, e);
              return !!n && (n.setAttribute(this.modality, r), !0);
            }
          }], [{
            key: "visitStree_",
            value: function visitStree_(t, e, r) {
              if (t.childNodes.length) {
                if (t.contentNodes.length && ("punctuated" === t.type && t.contentNodes.forEach(function (t) {
                  return r[t.id] = !0;
                }), "implicit" !== t.role && e.push(t.contentNodes.map(function (t) {
                  return t.id;
                }))), t.childNodes.length) {
                  if ("implicit" === t.role) {
                    var _n241 = [];
                    var _o50 = [];
                    var _iterator20 = _createForOfIteratorHelper(t.childNodes),
                      _step20;
                    try {
                      for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                        var _e112 = _step20.value;
                        var _t124 = [];
                        s.visitStree_(_e112, _t124, r), _t124.length <= 2 && _n241.push(_t124.shift()), _o50 = _o50.concat(_t124);
                      }
                    } catch (err) {
                      _iterator20.e(err);
                    } finally {
                      _iterator20.f();
                    }
                    return e.push(_n241), void _o50.forEach(function (t) {
                      return e.push(t);
                    });
                  }
                  t.childNodes.forEach(function (t) {
                    return s.visitStree_(t, e, r);
                  });
                }
              } else r[t.id] || e.push(t.id);
            }
          }]);
          return s;
        }(Q.AbstractSpeechGenerator);
        e.ColorGenerator = s;
      },
      6604: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DirectSpeechGenerator = void 0;
        var n = r(1204),
          o = r(6278);
        var i = /*#__PURE__*/function (_o$AbstractSpeechGene) {
          _inherits(i, _o$AbstractSpeechGene);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return n.getAttribute(t, this.modality);
            }
          }]);
          return i;
        }(o.AbstractSpeechGenerator);
        e.DirectSpeechGenerator = i;
      },
      3123: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DummySpeechGenerator = void 0;
        var n = r(6278);
        var o = /*#__PURE__*/function (_n$AbstractSpeechGene2) {
          _inherits(o, _n$AbstractSpeechGene2);
          function o() {
            _classCallCheck(this, o);
            return _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments));
          }
          _createClass(o, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return "";
            }
          }]);
          return o;
        }(n.AbstractSpeechGenerator);
        e.DummySpeechGenerator = o;
      },
      5858: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.NodeSpeechGenerator = void 0;
        var n = r(1204),
          o = r(4598);
        var i = /*#__PURE__*/function (_o$TreeSpeechGenerato) {
          _inherits(i, _o$TreeSpeechGenerato);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return _superPropGet(i, "getSpeech", this, 3)([t, e]), n.getAttribute(t, this.modality);
            }
          }]);
          return i;
        }(o.TreeSpeechGenerator);
        e.NodeSpeechGenerator = i;
      },
      9552: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.generatorMapping_ = e.generator = void 0;
        var n = r(1452),
          o = r(5152),
          i = r(6604),
          a = r(3123),
          Q = r(5858),
          s = r(597),
          T = r(4598);
        e.generator = function (t) {
          return (e.generatorMapping_[t] || e.generatorMapping_.Direct)();
        }, e.generatorMapping_ = {
          Adhoc: function Adhoc() {
            return new n.AdhocSpeechGenerator();
          },
          Color: function Color() {
            return new o.ColorGenerator();
          },
          Direct: function Direct() {
            return new i.DirectSpeechGenerator();
          },
          Dummy: function Dummy() {
            return new a.DummySpeechGenerator();
          },
          Node: function Node() {
            return new Q.NodeSpeechGenerator();
          },
          Summary: function Summary() {
            return new s.SummarySpeechGenerator();
          },
          Tree: function Tree() {
            return new T.TreeSpeechGenerator();
          }
        };
      },
      9543: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.computeSummary_ = e.retrieveSummary = e.connectAllMactions = e.connectMactions = e.nodeAtPosition_ = e.computePrefix_ = e.retrievePrefix = e.addPrefix = e.addModality = e.addSpeech = e.recomputeMarkup = e.computeMarkup = e.recomputeSpeech = e.computeSpeech = void 0;
        var n = r(8290),
          o = r(5740),
          i = r(5274),
          a = r(2298),
          Q = r(2362),
          s = r(7075),
          T = r(1204);
        function l(t) {
          return Q.SpeechRuleEngine.getInstance().evaluateNode(t);
        }
        function c(t) {
          return l(s.SemanticTree.fromNode(t).xml());
        }
        function u(t) {
          var e = c(t);
          return n.markup(e);
        }
        function p(t) {
          var e = h(t);
          return n.markup(e);
        }
        function h(t) {
          var e = s.SemanticTree.fromRoot(t),
            r = i.evalXPath('.//*[@id="' + t.id + '"]', e.xml());
          var n = r[0];
          return r.length > 1 && (n = d(t, r) || n), n ? Q.SpeechRuleEngine.getInstance().runInSetting({
            modality: "prefix",
            domain: "default",
            style: "default",
            strict: !0,
            speech: !0
          }, function () {
            return Q.SpeechRuleEngine.getInstance().evaluateNode(n);
          }) : [];
        }
        function d(t, e) {
          var r = e[0];
          if (!t.parent) return r;
          var n = [];
          for (; t;) n.push(t.id), t = t.parent;
          var o = function o(t, e) {
            for (; e.length && e.shift().toString() === t.getAttribute("id") && t.parentNode && t.parentNode.parentNode;) t = t.parentNode.parentNode;
            return !e.length;
          };
          for (var _t125, _r135 = 0; _t125 = e[_r135]; _r135++) if (o(_t125, n.slice())) return _t125;
          return r;
        }
        function f(t) {
          return t ? Q.SpeechRuleEngine.getInstance().runInSetting({
            modality: "summary",
            strict: !1,
            speech: !0
          }, function () {
            return Q.SpeechRuleEngine.getInstance().evaluateNode(t);
          }) : [];
        }
        e.computeSpeech = l, e.recomputeSpeech = c, e.computeMarkup = function (t) {
          var e = l(t);
          return n.markup(e);
        }, e.recomputeMarkup = u, e.addSpeech = function (t, e, r) {
          var i = o.querySelectorAllByAttrValue(r, "id", e.id.toString())[0],
            Q = i ? n.markup(l(i)) : u(e);
          t.setAttribute(a.Attribute.SPEECH, Q);
        }, e.addModality = function (t, e, r) {
          var n = u(e);
          t.setAttribute(r, n);
        }, e.addPrefix = function (t, e) {
          var r = p(e);
          r && t.setAttribute(a.Attribute.PREFIX, r);
        }, e.retrievePrefix = p, e.computePrefix_ = h, e.nodeAtPosition_ = d, e.connectMactions = function (t, e, r) {
          var n = o.querySelectorAll(e, "maction");
          for (var _e113, _i50 = 0; _e113 = n[_i50]; _i50++) {
            var _n242 = _e113.getAttribute("id"),
              _i51 = o.querySelectorAllByAttrValue(t, "id", _n242)[0];
            if (!_i51) continue;
            var _Q9 = _e113.childNodes[1],
              _s4 = _Q9.getAttribute(a.Attribute.ID);
            var _l3 = T.getBySemanticId(t, _s4);
            if (_l3 && "dummy" !== _l3.getAttribute(a.Attribute.TYPE)) continue;
            if (_l3 = _i51.childNodes[0], _l3.getAttribute("sre-highlighter-added")) continue;
            var _c2 = _Q9.getAttribute(a.Attribute.PARENT);
            _c2 && _l3.setAttribute(a.Attribute.PARENT, _c2), _l3.setAttribute(a.Attribute.TYPE, "dummy"), _l3.setAttribute(a.Attribute.ID, _s4);
            o.querySelectorAllByAttrValue(r, "id", _s4)[0].setAttribute("alternative", _s4);
          }
        }, e.connectAllMactions = function (t, e) {
          var r = o.querySelectorAll(t, "maction");
          for (var _t126, _n243 = 0; _t126 = r[_n243]; _n243++) {
            var _r136 = _t126.childNodes[1].getAttribute(a.Attribute.ID);
            o.querySelectorAllByAttrValue(e, "id", _r136)[0].setAttribute("alternative", _r136);
          }
        }, e.retrieveSummary = function (t) {
          var e = f(t);
          return n.markup(e);
        }, e.computeSummary_ = f;
      },
      597: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SummarySpeechGenerator = void 0;
        var n = r(6278),
          o = r(9543);
        var i = /*#__PURE__*/function (_n$AbstractSpeechGene3) {
          _inherits(i, _n$AbstractSpeechGene3);
          function i() {
            _classCallCheck(this, i);
            return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
          }
          _createClass(i, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              return o.connectAllMactions(e, this.getRebuilt().xml), this.generateSpeech(t, e);
            }
          }]);
          return i;
        }(n.AbstractSpeechGenerator);
        e.SummarySpeechGenerator = i;
      },
      4598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TreeSpeechGenerator = void 0;
        var n = r(2298),
          o = r(1204),
          i = r(6278),
          a = r(9543);
        var Q = /*#__PURE__*/function (_i$AbstractSpeechGene) {
          _inherits(Q, _i$AbstractSpeechGene);
          function Q() {
            _classCallCheck(this, Q);
            return _possibleConstructorReturn(this, _getPrototypeOf(Q).apply(this, arguments));
          }
          _createClass(Q, [{
            key: "getSpeech",
            value: function getSpeech(t, e) {
              var r = this.generateSpeech(t, e),
                i = this.getRebuilt().nodeDict;
              for (var _r137 in i) {
                var _Q10 = i[_r137],
                  s = o.getBySemanticId(e, _r137),
                  T = o.getBySemanticId(t, _r137);
                s && T && (this.modality && this.modality !== n.Attribute.SPEECH ? a.addModality(T, _Q10, this.modality) : a.addSpeech(T, _Q10, this.getRebuilt().xml), this.modality === n.Attribute.SPEECH && a.addPrefix(T, _Q10));
              }
              return r;
            }
          }]);
          return Q;
        }(i.AbstractSpeechGenerator);
        e.TreeSpeechGenerator = Q;
      },
      313: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.INTERVALS = e.makeLetter = e.numberRules = e.alphabetRules = e.getFont = e.makeInterval = e.generate = e.makeDomains_ = e.Domains_ = e.Base = e.Embellish = e.Font = void 0;
        var n = r(5897),
          o = r(7491),
          i = r(4356),
          a = r(2536),
          Q = r(2780);
        var s, T, l;
        function c() {
          var t = i.LOCALE.ALPHABETS,
            r = function r(t, e) {
              var r = {};
              return Object.keys(t).forEach(function (t) {
                return r[t] = !0;
              }), Object.keys(e).forEach(function (t) {
                return r[t] = !0;
              }), Object.keys(r);
            };
          e.Domains_.small = r(t.smallPrefix, t.letterTrans), e.Domains_.capital = r(t.capPrefix, t.letterTrans), e.Domains_.digit = r(t.digitPrefix, t.digitTrans);
        }
        function u(t) {
          var e = t.toString(16).toUpperCase();
          return e.length > 3 ? e : ("000" + e).slice(-4);
        }
        function p(_ref14, r) {
          var _ref15 = _slicedToArray(_ref14, 2),
            t = _ref15[0],
            e = _ref15[1];
          var n = parseInt(t, 16),
            o = parseInt(e, 16),
            i = [];
          for (var _t127 = n; _t127 <= o; _t127++) {
            var _e114 = u(_t127);
            !1 !== r[_e114] && (_e114 = r[_e114] || _e114, i.push(_e114));
          }
          return i;
        }
        function h(t) {
          var e = "normal" === t || "fullwidth" === t ? "" : i.LOCALE.MESSAGES.font[t] || i.LOCALE.MESSAGES.embellish[t] || "";
          return (0, a.localeFontCombiner)(e);
        }
        function d(t, r, n, o, a, Q) {
          var s = h(o);
          for (var _o51, _T2, _l4, _c3 = 0; _o51 = t[_c3], _T2 = r[_c3], _l4 = n[_c3]; _c3++) {
            var _t128 = Q ? i.LOCALE.ALPHABETS.capPrefix : i.LOCALE.ALPHABETS.smallPrefix,
              _r138 = Q ? e.Domains_.capital : e.Domains_.small;
            m(s.combiner, _o51, _T2, _l4, s.font, _t128, a, i.LOCALE.ALPHABETS.letterTrans, _r138);
          }
        }
        function f(t, r, n, o, a) {
          var Q = h(n);
          for (var _n244, _s5, _T3 = 0; _n244 = t[_T3], _s5 = r[_T3]; _T3++) {
            var _t129 = i.LOCALE.ALPHABETS.digitPrefix,
              _r139 = _T3 + a;
            m(Q.combiner, _n244, _s5, _r139, Q.font, _t129, o, i.LOCALE.ALPHABETS.digitTrans, e.Domains_.digit);
          }
        }
        function m(t, e, r, n, o, i, a, s, T) {
          for (var _l5, _c4 = 0; _l5 = T[_c4]; _c4++) {
            var _T4 = _l5 in s ? s[_l5] : s.default,
              _c5 = _l5 in i ? i[_l5] : i.default;
            Q.defineRule(e.toString(), _l5, "default", a, r, t(_T4(n), o, _c5));
          }
        }
        !function (t) {
          t.BOLD = "bold", t.BOLDFRAKTUR = "bold-fraktur", t.BOLDITALIC = "bold-italic", t.BOLDSCRIPT = "bold-script", t.DOUBLESTRUCK = "double-struck", t.FULLWIDTH = "fullwidth", t.FRAKTUR = "fraktur", t.ITALIC = "italic", t.MONOSPACE = "monospace", t.NORMAL = "normal", t.SCRIPT = "script", t.SANSSERIF = "sans-serif", t.SANSSERIFITALIC = "sans-serif-italic", t.SANSSERIFBOLD = "sans-serif-bold", t.SANSSERIFBOLDITALIC = "sans-serif-bold-italic";
        }(s = e.Font || (e.Font = {})), function (t) {
          t.SUPER = "super", t.SUB = "sub", t.CIRCLED = "circled", t.PARENTHESIZED = "parenthesized", t.PERIOD = "period", t.NEGATIVECIRCLED = "negative-circled", t.DOUBLECIRCLED = "double-circled", t.CIRCLEDSANSSERIF = "circled-sans-serif", t.NEGATIVECIRCLEDSANSSERIF = "negative-circled-sans-serif", t.COMMA = "comma", t.SQUARED = "squared", t.NEGATIVESQUARED = "negative-squared";
        }(T = e.Embellish || (e.Embellish = {})), function (t) {
          t.LATINCAP = "latinCap", t.LATINSMALL = "latinSmall", t.GREEKCAP = "greekCap", t.GREEKSMALL = "greekSmall", t.DIGIT = "digit";
        }(l = e.Base || (e.Base = {})), e.Domains_ = {
          small: ["default"],
          capital: ["default"],
          digit: ["default"]
        }, e.makeDomains_ = c, e.generate = function (t) {
          var r = n.default.getInstance().locale;
          n.default.getInstance().locale = t, o.setLocale(), Q.addSymbolRules({
            locale: t
          }), c();
          var a = e.INTERVALS;
          for (var _t130, _e115 = 0; _t130 = a[_e115]; _e115++) {
            var _e116 = p(_t130.interval, _t130.subst),
              _r140 = _e116.map(function (t) {
                return String.fromCodePoint(parseInt(t, 16));
              });
            if ("offset" in _t130) f(_e116, _r140, _t130.font, _t130.category, _t130.offset || 0);else {
              d(_e116, _r140, i.LOCALE.ALPHABETS[_t130.base], _t130.font, _t130.category, !!_t130.capital);
            }
          }
          n.default.getInstance().locale = r, o.setLocale();
        }, e.makeInterval = p, e.getFont = h, e.alphabetRules = d, e.numberRules = f, e.makeLetter = m, e.INTERVALS = [{
          interval: ["1D400", "1D419"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLD
        }, {
          interval: ["1D41A", "1D433"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLD
        }, {
          interval: ["1D56C", "1D585"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLDFRAKTUR
        }, {
          interval: ["1D586", "1D59F"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLDFRAKTUR
        }, {
          interval: ["1D468", "1D481"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLDITALIC
        }, {
          interval: ["1D482", "1D49B"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLDITALIC
        }, {
          interval: ["1D4D0", "1D4E9"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLDSCRIPT
        }, {
          interval: ["1D4EA", "1D503"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLDSCRIPT
        }, {
          interval: ["1D538", "1D551"],
          base: l.LATINCAP,
          subst: {
            "1D53A": "2102",
            "1D53F": "210D",
            "1D545": "2115",
            "1D547": "2119",
            "1D548": "211A",
            "1D549": "211D",
            "1D551": "2124"
          },
          capital: !0,
          category: "Lu",
          font: s.DOUBLESTRUCK
        }, {
          interval: ["1D552", "1D56B"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.DOUBLESTRUCK
        }, {
          interval: ["1D504", "1D51D"],
          base: l.LATINCAP,
          subst: {
            "1D506": "212D",
            "1D50B": "210C",
            "1D50C": "2111",
            "1D515": "211C",
            "1D51D": "2128"
          },
          capital: !0,
          category: "Lu",
          font: s.FRAKTUR
        }, {
          interval: ["1D51E", "1D537"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.FRAKTUR
        }, {
          interval: ["FF21", "FF3A"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.FULLWIDTH
        }, {
          interval: ["FF41", "FF5A"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.FULLWIDTH
        }, {
          interval: ["1D434", "1D44D"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.ITALIC
        }, {
          interval: ["1D44E", "1D467"],
          base: l.LATINSMALL,
          subst: {
            "1D455": "210E"
          },
          capital: !1,
          category: "Ll",
          font: s.ITALIC
        }, {
          interval: ["1D670", "1D689"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.MONOSPACE
        }, {
          interval: ["1D68A", "1D6A3"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.MONOSPACE
        }, {
          interval: ["0041", "005A"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.NORMAL
        }, {
          interval: ["0061", "007A"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.NORMAL
        }, {
          interval: ["1D49C", "1D4B5"],
          base: l.LATINCAP,
          subst: {
            "1D49D": "212C",
            "1D4A0": "2130",
            "1D4A1": "2131",
            "1D4A3": "210B",
            "1D4A4": "2110",
            "1D4A7": "2112",
            "1D4A8": "2133",
            "1D4AD": "211B"
          },
          capital: !0,
          category: "Lu",
          font: s.SCRIPT
        }, {
          interval: ["1D4B6", "1D4CF"],
          base: l.LATINSMALL,
          subst: {
            "1D4BA": "212F",
            "1D4BC": "210A",
            "1D4C4": "2134"
          },
          capital: !1,
          category: "Ll",
          font: s.SCRIPT
        }, {
          interval: ["1D5A0", "1D5B9"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIF
        }, {
          interval: ["1D5BA", "1D5D3"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIF
        }, {
          interval: ["1D608", "1D621"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIFITALIC
        }, {
          interval: ["1D622", "1D63B"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIFITALIC
        }, {
          interval: ["1D5D4", "1D5ED"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIFBOLD
        }, {
          interval: ["1D5EE", "1D607"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIFBOLD
        }, {
          interval: ["1D63C", "1D655"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIFBOLDITALIC
        }, {
          interval: ["1D656", "1D66F"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIFBOLDITALIC
        }, {
          interval: ["0391", "03A9"],
          base: l.GREEKCAP,
          subst: {
            "03A2": "03F4"
          },
          capital: !0,
          category: "Lu",
          font: s.NORMAL
        }, {
          interval: ["03B0", "03D0"],
          base: l.GREEKSMALL,
          subst: {
            "03B0": "2207",
            "03CA": "2202",
            "03CB": "03F5",
            "03CC": "03D1",
            "03CD": "03F0",
            "03CE": "03D5",
            "03CF": "03F1",
            "03D0": "03D6"
          },
          capital: !1,
          category: "Ll",
          font: s.NORMAL
        }, {
          interval: ["1D6A8", "1D6C0"],
          base: l.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLD
        }, {
          interval: ["1D6C1", "1D6E1"],
          base: l.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLD
        }, {
          interval: ["1D6E2", "1D6FA"],
          base: l.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.ITALIC
        }, {
          interval: ["1D6FB", "1D71B"],
          base: l.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.ITALIC
        }, {
          interval: ["1D71C", "1D734"],
          base: l.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.BOLDITALIC
        }, {
          interval: ["1D735", "1D755"],
          base: l.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.BOLDITALIC
        }, {
          interval: ["1D756", "1D76E"],
          base: l.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIFBOLD
        }, {
          interval: ["1D76F", "1D78F"],
          base: l.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIFBOLD
        }, {
          interval: ["1D790", "1D7A8"],
          base: l.GREEKCAP,
          subst: {},
          capital: !0,
          category: "Lu",
          font: s.SANSSERIFBOLDITALIC
        }, {
          interval: ["1D7A9", "1D7C9"],
          base: l.GREEKSMALL,
          subst: {},
          capital: !1,
          category: "Ll",
          font: s.SANSSERIFBOLDITALIC
        }, {
          interval: ["0030", "0039"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.NORMAL
        }, {
          interval: ["2070", "2079"],
          base: l.DIGIT,
          subst: {
            2071: "00B9",
            2072: "00B2",
            2073: "00B3"
          },
          offset: 0,
          category: "No",
          font: T.SUPER
        }, {
          interval: ["2080", "2089"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "No",
          font: T.SUB
        }, {
          interval: ["245F", "2473"],
          base: l.DIGIT,
          subst: {
            "245F": "24EA"
          },
          offset: 0,
          category: "No",
          font: T.CIRCLED
        }, {
          interval: ["3251", "325F"],
          base: l.DIGIT,
          subst: {},
          offset: 21,
          category: "No",
          font: T.CIRCLED
        }, {
          interval: ["32B1", "32BF"],
          base: l.DIGIT,
          subst: {},
          offset: 36,
          category: "No",
          font: T.CIRCLED
        }, {
          interval: ["2474", "2487"],
          base: l.DIGIT,
          subst: {},
          offset: 1,
          category: "No",
          font: T.PARENTHESIZED
        }, {
          interval: ["2487", "249B"],
          base: l.DIGIT,
          subst: {
            2487: "1F100"
          },
          offset: 0,
          category: "No",
          font: T.PERIOD
        }, {
          interval: ["2775", "277F"],
          base: l.DIGIT,
          subst: {
            2775: "24FF"
          },
          offset: 0,
          category: "No",
          font: T.NEGATIVECIRCLED
        }, {
          interval: ["24EB", "24F4"],
          base: l.DIGIT,
          subst: {},
          offset: 11,
          category: "No",
          font: T.NEGATIVECIRCLED
        }, {
          interval: ["24F5", "24FE"],
          base: l.DIGIT,
          subst: {},
          offset: 1,
          category: "No",
          font: T.DOUBLECIRCLED
        }, {
          interval: ["277F", "2789"],
          base: l.DIGIT,
          subst: {
            "277F": "1F10B"
          },
          offset: 0,
          category: "No",
          font: T.CIRCLEDSANSSERIF
        }, {
          interval: ["2789", "2793"],
          base: l.DIGIT,
          subst: {
            2789: "1F10C"
          },
          offset: 0,
          category: "No",
          font: T.NEGATIVECIRCLEDSANSSERIF
        }, {
          interval: ["FF10", "FF19"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.FULLWIDTH
        }, {
          interval: ["1D7CE", "1D7D7"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.BOLD
        }, {
          interval: ["1D7D8", "1D7E1"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.DOUBLESTRUCK
        }, {
          interval: ["1D7E2", "1D7EB"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.SANSSERIF
        }, {
          interval: ["1D7EC", "1D7F5"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.SANSSERIFBOLD
        }, {
          interval: ["1D7F6", "1D7FF"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "Nd",
          font: s.MONOSPACE
        }, {
          interval: ["1F101", "1F10A"],
          base: l.DIGIT,
          subst: {},
          offset: 0,
          category: "No",
          font: T.COMMA
        }, {
          interval: ["24B6", "24CF"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: T.CIRCLED
        }, {
          interval: ["24D0", "24E9"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "So",
          font: T.CIRCLED
        }, {
          interval: ["1F110", "1F129"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: T.PARENTHESIZED
        }, {
          interval: ["249C", "24B5"],
          base: l.LATINSMALL,
          subst: {},
          capital: !1,
          category: "So",
          font: T.PARENTHESIZED
        }, {
          interval: ["1F130", "1F149"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: T.SQUARED
        }, {
          interval: ["1F170", "1F189"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: T.NEGATIVESQUARED
        }, {
          interval: ["1F150", "1F169"],
          base: l.LATINCAP,
          subst: {},
          capital: !0,
          category: "So",
          font: T.NEGATIVECIRCLED
        }];
      },
      8504: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Parser = e.Comparator = e.ClearspeakPreferences = void 0;
        var n = r(5897),
          o = r(4440),
          i = r(1676),
          a = r(1676),
          Q = r(2780),
          s = r(2362);
        var T = /*#__PURE__*/function (_i$DynamicCstr) {
          _inherits(T, _i$DynamicCstr);
          function T(t, e) {
            var _this48;
            _classCallCheck(this, T);
            _this48 = _possibleConstructorReturn(this, _getPrototypeOf(T).call(this, t)), _this48.preference = e;
            return _this48;
          }
          _createClass(T, [{
            key: "equal",
            value: function equal(t) {
              if (!_superPropGet(T, "equal", this, 3)([t])) return !1;
              var e = Object.keys(this.preference),
                r = t.preference;
              if (e.length !== Object.keys(r).length) return !1;
              for (var _t131, _n245 = 0; _t131 = e[_n245]; _n245++) if (this.preference[_t131] !== r[_t131]) return !1;
              return !0;
            }
          }], [{
            key: "comparator",
            value: function comparator() {
              return new c(n.default.getInstance().dynamicCstr, a.DynamicProperties.createProp([i.DynamicCstr.DEFAULT_VALUES[a.Axis.LOCALE]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.MODALITY]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.DOMAIN]], [i.DynamicCstr.DEFAULT_VALUES[a.Axis.STYLE]]));
            }
          }, {
            key: "fromPreference",
            value: function fromPreference(t) {
              var e = t.split(":"),
                r = {},
                n = l.getProperties(),
                o = Object.keys(n);
              for (var _t132, _i52 = 0; _t132 = e[_i52]; _i52++) {
                var _e117 = _t132.split("_");
                if (-1 === o.indexOf(_e117[0])) continue;
                var _i53 = _e117[1];
                _i53 && _i53 !== T.AUTO && -1 !== n[_e117[0]].indexOf(_i53) && (r[_e117[0]] = _e117[1]);
              }
              return r;
            }
          }, {
            key: "toPreference",
            value: function toPreference(t) {
              var e = Object.keys(t),
                r = [];
              for (var _n246 = 0; _n246 < e.length; _n246++) r.push(e[_n246] + "_" + t[e[_n246]]);
              return r.length ? r.join(":") : i.DynamicCstr.DEFAULT_VALUE;
            }
          }, {
            key: "getLocalePreferences",
            value: function getLocalePreferences(t) {
              var e = t || Q.enumerate(s.SpeechRuleEngine.getInstance().enumerate());
              return T.getLocalePreferences_(e);
            }
          }, {
            key: "smartPreferences",
            value: function smartPreferences(t, e) {
              var r = T.getLocalePreferences()[e];
              if (!r) return [];
              var n = t.explorers.speech,
                i = T.relevantPreferences(n.walker.getFocus().getSemanticPrimary()),
                a = o.DOMAIN_TO_STYLES.clearspeak;
              return [{
                type: "radio",
                content: "No Preferences",
                id: "clearspeak-default",
                variable: "speechRules"
              }, {
                type: "radio",
                content: "Current Preferences",
                id: "clearspeak-" + a,
                variable: "speechRules"
              }, {
                type: "rule"
              }, {
                type: "label",
                content: "Preferences for " + i
              }, {
                type: "rule"
              }].concat(r[i].map(function (t) {
                var e = t.split("_");
                return {
                  type: "radio",
                  content: e[1],
                  id: "clearspeak-" + T.addPreference(a, e[0], e[1]),
                  variable: "speechRules"
                };
              }));
            }
          }, {
            key: "relevantPreferences",
            value: function relevantPreferences(t) {
              var e = h[t.type];
              return e && (e[t.role] || e[""]) || "ImpliedTimes";
            }
          }, {
            key: "findPreference",
            value: function findPreference(t, e) {
              if ("default" === t) return T.AUTO;
              return T.fromPreference(t)[e] || T.AUTO;
            }
          }, {
            key: "addPreference",
            value: function addPreference(t, e, r) {
              if ("default" === t) return e + "_" + r;
              var n = T.fromPreference(t);
              return n[e] = r, T.toPreference(n);
            }
          }, {
            key: "getLocalePreferences_",
            value: function getLocalePreferences_(t) {
              var e = {};
              for (var _r141 in t) {
                if (!t[_r141].speech || !t[_r141].speech.clearspeak) continue;
                var _n247 = Object.keys(t[_r141].speech.clearspeak),
                  _o52 = e[_r141] = {};
                for (var _t133 in l.getProperties()) {
                  var _e118 = l.getProperties()[_t133],
                    _r142 = [_t133 + "_Auto"];
                  if (_e118) {
                    var _iterator21 = _createForOfIteratorHelper(_e118),
                      _step21;
                    try {
                      for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                        var _o53 = _step21.value;
                        -1 !== _n247.indexOf(_t133 + "_" + _o53) && _r142.push(_t133 + "_" + _o53);
                      }
                    } catch (err) {
                      _iterator21.e(err);
                    } finally {
                      _iterator21.f();
                    }
                  }
                  _o52[_t133] = _r142;
                }
              }
              return e;
            }
          }]);
          return T;
        }(i.DynamicCstr);
        e.ClearspeakPreferences = T, T.AUTO = "Auto";
        var l = new a.DynamicProperties({
          AbsoluteValue: ["Auto", "AbsEnd", "Cardinality", "Determinant"],
          Bar: ["Auto", "Conjugate"],
          Caps: ["Auto", "SayCaps"],
          CombinationPermutation: ["Auto", "ChoosePermute"],
          Currency: ["Auto", "Position", "Prefix"],
          Ellipses: ["Auto", "AndSoOn"],
          Enclosed: ["Auto", "EndEnclose"],
          Exponent: ["Auto", "AfterPower", "Ordinal", "OrdinalPower", "Exponent"],
          Fraction: ["Auto", "EndFrac", "FracOver", "General", "GeneralEndFrac", "Ordinal", "Over", "OverEndFrac", "Per"],
          Functions: ["Auto", "None", "Reciprocal"],
          ImpliedTimes: ["Auto", "MoreImpliedTimes", "None"],
          Log: ["Auto", "LnAsNaturalLog"],
          Matrix: ["Auto", "Combinatoric", "EndMatrix", "EndVector", "SilentColNum", "SpeakColNum", "Vector"],
          MultiLineLabel: ["Auto", "Case", "Constraint", "Equation", "Line", "None", "Row", "Step"],
          MultiLineOverview: ["Auto", "None"],
          MultiLinePausesBetweenColumns: ["Auto", "Long", "Short"],
          MultsymbolDot: ["Auto", "Dot"],
          MultsymbolX: ["Auto", "By", "Cross"],
          Paren: ["Auto", "CoordPoint", "Interval", "Silent", "Speak", "SpeakNestingLevel"],
          Prime: ["Auto", "Angle", "Length"],
          Roots: ["Auto", "PosNegSqRoot", "PosNegSqRootEnd", "RootEnd"],
          SetMemberSymbol: ["Auto", "Belongs", "Element", "Member", "In"],
          Sets: ["Auto", "SilentBracket", "woAll"],
          TriangleSymbol: ["Auto", "Delta"],
          Trig: ["Auto", "ArcTrig", "TrigInverse", "Reciprocal"],
          VerticalLine: ["Auto", "Divides", "Given", "SuchThat"]
        });
        var c = /*#__PURE__*/function (_a$DefaultComparator) {
          _inherits(c, _a$DefaultComparator);
          function c(t, e) {
            var _this49;
            _classCallCheck(this, c);
            _this49 = _possibleConstructorReturn(this, _getPrototypeOf(c).call(this, t, e)), _this49.preference = t instanceof T ? t.preference : {};
            return _this49;
          }
          _createClass(c, [{
            key: "match",
            value: function match(t) {
              if (!(t instanceof T)) return _superPropGet(c, "match", this, 3)([t]);
              if ("default" === t.getComponents()[a.Axis.STYLE]) return !0;
              var e = Object.keys(t.preference);
              for (var _r143, _n248 = 0; _r143 = e[_n248]; _n248++) if (this.preference[_r143] !== t.preference[_r143]) return !1;
              return !0;
            }
          }, {
            key: "compare",
            value: function compare(t, e) {
              var r = _superPropGet(c, "compare", this, 3)([t, e]);
              if (0 !== r) return r;
              var n = t instanceof T,
                o = e instanceof T;
              if (!n && o) return 1;
              if (n && !o) return -1;
              if (!n && !o) return 0;
              var i = Object.keys(t.preference).length,
                a = Object.keys(e.preference).length;
              return i > a ? -1 : i < a ? 1 : 0;
            }
          }]);
          return c;
        }(a.DefaultComparator);
        e.Comparator = c;
        var u = /*#__PURE__*/function (_a$DynamicCstrParser) {
          _inherits(u, _a$DynamicCstrParser);
          function u() {
            _classCallCheck(this, u);
            return _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, [a.Axis.LOCALE, a.Axis.MODALITY, a.Axis.DOMAIN, a.Axis.STYLE]));
          }
          _createClass(u, [{
            key: "parse",
            value: function parse(t) {
              var e = _superPropGet(u, "parse", this, 3)([t]);
              var r = e.getValue(a.Axis.STYLE);
              var n = e.getValue(a.Axis.LOCALE),
                o = e.getValue(a.Axis.MODALITY);
              var Q = {};
              return r !== i.DynamicCstr.DEFAULT_VALUE && (Q = this.fromPreference(r), r = this.toPreference(Q)), new T({
                locale: n,
                modality: o,
                domain: "clearspeak",
                style: r
              }, Q);
            }
          }, {
            key: "fromPreference",
            value: function fromPreference(t) {
              return T.fromPreference(t);
            }
          }, {
            key: "toPreference",
            value: function toPreference(t) {
              return T.toPreference(t);
            }
          }]);
          return u;
        }(a.DynamicCstrParser);
        e.Parser = u;
        var p = [["AbsoluteValue", "fenced", "neutral", "metric"], ["Bar", "overscore", "overaccent"], ["Caps", "identifier", "latinletter"], ["CombinationPermutation", "appl", "unknown"], ["Ellipses", "punctuation", "ellipsis"], ["Exponent", "superscript", ""], ["Fraction", "fraction", ""], ["Functions", "appl", "simple function"], ["ImpliedTimes", "operator", "implicit"], ["Log", "appl", "prefix function"], ["Matrix", "matrix", ""], ["Matrix", "vector", ""], ["MultiLineLabel", "multiline", "label"], ["MultiLineOverview", "multiline", "table"], ["MultiLinePausesBetweenColumns", "multiline", "table"], ["MultiLineLabel", "table", "label"], ["MultiLineOverview", "table", "table"], ["MultiLinePausesBetweenColumns", "table", "table"], ["MultiLineLabel", "cases", "label"], ["MultiLineOverview", "cases", "table"], ["MultiLinePausesBetweenColumns", "cases", "table"], ["MultsymbolDot", "operator", "multiplication"], ["MultsymbolX", "operator", "multiplication"], ["Paren", "fenced", "leftright"], ["Prime", "superscript", "prime"], ["Roots", "root", ""], ["Roots", "sqrt", ""], ["SetMemberSymbol", "relation", "element"], ["Sets", "fenced", "set extended"], ["TriangleSymbol", "identifier", "greekletter"], ["Trig", "appl", "prefix function"], ["VerticalLine", "punctuated", "vbar"]],
          h = function () {
            var t = {};
            for (var _e119, _r144 = 0; _e119 = p[_r144]; _r144++) {
              var _r145 = _e119[0];
              var _n249 = t[_e119[1]];
              _n249 || (_n249 = {}, t[_e119[1]] = _n249), _n249[_e119[2]] = _r145;
            }
            return t;
          }();
        n.default.getInstance().comparators.clearspeak = T.comparator, n.default.getInstance().parsers.clearspeak = new u();
      },
      5425: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ClearspeakRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(9912),
          a = r(1378),
          Q = r(8437),
          s = r(7283);
        e.ClearspeakRules = function () {
          s.addStore(n.DynamicCstr.BASE_LOCALE + ".speech.clearspeak", "", {
            CTFpauseSeparator: o.pauseSeparator,
            CTFnodeCounter: i.nodeCounter,
            CTFcontentIterator: o.contentIterator,
            CSFvulgarFraction: Q.vulgarFraction,
            CQFvulgarFractionSmall: i.isSmallVulgarFraction,
            CQFcellsSimple: i.allCellsSimple,
            CSFordinalExponent: i.ordinalExponent,
            CSFwordOrdinal: i.wordOrdinal,
            CQFmatchingFences: i.matchingFences,
            CSFnestingDepth: i.nestingDepth,
            CQFfencedArguments: i.fencedArguments,
            CQFsimpleArguments: i.simpleArguments,
            CQFspaceoutNumber: a.spaceoutNumber
          });
        };
      },
      9912: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.wordOrdinal = e.layoutFactor_ = e.fencedFactor_ = e.simpleFactor_ = e.simpleArguments = e.fencedArguments = e.insertNesting = e.matchingFences = e.nestingDepth = e.NESTING_DEPTH = e.ordinalExponent = e.allTextLastContent_ = e.isUnitExpression = e.isSmallVulgarFraction = e.allCellsSimple = e.allIndices_ = e.isInteger_ = e.simpleCell_ = e.simpleNode = e.hasPreference = e.isSimpleFraction_ = e.isSimpleNumber_ = e.isNumber_ = e.isLetter_ = e.isSimple_ = e.isSimpleLetters_ = e.isSimpleDegree_ = e.isSimpleNegative_ = e.isSimpleFunction_ = e.isSimpleExpression = e.nodeCounter = void 0;
        var n = r(5740),
          o = r(5897),
          i = r(5274),
          a = r(4356),
          Q = r(4977),
          s = r(2105),
          T = r(365),
          l = r(7630),
          c = r(9265),
          u = r(3588);
        function p(t) {
          return v(t) || m(t) || f(t) || d(t) || h(t);
        }
        function h(t) {
          return "appl" === t.type && ("prefix function" === t.childNodes[0].role || "simple function" === t.childNodes[0].role) && (L(t.childNodes[1]) || "fenced" === t.childNodes[1].type && L(t.childNodes[1].childNodes[0]));
        }
        function d(t) {
          return "prefixop" === t.type && "negative" === t.role && L(t.childNodes[0]) && "prefixop" !== t.childNodes[0].type && "appl" !== t.childNodes[0].type && "punctuated" !== t.childNodes[0].type;
        }
        function f(t) {
          return "punctuated" === t.type && "endpunct" === t.role && 2 === t.childNodes.length && "degree" === t.childNodes[1].role && (y(t.childNodes[0]) || g(t.childNodes[0]) || "prefixop" === t.childNodes[0].type && "negative" === t.childNodes[0].role && (y(t.childNodes[0].childNodes[0]) || g(t.childNodes[0].childNodes[0])));
        }
        function m(t) {
          return y(t) || "infixop" === t.type && "implicit" === t.role && (2 === t.childNodes.length && (y(t.childNodes[0]) || v(t.childNodes[0])) && y(t.childNodes[1]) || 3 === t.childNodes.length && v(t.childNodes[0]) && y(t.childNodes[1]) && y(t.childNodes[2]));
        }
        function L(t) {
          return t.hasAnnotation("clearspeak", "simple");
        }
        function y(t) {
          return "identifier" === t.type && ("latinletter" === t.role || "greekletter" === t.role || "otherletter" === t.role || "simple function" === t.role);
        }
        function g(t) {
          return "number" === t.type && ("integer" === t.role || "float" === t.role);
        }
        function v(t) {
          return g(t) || b(t);
        }
        function b(t) {
          if (H("Fraction_Over") || H("Fraction_FracOver")) return !1;
          if ("fraction" !== t.type || "vulgar" !== t.role) return !1;
          if (H("Fraction_Ordinal")) return !0;
          var e = parseInt(t.childNodes[0].textContent, 10),
            r = parseInt(t.childNodes[1].textContent, 10);
          return e > 0 && e < 20 && r > 0 && r < 11;
        }
        function H(t) {
          return o.default.getInstance().style === t;
        }
        function _(t) {
          if (!t.hasAttribute("annotation")) return !1;
          var e = t.getAttribute("annotation");
          return !!/clearspeak:simple$|clearspeak:simple;/.exec(e);
        }
        function M(t) {
          if (_(t)) return !0;
          if ("subscript" !== t.tagName) return !1;
          var e = t.childNodes[0].childNodes,
            r = e[1];
          return "identifier" === e[0].tagName && (x(r) || "infixop" === r.tagName && r.hasAttribute("role") && "implicit" === r.getAttribute("role") && O(r));
        }
        function x(t) {
          return "number" === t.tagName && t.hasAttribute("role") && "integer" === t.getAttribute("role");
        }
        function O(t) {
          return i.evalXPath("children/*", t).every(function (t) {
            return x(t) || "identifier" === t.tagName;
          });
        }
        function S(t) {
          return "text" === t.type || "punctuated" === t.type && "text" === t.role && g(t.childNodes[0]) && V(t.childNodes.slice(1)) || "identifier" === t.type && "unit" === t.role || "infixop" === t.type && ("implicit" === t.role || "unit" === t.role);
        }
        function V(t) {
          for (var _e120 = 0; _e120 < t.length - 1; _e120++) if ("text" !== t[_e120].type || "" !== t[_e120].textContent) return !1;
          return "text" === t[t.length - 1].type;
        }
        function E(t, e) {
          if (!e || !t) return t;
          var r = t.match(/^(open|close) /);
          return r ? r[0] + e + " " + t.substring(r[0].length) : e + " " + t;
        }
        function A(t) {
          return !!t && ("number" === t.tagName || "identifier" === t.tagName || "function" === t.tagName || "appl" === t.tagName || "fraction" === t.tagName);
        }
        function C(t) {
          return t && ("fenced" === t.tagName || t.hasAttribute("role") && "leftright" === t.getAttribute("role") || w(t));
        }
        function w(t) {
          return !!t && ("matrix" === t.tagName || "vector" === t.tagName);
        }
        e.nodeCounter = function (t, e) {
          var r = e.split("-"),
            n = T.nodeCounter(t, r[0] || ""),
            o = r[1] || "",
            i = r[2] || "";
          var a = !0;
          return function () {
            var t = n();
            return a ? (a = !1, i + t + o) : t + o;
          };
        }, e.isSimpleExpression = p, e.isSimpleFunction_ = h, e.isSimpleNegative_ = d, e.isSimpleDegree_ = f, e.isSimpleLetters_ = m, e.isSimple_ = L, e.isLetter_ = y, e.isNumber_ = g, e.isSimpleNumber_ = v, e.isSimpleFraction_ = b, e.hasPreference = H, (0, l.register)(new c.SemanticAnnotator("clearspeak", "simple", function (t) {
          return p(t) ? "simple" : "";
        })), e.simpleNode = _, e.simpleCell_ = M, e.isInteger_ = x, e.allIndices_ = O, e.allCellsSimple = function (t) {
          var e = "matrix" === t.tagName ? "children/row/children/cell/children/*" : "children/line/children/*";
          return i.evalXPath(e, t).every(M) ? [t] : [];
        }, e.isSmallVulgarFraction = function (t) {
          return (0, Q.vulgarFractionSmall)(t, 20, 11) ? [t] : [];
        }, e.isUnitExpression = S, e.allTextLastContent_ = V, (0, l.register)(new c.SemanticAnnotator("clearspeak", "unit", function (t) {
          return S(t) ? "unit" : "";
        })), e.ordinalExponent = function (t) {
          var e = parseInt(t.textContent, 10);
          return isNaN(e) ? t.textContent : e > 10 ? a.LOCALE.NUMBERS.numericOrdinal(e) : a.LOCALE.NUMBERS.wordOrdinal(e);
        }, e.NESTING_DEPTH = null, e.nestingDepth = function (t) {
          var r = 0;
          var n = t.textContent,
            o = "open" === t.getAttribute("role") ? 0 : 1;
          var i = t.parentNode;
          for (; i;) "fenced" === i.tagName && i.childNodes[0].childNodes[o].textContent === n && r++, i = i.parentNode;
          return e.NESTING_DEPTH = r > 1 ? a.LOCALE.NUMBERS.wordOrdinal(r) : "", e.NESTING_DEPTH;
        }, e.matchingFences = function (t) {
          var e = t.previousSibling;
          var r, n;
          return e ? (r = e, n = t) : (r = t, n = t.nextSibling), n && (0, u.isMatchingFence)(r.textContent, n.textContent) ? [t] : [];
        }, e.insertNesting = E, s.Grammar.getInstance().setCorrection("insertNesting", E), e.fencedArguments = function (t) {
          var e = n.toArray(t.parentNode.childNodes),
            r = i.evalXPath("../../children/*", t),
            o = e.indexOf(t);
          return C(r[o]) || C(r[o + 1]) ? [t] : [];
        }, e.simpleArguments = function (t) {
          var e = n.toArray(t.parentNode.childNodes),
            r = i.evalXPath("../../children/*", t),
            o = e.indexOf(t);
          return A(r[o]) && r[o + 1] && (A(r[o + 1]) || "root" === r[o + 1].tagName || "sqrt" === r[o + 1].tagName || "superscript" === r[o + 1].tagName && r[o + 1].childNodes[0].childNodes[0] && ("number" === r[o + 1].childNodes[0].childNodes[0].tagName || "identifier" === r[o + 1].childNodes[0].childNodes[0].tagName) && ("2" === r[o + 1].childNodes[0].childNodes[1].textContent || "3" === r[o + 1].childNodes[0].childNodes[1].textContent)) ? [t] : [];
        }, e.simpleFactor_ = A, e.fencedFactor_ = C, e.layoutFactor_ = w, e.wordOrdinal = function (t) {
          return a.LOCALE.NUMBERS.wordOrdinal(parseInt(t.textContent, 10));
        };
      },
      6141: function _(t, e, r) {
        var n = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (o, i) {
            function a(t) {
              try {
                s(n.next(t));
              } catch (t) {
                i(t);
              }
            }
            function Q(t) {
              try {
                s(n.throw(t));
              } catch (t) {
                i(t);
              }
            }
            function s(t) {
              var e;
              t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
                t(e);
              })).then(a, Q);
            }
            s((n = n.apply(t, e || [])).next());
          });
        };
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.loadAjax = e.loadFileSync = e.loadFile = e.parseMaps = e.retrieveFiles = e.standardLoader = e.loadLocale = e.store = void 0;
        var o = r(2139),
          i = r(5897),
          a = r(4440),
          Q = r(7248),
          s = r(2315),
          T = r(1676),
          l = r(2780),
          c = r(2362),
          u = r(7491),
          p = r(313);
        e.store = l;
        var h = {
          functions: l.addFunctionRules,
          symbols: l.addSymbolRules,
          units: l.addUnitRules,
          si: l.setSiPrefixes
        };
        var d = !1;
        function f() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i.default.getInstance().locale;
          i.EnginePromise.loaded[t] || (i.EnginePromise.loaded[t] = [!1, !1], function (t) {
            if (i.default.getInstance().isIE && i.default.getInstance().mode === a.Mode.HTTP) return void v(t);
            L(t);
          }(t));
        }
        function m() {
          switch (i.default.getInstance().mode) {
            case a.Mode.ASYNC:
              return b;
            case a.Mode.HTTP:
              return _;
            case a.Mode.SYNC:
            default:
              return H;
          }
        }
        function L(t) {
          var e = i.default.getInstance().customLoader ? i.default.getInstance().customLoader : m(),
            r = new Promise(function (r) {
              e(t).then(function (e) {
                y(e), i.EnginePromise.loaded[t] = [!0, !0], r(t);
              }, function (e) {
                i.EnginePromise.loaded[t] = [!0, !1], console.error("Unable to load locale: ".concat(t)), i.default.getInstance().locale = i.default.getInstance().defaultLocale, r(t);
              });
            });
          i.EnginePromise.promises[t] = r;
        }
        function y(t) {
          g(JSON.parse(t));
        }
        function g(t, e) {
          var r = !0;
          for (var _n250, _o54 = 0; _n250 = Object.keys(t)[_o54]; _o54++) {
            var _o55 = _n250.split("/");
            e && e !== _o55[0] || ("rules" === _o55[1] ? c.SpeechRuleEngine.getInstance().addStore(t[_n250]) : "messages" === _o55[1] ? (0, u.completeLocale)(t[_n250]) : (r && (p.generate(_o55[0]), r = !1), t[_n250].forEach(h[_o55[1]])));
          }
        }
        function v(t, e) {
          var r = e || 1;
          o.mapsForIE ? g(o.mapsForIE, t) : r <= 5 && setTimeout(function () {
            return v(t, r++);
          }.bind(this), 300);
        }
        function b(t) {
          var e = Q.localePath(t);
          return new Promise(function (t, r) {
            s.default.fs.readFile(e, "utf8", function (e, n) {
              if (e) return r(e);
              t(n);
            });
          });
        }
        function H(t) {
          var e = Q.localePath(t);
          return new Promise(function (t, r) {
            var n = "{}";
            try {
              n = s.default.fs.readFileSync(e, "utf8");
            } catch (t) {
              return r(t);
            }
            t(n);
          });
        }
        function _(t) {
          var e = Q.localePath(t),
            r = new XMLHttpRequest();
          return new Promise(function (t, n) {
            r.onreadystatechange = function () {
              if (4 === r.readyState) {
                var _e121 = r.status;
                0 === _e121 || _e121 >= 200 && _e121 < 400 ? t(r.responseText) : n(_e121);
              }
            }, r.open("GET", e, !0), r.send();
          });
        }
        e.loadLocale = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i.default.getInstance().locale;
          return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
            var _this50 = this;
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", (d || (f(T.DynamicCstr.BASE_LOCALE), d = !0), i.EnginePromise.promises[T.DynamicCstr.BASE_LOCALE].then(function () {
                    return n(_this50, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      var _this51 = this;
                      var e;
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) switch (_context6.prev = _context6.next) {
                          case 0:
                            e = i.default.getInstance().defaultLocale;
                            return _context6.abrupt("return", e ? (f(e), i.EnginePromise.promises[e].then(function () {
                              return n(_this51, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                  while (1) switch (_context5.prev = _context5.next) {
                                    case 0:
                                      return _context5.abrupt("return", (f(t), i.EnginePromise.promises[t]));
                                    case 1:
                                    case "end":
                                      return _context5.stop();
                                  }
                                }, _callee5);
                              }));
                            })) : (f(t), i.EnginePromise.promises[t]));
                          case 2:
                          case "end":
                            return _context6.stop();
                        }
                      }, _callee6);
                    }));
                  })));
                case 1:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
        }, e.standardLoader = m, e.retrieveFiles = L, e.parseMaps = y, e.loadFile = b, e.loadFileSync = H, e.loadAjax = _;
      },
      7088: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.leftSubscriptBrief = e.leftSuperscriptBrief = e.leftSubscriptVerbose = e.leftSuperscriptVerbose = e.baselineBrief = e.baselineVerbose = void 0;
        var n = r(1378);
        e.baselineVerbose = function (t) {
          return n.baselineVerbose(t).replace(/-$/, "");
        }, e.baselineBrief = function (t) {
          return n.baselineBrief(t).replace(/-$/, "");
        }, e.leftSuperscriptVerbose = function (t) {
          return n.superscriptVerbose(t).replace(/^exposant/, "exposant gauche");
        }, e.leftSubscriptVerbose = function (t) {
          return n.subscriptVerbose(t).replace(/^indice/, "indice gauche");
        }, e.leftSuperscriptBrief = function (t) {
          return n.superscriptBrief(t).replace(/^sup/, "sup gauche");
        }, e.leftSubscriptBrief = function (t) {
          return n.subscriptBrief(t).replace(/^sub/, "sub gauche");
        };
      },
      9577: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.MathspeakRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(7088),
          a = r(1378),
          Q = r(8437),
          s = r(7283),
          T = r(7598);
        e.MathspeakRules = function () {
          s.addStore(n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", "", {
            CQFspaceoutNumber: a.spaceoutNumber,
            CQFspaceoutIdentifier: a.spaceoutIdentifier,
            CSFspaceoutText: a.spaceoutText,
            CSFopenFracVerbose: a.openingFractionVerbose,
            CSFcloseFracVerbose: a.closingFractionVerbose,
            CSFoverFracVerbose: a.overFractionVerbose,
            CSFopenFracBrief: a.openingFractionBrief,
            CSFcloseFracBrief: a.closingFractionBrief,
            CSFopenFracSbrief: a.openingFractionSbrief,
            CSFcloseFracSbrief: a.closingFractionSbrief,
            CSFoverFracSbrief: a.overFractionSbrief,
            CSFvulgarFraction: Q.vulgarFraction,
            CQFvulgarFractionSmall: a.isSmallVulgarFraction,
            CSFopenRadicalVerbose: a.openingRadicalVerbose,
            CSFcloseRadicalVerbose: a.closingRadicalVerbose,
            CSFindexRadicalVerbose: a.indexRadicalVerbose,
            CSFopenRadicalBrief: a.openingRadicalBrief,
            CSFcloseRadicalBrief: a.closingRadicalBrief,
            CSFindexRadicalBrief: a.indexRadicalBrief,
            CSFopenRadicalSbrief: a.openingRadicalSbrief,
            CSFindexRadicalSbrief: a.indexRadicalSbrief,
            CQFisSmallRoot: a.smallRoot,
            CSFsuperscriptVerbose: a.superscriptVerbose,
            CSFsuperscriptBrief: a.superscriptBrief,
            CSFsubscriptVerbose: a.subscriptVerbose,
            CSFsubscriptBrief: a.subscriptBrief,
            CSFbaselineVerbose: a.baselineVerbose,
            CSFbaselineBrief: a.baselineBrief,
            CSFleftsuperscriptVerbose: a.superscriptVerbose,
            CSFleftsubscriptVerbose: a.subscriptVerbose,
            CSFrightsuperscriptVerbose: a.superscriptVerbose,
            CSFrightsubscriptVerbose: a.subscriptVerbose,
            CSFleftsuperscriptBrief: a.superscriptBrief,
            CSFleftsubscriptBrief: a.subscriptBrief,
            CSFrightsuperscriptBrief: a.superscriptBrief,
            CSFrightsubscriptBrief: a.subscriptBrief,
            CSFunderscript: a.nestedUnderscript,
            CSFoverscript: a.nestedOverscript,
            CSFendscripts: a.endscripts,
            CTFordinalCounter: Q.ordinalCounter,
            CTFwordCounter: Q.wordCounter,
            CTFcontentIterator: o.contentIterator,
            CQFdetIsSimple: a.determinantIsSimple,
            CSFRemoveParens: a.removeParens,
            CQFresetNesting: a.resetNestingDepth,
            CGFbaselineConstraint: a.generateBaselineConstraint,
            CGFtensorRules: a.generateTensorRules
          }), s.addStore("es.speech.mathspeak", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CTFunitMultipliers: T.unitMultipliers,
            CQFoneLeft: T.oneLeft
          }), s.addStore("fr.speech.mathspeak", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CSFbaselineVerbose: i.baselineVerbose,
            CSFbaselineBrief: i.baselineBrief,
            CSFleftsuperscriptVerbose: i.leftSuperscriptVerbose,
            CSFleftsubscriptVerbose: i.leftSubscriptVerbose,
            CSFleftsuperscriptBrief: i.leftSuperscriptBrief,
            CSFleftsubscriptBrief: i.leftSubscriptBrief
          });
        };
      },
      1378: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.smallRoot = e.generateTensorRules = e.removeParens = e.generateBaselineConstraint = e.determinantIsSimple = e.nestedOverscript = e.endscripts = e.overscoreNestingDepth = e.nestedUnderscript = e.underscoreNestingDepth = e.indexRadicalSbrief = e.openingRadicalSbrief = e.indexRadicalBrief = e.closingRadicalBrief = e.openingRadicalBrief = e.indexRadicalVerbose = e.closingRadicalVerbose = e.openingRadicalVerbose = e.getRootIndex = e.nestedRadical = e.radicalNestingDepth = e.baselineBrief = e.baselineVerbose = e.superscriptBrief = e.superscriptVerbose = e.subscriptBrief = e.subscriptVerbose = e.nestedSubSuper = e.isSmallVulgarFraction = e.overFractionSbrief = e.closingFractionSbrief = e.openingFractionSbrief = e.closingFractionBrief = e.openingFractionBrief = e.overFractionVerbose = e.closingFractionVerbose = e.openingFractionVerbose = e.nestedFraction = e.fractionNestingDepth = e.computeNestingDepth_ = e.containsAttr = e.getNestingDepth = e.resetNestingDepth = e.nestingBarriers = e.spaceoutIdentifier = e.spaceoutNumber = e.spaceoutNodes = e.spaceoutText = void 0;
        var n = r(707),
          o = r(5740),
          i = r(5274),
          a = r(4356),
          Q = r(3308);
        var s = {};
        function T(t, e) {
          var r = Array.from(t.textContent),
            n = [],
            o = Q.default.getInstance(),
            i = t.ownerDocument;
          for (var _t134, _a20 = 0; _t134 = r[_a20]; _a20++) {
            var _r146 = o.getNodeFactory().makeLeafNode(_t134, "unknown"),
              _a21 = o.identifierNode(_r146, "unknown", "");
            e(_a21), n.push(_a21.xml(i));
          }
          return n;
        }
        function l(t, r, i, a, Q, T) {
          a = a || e.nestingBarriers, Q = Q || {}, T = T || function (t) {
            return !1;
          };
          var l = o.serializeXml(r);
          if (s[t] || (s[t] = {}), s[t][l]) return s[t][l];
          if (T(r) || i.indexOf(r.tagName) < 0) return 0;
          var c = u(r, i, n.setdifference(a, i), Q, T, 0);
          return s[t][l] = c, c;
        }
        function c(t, e) {
          if (!t.attributes) return !1;
          var r = o.toArray(t.attributes);
          for (var _t135, _n251 = 0; _t135 = r[_n251]; _n251++) if (e[_t135.nodeName] === _t135.nodeValue) return !0;
          return !1;
        }
        function u(t, e, r, n, i, a) {
          if (i(t) || r.indexOf(t.tagName) > -1 || c(t, n)) return a;
          if (e.indexOf(t.tagName) > -1 && a++, !t.childNodes || 0 === t.childNodes.length) return a;
          var Q = o.toArray(t.childNodes);
          return Math.max.apply(null, Q.map(function (t) {
            return u(t, e, r, n, i, a);
          }));
        }
        function p(t) {
          return l("fraction", t, ["fraction"], e.nestingBarriers, {}, a.LOCALE.FUNCTIONS.fracNestDepth);
        }
        function h(t, e, r) {
          var n = p(t),
            o = Array(n).fill(e);
          return r && o.push(r), o.join(a.LOCALE.MESSAGES.regexp.JOINER_FRAC);
        }
        function d(t, e, r) {
          for (; t.parentNode;) {
            var _n252 = t.parentNode,
              _o56 = _n252.parentNode;
            if (!_o56) break;
            var _i54 = t.getAttribute && t.getAttribute("role");
            ("subscript" === _o56.tagName && t === _n252.childNodes[1] || "tensor" === _o56.tagName && _i54 && ("leftsub" === _i54 || "rightsub" === _i54)) && (e = r.sub + a.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e), ("superscript" === _o56.tagName && t === _n252.childNodes[1] || "tensor" === _o56.tagName && _i54 && ("leftsuper" === _i54 || "rightsuper" === _i54)) && (e = r.sup + a.LOCALE.MESSAGES.regexp.JOINER_SUBSUPER + e), t = _o56;
          }
          return e.trim();
        }
        function f(t) {
          return l("radical", t, ["sqrt", "root"], e.nestingBarriers, {});
        }
        function m(t, e, r) {
          var n = f(t),
            o = L(t);
          return r = o ? a.LOCALE.FUNCTIONS.combineRootIndex(r, o) : r, 1 === n ? r : a.LOCALE.FUNCTIONS.combineNestedRadical(e, a.LOCALE.FUNCTIONS.radicalNestDepth(n - 1), r);
        }
        function L(t) {
          var e = "sqrt" === t.tagName ? "2" : i.evalXPath("children/*[1]", t)[0].textContent.trim();
          return a.LOCALE.MESSAGES.MSroots[e] || "";
        }
        function y(t) {
          return l("underscore", t, ["underscore"], e.nestingBarriers, {}, function (t) {
            return t.tagName && "underscore" === t.tagName && "underaccent" === t.childNodes[0].childNodes[1].getAttribute("role");
          });
        }
        function g(t) {
          return l("overscore", t, ["overscore"], e.nestingBarriers, {}, function (t) {
            return t.tagName && "overscore" === t.tagName && "overaccent" === t.childNodes[0].childNodes[1].getAttribute("role");
          });
        }
        e.spaceoutText = function (t) {
          return Array.from(t.textContent).join(" ");
        }, e.spaceoutNodes = T, e.spaceoutNumber = function (t) {
          return T(t, function (t) {
            t.textContent.match(/\W/) || (t.type = "number");
          });
        }, e.spaceoutIdentifier = function (t) {
          return T(t, function (t) {
            t.font = "unknown", t.type = "identifier";
          });
        }, e.nestingBarriers = ["cases", "cell", "integral", "line", "matrix", "multiline", "overscore", "root", "row", "sqrt", "subscript", "superscript", "table", "underscore", "vector"], e.resetNestingDepth = function (t) {
          return s = {}, [t];
        }, e.getNestingDepth = l, e.containsAttr = c, e.computeNestingDepth_ = u, e.fractionNestingDepth = p, e.nestedFraction = h, e.openingFractionVerbose = function (t) {
          return h(t, a.LOCALE.MESSAGES.MS.START, a.LOCALE.MESSAGES.MS.FRAC_V);
        }, e.closingFractionVerbose = function (t) {
          return h(t, a.LOCALE.MESSAGES.MS.END, a.LOCALE.MESSAGES.MS.FRAC_V);
        }, e.overFractionVerbose = function (t) {
          return h(t, a.LOCALE.MESSAGES.MS.FRAC_OVER);
        }, e.openingFractionBrief = function (t) {
          return h(t, a.LOCALE.MESSAGES.MS.START, a.LOCALE.MESSAGES.MS.FRAC_B);
        }, e.closingFractionBrief = function (t) {
          return h(t, a.LOCALE.MESSAGES.MS.END, a.LOCALE.MESSAGES.MS.FRAC_B);
        }, e.openingFractionSbrief = function (t) {
          var e = p(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.FRAC_S : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.FRAC_S);
        }, e.closingFractionSbrief = function (t) {
          var e = p(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.ENDFRAC : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.ENDFRAC);
        }, e.overFractionSbrief = function (t) {
          var e = p(t);
          return 1 === e ? a.LOCALE.MESSAGES.MS.FRAC_OVER : a.LOCALE.FUNCTIONS.combineNestedFraction(a.LOCALE.MESSAGES.MS.NEST_FRAC, a.LOCALE.FUNCTIONS.radicalNestDepth(e - 1), a.LOCALE.MESSAGES.MS.FRAC_OVER);
        }, e.isSmallVulgarFraction = function (t) {
          return a.LOCALE.FUNCTIONS.fracNestDepth(t) ? [t] : [];
        }, e.nestedSubSuper = d, e.subscriptVerbose = function (t) {
          return d(t, a.LOCALE.MESSAGES.MS.SUBSCRIPT, {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.subscriptBrief = function (t) {
          return d(t, a.LOCALE.MESSAGES.MS.SUB, {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.superscriptVerbose = function (t) {
          return d(t, a.LOCALE.MESSAGES.MS.SUPERSCRIPT, {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.superscriptBrief = function (t) {
          return d(t, a.LOCALE.MESSAGES.MS.SUP, {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
        }, e.baselineVerbose = function (t) {
          var e = d(t, "", {
            sup: a.LOCALE.MESSAGES.MS.SUPER,
            sub: a.LOCALE.MESSAGES.MS.SUB
          });
          return e ? e.replace(new RegExp(a.LOCALE.MESSAGES.MS.SUB + "$"), a.LOCALE.MESSAGES.MS.SUBSCRIPT).replace(new RegExp(a.LOCALE.MESSAGES.MS.SUPER + "$"), a.LOCALE.MESSAGES.MS.SUPERSCRIPT) : a.LOCALE.MESSAGES.MS.BASELINE;
        }, e.baselineBrief = function (t) {
          return d(t, "", {
            sup: a.LOCALE.MESSAGES.MS.SUP,
            sub: a.LOCALE.MESSAGES.MS.SUB
          }) || a.LOCALE.MESSAGES.MS.BASE;
        }, e.radicalNestingDepth = f, e.nestedRadical = m, e.getRootIndex = L, e.openingRadicalVerbose = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadicalVerbose = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadicalVerbose = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NESTED, a.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.openingRadicalBrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadicalBrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadicalBrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.openingRadicalSbrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.ROOT);
        }, e.indexRadicalSbrief = function (t) {
          return m(t, a.LOCALE.MESSAGES.MS.NEST_ROOT, a.LOCALE.MESSAGES.MS.INDEX);
        }, e.underscoreNestingDepth = y, e.nestedUnderscript = function (t) {
          var e = y(t);
          return Array(e).join(a.LOCALE.MESSAGES.MS.UNDER) + a.LOCALE.MESSAGES.MS.UNDERSCRIPT;
        }, e.overscoreNestingDepth = g, e.endscripts = function (t) {
          return a.LOCALE.MESSAGES.MS.ENDSCRIPTS;
        }, e.nestedOverscript = function (t) {
          var e = g(t);
          return Array(e).join(a.LOCALE.MESSAGES.MS.OVER) + a.LOCALE.MESSAGES.MS.OVERSCRIPT;
        }, e.determinantIsSimple = function (t) {
          if ("matrix" !== t.tagName || "determinant" !== t.getAttribute("role")) return [];
          var e = i.evalXPath("children/row/children/cell/children/*", t);
          for (var _t136, _r147 = 0; _t136 = e[_r147]; _r147++) if ("number" !== _t136.tagName) {
            if ("identifier" === _t136.tagName) {
              var _e122 = _t136.getAttribute("role");
              if ("latinletter" === _e122 || "greekletter" === _e122 || "otherletter" === _e122) continue;
            }
            return [];
          }
          return [t];
        }, e.generateBaselineConstraint = function () {
          var t = function t(_t137) {
              return _t137.map(function (t) {
                return "ancestor::" + t;
              });
            },
            e = function e(t) {
              return "not(" + t + ")";
            },
            r = e(t(["subscript", "superscript", "tensor"]).join(" or ")),
            n = t(["relseq", "multrel"]),
            o = t(["fraction", "punctuation", "fenced", "sqrt", "root"]);
          var i = [];
          var _loop9 = function _loop9(_t138) {
            i = i.concat(n.map(function (e) {
              return _t138 + "/" + e;
            }));
          };
          for (var _t138, _e123 = 0; _t138 = o[_e123]; _e123++) {
            _loop9(_t138);
          }
          return [["ancestor::*/following-sibling::*", r, e(i.join(" | "))].join(" and ")];
        }, e.removeParens = function (t) {
          if (!t.childNodes.length || !t.childNodes[0].childNodes.length || !t.childNodes[0].childNodes[0].childNodes.length) return "";
          var e = t.childNodes[0].childNodes[0].childNodes[0].textContent;
          return e.match(/^\(.+\)$/) ? e.slice(1, -1) : e;
        };
        var v = new Map([[3, "CSFleftsuperscript"], [4, "CSFleftsubscript"], [2, "CSFbaseline"], [1, "CSFrightsubscript"], [0, "CSFrightsuperscript"]]),
          b = new Map([[4, 2], [3, 3], [2, 1], [1, 4], [0, 5]]);
        function H(t) {
          var e = [];
          var r = "",
            n = "",
            o = parseInt(t, 2);
          for (var _t139 = 0; _t139 < 5; _t139++) {
            var _i55 = "children/*[" + b.get(_t139) + "]";
            if (1 & o) {
              var _e124 = v.get(_t139 % 5);
              r = "[t] " + _e124 + "Verbose; [n] " + _i55 + ";" + r, n = "[t] " + _e124 + "Brief; [n] " + _i55 + ";" + n;
            } else e.unshift("name(" + _i55 + ')="empty"');
            o >>= 1;
          }
          return [e, r, n];
        }
        e.generateTensorRules = function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var r = ["11111", "11110", "11101", "11100", "10111", "10110", "10101", "10100", "01111", "01110", "01101", "01100"];
          for (var _n253, _o57 = 0; _n253 = r[_o57]; _o57++) {
            var _r148 = "tensor" + _n253,
              _H = H(_n253),
              _H2 = _slicedToArray(_H, 3),
              _o58 = _H2[0],
              _i56 = _H2[1],
              _a22 = _H2[2];
            t.defineRule.apply(t, [_r148, "default", _i56, "self::tensor"].concat(_toConsumableArray(_o58))), e && (t.defineRule.apply(t, [_r148, "brief", _a22, "self::tensor"].concat(_toConsumableArray(_o58))), t.defineRule.apply(t, [_r148, "sbrief", _a22, "self::tensor"].concat(_toConsumableArray(_o58))));
            var _Q11 = v.get(2);
            _i56 += "; [t]" + _Q11 + "Verbose", _a22 += "; [t]" + _Q11 + "Brief", _r148 += "-baseline";
            var _s6 = "((.//*[not(*)])[last()]/@id)!=(((.//ancestor::fraction|ancestor::root|ancestor::sqrt|ancestor::cell|ancestor::line|ancestor::stree)[1]//*[not(*)])[last()]/@id)";
            t.defineRule.apply(t, [_r148, "default", _i56, "self::tensor", _s6].concat(_toConsumableArray(_o58))), e && (t.defineRule.apply(t, [_r148, "brief", _a22, "self::tensor", _s6].concat(_toConsumableArray(_o58))), t.defineRule.apply(t, [_r148, "sbrief", _a22, "self::tensor", _s6].concat(_toConsumableArray(_o58))));
          }
        }, e.smallRoot = function (t) {
          var e = Object.keys(a.LOCALE.MESSAGES.MSroots).length;
          if (!e) return [];
          if (e++, !t.childNodes || 0 === t.childNodes.length || !t.childNodes[0].childNodes) return [];
          var r = t.childNodes[0].childNodes[0].textContent;
          if (!/^\d+$/.test(r)) return [];
          var n = parseInt(r, 10);
          return n > 1 && n <= e ? [t] : [];
        };
      },
      6922: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.implicitIterator = e.relationIterator = e.propagateNumber = e.checkParent_ = e.NUMBER_INHIBITORS_ = e.NUMBER_PROPAGATORS_ = e.enlargeFence = e.indexRadical = e.closingRadical = e.openingRadical = e.radicalNestingDepth = e.nestedRadical = e.overBevelledFraction = e.overFraction = e.closingFraction = e.openingFraction = void 0;
        var n = r(7052),
          o = r(5740),
          i = r(5274),
          a = r(2105),
          Q = r(5897),
          s = r(7630),
          T = r(9265),
          l = r(4356),
          c = r(1378);
        function u(t, e) {
          var r = p(t);
          return 1 === r ? e : new Array(r).join(l.LOCALE.MESSAGES.MS.NESTED) + e;
        }
        function p(t, e) {
          var r = e || 0;
          return t.parentNode ? p(t.parentNode, "root" === t.tagName || "sqrt" === t.tagName ? r + 1 : r) : r;
        }
        function h(t) {
          var e = "\u2820";
          if (1 === t.length) return e + t;
          var r = t.split("");
          return r.every(function (t) {
            return "\u2833" === t;
          }) ? e + r.join(e) : t.slice(0, -1) + e + t.slice(-1);
        }
        function d(t, r) {
          var n = t.parent;
          if (!n) return !1;
          var o = n.type;
          return -1 !== e.NUMBER_PROPAGATORS_.indexOf(o) || "prefixop" === o && "negative" === n.role && !r.script || "prefixop" === o && "geometry" === n.role || !("punctuated" !== o || r.enclosed && "text" !== n.role);
        }
        function f(t, r) {
          return t.childNodes.length ? (-1 !== e.NUMBER_INHIBITORS_.indexOf(t.type) && (r.script = !0), "fenced" === t.type ? (r.number = !1, r.enclosed = !0, ["", r]) : (d(t, r) && (r.number = !0, r.enclosed = !1), ["", r])) : (d(t, r) && (r.number = !0, r.script = !1, r.enclosed = !1), [r.number ? "number" : "", {
            number: !1,
            enclosed: r.enclosed,
            script: r.script
          }]);
        }
        e.openingFraction = function (t) {
          var e = c.fractionNestingDepth(t);
          return new Array(e).join(l.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + l.LOCALE.MESSAGES.MS.FRACTION_START;
        }, e.closingFraction = function (t) {
          var e = c.fractionNestingDepth(t);
          return new Array(e).join(l.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + l.LOCALE.MESSAGES.MS.FRACTION_END;
        }, e.overFraction = function (t) {
          var e = c.fractionNestingDepth(t);
          return new Array(e).join(l.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + l.LOCALE.MESSAGES.MS.FRACTION_OVER;
        }, e.overBevelledFraction = function (t) {
          var e = c.fractionNestingDepth(t);
          return new Array(e).join(l.LOCALE.MESSAGES.MS.FRACTION_REPEAT) + "\u2838" + l.LOCALE.MESSAGES.MS.FRACTION_OVER;
        }, e.nestedRadical = u, e.radicalNestingDepth = p, e.openingRadical = function (t) {
          return u(t, l.LOCALE.MESSAGES.MS.STARTROOT);
        }, e.closingRadical = function (t) {
          return u(t, l.LOCALE.MESSAGES.MS.ENDROOT);
        }, e.indexRadical = function (t) {
          return u(t, l.LOCALE.MESSAGES.MS.ROOTINDEX);
        }, e.enlargeFence = h, a.Grammar.getInstance().setCorrection("enlargeFence", h), e.NUMBER_PROPAGATORS_ = ["multirel", "relseq", "appl", "row", "line"], e.NUMBER_INHIBITORS_ = ["subscript", "superscript", "overscore", "underscore"], e.checkParent_ = d, e.propagateNumber = f, (0, s.register)(new T.SemanticVisitor("nemeth", "number", f, {
          number: !0
        })), e.relationIterator = function (t, e) {
          var r = t.slice(0);
          var a,
            s = !0;
          return a = t.length > 0 ? i.evalXPath("../../content/*", t[0]) : [], function () {
            var t = a.shift(),
              i = r.shift(),
              T = r[0],
              u = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!t) return u;
            var p = i ? c.nestedSubSuper(i, "", {
                sup: l.LOCALE.MESSAGES.MS.SUPER,
                sub: l.LOCALE.MESSAGES.MS.SUB
              }) : "",
              h = i && "EMPTY" !== o.tagName(i) || s && t.parentNode.parentNode && t.parentNode.parentNode.previousSibling ? [n.AuditoryDescription.create({
                text: "\u2800" + p
              }, {})] : [],
              d = T && "EMPTY" !== o.tagName(T) || !a.length && t.parentNode.parentNode && t.parentNode.parentNode.nextSibling ? [n.AuditoryDescription.create({
                text: "\u2800"
              }, {})] : [],
              f = Q.default.evaluateNode(t);
            return s = !1, u.concat(h, f, d);
          };
        }, e.implicitIterator = function (t, e) {
          var r = t.slice(0);
          var a;
          return a = t.length > 0 ? i.evalXPath("../../content/*", t[0]) : [], function () {
            var t = r.shift(),
              i = r[0],
              Q = a.shift(),
              s = e ? [n.AuditoryDescription.create({
                text: e
              }, {
                translate: !0
              })] : [];
            if (!Q) return s;
            var T = t && "NUMBER" === o.tagName(t),
              l = i && "NUMBER" === o.tagName(i);
            return s.concat(T && l && "space" === Q.getAttribute("role") ? [n.AuditoryDescription.create({
              text: "\u2800"
            }, {})] : []);
          };
        };
      },
      8437: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.ordinalPosition = e.vulgarFraction = e.wordCounter = e.ordinalCounter = void 0;
        var n = r(9536),
          o = r(5740),
          i = r(4356),
          a = r(4977);
        e.ordinalCounter = function (t, e) {
          var r = 0;
          return function () {
            return i.LOCALE.NUMBERS.numericOrdinal(++r) + " " + e;
          };
        }, e.wordCounter = function (t, e) {
          var r = 0;
          return function () {
            return i.LOCALE.NUMBERS.numberToOrdinal(++r, !1) + " " + e;
          };
        }, e.vulgarFraction = function (t) {
          var e = (0, a.convertVulgarFraction)(t, i.LOCALE.MESSAGES.MS.FRAC_OVER);
          return e.convertible && e.enumerator && e.denominator ? [new n.Span(i.LOCALE.NUMBERS.numberToWords(e.enumerator), {
            extid: t.childNodes[0].childNodes[0].getAttribute("extid"),
            separator: ""
          }), new n.Span(i.LOCALE.NUMBERS.vulgarSep, {
            separator: ""
          }), new n.Span(i.LOCALE.NUMBERS.numberToOrdinal(e.denominator, 1 !== e.enumerator), {
            extid: t.childNodes[0].childNodes[1].getAttribute("extid")
          })] : [new n.Span(e.content || "", {
            extid: t.getAttribute("extid")
          })];
        }, e.ordinalPosition = function (t) {
          var e = o.toArray(t.parentNode.childNodes);
          return i.LOCALE.NUMBERS.numericOrdinal(e.indexOf(t) + 1).toString();
        };
      },
      9284: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.BrailleRules = e.OtherRules = e.PrefixRules = void 0;
        var n = r(1676),
          o = r(365),
          i = r(1378),
          a = r(6922),
          Q = r(8437),
          s = r(7283);
        e.PrefixRules = function () {
          s.addStore("en.prefix.default", "", {
            CSFordinalPosition: Q.ordinalPosition
          });
        }, e.OtherRules = function () {
          s.addStore("en.speech.chromevox", "", {
            CTFnodeCounter: o.nodeCounter,
            CTFcontentIterator: o.contentIterator
          }), s.addStore("en.speech.emacspeak", "en.speech.chromevox", {
            CQFvulgarFractionSmall: i.isSmallVulgarFraction,
            CSFvulgarFraction: Q.vulgarFraction
          });
        }, e.BrailleRules = function () {
          s.addStore("nemeth.braille.default", n.DynamicCstr.BASE_LOCALE + ".speech.mathspeak", {
            CSFopenFraction: a.openingFraction,
            CSFcloseFraction: a.closingFraction,
            CSFoverFraction: a.overFraction,
            CSFoverBevFraction: a.overBevelledFraction,
            CSFopenRadical: a.openingRadical,
            CSFcloseRadical: a.closingRadical,
            CSFindexRadical: a.indexRadical,
            CSFsubscript: i.subscriptVerbose,
            CSFsuperscript: i.superscriptVerbose,
            CSFbaseline: i.baselineVerbose,
            CGFtensorRules: function CGFtensorRules(t) {
              return i.generateTensorRules(t, !1);
            },
            CTFrelationIterator: a.relationIterator,
            CTFimplicitIterator: a.implicitIterator
          });
        };
      },
      7599: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.init = e.INIT_ = void 0;
        var n = r(5425),
          o = r(9577),
          i = r(9284);
        e.INIT_ = !1, e.init = function () {
          e.INIT_ || ((0, o.MathspeakRules)(), (0, n.ClearspeakRules)(), (0, i.PrefixRules)(), (0, i.OtherRules)(), (0, i.BrailleRules)(), e.INIT_ = !0);
        };
      },
      7283: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getStore = e.addStore = e.funcStore = void 0;
        var n = r(1676);
        e.funcStore = new Map(), e.addStore = function (t, r, n) {
          var o = {};
          if (r) {
            var _t140 = e.funcStore.get(r) || {};
            Object.assign(o, _t140);
          }
          e.funcStore.set(t, Object.assign(o, n));
        }, e.getStore = function (t, r, o) {
          return e.funcStore.get([t, r, o].join(".")) || e.funcStore.get([n.DynamicCstr.DEFAULT_VALUES[n.Axis.LOCALE], r, o].join(".")) || e.funcStore.get([n.DynamicCstr.BASE_LOCALE, r, o].join(".")) || {};
        };
      },
      7598: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.oneLeft = e.leftMostUnit = e.rightMostUnit = e.unitMultipliers = void 0;
        var n = r(7052),
          o = r(5274),
          i = r(4356);
        e.unitMultipliers = function (t, e) {
          var r = t;
          var o = 0;
          return function () {
            var t = n.AuditoryDescription.create({
              text: Q(r[o]) && s(r[o + 1]) ? i.LOCALE.MESSAGES.unitTimes : ""
            }, {});
            return o++, [t];
          };
        };
        var a = ["superscript", "subscript", "overscore", "underscore"];
        function Q(t) {
          for (; t;) {
            if ("unit" === t.getAttribute("role")) return !0;
            var _e125 = t.tagName,
              _r149 = o.evalXPath("children/*", t);
            t = -1 !== a.indexOf(_e125) ? _r149[0] : _r149[_r149.length - 1];
          }
          return !1;
        }
        function s(t) {
          for (; t;) {
            if ("unit" === t.getAttribute("role")) return !0;
            t = o.evalXPath("children/*", t)[0];
          }
          return !1;
        }
        e.rightMostUnit = Q, e.leftMostUnit = s, e.oneLeft = function (t) {
          for (; t;) {
            if ("number" === t.tagName && "1" === t.textContent) return [t];
            if ("infixop" !== t.tagName || "multiplication" !== t.getAttribute("role") && "implicit" !== t.getAttribute("role")) return [];
            t = o.evalXPath("children/*", t)[0];
          }
          return [];
        };
      },
      3284: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.AbstractWalker = void 0;
        var n = r(7052),
          o = r(8290),
          i = r(5740),
          a = r(4440),
          Q = r(6828),
          s = r(8496),
          T = r(2298),
          l = r(4356),
          c = r(2105),
          u = r(5656),
          p = r(9552),
          h = r(9543),
          d = r(8504),
          f = r(7730),
          m = r(1214),
          L = r(179),
          y = r(1204),
          g = r(5274);
        var v = /*#__PURE__*/function () {
          function v(t, e, r, n) {
            _classCallCheck(this, v);
            this.node = t, this.generator = e, this.highlighter = r, this.modifier = !1, this.keyMapping = new Map([[s.KeyCode.UP, this.up.bind(this)], [s.KeyCode.DOWN, this.down.bind(this)], [s.KeyCode.RIGHT, this.right.bind(this)], [s.KeyCode.LEFT, this.left.bind(this)], [s.KeyCode.TAB, this.repeat.bind(this)], [s.KeyCode.DASH, this.expand.bind(this)], [s.KeyCode.SPACE, this.depth.bind(this)], [s.KeyCode.HOME, this.home.bind(this)], [s.KeyCode.X, this.summary.bind(this)], [s.KeyCode.Z, this.detail.bind(this)], [s.KeyCode.V, this.virtualize.bind(this)], [s.KeyCode.P, this.previous.bind(this)], [s.KeyCode.U, this.undo.bind(this)], [s.KeyCode.LESS, this.previousRules.bind(this)], [s.KeyCode.GREATER, this.nextRules.bind(this)]]), this.cursors = [], this.xml_ = null, this.rebuilt_ = null, this.focus_ = null, this.active_ = !1, this.node.id ? this.id = this.node.id : this.node.hasAttribute(v.SRE_ID_ATTR) ? this.id = this.node.getAttribute(v.SRE_ID_ATTR) : (this.node.setAttribute(v.SRE_ID_ATTR, v.ID_COUNTER.toString()), this.id = v.ID_COUNTER++), this.rootNode = y.getSemanticRoot(t), this.rootId = this.rootNode.getAttribute(T.Attribute.ID), this.xmlString_ = n, this.moved = L.WalkerMoves.ENTER;
          }
          _createClass(v, [{
            key: "getXml",
            value: function getXml() {
              return this.xml_ || (this.xml_ = i.parseInput(this.xmlString_)), this.xml_;
            }
          }, {
            key: "getRebuilt",
            value: function getRebuilt() {
              return this.rebuilt_ || this.rebuildStree(), this.rebuilt_;
            }
          }, {
            key: "isActive",
            value: function isActive() {
              return this.active_;
            }
          }, {
            key: "activate",
            value: function activate() {
              this.isActive() || (this.generator.start(), this.toggleActive_());
            }
          }, {
            key: "deactivate",
            value: function deactivate() {
              this.isActive() && (L.WalkerState.setState(this.id, this.primaryId()), this.generator.end(), this.toggleActive_());
            }
          }, {
            key: "getFocus",
            value: function getFocus() {
              var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
              return this.focus_ || (this.focus_ = this.singletonFocus(this.rootId)), t && this.updateFocus(), this.focus_;
            }
          }, {
            key: "setFocus",
            value: function setFocus(t) {
              this.focus_ = t;
            }
          }, {
            key: "getDepth",
            value: function getDepth() {
              return this.levels.depth() - 1;
            }
          }, {
            key: "isSpeech",
            value: function isSpeech() {
              return this.generator.modality === T.Attribute.SPEECH;
            }
          }, {
            key: "focusDomNodes",
            value: function focusDomNodes() {
              return this.getFocus().getDomNodes();
            }
          }, {
            key: "focusSemanticNodes",
            value: function focusSemanticNodes() {
              return this.getFocus().getSemanticNodes();
            }
          }, {
            key: "speech",
            value: function speech() {
              var t = this.focusDomNodes();
              if (!t.length) return "";
              var e = this.specialMove();
              if (null !== e) return e;
              switch (this.moved) {
                case L.WalkerMoves.DEPTH:
                  return this.depth_();
                case L.WalkerMoves.SUMMARY:
                  return this.summary_();
                case L.WalkerMoves.DETAIL:
                  return this.detail_();
                default:
                  {
                    var _e126 = [],
                      _r150 = this.focusSemanticNodes();
                    for (var _n254 = 0, _o59 = t.length; _n254 < _o59; _n254++) {
                      var _o60 = t[_n254],
                        _i57 = _r150[_n254];
                      _e126.push(_o60 ? this.generator.getSpeech(_o60, this.getXml()) : h.recomputeMarkup(_i57));
                    }
                    return this.mergePrefix_(_e126);
                  }
              }
            }
          }, {
            key: "move",
            value: function move(t) {
              var e = this.keyMapping.get(t);
              if (!e) return null;
              var r = e();
              return !(!r || r === this.getFocus()) && (this.setFocus(r), this.moved === L.WalkerMoves.HOME && (this.levels = this.initLevels()), !0);
            }
          }, {
            key: "up",
            value: function up() {
              return this.moved = L.WalkerMoves.UP, this.getFocus();
            }
          }, {
            key: "down",
            value: function down() {
              return this.moved = L.WalkerMoves.DOWN, this.getFocus();
            }
          }, {
            key: "left",
            value: function left() {
              return this.moved = L.WalkerMoves.LEFT, this.getFocus();
            }
          }, {
            key: "right",
            value: function right() {
              return this.moved = L.WalkerMoves.RIGHT, this.getFocus();
            }
          }, {
            key: "repeat",
            value: function repeat() {
              return this.moved = L.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "depth",
            value: function depth() {
              return this.moved = this.isSpeech() ? L.WalkerMoves.DEPTH : L.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "home",
            value: function home() {
              this.moved = L.WalkerMoves.HOME;
              return this.singletonFocus(this.rootId);
            }
          }, {
            key: "getBySemanticId",
            value: function getBySemanticId(t) {
              return y.getBySemanticId(this.node, t);
            }
          }, {
            key: "primaryId",
            value: function primaryId() {
              return this.getFocus().getSemanticPrimary().id.toString();
            }
          }, {
            key: "expand",
            value: function expand() {
              var t = this.getFocus().getDomPrimary(),
                e = this.actionable_(t);
              return e ? (this.moved = L.WalkerMoves.EXPAND, e.dispatchEvent(new Event("click")), this.getFocus().clone()) : this.getFocus();
            }
          }, {
            key: "expandable",
            value: function expandable(t) {
              return !!this.actionable_(t) && 0 === t.childNodes.length;
            }
          }, {
            key: "collapsible",
            value: function collapsible(t) {
              return !!this.actionable_(t) && t.childNodes.length > 0;
            }
          }, {
            key: "restoreState",
            value: function restoreState() {
              if (!this.highlighter) return;
              var t = L.WalkerState.getState(this.id);
              if (!t) return;
              var e = this.getRebuilt().nodeDict[t];
              var r = [];
              for (; e;) r.push(e.id), e = e.parent;
              for (r.pop(); r.length > 0;) {
                this.down();
                var _t141 = r.pop(),
                  _e127 = this.findFocusOnLevel(_t141);
                if (!_e127) break;
                this.setFocus(_e127);
              }
              this.moved = L.WalkerMoves.ENTER;
            }
          }, {
            key: "updateFocus",
            value: function updateFocus() {
              this.setFocus(f.Focus.factory(this.getFocus().getSemanticPrimary().id.toString(), this.getFocus().getSemanticNodes().map(function (t) {
                return t.id.toString();
              }), this.getRebuilt(), this.node));
            }
          }, {
            key: "rebuildStree",
            value: function rebuildStree() {
              this.rebuilt_ = new m.RebuildStree(this.getXml()), this.rootId = this.rebuilt_.stree.root.id.toString(), this.generator.setRebuilt(this.rebuilt_), this.skeleton = u.SemanticSkeleton.fromTree(this.rebuilt_.stree), this.skeleton.populate(), this.focus_ = this.singletonFocus(this.rootId), this.levels = this.initLevels(), h.connectMactions(this.node, this.getXml(), this.rebuilt_.xml);
            }
          }, {
            key: "previousLevel",
            value: function previousLevel() {
              var t = this.getFocus().getDomPrimary();
              return t ? y.getAttribute(t, T.Attribute.PARENT) : this.getFocus().getSemanticPrimary().parent.id.toString();
            }
          }, {
            key: "nextLevel",
            value: function nextLevel() {
              var t = this.getFocus().getDomPrimary();
              var e, r;
              if (t) {
                e = y.splitAttribute(y.getAttribute(t, T.Attribute.CHILDREN)), r = y.splitAttribute(y.getAttribute(t, T.Attribute.CONTENT));
                var _n255 = y.getAttribute(t, T.Attribute.TYPE),
                  _o61 = y.getAttribute(t, T.Attribute.ROLE);
                return this.combineContentChildren(_n255, _o61, r, e);
              }
              var n = function n(t) {
                  return t.id.toString();
                },
                o = this.getRebuilt().nodeDict[this.primaryId()];
              return e = o.childNodes.map(n), r = o.contentNodes.map(n), 0 === e.length ? [] : this.combineContentChildren(o.type, o.role, r, e);
            }
          }, {
            key: "singletonFocus",
            value: function singletonFocus(t) {
              this.getRebuilt();
              var e = this.retrieveVisuals(t);
              return this.focusFromId(t, e);
            }
          }, {
            key: "retrieveVisuals",
            value: function retrieveVisuals(t) {
              if (!this.skeleton) return [t];
              var e = parseInt(t, 10),
                r = this.skeleton.subtreeNodes(e);
              if (!r.length) return [t];
              r.unshift(e);
              var n = {},
                o = [];
              g.updateEvaluator(this.getXml());
              var _iterator22 = _createForOfIteratorHelper(r),
                _step22;
              try {
                for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
                  var _t142 = _step22.value;
                  n[_t142] || (o.push(_t142.toString()), n[_t142] = !0, this.subtreeIds(_t142, n));
                }
              } catch (err) {
                _iterator22.e(err);
              } finally {
                _iterator22.f();
              }
              return o;
            }
          }, {
            key: "subtreeIds",
            value: function subtreeIds(t, e) {
              var r = g.evalXPath("//*[@data-semantic-id=\"".concat(t, "\"]"), this.getXml());
              g.evalXPath("*//@data-semantic-id", r[0]).forEach(function (t) {
                return e[parseInt(t.textContent, 10)] = !0;
              });
            }
          }, {
            key: "focusFromId",
            value: function focusFromId(t, e) {
              return f.Focus.factory(t, e, this.getRebuilt(), this.node);
            }
          }, {
            key: "summary",
            value: function summary() {
              return this.moved = this.isSpeech() ? L.WalkerMoves.SUMMARY : L.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "detail",
            value: function detail() {
              return this.moved = this.isSpeech() ? L.WalkerMoves.DETAIL : L.WalkerMoves.REPEAT, this.getFocus().clone();
            }
          }, {
            key: "specialMove",
            value: function specialMove() {
              return null;
            }
          }, {
            key: "virtualize",
            value: function virtualize(t) {
              return this.cursors.push({
                focus: this.getFocus(),
                levels: this.levels,
                undo: t || !this.cursors.length
              }), this.levels = this.levels.clone(), this.getFocus().clone();
            }
          }, {
            key: "previous",
            value: function previous() {
              var t = this.cursors.pop();
              return t ? (this.levels = t.levels, t.focus) : this.getFocus();
            }
          }, {
            key: "undo",
            value: function undo() {
              var t;
              do {
                t = this.cursors.pop();
              } while (t && !t.undo);
              return t ? (this.levels = t.levels, t.focus) : this.getFocus();
            }
          }, {
            key: "update",
            value: function update(t) {
              var _this52 = this;
              this.generator.setOptions(t), (0, Q.setup)(t).then(function () {
                return p.generator("Tree").getSpeech(_this52.node, _this52.getXml());
              });
            }
          }, {
            key: "nextRules",
            value: function nextRules() {
              var t = this.generator.getOptions();
              return "speech" !== t.modality ? this.getFocus() : (a.DOMAIN_TO_STYLES[t.domain] = t.style, t.domain = "mathspeak" === t.domain ? "clearspeak" : "mathspeak", t.style = a.DOMAIN_TO_STYLES[t.domain], this.update(t), this.moved = L.WalkerMoves.REPEAT, this.getFocus().clone());
            }
          }, {
            key: "nextStyle",
            value: function nextStyle(t, e) {
              if ("mathspeak" === t) {
                var _t143 = ["default", "brief", "sbrief"],
                  _r151 = _t143.indexOf(e);
                return -1 === _r151 ? e : _r151 >= _t143.length - 1 ? _t143[0] : _t143[_r151 + 1];
              }
              if ("clearspeak" === t) {
                var _t144 = d.ClearspeakPreferences.getLocalePreferences().en;
                if (!_t144) return "default";
                var _r152 = d.ClearspeakPreferences.relevantPreferences(this.getFocus().getSemanticPrimary()),
                  _n256 = d.ClearspeakPreferences.findPreference(e, _r152),
                  _o62 = _t144[_r152].map(function (t) {
                    return t.split("_")[1];
                  }),
                  _i58 = _o62.indexOf(_n256);
                if (-1 === _i58) return e;
                var _a23 = _i58 >= _o62.length - 1 ? _o62[0] : _o62[_i58 + 1];
                return d.ClearspeakPreferences.addPreference(e, _r152, _a23);
              }
              return e;
            }
          }, {
            key: "previousRules",
            value: function previousRules() {
              var t = this.generator.getOptions();
              return "speech" !== t.modality ? this.getFocus() : (t.style = this.nextStyle(t.domain, t.style), this.update(t), this.moved = L.WalkerMoves.REPEAT, this.getFocus().clone());
            }
          }, {
            key: "refocus",
            value: function refocus() {
              var t,
                e = this.getFocus();
              for (; !e.getNodes().length;) {
                t = this.levels.peek();
                var _r153 = this.up();
                if (!_r153) break;
                this.setFocus(_r153), e = this.getFocus(!0);
              }
              this.levels.push(t), this.setFocus(e);
            }
          }, {
            key: "toggleActive_",
            value: function toggleActive_() {
              this.active_ = !this.active_;
            }
          }, {
            key: "mergePrefix_",
            value: function mergePrefix_(t) {
              var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var r = this.isSpeech() ? this.prefix_() : "";
              r && t.unshift(r);
              var n = this.isSpeech() ? this.postfix_() : "";
              return n && t.push(n), o.finalize(o.merge(e.concat(t)));
            }
          }, {
            key: "prefix_",
            value: function prefix_() {
              var t = this.getFocus().getDomNodes(),
                e = this.getFocus().getSemanticNodes();
              return t[0] ? y.getAttribute(t[0], T.Attribute.PREFIX) : h.retrievePrefix(e[0]);
            }
          }, {
            key: "postfix_",
            value: function postfix_() {
              var t = this.getFocus().getDomNodes();
              return t[0] ? y.getAttribute(t[0], T.Attribute.POSTFIX) : "";
            }
          }, {
            key: "depth_",
            value: function depth_() {
              var t = c.Grammar.getInstance().getParameter("depth");
              c.Grammar.getInstance().setParameter("depth", !0);
              var e = this.getFocus().getDomPrimary(),
                r = this.expandable(e) ? l.LOCALE.MESSAGES.navigate.EXPANDABLE : this.collapsible(e) ? l.LOCALE.MESSAGES.navigate.COLLAPSIBLE : "",
                i = l.LOCALE.MESSAGES.navigate.LEVEL + " " + this.getDepth(),
                a = this.getFocus().getSemanticNodes(),
                Q = h.retrievePrefix(a[0]),
                s = [new n.AuditoryDescription({
                  text: i,
                  personality: {}
                }), new n.AuditoryDescription({
                  text: Q,
                  personality: {}
                }), new n.AuditoryDescription({
                  text: r,
                  personality: {}
                })];
              return c.Grammar.getInstance().setParameter("depth", t), o.finalize(o.markup(s));
            }
          }, {
            key: "actionable_",
            value: function actionable_(t) {
              var e = null == t ? void 0 : t.parentNode;
              return e && this.highlighter.isMactionNode(e) ? e : null;
            }
          }, {
            key: "summary_",
            value: function summary_() {
              var t = this.getFocus().getSemanticPrimary().id.toString(),
                e = this.getRebuilt().xml.getAttribute("id") === t ? this.getRebuilt().xml : i.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t)[0],
                r = h.retrieveSummary(e);
              return this.mergePrefix_([r]);
            }
          }, {
            key: "detail_",
            value: function detail_() {
              var t = this.getFocus().getSemanticPrimary().id.toString(),
                e = this.getRebuilt().xml.getAttribute("id") === t ? this.getRebuilt().xml : i.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", t)[0],
                r = e.getAttribute("alternative");
              e.removeAttribute("alternative");
              var n = h.computeMarkup(e),
                o = this.mergePrefix_([n]);
              return e.setAttribute("alternative", r), o;
            }
          }]);
          return v;
        }();
        e.AbstractWalker = v, v.ID_COUNTER = 0, v.SRE_ID_ATTR = "sre-explorer-id";
      },
      162: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.DummyWalker = void 0;
        var n = r(3284);
        var o = /*#__PURE__*/function (_n$AbstractWalker) {
          _inherits(o, _n$AbstractWalker);
          function o() {
            _classCallCheck(this, o);
            return _possibleConstructorReturn(this, _getPrototypeOf(o).apply(this, arguments));
          }
          _createClass(o, [{
            key: "up",
            value: function up() {
              return null;
            }
          }, {
            key: "down",
            value: function down() {
              return null;
            }
          }, {
            key: "left",
            value: function left() {
              return null;
            }
          }, {
            key: "right",
            value: function right() {
              return null;
            }
          }, {
            key: "repeat",
            value: function repeat() {
              return null;
            }
          }, {
            key: "depth",
            value: function depth() {
              return null;
            }
          }, {
            key: "home",
            value: function home() {
              return null;
            }
          }, {
            key: "getDepth",
            value: function getDepth() {
              return 0;
            }
          }, {
            key: "initLevels",
            value: function initLevels() {
              return null;
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, n) {
              return [];
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return null;
            }
          }]);
          return o;
        }(n.AbstractWalker);
        e.DummyWalker = o;
      },
      7730: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Focus = void 0;
        var n = r(1204);
        var o = /*#__PURE__*/function () {
          function o(t, e) {
            _classCallCheck(this, o);
            this.nodes = t, this.primary = e, this.domNodes = [], this.domPrimary_ = null, this.allNodes = [];
          }
          _createClass(o, [{
            key: "getSemanticPrimary",
            value: function getSemanticPrimary() {
              return this.primary;
            }
          }, {
            key: "getSemanticNodes",
            value: function getSemanticNodes() {
              return this.nodes;
            }
          }, {
            key: "getNodes",
            value: function getNodes() {
              return this.allNodes;
            }
          }, {
            key: "getDomNodes",
            value: function getDomNodes() {
              return this.domNodes;
            }
          }, {
            key: "getDomPrimary",
            value: function getDomPrimary() {
              return this.domPrimary_;
            }
          }, {
            key: "toString",
            value: function toString() {
              return "Primary:" + this.domPrimary_ + " Nodes:" + this.domNodes;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t = new o(this.nodes, this.primary);
              return t.domNodes = this.domNodes, t.domPrimary_ = this.domPrimary_, t.allNodes = this.allNodes, t;
            }
          }], [{
            key: "factory",
            value: function factory(t, e, r, i) {
              var a = function a(t) {
                  return n.getBySemanticId(i, t);
                },
                Q = r.nodeDict,
                s = a(t),
                T = e.map(a),
                l = e.map(function (t) {
                  return Q[t];
                }),
                c = new o(l, Q[t]);
              return c.domNodes = T, c.domPrimary_ = s, c.allNodes = o.generateAllVisibleNodes_(e, T, Q, i), c;
            }
          }, {
            key: "generateAllVisibleNodes_",
            value: function generateAllVisibleNodes_(t, e, r, i) {
              var a = function a(t) {
                return n.getBySemanticId(i, t);
              };
              var Q = [];
              for (var _n257 = 0, s = t.length; _n257 < s; _n257++) {
                if (e[_n257]) {
                  Q.push(e[_n257]);
                  continue;
                }
                var _s7 = r[t[_n257]];
                if (!_s7) continue;
                var T = _s7.childNodes.map(function (t) {
                    return t.id.toString();
                  }),
                  l = T.map(a);
                Q = Q.concat(o.generateAllVisibleNodes_(T, l, r, i));
              }
              return Q;
            }
          }]);
          return o;
        }();
        e.Focus = o;
      },
      9797: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.Levels = void 0;
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
            this.level_ = [];
          }
          _createClass(r, [{
            key: "push",
            value: function push(t) {
              this.level_.push(t);
            }
          }, {
            key: "pop",
            value: function pop() {
              return this.level_.pop();
            }
          }, {
            key: "peek",
            value: function peek() {
              return this.level_[this.level_.length - 1] || null;
            }
          }, {
            key: "indexOf",
            value: function indexOf(t) {
              var e = this.peek();
              return e ? e.indexOf(t) : null;
            }
          }, {
            key: "find",
            value: function find(t) {
              var e = this.peek();
              if (!e) return null;
              for (var _r154 = 0, n = e.length; _r154 < n; _r154++) if (t(e[_r154])) return e[_r154];
              return null;
            }
          }, {
            key: "get",
            value: function get(t) {
              var e = this.peek();
              return !e || t < 0 || t >= e.length ? null : e[t];
            }
          }, {
            key: "depth",
            value: function depth() {
              return this.level_.length;
            }
          }, {
            key: "clone",
            value: function clone() {
              var t = new r();
              return t.level_ = this.level_.slice(0), t;
            }
          }, {
            key: "toString",
            value: function toString() {
              var t = "";
              for (var _e128, _r155 = 0; _e128 = this.level_[_r155]; _r155++) t += "\n" + _e128.map(function (t) {
                return t.toString();
              });
              return t;
            }
          }]);
          return r;
        }();
        e.Levels = r;
      },
      1214: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.RebuildStree = void 0;
        var n = r(5740),
          o = r(2298),
          i = r(3588),
          a = r(6537),
          Q = r(3308),
          s = r(5656),
          T = r(7075),
          l = r(4795),
          c = r(1204);
        var u = /*#__PURE__*/function () {
          function u(t) {
            _classCallCheck(this, u);
            this.mathml = t, this.factory = new a.SemanticNodeFactory(), this.nodeDict = {}, this.mmlRoot = c.getSemanticRoot(t), this.streeRoot = this.assembleTree(this.mmlRoot), this.stree = T.SemanticTree.fromNode(this.streeRoot, this.mathml), this.xml = this.stree.xml(), Q.default.getInstance().setNodeFactory(this.factory);
          }
          _createClass(u, [{
            key: "getTree",
            value: function getTree() {
              return this.stree;
            }
          }, {
            key: "assembleTree",
            value: function assembleTree(t) {
              var _this53 = this;
              var e = this.makeNode(t),
                r = c.splitAttribute(c.getAttribute(t, o.Attribute.CHILDREN)),
                n = c.splitAttribute(c.getAttribute(t, o.Attribute.CONTENT));
              if (u.addAttributes(e, t, !(r.length || n.length)), 0 === n.length && 0 === r.length) return u.textContent(e, t), e;
              if (n.length > 0) {
                var _t145 = c.getBySemanticId(this.mathml, n[0]);
                _t145 && u.textContent(e, _t145, !0);
              }
              e.contentNodes = n.map(function (t) {
                return _this53.setParent(t, e);
              }), e.childNodes = r.map(function (t) {
                return _this53.setParent(t, e);
              });
              var i = c.getAttribute(t, o.Attribute.COLLAPSED);
              return i ? this.postProcess(e, i) : e;
            }
          }, {
            key: "makeNode",
            value: function makeNode(t) {
              var e = c.getAttribute(t, o.Attribute.TYPE),
                r = c.getAttribute(t, o.Attribute.ROLE),
                n = c.getAttribute(t, o.Attribute.FONT),
                i = c.getAttribute(t, o.Attribute.ANNOTATION) || "",
                a = c.getAttribute(t, o.Attribute.ID),
                Q = c.getAttribute(t, o.Attribute.EMBELLISHED),
                s = c.getAttribute(t, o.Attribute.FENCEPOINTER),
                T = this.createNode(parseInt(a, 10));
              return T.type = e, T.role = r, T.font = n || "unknown", T.parseAnnotation(i), s && (T.fencePointer = s), Q && (T.embellished = Q), T;
            }
          }, {
            key: "makePunctuation",
            value: function makePunctuation(t) {
              var e = this.createNode(t);
              return e.updateContent((0, i.invisibleComma)()), e.role = "dummy", e;
            }
          }, {
            key: "makePunctuated",
            value: function makePunctuated(t, e, r) {
              var n = this.createNode(e[0]);
              n.type = "punctuated", n.embellished = t.embellished, n.fencePointer = t.fencePointer, n.role = r;
              var o = e.splice(1, 1)[0].slice(1);
              n.contentNodes = o.map(this.makePunctuation.bind(this)), this.collapsedChildren_(e);
            }
          }, {
            key: "makeEmpty",
            value: function makeEmpty(t, e, r) {
              var n = this.createNode(e);
              n.type = "empty", n.embellished = t.embellished, n.fencePointer = t.fencePointer, n.role = r;
            }
          }, {
            key: "makeIndex",
            value: function makeIndex(t, e, r) {
              if (u.isPunctuated(e)) return this.makePunctuated(t, e, r), void (e = e[0]);
              s.SemanticSkeleton.simpleCollapseStructure(e) && !this.nodeDict[e.toString()] && this.makeEmpty(t, e, r);
            }
          }, {
            key: "postProcess",
            value: function postProcess(t, e) {
              var r = s.SemanticSkeleton.fromString(e).array;
              if ("subsup" === t.type) {
                var _e129 = this.createNode(r[1][0]);
                return _e129.type = "subscript", _e129.role = "subsup", t.type = "superscript", _e129.embellished = t.embellished, _e129.fencePointer = t.fencePointer, this.makeIndex(t, r[1][2], "rightsub"), this.makeIndex(t, r[2], "rightsuper"), this.collapsedChildren_(r), t;
              }
              if ("subscript" === t.type) return this.makeIndex(t, r[2], "rightsub"), this.collapsedChildren_(r), t;
              if ("superscript" === t.type) return this.makeIndex(t, r[2], "rightsuper"), this.collapsedChildren_(r), t;
              if ("tensor" === t.type) return this.makeIndex(t, r[2], "leftsub"), this.makeIndex(t, r[3], "leftsuper"), this.makeIndex(t, r[4], "rightsub"), this.makeIndex(t, r[5], "rightsuper"), this.collapsedChildren_(r), t;
              if ("punctuated" === t.type) {
                if (u.isPunctuated(r)) {
                  var _e130 = r.splice(1, 1)[0].slice(1);
                  t.contentNodes = _e130.map(this.makePunctuation.bind(this));
                }
                return t;
              }
              if ("underover" === t.type) {
                var _e131 = this.createNode(r[1][0]);
                return "overaccent" === t.childNodes[1].role ? (_e131.type = "overscore", t.type = "underscore") : (_e131.type = "underscore", t.type = "overscore"), _e131.role = "underover", _e131.embellished = t.embellished, _e131.fencePointer = t.fencePointer, this.collapsedChildren_(r), t;
              }
              return t;
            }
          }, {
            key: "createNode",
            value: function createNode(t) {
              var e = this.factory.makeNode(t);
              return this.nodeDict[t.toString()] = e, e;
            }
          }, {
            key: "collapsedChildren_",
            value: function collapsedChildren_(t) {
              var _this54 = this;
              var e = function (_e132) {
                function e(_x3) {
                  return _e132.apply(this, arguments);
                }
                e.toString = function () {
                  return _e132.toString();
                };
                return e;
              }(function (t) {
                var r = _this54.nodeDict[t[0]];
                r.childNodes = [];
                for (var _n258 = 1, _o63 = t.length; _n258 < _o63; _n258++) {
                  var _o64 = t[_n258];
                  r.childNodes.push(s.SemanticSkeleton.simpleCollapseStructure(_o64) ? _this54.nodeDict[_o64] : e(_o64));
                }
                return r;
              });
              e(t);
            }
          }, {
            key: "setParent",
            value: function setParent(t, e) {
              var r = c.getBySemanticId(this.mathml, t),
                n = this.assembleTree(r);
              return n.parent = e, n;
            }
          }], [{
            key: "addAttributes",
            value: function addAttributes(t, e, r) {
              r && 1 === e.childNodes.length && e.childNodes[0].nodeType !== n.NodeType.TEXT_NODE && l.addAttributes(t, e.childNodes[0]), l.addAttributes(t, e);
            }
          }, {
            key: "textContent",
            value: function textContent(t, e, r) {
              if (!r && e.textContent) return void (t.textContent = e.textContent);
              var n = c.splitAttribute(c.getAttribute(e, o.Attribute.OPERATOR));
              n.length > 1 && (t.textContent = n[1]);
            }
          }, {
            key: "isPunctuated",
            value: function isPunctuated(t) {
              return !s.SemanticSkeleton.simpleCollapseStructure(t) && t[1] && s.SemanticSkeleton.contentCollapseStructure(t[1]);
            }
          }]);
          return u;
        }();
        e.RebuildStree = u;
      },
      6295: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SemanticWalker = void 0;
        var n = r(3284),
          o = r(9797);
        var i = /*#__PURE__*/function (_n$AbstractWalker2) {
          _inherits(i, _n$AbstractWalker2);
          function i(t, e, r, n) {
            var _this55;
            _classCallCheck(this, i);
            _this55 = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, t, e, r, n)), _this55.node = t, _this55.generator = e, _this55.highlighter = r, _this55.levels = null, _this55.restoreState();
            return _this55;
          }
          _createClass(i, [{
            key: "initLevels",
            value: function initLevels() {
              var t = new o.Levels();
              return t.push([this.getFocus()]), t;
            }
          }, {
            key: "up",
            value: function up() {
              _superPropGet(i, "up", this, 3)([]);
              var t = this.previousLevel();
              if (!t) return null;
              this.levels.pop();
              return this.levels.find(function (e) {
                return e.getSemanticNodes().some(function (e) {
                  return e.id.toString() === t;
                });
              });
            }
          }, {
            key: "down",
            value: function down() {
              _superPropGet(i, "down", this, 3)([]);
              var t = this.nextLevel();
              return 0 === t.length ? null : (this.levels.push(t), t[0]);
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, n) {
              switch (t) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return this.makePairList(n, r);
                case "prefixop":
                  return [this.focusFromId(n[0], r.concat(n))];
                case "postfixop":
                  return [this.focusFromId(n[0], n.concat(r))];
                case "matrix":
                case "vector":
                case "fenced":
                  return [this.focusFromId(n[0], [r[0], n[0], r[1]])];
                case "cases":
                  return [this.focusFromId(n[0], [r[0], n[0]])];
                case "punctuated":
                  return "text" === e ? n.map(this.singletonFocus.bind(this)) : n.length === r.length ? r.map(this.singletonFocus.bind(this)) : this.combinePunctuations(n, r, [], []);
                case "appl":
                  return [this.focusFromId(n[0], [n[0], r[0]]), this.singletonFocus(n[1])];
                case "root":
                  return [this.singletonFocus(n[1]), this.singletonFocus(n[0])];
                default:
                  return n.map(this.singletonFocus.bind(this));
              }
            }
          }, {
            key: "combinePunctuations",
            value: function combinePunctuations(t, e, r, n) {
              if (0 === t.length) return n;
              var o = t.shift(),
                i = e.shift();
              return o === i ? (r.push(i), this.combinePunctuations(t, e, r, n)) : (e.unshift(i), r.push(o), t.length === e.length ? (n.push(this.focusFromId(o, r.concat(e))), n) : (n.push(this.focusFromId(o, r)), this.combinePunctuations(t, e, [], n)));
            }
          }, {
            key: "makePairList",
            value: function makePairList(t, e) {
              if (0 === t.length) return [];
              if (1 === t.length) return [this.singletonFocus(t[0])];
              var r = [this.singletonFocus(t.shift())];
              for (var _n259 = 0, _o65 = t.length; _n259 < _o65; _n259++) r.push(this.focusFromId(t[_n259], [e[_n259], t[_n259]]));
              return r;
            }
          }, {
            key: "left",
            value: function left() {
              _superPropGet(i, "left", this, 3)([]);
              var t = this.levels.indexOf(this.getFocus());
              if (null === t) return null;
              var e = this.levels.get(t - 1);
              return e || null;
            }
          }, {
            key: "right",
            value: function right() {
              _superPropGet(i, "right", this, 3)([]);
              var t = this.levels.indexOf(this.getFocus());
              if (null === t) return null;
              var e = this.levels.get(t + 1);
              return e || null;
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return this.levels.find(function (e) {
                return e.getSemanticPrimary().id === t;
              });
            }
          }]);
          return i;
        }(n.AbstractWalker);
        e.SemanticWalker = i;
      },
      9806: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.SyntaxWalker = void 0;
        var n = r(707),
          o = r(3284),
          i = r(9797);
        var a = /*#__PURE__*/function (_o$AbstractWalker) {
          _inherits(a, _o$AbstractWalker);
          function a(t, e, r, n) {
            var _this56;
            _classCallCheck(this, a);
            _this56 = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t, e, r, n)), _this56.node = t, _this56.generator = e, _this56.highlighter = r, _this56.levels = null, _this56.restoreState();
            return _this56;
          }
          _createClass(a, [{
            key: "initLevels",
            value: function initLevels() {
              var t = new i.Levels();
              return t.push([this.primaryId()]), t;
            }
          }, {
            key: "up",
            value: function up() {
              _superPropGet(a, "up", this, 3)([]);
              var t = this.previousLevel();
              return t ? (this.levels.pop(), this.singletonFocus(t)) : null;
            }
          }, {
            key: "down",
            value: function down() {
              _superPropGet(a, "down", this, 3)([]);
              var t = this.nextLevel();
              if (0 === t.length) return null;
              var e = this.singletonFocus(t[0]);
              return e && this.levels.push(t), e;
            }
          }, {
            key: "combineContentChildren",
            value: function combineContentChildren(t, e, r, o) {
              switch (t) {
                case "relseq":
                case "infixop":
                case "multirel":
                  return (0, n.interleaveLists)(o, r);
                case "prefixop":
                  return r.concat(o);
                case "postfixop":
                  return o.concat(r);
                case "matrix":
                case "vector":
                case "fenced":
                  return o.unshift(r[0]), o.push(r[1]), o;
                case "cases":
                  return o.unshift(r[0]), o;
                case "punctuated":
                  return "text" === e ? (0, n.interleaveLists)(o, r) : o;
                case "appl":
                  return [o[0], r[0], o[1]];
                case "root":
                  return [o[1], o[0]];
                default:
                  return o;
              }
            }
          }, {
            key: "left",
            value: function left() {
              _superPropGet(a, "left", this, 3)([]);
              var t = this.levels.indexOf(this.primaryId());
              if (null === t) return null;
              var e = this.levels.get(t - 1);
              return e ? this.singletonFocus(e) : null;
            }
          }, {
            key: "right",
            value: function right() {
              _superPropGet(a, "right", this, 3)([]);
              var t = this.levels.indexOf(this.primaryId());
              if (null === t) return null;
              var e = this.levels.get(t + 1);
              return e ? this.singletonFocus(e) : null;
            }
          }, {
            key: "findFocusOnLevel",
            value: function findFocusOnLevel(t) {
              return this.singletonFocus(t.toString());
            }
          }, {
            key: "focusDomNodes",
            value: function focusDomNodes() {
              return [this.getFocus().getDomPrimary()];
            }
          }, {
            key: "focusSemanticNodes",
            value: function focusSemanticNodes() {
              return [this.getFocus().getSemanticPrimary()];
            }
          }]);
          return a;
        }(o.AbstractWalker);
        e.SyntaxWalker = a;
      },
      1799: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.TableWalker = void 0;
        var n = r(5740),
          o = r(8496),
          i = r(9806),
          a = r(179);
        var Q = /*#__PURE__*/function (_i$SyntaxWalker) {
          _inherits(Q, _i$SyntaxWalker);
          function Q(t, e, r, n) {
            var _this57;
            _classCallCheck(this, Q);
            _this57 = _possibleConstructorReturn(this, _getPrototypeOf(Q).call(this, t, e, r, n)), _this57.node = t, _this57.generator = e, _this57.highlighter = r, _this57.firstJump = null, _this57.key_ = null, _this57.row_ = 0, _this57.currentTable_ = null, _this57.keyMapping.set(o.KeyCode.ZERO, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.ONE, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.TWO, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.THREE, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.FOUR, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.FIVE, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.SIX, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.SEVEN, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.EIGHT, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57)))), _this57.keyMapping.set(o.KeyCode.NINE, _this57.jumpCell.bind(_assertThisInitialized(_assertThisInitialized(_this57))));
            return _this57;
          }
          _createClass(Q, [{
            key: "move",
            value: function move(t) {
              this.key_ = t;
              var e = _superPropGet(Q, "move", this, 3)([t]);
              return this.modifier = !1, e;
            }
          }, {
            key: "up",
            value: function up() {
              return this.moved = a.WalkerMoves.UP, this.eligibleCell_() ? this.verticalMove_(!1) : _superPropGet(Q, "up", this, 3)([]);
            }
          }, {
            key: "down",
            value: function down() {
              return this.moved = a.WalkerMoves.DOWN, this.eligibleCell_() ? this.verticalMove_(!0) : _superPropGet(Q, "down", this, 3)([]);
            }
          }, {
            key: "jumpCell",
            value: function jumpCell() {
              if (!this.isInTable_() || null === this.key_) return this.getFocus();
              if (this.moved === a.WalkerMoves.ROW) {
                this.moved = a.WalkerMoves.CELL;
                var _t146 = this.key_ - o.KeyCode.ZERO;
                return this.isLegalJump_(this.row_, _t146) ? this.jumpCell_(this.row_, _t146) : this.getFocus();
              }
              var t = this.key_ - o.KeyCode.ZERO;
              return t > this.currentTable_.childNodes.length ? this.getFocus() : (this.row_ = t, this.moved = a.WalkerMoves.ROW, this.getFocus().clone());
            }
          }, {
            key: "undo",
            value: function undo() {
              var t = _superPropGet(Q, "undo", this, 3)([]);
              return t === this.firstJump && (this.firstJump = null), t;
            }
          }, {
            key: "eligibleCell_",
            value: function eligibleCell_() {
              var t = this.getFocus().getSemanticPrimary();
              return this.modifier && "cell" === t.type && -1 !== Q.ELIGIBLE_CELL_ROLES.indexOf(t.role);
            }
          }, {
            key: "verticalMove_",
            value: function verticalMove_(t) {
              var e = this.previousLevel();
              if (!e) return null;
              var r = this.getFocus(),
                n = this.levels.indexOf(this.primaryId()),
                o = this.levels.pop(),
                i = this.levels.indexOf(e),
                a = this.levels.get(t ? i + 1 : i - 1);
              if (!a) return this.levels.push(o), null;
              this.setFocus(this.singletonFocus(a));
              var Q = this.nextLevel();
              return Q[n] ? (this.levels.push(Q), this.singletonFocus(Q[n])) : (this.setFocus(r), this.levels.push(o), null);
            }
          }, {
            key: "jumpCell_",
            value: function jumpCell_(t, e) {
              this.firstJump ? this.virtualize(!1) : (this.firstJump = this.getFocus(), this.virtualize(!0));
              var r = this.currentTable_.id.toString();
              var n;
              do {
                n = this.levels.pop();
              } while (-1 === n.indexOf(r));
              this.levels.push(n), this.setFocus(this.singletonFocus(r)), this.levels.push(this.nextLevel());
              var o = this.currentTable_.childNodes[t - 1];
              return this.setFocus(this.singletonFocus(o.id.toString())), this.levels.push(this.nextLevel()), this.singletonFocus(o.childNodes[e - 1].id.toString());
            }
          }, {
            key: "isLegalJump_",
            value: function isLegalJump_(t, e) {
              var r = n.querySelectorAllByAttrValue(this.getRebuilt().xml, "id", this.currentTable_.id.toString())[0];
              if (!r || r.hasAttribute("alternative")) return !1;
              var o = this.currentTable_.childNodes[t - 1];
              if (!o) return !1;
              var i = n.querySelectorAllByAttrValue(r, "id", o.id.toString())[0];
              return !(!i || i.hasAttribute("alternative")) && !(!o || !o.childNodes[e - 1]);
            }
          }, {
            key: "isInTable_",
            value: function isInTable_() {
              var t = this.getFocus().getSemanticPrimary();
              for (; t;) {
                if (-1 !== Q.ELIGIBLE_TABLE_TYPES.indexOf(t.type)) return this.currentTable_ = t, !0;
                t = t.parent;
              }
              return !1;
            }
          }]);
          return Q;
        }(i.SyntaxWalker);
        e.TableWalker = Q, Q.ELIGIBLE_CELL_ROLES = ["determinant", "rowvector", "binomial", "squarematrix", "multiline", "matrix", "vector", "cases", "table"], Q.ELIGIBLE_TABLE_TYPES = ["multiline", "matrix", "vector", "cases", "table"];
      },
      179: function _(t, e) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.WalkerState = e.WalkerMoves = void 0, function (t) {
          t.UP = "up", t.DOWN = "down", t.LEFT = "left", t.RIGHT = "right", t.REPEAT = "repeat", t.DEPTH = "depth", t.ENTER = "enter", t.EXPAND = "expand", t.HOME = "home", t.SUMMARY = "summary", t.DETAIL = "detail", t.ROW = "row", t.CELL = "cell";
        }(e.WalkerMoves || (e.WalkerMoves = {}));
        var r = /*#__PURE__*/function () {
          function r() {
            _classCallCheck(this, r);
          }
          _createClass(r, null, [{
            key: "resetState",
            value: function resetState(t) {
              delete r.STATE[t];
            }
          }, {
            key: "setState",
            value: function setState(t, e) {
              r.STATE[t] = e;
            }
          }, {
            key: "getState",
            value: function getState(t) {
              return r.STATE[t];
            }
          }]);
          return r;
        }();
        e.WalkerState = r, r.STATE = {};
      },
      3362: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.walkerMapping_ = e.walker = void 0;
        var n = r(162),
          o = r(6295),
          i = r(9806),
          a = r(1799);
        e.walker = function (t, r, n, o, i) {
          return (e.walkerMapping_[t.toLowerCase()] || e.walkerMapping_.dummy)(r, n, o, i);
        }, e.walkerMapping_ = {
          dummy: function dummy(t, e, r, o) {
            return new n.DummyWalker(t, e, r, o);
          },
          semantic: function semantic(t, e, r, n) {
            return new o.SemanticWalker(t, e, r, n);
          },
          syntax: function syntax(t, e, r, n) {
            return new i.SyntaxWalker(t, e, r, n);
          },
          table: function table(t, e, r, n) {
            return new a.TableWalker(t, e, r, n);
          }
        };
      },
      1204: function _(t, e, r) {
        Object.defineProperty(e, "__esModule", {
          value: !0
        }), e.getBySemanticId = e.getSemanticRoot = e.getAttribute = e.splitAttribute = void 0;
        var n = r(5740),
          o = r(2298);
        e.splitAttribute = function (t) {
          return t ? t.split(/,/) : [];
        }, e.getAttribute = function (t, e) {
          return t.getAttribute(e);
        }, e.getSemanticRoot = function (t) {
          if (t.hasAttribute(o.Attribute.TYPE) && !t.hasAttribute(o.Attribute.PARENT)) return t;
          var e = n.querySelectorAllByAttr(t, o.Attribute.TYPE);
          for (var _t147, _r156 = 0; _t147 = e[_r156]; _r156++) if (!_t147.hasAttribute(o.Attribute.PARENT)) return _t147;
          return t;
        }, e.getBySemanticId = function (t, e) {
          return t.getAttribute(o.Attribute.ID) === e ? t : n.querySelectorAllByAttrValue(t, o.Attribute.ID, e)[0];
        };
      }
    },
    __webpack_module_cache__ = {};
  function __webpack_require__(t) {
    var e = __webpack_module_cache__[t];
    if (void 0 !== e) return e.exports;
    var r = __webpack_module_cache__[t] = {
      exports: {}
    };
    return __webpack_modules__[t].call(r.exports, r, r.exports, __webpack_require__), r.exports;
  }
  __webpack_require__.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (t) {
      if ("object" == typeof window) return window;
    }
  }();
  var __webpack_exports__ = {};
  !function () {
    var t = __webpack_require__(9515),
      e = __webpack_require__(3282),
      r = __webpack_require__(235),
      n = __webpack_require__(265),
      o = __webpack_require__(2388);
    function i(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("startup", e.VERSION, "startup"), (0, t.combineWithMathJax)({
      _: {
        components: {
          loader: r,
          package: n,
          startup: o
        }
      }
    });
    var a,
      Q = {
        "a11y/semantic-enrich": ["input/mml", "a11y/sre"],
        "a11y/complexity": ["a11y/semantic-enrich"],
        "a11y/explorer": ["a11y/semantic-enrich", "ui/menu"],
        "[mml]/mml3": ["input/mml"],
        "[tex]/all-packages": ["input/tex-base"],
        "[tex]/action": ["input/tex-base", "[tex]/newcommand"],
        "[tex]/autoload": ["input/tex-base", "[tex]/require"],
        "[tex]/ams": ["input/tex-base"],
        "[tex]/amscd": ["input/tex-base"],
        "[tex]/bbox": ["input/tex-base", "[tex]/ams", "[tex]/newcommand"],
        "[tex]/boldsymbol": ["input/tex-base"],
        "[tex]/braket": ["input/tex-base"],
        "[tex]/bussproofs": ["input/tex-base"],
        "[tex]/cancel": ["input/tex-base", "[tex]/enclose"],
        "[tex]/centernot": ["input/tex-base"],
        "[tex]/color": ["input/tex-base"],
        "[tex]/colorv2": ["input/tex-base"],
        "[tex]/colortbl": ["input/tex-base", "[tex]/color"],
        "[tex]/configmacros": ["input/tex-base", "[tex]/newcommand"],
        "[tex]/enclose": ["input/tex-base"],
        "[tex]/extpfeil": ["input/tex-base", "[tex]/newcommand", "[tex]/ams"],
        "[tex]/html": ["input/tex-base"],
        "[tex]/mathtools": ["input/tex-base", "[tex]/newcommand", "[tex]/ams"],
        "[tex]/mhchem": ["input/tex-base", "[tex]/ams"],
        "[tex]/newcommand": ["input/tex-base"],
        "[tex]/noerrors": ["input/tex-base"],
        "[tex]/noundefined": ["input/tex-base"],
        "[tex]/physics": ["input/tex-base"],
        "[tex]/require": ["input/tex-base"],
        "[tex]/setoptions": ["input/tex-base"],
        "[tex]/tagformat": ["input/tex-base"],
        "[tex]/textcomp": ["input/tex-base", "[tex]/textmacros"],
        "[tex]/textmacros": ["input/tex-base"],
        "[tex]/unicode": ["input/tex-base"],
        "[tex]/verb": ["input/tex-base"],
        "[tex]/cases": ["[tex]/empheq"],
        "[tex]/empheq": ["input/tex-base", "[tex]/ams"]
      },
      s = Array.from(Object.keys(Q)).filter(function (t) {
        return "[tex]" === t.substr(0, 5) && "[tex]/autoload" !== t && "[tex]/colorv2" !== t && "[tex]/all-packages" !== t;
      }),
      T = {
        startup: ["loader"],
        "input/tex": ["input/tex-base", "[tex]/ams", "[tex]/newcommand", "[tex]/noundefined", "[tex]/require", "[tex]/autoload", "[tex]/configmacros"],
        "input/tex-full": ["input/tex-base", "[tex]/all-packages"].concat((a = s, function (t) {
          if (Array.isArray(t)) return i(t);
        }(a) || function (t) {
          if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(a) || function (t, e) {
          if (t) {
            if ("string" == typeof t) return i(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(t, e) : void 0;
          }
        }(a) || function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }())),
        "[tex]/all-packages": s
      };
    (0, t.combineDefaults)(MathJax.config.loader, "dependencies", Q), (0, t.combineDefaults)(MathJax.config.loader, "paths", {
      tex: "[mathjax]/input/tex/extensions",
      mml: "[mathjax]/input/mml/extensions",
      sre: "[mathjax]/sre/mathmaps"
    }), (0, t.combineDefaults)(MathJax.config.loader, "provides", T), (0, t.combineDefaults)(MathJax.config.loader, "source", {
      "[tex]/amsCd": "[tex]/amscd",
      "[tex]/colorV2": "[tex]/colorv2",
      "[tex]/configMacros": "[tex]/configmacros",
      "[tex]/tagFormat": "[tex]/tagformat"
    }), r.Loader.preLoad("loader", "startup", "core", "input/tex-full", "output/svg", "output/svg/fonts/tex.js", "ui/menu", "a11y/assistive-mml");
    var l = __webpack_require__(444),
      c = __webpack_require__(6191),
      u = __webpack_require__(5009),
      p = __webpack_require__(3494),
      h = __webpack_require__(3670),
      d = __webpack_require__(805),
      f = __webpack_require__(9206),
      m = __webpack_require__(5722),
      L = __webpack_require__(4474),
      y = __webpack_require__(9e3),
      g = __webpack_require__(91),
      v = __webpack_require__(6336),
      b = __webpack_require__(1759),
      H = __webpack_require__(3909),
      _ = __webpack_require__(9007),
      M = __webpack_require__(3948),
      x = __webpack_require__(9145),
      O = __webpack_require__(142),
      S = __webpack_require__(7590),
      V = __webpack_require__(3233),
      E = __webpack_require__(1334),
      A = __webpack_require__(6661),
      C = __webpack_require__(1581),
      w = __webpack_require__(5410),
      N = __webpack_require__(6850),
      P = __webpack_require__(3985),
      k = __webpack_require__(450),
      I = __webpack_require__(6405),
      R = __webpack_require__(3050),
      D = __webpack_require__(2756),
      j = __webpack_require__(7238),
      B = __webpack_require__(5741),
      F = __webpack_require__(6145),
      Z = __webpack_require__(9878),
      G = __webpack_require__(7265),
      q = __webpack_require__(6030),
      U = __webpack_require__(7131),
      W = __webpack_require__(1314),
      X = __webpack_require__(4461),
      z = __webpack_require__(1349),
      $ = __webpack_require__(4359),
      K = __webpack_require__(4770),
      J = __webpack_require__(5022),
      Y = __webpack_require__(5184),
      tt = __webpack_require__(9102),
      et = __webpack_require__(6325),
      rt = __webpack_require__(4082),
      nt = __webpack_require__(9259),
      ot = __webpack_require__(2975),
      it = __webpack_require__(4574),
      at = __webpack_require__(4596),
      Qt = __webpack_require__(7860),
      st = __webpack_require__(8823),
      Tt = __webpack_require__(8912),
      lt = __webpack_require__(3811),
      ct = __webpack_require__(6272),
      ut = __webpack_require__(3683),
      pt = __webpack_require__(5138),
      ht = __webpack_require__(3726),
      dt = __webpack_require__(3363),
      ft = __webpack_require__(3335),
      mt = __webpack_require__(5713),
      Lt = __webpack_require__(9923),
      yt = __webpack_require__(6469),
      gt = __webpack_require__(6751),
      vt = __webpack_require__(5368),
      bt = __webpack_require__(7525),
      Ht = __webpack_require__(103),
      _t = __webpack_require__(7233),
      Mt = __webpack_require__(8666),
      xt = __webpack_require__(4542),
      Ot = __webpack_require__(4139),
      St = __webpack_require__(8054),
      Vt = __webpack_require__(6010),
      Et = __webpack_require__(7875),
      At = __webpack_require__(505);
    MathJax.loader && MathJax.loader.checkVersion("core", e.VERSION, "core"), (0, t.combineWithMathJax)({
      _: {
        adaptors: {
          HTMLAdaptor: l,
          browserAdaptor: c
        },
        components: {
          global: t
        },
        core: {
          DOMAdaptor: u,
          FindMath: p,
          Handler: h,
          HandlerList: d,
          InputJax: f,
          MathDocument: m,
          MathItem: L,
          MathList: y,
          MmlTree: {
            Attributes: g,
            MML: v,
            MathMLVisitor: b,
            MmlFactory: H,
            MmlNode: _,
            MmlNodes: {
              TeXAtom: M,
              maction: x,
              maligngroup: O,
              malignmark: S,
              math: V,
              mathchoice: E,
              menclose: A,
              merror: C,
              mfenced: w,
              mfrac: N,
              mglyph: P,
              mi: k,
              mmultiscripts: I,
              mn: R,
              mo: D,
              mpadded: j,
              mphantom: B,
              mroot: F,
              mrow: Z,
              ms: G,
              mspace: q,
              msqrt: U,
              mstyle: W,
              msubsup: X,
              mtable: z,
              mtd: $,
              mtext: K,
              mtr: J,
              munderover: Y,
              semantics: tt
            },
            MmlVisitor: et,
            OperatorDictionary: rt,
            SerializedMmlVisitor: nt
          },
          OutputJax: ot,
          Tree: {
            Factory: it,
            Node: at,
            NodeFactory: Qt,
            Visitor: st,
            Wrapper: Tt,
            WrapperFactory: lt
          }
        },
        handlers: {
          html_ts: ct,
          html: {
            HTMLDocument: ut,
            HTMLDomStrings: pt,
            HTMLHandler: ht,
            HTMLMathItem: dt,
            HTMLMathList: ft
          }
        },
        mathjax: mt,
        util: {
          AsyncLoad: Lt,
          BBox: yt,
          BitField: gt,
          Entities: vt,
          FunctionList: bt,
          LinkedList: Ht,
          Options: _t,
          PrioritizedList: Mt,
          Retries: xt,
          StyleList: Ot,
          Styles: St,
          lengths: Vt,
          numeric: Et,
          string: At
        }
      }
    }), MathJax.startup && (MathJax.startup.registerConstructor("HTMLHandler", ht.HTMLHandler), MathJax.startup.registerConstructor("browserAdaptor", c.browserAdaptor), MathJax.startup.useHandler("HTMLHandler"), MathJax.startup.useAdaptor("browserAdaptor")), MathJax.loader && (MathJax._.mathjax.mathjax.asyncLoad = function (t) {
      return MathJax.loader.load(t);
    });
    var Ct = __webpack_require__(8462),
      wt = __webpack_require__(210),
      Nt = __webpack_require__(9899),
      Pt = __webpack_require__(4676),
      kt = __webpack_require__(7073),
      It = __webpack_require__(2947),
      Rt = __webpack_require__(8929),
      Dt = __webpack_require__(1256),
      jt = __webpack_require__(5450),
      Bt = __webpack_require__(8562),
      Ft = __webpack_require__(1130),
      Zt = __webpack_require__(9497),
      Gt = __webpack_require__(8292),
      qt = __webpack_require__(5453),
      Ut = __webpack_require__(8803),
      Wt = __webpack_require__(9140),
      Xt = __webpack_require__(6521),
      zt = __webpack_require__(8317),
      $t = __webpack_require__(3971),
      Kt = __webpack_require__(8417),
      Jt = __webpack_require__(8174),
      Yt = __webpack_require__(583),
      te = __webpack_require__(7819),
      ee = __webpack_require__(8021),
      re = __webpack_require__(2790),
      ne = __webpack_require__(4387),
      oe = __webpack_require__(1275),
      ie = __webpack_require__(2942),
      ae = __webpack_require__(1181),
      Qe = __webpack_require__(7693),
      se = __webpack_require__(1186),
      Te = __webpack_require__(8603),
      le = __webpack_require__(6538),
      ce = __webpack_require__(7191),
      ue = __webpack_require__(8667),
      pe = __webpack_require__(9499),
      he = __webpack_require__(3980),
      de = __webpack_require__(4934),
      fe = __webpack_require__(1933),
      me = __webpack_require__(8963),
      Le = __webpack_require__(3752),
      ye = __webpack_require__(8227),
      ge = __webpack_require__(6648),
      ve = __webpack_require__(6628),
      be = __webpack_require__(5860),
      He = __webpack_require__(7960),
      _e = __webpack_require__(2784),
      Me = __webpack_require__(4207),
      xe = __webpack_require__(8458),
      Oe = __webpack_require__(5464),
      Se = __webpack_require__(6471),
      Ve = __webpack_require__(1428),
      Ee = __webpack_require__(6121),
      Ae = __webpack_require__(3078),
      Ce = __webpack_require__(8901),
      we = __webpack_require__(332),
      Ne = __webpack_require__(7535),
      Pe = __webpack_require__(6224),
      ke = __webpack_require__(643),
      Ie = __webpack_require__(1503),
      Re = __webpack_require__(836),
      De = __webpack_require__(6944),
      je = __webpack_require__(1496),
      Be = __webpack_require__(6793),
      Fe = __webpack_require__(1110),
      Ze = __webpack_require__(5579),
      Ge = __webpack_require__(4234),
      qe = __webpack_require__(4898),
      Ue = __webpack_require__(3168),
      We = __webpack_require__(2612),
      Xe = __webpack_require__(7157),
      ze = __webpack_require__(7741),
      $e = __webpack_require__(9365),
      Ke = __webpack_require__(1527),
      Je = __webpack_require__(2307),
      Ye = __webpack_require__(2675),
      tr = __webpack_require__(58),
      er = __webpack_require__(8728),
      rr = __webpack_require__(6841),
      nr = __webpack_require__(1442),
      or = __webpack_require__(1247);
    function ir() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      if (MathJax.startup) {
        e && (MathJax.startup.registerConstructor("tex", MathJax._.input.tex_ts.TeX), MathJax.startup.useInput("tex")), MathJax.config.tex || (MathJax.config.tex = {});
        var r = MathJax.config.tex.packages;
        MathJax.config.tex.packages = t, r && (0, _t.insert)(MathJax.config.tex, {
          packages: r
        });
      }
    }
    function ar(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("input/tex-full", e.VERSION, "input"), (0, t.combineWithMathJax)({
      _: {
        input: {
          tex_ts: Ct,
          tex: {
            AllPackages: wt,
            Configuration: Nt,
            FilterUtil: Pt,
            FindTeX: kt,
            MapHandler: It,
            NodeFactory: Rt,
            NodeUtil: Dt,
            ParseMethods: jt,
            ParseOptions: Bt,
            ParseUtil: Ft,
            Stack: Zt,
            StackItem: Gt,
            StackItemFactory: qt,
            Symbol: Ut,
            SymbolMap: Wt,
            Tags: Xt,
            TexConstants: zt,
            TexError: $t,
            TexParser: Kt,
            action: {
              ActionConfiguration: Jt
            },
            amscd: {
              AmsCdConfiguration: Yt,
              AmsCdMethods: te
            },
            ams: {
              AmsConfiguration: ee,
              AmsItems: re,
              AmsMethods: ne
            },
            autoload: {
              AutoloadConfiguration: oe
            },
            base: {
              BaseConfiguration: ie,
              BaseItems: ae,
              BaseMethods: Qe
            },
            bbox: {
              BboxConfiguration: se
            },
            boldsymbol: {
              BoldsymbolConfiguration: Te
            },
            braket: {
              BraketConfiguration: le,
              BraketItems: ce,
              BraketMethods: ue
            },
            bussproofs: {
              BussproofsConfiguration: pe,
              BussproofsItems: he,
              BussproofsMethods: de,
              BussproofsUtil: fe
            },
            cancel: {
              CancelConfiguration: me
            },
            cases: {
              CasesConfiguration: Le
            },
            centernot: {
              CenternotConfiguration: ye
            },
            colortbl: {
              ColortblConfiguration: ge
            },
            colorv2: {
              ColorV2Configuration: ve
            },
            color: {
              ColorConfiguration: be,
              ColorConstants: He,
              ColorMethods: _e,
              ColorUtil: Me
            },
            configmacros: {
              ConfigMacrosConfiguration: xe
            },
            empheq: {
              EmpheqConfiguration: Oe,
              EmpheqUtil: Se
            },
            enclose: {
              EncloseConfiguration: Ve
            },
            extpfeil: {
              ExtpfeilConfiguration: Ee
            },
            gensymb: {
              GensymbConfiguration: Ae
            },
            html: {
              HtmlConfiguration: Ce,
              HtmlMethods: we
            },
            mathtools: {
              MathtoolsConfiguration: Ne,
              MathtoolsItems: Pe,
              MathtoolsMethods: ke,
              MathtoolsTags: Ie,
              MathtoolsUtil: Re
            },
            mhchem: {
              MhchemConfiguration: De
            },
            newcommand: {
              NewcommandConfiguration: je,
              NewcommandItems: Be,
              NewcommandMethods: Fe,
              NewcommandUtil: Ze
            },
            noerrors: {
              NoErrorsConfiguration: Ge
            },
            noundefined: {
              NoUndefinedConfiguration: qe
            },
            physics: {
              PhysicsConfiguration: Ue,
              PhysicsItems: We,
              PhysicsMethods: Xe
            },
            require: {
              RequireConfiguration: ze
            },
            setoptions: {
              SetOptionsConfiguration: $e
            },
            tagformat: {
              TagFormatConfiguration: Ke
            },
            textcomp: {
              TextcompConfiguration: Je
            },
            textmacros: {
              TextMacrosConfiguration: Ye,
              TextMacrosMethods: tr,
              TextParser: er
            },
            unicode: {
              UnicodeConfiguration: rr
            },
            upgreek: {
              UpgreekConfiguration: nr
            },
            verb: {
              VerbConfiguration: or
            }
          }
        }
      }
    }), MathJax.loader && MathJax.loader.checkVersion("[tex]/all-packages", e.VERSION, "tex-extension"), (0, t.combineWithMathJax)({
      _: {
        input: {
          tex: {
            AllPackages: wt,
            autoload: {
              AutoloadConfiguration: oe
            },
            require: {
              RequireConfiguration: ze
            }
          }
        }
      }
    }), MathJax.loader && MathJax.loader.preLoad("[tex]/autoload", "[tex]/require"), ir(["require"].concat(function (t) {
      return function (t) {
        if (Array.isArray(t)) return ar(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return ar(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ar(t, e);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }(wt.AllPackages)), !1), MathJax.loader && MathJax.loader.preLoad("input/tex-base", "[tex]/all-packages"), ir();
    var Qr = __webpack_require__(5884),
      sr = __webpack_require__(5552),
      Tr = __webpack_require__(3055),
      lr = __webpack_require__(7519),
      cr = __webpack_require__(4420),
      ur = __webpack_require__(9800),
      pr = __webpack_require__(1160),
      hr = __webpack_require__(1956),
      dr = __webpack_require__(7490),
      fr = __webpack_require__(7313),
      mr = __webpack_require__(7555),
      Lr = __webpack_require__(2688),
      yr = __webpack_require__(5636),
      gr = __webpack_require__(5723),
      vr = __webpack_require__(8009),
      br = __webpack_require__(5023),
      Hr = __webpack_require__(7096),
      _r = __webpack_require__(6898),
      Mr = __webpack_require__(9086),
      xr = __webpack_require__(8411),
      Or = __webpack_require__(4126),
      Sr = __webpack_require__(258),
      Vr = __webpack_require__(4093),
      Er = __webpack_require__(905),
      Ar = __webpack_require__(6237),
      Cr = __webpack_require__(5164),
      wr = __webpack_require__(6319),
      Nr = __webpack_require__(5766),
      Pr = __webpack_require__(1971),
      kr = __webpack_require__(167),
      Ir = __webpack_require__(5806),
      Rr = __webpack_require__(4097),
      Dr = __webpack_require__(2597),
      jr = __webpack_require__(768),
      Br = __webpack_require__(7620),
      Fr = __webpack_require__(7079),
      Zr = __webpack_require__(7826),
      Gr = __webpack_require__(6368),
      qr = __webpack_require__(131),
      Ur = __webpack_require__(640),
      Wr = __webpack_require__(988),
      Xr = __webpack_require__(2438),
      zr = __webpack_require__(6614),
      $r = __webpack_require__(9375),
      Kr = __webpack_require__(6670),
      Jr = __webpack_require__(5535),
      Yr = __webpack_require__(9645),
      tn = __webpack_require__(1618),
      en = __webpack_require__(9950),
      rn = __webpack_require__(5710),
      nn = __webpack_require__(5896),
      on = __webpack_require__(7512),
      an = __webpack_require__(3572),
      Qn = __webpack_require__(7725),
      sn = __webpack_require__(3289),
      Tn = __webpack_require__(3735),
      ln = __webpack_require__(6465),
      cn = __webpack_require__(1107),
      un = __webpack_require__(4445),
      pn = __webpack_require__(2558),
      hn = __webpack_require__(8926),
      dn = __webpack_require__(3365),
      fn = __webpack_require__(3006),
      mn = __webpack_require__(8835),
      Ln = __webpack_require__(6369),
      yn = __webpack_require__(2417);
    MathJax.loader && MathJax.loader.checkVersion("output/svg", e.VERSION, "output"), (0, t.combineWithMathJax)({
      _: {
        output: {
          common: {
            FontData: Qr,
            Notation: sr,
            OutputJax: Tr,
            Wrapper: lr,
            WrapperFactory: cr,
            Wrappers: {
              TeXAtom: ur,
              TextNode: pr,
              maction: hr,
              math: dr,
              menclose: fr,
              mfenced: mr,
              mfrac: Lr,
              mglyph: yr,
              mi: gr,
              mmultiscripts: vr,
              mn: br,
              mo: Hr,
              mpadded: _r,
              mroot: Mr,
              mrow: xr,
              ms: Or,
              mspace: Sr,
              msqrt: Vr,
              msubsup: Er,
              mtable: Ar,
              mtd: Cr,
              mtext: wr,
              mtr: Nr,
              munderover: Pr,
              scriptbase: kr,
              semantics: Ir
            }
          },
          svg_ts: Rr,
          svg: {
            FontCache: Dr,
            FontData: jr,
            Notation: Br,
            Wrapper: Fr,
            WrapperFactory: Zr,
            Wrappers_ts: Gr,
            Wrappers: {
              TeXAtom: qr,
              TextNode: Ur,
              maction: Wr,
              math: Xr,
              menclose: zr,
              merror: $r,
              mfenced: Kr,
              mfrac: Jr,
              mglyph: Yr,
              mi: tn,
              mmultiscripts: en,
              mn: rn,
              mo: nn,
              mpadded: on,
              mphantom: an,
              mroot: Qn,
              mrow: sn,
              ms: Tn,
              mspace: ln,
              msqrt: cn,
              msubsup: un,
              mtable: pn,
              mtd: hn,
              mtext: dn,
              mtr: fn,
              munderover: mn,
              scriptbase: Ln,
              semantics: yn
            }
          }
        }
      }
    }), MathJax.loader && (0, t.combineDefaults)(MathJax.config.loader, "output/svg", {
      checkReady: function checkReady() {
        return MathJax.loader.load("output/svg/fonts/tex");
      }
    }), MathJax.startup && (MathJax.startup.registerConstructor("svg", Rr.SVG), MathJax.startup.useOutput("svg"));
    var gn = __webpack_require__(5887),
      vn = __webpack_require__(1103),
      bn = __webpack_require__(9124),
      Hn = __webpack_require__(6001),
      _n = __webpack_require__(3696),
      Mn = __webpack_require__(9587),
      xn = __webpack_require__(8348),
      On = __webpack_require__(1376),
      Sn = __webpack_require__(1439),
      Vn = __webpack_require__(331),
      En = __webpack_require__(4886),
      An = __webpack_require__(4471),
      Cn = __webpack_require__(5181),
      wn = __webpack_require__(3526),
      Nn = __webpack_require__(5649),
      Pn = __webpack_require__(7153),
      kn = __webpack_require__(5745),
      In = __webpack_require__(1411),
      Rn = __webpack_require__(6384),
      Dn = __webpack_require__(6041),
      jn = __webpack_require__(8199),
      Bn = __webpack_require__(9848),
      Fn = __webpack_require__(7906),
      Zn = __webpack_require__(2644),
      Gn = __webpack_require__(4926),
      qn = __webpack_require__(42),
      Un = __webpack_require__(7040),
      Wn = __webpack_require__(2560),
      Xn = __webpack_require__(6982),
      zn = __webpack_require__(175),
      $n = __webpack_require__(5735),
      Kn = __webpack_require__(8594),
      Jn = __webpack_require__(4749),
      Yn = __webpack_require__(9320),
      to = __webpack_require__(466),
      eo = __webpack_require__(9671),
      ro = __webpack_require__(3746),
      no = __webpack_require__(3240),
      oo = __webpack_require__(8652),
      io = __webpack_require__(5667),
      ao = __webpack_require__(5821),
      Qo = __webpack_require__(957),
      so = __webpack_require__(1044),
      To = __webpack_require__(7292),
      lo = __webpack_require__(2162),
      co = __webpack_require__(9244),
      uo = __webpack_require__(5525);
    if (MathJax.loader && MathJax.loader.checkVersion("output/svg/fonts/tex", e.VERSION, "svg-font"), (0, t.combineWithMathJax)({
      _: {
        output: {
          common: {
            fonts: {
              tex: {
                "bold-italic": gn,
                bold: vn,
                delimiters: bn,
                "double-struck": Hn,
                "fraktur-bold": _n,
                fraktur: Mn,
                italic: xn,
                largeop: On,
                monospace: Sn,
                normal: Vn,
                "sans-serif-bold-italic": En,
                "sans-serif-bold": An,
                "sans-serif-italic": Cn,
                "sans-serif": wn,
                "script-bold": Nn,
                script: Pn,
                smallop: kn,
                "tex-calligraphic-bold": In,
                "tex-calligraphic": Rn,
                "tex-mathit": Dn,
                "tex-oldstyle-bold": jn,
                "tex-oldstyle": Bn,
                "tex-size3": Fn,
                "tex-size4": Zn,
                "tex-variant": Gn
              }
            }
          },
          svg: {
            fonts: {
              tex_ts: qn,
              tex: {
                "bold-italic": Un,
                bold: Wn,
                "fraktur-bold": Xn,
                fraktur: zn,
                italic: $n,
                largeop: Kn,
                monospace: Jn,
                normal: Yn,
                "sans-serif-bold-italic": to,
                "sans-serif-bold": eo,
                "sans-serif-italic": ro,
                "sans-serif": no,
                smallop: oo,
                "tex-calligraphic-bold": io,
                "tex-calligraphic": ao,
                "tex-mathit": Qo,
                "tex-oldstyle-bold": so,
                "tex-oldstyle": To,
                "tex-size3": lo,
                "tex-size4": co,
                "tex-variant": uo
              }
            }
          }
        }
      }
    }), MathJax.startup) {
      var po = (0, _t.selectOptionsFromKeys)(MathJax.config.svg || {}, qn.TeXFont.OPTIONS);
      (0, t.combineDefaults)(MathJax.config, "svg", {
        font: new qn.TeXFont(po)
      });
    }
    var ho = __webpack_require__(5865),
      fo = __webpack_require__(8310),
      mo = __webpack_require__(4001),
      Lo = __webpack_require__(473),
      yo = __webpack_require__(4414);
    MathJax.loader && MathJax.loader.checkVersion("ui/menu", e.VERSION, "ui"), (0, t.combineWithMathJax)({
      _: {
        ui: {
          menu: {
            MJContextMenu: ho,
            Menu: fo,
            MenuHandler: mo,
            MmlVisitor: Lo,
            SelectableInfo: yo
          }
        }
      }
    }), MathJax.startup && "undefined" != typeof window && MathJax.startup.extendHandler(function (t) {
      return (0, mo.MenuHandler)(t);
    }, 20);
    var go = __webpack_require__(351);
    function vo(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
      return n;
    }
    MathJax.loader && MathJax.loader.checkVersion("a11y/assistive-mml", e.VERSION, "a11y"), (0, t.combineWithMathJax)({
      _: {
        a11y: {
          "assistive-mml": go
        }
      }
    }), MathJax.startup && MathJax.startup.extendHandler(function (t) {
      return (0, go.AssistiveMmlHandler)(t);
    }), r.Loader.preLoad("loader"), r.Loader.load.apply(r.Loader, function (t) {
      return function (t) {
        if (Array.isArray(t)) return vo(t);
      }(t) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(t) || function (t, e) {
        if (!t) return;
        if ("string" == typeof t) return vo(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return vo(t, e);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }(r.CONFIG.load)).then(function () {
      return r.CONFIG.ready();
    }).catch(function (t) {
      return r.CONFIG.failed(t);
    });
  }();
})();